
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0102"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0102"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.0";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));




var $acw62 = parcelRequire("acw62");
var $af44cc7d4ea0e537$exports = {};
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    $af44cc7d4ea0e537$exports = factory();
})($af44cc7d4ea0e537$exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        var e = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
        function n(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = r * s - i * n;
            return o ? (t1[0] = s * (o = 1 / o), t1[1] = -n * o, t1[2] = -i * o, t1[3] = r * o, t1) : null;
        }
        function i() {
            var t1 = new r(9);
            return r != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }
        function s(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = e[4], a = e[5], l = e[6], u = e[7], c = e[8];
            return t1[0] = o * c - a * u, t1[1] = i * u - n * c, t1[2] = n * a - i * o, t1[3] = a * l - s * c, t1[4] = r * c - i * l, t1[5] = i * s - r * a, t1[6] = s * u - o * l, t1[7] = n * l - r * u, t1[8] = r * o - n * s, t1;
        }
        function o(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = e[3], a = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = r[0], f = r[1], d = r[2], m = r[3], y = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
            return t1[0] = p * n + f * o + d * u, t1[1] = p * i + f * a + d * c, t1[2] = p * s + f * l + d * h, t1[3] = m * n + y * o + g * u, t1[4] = m * i + y * a + g * c, t1[5] = m * s + y * l + g * h, t1[6] = x * n + v * o + b * u, t1[7] = x * i + v * a + b * c, t1[8] = x * s + v * l + b * h, t1;
        }
        function a() {
            var t1 = new r(16);
            return r != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }
        function l(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function u(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = e[4], a = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15], x = r * a - n * o, v = r * l - i * o, b = r * u - s * o, w = n * l - i * a, _ = n * u - s * a, A = i * u - s * l, M = c * m - h * d, I = c * y - p * d, S = c * g - f * d, z = h * y - p * m, k = h * g - f * m, P = p * g - f * y, E = x * P - v * k + b * z + w * S - _ * I + A * M;
            return E ? (t1[0] = (a * P - l * k + u * z) * (E = 1 / E), t1[1] = (i * k - n * P - s * z) * E, t1[2] = (m * A - y * _ + g * w) * E, t1[3] = (p * _ - h * A - f * w) * E, t1[4] = (l * S - o * P - u * I) * E, t1[5] = (r * P - i * S + s * I) * E, t1[6] = (y * b - d * A - g * v) * E, t1[7] = (c * A - p * b + f * v) * E, t1[8] = (o * k - a * S + u * M) * E, t1[9] = (n * S - r * k - s * M) * E, t1[10] = (d * _ - m * b + g * x) * E, t1[11] = (h * b - c * _ - f * x) * E, t1[12] = (a * I - o * z - l * M) * E, t1[13] = (r * z - n * I + i * M) * E, t1[14] = (m * v - d * w - y * x) * E, t1[15] = (c * w - h * v + p * x) * E, t1) : null;
        }
        function c(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = e[3], a = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], m = e[12], y = e[13], g = e[14], x = e[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = v * n + b * a + w * h + _ * m, t1[1] = v * i + b * l + w * p + _ * y, t1[2] = v * s + b * u + w * f + _ * g, t1[3] = v * o + b * c + w * d + _ * x, t1[4] = (v = r[4]) * n + (b = r[5]) * a + (w = r[6]) * h + (_ = r[7]) * m, t1[5] = v * i + b * l + w * p + _ * y, t1[6] = v * s + b * u + w * f + _ * g, t1[7] = v * o + b * c + w * d + _ * x, t1[8] = (v = r[8]) * n + (b = r[9]) * a + (w = r[10]) * h + (_ = r[11]) * m, t1[9] = v * i + b * l + w * p + _ * y, t1[10] = v * s + b * u + w * f + _ * g, t1[11] = v * o + b * c + w * d + _ * x, t1[12] = (v = r[12]) * n + (b = r[13]) * a + (w = r[14]) * h + (_ = r[15]) * m, t1[13] = v * i + b * l + w * p + _ * y, t1[14] = v * s + b * u + w * f + _ * g, t1[15] = v * o + b * c + w * d + _ * x, t1;
        }
        function h(t1, e, r) {
            var n, i, s, o, a, l, u, c, h, p, f, d, m = r[0], y = r[1], g = r[2];
            return e === t1 ? (t1[12] = e[0] * m + e[4] * y + e[8] * g + e[12], t1[13] = e[1] * m + e[5] * y + e[9] * g + e[13], t1[14] = e[2] * m + e[6] * y + e[10] * g + e[14], t1[15] = e[3] * m + e[7] * y + e[11] * g + e[15]) : (i = e[1], s = e[2], o = e[3], a = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t1[0] = n = e[0], t1[1] = i, t1[2] = s, t1[3] = o, t1[4] = a, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * m + a * y + h * g + e[12], t1[13] = i * m + l * y + p * g + e[13], t1[14] = s * m + u * y + f * g + e[14], t1[15] = o * m + c * y + d * g + e[15]), t1;
        }
        function p(t1, e, r) {
            var n = r[0], i = r[1], s = r[2];
            return t1[0] = e[0] * n, t1[1] = e[1] * n, t1[2] = e[2] * n, t1[3] = e[3] * n, t1[4] = e[4] * i, t1[5] = e[5] * i, t1[6] = e[6] * i, t1[7] = e[7] * i, t1[8] = e[8] * s, t1[9] = e[9] * s, t1[10] = e[10] * s, t1[11] = e[11] * s, t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
        }
        function f(t1, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[4], o = e[5], a = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t1 && (t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[4] = s * i + u * n, t1[5] = o * i + c * n, t1[6] = a * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - s * n, t1[9] = c * i - o * n, t1[10] = h * i - a * n, t1[11] = p * i - l * n, t1;
        }
        function d(t1, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[0], o = e[1], a = e[2], l = e[3], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t1 && (t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = s * i - u * n, t1[1] = o * i - c * n, t1[2] = a * i - h * n, t1[3] = l * i - p * n, t1[8] = s * n + u * i, t1[9] = o * n + c * i, t1[10] = a * n + h * i, t1[11] = l * n + p * i, t1;
        }
        function m(t1, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
            return e !== t1 && (t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = s * i + u * n, t1[1] = o * i + c * n, t1[2] = a * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - s * n, t1[5] = c * i - o * n, t1[6] = h * i - a * n, t1[7] = p * i - l * n, t1;
        }
        function y(t1, e) {
            return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function g(t1, r, n) {
            var i, s, o, a = n[0], l = n[1], u = n[2], c = Math.hypot(a, l, u);
            return c < e ? null : (a *= c = 1 / c, l *= c, u *= c, i = Math.sin(r), s = Math.cos(r), t1[0] = a * a * (o = 1 - s) + s, t1[1] = l * a * o + u * i, t1[2] = u * a * o - l * i, t1[3] = 0, t1[4] = a * l * o - u * i, t1[5] = l * l * o + s, t1[6] = u * l * o + a * i, t1[7] = 0, t1[8] = a * u * o + l * i, t1[9] = l * u * o - a * i, t1[10] = u * u * o + s, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
        }
        function x(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = r + r, a = n + n, l = i + i, u = r * o, c = n * o, h = n * a, p = i * o, f = i * a, d = i * l, m = s * o, y = s * a, g = s * l;
            return t1[0] = 1 - h - d, t1[1] = c + g, t1[2] = p - y, t1[3] = 0, t1[4] = c - g, t1[5] = 1 - u - d, t1[6] = f + m, t1[7] = 0, t1[8] = p + y, t1[9] = f - m, t1[10] = 1 - u - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = 0, e = arguments.length; e--;)t1 += arguments[e] * arguments[e];
            return Math.sqrt(t1);
        });
        var v = c;
        function b() {
            var t1 = new r(3);
            return r != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
        }
        function w(t1) {
            var e = new r(3);
            return e[0] = t1[0], e[1] = t1[1], e[2] = t1[2], e;
        }
        function _(t1) {
            return Math.hypot(t1[0], t1[1], t1[2]);
        }
        function A(t1, e, n) {
            var i = new r(3);
            return i[0] = t1, i[1] = e, i[2] = n, i;
        }
        function M(t1, e, r) {
            return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1;
        }
        function I(t1, e, r) {
            return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1;
        }
        function S(t1, e, r) {
            return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1[2] = e[2] * r[2], t1;
        }
        function z(t1, e, r) {
            return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1;
        }
        function k(t1, e, r) {
            return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1;
        }
        function P(t1, e, r) {
            return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1;
        }
        function E(t1, e, r, n) {
            return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1;
        }
        function T(t1, e) {
            var r = e[0] - t1[0], n = e[1] - t1[1], i = e[2] - t1[2];
            return r * r + n * n + i * i;
        }
        function B(t1) {
            var e = t1[0], r = t1[1], n = t1[2];
            return e * e + r * r + n * n;
        }
        function V(t1, e) {
            return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1;
        }
        function C(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t1[0] = e[0] * s, t1[1] = e[1] * s, t1[2] = e[2] * s, t1;
        }
        function F(t1, e) {
            return t1[0] * e[0] + t1[1] * e[1] + t1[2] * e[2];
        }
        function D(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = r[0], a = r[1], l = r[2];
            return t1[0] = i * l - s * a, t1[1] = s * o - n * l, t1[2] = n * a - i * o, t1;
        }
        function L(t1, e, r, n) {
            var i = e[0], s = e[1], o = e[2];
            return t1[0] = i + n * (r[0] - i), t1[1] = s + n * (r[1] - s), t1[2] = o + n * (r[2] - o), t1;
        }
        function R(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = r[3] * n + r[7] * i + r[11] * s + r[15];
            return t1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (o = o || 1), t1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / o, t1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / o, t1;
        }
        function O(t1, e, r) {
            var n = e[0], i = e[1], s = e[2];
            return t1[0] = n * r[0] + i * r[3] + s * r[6], t1[1] = n * r[1] + i * r[4] + s * r[7], t1[2] = n * r[2] + i * r[5] + s * r[8], t1;
        }
        function U(t1, e, r) {
            var n = r[0], i = r[1], s = r[2], o = e[0], a = e[1], l = e[2], u = i * l - s * a, c = s * o - n * l, h = n * a - i * o, p = i * h - s * c, f = s * u - n * h, d = n * c - i * u, m = 2 * r[3];
            return c *= m, h *= m, f *= 2, d *= 2, t1[0] = o + (u *= m) + (p *= 2), t1[1] = a + c + f, t1[2] = l + h + d, t1;
        }
        function N(t1, e) {
            return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2];
        }
        var j = I, $ = S, G = _;
        function q() {
            var t1 = new r(4);
            return r != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0), t1;
        }
        function H(t1, e, r) {
            return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1;
        }
        function X(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = r * r + n * n + i * i + s * s;
            return o > 0 && (o = 1 / Math.sqrt(o)), t1[0] = r * o, t1[1] = n * o, t1[2] = i * o, t1[3] = s * o, t1;
        }
        function Z(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = e[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * o, t1;
        }
        function W() {
            var t1 = new r(4);
            return r != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
        }
        function Y(t1) {
            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
        }
        function K(t1, e, r) {
            r *= .5;
            var n = e[0], i = e[1], s = e[2], o = e[3], a = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + o * a, t1[1] = i * l + s * a, t1[2] = s * l - i * a, t1[3] = o * l - n * a, t1;
        }
        function J(t1, e, r) {
            r *= .5;
            var n = e[0], i = e[1], s = e[2], o = e[3], a = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l - s * a, t1[1] = i * l + o * a, t1[2] = s * l + n * a, t1[3] = o * l - i * a, t1;
        }
        b(), q();
        var Q, tt, et, rt, nt, it = X, st = (Q = b(), tt = A(1, 0, 0), et = A(0, 1, 0), function(t1, e, r) {
            var n = F(e, r);
            return n < -0.999999 ? (D(Q, tt, e), G(Q) < 1e-6 && D(Q, et, e), C(Q, Q), function(t1, e, r) {
                r *= .5;
                var n = Math.sin(r);
                t1[0] = n * e[0], t1[1] = n * e[1], t1[2] = n * e[2], t1[3] = Math.cos(r);
            }(t1, Q, Math.PI), t1) : n > .999999 ? (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1) : (D(Q, e, r), t1[0] = Q[0], t1[1] = Q[1], t1[2] = Q[2], t1[3] = 1 + n, it(t1, t1));
        });
        function ot() {
            var t1 = new r(2);
            return r != Float32Array && (t1[0] = 0, t1[1] = 0), t1;
        }
        function at(t1, e) {
            var n = new r(2);
            return n[0] = t1, n[1] = e, n;
        }
        function lt(t1, e, r) {
            return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1;
        }
        function ut(t1, e, r) {
            return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1;
        }
        function ct(t1, e, r) {
            return t1[0] = e[0] * r, t1[1] = e[1] * r, t1;
        }
        function ht(t1) {
            return Math.hypot(t1[0], t1[1]);
        }
        function pt(t1, e) {
            var r = e[0], n = e[1], i = r * r + n * n;
            return i > 0 && (i = 1 / Math.sqrt(i)), t1[0] = e[0] * i, t1[1] = e[1] * i, t1;
        }
        function ft(t1, e) {
            return t1[0] * e[0] + t1[1] * e[1];
        }
        function dt(t1) {
            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
        }
        W(), W(), i(), ot();
        var mt, yt, gt = function() {
            if (nt) return rt;
            function t1(t1, e, r, n) {
                this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e, this.p2x = r, this.p2y = n;
            }
            return nt = 1, rt = t1, t1.prototype = {
                sampleCurveX: function(t1) {
                    return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                },
                sampleCurveY: function(t1) {
                    return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                },
                sampleCurveDerivativeX: function(t1) {
                    return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                },
                solveCurveX: function(t1, e) {
                    if (void 0 === e && (e = 1e-6), t1 < 0) return 0;
                    if (t1 > 1) return 1;
                    for(var r = t1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - t1;
                        if (Math.abs(i) < e) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var o = 0, a = 1;
                    for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e)); n++)t1 > i ? o = r : a = r, r = .5 * (a - o) + o;
                    return r;
                },
                solve: function(t1, e) {
                    return this.sampleCurveY(this.solveCurveX(t1, e));
                }
            }, rt;
        }(), xt = dt(gt);
        function vt() {
            if (yt) return mt;
            function t1(t1, e) {
                this.x = t1, this.y = e;
            }
            return yt = 1, mt = t1, t1.prototype = {
                clone: function() {
                    return new t1(this.x, this.y);
                },
                add: function(t1) {
                    return this.clone()._add(t1);
                },
                sub: function(t1) {
                    return this.clone()._sub(t1);
                },
                multByPoint: function(t1) {
                    return this.clone()._multByPoint(t1);
                },
                divByPoint: function(t1) {
                    return this.clone()._divByPoint(t1);
                },
                mult: function(t1) {
                    return this.clone()._mult(t1);
                },
                div: function(t1) {
                    return this.clone()._div(t1);
                },
                rotate: function(t1) {
                    return this.clone()._rotate(t1);
                },
                rotateAround: function(t1, e) {
                    return this.clone()._rotateAround(t1, e);
                },
                matMult: function(t1) {
                    return this.clone()._matMult(t1);
                },
                unit: function() {
                    return this.clone()._unit();
                },
                perp: function() {
                    return this.clone()._perp();
                },
                round: function() {
                    return this.clone()._round();
                },
                mag: function() {
                    return Math.sqrt(this.x * this.x + this.y * this.y);
                },
                equals: function(t1) {
                    return this.x === t1.x && this.y === t1.y;
                },
                dist: function(t1) {
                    return Math.sqrt(this.distSqr(t1));
                },
                distSqr: function(t1) {
                    var e = t1.x - this.x, r = t1.y - this.y;
                    return e * e + r * r;
                },
                angle: function() {
                    return Math.atan2(this.y, this.x);
                },
                angleTo: function(t1) {
                    return Math.atan2(this.y - t1.y, this.x - t1.x);
                },
                angleWith: function(t1) {
                    return this.angleWithSep(t1.x, t1.y);
                },
                angleWithSep: function(t1, e) {
                    return Math.atan2(this.x * e - this.y * t1, this.x * t1 + this.y * e);
                },
                _matMult: function(t1) {
                    var e = t1[2] * this.x + t1[3] * this.y;
                    return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e, this;
                },
                _add: function(t1) {
                    return this.x += t1.x, this.y += t1.y, this;
                },
                _sub: function(t1) {
                    return this.x -= t1.x, this.y -= t1.y, this;
                },
                _mult: function(t1) {
                    return this.x *= t1, this.y *= t1, this;
                },
                _div: function(t1) {
                    return this.x /= t1, this.y /= t1, this;
                },
                _multByPoint: function(t1) {
                    return this.x *= t1.x, this.y *= t1.y, this;
                },
                _divByPoint: function(t1) {
                    return this.x /= t1.x, this.y /= t1.y, this;
                },
                _unit: function() {
                    return this._div(this.mag()), this;
                },
                _perp: function() {
                    var t1 = this.y;
                    return this.y = this.x, this.x = -t1, this;
                },
                _rotate: function(t1) {
                    var e = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e * this.y;
                    return this.x = e * this.x - r * this.y, this.y = n, this;
                },
                _rotateAround: function(t1, e) {
                    var r = Math.cos(t1), n = Math.sin(t1), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                    return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
                },
                _round: function() {
                    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                }
            }, t1.convert = function(e) {
                return e instanceof t1 ? e : Array.isArray(e) ? new t1(e[0], e[1]) : e;
            }, mt;
        }
        var bt = dt(vt());
        function wt(t1, e) {
            if (Array.isArray(t1)) {
                if (!Array.isArray(e) || t1.length !== e.length) return !1;
                for(let r = 0; r < t1.length; r++)if (!wt(t1[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t1 && null !== t1 && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t1).length !== Object.keys(e).length) return !1;
                for(const r in t1)if (!wt(t1[r], e[r])) return !1;
                return !0;
            }
            return t1 === e;
        }
        const _t = Math.PI / 180, At = 180 / Math.PI;
        function Mt(t1) {
            return t1 * _t;
        }
        function It(t1) {
            return t1 * At;
        }
        const St = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function zt(t1) {
            if (t1 <= 0) return 0;
            if (t1 >= 1) return 1;
            const e = t1 * t1, r = e * t1;
            return 4 * (t1 < .5 ? r : 3 * (t1 - e) + r - .75);
        }
        function kt(t1, e, r, n) {
            const i = new xt(t1, e, r, n);
            return function(t1) {
                return i.solve(t1);
            };
        }
        const Pt = kt(.25, .1, .25, 1);
        function Et(t1, e, r) {
            return Math.min(r, Math.max(e, t1));
        }
        function Tt(t1, e, r) {
            return (r = Et((r - t1) / (e - t1), 0, 1)) * r * (3 - 2 * r);
        }
        function Bt(t1, e, r) {
            const n = r - e, i = ((t1 - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function Vt(t1, e, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let s = null;
            t1.forEach((t1, o)=>{
                e(t1, (t1, e)=>{
                    t1 && (s = t1), i[o] = e, 0 == --n && r(s, i);
                });
            });
        }
        function Ct(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        let Ft = 1;
        function Dt() {
            return Ft++;
        }
        function Lt(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function Rt(t1, e) {
            t1.forEach((t1)=>{
                e[t1] && (e[t1] = e[t1].bind(e));
            });
        }
        function Ot(t1, e, r) {
            const n = {};
            for(const r in t1)n[r] = e.call(this, t1[r], r, t1);
            return n;
        }
        function Ut(t1, e, r) {
            const n = {};
            for(const r in t1)e.call(this, t1[r], r, t1) && (n[r] = t1[r]);
            return n;
        }
        function Nt(t1) {
            return Array.isArray(t1) ? t1.map(Nt) : "object" == typeof t1 && t1 ? Ot(t1, Nt) : t1;
        }
        function jt(t1, e) {
            for(let r = 0; r < t1.length; r++)if (e.indexOf(t1[r]) >= 0) return !0;
            return !1;
        }
        const $t = {};
        function Gt(t1) {
            $t[t1] || ("undefined" != typeof console && console.warn(t1), $t[t1] = !0);
        }
        function qt(t1, e, r) {
            return (r.y - t1.y) * (e.x - t1.x) > (e.y - t1.y) * (r.x - t1.x);
        }
        function Ht(t1) {
            let e = 0;
            for(let r, n, i = 0, s = t1.length, o = s - 1; i < s; o = i++)r = t1[i], n = t1[o], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function Xt([t1, e, r]) {
            const n = Mt(e + 90), i = Mt(r);
            return {
                x: t1 * Math.cos(n) * Math.sin(i),
                y: t1 * Math.sin(n) * Math.sin(i),
                z: t1 * Math.cos(i),
                azimuthal: e,
                polar: r
            };
        }
        function Zt(t1) {
            return ("undefined" != typeof self || void 0 !== t1) && "undefined" != typeof WorkerGlobalScope && (void 0 !== t1 ? t1 : self) instanceof WorkerGlobalScope;
        }
        function Wt(t1) {
            const e = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const s = n || i;
                return e[r] = !s || s.toLowerCase(), "";
            }), e["max-age"]) {
                const t1 = parseInt(e["max-age"], 10);
                isNaN(t1) ? delete e["max-age"] : e["max-age"] = t1;
            }
            return e;
        }
        let Yt = null;
        function Kt(t1, e) {
            return [
                t1[4 * e],
                t1[4 * e + 1],
                t1[4 * e + 2],
                t1[4 * e + 3]
            ];
        }
        function Jt(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] < n ? e = i + 1 : r = i;
            }
            return e;
        }
        function Qt(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] <= n ? e = i + 1 : r = i;
            }
            return e;
        }
        function te(t1) {
            return t1 > 0 ? 1 / (1.001 - t1) : 1 + t1;
        }
        function ee(t1) {
            return t1 > 0 ? 1 - 1 / (1.001 - t1) : -t1;
        }
        function re(t1, e, r) {
            return (t1 - e.min) * (r.max - r.min) / (e.max - e.min) + r.min;
        }
        const ne = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!ne.API_URL) return null;
                try {
                    const t1 = new URL(ne.API_URL);
                    return "api.mapbox.cn" === t1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (t1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm",
            MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm",
            BUILDING_GEN_URL: "https://api.mapbox.com/mapbox-gl-js/building-gen/building_gen_v0.3.0.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1"
        };
        function ie(t1) {
            return ne.API_URL_REGEX.test(t1);
        }
        function se(t1) {
            return ne.API_SPRITE_REGEX.test(t1);
        }
        let oe, ae, le, ue, ce, he;
        function pe() {
            return null == oe && (oe = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), oe;
        }
        const fe = {
            now: ()=>void 0 !== ue ? ue : performance.now(),
            setNow (t1) {
                ue = t1;
            },
            restoreNow () {
                ue = void 0;
            },
            frame (t1) {
                const e = requestAnimationFrame(t1);
                return {
                    cancel: ()=>cancelAnimationFrame(e)
                };
            },
            getImageData (t1, e = 0) {
                const { width: r, height: n } = t1;
                ce || (ce = document.createElement("canvas"));
                const i = ce.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return (r > ce.width || n > ce.height) && (ce.width = r, ce.height = n), i.clearRect(-e, -e, r + 2 * e, n + 2 * e), i.drawImage(t1, 0, 0, r, n), i.getImageData(-e, -e, r + 2 * e, n + 2 * e);
            },
            resolveURL: (t1)=>(ae || (ae = document.createElement("a")), ae.href = t1, ae.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (null == le && (le = window.matchMedia("(prefers-reduced-motion: reduce)")), le.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== he) return he;
                if (!pe()) return he = !1, !1;
                const t1 = new OffscreenCanvas(85, 1), e = t1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let n = 0; n < t1.width; ++n)e.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, e.fillRect(n, 0, 1, 1);
                const n = e.getImageData(0, 0, t1.width, t1.height);
                r = 0;
                for(let t1 = 0; t1 < n.data.length; ++t1)if (t1 % 4 != 3 && r++ !== n.data[t1]) return he = !0, !0;
                return he = !1, !1;
            }
        };
        function de(t1, e) {
            const r = t1.indexOf("?");
            if (r < 0) return `${t1}?${new URLSearchParams(e).toString()}`;
            const n = new URLSearchParams(t1.slice(r));
            for(const t1 in e)n.set(t1, e[t1]);
            return `${t1.slice(0, r)}?${n.toString()}`;
        }
        function me(t1, e = {
            persistentParams: []
        }) {
            const r = t1.indexOf("?");
            if (r < 0) return t1;
            const n = new URLSearchParams, i = new URLSearchParams(t1.slice(r));
            for (const t1 of e.persistentParams){
                const e = i.get(t1);
                e && n.set(t1, e);
            }
            const s = n.toString();
            return `${t1.slice(0, r)}${s.length > 0 ? `?${s}` : ""}`;
        }
        const ye = "mapbox-tiles";
        let ge = 500, xe = 50;
        const ve = [
            "language",
            "worldview",
            "jobid"
        ];
        let be, we;
        function _e() {
            try {
                return caches;
            } catch (t1) {}
        }
        function Ae() {
            const t1 = _e();
            t1 && null == be && (be = t1.open(ye));
        }
        let Me = 1 / 0;
        const Ie = {
            supported: !1,
            testSupport: function(t1) {
                !ke && ze && (Pe ? Te(t1) : Se = t1);
            }
        };
        let Se, ze, ke = !1, Pe = !1;
        const Ee = "undefined" != typeof self ? self : {};
        function Te(t1) {
            const e = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, ze), t1.isContextLost()) return;
                Ie.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e), ke = !0;
        }
        Ee.document && (ze = Ee.document.createElement("img"), ze.onload = function() {
            Se && Te(Se), Se = null, Pe = !0;
        }, ze.onerror = function() {
            ke = !0, Se = null;
        }, ze.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const Be = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        "function" == typeof Object.freeze && Object.freeze(Be);
        class Ve extends Error {
            constructor(t1, e, r){
                401 === e && ie(r) && (t1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t1), this.status = e, this.url = r;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        const Ce = Zt() ? ()=>self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href;
        const Fe = function(t1, e) {
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(Ce()) && !/^\w+:/.test(r))) {
                if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function(t1, e) {
                    const r = new AbortController, n = new Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: Ce(),
                        referrerPolicy: t1.referrerPolicy,
                        signal: r.signal
                    });
                    let i = !1, s = !1;
                    const o = (a = n.url).indexOf("sku=") > 0 && ie(a);
                    var a;
                    "json" === t1.type && n.headers.set("Accept", "application/json");
                    const l = (r, i, a)=>{
                        if (s) return;
                        if (r && "SecurityError" !== r.message && Gt(r.toString()), i && a) return u(i);
                        const l = Date.now();
                        fetch(n).then((r)=>{
                            if (r.ok) {
                                const t1 = o ? r.clone() : null;
                                return u(r, t1, l);
                            }
                            return e(new Ve(r.statusText, r.status, t1.url));
                        }).catch((r)=>{
                            "AbortError" !== r.name && e(new Error(`${r.message} ${t1.url}`));
                        });
                    }, u = (r, o, a)=>{
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then((t1)=>{
                            s || (o && a && function(t1, e, r) {
                                if (Ae(), null == be) return;
                                const n = Wt(e.headers.get("Cache-Control") || "");
                                if (n["no-store"]) return;
                                const i = {
                                    status: e.status,
                                    statusText: e.statusText,
                                    headers: new Headers
                                };
                                e.headers.forEach((t1, e)=>i.headers.set(e, t1)), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                                const s = i.headers.get("Expires");
                                if (!s) return;
                                if (new Date(s).getTime() - r < 42e4) return;
                                let o = me(t1.url, {
                                    persistentParams: ve
                                });
                                if (206 === e.status) {
                                    const e = t1.headers.get("Range");
                                    if (!e) return;
                                    i.status = 200, o = de(o, {
                                        range: e
                                    });
                                }
                                !function(t1, e) {
                                    if (void 0 === we) try {
                                        new Response(new ReadableStream), we = !0;
                                    } catch (t1) {
                                        we = !1;
                                    }
                                    we ? e(t1.body) : t1.blob().then(e).catch((t1)=>Gt(t1.message));
                                }(e, (t1)=>{
                                    const r = new Response(200 !== (n = e.status) && 404 !== n && [
                                        101,
                                        103,
                                        204,
                                        205,
                                        304
                                    ].includes(n) ? null : t1, i);
                                    var n;
                                    Ae(), null != be && be.then((t1)=>t1.put(o, r)).catch((t1)=>Gt(t1.message));
                                });
                            }(n, o, a), i = !0, e(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((t1)=>{
                            s || e(new Error(t1.message));
                        });
                    };
                    return o ? function(t1, e) {
                        if (Ae(), null == be) return e(null);
                        be.then((r)=>{
                            let n = me(t1.url, {
                                persistentParams: ve
                            });
                            const i = t1.headers.get("Range");
                            i && (n = de(n, {
                                range: i
                            })), r.match(n).then((t1)=>{
                                const i = function(t1) {
                                    if (!t1) return !1;
                                    const e = new Date(t1.headers.get("Expires") || 0), r = Wt(t1.headers.get("Cache-Control") || "");
                                    return Number(e) > Date.now() && !r["no-cache"];
                                }(t1);
                                r.delete(n).catch(e), i && r.put(n, t1.clone()).catch(e), e(null, t1, i);
                            }).catch(e);
                        }).catch(e);
                    }(n, l) : l(null, null), {
                        cancel: ()=>{
                            s = !0, i || r.abort();
                        }
                    };
                }(t1, e);
                if (Zt(self) && self.worker.actor) return self.worker.actor.send("getResource", t1, e, void 0, !0);
            }
            var r;
            return function(t1, e) {
                const r = new XMLHttpRequest;
                r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer");
                for(const e in t1.headers)r.setRequestHeader(e, t1.headers[e]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = ()=>{
                    e(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e(t1);
                        }
                        e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else e(new Ve(r.statusText, r.status, t1.url));
                }, r.send(t1.body), {
                    cancel: ()=>r.abort()
                };
            }(t1, e);
        }, De = function(t1, e) {
            return Fe(Ct(t1, {
                type: "arrayBuffer"
            }), e);
        };
        function Le(t1) {
            const e = document.createElement("a");
            return e.href = t1, e.protocol === location.protocol && e.host === location.host;
        }
        const Re = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let Oe, Ue;
        Oe = [], Ue = 0;
        const Ne = function(t1, e) {
            if (Ie.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), Ue >= ne.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: t1,
                    callback: e,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Oe.push(r), r;
            }
            Ue++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, Ue--; Oe.length && Ue < ne.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = Oe.shift(), { requestParameters: e, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = Ne(e, r).cancel);
                }
            }, i = De(t1, (t1, r, i, s)=>{
                n(), t1 ? e(t1) : r && (self.createImageBitmap ? function(t1, e) {
                    const r = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    createImageBitmap(r).then((t1)=>{
                        e(null, t1);
                    }).catch((t1)=>{
                        e(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (t1, r)=>e(t1, r, i, s)) : function(t1, e) {
                    const r = new Image;
                    r.onload = ()=>{
                        e(null, r), URL.revokeObjectURL(r.src), r.onload = null, requestAnimationFrame(()=>{
                            r.src = Re;
                        });
                    }, r.onerror = ()=>e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const n = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    r.src = t1.byteLength ? URL.createObjectURL(n) : Re;
                }(r, (t1, r)=>e(t1, r, i, s)));
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        var je, $e, Ge, qe = {
            exports: {}
        }, He = {
            exports: {}
        }, Xe = {
            exports: {}
        }, Ze = function() {
            if (Ge) return qe.exports;
            Ge = 1;
            var t1 = (je || (je = 1, He.exports = function(t1, e) {
                var r, n, i, s, o, a, l, u;
                for(n = t1.length - (r = 3 & t1.length), i = e, o = 3432918353, a = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), He.exports), e = ($e || ($e = 1, Xe.exports = function(t1, e) {
                for(var r, n = t1.length, i = e ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(s) | (255 & t1.charCodeAt(++s)) << 8 | (255 & t1.charCodeAt(++s)) << 16 | (255 & t1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), Xe.exports);
            return qe.exports = t1, qe.exports.murmur3 = t1, qe.exports.murmur2 = e, qe.exports;
        }(), We = dt(Ze);
        class Ye {
            constructor(t1, ...e){
                Ct(this, e[0] || {}), this.type = t1;
            }
        }
        class Ke extends Ye {
            constructor(t1, e = {}){
                super("error", Ct({
                    error: t1
                }, e));
            }
        }
        function Je(t1, e, r) {
            r[t1] && -1 !== r[t1].indexOf(e) || (r[t1] = r[t1] || [], r[t1].push(e));
        }
        function Qe(t1, e, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class tr {
            on(t1, e) {
                return this._listeners = this._listeners || {}, Je(t1, e, this._listeners), this;
            }
            off(t1, e) {
                return Qe(t1, e, this._listeners), Qe(t1, e, this._oneTimeListeners), this;
            }
            once(t1, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, Je(t1, e, this._oneTimeListeners), this) : new Promise((e)=>{
                    this.once(t1, e);
                });
            }
            fire(t1, e) {
                const r = "string" == typeof t1 ? new Ye(t1, e) : t1, n = r.type;
                if (this.listens(n)) {
                    r.target = this;
                    const t1 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const e of t1)e.call(this, r);
                    const e = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const t1 of e)Qe(n, t1, this._oneTimeListeners), t1.call(this, r);
                    const i = this._eventedParent;
                    i && (Ct(r, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(r));
                } else r instanceof Ke && console.error(r.error);
                return this;
            }
            listens(t1) {
                return !!(this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1));
            }
            setEventedParent(t1, e) {
                return this._eventedParent = t1, this._eventedParentData = e, this;
            }
        }
        class er {
            constructor(t1){
                "string" == typeof t1 ? this.name = t1 : (this.name = t1.name, this.iconsetId = t1.iconsetId);
            }
            static from(t1) {
                return new er(t1);
            }
            static toString(t1) {
                return t1.iconsetId ? `${t1.name}${t1.iconsetId}` : t1.name;
            }
            static parse(t1) {
                const [e, r] = t1.split("");
                return new er({
                    name: e,
                    iconsetId: r
                });
            }
            static isEqual(t1, e) {
                return t1.name === e.name && t1.iconsetId === e.iconsetId;
            }
            toString() {
                return er.toString(this);
            }
            serialize() {
                return {
                    name: this.name,
                    iconsetId: this.iconsetId
                };
            }
        }
        var rr, nr = {}, ir = function() {
            if (rr) return nr;
            rr = 1;
            var t1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function e(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function r(t1) {
                return e("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function n(t1) {
                var e;
                return (e = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e > 1 ? 1 : e;
            }
            function i(t1, e, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e - t1) * r * 6 : 2 * r < 1 ? e : 3 * r < 2 ? t1 + (e - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                nr.parseCSSColor = function(s) {
                    var o, a = s.replace(/ /g, "").toLowerCase();
                    if (a in t1) return t1[a].slice();
                    if ("#" === a[0]) return 4 === a.length ? (o = parseInt(a.substr(1), 16)) >= 0 && o <= 4095 ? [
                        (3840 & o) >> 4 | (3840 & o) >> 8,
                        240 & o | (240 & o) >> 4,
                        15 & o | (15 & o) << 4,
                        1
                    ] : null : 7 === a.length && (o = parseInt(a.substr(1), 16)) >= 0 && o <= 16777215 ? [
                        (16711680 & o) >> 16,
                        (65280 & o) >> 8,
                        255 & o,
                        1
                    ] : null;
                    var l = a.indexOf("("), u = a.indexOf(")");
                    if (-1 !== l && u + 1 === a.length) {
                        var c = a.substr(0, l), h = a.substr(l + 1, u - (l + 1)).split(","), p = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    r(h[0]),
                                    r(h[1]),
                                    r(h[2]),
                                    p
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, d = n(h[1]), m = n(h[2]), y = m <= .5 ? m * (d + 1) : m + d - m * d, g = 2 * m - y;
                                return [
                                    e(255 * i(g, y, f + 1 / 3)),
                                    e(255 * i(g, y, f)),
                                    e(255 * i(g, y, f - 1 / 3)),
                                    p
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
            return nr;
        }();
        class sr {
            constructor(t1, e, r, n = 1){
                this.r = t1, this.g = e, this.b = r, this.a = n;
            }
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof sr) return t1;
                if ("string" != typeof t1) return;
                const e = ir.parseCSSColor(t1);
                return e ? new sr(e[0] / 255, e[1] / 255, e[2] / 255, e[3]) : void 0;
            }
            toString() {
                const [t1, e, r, n] = [
                    this.r,
                    this.g,
                    this.b,
                    this.a
                ];
                return `rgba(${Math.round(255 * t1)},${Math.round(255 * e)},${Math.round(255 * r)},${n})`;
            }
            toNonPremultipliedRenderColor(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return new ar(t1, e, r, n, i);
            }
            toPremultipliedRenderColor(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return new lr(t1, e * i, r * i, n * i, i);
            }
            clone() {
                return new sr(this.r, this.g, this.b, this.a);
            }
        }
        class or {
            constructor(t1, e, r, n, i, s = !1){
                if (this.premultiplied = !1, this.premultiplied = s, t1) {
                    const s = t1.image.height, o = s * s;
                    this.premultiplied ? (e = 0 === i ? 0 : e / i * (s - 1), r = 0 === i ? 0 : r / i * (s - 1), n = 0 === i ? 0 : n / i * (s - 1)) : (e *= s - 1, r *= s - 1, n *= s - 1);
                    const a = Math.floor(e), l = Math.floor(r), u = Math.floor(n), c = Math.ceil(e), h = Math.ceil(r), p = Math.ceil(n), f = e - a, d = r - l, m = n - u, y = t1.image.data, g = 4 * (a + l * o + u * s), x = 4 * (a + l * o + p * s), v = 4 * (a + h * o + u * s), b = 4 * (a + h * o + p * s), w = 4 * (c + l * o + u * s), _ = 4 * (c + l * o + p * s), A = 4 * (c + h * o + u * s), M = 4 * (c + h * o + p * s);
                    if (g < 0 || M >= y.length) throw new Error("out of range");
                    this.r = ur(ur(ur(y[g], y[x], m), ur(y[v], y[b], m), d), ur(ur(y[w], y[_], m), ur(y[A], y[M], m), d), f) / 255 * (this.premultiplied ? i : 1), this.g = ur(ur(ur(y[g + 1], y[x + 1], m), ur(y[v + 1], y[b + 1], m), d), ur(ur(y[w + 1], y[_ + 1], m), ur(y[A + 1], y[M + 1], m), d), f) / 255 * (this.premultiplied ? i : 1), this.b = ur(ur(ur(y[g + 2], y[x + 2], m), ur(y[v + 2], y[b + 2], m), d), ur(ur(y[w + 2], y[_ + 2], m), ur(y[A + 2], y[M + 2], m), d), f) / 255 * (this.premultiplied ? i : 1), this.a = i;
                } else this.r = e, this.g = r, this.b = n, this.a = i;
            }
            toArray() {
                const { r: t1, g: e, b: r, a: n } = this;
                return [
                    255 * t1,
                    255 * e,
                    255 * r,
                    n
                ];
            }
            toHslaArray() {
                let { r: t1, g: e, b: r, a: n } = this;
                if (this.premultiplied) {
                    if (0 === n) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    t1 /= n, e /= n, r /= n;
                }
                const i = Math.min(Math.max(t1, 0), 1), s = Math.min(Math.max(e, 0), 1), o = Math.min(Math.max(r, 0), 1), a = Math.min(i, s, o), l = Math.max(i, s, o), u = (a + l) / 2;
                if (a === l) return [
                    0,
                    0,
                    100 * u,
                    n
                ];
                const c = l - a, h = u > .5 ? c / (2 - l - a) : c / (l + a);
                let p = 0;
                return l === i ? p = (s - o) / c + (s < o ? 6 : 0) : l === s ? p = (o - i) / c + 2 : l === o && (p = (i - s) / c + 4), p *= 60, [
                    Math.min(Math.max(p, 0), 360),
                    Math.min(Math.max(100 * h, 0), 100),
                    Math.min(Math.max(100 * u, 0), 100),
                    n
                ];
            }
            toArray01() {
                const { r: t1, g: e, b: r, a: n } = this;
                return [
                    t1,
                    e,
                    r,
                    n
                ];
            }
            toArray01Scaled(t1) {
                const { r: e, g: r, b: n } = this;
                return [
                    e * t1,
                    r * t1,
                    n * t1
                ];
            }
            toArray01Linear() {
                const { r: t1, g: e, b: r, a: n } = this;
                return [
                    Math.pow(t1, 2.2),
                    Math.pow(e, 2.2),
                    Math.pow(r, 2.2),
                    n
                ];
            }
        }
        class ar extends or {
            constructor(t1, e, r, n, i){
                super(t1, e, r, n, i, !1);
            }
        }
        class lr extends or {
            constructor(t1, e, r, n, i){
                super(t1, e, r, n, i, !0);
            }
        }
        function ur(t1, e, r) {
            return t1 * (1 - r) + e * r;
        }
        function cr(t1, e, r) {
            return t1.map((t1, n)=>ur(t1, e[n], r));
        }
        sr.black = new sr(0, 0, 0, 1), sr.white = new sr(1, 1, 1, 1), sr.transparent = new sr(0, 0, 0, 0), sr.red = new sr(1, 0, 0, 1), sr.blue = new sr(0, 0, 1, 1);
        var hr = Object.freeze({
            __proto__: null,
            array: cr,
            color: function(t1, e, r) {
                return new sr(ur(t1.r, e.r, r), ur(t1.g, e.g, r), ur(t1.b, e.b, r), ur(t1.a, e.a, r));
            },
            number: ur
        });
        function pr(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        class fr extends Error {
            constructor(t1, e){
                super(e), this.message = e, this.key = t1;
            }
        }
        class dr {
            constructor(t1, e = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e)this.bindings[t1] = r;
            }
            concat(t1) {
                return new dr(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
        }
        const mr = {
            kind: "null"
        }, yr = {
            kind: "number"
        }, gr = {
            kind: "string"
        }, xr = {
            kind: "boolean"
        }, vr = {
            kind: "color"
        }, br = {
            kind: "object"
        }, wr = {
            kind: "value"
        }, _r = {
            kind: "collator"
        }, Ar = {
            kind: "formatted"
        }, Mr = {
            kind: "resolvedImage"
        };
        function Ir(t1, e) {
            return {
                kind: "array",
                itemType: t1,
                N: e
            };
        }
        function Sr(t1) {
            if ("array" === t1.kind) {
                const e = Sr(t1.itemType);
                return "number" == typeof t1.N ? `array<${e}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e}>`;
            }
            return t1.kind;
        }
        const zr = [
            mr,
            yr,
            gr,
            xr,
            vr,
            Ar,
            br,
            Ir(wr),
            Mr
        ];
        function kr(t1, e) {
            if ("error" === e.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !kr(t1.itemType, e.itemType)) && ("number" != typeof t1.N || t1.N === e.N)) return null;
            } else {
                if (t1.kind === e.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of zr)if (!kr(t1, e)) return null;
                }
            }
            return `Expected ${Sr(t1)} but found ${Sr(e)} instead.`;
        }
        function Pr(t1, e) {
            return e.some((e)=>e.kind === t1.kind);
        }
        function Er(t1, e) {
            return e.some((e)=>"null" === e ? null === t1 : "array" === e ? Array.isArray(t1) : "object" === e ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e === typeof t1);
        }
        function Tr(t1, e) {
            return "array" === t1.kind && "array" === e.kind ? t1.N === e.N && Tr(t1.itemType, e.itemType) : t1.kind === e.kind;
        }
        class Br {
            constructor(t1, e, r){
                this.sensitivity = t1 ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t1, e) {
                return this.collator.compare(t1, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Vr {
            constructor(t1, e, r, n, i){
                this.text = t1.normalize ? t1.normalize() : t1, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Cr {
            constructor(t1){
                this.sections = t1;
            }
            static fromString(t1) {
                return new Cr([
                    new Vr(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || !!t1.image && t1.image.hasPrimary());
            }
            static factory(t1) {
                return t1 instanceof Cr ? t1 : Cr.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    if (e.image) {
                        const r = e.image.getPrimary().id.toString();
                        t1.push([
                            "image",
                            r
                        ]);
                        continue;
                    }
                    t1.push(e.text);
                    const r = {};
                    e.fontStack && (r["text-font"] = [
                        "literal",
                        e.fontStack.split(",")
                    ]), e.scale && (r["font-scale"] = e.scale), e.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(e.textColor.toNonPremultipliedRenderColor(null).toArray())), t1.push(r);
                }
                return t1;
            }
        }
        class Fr {
            constructor(t1, e = {}){
                if (this.id = er.from(t1), this.options = Object.assign({}, e), e.transform) {
                    const { a: t1, b: r, c: n, d: i, e: s, f: o } = e.transform;
                    this.options.transform = new DOMMatrix([
                        t1,
                        r,
                        n,
                        i,
                        s,
                        o
                    ]);
                } else this.options.transform = new DOMMatrix([
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ]);
            }
            toString() {
                const { a: t1, b: e, c: r, d: n, e: i, f: s } = this.options.transform;
                return JSON.stringify({
                    name: this.id.name,
                    iconsetId: this.id.iconsetId,
                    params: this.options.params,
                    transform: {
                        a: t1,
                        b: e,
                        c: r,
                        d: n,
                        e: i,
                        f: s
                    }
                });
            }
            static parse(t1) {
                let e, r, n, i;
                try {
                    ({ name: e, iconsetId: r, params: n, transform: i } = JSON.parse(t1) || {});
                } catch (t1) {
                    return null;
                }
                if (!e) return null;
                const { a: s, b: o, c: a, d: l, e: u, f: c } = i || {};
                return new Fr({
                    name: e,
                    iconsetId: r
                }, {
                    params: n,
                    transform: new DOMMatrix([
                        s,
                        o,
                        a,
                        l,
                        u,
                        c
                    ])
                });
            }
            scaleSelf(t1, e) {
                return this.options.transform.scaleSelf(t1, e), this;
            }
        }
        class Dr {
            constructor(t1, e, r, n, i = !1){
                this.primaryId = er.from(t1), this.primaryOptions = e, r && (this.secondaryId = er.from(r)), this.secondaryOptions = n, this.available = i;
            }
            toString() {
                return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
                return !!this.primaryId;
            }
            getPrimary() {
                return new Fr(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
                return !!this.secondaryId;
            }
            getSecondary() {
                return this.secondaryId ? new Fr(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(t1) {
                return "string" == typeof t1 ? Dr.build({
                    name: t1
                }) : t1;
            }
            static build(t1, e, r, n) {
                return !t1 || "object" == typeof t1 && !("name" in t1) ? null : new Dr(t1, r, e, n);
            }
        }
        function Lr(t1, e, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e,
                r,
                n
            ] : [
                t1,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Rr(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof sr) return !0;
            if (t1 instanceof Br) return !0;
            if (t1 instanceof Cr) return !0;
            if (t1 instanceof Dr) return !0;
            if (Array.isArray(t1)) {
                for (const e of t1)if (!Rr(e)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e in t1)if (!Rr(t1[e])) return !1;
                return !0;
            }
            return !1;
        }
        function Or(t1) {
            if (null === t1) return mr;
            if ("string" == typeof t1) return gr;
            if ("boolean" == typeof t1) return xr;
            if ("number" == typeof t1) return yr;
            if (t1 instanceof sr) return vr;
            if (t1 instanceof Br) return _r;
            if (t1 instanceof Cr) return Ar;
            if (t1 instanceof Dr) return Mr;
            if (Array.isArray(t1)) {
                const e = t1.length;
                let r;
                for (const e of t1){
                    const t1 = Or(e);
                    if (r) {
                        if (r === t1) continue;
                        r = wr;
                        break;
                    }
                    r = t1;
                }
                return Ir(r || wr, e);
            }
            return br;
        }
        function Ur(t1) {
            const e = typeof t1;
            return null === t1 ? "" : "string" === e || "number" === e || "boolean" === e ? String(t1) : t1 instanceof Cr || t1 instanceof Dr || t1 instanceof sr ? t1.toString() : JSON.stringify(t1);
        }
        class Nr {
            constructor(t1, e){
                this.type = t1, this.value = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!Rr(t1[1])) return e.error("invalid value");
                const r = t1[1];
                let n = Or(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Nr(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof sr ? [
                    "rgba"
                ].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof Cr ? this.value.serialize() : this.value;
            }
        }
        class jr {
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
            toJSON() {
                return this.message;
            }
        }
        const $r = {
            string: gr,
            number: yr,
            boolean: xr,
            object: br
        };
        class Gr {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, s;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in $r) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = $r[r], n++;
                    } else i = wr;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t1[2], n++;
                    }
                    r = Ir(i, s);
                } else r = $r[i];
                const s = [];
                for(; n < t1.length; n++){
                    const r = e.parse(t1[n], n, wr);
                    if (!r) return null;
                    s.push(r);
                }
                return new Gr(r, s);
            }
            evaluate(t1) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t1);
                    if (!kr(this.type, Or(r))) return r;
                    if (e === this.args.length - 1) throw new jr(`The expression ${JSON.stringify(this.args[e].serialize())} evaluated to ${Sr(Or(r))} but was expected to be of type ${Sr(this.type)}.`);
                }
                return null;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = this.type, e = [
                    t1.kind
                ];
                if ("array" === t1.kind) {
                    const r = t1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        e.push(r.kind);
                        const n = t1.N;
                        ("number" == typeof n || this.args.length > 1) && e.push(n);
                    }
                }
                return e.concat(this.args.map((t1)=>t1.serialize()));
            }
        }
        class qr {
            constructor(t1){
                this.type = Ar, this.sections = t1;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const s = t1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t1 = null;
                        if (s["font-scale"] && (t1 = e.parseObjectValue(s["font-scale"], r, "font-scale", yr), !t1)) return null;
                        let o = null;
                        if (s["text-font"] && (o = e.parseObjectValue(s["text-font"], r, "text-font", Ir(gr)), !o)) return null;
                        let a = null;
                        if (s["text-color"] && (a = e.parseObjectValue(s["text-color"], r, "text-color", vr), !a)) return null;
                        const l = n[n.length - 1];
                        l.scale = t1, l.font = o, l.textColor = a;
                    } else {
                        const s = e.parse(t1[r], r, wr);
                        if (!s) return null;
                        const o = s.type.kind;
                        if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new qr(n);
            }
            evaluate(t1) {
                return new Cr(this.sections.map((e)=>{
                    const r = e.content.evaluate(t1);
                    return Tr(Or(r), Mr) ? new Vr("", r, null, null, null) : new Vr(Ur(r), null, e.scale ? e.scale.evaluate(t1) : null, e.font ? e.font.evaluate(t1).join(",") : null, e.textColor ? e.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e of this.sections)t1(e.content), e.scale && t1(e.scale), e.font && t1(e.font), e.textColor && t1(e.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    t1.push(e.content.serialize());
                    const r = {};
                    e.scale && (r["font-scale"] = e.scale.serialize()), e.font && (r["text-font"] = e.font.serialize()), e.textColor && (r["text-color"] = e.textColor.serialize()), t1.push(r);
                }
                return t1;
            }
        }
        class Hr {
            constructor(t1, e, r, n){
                this._imageWarnHistory = {}, this.type = Mr, this.namePrimary = t1, this.nameSecondary = e, r && (this.paramsPrimary = r.params, this.iconsetIdPrimary = r.iconset ? r.iconset.id : void 0), n && (this.paramsSecondary = n.params, this.iconsetIdSecondary = n.iconset ? n.iconset.id : void 0);
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected two or more arguments.");
                let r = 1;
                const n = [];
                function i() {
                    if (r < t1.length) {
                        const i = e.parse(t1[r], r++, gr);
                        return i ? (n.push({
                            image: i,
                            options: {}
                        }), !0) : (e.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function s() {
                    if (r < t1.length) {
                        const s = t1[r];
                        if (null === (i = s) || "object" != typeof i || Array.isArray(i)) return !0;
                        const o = s.params, a = s.iconset, l = e.concat(r);
                        if (!o && !a) return r++, !0;
                        if (o) {
                            if ("object" != typeof o || o.constructor !== Object) return l.error('Image options "params" should be an object'), !1;
                            const t1 = {}, e = l.concat(void 0, "params");
                            for(const r in o){
                                if (!r) return e.error("Image parameter name should be non-empty"), !1;
                                const n = e.concat(void 0, r).parse(o[r], void 0, vr, void 0, {
                                    typeAnnotation: "coerce"
                                });
                                if (!n) return !1;
                                t1[r] = n;
                            }
                            n[n.length - 1].options.params = t1;
                        }
                        if (a) {
                            if ("object" != typeof a || a.constructor !== Object) return l.error('Image options "iconset" should be an object'), !1;
                            if (!a.id) return l.error('Image options "iconset" should have an "id" property'), !1;
                            n[n.length - 1].options.iconset = a;
                        }
                        return r++, !0;
                    }
                    var i;
                    return !0;
                }
                for(let t1 = 0; t1 < 2; t1++)if (!i() || !s()) return;
                return new Hr(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(t1, e) {
                const r = {};
                if (e) {
                    for(const n in e)if (e[n]) try {
                        r[n] = e[n].evaluate(t1);
                    } catch (t1) {
                        continue;
                    }
                    if (0 !== Object.keys(r).length) return {
                        params: r
                    };
                }
            }
            evaluate(t1) {
                const e = {
                    name: this.namePrimary.evaluate(t1),
                    iconsetId: this.iconsetIdPrimary
                }, r = this.nameSecondary ? {
                    name: this.nameSecondary.evaluate(t1),
                    iconsetId: this.iconsetIdSecondary
                } : void 0, n = Dr.build(e, r, this.paramsPrimary ? this.evaluateParams(t1, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(t1, this.paramsSecondary) : void 0);
                if (n && t1.availableImages) {
                    const e = n.getPrimary().id;
                    if (n.available = t1.availableImages.some((t1)=>er.isEqual(t1, e)), n.available) {
                        const e = n.getSecondary() ? n.getSecondary().id : null;
                        e && (n.available = t1.availableImages.some((t1)=>er.isEqual(t1, e)));
                    }
                }
                return n;
            }
            eachChild(t1) {
                if (t1(this.namePrimary), this.paramsPrimary) for(const e in this.paramsPrimary)this.paramsPrimary[e] && t1(this.paramsPrimary[e]);
                if (this.nameSecondary && (t1(this.nameSecondary), this.paramsSecondary)) for(const e in this.paramsSecondary)this.paramsSecondary[e] && t1(this.paramsSecondary[e]);
            }
            outputDefined() {
                return !1;
            }
            serializeOptions(t1, e) {
                const r = {};
                if (e && (r.iconset = {
                    id: e
                }), t1) {
                    r.params = {};
                    for(const e in t1)t1[e] && (r.params[e] = t1[e].serialize());
                }
                return Object.keys(r).length > 0 ? r : void 0;
            }
            serialize() {
                const t1 = [
                    "image",
                    this.namePrimary.serialize()
                ];
                if (this.paramsPrimary || this.iconsetIdPrimary) {
                    const e = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                    e && t1.push(e);
                }
                if (this.nameSecondary && (t1.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                    const e = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                    e && t1.push(e);
                }
                return t1;
            }
        }
        function Xr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        const Zr = {
            "to-boolean": xr,
            "to-color": vr,
            "to-number": yr,
            "to-string": gr
        };
        class Wr {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[0], n = [];
                let i = mr;
                if ("to-array" === r) {
                    if (!Array.isArray(t1[1])) return null;
                    const r = t1[1].length;
                    if (e.expectedType) {
                        if ("array" !== e.expectedType.kind) return e.error(`Expected ${e.expectedType.kind} but found array.`);
                        i = Ir(e.expectedType.itemType, r);
                    } else {
                        if (!(r > 0 && Rr(t1[1][0]))) return null;
                        i = Ir(Or(t1[1][0]), r);
                    }
                    for(let s = 0; s < r; s++){
                        const r = t1[1][s];
                        let o;
                        if ("array" === Xr(r)) o = e.parse(r, void 0, i.itemType);
                        else {
                            const t1 = Xr(r);
                            if (t1 !== i.itemType.kind) return e.error(`Expected ${i.itemType.kind} but found ${t1}.`);
                            o = e.registry.literal.parse([
                                "literal",
                                void 0 === r ? null : r
                            ], e);
                        }
                        if (!o) return null;
                        n.push(o);
                    }
                } else {
                    if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e.error("Expected one argument.");
                    i = Zr[r];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], r, wr);
                        if (!i) return null;
                        n.push(i);
                    }
                }
                return new Wr(i, n);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e, r;
                    for (const n of this.args){
                        if (e = n.evaluate(t1), r = null, e instanceof sr) return e;
                        if ("string" == typeof e) {
                            const r = t1.parseColor(e);
                            if (r) return r;
                        } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : Lr(e[0], e[1], e[2], e[3]), !r)) return new sr(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                    }
                    throw new jr(r || `Could not parse color from value '${"string" == typeof e ? e : String(JSON.stringify(e))}'`);
                }
                if ("number" === this.type.kind) {
                    let e = null;
                    for (const r of this.args){
                        if (e = r.evaluate(t1), null === e) return 0;
                        const n = Number(e);
                        if (!isNaN(n)) return n;
                    }
                    throw new jr(`Could not convert ${JSON.stringify(e)} to number.`);
                }
                return "formatted" === this.type.kind ? Cr.fromString(Ur(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? Dr.build(Ur(this.args[0].evaluate(t1))) : "array" === this.type.kind ? this.args.map((e)=>e.evaluate(t1)) : Ur(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new qr([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Hr(this.args[0]).serialize();
                const t1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        const Yr = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Kr {
            constructor(t1, e){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t1, this.options = e;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Yr[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(t1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const t1 = this.featureDistanceData.center, e = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * e - t1[0]) + this.featureDistanceData.bearing[1] * (n * e - t1[1]);
                }
                return 0;
            }
            parseColor(t1) {
                let e = this._parseColorCache[t1];
                return e || (e = this._parseColorCache[t1] = sr.parse(t1)), e;
            }
            getConfig(t1) {
                return this.options ? this.options.get(t1) : null;
            }
        }
        class Jr {
            constructor(t1, e, r, n, i){
                this.name = t1, this.type = e, this._evaluate = r, this.args = n, this._overloadIndex = i;
            }
            evaluate(t1) {
                if (!this._evaluate) {
                    const t1 = Jr.definitions[this.name];
                    this._evaluate = Array.isArray(t1) ? t1[2] : t1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((t1)=>t1.serialize()));
            }
            static parse(t1, e) {
                const r = t1[0], n = Jr.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, o = [];
                let a = null, l = -1;
                for (const [n, u] of s){
                    if (Array.isArray(n) && n.length !== t1.length - 1) continue;
                    o.push(n), l++, a = new bi(e.registry, e.path, null, e.scope, void 0, e._scope, e.options);
                    const s = [];
                    let c = !1;
                    for(let e = 1; e < t1.length; e++){
                        const r = t1[e], i = Array.isArray(n) ? n[e - 1] : n.type, o = a.parse(r, 1 + s.length, i);
                        if (!o) {
                            c = !0;
                            break;
                        }
                        s.push(o);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== s.length) a.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < s.length; t1++){
                                const e = Array.isArray(n) ? n[t1] : n.type, r = s[t1];
                                a.concat(t1 + 1).checkSubtype(e, r.type);
                            }
                            if (0 === a.errors.length) return new Jr(r, i, u, s, l);
                        }
                    }
                }
                if (1 === o.length) e.errors.push(...a.errors);
                else {
                    const r = (o.length ? o : s.map(([t1])=>t1)).map(Qr).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(Sr(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e) {
                Jr.definitions = e;
                for(const r in e)t1[r] = Jr;
            }
        }
        function Qr(t1) {
            return Array.isArray(t1) ? `(${t1.map(Sr).join(", ")})` : `(${Sr(t1.type)}...)`;
        }
        class tn {
            constructor(t1, e, r){
                this.type = _r, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = void 0 === r["case-sensitive"] ? e.parse(!1, 1, xr) : e.parseObjectValue(r["case-sensitive"], 1, "case-sensitive", xr);
                if (!n) return null;
                const i = void 0 === r["diacritic-sensitive"] ? e.parse(!1, 1, xr) : e.parseObjectValue(r["diacritic-sensitive"], 1, "diacritic-sensitive", xr);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e.parseObjectValue(r.locale, 1, "locale", gr), !s) ? null : new tn(n, i, s);
            }
            evaluate(t1) {
                return new Br(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                    "collator",
                    t1
                ];
            }
        }
        function en(t1, e, r = 0, n = t1.length - 1, i = nn) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, o = e - r + 1, a = Math.log(s), l = .5 * Math.exp(2 * a / 3), u = .5 * Math.sqrt(a * l * (s - l) / s) * (o - s / 2 < 0 ? -1 : 1);
                    en(t1, e, Math.max(r, Math.floor(e - o * l / s + u)), Math.min(n, Math.floor(e + (s - o) * l / s + u)), i);
                }
                const s = t1[e];
                let o = r, a = n;
                for(rn(t1, r, e), i(t1[n], s) > 0 && rn(t1, r, n); o < a;){
                    for(rn(t1, o, a), o++, a--; i(t1[o], s) < 0;)o++;
                    for(; i(t1[a], s) > 0;)a--;
                }
                0 === i(t1[r], s) ? rn(t1, r, a) : (a++, rn(t1, a, n)), a <= e && (r = a + 1), e <= a && (n = a - 1);
            }
        }
        function rn(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function nn(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function sn(t1) {
            let e = 0;
            for(let r, n, i = 0, s = t1.length, o = s - 1; i < s; o = i++)r = t1[i], n = t1[o], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function on(t1, e) {
            t1[0] = Math.min(t1[0], e[0]), t1[1] = Math.min(t1[1], e[1]), t1[2] = Math.max(t1[2], e[0]), t1[3] = Math.max(t1[3], e[1]);
        }
        function an(t1, e) {
            return !(t1[0] <= e[0] || t1[2] >= e[2] || t1[1] <= e[1] || t1[3] >= e[3]);
        }
        function ln(t1, e, r) {
            const n = t1[0] - e[0], i = t1[1] - e[1], s = t1[0] - r[0], o = t1[1] - r[1];
            return n * o - s * i == 0 && n * s <= 0 && i * o <= 0;
        }
        function un(t1, e, r = !1) {
            let n = !1;
            for(let a = 0, l = e.length; a < l; a++){
                const l = e[a];
                for(let e = 0, a = l.length, u = a - 1; e < a; u = e++){
                    const a = l[u], c = l[e];
                    if (ln(t1, a, c)) return r;
                    (s = a)[1] > (i = t1)[1] != (o = c)[1] > i[1] && i[0] < (o[0] - s[0]) * (i[1] - s[1]) / (o[1] - s[1]) + s[0] && (n = !n);
                }
            }
            var i, s, o;
            return n;
        }
        function cn(t1, e, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], o = (t1[0] - r[0]) * s - i * (t1[1] - r[1]), a = (e[0] - r[0]) * s - i * (e[1] - r[1]);
            return o > 0 && a < 0 || o < 0 && a > 0;
        }
        function hn(t1, e, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                e[0] - t1[0],
                e[1] - t1[1]
            ])[1] - i[1] * s[0] && !(!cn(t1, e, r, n) || !cn(r, n, t1, e));
        }
        function pn(t1) {
            const e = new bt(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r = new bt(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n of t1[0])e.x > n.x && (e.x = n.x), e.y > n.y && (e.y = n.y), r.x < n.x && (r.x = n.x), r.y < n.y && (r.y = n.y);
            return {
                min: e,
                max: r
            };
        }
        const fn = 8192;
        function dn(t1, e) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * fn),
                Math.round(n * i * fn)
            ];
        }
        function mn(t1, e) {
            for(let r = 0; r < e.length; r++)if (un(t1, e[r])) return !0;
            return !1;
        }
        function yn(t1, e, r) {
            for (const n of r)for(let r = 0, i = n.length, s = i - 1; r < i; s = r++)if (hn(t1, e, n[s], n[r])) return !0;
            return !1;
        }
        function gn(t1, e) {
            for(let r = 0; r < t1.length; ++r)if (!un(t1[r], e)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (yn(t1[r], t1[r + 1], e)) return !1;
            return !0;
        }
        function xn(t1, e) {
            for(let r = 0; r < e.length; r++)if (gn(t1, e[r])) return !0;
            return !1;
        }
        function vn(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = [];
                for(let n = 0; n < t1[i].length; n++){
                    const o = dn(t1[i][n], r);
                    on(e, o), s.push(o);
                }
                n.push(s);
            }
            return n;
        }
        function bn(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = vn(t1[i], e, r);
                n.push(s);
            }
            return n;
        }
        function wn(t1, e, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e = .5 * n;
                let i = t1[0] - r[0] > e ? -n : r[0] - t1[0] > e ? n : 0;
                0 === i && (i = t1[0] - r[2] > e ? -n : r[2] - t1[0] > e ? n : 0), t1[0] += i;
            }
            on(e, t1);
        }
        function _n(t1, e, r, n) {
            const i = Math.pow(2, n.z) * fn, s = [
                n.x * fn,
                n.y * fn
            ], o = [];
            if (!t1) return o;
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + s[0],
                    t1.y + s[1]
                ];
                wn(n, e, r, i), o.push(n);
            }
            return o;
        }
        function An(t1, e, r, n) {
            const i = Math.pow(2, n.z) * fn, s = [
                n.x * fn,
                n.y * fn
            ], o = [];
            if (!t1) return o;
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    on(e, r), t1.push(r);
                }
                o.push(t1);
            }
            if (e[2] - e[0] <= i / 2) {
                (a = e)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const t1 of o)for (const n of t1)wn(n, e, r, i);
            }
            var a;
            return o;
        }
        class Mn {
            constructor(t1, e){
                this.type = xr, this.geojson = t1, this.geometries = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (Rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) for(let t1 = 0; t1 < e.features.length; ++t1){
                        const r = e.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Mn(e, e.features[t1].geometry);
                    }
                    else if ("Feature" === e.type) {
                        const t1 = e.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new Mn(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Mn(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const s = vn(e.coordinates, n, i), o = _n(t1.geometry(), r, n, i);
                            if (!an(r, n)) return !1;
                            for (const t1 of o)if (!un(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = bn(e.coordinates, n, i), o = _n(t1.geometry(), r, n, i);
                            if (!an(r, n)) return !1;
                            for (const t1 of o)if (!mn(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const s = vn(e.coordinates, n, i), o = An(t1.geometry(), r, n, i);
                            if (!an(r, n)) return !1;
                            for (const t1 of o)if (!gn(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = bn(e.coordinates, n, i), o = An(t1.geometry(), r, n, i);
                            if (!an(r, n)) return !1;
                            for (const t1 of o)if (!xn(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        const In = {
            kilometers: 1,
            miles: 1e3 / 1609.344,
            nauticalmiles: 1e3 / 1852,
            meters: 1e3,
            metres: 1e3,
            yards: 1e3 / .9144,
            feet: 1e3 / .3048,
            inches: 1e3 / .0254
        }, Sn = 1 / 298.257223563, zn = Sn * (2 - Sn), kn = Math.PI / 180;
        class Pn {
            static fromTile(t1, e, r) {
                const n = Math.PI * (1 - 2 * (t1 + .5) / Math.pow(2, e)), i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / kn;
                return new Pn(i, r);
            }
            static get units() {
                return In;
            }
            constructor(t1, e){
                if (void 0 === t1) throw new Error("No latitude given.");
                if (e && !In[e]) throw new Error(`Unknown unit ${e}. Use one of: ${Object.keys(In).join(", ")}`);
                const r = 6378.137 * kn * (e ? In[e] : 1), n = Math.cos(t1 * kn), i = 1 / (1 - zn * (1 - n * n)), s = Math.sqrt(i);
                this.kx = r * s * n, this.ky = r * s * i * (1 - zn);
            }
            distance(t1, e) {
                const r = Bn(t1[0] - e[0]) * this.kx, n = (t1[1] - e[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            bearing(t1, e) {
                const r = Bn(e[0] - t1[0]) * this.kx;
                return Math.atan2(r, (e[1] - t1[1]) * this.ky) / kn;
            }
            destination(t1, e, r) {
                const n = r * kn;
                return this.offset(t1, Math.sin(n) * e, Math.cos(n) * e);
            }
            offset(t1, e, r) {
                return [
                    t1[0] + e / this.kx,
                    t1[1] + r / this.ky
                ];
            }
            lineDistance(t1) {
                let e = 0;
                for(let r = 0; r < t1.length - 1; r++)e += this.distance(t1[r], t1[r + 1]);
                return e;
            }
            area(t1) {
                let e = 0;
                for(let r = 0; r < t1.length; r++){
                    const n = t1[r];
                    for(let t1 = 0, i = n.length, s = i - 1; t1 < i; s = t1++)e += Bn(n[t1][0] - n[s][0]) * (n[t1][1] + n[s][1]) * (r ? -1 : 1);
                }
                return Math.abs(e) / 2 * this.kx * this.ky;
            }
            along(t1, e) {
                let r = 0;
                if (e <= 0) return t1[0];
                for(let n = 0; n < t1.length - 1; n++){
                    const i = t1[n], s = t1[n + 1], o = this.distance(i, s);
                    if (r += o, r > e) return Tn(i, s, (e - (r - o)) / o);
                }
                return t1[t1.length - 1];
            }
            pointToSegmentDistance(t1, e, r) {
                let [n, i] = e, s = Bn(r[0] - n) * this.kx, o = (r[1] - i) * this.ky;
                if (0 !== s || 0 !== o) {
                    const e = (Bn(t1[0] - n) * this.kx * s + (t1[1] - i) * this.ky * o) / (s * s + o * o);
                    e > 1 ? (n = r[0], i = r[1]) : e > 0 && (n += s / this.kx * e, i += o / this.ky * e);
                }
                return s = Bn(t1[0] - n) * this.kx, o = (t1[1] - i) * this.ky, Math.sqrt(s * s + o * o);
            }
            pointOnLine(t1, e) {
                let r = 1 / 0, n = t1[0][0], i = t1[0][1], s = 0, o = 0;
                for(let a = 0; a < t1.length - 1; a++){
                    let l = t1[a][0], u = t1[a][1], c = Bn(t1[a + 1][0] - l) * this.kx, h = (t1[a + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (Bn(e[0] - l) * this.kx * c + (e[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t1[a + 1][0], u = t1[a + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = Bn(e[0] - l) * this.kx, h = (e[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < r && (r = f, n = l, i = u, s = a, o = p);
                }
                return {
                    point: [
                        n,
                        i
                    ],
                    index: s,
                    t: Math.max(0, Math.min(1, o))
                };
            }
            lineSlice(t1, e, r) {
                let n = this.pointOnLine(r, t1), i = this.pointOnLine(r, e);
                if (n.index > i.index || n.index === i.index && n.t > i.t) {
                    const t1 = n;
                    n = i, i = t1;
                }
                const s = [
                    n.point
                ], o = n.index + 1, a = i.index;
                !En(r[o], s[0]) && o <= a && s.push(r[o]);
                for(let t1 = o + 1; t1 <= a; t1++)s.push(r[t1]);
                return En(r[a], i.point) || s.push(i.point), s;
            }
            lineSliceAlong(t1, e, r) {
                let n = 0;
                const i = [];
                for(let s = 0; s < r.length - 1; s++){
                    const o = r[s], a = r[s + 1], l = this.distance(o, a);
                    if (n += l, n > t1 && 0 === i.length && i.push(Tn(o, a, (t1 - (n - l)) / l)), n >= e) return i.push(Tn(o, a, (e - (n - l)) / l)), i;
                    n > t1 && i.push(a);
                }
                return i;
            }
            bufferPoint(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[0] + n,
                    t1[1] + r
                ];
            }
            bufferBBox(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[2] + n,
                    t1[3] + r
                ];
            }
            insideBBox(t1, e) {
                return Bn(t1[0] - e[0]) >= 0 && Bn(t1[0] - e[2]) <= 0 && t1[1] >= e[1] && t1[1] <= e[3];
            }
        }
        function En(t1, e) {
            return t1[0] === e[0] && t1[1] === e[1];
        }
        function Tn(t1, e, r) {
            const n = Bn(e[0] - t1[0]);
            return [
                t1[0] + n * r,
                t1[1] + (e[1] - t1[1]) * r
            ];
        }
        function Bn(t1) {
            for(; t1 < -180;)t1 += 360;
            for(; t1 > 180;)t1 -= 360;
            return t1;
        }
        class Vn {
            constructor(t1 = [], e = (t1, e)=>t1 < e ? -1 : t1 > e ? 1 : 0){
                if (this.data = t1, this.length = this.data.length, this.compare = e, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
            push(t1) {
                this.data.push(t1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e, compare: r } = this, n = e[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t1] = s, t1 = i;
                }
                e[t1] = n;
            }
            _down(t1) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t1] = e[n], t1 = n;
                }
                e[t1] = i;
            }
        }
        var Cn = 8192;
        function Fn(t1, e) {
            return e.dist - t1.dist;
        }
        const Dn = 100, Ln = 50;
        function Rn(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (e.length !== t1.length) return !1;
            for(let r = 0; r < e.length; r++)if (e[r] !== t1[r]) return !1;
            return !0;
        }
        function On(t1) {
            return t1[1] - t1[0] + 1;
        }
        function Un(t1, e) {
            const r = t1[1] >= t1[0] && t1[1] < e;
            return r || console.warn("Distance Expression: Index is out of range"), r;
        }
        function Nn(t1, e) {
            if (t1[0] > t1[1]) return [
                null,
                null
            ];
            const r = On(t1);
            if (e) {
                if (2 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2);
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e,
                        t1[1]
                    ]
                ];
            }
            {
                if (1 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2) - 1;
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e + 1,
                        t1[1]
                    ]
                ];
            }
        }
        function jn(t1, e) {
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!Un(e, t1.length)) return r;
            for(let n = e[0]; n <= e[1]; ++n)on(r, t1[n]);
            return r;
        }
        function $n(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = 0; r < t1.length; ++r)for(let n = 0; n < t1[r].length; ++n)on(e, t1[r][n]);
            return e;
        }
        function Gn(t1, e, r) {
            if (Rn(t1) || Rn(e)) return NaN;
            let n = 0, i = 0;
            return t1[2] < e[0] && (n = e[0] - t1[2]), t1[0] > e[2] && (n = t1[0] - e[2]), t1[1] > e[3] && (i = t1[1] - e[3]), t1[3] < e[1] && (i = e[1] - t1[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function qn(t1) {
            return 360 * t1 - 180;
        }
        function Hn(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function Xn(t1, e) {
            const r = Math.pow(2, e.z), n = (t1.y / Cn + e.y) / r;
            return [
                qn((t1.x / Cn + e.x) / r),
                Hn(n)
            ];
        }
        function Zn(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; ++n)r.push(Xn(t1[n], e));
            return r;
        }
        function Wn(t1, e, r) {
            const n = r.pointOnLine(e, t1).point;
            return r.distance(t1, n);
        }
        function Yn(t1, e, r, n, i) {
            const s = r.slice(n[0], n[1] + 1);
            let o = 1 / 0;
            for(let r = e[0]; r <= e[1]; ++r)if (0 === (o = Math.min(o, Wn(t1[r], s, i)))) return 0;
            return o;
        }
        function Kn(t1, e, r, n, i) {
            const s = Math.min(i.pointToSegmentDistance(t1, r, n), i.pointToSegmentDistance(e, r, n)), o = Math.min(i.pointToSegmentDistance(r, t1, e), i.pointToSegmentDistance(n, t1, e));
            return Math.min(s, o);
        }
        function Jn(t1, e, r, n, i) {
            if (!Un(e, t1.length) || !Un(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let o = e[0]; o < e[1]; ++o)for(let e = n[0]; e < n[1]; ++e){
                if (hn(t1[o], t1[o + 1], r[e], r[e + 1])) return 0;
                s = Math.min(s, Kn(t1[o], t1[o + 1], r[e], r[e + 1], i));
            }
            return s;
        }
        function Qn(t1, e, r, n, i) {
            if (!Un(e, t1.length) || !Un(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let o = e[0]; o <= e[1]; ++o)for(let e = n[0]; e <= n[1]; ++e)if (0 === (s = Math.min(s, i.distance(t1[o], r[e])))) return s;
            return s;
        }
        function ti(t1, e, r) {
            if (un(t1, e, !0)) return 0;
            let n = 1 / 0;
            for (const i of e){
                const e = i.length;
                if (e < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (i[0] !== i[e - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(t1, i[e - 1], i[0])))) return n;
                if (0 === (n = Math.min(n, Wn(t1, i, r)))) return n;
            }
            return n;
        }
        function ei(t1, e, r, n) {
            if (!Un(e, t1.length)) return NaN;
            for(let n = e[0]; n <= e[1]; ++n)if (un(t1[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = e[0]; s < e[1]; ++s)for (const e of r)for(let r = 0, o = e.length, a = o - 1; r < o; a = r++){
                if (hn(t1[s], t1[s + 1], e[a], e[r])) return 0;
                i = Math.min(i, Kn(t1[s], t1[s + 1], e[a], e[r], n));
            }
            return i;
        }
        function ri(t1, e) {
            for (const r of t1)for(let t1 = 0; t1 <= r.length - 1; ++t1)if (un(r[t1], e, !0)) return !0;
            return !1;
        }
        function ni(t1, e, r, n = 1 / 0) {
            const i = $n(t1), s = $n(e);
            if (n !== 1 / 0 && Gn(i, s, r) >= n) return n;
            if (an(i, s)) {
                if (ri(t1, e)) return 0;
            } else if (ri(e, t1)) return 0;
            let o = n;
            for (const n of t1)for(let t1 = 0, i = n.length, s = i - 1; t1 < i; s = t1++)for (const i of e)for(let e = 0, a = i.length, l = a - 1; e < a; l = e++){
                if (hn(n[s], n[t1], i[l], i[e])) return 0;
                o = Math.min(o, Kn(n[s], n[t1], i[l], i[e], r));
            }
            return o;
        }
        function ii(t1, e, r, n, i, s, o) {
            if (null === s || null === o) return;
            const a = Gn(jn(n, s), jn(i, o), r);
            a < e && t1.push({
                dist: a,
                range1: s,
                range2: o
            });
        }
        function si(t1, e, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(t1[0], r[0][0]), i);
            if (0 === s) return s;
            const o = new Vn([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Fn), a = e ? Ln : Dn, l = $n(r);
            for(; o.length;){
                const i = o.pop();
                if (i.dist >= s) continue;
                const u = i.range1;
                if (On(u) <= a) {
                    if (!Un(u, t1.length)) return NaN;
                    if (e) {
                        const e = ei(t1, u, r, n);
                        if (0 === (s = Math.min(s, e))) return s;
                    } else for(let e = u[0]; e <= u[1]; ++e){
                        const i = ti(t1[e], r, n);
                        if (0 === (s = Math.min(s, i))) return s;
                    }
                } else {
                    const r = Nn(u, e);
                    if (null !== r[0]) {
                        const e = Gn(jn(t1, r[0]), l, n);
                        e < s && o.push({
                            dist: e,
                            range1: r[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== r[1]) {
                        const e = Gn(jn(t1, r[1]), l, n);
                        e < s && o.push({
                            dist: e,
                            range1: r[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return s;
        }
        function oi(t1, e, r, n, i, s = 1 / 0) {
            let o = Math.min(s, i.distance(t1[0], r[0]));
            if (0 === o) return o;
            const a = new Vn([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        r.length - 1
                    ]
                }
            ], Fn), l = e ? Ln : Dn, u = n ? Ln : Dn;
            for(; a.length;){
                const s = a.pop();
                if (s.dist >= o) continue;
                const c = s.range1, h = s.range2;
                if (On(c) <= l && On(h) <= u) {
                    if (!Un(c, t1.length) || !Un(h, r.length)) return NaN;
                    if (e && n ? o = Math.min(o, Jn(t1, c, r, h, i)) : e || n ? e && !n ? o = Math.min(o, Yn(r, h, t1, c, i)) : !e && n && (o = Math.min(o, Yn(t1, c, r, h, i))) : o = Math.min(o, Qn(t1, c, r, h, i)), 0 === o) return o;
                } else {
                    const s = Nn(c, e), l = Nn(h, n);
                    ii(a, o, i, t1, r, s[0], l[0]), ii(a, o, i, t1, r, s[0], l[1]), ii(a, o, i, t1, r, s[1], l[0]), ii(a, o, i, t1, r, s[1], l[1]);
                }
            }
            return o;
        }
        function ai(t1, e, r, n, i = 1 / 0) {
            let s = i;
            const o = jn(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r)if (!(s !== 1 / 0 && Gn(o, jn(i, [
                0,
                i.length - 1
            ]), n) >= s) && (s = Math.min(s, oi(t1, e, i, !0, n, s)), 0 === s)) return s;
            return s;
        }
        function li(t1, e, r, n, i = 1 / 0) {
            let s = i;
            const o = jn(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r){
                if (s !== 1 / 0 && Gn(o, $n(i), n) >= s) continue;
                const r = si(t1, e, i, n, s);
                if (isNaN(r)) return r;
                if (0 === (s = Math.min(s, r))) return s;
            }
            return s;
        }
        function ui(t1) {
            return "Point" === t1 || "MultiPoint" === t1 || "LineString" === t1 || "MultiLineString" === t1 || "Polygon" === t1 || "MultiPolygon" === t1;
        }
        class ci {
            constructor(t1, e){
                this.type = yr, this.geojson = t1, this.geometries = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'distance' expression requires either one argument, but found ' ${t1.length - 1} instead.`);
                if (Rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) {
                        for(let t1 = 0; t1 < e.features.length; ++t1)if (ui(e.features[t1].geometry.type)) return new ci(e, e.features[t1].geometry);
                    } else if ("Feature" === e.type) {
                        if (ui(e.geometry.type)) return new ci(e, e.geometry);
                    } else if (ui(e.type)) return new ci(e, e);
                }
                return e.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(t1) {
                const e = t1.geometry(), r = t1.canonicalID();
                if (null != e && null != r) {
                    if ("Point" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1)for (const t1 of r)n.push(Xn(t1, e));
                        const i = new Pn(n[0][1], "meters");
                        return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? oi(n, !1, "Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? ai(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? li(n, !1, "Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, i) : null;
                    }(e, r, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1){
                            const t1 = [];
                            for (const n of r)t1.push(Xn(n, e));
                            n.push(t1);
                        }
                        const i = new Pn(n[0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return ai("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const s = ai(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < n.length; e++){
                                const s = li(n[e], !0, "Polygon" === r.type ? [
                                    r.coordinates
                                ] : r.coordinates, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        return null;
                    }(e, r, this.geometries);
                    if ("Polygon" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of function(t1, e) {
                            const r = t1.length;
                            if (r <= 1) return [
                                t1
                            ];
                            const n = [];
                            let i, s;
                            for(let e = 0; e < r; e++){
                                const r = sn(t1[e]);
                                0 !== r && (t1[e].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                                    t1[e]
                                ]) : i.push(t1[e]));
                            }
                            return i && n.push(i), n;
                        }(t1)){
                            const t1 = [];
                            for(let n = 0; n < r.length; ++n)t1.push(Zn(r[n], e));
                            n.push(t1);
                        }
                        const i = new Pn(n[0][0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return li("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const s = li(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        return "Polygon" === r.type || "MultiPolygon" === r.type ? function(t1, e, r) {
                            let n = 1 / 0;
                            for (const i of t1)for (const t1 of e){
                                const e = ni(i, t1, r, n);
                                if (isNaN(e)) return e;
                                if (0 === (n = Math.min(n, e))) return n;
                            }
                            return n;
                        }("Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, n, i) : null;
                    }(e, r, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requirs valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        function hi(t1) {
            if (t1 instanceof Jr) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof Mn) return !1;
            if (t1 instanceof ci) return !1;
            if (t1 instanceof xi) return t1.featureConstant;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !hi(t1) && (e = !1);
            }), e;
        }
        function pi(t1) {
            if (t1 instanceof Jr && "feature-state" === t1.name) return !1;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !pi(t1) && (e = !1);
            }), e;
        }
        function fi(t1) {
            if (t1 instanceof xi) return new Set([
                t1.key
            ]);
            let e = new Set;
            return t1.eachChild((t1)=>{
                e = new Set([
                    ...e,
                    ...fi(t1)
                ]);
            }), e;
        }
        function di(t1, e) {
            if (t1 instanceof Jr && e.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !di(t1, e) && (r = !1);
            }), r;
        }
        function mi(t1, e, r) {
            return [
                t1,
                e,
                r
            ].filter(Boolean).join("");
        }
        function yi(t1, e) {
            switch(t1){
                case "string":
                    return Ur(e);
                case "number":
                    return +e;
                case "boolean":
                    return !!e;
                case "color":
                    return sr.parse(e);
                case "formatted":
                    return Cr.fromString(Ur(e));
                case "resolvedImage":
                    return Dr.build(Ur(e));
            }
            return e;
        }
        function gi(t1, e, r, n) {
            return void 0 !== n && (t1 = n * Math.round(t1 / n)), void 0 !== e && t1 < e && (t1 = e), void 0 !== r && t1 > r && (t1 = r), t1;
        }
        class xi {
            constructor(t1, e, r, n = !1){
                this.type = t1, this.key = e, this.scope = r, this.featureConstant = n;
            }
            static parse(t1, e) {
                let r = e.expectedType;
                if (null == r && (r = wr), t1.length < 2 || t1.length > 3) return e.error("Invalid number of arguments for 'config' expression.");
                const n = e.parse(t1[1], 1);
                if (!(n instanceof Nr)) return e.error("Key name of 'config' expression must be a string literal.");
                let i, s = !0;
                const o = Ur(n.value);
                if (t1.length >= 3) {
                    const r = e.parse(t1[2], 2);
                    if (!(r instanceof Nr)) return e.error("Scope of 'config' expression must be a string literal.");
                    i = Ur(r.value);
                }
                if (e.options) {
                    const t1 = mi(o, i, e._scope), r = e.options.get(t1);
                    r && (s = hi(r.value || r.default));
                }
                return new xi(r, o, i, s);
            }
            evaluate(t1) {
                const e = mi(this.key, this.scope, t1.scope), r = t1.getConfig(e);
                if (!r) return null;
                const { type: n, value: i, values: s, minValue: o, maxValue: a, stepValue: l } = r, u = r.default.evaluate(t1);
                let c = u;
                if (i) {
                    const e = t1.scope;
                    t1.scope = (e || "").split("").slice(1).join(""), c = i.evaluate(t1), t1.scope = e;
                }
                return n && (c = yi(n, c)), void 0 === c || void 0 === o && void 0 === a && void 0 === l || ("number" == typeof c ? c = gi(c, o, a, l) : Array.isArray(c) && (c = c.map((t1)=>"number" == typeof t1 ? gi(t1, o, a, l) : t1))), void 0 !== i && void 0 !== c && s && !s.includes(c) && (c = u, n && (c = yi(n, c))), (n && n !== this.type || void 0 !== c && !Tr(Or(c), this.type)) && (c = yi(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "config",
                    this.key
                ];
                return this.scope && t1.concat(this.scope), t1;
            }
        }
        class vi {
            constructor(t1, e){
                this.type = e.type, this.name = t1, this.boundExpression = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e.scope.has(r) ? new vi(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class bi {
            constructor(t1, e = [], r, n = new dr, i = [], s, o){
                this.registry = t1, this.path = e, this.key = e.map((t1)=>"string" == typeof t1 ? `['${t1}']` : `[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = s, this.options = o;
            }
            parse(t1, e, r, n, i = {}) {
                return e || r ? this.concat(e, null, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            parseObjectValue(t1, e, r, n, i, s = {}) {
                return this.concat(e, r, n, i)._parse(t1, s);
            }
            _parse(t1, e) {
                function r(t1, e, r) {
                    return "assert" === r ? new Gr(e, [
                        t1
                    ]) : "coerce" === r ? new Wr(e, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = "string" == typeof t1[0] ? this.registry[t1[0]] : void 0;
                    if (n) {
                        let i = n.parse(t1, this);
                        if (!i) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, n = i.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== n.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== n.kind && "string" !== n.kind) {
                                    if (this.checkSubtype(t1, n)) return null;
                                } else i = r(i, t1, e.typeAnnotation || "coerce");
                            } else i = r(i, t1, e.typeAnnotation || "assert");
                        }
                        if (!(i instanceof Nr) && "resolvedImage" !== i.type.kind && wi(i)) {
                            const t1 = new Kr(this._scope, this.options);
                            try {
                                i = new Nr(i.type, i.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return i;
                    }
                    return Wr.parse([
                        "to-array",
                        t1
                    ], this);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e, r, n) {
                let i = "number" == typeof t1 ? this.path.concat(t1) : this.path;
                i = "string" == typeof e ? i.concat(e) : i;
                const s = n ? this.scope.concat(n) : this.scope;
                return new bi(this.registry, i, r || null, s, this.errors, this._scope, this.options);
            }
            error(t1, ...e) {
                const r = `${this.key}${e.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new fr(r, t1));
            }
            checkSubtype(t1, e) {
                const r = kr(t1, e);
                return r && this.error(r), r;
            }
        }
        function wi(t1) {
            if (t1 instanceof vi) return wi(t1.boundExpression);
            if (t1 instanceof Jr && "error" === t1.name) return !1;
            if (t1 instanceof tn) return !1;
            if (t1 instanceof Mn) return !1;
            if (t1 instanceof ci) return !1;
            if (t1 instanceof xi) return !1;
            const e = t1 instanceof Wr || t1 instanceof Gr;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e ? r && wi(t1) : r && t1 instanceof Nr;
            }), !!r && hi(t1) && di(t1, [
                "zoom",
                "heatmap-density",
                "worldview",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light",
                "raster-particle-speed"
            ]);
        }
        function _i(t1, e) {
            const r = t1.length - 1;
            let n, i, s = 0, o = r, a = 0;
            for(; s <= o;)if (a = Math.floor((s + o) / 2), n = t1[a], i = t1[a + 1], n <= e) {
                if (a === r || e < i) return a;
                s = a + 1;
            } else {
                if (!(n > e)) throw new jr("Input is not a number.");
                o = a - 1;
            }
            return 0;
        }
        class Ai {
            constructor(t1, e, r){
                this.type = t1, this.input = e, this.labels = [], this.outputs = [];
                for (const [t1, e] of r)this.labels.push(t1), this.outputs.push(e);
            }
            static parse(t1, e) {
                if (t1.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t1[1], 1, yr);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t1[r], o = t1[r + 1], a = r, l = r + 1;
                    if ("number" != typeof s) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (n.length && n[n.length - 1][0] >= s) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const u = e.parse(o, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new Ai(i, r, n);
            }
            evaluate(t1) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t1) : r[_i(e, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let e = 0; e < this.labels.length; e++)e > 0 && t1.push(this.labels[e]), t1.push(this.outputs[e].serialize());
                return t1;
            }
        }
        const Mi = .95047, Ii = 1.08883, Si = 4 / 29, zi = 6 / 29, ki = 3 * zi * zi, Pi = zi * zi * zi, Ei = Math.PI / 180, Ti = 180 / Math.PI;
        function Bi(t1) {
            return t1 > Pi ? Math.pow(t1, 1 / 3) : t1 / ki + Si;
        }
        function Vi(t1) {
            return t1 > zi ? t1 * t1 * t1 : ki * (t1 - Si);
        }
        function Ci(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function Fi(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Di(t1) {
            const e = Fi(t1.r), r = Fi(t1.g), n = Fi(t1.b), i = Bi((.4124564 * e + .3575761 * r + .1804375 * n) / Mi), s = Bi((.2126729 * e + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - Bi((.0193339 * e + .119192 * r + .9503041 * n) / Ii)),
                alpha: t1.a
            };
        }
        function Li(t1) {
            let e = (t1.l + 16) / 116, r = isNaN(t1.a) ? e : e + t1.a / 500, n = isNaN(t1.b) ? e : e - t1.b / 200;
            return e = 1 * Vi(e), r = Mi * Vi(r), n = Ii * Vi(n), new sr(Ci(3.2404542 * r - 1.5371385 * e - .4985314 * n), Ci(-0.969266 * r + 1.8760108 * e + .041556 * n), Ci(.0556434 * r - .2040259 * e + 1.0572252 * n), t1.alpha);
        }
        function Ri(t1, e, r) {
            const n = e - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Oi = {
            forward: Di,
            reverse: Li,
            interpolate: function(t1, e, r) {
                return {
                    l: ur(t1.l, e.l, r),
                    a: ur(t1.a, e.a, r),
                    b: ur(t1.b, e.b, r),
                    alpha: ur(t1.alpha, e.alpha, r)
                };
            }
        }, Ui = {
            forward: function(t1) {
                const { l: e, a: r, b: n } = Di(t1), i = Math.atan2(n, r) * Ti;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e = t1.h * Ei, r = t1.c;
                return Li({
                    l: t1.l,
                    a: Math.cos(e) * r,
                    b: Math.sin(e) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e, r) {
                return {
                    h: Ri(t1.h, e.h, r),
                    c: ur(t1.c, e.c, r),
                    l: ur(t1.l, e.l, r),
                    alpha: ur(t1.alpha, e.alpha, r)
                };
            }
        };
        var Ni = Object.freeze({
            __proto__: null,
            hcl: Ui,
            lab: Oi
        });
        class ji {
            constructor(t1, e, r, n, i){
                this.type = t1, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e] of i)this.labels.push(t1), this.outputs.push(e);
            }
            static interpolationFactor(t1, e, r, n) {
                let i = 0;
                if ("exponential" === t1.name) i = $i(e, t1.base, r, n);
                else if ("linear" === t1.name) i = $i(e, 1, r, n);
                else if ("cubic-bezier" === t1.name) {
                    const s = t1.controlPoints;
                    i = new xt(s[0], s[1], s[2], s[3]).solve($i(e, 1, r, n));
                }
                return i;
            }
            static parse(t1, e) {
                let [r, n, i, ...s] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length - 1 > 3 && (t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, yr), !i) return null;
                const o = [];
                let a = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? a = vr : e.expectedType && "value" !== e.expectedType.kind && (a = e.expectedType);
                for(let t1 = 0; t1 < s.length; t1 += 2){
                    const r = s[t1], n = s[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (o.length && o[o.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, a);
                    if (!u) return null;
                    a = a || u.type, o.push([
                        r,
                        u
                    ]);
                }
                return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new ji(a, r, n, i, o) : e.error(`Type ${Sr(a)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t1);
                const s = _i(e, n), o = ji.interpolationFactor(this.interpolation, n, e[s], e[s + 1]), a = r[s].evaluate(t1), l = r[s + 1].evaluate(t1);
                return "interpolate" === this.operator ? hr[this.type.kind.toLowerCase()](a, l, o) : "interpolate-hcl" === this.operator ? Ui.reverse(Ui.interpolate(Ui.forward(a), Ui.forward(l), o)) : Oi.reverse(Oi.interpolate(Oi.forward(a), Oi.forward(l), o));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                let t1;
                t1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier",
                    ...this.interpolation.controlPoints
                ];
                const e = [
                    this.operator,
                    t1,
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)e.push(this.labels[t1], this.outputs[t1].serialize());
                return e;
            }
        }
        function $i(t1, e, r, n) {
            const i = n - r, s = t1 - r;
            return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
        }
        class Gi {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                const s = n && i.some((t1)=>kr(n, t1.type));
                return new Gi(s ? wr : r, i);
            }
            evaluate(t1) {
                let e, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(t1), r && r instanceof Dr && !r.available && (e || (e = r), r = null, n === this.args.length)) return e;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "coalesce"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        class qi {
            constructor(t1, e){
                this.type = e.type, this.bindings = [].concat(t1), this.result = e;
            }
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e of this.bindings)t1(e[1]);
                t1(this.result);
            }
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e.parse(t1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e.parse(t1[t1.length - 1], t1.length - 1, e.expectedType, r);
                return n ? new qi(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const t1 = [
                    "let"
                ];
                for (const [e, r] of this.bindings)t1.push(e, r.serialize());
                return t1.push(this.result.serialize()), t1;
            }
        }
        class Hi {
            constructor(t1, e, r){
                this.type = t1, this.index = e, this.input = r;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, yr), n = e.parse(t1[2], 2, Ir(e.expectedType || wr));
                return r && n ? new Hi(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e < 0) throw new jr(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new jr(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new jr(`Array index must be an integer, but found ${e} instead. Use at-interpolated to retrieve interpolated result with a fractional index.`);
                return r[e];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Xi {
            constructor(t1, e, r){
                this.type = t1, this.index = e, this.input = r;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, yr), n = e.parse(t1[2], 2, Ir(e.expectedType || wr));
                return r && n ? new Xi(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e < 0) throw new jr(`Array index out of bounds: ${e} < 0.`);
                if (e > r.length - 1) throw new jr(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e === Math.floor(e)) return r[e];
                const n = Math.floor(e), i = Math.ceil(e), s = r[n], o = r[i];
                if ("number" != typeof s || "number" != typeof o) throw new jr(`Cannot interpolate between non-number values at index ${e}.`);
                const a = e - n;
                return s * (1 - a) + o * a;
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at-interpolated",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Zi {
            constructor(t1, e){
                this.type = xr, this.needle = t1, this.haystack = e;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, wr), n = e.parse(t1[2], 2, wr);
                return r && n ? Pr(r.type, [
                    xr,
                    gr,
                    yr,
                    mr,
                    wr
                ]) ? new Zi(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (null == r) return !1;
                if (!Er(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new jr(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(Or(e))} instead.`);
                if (!Er(r, [
                    "string",
                    "array"
                ])) throw new jr(`Expected second argument to be of type array or string, but found ${Sr(Or(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class Wi {
            constructor(t1, e, r){
                this.type = yr, this.needle = t1, this.haystack = e, this.fromIndex = r;
            }
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, wr), n = e.parse(t1[2], 2, wr);
                if (!r || !n) return null;
                if (!Pr(r.type, [
                    xr,
                    gr,
                    yr,
                    mr,
                    wr
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, yr);
                    return i ? new Wi(r, n, i) : null;
                }
                return new Wi(r, n);
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!Er(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new jr(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(Or(e))} instead.`);
                if (!Er(r, [
                    "string",
                    "array"
                ])) throw new jr(`Expected second argument to be of type array or string, but found ${Sr(Or(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e, n);
                }
                return r.indexOf(e);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const t1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        t1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class Yi {
            constructor(t1, e, r, n, i, s){
                this.inputType = t1, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(t1, e) {
                if (t1.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, s = [];
                for(let o = 2; o < t1.length - 1; o += 2){
                    let a = t1[o];
                    const l = t1[o + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const u = e.concat(o);
                    if (0 === a.length) return u.error("Expected at least one branch label.");
                    for (const t1 of a){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, Or(t1))) return null;
                        } else r = Or(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = s.length;
                    }
                    const c = e.parse(l, o, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const o = e.parse(t1[1], 1, wr);
                if (!o) return null;
                const a = e.parse(t1[t1.length - 1], t1.length - 1, n);
                return a ? "value" !== o.type.kind && e.concat(1).checkSubtype(r, o.type) ? null : new Yi(r, n, o, i, s, a) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                return (Tr(Or(e), this.inputType) && this.outputs[this.cases[e]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "match",
                    this.input.serialize()
                ], e = Object.keys(this.cases).sort(), r = [], n = {};
                for (const t1 of e){
                    const e = n[this.cases[t1]];
                    void 0 === e ? (n[this.cases[t1]] = r.length, r.push([
                        this.cases[t1],
                        [
                            t1
                        ]
                    ])) : r[e][1].push(t1);
                }
                const i = (t1)=>"number" === this.inputType.kind ? Number(t1) : t1;
                for (const [e, n] of r)t1.push(1 === n.length ? i(n[0]) : n.map(i)), t1.push(this.outputs[e].serialize());
                return t1.push(this.otherwise.serialize()), t1;
            }
        }
        class Ki {
            constructor(t1, e, r){
                this.type = t1, this.branches = e, this.otherwise = r;
            }
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const s = e.parse(t1[i], i, xr);
                    if (!s) return null;
                    const o = e.parse(t1[i + 1], i + 1, r);
                    if (!o) return null;
                    n.push([
                        s,
                        o
                    ]), r = r || o.type;
                }
                const i = e.parse(t1[t1.length - 1], t1.length - 1, r);
                return i ? new Ki(r, n, i) : null;
            }
            evaluate(t1) {
                for (const [e, r] of this.branches)if (e.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e, r] of this.branches)t1(e), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "case"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        class Ji {
            constructor(t1, e, r, n){
                this.type = t1, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, wr), n = e.parse(t1[2], 2, yr);
                if (!r || !n) return null;
                if (!Pr(r.type, [
                    Ir(wr),
                    gr,
                    wr
                ])) return e.error(`Expected first argument to be of type array or string, but found ${Sr(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, yr);
                    return i ? new Ji(r.type, r, n, i) : null;
                }
                return new Ji(r.type, r, n);
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!Er(e, [
                    "string",
                    "array"
                ])) throw new jr(`Expected first argument to be of type array or string, but found ${Sr(Or(e))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e.slice(r, n);
                }
                return e.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const t1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        t1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        function Qi(t1, e) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function ts(t1, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function es(t1, e, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                constructor(t1, e, r){
                    this.type = xr, this.lhs = t1, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e.type.kind;
                }
                static parse(t1, e) {
                    if (3 !== t1.length && 4 !== t1.length) return e.error("Expected two or three arguments.");
                    const r = t1[0];
                    let s = e.parse(t1[1], 1, wr);
                    if (!s) return null;
                    if (!Qi(r, s.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${Sr(s.type)}'.`);
                    let o = e.parse(t1[2], 2, wr);
                    if (!o) return null;
                    if (!Qi(r, o.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${Sr(o.type)}'.`);
                    if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return e.error(`Cannot compare types '${Sr(s.type)}' and '${Sr(o.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== o.type.kind ? s = new Gr(o.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new Gr(s.type, [
                        o
                    ])));
                    let a = null;
                    if (4 === t1.length) {
                        if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (a = e.parse(t1[3], 3, _r), !a) return null;
                    }
                    return new i(s, o, a);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = Or(s), r = Or(o);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new jr(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = Or(s), r = Or(o);
                        if ("string" !== t1.kind || "string" !== r.kind) return e(i, s, o);
                    }
                    return this.collator ? r(i, s, o, this.collator.evaluate(i)) : e(i, s, o);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const e = [
                        t1
                    ];
                    return this.eachChild((t1)=>{
                        e.push(t1.serialize());
                    }), e;
                }
            };
        }
        const rs = es("==", function(t1, e, r) {
            return e === r;
        }, ts), ns = es("!=", function(t1, e, r) {
            return e !== r;
        }, function(t1, e, r, n) {
            return !ts(0, e, r, n);
        }), is = es("<", function(t1, e, r) {
            return e < r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) < 0;
        }), ss = es(">", function(t1, e, r) {
            return e > r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) > 0;
        }), os = es("<=", function(t1, e, r) {
            return e <= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) <= 0;
        }), as = es(">=", function(t1, e, r) {
            return e >= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class ls {
            constructor(t1, e, r, n, i, s){
                this.type = gr, this.number = t1, this.locale = e, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error("Expected two arguments.");
                const r = e.parse(t1[1], 1, yr);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parseObjectValue(n.locale, 2, "locale", gr), !i)) return null;
                let s = null;
                if (n.currency && (s = e.parseObjectValue(n.currency, 2, "currency", gr), !s)) return null;
                let o = null;
                if (n.unit && (o = e.parseObjectValue(n.unit, 2, "unit", gr), !o)) return null;
                let a = null;
                if (n["min-fraction-digits"] && (a = e.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", yr), !a)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = e.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", yr), !l) ? null : new ls(r, i, s, o, a, l);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    unit: this.unit ? this.unit.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.unit && t1(this.unit), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.unit && (t1.unit = this.unit.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    t1
                ];
            }
        }
        class us {
            constructor(t1){
                this.type = yr, this.input = t1;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${Sr(r.type)} instead.`) : new us(r) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                if ("string" == typeof e) return e.length;
                if (Array.isArray(e)) return e.length;
                throw new jr(`Expected value to be of type string or array, but found ${Sr(Or(e))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "length"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        function cs(t1) {
            return function() {
                t1 = 1831565813 + (t1 |= 0) | 0;
                let e = Math.imul(t1 ^ t1 >>> 15, 1 | t1);
                return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
            };
        }
        const hs = {
            "==": rs,
            "!=": ns,
            ">": ss,
            "<": is,
            ">=": as,
            "<=": os,
            array: Gr,
            at: Hi,
            "at-interpolated": Xi,
            boolean: Gr,
            case: Ki,
            coalesce: Gi,
            collator: tn,
            format: qr,
            image: Hr,
            in: Zi,
            "index-of": Wi,
            interpolate: ji,
            "interpolate-hcl": ji,
            "interpolate-lab": ji,
            length: us,
            let: qi,
            literal: Nr,
            match: Yi,
            number: Gr,
            "number-format": ls,
            object: Gr,
            slice: Ji,
            step: Ai,
            string: Gr,
            "to-boolean": Wr,
            "to-color": Wr,
            "to-number": Wr,
            "to-string": Wr,
            var: vi,
            within: Mn,
            distance: ci,
            config: xi
        };
        function ps(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, o = Lr(e, r, n, s);
            if (o) throw new jr(o);
            return new sr(e / 255, r / 255, n / 255, s);
        }
        function fs(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, o = function(t1, e, r, n) {
                return "number" == typeof t1 && t1 >= 0 && t1 <= 360 ? "number" == typeof e && e >= 0 && e <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    t1,
                    e,
                    r,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(e, r, n, s);
            if (o) throw new jr(o);
            const a = `hsla(${e}, ${r}%, ${n}%, ${s})`, l = sr.parse(a);
            if (!l) throw new jr(`Failed to parse HSLA color: ${a}`);
            return l;
        }
        function ds(t1, e) {
            return t1 in e;
        }
        function ms(t1, e) {
            const r = e[t1];
            return void 0 === r ? null : r;
        }
        function ys(t1) {
            return {
                type: t1
            };
        }
        function gs(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function xs(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function vs(t1, e) {
            return !!t1 && !!t1.parameters && t1.parameters.indexOf(e) > -1;
        }
        function bs(t1) {
            return "data-driven" === t1["property-type"];
        }
        function ws(t1) {
            return vs(t1.expression, "measure-light");
        }
        function _s(t1) {
            return vs(t1.expression, "zoom");
        }
        function As(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Ms(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Is(t1) {
            return t1;
        }
        function Ss(t1, e) {
            const r = "color" === e.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), s = t1.type || (As(e) ? "exponential" : "interval");
            if (r && ((t1 = pr({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                    t1[0],
                    sr.parse(t1[1])
                ])), t1.default = sr.parse(t1.default ? t1.default : e.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !Ni[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let o, a, l;
            if ("exponential" === s) o = Es;
            else if ("interval" === s) o = Ps;
            else if ("categorical" === s) {
                o = ks, a = Object.create(null);
                for (const e of t1.stops)a[e[0]] = e[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                o = Ts;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t1.stops.length; e++){
                    const i = t1.stops[e], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    Ss(r[t1], e)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: ji.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Es({
                            stops: i,
                            base: t1.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: ji.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>o(t1, e, r, a, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? zs(t1.default, e.default) : o(t1, e, i, a, l);
                }
            };
        }
        function zs(t1, e, r) {
            return void 0 !== t1 ? t1 : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function ks(t1, e, r, n, i) {
            return zs(typeof r === i ? n[r] : void 0, t1.default, e.default);
        }
        function Ps(t1, e, r) {
            if ("number" !== Xr(r)) return zs(t1.default, e.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = _i(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Es(t1, e, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== Xr(r)) return zs(t1.default, e.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const s = _i(t1.stops.map((t1)=>t1[0]), r), o = function(t1, e, r, n) {
                const i = n - r, s = t1 - r;
                return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t1.stops[s][0], t1.stops[s + 1][0]), a = t1.stops[s][1], l = t1.stops[s + 1][1];
            let u = hr[e.type] || Is;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e = Ni[t1.colorSpace];
                u = (t1, r)=>e.reverse(e.interpolate(e.forward(t1), e.forward(r), o));
            }
            return "function" == typeof a.evaluate ? {
                evaluate (...t1) {
                    const e = a.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e && void 0 !== r) return u(e, r, o);
                }
            } : u(a, l, o);
        }
        function Ts(t1, e, r) {
            return "color" === e.type ? r = sr.parse(r) : "formatted" === e.type ? r = Cr.fromString(r.toString()) : "resolvedImage" === e.type ? r = Dr.build(r.toString()) : Xr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0), zs(r, t1.default, e.default);
        }
        Jr.register(hs, {
            error: [
                {
                    kind: "error"
                },
                [
                    gr
                ],
                (t1, [e])=>{
                    throw new jr(e.evaluate(t1));
                }
            ],
            typeof: [
                gr,
                [
                    wr
                ],
                (t1, [e])=>Sr(Or(e.evaluate(t1)))
            ],
            "to-rgba": [
                Ir(yr, 4),
                [
                    vr
                ],
                (t1, [e])=>e.evaluate(t1).toNonPremultipliedRenderColor(null).toArray()
            ],
            "to-hsla": [
                Ir(yr, 4),
                [
                    vr
                ],
                (t1, [e])=>e.evaluate(t1).toNonPremultipliedRenderColor(null).toHslaArray()
            ],
            rgb: [
                vr,
                [
                    yr,
                    yr,
                    yr
                ],
                ps
            ],
            rgba: [
                vr,
                [
                    yr,
                    yr,
                    yr,
                    yr
                ],
                ps
            ],
            hsl: [
                vr,
                [
                    yr,
                    yr,
                    yr
                ],
                fs
            ],
            hsla: [
                vr,
                [
                    yr,
                    yr,
                    yr,
                    yr
                ],
                fs
            ],
            has: {
                type: xr,
                overloads: [
                    [
                        [
                            gr
                        ],
                        (t1, [e])=>ds(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            gr,
                            br
                        ],
                        (t1, [e, r])=>ds(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: wr,
                overloads: [
                    [
                        [
                            gr
                        ],
                        (t1, [e])=>ms(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            gr,
                            br
                        ],
                        (t1, [e, r])=>ms(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                wr,
                [
                    gr
                ],
                (t1, [e])=>ms(e.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                br,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                gr,
                [],
                (t1)=>t1.geometryType()
            ],
            worldview: [
                gr,
                [],
                (t1)=>t1.globals.worldview || ""
            ],
            id: [
                wr,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                yr,
                [],
                (t1)=>t1.globals.zoom
            ],
            pitch: [
                yr,
                [],
                (t1)=>t1.globals.pitch || 0
            ],
            "distance-from-center": [
                yr,
                [],
                (t1)=>t1.distanceFromCenter()
            ],
            "measure-light": [
                yr,
                [
                    gr
                ],
                (t1, [e])=>t1.measureLight(e.evaluate(t1))
            ],
            "heatmap-density": [
                yr,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                yr,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            "raster-value": [
                yr,
                [],
                (t1)=>t1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                yr,
                [],
                (t1)=>t1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                yr,
                [],
                (t1)=>t1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                wr,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                yr,
                ys(yr),
                (t1, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                yr,
                ys(yr),
                (t1, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: yr,
                overloads: [
                    [
                        [
                            yr,
                            yr
                        ],
                        (t1, [e, r])=>e.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            yr
                        ],
                        (t1, [e])=>-e.evaluate(t1)
                    ]
                ]
            },
            "/": [
                yr,
                [
                    yr,
                    yr
                ],
                (t1, [e, r])=>e.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                yr,
                [
                    yr,
                    yr
                ],
                (t1, [e, r])=>e.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                yr,
                [],
                ()=>Math.LN2
            ],
            pi: [
                yr,
                [],
                ()=>Math.PI
            ],
            e: [
                yr,
                [],
                ()=>Math.E
            ],
            "^": [
                yr,
                [
                    yr,
                    yr
                ],
                (t1, [e, r])=>Math.pow(e.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.sqrt(e.evaluate(t1))
            ],
            log10: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN10
            ],
            ln: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.log(e.evaluate(t1))
            ],
            log2: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN2
            ],
            sin: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.sin(e.evaluate(t1))
            ],
            cos: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.cos(e.evaluate(t1))
            ],
            tan: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.tan(e.evaluate(t1))
            ],
            asin: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.asin(e.evaluate(t1))
            ],
            acos: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.acos(e.evaluate(t1))
            ],
            atan: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.atan(e.evaluate(t1))
            ],
            min: [
                yr,
                ys(yr),
                (t1, e)=>Math.min(...e.map((e)=>e.evaluate(t1)))
            ],
            max: [
                yr,
                ys(yr),
                (t1, e)=>Math.max(...e.map((e)=>e.evaluate(t1)))
            ],
            abs: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.abs(e.evaluate(t1))
            ],
            round: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>{
                    const r = e.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.floor(e.evaluate(t1))
            ],
            ceil: [
                yr,
                [
                    yr
                ],
                (t1, [e])=>Math.ceil(e.evaluate(t1))
            ],
            "filter-==": [
                xr,
                [
                    gr,
                    wr
                ],
                (t1, [e, r])=>t1.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>t1.id() === e.value
            ],
            "filter-type-==": [
                xr,
                [
                    gr
                ],
                (t1, [e])=>t1.geometryType() === e.value
            ],
            "filter-<": [
                xr,
                [
                    gr,
                    wr
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                xr,
                [
                    gr,
                    wr
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                xr,
                [
                    gr,
                    wr
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                xr,
                [
                    gr,
                    wr
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                xr,
                [
                    wr
                ],
                (t1, [e])=>e.value in t1.properties()
            ],
            "filter-has-id": [
                xr,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                xr,
                [
                    Ir(gr)
                ],
                (t1, [e])=>e.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                xr,
                [
                    Ir(wr)
                ],
                (t1, [e])=>e.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                xr,
                [
                    gr,
                    Ir(wr)
                ],
                (t1, [e, r])=>r.value.indexOf(t1.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                xr,
                [
                    gr,
                    Ir(wr)
                ],
                (t1, [e, r])=>(function(t1, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t1) return !0;
                            e[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: xr,
                overloads: [
                    [
                        [
                            xr,
                            xr
                        ],
                        (t1, [e, r])=>e.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        ys(xr),
                        (t1, e)=>{
                            for (const r of e)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: xr,
                overloads: [
                    [
                        [
                            xr,
                            xr
                        ],
                        (t1, [e, r])=>e.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        ys(xr),
                        (t1, e)=>{
                            for (const r of e)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                xr,
                [
                    xr
                ],
                (t1, [e])=>!e.evaluate(t1)
            ],
            "is-supported-script": [
                xr,
                [
                    gr
                ],
                (t1, [e])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e.evaluate(t1));
                }
            ],
            upcase: [
                gr,
                [
                    gr
                ],
                (t1, [e])=>e.evaluate(t1).toUpperCase()
            ],
            downcase: [
                gr,
                [
                    gr
                ],
                (t1, [e])=>e.evaluate(t1).toLowerCase()
            ],
            concat: [
                gr,
                ys(wr),
                (t1, e)=>e.map((e)=>Ur(e.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                gr,
                [
                    _r
                ],
                (t1, [e])=>e.evaluate(t1).resolvedLocale()
            ],
            random: [
                yr,
                [
                    yr,
                    yr,
                    wr
                ],
                (t1, e)=>{
                    const [r, n, i] = e.map((e)=>e.evaluate(t1));
                    if (r > n) return r;
                    if (r === n) return r;
                    let s;
                    if ("string" == typeof i) s = function(t1) {
                        let e = 0;
                        if (0 === t1.length) return e;
                        for(let r = 0; r < t1.length; r++)e = (e << 5) - e + t1.charCodeAt(r), e |= 0;
                        return e;
                    }(i);
                    else {
                        if ("number" != typeof i) throw new jr(`Invalid seed input: ${i}`);
                        s = i;
                    }
                    return r + cs(s)() * (n - r);
                }
            ]
        });
        class Bs {
            constructor(t1, e, r, n){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new Kr(r, n), this._defaultValue = e ? function(t1) {
                    return "color" === t1.type && (Ms(t1.default) || Array.isArray(t1.default)) ? new sr(0, 0, 0, 0) : "color" === t1.type ? sr.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e) : null, this._enumValues = e && "enum" === e.type ? e.values : null, this.configDependencies = fi(t1);
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s, o, a) {
                return this._evaluator.globals = t1, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e, r, n, i, s, o, a) {
                this._evaluator.globals = t1, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new jr(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function Vs(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in hs;
        }
        function Cs(t1, e, r, n) {
            const i = new bi(hs, [], e ? function(t1) {
                const e = {
                    color: vr,
                    string: gr,
                    number: yr,
                    enum: gr,
                    boolean: xr,
                    formatted: Ar,
                    resolvedImage: Mr
                };
                return "array" === t1.type ? Ir(e[t1.value] || wr, t1.length) : e[t1.type];
            }(e) : void 0, void 0, void 0, r, n), s = i.parse(t1, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return s ? gs(new Bs(s, e, r, n)) : xs(i.errors);
        }
        class Fs {
            constructor(t1, e, r, n){
                this.kind = t1, this._styleExpression = e, this.isLightConstant = r, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== t1 && !pi(e.expression), this.configDependencies = fi(e.expression);
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, s);
            }
            evaluate(t1, e, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e, r, n, i, s);
            }
        }
        class Ds {
            constructor(t1, e, r, n, i, s){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t1 && !pi(e.expression), this.isLightConstant = i, this.isLineProgressConstant = s, this.configDependencies = fi(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, s);
            }
            evaluate(t1, e, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e, r, n, i, s);
            }
            interpolationFactor(t1, e, r) {
                return this.interpolationType ? ji.interpolationFactor(this.interpolationType, t1, e, r) : 0;
            }
        }
        function Ls(t1, e, r, n) {
            if ("error" === (t1 = Cs(t1, e, r, n)).result) return t1;
            const i = t1.value.expression, s = hi(i);
            if (!s && !bs(e)) return xs([
                new fr("", "data expressions not supported")
            ]);
            const o = di(i, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!o && !_s(e)) return xs([
                new fr("", "zoom expressions not supported")
            ]);
            const a = di(i, [
                "measure-light"
            ]);
            if (!a && !ws(e)) return xs([
                new fr("", "measure-light expression not supported")
            ]);
            const l = di(i, [
                "line-progress"
            ]);
            if (!l && !function(t1) {
                return vs(t1.expression, "line-progress");
            }(e)) return xs([
                new fr("", "line-progress expression not supported")
            ]);
            const u = e.expression && e.expression.relaxZoomRestriction, c = Os(i);
            return c || o || u ? c instanceof fr ? xs([
                c
            ]) : c instanceof ji && !As(e) ? xs([
                new fr("", '"interpolate" expressions cannot be used with this property')
            ]) : gs(c ? new Ds(s && l ? "camera" : "composite", t1.value, c.labels, c instanceof ji ? c.interpolation : void 0, a, l) : new Fs(s && l ? "constant" : "source", t1.value, a, l)) : xs([
                new fr("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class Rs {
            constructor(t1, e){
                this._parameters = t1, this._specification = e, pr(this, Ss(this._parameters, this._specification));
            }
            static deserialize(t1) {
                return new Rs(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
        }
        function Os(t1) {
            let e = null;
            if (t1 instanceof qi) e = Os(t1.result);
            else if (t1 instanceof Gi) {
                for (const r of t1.args)if (e = Os(r), e) break;
            } else (t1 instanceof Ai || t1 instanceof ji) && t1.input instanceof Jr && "zoom" === t1.input.name && (e = t1);
            return e instanceof fr || t1.eachChild((t1)=>{
                const r = Os(t1);
                r instanceof fr ? e = r : e && r && e !== r && (e = new fr("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        var Us, Ns, js = function() {
            if (Ns) return Us;
            Ns = 1, Us = e;
            var t1 = 3;
            function e(e, r, n) {
                var i = this.cells = [];
                if (e instanceof ArrayBuffer) {
                    this.arrayBuffer = e;
                    var s = new Int32Array(this.arrayBuffer);
                    e = s[0], this.d = (r = s[1]) + 2 * (n = s[2]);
                    for(var o = 0; o < this.d * this.d; o++){
                        var a = s[t1 + o], l = s[t1 + o + 1];
                        i.push(a === l ? null : s.subarray(a, l));
                    }
                    var u = s[t1 + i.length + 1];
                    this.keys = s.subarray(s[t1 + i.length], u), this.bboxes = s.subarray(u), this.insert = this._insertReadonly;
                } else {
                    this.d = r + 2 * n;
                    for(var c = 0; c < this.d * this.d; c++)i.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = r, this.extent = e, this.padding = n, this.scale = r / e, this.uid = 0;
                var h = n / r * e;
                this.min = -h, this.max = e + h;
            }
            return e.prototype.insert = function(t1, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }, e.prototype._insertReadonly = function() {
                throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, e.prototype._insertCell = function(t1, e, r, n, i, s) {
                this.cells[i].push(s);
            }, e.prototype.query = function(t1, e, r, n, i) {
                var s = this.min, o = this.max;
                if (t1 <= s && e <= s && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                var a = [];
                return this._forEachCell(t1, e, r, n, this._queryCell, a, {}, i), a;
            }, e.prototype._queryCell = function(t1, e, r, n, i, s, o, a) {
                var l = this.cells[i];
                if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                    var p = l[h];
                    if (void 0 === o[p]) {
                        var f = 4 * p;
                        (a ? a(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t1 <= c[f + 2] && e <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (o[p] = !0, s.push(u[p])) : o[p] = !1;
                    }
                }
            }, e.prototype._forEachCell = function(t1, e, r, n, i, s, o, a) {
                for(var l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var f = u; f <= h; f++){
                    var d = this.d * f + p;
                    if ((!a || a(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e, r, n, d, s, o, a)) return;
                }
            }, e.prototype._convertFromCellCoord = function(t1) {
                return (t1 - this.padding) / this.scale;
            }, e.prototype._convertToCellCoord = function(t1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
            }, e.prototype.toArrayBuffer = function() {
                if (this.arrayBuffer) return this.arrayBuffer;
                for(var e = this.cells, r = t1 + this.cells.length + 1 + 1, n = 0, i = 0; i < this.cells.length; i++)n += this.cells[i].length;
                var s = new Int32Array(r + n + this.keys.length + this.bboxes.length);
                s[0] = this.extent, s[1] = this.n, s[2] = this.padding;
                for(var o = r, a = 0; a < e.length; a++){
                    var l = e[a];
                    s[t1 + a] = o, s.set(l, o), o += l.length;
                }
                return s[t1 + e.length] = o, s.set(this.keys, o), s[t1 + e.length + 1] = o += this.keys.length, s.set(this.bboxes, o), o += this.bboxes.length, s.buffer;
            }, Us;
        }(), $s = dt(js);
        const Gs = {};
        function qs(t1, e, r = {}) {
            Object.defineProperty(t1, "_classRegistryKey", {
                value: e,
                writable: !1
            }), Gs[e] = {
                klass: t1,
                omit: r.omit || []
            };
        }
        qs(Object, "Object"), $s.serialize = function(t1, e) {
            const r = t1.toArrayBuffer();
            return e && e.add(r), {
                buffer: r
            };
        }, $s.deserialize = function(t1) {
            return new $s(t1.buffer);
        }, Object.defineProperty($s, "name", {
            value: "Grid"
        }), qs($s, "Grid"), "undefined" != typeof DOMMatrix && qs(DOMMatrix, "DOMMatrix"), qs(sr, "Color"), qs(Error, "Error"), qs(Cr, "Formatted"), qs(Vr, "FormattedSection"), qs(Ve, "AJAXError"), qs(Dr, "ResolvedImage"), qs(Rs, "StylePropertyFunction"), qs(Bs, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), qs(er, "ImageId"), qs(Fr, "ImageVariant"), qs(Ds, "ZoomDependentExpression"), qs(Fs, "ZoomConstantExpression"), qs(Jr, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in hs)Gs[hs[t1]._classRegistryKey] || qs(hs[t1], `Expression${t1}`);
        function Hs(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function Xs(t1) {
            return self.ImageBitmap && t1 instanceof ImageBitmap;
        }
        function Zs(t1, e) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (Hs(t1) || Xs(t1)) return e && e.add(t1), t1;
            if (ArrayBuffer.isView(t1)) return e && e.add(t1.buffer), t1;
            if (t1 instanceof ImageData) return e && e.add(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const r = [];
                for (const n of t1)r.push(Zs(n, e));
                return r;
            }
            if (t1 instanceof Map) {
                const r = {
                    $name: "Map",
                    entries: []
                };
                for (const [n, i] of t1.entries())r.entries.push(Zs(n), Zs(i, e));
                return r;
            }
            if (t1 instanceof Set) {
                const e = {
                    $name: "Set"
                };
                let r = 0;
                for (const n of t1.values())e[++r] = Zs(n);
                return e;
            }
            if (t1 instanceof DOMMatrix) {
                const e = {
                    $name: "DOMMatrix"
                }, r = [
                    "is2D",
                    "m11",
                    "m12",
                    "m13",
                    "m14",
                    "m21",
                    "m22",
                    "m23",
                    "m24",
                    "m31",
                    "m32",
                    "m33",
                    "m34",
                    "m41",
                    "m42",
                    "m43",
                    "m44",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f"
                ];
                for (const n of r)e[n] = t1[n];
                return e;
            }
            if ("bigint" == typeof t1) return {
                $name: "BigInt",
                value: t1.toString()
            };
            if ("object" == typeof t1) {
                const r = t1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error(`Can't serialize object of unregistered class "${r.name}".`);
                const i = r.serialize ? r.serialize(t1, e) : {};
                if (!r.serialize) {
                    for(const r in t1)t1.hasOwnProperty(r) && (Gs[n].omit.indexOf(r) >= 0 || (i[r] = Zs(t1[r], e)));
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Ws(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || Hs(t1) || Xs(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(Ws);
            if ("object" == typeof t1) {
                const e = t1.$name || "Object";
                if ("Map" === e) {
                    const e = t1.entries || [], r = new Map;
                    for(let t1 = 0; t1 < e.length; t1 += 2)r.set(Ws(e[t1]), Ws(e[t1 + 1]));
                    return r;
                }
                if ("Set" === e) {
                    const e = new Set;
                    for (const r of Object.keys(t1))"$name" !== r && e.add(Ws(t1[r]));
                    return e;
                }
                if ("DOMMatrix" === e) {
                    let e;
                    return e = t1.is2D ? [
                        t1.a,
                        t1.b,
                        t1.c,
                        t1.d,
                        t1.e,
                        t1.f
                    ] : [
                        t1.m11,
                        t1.m12,
                        t1.m13,
                        t1.m14,
                        t1.m21,
                        t1.m22,
                        t1.m23,
                        t1.m24,
                        t1.m31,
                        t1.m32,
                        t1.m33,
                        t1.m34,
                        t1.m41,
                        t1.m42,
                        t1.m43,
                        t1.m44
                    ], new DOMMatrix(e);
                }
                if ("BigInt" === e) return BigInt(t1.value);
                const { klass: r } = Gs[e];
                if (!r) throw new Error(`Can't deserialize unregistered class "${e}".`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const e of Object.keys(t1))"$name" !== e && (n[e] = Ws(t1[e]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        const Ys = {
            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519,
            Osage: (t1)=>t1 >= 66736 && t1 <= 66815,
            "CJK Unified Ideographs Extension B": (t1)=>t1 >= 131072 && t1 <= 173791
        };
        function Ks(t1) {
            for (const e of t1)if (to(e.charCodeAt(0))) return !0;
            return !1;
        }
        function Js(t1) {
            for (const e of t1)if (!Qs(e.charCodeAt(0))) return !1;
            return !0;
        }
        function Qs(t1) {
            return !(Ys.Arabic(t1) || Ys["Arabic Supplement"](t1) || Ys["Arabic Extended-A"](t1) || Ys["Arabic Presentation Forms-A"](t1) || Ys["Arabic Presentation Forms-B"](t1));
        }
        function to(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Ys["Bopomofo Extended"](t1) || Ys.Bopomofo(t1) || Ys["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || Ys["CJK Compatibility Ideographs"](t1) || Ys["CJK Compatibility"](t1) || Ys["CJK Radicals Supplement"](t1) || Ys["CJK Strokes"](t1) || !(!Ys["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || Ys["CJK Unified Ideographs Extension A"](t1) || Ys["CJK Unified Ideographs"](t1) || Ys["Enclosed CJK Letters and Months"](t1) || Ys["Hangul Compatibility Jamo"](t1) || Ys["Hangul Jamo Extended-A"](t1) || Ys["Hangul Jamo Extended-B"](t1) || Ys["Hangul Jamo"](t1) || Ys["Hangul Syllables"](t1) || Ys.Hiragana(t1) || Ys["Ideographic Description Characters"](t1) || Ys.Kanbun(t1) || Ys["Kangxi Radicals"](t1) || Ys["Katakana Phonetic Extensions"](t1) || Ys.Katakana(t1) && 12540 !== t1 || !(!Ys["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Ys["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || Ys["Unified Canadian Aboriginal Syllabics"](t1) || Ys["Unified Canadian Aboriginal Syllabics Extended"](t1) || Ys["Vertical Forms"](t1) || Ys["Yijing Hexagram Symbols"](t1) || Ys["Yi Syllables"](t1) || Ys["Yi Radicals"](t1))));
        }
        function eo(t1) {
            return !(to(t1) || function(t1) {
                return !!(Ys["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || Ys["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || Ys["Letterlike Symbols"](t1) || Ys["Number Forms"](t1) || Ys["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || Ys["Control Pictures"](t1) && 9251 !== t1 || Ys["Optical Character Recognition"](t1) || Ys["Enclosed Alphanumerics"](t1) || Ys["Geometric Shapes"](t1) || Ys["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || Ys["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Ys["CJK Symbols and Punctuation"](t1) || Ys.Katakana(t1) || Ys["Private Use Area"](t1) || Ys["CJK Compatibility Forms"](t1) || Ys["Small Form Variants"](t1) || Ys["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function ro(t1) {
            return Ys.Arabic(t1) || Ys["Arabic Supplement"](t1) || Ys["Arabic Extended-A"](t1) || Ys["Arabic Presentation Forms-A"](t1) || Ys["Arabic Presentation Forms-B"](t1);
        }
        function no(t1) {
            return t1 >= 1424 && t1 <= 2303 || Ys["Arabic Presentation Forms-A"](t1) || Ys["Arabic Presentation Forms-B"](t1);
        }
        function io(t1, e) {
            return !(!e && no(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Ys.Khmer(t1));
        }
        function so(t1) {
            for (const e of t1)if (no(e.charCodeAt(0))) return !0;
            return !1;
        }
        const oo = {
            unavailable: "unavailable",
            deferred: "deferred",
            loading: "loading",
            parsing: "parsing",
            parsed: "parsed",
            loaded: "loaded",
            error: "error"
        };
        let ao = null, lo = oo.unavailable, uo = null;
        const co = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (lo = oo.error), ao && ao(t1);
        };
        function ho() {
            po.fire(new Ye("pluginStateChange", {
                pluginStatus: lo,
                pluginURL: uo
            }));
        }
        const po = new tr, fo = function() {
            return lo;
        }, mo = function() {
            if (lo !== oo.deferred || !uo) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            lo = oo.loading, ho(), uo && De({
                url: uo
            }, (t1)=>{
                t1 ? co(t1) : (lo = oo.loaded, ho());
            });
        }, yo = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>lo === oo.loaded || null != yo.applyArabicShaping,
            isLoading: ()=>lo === oo.loading,
            setState (t1) {
                lo = t1.pluginStatus, uo = t1.pluginURL;
            },
            isParsing: ()=>lo === oo.parsing,
            isParsed: ()=>lo === oo.parsed,
            getPluginURL: ()=>uo
        };
        class go {
            constructor(t1, e){
                this.zoom = t1, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.transition = e.transition, this.pitch = e.pitch, this.brightness = e.brightness, this.worldview = e.worldview) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(t1) {
                return function(t1, e) {
                    for (const r of t1)if (!io(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t1, yo.isLoaded());
            }
        }
        class xo {
            constructor(t1, e, r, n){
                this.property = t1, this.value = e, this.expression = function(t1, e, r, n) {
                    if (Ms(t1)) return new Rs(t1, e);
                    if (Vs(t1) || Array.isArray(t1) && t1.length > 0) {
                        const i = Ls(t1, e, r, n);
                        if ("error" === i.result) throw new Error(i.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return i.value;
                    }
                    {
                        let r = t1;
                        return "string" == typeof t1 && "color" === e.type && (r = sr.parse(t1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t1.specification.default : e, t1.specification, r, n);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e, r) {
                return this.property.possiblyEvaluate(this, t1, e, r);
            }
        }
        class vo {
            constructor(t1, e, r){
                this.property = t1, this.value = new xo(t1, void 0, e, r);
            }
            transitioned(t1, e) {
                return new wo(this.property, this.value, e, Ct({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new wo(this.property, this.value, null, {}, 0);
            }
        }
        class bo {
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
            getValue(t1) {
                return Nt(this._values[t1].value.value);
            }
            setValue(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new vo(this._values[t1].property, this._scope, this._options)), this._values[t1].value = new xo(this._values[t1].property, null === e ? void 0 : Nt(e), this._scope, this._options), this._values[t1].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].value.expression.configDependencies
                ]));
            }
            setTransitionOrValue(t1, e) {
                e && (this._options = e);
                const r = this._properties.properties;
                if (t1) for(const e in t1){
                    const n = t1[e];
                    if (e.endsWith("-transition")) {
                        const t1 = e.slice(0, -11);
                        r[t1] && this.setTransition(t1, n);
                    } else r.hasOwnProperty(e) && this.setValue(e, n);
                }
            }
            getTransition(t1) {
                return Nt(this._values[t1].transition);
            }
            setTransition(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new vo(this._values[t1].property)), this._values[t1].transition = Nt(e) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t1[`${e}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e) {
                const r = new _o(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new _o(this._properties);
                for (const e of Object.keys(this._values))t1._values[e] = this._values[e].untransitioned();
                return t1;
            }
        }
        class wo {
            constructor(t1, e, r, n, i){
                const s = n.delay || 0, o = n.duration || 0;
                i = i || 0, this.property = t1, this.value = e, this.begin = i + s, this.end = this.begin + o, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t1, e, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t1, e, r);
                    {
                        const o = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t1, e, r), i, zt(o));
                    }
                }
                return i;
            }
        }
        class _o {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t1, e, r) {
                const n = new Io(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
        }
        class Ao {
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
            getValue(t1) {
                return Nt(this._values[t1].value);
            }
            setValue(t1, e) {
                this._values[t1] = new xo(this._values[t1].property, null === e ? void 0 : Nt(e), this._scope, this._options), this._values[t1].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].expression.configDependencies
                ]));
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e, r) {
                const n = new Io(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
        }
        class Mo {
            constructor(t1, e, r){
                this.property = t1, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e, r, n);
            }
        }
        class Io {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
            get(t1) {
                return this._values[t1];
            }
        }
        class So {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return t1.expression.evaluate(e);
            }
            interpolate(t1, e, r) {
                const n = hr[this.specification.type];
                return n ? n(t1, e, r) : t1;
            }
        }
        class zo {
            constructor(t1, e){
                this.specification = t1, this.overrides = e;
            }
            possiblyEvaluate(t1, e, r, n) {
                return new Mo(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e, null, {}, r, n)
                } : t1.expression, e);
            }
            interpolate(t1, e, r) {
                if ("constant" !== t1.value.kind || "constant" !== e.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e.value.value) return new Mo(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = hr[this.specification.type];
                return n ? new Mo(this, {
                    kind: "constant",
                    value: n(t1.value.value, e.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e, r, n, i, s) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e, r, n, i, s);
            }
        }
        class ko {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e, r, n) {
                return !!t1.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Po {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const e = new go(0, {});
                for(const r in t1){
                    const n = t1[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new xo(n, void 0), s = this.defaultTransitionablePropertyValues[r] = new vo(n);
                    this.defaultTransitioningPropertyValues[r] = s.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(e);
                }
            }
        }
        qs(zo, "DataDrivenProperty"), qs(So, "DataConstantProperty"), qs(ko, "ColorRampProperty");
        var Eo = JSON.parse('{"$version":8,"$root":{"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","expression":{}},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string"},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string"},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"clip":{}}},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{}},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","expression":{}},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-markup":1},"default":"none","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}}},"layout_building":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"building-roof-shape":{"type":"enum","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"default":"flat","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","expression":{}},"line-cross-slope":{"type":"number","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","expression":{"parameters":["zoom"]}}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"expression":{}},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"expression":{}},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_building":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*"}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective"}},"colorTheme":{"data":{"type":"string","expression":{}}},"indoor":{"floorplanFeaturesetId":{"type":"string","expression":{}},"buildingFeaturesetId":{"type":"string","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator"},"center":{"type":"array","length":2,"value":"number","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"flat"},"fill-extrusion-base-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"terrain"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-ambient-occlusion-wall-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","use-theme":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]},"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-gradient":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["line-progress"]}},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1]},"line-trim-fade-range":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-trim-color":{"type":"color","default":"transparent","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-border-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"use-theme":true,"expression":{"interpolated":true,"parameters":["heatmap-density"]}},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{}},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-value"]}},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-particle-speed"]}},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-shadow-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-accent-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"use-theme":true,"expression":{"interpolated":true,"parameters":["sky-radial-progress"]}},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":true},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":true},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"use-theme":true,"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d"},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"model-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"promoteId":{"*":{"type":"*"}}}');
        function To(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Bo(t1) {
            if (Array.isArray(t1)) return t1.map(Bo);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e = {};
                for(const r in t1)e[r] = Bo(t1[r]);
                return e;
            }
            return To(t1);
        }
        function Vo(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e of t1.slice(1))if (!Vo(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Co(t1, e = "", r = null, n = "fill") {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Vo(t1) || (t1 = No(t1));
            const i = t1;
            let s = !0;
            try {
                s = function(t1) {
                    if (!Lo(t1)) return t1;
                    let e = Bo(t1);
                    return Do(e), e = Fo(e), e;
                }(i);
            } catch (t1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            let o = null, a = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                a = Eo[`filter_${n}`];
                const t1 = Cs(s, a, e, r);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                o = (e, r, n)=>t1.value.evaluate(e, r, {}, n);
            }
            let l = null, u = null;
            if (s !== i) {
                const t1 = Cs(i, a, e, r);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                l = (e, r, n, i, s)=>t1.value.evaluate(e, r, {}, n, void 0, void 0, i, s), u = !hi(t1.value.expression);
            }
            return {
                filter: o,
                dynamicFilter: l || void 0,
                needGeometry: Uo(s),
                needFeature: !!u
            };
        }
        function Fo(t1) {
            if (!Array.isArray(t1)) return t1;
            const e = function(t1) {
                if (Ro.has(t1[0])) {
                    for(let e = 1; e < t1.length; e++)if (Lo(t1[e])) return !0;
                }
                return t1;
            }(t1);
            return !0 === e ? e : e.map((t1)=>Fo(t1));
        }
        function Do(t1) {
            let e = !1;
            const r = [];
            if ("case" === t1[0]) {
                for(let n = 1; n < t1.length - 1; n += 2)e = e || Lo(t1[n]), r.push(t1[n + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("match" === t1[0]) {
                e = e || Lo(t1[1]);
                for(let e = 2; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("step" === t1[0]) {
                e = e || Lo(t1[1]);
                for(let e = 1; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
            }
            e && (t1.length = 0, t1.push("any", ...r));
            for(let e = 1; e < t1.length; e++)Do(t1[e]);
        }
        function Lo(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("pitch" === (e = t1[0]) || "distance-from-center" === e) return !0;
            var e;
            for(let e = 1; e < t1.length; e++)if (Lo(t1[e])) return !0;
            return !1;
        }
        const Ro = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function Oo(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function Uo(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0] || "distance" === t1[0]) return !0;
            for(let e = 1; e < t1.length; e++)if (Uo(t1[e])) return !0;
            return !1;
        }
        function No(t1) {
            if (!t1) return !0;
            const e = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e : "==" === e ? jo(t1[1], t1[2], "==") : "!=" === e ? qo(jo(t1[1], t1[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? jo(t1[1], t1[2], e) : "any" === e ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(No))) : "all" === e ? [
                "all"
            ].concat(t1.slice(1).map(No)) : "none" === e ? [
                "all"
            ].concat(t1.slice(1).map(No).map(qo)) : "in" === e ? $o(t1[1], t1.slice(2)) : "!in" === e ? qo($o(t1[1], t1.slice(2))) : "has" === e ? Go(t1[1]) : "!has" !== e || qo(Go(t1[1]));
        }
        function jo(t1, e, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e
                    ];
            }
        }
        function $o(t1, e) {
            if (0 === e.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t1)=>typeof t1 != typeof e[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e.sort(Oo)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function Go(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function qo(t1) {
            return [
                "!",
                t1
            ];
        }
        const Ho = "";
        function Xo(t1, e) {
            return e ? `${t1}${Ho}${e}` : t1;
        }
        const Zo = "-transition", Wo = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class Yo extends tr {
            constructor(t1, e, r, n, i){
                if (super(), this.id = t1.id, this.fqid = Xo(this.id, r), this.type = t1.type, this.scope = r, this.lut = n, this.options = i, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.configDependencies = new Set, "custom" !== t1.type) {
                    if (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, t1.type && "background" !== t1.type && "sky" !== t1.type && "slot" !== t1.type) {
                        this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter;
                        const e = Cs(this.filter, Eo[`filter_${t1.type}`]);
                        "error" !== e.result && (this.configDependencies = new Set([
                            ...this.configDependencies,
                            ...e.value.configDependencies
                        ]));
                    }
                    if (t1.slot && (this.slot = t1.slot), e.layout && (this._unevaluatedLayout = new Ao(e.layout, this.scope, i), this.configDependencies = new Set([
                        ...this.configDependencies,
                        ...this._unevaluatedLayout.configDependencies
                    ])), e.paint) {
                        this._transitionablePaint = new bo(e.paint, this.scope, i);
                        for(const e in t1.paint)this.setPaintProperty(e, t1.paint[e]);
                        for(const e in t1.layout)this.setLayoutProperty(e, t1.layout[e]);
                        this.configDependencies = new Set([
                            ...this.configDependencies,
                            ...this._transitionablePaint.configDependencies
                        ]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Io(e.paint);
                    }
                }
            }
            onAdd(t1) {}
            onRemove(t1) {}
            isDraped(t1) {
                return !this.is3D(!0) && Wo.has(this.type);
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e) {
                if ("custom" === this.type && "visibility" === t1) return void (this.visibility = e);
                const r = this._unevaluatedLayout;
                r._properties.properties[t1] && (r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), "visibility" === t1 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
                this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getPaintProperty(t1) {
                return t1.endsWith(Zo) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e) {
                const r = this._transitionablePaint, n = r._properties.properties;
                if (t1.endsWith(Zo)) {
                    const i = t1.slice(0, -11);
                    return n[i] && r.setTransition(i, e || void 0), !1;
                }
                if (!n[t1]) return !1;
                const i = r._values[t1], s = i.value.isDataDriven(), o = i.value;
                r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), this._handleSpecialPaintPropertyUpdate(t1);
                const a = r._values[t1].value, l = a.isDataDriven(), u = t1.endsWith("pattern") || "line-dasharray" === t1;
                return l || s || u || this._handleOverridablePaintPropertyUpdate(t1, o, a);
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(t1, e, r) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e);
            }
            serialize() {
                return Ut({
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                }, (t1, e)=>!(void 0 === t1 || "layout" === e && !Object.keys(t1).length || "paint" === e && !Object.keys(t1).length));
            }
            is3D(t1) {
                return !1;
            }
            hasElevation() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e = this.paint.get(t1);
                    if (e instanceof Mo && bs(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter(t1) {
                this._filterCompiled || (this._featureFilter = Co(this.filter, this.scope, t1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(t1) {
                this._stats && ("shadow" === t1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            queryRadius(t1) {}
            queryIntersectsFeature(t1, e, r, n, i, s, o, a, l) {}
        }
        const Ko = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Jo {
            constructor(t1, e){
                this._structArray = t1, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Qo {
            constructor(){
                this.capacity = -1, this.resize(0);
            }
            static serialize(t1, e) {
                return t1._trim(), e && e.add(t1.arrayBuffer), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t1.arrayBuffer, e.length = t1.length, e.capacity = t1.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...t1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...t1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function ta(t1, e = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = Ko[t1.type].BYTES_PER_ELEMENT, s = r = ea(r, Math.max(e, i)), o = t1.components || 1;
                    return n = Math.max(n, i), r += i * o, {
                        name: t1.name,
                        type: t1.type,
                        components: o,
                        offset: s
                    };
                }),
                size: ea(r, Math.max(n, e)),
                alignment: e
            };
        }
        function ea(t1, e) {
            return Math.ceil(t1 / e) * e;
        }
        class ra extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t1;
            }
        }
        ra.prototype.bytesPerElement = 4, qs(ra, "StructArrayLayout2i4");
        class na extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        na.prototype.bytesPerElement = 6, qs(na, "StructArrayLayout3i6");
        class ia extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t1;
            }
        }
        ia.prototype.bytesPerElement = 8, qs(ia, "StructArrayLayout4i8");
        class sa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.float32[1 * t1 + 0] = e, t1;
            }
        }
        sa.prototype.bytesPerElement = 4, qs(sa, "StructArrayLayout1f4");
        class oa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 4 * t1, s = 2 * t1;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.float32[s + 1] = n, t1;
            }
        }
        oa.prototype.bytesPerElement = 8, qs(oa, "StructArrayLayout2i1f8");
        class aa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 4 * t1;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        aa.prototype.bytesPerElement = 8, qs(aa, "StructArrayLayout3i8");
        class la extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const o = 5 * t1;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, t1;
            }
        }
        la.prototype.bytesPerElement = 10, qs(la, "StructArrayLayout5i10");
        class ua extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s, o);
            }
            emplace(t1, e, r, n, i, s, o, a) {
                const l = 6 * t1, u = 12 * t1, c = 3 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = o, this.float32[c + 2] = a, t1;
            }
        }
        ua.prototype.bytesPerElement = 12, qs(ua, "StructArrayLayout2i4ub1f12");
        class ca extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        ca.prototype.bytesPerElement = 12, qs(ca, "StructArrayLayout3f12");
        class ha extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const o = 6 * t1, a = 3 * t1;
                return this.uint16[o + 0] = e, this.uint16[o + 1] = r, this.uint16[o + 2] = n, this.uint16[o + 3] = i, this.float32[a + 2] = s, t1;
            }
        }
        ha.prototype.bytesPerElement = 12, qs(ha, "StructArrayLayout4ui1f12");
        class pa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.uint16[s + 0] = e, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, t1;
            }
        }
        pa.prototype.bytesPerElement = 8, qs(pa, "StructArrayLayout4ui8");
        class fa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, o) {
                const a = 6 * t1;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, t1;
            }
        }
        fa.prototype.bytesPerElement = 12, qs(fa, "StructArrayLayout6i12");
        class da extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e, r, n, i, s, o, a, l, u, c, h);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = o, this.uint16[f + 6] = a, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        da.prototype.bytesPerElement = 24, qs(da, "StructArrayLayout4i4ui4i24");
        class ma extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, o) {
                const a = 10 * t1, l = 5 * t1;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = o, t1;
            }
        }
        ma.prototype.bytesPerElement = 20, qs(ma, "StructArrayLayout3i3f20");
        class ya extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t1;
            }
        }
        ya.prototype.bytesPerElement = 16, qs(ya, "StructArrayLayout4f16");
        class ga extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint32[1 * t1 + 0] = e, t1;
            }
        }
        ga.prototype.bytesPerElement = 4, qs(ga, "StructArrayLayout1ul4");
        class xa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t1;
            }
        }
        xa.prototype.bytesPerElement = 4, qs(xa, "StructArrayLayout2ui4");
        class va extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c, h, p) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, t1, e, r, n, i, s, o, a, l, u, c, h, p);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h, p, f) {
                const d = 20 * t1, m = 10 * t1;
                return this.int16[d + 0] = e, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = s, this.float32[m + 3] = o, this.float32[m + 4] = a, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[d + 14] = c, this.uint32[m + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t1;
            }
        }
        va.prototype.bytesPerElement = 40, qs(va, "StructArrayLayout5i4f1i1ul2ui40");
        class ba extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s, o);
            }
            emplace(t1, e, r, n, i, s, o, a) {
                const l = 8 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = o, this.int16[l + 7] = a, t1;
            }
        }
        ba.prototype.bytesPerElement = 16, qs(ba, "StructArrayLayout3i2i2i16");
        class wa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const o = 4 * t1, a = 8 * t1;
                return this.float32[o + 0] = e, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[a + 6] = i, this.int16[a + 7] = s, t1;
            }
        }
        wa.prototype.bytesPerElement = 16, qs(wa, "StructArrayLayout2f1f2i16");
        class _a extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, o) {
                const a = 20 * t1, l = 5 * t1;
                return this.uint8[a + 0] = e, this.uint8[a + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = o, t1;
            }
        }
        _a.prototype.bytesPerElement = 20, qs(_a, "StructArrayLayout2ub4f20");
        class Aa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        Aa.prototype.bytesPerElement = 6, qs(Aa, "StructArrayLayout3ui6");
        class Ma extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b) {
                const w = this.length;
                return this.resize(w + 1), this.emplace(w, t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b, w) {
                const _ = 30 * t1, A = 15 * t1, M = 60 * t1;
                return this.int16[_ + 0] = e, this.int16[_ + 1] = r, this.int16[_ + 2] = n, this.float32[A + 2] = i, this.float32[A + 3] = s, this.uint16[_ + 8] = o, this.uint16[_ + 9] = a, this.uint32[A + 5] = l, this.uint32[A + 6] = u, this.uint32[A + 7] = c, this.uint16[_ + 16] = h, this.uint16[_ + 17] = p, this.uint16[_ + 18] = f, this.float32[A + 10] = d, this.float32[A + 11] = m, this.uint8[M + 48] = y, this.uint8[M + 49] = g, this.uint8[M + 50] = x, this.uint32[A + 13] = v, this.int16[_ + 28] = b, this.uint8[M + 58] = w, t1;
            }
        }
        Ma.prototype.bytesPerElement = 60, qs(Ma, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Ia extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b, w, _, A, M, I, S, z, k, P, E, T, B) {
                const V = this.length;
                return this.resize(V + 1), this.emplace(V, t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b, w, _, A, M, I, S, z, k, P, E, T, B);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b, w, _, A, M, I, S, z, k, P, E, T, B, V) {
                const C = 20 * t1, F = 40 * t1, D = 80 * t1;
                return this.float32[C + 0] = e, this.float32[C + 1] = r, this.int16[F + 4] = n, this.int16[F + 5] = i, this.int16[F + 6] = s, this.int16[F + 7] = o, this.int16[F + 8] = a, this.int16[F + 9] = l, this.int16[F + 10] = u, this.int16[F + 11] = c, this.int16[F + 12] = h, this.uint16[F + 13] = p, this.uint16[F + 14] = f, this.uint16[F + 15] = d, this.uint16[F + 16] = m, this.uint16[F + 17] = y, this.uint16[F + 18] = g, this.uint16[F + 19] = x, this.uint16[F + 20] = v, this.uint16[F + 21] = b, this.uint16[F + 22] = w, this.uint16[F + 23] = _, this.uint16[F + 24] = A, this.uint16[F + 25] = M, this.uint16[F + 26] = I, this.uint16[F + 27] = S, this.uint32[C + 14] = z, this.float32[C + 15] = k, this.float32[C + 16] = P, this.float32[C + 17] = E, this.float32[C + 18] = T, this.uint8[D + 76] = B, this.uint16[F + 39] = V, t1;
            }
        }
        Ia.prototype.bytesPerElement = 80, qs(Ia, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
        class Sa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, o) {
                const a = 6 * t1;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, this.float32[a + 5] = o, t1;
            }
        }
        Sa.prototype.bytesPerElement = 24, qs(Sa, "StructArrayLayout6f24");
        class za extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const o = 5 * t1;
                return this.float32[o + 0] = e, this.float32[o + 1] = r, this.float32[o + 2] = n, this.float32[o + 3] = i, this.float32[o + 4] = s, t1;
            }
        }
        za.prototype.bytesPerElement = 20, qs(za, "StructArrayLayout5f20");
        class ka extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s, o);
            }
            emplace(t1, e, r, n, i, s, o, a) {
                const l = 7 * t1;
                return this.float32[l + 0] = e, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = s, this.float32[l + 5] = o, this.float32[l + 6] = a, t1;
            }
        }
        ka.prototype.bytesPerElement = 28, qs(ka, "StructArrayLayout7f28");
        class Pa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, t1, e, r, n, i, s, o, a, l, u, c);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h) {
                const p = 11 * t1;
                return this.float32[p + 0] = e, this.float32[p + 1] = r, this.float32[p + 2] = n, this.float32[p + 3] = i, this.float32[p + 4] = s, this.float32[p + 5] = o, this.float32[p + 6] = a, this.float32[p + 7] = l, this.float32[p + 8] = u, this.float32[p + 9] = c, this.float32[p + 10] = h, t1;
            }
        }
        Pa.prototype.bytesPerElement = 44, qs(Pa, "StructArrayLayout11f44");
        class Ea extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t1, e, r, n, i, s, o, a, l);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u) {
                const c = 9 * t1;
                return this.float32[c + 0] = e, this.float32[c + 1] = r, this.float32[c + 2] = n, this.float32[c + 3] = i, this.float32[c + 4] = s, this.float32[c + 5] = o, this.float32[c + 6] = a, this.float32[c + 7] = l, this.float32[c + 8] = u, t1;
            }
        }
        Ea.prototype.bytesPerElement = 36, qs(Ea, "StructArrayLayout9f36");
        class Ta extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t1;
            }
        }
        Ta.prototype.bytesPerElement = 8, qs(Ta, "StructArrayLayout2f8");
        class Ba extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 6 * t1;
                return this.uint32[3 * t1 + 0] = e, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, t1;
            }
        }
        Ba.prototype.bytesPerElement = 12, qs(Ba, "StructArrayLayout1ul3ui12");
        class Va extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint16[1 * t1 + 0] = e, t1;
            }
        }
        Va.prototype.bytesPerElement = 2, qs(Va, "StructArrayLayout1ui2");
        class Ca extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m) {
                const y = this.length;
                return this.resize(y + 1), this.emplace(y, t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m);
            }
            emplace(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y) {
                const g = 16 * t1;
                return this.float32[g + 0] = e, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = s, this.float32[g + 5] = o, this.float32[g + 6] = a, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = p, this.float32[g + 12] = f, this.float32[g + 13] = d, this.float32[g + 14] = m, this.float32[g + 15] = y, t1;
            }
        }
        Ca.prototype.bytesPerElement = 64, qs(Ca, "StructArrayLayout16f64");
        class Fa extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s, o);
            }
            emplace(t1, e, r, n, i, s, o, a) {
                const l = 10 * t1, u = 5 * t1;
                return this.uint16[l + 0] = e, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = s, this.float32[u + 3] = o, this.float32[u + 4] = a, t1;
            }
        }
        Fa.prototype.bytesPerElement = 20, qs(Fa, "StructArrayLayout4ui3f20");
        class Da extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.int16[1 * t1 + 0] = e, t1;
            }
        }
        Da.prototype.bytesPerElement = 2, qs(Da, "StructArrayLayout1i2");
        class La extends Qo {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint8[1 * t1 + 0] = e, t1;
            }
        }
        La.prototype.bytesPerElement = 1, qs(La, "StructArrayLayout1ub1");
        class Ra extends Jo {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        Ra.prototype.size = 40;
        class Oa extends va {
            get(t1) {
                return new Ra(this, t1);
            }
        }
        qs(Oa, "CollisionBoxArray");
        class Ua extends Jo {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 49] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 50] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 13] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t1) {
                this._structArray.uint8[this._pos1 + 58] = t1;
            }
        }
        Ua.prototype.size = 60;
        class Na extends Ma {
            get(t1) {
                return new Ua(this, t1);
            }
        }
        qs(Na, "PlacedSymbolArray");
        class ja extends Jo {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 14] = t1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(t1) {
                this._structArray.float32[this._pos4 + 18] = t1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
                return this._structArray.uint16[this._pos2 + 39];
            }
        }
        ja.prototype.size = 80;
        class $a extends Ia {
            get(t1) {
                return new ja(this, t1);
            }
        }
        qs($a, "SymbolInstanceArray");
        class Ga extends sa {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        qs(Ga, "GlyphOffsetArray");
        class qa extends ra {
            getx(t1) {
                return this.int16[2 * t1 + 0];
            }
            gety(t1) {
                return this.int16[2 * t1 + 1];
            }
        }
        qs(qa, "SymbolLineVertexArray");
        class Ha extends Jo {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Ha.prototype.size = 12;
        class Xa extends Ba {
            get(t1) {
                return new Ha(this, t1);
            }
        }
        qs(Xa, "FeatureIndexArray");
        class Za extends xa {
            geta_centroid_pos0(t1) {
                return this.uint16[2 * t1 + 0];
            }
            geta_centroid_pos1(t1) {
                return this.uint16[2 * t1 + 1];
            }
        }
        qs(Za, "FillExtrusionCentroidArray");
        class Wa extends Jo {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        Wa.prototype.size = 6;
        class Ya extends na {
            get(t1) {
                return new Wa(this, t1);
            }
        }
        qs(Ya, "FillExtrusionWallArray");
        const Ka = ta([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Ja = ta([
            {
                name: "a_circle_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Qa = ta([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class tl {
            constructor(t1 = []){
                this.segments = t1;
            }
            _prepareSegment(t1, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > tl.MAX_VERTEX_ARRAY_LENGTH && Gt(`Max vertices per segment is ${tl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > tl.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e,
                    primitiveOffset: r,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            prepareSegment(t1, e, r, n) {
                return this._prepareSegment(t1, e.length, r.length, n);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e in t1.vaos)t1.vaos[e].destroy();
            }
            static simpleSegment(t1, e, r, n) {
                return new tl([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function el(t1, e) {
            return 256 * (t1 = Et(Math.floor(t1), 0, 255)) + Et(Math.floor(e), 0, 255);
        }
        tl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, qs(tl, "SegmentVector");
        const rl = ta([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), nl = ta([
            {
                name: "a_pattern_b",
                components: 4,
                type: "Uint16"
            }
        ]), il = ta([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class sl {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(t1, e, r, n) {
                this.ids.push(ol(t1)), this.positions.push(e, r, n);
            }
            eachPosition(t1, e) {
                const r = ol(t1);
                let n = 0, i = this.ids.length - 1;
                for(; n < i;){
                    const t1 = n + i >> 1;
                    this.ids[t1] >= r ? i = t1 : n = t1 + 1;
                }
                for(; this.ids[n] === r;)e(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(t1, e) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return al(r, n, 0, r.length - 1), e && (e.add(r.buffer), e.add(n.buffer)), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e = new sl;
                let r;
                e.ids = t1.ids, e.positions = t1.positions;
                for (const t1 of e.ids)t1 !== r && e.uniqueIds.push(t1), r = t1;
                return e.indexed = !0, e;
            }
        }
        function ol(t1) {
            const e = +t1;
            return !isNaN(e) && Number.MIN_SAFE_INTEGER <= e && e <= Number.MAX_SAFE_INTEGER ? e : We(String(t1));
        }
        function al(t1, e, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let s = r - 1, o = n + 1;
                for(;;){
                    do s++;
                    while (t1[s] < i);
                    do o--;
                    while (t1[o] > i);
                    if (s >= o) break;
                    ll(t1, s, o), ll(e, 3 * s, 3 * o), ll(e, 3 * s + 1, 3 * o + 1), ll(e, 3 * s + 2, 3 * o + 2);
                }
                o - r < n - o ? (al(t1, e, r, o), r = o + 1) : (al(t1, e, o + 1, n), n = o);
            }
        }
        function ll(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        qs(sl, "FeaturePositionMap");
        class ul {
            constructor(t1){
                this.gl = t1.gl, this.initialized = !1;
            }
            fetchUniformLocation(t1, e) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t1, e), this.initialized = !0), !!this.location;
            }
            set(t1, e, r) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class cl extends ul {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
        }
        class hl extends ul {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
        }
        class pl extends ul {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
        }
        class fl extends ul {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
        }
        class dl extends ul {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class ml extends ul {
            constructor(t1){
                super(t1), this.current = sr.transparent.toPremultipliedRenderColor(null);
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
        }
        const yl = new Float32Array(16);
        class gl extends ul {
            constructor(t1){
                super(t1), this.current = yl;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let t1 = 1; t1 < 16; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        const xl = new Float32Array(9), vl = new Float32Array(4);
        class bl extends ul {
            constructor(t1){
                super(t1), this.current = vl;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 4; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        function wl(t1) {
            return [
                el(255 * t1.r, 255 * t1.g),
                el(255 * t1.b, 255 * t1.a)
            ];
        }
        class _l {
            constructor(t1, e, r, n){
                this.value = t1, this.uniformNames = e.map((t1)=>`u_${t1}`), this.type = r, this.context = n;
            }
            setUniform(t1, e, r, n, i) {
                const s = n.constantOr(this.value);
                e.set(t1, i, s instanceof sr ? s.toPremultipliedRenderColor(this.lutExpression && "none" === this.lutExpression.value ? null : this.context.lut) : s);
            }
            getBinding(t1, e) {
                return "color" === this.type ? new ml(t1) : new hl(t1);
            }
        }
        class Al {
            constructor(t1, e){
                this.uniformNames = e.map((t1)=>`u_${t1}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(t1, e) {
                this.pixelRatio = t1.pixelRatio || 1, this.pattern = t1.tl.concat(t1.br), this.patternTransition = e ? e.tl.concat(e.br) : this.pattern;
            }
            setUniform(t1, e, r, n, i) {
                let s = null;
                "u_pattern" !== i && "u_dash" !== i || (s = this.pattern), "u_pattern_b" === i && (s = this.patternTransition), "u_pixel_ratio" === i && (s = this.pixelRatio), s && e.set(t1, i, s);
            }
            getBinding(t1, e) {
                return "u_pattern" === e || "u_pattern_b" === e || "u_dash" === e ? new dl(t1) : new hl(t1);
            }
        }
        class Ml {
            constructor(t1, e, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e, r, n, i, s, o, a) {
                const l = this.paintVertexArray.length, u = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new go(0, {
                    brightness: s,
                    worldview: a
                }), e, {}, i, n, o) : "constant" === this.expression.kind && this.expression.value, c = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, {
                    brightness: s,
                    worldview: a
                }), e, {}, i, n, o) : this.lutExpression.value);
                this.paintVertexArray.resize(t1), this._setPaintValue(l, t1, u, c ? null : this.context.lut);
            }
            updatePaintArray(t1, e, r, n, i, s, o, a) {
                const l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i) : "constant" === this.expression.kind && this.expression.value, u = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, {
                    brightness: o,
                    worldview: a
                }), r, n, void 0, i) : this.lutExpression.value);
                this._setPaintValue(t1, e, l, u ? null : this.context.lut);
            }
            _setPaintValue(t1, e, r, n) {
                if ("color" === this.type) {
                    const i = wl(r.toPremultipliedRenderColor(n));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1]);
                } else {
                    for(let n = t1; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Il {
            constructor(t1, e, r, n, i, s){
                this.expression = t1, this.uniformNames = e.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t1, e, r, n, i, s, o, a) {
                const l = this.expression.evaluate(new go(this.context.zoom, {
                    brightness: s,
                    worldview: a
                }), e, {}, i, n, o), u = this.expression.evaluate(new go(this.context.zoom + 1, {
                    brightness: s,
                    worldview: a
                }), e, {}, i, n, o), c = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, {
                    brightness: s,
                    worldview: a
                }), e, {}, i, n, o) : this.lutExpression.value), h = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(h, t1, l, u, c ? null : this.context.lut);
            }
            updatePaintArray(t1, e, r, n, i, s, o, a) {
                const l = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i), u = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i), c = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, {
                    brightness: o,
                    worldview: a
                }), r, n, void 0, i) : this.lutExpression.value);
                this._setPaintValue(t1, e, l, u, c ? null : this.context.lut);
            }
            _setPaintValue(t1, e, r, n, i) {
                if ("color" === this.type) {
                    const n = wl(r.toPremultipliedRenderColor(i)), s = wl(r.toPremultipliedRenderColor(i));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1], s[0], s[1]);
                } else {
                    for(let i = t1; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, o = Et(this.expression.interpolationFactor(s, this.context.zoom, this.context.zoom + 1), 0, 1);
                e.set(t1, i, o);
            }
            getBinding(t1, e) {
                return new hl(t1);
            }
        }
        class Sl {
            constructor(t1, e, r, n, i){
                this.expression = t1, this.layerId = i, this.paintVertexAttributes = ("array" === r ? il : rl).members;
                for(let t1 = 0; t1 < e.length; ++t1);
                this.paintVertexArray = new n, this.paintTransitionVertexArray = new pa;
            }
            populatePaintArray(t1, e, r, n) {
                const i = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValues(i, t1, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e, r, n, i, s, o) {
                this._setPaintValues(t1, e, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(t1, e, r, n) {
                if (!n || !r) return;
                const i = n[r[0]], s = n[r[1]];
                if (i) {
                    if (i) {
                        const { tl: r, br: n, pixelRatio: s } = i;
                        for(let i = t1; i < e; i++)this.paintVertexArray.emplace(i, r[0], r[1], n[0], n[1], s);
                    }
                    if (s) {
                        this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                        const { tl: r, br: n } = s;
                        for(let i = t1; i < e; i++)this.paintTransitionVertexArray.emplace(i, r[0], r[1], n[0], n[1]);
                    }
                }
            }
            upload(t1) {
                const e = this.expression.isStateDependent || !this.expression.isLightConstant;
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, e)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = t1.createVertexBuffer(this.paintTransitionVertexArray, nl.members, e));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
        }
        class zl {
            constructor(t1, e, r = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = e;
                const n = [];
                for(const i in t1.paint._values){
                    const s = t1.paint.get(i);
                    if (i.endsWith("-use-theme")) continue;
                    if (!r(i)) continue;
                    if (!(s instanceof Mo && bs(s.property.specification))) continue;
                    const o = El(i, t1.type), a = s.value, l = s.property.specification.type, u = !!s.property.useIntegerZoom, c = "line-dasharray" === i || i.endsWith("pattern"), h = t1.paint.get(`${i}-use-theme`), p = "line-dasharray" === i && "constant" !== t1.layout.get("line-cap").value.kind || h && "constant" !== h.value.kind;
                    if ("constant" !== a.kind || p) {
                        if ("source" === a.kind || p || c) {
                            const e = Vl(i, l, "source");
                            this.binders[i] = c ? new Sl(a, o, l, e, t1.id) : new Ml(a, o, l, e), n.push(`/a_${i}`);
                        } else {
                            const t1 = Vl(i, l, "composite");
                            this.binders[i] = new Il(a, o, l, u, e, t1), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = c ? new Al(a.value, o) : new _l(a.value, o, l, e), n.push(`/u_${i}`);
                    h && (this.binders[i].lutExpression = h.value);
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t1) {
                const e = this.binders[t1];
                return e instanceof Ml || e instanceof Il ? e.maxValue : 0;
            }
            populatePaintArrays(t1, e, r, n, i, s, o, a) {
                for(const l in this.binders){
                    const u = this.binders[l];
                    u.context = this.context, (u instanceof Ml || u instanceof Il || u instanceof Sl) && u.populatePaintArray(t1, e, r, n, i, s, o, a);
                }
            }
            setConstantPatternPositions(t1, e) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Al && n.setConstantPatternPositions(t1, e);
                }
            }
            getPatternTransitionVertexBuffer(t1) {
                const e = this.binders[t1];
                return e instanceof Sl ? e.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(t1, e, r, n, i, s, o, a, l, u) {
                let c = !1;
                const h = Object.keys(t1), p = 0 !== h.length && !a, f = p ? h : e.uniqueIds;
                this.context.lut = i.lut;
                for(const a in this.binders){
                    const h = this.binders[a];
                    if (h.context = this.context, (h instanceof Ml || h instanceof Il || h instanceof Sl) && h.expression && h.expression.kind && "constant" !== h.expression.kind && (!0 === h.expression.isStateDependent || !1 === h.expression.isLightConstant)) {
                        const d = i.paint.get(a);
                        h.expression = d.value;
                        for (const r of f){
                            const i = t1[r.toString()];
                            e.eachPosition(r, (t1, e, r)=>{
                                const a = n.feature(t1);
                                h.updatePaintArray(e, r, a, i, s, o, l, u);
                            });
                        }
                        if (!p) for (const e of r.uniqueIds){
                            const i = t1[e.toString()];
                            r.eachPosition(e, (t1, e, r)=>{
                                const a = n.feature(t1);
                                h.updatePaintArray(e, r, a, i, s, o, l, u);
                            });
                        }
                        c = !0;
                    }
                }
                return c;
            }
            defines() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof _l || r instanceof Al) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Ml || r instanceof Il || r instanceof Sl) for(let e = 0; e < r.paintVertexAttributes.length; e++)t1.push(r.paintVertexAttributes[e].name);
                    if (r instanceof Sl) for(let e = 0; e < nl.members.length; e++)t1.push(nl.members[e].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof _l || r instanceof Al || r instanceof Il) for (const e of r.uniformNames)t1.push(e);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1) {
                const e = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof _l || n instanceof Al || n instanceof Il) for (const i of n.uniformNames)e.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(t1, i)
                    });
                }
                return e;
            }
            setUniforms(t1, e, r, n, i) {
                for (const { name: e, property: s, binding: o } of r)this.binders[s].setUniform(t1, o, i, n.get(s), e);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Ml || e instanceof Il || e instanceof Sl) && e.paintVertexBuffer && this._buffers.push(e.paintVertexBuffer), e instanceof Sl && e.paintTransitionVertexBuffer && this._buffers.push(e.paintTransitionVertexBuffer);
                }
            }
            upload(t1) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Ml || r instanceof Il || r instanceof Sl) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Ml || e instanceof Il || e instanceof Sl) && e.destroy();
                }
            }
        }
        class kl {
            constructor(t1, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new zl(n, e, r);
                this.needsUpload = !1, this._featureMap = new sl, this._featureMapWithoutIds = new sl, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(t1, e, r, n, i, s, o, a, l) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e, n, i, s, o, a, l);
                void 0 !== e.id ? this._featureMap.add(e.id, r, this._bufferOffset, t1) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, t1), this._idlessCounter += 1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e, r, n, i, s, o, a) {
                for (const l of r)this.needsUpload = this.programConfigurations[l.id].updatePaintArrays(t1, this._featureMap, this._featureMapWithoutIds, e, l, n, i, s, o || 0, a) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
        }
        const Pl = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "line-dasharray": [
                "dash"
            ],
            "fill-bridge-guard-rail-color": [
                "structure_color"
            ],
            "fill-tunnel-structure-color": [
                "structure_color"
            ]
        };
        function El(t1, e) {
            return Pl[t1] || [
                t1.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        const Tl = {
            "line-pattern": {
                source: ha,
                composite: ha
            },
            "fill-pattern": {
                source: ha,
                composite: ha
            },
            "fill-extrusion-pattern": {
                source: ha,
                composite: ha
            },
            "line-dasharray": {
                source: pa,
                composite: pa
            }
        }, Bl = {
            color: {
                source: Ta,
                composite: ya
            },
            number: {
                source: sa,
                composite: Ta
            }
        };
        function Vl(t1, e, r) {
            const n = Tl[t1];
            return n && n[r] || Bl[e][r];
        }
        qs(_l, "ConstantBinder"), qs(Al, "PatternConstantBinder"), qs(Ml, "SourceExpressionBinder"), qs(Sl, "PatternCompositeBinder"), qs(Il, "CompositeExpressionBinder"), qs(zl, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), qs(kl, "ProgramConfigurationSet");
        const Cl = Cn / Math.PI / 2, Fl = 5, Dl = 6, Ll = 16383, Rl = 64, Ol = [
            Rl,
            32,
            16
        ], Ul = -Cl, Nl = Cl;
        function jl(t1, e, r, n = Cl) {
            return r = Mt(r), [
                t1 * Math.sin(r) * n,
                -e * n,
                t1 * Math.cos(r) * n
            ];
        }
        function $l(t1, e, r) {
            return jl(Math.cos(Mt(t1)), Math.sin(Mt(t1)), e, r);
        }
        const Gl = 6371008.8, ql = 2 * Math.PI * Gl;
        class Hl {
            constructor(t1, e){
                if (isNaN(t1) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t1}, ${e})`);
                if (this.lng = +t1, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new Hl(Bt(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e = Math.PI / 180, r = this.lat * e, n = t1.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e);
                return Gl * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e = 360 * t1 / 40075017, r = e / Math.cos(Math.PI / 180 * this.lat);
                return new Xl({
                    lng: this.lng - r,
                    lat: this.lat - e
                }, {
                    lng: this.lng + r,
                    lat: this.lat + e
                });
            }
            toEcef(t1) {
                return $l(this.lat, this.lng, Cl + t1 * Cl / Gl);
            }
            static convert(t1) {
                if (t1 instanceof Hl) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Hl(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Hl(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class Xl {
            constructor(t1, e){
                if (t1) {
                    if (e) this.setSouthWest(t1).setNorthEast(e);
                    else if (4 === t1.length) {
                        const e = t1;
                        this.setSouthWest([
                            e[0],
                            e[1]
                        ]).setNorthEast([
                            e[2],
                            e[3]
                        ]);
                    } else {
                        const e = t1;
                        this.setSouthWest(e[0]).setNorthEast(e[1]);
                    }
                }
            }
            setNorthEast(t1) {
                return this._ne = t1 instanceof Hl ? new Hl(t1.lng, t1.lat) : Hl.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof Hl ? new Hl(t1.lng, t1.lat) : Hl.convert(t1), this;
            }
            extend(t1) {
                const e = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof Hl) n = t1, i = t1;
                else {
                    if (!(t1 instanceof Xl)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Xl.convert(t1)) : this.extend(Hl.convert(t1)) : "object" == typeof t1 && null !== t1 && t1.hasOwnProperty("lat") && (t1.hasOwnProperty("lon") || t1.hasOwnProperty("lng")) ? this.extend(Hl.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e || r ? (e.lng = Math.min(n.lng, e.lng), e.lat = Math.min(n.lat, e.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new Hl(n.lng, n.lat), this._ne = new Hl(i.lng, i.lat)), this;
            }
            getCenter() {
                return new Hl((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new Hl(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new Hl(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e, lat: r } = Hl.convert(t1);
                let n = this._sw.lng <= e && e <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e && e >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                if (t1) return t1 instanceof Xl ? t1 : new Xl(t1);
            }
        }
        const Zl = 0, Wl = 25.5;
        function Yl(t1) {
            return ql * Math.cos(t1 * Math.PI / 180);
        }
        function Kl(t1) {
            return (180 + t1) / 360;
        }
        function Jl(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function Ql(t1, e) {
            return t1 / Yl(e);
        }
        function tu(t1) {
            return 360 * t1 - 180;
        }
        function eu(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function ru(t1, e) {
            return t1 * Yl(eu(e));
        }
        const nu = 85.051129;
        function iu(t1) {
            return Math.cos(Mt(Et(t1, -85.051129, nu)));
        }
        function su(t1, e) {
            const r = Et(e, Zl, Wl), n = Math.pow(2, r);
            return iu(t1) * ql / (512 * n);
        }
        function ou(t1) {
            return 1 / Math.cos(t1 * Math.PI / 180);
        }
        function au(t1, e = 0) {
            const r = Math.exp(Math.PI * (1 - (t1.y + e / Cn) / (1 << t1.z) * 2));
            return 80150034 * r / (r * r + 1) / Cn / (1 << t1.z);
        }
        class lu {
            constructor(t1, e, r = 0){
                this.x = +t1, this.y = +e, this.z = +r;
            }
            static fromLngLat(t1, e = 0) {
                const r = Hl.convert(t1);
                return new lu(Kl(r.lng), Jl(r.lat), Ql(e, r.lat));
            }
            toLngLat() {
                return new Hl(tu(this.x), eu(this.y));
            }
            toAltitude() {
                return ru(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / ql * ou(eu(this.y));
            }
        }
        function uu(t1, e, r, n, i, s, o, a, l) {
            const u = (e + n) / 2, c = (r + i) / 2, h = new bt(u, c);
            a(h), function(t1, e, r, n, i, s) {
                const o = r - i, a = n - s;
                return Math.abs((n - e) * o - (r - t1) * a) / Math.hypot(o, a);
            }(h.x, h.y, s.x, s.y, o.x, o.y) >= l ? (uu(t1, e, r, u, c, s, h, a, l), uu(t1, u, c, n, i, h, o, a, l)) : t1.push(o);
        }
        function cu(t1, e, r) {
            let n = t1[0], i = n.x, s = n.y;
            e(n);
            const o = [
                n
            ];
            for(let a = 1; a < t1.length; a++){
                const l = t1[a], { x: u, y: c } = l;
                e(l), uu(o, i, s, u, c, n, l, e, r), i = u, s = c, n = l;
            }
            return o;
        }
        function hu(t1, e, r, n) {
            if (n(e, r)) {
                const i = e.add(r)._mult(.5);
                hu(t1, e, i, n), hu(t1, i, r, n);
            } else t1.push(r);
        }
        function pu(t1, e) {
            let r = t1[0];
            const n = [
                r
            ];
            for(let i = 1; i < t1.length; i++){
                const s = t1[i];
                hu(n, r, s, e), r = s;
            }
            return n;
        }
        const fu = Math.pow(2, 14) - 1, du = -fu - 1;
        function mu(t1, e) {
            const r = Math.round(t1.x * e), n = Math.round(t1.y * e);
            return t1.x = Et(r, du, fu), t1.y = Et(n, du, fu), (r < t1.x || r > t1.x + 1 || n < t1.y || n > t1.y + 1) && Gt("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t1;
        }
        function yu(t1, e, r) {
            const n = t1.loadGeometry(), i = t1.extent, s = Cn / i;
            if (e && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << e.z, { scale: o, x: a, y: l, projection: u } = r, c = (t1)=>{
                    const r = tu((e.x + t1.x / i) / s), n = eu((e.y + t1.y / i) / s), c = u.project(r, n);
                    t1.x = (c.x * o - a) * i, t1.y = (c.y * o - l) * i;
                };
                for(let e = 0; e < n.length; e++)if (1 !== t1.type) n[e] = cu(n[e], c, 1);
                else {
                    const t1 = [];
                    for (const r of n[e])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), t1.push(r));
                    n[e] = t1;
                }
            }
            for (const t1 of n)for (const e of t1)mu(e, s);
            return n;
        }
        function gu(t1, e) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e ? yu(t1) : []
            };
        }
        var xu, vu, bu, wu, _u, Au, Mu, Iu = {};
        function Su() {
            if (vu) return xu;
            vu = 1;
            var t1 = vt();
            function e(t1, e, n, i, s) {
                this.properties = {}, this.extent = n, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = i, this._values = s, t1.readFields(r, this, e);
            }
            function r(t1, e, r) {
                1 == t1 ? e.id = r.readVarint() : 2 == t1 ? function(t1, e) {
                    for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = e._keys[t1.readVarint()], i = e._values[t1.readVarint()];
                        e.properties[n] = i;
                    }
                }(r, e) : 3 == t1 ? e.type = r.readVarint() : 4 == t1 && (e._geometry = r.pos);
            }
            function n(t1) {
                for(var e, r, n = 0, i = 0, s = t1.length, o = s - 1; i < s; o = i++)n += ((r = t1[o]).x - (e = t1[i]).x) * (e.y + r.y);
                return n;
            }
            return xu = e, e.types = [
                "Unknown",
                "Point",
                "LineString",
                "Polygon"
            ], e.prototype.loadGeometry = function() {
                var e = this._pbf;
                e.pos = this._geometry;
                for(var r, n = e.readVarint() + e.pos, i = 1, s = 0, o = 0, a = 0, l = []; e.pos < n;){
                    if (s <= 0) {
                        var u = e.readVarint();
                        i = 7 & u, s = u >> 3;
                    }
                    if (s--, 1 === i || 2 === i) o += e.readSVarint(), a += e.readSVarint(), 1 === i && (r && l.push(r), r = []), r.push(new t1(o, a));
                    else {
                        if (7 !== i) throw new Error("unknown command " + i);
                        r && r.push(r[0].clone());
                    }
                }
                return r && l.push(r), l;
            }, e.prototype.bbox = function() {
                var t1 = this._pbf;
                t1.pos = this._geometry;
                for(var e = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, s = 0, o = 1 / 0, a = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e;){
                    if (n <= 0) {
                        var c = t1.readVarint();
                        r = 7 & c, n = c >> 3;
                    }
                    if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > a && (a = i), (s += t1.readSVarint()) < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error("unknown command " + r);
                }
                return [
                    o,
                    l,
                    a,
                    u
                ];
            }, e.prototype.toGeoJSON = function(t1, r, i) {
                var s, o, a = this.extent * Math.pow(2, i), l = this.extent * t1, u = this.extent * r, c = this.loadGeometry(), h = e.types[this.type];
                function p(t1) {
                    for(var e = 0; e < t1.length; e++){
                        var r = t1[e];
                        t1[e] = [
                            360 * (r.x + l) / a - 180,
                            360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + u) / a) * Math.PI / 180)) - 90
                        ];
                    }
                }
                switch(this.type){
                    case 1:
                        var f = [];
                        for(s = 0; s < c.length; s++)f[s] = c[s][0];
                        p(c = f);
                        break;
                    case 2:
                        for(s = 0; s < c.length; s++)p(c[s]);
                        break;
                    case 3:
                        for(c = function(t1) {
                            var e = t1.length;
                            if (e <= 1) return [
                                t1
                            ];
                            for(var r, i, s = [], o = 0; o < e; o++){
                                var a = n(t1[o]);
                                0 !== a && (void 0 === i && (i = a < 0), i === a < 0 ? (r && s.push(r), r = [
                                    t1[o]
                                ]) : r.push(t1[o]));
                            }
                            return r && s.push(r), s;
                        }(c), s = 0; s < c.length; s++)for(o = 0; o < c[s].length; o++)p(c[s][o]);
                }
                1 === c.length ? c = c[0] : h = "Multi" + h;
                var d = {
                    type: "Feature",
                    geometry: {
                        type: h,
                        coordinates: c
                    },
                    properties: this.properties
                };
                return "id" in this && (d.id = this.id), d;
            }, xu;
        }
        function zu() {
            if (wu) return bu;
            wu = 1;
            var t1 = Su();
            function e(t1, e) {
                this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(r, this, e), this.length = this._features.length;
            }
            function r(t1, e, r) {
                15 === t1 ? e.version = r.readVarint() : 1 === t1 ? e.name = r.readString() : 5 === t1 ? e.extent = r.readVarint() : 2 === t1 ? e._features.push(r.pos) : 3 === t1 ? e._keys.push(r.readString()) : 4 === t1 && e._values.push(function(t1) {
                    for(var e = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = t1.readVarint() >> 3;
                        e = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                    }
                    return e;
                }(r));
            }
            return bu = e, e.prototype.feature = function(e) {
                if (e < 0 || e >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e];
                var r = this._pbf.readVarint() + this._pbf.pos;
                return new t1(this._pbf, r, this.extent, this._keys, this._values);
            }, bu;
        }
        function ku() {
            return Mu || (Mu = 1, Iu.VectorTile = function() {
                if (Au) return _u;
                Au = 1;
                var t1 = zu();
                function e(e, r, n) {
                    if (3 === e) {
                        var i = new t1(n, n.readVarint() + n.pos);
                        i.length && (r[i.name] = i);
                    }
                }
                return _u = function(t1, r) {
                    this.layers = t1.readFields(e, {}, r);
                }, _u;
            }(), Iu.VectorTileFeature = Su(), Iu.VectorTileLayer = zu()), Iu;
        }
        var Pu = ku();
        const Eu = "3d_elevation_id", Tu = "level";
        class Bu {
            constructor(){
                this._valid = !1;
            }
            reset(t1) {
                return this.feature = t1, this._valid = !0, this._geometry = t1.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(t1, e) {
                return this._valid && t1(e(this._geometry)), this;
            }
            require(t1, e, r) {
                return this.get(t1, !0, e, r);
            }
            optional(t1, e, r) {
                return this.get(t1, !1, e, r);
            }
            success() {
                return this._valid;
            }
            get(t1, e, r, n) {
                const i = this.feature.properties.hasOwnProperty(t1) ? +this.feature.properties[t1] : void 0;
                return this._valid && void 0 !== i && !Number.isNaN(i) ? r(n ? n(i) : i) : e && (this._valid = !1), this;
            }
        }
        class Vu {
            constructor(t1, e){
                this.featureFunc = t1, this.vertexFunc = e;
            }
            parseFeature(t1, e, r) {
                return this.featureFunc(t1, e, r);
            }
            parseVertex(t1, e, r) {
                return this.vertexFunc(t1, e, r);
            }
        }
        const Cu = new Vu((t1, e, r)=>t1.reset(e).require(Eu, (t1)=>{
                r.id = t1;
            }).optional("fixed_height_relative", (t1)=>{
                r.constantHeight = t1;
            }, Du.decodeRelativeHeight).geometry((t1)=>{
                r.bounds = t1;
            }, pn).success(), (t1, e, r)=>t1.reset(e).require(Eu, (t1)=>{
                r.id = t1;
            }).require("elevation_idx", (t1)=>{
                r.idx = t1;
            }).require("extent", (t1)=>{
                r.extent = t1;
            }).require("height_relative", (t1)=>{
                r.height = t1;
            }, Du.decodeRelativeHeight).geometry((t1)=>{
                r.position = t1;
            }, Du.getPoint).success()), Fu = new Vu((t1, e, r)=>t1.reset(e).require(Eu, (t1)=>{
                r.id = t1;
            }).optional("fixed_height", (t1)=>{
                r.constantHeight = t1;
            }, Du.decodeMetricHeight).geometry((t1)=>{
                r.bounds = t1;
            }, pn).success(), (t1, e, r)=>t1.reset(e).require(Eu, (t1)=>{
                r.id = t1;
            }).require("elevation_idx", (t1)=>{
                r.idx = t1;
            }).require("extent", (t1)=>{
                r.extent = t1;
            }).require("height", (t1)=>{
                r.height = t1;
            }, Du.decodeMetricHeight).geometry((t1)=>{
                r.position = t1;
            }, Du.getPoint).success());
        class Du {
            static getPoint(t1) {
                return at(t1[0][0].x, t1[0][0].y);
            }
            static decodeRelativeHeight(t1) {
                return 1e-4 * t1 * 5;
            }
            static decodeMetricHeight(t1) {
                return 1e-4 * t1;
            }
            static parse(t1) {
                const e = [], r = [], n = t1.length, i = new Bu;
                for(let o = 0; o < n; o++){
                    const n = t1.feature(o), a = n.properties.hasOwnProperty("version") ? String(n.properties.version) : void 0, l = (s = a) ? "1.0.1" === s ? Fu : void 0 : Cu;
                    if (void 0 === l) {
                        Gt(`Unknown elevation feature version number ${a || "(unknown)"}`);
                        continue;
                    }
                    const u = n.properties.hasOwnProperty("type") ? n.properties.type : void 0;
                    if (u) {
                        if ("Point" === Pu.VectorTileFeature.types[n.type] && "curve_point" === u) {
                            const t1 = {};
                            l.parseVertex(i, n, t1) && e.push(t1);
                        } else if ("Polygon" === Pu.VectorTileFeature.types[n.type] && "curve_meta" === u) {
                            const t1 = {};
                            l.parseFeature(i, n, t1) && r.push(t1);
                        }
                    }
                }
                var s;
                return {
                    vertices: e,
                    features: r
                };
            }
        }
        class Lu {
            constructor(t1, e){
                this.pos = t1, this.dir = e;
            }
            intersectsPlane(t1, e, r) {
                const n = ft(e, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e[0] + (t1[1] - this.pos[1]) * e[1]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, !0;
            }
        }
        class Ru {
            constructor(t1, e){
                this.pos = t1, this.dir = e;
            }
            intersectsPlane(t1, e, r) {
                const n = F(e, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e[0] + (t1[1] - this.pos[1]) * e[1] + (t1[2] - this.pos[2]) * e[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(t1, r, n) {
                if (function(t1, r) {
                    var n = t1[0], i = t1[1], s = t1[2], o = r[0], a = r[1], l = r[2];
                    return Math.abs(n - o) <= e * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - a) <= e * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(s - l) <= e * Math.max(1, Math.abs(s), Math.abs(l));
                }(this.pos, t1) || 0 === r) return n[0] = n[1] = n[2] = 0, !1;
                const [i, s, o] = this.dir, a = this.pos[0] - t1[0], l = this.pos[1] - t1[1], u = this.pos[2] - t1[2], c = i * i + s * s + o * o, h = 2 * (a * i + l * s + u * o), p = h * h - 4 * c * (a * a + l * l + u * u - r * r);
                if (p < 0) {
                    const t1 = Math.max(-h / 2, 0), e = a + i * t1, c = l + s * t1, p = u + o * t1, f = Math.hypot(e, c, p);
                    return n[0] = e * r / f, n[1] = c * r / f, n[2] = p * r / f, !1;
                }
                {
                    const t1 = (-h - Math.sqrt(p)) / (2 * c);
                    if (t1 < 0) {
                        const t1 = Math.hypot(a, l, u);
                        return n[0] = a * r / t1, n[1] = l * r / t1, n[2] = u * r / t1, !1;
                    }
                    return n[0] = a + i * t1, n[1] = l + s * t1, n[2] = u + o * t1, !0;
                }
            }
        }
        class Ou {
            constructor(t1, e, r, n, i){
                this.TL = t1, this.TR = e, this.BR = r, this.BL = n, this.horizon = i;
            }
            static fromInvProjectionMatrix(t1, e, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], o = [
                    -1,
                    -1,
                    1
                ], a = R(n, n, t1), l = R(i, i, t1), u = R(s, s, t1), c = R(o, o, t1);
                return new Ou(a, l, u, c, e / r);
            }
        }
        function Uu(t1, e, r) {
            let n = 1 / 0, i = -1 / 0;
            const s = [];
            for (const o of t1){
                j(s, o, e);
                const t1 = F(s, r);
                n = Math.min(n, t1), i = Math.max(i, t1);
            }
            return [
                n,
                i
            ];
        }
        function Nu(t1, e) {
            let r = !0;
            for(let n = 0; n < t1.planes.length; n++){
                const i = t1.planes[n];
                let s = 0;
                for(let t1 = 0; t1 < e.length; t1++)s += F(i, e[t1]) + i[3] >= 0;
                if (0 === s) return 0;
                s !== e.length && (r = !1);
            }
            return r ? 2 : 1;
        }
        function ju(t1, e) {
            for (const r of t1.projections){
                const n = Uu(e, t1.points[0], r.axis);
                if (r.projection[1] < n[0] || r.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function $u(t1, e) {
            let r = 0;
            const n = [
                0,
                0,
                0,
                0
            ];
            for(let o = 0; o < t1.length; o++)n[0] = t1[o][0], n[1] = t1[o][1], n[2] = t1[o][2], n[3] = 1, (i = n)[0] * (s = e)[0] + i[1] * s[1] + i[2] * s[2] + i[3] * s[3] >= 0 && r++;
            var i, s;
            return r;
        }
        class Gu {
            constructor(t1, e){
                this.points = t1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = e || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = qu.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    j([], this.points[2], this.points[3]),
                    j([], this.points[0], this.points[3]),
                    j([], this.points[4], this.points[0]),
                    j([], this.points[5], this.points[1]),
                    j([], this.points[6], this.points[2]),
                    j([], this.points[7], this.points[3])
                ];
                for (const t1 of this.frustumEdges){
                    const e = [
                        0,
                        -t1[2],
                        t1[1]
                    ], r = [
                        t1[2],
                        0,
                        -t1[0]
                    ];
                    this.projections.push({
                        axis: e,
                        projection: Uu(this.points, this.points[0], e)
                    }), this.projections.push({
                        axis: r,
                        projection: Uu(this.points, this.points[0], r)
                    });
                }
            }
            static fromInvProjectionMatrix(t1, e, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = Z([], r, t1), o = 1 / s[3] / e * i;
                    var a, l, u;
                    return (a = s)[0] = (l = s)[0] * (u = [
                        o,
                        o,
                        n ? 1 / s[3] : o,
                        o
                    ])[0], a[1] = l[1] * u[1], a[2] = l[2] * u[2], a[3] = l[3] * u[3], a;
                }), o = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e = C([], D([], j([], s[t1[0]], s[t1[1]]), j([], s[t1[2]], s[t1[1]]))), r = -F(e, s[t1[1]]);
                    return e.concat(r);
                }), a = [];
                for(let t1 = 0; t1 < s.length; t1++)a.push([
                    s[t1][0],
                    s[t1][1],
                    s[t1][2]
                ]);
                return new Gu(a, o);
            }
            intersectsPrecise(t1, e, r) {
                for(let r = 0; r < e.length; r++)if (!$u(t1, e[r])) return 0;
                for(let e = 0; e < this.planes.length; e++)if (!$u(t1, this.planes[e])) return 0;
                for (const e of r)for (const r of this.frustumEdges){
                    const n = D([], e, r), i = _(n);
                    if (0 === i) continue;
                    P(n, n, 1 / i);
                    const s = Uu(this.points, this.points[0], n), o = Uu(t1, this.points[0], n);
                    if (s[0] > o[1] || o[0] > s[1]) return 0;
                }
                return 1;
            }
            containsPoint(t1) {
                for (const e of this.planes){
                    const r = e[3];
                    if (F([
                        e[0],
                        e[1],
                        e[2]
                    ], t1) + r < 0) return !1;
                }
                return !0;
            }
        }
        class qu {
            static fromPoints(t1) {
                const e = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of t1)z(e, e, n), k(r, r, n);
                return new qu(e, r);
            }
            static fromTileIdAndHeight(t1, e, r) {
                const n = 1 << t1.canonical.z, i = t1.canonical.x, s = t1.canonical.y;
                return new qu([
                    i / n,
                    s / n,
                    e
                ], [
                    (i + 1) / n,
                    (s + 1) / n,
                    r
                ]);
            }
            static applyTransform(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)R(r[t1], r[t1], e);
                return qu.fromPoints(r);
            }
            static applyTransformFast(t1, e) {
                const r = [
                    e[12],
                    e[13],
                    e[14]
                ], n = [
                    ...r
                ];
                for(let i = 0; i < 3; i++)for(let s = 0; s < 3; s++){
                    const o = e[4 * s + i], a = o * t1.min[s], l = o * t1.max[s];
                    r[i] += Math.min(a, l), n[i] += Math.max(a, l);
                }
                return new qu(r, n);
            }
            static projectAabbCorners(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)R(r[t1], r[t1], e);
                return r;
            }
            constructor(t1, e){
                this.min = t1, this.max = e, this.center = P([], M([], this.min, this.max), .5);
            }
            quadrant(t1) {
                const e = [
                    t1 % 2 == 0,
                    t1 < 2
                ], r = w(this.min), n = w(this.max);
                for(let t1 = 0; t1 < e.length; t1++)r[t1] = e[t1] ? this.min[t1] : this.center[t1], n[t1] = e[t1] ? this.center[t1] : this.max[t1];
                return n[2] = this.max[2], new qu(r, n);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            distanceZ(t1) {
                return Math.max(Math.min(this.max[2], t1[2]), this.min[2]) - t1[2];
            }
            getCorners() {
                const t1 = this.min, e = this.max;
                return [
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        e[1],
                        e[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        e[2]
                    ]
                ];
            }
            intersects(t1) {
                return this.intersectsAabb(t1.bounds) ? Nu(t1, this.getCorners()) : 0;
            }
            intersectsFlat(t1) {
                return this.intersectsAabb(t1.bounds) ? Nu(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(t1, e) {
                return e || this.intersects(t1) ? ju(t1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(t1, e) {
                return e || this.intersectsFlat(t1) ? ju(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(t1) {
                for(let e = 0; e < 3; ++e)if (this.min[e] > t1.max[e] || t1.min[e] > this.max[e]) return !1;
                return !0;
            }
            intersectsAabbXY(t1) {
                return !(this.min[0] > t1.max[0] || t1.min[0] > this.max[0] || this.min[1] > t1.max[1] || t1.min[1] > this.max[1]);
            }
            encapsulate(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1.min[e]), this.max[e] = Math.max(this.max[e], t1.max[e]);
            }
            encapsulatePoint(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1[e]), this.max[e] = Math.max(this.max[e], t1[e]);
            }
            closestPoint(t1) {
                return [
                    Math.max(Math.min(this.max[0], t1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], t1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], t1[2]), this.min[2])
                ];
            }
        }
        qs(qu, "Aabb");
        class Hu {
            constructor(t1, e){
                this.feature = t1, this.metersToTile = e, this.index = 0;
            }
            get() {
                const t1 = this.feature.vertices[this.index], e = this.feature.vertexProps[this.index].dir, r = e[1], n = -e[0], i = (t1.extent + 1) * this.metersToTile;
                return [
                    new bt(Math.trunc(t1.position[0] + r * i), Math.trunc(t1.position[1] + n * i)),
                    new bt(Math.trunc(t1.position[0] - r * i), Math.trunc(t1.position[1] - n * i))
                ];
            }
            next() {
                this.index++;
            }
            valid() {
                return this.index < this.feature.vertices.length;
            }
        }
        class Xu {
            constructor(t1, e, r, n, i, s){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this.id = t1, this.heightRange = {
                    min: r,
                    max: r
                }, this.safeArea = e, this.constantHeight = r, null == this.constantHeight && (null != this.constantHeight || 0 !== n.length)) {
                    this.vertices = n, this.edges = i, this.edges = this.edges.filter((t1)=>{
                        var e, r;
                        return t1.a < this.vertices.length && t1.b < this.vertices.length && !((e = this.vertices[t1.a].position)[0] === (r = this.vertices[t1.b].position)[0] && e[1] === r[1]);
                    }), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const t1 of this.vertices)this.vertexProps.push({
                        dir: at(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, t1.height), this.heightRange.max = Math.max(this.heightRange.max, t1.height);
                    for (const t1 of this.edges){
                        const e = this.vertices[t1.a].position, r = this.vertices[t1.b].position, n = ut(ot(), r, e), i = ht(n), s = ct(ot(), n, 1 / i);
                        this.edgeProps.push({
                            vec: n,
                            dir: s,
                            len: i
                        });
                        const o = this.vertexProps[t1.a].dir, a = this.vertexProps[t1.b].dir;
                        lt(o, o, s), lt(a, a, s);
                    }
                    for (const t1 of this.vertexProps)0 === t1.dir[0] && 0 === t1.dir[1] || pt(t1.dir, t1.dir);
                    this.tessellate(s);
                }
            }
            pointElevation(t1) {
                if (null != this.constantHeight) return this.constantHeight;
                const e = this.getClosestEdge(t1);
                if (null == e) return 0;
                const [r, n] = e;
                return ur(this.vertices[this.edges[r].a].height, this.vertices[this.edges[r].b].height, n);
            }
            computeSlopeNormal(t1, e) {
                const r = this.getClosestEdge(t1);
                if (!r) return A(0, 0, 1);
                const n = r[0], i = this.edges[n], s = this.edgeProps[n].vec, o = A(s[0], s[1], (this.vertices[i.b].height - this.vertices[i.a].height) * e), a = A(o[1], -o[0], 0);
                D(a, a, o);
                const l = _(a);
                return l > 0 ? P(a, a, 1 / l) : A(0, 0, 1);
            }
            getSafeArea() {
                return this.safeArea;
            }
            isTunnel() {
                return this.heightRange.max <= -5;
            }
            getClosestEdge(t1) {
                if (0 === this.edges.length) return;
                let e = 0, r = Number.POSITIVE_INFINITY, n = 0;
                const i = at(t1.x, t1.y);
                for(let t1 = 0; t1 < this.edges.length; t1++){
                    const s = this.edges[t1], o = this.edgeProps[t1].dir, a = new Lu(i, this.edgeProps[t1].dir), l = this.vertices[s.a].position, u = this.vertices[s.b].position, c = ot(), h = ot(), p = a.intersectsPlane(l, this.vertexProps[s.a].dir, c), f = a.intersectsPlane(u, this.vertexProps[s.b].dir, h);
                    if (!p || !f) continue;
                    const d = ut(ot(), h, c), m = ut(ot(), i, c), y = ft(d, d), g = y > 0 ? ft(m, d) / y : 0, x = Et(g, 0, 1), v = Math.abs((g - x) * this.edgeProps[t1].len), b = ut(ot(), i, l), w = v + Math.abs(ft(b, at(o[1], -o[0])));
                    w < r && (e = t1, r = w, n = x);
                }
                return [
                    e,
                    n
                ];
            }
            tessellate(t1) {
                for(let e = this.edges.length - 1; e >= 0; --e){
                    const r = this.edges[e].a, n = this.edges[e].b, { position: i, height: s, extent: o } = this.vertices[r], { position: a, height: l, extent: u } = this.vertices[n], c = this.vertexProps[r].dir, h = this.vertexProps[n].dir, p = A(i[0] / t1, i[1] / t1, s), f = A(a[0] / t1, a[1] / t1, l), d = A(c[1], -c[0], 0);
                    P(d, d, o);
                    const m = A(h[1], -h[0], 0);
                    if (P(m, m, u), this.distSqLines(A(p[0] + .5 * d[0], p[1] + .5 * d[1], p[2] + .5 * d[2]), A(f[0] - .5 * m[0], f[1] - .5 * m[1], f[2] - .5 * m[2]), A(p[0] - .5 * d[0], p[1] - .5 * d[1], p[2] - .5 * d[2]), A(f[0] + .5 * m[0], f[1] + .5 * m[1], f[2] + .5 * m[2])) <= .0025000000000000005) continue;
                    const y = this.vertices.length, g = lt(ot(), i, a);
                    this.vertices.push({
                        position: ct(g, g, .5),
                        height: .5 * (s + l),
                        extent: .5 * (o + u)
                    });
                    const x = lt(ot(), c, h);
                    this.vertexProps.push({
                        dir: pt(x, x)
                    }), this.edges.splice(e, 1), this.edgeProps.splice(e, 1), this.edges.push({
                        a: r,
                        b: y
                    }), this.edges.push({
                        a: y,
                        b: n
                    });
                    const v = ut(ot(), this.vertices[y].position, i), b = ht(v), w = {
                        vec: v,
                        dir: ct(ot(), v, 1 / b),
                        len: b
                    };
                    this.edgeProps.push(w), this.edgeProps.push(w);
                }
            }
            distSqLines(t1, e, r, n) {
                const i = I(b(), e, t1), s = I(b(), n, r), o = I(b(), t1, r), a = F(i, i), l = F(i, s), u = F(i, o), c = F(s, s), h = F(s, o), p = a * c - l * l;
                if (0 === p) {
                    const e = F(o, s) / F(s, s);
                    return T(L(b(), r, n, e), t1);
                }
                const f = (l * h - u * c) / p, d = (a * h - l * u) / p;
                return T(L(b(), t1, e, f), L(b(), r, n, d));
            }
        }
        class Zu {
            static parseFrom(t1, e) {
                const r = Du.parse(t1);
                if (!r) return [];
                let { vertices: n, features: i } = r;
                const s = 1 / au(e);
                i.sort((t1, e)=>t1.id - e.id), n.sort((t1, e)=>t1.id - e.id || t1.idx - e.idx), n = n.filter((t1, e, r)=>e === r.findIndex((e)=>e.id === t1.id && e.idx === t1.idx));
                const o = new Array;
                let a = 0;
                const l = n.length;
                for (const t1 of i){
                    if (t1.constantHeight) {
                        o.push(new Xu(t1.id, t1.bounds, t1.constantHeight));
                        continue;
                    }
                    for(; a !== l && n[a].id < t1.id;)a++;
                    if (a === l || n[a].id !== t1.id) continue;
                    const e = new Array, r = new Array, i = a;
                    for(; a !== l && n[a].id === t1.id;){
                        const t1 = n[a];
                        if (e.push({
                            position: t1.position,
                            height: t1.height,
                            extent: t1.extent
                        }), a !== i && n[a - 1].idx === t1.idx - 1) {
                            const t1 = a - i;
                            r.push({
                                a: t1 - 1,
                                b: t1
                            });
                        }
                        a++;
                    }
                    o.push(new Xu(t1.id, t1.bounds, void 0, e, r, s));
                }
                return o;
            }
            static getElevationFeature(t1, e) {
                if (!e) return;
                const r = +t1.properties[Eu];
                return Number.isNaN(r) ? void 0 : e.find((t1)=>t1.id === r);
            }
        }
        class Wu {
            constructor(t1, e){
                this.zScale = 1, this.xOffset = 0, this.yOffset = 0, t1.equals(e) || (this.zScale = Math.pow(2, e.z - t1.z), this.xOffset = (t1.x * this.zScale - e.x) * Cn, this.yOffset = (t1.y * this.zScale - e.y) * Cn);
            }
            constantElevation(t1, e) {
                if (null != t1.constantHeight) return this.computeBiasedHeight(t1.constantHeight, e);
            }
            pointElevation(t1, e, r) {
                const n = this.constantElevation(e, r);
                return null != n ? n : (t1.x = t1.x * this.zScale + this.xOffset, t1.y = t1.y * this.zScale + this.yOffset, this.computeBiasedHeight(e.pointElevation(t1), r));
            }
            computeBiasedHeight(t1, e) {
                return e <= 0 ? t1 : t1 + e * Tt(0, e, t1 >= 0 ? t1 : Math.abs(.5 * t1));
            }
        }
        qs(Xu, "ElevationFeature");
        class Yu {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.projection = t1.projection, this.layoutVertexArray = new ra, this.indexArray = new Aa, this.segments = new tl, this.programConfigurations = new kl(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.elevationMode = this.layers[0].layout.get("circle-elevation-reference"), this.hasElevation = !1, "none" !== this.elevationMode && (this.elevatedLayoutVertexArray = new sa), this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                const i = this.layers[0], s = [];
                let o = null;
                "circle" === i.type && (o = i.layout.get("circle-sort-key"));
                for (const { feature: e, id: i, index: a, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = gu(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), u, r)) continue;
                    const c = o ? o.evaluate(u, {}, r) : void 0, h = {
                        id: i,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: t1 ? u.geometry : yu(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                o && s.sort((t1, e)=>t1.sortKey - e.sortKey);
                let a = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new fa, a = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n, l = t1[s].feature;
                    this.addFeature(n, i, s, e.availableImages, r, a, e.brightness, e.elevationFeatures), e.featureIndex.insert(l, i, s, o, this.index);
                }
                this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            update(t1, e, r, n, i, s, o) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Ka.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, Qa.members)), this.elevatedLayoutVertexArray && (this.elevatedLayoutVertexBuffer = t1.createVertexBuffer(this.elevatedLayoutVertexArray, Ja.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy());
            }
            addFeature(t1, e, r, n, i, s, o, a) {
                let l;
                "none" !== this.elevationMode && (l = Zu.getElevationFeature(t1, a));
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= Cn || n < 0 || n >= Cn) continue;
                    if (s) {
                        const t1 = s.projectTilePoint(r, n, i), e = s.upVector(i, r, n);
                        this.addGlobeExtVertex(t1, e), this.addGlobeExtVertex(t1, e), this.addGlobeExtVertex(t1, e), this.addGlobeExtVertex(t1, e);
                    }
                    const o = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), a = o.vertexLength;
                    if (this.addCircleVertex(r, n, -1, -1), this.addCircleVertex(r, n, 1, -1), this.addCircleVertex(r, n, 1, 1), this.addCircleVertex(r, n, -1, 1), "none" !== this.elevationMode) {
                        const t1 = l ? l.pointElevation(new bt(r, n)) : 0;
                        this.hasElevation = this.hasElevation || 0 !== t1;
                        for(let e = 0; e < 4; e++)this.elevatedLayoutVertexArray.emplaceBack(t1);
                    }
                    this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 2, a + 3), o.vertexLength += 4, o.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n, i, o, void 0, this.worldview);
            }
            addCircleVertex(t1, e, r, n) {
                this.layoutVertexArray.emplaceBack(2 * t1 + (r + 1) / 2, 2 * e + (n + 1) / 2);
            }
            addGlobeExtVertex(t1, e) {
                const r = 16384;
                this.globeExtVertexArray.emplaceBack(t1.x, t1.y, t1.z, e[0] * r, e[1] * r, e[2] * r);
            }
        }
        function Ku(t1, e) {
            for(let r = 0; r < t1.length; r++)if (lc(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (lc(t1, e[r])) return !0;
            return !!ec(t1, e);
        }
        function Ju(t1, e, r) {
            return !!lc(t1, e) || !!sc(e, t1, r);
        }
        function Qu(t1, e) {
            if (1 === t1.length) return ac(e, t1[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (lc(t1, n[e])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (ac(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (ec(t1, e[r])) return !0;
            return !1;
        }
        function tc(t1, e, r) {
            if (t1.length > 1) {
                if (ec(t1, e)) return !0;
                for(let n = 0; n < e.length; n++)if (sc(e[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (sc(t1[n], e, r)) return !0;
            return !1;
        }
        function ec(t1, e) {
            if (0 === t1.length || 0 === e.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e.length - 1; t1++)if (rc(n, i, e[t1], e[t1 + 1])) return !0;
            }
            return !1;
        }
        function rc(t1, e, r, n) {
            return qt(t1, r, n) !== qt(e, r, n) && qt(t1, e, r) !== qt(t1, e, n);
        }
        function nc(t1, e, r) {
            return (t1.x - r.x) * (e.y - r.y) - (t1.y - r.y) * (e.x - r.x);
        }
        function ic(t1, e, r, n) {
            const i = nc(t1, e, n), s = nc(t1, e, r);
            if (Math.sign(i) === Math.sign(s)) return;
            const o = nc(r, n, t1), a = o + s - i;
            return Math.sign(o) !== Math.sign(a) ? [
                o / (o - a),
                s / (s - i)
            ] : void 0;
        }
        function sc(t1, e, r) {
            const n = r * r;
            if (1 === e.length) return t1.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (oc(t1, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function oc(t1, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t1.distSqr(e);
            const i = ((t1.x - e.x) * (r.x - e.x) + (t1.y - e.y) * (r.y - e.y)) / n;
            return t1.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function ac(t1, e) {
            let r, n, i, s = !1;
            for(let o = 0; o < t1.length; o++){
                r = t1[o];
                for(let t1 = 0, o = r.length - 1; t1 < r.length; o = t1++)n = r[t1], i = r[o], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function lc(t1, e) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const s = t1[n], o = t1[i];
                s.y > e.y != o.y > e.y && e.x < (o.x - s.x) * (e.y - s.y) / (o.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function uc(t1, e, r, n, i) {
            for (const s of t1)if (e <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
            const s = [
                new bt(e, r),
                new bt(e, i),
                new bt(n, i),
                new bt(n, r)
            ];
            if (t1.length > 2) {
                for (const e of s)if (lc(t1, e)) return !0;
            }
            for(let e = 0; e < t1.length - 1; e++)if (cc(t1[e], t1[e + 1], s)) return !0;
            return !1;
        }
        function cc(t1, e, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e.x < n.x || t1.x > i.x && e.x > i.x || t1.y < n.y && e.y < n.y || t1.y > i.y && e.y > i.y) return !1;
            const s = qt(t1, e, r[0]);
            return s !== qt(t1, e, r[1]) || s !== qt(t1, e, r[2]) || s !== qt(t1, e, r[3]);
        }
        function hc(t1, e, r, n, i, s) {
            let o = e.y - t1.y, a = t1.x - e.x;
            if (s = s || 0) {
                const t1 = o * o + a * a;
                if (0 === t1) return !0;
                const e = Math.sqrt(t1);
                o /= e, a /= e;
            }
            return !((r.x - t1.x) * o + (r.y - t1.y) * a - s < 0 || (n.x - t1.x) * o + (n.y - t1.y) * a - s < 0 || (i.x - t1.x) * o + (i.y - t1.y) * a - s < 0);
        }
        function pc(t1, e, r, n, i, s, o) {
            return !(hc(t1, e, n, i, s, o) || hc(e, r, n, i, s, o) || hc(r, t1, n, i, s, o) || hc(n, i, t1, e, r, o) || hc(i, s, t1, e, r, o) || hc(s, n, t1, e, r, o));
        }
        function fc(t1, e, r) {
            const n = e.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t1);
        }
        function dc(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function mc(t1, e, r, n, i) {
            if (!e[0] && !e[1]) return t1;
            const s = bt.convert(e)._mult(i);
            "viewport" === r && s._rotate(-n);
            const o = [];
            for(let e = 0; e < t1.length; e++)o.push(t1[e].sub(s));
            return o;
        }
        function yc(t1, e, r, n) {
            const i = bt.convert(t1)._mult(n);
            return "viewport" === e && i._rotate(-r), i;
        }
        let gc, xc;
        function vc(t1, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        qs(Yu, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        class bc {
            constructor(t1, e, r){
                this.z = t1, this.x = e, this.y = r, this.key = Ac(0, t1, t1, e, r);
            }
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e) {
                const r = function(t1, e, r) {
                    var n = vc(256 * t1, 256 * (e = Math.pow(2, r) - e - 1), r), i = vc(256 * (t1 + 1), 256 * (e + 1), r);
                    return n[0] + "," + n[1] + "," + i[0] + "," + i[1];
                }(this.x, this.y, this.z), n = function(t1, e, r) {
                    let n, i = "";
                    for(let s = t1; s > 0; s--)n = 1 << s - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class wc {
            constructor(t1, e){
                this.wrap = t1, this.canonical = e, this.key = Ac(t1, e.z, e.z, e.x, e.y);
            }
        }
        class _c {
            constructor(t1, e, r, n, i){
                this.overscaledZ = t1, this.wrap = e, this.canonical = new bc(r, +n, +i), this.key = 0 === e && t1 === r ? this.canonical.key : Ac(e, t1, r, n, i);
            }
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                const e = this.canonical.z - t1;
                return t1 > this.canonical.z ? new _c(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new _c(t1, this.wrap, t1, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t1, e = !0) {
                if (this.overscaledZ === t1 && e) return this.key;
                if (t1 > this.canonical.z) return Ac(this.wrap * +e, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - t1;
                    return Ac(this.wrap * +e, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.z < this.canonical.z && t1.canonical.x === this.canonical.x >> e && t1.canonical.y === this.canonical.y >> e;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new _c(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new _c(e, this.wrap, e, r, n),
                    new _c(e, this.wrap, e, r + 1, n),
                    new _c(e, this.wrap, e, r, n + 1),
                    new _c(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new _c(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new _c(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new wc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function Ac(t1, e, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let o = s * (i % s) + n % s;
            return t1 && r < 22 && (o += s * s * ((t1 < 0 ? -2 * t1 - 1 : 2 * t1) % (1 << 2 * (22 - r)))), 16 * (32 * o + r) + (e - r);
        }
        const Mc = [
            (t1)=>{
                let e = t1.canonical.x - 1, r = t1.wrap;
                return e < 0 && (e = (1 << t1.canonical.z) - 1, r--), new _c(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>{
                let e = t1.canonical.x + 1, r = t1.wrap;
                return e === 1 << t1.canonical.z && (e = 0, r++), new _c(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>new _c(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, (0 === t1.canonical.y ? 1 << t1.canonical.z : t1.canonical.y) - 1),
            (t1)=>new _c(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y === (1 << t1.canonical.z) - 1 ? 0 : t1.canonical.y + 1)
        ];
        qs(bc, "CanonicalTileID"), qs(_c, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const Ic = ta([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Sc } = Ic, zc = ta([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var kc = ta([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function Pc(t1) {
            return t1 * Cl / Gl;
        }
        const Ec = [
            new qu([
                Ul,
                Ul,
                Ul
            ], [
                Nl,
                Nl,
                Nl
            ]),
            new qu([
                Ul,
                Ul,
                Ul
            ], [
                0,
                0,
                Nl
            ]),
            new qu([
                0,
                Ul,
                Ul
            ], [
                Nl,
                0,
                Nl
            ]),
            new qu([
                Ul,
                0,
                Ul
            ], [
                0,
                Nl,
                Nl
            ]),
            new qu([
                0,
                0,
                Ul
            ], [
                Nl,
                Nl,
                Nl
            ])
        ];
        function Tc(t1, e, r, n = !0) {
            const i = P([], t1._camera.position, t1.worldSize), s = [
                e,
                r,
                1,
                1
            ];
            Z(s, s, t1.pixelMatrixInverse), H(s, s, 1 / s[3]);
            const o = C([], j([], s, i)), a = t1.globeMatrix, l = [
                a[12],
                a[13],
                a[14]
            ], u = j([], l, i), c = _(u), h = C([], u), p = t1.worldSize / (2 * Math.PI), f = F(h, o), d = Math.asin(p / c);
            if (d < Math.acos(f)) {
                if (!n) return null;
                const t1 = [], e = [];
                P(t1, o, c / f), C(e, j(e, t1, u)), C(o, M(o, u, P(o, e, Math.tan(d) * c)));
            }
            const m = [];
            new Ru(i, o).closestPointOnSphere(l, p, m);
            const y = C([], Kt(a, 0)), g = C([], Kt(a, 1)), x = C([], Kt(a, 2)), v = F(y, m), b = F(g, m), w = F(x, m), A = It(Math.asin(-b / p));
            let I = It(Math.atan2(v, w));
            I = t1.center.lng + function(t1, e) {
                const r = (e - t1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(t1.center.lng, I);
            const S = Kl(I), z = Et(Jl(A), 0, 1);
            return new lu(S, z);
        }
        class Bc {
            constructor(t1, e, r){
                this.a = j([], t1, r), this.b = j([], e, r), this.center = r;
                const n = C([], this.a), i = C([], this.b);
                this.angle = Math.acos(F(n, i));
            }
        }
        function Vc(t1, e) {
            if (0 === t1.angle) return null;
            let r;
            return r = 0 === t1.a[e] ? 1 / t1.angle * .5 * Math.PI : 1 / t1.angle * Math.atan(t1.b[e] / t1.a[e] / Math.sin(t1.angle) - 1 / Math.tan(t1.angle)), r < 0 || r > 1 ? null : function(t1, e, r, n) {
                const i = Math.sin(r);
                return t1 * (Math.sin((1 - n) * r) / i) + e * (Math.sin(n * r) / i);
            }(t1.a[e], t1.b[e], t1.angle, Et(r, 0, 1)) + t1.center[e];
        }
        function Cc(t1) {
            if (t1.z <= 1) return Ec[t1.z + 2 * t1.y + t1.x];
            const e = Oc(Rc(t1));
            return qu.fromPoints(e);
        }
        function Fc(t1, e, r) {
            return P(t1, t1, 1 - r), E(t1, t1, e, r);
        }
        function Dc(t1, e, r) {
            for (const n of t1)R(n, n, e), P(n, n, r);
        }
        function Lc(t1, e, r, n) {
            const i = e / t1.worldSize, s = t1.globeMatrix;
            if (r.z <= 1) {
                const t1 = Cc(r).getCorners();
                return Dc(t1, s, i), qu.fromPoints(t1);
            }
            const o = Rc(r, n), a = Oc(o, Cl + Pc(t1._tileCoverLift));
            Dc(a, s, i);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (o.contains(t1.center)) {
                for (const t1 of a)z(c, c, t1), k(u, u, t1);
                u[2] = 0;
                const e = t1.point, r = [
                    e.x * i,
                    e.y * i,
                    0
                ];
                return z(c, c, r), k(u, u, r), new qu(c, u);
            }
            if (t1._tileCoverLift > 0) {
                for (const t1 of a)z(c, c, t1), k(u, u, t1);
                return new qu(c, u);
            }
            const h = [
                s[12] * i,
                s[13] * i,
                s[14] * i
            ], p = o.getCenter(), f = Et(t1.center.lat, -85.051129, nu), d = Et(p.lat, -85.051129, nu), m = Kl(t1.center.lng), y = Jl(f);
            let g = m - Kl(p.lng);
            const x = y - Jl(d);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let v = 0;
            Math.abs(g) > Math.abs(x) ? v = g >= 0 ? 1 : 3 : (v = x >= 0 ? 0 : 2, E(h, h, [
                s[4] * i,
                s[5] * i,
                s[6] * i
            ], -Math.sin(Mt(x >= 0 ? o.getSouth() : o.getNorth())) * Cl));
            const b = a[v], w = a[(v + 1) % 4], _ = new Bc(b, w, h), A = [
                Vc(_, 0) || b[0],
                Vc(_, 1) || b[1],
                Vc(_, 2) || b[2]
            ], I = Zc(t1.zoom);
            if (I > 0) {
                const n = function({ x: t1, y: e, z: r }, n, i, s, o) {
                    const a = 1 / (1 << r);
                    let l = t1 * a, u = l + a, c = e * a, h = c + a, p = 0;
                    const f = (l + u) / 2 - s;
                    return f > .5 ? p = -1 : f < -0.5 && (p = 1), l = ((l + p) * n - (s *= n)) * i + s, u = ((u + p) * n - s) * i + s, c = (c * n - (o *= n)) * i + o, h = (h * n - o) * i + o, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, e, t1._pixelsPerMercatorPixel, m, y);
                for(let t1 = 0; t1 < a.length; t1++)Fc(a[t1], n[t1], I);
                const i = M([], n[v], n[(v + 1) % 4]);
                P(i, i, .5), Fc(A, i, I);
            }
            for (const t1 of a)z(c, c, t1), k(u, u, t1);
            return c[2] = Math.min(b[2], w[2]), z(c, c, A), k(u, u, A), new qu(c, u);
        }
        function Rc({ x: t1, y: e, z: r }, n = !1) {
            const i = 1 / (1 << r), s = new Hl(tu(t1 * i), e === (1 << r) - 1 && n ? -90 : eu((e + 1) * i)), o = new Hl(tu((t1 + 1) * i), 0 === e && n ? 90 : eu(e * i));
            return new Xl(s, o);
        }
        function Oc(t1, e = Cl) {
            const r = Mt(t1.getNorth()), n = Mt(t1.getSouth()), i = Math.cos(r), s = Math.cos(n), o = Math.sin(r), a = Math.sin(n), l = t1.getWest(), u = t1.getEast();
            return [
                jl(s, a, l, e),
                jl(s, a, u, e),
                jl(i, o, u, e),
                jl(i, o, l, e)
            ];
        }
        function Uc(t1, e, r, n) {
            const i = 1 << r.z, s = (t1 / Cn + r.x) / i;
            return $l(eu((e / Cn + r.y) / i), tu(s), n);
        }
        function Nc({ min: t1, max: e }) {
            return Ll / Math.max(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
        }
        const jc = new Float64Array(16);
        function $c(t1) {
            const e = Nc(t1), r = y(jc, [
                e,
                e,
                e
            ]);
            return h(r, r, V([], t1.min));
        }
        function Gc(t1) {
            const e = (n = t1.min, (r = jc)[0] = 1, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = 1, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 1, r[11] = 0, r[12] = n[0], r[13] = n[1], r[14] = n[2], r[15] = 1, r);
            var r, n;
            const i = 1 / Nc(t1);
            return p(e, e, [
                i,
                i,
                i
            ]);
        }
        function qc(t1) {
            const e = Cn / (2 * Math.PI);
            return t1 / (2 * Math.PI) / e;
        }
        function Hc(t1, e) {
            return Cn / (512 * Math.pow(2, t1)) * Nc(Cc(e));
        }
        function Xc(t1, e, r, n, i) {
            const s = qc(r), o = [
                t1,
                e,
                -r / (2 * Math.PI)
            ], a = l(new Float64Array(16));
            return h(a, a, o), p(a, a, [
                s,
                s,
                s
            ]), f(a, a, Mt(-i)), d(a, a, Mt(-n)), a;
        }
        function Zc(t1) {
            return Tt(Fl, Dl, t1);
        }
        function Wc(t1, e) {
            const r = $l(e.lat, e.lng), n = function(t1) {
                const e = $l(t1._center.lat, t1._center.lng);
                let r = D([], A(0, 1, 0), e);
                const n = g([], -t1.angle, e);
                r = R(r, r, n), g(n, -t1._pitch, r);
                const i = C([], e);
                return P(i, i, Pc(t1.cameraToCenterDistance / t1.pixelsPerMeter)), R(i, i, n), M([], e, i);
            }(t1);
            var i, s, o, a, l, u, c, h, p, f;
            return o = (i = I([], n, r))[0], a = i[1], l = i[2], u = (s = r)[0], c = s[1], h = s[2], f = (p = Math.sqrt(o * o + a * a + l * l) * Math.sqrt(u * u + c * c + h * h)) && F(i, s) / p, Math.acos(Math.min(Math.max(f, -1), 1));
        }
        function Yc(t1, e) {
            return Wc(t1, e) > Math.PI / 2 * 1.01;
        }
        const Kc = Mt(85), Jc = Math.cos(Kc), Qc = Math.sin(Kc), th = a(), eh = (t1)=>{
            const e = [];
            return "map" === t1.paint.get("circle-pitch-alignment") && e.push("PITCH_WITH_MAP"), "map" === t1.paint.get("circle-pitch-scale") && e.push("SCALE_WITH_MAP"), e;
        };
        function rh(t1, e, r, n, i, s, o, a, l) {
            if (s && t1.queryGeometry.isAboveHorizon) return !1;
            s && (l *= t1.pixelToTileUnitsFactor);
            const u = t1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of e)for (const e of h){
                const h = e.add(a), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, f = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const t1 = r.projection.upVector(u, h.x, h.y);
                    f.x += t1[0] * c * p, f.y += t1[1] * c * p, f.z += t1[2] * c * p;
                }
                const d = s ? h : nh(f.x, f.y, f.z, n), m = s ? t1.tilespaceRays.map((t1)=>oh(t1, p)) : t1.queryGeometry.screenGeometry, y = Z([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!o && s ? l *= y[3] / r.cameraToCenterDistance : o && !s && (l *= r.cameraToCenterDistance / y[3]), s) {
                    const t1 = eu((e.y / Cn + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(t1, 1) / Ql(1, t1);
                }
                if (Ju(m, d, l)) return !0;
            }
            return !1;
        }
        function nh(t1, e, r, n) {
            const i = Z([], [
                t1,
                e,
                r,
                1
            ], n);
            return new bt(i[0] / i[3], i[1] / i[3]);
        }
        const ih = A(0, 0, 0), sh = A(0, 0, 1);
        function oh(t1, e) {
            const r = b();
            return ih[2] = e, t1.intersectsPlane(ih, sh, r), new bt(r[0], r[1]);
        }
        class ah extends Yu {
        }
        let lh, uh, ch, hh;
        function ph(t1, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(e * r * n);
            return t1.width = e, t1.height = r, t1.data = i, t1;
        }
        function fh(t1, e, r) {
            const { width: n, height: i } = e;
            n === t1.width && i === t1.height || (dh(t1, e, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, n),
                height: Math.min(t1.height, i)
            }, r, null), t1.width = n, t1.height = i, t1.data = e.data);
        }
        function dh(t1, e, r, n, i, s, o, a) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = t1.data, u = e.data, c = 4 === s && a;
            for(let a = 0; a < i.height; a++){
                const h = ((r.y + a) * t1.width + r.x) * s, p = ((n.y + a) * e.width + n.x) * s;
                if (c) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * s + 3, r = p + t1 * s;
                    u[r + 0] = 255, u[r + 1] = 255, u[r + 2] = 255, u[r + 3] = l[e];
                }
                else if (o) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * s, r = p + t1 * s, n = new sr(l[e + 0] / 255, l[e + 1] / 255, l[e + 2] / 255, l[e + 3]).toNonPremultipliedRenderColor(o).toArray();
                    u[r + 0] = n[0], u[r + 1] = n[1], u[r + 2] = n[2], u[r + 3] = n[3];
                }
                else for(let t1 = 0; t1 < i.width * s; t1++)u[p + t1] = l[h + t1];
            }
            return e;
        }
        qs(ah, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class mh {
            constructor(t1, e){
                ph(this, t1, 1, e);
            }
            resize(t1) {
                fh(this, new mh(t1), 1);
            }
            clone() {
                return new mh({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i) {
                dh(t1, e, r, n, i, 1, null);
            }
        }
        class yh {
            constructor(t1, e){
                ph(this, t1, 4, e);
            }
            resize(t1) {
                fh(this, new yh(t1), 4);
            }
            replace(t1, e) {
                e ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new yh({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i, s, o) {
                dh(t1, e, r, n, i, 4, s, o);
            }
        }
        class gh {
            constructor(t1, e){
                this.width = t1.width, this.height = t1.height, this.data = e instanceof Uint8Array ? new Float32Array(e.buffer) : e;
            }
        }
        function xh(t1) {
            const e = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new yh({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                e[t1.evaluationKey] = s;
                const o = t1.expression.evaluate(e), a = o ? o.toNonPremultipliedRenderColor(null) : null;
                a && (i.data[r + n + 0] = Math.floor(255 * a.r), i.data[r + n + 1] = Math.floor(255 * a.g), i.data[r + n + 2] = Math.floor(255 * a.b), i.data[r + n + 3] = Math.floor(255 * a.a));
            };
            if (t1.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, o = 0; n < r; n++, o += 4){
                const a = n / (r - 1), { start: l, end: u } = t1.clips[e];
                s(i, o, l * (1 - a) + u * a);
            }
            else for(let t1 = 0, e = 0; t1 < r; t1++, e += 4)s(0, e, t1 / (r - 1));
            return i;
        }
        qs(mh, "AlphaImage"), qs(yh, "RGBAImage");
        const vh = ta([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), bh = ta([
            {
                name: "a_road_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), wh = ta([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_height",
                components: 1,
                type: "Float32"
            }
        ], 4), _h = ta([
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ], 4);
        function Ah(t1, e, r = 2) {
            const n = e && e.length, i = n ? e[0] * r : t1.length;
            let s = Mh(t1, 0, i, r, !0);
            const o = [];
            if (!s || s.next === s.prev) return o;
            let a, l, u;
            if (n && (s = function(t1, e, r, n) {
                const i = [];
                for(let r = 0, s = e.length; r < s; r++){
                    const o = Mh(t1, e[r] * n, r < s - 1 ? e[r + 1] * n : t1.length, n, !1);
                    o === o.next && (o.steiner = !0), i.push(Fh(o));
                }
                i.sort(Th);
                for(let t1 = 0; t1 < i.length; t1++)r = Bh(i[t1], r);
                return r;
            }(t1, e, s, r)), t1.length > 80 * r) {
                a = 1 / 0, l = 1 / 0;
                let e = -1 / 0, n = -1 / 0;
                for(let s = r; s < i; s += r){
                    const r = t1[s], i = t1[s + 1];
                    r < a && (a = r), i < l && (l = i), r > e && (e = r), i > n && (n = i);
                }
                u = Math.max(e - a, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return Sh(s, o, r, a, l, u, 0), o;
        }
        function Mh(t1, e, r, n, i) {
            let s;
            if (i === function(t1, e, r, n) {
                let i = 0;
                for(let s = e, o = r - n; s < r; s += n)i += (t1[o] - t1[s]) * (t1[s + 1] + t1[o + 1]), o = s;
                return i;
            }(t1, e, r, n) > 0) for(let i = e; i < r; i += n)s = Hh(i / n | 0, t1[i], t1[i + 1], s);
            else for(let i = r - n; i >= e; i -= n)s = Hh(i / n | 0, t1[i], t1[i + 1], s);
            return s && Uh(s, s.next) && (Xh(s), s = s.next), s;
        }
        function Ih(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let r, n = t1;
            do if (r = !1, n.steiner || !Uh(n, n.next) && 0 !== Oh(n.prev, n, n.next)) n = n.next;
            else {
                if (Xh(n), n = e = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function Sh(t1, e, r, n, i, s, o) {
            if (!t1) return;
            !o && s && function(t1, e, r, n) {
                let i = t1;
                do 0 === i.z && (i.z = Ch(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t1);
                i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                    let e, r = 1;
                    do {
                        let n, i = t1;
                        t1 = null;
                        let s = null;
                        for(e = 0; i;){
                            e++;
                            let o = i, a = 0;
                            for(let t1 = 0; t1 < r && (a++, o = o.nextZ, o); t1++);
                            let l = r;
                            for(; a > 0 || l > 0 && o;)0 !== a && (0 === l || !o || i.z <= o.z) ? (n = i, i = i.nextZ, a--) : (n = o, o = o.nextZ, l--), s ? s.nextZ = n : t1 = n, n.prevZ = s, s = n;
                            i = o;
                        }
                        s.nextZ = null, r *= 2;
                    }while (e > 1);
                }(i);
            }(t1, n, i, s);
            let a = t1;
            for(; t1.prev !== t1.next;){
                const l = t1.prev, u = t1.next;
                if (s ? kh(t1, n, i, s) : zh(t1)) e.push(l.i, t1.i, u.i), Xh(t1), t1 = u.next, a = u.next;
                else if ((t1 = u) === a) {
                    o ? 1 === o ? Sh(t1 = Ph(Ih(t1), e), e, r, n, i, s, 2) : 2 === o && Eh(t1, e, r, n, i, s) : Sh(Ih(t1), e, r, n, i, s, 1);
                    break;
                }
            }
        }
        function zh(t1) {
            const e = t1.prev, r = t1, n = t1.next;
            if (Oh(e, r, n) >= 0) return !1;
            const i = e.x, s = r.x, o = n.x, a = e.y, l = r.y, u = n.y, c = Math.min(i, s, o), h = Math.min(a, l, u), p = Math.max(i, s, o), f = Math.max(a, l, u);
            let d = n.next;
            for(; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Lh(i, a, s, l, o, u, d.x, d.y) && Oh(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function kh(t1, e, r, n) {
            const i = t1.prev, s = t1, o = t1.next;
            if (Oh(i, s, o) >= 0) return !1;
            const a = i.x, l = s.x, u = o.x, c = i.y, h = s.y, p = o.y, f = Math.min(a, l, u), d = Math.min(c, h, p), m = Math.max(a, l, u), y = Math.max(c, h, p), g = Ch(f, d, e, r, n), x = Ch(m, y, e, r, n);
            let v = t1.prevZ, b = t1.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== o && Lh(a, c, l, h, u, p, v.x, v.y) && Oh(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== o && Lh(a, c, l, h, u, p, b.x, b.y) && Oh(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== o && Lh(a, c, l, h, u, p, v.x, v.y) && Oh(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== o && Lh(a, c, l, h, u, p, b.x, b.y) && Oh(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Ph(t1, e) {
            let r = t1;
            do {
                const n = r.prev, i = r.next.next;
                !Uh(n, i) && Nh(n, r, r.next, i) && Gh(n, i) && Gh(i, n) && (e.push(n.i, r.i, i.i), Xh(r), Xh(r.next), r = t1 = i), r = r.next;
            }while (r !== t1);
            return Ih(r);
        }
        function Eh(t1, e, r, n, i, s) {
            let o = t1;
            do {
                let t1 = o.next.next;
                for(; t1 !== o.prev;){
                    if (o.i !== t1.i && Rh(o, t1)) {
                        let a = qh(o, t1);
                        return o = Ih(o, o.next), a = Ih(a, a.next), Sh(o, e, r, n, i, s, 0), void Sh(a, e, r, n, i, s, 0);
                    }
                    t1 = t1.next;
                }
                o = o.next;
            }while (o !== t1);
        }
        function Th(t1, e) {
            let r = t1.x - e.x;
            return 0 === r && (r = t1.y - e.y, 0 === r) && (r = (t1.next.y - t1.y) / (t1.next.x - t1.x) - (e.next.y - e.y) / (e.next.x - e.x)), r;
        }
        function Bh(t1, e) {
            const r = function(t1, e) {
                let r = e;
                const n = t1.x, i = t1.y;
                let s, o = -1 / 0;
                if (Uh(t1, r)) return r;
                do {
                    if (Uh(t1, r.next)) return r.next;
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const t1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (t1 <= n && t1 > o && (o = t1, s = r.x < r.next.x ? r : r.next, t1 === n)) return s;
                    }
                    r = r.next;
                }while (r !== e);
                if (!s) return null;
                const a = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && Dh(i < u ? n : o, i, l, u, i < u ? o : n, i, r.x, r.y)) {
                        const e = Math.abs(i - r.y) / (n - r.x);
                        Gh(r, t1) && (e < c || e === c && (r.x > s.x || r.x === s.x && Vh(s, r))) && (s = r, c = e);
                    }
                    r = r.next;
                }while (r !== a);
                return s;
            }(t1, e);
            if (!r) return e;
            const n = qh(r, t1);
            return Ih(n, n.next), Ih(r, r.next);
        }
        function Vh(t1, e) {
            return Oh(t1.prev, t1, e.prev) < 0 && Oh(e.next, t1, t1.next) < 0;
        }
        function Ch(t1, e, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function Fh(t1) {
            let e = t1, r = t1;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t1);
            return r;
        }
        function Dh(t1, e, r, n, i, s, o, a) {
            return (i - o) * (e - a) >= (t1 - o) * (s - a) && (t1 - o) * (n - a) >= (r - o) * (e - a) && (r - o) * (s - a) >= (i - o) * (n - a);
        }
        function Lh(t1, e, r, n, i, s, o, a) {
            return !(t1 === o && e === a) && Dh(t1, e, r, n, i, s, o, a);
        }
        function Rh(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e.i && r.next.i !== e.i && Nh(r, r.next, t1, e)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e) && (Gh(t1, e) && Gh(e, t1) && function(t1, e) {
                let r = t1, n = !1;
                const i = (t1.x + e.x) / 2, s = (t1.y + e.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e) && (Oh(t1.prev, t1, e.prev) || Oh(t1, e.prev, e)) || Uh(t1, e) && Oh(t1.prev, t1, t1.next) > 0 && Oh(e.prev, e, e.next) > 0);
        }
        function Oh(t1, e, r) {
            return (e.y - t1.y) * (r.x - e.x) - (e.x - t1.x) * (r.y - e.y);
        }
        function Uh(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function Nh(t1, e, r, n) {
            const i = $h(Oh(t1, e, r)), s = $h(Oh(t1, e, n)), o = $h(Oh(r, n, t1)), a = $h(Oh(r, n, e));
            return i !== s && o !== a || !(0 !== i || !jh(t1, r, e)) || !(0 !== s || !jh(t1, n, e)) || !(0 !== o || !jh(r, t1, n)) || !(0 !== a || !jh(r, e, n));
        }
        function jh(t1, e, r) {
            return e.x <= Math.max(t1.x, r.x) && e.x >= Math.min(t1.x, r.x) && e.y <= Math.max(t1.y, r.y) && e.y >= Math.min(t1.y, r.y);
        }
        function $h(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function Gh(t1, e) {
            return Oh(t1.prev, t1, t1.next) < 0 ? Oh(t1, e, t1.next) >= 0 && Oh(t1, t1.prev, e) >= 0 : Oh(t1, e, t1.prev) < 0 || Oh(t1, t1.next, e) < 0;
        }
        function qh(t1, e) {
            const r = Zh(t1.i, t1.x, t1.y), n = Zh(e.i, e.x, e.y), i = t1.next, s = e.prev;
            return t1.next = e, e.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function Hh(t1, e, r, n) {
            const i = Zh(t1, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function Xh(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Zh(t1, e, r) {
            return {
                i: t1,
                x: e,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function Wh(t1, e) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, s;
            for(let e = 0; e < r; e++){
                const r = Ht(t1[e]);
                0 !== r && (t1[e].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    t1[e]
                ]) : i.push(t1[e]));
            }
            if (i && n.push(i), e > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e || (en(n[t1], e, 1, n[t1].length - 1, Yh), n[t1] = n[t1].slice(0, e));
            return n;
        }
        function Yh(t1, e) {
            return e.area - t1.area;
        }
        function Kh(t1, e, r = 1) {
            if (!t1) return null;
            const n = "string" == typeof t1 ? Dr.from(t1).getPrimary() : t1.getPrimary(), i = "string" == typeof t1 ? null : t1.getSecondary();
            for (const t1 of [
                n,
                i
            ]){
                if (!t1) continue;
                const n = t1.id.toString();
                e.has(n) || e.set(n, []), t1.scaleSelf(r), e.get(n).push(t1);
            }
            return {
                primary: n.toString(),
                secondary: i ? i.toString() : null
            };
        }
        function Jh(t1, e, r, n) {
            const i = n.patternDependencies;
            let s = !1;
            for (const n of e){
                const e = n.paint.get(`${t1}-pattern`);
                e.isConstant() || (s = !0), Kh(e.constantOr(null), i, r) && (s = !0);
            }
            return s;
        }
        function Qh(t1, e, r, n, i, s) {
            const o = s.patternDependencies;
            for (const a of e){
                const e = a.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t1 = e.evaluate({
                        zoom: n
                    }, r, {}, s.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1;
                    const l = Kh(t1, o, i);
                    if (!l) continue;
                    const { primary: u, secondary: c } = l;
                    u && (r.patterns[a.id] = [
                        u,
                        c
                    ].filter(Boolean));
                }
            }
            return r;
        }
        class tp {
            constructor(){
                this.polygons = new Map;
            }
            add(t1, ...e) {
                this.polygons.has(t1) ? this.polygons.get(t1).push(...e) : this.polygons.set(t1, e);
            }
            merge(t1) {
                for (const [e, r] of t1.polygons)this.add(e, ...r);
            }
        }
        class ep {
            constructor(){
                this.portals = [];
            }
            static evaluate(t1) {
                if (0 === t1.length) return new ep;
                let e = [];
                for (const r of t1)e.push(...r.portals);
                if (0 === e.length) return new ep;
                const r = (t1, e)=>t1 <= 0 && e <= 0 || t1 >= Cn && e >= Cn;
                for (const t1 of e){
                    const e = t1.va, n = t1.vb;
                    (r(e.x, n.x) || r(e.y, n.y)) && (t1.type = "border");
                }
                const n = e.filter((t1)=>"unevaluated" !== t1.type), i = e.filter((t1)=>"unevaluated" === t1.type);
                if (0 === i.length) return new ep;
                i.sort((t1, e)=>t1.hash === e.hash ? t1.isTunnel === e.isTunnel ? 0 : t1.isTunnel ? -1 : 1 : t1.hash < e.hash ? 1 : -1), e = n.concat(i);
                let s = n.length, o = s, a = s;
                do if (o++, o === e.length || e[s].hash !== e[o].hash) {
                    if (o - s == 2) {
                        a < s && (e[a] = e[s], e[s] = null);
                        const t1 = e[a], r = e[o - 1];
                        t1.type = t1.isTunnel !== r.isTunnel ? "tunnel" : "polygon", t1.connection = {
                            a: t1.connection.a,
                            b: r.connection.a
                        }, a++;
                    }
                    s = o;
                }
                while (s !== e.length);
                return e.splice(a), e.sort((t1, e)=>t1.hash < e.hash ? 1 : -1), {
                    portals: e
                };
            }
        }
        qs(ep, "ElevationPortalGraph"), qs(tp, "ElevationPolygons");
        class rp {
            constructor(t1, e, r){
                this.outPositions = t1, this.outNormals = e, this.outIndices = r, this.vertexLookup = new Map, this.buffer = new ArrayBuffer(4), this.view = new DataView(this.buffer);
            }
            addVertex(t1, e, r) {
                let n = t1[2];
                null != r && (n *= r);
                const i = this.getVec3Bits(t1) << 96n | this.getVec3Bits(e), s = this.vertexLookup.get(i);
                if (null != s) return s;
                const o = this.outPositions.length;
                this.vertexLookup.set(i, o);
                const a = Math.trunc(16384 * e[0]), l = Math.trunc(16384 * e[1]), u = Math.trunc(16384 * e[2]);
                return this.outPositions.emplaceBack(t1[0], t1[1], n), this.outNormals.emplaceBack(a, l, u), o;
            }
            addVertices(t1, e, ...r) {
                const n = [];
                for (const i of r){
                    const r = this.addVertex(i, t1, e);
                    n.push(r);
                }
                return n;
            }
            addTriangles(t1, e, r) {
                if (e && r) {
                    const n = 1 === r.length, i = A(0, 0, 0);
                    for(let s = 0; s < t1.length; s += 3){
                        const o = e[t1[s + 0]], a = e[t1[s + 1]], l = e[t1[s + 2]], u = n ? r[0] : r[t1[s + 1]], c = n ? r[0] : r[t1[s + 2]], h = this.addVertex(A(o.x, o.y, n ? r[0] : r[t1[s + 0]]), i), p = this.addVertex(A(a.x, a.y, u), i), f = this.addVertex(A(l.x, l.y, c), i);
                        this.outIndices.emplaceBack(h, p, f);
                    }
                } else for(let e = 0; e < t1.length; e += 3)this.outIndices.emplaceBack(t1[e + 0], t1[e + 1], t1[e + 2]);
            }
            addQuad(t1, e) {
                const r = this.addVertices(e, void 0, ...t1.map((t1)=>A(t1.coord.x, t1.coord.y, t1.height))), [n, i, s, o] = r;
                this.addTriangles([
                    n,
                    i,
                    s,
                    s,
                    o,
                    n
                ]);
            }
            getVertexCount() {
                return this.outPositions.length;
            }
            clearVertexLookup() {
                this.vertexLookup.clear();
            }
            getBits(t1) {
                return this.view.setFloat32(0, t1), BigInt(this.view.getUint32(0));
            }
            getVec3Bits(t1) {
                return this.getBits(t1[0]) << 64n | this.getBits(t1[1]) << 32n | this.getBits(t1[2]);
            }
        }
        class np {
            constructor(t1, e, r, n){
                this.unevaluatedPortals = new ep, this.portalPolygons = new tp, this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = new Map, this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new oa, this.vertexNormals = new aa, this.indexArray = new Aa, this.tileToMeters = au(t1), this.bridgeProgramConfigurations = new kl(e, {
                    zoom: r,
                    lut: n
                }, (t1)=>"fill-tunnel-structure-color" !== t1), this.tunnelProgramConfigurations = new kl(e, {
                    zoom: r,
                    lut: n
                }, (t1)=>"fill-bridge-guard-rail-color" !== t1);
            }
            addVertices(t1, e) {
                const r = this.unevalVertices.length;
                for(let r = 0; r < t1.length; r++)this.unevalVertices.push(t1[r]), this.unevalHeights.push(e[r]);
                return r;
            }
            addTriangles(t1, e, r) {
                const n = r ? this.unevalTunnelTriangles : this.unevalTriangles;
                for (const r of t1)n.push(r + e);
            }
            addRenderableRing(t1, e, r, n, i, s) {
                const o = [
                    new bt(i.min.x, i.min.y),
                    new bt(i.max.x, i.min.y),
                    new bt(i.max.x, i.max.y),
                    new bt(i.min.x, i.max.y)
                ];
                for(let a = 0; a < r - 1; a++){
                    const r = e + a, l = r + 1, u = this.unevalVertices[r], c = this.unevalVertices[l];
                    if (!(u.x >= i.min.x && u.x <= i.max.x && u.y >= i.min.y && u.y <= i.max.y || c.x >= i.min.x && c.x <= i.max.x && c.y >= i.min.y && c.y <= i.max.y || cc(u, c, o))) continue;
                    if (this.isOnBorder(u.x, c.x) || this.isOnBorder(u.y, c.y)) continue;
                    const h = np.computeEdgeHash(this.unevalVertices[r], this.unevalVertices[l]);
                    let p, f = this.vertexHashLookup.get(np.computePosHash(u));
                    null != f ? p = f.next : (f = this.vertexHashLookup.get(np.computePosHash(c)), p = null != f ? f.prev : h), this.unevalEdges.push({
                        polygonIdx: t1,
                        a: r,
                        b: l,
                        hash: h,
                        portalHash: p,
                        isTunnel: n,
                        type: "unevaluated",
                        featureInfo: s
                    });
                }
            }
            addPortalCandidates(t1, e, r, n, i) {
                if (0 === e.length) return;
                this.portalPolygons.add(t1, {
                    geometry: e,
                    zLevel: i
                });
                const s = e[0];
                this.vertexHashLookup.clear();
                let o = np.computeEdgeHash(s[s.length - 2], s[s.length - 1]);
                for(let e = 0; e < s.length - 1; e++){
                    const i = s[e + 0], a = s[e + 1], l = at(a.x - i.x, a.y - i.y), u = ht(l);
                    if (0 === u) continue;
                    let c = "unevaluated";
                    const h = n.pointElevation(i), p = n.pointElevation(a);
                    Math.abs(h) < .01 && Math.abs(p) < .01 ? c = "entrance" : (this.isOnBorder(i.x, a.x) || this.isOnBorder(i.y, a.y)) && (c = "border");
                    const f = np.computeEdgeHash(i, a);
                    this.unevaluatedPortals.portals.push({
                        connection: {
                            a: t1,
                            b: void 0
                        },
                        va: i,
                        vb: a,
                        vab: l,
                        length: u,
                        hash: f,
                        isTunnel: r,
                        type: c
                    });
                    const d = np.computePosHash(i);
                    this.vertexHashLookup.set(d, {
                        prev: o,
                        next: f
                    }), o = f;
                }
            }
            construct(t1) {
                if (0 === this.unevalVertices.length) return;
                const e = ()=>({
                        vertexOffset: 0,
                        primitiveOffset: this.indexArray.length
                    }), r = (t1)=>{
                    t1.primitiveLength = this.indexArray.length - t1.primitiveOffset;
                }, n = new rp(this.vertexPositions, this.vertexNormals, this.indexArray);
                this.prepareEdges(t1.portals, this.unevalEdges);
                const i = e(), s = e(), o = e(), a = (t1, e)=>{
                    t1.sort((t1, r)=>t1.type === e && r.type !== e ? -1 : t1.type !== e && r.type === e ? 1 : 0);
                    const r = t1.findIndex((t1)=>t1.type !== e);
                    return r >= 0 ? r : t1.length;
                };
                let l = 0;
                this.unevalEdges.length > 0 && (l = a(this.unevalEdges, "none"), this.constructBridgeStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                    min: 0,
                    max: l
                }, this.tileToMeters)), r(o);
                const u = e(), c = e();
                if (this.unevalEdges.length > 0) {
                    const t1 = this.unevalEdges.splice(l), e = a(t1, "tunnel") + l;
                    this.unevalEdges.push(...t1), this.constructTunnelStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                        min: 0,
                        max: l
                    }, {
                        min: l,
                        max: e
                    });
                }
                r(u), n.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), r(c), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), r(s), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, [
                    -0.1
                ]), r(i), this.maskSegments = tl.simpleSegment(0, c.primitiveOffset, 0, c.primitiveLength), this.depthSegments = tl.simpleSegment(0, s.primitiveOffset, 0, s.primitiveLength), this.renderableBridgeSegments = tl.simpleSegment(0, o.primitiveOffset, 0, o.primitiveLength), this.renderableTunnelSegments = tl.simpleSegment(0, u.primitiveOffset, 0, u.primitiveLength), this.shadowCasterSegments = tl.simpleSegment(0, i.primitiveOffset, 0, i.primitiveLength);
            }
            update(t1, e, r, n, i, s, o, a) {
                this.bridgeProgramConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, a), this.tunnelProgramConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, a);
            }
            upload(t1) {
                this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = t1.createVertexBuffer(this.vertexPositions, wh.members), this.vertexBufferNormal = t1.createVertexBuffer(this.vertexNormals, _h.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(t1), this.tunnelProgramConfigurations.upload(t1));
            }
            destroy() {
                this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(t1, e, r, n, i) {
                const s = (s, o)=>{
                    for(let a = 0; a < o.length - 1; a++){
                        const l = o[a].featureIndex, u = o[a + 1].vertexStart, c = t1.feature(l);
                        s.populatePaintArrays(u, c, l, {}, r, e, n, void 0, i);
                    }
                };
                s(this.bridgeProgramConfigurations, this.bridgeFeatureSections), s(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(t1, e, r, n, i) {
                const s = new Map;
                for(let o = n; o < i; o++){
                    const n = r[o], i = n.a, a = n.b, l = np.computePosHash(t1[i]), u = np.computePosHash(t1[a]);
                    s.has(l) || s.set(l, {}), s.has(u) || s.set(u, {});
                    const c = s.get(l), h = s.get(u);
                    e[i] <= 0 && e[a] <= 0 || (c.to = a, h.from = i);
                }
                return s;
            }
            constructBridgeStructures(t1, e, r, n, i, s) {
                t1.clearVertexLookup();
                const o = this.computeVertexConnections(e, r, n, i.min, i.max), a = 1 / s, l = .5 * a, u = (t1)=>A(e[t1].x, e[t1].y, r[t1] * a), c = (t1)=>{
                    const r = o.get(np.computePosHash(e[t1])), n = r.from, i = r.to;
                    if (!n || !i) return;
                    const s = u(n), a = u(t1), l = u(i), c = A(0, 0, 0);
                    if (!N(s, a)) {
                        const t1 = j(b(), a, s);
                        M(c, c, C(t1, t1));
                    }
                    if (!N(l, a)) {
                        const t1 = j(b(), l, a);
                        M(c, c, C(t1, t1));
                    }
                    const h = G(c);
                    return h > 0 ? P(c, c, 1 / h) : void 0;
                };
                let h = Number.POSITIVE_INFINITY;
                this.sortSubarray(n, i.min, i.max, (t1, e)=>t1.featureInfo.featureIndex - e.featureInfo.featureIndex);
                for(let o = i.min; o < i.max; o++){
                    const i = n[o];
                    if (!i.featureInfo.guardRailEnabled) continue;
                    const u = this.prepareEdgePoints(e, r, i, (t1, e)=>t1 > e);
                    if (null == u) continue;
                    const p = u[0], f = u[1], d = A(p.coord.x, p.coord.y, a * p.height), m = A(f.coord.x, f.coord.y, a * f.height);
                    if (N(d, m)) continue;
                    const y = j(b(), m, d);
                    C(y, y);
                    const g = (t1)=>C(t1, t1), x = c(i.a) || y, v = c(i.b) || y, w = g(A(x[1], -x[0], 0)), _ = g(A(v[1], -v[0], 0)), I = g(D(b(), w, x)), S = g(D(b(), _, v)), z = b(), k = [
                        M(b(), d, P(z, j(z, w, I), l)),
                        M(b(), d, P(z, M(z, w, I), l)),
                        M(b(), d, P(z, I, l)),
                        d
                    ], E = [
                        M(b(), m, P(z, j(z, _, S), l)),
                        M(b(), m, P(z, M(z, _, S), l)),
                        M(b(), m, P(z, S, l)),
                        m
                    ];
                    h = this.addFeatureSection(i.featureInfo.featureIndex, h, this.bridgeFeatureSections, t1);
                    const [T, B] = t1.addVertices(w, s, k[0], k[1]), [F, L] = t1.addVertices(_, s, E[0], E[1]);
                    t1.addTriangles([
                        T,
                        B,
                        F,
                        B,
                        L,
                        F
                    ]);
                    const [R, O] = t1.addVertices(I, s, k[1], k[2]), [U, $] = t1.addVertices(S, s, E[1], E[2]);
                    t1.addTriangles([
                        R,
                        O,
                        U,
                        O,
                        $,
                        U
                    ]);
                    const [G, q] = t1.addVertices(V(w, w), s, k[2], k[3]), [H, X] = t1.addVertices(V(_, _), s, E[2], E[3]);
                    t1.addTriangles([
                        G,
                        q,
                        H,
                        q,
                        X,
                        H
                    ]);
                }
                this.bridgeFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: t1.getVertexCount()
                });
            }
            constructTunnelStructures(t1, e, r, n, i, s) {
                t1.clearVertexLookup();
                let o = Number.POSITIVE_INFINITY;
                const a = (t1, e)=>t1.featureInfo.featureIndex - e.featureInfo.featureIndex;
                this.sortSubarray(n, i.min, i.max, a), this.sortSubarray(n, s.min, s.max, a);
                const l = (t1)=>C(t1, t1);
                for(let s = i.min; s < i.max; s++){
                    const i = this.prepareEdgePoints(e, r, n[s], (t1, e)=>t1 < e);
                    if (null == i) continue;
                    const [a, u] = i, c = l(A(-(u.coord.y - a.coord.y), u.coord.x - a.coord.x, 0));
                    o = this.addFeatureSection(n[s].featureInfo.featureIndex, o, this.tunnelFeatureSections, t1), t1.addQuad([
                        a,
                        u,
                        {
                            coord: u.coord,
                            height: n[s].isTunnel ? -0.1 : 0
                        },
                        {
                            coord: a.coord,
                            height: n[s].isTunnel ? -0.1 : 0
                        }
                    ], c);
                }
                for(let i = s.min; i < s.max; i++){
                    const s = n[i];
                    s.isTunnel && ([s.a, s.b] = [
                        s.b,
                        s.a
                    ]);
                    const a = e[s.a], u = e[s.b], c = l(A(-(u.y - a.y), u.x - a.x, 0));
                    o = this.addFeatureSection(s.featureInfo.featureIndex, o, this.tunnelFeatureSections, t1), t1.addQuad([
                        {
                            coord: u,
                            height: 0
                        },
                        {
                            coord: a,
                            height: 0
                        },
                        {
                            coord: a,
                            height: r[s.a] + 4
                        },
                        {
                            coord: u,
                            height: r[s.b] + 4
                        }
                    ], c), t1.addQuad([
                        {
                            coord: a,
                            height: 0
                        },
                        {
                            coord: u,
                            height: 0
                        },
                        {
                            coord: u,
                            height: r[s.b] + 4
                        },
                        {
                            coord: a,
                            height: r[s.a] + 4
                        }
                    ], c);
                }
                this.tunnelFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: t1.getVertexCount()
                });
            }
            prepareEdgePoints(t1, e, r, n) {
                let i = e[r.a], s = e[r.b];
                const o = n(i, 0), a = n(s, 0);
                if (o && a) return [
                    {
                        coord: t1[r.a],
                        height: i
                    },
                    {
                        coord: t1[r.b],
                        height: s
                    }
                ];
                if (!o && !a) return;
                const l = t1[r.a].clone(), u = t1[r.b].clone();
                if (o) {
                    if (!a) {
                        const t1 = s / (s - i);
                        u.x = ur(u.x, l.x, t1), u.y = ur(u.y, l.y, t1), s = ur(s, i, t1);
                    }
                } else {
                    const t1 = i / (i - s);
                    l.x = ur(l.x, u.x, t1), l.y = ur(l.y, u.y, t1), i = ur(i, s, t1);
                }
                return [
                    {
                        coord: l,
                        height: i
                    },
                    {
                        coord: u,
                        height: s
                    }
                ];
            }
            prepareEdges(t1, e) {
                if (0 === e.length) return;
                e.sort((t1, e)=>t1.hash === e.hash ? e.polygonIdx - t1.polygonIdx : e.hash > t1.hash ? 1 : -1);
                let r = 0, n = 0, i = 0, s = e[r].polygonIdx;
                do n++, (n === e.length || e[r].hash !== e[n].hash) && ((1 == n - r || e[n - 1].polygonIdx !== s) && (i < r && (e[i] = e[r], e[r] = null), e[i].type = "none", i++), r = n, r !== e.length && (s = e[r].polygonIdx));
                while (r !== e.length);
                if (e.splice(i), 0 !== e.length && 0 !== t1.length) {
                    e.sort((t1, e)=>t1.portalHash < e.portalHash ? 1 : -1);
                    let r = 0, n = 0;
                    for(; r !== e.length && n !== t1.length;){
                        const i = e[r], s = t1[n];
                        i.portalHash > s.hash ? r++ : s.hash > i.portalHash ? n++ : (i.type = s.type, r++);
                    }
                }
            }
            isOnBorder(t1, e) {
                return t1 <= 0 && e <= 0 || t1 >= Cn && e >= Cn;
            }
            addFeatureSection(t1, e, r, n) {
                return t1 !== e && (e = t1, r.push({
                    featureIndex: t1,
                    vertexStart: n.getVertexCount()
                }), n.clearVertexLookup()), e;
            }
            sortSubarray(t1, e, r, n) {
                const i = t1.slice(e, r);
                i.sort(n), t1.splice(e, i.length, ...i);
            }
            static computeEdgeHash(t1, e) {
                return (t1.y === e.y && t1.x > e.x || t1.y > e.y) && ([t1, e] = [
                    e,
                    t1
                ]), BigInt(np.computePosHash(t1)) << 32n | BigInt(np.computePosHash(e));
            }
            static computePosHash(t1) {
                return ((65535 & t1.x) << 16 | 65535 & t1.y) >>> 0;
            }
        }
        var ip, sp = {
            exports: {}
        }, op = (ip || (ip = 1, function(t1, e) {
            !function(t1) {
                function e(t1, e) {
                    return t1 > e ? 1 : t1 < e ? -1 : 0;
                }
                var r = function(t1, r) {
                    void 0 === t1 && (t1 = e), void 0 === r && (r = !1), this._compare = t1, this._root = null, this._size = 0, this._noDuplicates = !!r;
                }, n = {
                    size: {
                        configurable: !0
                    }
                };
                function i(t1, e, r, n, s) {
                    var o = s - n;
                    if (o > 0) {
                        var a = n + Math.floor(o / 2), l = {
                            key: e[a],
                            data: r[a],
                            parent: t1
                        };
                        return l.left = i(l, e, r, n, a), l.right = i(l, e, r, a + 1, s), l;
                    }
                    return null;
                }
                function s(t1, e, r, n, i) {
                    if (!(r >= n)) {
                        for(var o = t1[r + n >> 1], a = r - 1, l = n + 1;;){
                            do a++;
                            while (i(t1[a], o) < 0);
                            do l--;
                            while (i(t1[l], o) > 0);
                            if (a >= l) break;
                            var u = t1[a];
                            t1[a] = t1[l], t1[l] = u, u = e[a], e[a] = e[l], e[l] = u;
                        }
                        s(t1, e, r, l, i), s(t1, e, l + 1, n, i);
                    }
                }
                r.prototype.rotateLeft = function(t1) {
                    var e = t1.right;
                    e && (t1.right = e.left, e.left && (e.left.parent = t1), e.parent = t1.parent), t1.parent ? t1 === t1.parent.left ? t1.parent.left = e : t1.parent.right = e : this._root = e, e && (e.left = t1), t1.parent = e;
                }, r.prototype.rotateRight = function(t1) {
                    var e = t1.left;
                    e && (t1.left = e.right, e.right && (e.right.parent = t1), e.parent = t1.parent), t1.parent ? t1 === t1.parent.left ? t1.parent.left = e : t1.parent.right = e : this._root = e, e && (e.right = t1), t1.parent = e;
                }, r.prototype._splay = function(t1) {
                    for(; t1.parent;){
                        var e = t1.parent;
                        e.parent ? e.left === t1 && e.parent.left === e ? (this.rotateRight(e.parent), this.rotateRight(e)) : e.right === t1 && e.parent.right === e ? (this.rotateLeft(e.parent), this.rotateLeft(e)) : e.left === t1 && e.parent.right === e ? (this.rotateRight(e), this.rotateLeft(e)) : (this.rotateLeft(e), this.rotateRight(e)) : e.left === t1 ? this.rotateRight(e) : this.rotateLeft(e);
                    }
                }, r.prototype.splay = function(t1) {
                    for(var e, r, n, i, s; t1.parent;)(r = (e = t1.parent).parent) && r.parent ? ((n = r.parent).left === r ? n.left = t1 : n.right = t1, t1.parent = n) : (t1.parent = null, this._root = t1), i = t1.left, s = t1.right, t1 === e.left ? (r && (r.left === e ? (e.right ? (r.left = e.right, r.left.parent = r) : r.left = null, e.right = r, r.parent = e) : (i ? (r.right = i, i.parent = r) : r.right = null, t1.left = r, r.parent = t1)), s ? (e.left = s, s.parent = e) : e.left = null, t1.right = e, e.parent = t1) : (r && (r.right === e ? (e.left ? (r.right = e.left, r.right.parent = r) : r.right = null, e.left = r, r.parent = e) : (s ? (r.left = s, s.parent = r) : r.left = null, t1.right = r, r.parent = t1)), i ? (e.right = i, i.parent = e) : e.right = null, t1.left = e, e.parent = t1);
                }, r.prototype.replace = function(t1, e) {
                    t1.parent ? t1 === t1.parent.left ? t1.parent.left = e : t1.parent.right = e : this._root = e, e && (e.parent = t1.parent);
                }, r.prototype.minNode = function(t1) {
                    if (void 0 === t1 && (t1 = this._root), t1) for(; t1.left;)t1 = t1.left;
                    return t1;
                }, r.prototype.maxNode = function(t1) {
                    if (void 0 === t1 && (t1 = this._root), t1) for(; t1.right;)t1 = t1.right;
                    return t1;
                }, r.prototype.insert = function(t1, e) {
                    var r = this._root, n = null, i = this._compare;
                    if (this._noDuplicates) for(; r;){
                        if (n = r, 0 === i(r.key, t1)) return;
                        r = i(r.key, t1) < 0 ? r.right : r.left;
                    }
                    else for(; r;)n = r, r = i(r.key, t1) < 0 ? r.right : r.left;
                    return r = {
                        key: t1,
                        data: e,
                        left: null,
                        right: null,
                        parent: n
                    }, n ? i(n.key, r.key) < 0 ? n.right = r : n.left = r : this._root = r, this.splay(r), this._size++, r;
                }, r.prototype.find = function(t1) {
                    for(var e = this._root, r = this._compare; e;){
                        var n = r(e.key, t1);
                        if (n < 0) e = e.right;
                        else {
                            if (!(n > 0)) return e;
                            e = e.left;
                        }
                    }
                    return null;
                }, r.prototype.contains = function(t1) {
                    for(var e = this._root, r = this._compare; e;){
                        var n = r(t1, e.key);
                        if (0 === n) return !0;
                        e = n < 0 ? e.left : e.right;
                    }
                    return !1;
                }, r.prototype.remove = function(t1) {
                    var e = this.find(t1);
                    if (!e) return !1;
                    if (this.splay(e), e.left) {
                        if (e.right) {
                            var r = this.minNode(e.right);
                            r.parent !== e && (this.replace(r, r.right), r.right = e.right, r.right.parent = r), this.replace(e, r), r.left = e.left, r.left.parent = r;
                        } else this.replace(e, e.left);
                    } else this.replace(e, e.right);
                    return this._size--, !0;
                }, r.prototype.removeNode = function(t1) {
                    if (!t1) return !1;
                    if (this.splay(t1), t1.left) {
                        if (t1.right) {
                            var e = this.minNode(t1.right);
                            e.parent !== t1 && (this.replace(e, e.right), e.right = t1.right, e.right.parent = e), this.replace(t1, e), e.left = t1.left, e.left.parent = e;
                        } else this.replace(t1, t1.left);
                    } else this.replace(t1, t1.right);
                    return this._size--, !0;
                }, r.prototype.erase = function(t1) {
                    var e = this.find(t1);
                    if (e) {
                        this.splay(e);
                        var r = e.left, n = e.right, i = null;
                        r && (r.parent = null, i = this.maxNode(r), this.splay(i), this._root = i), n && (r ? i.right = n : this._root = n, n.parent = i), this._size--;
                    }
                }, r.prototype.pop = function() {
                    var t1 = this._root, e = null;
                    if (t1) {
                        for(; t1.left;)t1 = t1.left;
                        e = {
                            key: t1.key,
                            data: t1.data
                        }, this.remove(t1.key);
                    }
                    return e;
                }, r.prototype.next = function(t1) {
                    var e = t1;
                    if (e) {
                        if (e.right) for(e = e.right; e && e.left;)e = e.left;
                        else for(e = t1.parent; e && e.right === t1;)t1 = e, e = e.parent;
                    }
                    return e;
                }, r.prototype.prev = function(t1) {
                    var e = t1;
                    if (e) {
                        if (e.left) for(e = e.left; e && e.right;)e = e.right;
                        else for(e = t1.parent; e && e.left === t1;)t1 = e, e = e.parent;
                    }
                    return e;
                }, r.prototype.forEach = function(t1) {
                    for(var e = this._root, r = [], n = !1, i = 0; !n;)e ? (r.push(e), e = e.left) : r.length > 0 ? (t1(e = r.pop(), i++), e = e.right) : n = !0;
                    return this;
                }, r.prototype.range = function(t1, e, r, n) {
                    for(var i = [], s = this._compare, o = this._root; 0 !== i.length || o;)if (o) i.push(o), o = o.left;
                    else {
                        if (s((o = i.pop()).key, e) > 0) break;
                        if (s(o.key, t1) >= 0 && r.call(n, o)) return this;
                        o = o.right;
                    }
                    return this;
                }, r.prototype.keys = function() {
                    for(var t1 = this._root, e = [], r = [], n = !1; !n;)t1 ? (e.push(t1), t1 = t1.left) : e.length > 0 ? (t1 = e.pop(), r.push(t1.key), t1 = t1.right) : n = !0;
                    return r;
                }, r.prototype.values = function() {
                    for(var t1 = this._root, e = [], r = [], n = !1; !n;)t1 ? (e.push(t1), t1 = t1.left) : e.length > 0 ? (t1 = e.pop(), r.push(t1.data), t1 = t1.right) : n = !0;
                    return r;
                }, r.prototype.at = function(t1) {
                    for(var e = this._root, r = [], n = !1, i = 0; !n;)if (e) r.push(e), e = e.left;
                    else if (r.length > 0) {
                        if (e = r.pop(), i === t1) return e;
                        i++, e = e.right;
                    } else n = !0;
                    return null;
                }, r.prototype.load = function(t1, e, r) {
                    if (void 0 === t1 && (t1 = []), void 0 === e && (e = []), void 0 === r && (r = !1), 0 !== this._size) throw new Error("bulk-load: tree is not empty");
                    var n = t1.length;
                    return r && s(t1, e, 0, n - 1, this._compare), this._root = i(null, t1, e, 0, n), this._size = n, this;
                }, r.prototype.min = function() {
                    var t1 = this.minNode(this._root);
                    return t1 ? t1.key : null;
                }, r.prototype.max = function() {
                    var t1 = this.maxNode(this._root);
                    return t1 ? t1.key : null;
                }, r.prototype.isEmpty = function() {
                    return null === this._root;
                }, n.size.get = function() {
                    return this._size;
                }, r.createTree = function(t1, e, n, i, s) {
                    return new r(n, s).load(t1, e, i);
                }, Object.defineProperties(r.prototype, n);
                var o = 0, a = 1, l = 2, u = 3, c = 0, h = 1, p = 2, f = 3;
                function d(t1, e, r) {
                    null === e ? (t1.inOut = !1, t1.otherInOut = !0) : (t1.isSubject === e.isSubject ? (t1.inOut = !e.inOut, t1.otherInOut = e.otherInOut) : (t1.inOut = !e.otherInOut, t1.otherInOut = e.isVertical() ? !e.inOut : e.inOut), e && (t1.prevInResult = !m(e, r) || e.isVertical() ? e.prevInResult : e));
                    var n = m(t1, r);
                    t1.resultTransition = n ? function(t1, e) {
                        var r, n = !t1.inOut, i = !t1.otherInOut;
                        switch(e){
                            case c:
                                r = n && i;
                                break;
                            case h:
                                r = n || i;
                                break;
                            case f:
                                r = n ^ i;
                                break;
                            case p:
                                r = t1.isSubject ? n && !i : i && !n;
                        }
                        return r ? 1 : -1;
                    }(t1, r) : 0;
                }
                function m(t1, e) {
                    switch(t1.type){
                        case o:
                            switch(e){
                                case c:
                                    return !t1.otherInOut;
                                case h:
                                    return t1.otherInOut;
                                case p:
                                    return t1.isSubject && t1.otherInOut || !t1.isSubject && !t1.otherInOut;
                                case f:
                                    return !0;
                            }
                            break;
                        case l:
                            return e === c || e === h;
                        case u:
                            return e === p;
                        case a:
                            return !1;
                    }
                    return !1;
                }
                var y = function(t1, e, r, n, i) {
                    this.left = e, this.point = t1, this.otherEvent = r, this.isSubject = n, this.type = i || o, this.inOut = !1, this.otherInOut = !1, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = !0;
                }, g = {
                    inResult: {
                        configurable: !0
                    }
                };
                function x(t1, e) {
                    return t1[0] === e[0] && t1[1] === e[1];
                }
                y.prototype.isBelow = function(t1) {
                    var e = this.point, r = this.otherEvent.point;
                    return this.left ? (e[0] - t1[0]) * (r[1] - t1[1]) - (r[0] - t1[0]) * (e[1] - t1[1]) > 0 : (r[0] - t1[0]) * (e[1] - t1[1]) - (e[0] - t1[0]) * (r[1] - t1[1]) > 0;
                }, y.prototype.isAbove = function(t1) {
                    return !this.isBelow(t1);
                }, y.prototype.isVertical = function() {
                    return this.point[0] === this.otherEvent.point[0];
                }, g.inResult.get = function() {
                    return 0 !== this.resultTransition;
                }, y.prototype.clone = function() {
                    var t1 = new y(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                    return t1.contourId = this.contourId, t1.resultTransition = this.resultTransition, t1.prevInResult = this.prevInResult, t1.isExteriorRing = this.isExteriorRing, t1.inOut = this.inOut, t1.otherInOut = this.otherInOut, t1;
                }, Object.defineProperties(y.prototype, g);
                var v = 11102230246251565e-32, b = 134217729, w = (3 + 8 * v) * v;
                function _(t1, e, r, n, i) {
                    var s, o, a, l, u = e[0], c = n[0], h = 0, p = 0;
                    c > u == c > -u ? (s = u, u = e[++h]) : (s = c, c = n[++p]);
                    var f = 0;
                    if (h < t1 && p < r) for(c > u == c > -u ? (a = s - ((o = u + s) - u), u = e[++h]) : (a = s - ((o = c + s) - c), c = n[++p]), s = o, 0 !== a && (i[f++] = a); h < t1 && p < r;)c > u == c > -u ? (a = s - ((o = s + u) - (l = o - s)) + (u - l), u = e[++h]) : (a = s - ((o = s + c) - (l = o - s)) + (c - l), c = n[++p]), s = o, 0 !== a && (i[f++] = a);
                    for(; h < t1;)a = s - ((o = s + u) - (l = o - s)) + (u - l), u = e[++h], s = o, 0 !== a && (i[f++] = a);
                    for(; p < r;)a = s - ((o = s + c) - (l = o - s)) + (c - l), c = n[++p], s = o, 0 !== a && (i[f++] = a);
                    return 0 === s && 0 !== f || (i[f++] = s), f;
                }
                function A(t1) {
                    return new Float64Array(t1);
                }
                var M = 33306690738754716e-32, I = 22204460492503146e-32, S = 11093356479670487e-47, z = A(4), k = A(8), P = A(12), E = A(16), T = A(4);
                function B(t1, e, r) {
                    var n = function(t1, e, r, n, i, s) {
                        var o = (e - s) * (r - i), a = (t1 - i) * (n - s), l = o - a;
                        if (0 === o || 0 === a || o > 0 != a > 0) return l;
                        var u = Math.abs(o + a);
                        return Math.abs(l) >= M * u ? l : -function(t1, e, r, n, i, s, o) {
                            var a, l, u, c, h, p, f, d, m, y, g, x, v, A, M, B, V, C, F = t1 - i, D = r - i, L = e - s, R = n - s;
                            z[0] = (M = (d = F - (f = (p = b * F) - (p - F))) * (y = R - (m = (p = b * R) - (p - R))) - ((A = F * R) - f * m - d * m - f * y)) - ((g = M - (V = (d = L - (f = (p = b * L) - (p - L))) * (y = D - (m = (p = b * D) - (p - D))) - ((B = L * D) - f * m - d * m - f * y))) + (h = M - g)) + (h - V), z[1] = (v = A - ((x = A + g) - (h = x - A)) + (g - h)) - ((g = v - B) + (h = v - g)) + (h - B), z[2] = x - ((C = x + g) - (h = C - x)) + (g - h), z[3] = C;
                            var O = function(t1, e) {
                                for(var r = e[0], n = 1; n < 4; n++)r += e[n];
                                return r;
                            }(0, z), U = I * o;
                            if (O >= U || -O >= U) return O;
                            if (a = t1 - (F + (h = t1 - F)) + (h - i), u = r - (D + (h = r - D)) + (h - i), l = e - (L + (h = e - L)) + (h - s), c = n - (R + (h = n - R)) + (h - s), 0 === a && 0 === l && 0 === u && 0 === c) return O;
                            if (U = S * o + w * Math.abs(O), (O += F * c + R * a - (L * u + D * l)) >= U || -O >= U) return O;
                            T[0] = (M = (d = a - (f = (p = b * a) - (p - a))) * (y = R - (m = (p = b * R) - (p - R))) - ((A = a * R) - f * m - d * m - f * y)) - ((g = M - (V = (d = l - (f = (p = b * l) - (p - l))) * (y = D - (m = (p = b * D) - (p - D))) - ((B = l * D) - f * m - d * m - f * y))) + (h = M - g)) + (h - V), T[1] = (v = A - ((x = A + g) - (h = x - A)) + (g - h)) - ((g = v - B) + (h = v - g)) + (h - B), T[2] = x - ((C = x + g) - (h = C - x)) + (g - h), T[3] = C;
                            var N = _(4, z, 4, T, k);
                            T[0] = (M = (d = F - (f = (p = b * F) - (p - F))) * (y = c - (m = (p = b * c) - (p - c))) - ((A = F * c) - f * m - d * m - f * y)) - ((g = M - (V = (d = L - (f = (p = b * L) - (p - L))) * (y = u - (m = (p = b * u) - (p - u))) - ((B = L * u) - f * m - d * m - f * y))) + (h = M - g)) + (h - V), T[1] = (v = A - ((x = A + g) - (h = x - A)) + (g - h)) - ((g = v - B) + (h = v - g)) + (h - B), T[2] = x - ((C = x + g) - (h = C - x)) + (g - h), T[3] = C;
                            var j = _(N, k, 4, T, P);
                            T[0] = (M = (d = a - (f = (p = b * a) - (p - a))) * (y = c - (m = (p = b * c) - (p - c))) - ((A = a * c) - f * m - d * m - f * y)) - ((g = M - (V = (d = l - (f = (p = b * l) - (p - l))) * (y = u - (m = (p = b * u) - (p - u))) - ((B = l * u) - f * m - d * m - f * y))) + (h = M - g)) + (h - V), T[1] = (v = A - ((x = A + g) - (h = x - A)) + (g - h)) - ((g = v - B) + (h = v - g)) + (h - B), T[2] = x - ((C = x + g) - (h = C - x)) + (g - h), T[3] = C;
                            var $ = _(j, P, 4, T, E);
                            return E[$ - 1];
                        }(t1, e, r, n, i, s, u);
                    }(t1[0], t1[1], e[0], e[1], r[0], r[1]);
                    return n > 0 ? -1 : n < 0 ? 1 : 0;
                }
                function V(t1, e) {
                    var r = t1.point, n = e.point;
                    return r[0] > n[0] ? 1 : r[0] < n[0] ? -1 : r[1] !== n[1] ? r[1] > n[1] ? 1 : -1 : function(t1, e, r, n) {
                        return t1.left !== e.left ? t1.left ? 1 : -1 : 0 !== B(r, t1.otherEvent.point, e.otherEvent.point) ? t1.isBelow(e.otherEvent.point) ? -1 : 1 : !t1.isSubject && e.isSubject ? 1 : -1;
                    }(t1, e, r);
                }
                function C(t1, e, r) {
                    var n = new y(e, !1, t1, t1.isSubject), i = new y(e, !0, t1.otherEvent, t1.isSubject);
                    return x(t1.point, t1.otherEvent.point) && console.warn("what is that, a collapsed segment?", t1), n.contourId = i.contourId = t1.contourId, V(i, t1.otherEvent) > 0 && (t1.otherEvent.left = !0, i.left = !1), t1.otherEvent.otherEvent = i, t1.otherEvent = n, r.push(i), r.push(n), r;
                }
                function F(t1, e) {
                    return t1[0] * e[1] - t1[1] * e[0];
                }
                function D(t1, e) {
                    return t1[0] * e[0] + t1[1] * e[1];
                }
                function L(t1, e, r) {
                    var n = function(t1, e, r, n, i) {
                        var s = [
                            e[0] - t1[0],
                            e[1] - t1[1]
                        ], o = [
                            n[0] - r[0],
                            n[1] - r[1]
                        ];
                        function a(t1, e, r) {
                            return [
                                t1[0] + e * r[0],
                                t1[1] + e * r[1]
                            ];
                        }
                        var l = [
                            r[0] - t1[0],
                            r[1] - t1[1]
                        ], u = F(s, o), c = u * u, h = D(s, s);
                        if (c > 0) {
                            var p = F(l, o) / u;
                            if (p < 0 || p > 1) return null;
                            var f = F(l, s) / u;
                            return f < 0 || f > 1 ? null : 0 === p || 1 === p ? [
                                a(t1, p, s)
                            ] : 0 === f || 1 === f ? [
                                a(r, f, o)
                            ] : [
                                a(t1, p, s)
                            ];
                        }
                        if ((c = (u = F(l, s)) * u) > 0) return null;
                        var d = D(s, l) / h, m = d + D(s, o) / h, y = Math.min(d, m), g = Math.max(d, m);
                        return y <= 1 && g >= 0 ? 1 === y ? [
                            a(t1, y > 0 ? y : 0, s)
                        ] : 0 === g ? [
                            a(t1, g < 1 ? g : 1, s)
                        ] : [
                            a(t1, y > 0 ? y : 0, s),
                            a(t1, g < 1 ? g : 1, s)
                        ] : null;
                    }(t1.point, t1.otherEvent.point, e.point, e.otherEvent.point), i = n ? n.length : 0;
                    if (0 === i) return 0;
                    if (1 === i && (x(t1.point, e.point) || x(t1.otherEvent.point, e.otherEvent.point))) return 0;
                    if (2 === i && t1.isSubject === e.isSubject) return 0;
                    if (1 === i) return x(t1.point, n[0]) || x(t1.otherEvent.point, n[0]) || C(t1, n[0], r), x(e.point, n[0]) || x(e.otherEvent.point, n[0]) || C(e, n[0], r), 1;
                    var s = [], o = !1, c = !1;
                    return x(t1.point, e.point) ? o = !0 : 1 === V(t1, e) ? s.push(e, t1) : s.push(t1, e), x(t1.otherEvent.point, e.otherEvent.point) ? c = !0 : 1 === V(t1.otherEvent, e.otherEvent) ? s.push(e.otherEvent, t1.otherEvent) : s.push(t1.otherEvent, e.otherEvent), o && c || o ? (e.type = a, t1.type = e.inOut === t1.inOut ? l : u, o && !c && C(s[1].otherEvent, s[0].point, r), 2) : c ? (C(s[0], s[1].point, r), 3) : s[0] !== s[3].otherEvent ? (C(s[0], s[1].point, r), C(s[1], s[2].point, r), 3) : (C(s[0], s[1].point, r), C(s[3].otherEvent, s[2].point, r), 3);
                }
                function R(t1, e) {
                    if (t1 === e) return 0;
                    if (0 !== B(t1.point, t1.otherEvent.point, e.point) || 0 !== B(t1.point, t1.otherEvent.point, e.otherEvent.point)) return x(t1.point, e.point) ? t1.isBelow(e.otherEvent.point) ? -1 : 1 : t1.point[0] === e.point[0] ? t1.point[1] < e.point[1] ? -1 : 1 : 1 === V(t1, e) ? e.isAbove(t1.point) ? -1 : 1 : t1.isBelow(e.point) ? -1 : 1;
                    if (t1.isSubject !== e.isSubject) return t1.isSubject ? -1 : 1;
                    var r = t1.point, n = e.point;
                    return r[0] === n[0] && r[1] === n[1] ? (r = t1.otherEvent.point)[0] === (n = e.otherEvent.point)[0] && r[1] === n[1] ? 0 : t1.contourId > e.contourId ? 1 : -1 : 1 === V(t1, e) ? 1 : -1;
                }
                var O = function() {
                    this.points = [], this.holeIds = [], this.holeOf = null, this.depth = null;
                };
                function U(t1, e, r, n) {
                    var i, s = t1 + 1, o = e[t1].point, a = e.length;
                    for(s < a && (i = e[s].point); s < a && i[0] === o[0] && i[1] === o[1];){
                        if (!r[s]) return s;
                        ++s < a && (i = e[s].point);
                    }
                    for(s = t1 - 1; r[s] && s > n;)s--;
                    return s;
                }
                O.prototype.isExterior = function() {
                    return null == this.holeOf;
                };
                var N = $, j = $;
                function $(t1, e) {
                    if (!(this instanceof $)) return new $(t1, e);
                    if (this.data = t1 || [], this.length = this.data.length, this.compare = e || G, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
                }
                function G(t1, e) {
                    return t1 < e ? -1 : t1 > e ? 1 : 0;
                }
                $.prototype = {
                    push: function(t1) {
                        this.data.push(t1), this.length++, this._up(this.length - 1);
                    },
                    pop: function() {
                        if (0 !== this.length) {
                            var t1 = this.data[0];
                            return this.length--, this.length > 0 && (this.data[0] = this.data[this.length], this._down(0)), this.data.pop(), t1;
                        }
                    },
                    peek: function() {
                        return this.data[0];
                    },
                    _up: function(t1) {
                        for(var e = this.data, r = this.compare, n = e[t1]; t1 > 0;){
                            var i = t1 - 1 >> 1, s = e[i];
                            if (r(n, s) >= 0) break;
                            e[t1] = s, t1 = i;
                        }
                        e[t1] = n;
                    },
                    _down: function(t1) {
                        for(var e = this.data, r = this.compare, n = this.length >> 1, i = e[t1]; t1 < n;){
                            var s = 1 + (t1 << 1), o = s + 1, a = e[s];
                            if (o < this.length && r(e[o], a) < 0 && (s = o, a = e[o]), r(a, i) >= 0) break;
                            e[t1] = a, t1 = s;
                        }
                        e[t1] = i;
                    }
                }, N.default = j;
                var q = Math.max, H = Math.min, X = 0;
                function Z(t1, e, r, n, i, s) {
                    var o, a, l, u, c, h;
                    for(o = 0, a = t1.length - 1; o < a; o++)if (u = t1[o + 1], c = new y(l = t1[o], !1, void 0, e), h = new y(u, !1, c, e), c.otherEvent = h, l[0] !== u[0] || l[1] !== u[1]) {
                        c.contourId = h.contourId = r, s || (c.isExteriorRing = !1, h.isExteriorRing = !1), V(c, h) > 0 ? h.left = !0 : c.left = !0;
                        var p = l[0], f = l[1];
                        i[0] = H(i[0], p), i[1] = H(i[1], f), i[2] = q(i[2], p), i[3] = q(i[3], f), n.push(c), n.push(h);
                    }
                }
                var W = [];
                function Y(t1, e, n) {
                    "number" == typeof t1[0][0][0] && (t1 = [
                        t1
                    ]), "number" == typeof e[0][0][0] && (e = [
                        e
                    ]);
                    var i = function(t1, e, r) {
                        var n = null;
                        return t1.length * e.length == 0 && (r === c ? n = W : r === p ? n = t1 : r !== h && r !== f || (n = 0 === t1.length ? e : t1)), n;
                    }(t1, e, n);
                    if (i) return i === W ? null : i;
                    var s = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], o = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], a = function(t1, e, r, n, i) {
                        var s, o, a, l, u, c, h = new N(null, V);
                        for(a = 0, l = t1.length; a < l; a++)for(u = 0, c = (s = t1[a]).length; u < c; u++)(o = 0 === u) && X++, Z(s[u], !0, X, h, r, o);
                        for(a = 0, l = e.length; a < l; a++)for(u = 0, c = (s = e[a]).length; u < c; u++)o = 0 === u, i === p && (o = !1), o && X++, Z(s[u], !1, X, h, n, o);
                        return h;
                    }(t1, e, s, o, n);
                    if (i = function(t1, e, r, n, i) {
                        var s = null;
                        return (r[0] > n[2] || n[0] > r[2] || r[1] > n[3] || n[1] > r[3]) && (i === c ? s = W : i === p ? s = t1 : i !== h && i !== f || (s = t1.concat(e))), s;
                    }(t1, e, s, o, n)) return i === W ? null : i;
                    for(var l = function(t1) {
                        var e, r, n = function(t1) {
                            var e, r, n, i, s = [];
                            for(r = 0, n = t1.length; r < n; r++)((e = t1[r]).left && e.inResult || !e.left && e.otherEvent.inResult) && s.push(e);
                            for(var o = !1; !o;)for(o = !0, r = 0, n = s.length; r < n; r++)r + 1 < n && 1 === V(s[r], s[r + 1]) && (i = s[r], s[r] = s[r + 1], s[r + 1] = i, o = !1);
                            for(r = 0, n = s.length; r < n; r++)(e = s[r]).otherPos = r;
                            for(r = 0, n = s.length; r < n; r++)(e = s[r]).left || (i = e.otherPos, e.otherPos = e.otherEvent.otherPos, e.otherEvent.otherPos = i);
                            return s;
                        }(t1), i = {}, s = [], o = function() {
                            if (!i[e]) {
                                var t1 = s.length, r = function(t1, e, r) {
                                    var n = new O;
                                    if (null != t1.prevInResult) {
                                        var i = t1.prevInResult, s = i.outputContourId;
                                        if (i.resultTransition > 0) {
                                            var o = e[s];
                                            if (null != o.holeOf) {
                                                var a = o.holeOf;
                                                e[a].holeIds.push(r), n.holeOf = a, n.depth = e[s].depth;
                                            } else e[s].holeIds.push(r), n.holeOf = s, n.depth = e[s].depth + 1;
                                        } else n.holeOf = null, n.depth = e[s].depth;
                                    } else n.holeOf = null, n.depth = 0;
                                    return n;
                                }(n[e], s, t1), o = function(e) {
                                    i[e] = !0, e < n.length && n[e] && (n[e].outputContourId = t1);
                                }, a = e, l = e;
                                for(r.points.push(n[e].point); o(a), o(a = n[a].otherPos), r.points.push(n[a].point), !((a = U(a, n, i, l)) == l || a >= n.length) && n[a];);
                                s.push(r);
                            }
                        };
                        for(e = 0, r = n.length; e < r; e++)o();
                        return s;
                    }(function(t1, e, n, i, s, o) {
                        for(var a, l, u, h = new r(R), f = [], m = Math.min(i[2], s[2]); 0 !== t1.length;){
                            var y = t1.pop();
                            if (f.push(y), o === c && y.point[0] > m || o === p && y.point[0] > i[2]) break;
                            if (y.left) {
                                l = a = h.insert(y), a = a !== (u = h.minNode()) ? h.prev(a) : null, l = h.next(l);
                                var g = a ? a.key : null;
                                if (d(y, g, o), l && 2 === L(y, l.key, t1) && (d(y, g, o), d(l.key, y, o)), a && 2 === L(a.key, y, t1)) {
                                    var x = a;
                                    d(g, (x = x !== u ? h.prev(x) : null) ? x.key : null, o), d(y, g, o);
                                }
                            } else l = a = h.find(y = y.otherEvent), a && l && (a = a !== u ? h.prev(a) : null, l = h.next(l), h.remove(y), l && a && L(a.key, l.key, t1));
                        }
                        return f;
                    }(a, 0, 0, s, o, n)), u = [], m = 0; m < l.length; m++){
                        var y = l[m];
                        if (y.isExterior()) {
                            for(var g = [
                                y.points
                            ], x = 0; x < y.holeIds.length; x++)g.push(l[y.holeIds[x]].points);
                            u.push(g);
                        }
                    }
                    return u;
                }
                var K = {
                    UNION: h,
                    DIFFERENCE: p,
                    INTERSECTION: c,
                    XOR: f
                };
                t1.diff = function(t1, e) {
                    return Y(t1, e, p);
                }, t1.intersection = function(t1, e) {
                    return Y(t1, e, c);
                }, t1.operations = K, t1.union = function(t1, e) {
                    return Y(t1, e, h);
                }, t1.xor = function(t1, e) {
                    return Y(t1, e, f);
                }, Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
            }(e);
        }(0, sp.exports)), sp.exports);
        /**
 * martinez v0.7.4
 * Martinez polygon clipping algorithm, does boolean operation on polygons (multipolygons, polygons with holes etc): intersection, union, difference, xor
 *
 * @author Alex Milevski <info@w8r.name>
 * @license MIT
 * @preserve
 */ function ap(t1, e, r, n) {
            const i = [], s = 0 === n ? (t1, e, r, n, i, s)=>{
                t1.push(new bt(s, r + (s - e) / (n - e) * (i - r)));
            } : (t1, e, r, n, i, s)=>{
                t1.push(new bt(e + (s - r) / (i - r) * (n - e), s));
            };
            for (const o of t1){
                const t1 = [];
                for (const i of o){
                    if (i.length <= 2) continue;
                    const o = [];
                    for(let t1 = 0; t1 < i.length - 1; t1++){
                        const a = i[t1].x, l = i[t1].y, u = i[t1 + 1].x, c = i[t1 + 1].y, h = 0 === n ? a : l, p = 0 === n ? u : c;
                        h < e ? p > e && s(o, a, l, u, c, e) : h > r ? p < r && s(o, a, l, u, c, r) : o.push(i[t1]), p < e && h >= e && s(o, a, l, u, c, e), p > r && h <= r && s(o, a, l, u, c, r);
                    }
                    let a = i[i.length - 1];
                    const l = 0 === n ? a.x : a.y;
                    l >= e && l <= r && o.push(a), o.length && (a = o[o.length - 1], o[0].x === a.x && o[0].y === a.y || o.push(o[0]), t1.push(o));
                }
                t1.length && i.push(t1);
            }
            return i;
        }
        function lp(t1, e) {
            const r = cp(t1), n = cp([
                e
            ]), i = op.intersection(r, n);
            return null == i ? [] : hp(i);
        }
        function up(t1, e) {
            const r = 65536;
            let n = cp(t1, r);
            for(; e.valid(); e.next()){
                const [t1, i] = e.get(), s = t1.x * r, o = t1.y * r, a = i.x * r, l = i.y * r, u = a - s, c = l - o, h = Math.hypot(u, c), p = Math.trunc(c / h * 3), f = -Math.trunc(u / h * 3);
                n = op.diff(n, [
                    [
                        [
                            s,
                            o
                        ],
                        [
                            a,
                            l
                        ],
                        [
                            a + p,
                            l + f
                        ],
                        [
                            s + p,
                            o + f
                        ],
                        [
                            s,
                            o
                        ]
                    ]
                ]);
            }
            return hp(n, 1 / r);
        }
        function cp(t1, e = 1) {
            return [
                t1.map((t1)=>t1.map((t1)=>[
                            t1.x * e,
                            t1.y * e
                        ]))
            ];
        }
        function hp(t1, e = 1) {
            return t1.map((t1)=>t1.map((t1, r)=>{
                    const n = t1.map((t1)=>new bt(t1[0] * e, t1[1] * e).round());
                    return r > 0 && n.reverse(), n;
                }));
        }
        class pp {
            constructor(t1, e){
                this.layoutVertexArray = new ra, this.indexArray = new Aa, this.lineIndexArray = new xa, this.triangleSegments = new tl, this.lineSegments = new tl, this.programConfigurations = new kl(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.uploaded = !1, e && (this.elevatedLayoutVertexArray = new sa);
            }
            update(t1, e, r, n, i, s, o, a) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, a);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
                return this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, vh.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.lineIndexBuffer = t1.createIndexBuffer(this.lineIndexArray), this.elevatedLayoutVertexArray && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = t1.createVertexBuffer(this.elevatedLayoutVertexArray, bh.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(t1, e, r, n, i, s, o) {
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, e, r, n, i, s, void 0, o);
            }
        }
        class fp {
            constructor(t1){
                this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lut = t1.lut, this.bufferData = new pp(t1, !1), this.elevationBufferData = new pp(t1, !0), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.projection = t1.projection, this.elevationMode = this.layers[0].layout.get("fill-elevation-reference"), this.sourceLayerIndex = t1.sourceLayerIndex, this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Jh("fill", this.layers, this.pixelRatio, e);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = gu(o, t1);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : yu(o, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t1, e)=>t1.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    if (this.hasPattern) {
                        const t1 = Qh("fill", this.layers, n, this.zoom, this.pixelRatio, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, {}, e.availableImages, e.brightness, e.elevationFeatures);
                    e.featureIndex.insert(t1[s].feature, i, s, o, this.index);
                }
            }
            update(t1, e, r, n, i, s, o) {
                this.bufferData.update(t1, e, r, n, i, s, o, this.worldview), this.elevationBufferData.update(t1, e, r, n, i, s, o, this.worldview), this.elevatedStructures && this.elevatedStructures.update(t1, e, r, n, i, s, o, this.worldview);
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, e, r, n, s, t1.elevationFeatures);
            }
            isEmpty() {
                return this.bufferData.isEmpty() && this.elevationBufferData.isEmpty();
            }
            uploadPending() {
                return !this.uploaded || this.bufferData.needsUpload() || this.elevationBufferData.needsUpload();
            }
            upload(t1) {
                this.bufferData.upload(t1), this.elevationBufferData.upload(t1), this.elevatedStructures && this.elevatedStructures.upload(t1);
            }
            destroy() {
                this.bufferData.destroy(), this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            addFeature(t1, e, r, n, i, s = [], o, a) {
                const l = Wh(e, 500);
                "none" !== this.elevationMode ? this.addElevatedRoadFeature(t1, l, n, r, a) : this.addGeometry(l, this.bufferData), this.bufferData.populatePaintArrays(t1, r, i, s, n, o, this.worldview), this.elevationBufferData.populatePaintArrays(t1, r, i, s, n, o, this.worldview);
            }
            getUnevaluatedPortalGraph() {
                return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            getElevationPolygons() {
                return this.elevatedStructures ? this.elevatedStructures.portalPolygons : void 0;
            }
            setEvaluatedPortalGraph(t1, e, r, n, i) {
                this.elevatedStructures && (this.elevatedStructures.construct(t1), this.elevatedStructures.populatePaintArrays(e, r, n, i, this.worldview));
            }
            addElevatedRoadFeature(t1, e, r, n, i) {
                const s = new Array, o = Zu.getElevationFeature(t1, i);
                if (!o) return void this.addGeometry(e, this.bufferData);
                {
                    const t1 = this.clipPolygonsToTile(e, 1);
                    t1.length > 0 && s.push({
                        polygons: t1,
                        elevationFeature: o,
                        elevationTileID: r
                    });
                }
                const a = {
                    guardRailEnabled: this.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(t1, {}, r),
                    featureIndex: n
                };
                for (const e of s)if (e.elevationFeature) {
                    if ("hd-road-base" === this.elevationMode) {
                        this.elevatedStructures || (this.elevatedStructures = new np(e.elevationTileID, this.layers, this.zoom, this.lut));
                        const r = e.elevationFeature.isTunnel();
                        let n = 0;
                        t1.properties.hasOwnProperty(Tu) && (n = +t1.properties[Tu]);
                        for (const t1 of e.polygons)this.elevatedStructures.addPortalCandidates(e.elevationFeature.id, t1, r, e.elevationFeature, n);
                    }
                    null == e.elevationFeature.constantHeight && (e.polygons = this.prepareElevatedPolygons(e.polygons, e.elevationFeature, e.elevationTileID));
                    const i = new Wu(r, e.elevationTileID);
                    this.addElevatedGeometry(e.polygons, i, e.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : .05, n, a);
                }
            }
            addElevatedGeometry(t1, e, r, n, i, s) {
                const o = {
                    elevation: r,
                    elevationSampler: e,
                    bias: n,
                    index: i,
                    featureInfo: s
                }, [a, l] = this.addGeometry(t1, this.elevationBufferData, o);
                null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = {
                    min: a,
                    max: l
                } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, a), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, l));
            }
            addGeometry(t1, e, r) {
                let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY, s = null;
                r && (s = r.elevationSampler.constantElevation(r.elevation, r.bias), null != s && (n = s, i = s));
                const o = (t1, o, a)=>{
                    if (null != r) {
                        if (o.push(t1), null != s) e.elevatedLayoutVertexArray.emplaceBack(s), a.push(s);
                        else {
                            const s = r.elevationSampler.pointElevation(t1, r.elevation, r.bias);
                            e.elevatedLayoutVertexArray.emplaceBack(s), a.push(s), n = Math.min(n, s), i = Math.max(i, s);
                        }
                    }
                };
                for (const n of t1){
                    let t1 = 0;
                    for (const e of n)t1 += e.length;
                    const i = e.triangleSegments.prepareSegment(t1, e.layoutVertexArray, e.indexArray), s = i.vertexLength, a = [], l = [], u = [], c = [], h = [], p = e.layoutVertexArray.length;
                    for (const t1 of n){
                        if (0 === t1.length) continue;
                        t1 !== n[0] && l.push(a.length / 2);
                        const i = e.lineSegments.prepareSegment(t1.length, e.layoutVertexArray, e.lineIndexArray), s = i.vertexLength;
                        r && h.push(e.layoutVertexArray.length - p), o(t1[0], u, c), e.layoutVertexArray.emplaceBack(t1[0].x, t1[0].y), e.lineIndexArray.emplaceBack(s + t1.length - 1, s), a.push(t1[0].x), a.push(t1[0].y);
                        for(let r = 1; r < t1.length; r++)o(t1[r], u, c), e.layoutVertexArray.emplaceBack(t1[r].x, t1[r].y), e.lineIndexArray.emplaceBack(s + r - 1, s + r), a.push(t1[r].x), a.push(t1[r].y);
                        i.vertexLength += t1.length, i.primitiveLength += t1.length;
                    }
                    const f = Ah(a, l);
                    for(let t1 = 0; t1 < f.length; t1 += 3)e.indexArray.emplaceBack(s + f[t1], s + f[t1 + 1], s + f[t1 + 2]);
                    if (f.length > 0 && r && "hd-road-base" === this.elevationMode) {
                        const t1 = r.elevation.isTunnel(), e = r.elevation.safeArea, n = this.elevatedStructures.addVertices(u, c);
                        this.elevatedStructures.addTriangles(f, n, t1);
                        const i = h.length;
                        if (i > 0) {
                            for(let s = 0; s < i - 1; s++)this.elevatedStructures.addRenderableRing(r.index, h[s] + n, h[s + 1] - h[s], t1, e, r.featureInfo);
                            this.elevatedStructures.addRenderableRing(r.index, h[i - 1] + n, u.length - h[i - 1], t1, e, r.featureInfo);
                        }
                    }
                    i.vertexLength += t1, i.primitiveLength += f.length / 3;
                }
                return [
                    n,
                    i
                ];
            }
            prepareElevatedPolygons(t1, e, r) {
                const n = 1 / au(r), i = [];
                for (const r of t1){
                    const t1 = up(r, new Hu(e, n));
                    i.push(...t1);
                }
                return i;
            }
            clipPolygonsToTile(t1, e) {
                const r = -e, n = -e, i = Cn + e, s = Cn + e;
                let o = 0;
                const a = [], l = [];
                for(; o < t1.length; o++){
                    const e = t1[o], u = pn(e);
                    (u.min.x >= r && u.max.x <= i && u.min.y >= n && u.max.y <= s ? a : l).push(e);
                }
                if (a.length === t1.length) return t1;
                const u = [
                    new bt(r, n),
                    new bt(i, n),
                    new bt(i, s),
                    new bt(r, s),
                    new bt(r, n)
                ], c = a;
                for (const t1 of l)c.push(...lp(t1, u));
                return c;
            }
        }
        let dp, mp, yp, gp;
        qs(fp, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        }), qs(pp, "FillBufferData"), qs(np, "ElevatedStructures");
        class xp {
            constructor(t1, e, r, n){
                if (this.triangleCount = e.length / 3, this.min = new bt(0, 0), this.max = new bt(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t1.length) return;
                const [i, s] = [
                    t1[0].clone(),
                    t1[0].clone()
                ];
                for(let e = 1; e < t1.length; ++e){
                    const r = t1[e];
                    i.x = Math.min(i.x, r.x), i.y = Math.min(i.y, r.y), s.x = Math.max(s.x, r.x), s.y = Math.max(s.y, r.y);
                }
                if (n) {
                    const t1 = Math.ceil(Math.max(s.x - i.x, s.y - i.y) / n);
                    r = Math.max(r, t1);
                }
                if (0 === r) return;
                this.min = i, this.max = s;
                const o = this.max.sub(this.min);
                o.x = Math.max(o.x, 1), o.y = Math.max(o.y, 1);
                const a = Math.max(o.x, o.y) / r;
                this.cellsX = Math.max(1, Math.ceil(o.x / a)), this.cellsY = Math.max(1, Math.ceil(o.y / a)), this.xScale = 1 / a, this.yScale = 1 / a;
                const l = [];
                for(let r = 0; r < this.triangleCount; r++){
                    const n = t1[e[3 * r + 0]].sub(this.min), i = t1[e[3 * r + 1]].sub(this.min), s = t1[e[3 * r + 2]].sub(this.min), o = vp(Math.floor(Math.min(n.x, i.x, s.x)), this.xScale, this.cellsX), u = vp(Math.floor(Math.max(n.x, i.x, s.x)), this.xScale, this.cellsX), c = vp(Math.floor(Math.min(n.y, i.y, s.y)), this.yScale, this.cellsY), h = vp(Math.floor(Math.max(n.y, i.y, s.y)), this.yScale, this.cellsY), p = new bt(0, 0), f = new bt(0, 0), d = new bt(0, 0), m = new bt(0, 0);
                    for(let t1 = c; t1 <= h; ++t1){
                        p.y = f.y = t1 * a, d.y = m.y = (t1 + 1) * a;
                        for(let e = o; e <= u; ++e)p.x = d.x = e * a, f.x = m.x = (e + 1) * a, (pc(n, i, s, p, f, m) || pc(n, i, s, p, m, d)) && l.push({
                            cellIdx: t1 * this.cellsX + e,
                            triIdx: r
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((t1, e)=>t1.cellIdx - e.cellIdx || t1.triIdx - e.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const t1 = l[u].cellIdx, e = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === t1;)++e.len, this.payload.push(l[u++].triIdx);
                    this.cells[t1] = e;
                }
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(t1, e) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > t1.x || t1.y > this.max.y || this.min.y > t1.y) return;
                const r = vp(t1.x - this.min.x, this.xScale, this.cellsX), n = vp(t1.y - this.min.y, this.yScale, this.cellsY), i = this.cells[n * this.cellsX + r];
                if (i) {
                    this._lazyInitLookup();
                    for(let t1 = 0; t1 < i.len; t1++){
                        const r = this.payload[i.start + t1], n = Math.floor(r / 8), s = 1 << r % 8;
                        if (!(this.lookup[n] & s) && (this.lookup[n] |= s, e.push(r), e.length === this.triangleCount)) return;
                    }
                }
            }
            query(t1, e, r) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > e.x) return;
                if (t1.y > this.max.y || this.min.y > e.y) return;
                this._lazyInitLookup();
                const n = vp(t1.x - this.min.x, this.xScale, this.cellsX), i = vp(e.x - this.min.x, this.xScale, this.cellsX), s = vp(t1.y - this.min.y, this.yScale, this.cellsY), o = vp(e.y - this.min.y, this.yScale, this.cellsY);
                for(let t1 = s; t1 <= o; t1++)for(let e = n; e <= i; e++){
                    const n = this.cells[t1 * this.cellsX + e];
                    if (n) for(let t1 = 0; t1 < n.len; t1++){
                        const e = this.payload[n.start + t1], i = Math.floor(e / 8), s = 1 << e % 8;
                        if (!(this.lookup[i] & s) && (this.lookup[i] |= s, r.push(e), r.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function vp(t1, e, r) {
            return Math.max(0, Math.min(r - 1, Math.floor(t1 * e)));
        }
        qs(xp, "TriangleGridIndex");
        class bp {
            constructor(t1){
                this.zoom = t1.zoom, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.footprints = [], this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {
                for (const r of this.footprints)e.push({
                    footprint: r,
                    id: t1
                });
            }
            populate(t1, e, r, n) {
                const i = [];
                for (const { feature: e, id: s, index: o, sourceLayerIndex: a } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = gu(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), l, r)) continue;
                    const u = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: a,
                        index: o,
                        geometry: t1 ? l.geometry : yu(e, r, n),
                        patterns: {}
                    };
                    i.push(u);
                }
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    this.addFeature(n, i, s, r, {}, e.availableImages, e.brightness), e.featureIndex.insert(t1[s].feature, i, s, o, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(t1) {}
            update(t1, e, r, n, i, s, o) {}
            destroy() {}
            addFeature(t1, e, r, n, i, s = [], o) {
                for (const t1 of Wh(e, 2)){
                    const e = [], r = [], n = [], i = new bt(1 / 0, 1 / 0), s = new bt(-1 / 0, -1 / 0);
                    for (const o of t1)if (0 !== o.length) {
                        o !== t1[0] && n.push(r.length / 2);
                        for(let t1 = 0; t1 < o.length; t1++)r.push(o[t1].x), r.push(o[t1].y), e.push(o[t1]), i.x = Math.min(i.x, o[t1].x), i.y = Math.min(i.y, o[t1].y), s.x = Math.max(s.x, o[t1].x), s.y = Math.max(s.y, o[t1].y);
                    }
                    const o = Ah(r, n), a = new xp(e, o, 8, 256);
                    this.footprints.push({
                        vertices: e,
                        indices: o,
                        grid: a,
                        min: i,
                        max: s
                    });
                }
            }
        }
        qs(bp, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const wp = ta([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), _p = ta([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Ap = ta([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Mp = ta([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Ip = ta([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Sp = ta([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: zp } = wp, kp = Number.MAX_SAFE_INTEGER;
        function Pp(t1, e, r, n) {
            return t1.order < e || t1.order === kp || !(t1.clipMask & r) || function(t1, e) {
                return 0 !== e.length && void 0 === e.find((e)=>e === t1);
            }(n, t1.clipScope);
        }
        function Ep(t1, e) {
            return t1.x - e.x || t1.y - e.y;
        }
        function Tp(t1, e) {
            return 0 === Ep(t1.min, e.min) && 0 === Ep(t1.max, e.max);
        }
        function Bp(t1, e) {
            return !(t1.min.x > e.max.x || t1.max.x < e.min.x || t1.min.y > e.max.y || t1.max.y < e.min.y);
        }
        function Vp(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let r = 0; r < t1.length; r++)if (t1[r].sourceId !== e[r].sourceId || !Tp(t1[r], e[r]) || t1[r].order !== e[r].order || t1[r].clipMask !== e[r].clipMask || !wt(t1[r].clipScope, e[r].clipScope)) return !1;
            return !0;
        }
        function Cp(t1, e, r) {
            const n = 1 / Cn, i = 1 / (1 << r.canonical.z), s = (e.x * n + r.canonical.x) * i + r.wrap, o = (e.y * n + r.canonical.y) * i;
            return {
                min: new bt((t1.x * n + r.canonical.x) * i + r.wrap, (t1.y * n + r.canonical.y) * i),
                max: new bt(s, o)
            };
        }
        function Fp(t1, e, r) {
            const n = 1 << r.canonical.z, i = ((e.x - r.wrap) * n - r.canonical.x) * Cn, s = (e.y * n - r.canonical.y) * Cn;
            return {
                min: new bt(((t1.x - r.wrap) * n - r.canonical.x) * Cn, (t1.y * n - r.canonical.y) * Cn),
                max: new bt(i, s)
            };
        }
        function Dp(t1, e, r, n, i, s, o) {
            const a = t1.indices, l = t1.vertices, u = [];
            for(let c = n; c < n + i; c += 3){
                const n = e[r[c + 0] + s], i = e[r[c + 1] + s], h = e[r[c + 2] + s], p = Math.min(n.x, i.x, h.x), f = Math.max(n.x, i.x, h.x), d = Math.min(n.y, i.y, h.y), m = Math.max(n.y, i.y, h.y);
                u.length = 0, t1.grid.query(new bt(p, d), new bt(f, m), u);
                for(let t1 = 0; t1 < u.length; t1++){
                    const e = u[t1];
                    if (pc(l[a[3 * e + 0]], l[a[3 * e + 1]], l[a[3 * e + 2]], n, i, h, o)) return !0;
                }
            }
            return !1;
        }
        function Lp(t1, e, r, n) {
            if (!t1 || !r) return !1;
            let i = t1.vertices;
            if (!e.canonical.equals(n.canonical) || e.wrap !== n.wrap) {
                if (r.vertices.length < t1.vertices.length) return Lp(r, n, t1, e);
                const s = e.canonical, o = n.canonical, a = Math.pow(2, o.z - s.z);
                i = t1.vertices.map((t1)=>new bt((t1.x + s.x * Cn) * a - o.x * Cn, (t1.y + s.y * Cn) * a - o.y * Cn));
            }
            return Dp(r, i, t1.indices, 0, t1.indices.length, 0, 0);
        }
        function Rp(t1, e, r, n) {
            const i = Math.pow(2, n.z - r.z);
            return new bt((t1 + r.x * Cn) * i - n.x * Cn, (e + r.y * Cn) * i - n.y * Cn);
        }
        function Op(t1, e) {
            const r = [];
            e.grid.queryPoint(t1, r);
            const n = e.indices, i = e.vertices;
            for(let e = 0; e < r.length; e++){
                const s = r[e];
                if (lc([
                    i[n[3 * s + 0]],
                    i[n[3 * s + 1]],
                    i[n[3 * s + 2]]
                ], t1)) return !0;
            }
            return !1;
        }
        const Up = [
            new bt(0, 0),
            new bt(Cn, 0),
            new bt(Cn, Cn),
            new bt(0, Cn)
        ];
        function Np(t1, e) {
            const r = [];
            let n = [];
            if (!e || t1.length < 2) return [
                t1
            ];
            if (2 === t1.length) return cc(t1[0], t1[1], Up) ? [
                t1
            ] : [];
            for(let e = 0; e < t1.length + 2; e++){
                const i = t1[e % t1.length], s = t1[(e + 1) % t1.length], o = cc(0 === e ? t1[t1.length - 1] : t1[(e - 1) % t1.length], i, Up), a = cc(i, s, Up), l = o || a;
                l && n.push(i), l && a || n.length > 0 && (n.length > 1 && r.push(n), n = []);
            }
            return n.length > 1 && r.push(n), r;
        }
        const jp = Pu.VectorTileFeature.types, $p = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], Gp = [
            "fill-extrusion-flood-light-ground-radius"
        ], qp = Math.pow(2, 13), Hp = Math.pow(2, 15) - 1, Xp = new bt(0, 1), Zp = 2147483648;
        function Wp(t1, e, r, n, i, s, o, a) {
            t1.emplaceBack((e << 1) + o, (r << 1) + s, (Math.floor(n * qp) << 1) + i, Math.round(a));
        }
        function Yp(t1, e, r) {
            t1.emplaceBack(e.x * Cn, e.y * Cn, r ? 1 : 0);
        }
        function Kp(t1, e, r, n, i, s) {
            t1.emplaceBack(e.x, e.y, (r.x << 1) + n, (r.y << 1) + i, s);
        }
        function Jp(t1, e, r) {
            const n = 16384;
            t1.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class Qp {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class tf {
            constructor(){
                this.centroidXY = new bt(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new bt(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new bt(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
            span() {
                return new bt(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class ef {
            constructor(){
                this.acc = new bt(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(t1, e) {
                t1.min.x === Number.MAX_VALUE && (t1.min.x = t1.max.x = e.x, t1.min.y = t1.max.y = e.y);
            }
            appendEdge(t1, e, r) {
                this.accCount++, this.acc._add(e);
                let n = !!this.borders;
                e.x < t1.min.x ? (t1.min.x = e.x, n = !0) : e.x > t1.max.x && (t1.max.x = e.x, n = !0), e.y < t1.min.y ? (t1.min.y = e.y, n = !0) : e.y > t1.max.y && (t1.max.y = e.y, n = !0), ((0 === e.x || e.x === Cn) && e.x === r.x) != ((0 === e.y || e.y === Cn) && e.y === r.y) && this.processBorderOverlap(e, r), n && this.checkBorderIntersection(e, r);
            }
            checkBorderIntersection(t1, e) {
                e.x < 0 != t1.x < 0 && this.addBorderIntersection(0, ur(e.y, t1.y, (0 - e.x) / (t1.x - e.x))), e.x > Cn != t1.x > Cn && this.addBorderIntersection(1, ur(e.y, t1.y, (Cn - e.x) / (t1.x - e.x))), e.y < 0 != t1.y < 0 && this.addBorderIntersection(2, ur(e.x, t1.x, (0 - e.y) / (t1.y - e.y))), e.y > Cn != t1.y > Cn && this.addBorderIntersection(3, ur(e.x, t1.x, (Cn - e.y) / (t1.y - e.y)));
            }
            addBorderIntersection(t1, e) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[t1];
                e < r[0] && (r[0] = e), e > r[1] && (r[1] = e);
            }
            processBorderOverlap(t1, e) {
                if (t1.x === e.x) {
                    if (t1.y === e.y) return;
                    const r = 0 === t1.x ? 0 : 1;
                    this.addBorderIntersection(r, e.y), this.addBorderIntersection(r, t1.y);
                } else {
                    const r = 0 === t1.y ? 2 : 3;
                    this.addBorderIntersection(r, e.x), this.addBorderIntersection(r, t1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new bt(0, 0) : new bt(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((t1, e)=>t1 + +(e[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function rf(t1, e) {
            const r = t1.add(e)._unit(), n = Et(t1.x * r.x + t1.y * r.y, -1, 1);
            var i, s, o;
            return i = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(i))) / 4 * Hp * ((s = t1).x * (o = e).y - s.y * o.x < 0 ? -1 : 1);
        }
        const nf = [
            (t1)=>t1.x < 0,
            (t1)=>t1.x > Cn,
            (t1)=>t1.y < 0,
            (t1)=>t1.y > Cn
        ];
        function sf(t1, e, r, n) {
            const i = [
                4
            ];
            if (0 === n) return i;
            r._mult(n);
            const s = t1.sub(r), o = e.sub(r), a = [
                t1,
                e,
                s,
                o
            ];
            for(let t1 = 0; t1 < 4; t1++)for (const e of a)if (nf[t1](e)) {
                i.push(t1);
                break;
            }
            return i;
        }
        class of {
            constructor(t1){
                this.vertexArray = new la, this.indexArray = new Aa, this.programConfigurations = new kl(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>Gp.includes(t1)), this._segments = new tl, this.hiddenByLandmarkVertexArray = new La, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new tl;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(t1, e, r, n = !1) {
                const i = t1.length;
                if (i > 2) {
                    let s = Math.max(0, this._segments.get().length - 1);
                    const o = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[s].length);
                    let a;
                    s !== this._segments.get().length - 1 && (s++, this._segmentToGroundQuads[s] = [], this._segmentToRegionTriCounts[s] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const e = t1[0], r = t1[1];
                        a = rf(e.sub(t1[i - 1])._perp()._unit(), r.sub(e)._perp()._unit());
                    }
                    for(let l = 0; l < i; l++){
                        const u = l === i - 1 ? 0 : l + 1, c = t1[l], h = t1[u], p = t1[u === i - 1 ? 0 : u + 1], f = h.sub(c)._perp()._unit(), d = rf(f, p.sub(h)._perp()._unit()), m = a, y = d;
                        if (hf(c, h, e) || n && pf(c, e) && pf(h, e)) {
                            a = d;
                            continue;
                        }
                        const g = o.vertexLength;
                        Kp(this.vertexArray, c, h, 1, 1, m), Kp(this.vertexArray, c, h, 1, 0, m), Kp(this.vertexArray, c, h, 0, 1, y), Kp(this.vertexArray, c, h, 0, 0, y), o.vertexLength += 4;
                        const x = sf(c, h, f, r);
                        for (const t1 of x)this._segmentToGroundQuads[s].push({
                            id: g,
                            region: t1
                        }), this._segmentToRegionTriCounts[s][t1] += 2, o.primitiveLength += 2;
                        a = d;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const t1 = this._segments.get(), e = t1.length;
                for(let t1 = 0; t1 < e; t1++)this._segmentToGroundQuads[t1].sort((t1, e)=>t1.region - e.region);
                for(let r = 0; r < e; r++){
                    const e = this._segmentToGroundQuads[r], n = t1[r], i = this._segmentToRegionTriCounts[r];
                    i.reduce((t1, e)=>t1 + e, 0);
                    let s = 0;
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = i[t1];
                        if (0 !== e) {
                            let r = this.regionSegments[t1];
                            r || (r = this.regionSegments[t1] = new tl);
                            const i = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + s,
                                vertexLength: n.vertexLength,
                                primitiveLength: e
                            };
                            r.get().push(i);
                        }
                        s += e;
                    }
                    for(let t1 = 0; t1 < e.length; t1++){
                        const r = e[t1].id;
                        this.indexArray.emplaceBack(r, r + 1, r + 3), this.indexArray.emplaceBack(r, r + 3, r + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(t1, e, r, n, i, s, o) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t1, e, r, n, i, s, void 0, o);
            }
            upload(t1) {
                this.hasData() && (this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, _p.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(t1) {
                this.hasData() && this.programConfigurations.upload(t1);
            }
            update(t1, e, r, n, i, s, o, a) {
                this.hasData() && this.programConfigurations.updatePaintArrays(t1, e, r, n, i, s, o, a);
            }
            updateHiddenByLandmark(t1) {
                if (!this.hasData()) return;
                const e = t1.groundVertexCount + t1.groundVertexArrayOffset;
                if (0 === t1.groundVertexCount) return;
                const r = t1.flags & Zp ? 1 : 0;
                for(let n = t1.groundVertexArrayOffset; n < e; ++n)this.hiddenByLandmarkVertexArray.emplace(n, r);
                this._needsHiddenByLandmarkUpdate = !0;
            }
            uploadHiddenByLandmark(t1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Ip.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = this.regionSegments[t1];
                        e && e.destroy();
                    }
                }
            }
        }
        class af {
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.overscaling = t1.overscaling, this.layers = t1.layers, this.pixelRatio = t1.pixelRatio, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Aa, this.footprintVertices = new ra, this.footprintSegments = [], this.layoutVertexArray = new ia, this.centroidVertexArray = new Za, this.wallVertexArray = new Ya, this.indexArray = new Aa, this.programConfigurations = new kl(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>$p.includes(t1)), this.segments = new tl, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.groundEffect = new of(t1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [], this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.features = [], this.hasPattern = Jh("fill-extrusion", this.layers, this.pixelRatio, e), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = au(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: i, id: s, index: o, sourceLayerIndex: a } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = gu(i, t1);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: a,
                        index: o,
                        geometry: t1 ? l.geometry : yu(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === jp[u.type];
                    if (this.hasPattern) this.features.push(Qh("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, e));
                    else if (this.wallMode) for (const t1 of u.geometry)for (const i of Np(t1, h))this.addFeature(u, [
                        i
                    ], o, r, {}, e.availableImages, n, e.brightness);
                    else this.addFeature(u, u.geometry, o, r, {}, e.availableImages, n, e.brightness);
                    e.featureIndex.insert(i, u.geometry, o, a, this.index, c);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const t1 of this.features){
                    const o = "Polygon" === jp[t1.type], { geometry: a } = t1;
                    if (this.wallMode) for (const l of a)for (const a of Np(l, o))this.addFeature(t1, [
                        a
                    ], t1.index, e, r, n, i, s);
                    else this.addFeature(t1, a, t1.index, e, r, n, i, s);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(t1, e, r, n, i, s, o) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, this.worldview), this.groundEffect.update(t1, e, i, r, n, s, o, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, zp), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t1.createVertexBuffer(this.wallVertexArray, Mp.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t1.createVertexBuffer(this.layoutVertexExtArray, Sp.members, !0)), this.groundEffect.upload(t1)), this.groundEffect.uploadPaintProperties(t1), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            uploadCentroid(t1) {
                this.groundEffect.uploadHiddenByLandmark(t1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, Ap.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e, r, n, i, s, o, a) {
                const l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, u = [
                    new bt(0, 0),
                    new bt(Cn, Cn)
                ], c = o.projection, h = "globe" === c.name, p = this.wallMode || "Polygon" === jp[t1.type], f = new ef;
                f.centroidDataIndex = this.centroidData.length;
                const d = new tf, m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, n) <= 0, y = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, n);
                let g;
                if (d.height = y, d.vertexArrayOffset = this.layoutVertexArray.length, d.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new fa), this.wallMode) {
                    if (h) return void Gt("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== e.length) return;
                    g = function(t1) {
                        const e = t1[0].x === t1[t1.length - 1].x && t1[0].y === t1[t1.length - 1].y, r = function(t1) {
                            let e = 0;
                            const r = t1.length;
                            for(let n = 0; n < r; n++)e += (t1[(n + 1) % r].x - t1[n].x) * (t1[(n + 1) % r].y + t1[n].y);
                            return e >= 0;
                        }(t1);
                        r || (t1 = t1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, i = [], s = [], o = [];
                        let a = t1.length;
                        for(; a >= 2 && t1[a - 1].equals(t1[a - 2]);)a--;
                        if (a < (e ? 3 : 2)) return n;
                        let l, u, c, h, p, f = 0;
                        for(; f < a - 1 && t1[f].equals(t1[f + 1]);)f++;
                        e && (l = t1[a - 2], p = t1[f].sub(l)._unit()._perp());
                        for(let r = f; r < a; r++){
                            if (c = r === a - 1 ? e ? t1[f + 1] : void 0 : t1[r + 1], c && t1[r].equals(c)) continue;
                            p && (h = p), l && (u = l), l = t1[r], p = c ? c.sub(l)._unit()._perp() : h, h = h || p;
                            let n = h.add(p);
                            0 === n.x && 0 === n.y || n._unit();
                            const d = n.x * p.x + n.y * p.y, m = 0 !== d ? 1 / d : 1 / 0, y = h.x * p.y - h.y * p.x > 0;
                            let g = "miter";
                            const x = 2;
                            "miter" === g && m > x && (g = "bevel"), "bevel" === g && (m > 100 && (g = "flipbevel"), m < x && (g = "miter"));
                            const v = (t1, e, r, n)=>{
                                const a = new bt(t1.x, t1.y), l = new bt(t1.x, t1.y);
                                a.x += e.x * n, a.y += e.y * n, l.x -= e.x * Math.max(r, 1), l.y -= e.y * Math.max(r, 1), o.push(e), i.push(a), s.push(l);
                            };
                            if ("miter" === g) n._mult(m), v(l, n, 0, 0);
                            else if ("flipbevel" === g) n = p.mult(-1), v(l, n, 0, 0), v(l, n.mult(-1), 0, 0);
                            else {
                                const t1 = -Math.sqrt(m * m - 1), e = y ? t1 : 0, r = y ? 0 : t1;
                                u && v(l, h, e, r), c && v(l, p, e, r);
                            }
                        }
                        n.geometry = [
                            ...i,
                            ...s.reverse(),
                            i[0]
                        ], n.joinNormals = [
                            ...o,
                            ...o.reverse(),
                            o[o.length - 1]
                        ];
                        const d = n.geometry.length - 1;
                        for(let t1 = 0; t1 < d / 2; t1++)if (t1 + 1 < d / 2) {
                            let e = t1, r = t1 + 1, i = d - 1 - t1, s = d - 2 - t1;
                            e = 0 === e ? d - 1 : e - 1, r = 0 === r ? d - 1 : r - 1, i = 0 === i ? d - 1 : i - 1, s = 0 === s ? d - 1 : s - 1, n.indices.push(i), n.indices.push(r), n.indices.push(e), n.indices.push(i), n.indices.push(s), n.indices.push(r);
                        }
                        return n;
                    }(e[0]), e = [
                        g.geometry
                    ];
                }
                const x = (t1, e)=>t1 < (e.length - 1) / 2 || t1 === e.length - 1, v = this.wallMode ? [
                    e
                ] : Wh(e, 500);
                for(let t1 = v.length - 1; t1 >= 0; t1--){
                    const e = v[t1];
                    (0 === e.length || (b = e[0]).every((t1)=>t1.x <= 0) || b.every((t1)=>t1.x >= Cn) || b.every((t1)=>t1.y <= 0) || b.every((t1)=>t1.y >= Cn)) && v.splice(t1, 1);
                }
                var b;
                let w;
                if (h) w = yf(v, u, n);
                else {
                    w = [];
                    for (const t1 of v)w.push({
                        polygon: t1,
                        bounds: u
                    });
                }
                const _ = p ? this.edgeRadius : 0, A = _ > 0 && this.zoom < 17, M = (t1, e)=>{
                    if (0 === t1.length) return !1;
                    const r = t1[t1.length - 1];
                    return e.x === r.x && e.y === r.y;
                };
                for (const { polygon: t1, bounds: e } of w){
                    let r = 0, i = 0;
                    for (const e of t1)p && !e[0].equals(e[e.length - 1]) && e.push(e[0]), i += p ? e.length - 1 : e.length;
                    const s = this.segments.prepareSegment((p ? 5 : 4) * i, this.layoutVertexArray, this.indexArray);
                    d.footprintSegIdx < 0 && (d.footprintSegIdx = this.footprintSegments.length), d.polygonSegIdx < 0 && (d.polygonSegIdx = this.polygonSegments.length);
                    const o = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, a = new Qp;
                    if (a.vertexOffset = this.footprintVertices.length, a.indexOffset = 3 * this.footprintIndices.length, a.ringIndices = [], p) {
                        const i = [], o = [];
                        r = s.vertexLength;
                        for(let r = 0; r < t1.length; r++){
                            const u = t1[r];
                            u.length && 0 !== r && o.push(i.length / 2);
                            const p = [];
                            let f, d;
                            f = u[1].sub(u[0])._perp()._unit(), a.ringIndices.push(u.length - 1);
                            for(let t1 = 1; t1 < u.length; t1++){
                                const e = u[t1], r = u[t1 === u.length - 1 ? 1 : t1 + 1], o = e.clone();
                                if (_) {
                                    d = r.sub(e)._perp()._unit();
                                    const t1 = f.add(d)._unit(), n = _ * Math.min(4, 1 / (f.x * t1.x + f.y * t1.y));
                                    o.x += n * t1.x, o.y += n * t1.y, o.x = Math.round(o.x), o.y = Math.round(o.y), f = d;
                                }
                                if (!m || 0 !== _ && !A || M(p, o) || p.push(o), Wp(this.layoutVertexArray, o.x, o.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const e = x(t1, u);
                                    Yp(this.wallVertexArray, g.joinNormals[t1], !e);
                                }
                                s.vertexLength++, this.footprintVertices.emplaceBack(e.x, e.y), i.push(e.x, e.y), h && Jp(this.layoutVertexExtArray, c.projectTilePoint(o.x, o.y, n), c.upVector(n, o.x, o.y));
                            }
                            m && (0 === _ || A) && (0 !== p.length && M(p, p[0]) && p.pop(), this.groundEffect.addData(p, e, l));
                        }
                        const u = this.wallMode ? g.indices : Ah(i, o);
                        for(let t1 = 0; t1 < u.length; t1 += 3)this.footprintIndices.emplaceBack(a.vertexOffset + u[t1 + 0], a.vertexOffset + u[t1 + 1], a.vertexOffset + u[t1 + 2]), this.indexArray.emplaceBack(r + u[t1], r + u[t1 + 2], r + u[t1 + 1]), s.primitiveLength++;
                        a.indexCount += u.length, a.vertexCount += this.footprintVertices.length - a.vertexOffset;
                    }
                    for(let i = 0; i < t1.length; i++){
                        const o = t1[i];
                        f.startRing(d, o[0]);
                        let a = o.length > 4 && ff(o[o.length - 2], o[0], o[1]), u = _ ? uf(o[o.length - 2], o[0], o[1], _) : 0;
                        const y = [];
                        let v, b, w;
                        b = o[1].sub(o[0])._perp()._unit();
                        let A = !0;
                        for(let t1 = 1, i = 0; t1 < o.length; t1++){
                            let l = o[t1 - 1], p = o[t1];
                            const I = o[t1 === o.length - 1 ? 1 : t1 + 1];
                            if (f.appendEdge(d, p, l), hf(p, l, e)) {
                                _ && (b = I.sub(p)._perp()._unit(), A = !A);
                                continue;
                            }
                            const S = p.sub(l)._perp(), z = S.x / (Math.abs(S.x) + Math.abs(S.y)), k = S.y > 0 ? 1 : 0, P = l.dist(p);
                            if (i + P > 32768 && (i = 0), _) {
                                w = I.sub(p)._perp()._unit();
                                let t1 = cf(l, p, I, lf(b, w), _);
                                isNaN(t1) && (t1 = 0);
                                const e = p.sub(l)._unit();
                                l = l.add(e.mult(u))._round(), p = p.add(e.mult(-t1))._round(), u = t1, b = w, m && this.zoom >= 17 && (M(y, l) || y.push(l), M(y, p) || y.push(p));
                            }
                            const E = s.vertexLength, T = o.length > 4 && ff(l, p, I);
                            let B = df(i, a, A);
                            if (Wp(this.layoutVertexArray, l.x, l.y, z, k, 0, 0, B), Wp(this.layoutVertexArray, l.x, l.y, z, k, 0, 1, B), this.wallMode) {
                                const e = x(t1 - 1, o), r = g.joinNormals[t1 - 1];
                                Yp(this.wallVertexArray, r, e), Yp(this.wallVertexArray, r, e);
                            }
                            if (i += P, B = df(i, T, !A), a = T, Wp(this.layoutVertexArray, p.x, p.y, z, k, 0, 0, B), Wp(this.layoutVertexArray, p.x, p.y, z, k, 0, 1, B), this.wallMode) {
                                const e = x(t1, o), r = g.joinNormals[t1];
                                Yp(this.wallVertexArray, r, e), Yp(this.wallVertexArray, r, e);
                            }
                            if (s.vertexLength += 4, this.indexArray.emplaceBack(E + 0, E + 1, E + 2), this.indexArray.emplaceBack(E + 1, E + 3, E + 2), s.primitiveLength += 2, _) {
                                const n = r + (1 === t1 ? o.length - 2 : t1 - 2), i = 1 === t1 ? r : n + 1;
                                if (this.indexArray.emplaceBack(E + 1, n, E + 3), this.indexArray.emplaceBack(n, i, E + 3), s.primitiveLength += 2, void 0 === v && (v = E), !hf(I, o[t1], e)) {
                                    const e = t1 === o.length - 1 ? v : s.vertexLength;
                                    this.indexArray.emplaceBack(E + 2, E + 3, e), this.indexArray.emplaceBack(E + 3, e + 1, e), this.indexArray.emplaceBack(E + 3, i, e + 1), s.primitiveLength += 3;
                                }
                                A = !A;
                            }
                            if (h) {
                                const t1 = this.layoutVertexExtArray, e = c.projectTilePoint(l.x, l.y, n), r = c.projectTilePoint(p.x, p.y, n), i = c.upVector(n, l.x, l.y), s = c.upVector(n, p.x, p.y);
                                Jp(t1, e, i), Jp(t1, e, i), Jp(t1, r, s), Jp(t1, r, s);
                            }
                        }
                        p && (r += o.length - 1), m && _ && this.zoom >= 17 && (0 !== y.length && M(y, y[0]) && y.pop(), this.groundEffect.addData(y, e, l, _ > 0));
                    }
                    this.footprintSegments.push(a), o.triangleCount = this.indexArray.length - o.triangleArrayOffset, this.polygonSegments.push(o), ++d.footprintSegLen, ++d.polygonSegLen;
                }
                if (d.vertexCount = this.layoutVertexArray.length - d.vertexArrayOffset, d.groundVertexCount = this.groundEffect.vertexArray.length - d.groundVertexArrayOffset, 0 !== d.vertexCount) {
                    if (d.centroidXY = f.borders ? Xp : this.encodeCentroid(f, d), this.centroidData.push(d), f.borders) {
                        this.featuresOnBorder.push(f);
                        const t1 = this.featuresOnBorder.length - 1;
                        for(let e = 0; e < f.borders.length; e++)f.borders[e][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e].push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n, a, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t1, r, i, s, n, a, this.worldview), this.maxHeight = Math.max(this.maxHeight, y);
                }
            }
            sortBorders() {
                for(let t1 = 0; t1 < this.borderFeatureIndices.length; t1++)this.borderFeatureIndices[t1].sort((e, r)=>this.featuresOnBorder[e].borders[t1][0] - this.featuresOnBorder[r].borders[t1][0]);
            }
            splitToSubtiles() {
                const t1 = [];
                for(let e = 0; e < this.centroidData.length; e++){
                    const r = this.centroidData[e], n = +(r.min.y + r.max.y > Cn), i = 2 * n + (+(r.min.x + r.max.x > Cn) ^ n);
                    for(let n = 0; n < r.polygonSegLen; n++){
                        const s = r.polygonSegIdx + n;
                        t1.push({
                            centroidIdx: e,
                            subtile: i,
                            polygonSegmentIdx: s,
                            triangleSegmentIdx: this.polygonSegments[s].triangleSegIdx
                        });
                    }
                }
                const e = new Aa;
                t1.sort((t1, e)=>t1.triangleSegmentIdx === e.triangleSegmentIdx ? t1.subtile - e.subtile : t1.triangleSegmentIdx - e.triangleSegmentIdx);
                let r = 0, n = 0, i = 0;
                for (const e of t1){
                    if (e.triangleSegmentIdx !== r) break;
                    i++;
                }
                const s = t1.length;
                for(; n !== t1.length;){
                    r = t1[n].triangleSegmentIdx;
                    let o = 0, a = n, l = n;
                    for(let e = a; e < i && t1[e].subtile === o; e++)l++;
                    for(; a !== i;){
                        const n = t1[a];
                        o = n.subtile;
                        const s = this.centroidData[n.centroidIdx].min.clone(), u = this.centroidData[n.centroidIdx].max.clone(), c = {
                            vertexOffset: this.segments.segments[r].vertexOffset,
                            primitiveOffset: e.length,
                            vertexLength: this.segments.segments[r].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let r = a; r < l; r++){
                            const n = t1[r], i = this.polygonSegments[n.polygonSegmentIdx], o = this.centroidData[n.centroidIdx].min, a = this.centroidData[n.centroidIdx].max, l = this.indexArray.uint16;
                            for(let t1 = i.triangleArrayOffset; t1 < i.triangleArrayOffset + i.triangleCount; t1++)e.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
                            c.primitiveLength += i.triangleCount, s.x = Math.min(s.x, o.x), s.y = Math.min(s.y, o.y), u.x = Math.max(u.x, a.x), u.y = Math.max(u.y, a.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: s,
                            max: u
                        }), a = l;
                        for(let e = a; e < i && t1[e].subtile === t1[a].subtile; e++)l++;
                    }
                    n = i;
                    for(let e = n; e < s && t1[e].triangleSegmentIdx === t1[n].triangleSegmentIdx; e++)i++;
                }
                e._trim(), this.indexArray = e;
            }
            getVisibleSegments(t1, e, r) {
                const n = new tl;
                if (this.wallMode) {
                    for (const t1 of this.triangleSubSegments)n.segments.push(t1.segment);
                    return n;
                }
                let i = 0, s = 0;
                const o = 1 << t1.canonical.z;
                if (e) {
                    const r = e.getMinMaxForTile(t1);
                    r && (i = r.min, s = r.max);
                }
                s += this.maxHeight;
                const a = t1.toUnwrapped();
                let l;
                const u = [
                    a.canonical.x / o + a.wrap,
                    a.canonical.y / o
                ], c = [
                    (a.canonical.x + 1) / o + a.wrap,
                    (a.canonical.y + 1) / o
                ], h = (t1, e, r)=>[
                        t1[0] * (1 - r[0]) + e[0] * r[0],
                        t1[1] * (1 - r[1]) + e[1] * r[1]
                    ], p = [], f = [];
                for (const t1 of this.triangleSubSegments){
                    p[0] = t1.min.x / Cn, p[1] = t1.min.y / Cn, f[0] = t1.max.x / Cn, f[1] = t1.max.y / Cn;
                    const e = h(u, c, p), o = h(u, c, f);
                    if (0 === new qu([
                        e[0],
                        e[1],
                        i
                    ], [
                        o[0],
                        o[1],
                        s
                    ]).intersectsPrecise(r)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const a = t1.segment;
                    l && l.vertexOffset !== a.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += a.vertexLength, l.primitiveLength += a.primitiveLength) : l = {
                        vertexOffset: a.vertexOffset,
                        primitiveLength: a.primitiveLength,
                        vertexLength: a.vertexLength,
                        primitiveOffset: a.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(t1, e) {
                const r = t1.centroid(), n = e.span(), i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), s = Math.min(7, Math.round(n.y * this.tileToMeter / 10));
                return new bt(Et(r.x, 1, Cn - 1) << 3 | i, Et(r.y, 1, Cn - 1) << 3 | s);
            }
            encodeBorderCentroid(t1) {
                if (!t1.borders) return new bt(0, 0);
                const e = t1.borders, r = Number.MAX_VALUE;
                if (e[0][0] !== r || e[1][0] !== r) {
                    const t1 = e[0][0] !== r ? 0 : 1;
                    return new bt(6 | (e[0][0] !== r ? 0 : 65528), (e[t1][0] + e[t1][1]) / 2 << 3 | 6);
                }
                {
                    const t1 = e[2][0] !== r ? 2 : 3;
                    return new bt((e[t1][0] + e[t1][1]) / 2 << 3 | 6, 6 | (e[2][0] !== r ? 0 : 65528));
                }
            }
            showCentroid(t1) {
                const e = this.centroidData[t1.centroidDataIndex];
                e.flags &= Zp, e.centroidXY.x = 0, e.centroidXY.y = 0, this.writeCentroidToBuffer(e);
            }
            writeCentroidToBuffer(t1) {
                this.groundEffect.updateHiddenByLandmark(t1);
                const e = t1.vertexArrayOffset, r = t1.vertexCount + t1.vertexArrayOffset, n = t1.flags & Zp ? Xp : t1.centroidXY, i = this.centroidVertexArray.geta_centroid_pos0(e);
                if (this.centroidVertexArray.geta_centroid_pos1(e) !== n.y || i !== n.x) {
                    for(let t1 = e; t1 < r; ++t1)this.centroidVertexArray.emplace(t1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
            }
            updateReplacement(t1, e, r) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const n = e.getReplacementRegionsForTile(t1.toUnwrapped());
                if (Vp(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const t1 of this.centroidData)t1.flags &= 2147483647;
                const i = [];
                for (const e of this.activeReplacements){
                    if (e.order < r) continue;
                    const n = Math.max(1, Math.pow(2, e.footprintTileId.canonical.z - t1.canonical.z));
                    for (const r of this.centroidData)if (!(r.flags & Zp || e.min.x > r.max.x || r.min.x > e.max.x || e.min.y > r.max.y || r.min.y > e.max.y)) for(let s = 0; s < r.footprintSegLen; s++){
                        const o = this.footprintSegments[r.footprintSegIdx + s];
                        if (i.length = 0, gf(this.footprintVertices, o.vertexOffset, o.vertexCount, e.footprintTileId.canonical, t1.canonical, i), Dp(e.footprint, i, this.footprintIndices.uint16, o.indexOffset, o.indexCount, -o.vertexOffset, -n)) {
                            r.flags |= Zp;
                            break;
                        }
                    }
                }
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(t1, e, r) {
                let n = !1;
                for(let i = 0; i < r.footprintSegLen; i++){
                    const s = this.footprintSegments[r.footprintSegIdx + i];
                    let o = 0;
                    for (const r of s.ringIndices){
                        for(let i = o, a = r + o - 1; i < r + o; a = i++){
                            const r = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 0], o = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (a + s.vertexOffset) + 1];
                            o > e != l > e && t1 < (this.footprintVertices.int16[2 * (a + s.vertexOffset) + 0] - r) * (e - o) / (l - o) + r && (n = !n);
                        }
                        o = r;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(t1, e) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (t1 + Cn) * Cn + (e + Cn);
                if (this.partLookup.hasOwnProperty(i)) {
                    const t1 = this.partLookup[i];
                    return t1 ? {
                        height: t1.height,
                        hidden: !!(t1.flags & Zp)
                    } : void 0;
                }
                for (const s of this.centroidData)t1 > s.max.x || s.min.x > t1 || e > s.max.y || s.min.y > e || this.footprintContainsPoint(t1, e, s) && s && s.height > r && (r = s.height, this.partLookup[i] = s, n = !!(s.flags & Zp));
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.partLookup[i] = void 0;
            }
        }
        function lf(t1, e) {
            const r = t1.add(e)._unit();
            return t1.x * r.x + t1.y * r.y;
        }
        function uf(t1, e, r, n) {
            const i = e.sub(t1)._perp()._unit(), s = r.sub(e)._perp()._unit();
            return cf(t1, e, r, lf(i, s), n);
        }
        function cf(t1, e, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(t1.dist(e) / 3, e.dist(r) / 3, i * s / n);
        }
        function hf(t1, e, r) {
            return t1.x < r[0].x && e.x < r[0].x || t1.x > r[1].x && e.x > r[1].x || t1.y < r[0].y && e.y < r[0].y || t1.y > r[1].y && e.y > r[1].y;
        }
        function pf(t1, e) {
            return t1.x < e[0].x || t1.x > e[1].x || t1.y < e[0].y || t1.y > e[1].y;
        }
        function ff(t1, e, r) {
            if (t1.x < 0 || t1.x >= Cn || e.x < 0 || e.x >= Cn || r.x < 0 || r.x >= Cn) return !1;
            const n = r.sub(e), i = n.perp(), s = t1.sub(e);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function df(t1, e, r) {
            const n = e ? 2 | t1 : -3 & t1;
            return r ? 1 | n : -2 & n;
        }
        function mf() {
            const t1 = Math.PI / 32, e = Math.tan(t1), r = Gl;
            return r * Math.sqrt(1 + 2 * e * e) - r;
        }
        function yf(t1, e, r) {
            const n = 1 << r.z, i = tu(r.x / n), s = tu((r.x + 1) / n), o = eu(r.y / n), a = eu((r.y + 1) / n);
            return function(t1, e, r, n, i = 0, s) {
                const o = [];
                if (!t1.length || !r || !n) return o;
                const a = (t1, e)=>{
                    for (const r of t1)o.push({
                        polygon: r,
                        bounds: e
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let t1 = 0; t1 < Math.abs(c); t1++)h.push(c > 0 ? 0 : 1);
                for(let t1 = 0; t1 < Math.min(l, u); t1++)h.push(0), h.push(1);
                let p = t1;
                if (p = ap(p, e[0].y - i, e[1].y + i, 1), p = ap(p, e[0].x - i, e[1].x + i, 0), !p.length) return o;
                const f = [];
                for(h.length ? f.push({
                    polygons: p,
                    bounds: e,
                    depth: 0
                }) : a(p, e); f.length;){
                    const t1 = f.pop(), e = t1.depth, r = h[e], n = t1.bounds[0], o = t1.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? o.x : o.y, c = s ? s(r, l, u) : .5 * (l + u), p = ap(t1.polygons, l - i, c + i, r), d = ap(t1.polygons, c - i, u + i, r);
                    if (p.length) {
                        const t1 = [
                            n,
                            new bt(0 === r ? c : o.x, 1 === r ? c : o.y)
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: p,
                            bounds: t1,
                            depth: e + 1
                        }) : a(p, t1);
                    }
                    if (d.length) {
                        const t1 = [
                            new bt(0 === r ? c : n.x, 1 === r ? c : n.y),
                            o
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: d,
                            bounds: t1,
                            depth: e + 1
                        }) : a(d, t1);
                    }
                }
                return o;
            }(t1, e, Math.ceil((s - i) / 11.25), Math.ceil((o - a) / 11.25), 1, (t1, e, i)=>{
                if (0 === t1) return .5 * (e + i);
                {
                    const t1 = eu((r.y + e / Cn) / n);
                    return (Jl(.5 * (eu((r.y + i / Cn) / n) + t1)) * n - r.y) * Cn;
                }
            });
        }
        function gf(t1, e, r, n, i, s) {
            const o = Math.pow(2, n.z - i.z);
            for(let a = 0; a < r; a++){
                let r = t1.int16[2 * (a + e) + 0], l = t1.int16[2 * (a + e) + 1];
                r = (r + i.x * Cn) * o - n.x * Cn, l = (l + i.y * Cn) * o - n.y * Cn, s.push(new bt(r, l));
            }
        }
        let xf, vf;
        qs(af, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), qs(tf, "PartData"), qs(Qp, "FootprintSegment"), qs(ef, "BorderCentroidData"), qs(of, "GroundEffect");
        class bf extends bt {
            constructor(t1, e, r){
                super(t1, e), this.z = r;
            }
        }
        class wf extends bf {
            constructor(t1, e, r, n){
                super(t1, e, r), this.w = n;
            }
        }
        function _f(t1, e, r, n) {
            const i = "x" === r ? "y" : "x", s = (n - t1[r]) / (e[r] - t1[r]);
            t1[i] = Math.round(t1[i] + (e[i] - t1[i]) * s), t1[r] = n, t1.hasOwnProperty("z") && (t1.z = ur(t1.z, e.z, s)), t1.hasOwnProperty("w") && (t1.w = ur(t1.w, e.w, s));
        }
        function Af(t1, e, r, n) {
            const i = r, s = n;
            for (const r of [
                "x",
                "y"
            ]){
                let n = t1, o = e;
                n[r] >= o[r] && (n = e, o = t1), n[r] < i && o[r] > i && _f(n, o, r, i), n[r] < s && o[r] > s && _f(o, n, r, s);
            }
        }
        function Mf(t1, e, r, n, i, s) {
            const o = [];
            for(let a = 0; a < t1.length; a++){
                const l = t1[a];
                let u;
                const c = o.length;
                let h = 0;
                for(let t1 = 0; t1 < l.length - 1; t1++){
                    let c = l[t1], p = l[t1 + 1], f = 0;
                    const d = h;
                    let m, y;
                    s && (f = Math.hypot(p.x - c.x, p.y - c.y), h += f, m = c, y = p), c.x < e && p.x < e || (c.x < e ? c = new bt(e, c.y + (e - c.x) / (p.x - c.x) * (p.y - c.y))._round() : p.x < e && (p = new bt(e, c.y + (e - c.x) / (p.x - c.x) * (p.y - c.y))._round()), c.y < r && p.y < r || (c.y < r ? c = new bt(c.x + (r - c.y) / (p.y - c.y) * (p.x - c.x), r)._round() : p.y < r && (p = new bt(c.x + (r - c.y) / (p.y - c.y) * (p.x - c.x), r)._round()), c.x >= n && p.x >= n || (c.x >= n ? c = new bt(n, c.y + (n - c.x) / (p.x - c.x) * (p.y - c.y))._round() : p.x >= n && (p = new bt(n, c.y + (n - c.x) / (p.x - c.x) * (p.y - c.y))._round()), c.y >= i && p.y >= i || (c.y >= i ? c = new bt(c.x + (i - c.y) / (p.y - c.y) * (p.x - c.x), i)._round() : p.y >= i && (p = new bt(c.x + (i - c.y) / (p.y - c.y) * (p.x - c.x), i)._round()), u && c.equals(u[u.length - 1]) || (u = [
                        c
                    ], o.push(u), s && s.push({
                        progress: {
                            min: d + Sf(m, y, c) * f,
                            max: 1
                        },
                        parentIndex: a,
                        prevPoint: m,
                        nextPoint: y
                    })), u.push(p), s && (s[s.length - 1].progress.max = d + Sf(m, y, p) * f, s[s.length - 1].nextPoint = y)))));
                }
                if (s && h > 0) for(let t1 = c; t1 < o.length; t1++)s[t1].progress.min /= h, s[t1].progress.max /= h;
            }
            return o;
        }
        function If(t1, e, r, n, i) {
            if (t1.length < 2) return void n.push(t1);
            const s = [];
            for(; e.valid();){
                const [r, n] = e.get();
                for(let e = 0; e < t1.length - 1; e++){
                    const i = t1[e], o = t1[e + 1], a = ic(i, o, r, n);
                    if (a) {
                        const [t1] = a, r = new bt(ur(i.x, o.x, t1), ur(i.y, o.y, t1));
                        s.push({
                            t: e + t1,
                            distance: 0,
                            point: r
                        });
                    }
                }
                e.next();
            }
            if (0 === s.length) return void n.push(t1);
            s.sort((t1, e)=>t1.t - e.t);
            let o = 0, a = 0, l = [];
            for(n.push(l); o !== t1.length;){
                if (a === s.length) {
                    for(; o !== t1.length;)0 !== l.length && l[l.length - 1].equals(t1[o]) || l.push(t1[o]), o++;
                    break;
                }
                s[a].t <= o ? (0 !== l.length && l[l.length - 1].equals(s[a].point) || l.push(s[a].point), s[a].t, a++) : (0 !== l.length && l[l.length - 1].equals(t1[o]) || l.push(t1[o]), o++);
            }
        }
        function Sf(t1, e, r) {
            return t1.x !== e.x ? (r.x - t1.x) / (e.x - t1.x) : t1.y !== e.y ? (r.y - t1.y) / (e.y - t1.y) : 0;
        }
        function zf(t1, e) {
            return t1.x * e.x + t1.y * e.y;
        }
        function kf(t1, e) {
            if (1 === t1.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const s = e[r], o = t1[0], a = i.sub(n), l = s.sub(n), u = o.sub(n), c = zf(a, a), h = zf(a, l), p = zf(l, l), f = zf(u, a), d = zf(u, l), m = c * p - h * h, y = (p * f - h * d) / m, g = (c * d - h * f) / m, x = n.z * (1 - y - g) + i.z * y + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        function Pf(t1, e, r, n, i, s, o, a) {
            const l = o * i.getElevationAt(t1, e, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? o * (s[0] / 7 - 450) : o * function(t1, e, r) {
                const n = Math.floor(e[0] / 8), i = Math.floor(e[1] / 8), s = 10 * (e[0] - 8 * n), o = 10 * (e[1] - 8 * i), a = t1.getElevationAt(n, i, !0, !0), l = t1.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (o * l - 1)), h = t1.tileCoordToPixel(n, i), p = 2 * u + 1, f = 2 * c + 1, d = function(t1, e, r, n, i) {
                    return [
                        t1.getElevationAtPixel(e, r, !0),
                        t1.getElevationAtPixel(e + i, r, !0),
                        t1.getElevationAtPixel(e, r + i, !0),
                        t1.getElevationAtPixel(e + n, r + i, !0)
                    ];
                }(t1, h.x - u, h.y - c, p, f), m = Math.abs(d[0] - d[1]), y = Math.abs(d[2] - d[3]), g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]), x = Math.min(.25, .5 * l * (m + y) / p), v = Math.min(.25, .5 * l * g / f);
                return a + Math.max(x * s, v * o);
            }(i, s, a) : l;
            return {
                base: l + (0 === r ? -1 : r),
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        class Ef {
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class Tf {
            constructor(){
                this.tasks = {}, this.taskQueue = [], Rt([
                    "process"
                ], this), this.invoker = new Ef(this.process), this.nextId = 0;
            }
            add(t1, e) {
                const r = this.nextId++, n = function({ type: t1, isSymbolTile: e, zoom: r }) {
                    return r = r || 0, "message" === t1 ? 0 : "maybePrepare" !== t1 || e ? "parseTile" !== t1 || e ? "parseTile" === t1 && e ? 300 - r : "maybePrepare" === t1 && e ? 400 - r : 500 : 200 - r : 100 - r;
                }(e);
                if (0 === n) {
                    t1();
                    return null;
                }
                return this.tasks[r] = {
                    fn: t1,
                    metadata: e,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                {
                    if (this.taskQueue = this.taskQueue.filter((t1)=>!!this.tasks[t1]), !this.taskQueue.length) return;
                    const t1 = this.pick();
                    if (null === t1) return;
                    const e = this.tasks[t1];
                    if (delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), !e) return;
                    e.fn();
                }
            }
            pick() {
                let t1 = null, e = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < e && (e = n.priority, t1 = r);
                }
                if (null === t1) return null;
                const r = this.taskQueue[t1];
                return this.taskQueue.splice(t1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
        }
        class Bf {
            constructor(t1, e, r){
                this.target = t1, this.parent = e, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, Rt([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new Tf;
            }
            send(t1, e, r, n, i = !1, s) {
                const o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[o] = r);
                const a = new Set;
                return this.target.postMessage({
                    id: o,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Zs(e, a)
                }, a), {
                    cancel: ()=>{
                        r && delete this.callbacks[o], this.target.postMessage({
                            id: o,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e = t1.data;
                if (!e) return;
                const r = e.id;
                if (r && (!e.targetMapId || this.mapId === e.targetMapId)) {
                    if ("<cancel>" === e.type) {
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1.cancel();
                    } else if (e.mustQueue || Zt(self)) {
                        const t1 = this.callbacks[r], n = this.scheduler.add(()=>this.processTask(r, e), t1 && t1.metadata || {
                            type: "message"
                        });
                        n && (this.cancelCallbacks[r] = n);
                    } else this.processTask(r, e);
                }
            }
            processTask(t1, e) {
                if (delete this.cancelCallbacks[t1], "<response>" === e.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e.error ? r(Ws(e.error)) : r(null, Ws(e.data)));
                } else {
                    const r = new Set, n = e.hasCallback ? (e, n)=>{
                        this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e ? Zs(e) : null,
                            data: Zs(n, r)
                        }, r);
                    } : ()=>{}, i = Ws(e.data);
                    if (this.parent[e.type]) this.parent[e.type](e.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e.type.split("."), { source: r, scope: s } = i;
                        this.parent.getWorkerSource(e.sourceMapId, t1[0], r, s)[t1[1]](i, n);
                    } else n(new Error(`Could not find function ${e.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }
        var Vf = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        const Cf = "mapboxgl_preloaded_worker_pool";
        class Ff {
            constructor(){
                this.active = {};
            }
            acquire(t1, e = Ff.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < e;)this.workers.push(null != Vf.workerClass ? new Vf.workerClass : new self.Worker(Vf.workerUrl, Vf.workerParams));
                return this.active[t1] = !0, this.workers.slice();
            }
            release(t1) {
                delete this.active[t1], this.workers && 0 === this.numActive() && (this.workers.forEach((t1)=>{
                    t1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Cf];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        Ff.workerCount = 2;
        class Df {
            constructor(t1, e, r = "Worker", n = Ff.workerCount){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = Dt();
                const i = this.workerPool.acquire(this.id, n);
                for(let t1 = 0; t1 < i.length; t1++){
                    const n = new Df.Actor(i[t1], e, this.id);
                    n.name = `${r} ${t1}`, this.actors.push(n);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(t1, e, r) {
                Vt(this.actors, (r, n)=>{
                    r.send(t1, e, n);
                }, r = r || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((t1)=>{
                    t1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        let Lf, Rf;
        function Of() {
            return Lf || (Lf = new Ff), Lf;
        }
        Df.Actor = Bf;
        class Uf {
            constructor(t1){
                this.module = t1;
            }
            createIntArray(t1) {
                const e = new Int32Array(t1), r = this.module.malloc(e.length * e.BYTES_PER_ELEMENT);
                return this.module.heap32.set(e, r / e.BYTES_PER_ELEMENT), r;
            }
            createFloatArray(t1) {
                const e = new Float32Array(t1), r = this.module.malloc(e.length * e.BYTES_PER_ELEMENT);
                return this.module.heapF32.set(e, r / e.BYTES_PER_ELEMENT), r;
            }
            createStringBuffer(t1) {
                const e = this.module.malloc(t1.length + 1);
                for(let r = 0; r < t1.length; ++r)this.module.heapU8[e + r] = t1.charCodeAt(r);
                return this.module.heapU8[e + t1.length] = 0, e;
            }
            readStringBuffer(t1) {
                let e = "";
                for(; 0 !== this.module.heapU8[t1];)e += String.fromCharCode(this.module.heapU8[t1]), ++t1;
                return e;
            }
            setStyle(t1) {
                const e = t1.entranceColorRgb, r = t1.facadeGlazingColorRgb, n = t1.roofColorRgb, i = t1.wallColorRgb, s = t1.normalScale;
                this.module.setStyle(e[0], e[1], e[2], r[0], r[1], r[2], n[0], n[1], n[2], i[0], i[1], i[2], s[0], s[1], s[2], t1.tileToMeters);
            }
            setAOOptions(t1, e) {
                this.module.setAOOptions(t1 ? 1 : 0, e);
            }
            setMetricOptions(t1, e) {
                this.module.setMetricOptions(t1 ? 1 : 0, e);
            }
            setFacadeOptions(t1, e, r) {
                this.module.setFacadeOptions(t1, e, r);
            }
            generateMesh(t1, e) {
                for (const e of t1){
                    const t1 = this.createStringBuffer(e.roofType), r = [
                        0
                    ], n = [];
                    for (const t1 of e.coordinates)if (Array.isArray(t1)) {
                        for (const e of t1)n.push(e.x), n.push(e.y);
                        r.push(n.length);
                    }
                    const i = this.createIntArray(r), s = this.createFloatArray(n);
                    this.module.addFeature(e.id, e.sourceId, e.minHeight, e.height, t1, e.roofType.length, s, i, r.length - 1), this.module.free(t1), this.module.free(i), this.module.free(s);
                }
                for (const t1 of e){
                    let e;
                    e = t1.entrances ? JSON.parse(t1.entrances) : [];
                    const r = this.createFloatArray(e), n = [];
                    for (const e of t1.coordinates)n.push(e.x), n.push(e.y);
                    const i = this.createFloatArray(n);
                    this.module.addFacade(t1.sourceId, t1.crossPerc, t1.distanceToRoad, r, e.length, i, n.length), this.module.free(r), this.module.free(i);
                }
                if (!this.module.generateMesh()) {
                    const t1 = this.module.getLastError();
                    return this.readStringBuffer(t1);
                }
                const r = this.module.getMeshCount(), n = new Array(r);
                for(let t1 = 0; t1 < r; t1++){
                    const e = this.module.getPositionsPtr(t1), r = this.module.getPositionsLength(t1), i = new Float32Array(this.module.heapF32.buffer, e, r), s = this.module.getNormalsPtr(t1), o = this.module.getNormalsLength(t1), a = new Float32Array(this.module.heapF32.buffer, s, o), l = this.module.getColorsPtr(t1), u = this.module.getColorsLength(t1), c = new Uint8Array(this.module.heapU8.buffer, l, u), h = this.module.getAOPtr(t1), p = this.module.getAOLength(t1), f = new Float32Array(this.module.heapF32.buffer, h, p), d = this.module.getIndicesPtr(t1), m = this.module.getIndicesLength(t1), y = new Int32Array(this.module.heap32.buffer, d, m), g = this.module.getBuildingPart(t1), x = this.readStringBuffer(g);
                    n[t1] = {
                        positions: i,
                        normals: a,
                        colors: c,
                        ao: f,
                        indices: y,
                        buildingPart: x
                    };
                }
                const i = this.module.getRingCount(), s = [];
                for(let t1 = 0; t1 < i; t1++){
                    const e = this.module.getRingPtr(t1), r = this.module.getRingLength(t1), n = new Float32Array(this.module.heapF32.buffer, e, r);
                    s.push(n);
                }
                return {
                    meshes: n,
                    modifiedPolygonRings: s
                };
            }
        }
        let Nf, jf, $f, Gf, qf, Hf = null, Xf = null, Zf = null, Wf = null;
        function Yf() {
            return Zt(self) && self.worker.dracoUrl ? self.worker.dracoUrl : jf || ne.DRACO_URL;
        }
        function Kf() {
            if (Zt(self) && self.worker.meshoptUrl) return self.worker.meshoptUrl;
            if (Gf) return Gf;
            const t1 = new Uint8Array([
                0,
                97,
                115,
                109,
                1,
                0,
                0,
                0,
                1,
                4,
                1,
                96,
                0,
                0,
                3,
                3,
                2,
                0,
                0,
                5,
                3,
                1,
                0,
                1,
                12,
                1,
                0,
                10,
                22,
                2,
                12,
                0,
                65,
                0,
                65,
                0,
                65,
                0,
                252,
                10,
                0,
                0,
                11,
                7,
                0,
                65,
                0,
                253,
                15,
                26,
                11
            ]);
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return Gf = WebAssembly.validate(t1) ? ne.MESHOPT_SIMD_URL : ne.MESHOPT_URL, Gf;
        }
        const Jf = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, Qf = {
            5120: "DT_INT8",
            5121: "DT_UINT8",
            5122: "DT_INT16",
            5123: "DT_UINT16",
            5125: "DT_UINT32",
            5126: "DT_FLOAT32"
        }, td = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function ed(t1, e, r) {
            const n = r.json.bufferViews.length, i = r.buffers.length;
            e.bufferView = n, r.json.bufferViews[n] = {
                buffer: i,
                byteLength: t1.byteLength
            }, r.buffers[i] = t1;
        }
        const rd = "KHR_draco_mesh_compression";
        function nd(t1, e) {
            const r = t1.extensions && t1.extensions[rd];
            if (!r) return;
            const n = new $f.Decoder, i = cd(e, r.bufferView), s = new $f.Mesh;
            if (!n.DecodeArrayToMesh(i, i.byteLength, s)) throw new Error("Failed to decode Draco mesh");
            const o = e.json.accessors[t1.indices], a = Jf[o.componentType], l = o.count * a.BYTES_PER_ELEMENT, u = $f._malloc(l);
            a === Uint16Array ? n.GetTrianglesUInt16Array(s, l, u) : n.GetTrianglesUInt32Array(s, l, u), ed($f.memory.buffer.slice(u, u + l), o, e), $f._free(u);
            for (const i of Object.keys(r.attributes)){
                const o = n.GetAttributeByUniqueId(s, r.attributes[i]), a = e.json.accessors[t1.attributes[i]], l = Qf[a.componentType], u = a.count * td[a.type] * Jf[a.componentType].BYTES_PER_ELEMENT, c = $f._malloc(u);
                n.GetAttributeDataArrayForAllPoints(s, o, $f[l], u, c), ed($f.memory.buffer.slice(c, c + u), a, e), $f._free(c);
            }
            n.destroy(), s.destroy(), delete t1.extensions[rd];
        }
        const id = "EXT_meshopt_compression";
        function sd(t1, e) {
            if (!t1.extensions || !t1.extensions[id]) return;
            const r = t1.extensions[id], n = new Uint8Array(e.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0), i = new Uint8Array(r.count * r.byteStride);
            qf.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), t1.buffer = e.buffers.length, t1.byteOffset = 0, e.buffers[t1.buffer] = i.buffer, delete t1.extensions[id];
        }
        const od = 1179937895, ad = new TextDecoder("utf8");
        function ld(t1, e) {
            return new URL(t1, e).href;
        }
        function ud(t1, e, r, n) {
            return fetch(ld(t1.uri, n)).then((t1)=>t1.arrayBuffer()).then((t1)=>{
                e.buffers[r] = t1;
            });
        }
        function cd(t1, e) {
            const r = t1.json.bufferViews[e];
            return new Uint8Array(t1.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
        }
        function hd(t1, e, r, n) {
            if (t1.uri) {
                const i = ld(t1.uri, n);
                return fetch(i).then((t1)=>t1.blob()).then((t1)=>createImageBitmap(t1)).then((t1)=>{
                    e.images[r] = t1;
                });
            }
            if (void 0 !== t1.bufferView) {
                const n = cd(e, t1.bufferView), i = new Blob([
                    n
                ], {
                    type: t1.mimeType
                });
                return createImageBitmap(i).then((t1)=>{
                    e.images[r] = t1;
                });
            }
        }
        function pd(t1, e = 0, r) {
            const n = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(t1, e, 1)[0] === od) {
                const r = new Uint32Array(t1, e);
                let i = 2;
                const s = (r[i++] >> 2) - 3, o = r[i++] >> 2;
                if (i++, n.json = JSON.parse(ad.decode(r.subarray(i, i + o))), i += o, i < s) {
                    const s = r[i++];
                    i++;
                    const o = e + (i << 2);
                    n.buffers[0] = t1.slice(o, o + s);
                }
            } else n.json = JSON.parse(ad.decode(new Uint8Array(t1, e)));
            const { buffers: i, images: s, meshes: o, extensionsUsed: a, bufferViews: l } = n.json;
            let u = Promise.resolve();
            if (i) {
                const t1 = [];
                for(let e = 0; e < i.length; e++){
                    const s = i[e];
                    s.uri ? t1.push(ud(s, n, e, r)) : n.buffers[e] || (n.buffers[e] = null);
                }
                u = Promise.all(t1);
            }
            return u.then(()=>{
                const t1 = [], e = a && a.includes(rd), i = a && a.includes(id);
                if (e && t1.push(function() {
                    if (!$f) return null != Nf ? Nf : (Nf = function(t1) {
                        let e, r = null;
                        function n() {
                            e = new Uint8Array(r.buffer);
                        }
                        function i() {
                            throw new Error("Unexpected Draco error.");
                        }
                        const s = {
                            a: {
                                a: i,
                                d: function(t1, r, n) {
                                    return e.copyWithin(t1, r, r + n);
                                },
                                c: function(t1) {
                                    const i = e.length, s = Math.max(t1 >>> 0, Math.ceil(1.2 * i)), o = Math.ceil((s - i) / 65536);
                                    try {
                                        return r.grow(o), n(), !0;
                                    } catch (t1) {
                                        return !1;
                                    }
                                },
                                b: i
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t1, s) : t1.then((t1)=>t1.arrayBuffer()).then((t1)=>WebAssembly.instantiate(t1, s))).then((t1)=>{
                            const { Rb: i, Qb: s, P: o, T: a, X: l, Ja: u, La: c, Qa: h, Va: p, Wa: f, eb: d, jb: m, f: y, e: g, yb: x, zb: v, Ab: b, Bb: w, Db: _, Gb: A } = t1.instance.exports;
                            r = g;
                            const M = (()=>{
                                let t1 = 0, r = 0, n = 0, o = 0;
                                return (a)=>{
                                    n && (i(o), i(t1), r += n, n = t1 = 0), t1 || (r += 128, t1 = s(r));
                                    const l = a.length + 7 & -8;
                                    let u = t1;
                                    l >= r && (n = l, u = o = s(l));
                                    for(let t1 = 0; t1 < a.length; t1++)e[u + t1] = a[t1];
                                    return u;
                                };
                            })();
                            return n(), y(), {
                                memory: g,
                                _free: i,
                                _malloc: s,
                                Mesh: class {
                                    constructor(){
                                        this.ptr = o();
                                    }
                                    destroy() {
                                        a(this.ptr);
                                    }
                                },
                                Decoder: class {
                                    constructor(){
                                        this.ptr = u();
                                    }
                                    destroy() {
                                        m(this.ptr);
                                    }
                                    DecodeArrayToMesh(t1, e, r) {
                                        const n = M(t1), i = c(this.ptr, n, e, r.ptr);
                                        return !!l(i);
                                    }
                                    GetAttributeByUniqueId(t1, e) {
                                        return {
                                            ptr: h(this.ptr, t1.ptr, e)
                                        };
                                    }
                                    GetTrianglesUInt16Array(t1, e, r) {
                                        p(this.ptr, t1.ptr, e, r);
                                    }
                                    GetTrianglesUInt32Array(t1, e, r) {
                                        f(this.ptr, t1.ptr, e, r);
                                    }
                                    GetAttributeDataArrayForAllPoints(t1, e, r, n, i) {
                                        d(this.ptr, t1.ptr, e.ptr, r, n, i);
                                    }
                                },
                                DT_INT8: x(),
                                DT_UINT8: v(),
                                DT_INT16: b(),
                                DT_UINT16: w(),
                                DT_UINT32: _(),
                                DT_FLOAT32: A()
                            };
                        });
                    }(fetch(Yf())), Nf.then((t1)=>{
                        $f = t1, Nf = void 0;
                    }));
                }()), i && t1.push(function() {
                    if (qf) return;
                    const t1 = function(t1) {
                        let e;
                        const r = WebAssembly.instantiateStreaming(t1, {}).then((t1)=>{
                            e = t1.instance, e.exports.__wasm_call_ctors();
                        }), n = {
                            NONE: "",
                            OCTAHEDRAL: "meshopt_decodeFilterOct",
                            QUATERNION: "meshopt_decodeFilterQuat",
                            EXPONENTIAL: "meshopt_decodeFilterExp"
                        }, i = {
                            ATTRIBUTES: "meshopt_decodeVertexBuffer",
                            TRIANGLES: "meshopt_decodeIndexBuffer",
                            INDICES: "meshopt_decodeIndexSequence"
                        };
                        return {
                            ready: r,
                            supported: !0,
                            decodeGltfBuffer (t1, r, s, o, a, l) {
                                !function(t1, e, r, n, i, s, o) {
                                    const a = t1.exports.sbrk, l = n + 3 & -4, u = a(l * i), c = a(s.length), h = new Uint8Array(t1.exports.memory.buffer);
                                    h.set(s, c);
                                    const p = e(u, n, i, c, s.length);
                                    if (0 === p && o && o(u, l, i), r.set(h.subarray(u, u + n * i)), a(u - a(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                                }(e, e.exports[i[a]], t1, r, s, o, e.exports[n[l]]);
                            }
                        };
                    }(fetch(Kf()));
                    return t1.ready.then(()=>{
                        qf = t1;
                    });
                }()), s) for(let e = 0; e < s.length; e++)t1.push(hd(s[e], n, e, r));
                return (t1.length ? Promise.all(t1) : Promise.resolve()).then(()=>{
                    if (e && o) for (const { primitives: t1 } of o)for (const e of t1)nd(e, n);
                    if (i && o && l) for (const t1 of l)sd(t1, n);
                    return n;
                });
            });
        }
        class fd {
            constructor(t1){
                this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.hasPattern = !1, this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {}
            prepare() {
                return function() {
                    if (null != Wf || null != Zf) return null;
                    if (null != Xf) return Xf;
                    const t1 = fetch(ne.BUILDING_GEN_URL);
                    return Xf = (function(t1) {
                        let e, r, n, i;
                        function s() {
                            e = new Uint8Array(i.buffer), r = new Int32Array(i.buffer), n = new Float32Array(i.buffer);
                        }
                        function o() {
                            throw new Error("Unexpected BuildingGen error.");
                        }
                        const a = ()=>{}, l = {
                            a: {
                                a: o,
                                f: function(t1) {
                                    const r = e.length, n = Math.max(t1 >>> 0, Math.ceil(1.2 * r)), o = Math.ceil((n - r) / 65536);
                                    try {
                                        return i.grow(o), s(), !0;
                                    } catch (t1) {
                                        return !1;
                                    }
                                },
                                g: o,
                                b: a,
                                c: a,
                                d: a,
                                e: a
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t1, l) : t1.then((t1)=>t1.arrayBuffer()).then((t1)=>WebAssembly.instantiate(t1, l))).then((t1)=>{
                            const o = t1.instance.exports;
                            return (0, o.g)(), i = o.f, s(), new Uf({
                                setStyle: o.h,
                                setAOOptions: o.i,
                                setMetricOptions: o.j,
                                setFacadeOptions: o.k,
                                addFeature: o.l,
                                addFacade: o.m,
                                generateMesh: o.n,
                                getLastError: o.o,
                                getMeshCount: o.p,
                                getPositionsPtr: o.q,
                                getPositionsLength: o.r,
                                getNormalsPtr: o.s,
                                getNormalsLength: o.t,
                                getColorsPtr: o.u,
                                getColorsLength: o.v,
                                getAOPtr: o.w,
                                getAOLength: o.x,
                                getIndicesPtr: o.y,
                                getIndicesLength: o.z,
                                getBuildingPart: o.A,
                                getRingCount: o.B,
                                getRingPtr: o.C,
                                getRingLength: o.D,
                                free: o.E,
                                malloc: o.F,
                                heapU8: e,
                                heap32: r,
                                heapF32: n
                            });
                        });
                    })(t1).then((t1)=>(Xf = null, Wf = t1, Wf)).catch((t1)=>{
                        Gt("Could not load building-gen"), Xf = null, Zf = t1;
                    }), Xf;
                }();
            }
            populate(t1, e, r, n) {}
            update(t1, e, r, n, i, s, o) {}
            isEmpty() {
                return !1;
            }
            uploadPending() {
                return !1;
            }
            upload(t1) {}
            destroy() {}
            getHeightAtTileCoord(t1, e) {
                return {
                    height: Number.NEGATIVE_INFINITY,
                    hidden: !0
                };
            }
        }
        let dd, md;
        qs(fd, "BuildingBucket", {
            omit: [
                "layers"
            ]
        });
        const yd = ta([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), gd = ta([
            {
                name: "a_z_offset_width",
                components: 3,
                type: "Float32"
            }
        ], 4), { members: xd } = yd, vd = ta([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: bd } = vd, wd = ta([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: _d } = wd;
        class Ad {
            constructor(t1, e){
                this.width = t1, this.height = e, this.nextRow = 0, this.image = new mh({
                    width: t1,
                    height: e
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(t1, e) {
                const r = this.getKey(t1, e);
                return this.positions[r];
            }
            trim() {
                const t1 = this.width, e = this.height = Lt(this.nextRow);
                this.image.resize({
                    width: t1,
                    height: e
                });
            }
            getKey(t1, e) {
                return t1.join(",") + e;
            }
            getDashRanges(t1, e, r) {
                const n = [];
                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, s = t1[0] * r, o = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: o,
                    zeroLength: 0 === t1[0]
                });
                let a = t1[0];
                for(let e = 1; e < t1.length; e++){
                    o = !o;
                    const l = t1[e];
                    i = a * r, a += l, s = a * r, n.push({
                        left: i,
                        right: s,
                        isDash: o,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(t1, e, r) {
                const n = e / 2;
                for(let e = -r; e <= r; e++){
                    const i = this.width * (this.nextRow + r + e);
                    let s = 0, o = t1[s];
                    for(let a = 0; a < this.width; a++){
                        a / o.right > 1 && (o = t1[++s]);
                        const l = Math.abs(a - o.left), u = Math.abs(a - o.right), c = Math.min(l, u);
                        let h;
                        const p = e / r * (n + 1);
                        if (o.isDash) {
                            const t1 = n - Math.abs(p);
                            h = Math.sqrt(c * c + t1 * t1);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + a] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(t1, e) {
                for(let e = t1.length - 1; e >= 0; --e){
                    const r = t1[e], n = t1[e + 1];
                    r.zeroLength ? t1.splice(e, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e, 1));
                }
                const r = t1[0], n = t1[t1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, o = t1[s];
                for(let r = 0; r < this.width; r++){
                    r / o.right > 1 && (o = t1[++s]);
                    const n = Math.abs(r - o.left), a = Math.abs(r - o.right), l = Math.min(n, a);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (o.isDash ? l : -l) + e + 128));
                }
            }
            addDash(t1, e) {
                const r = this.getKey(t1, e);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === e, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return Gt("LineAtlas out of space"), null;
                0 === t1.length && t1.push(1);
                let o = 0;
                for(let e = 0; e < t1.length; e++)t1[e] < 0 && (Gt("Negative value is found in line dasharray, replacing values with 0"), t1[e] = 0), o += t1[e];
                if (0 !== o) {
                    const r = this.width / o, s = this.getDashRanges(t1, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === e ? .5 * r : 0);
                }
                const a = this.nextRow + i;
                this.nextRow += s;
                const l = {
                    tl: [
                        a,
                        i
                    ],
                    br: [
                        o,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
        }
        qs(Ad, "LineAtlas");
        const Md = Pu.VectorTileFeature.types, Id = Math.cos(Math.PI / 180 * 37.5), Sd = Math.cos(Math.PI / 180 * 5);
        class zd {
            constructor(t1){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.elevationType = "none", this.zoom = t1.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = t1.overscaling, this.pixelRatio = t1.pixelRatio, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.projection = t1.projection, this.hasPattern = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new ua, this.layoutVertexArray2 = new ca, this.patternVertexArray = new ca, this.indexArray = new Aa, this.programConfigurations = new kl(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.segments = new tl, this.maxLineLength = 0, this.zOffsetVertexArray = new ca, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.tessellationStep = t1.tessellationStep ? t1.tessellationStep : Cn / 64, this.worldview = t1.worldview;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Jh("line", this.layers, this.pixelRatio, e);
                const i = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = au(r);
                const s = this.layers[0].layout.get("line-elevation-reference");
                if ("hd-road-markup" === s) this.elevationType = "road";
                else {
                    const t1 = this.layers[0].layout.get("line-z-offset"), e = t1.isConstant() && !t1.constantOr(0);
                    this.elevationType = "sea" !== s && "ground" !== s && e ? "none" : "offset", "offset" === this.elevationType && "none" === s && Gt(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`);
                }
                const o = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = "offset" === this.elevationType && void 0 !== o;
                const a = [];
                for (const { feature: e, id: s, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = gu(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), u, r)) continue;
                    const c = i ? i.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : yu(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t1, e)=>t1.sortKey - e.sortKey);
                const { lineAtlas: l, featureIndex: u } = e, c = this.addConstantDashes(l);
                for (const n of a){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    if (c && this.addFeatureDashes(n, l), this.hasPattern) {
                        const t1 = Qh("line", this.layers, n, this.zoom, this.pixelRatio, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, l.positions, e.availableImages, e.brightness, e.elevationFeatures);
                    u.insert(t1[s].feature, i, s, o, this.index);
                }
            }
            addConstantDashes(t1) {
                let e = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) e = !0;
                    else {
                        const e = i.value, r = n.value;
                        if (!r) continue;
                        t1.addDash(r, e);
                    }
                }
                return e;
            }
            addFeatureDashes(t1, e) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let o, a;
                    if ("constant" === i.kind) {
                        if (o = i.value, !o) continue;
                    } else o = i.evaluate({
                        zoom: r
                    }, t1);
                    a = "constant" === s.kind ? s.value : s.evaluate({
                        zoom: r
                    }, t1), e.addDash(o, a), t1.patterns[n.id] = [
                        e.getKey(o, a)
                    ];
                }
            }
            update(t1, e, r, n, i, s, o, a) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, a);
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e, r, n, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, bd)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t1.createVertexBuffer(this.patternVertexArray, _d)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, gd.members, !0)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, xd), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e, r, n, i, s, o, a) {
                const l = this.layers[0].layout, u = l.get("line-join").evaluate(t1, {}), c = l.get("line-cap").evaluate(t1, {}), h = l.get("line-miter-limit"), p = l.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1), this.lineFeature = t1, this.zOffsetValue = l.get("line-z-offset").value;
                const f = this.layers[0].paint.get("line-width").value;
                if ("constant" !== f.kind && !1 === f.isLineProgressConstant && (this.variableWidthValue = f), "road" === this.elevationType) {
                    const r = this.layoutVertexArray.length;
                    if (!this.addElevatedRoadFeature(t1, e, n, a, u, c, h, p)) {
                        const [i, s] = this.clipRuntimeLinesToTile(e, 1);
                        for(let e = 0; e < i.length; e++){
                            const r = i[e], o = s[e], a = {
                                progress: {
                                    min: o.progress.min,
                                    max: o.progress.max
                                },
                                nextDir: this.computeSegNextDir(o, r),
                                prevDir: this.computeSegPrevDir(o, r)
                            };
                            this.addLine(r, t1, n, u, c, h, p, a);
                        }
                        this.fillNonElevatedRoadSegment(r);
                    }
                } else for (const r of e)this.addLine(r, t1, n, u, c, h, p);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n, o, void 0, this.worldview);
            }
            computeSegNextDir(t1, e) {
                return t1.nextPoint.sub(e.at(-2)).unit();
            }
            computeSegPrevDir(t1, e) {
                return e[1].sub(t1.prevPoint).unit();
            }
            clipLinesToTile(t1, e) {
                return Mf(t1, -e, -e, Cn + e, Cn + e);
            }
            clipRuntimeLinesToTile(t1, e) {
                const r = [];
                return [
                    Mf(t1, -e, -e, Cn + e, Cn + e, r),
                    r
                ];
            }
            addElevatedRoadFeature(t1, e, r, n, i, s, o, a) {
                const l = [], u = Zu.getElevationFeature(t1, n);
                if (u) {
                    const t1 = this.clipLinesToTile(e, 1), n = this.prepareElevatedLines(t1, u, r);
                    for (const t1 of n)l.push({
                        geometry: t1,
                        elevation: u,
                        elevationTileID: r,
                        segment: {
                            progress: {
                                min: 0,
                                max: 1
                            },
                            nextDir: void 0,
                            prevDir: void 0
                        }
                    });
                }
                if (0 === l.length) return !1;
                for (const e of l){
                    const n = this.layoutVertexArray.length;
                    this.addLine(e.geometry, t1, r, i, s, o, a);
                    const l = new Wu(r, e.elevationTileID);
                    if (e.elevation) for(let t1 = n; t1 < this.layoutVertexArray.length; t1++){
                        const r = new bt(this.layoutVertexArray.int16[6 * t1] >> 1, this.layoutVertexArray.int16[6 * t1 + 1] >> 1), n = l.pointElevation(r, e.elevation, .05);
                        this.updateHeightRange(n), this.zOffsetVertexArray.emplaceBack(n, 0, 0);
                    }
                    else this.fillNonElevatedRoadSegment(n);
                }
                return !0;
            }
            prepareElevatedLines(t1, e, r) {
                if (null != e.constantHeight) return t1;
                const n = [], i = 1 / au(r);
                for (const r of t1)If(r, new Hu(e, i), 0, n);
                return n;
            }
            fillNonElevatedRoadSegment(t1) {
                for(let e = t1; e < this.layoutVertexArray.length; e++)this.zOffsetVertexArray.emplaceBack(0, 0, 0);
            }
            updateHeightRange(t1) {
                this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, t1), this.heightRange.max = Math.max(this.heightRange.max, t1)) : this.heightRange = {
                    min: t1,
                    max: t1
                };
            }
            addLine(t1, e, r, n, i, s, o, a) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0;
                const l = "none" === n;
                this.patternJoinNone = this.hasPattern && l, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
                const u = a && a.progress.min > 0, c = a && a.progress.max < 1;
                if (this.lineClips) {
                    let r = {
                        min: this.lineClips.start,
                        max: this.lineClips.end
                    }, n = 1;
                    if (a) {
                        const t1 = this.lineClips.end - this.lineClips.start;
                        r = function(t1, e, r) {
                            return {
                                min: re(t1.min, e, r),
                                max: re(t1.max, e, r)
                            };
                        }(a.progress, {
                            min: 0,
                            max: 1
                        }, r), t1 > 0 && (n = (r.max - r.min) / t1);
                    }
                    const i = +e.properties.mapbox_clip_feature_len, s = +e.properties.mapbox_clip_seg_len;
                    if (Number.isNaN(i) || Number.isNaN(s)) {
                        for(let e = 0; e < t1.length - 1; e++)this.totalDistance += t1[e].dist(t1[e + 1]);
                        const e = this.totalDistance / (r.max - r.min);
                        this.totalFeatureLength = Number.isFinite(e) ? e : 0, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    } else this.totalFeatureLength = i, this.distance = s * n, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.distance);
                    this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
                }
                const h = "Polygon" === Md[e.type];
                let p = t1.length;
                for(; p >= 2 && t1[p - 1].equals(t1[p - 2]);)p--;
                let f = 0;
                for(; f < p - 1 && t1[f].equals(t1[f + 1]);)f++;
                if (p < (h ? 3 : 2)) return;
                "bevel" === n && (s = 1.05);
                const d = this.segments.prepareSegment(10 * p, this.layoutVertexArray, this.indexArray);
                let m, y, g, x, v, b, w, _;
                a && a.prevDir && (b = a.prevDir.perp()), a && a.nextDir && (w = a.nextDir.perp()), this.e1 = this.e2 = -1, h && (m = t1[p - 2], v = t1[f].sub(m)._unit()._perp());
                for(let e = f; e < p; e++){
                    if (g = e === p - 1 ? h ? t1[f + 1] : void 0 : t1[e + 1], g && t1[e].equals(g)) continue;
                    v && (x = v), m && (y = m), m = t1[e], _ = this.evaluateLineProgressFeatures(y ? y.dist(m) : 0), v = g ? g.sub(m)._unit()._perp() : x, x = x || v;
                    const r = y && g;
                    let a = r ? n : h || l ? "butt" : i;
                    const A = x.x * v.x + x.y * v.y;
                    if (l) {
                        const t1 = function(t1) {
                            if (t1.patternJoinNone) {
                                const e = t1.segmentPoints.length / 2, r = t1.lineSoFar - t1.segmentStart;
                                for(let n = 0; n < e; ++n){
                                    const e = t1.segmentPoints[2 * n + 1], i = Math.round(t1.segmentPoints[2 * n]) + .5 + .25 * e;
                                    t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart), t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart);
                                }
                                t1.segmentPoints.length = 0;
                            }
                            t1.e1 = t1.e2 = -1;
                        };
                        if (r && A < Sd) {
                            this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, _), t1(this), this.addCurrentVertex(m, v, -1, -1, d, _);
                            continue;
                        }
                        if (y) {
                            if (!g) {
                                this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, _), t1(this);
                                continue;
                            }
                            a = "miter";
                        }
                    }
                    let M = x.add(v);
                    0 === M.x && 0 === M.y || M._unit();
                    const I = M.x * v.x + M.y * v.y, S = 0 !== I ? 1 / I : 1 / 0, z = 2 * Math.sqrt(2 - 2 * I), k = I < Id && y && g, P = x.x * v.y - x.y * v.x > 0, E = this.overscaling <= 16 ? 15 * Cn / (512 * this.overscaling) : 0;
                    if (r && "round" === a) {
                        if (S < o) a = "miter";
                        else if (S <= 2) {
                            const t1 = kd(m, -10, Cn + 10);
                            a = "offset" === this.elevationType && (t1 || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === a && S > s && (a = "bevel"), "bevel" === a && (S > 2 && (a = "flipbevel"), S < s && (a = "miter")), y && !("miter" === a && k) && this.updateDistance(y, m), "miter" === a) {
                        if (k) {
                            const t1 = m.dist(y);
                            if (t1 > 2 * E) {
                                const e = m.sub(m.sub(y)._mult(E / t1)._round());
                                this.updateDistance(y, e), this.addCurrentVertex(e, x, 0, 0, d, _), y = e;
                            }
                            this.updateDistance(y, m), M._mult(S), this.addCurrentVertex(m, M, 0, 0, d, _);
                            const e = m.dist(g);
                            if (e > 2 * E) {
                                const t1 = m.add(g.sub(m)._mult(E / e)._round());
                                this.updateDistance(m, t1), this.addCurrentVertex(t1, v, 0, 0, d, _), m = t1;
                            }
                        } else M._mult(S), this.addCurrentVertex(m, M, 0, 0, d, _);
                    } else if ("flipbevel" === a) {
                        if (S > 100) M = v.mult(-1);
                        else {
                            const t1 = S * x.add(v).mag() / x.sub(v).mag();
                            M._perp()._mult(t1 * (P ? -1 : 1));
                        }
                        this.addCurrentVertex(m, M, 0, 0, d, _), this.addCurrentVertex(m, M.mult(-1), 0, 0, d, _);
                    } else if ("bevel" === a || "fakeround" === a) {
                        null != _ && y && this.addCurrentVertex(m, w || x, -1, -1, d, _);
                        const t1 = m.dist(y) <= 2 * E && "bevel" !== a, e = M.mult(P ? 1 : -1);
                        e._mult(S);
                        const r = v.mult(P ? -1 : 1), n = x.mult(P ? -1 : 1), i = this.evaluateLineProgressFeatures(this.distance);
                        if (null == _ && (this.addHalfVertex(m, e.x, e.y, !1, !P, 0, d, i), t1 || this.addHalfVertex(m, e.x + 2 * n.x, e.y + 2 * n.y, !1, P, 0, d, i)), "fakeround" === a) {
                            const t1 = Math.round(180 * z / Math.PI / 20);
                            this.addHalfVertex(m, n.x, n.y, !1, P, 0, d, i);
                            for(let e = 0; e < t1; e++){
                                let s = e / t1;
                                if (.5 !== s) {
                                    const t1 = s - .5;
                                    s += s * t1 * (s - 1) * ((1.0904 + A * (A * (3.55645 - 1.43519 * A) - 3.2452)) * t1 * t1 + (.848013 + A * (.215638 * A - 1.06021)));
                                }
                                const o = r.sub(n)._mult(s)._add(n)._unit();
                                this.addHalfVertex(m, o.x, o.y, !1, P, 0, d, i);
                            }
                            this.addHalfVertex(m, r.x, r.y, !1, P, 0, d, i);
                        }
                        t1 || null != _ || this.addHalfVertex(m, e.x + 2 * r.x, e.y + 2 * r.y, !1, P, 0, d, i), null != _ && g && this.addCurrentVertex(m, b || v, 1, 1, d, _);
                    } else if ("butt" === a) this.addCurrentVertex(m, M, 0, 0, d, _);
                    else if ("square" === a) {
                        if (!y) {
                            const t1 = u ? 0 : -1;
                            this.addCurrentVertex(m, M, t1, t1, d, _);
                        }
                        if (this.addCurrentVertex(m, M, 0, 0, d, _), y) {
                            const t1 = c ? 0 : 1;
                            this.addCurrentVertex(m, M, t1, t1, d, _);
                        }
                    } else if ("round" === a) {
                        if (y) {
                            const t1 = !r && w ? w : x;
                            this.addCurrentVertex(m, t1, 0, 0, d, _), !r && c || this.addCurrentVertex(m, t1, 1, 1, d, _, !0);
                        }
                        if (g) {
                            const t1 = !r && b ? b : v;
                            !r && u || this.addCurrentVertex(m, t1, -1, -1, d, _, !0), this.addCurrentVertex(m, t1, 0, 0, d, _);
                        }
                    }
                }
            }
            addVerticesTo(t1, e, r, n, i, s, o, a, l, u) {
                const c = (e.w - t1.w) / this.tessellationStep | 0;
                let h = 0;
                const p = this.scaledDistance;
                if (c > 1) {
                    this.lineSoFar = t1.w;
                    const p = (e.x - t1.x) / c, f = (e.y - t1.y) / c, d = (e.z - t1.z) / c, m = (e.w - t1.w) / c;
                    for(let e = 1; e < c; ++e){
                        t1.x += p, t1.y += f, t1.z += d, this.lineSoFar += m, h += m;
                        const e = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(t1, r, n, u, !1, o, l, e), this.addHalfVertex(t1, i, s, u, !0, -a, l, e);
                    }
                }
                this.lineSoFar = e.w, this.scaledDistance = p;
                const f = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(e, r, n, u, !1, o, l, f), this.addHalfVertex(e, i, s, u, !0, -a, l, f);
            }
            evaluateLineProgressFeatures(t1) {
                if (!this.variableWidthValue && "offset" !== this.elevationType) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + t1) / this.totalFeatureLength) : Gt(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let e = 0;
                return this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (e = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0), "offset" !== this.elevationType ? {
                    zOffset: 0,
                    variableWidth: e
                } : "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: e
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: e
                };
            }
            addCurrentVertex(t1, e, r, n, i, s, o = !1) {
                const a = e.x + e.y * r, l = e.y - e.x * r, u = e.y * n - e.x, c = -e.y - e.x * n;
                if (null != s) {
                    const e = "offset" === this.elevationType, h = -10, p = Cn + 10, f = s.zOffset, d = new wf(t1.x, t1.y, f, this.lineSoFar), m = !!e && kd(t1, h, p), y = this.lineSoFar, g = this.distance;
                    if (this.currentVertex) {
                        if (m) {
                            const e = this.currentVertexIsOutside, s = this.currentVertex, m = new wf(t1.x, t1.y, f, this.lineSoFar);
                            if (Af(s, m, h, p), !kd(m, h, p)) {
                                if (e) {
                                    this.e1 = this.e2 = -1, this.distance -= s.dist(d), this.lineSoFar = s.w;
                                    const t1 = this.evaluateLineProgressFeatures(s.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(s, a, l, o, !1, r, i, t1), this.addHalfVertex(s, u, c, o, !0, -n, i, t1), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + s.dist(m), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(s, m, a, l, u, c, r, n, i, o), this.distance = g, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const t1 = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                Af(t1, d, h, p), this.e1 = this.e2 = -1, this.distance -= t1.dist(d), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t1.w;
                                const e = this.evaluateLineProgressFeatures(t1.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(t1, a, l, o, !1, r, i, e), this.addHalfVertex(t1, u, c, o, !0, -n, i, e), this.prevDistance = this.distance, this.distance = g, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(t1, d, a, l, u, c, r, n, i, o);
                        }
                    } else m || (this.addHalfVertex(t1, a, l, o, !1, r, i, s), this.addHalfVertex(t1, u, c, o, !0, -n, i, s));
                    this.currentVertex = d, this.currentVertexIsOutside = m, this.lineSoFar = y;
                } else this.addHalfVertex(t1, a, l, o, !1, r, i, s), this.addHalfVertex(t1, u, c, o, !0, -n, i, s);
            }
            addHalfVertex({ x: t1, y: e }, r, n, i, s, o, a, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s || this.segmentPoints.push(this.lineSoFar - this.segmentStart, o)), this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                    const t1 = ur(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, t1);
                }
                const u = a.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), a.primitiveLength++), s ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth);
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(t1, e) {
                this.prevDistance = this.distance, this.distance += t1.dist(e), this.updateScaledDistance();
            }
        }
        function kd(t1, e, r) {
            return t1.x < e || t1.x > r || t1.y < e || t1.y > r;
        }
        let Pd, Ed;
        function Td(t1, e, r) {
            return e * (Cn / (t1.tileSize * Math.pow(2, r - t1.tileID.overscaledZ)));
        }
        qs(zd, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const Bd = (t1, e, r)=>(1 - r) * t1 + r * e;
        function Vd(t1, e) {
            return 1 / Td(t1, 1, e.tileZoom);
        }
        function Cd(t1, e, r, n) {
            return t1.translatePosMatrix(n || e.tileID.projMatrix, e, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        const Fd = (t1)=>{
            const e = [];
            Dd(t1) && e.push("RENDER_LINE_DASH"), t1.paint.get("line-gradient") && e.push("RENDER_LINE_GRADIENT");
            const r = t1.paint.get("line-trim-offset");
            0 === r[0] && 0 === r[1] || e.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t1.paint.get("line-border-width").constantOr(1) && e.push("RENDER_LINE_BORDER");
            const n = "none" === t1.layout.get("line-join").constantOr("miter"), i = !!t1.paint.get("line-pattern").constantOr(1);
            return n && i && e.push("LINE_JOIN_NONE"), e;
        };
        function Dd(t1) {
            const e = t1.paint.get("line-dasharray").value;
            return e.value || "constant" !== e.kind;
        }
        let Ld;
        const Rd = ()=>Ld || (Ld = {
                layout: Pd || (Pd = new Po({
                    "line-cap": new zo(Eo.layout_line["line-cap"]),
                    "line-join": new zo(Eo.layout_line["line-join"]),
                    "line-miter-limit": new So(Eo.layout_line["line-miter-limit"]),
                    "line-round-limit": new So(Eo.layout_line["line-round-limit"]),
                    "line-sort-key": new zo(Eo.layout_line["line-sort-key"]),
                    "line-z-offset": new zo(Eo.layout_line["line-z-offset"]),
                    "line-elevation-reference": new So(Eo.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new So(Eo.layout_line["line-cross-slope"]),
                    visibility: new So(Eo.layout_line.visibility),
                    "line-width-unit": new So(Eo.layout_line["line-width-unit"])
                })),
                paint: Ed || (Ed = new Po({
                    "line-opacity": new zo(Eo.paint_line["line-opacity"]),
                    "line-color": new zo(Eo.paint_line["line-color"]),
                    "line-translate": new So(Eo.paint_line["line-translate"]),
                    "line-translate-anchor": new So(Eo.paint_line["line-translate-anchor"]),
                    "line-width": new zo(Eo.paint_line["line-width"]),
                    "line-gap-width": new zo(Eo.paint_line["line-gap-width"]),
                    "line-offset": new zo(Eo.paint_line["line-offset"]),
                    "line-blur": new zo(Eo.paint_line["line-blur"]),
                    "line-dasharray": new zo(Eo.paint_line["line-dasharray"]),
                    "line-pattern": new zo(Eo.paint_line["line-pattern"]),
                    "line-pattern-cross-fade": new So(Eo.paint_line["line-pattern-cross-fade"]),
                    "line-gradient": new ko(Eo.paint_line["line-gradient"]),
                    "line-trim-offset": new So(Eo.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new So(Eo.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new So(Eo.paint_line["line-trim-color"]),
                    "line-emissive-strength": new So(Eo.paint_line["line-emissive-strength"]),
                    "line-border-width": new zo(Eo.paint_line["line-border-width"]),
                    "line-border-color": new zo(Eo.paint_line["line-border-color"]),
                    "line-occlusion-opacity": new So(Eo.paint_line["line-occlusion-opacity"]),
                    "line-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, Ld);
        class Od extends zo {
            possiblyEvaluate(t1, e) {
                return e = new go(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    transition: e.transition,
                    worldview: e.worldview
                }), super.possiblyEvaluate(t1, e);
            }
            evaluate(t1, e, r, n) {
                return e = Ct({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t1, e, r, n);
            }
        }
        let Ud;
        function Nd(t1, e) {
            return e > 0 ? e + 2 * t1 : t1;
        }
        const jd = ta([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), $d = ta([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), Gd = ta([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        ta([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const qd = ta([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Hd = ta([
            {
                name: "a_x_axis",
                components: 3,
                type: "Float32"
            },
            {
                name: "a_y_axis",
                components: 3,
                type: "Float32"
            }
        ]), Xd = ta([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), Zd = ta([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), Wd = ta([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        ta([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Yd = ta([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Kd = ta([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        ta([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), ta([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), ta([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            },
            {
                type: "Uint16",
                name: "elevationFeatureIndex"
            }
        ]), ta([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), ta([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var Jd = 24;
        function Qd(t1, e, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), yo.applyArabicShaping && (t1 = yo.applyArabicShaping(t1)), t1;
                }(t1.text, e, r);
            }), t1;
        }
        const tm = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function em(t1) {
            return "\uFE36" === t1 || "\uFE48" === t1 || "\uFE38" === t1 || "\uFE44" === t1 || "\uFE42" === t1 || "\uFE3E" === t1 || "\uFE3C" === t1 || "\uFE3A" === t1 || "\uFE18" === t1 || "\uFE40" === t1 || "\uFE10" === t1 || "\uFE13" === t1 || "\uFE14" === t1 || "\uFF40" === t1 || "\uFFE3" === t1 || "\uFE11" === t1 || "\uFE12" === t1;
        }
        function rm(t1) {
            return "\uFE35" === t1 || "\uFE47" === t1 || "\uFE37" === t1 || "\uFE43" === t1 || "\uFE41" === t1 || "\uFE3D" === t1 || "\uFE3B" === t1 || "\uFE39" === t1 || "\uFE17" === t1 || "\uFE3F" === t1;
        }
        var nm, im, sm, om = {};
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ function am() {
            return nm || (nm = 1, om.read = function(t1, e, r, n, i) {
                var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e + h];
                for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += a; c > 0; s = 256 * s + t1[e + h], h += p, c -= 8);
                for(o = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; o = 256 * o + t1[e + h], h += p, c -= 8);
                if (0 === s) s = 1 - u;
                else {
                    if (s === l) return o ? NaN : 1 / 0 * (f ? -1 : 1);
                    o += Math.pow(2, n), s -= u;
                }
                return (f ? -1 : 1) * o * Math.pow(2, s - n);
            }, om.write = function(t1, e, r, n, i, s) {
                var o, a, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, o = c) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e += o + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= c ? (a = 0, o = c) : o + h >= 1 ? (a = (e * l - 1) * Math.pow(2, i), o += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + f] = 255 & a, f += d, a /= 256, i -= 8);
                for(o = o << i | a, u += i; u > 0; t1[r + f] = 255 & o, f += d, o /= 256, u -= 8);
                t1[r + f - d] |= 128 * m;
            }), om;
        }
        function lm() {
            if (sm) return im;
            sm = 1, im = e;
            var t1 = am();
            function e(t1) {
                this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
            var r = 4294967296, n = 1 / r, i = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
            function s(t1) {
                return t1.type === e.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
            }
            function o(t1, e, r) {
                return r ? 4294967296 * e + (t1 >>> 0) : 4294967296 * (e >>> 0) + (t1 >>> 0);
            }
            function a(t1, e, r) {
                var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
                r.realloc(n);
                for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
            }
            function l(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeVarint(t1[r]);
            }
            function u(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSVarint(t1[r]);
            }
            function c(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFloat(t1[r]);
            }
            function h(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeDouble(t1[r]);
            }
            function p(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeBoolean(t1[r]);
            }
            function f(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed32(t1[r]);
            }
            function d(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed32(t1[r]);
            }
            function m(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed64(t1[r]);
            }
            function y(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed64(t1[r]);
            }
            function g(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + 16777216 * t1[e + 3];
            }
            function x(t1, e, r) {
                t1[r] = e, t1[r + 1] = e >>> 8, t1[r + 2] = e >>> 16, t1[r + 3] = e >>> 24;
            }
            function v(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + (t1[e + 3] << 24);
            }
            return e.prototype = {
                destroy: function() {
                    this.buf = null;
                },
                readFields: function(t1, e, r) {
                    for(r = r || this.length; this.pos < r;){
                        var n = this.readVarint(), i = n >> 3, s = this.pos;
                        this.type = 7 & n, t1(i, e, this), this.pos === s && this.skip(n);
                    }
                    return e;
                },
                readMessage: function(t1, e) {
                    return this.readFields(t1, e, this.readVarint() + this.pos);
                },
                readFixed32: function() {
                    var t1 = g(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readSFixed32: function() {
                    var t1 = v(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readFixed64: function() {
                    var t1 = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readSFixed64: function() {
                    var t1 = g(this.buf, this.pos) + v(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readFloat: function() {
                    var e = t1.read(this.buf, this.pos, !0, 23, 4);
                    return this.pos += 4, e;
                },
                readDouble: function() {
                    var e = t1.read(this.buf, this.pos, !0, 52, 8);
                    return this.pos += 8, e;
                },
                readVarint: function(t1) {
                    var e, r, n = this.buf;
                    return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t1, e, r) {
                        var n, i, s = r.buf;
                        if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return o(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return o(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return o(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return o(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return o(t1, n, e);
                        if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return o(t1, n, e);
                        throw new Error("Expected varint not more than 10 bytes");
                    }(e |= (15 & (r = n[this.pos])) << 28, t1, this))));
                },
                readVarint64: function() {
                    return this.readVarint(!0);
                },
                readSVarint: function() {
                    var t1 = this.readVarint();
                    return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                },
                readBoolean: function() {
                    return Boolean(this.readVarint());
                },
                readString: function() {
                    var t1 = this.readVarint() + this.pos, e = this.pos;
                    return this.pos = t1, t1 - e >= 12 && i ? function(t1, e, r) {
                        return i.decode(t1.subarray(e, r));
                    }(this.buf, e, t1) : function(t1, e, r) {
                        for(var n = "", i = e; i < r;){
                            var s, o, a, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                            if (i + c > r) break;
                            1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t1[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (o = t1[i + 2], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & o) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & o) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (o = t1[i + 2], a = t1[i + 3], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & o) && 128 == (192 & a) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                        }
                        return n;
                    }(this.buf, e, t1);
                },
                readBytes: function() {
                    var t1 = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t1);
                    return this.pos = t1, e;
                },
                readPackedVarint: function(t1, r) {
                    if (this.type !== e.Bytes) return t1.push(this.readVarint(r));
                    var n = s(this);
                    for(t1 = t1 || []; this.pos < n;)t1.push(this.readVarint(r));
                    return t1;
                },
                readPackedSVarint: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSVarint());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSVarint());
                    return t1;
                },
                readPackedBoolean: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readBoolean());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readBoolean());
                    return t1;
                },
                readPackedFloat: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFloat());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFloat());
                    return t1;
                },
                readPackedDouble: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readDouble());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readDouble());
                    return t1;
                },
                readPackedFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed32());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed32());
                    return t1;
                },
                readPackedSFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed32());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed32());
                    return t1;
                },
                readPackedFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed64());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed64());
                    return t1;
                },
                readPackedSFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed64());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed64());
                    return t1;
                },
                skip: function(t1) {
                    var r = 7 & t1;
                    if (r === e.Varint) for(; this.buf[this.pos++] > 127;);
                    else if (r === e.Bytes) this.pos = this.readVarint() + this.pos;
                    else if (r === e.Fixed32) this.pos += 4;
                    else {
                        if (r !== e.Fixed64) throw new Error("Unimplemented type: " + r);
                        this.pos += 8;
                    }
                },
                writeTag: function(t1, e) {
                    this.writeVarint(t1 << 3 | e);
                },
                realloc: function(t1) {
                    for(var e = this.length || 16; e < this.pos + t1;)e *= 2;
                    if (e !== this.length) {
                        var r = new Uint8Array(e);
                        r.set(this.buf), this.buf = r, this.length = e;
                    }
                },
                finish: function() {
                    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                },
                writeFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeSFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeSFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeVarint: function(t1) {
                    (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e) {
                        var r, n;
                        if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                        e.realloc(10), function(t1, e, r) {
                            r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                        }(r, 0, e), function(t1, e) {
                            var r = (7 & t1) << 4;
                            e.buf[e.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1)))));
                        }(n, e);
                    }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                },
                writeSVarint: function(t1) {
                    this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                },
                writeBoolean: function(t1) {
                    this.writeVarint(Boolean(t1));
                },
                writeString: function(t1) {
                    t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                    var e = this.pos;
                    this.pos = function(t1, e, r) {
                        for(var n, i, s = 0; s < e.length; s++){
                            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
                                if (!i) {
                                    n > 56319 || s + 1 === e.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                    continue;
                                }
                                if (n < 56320) {
                                    t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                    continue;
                                }
                                n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                            } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                            n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                        }
                        return r;
                    }(this.buf, t1, this.pos);
                    var r = this.pos - e;
                    r >= 128 && a(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
                },
                writeFloat: function(e) {
                    this.realloc(4), t1.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
                },
                writeDouble: function(e) {
                    this.realloc(8), t1.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
                },
                writeBytes: function(t1) {
                    var e = t1.length;
                    this.writeVarint(e), this.realloc(e);
                    for(var r = 0; r < e; r++)this.buf[this.pos++] = t1[r];
                },
                writeRawMessage: function(t1, e) {
                    this.pos++;
                    var r = this.pos;
                    t1(e, this);
                    var n = this.pos - r;
                    n >= 128 && a(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                },
                writeMessage: function(t1, r, n) {
                    this.writeTag(t1, e.Bytes), this.writeRawMessage(r, n);
                },
                writePackedVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, l, e);
                },
                writePackedSVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, u, e);
                },
                writePackedBoolean: function(t1, e) {
                    e.length && this.writeMessage(t1, p, e);
                },
                writePackedFloat: function(t1, e) {
                    e.length && this.writeMessage(t1, c, e);
                },
                writePackedDouble: function(t1, e) {
                    e.length && this.writeMessage(t1, h, e);
                },
                writePackedFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, f, e);
                },
                writePackedSFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, d, e);
                },
                writePackedFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, m, e);
                },
                writePackedSFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, y, e);
                },
                writeBytesField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeBytes(r);
                },
                writeFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFixed32(r);
                },
                writeSFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeSFixed32(r);
                },
                writeFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeFixed64(r);
                },
                writeSFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeSFixed64(r);
                },
                writeVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeVarint(r);
                },
                writeSVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeSVarint(r);
                },
                writeStringField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeString(r);
                },
                writeFloatField: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFloat(r);
                },
                writeDoubleField: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeDouble(r);
                },
                writeBooleanField: function(t1, e) {
                    this.writeVarintField(t1, Boolean(e));
                }
            }, im;
        }
        var um = dt(lm());
        const cm = 3;
        function hm(t1, e, r) {
            e.glyphs = [], 1 === t1 && r.readMessage(pm, e);
        }
        function pm(t1, e, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: s, left: o, top: a, advance: l } = r.readMessage(fm, {});
                e.glyphs.push({
                    id: t1,
                    bitmap: new mh({
                        width: i + 2 * cm,
                        height: s + 2 * cm
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: o,
                        top: a,
                        advance: l
                    }
                });
            } else 4 === t1 ? e.ascender = r.readSVarint() : 5 === t1 && (e.descender = r.readSVarint());
        }
        function fm(t1, e, r) {
            1 === t1 ? e.id = r.readVarint() : 2 === t1 ? e.bitmap = r.readBytes() : 3 === t1 ? e.width = r.readVarint() : 4 === t1 ? e.height = r.readVarint() : 5 === t1 ? e.left = r.readSVarint() : 6 === t1 ? e.top = r.readSVarint() : 7 === t1 && (e.advance = r.readVarint());
        }
        const dm = cm, mm = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class ym {
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(t1, e) {
                const r = new ym;
                return r.scale = t1 || 1, r.fontStack = e, r;
            }
            static forImage(t1) {
                const e = new ym;
                return e.image = t1, e;
            }
        }
        class gm {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t1, e, r) {
                const n = new gm;
                for(let i = 0; i < t1.sections.length; i++){
                    const s = t1.sections[i];
                    s.image ? n.addImageSection(s, r) : n.addTextSection(s, e);
                }
                return n;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCodePoint(t1) {
                return this.text.codePointAt(t1);
            }
            verticalizePunctuation(t1) {
                this.text = function(t1, e) {
                    let r = "";
                    for(let n = 0; n < t1.length; n++){
                        const i = t1.charCodeAt(n + 1) || null, s = t1.charCodeAt(n - 1) || null;
                        r += !e && (i && eo(i) && !tm[t1[n + 1]] || s && eo(s) && !tm[t1[n - 1]]) || !tm[t1[n]] ? t1[n] : tm[t1[n]];
                    }
                    return r;
                }(this.text, t1);
            }
            trim() {
                let t1 = 0;
                for(let e = 0; e < this.text.length && vm[this.text.charCodeAt(e)]; e++)t1++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && vm[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t1, e), this.sectionIndex = this.sectionIndex.slice(t1, e);
            }
            substring(t1, e) {
                const r = new gm;
                return r.text = this.text.substring(t1, e), r.sectionIndex = this.sectionIndex.slice(t1, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e)=>Math.max(t1, this.sections[e].scale), 0);
            }
            addTextSection(t1, e) {
                this.text += t1.text, this.sections.push(ym.forText(t1.scale, t1.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t1.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t1, e) {
                const r = t1.image ? t1.image.getPrimary() : null;
                if (!r) return void Gt("Can't add FormattedSection with an empty image.");
                r.scaleSelf(e);
                const n = this.getNextImageSectionCharCode();
                n ? (this.text += String.fromCodePoint(n), this.sections.push(ym.forImage(r)), this.sectionIndex.push(this.sections.length - 1)) : Gt("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function xm(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m = 1) {
            const y = gm.fromFeature(t1, i, m);
            h === mm.vertical && y.verticalizePunctuation(p);
            let g = [];
            const x = function(t1, e, r, n, i, s) {
                if (!t1) return [];
                const o = [], a = function(t1, e, r, n, i, s) {
                    let o = 0;
                    for(let r = 0; r < t1.length(); r++){
                        const a = t1.getSection(r);
                        o += wm(t1.getCodePoint(r), a, n, i, e, s);
                    }
                    return o / Math.max(1, Math.ceil(o / r));
                }(t1, e, r, n, i, s), l = t1.text.indexOf("\u200B") >= 0;
                let u = 0;
                for(let r = 0; r < t1.length(); r++){
                    const h = t1.getSection(r), p = t1.getCodePoint(r);
                    if (vm[p] || (u += wm(p, h, n, i, e, s)), r < t1.length() - 1) {
                        const e = !((c = p) < 11904 || !(Ys["Bopomofo Extended"](c) || Ys.Bopomofo(c) || Ys["CJK Compatibility Forms"](c) || Ys["CJK Compatibility Ideographs"](c) || Ys["CJK Compatibility"](c) || Ys["CJK Radicals Supplement"](c) || Ys["CJK Strokes"](c) || Ys["CJK Symbols and Punctuation"](c) || Ys["CJK Unified Ideographs Extension A"](c) || Ys["CJK Unified Ideographs"](c) || Ys["Enclosed CJK Letters and Months"](c) || Ys["Halfwidth and Fullwidth Forms"](c) || Ys.Hiragana(c) || Ys["Ideographic Description Characters"](c) || Ys["Kangxi Radicals"](c) || Ys["Katakana Phonetic Extensions"](c) || Ys.Katakana(c) || Ys["Vertical Forms"](c) || Ys["Yi Radicals"](c) || Ys["Yi Syllables"](c)));
                        (bm[p] || e || h.image) && o.push(Mm(r + 1, u, a, o, Am(p, t1.getCodePoint(r + 1), e && l), !1));
                    }
                }
                var c;
                return Im(Mm(t1.length(), u, a, o, 0, !0));
            }(y, u, s, e, n, f), { processBidirectionalText: v, processStyledBidirectionalText: b } = yo;
            if (v && 1 === y.sections.length) {
                const t1 = v(y.toString(), x);
                for (const e of t1){
                    const t1 = new gm;
                    t1.text = e, t1.sections = y.sections;
                    for(let r = 0; r < e.length; r++)t1.sectionIndex.push(0);
                    g.push(t1);
                }
            } else if (b) {
                const t1 = b(y.text, y.sectionIndex, x);
                for (const e of t1){
                    const t1 = new gm;
                    t1.text = e[0], t1.sectionIndex = e[1], t1.sections = y.sections, g.push(t1);
                }
            } else g = function(t1, e) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(y, x);
            const w = [], _ = {
                positionedLines: w,
                text: y.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            if (function(t1, e, r, n, i, s, o, a, l, u, c, h) {
                let p = 0, f = 0, d = 0;
                const m = "right" === a ? 1 : "left" === a ? 0 : .5;
                let y = !1;
                for (const t1 of i){
                    const r = t1.getSections();
                    for (const t1 of r){
                        if (t1.image) continue;
                        const r = e[t1.fontStack];
                        if (r && (y = void 0 !== r.ascender && void 0 !== r.descender, !y)) break;
                    }
                    if (!y) break;
                }
                let g = 0;
                for (const o of i){
                    o.trim();
                    const i = o.getMaxScale(), a = (i - 1) * Jd, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[g] = v;
                    const b = v.positionedGlyphs;
                    let w = 0;
                    if (!o.length()) {
                        f += s, ++g;
                        continue;
                    }
                    let _ = 0, A = 0;
                    for(let s = 0; s < o.length(); s++){
                        const a = o.getSection(s), d = o.getSectionIndex(s), m = o.getCodePoint(s);
                        let g = a.scale, v = null, M = null, I = null, S = Jd, z = 0;
                        l === mm.vertical && (12312 === (x = m) || 12313 === x || 12316 === x || 12540 === x || 12448 === x) && (l = mm.horizontal);
                        const k = !(l === mm.horizontal || !c && !to(m) || c && (vm[m] || ro(m)));
                        if (a.image) {
                            const e = n.get(a.image.toString());
                            if (!e) continue;
                            I = a.image, t1.iconsInText = t1.iconsInText || !0, M = e.paddedRect;
                            const r = e.displaySize;
                            g = g * Jd / h, v = {
                                width: r[0],
                                height: r[1],
                                left: 0,
                                top: -3,
                                advance: k ? r[1] : r[0],
                                localGlyph: !1
                            }, z = y ? -v.height * g : i * Jd - 17 - r[1] * g, S = v.advance;
                            const s = (k ? r[0] : r[1]) * g - Jd * i;
                            s > 0 && s > w && (w = s);
                        } else {
                            const t1 = r[a.fontStack];
                            if (!t1) continue;
                            t1[m] && (M = t1[m]);
                            const n = e[a.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[m];
                            if (!s) continue;
                            if (v = s.metrics, S = 8203 !== m ? Jd : 0, y) {
                                const t1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, e = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (t1 + e) * g;
                                _ < r && (_ = r, A = (t1 - e) / 2 * g), z = -t1 * g;
                            } else z = (i - g) * Jd - 17;
                        }
                        k ? (t1.verticalizable = !0, b.push({
                            glyph: m,
                            image: I,
                            x: p,
                            y: f + z,
                            vertical: k,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: M
                        }), p += S * g + u) : (b.push({
                            glyph: m,
                            image: I,
                            x: p,
                            y: f + z,
                            vertical: k,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: M
                        }), p += v.advance * g + u);
                    }
                    0 !== b.length && (d = Math.max(p - u, d), y ? zm(b, m, w, A, s * i / 2) : zm(b, m, w, 0, s / 2)), p = 0;
                    const M = s * i + w;
                    v.lineOffset = Math.max(w, a), f += M, ++g;
                }
                var x;
                const v = f, { horizontalAlign: b, verticalAlign: w } = Sm(o);
                (function(t1, e, r, n, i, s) {
                    const o = (e - r) * i, a = -s * n;
                    for (const e of t1)for (const t1 of e.positionedGlyphs)t1.x += o, t1.y += a;
                })(t1.positionedLines, m, b, w, d, v), t1.top += -w * v, t1.bottom = t1.top + v, t1.left += -b * d, t1.right = t1.left + d, t1.hasBaseline = y;
            }(_, e, r, n, g, o, a, l, h, u, p, d), !function(t1) {
                for (const e of t1)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(w)) return _;
        }
        const vm = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, bm = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function wm(t1, e, r, n, i, s) {
            if (e.image) {
                const t1 = n.get(e.image.toString());
                return t1 ? t1.displaySize[0] * e.scale * Jd / s + i : 0;
            }
            {
                const n = r[e.fontStack], s = n && n.glyphs[t1];
                return s ? s.metrics.advance * e.scale + i : 0;
            }
        }
        function _m(t1, e, r, n) {
            const i = Math.pow(t1 - e, 2);
            return n ? t1 < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Am(t1, e, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function Mm(t1, e, r, n, i, s) {
            let o = null, a = _m(e, r, i, s);
            for (const t1 of n){
                const n = _m(e - t1.x, r, i, s) + t1.badness;
                n <= a && (o = t1, a = n);
            }
            return {
                index: t1,
                x: e,
                priorBreak: o,
                badness: a
            };
        }
        function Im(t1) {
            return t1 ? Im(t1.priorBreak).concat(t1.index) : [];
        }
        function Sm(t1) {
            let e = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function zm(t1, e, r, n, i) {
            if (!(e || r || n || i)) return;
            const s = t1.length - 1, o = t1[s], a = (o.x + o.metrics.advance * o.scale) * e;
            for(let e = 0; e <= s; e++)t1[e].x -= a, t1[e].y += r + n + i;
        }
        function km(t1) {
            return void 0 !== t1.imagePrimary && void 0 !== t1.top && void 0 !== t1.bottom && void 0 !== t1.left && void 0 !== t1.right;
        }
        function Pm(t1, e, r, n) {
            const { horizontalAlign: i, verticalAlign: s } = Sm(n), o = r[0] - t1.displaySize[0] * i, a = r[1] - t1.displaySize[1] * s;
            return {
                imagePrimary: t1,
                imageSecondary: e,
                top: a,
                bottom: a + t1.displaySize[1],
                left: o,
                right: o + t1.displaySize[0]
            };
        }
        function Em(t1, e, r, n, i, s) {
            const o = t1.imagePrimary;
            let a;
            if (o.content) {
                const t1 = o.content, e = o.pixelRatio || 1;
                a = [
                    t1[0] / e,
                    t1[1] / e,
                    o.displaySize[0] - t1[2] / e,
                    o.displaySize[1] - t1[3] / e
                ];
            }
            const l = e.left * s, u = e.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - o.displaySize[0]) / 2, h = f + o.displaySize[0]);
            const d = e.top * s, m = e.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + m + n[2]) : (c = i[1] + (d + m - o.displaySize[1]) / 2, p = c + o.displaySize[1]), {
                imagePrimary: o,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: a
            };
        }
        function Tm(t1) {
            return !t1.imagePrimary.stretchX;
        }
        function Bm(t1) {
            return !t1.imagePrimary.stretchY;
        }
        function Vm(t1) {
            return {
                width: t1.right - t1.left,
                height: t1.bottom - t1.top
            };
        }
        const Cm = 128;
        function Fm(t1, e, r) {
            const { expression: n } = e;
            if ("constant" === n.kind) return {
                kind: "constant",
                layoutSize: n.evaluate(new go(t1 + 1, {
                    worldview: r
                }))
            };
            if ("source" === n.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: i } = n;
                let s = 0;
                for(; s < e.length && e[s] <= t1;)s++;
                s = Math.max(0, s - 1);
                let o = s;
                for(; o < e.length && e[o] < t1 + 1;)o++;
                o = Math.min(e.length - 1, o);
                const a = e[s], l = e[o];
                return "composite" === n.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: l,
                    interpolationType: i
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: l,
                    minSize: n.evaluate(new go(a, {
                        worldview: r
                    })),
                    maxSize: n.evaluate(new go(l, {
                        worldview: r
                    })),
                    interpolationType: i
                };
            }
        }
        function Dm(t1, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / Cm : "composite" === t1.kind ? ur(n / Cm, i / Cm, r) : e;
        }
        function Lm(t1, e, r = 1) {
            let n = 0, i = 0;
            if ("constant" === t1.kind) i = t1.layoutSize * r;
            else if ("source" !== t1.kind) {
                const { interpolationType: s, minZoom: o, maxZoom: a } = t1, l = s ? Et(ji.interpolationFactor(s, e, o, a), 0, 1) : 0;
                "camera" === t1.kind ? i = ur(t1.minSize, t1.maxSize, l) * r : n = l * r;
            }
            return {
                uSizeT: n,
                uSize: i
            };
        }
        class Rm extends bt {
            constructor(t1, e, r, n, i){
                super(t1, e), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new Rm(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function Om(t1, e, r, n, i) {
            if (void 0 === e.segment) return !0;
            let s = e, o = e.segment + 1, a = 0;
            for(; a > -r / 2;){
                if (o--, o < 0) return !1;
                a -= t1[o].dist(s), s = t1[o];
            }
            a += t1[o].dist(t1[o + 1]), o++;
            const l = [];
            let u = 0;
            for(; a < r / 2;){
                const e = t1[o], r = t1[o + 1];
                if (!r) return !1;
                let s = t1[o - 1].angleTo(e) - e.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), u += s; a - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                o++, a += e.dist(r);
            }
            return !0;
        }
        function Um(t1) {
            let e = 0;
            for(let r = 0; r < t1.length - 1; r++)e += t1[r].dist(t1[r + 1]);
            return e;
        }
        function Nm(t1, e, r) {
            return t1 ? .6 * e * r : 0;
        }
        function jm(t1, e) {
            return Math.max(t1 ? t1.right - t1.left : 0, e ? e.right - e.left : 0);
        }
        function $m(t1, e, r, n, i, s) {
            const o = Nm(r, i, s), a = jm(r, n) * s;
            let l = 0;
            const u = Um(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = ur(n.x, i.x, c), p = ur(n.y, i.y, c), f = new Rm(h, p, 0, i.angleTo(n), r);
                    return !o || Om(t1, f, a, o, e) ? f : void 0;
                }
                l += s;
            }
        }
        function Gm(t1, e, r, n, i, s, o, a, l) {
            const u = Nm(n, s, o), c = jm(n, i), h = c * o, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), qm(t1, p ? e / 2 * a % e : (c / 2 + 2 * s) * o * a % e, e, u, r, h, p, !1, l);
        }
        function qm(t1, e, r, n, i, s, o, a, l) {
            const u = s / 2, c = Um(t1);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t1.length - 1; e++){
                const o = t1[e], a = t1[e + 1], d = o.dist(a), m = a.angleTo(o);
                for(; p + r < h + d;){
                    p += r;
                    const y = (p - h) / d, g = ur(o.x, a.x, y), x = ur(o.y, a.y, y);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Rm(g, x, 0, m, e);
                        n && !Om(t1, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return a || f.length || o || (f = qm(t1, h / 2, r, n, i, s, o, !0, l)), f;
        }
        function Hm(t1) {
            let e = 0, r = 0;
            for (const n of t1)e += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e)=>e.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, s = Math.max(s, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t1 < n.length && (n[t1] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e / (i * s) || 0
            };
        }
        qs(Rm, "Anchor");
        const Xm = 1;
        class Zm {
            static getImagePositionScale(t1, e, r) {
                if (e && t1 && t1.options && t1.options.transform) {
                    const e = t1.options.transform;
                    return {
                        x: e.a,
                        y: e.d
                    };
                }
                return {
                    x: r,
                    y: r
                };
            }
            constructor(t1, e, r, n){
                this.paddedRect = t1;
                const { pixelRatio: i, version: s, stretchX: o, stretchY: a, content: l, sdf: u, usvg: c } = e;
                this.pixelRatio = i, this.stretchX = o, this.stretchY = a, this.content = l, this.version = s, this.padding = r, this.sdf = u, this.usvg = c, this.scale = Zm.getImagePositionScale(n, c, i);
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
        }
        function Wm(t1, e, r) {
            const n = Fr.parse(t1), i = function(t1, e, r = [
                1,
                1
            ]) {
                return {
                    x: 0,
                    y: 0,
                    w: (t1.data ? t1.data.width : t1.width * r[0]) + 2 * e,
                    h: (t1.data ? t1.data.height : t1.height * r[1]) + 2 * e
                };
            }(e, r, [
                n.options.transform.a,
                n.options.transform.d
            ]);
            return {
                bin: i,
                imagePosition: new Zm(i, e, r, n),
                imageVariant: n
            };
        }
        class Ym {
            constructor(t1, e, r){
                const n = new Map, i = new Map;
                this.haveRenderCallbacks = [];
                const s = [];
                this.addImages(t1, n, Xm, s), this.addImages(e, i, 2, s);
                const { w: o, h: a } = Hm(s), l = new yh({
                    width: o || 1,
                    height: a || 1
                });
                for (const [e, i] of t1.entries()){
                    const t1 = n.get(e).paddedRect;
                    yh.copy(i.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: t1.x + Xm,
                        y: t1.y + Xm
                    }, i.data, r, i.sdf);
                }
                for (const [t1, n] of e.entries()){
                    const e = i.get(t1), s = e.paddedRect;
                    let o = e.padding;
                    const a = s.x + o, u = s.y + o, c = n.data.width, h = n.data.height;
                    o = o > 1 ? o - 1 : o, yh.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: u
                    }, n.data, r), yh.copy(n.data, l, {
                        x: 0,
                        y: h - o
                    }, {
                        x: a,
                        y: u - o
                    }, {
                        width: c,
                        height: o
                    }, r), yh.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: u + h
                    }, {
                        width: c,
                        height: o
                    }, r), yh.copy(n.data, l, {
                        x: c - o,
                        y: 0
                    }, {
                        x: a - o,
                        y: u
                    }, {
                        width: o,
                        height: h
                    }, r), yh.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + c,
                        y: u
                    }, {
                        width: o,
                        height: h
                    }, r), yh.copy(n.data, l, {
                        x: c - o,
                        y: h - o
                    }, {
                        x: a - o,
                        y: u - o
                    }, {
                        width: o,
                        height: o
                    }, r), yh.copy(n.data, l, {
                        x: 0,
                        y: h - o
                    }, {
                        x: a + c,
                        y: u - o
                    }, {
                        width: o,
                        height: o
                    }, r), yh.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + c,
                        y: u + h
                    }, {
                        width: o,
                        height: o
                    }, r), yh.copy(n.data, l, {
                        x: c - o,
                        y: 0
                    }, {
                        x: a - o,
                        y: u + h
                    }, {
                        width: o,
                        height: o
                    }, r);
                }
                this.lut = r, this.image = l, this.iconPositions = n, this.patternPositions = i;
            }
            addImages(t1, e, r, n) {
                for (const [i, s] of t1.entries()){
                    const { bin: t1, imagePosition: o, imageVariant: a } = Wm(i, s, r);
                    e.set(i, o), n.push(t1), s.hasRenderCallback && this.haveRenderCallbacks.push(a.id);
                }
            }
            patchUpdatedImages(t1, e, r) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e)=>t1.hasImage(e, r)), t1.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
                for (const n of t1.getUpdatedImages(r)){
                    for (const i of this.iconPositions.keys()){
                        const s = Fr.parse(i);
                        if (er.isEqual(s.id, n)) {
                            const s = t1.getImage(n, r);
                            this.patchUpdatedImage(this.iconPositions.get(i), s, e);
                        }
                    }
                    for (const i of this.patternPositions.keys()){
                        const s = Fr.parse(i);
                        if (er.isEqual(s.id, n)) {
                            const s = t1.getImage(n, r);
                            this.patchUpdatedImage(this.patternPositions.get(i), s, e);
                        }
                    }
                }
            }
            patchUpdatedImage(t1, e, r) {
                if (!t1 || !e) return;
                if (t1.version === e.version) return;
                t1.version = e.version;
                const [n, i] = t1.tl, s = t1.sdf;
                if (this.lut || s) {
                    const t1 = {
                        width: e.data.width,
                        height: e.data.height
                    }, o = new yh(t1);
                    yh.copy(e.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, t1, this.lut, s), r.update(o, {
                        position: {
                            x: n,
                            y: i
                        }
                    });
                } else r.update(e.data, {
                    position: {
                        x: n,
                        y: i
                    }
                });
            }
        }
        qs(Zm, "ImagePosition"), qs(Ym, "ImageAtlas");
        const Km = 1e20;
        function Jm(t1, e, r, n, i, s, o, a, l) {
            for(let u = e; u < e + n; u++)Qm(t1, r * s + u, s, i, o, a, l);
            for(let u = r; u < r + i; u++)Qm(t1, u * s + e, 1, n, o, a, l);
        }
        function Qm(t1, e, r, n, i, s, o) {
            s[0] = 0, o[0] = -100000000000000000000, o[1] = Km, i[0] = t1[e];
            for(let a = 1, l = 0, u = 0; a < n; a++){
                i[a] = t1[e + a * r];
                const n = a * a;
                do {
                    const t1 = s[l];
                    u = (i[a] - i[t1] + n - t1 * t1) / (a - t1) / 2;
                }while (u <= o[l] && --l > -1);
                l++, s[l] = a, o[l] = u, o[l + 1] = Km;
            }
            for(let a = 0, l = 0; a < n; a++){
                for(; o[l + 1] < a;)l++;
                const n = s[l], u = a - n;
                t1[e + a * r] = i[n] + u * u;
            }
        }
        const ty = 2, ey = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class ry {
            constructor(t1, e, r){
                this.requestManager = t1, this.localGlyphMode = e, this.localFontFamily = r, this.urls = {}, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(t1, e) {
                this.urls[e] = t1;
            }
            getGlyphs(t1, e, r) {
                const n = [], i = this.urls[e] || ne.GLYPHS_URL;
                for(const e in t1)for (const r of t1[e])n.push({
                    stack: e,
                    id: r
                });
                Vt(n, ({ stack: t1, id: e }, r)=>{
                    let n = this.entries[t1];
                    n || (n = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let s = n.glyphs[e];
                    if (void 0 !== s) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    if (s = this._tinySDF(n, t1, e), s) return n.glyphs[e] = s, void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    const o = Math.floor(e / 256);
                    if (256 * o > 65535) return Gt("glyphs > 65535 not supported"), void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    if (n.ranges[o]) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    let a = n.requests[o];
                    a || (a = n.requests[o] = [], ry.loadGlyphRange(t1, o, i, this.requestManager, (t1, e)=>{
                        if (e) {
                            n.ascender = e.ascender, n.descender = e.descender;
                            for(const t1 in e.glyphs)this._doesCharSupportLocalGlyph(+t1) || (n.glyphs[+t1] = e.glyphs[+t1]);
                            n.ranges[o] = !0;
                        }
                        for (const r of a)r(t1, e);
                        delete n.requests[o];
                    })), a.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: t1,
                            id: e,
                            glyph: i.glyphs[e] || null
                        });
                    });
                }, (t1, e)=>{
                    if (t1) r(t1);
                    else if (e) {
                        const t1 = {};
                        for (const { stack: r, id: n, glyph: i } of e)void 0 === t1[r] && (t1[r] = {}), void 0 === t1[r].glyphs && (t1[r].glyphs = {}), t1[r].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, t1[r].ascender = this.entries[r].ascender, t1[r].descender = this.entries[r].descender;
                        r(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(t1) {
                return this.localGlyphMode !== ey.none && (this.localGlyphMode === ey.all ? !!this.localFontFamily : !!this.localFontFamily && (Ys["CJK Unified Ideographs"](t1) || Ys["Hangul Syllables"](t1) || Ys.Hiragana(t1) || Ys.Katakana(t1) || Ys["CJK Symbols and Punctuation"](t1) || Ys["CJK Unified Ideographs Extension A"](t1) || Ys["CJK Unified Ideographs Extension B"](t1) || Ys.Osage(t1)));
            }
            _tinySDF(t1, e, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = t1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(e) ? r = "900" : /medium/i.test(e) ? r = "500" : /light/i.test(e) && (r = "200"), i = t1.tinySDF = new ry.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 24 * ty,
                        buffer: 3 * ty,
                        radius: 8 * ty
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const s = String.fromCodePoint(r), { data: o, width: a, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: f } = i.draw(s);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new mh({
                        width: a,
                        height: l
                    }, o),
                    metrics: {
                        width: u / ty,
                        height: c / ty,
                        left: h / ty,
                        top: p / ty - 27,
                        advance: f / ty,
                        localGlyph: !0
                    }
                };
            }
        }
        ry.loadGlyphRange = function(t1, e, r, n, i) {
            const s = 256 * e, o = s + 255, a = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t1).replace("{range}", `${s}-${o}`), Be.Glyphs);
            De(a, (t1, e)=>{
                if (t1) i(t1);
                else if (e) {
                    const t1 = {}, r = function(t1) {
                        return new um(t1).readFields(hm, {});
                    }(e);
                    for (const e of r.glyphs)t1[e.id] = e;
                    i(null, {
                        glyphs: t1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, ry.TinySDF = class {
            constructor({ fontSize: t1 = 24, buffer: e = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: o = "normal" } = {}){
                this.buffer = e, this.cutoff = n, this.radius = r;
                const a = this.size = t1 + 4 * e, l = this._createCanvas(a), u = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${o} ${s} ${t1}px ${i}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(a * a), this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), this.v = new Uint16Array(a);
            }
            _createCanvas(t1) {
                const e = document.createElement("canvas");
                return e.width = e.height = t1, e;
            }
            draw(t1) {
                const { width: e, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(t1), o = Math.ceil(r), a = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))), l = Math.min(this.size - this.buffer, o + Math.ceil(n)), u = a + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), f = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: a,
                    glyphHeight: l,
                    glyphTop: o,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === a || 0 === l) return f;
                const { ctx: d, buffer: m, gridInner: y, gridOuter: g } = this;
                d.clearRect(m, m, a, l), d.fillText(t1, m, m + o);
                const x = d.getImageData(m, m, a, l);
                g.fill(Km, 0, h), y.fill(0, 0, h);
                for(let t1 = 0; t1 < l; t1++)for(let e = 0; e < a; e++){
                    const r = x.data[4 * (t1 * a + e) + 3] / 255;
                    if (0 === r) continue;
                    const n = (t1 + m) * u + e + m;
                    if (1 === r) g[n] = 0, y[n] = Km;
                    else {
                        const t1 = .5 - r;
                        g[n] = t1 > 0 ? t1 * t1 : 0, y[n] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                Jm(g, 0, 0, u, c, u, this.f, this.v, this.z), Jm(y, m, m, a, l, u, this.f, this.v, this.z);
                for(let t1 = 0; t1 < h; t1++){
                    const e = Math.sqrt(g[t1]) - Math.sqrt(y[t1]);
                    p[t1] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return f;
            }
        };
        const ny = Xm;
        function iy(t1, e) {
            return t1 + e[1] - e[0];
        }
        function sy(t1, e, r, n, i = 1) {
            const s = [], o = t1.imagePrimary, a = o.pixelRatio, l = o.paddedRect.w - 2 * ny, u = o.paddedRect.h - 2 * ny, c = (t1.right - t1.left) * i, h = (t1.bottom - t1.top) * i, p = o.stretchX || [
                [
                    0,
                    l
                ]
            ], f = o.stretchY || [
                [
                    0,
                    u
                ]
            ], d = p.reduce(iy, 0), m = f.reduce(iy, 0), y = l - d, g = u - m;
            let x = 0, v = d, b = 0, w = m, _ = 0, A = y, M = 0, I = g;
            if (o.content && n) {
                const t1 = o.content;
                x = oy(p, 0, t1[0]), b = oy(f, 0, t1[1]), v = oy(p, t1[0], t1[2]), w = oy(f, t1[1], t1[3]), _ = t1[0] - x, M = t1[1] - b, A = t1[2] - t1[0] - v, I = t1[3] - t1[1] - w;
            }
            const S = (n, s, l, u)=>{
                const p = ly(n.stretch - x, v, c, t1.left * i), f = uy(n.fixed - _, A, n.stretch, d), y = ly(s.stretch - b, w, h, t1.top * i), g = uy(s.fixed - M, I, s.stretch, m), S = ly(l.stretch - x, v, c, t1.left * i), z = uy(l.fixed - _, A, l.stretch, d), k = ly(u.stretch - b, w, h, t1.top * i), P = uy(u.fixed - M, I, u.stretch, m), E = new bt(p, y), T = new bt(S, y), B = new bt(S, k), V = new bt(p, k), C = new bt(f / a, g / a), F = new bt(z / a, P / a), D = e * Math.PI / 180;
                if (D) {
                    const t1 = Math.sin(D), e = Math.cos(D), r = [
                        e,
                        -t1,
                        t1,
                        e
                    ];
                    E._matMult(r), T._matMult(r), V._matMult(r), B._matMult(r);
                }
                const L = n.stretch + n.fixed, R = l.stretch + l.fixed, O = s.stretch + s.fixed, U = u.stretch + u.fixed, N = t1.imageSecondary;
                return {
                    tl: E,
                    tr: T,
                    bl: V,
                    br: B,
                    texPrimary: {
                        x: o.paddedRect.x + ny + L,
                        y: o.paddedRect.y + ny + O,
                        w: R - L,
                        h: U - O
                    },
                    texSecondary: N ? {
                        x: N.paddedRect.x + ny + L,
                        y: N.paddedRect.y + ny + O,
                        w: R - L,
                        h: U - O
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: C,
                    pixelOffsetBR: F,
                    minFontScaleX: A / a / c,
                    minFontScaleY: I / a / h,
                    isSDF: r
                };
            };
            if (n && (o.stretchX || o.stretchY)) {
                const t1 = ay(p, y, d), e = ay(f, g, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], i = t1[r + 1];
                    for(let t1 = 0; t1 < e.length - 1; t1++)s.push(S(n, e[t1], i, e[t1 + 1]));
                }
            } else s.push(S({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function oy(t1, e, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function ay(t1, e, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + ny,
                stretch: r
            }), n;
        }
        function ly(t1, e, r, n) {
            return t1 / e * r + n;
        }
        function uy(t1, e, r, n) {
            return t1 - e * r / n;
        }
        function cy(t1, e, r, n) {
            const i = e + t1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (e + t1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function hy(t1, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
            const a = t1[0];
            for(let t1 = 0; t1 < a.length; t1++){
                const e = a[t1];
                (!t1 || e.x < n) && (n = e.x), (!t1 || e.y < i) && (i = e.y), (!t1 || e.x > s) && (s = e.x), (!t1 || e.y > o) && (o = e.y);
            }
            const l = Math.min(s - n, o - i);
            let u = l / 2;
            const c = new Vn([], py);
            if (0 === l) return new bt(n, i);
            for(let e = n; e < s; e += l)for(let r = i; r < o; r += l)c.push(new fy(e + u, r + u, u, t1));
            let h = function(t1) {
                let e = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, s = i.length, o = s - 1; t1 < s; o = t1++){
                    const s = i[t1], a = i[o], l = s.x * a.y - a.x * s.y;
                    r += (s.x + a.x) * l, n += (s.y + a.y) * l, e += 3 * l;
                }
                return new fy(r / e, n / e, 0, t1);
            }(t1), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= e || (u = n.h / 2, c.push(new fy(n.p.x - u, n.p.y - u, u, t1)), c.push(new fy(n.p.x + u, n.p.y - u, u, t1)), c.push(new fy(n.p.x - u, n.p.y + u, u, t1)), c.push(new fy(n.p.x + u, n.p.y + u, u, t1)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function py(t1, e) {
            return e.max - t1.max;
        }
        class fy {
            constructor(t1, e, r, n){
                this.p = new bt(t1, e), this.h = r, this.d = function(t1, e) {
                    let r = !1, n = 1 / 0;
                    for(let i = 0; i < e.length; i++){
                        const s = e[i];
                        for(let e = 0, i = s.length, o = i - 1; e < i; o = e++){
                            const i = s[e], a = s[o];
                            i.y > t1.y != a.y > t1.y && t1.x < (a.x - i.x) * (t1.y - i.y) / (a.y - i.y) + i.x && (r = !r), n = Math.min(n, oc(t1, i, a));
                        }
                    }
                    return (r ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const dy = Object.keys, my = Number.POSITIVE_INFINITY, yy = Math.sqrt(2);
        function gy(t1, [e, r]) {
            let n = 0, i = 0;
            if (r === my) {
                e < 0 && (e = 0);
                const r = e / yy;
                switch(t1){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - e;
                        break;
                    case "top":
                        i = e - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = e;
                        break;
                    case "right":
                        n = -e;
                }
            } else {
                switch(e = Math.abs(e), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
            }
            return [
                n,
                i
            ];
        }
        function xy(t1, e, r, n, i, s, o, a, l) {
            if (!e || !e.usvg) return;
            const u = Vm(n), c = Vm(i), h = "both" !== s && "width" !== s || !Tm(n) ? 1 : c.width / u.width, p = "both" !== s && "height" !== s || !Bm(n) ? 1 : c.height / u.height;
            r.scaleSelf(h, p);
            const f = r.toString();
            o.set(f, r), a.set(f, e);
            const { imagePosition: d } = Wm(f, e, Xm);
            l.set(f, d);
        }
        function vy(t1, e, r, n, i, s, o, a, l) {
            if (!t1) return;
            const u = function(t1, e, r, n, i, s) {
                if ("camera" === t1.kind) return t1.maxSize;
                if ("composite" === t1.kind) {
                    const n = e.possiblyEvaluate(new go(t1.maxZoom, {
                        worldview: s
                    }), r).evaluate(i, {}, r), o = e.possiblyEvaluate(new go(t1.minZoom, {
                        worldview: s
                    }), r).evaluate(i, {}, r);
                    return Math.max(n, o);
                }
                return e.possiblyEvaluate(new go(n, {
                    worldview: s
                })).evaluate(i, {}, r);
            }(e, r, n, i, s, l);
            return t1.scaleSelf(u * a * o);
        }
        function by(t1, e, r, n, i, s, o, a, l) {
            return {
                iconPrimary: vy(t1.getPrimary(), e, r, n, i, s, o, a, l),
                iconSecondary: vy(t1.getSecondary(), e, r, n, i, s, o, a, l)
            };
        }
        function wy(t1, e, r) {
            if (!e) return;
            const n = r.get(t1.toString()), i = r.get(e.toString());
            i && (n.paddedRect.w === i.paddedRect.w && n.paddedRect.h === i.paddedRect.h || Gt(`Mismatch in icon variant sizes: ${t1.toString()} and ${e.toString()}`), n.usvg !== i.usvg && Gt(`Mismatch in icon variant image types: ${t1.id} and ${e.id}`));
        }
        function _y(t1, e, r, n) {
            if (!t1) return;
            const i = e.get(r.toString());
            if (t1.imagePrimary = i, n) {
                const r = e.get(n.toString());
                t1.imageSecondary = r;
            }
        }
        function Ay(t1, e) {
            for(const r in t1.horizontal)My(t1.horizontal[r], e);
            My(t1.vertical, e);
        }
        function My(t1, e) {
            if (t1) {
                for (const r of t1.positionedLines)for (const t1 of r.positionedGlyphs)if (null !== t1.image) {
                    const r = t1.image.toString();
                    t1.rect = e.get(r).paddedRect;
                }
            }
        }
        function Iy(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Sy(t1, e, r, n, i, s, o, a, l) {
            const u = Ty(s.horizontal) || s.vertical, c = r.get("icon-text-fit-padding").evaluate(n, {}, i);
            let h, p = e;
            return e && "none" !== l && (t1.allowVerticalPlacement && s.vertical && (h = Em(e, s.vertical, l, c, a, o)), u && (p = Em(e, u, l, c, a, o))), {
                defaultShapedIcon: p,
                verticallyShapedIcon: h
            };
        }
        function zy(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v) {
            let b = o.textMaxSize.evaluate(e, {}, p);
            void 0 === b ? b = a * o.textScaleFactor : b *= o.textScaleFactor;
            const w = t1.layers[0].layout, _ = Ty(r.horizontal) || r.vertical, A = "globe" === f.name, M = Jd, I = t1.tilePixelRatio * b / M, S = (B = t1.overscaling, t1.zoom > 18 && B > 2 && (B >>= 1), Math.max(Cn / (512 * B), 1) * w.get("symbol-spacing")), z = w.get("text-padding") * t1.tilePixelRatio, k = w.get("icon-padding") * t1.tilePixelRatio, P = Mt(w.get("text-max-angle")), E = "map" === w.get("icon-rotation-alignment") && "point" !== v, T = S / 2;
            var B;
            !1 === t1.hasAnyIconTextFit && "none" !== y && (t1.hasAnyIconTextFit = !0);
            const V = e.properties ? +e.properties[Eu] : null, C = V && t1.elevationFeatureIdToIndex ? t1.elevationFeatureIdToIndex.get(V) : 65535, F = (a, l, v)=>{
                if (l.x < 0 || l.x >= Cn || l.y < 0 || l.y >= Cn) return;
                let b = null;
                if (A) {
                    const { x: t1, y: e, z: r } = f.projectTilePoint(l.x, l.y, v);
                    b = {
                        anchor: new Rm(t1, e, r, 0, void 0),
                        up: f.upVector(v, l.x, l.y)
                    };
                }
                !function(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g, x, v, b, w, _, A, M, I, S, z, k) {
                    const P = t1.addToLineVertexArray(e, n);
                    let E, T, B, V, C, F, D, L = 0, R = 0, O = 0, U = 0, N = -1, j = -1;
                    const $ = {};
                    let G = We("");
                    const q = r ? r.anchor : e, H = "none" !== z;
                    let X = 0, Z = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset")) {
                        const t1 = l.layout.get("text-offset").evaluate(b, {}, M);
                        X = t1[0] * Jd, Z = t1[1] * Jd;
                    } else X = l.layout.get("text-radial-offset").evaluate(b, {}, M) * Jd, Z = my;
                    if (t1.allowVerticalPlacement && i.vertical) {
                        const t1 = i.vertical;
                        if (d) F = Vy(t1), a && (D = Vy(a));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, M) + 90;
                            B = By(u, q, e, c, h, p, t1, f, r, m), a && (V = By(u, q, e, c, h, p, a, g, r));
                        }
                    }
                    if (s) {
                        const n = t1.iconSizeData, i = l.layout.get("icon-rotate").evaluate(b, {}, M), o = sy(s, i, _, H, w.iconScaleFactor), f = a ? sy(a, i, _, H, w.iconScaleFactor) : void 0;
                        T = By(u, q, e, c, h, p, s, g, i, null), L = 4 * o.length;
                        let d = null;
                        "source" === n.kind ? (d = [
                            Cm * l.layout.get("icon-size").evaluate(b, {}, M) * w.iconScaleFactor
                        ], d[0] > Py && Gt(`${t1.layerIds[0]}: Value for "icon-size" is >= ${ky}. Reduce your "icon-size".`)) : "composite" === n.kind && (d = [
                            Cm * w.compositeIconSizes[0].evaluate(b, {}, M) * w.iconScaleFactor,
                            Cm * w.compositeIconSizes[1].evaluate(b, {}, M) * w.iconScaleFactor
                        ], (d[0] > Py || d[1] > Py) && Gt(`${t1.layerIds[0]}: Value for "icon-size" is >= ${ky}. Reduce your "icon-size".`)), t1.addSymbols(t1.icon, o, d, v, x, b, void 0, r, e, P.lineStartIndex, P.lineLength, -1, A, M, I, S), N = t1.icon.placedSymbolArray.length - 1, f && (R = 4 * f.length, t1.addSymbols(t1.icon, f, d, v, x, b, mm.vertical, r, e, P.lineStartIndex, P.lineLength, -1, A, M, I, S), j = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = n, a = i.horizontal[s];
                        E || (G = We(a.text), d ? C = Vy(a) : E = By(u, q, e, c, h, p, a, f, l.layout.get("text-rotate").evaluate(b, {}, M), m));
                        const y = 1 === a.positionedLines.length;
                        if (O += Ey(t1, r, e, a, o, l, d, b, m, P, i.vertical ? mm.horizontal : mm.horizontalOnly, y ? dy(i.horizontal) : [
                            s
                        ], $, N, w, A, M, I), y) break;
                    }
                    i.vertical && (U += Ey(t1, r, e, i.vertical, o, l, d, b, m, P, mm.vertical, [
                        "vertical"
                    ], $, j, w, A, M, I));
                    let W = -1;
                    const Y = (t1, e)=>t1 ? Math.max(t1, e) : e;
                    W = Y(C, W), W = Y(F, W), W = Y(D, W);
                    const K = W > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= 65535 && Gt("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(e.x, e.y, q.x, q.y, q.z, $.right >= 0 ? $.right : -1, $.center >= 0 ? $.center : -1, $.left >= 0 ? $.left : -1, $.vertical >= 0 ? $.vertical : -1, N, j, G, void 0 !== E ? E : t1.collisionBoxArray.length, void 0 !== E ? E + 1 : t1.collisionBoxArray.length, void 0 !== B ? B : t1.collisionBoxArray.length, void 0 !== B ? B + 1 : t1.collisionBoxArray.length, void 0 !== T ? T : t1.collisionBoxArray.length, void 0 !== T ? T + 1 : t1.collisionBoxArray.length, V || t1.collisionBoxArray.length, V ? V + 1 : t1.collisionBoxArray.length, c, O, U, L, R, K, 0, X, Z, W, 0, H ? 1 : 0, k);
                }(t1, l, b, a, r, n, s, i, t1.layers[0], t1.collisionBoxArray, e.index, e.sourceLayerIndex, t1.index, z, x, u, 0, k, E, g, e, o, c, h, p, d, m, y, C);
            };
            if ("line" === v) for (const i of Mf(e.geometry, 0, 0, Cn, Cn)){
                const e = Gm(i, S, P, r.vertical || _, n, M, I, t1.overscaling, Cn);
                for (const r of e)_ && Cy(t1, _.text, T, r) || F(i, r, p);
            }
            else if ("line-center" === v) {
                for (const t1 of e.geometry)if (t1.length > 1) {
                    const e = $m(t1, P, r.vertical || _, n, M, I);
                    e && F(t1, e, p);
                }
            } else if ("Polygon" === e.type) for (const t1 of Wh(e.geometry, 0)){
                const e = hy(t1, 16);
                F(t1[0], new Rm(e.x, e.y, 0, 0, void 0), p);
            }
            else if ("LineString" === e.type) for (const t1 of e.geometry)F(t1, new Rm(t1[0].x, t1[0].y, 0, 0, void 0), p);
            else if ("Point" === e.type) for (const t1 of e.geometry)for (const e of t1)F([
                e
            ], new Rm(e.x, e.y, 0, 0, void 0), p);
        }
        const ky = 255, Py = ky * Cm;
        function Ey(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m, y, g) {
            const x = function(t1, e, r, n, i, s, o, a) {
                const l = [];
                if (0 === e.positionedLines.length) return l;
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = function(t1) {
                    const e = t1[0], r = t1[1], n = e * r;
                    return n > 0 ? [
                        e,
                        -r
                    ] : n < 0 ? [
                        -e,
                        r
                    ] : 0 === e ? [
                        r,
                        e
                    ] : [
                        r,
                        -e
                    ];
                }(r);
                let h = Math.abs(e.top - e.bottom);
                for (const t1 of e.positionedLines)h -= t1.lineOffset;
                const p = e.positionedLines.length, f = h / p;
                let d = e.top - r[1];
                for(let t1 = 0; t1 < p; ++t1){
                    const n = e.positionedLines[t1];
                    d = cy(e, f, d, t1);
                    for (const t1 of n.positionedGlyphs){
                        if (!t1.rect) continue;
                        const n = t1.rect || {};
                        let s = dm + 1, h = !0, p = 1, f = 0;
                        if (t1.image) {
                            const e = o.get(t1.image.toString());
                            if (!e) continue;
                            if (e.sdf) {
                                Gt("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            h = !1, p = e.pixelRatio, s = Xm / p;
                        }
                        const m = (i || a) && t1.vertical, y = t1.metrics.advance * t1.scale / 2, g = t1.metrics, x = t1.rect;
                        if (null === x) continue;
                        a && e.verticalizable && (f = t1.image ? y - t1.metrics.width * t1.scale / 2 : 0);
                        const v = i ? [
                            t1.x + y,
                            t1.y
                        ] : [
                            0,
                            0
                        ];
                        let b = [
                            0,
                            0
                        ], w = [
                            0,
                            0
                        ], _ = !1;
                        i || (m ? (w = [
                            t1.x + y + c[0],
                            t1.y + c[1] - f
                        ], _ = !0) : b = [
                            t1.x + y + r[0],
                            t1.y + r[1] - f
                        ]);
                        const A = x.w * t1.scale / (p * (t1.localGlyph ? ty : 1)), M = x.h * t1.scale / (p * (t1.localGlyph ? ty : 1));
                        let I, S, z, k;
                        if (m) {
                            const e = t1.y - d, r = new bt(-y, y - e), n = -Math.PI / 2, i = new bt(...w);
                            I = new bt(-y + b[0], b[1]), I._rotateAround(n, r)._add(i), I.x += -e + y, I.y -= (g.left - s) * t1.scale;
                            const o = t1.image ? g.advance * t1.scale : Jd * t1.scale, a = String.fromCodePoint(t1.glyph);
                            em(a) ? I.x += (1 - s) * t1.scale : rm(a) ? I.x += o - g.height * t1.scale + (-s - 1) * t1.scale : I.x += t1.image || g.width + 2 * s === x.w && g.height + 2 * s === x.h ? (o - M) / 2 : (o - (g.height + 2 * s) * t1.scale) / 2, S = new bt(I.x, I.y - A), z = new bt(I.x + M, I.y), k = new bt(I.x + M, I.y - A);
                        } else {
                            const e = (g.left - s) * t1.scale - y + b[0], r = (-g.top - s) * t1.scale + b[1], n = e + A, i = r + M;
                            I = new bt(e, r), S = new bt(n, r), z = new bt(e, i), k = new bt(n, i);
                        }
                        if (u) {
                            let t1;
                            t1 = i ? new bt(0, 0) : _ ? new bt(c[0], c[1]) : new bt(r[0], r[1]), I._rotateAround(u, t1), S._rotateAround(u, t1), z._rotateAround(u, t1), k._rotateAround(u, t1);
                        }
                        const P = new bt(0, 0), E = new bt(0, 0);
                        l.push({
                            tl: I,
                            tr: S,
                            bl: z,
                            br: k,
                            texPrimary: n,
                            texSecondary: void 0,
                            writingMode: e.writingMode,
                            glyphOffset: v,
                            sectionIndex: t1.sectionIndex,
                            isSDF: h,
                            pixelOffsetTL: P,
                            pixelOffsetBR: E,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, n, l, s, o, a, i, t1.allowVerticalPlacement), v = t1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                Cm * s.layout.get("text-size").evaluate(a, {}, y) * d.textScaleFactor
            ], b[0] > Py && Gt(`${t1.layerIds[0]}: Value for "text-size" is >= ${ky}. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                Cm * d.compositeTextSizes[0].evaluate(a, {}, y) * d.textScaleFactor,
                Cm * d.compositeTextSizes[1].evaluate(a, {}, y) * d.textScaleFactor
            ], (b[0] > Py || b[1] > Py) && Gt(`${t1.layerIds[0]}: Value for "text-size" is >= ${ky}. Reduce your "text-size".`)), t1.addSymbols(t1.text, x, b, l, o, a, c, e, r, u.lineStartIndex, u.lineLength, f, m, y, g, !1);
            for (const e of h)p[e] = t1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function Ty(t1) {
            for(const e in t1)return t1[e];
            return null;
        }
        function By(t1, e, r, n, i, s, o, a, l, u) {
            let c = o.top, h = o.bottom, p = o.left, f = o.right;
            if (km(o) && o.collisionPadding) {
                const t1 = o.collisionPadding;
                p -= t1[0], c -= t1[1], f += t1[2], h += t1[3];
            }
            if (l) {
                const t1 = new bt(p, c), e = new bt(f, c), r = new bt(p, h), n = new bt(f, h), i = Mt(l);
                let s = new bt(0, 0);
                u && (s = new bt(u[0], u[1])), t1._rotateAround(i, s), e._rotateAround(i, s), r._rotateAround(i, s), n._rotateAround(i, s), p = Math.min(t1.x, e.x, r.x, n.x), f = Math.max(t1.x, e.x, r.x, n.x), c = Math.min(t1.y, e.y, r.y, n.y), h = Math.max(t1.y, e.y, r.y, n.y);
            }
            return t1.emplaceBack(e.x, e.y, e.z, r.x, r.y, p, c, f, h, a, n, i, s), t1.length - 1;
        }
        function Vy(t1) {
            km(t1) && t1.collisionPadding && (t1.top -= t1.collisionPadding[1], t1.bottom += t1.collisionPadding[3]);
            const e = t1.bottom - t1.top;
            return e > 0 ? Math.max(10, e) : null;
        }
        function Cy(t1, e, r, n) {
            const i = t1.compareText;
            if (e in i) {
                const t1 = i[e];
                for(let e = t1.length - 1; e >= 0; e--)if (n.dist(t1[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        function Fy(t1, e) {
            const r = t1.fovAboveCenter, n = t1.elevation ? t1.elevation.getMinElevationBelowMSL() * e : 0, i = (t1._camera.position[2] * t1.worldSize - n) / Math.cos(t1._pitch), s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t1._pitch - r, .01));
            let o = Math.sin(t1._pitch) * s + i;
            const a = i * (1 / t1._horizonShift);
            if (!t1.elevation || 0 === t1.elevation.exaggeration()) {
                let e = Math.max(t1.zoom - 17, 0);
                t1.isOrthographic && (e /= 10), o *= 1 + e;
            }
            return Math.min(1.01 * o, a);
        }
        function Dy(t1, e) {
            if (!e.isReprojectedInTileSpace) return {
                scale: 1 << t1.z,
                x: t1.x,
                y: t1.y,
                x2: t1.x + 1,
                y2: t1.y + 1,
                projection: e
            };
            const r = Math.pow(2, -t1.z), n = t1.x * r, i = (t1.x + 1) * r, s = t1.y * r, o = (t1.y + 1) * r, a = tu(n), l = tu(i), u = eu(s), c = eu(o), h = e.project(a, u), p = e.project(l, u), f = e.project(l, c), d = e.project(a, c);
            let m = Math.min(h.x, p.x, f.x, d.x), y = Math.min(h.y, p.y, f.y, d.y), g = Math.max(h.x, p.x, f.x, d.x), x = Math.max(h.y, p.y, f.y, d.y);
            const v = r / 16;
            function b(t1, r, n, i, s, o) {
                const a = (n + s) / 2, l = (i + o) / 2, u = e.project(tu(a), eu(l)), c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
                m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > v && (b(t1, u, n, i, a, l), b(u, r, a, l, s, o));
            }
            b(h, p, n, s, i, s), b(p, f, i, s, i, o), b(f, d, i, o, n, o), b(d, h, n, o, n, s), m -= v, y -= v, g += v, x += v;
            const w = 1 / Math.max(g - m, x - y);
            return {
                scale: w,
                x: m * w,
                y: y * w,
                x2: g * w,
                y2: x * w,
                projection: e
            };
        }
        function Ly(t1, { x: e, y: r }, n = 0) {
            return new bt(((e - n) * t1.scale - t1.x) * Cn, (r * t1.scale - t1.y) * Cn);
        }
        const Ry = l(new Float32Array(16));
        class Oy {
            constructor(t1){
                this.spec = t1, this.name = t1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(t1, e) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(t1, e) {
                return new Hl(0, 0);
            }
            projectTilePoint(t1, e, r) {
                return {
                    x: t1,
                    y: e,
                    z: 0
                };
            }
            locationPoint(t1, e, r, n = !0) {
                return t1._coordinatePoint(t1.locationCoordinate(e, r), n);
            }
            pixelsPerMeter(t1, e) {
                return Ql(1, t1) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                return 1;
            }
            farthestPixelDistance(t1) {
                return Fy(t1, t1.pixelsPerMeter);
            }
            pointCoordinate(t1, e, r, n) {
                const i = t1.horizonLineFromTop(!1), s = new bt(e, Math.max(i, r));
                return t1.rayIntersectionCoordinate(t1.pointRayIntersection(s, n));
            }
            pointCoordinate3D(t1, e, r) {
                const n = new bt(e, r);
                if (t1.elevation) return t1.elevation.pointCoordinate(n);
                {
                    const e = this.pointCoordinate(t1, n.x, n.y, 0);
                    return [
                        e.x,
                        e.y,
                        e.z
                    ];
                }
            }
            isPointAboveHorizon(t1, e) {
                if (t1.elevation && t1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t1, e.x, e.y);
                const r = t1.horizonLineFromTop();
                return e.y < r;
            }
            createInversionMatrix(t1, e) {
                return Ry;
            }
            createTileMatrix(t1, e, r) {
                let n, i, s;
                const o = r.canonical, a = l(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = Dy(o, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, p(a, a, [
                        n / l.scale,
                        n / l.scale,
                        t1.pixelsPerMeter / e
                    ]);
                } else n = e / t1.zoomScale(o.z), i = (o.x + Math.pow(2, o.z) * r.wrap) * n, s = o.y * n;
                return h(a, a, [
                    i,
                    s,
                    0
                ]), p(a, a, [
                    n / Cn,
                    n / Cn,
                    1
                ]), a;
            }
            upVector(t1, e, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(t1, e, r) {
                return {
                    metersToTile: 1
                };
            }
        }
        class Uy extends Oy {
            constructor(t1){
                super(t1), this.range = [
                    4,
                    7
                ], this.center = t1.center || [
                    -96,
                    37.5
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Mt(e));
                this.n = (n + Math.sin(Mt(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(t1, e) {
                const { n: r, c: n, r0: i } = this, s = Mt(t1 - this.center[0]), o = Mt(e), a = Math.sqrt(n - 2 * r * Math.sin(o)) / r;
                return {
                    x: a * Math.sin(s * r),
                    y: a * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { n: r, c: n, r0: i } = this, s = i + e;
                let o = Math.atan2(t1, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (o -= Math.PI * Math.sign(t1) * Math.sign(s));
                const a = Mt(this.center[0]) * r;
                o = Bt(o, -Math.PI - a, Math.PI - a);
                const l = Et(It(o / r) + this.center[0], -180, 180), u = Math.asin(Et((n - (t1 * t1 + s * s) * r * r) / (2 * r), -1, 1)), c = Et(It(u), -85.051129, nu);
                return new Hl(l, c);
            }
        }
        const Ny = 1.340264, jy = -0.081106, $y = 893e-6, Gy = .003796, qy = Math.sqrt(3) / 2;
        class Hy extends Oy {
            project(t1, e) {
                e = e / 180 * Math.PI, t1 = t1 / 180 * Math.PI;
                const r = Math.asin(qy * Math.sin(e)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (t1 * Math.cos(r) / (qy * (Ny + 3 * jy * n + i * (7 * $y + 9 * Gy * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (Ny + jy * n + i * ($y + Gy * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let t1, s, o, a = 0; a < 12 && (s = r * (Ny + jy * n + i * ($y + Gy * n)) - e, o = Ny + 3 * jy * n + i * (7 * $y + 9 * Gy * n), t1 = s / o, r = Et(r - t1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(t1) < 1e-12)); ++a);
                const s = qy * t1 * (Ny + 3 * jy * n + i * (7 * $y + 9 * Gy * n)) / Math.cos(r), o = Math.asin(Math.sin(r) / qy), a = Et(180 * s / Math.PI, -180, 180), l = Et(180 * o / Math.PI, -85.051129, nu);
                return new Hl(a, l);
            }
        }
        class Xy extends Oy {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e) {
                return {
                    x: .5 + t1 / 360,
                    y: .5 - e / 360,
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = 360 * (t1 - .5), n = Et(360 * (.5 - e), -85.051129, nu);
                return new Hl(r, n);
            }
        }
        const Zy = Math.PI / 2;
        function Wy(t1) {
            return Math.tan((Zy + t1) / 2);
        }
        class Yy extends Oy {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    30
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    30,
                    30
                ];
                let n = Mt(e), i = Mt(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const s = Math.cos(n), o = Wy(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Wy(i) / o), this.f = s * Math.pow(Wy(n), this.n) / this.n;
            }
            project(t1, e) {
                e = Mt(e), this.southernCenter && (e = -e), t1 = Mt(t1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? e < -Zy + r && (e = -Zy + r) : e > Zy - r && (e = Zy - r);
                const s = i / Math.pow(Wy(e), n);
                let o = s * Math.sin(n * t1), a = i - s * Math.cos(n * t1);
                return o = .5 * (o / Math.PI + .5), a = .5 * (a / Math.PI + .5), {
                    x: o,
                    y: this.southernCenter ? a : 1 - a,
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI, this.southernCenter && (e = 1 - e), e = (2 * (1 - e) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - e, s = Math.sign(i), o = Math.sign(r) * Math.sqrt(t1 * t1 + i * i);
                let a = Math.atan2(t1, Math.abs(i)) * s;
                i * r < 0 && (a -= Math.PI * Math.sign(t1) * s);
                const l = Et(It(a / r) + this.center[0], -180, 180), u = Et(It(2 * Math.atan(Math.pow(n / o, 1 / r)) - Zy), -85.051129, nu);
                return new Hl(l, this.southernCenter ? -u : u);
            }
        }
        class Ky extends Oy {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(t1, e) {
                return {
                    x: Kl(t1),
                    y: Jl(e),
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = tu(t1), n = eu(e);
                return new Hl(r, n);
            }
        }
        const Jy = Mt(nu);
        class Qy extends Oy {
            project(t1, e) {
                const r = (e = Mt(e)) * e, n = r * r;
                return {
                    x: .5 * ((t1 = Mt(t1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (e * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const t1 = s * s;
                    i = (r * (1.007226 + s * (.015085 + t1 * (.028874 * s - .044475 - .005916 * t1))) - e) / (1.007226 + s * (.045255 + t1 * (.259866 * s - .311325 - .005916 * 11 * t1))), r = Et(r - i, -Jy, Jy);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const o = Et(It(t1 / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), a = It(r);
                return new Hl(o, a);
            }
        }
        const tg = Mt(nu);
        class eg extends Oy {
            project(t1, e) {
                e = Mt(e), t1 = Mt(t1);
                const r = Math.cos(e), n = 2 / Math.PI, i = Math.acos(r * Math.cos(t1 / 2)), s = Math.sin(i) / i, o = .5 * (t1 * n + 2 * r * Math.sin(t1 / 2) / s) || 0, a = .5 * (e + Math.sin(e) / s) || 0;
                return {
                    x: .5 * (o / Math.PI + .5),
                    y: 1 - .5 * (a / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                let r = t1 = (2 * t1 - .5) * Math.PI, n = e = (2 * (1 - e) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let o = 0, a = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), f = 2 * h * p, d = p * p, m = 1 - c * h * h, y = m ? 1 / m : 0, g = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, x = .5 * (2 * g * i * p + 2 * r / Math.PI) - t1, v = .5 * (g * s + n) - e, b = .5 * y * (c * d + g * i * h * u) + 1 / Math.PI, w = y * (f * l / 4 - g * s * p), _ = .125 * y * (l * p - g * s * c * f), A = .5 * y * (u * h + g * d * i) + .5, M = w * _ - A * b;
                    o = (v * w - x * A) / M, a = (x * _ - v * b) / M, r = Et(r - o, -Math.PI, Math.PI), n = Et(n - a, -tg, tg);
                }while ((Math.abs(o) > s || Math.abs(a) > s) && --i > 0);
                return new Hl(It(r), It(n));
            }
        }
        class rg extends Oy {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    0
                ], this.parallels = t1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Mt(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: Mt(t1) * n * r + .5,
                    y: -Math.sin(Mt(e)) / n * r + .5,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { scale: r, cosPhi: n } = this, i = -(e - .5) / r, s = Et(It((t1 - .5) / r) / n, -180, 180), o = Math.asin(Et(i * n, -1, 1)), a = Et(It(o), -85.051129, nu);
                return new Hl(s, a);
            }
        }
        class ng extends Ky {
            constructor(t1){
                super(t1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(t1, e, r) {
                const n = Uc(t1, e, r);
                return R(n, n, $c(Cc(r))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(t1, e, r) {
                const n = $l(e.lat, e.lng), i = C([], n), s = r ? t1._centerAltitude + r : t1.elevation ? t1.elevation.getAtPointOrZero(t1.locationCoordinate(e), t1._centerAltitude) : t1._centerAltitude;
                E(n, n, i, Ql(1, 0) * Cn * s);
                const o = l(new Float64Array(16));
                return c(o, t1.pixelMatrix, t1.globeMatrix), R(n, n, o), new bt(n[0], n[1]);
            }
            pixelsPerMeter(t1, e) {
                return Ql(1, 0) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                const n = Ql(1, t1) * e, i = ur(Ql(1, 45) * e, n, r);
                return this.pixelsPerMeter(t1, e) / i;
            }
            createTileMatrix(t1, e, r) {
                const n = Gc(Cc(r.canonical));
                return c(new Float64Array(16), t1.globeMatrix, n);
            }
            createInversionMatrix(t1, e) {
                const { center: r } = t1, n = $c(Cc(e));
                return d(n, n, Mt(r.lng)), f(n, n, Mt(r.lat)), p(n, n, [
                    t1._pixelsPerMercatorPixel,
                    t1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(t1, e, r, n) {
                return Tc(t1, e, r, !0) || new lu(0, 0);
            }
            pointCoordinate3D(t1, e, r) {
                const n = this.pointCoordinate(t1, e, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(t1, e) {
                return !Tc(t1, e.x, e.y, !1);
            }
            farthestPixelDistance(t1) {
                const e = function(t1, e) {
                    const r = t1.cameraToCenterDistance, n = t1._centerAltitude * e, i = t1._camera, s = t1._camera.forward(), o = M([], P([], s, -r), [
                        0,
                        0,
                        n
                    ]), a = t1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -a
                    ], u = t1.width / t1.height, c = Math.tan(t1.fovAboveCenter), h = P([], i.up(), c), p = P([], i.right(), c * u), f = C([], M([], M([], s, h), p)), d = [];
                    let m;
                    if (new Ru(o, f).closestPointOnSphere(l, a, d)) {
                        const e = M([], d, l), r = j([], e, o);
                        m = Math.cos(t1.fovAboveCenter) * _(r);
                    } else {
                        const t1 = j([], o, l), e = j([], l, o);
                        C(e, e);
                        const r = _(t1) - a;
                        m = Math.sqrt(r * (r + 2 * a));
                        const n = Math.acos(m / (a + r)) - Math.acos(F(s, e));
                        m *= Math.cos(n);
                    }
                    return 1.01 * m;
                }(t1, this.pixelsPerMeter(t1.center.lat, t1.worldSize)), r = Zc(t1.zoom);
                if (r > 0) {
                    const n = Fy(t1, Ql(1, t1.center.lat) * t1.worldSize), i = t1.worldSize / (2 * Math.PI), s = Math.max(t1.width, t1.height) / t1.worldSize * Math.PI;
                    return ur(e, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return e;
            }
            upVector(t1, e, r) {
                return Uc(e, r, t1, 1);
            }
            upVectorScale(t1) {
                return {
                    metersToTile: Pc(Nc(Cc(t1)))
                };
            }
        }
        function ig(t1) {
            const e = t1.parallels, r = !!e && Math.abs(e[0] + e[1]) < .01;
            switch(t1.name){
                case "mercator":
                    return new Ky(t1);
                case "equirectangular":
                    return new Xy(t1);
                case "naturalEarth":
                    return new Qy(t1);
                case "equalEarth":
                    return new Hy(t1);
                case "winkelTripel":
                    return new eg(t1);
                case "albers":
                    return r ? new rg(t1) : new Uy(t1);
                case "lambertConformalConic":
                    return r ? new rg(t1) : new Yy(t1);
                case "globe":
                    return new ng(t1);
            }
            throw new Error(`Invalid projection name: ${t1.name}`);
        }
        const sg = Pu.VectorTileFeature.types, og = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function ag(t1, e, r, n, i, s, o, a, l, u, c, h, p) {
            const f = a ? Math.min(Py, Math.round(a[0])) : 0, d = a ? Math.min(Py, Math.round(a[1])) : 0;
            t1.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), s, o, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function lg(t1, e, r) {
            t1.emplaceBack(e, r);
        }
        function ug(t1, e, r, n, i, s, o) {
            t1.emplaceBack(e, r, n, i, s, o);
        }
        const cg = (t1, e, r, n)=>{
            for(let i = 0; i < e; i++)t1.emplaceBack(r[0], r[1], r[2], n[0], n[1], n[2]);
        };
        function hg(t1, e, r, n, i) {
            t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i);
        }
        function pg(t1) {
            for (const e of t1.sections)if (so(e.text)) return !0;
            return !1;
        }
        class fg {
            constructor(t1){
                this.layoutVertexArray = new da, this.indexArray = new Aa, this.programConfigurations = t1, this.segments = new tl, this.dynamicLayoutVertexArray = new ya, this.opacityVertexArray = new ga, this.placedSymbolArray = new Na, this.iconTransitioningVertexArray = new xa, this.globeExtVertexArray = new ma, this.zOffsetVertexArray = new sa, this.orientationVertexArray = new Sa;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(t1, e, r, n, i) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, jd.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Gd.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, og, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t1.createVertexBuffer(this.iconTransitioningVertexArray, Xd.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, $d.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, qd.members, !0)), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = t1.createVertexBuffer(this.orientationVertexArray, Hd.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy());
            }
        }
        qs(fg, "SymbolBuffers");
        class dg {
            constructor(t1, e, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e, this.indexArray = new r, this.segments = new tl, this.collisionVertexArray = new _a, this.collisionVertexArrayExt = new ya;
            }
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Zd.members, !0), this.collisionVertexBufferExt = t1.createVertexBuffer(this.collisionVertexArrayExt, Wd.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        qs(dg, "CollisionBuffers");
        class mg {
            constructor(t1){
                this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.lut = t1.lut, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = l([]), this.placementViewportMatrix = l([]);
                const e = this.layers[0]._unevaluatedLayout._values;
                this.worldview = t1.worldview, this.textSizeData = Fm(this.zoom, e["text-size"], this.worldview), this.iconSizeData = Fm(this.zoom, e["icon-size"], this.worldview);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((t1)=>mm[t1]), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = t1.sourceID, this.projection = t1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = !1, this.elevationType = "none", this.elevationStateComplete = !1, this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
            createArrays() {
                this.text = new fg(new kl(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("text") || t1.startsWith("symbol"))), this.icon = new fg(new kl(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("icon") || t1.startsWith("symbol"))), this.glyphOffsetArray = new Ga, this.lineVertexArray = new qa, this.symbolInstances = new $a;
            }
            calculateGlyphDependencies(t1, e, r, n, i) {
                for (const r of t1){
                    const t1 = r.codePointAt(0);
                    if (void 0 === t1) break;
                    if (e[t1] = !0, n && i && t1 <= 65535) {
                        const t1 = tm[r];
                        t1 && (e[t1.charCodeAt(0)] = !0);
                    }
                }
            }
            updateFootprints(t1, e) {}
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                return !Vp(this.activeReplacements, r) && (this.activeReplacements = r, !0);
            }
            populate(t1, e, r, n) {
                const i = this.layers[0], s = i.layout, o = "globe" === this.projection.name, a = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), [c, h] = s.get("icon-size-scale-range"), p = Et(e.scaleFactor || 1, c, h), f = ("constant" !== l.value.kind || l.value.value instanceof Cr && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), d = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, m = s.get("symbol-sort-key");
                if (this.features = [], !f && !d) return;
                const y = e.iconDependencies, g = e.glyphDependencies, x = e.availableImages, v = new go(this.zoom, {
                    worldview: this.worldview
                });
                for (const { feature: e, id: l, index: u, sourceLayerIndex: c } of t1){
                    const t1 = i._featureFilter.needGeometry, h = gu(e, t1);
                    if (!i._featureFilter.filter(v, h, r)) continue;
                    if (t1 || (h.geometry = yu(e, r, n)), o && 1 !== e.type && r.z <= 5) {
                        const t1 = h.geometry, e = .98078528056, n = (t1, n)=>F(Uc(t1.x, t1.y, r, 1), Uc(n.x, n.y, r, 1)) < e;
                        for(let e = 0; e < t1.length; e++)t1[e] = pu(t1[e], n);
                    }
                    let b, w;
                    if (f) {
                        const t1 = i.getValueAndResolveTokens("text-field", h, r, x), e = Cr.factory(t1);
                        pg(e) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === fo() || this.hasRTLText && yo.isParsed()) && (b = Qd(e, i, h));
                    }
                    if (d) {
                        const t1 = i.getValueAndResolveTokens("icon-image", h, r, x);
                        w = "string" == typeof t1 ? Dr.build(t1) : t1;
                    }
                    if (!b && !w) continue;
                    const _ = this.sortFeaturesByKey ? m.evaluate(h, {}, r) : void 0, A = {
                        id: l,
                        text: b,
                        icon: w,
                        index: u,
                        sourceLayerIndex: c,
                        geometry: h.geometry,
                        properties: e.properties,
                        type: sg[e.type],
                        sortKey: _
                    };
                    if (this.features.push(A), w) {
                        const t1 = this.layers[0]._unevaluatedLayout._values, { iconPrimary: e, iconSecondary: n } = by(w, this.iconSizeData, t1["icon-size"], r, this.zoom, A, this.pixelRatio, p, this.worldview), i = e.id.toString();
                        if (y.has(i) ? y.get(i).push(e) : y.set(i, [
                            e
                        ]), n) {
                            const t1 = n.id.toString();
                            y.has(t1) ? y.get(t1).push(n) : y.set(t1, [
                                n
                            ]);
                        }
                    }
                    if (b) {
                        const t1 = a.evaluate(h, {}, r).join(","), e = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(mm.vertical) >= 0;
                        for (const r of b.sections)if (r.image) {
                            const t1 = r.image.getPrimary().scaleSelf(this.pixelRatio), e = t1.id.toString(), n = y.get(e) || [];
                            n.push(t1), y.set(e, n);
                        } else {
                            const n = Ks(b.toString()), i = r.fontStack || t1, s = g[i] = g[i] || {};
                            this.calculateGlyphDependencies(r.text, s, e, this.allowVerticalPlacement, n);
                        }
                    }
                }
                if ("line" === s.get("symbol-placement") && (this.features = function(t1) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function s(e) {
                        n.push(t1[e]), i++;
                    }
                    function o(t1, e, i) {
                        const s = r[t1];
                        return delete r[t1], r[e] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function a(t1, r, i) {
                        const s = e[r];
                        return delete e[r], e[t1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t1, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t1 = a(f, d, h), i = o(f, d, n[t1].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? o(f, d, h) : d in e ? a(f, d, h) : (s(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), "hd-road-markup" === s.get("symbol-elevation-reference")) {
                    if (this.elevationType = "road", e.elevationFeatures) {
                        !this.elevationFeatures && e.elevationFeatures.length > 0 && (this.elevationFeatures = [], this.elevationFeatureIdToIndex = new Map);
                        for (const t1 of e.elevationFeatures)this.elevationFeatureIdToIndex.set(t1.id, this.elevationFeatures.length), this.elevationFeatures.push(t1);
                    }
                } else s.get("symbol-z-elevate") && (this.elevationType = "offset");
                "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = !0), this.sortFeaturesByKey && this.features.sort((t1, e)=>t1.sortKey - e.sortKey);
            }
            update(t1, e, r, n, i, s, o) {
                this.text.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, this.worldview), this.icon.programConfigurations.updatePaintArrays(t1, e, i, r, n, s, o, this.worldview);
            }
            updateRoadElevation(t1) {
                if ("road" !== this.elevationType || !this.elevationFeatures) return;
                if (this.elevationStateComplete) return;
                this.elevationStateComplete = !0, this.hasAnyZOffset = !1;
                let e = !1;
                const r = au(t1), n = 1 / r;
                let i = !1, s = !1;
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const o = this.symbolInstances.get(t1), a = A(1, 0, 0), l = A(0, 1, 0), { numHorizontalGlyphVertices: u, numVerticalGlyphVertices: c, numIconVertices: h, numVerticalIconVertices: p } = o, f = u > 0 || c > 0, d = h > 0, m = this.elevationFeatures[o.elevationFeatureIndex];
                    if (m) {
                        const t1 = new bt(o.tileAnchorX, o.tileAnchorY), u = .075 + m.pointElevation(t1);
                        o.zOffset !== u && (e = !0, o.zOffset = u);
                        const c = m.computeSlopeNormal(t1, n), h = st(W(), A(0, 0, 1), c);
                        U(a, a, h), U(l, l, h), a[2] *= r, l[2] *= r, 1 === a[0] && 0 === a[1] && 0 === a[2] && 0 === l[0] && 1 === l[1] && 0 === l[2] || (i = i || f, s = s || d);
                    }
                    if (f && (cg(this.text.orientationVertexArray, u, a, l), cg(this.text.orientationVertexArray, c, a, l)), d) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: e } = o;
                        t1 >= 0 && cg(this.icon.orientationVertexArray, h, a, l), e >= 0 && cg(this.icon.orientationVertexArray, p, a, l);
                    }
                }
                i || (this.text.orientationVertexArray = void 0), s || (this.icon.orientationVertexArray = void 0), e && (this.zOffsetBuffersNeedUpload = !0, this.zOffsetSortDirty = !0);
            }
            updateZOffset() {
                const t1 = (t1, e, n)=>{
                    r += e, r > t1.length && t1.resize(r);
                    for(let i = -e; i < 0; i++)t1.emplace(i + r, n);
                }, e = (t1, e, r)=>{
                    n += e, n > t1.length && t1.resize(n);
                    for(let i = -e; i < 0; i++)t1.emplace(i + n, r);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let r = 0, n = 0;
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const n = this.symbolInstances.get(r), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: s, numIconVertices: o } = n, a = n.zOffset, l = o > 0;
                    if ((i > 0 || s > 0) && (t1(this.text.zOffsetVertexArray, i, a), t1(this.text.zOffsetVertexArray, s, a)), l) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: r } = n;
                        t1 >= 0 && e(this.icon.zOffsetVertexArray, o, a), r >= 0 && e(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, a);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = ig(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) for (const { x: t1, y: r } of e)this.lineVertexArray.emplaceBack(t1, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t1, e, r, n, i, s, o, a, l, u, c, h, p, f, d, m) {
                const y = t1.indexArray, g = t1.layoutVertexArray, x = t1.globeExtVertexArray, v = t1.segments.prepareSegment(4 * e.length, g, y, this.canOverlap ? s.sortKey : void 0), b = this.glyphOffsetArray.length, w = v.vertexLength, _ = this.allowVerticalPlacement && o === mm.vertical ? Math.PI / 2 : 0, A = s.text && s.text.sections;
                for(let n = 0; n < e.length; n++){
                    const { tl: i, tr: o, bl: u, br: c, texPrimary: h, texSecondary: b, pixelOffsetTL: w, pixelOffsetBR: M, minFontScaleX: I, minFontScaleY: S, glyphOffset: z, isSDF: k, sectionIndex: P } = e[n], E = v.vertexLength, T = z[1];
                    if (ag(g, l.x, l.y, i.x, T + i.y, h.x, h.y, r, k, w.x, w.y, I, S), ag(g, l.x, l.y, o.x, T + o.y, h.x + h.w, h.y, r, k, M.x, w.y, I, S), ag(g, l.x, l.y, u.x, T + u.y, h.x, h.y + h.h, r, k, w.x, M.y, I, S), ag(g, l.x, l.y, c.x, T + c.y, h.x + h.w, h.y + h.h, r, k, M.x, M.y, I, S), a) {
                        const { x: e, y: r, z: n } = a.anchor, [i, s, o] = a.up;
                        ug(x, e, r, n, i, s, o), ug(x, e, r, n, i, s, o), ug(x, e, r, n, i, s, o), ug(x, e, r, n, i, s, o), hg(t1.dynamicLayoutVertexArray, e, r, n, _);
                    } else hg(t1.dynamicLayoutVertexArray, l.x, l.y, l.z, _);
                    if (m) {
                        const e = b || h;
                        lg(t1.iconTransitioningVertexArray, e.x, e.y), lg(t1.iconTransitioningVertexArray, e.x + e.w, e.y), lg(t1.iconTransitioningVertexArray, e.x, e.y + e.h), lg(t1.iconTransitioningVertexArray, e.x + e.w, e.y + e.h);
                    }
                    y.emplaceBack(E, E + 1, E + 2), y.emplaceBack(E + 1, E + 2, E + 3), v.vertexLength += 4, v.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(z[0]), n !== e.length - 1 && P === e[n + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(g.length, s, s.index, {}, p, f, d, A && A[P], this.worldview);
                }
                const M = a ? a.anchor : l;
                t1.placedSymbolArray.emplaceBack(M.x, M.y, M.z, l.x, l.y, b, this.glyphOffsetArray.length - b, w, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, 0, 0, h, 0);
            }
            _commitLayoutVertex(t1, e, r, n, i, s, o) {
                t1.emplaceBack(e, r, n, i, s, Math.round(o.x), Math.round(o.y));
            }
            _addCollisionDebugVertices(t1, e, r, n, i, s, o) {
                const a = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = a.vertexLength, u = o.tileAnchorX, c = o.tileAnchorY;
                for(let t1 = 0; t1 < 4; t1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, e, t1.padding, o.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new bt(t1.x1, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new bt(t1.x2, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new bt(t1.x2, t1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new bt(t1.x1, t1.y2)), a.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), a.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceTextSize(t1, s, e, o);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceIconSize(t1, e, s.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(t1, e, r) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new dg(ba, Yd.members, xa), this.iconCollisionBox = new dg(ba, Yd.members, xa);
                const n = Lm(this.iconSizeData, t1), i = Lm(this.textSizeData, t1, r);
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const s = this.symbolInstances.get(r);
                    this._addTextDebugCollisionBoxes(i, t1, e, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(i, t1, e, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, t1, e, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, t1, e, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(t1, e, r, n) {
                const i = this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex >= 0 ? e.rightJustifiedTextSymbolIndex : e.centerJustifiedTextSymbolIndex >= 0 ? e.centerJustifiedTextSymbolIndex : e.leftJustifiedTextSymbolIndex >= 0 ? e.leftJustifiedTextSymbolIndex : e.verticalPlacedTextSymbolIndex >= 0 ? e.verticalPlacedTextSymbolIndex : n), s = Dm(this.textSizeData, t1, i) / Jd;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(t1, e, r) {
                const n = this.icon.placedSymbolArray.get(r), i = Dm(this.iconSizeData, t1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(t1, e, r, n) {
                t1.emplaceBack(e, -r, -r, n), t1.emplaceBack(e, r, -r, n), t1.emplaceBack(e, r, r, n), t1.emplaceBack(e, -r, r, n);
            }
            _updateTextDebugCollisionBoxes(t1, e, r, n, i, s, o) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceTextSize(t1, s, e, o);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(t1, e, r, n, i, s, o) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceIconSize(t1, e, s.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            updateCollisionDebugBuffers(t1, e, r, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = Lm(this.iconSizeData, t1, n), s = Lm(this.textSizeData, t1, r);
                for(let o = 0; o < this.symbolInstances.length; o++){
                    const a = this.symbolInstances.get(o);
                    this._updateTextDebugCollisionBoxes(s, t1, e, a.textBoxStartIndex, a.textBoxEndIndex, a, r), this._updateTextDebugCollisionBoxes(s, t1, e, a.verticalTextBoxStartIndex, a.verticalTextBoxEndIndex, a, r), this._updateIconDebugCollisionBoxes(i, t1, e, a.iconBoxStartIndex, a.iconBoxEndIndex, a, n), this._updateIconDebugCollisionBoxes(i, t1, e, a.verticalIconBoxStartIndex, a.verticalIconBoxEndIndex, a, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t1, e, r, n, i, s, o, a, l) {
                const u = {};
                if (e < r) {
                    const { x1: r, y1: n, x2: i, y2: s, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(e);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: s,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.textFeatureIndex = f;
                }
                if (n < i) {
                    const { x1: e, y1: r, x2: i, y2: s, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(n);
                    u.verticalTextBox = {
                        x1: e,
                        y1: r,
                        x2: i,
                        y2: s,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalTextFeatureIndex = f;
                }
                if (s < o) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(s);
                    u.iconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.iconFeatureIndex = f;
                }
                if (a < l) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(a);
                    u.verticalIconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalIconFeatureIndex = f;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(t1, e) {
                const r = t1.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t1.indexArray.emplaceBack(e, e + 1, e + 2), t1.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t1), r = Math.cos(t1), n = [], i = [], s = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    s.push(t1);
                    const o = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e * o.tileAnchorX + r * o.tileAnchorY)), i.push(o.featureIndex);
                }
                return s.sort((t1, e)=>n[t1] - n[e] || i[e] - i[t1]), s;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let t1 = 0; t1 < this.symbolInstances.length; ++t1)this.symbolInstanceIndexesSortedZOffset.push(t1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((t1, e)=>this.symbolInstances.get(e).zOffset - this.symbolInstances.get(t1).zOffset);
            }
            addToSortKeyRanges(t1, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e.featureIndex);
                        const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s, placedIconSymbolIndex: o, verticalPlacedIconSymbolIndex: a } = e;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let yg, gg, xg;
        qs(mg, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), mg.addDynamicAttributes = hg;
        class vg {
            constructor(t1){
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : mr, this.defaultValue = t1;
            }
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t1.formattedSection)) return e.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        qs(vg, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const bg = ()=>xg || (xg = {
                layout: yg || (yg = new Po({
                    "symbol-placement": new So(Eo.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new So(Eo.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new So(Eo.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new zo(Eo.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new So(Eo.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new So(Eo.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new So(Eo.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new So(Eo.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new So(Eo.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new So(Eo.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new So(Eo.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new zo(Eo.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new So(Eo.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new zo(Eo.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new zo(Eo.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new zo(Eo.layout_symbol["icon-image"]),
                    "icon-rotate": new zo(Eo.layout_symbol["icon-rotate"]),
                    "icon-padding": new So(Eo.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new So(Eo.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new zo(Eo.layout_symbol["icon-offset"]),
                    "icon-anchor": new zo(Eo.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new So(Eo.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new So(Eo.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new So(Eo.layout_symbol["text-rotation-alignment"]),
                    "text-field": new zo(Eo.layout_symbol["text-field"]),
                    "text-font": new zo(Eo.layout_symbol["text-font"]),
                    "text-size": new zo(Eo.layout_symbol["text-size"]),
                    "text-size-scale-range": new So(Eo.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new zo(Eo.layout_symbol["text-max-width"]),
                    "text-line-height": new zo(Eo.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new zo(Eo.layout_symbol["text-letter-spacing"]),
                    "text-justify": new zo(Eo.layout_symbol["text-justify"]),
                    "text-radial-offset": new zo(Eo.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new So(Eo.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new zo(Eo.layout_symbol["text-anchor"]),
                    "text-max-angle": new So(Eo.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new So(Eo.layout_symbol["text-writing-mode"]),
                    "text-rotate": new zo(Eo.layout_symbol["text-rotate"]),
                    "text-padding": new So(Eo.layout_symbol["text-padding"]),
                    "text-keep-upright": new So(Eo.layout_symbol["text-keep-upright"]),
                    "text-transform": new zo(Eo.layout_symbol["text-transform"]),
                    "text-offset": new zo(Eo.layout_symbol["text-offset"]),
                    "text-allow-overlap": new So(Eo.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new So(Eo.layout_symbol["text-ignore-placement"]),
                    "text-optional": new So(Eo.layout_symbol["text-optional"]),
                    visibility: new So(Eo.layout_symbol.visibility)
                })),
                paint: gg || (gg = new Po({
                    "icon-opacity": new zo(Eo.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new zo(Eo.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new zo(Eo.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new zo(Eo.paint_symbol["text-emissive-strength"]),
                    "icon-color": new zo(Eo.paint_symbol["icon-color"]),
                    "icon-halo-color": new zo(Eo.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new zo(Eo.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new zo(Eo.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new So(Eo.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new So(Eo.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new So(Eo.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new zo(Eo.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new zo(Eo.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new zo(Eo.paint_symbol["text-color"], {
                        runtimeType: vr,
                        getOverride: (t1)=>t1.textColor,
                        hasOverride: (t1)=>!!t1.textColor
                    }),
                    "text-halo-color": new zo(Eo.paint_symbol["text-halo-color"]),
                    "text-halo-width": new zo(Eo.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new zo(Eo.paint_symbol["text-halo-blur"]),
                    "text-translate": new So(Eo.paint_symbol["text-translate"]),
                    "text-translate-anchor": new So(Eo.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new So(Eo.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new So(Eo.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new So(Eo.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new So(Eo.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new zo(Eo.paint_symbol["symbol-z-offset"]),
                    "icon-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new zo({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, xg);
        class wg extends Yo {
            constructor(t1, e, r, n){
                super(t1, bg(), e, r, n), this._colorAdjustmentMatrix = l([]), this.hasInitialOcclusionOpacityProperties = void 0 !== t1.paint && ("icon-occlusion-opacity" in t1.paint || "text-occlusion-opacity" in t1.paint);
            }
            recalculate(t1, e) {
                super.recalculate(t1, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const t1 = [];
                    for (const e of r)t1.indexOf(e) < 0 && t1.push(e);
                    this.layout._values["text-writing-mode"] = t1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(t1, e, r, n) {
                return this._saturation === t1 && this._contrast === e && this._brightnessMin === r && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(t1, e, r, n) {
                    t1 = ee(t1), e = te(e);
                    const i = a(), s = t1 / 3, o = 1 - 2 * s, l = [
                        o,
                        s,
                        s,
                        0,
                        s,
                        o,
                        s,
                        0,
                        s,
                        s,
                        o,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], u = .5 - .5 * e, h = n - r;
                    return c(i, [
                        h,
                        0,
                        0,
                        0,
                        0,
                        h,
                        0,
                        0,
                        0,
                        0,
                        h,
                        0,
                        r,
                        r,
                        r,
                        1
                    ], [
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        u,
                        u,
                        u,
                        1
                    ]), c(i, i, l), i;
                }(t1, e, r, n), this._saturation = t1, this._contrast = e, this._brightnessMin = r, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(t1, e, r, n) {
                const i = this.layout.get(t1).evaluate(e, {}, r, n), s = this._unevaluatedLayout._values[t1];
                return s.isDataDriven() || Vs(s.value) || !i ? i : function(t1, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>r in t1 ? String(t1[r]) : "");
                }(e.properties, i);
            }
            createBucket(t1) {
                return new mg(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const t1 of bg().paint.overridableProperties){
                    if (!wg.hasPaintOverride(this.layout, t1)) continue;
                    const e = this.paint.get(t1), r = new vg(e), n = new Bs(r, e.property.specification, this.scope, this.options);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Fs("source", n) : new Ds("composite", n, e.value.zoomStops, e.value.interpolationType), this.paint._values[t1] = new Mo(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && wg.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e) {
                const r = t1.get("text-field"), n = bg().paint.properties[e];
                let i = !1;
                const s = (t1)=>{
                    for (const e of t1)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Cr) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e)=>{
                        i || (e instanceof Nr && Or(e.value) === Ar ? s(e.value.sections) : e instanceof qr ? s(e.sections) : e.eachChild(t1));
                    }, e = r.value;
                    e._styleExpression && t1(e._styleExpression.expression);
                }
                return i;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(t1, e, r) {
                return {
                    config: new zl(this, {
                        zoom: e,
                        lut: r
                    }),
                    overrideFog: !1
                };
            }
            hasElevation() {
                return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
        }
        let _g, Ag, Mg, Ig;
        var Sg = ta([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function zg(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function kg(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        class Pg {
            constructor(t1, e, r, n){
                this.context = t1, this.format = r, this.useMipmap = n && n.useMipmap, this.texture = t1.gl.createTexture(), this.update(e, {
                    premultiply: n && n.premultiply
                });
            }
            update(t1, e) {
                const r = t1 && t1 instanceof HTMLVideoElement && 0 === t1.width ? t1.videoWidth : t1.width, n = t1 && t1 instanceof HTMLVideoElement && 0 === t1.height ? t1.videoHeight : t1.height, { context: i } = this, { gl: s } = i, { x: o, y: a } = e && e.position ? e.position : {
                    x: 0,
                    y: 0
                }, l = o + r, u = a + n;
                !this.size || this.size[0] === l && this.size[1] === u || (s.bindTexture(s.TEXTURE_2D, null), s.deleteTexture(this.texture), this.texture = s.createTexture(), this.size = null), s.bindTexture(s.TEXTURE_2D, this.texture), i.pixelStoreUnpackFlipY.set(!1), i.pixelStoreUnpack.set(1), i.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA8 && (!e || !1 !== e.premultiply));
                const c = t1 instanceof HTMLImageElement || t1 instanceof HTMLCanvasElement || t1 instanceof HTMLVideoElement || t1 instanceof ImageData || ImageBitmap && t1 instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const t1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    s.texStorage2D(s.TEXTURE_2D, t1, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                if (this.size) {
                    if (c) s.texSubImage2D(s.TEXTURE_2D, 0, o, a, zg(this.format), kg(this.format), t1);
                    else {
                        const e = t1.data;
                        e && s.texSubImage2D(s.TEXTURE_2D, 0, o, a, r, n, zg(this.format), kg(this.format), e);
                    }
                }
                this.useMipmap && s.generateMipmap(s.TEXTURE_2D);
            }
            bind(t1, e, r = !1) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), t1 !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? t1 === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), e !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            bindExtraParam(t1, e, r, n, i) {
                const { context: s } = this, { gl: o } = s;
                o.bindTexture(o.TEXTURE_2D, this.texture), e !== this.magFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, e), this.magFilter = e), t1 !== this.minFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this.useMipmap ? t1 === o.NEAREST ? o.NEAREST_MIPMAP_NEAREST : o.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), r !== this.wrapS && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, n), this.wrapT = n), i !== this.compareMode && (i ? (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_MODE, o.COMPARE_REF_TO_TEXTURE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_FUNC, i)) : o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_MODE, o.NONE), this.compareMode = i);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Eg {
            constructor(t1, e){
                this.context = t1, this.texture = e;
            }
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
        }
        function Tg(t1, e, r, n, i, a, l, u) {
            const c = [
                t1,
                e,
                1,
                r,
                n,
                1,
                i,
                a,
                1
            ], h = [
                l,
                u,
                1
            ], p = s([], c), [f, d, m] = O(h, h, p);
            return o(c, c, [
                f,
                0,
                0,
                0,
                d,
                0,
                0,
                0,
                m
            ]);
        }
        function Bg(t1, e, r, n, i, a, l, u) {
            const c = function(t1, e, r, n, i, a, l, u) {
                const c = Tg(0, 0, 1, 0, 1, 1, 0, 1), h = Tg(t1, e, r, n, i, a, l, u);
                return o(h, h, s([], c));
            }(t1, e, r, n, i, a, l, u);
            return [
                c[2] / c[8] / Cn,
                c[5] / c[8] / Cn
            ];
        }
        function Vg(t1) {
            return [
                t1[0],
                Math.min(Math.max(t1[1], -85.051129), nu)
            ];
        }
        class Cg extends tr {
            constructor(t1, e, r, n){
                super(), this.id = t1, this.dispatcher = r, this.coordinates = e.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(n), this.options = e, this._dirty = !1;
            }
            load(t1, e) {
                if (this._loaded = e || !1, this.fire(new Ye("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return t1 && (this.coordinates = t1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = Ne(this.map._requestManager.transformRequest(this.url, Be.Image), (e, r)=>{
                    this._imageRequest = null, this._loaded = !0, e ? this.fire(new Ke(e)) : r && (this.image = r instanceof HTMLImageElement ? fe.getImageData(r) : r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t1) {
                return t1.url ? (this._imageRequest && t1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t1.url, this.load(t1.coordinates, this._loaded), this) : this;
            }
            setTexture(t1) {
                if (!(t1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new Eg(this.map.painter.context, t1.handle), this.width = t1.dimensions[0], this.height = t1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new Ye("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove(t1) {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof Eg || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t1) {
                if (this.coordinates = t1, this._boundsArray = void 0, this._unsupportedCoords = !1, !t1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let e = t1[0][1], r = t1[0][1];
                for (const n of t1)n[1] > r && (r = n[1]), n[1] < e && (e = n[1]);
                const n = (r + e) / 2;
                if (n > nu ? this.onNorthPole = !0 : n < -85.051129 && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const e = t1.map(lu.fromLngLat);
                    this.tileID = function(t1) {
                        let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                        for (const s of t1)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                        const s = Math.max(n - e, i - r), o = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)), a = Math.pow(2, o);
                        let l = Math.floor((e + n) / 2 * a);
                        return l > 1 && (l -= 1), new bc(o, l, Math.floor((r + i) / 2 * a));
                    }(e), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new Ye("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(t1) {
                for(const t1 in this.tiles){
                    const e = this.tiles[t1];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const e = Dy(new bc(0, 0, 0), this.map.transform.projection), r = [
                    e.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    e.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    e.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    e.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(t1) {
                    const e = t1[1].x - t1[0].x, r = t1[1].y - t1[0].y, n = t1[2].x - t1[1].x, i = t1[2].y - t1[1].y, s = t1[3].x - t1[2].x, o = t1[3].y - t1[2].y, a = t1[0].x - t1[3].x, l = t1[0].y - t1[3].y, u = e * i - n * r, c = n * o - s * i, h = s * l - a * o, p = a * r - e * l;
                    return u > 0 && c > 0 && h > 0 && p > 0 || u < 0 && c < 0 && h < 0 && p < 0;
                }(r)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const n = Dy(this.tileID, this.map.transform.projection), [i, a, l, u] = this.coordinates.map((t1)=>{
                    const e = n.projection.project(t1[0], t1[1]);
                    return Ly(n, e)._round();
                });
                this.perspectiveTransform = Bg(i.x, i.y, a.x, a.y, l.x, l.y, u.x, u.y);
                const c = this._boundsArray = new ia;
                c.emplaceBack(i.x, i.y, 0, 0), c.emplaceBack(a.x, a.y, Cn, 0), c.emplaceBack(u.x, u.y, 0, Cn), c.emplaceBack(l.x, l.y, Cn, Cn), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t1.createVertexBuffer(c, Sg.members), this.boundsSegments = tl.simpleSegment(0, 0, 4, 2);
                const h = [], p = [
                    Vg((f = this.coordinates)[0]),
                    Vg(f[1]),
                    Vg(f[2]),
                    Vg(f[3])
                ];
                var f;
                const [d, m, y, g] = function(t1) {
                    let e = t1[0][0], r = e, n = t1[0][1], i = n;
                    for(let s = 1; s < t1.length; s++)t1[s][0] < e ? e = t1[s][0] : t1[s][0] > r && (r = t1[s][0]), t1[s][1] < n ? n = t1[s][1] : t1[s][1] > i && (i = t1[s][1]);
                    return [
                        e,
                        n,
                        r - e,
                        i - n
                    ];
                }(p);
                {
                    const n = new ia, [i, a, l, u] = function(t1) {
                        let e = t1[0].x, r = e, n = t1[0].y, i = n;
                        for(let s = 1; s < t1.length; s++)t1[s].x < e ? e = t1[s].x : t1[s].x > r && (r = t1[s].x), t1[s].y < n ? n = t1[s].y : t1[s].y > i && (i = t1[s].y);
                        return [
                            e,
                            n,
                            r - e,
                            i - n
                        ];
                    }(r), c = (t1)=>[
                            (t1.x - i) / l,
                            (t1.y - a) / u
                        ], [p, f, x, v] = r.map(c), b = function(t1, e, r, n, i, a, l, u) {
                        const c = Tg(0, 0, 1, 0, 1, 1, 0, 1);
                        return o(c, c, s([], Tg(t1, e, r, n, i, a, l, u)));
                    }(p[0], p[1], f[0], f[1], x[0], x[1], v[0], v[1]);
                    this.elevatedGlobePerspectiveTransform = Bg(p[0], p[1], f[0], f[1], x[0], x[1], v[0], v[1]);
                    const w = (t1, e)=>{
                        h.push(t1.lng);
                        const r = Math.round((t1.lng - d) / y * Cn), i = Math.round((t1.lat - m) / g * Cn), s = c(e), o = O([], [
                            s[0],
                            s[1],
                            1
                        ], b), a = Math.round(o[0] / o[2] * Cn), l = Math.round(o[1] / o[2] * Cn);
                        n.emplaceBack(r, i, a, l);
                    }, _ = r[3].x - r[0].x, A = r[3].y - r[0].y, M = r[2].x - r[1].x, I = r[2].y - r[1].y;
                    for(let t1 = 0; t1 < 65; t1++){
                        const n = t1 / 64, i = [
                            r[0].x + n * _,
                            r[0].y + n * A
                        ], s = [
                            r[1].x + n * M,
                            r[1].y + n * I
                        ], o = s[0] - i[0], a = s[1] - i[1];
                        for(let t1 = 0; t1 < 65; t1++){
                            const r = t1 / 64, n = {
                                x: i[0] + o * r,
                                y: i[1] + a * r
                            };
                            w(e.projection.unproject(n.x, n.y), n);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = t1.createVertexBuffer(n, Sg.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let e = [], r = new Aa;
                    const n = (t1, n, i)=>{
                        r.emplaceBack(t1, n, i);
                        const s = h[t1], o = h[n], a = h[i], l = Math.min(Math.min(s, o), a), u = Math.max(Math.max(s, o), a) - l;
                        u > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = u), e.push(l + u / 2);
                    };
                    for(let t1 = 0; t1 < 64; t1++)for(let e = 0; e < 64; e++){
                        const r = 65 * t1 + e, i = r + 1, s = r + 65, o = s + 1;
                        n(r, s, i), n(i, s, o);
                    }
                    [e, r] = function(t1, e) {
                        const r = Array.from({
                            length: t1.length
                        }, (t1, e)=>e);
                        r.sort((e, r)=>t1[e] - t1[r]);
                        const n = [], i = new Aa;
                        for(let s = 0; s < r.length; s++){
                            const o = r[s];
                            n.push(t1[o]);
                            const a = 3 * o, l = a + 1;
                            i.emplaceBack(e.uint16[a], e.uint16[l], e.uint16[l + 1]);
                        }
                        return [
                            n,
                            i
                        ];
                    }(e, r), this.elevatedGlobeTrianglesCenterLongitudes = e, this.elevatedGlobeIndexBuffer = t1.createIndexBuffer(r);
                }
                this.elevatedGlobeSegments = tl.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    y / Cn,
                    0,
                    g / Cn,
                    0,
                    0,
                    m,
                    d,
                    0
                ]);
            }
            prepare() {
                const t1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !t1) return;
                const e = this.map.painter.context, r = e.gl;
                !this._dirty || this.texture instanceof Eg || (this.texture ? this.texture.update(this.image) : (this.texture = new Pg(e, this.image, r.RGBA8), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), t1 && this._prepareData(e);
            }
            loadTile(t1, e) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e(null)) : (t1.state = "errored", e(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(t1) {
                const e = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !e) return null;
                const r = this.elevatedGlobeTrianglesCenterLongitudes;
                let n = (i = t1 + 180) + 360 * Math.round((r[0] - i) / 360);
                var i;
                const s = new tl, o = (t1, r)=>{
                    s.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: t1,
                        vertexLength: e.segments[0].vertexLength,
                        primitiveLength: r,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, a = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(r[0] - n) <= a) {
                    const t1 = Qt(r, 0, r.length, n + a);
                    return t1 === r.length || o(t1, Jt(r, t1 + 1, r.length, n + 360 - a) - t1), s;
                }
                n < r[0] && (n += 360);
                const l = Jt(r, 0, r.length, n - a);
                if (l === r.length) return o(0, r.length), s;
                o(0, l - 0);
                const u = Qt(r, l + 1, r.length, n + a);
                return u !== r.length && o(u, r.length - u), s;
            }
        }
        const Fg = (Math.pow(256, 2) - 1) / 16907520;
        class Dg extends Yo {
            constructor(t1, e, r, n){
                super(t1, {
                    layout: Mg || (Mg = new Po({
                        visibility: new So(Eo.layout_raster.visibility)
                    })),
                    paint: Ig || (Ig = new Po({
                        "raster-opacity": new So(Eo.paint_raster["raster-opacity"]),
                        "raster-color": new ko(Eo.paint_raster["raster-color"]),
                        "raster-color-mix": new So(Eo.paint_raster["raster-color-mix"]),
                        "raster-color-range": new So(Eo.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new So(Eo.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new So(Eo.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new So(Eo.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new So(Eo.paint_raster["raster-saturation"]),
                        "raster-contrast": new So(Eo.paint_raster["raster-contrast"]),
                        "raster-resampling": new So(Eo.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new So(Eo.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new So(Eo.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new So(Eo.paint_raster["raster-array-band"]),
                        "raster-elevation": new So(Eo.paint_raster["raster-elevation"]),
                        "raster-color-use-theme": new zo({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, e, r, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(t1) {
                return !(t1 && t1._source instanceof Cg && (t1._source.onNorthPole || t1._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-color" !== t1 && "raster-color-range" !== t1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            updateColorRamp(t1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const e = this._transitionablePaint._values["raster-color"].value.expression, [r, n] = t1 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = xh({
                    expression: e,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: r,
                            end: n
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null, this._curRampRange = [
                    r,
                    n
                ]);
            }
        }
        let Lg, Rg, Og, Ug, Ng;
        class jg extends Yo {
            constructor(t1, e, r, n){
                super(t1, {
                    layout: Lg || (Lg = new Po({
                        visibility: new So(Eo["layout_raster-particle"].visibility)
                    })),
                    paint: Rg || (Rg = new Po({
                        "raster-particle-array-band": new So(Eo["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new So(Eo["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new ko(Eo["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new So(Eo["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new So(Eo["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new So(Eo["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new So(Eo["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new So(Eo["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new zo({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, e, r, n), this._updateColorRamp(), this.lastInvalidatedAt = fe.now();
            }
            onRemove(t1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(t1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-particle-color" !== t1 && "raster-particle-max-speed" !== t1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const t1 = this._transitionablePaint._values["raster-particle-color"].value.expression, e = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = xh({
                    expression: t1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: e
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = fe.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class $g extends Yo {
            constructor(t1, e){
                super(t1, {}, e, null), this.implementation = t1, t1.slot && (this.slot = t1.slot);
            }
            is3D(t1) {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(t1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }
            onRemove(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }
        }
        function Gg(t1, e, r) {
            const n = [
                0,
                0,
                1
            ], i = Y([]);
            return J(i, i, r ? -Mt(t1) + Math.PI : Mt(t1)), K(i, i, -Mt(e)), U(n, n, i), C(n, n);
        }
        function qg(t1, e) {
            const r = Xg(t1.projection, t1.zoom, t1.width, t1.height), n = function(t1, e, r, n, i) {
                const s = new Hl(r.lng - 180 * Zg, r.lat), o = new Hl(r.lng + 180 * Zg, r.lat), a = t1.project(s.lng, s.lat), u = t1.project(o.lng, o.lat), h = -Math.atan2(u.y - a.y, u.x - a.x), f = lu.fromLngLat(r);
                f.y = Et(f.y, -1 + Zg, 1 - Zg);
                const d = f.toLngLat(), y = t1.project(d.lng, d.lat), g = lu.fromLngLat(d);
                g.x += Zg;
                const x = g.toLngLat(), v = t1.project(x.lng, x.lat), b = Yg(v.x - y.x, v.y - y.y, h), w = lu.fromLngLat(d);
                w.y += Zg;
                const _ = w.toLngLat(), A = t1.project(_.lng, _.lat), M = Yg(A.x - y.x, A.y - y.y, h), I = Math.abs(b.x) / Math.abs(M.y), S = l([]);
                m(S, S, -h * (1 - (i ? 0 : n)));
                const z = l([]);
                return p(z, z, [
                    1,
                    1 - (1 - I) * n,
                    1
                ]), z[4] = -M.x / M.y * n, m(z, z, h), c(z, S, z), z;
            }(t1.projection, 0, t1.center, r, e), i = Hg(t1);
            return p(n, n, [
                i,
                i,
                1
            ]), n;
        }
        function Hg(t1) {
            const e = t1.projection, r = Xg(t1.projection, t1.zoom, t1.width, t1.height), n = Wg(e, t1.center), i = Wg(e, Hl.convert(e.center));
            return Math.pow(2, n * r + (1 - r) * i);
        }
        function Xg(t1, e, r, n, i = 1 / 0) {
            const s = t1.range;
            if (!s) return 0;
            const o = Math.min(i, Math.max(r, n)), a = Math.log(o / 1024) / Math.LN2;
            return Tt(s[0] + a, s[1] + a, e);
        }
        const Zg = 1 / 4e4;
        function Wg(t1, e) {
            const r = Et(e.lat, -85.051129, nu), n = new Hl(e.lng - 180 * Zg, r), i = new Hl(e.lng + 180 * Zg, r), s = t1.project(n.lng, r), o = t1.project(i.lng, r), a = lu.fromLngLat(n), l = lu.fromLngLat(i), u = o.x - s.x, c = o.y - s.y, h = l.x - a.x, p = l.y - a.y, f = Math.sqrt((h * h + p * p) / (u * u + c * c));
            return Math.log(f) / Math.LN2;
        }
        function Yg(t1, e, r) {
            const n = Math.cos(r), i = Math.sin(r);
            return {
                x: t1 * n - e * i,
                y: t1 * i + e * n
            };
        }
        function Kg(t1, e, r) {
            l(t1), m(t1, t1, Mt(e[2])), f(t1, t1, Mt(e[0])), d(t1, t1, Mt(e[1])), p(t1, t1, r), c(t1, t1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Jg(t1, e, r, n, i, s, o, a) {
            const l = [
                r[0] - e[0],
                r[1] - e[1],
                0
            ], u = [
                n[0] - e[0],
                n[1] - e[1],
                0
            ];
            if (_(l) < 1e-12 || _(u) < 1e-12) return Y(t1);
            const c = D([], l, u);
            C(c, c), I(u, n, e), l[2] = (s - i) * a, u[2] = (o - i) * a;
            const h = l;
            return D(h, l, u), C(h, h), st(t1, c, h);
        }
        function Qg(t1, e, r = !1) {
            const n = Zc(e.zoom), i = function(t1, e, r) {
                const n = e.worldSize, i = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], s = eu(i[1] / n), o = tu(i[0] / n), a = l([]), u = Ql(1, s) * n, f = Ql(1, 0) * n * su(s, e.zoom), d = 1 / qc(n);
                let m = f * d;
                if (r) {
                    const t1 = Xg(e.projection, e.zoom, e.width, e.height, 1024);
                    m = d * e.projection.pixelSpaceConversion(e.center.lat, n, t1);
                }
                const y = $l(s, o);
                M(y, y, P([], C([], y), u * m * i[2]));
                const g = function(t1) {
                    const e = [
                        t1[0],
                        t1[1],
                        t1[2]
                    ];
                    let r = [
                        0,
                        1,
                        0
                    ];
                    const n = D([], r, e);
                    return D(r, e, n), 0 === B(r) && (r = [
                        0,
                        1,
                        0
                    ], D(n, e, r)), C(n, n), C(r, r), C(e, e), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        r[0],
                        r[1],
                        r[2],
                        0,
                        e[0],
                        e[1],
                        e[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        1
                    ];
                }(y);
                p(a, a, [
                    m,
                    m,
                    m * u
                ]), h(a, a, [
                    -i[0],
                    -i[1],
                    -i[2]
                ]);
                const x = c([], e.globeMatrix, g);
                return c(x, x, a), c(x, x, t1), x;
            }(t1, e, r);
            if (n > 0) {
                const r = function(t1, e) {
                    const r = e.worldSize, n = Ql(1, 0) * r * su(e.center.lat, e.zoom) / qc(r), i = Ql(1, e.center.lat) * r, s = l([]);
                    return d(s, s, Mt(e.center.lng)), f(s, s, Mt(e.center.lat)), h(s, s, [
                        0,
                        0,
                        Cl
                    ]), p(s, s, [
                        n,
                        n,
                        n * i
                    ]), h(s, s, [
                        e.point.x - .5 * r,
                        e.point.y - .5 * r,
                        0
                    ]), c(s, s, t1), c(s, e.globeMatrix, s);
                }(t1, e);
                return function(t1, e, r) {
                    const n = (t1, e, r)=>{
                        const n = _(t1), i = _(e), s = Fc(t1, e, r);
                        return P(s, s, 1 / _(s) * ur(n, i, r));
                    }, i = n([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], [
                        e[0],
                        e[1],
                        e[2]
                    ], r), s = n([
                        t1[4],
                        t1[5],
                        t1[6]
                    ], [
                        e[4],
                        e[5],
                        e[6]
                    ], r), o = n([
                        t1[8],
                        t1[9],
                        t1[10]
                    ], [
                        e[8],
                        e[9],
                        e[10]
                    ], r), a = Fc([
                        t1[12],
                        t1[13],
                        t1[14]
                    ], [
                        e[12],
                        e[13],
                        e[14]
                    ], r);
                    return [
                        i[0],
                        i[1],
                        i[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        1
                    ];
                }(i, r, n);
            }
            return i;
        }
        function tx(t1, e, r, n) {
            const i = qu.projectAabbCorners(n, r);
            let s = Number.MAX_VALUE, o = -1;
            for(let t1 = 0; t1 < i.length; ++t1){
                const r = i[t1];
                r[0] = (.5 * r[0] + .5) * e.width, r[1] = (.5 - .5 * r[1]) * e.height, r[2] < s && (o = t1, s = r[2]);
            }
            const a = (t1)=>new bt(i[t1][0], i[t1][1]);
            let l;
            switch(o){
                case 0:
                case 6:
                    l = [
                        a(1),
                        a(5),
                        a(4),
                        a(7),
                        a(3),
                        a(2),
                        a(1)
                    ];
                    break;
                case 1:
                case 7:
                    l = [
                        a(0),
                        a(4),
                        a(5),
                        a(6),
                        a(2),
                        a(3),
                        a(0)
                    ];
                    break;
                case 3:
                case 5:
                    l = [
                        a(1),
                        a(0),
                        a(4),
                        a(7),
                        a(6),
                        a(2),
                        a(1)
                    ];
                    break;
                default:
                    l = [
                        a(1),
                        a(5),
                        a(6),
                        a(7),
                        a(3),
                        a(0),
                        a(1)
                    ];
            }
            if (Ku(t1, l)) return s;
        }
        const ex = ta([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), rx = ta([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), nx = ta([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), ix = ta([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), sx = ta([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), ox = ta([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), ax = ta([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]), lx = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4
        };
        class ux {
            constructor(t1, e, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function cx(t1, e) {
            const r = -1 === t1.indexOf("://");
            try {
                return new URL(t1, r && e ? "http://example.com" : void 0), !0;
            } catch (t1) {
                return !1;
            }
        }
        class hx {
            constructor(t1, e){
                this.feature = t1, this.instancedDataOffset = e, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class px {
            constructor(){
                this.instancedDataArray = new Ca, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
        }
        class fx {
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.projection = t1.projection, this.index = t1.index, this.worldview = t1.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = t1.styleDefinedModelURLs;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.tileToMeter = au(r);
                const i = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                for (const { feature: s, id: o, index: a, sourceLayerIndex: l } of t1){
                    const t1 = null != o ? o : s.properties && s.properties.hasOwnProperty("id") ? s.properties.id : void 0, u = gu(s, i);
                    if (!this.layers[0]._featureFilter.filter(new go(this.zoom, {
                        worldview: this.worldview
                    }), u, r)) continue;
                    const c = {
                        id: t1,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: i ? u.geometry : yu(s, r, n),
                        properties: s.properties,
                        type: s.type,
                        patterns: {}
                    }, h = this.addFeature(c, c.geometry, u);
                    h && e.featureIndex.insert(s, c.geometry, a, l, this.index, this.instancesPerModel[h].instancedDataArray.length, Cn / 32);
                }
                this.lookup = null;
            }
            update(t1, e, r, n) {
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for(const e in t1)r.idToFeaturesIndex.hasOwnProperty(e) && (this.evaluate(r.features[r.idToFeaturesIndex[e]], t1[e], r, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let t1 = !1;
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for (const e of r.features){
                        const n = this.layers[0], i = e.feature, s = this.canonical, o = n.paint.get("model-rotation").evaluate(i, {}, s), a = n.paint.get("model-scale").evaluate(i, {}, s), l = n.paint.get("model-translation").evaluate(i, {}, s);
                        N(e.rotation, o) && N(e.scale, a) && N(e.translation, l) || (this.evaluate(e, e.featureStates, r, !0), t1 = !0);
                    }
                }
                return t1;
            }
            updateReplacement(t1, e, r, n) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const i = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                if (Vp(this.activeReplacements, i)) return !1;
                this.activeReplacements = i;
                let s = !1;
                for(const e in this.instancesPerModel){
                    const i = this.instancesPerModel[e], o = i.instancedDataArray;
                    for (const e of i.features){
                        const i = e.instancedDataOffset, a = e.instancedDataCount;
                        for(let e = 0; e < a; e++){
                            const a = 16 * (e + i);
                            let l = o.float32[a + 0];
                            const u = l > Cn;
                            l = u ? l - Cn : l;
                            const c = Math.floor(l), h = o.float32[a + 1];
                            let p = !1;
                            for (const e of this.activeReplacements)if (!Pp(e, r, lx.Model, n) && !(e.min.x > c || c > e.max.x || e.min.y > h || h > e.max.y) && (p = Op(Rp(c, h, t1.canonical, e.footprintTileId.canonical), e.footprint), p)) break;
                            o.float32[a] = p ? l + Cn : l, s = s || p !== u;
                        }
                    }
                }
                return s;
            }
            isEmpty() {
                for(const t1 in this.instancesPerModel)if (0 !== this.instancesPerModel[t1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(t1) {
                if (!this.uploaded) for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    r.instancedDataArray.length < 0 || 0 === r.instancedDataArray.length || (r.instancedDataBuffer ? r.instancedDataBuffer.updateData(r.instancedDataArray) : r.instancedDataBuffer = t1.createVertexBuffer(r.instancedDataArray, ox.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy() {
                for(const t1 in this.instancesPerModel){
                    const e = this.instancesPerModel[t1];
                    0 !== e.instancedDataArray.length && e.instancedDataBuffer && e.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (t1 && this.modelUris && this.modelsRequested) for (const e of this.modelUris)t1.removeModel(e, "", !0);
            }
            addFeature(t1, e, r) {
                const n = this.layers[0], i = n.layout.get("model-id").evaluate(r, {}, this.canonical);
                if (!i) return Gt(`modelId is not evaluated for layer ${n.id} and it is not going to get rendered.`), i;
                (cx(i, !1) || void 0 !== this.styleDefinedModelURLs[i]) && (this.modelUris.includes(i) || this.modelUris.push(i)), this.instancesPerModel[i] || (this.instancesPerModel[i] = new px);
                const s = this.instancesPerModel[i], o = s.instancedDataArray, a = new hx(r, o.length);
                for (const t1 of e)for (const e of t1){
                    if (e.x < 0 || e.x >= Cn || e.y < 0 || e.y >= Cn) continue;
                    const t1 = (this.lookupDim - 1) / Cn, r = this.lookupDim * (e.y * t1 | 0) + e.x * t1 | 0;
                    if (this.lookup) {
                        if (0 !== this.lookup[r]) continue;
                        this.lookup[r] = 1;
                    }
                    this.instanceCount++;
                    const n = o.length;
                    o.resize(n + 1), s.instancesEvaluatedElevation.push(0), o.float32[16 * n] = e.x, o.float32[16 * n + 1] = e.y;
                }
                return a.instancedDataCount = s.instancedDataArray.length - a.instancedDataOffset, a.instancedDataCount > 0 && (t1.id && (s.idToFeaturesIndex[t1.id] = s.features.length), s.features.push(a), this.evaluate(a, {}, s, !1)), i;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(t1, e, r, n) {
                const i = this.layers[0], s = t1.feature, o = this.canonical, a = t1.rotation = i.paint.get("model-rotation").evaluate(s, e, o), l = t1.scale = i.paint.get("model-scale").evaluate(s, e, o), u = t1.translation = i.paint.get("model-translation").evaluate(s, e, o), c = i.paint.get("model-color").evaluate(s, e, o);
                c.a = i.paint.get("model-color-mix-intensity").evaluate(s, e, o);
                const h = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Kg(h, a, l);
                const p = Math.round(100 * c.a) + c.b / 1.05;
                for(let e = 0; e < t1.instancedDataCount; ++e){
                    const i = t1.instancedDataOffset + e, s = 16 * i, a = r.instancedDataArray.float32;
                    let l = 0;
                    n && (l = a[s + 6] - r.instancesEvaluatedElevation[i]);
                    const f = 0 | a[s + 1];
                    a[s] = (0 | a[s]) + c.r / 1.05, a[s + 1] = f + c.g / 1.05, a[s + 2] = p, a[s + 3] = 1 / (o.z > 10 ? this.tileToMeter : au(o, f)), a[s + 4] = u[0], a[s + 5] = u[1], a[s + 6] = u[2] + l, a[s + 7] = h[0], a[s + 8] = h[1], a[s + 9] = h[2], a[s + 10] = h[4], a[s + 11] = h[5], a[s + 12] = h[6], a[s + 13] = h[8], a[s + 14] = h[9], a[s + 15] = h[10], r.instancesEvaluatedElevation[i] = u[2];
                }
            }
        }
        let dx, mx;
        qs(fx, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), qs(px, "PerModelAttributes"), qs(hx, "ModelFeature");
        const yx = 64, gx = {
            CoordinateSpaceTile: 1,
            HasMapboxMeshFeatures: 4,
            HasMeshoptCompression: 8
        };
        function xx(t1, e, r, n, i, s, o, a, u, f = !1) {
            const d = r.zoom, m = r.project(n), y = su(n.lat, d), g = 1 / y;
            l(t1), h(t1, t1, [
                m.x + o[0] * g,
                m.y + o[1] * g,
                o[2]
            ]);
            let v = 1, b = 1;
            const w = r.worldSize;
            if (f) {
                if ("mercator" === r.projection.name) {
                    let t1 = 0;
                    r.elevation && (t1 = r.elevation.getAtPointOrZero(new lu(m.x / w, m.y / w), 0));
                    const e = Z([], [
                        m.x,
                        m.y,
                        t1,
                        1
                    ], r.projMatrix)[3] / r.cameraToCenterDistance;
                    v = e, b = e * su(r.center.lat, d);
                } else if ("globe" === r.projection.name) {
                    const e = Qg(t1, r), i = [
                        0,
                        0,
                        0,
                        1
                    ];
                    Z(i, i, c([], r.projMatrix, e));
                    const s = i[3] / r.cameraToCenterDistance, o = Zc(d), a = r.projection.pixelsPerMeter(n.lat, w) * su(n.lat, d), l = r.projection.pixelsPerMeter(r.center.lat, w) * su(r.center.lat, d);
                    v = s / ur(a, iu(r.center.lat), o), b = s * y / a, v *= l, b *= l;
                }
            } else v = g;
            p(t1, t1, [
                v,
                v,
                b
            ]);
            const _ = [
                ...t1
            ], A = e.orientation, M = [];
            if (Kg(M, [
                A[0] + i[0],
                A[1] + i[1],
                A[2] + i[2]
            ], s), c(t1, _, M), a && r.elevation) {
                let i = 0;
                const s = [];
                if (u && r.elevation) {
                    i = function(t1, e, r, n, i) {
                        const s = e.elevation;
                        if (!s) return 0;
                        const o = qu.projectAabbCorners(r, n), a = Ql(1, i.lat) * e.worldSize, l = function(t1, e) {
                            const r = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const i of n){
                                const n = t1[i.corners[0]], s = t1[i.corners[1]], o = t1[i.corners[2]], a = [
                                    s[0] - n[0],
                                    s[1] - n[1],
                                    e * (s[2] - n[2])
                                ], l = D(a, a, [
                                    o[0] - n[0],
                                    o[1] - n[1],
                                    e * (o[2] - n[2])
                                ]);
                                C(l, l), i.dotProductWithUp = F(l, r);
                            }
                            return n.sort((t1, e)=>t1.dotProductWithUp - e.dotProductWithUp), n[0].corners;
                        }(o, a), u = o[l[0]], c = o[l[1]], h = o[l[2]], p = o[l[3]], f = s.getAtPointOrZero(new lu(u[0] / e.worldSize, u[1] / e.worldSize), 0), d = s.getAtPointOrZero(new lu(c[0] / e.worldSize, c[1] / e.worldSize), 0), m = s.getAtPointOrZero(new lu(h[0] / e.worldSize, h[1] / e.worldSize), 0), y = s.getAtPointOrZero(new lu(p[0] / e.worldSize, p[1] / e.worldSize), 0), g = (f + y) / 2, x = (d + m) / 2;
                        return g > x ? d < m ? Jg(t1, c, p, u, d, y, f, a) : Jg(t1, h, u, p, m, f, y, a) : f < y ? Jg(t1, u, c, h, f, d, m, a) : Jg(t1, p, h, c, y, m, d, a), Math.max(g, x);
                    }(s, r, e.aabb, t1, n);
                    const o = c([], x([], s), M);
                    c(t1, _, o);
                } else i = r.elevation.getAtPointOrZero(new lu(m.x / w, m.y / w), 0);
                0 !== i && (t1[14] += i);
            }
        }
        function vx(t1, e, r = !1) {
            t1.uploaded || (t1.gfxTexture = new Pg(e, t1.image, r ? e.gl.R8 : e.gl.RGBA8, {
                useMipmap: t1.sampler.minFilter >= e.gl.NEAREST_MIPMAP_NEAREST
            }), t1.uploaded = !0, t1.image = null);
        }
        function bx(t1, e, r) {
            t1.indexBuffer = e.createIndexBuffer(t1.indexArray, !1, !0), t1.vertexBuffer = e.createVertexBuffer(t1.vertexArray, ex.members, !1, !0), t1.normalArray && (t1.normalBuffer = e.createVertexBuffer(t1.normalArray, sx.members, !1, !0)), t1.texcoordArray && (t1.texcoordBuffer = e.createVertexBuffer(t1.texcoordArray, ix.members, !1, !0)), t1.colorArray && (t1.colorBuffer = e.createVertexBuffer(t1.colorArray, (12 === t1.colorArray.bytesPerElement ? rx : nx).members, !1, !0)), t1.featureArray && (t1.pbrBuffer = e.createVertexBuffer(t1.featureArray, ax.members, !0)), t1.segments = tl.simpleSegment(0, 0, t1.vertexArray.length, t1.indexArray.length);
            const n = t1.material;
            n.pbrMetallicRoughness.baseColorTexture && vx(n.pbrMetallicRoughness.baseColorTexture, e), n.pbrMetallicRoughness.metallicRoughnessTexture && vx(n.pbrMetallicRoughness.metallicRoughnessTexture, e), n.normalTexture && vx(n.normalTexture, e), n.occlusionTexture && vx(n.occlusionTexture, e, r), n.emissionTexture && vx(n.emissionTexture, e);
        }
        function wx(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes)bx(n, e, r);
            if (t1.children) for (const n of t1.children)wx(n, e, r);
        }
        function _x(t1) {
            if (t1.meshes) for (const e of t1.meshes)e.indexArray.destroy(), e.vertexArray.destroy(), e.colorArray && e.colorArray.destroy(), e.normalArray && e.normalArray.destroy(), e.texcoordArray && e.texcoordArray.destroy(), e.featureArray && e.featureArray.destroy();
            if (t1.children) for (const e of t1.children)_x(e);
        }
        function Ax(t1) {
            if (t1.meshes) for (const r of t1.meshes)r.vertexBuffer && (r.vertexBuffer.destroy(), r.indexBuffer.destroy(), r.normalBuffer && r.normalBuffer.destroy(), r.texcoordBuffer && r.texcoordBuffer.destroy(), r.colorBuffer && r.colorBuffer.destroy(), r.pbrBuffer && r.pbrBuffer.destroy(), r.segments.destroy(), r.material && ((e = r.material).pbrMetallicRoughness.baseColorTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e.pbrMetallicRoughness.metallicRoughnessTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e.normalTexture && e.normalTexture.gfxTexture && e.normalTexture.gfxTexture.destroy(), e.emissionTexture && e.emissionTexture.gfxTexture && e.emissionTexture.gfxTexture.destroy(), e.occlusionTexture && e.occlusionTexture.gfxTexture && e.occlusionTexture.gfxTexture.destroy()));
            var e;
            if (t1.children) for (const e of t1.children)Ax(e);
        }
        class Mx {
            constructor(t1, e, r){
                this._demTile = t1, this._dem = this._demTile.dem, this._scale = e, this._offset = r;
            }
            static create(t1, e, r) {
                const n = r || t1.findDEMTileFor(e);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, o = 1 << e.canonical.z - s.canonical.z;
                return new Mx(n, i.dim / Cn / o, [
                    (e.canonical.x / o - s.canonical.x) * i.dim,
                    (e.canonical.y / o - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(t1, e) {
                const r = e * this._scale + this._offset[1], n = Math.floor(t1 * this._scale + this._offset[0]), i = Math.floor(r);
                return new bt(n, i);
            }
            getElevationAt(t1, e, r, n) {
                const i = t1 * this._scale + this._offset[0], s = e * this._scale + this._offset[1], o = Math.floor(i), a = Math.floor(s), l = this._dem;
                return n = !!n, r ? ur(ur(l.get(o, a, n), l.get(o, a + 1, n), s - a), ur(l.get(o + 1, a, n), l.get(o + 1, a + 1, n), s - a), i - o) : l.get(o, a, n);
            }
            getElevationAtPixel(t1, e, r) {
                return this._dem.get(t1, e, !!r);
            }
            getMeterToDEM(t1) {
                return (1 << this._demTile.tileID.canonical.z) * Ql(1, t1) * this._dem.stride;
            }
        }
        const Ix = new Float32Array(262144), Sx = new Uint8Array(262144);
        function zx(t1) {
            let e = 0;
            if (t1.meshes) for (const r of t1.meshes)e = Math.max(e, r.aabb.max[2]);
            if (t1.children) for (const r of t1.children)e = Math.max(e, zx(r));
            return e;
        }
        function kx(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const i = qu.applyTransform(n.aabb, t1.matrix);
                r.insert(e, i.min[0], i.min[1], i.max[0], i.max[1]);
            }
            if (t1.children) for (const n of t1.children)kx(n, e, r);
        }
        const Px = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class Ex {
            constructor(t1){
                this.node = t1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedTranslation = [
                    0,
                    0,
                    0
                ], this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = {
                    type: "Point",
                    id: t1.id,
                    geometry: [],
                    properties: {
                        height: zx(t1)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new qu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let t1 = 0;
                    const e = new qu([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const r of this.node.meshes)this.node.lightMeshIndex !== t1 && (r.transformedAabb = qu.applyTransformFast(r.aabb, this.node.matrix), e.encapsulate(r.transformedAabb)), t1++;
                    this.aabb = e;
                }
                return this.aabb;
            }
        }
        class Tx {
            constructor(t1, e, r, n, i, s, o, a){
                this.id = r, this.layers = t1, this.layerIds = this.layers.map((t1)=>t1.fqid), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.modelTraits |= gx.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= gx.HasMapboxMeshFeatures), i && (this.modelTraits |= gx.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = s, this.worldview = a, this.dirty = !0, this.needsUpload = !1, this.filter = null, this.nodesInfo = [];
                for (const t1 of e)this.nodesInfo.push(new Ex(t1)), kx(t1, o.featureIndexArray.length, o.grid), o.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, o.bucketLayerIDs.length - 1, 0);
                this.states = {};
            }
            updateFootprints(t1, e) {
                for (const r of this.getNodesInfo()){
                    const n = r.node;
                    n.footprint && e.push({
                        footprint: n.footprint,
                        id: t1
                    });
                }
            }
            update(t1) {
                const e = 0 !== Object.keys(t1).length;
                if (e && !this.stateDependentLayers.length) return;
                const r = e ? this.stateDependentLayers : this.layers;
                if (!wt(t1, this.states)) for (const e of r)this.evaluate(e, t1);
                this.states = structuredClone(t1);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(t1) {
                if (!this.needsUpload) return;
                const e = this.getNodesInfo();
                for (const r of e){
                    const e = r.node;
                    this.uploaded ? this.updatePbrBuffer(e) : wx(e, t1, !0);
                }
                for (const t1 of e)_x(t1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(t1) {
                let e = !1;
                if (!t1.meshes) return e;
                for (const r of t1.meshes)r.pbrBuffer && (r.pbrBuffer.updateData(r.featureArray), e = !0);
                return e;
            }
            needsReEvaluation(t1, e, r) {
                const n = t1.transform.projectionOptions, i = t1.style.getBrightness(), s = this.brightness !== i;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || Bx(r.paint.get("model-color").value, s) || Bx(r.paint.get("model-color-mix-intensity").value, s) || Bx(r.paint.get("model-roughness").value, s) || Bx(r.paint.get("model-emissive-strength").value, s) || Bx(r.paint.get("model-height-based-emissive-strength-multiplier").value, s)) {
                    this.projection = n, this.brightness = i;
                    const t1 = this.getNodesInfo();
                    for (const e of t1)e.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateTransform(t1, e) {
                if (t1.transform.zoom === this.zoom) return;
                this.zoom = t1.transform.zoom;
                const r = this.getNodesInfo(), n = this.id.canonical;
                for (const t1 of r){
                    const r = t1.feature;
                    t1.evaluatedTranslation = e.paint.get("model-translation").evaluate(r, {}, n), t1.evaluatedScale = e.paint.get("model-scale").evaluate(r, {}, n);
                }
            }
            evaluate(t1, e) {
                const r = this.getNodesInfo();
                for (const n of r){
                    if (!n.node.meshes) continue;
                    const r = n.feature, i = e && e[r.id];
                    if (wt(i, n.state)) continue;
                    n.state = structuredClone(i);
                    const s = n.node.meshes && n.node.meshes[0].featureData, o = n.evaluatedColor[2], a = n.evaluatedRMEA[2], l = this.id.canonical;
                    if (n.hasTranslucentParts = !1, s) {
                        for(let e = 0; e < Px.length; e++){
                            const s = Px[e];
                            s.length && (r.properties.part = s);
                            const o = t1.paint.get("model-color").evaluate(r, i, l).toPremultipliedRenderColor(null), a = t1.paint.get("model-color-mix-intensity").evaluate(r, i, l);
                            n.evaluatedColor[e] = [
                                o.r,
                                o.g,
                                o.b,
                                a
                            ], n.evaluatedRMEA[e][0] = t1.paint.get("model-roughness").evaluate(r, i, l), n.evaluatedRMEA[e][2] = t1.paint.get("model-emissive-strength").evaluate(r, i, l), n.evaluatedRMEA[e][3] = o.a, n.emissionHeightBasedParams[e] = t1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r, i, l), !n.hasTranslucentParts && o.a < 1 && (n.hasTranslucentParts = !0);
                        }
                        delete r.properties.part, Cx(n, o !== n.evaluatedColor[2] || a !== n.evaluatedRMEA[2], this.modelTraits);
                    } else n.evaluatedRMEA[0][2] = t1.paint.get("model-emissive-strength").evaluate(r, i, l);
                    n.evaluatedTranslation = t1.paint.get("model-translation").evaluate(r, i, l), n.evaluatedScale = t1.paint.get("model-scale").evaluate(r, i, l), this.updatePbrBuffer(n.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(t1, e, r, n) {
                const i = t1.findDEMTileFor(r);
                if (i && (i.tileID.canonical !== this.terrainTile || e !== this.terrainExaggeration)) {
                    if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = i.tileID.overscaledZ;
                        const e = Mx.create(t1, r, i);
                        if (!e) return;
                        this.modelTraits & gx.HasMapboxMeshFeatures && this.updateDEM(t1, e, r, n);
                        for (const t1 of this.getNodesInfo()){
                            const r = t1.node;
                            if (!r.footprint || !r.footprint.vertices || !r.footprint.vertices.length) continue;
                            const n = r.footprint.vertices;
                            let i = e.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let t1 = 1; t1 < n.length; t1++)i = Math.min(i, e.getElevationAt(n[t1].x, n[t1].y, !0, !0));
                            r.elevation = i;
                        }
                    }
                    this.terrainTile = i.tileID.canonical, this.terrainExaggeration = e;
                }
            }
            updateDEM(t1, e, r, n) {
                let i = e._dem._modifiedForSources[n];
                if (void 0 === i && (e._dem._modifiedForSources[n] = [], i = e._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
                const s = e._dem.dim;
                i.push(r.canonical);
                let o = !1;
                for (const t1 of this.getNodesInfo()){
                    const r = t1.node;
                    if (!r.footprint || !r.footprint.grid) continue;
                    const n = r.footprint.grid, i = e.tileCoordToPixel(n.min.x, n.min.y), a = e.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(s - a.y, i.x), Math.min(i.y, s - a.x));
                    if (l < 0) continue;
                    const u = Et(l, 2, 5);
                    let c = Math.max(0, i.x - u), h = Math.max(0, i.y - u), p = Math.min(a.x + u, s - 1), f = Math.min(a.y + u, s - 1);
                    for(let t1 = h; t1 <= f; ++t1)for(let e = c; e <= p; ++e)Sx[t1 * s + e] = 255;
                    let d = 0, m = 0;
                    for(let t1 = 0; t1 < n.cellsY; ++t1)for(let r = 0; r < n.cellsX; ++r){
                        if (!n.cells[t1 * n.cellsX + r]) continue;
                        const i = e.tileCoordToPixel(n.min.x + r / n.xScale, n.min.y + t1 / n.yScale), o = e.tileCoordToPixel(n.min.x + (r + 1) / n.xScale, n.min.y + (t1 + 1) / n.yScale);
                        for(let t1 = i.y; t1 <= Math.min(o.y + 1, s - 1); ++t1)for(let r = i.x; r <= Math.min(o.x + 1, s - 1); ++r)255 === Sx[t1 * s + r] && (Sx[t1 * s + r] = 0, d += e.getElevationAtPixel(r, t1), m++);
                    }
                    const y = d / m;
                    c = Math.max(1, i.x - u), h = Math.max(1, i.y - u), p = Math.min(a.x + u, s - 2), f = Math.min(a.y + u, s - 2), o = !0;
                    for(let t1 = h; t1 <= f; ++t1)for(let r = c; r <= p; ++r)0 === Sx[t1 * s + r] && (Ix[t1 * s + r] = e._dem.set(r, t1, y));
                    for(let t1 = 1; t1 < u; ++t1){
                        c = Math.max(1, i.x - t1), h = Math.max(1, i.y - t1), p = Math.min(a.x + t1, s - 2), f = Math.min(a.y + t1, s - 2);
                        for(let r = h; r <= f; ++r)for(let n = c; n <= p; ++n){
                            const i = r * s + n;
                            if (255 === Sx[i]) {
                                let o = 0, a = 0, l = -1, c = -1;
                                for(let e = -1; e <= 1; ++e)for(let i = -1; i <= 1; ++i){
                                    const u = (r + e) * s + n + i;
                                    if (Sx[u] >= t1) continue;
                                    const h = Ix[u], p = Math.abs(h);
                                    p > a && (o = h, a = p, l = i, c = e);
                                }
                                if (a > .1) {
                                    const s = 1 - (t1 + .5 * Math.abs(l * c)) / u;
                                    let a = e._dem.get(n, r) + o * s;
                                    const h = e._dem.get(n + l, r + c), p = e._dem.get(n - l, r - c, !0);
                                    (a - h) * (a - p) > 0 && (a = (h + p) / 2), Ix[i] = e._dem.set(n, r, a), Sx[i] = t1;
                                }
                            }
                        }
                    }
                }
                o && (e._demTile.needsDEMTextureUpload = !0, e._dem._timestamp = fe.now());
            }
            setFilter(t1) {
                this.filter = t1 ? Co(t1) : null;
            }
            getNodesInfo() {
                return this.filter ? this.nodesInfo.filter((t1)=>this.filter.filter(new go(this.id.overscaledZ, {
                        worldview: this.worldview
                    }), t1.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
                const t1 = this.getNodesInfo();
                for (const e of t1)_x(e.node), Ax(e.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped());
                for (const t1 of this.getNodesInfo()){
                    const e = t1.node.footprint;
                    t1.hiddenByReplacement = !!e && !r.find((t1)=>t1.footprint === e);
                }
            }
            getHeightAtTileCoord(t1, e) {
                const r = [], n = [
                    0,
                    0,
                    0
                ], i = l([]);
                for (const s of this.getNodesInfo()){
                    const o = s.node.meshes[0], a = o.transformedAabb;
                    if (t1 < a.min[0] || e < a.min[1] || t1 > a.max[0] || e > a.max[1]) continue;
                    if (!0 === s.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: s.feature.properties.height,
                        hidden: !1,
                        verticalScale: s.evaluatedScale[2]
                    };
                    u(i, s.node.matrix), n[0] = t1, n[1] = e, R(n, n, i);
                    const l = (n[0] - o.aabb.min[0]) / (o.aabb.max[0] - o.aabb.min[0]) * yx | 0, c = Math.min(63, (n[1] - o.aabb.min[1]) / (o.aabb.max[1] - o.aabb.min[1]) * yx | 0) * yx + Math.min(63, l), h = o.heightmap[c];
                    if (!(h < 0 && s.node.footprint)) {
                        if (s.hiddenByReplacement) return;
                        return {
                            height: h,
                            maxHeight: s.feature.properties.height,
                            hidden: !1,
                            verticalScale: s.evaluatedScale[2]
                        };
                    }
                    if (s.node.footprint.grid.query(new bt(t1, e), new bt(t1, e), r), r.length > 0) return {
                        height: void 0,
                        maxHeight: s.feature.properties.height,
                        hidden: s.hiddenByReplacement,
                        verticalScale: s.evaluatedScale[2]
                    };
                }
            }
        }
        function Bx(t1, e) {
            return t1 instanceof Fs && !t1.isLightConstant && e;
        }
        function Vx(t1, e, r, n, i, s, o, a) {
            let l = (61440 & e | (61440 & e) >> 4) >> 8, u = (3840 & e | (3840 & e) >> 4) >> 4, c = 240 & e | (240 & e) >> 4;
            r[3] > 0 && (l = ur(l, 255 * r[0], r[3]), u = ur(u, 255 * r[1], r[3]), c = ur(c, 255 * r[2], r[3]));
            const h = l << 8 | u, p = c << 8 | Math.floor(255 * n[3]), f = function(t1) {
                const e = Et(t1, 0, 2);
                return Math.min(Math.round(.5 * e * 255), 255);
            }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1], d = Et(i[0], 0, 1), m = Et(i[1], 0, 1), y = Et(i[2], 0, 1), g = Et(i[3], 0, 1);
            let x, v, b, w;
            if (d !== m && o !== s && m !== d) {
                const t1 = o - s;
                v = 1 / (t1 * (m - d)), b = -(s + t1 * d) / (t1 * (m - d));
                const e = Et(i[4], -1, 1);
                w = Math.pow(10, e), x = 255 * y << 8 | 255 * g;
            } else x = 65535, v = 0, b = 1, w = 1;
            if (t1.emplaceBack(h, p, f, x, v, b, w), a) {
                const t1 = a.length;
                a.clear();
                for(let e = 0; e < t1; e++)a.emplaceBack(h, p, f, x, v, b, w);
            }
        }
        function Cx(t1, e, r) {
            const n = t1.node;
            let i = 0;
            const s = r & gx.HasMeshoptCompression;
            for (const r of n.meshes){
                if (n.lights && n.lightMeshIndex === i) continue;
                if (!r.featureData) continue;
                r.featureArray = new Fa, r.featureArray.reserve(r.featureData.length);
                let o = e;
                for (const e of r.featureData){
                    const i = s ? 65535 & e : e >> 16 & 65535, a = s ? e >> 16 & 65535 : 65535 & e, l = (15 & a) < 8 ? 15 & a : 0, u = t1.evaluatedRMEA[l], c = t1.evaluatedColor[l], h = t1.emissionHeightBasedParams[l];
                    let p;
                    if (o && 2 === l && n.lights && (p = new Fa, p.resize(10 * n.lights.length)), Vx(r.featureArray, i, c, u, h, r.aabb.min[2], r.aabb.max[2], p), p && o) {
                        o = !1;
                        const t1 = n.meshes[n.lightMeshIndex];
                        t1.featureArray = p, t1.featureArray._trim();
                    }
                }
                r.featureArray._trim(), i++;
            }
        }
        function Fx(t1, e, r, n) {
            const i = 1 << t1.z;
            e.lat = eu((n / Cn + t1.y) / i), e.lng = tu((r / Cn + t1.x) / i);
        }
        function Dx(t1, e, r, n) {
            const i = t1.getNodesInfo()[e];
            if (!i || i.hiddenByReplacement || !i.node.meshes) return;
            let s = Number.MAX_VALUE;
            const o = i.node, a = r.tile, l = n.calculatePosMatrix(a.tileID.toUnwrapped(), n.worldSize), u = i.evaluatedScale;
            let f = 0;
            n.elevation && o.elevation && (f = o.elevation * n.elevation.exaggeration()), h(l, l, [
                (o.anchor ? o.anchor[0] : 0) * (u[0] - 1),
                (o.anchor ? o.anchor[1] : 0) * (u[1] - 1),
                f
            ]), p(l, l, u);
            const d = r.queryGeometry, m = d.isPointQuery() ? d.screenBounds : d.screenGeometry, y = function(t1) {
                const e = c([], l, t1.matrix);
                c(e, n.expandedFarZProjMatrix, e);
                for(let r = 0; r < t1.meshes.length; ++r){
                    const i = t1.meshes[r];
                    if (r === t1.lightMeshIndex) continue;
                    const o = tx(m, n, e, i.aabb);
                    null != o && (s = Math.min(o, s));
                }
                if (t1.children) for (const e of t1.children)y(e);
            };
            if (y(o), s === Number.MAX_VALUE) return;
            const g = new Hl(0, 0);
            return Fx(a.tileID.canonical, g, i.node.anchor[0], i.node.anchor[1]), {
                intersectionZ: s,
                position: g,
                feature: i.feature
            };
        }
        qs(Tx, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), qs(Ex, "Tiled3dModelFeature");
        const Lx = {
            circle: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: gc || (gc = new Po({
                            "circle-sort-key": new zo(Eo.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new So(Eo.layout_circle["circle-elevation-reference"]),
                            visibility: new So(Eo.layout_circle.visibility)
                        })),
                        paint: xc || (xc = new Po({
                            "circle-radius": new zo(Eo.paint_circle["circle-radius"]),
                            "circle-color": new zo(Eo.paint_circle["circle-color"]),
                            "circle-blur": new zo(Eo.paint_circle["circle-blur"]),
                            "circle-opacity": new zo(Eo.paint_circle["circle-opacity"]),
                            "circle-translate": new So(Eo.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new So(Eo.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new So(Eo.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new So(Eo.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new zo(Eo.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new zo(Eo.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new zo(Eo.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new So(Eo.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
                createBucket(t1) {
                    return new Yu(t1);
                }
                queryRadius(t1) {
                    const e = t1;
                    return fc("circle-radius", this, e) + fc("circle-stroke-width", this, e) + dc(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s, o, a) {
                    const l = yc(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r);
                    return rh(t1, n, s, o, a, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = eh(this);
                    return {
                        config: new zl(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                is3D(t1) {
                    return !t1 && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
            },
            heatmap: class extends Yo {
                createBucket(t1) {
                    return new ah(t1);
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: lh || (lh = new Po({
                            visibility: new So(Eo.layout_heatmap.visibility)
                        })),
                        paint: uh || (uh = new Po({
                            "heatmap-radius": new zo(Eo.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new zo(Eo.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new So(Eo.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new ko(Eo.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new So(Eo.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = xh({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(t1) {
                    return fc("heatmap-radius", this, t1);
                }
                queryIntersectsFeature(t1, e, r, n, i, s, o, a) {
                    const l = this.paint.get("heatmap-radius").evaluate(e, r);
                    return rh(t1, n, s, o, a, !0, !0, new bt(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return "heatmap" === t1 ? {
                        config: new zl(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: ch || (ch = new Po({
                            visibility: new So(Eo.layout_hillshade.visibility)
                        })),
                        paint: hh || (hh = new Po({
                            "hillshade-illumination-direction": new So(Eo.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new So(Eo.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new So(Eo.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new So(Eo.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new So(Eo.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new So(Eo.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new So(Eo.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: dp || (dp = new Po({
                            "fill-sort-key": new zo(Eo.layout_fill["fill-sort-key"]),
                            visibility: new So(Eo.layout_fill.visibility),
                            "fill-elevation-reference": new So(Eo.layout_fill["fill-elevation-reference"]),
                            "fill-construct-bridge-guard-rail": new zo(Eo.layout_fill["fill-construct-bridge-guard-rail"])
                        })),
                        paint: mp || (mp = new Po({
                            "fill-antialias": new So(Eo.paint_fill["fill-antialias"]),
                            "fill-opacity": new zo(Eo.paint_fill["fill-opacity"]),
                            "fill-color": new zo(Eo.paint_fill["fill-color"]),
                            "fill-outline-color": new zo(Eo.paint_fill["fill-outline-color"]),
                            "fill-translate": new So(Eo.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new So(Eo.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new zo(Eo.paint_fill["fill-pattern"]),
                            "fill-pattern-cross-fade": new So(Eo.paint_fill["fill-pattern-cross-fade"]),
                            "fill-emissive-strength": new So(Eo.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new zo(Eo.paint_fill["fill-z-offset"]),
                            "fill-bridge-guard-rail-color": new zo(Eo.paint_fill["fill-bridge-guard-rail-color"]),
                            "fill-tunnel-structure-color": new zo(Eo.paint_fill["fill-tunnel-structure-color"]),
                            "fill-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-bridge-guard-rail-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-tunnel-structure-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
                getProgramIds() {
                    const t1 = this.paint.get("fill-pattern"), e = t1 && t1.constantOr(1), r = [
                        e ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(e && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        config: new zl(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new fp(t1);
                }
                queryRadius() {
                    return dc(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    return !t1.queryGeometry.isAboveHorizon && Qu(mc(t1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return 0 === this.paint.get("fill-z-offset").constantOr(1);
                }
                is3D(t1) {
                    if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return !0;
                    const e = this.layout && "none" !== this.layout.get("fill-elevation-reference");
                    return null != t1 ? e && !t1 : e;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
                hasShadowPass() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
            },
            "fill-extrusion": class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: xf || (xf = new Po({
                            visibility: new So(Eo["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new So(Eo["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
                        })),
                        paint: vf || (vf = new Po({
                            "fill-extrusion-opacity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new So(Eo["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new So(Eo["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-pattern-cross-fade": new So(Eo["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]),
                            "fill-extrusion-height": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new So(Eo["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new So(Eo["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new So(Eo["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new So(Eo["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new So(Eo["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new So(Eo["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-emissive-strength": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new So(Eo["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(t1) {
                    return new af(t1);
                }
                queryRadius() {
                    return dc(this.paint.get("fill-extrusion-translate"));
                }
                is3D(t1) {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(t1, e, r, n, i, s, o, a, l) {
                    const u = yc(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = [
                        0,
                        0
                    ], f = a && s.elevation, d = s.elevation ? s.elevation.exaggeration() : 1, m = t1.tile.getBucket(this);
                    if (f && m instanceof af) {
                        const t1 = m.centroidVertexArray, e = l + 1;
                        e < t1.length && (p[0] = t1.geta_centroid_pos0(e), p[1] = t1.geta_centroid_pos1(e));
                    }
                    if (0 === p[0] && 1 === p[1]) return !1;
                    "globe" === s.projection.name && (n = yf([
                        n
                    ], [
                        new bt(0, 0),
                        new bt(Cn, Cn)
                    ], t1.tileID.canonical).map((t1)=>t1.polygon).flat());
                    const y = f ? a : null, [g, x] = function(t1, e, r, n, i, s, o, a, l, u, c) {
                        return "globe" === t1.projection.name ? function(t1, e, r, n, i, s, o, a, l, u, c) {
                            const h = [], p = [], f = t1.projection.upVectorScale(c, t1.center.lat, t1.worldSize).metersToTile, d = [
                                0,
                                0,
                                0,
                                1
                            ], m = [
                                0,
                                0,
                                0,
                                1
                            ], y = (t1, e, r, n)=>{
                                t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = 1;
                            }, g = mf();
                            r > 0 && (r += g), n += g;
                            for (const g of e){
                                const e = [], x = [];
                                for (const h of g){
                                    const p = h.x + i.x, g = h.y + i.y, v = t1.projection.projectTilePoint(p, g, c), b = t1.projection.upVector(c, h.x, h.y);
                                    let w = r, _ = n;
                                    if (o) {
                                        const t1 = Pf(p, g, r, n, o, a, l, u);
                                        w += t1.base, _ += t1.top;
                                    }
                                    0 !== r ? y(d, v.x + b[0] * f * w, v.y + b[1] * f * w, v.z + b[2] * f * w) : y(d, v.x, v.y, v.z), y(m, v.x + b[0] * f * _, v.y + b[1] * f * _, v.z + b[2] * f * _), R(d, d, s), R(m, m, s), e.push(new bf(d[0], d[1], d[2])), x.push(new bf(m[0], m[1], m[2]));
                                }
                                h.push(e), p.push(x);
                            }
                            return [
                                h,
                                p
                            ];
                        }(t1, e, r, n, i, s, o, a, l, u, c) : o ? function(t1, e, r, n, i, s, o, a, l) {
                            const u = [], c = [], h = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const p of t1){
                                const t1 = [], f = [];
                                for (const u of p){
                                    const c = u.x + n.x, p = u.y + n.y, d = Pf(c, p, e, r, s, o, a, l);
                                    h[0] = c, h[1] = p, h[2] = d.base, h[3] = 1, Z(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const m = new bf(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    h[0] = c, h[1] = p, h[2] = d.top, h[3] = 1, Z(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const y = new bf(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    t1.push(m), f.push(y);
                                }
                                u.push(t1), c.push(f);
                            }
                            return [
                                u,
                                c
                            ];
                        }(e, r, n, i, s, o, a, l, u) : function(t1, e, r, n, i) {
                            const s = [], o = [], a = i[8] * e, l = i[9] * e, u = i[10] * e, c = i[11] * e, h = i[8] * r, p = i[9] * r, f = i[10] * r, d = i[11] * r;
                            for (const e of t1){
                                const t1 = [], r = [];
                                for (const s of e){
                                    const e = s.x + n.x, o = s.y + n.y, m = i[0] * e + i[4] * o + i[12], y = i[1] * e + i[5] * o + i[13], g = i[2] * e + i[6] * o + i[14], x = i[3] * e + i[7] * o + i[15], v = m + a, b = y + l, w = g + u, _ = Math.max(x + c, 1e-5), A = m + h, M = y + p, I = g + f, S = Math.max(x + d, 1e-5);
                                    t1.push(new bf(v / _, b / _, w / _)), r.push(new bf(A / S, M / S, I / S));
                                }
                                s.push(t1), o.push(r);
                            }
                            return [
                                s,
                                o
                            ];
                        }(e, r, n, i, s);
                    }(s, n, h, c, u, o, y, p, d, s.center.lat, t1.tileID.canonical), v = t1.queryGeometry;
                    return function(t1, e, r) {
                        let n = 1 / 0;
                        Qu(r, e) && (n = kf(r, e[0]));
                        for(let i = 0; i < e.length; i++){
                            const s = e[i], o = t1[i];
                            for(let t1 = 0; t1 < s.length - 1; t1++){
                                const e = s[t1], i = [
                                    e,
                                    s[t1 + 1],
                                    o[t1 + 1],
                                    o[t1],
                                    e
                                ];
                                Ku(r, i) && (n = Math.min(n, kf(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
            },
            building: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: dd || (dd = new Po({
                            visibility: new So(Eo.layout_building.visibility),
                            "building-roof-shape": new zo(Eo.layout_building["building-roof-shape"]),
                            "building-height": new zo(Eo.layout_building["building-height"]),
                            "building-base": new zo(Eo.layout_building["building-base"])
                        })),
                        paint: md || (md = new Po({
                            "building-opacity": new So(Eo.paint_building["building-opacity"]),
                            "building-ambient-occlusion-wall-intensity": new So(Eo.paint_building["building-ambient-occlusion-wall-intensity"]),
                            "building-ambient-occlusion-ground-intensity": new So(Eo.paint_building["building-ambient-occlusion-ground-intensity"]),
                            "building-ambient-occlusion-ground-radius": new So(Eo.paint_building["building-ambient-occlusion-ground-radius"]),
                            "building-ambient-occlusion-ground-attenuation": new So(Eo.paint_building["building-ambient-occlusion-ground-attenuation"]),
                            "building-vertical-scale": new So(Eo.paint_building["building-vertical-scale"]),
                            "building-cast-shadows": new So(Eo.paint_building["building-cast-shadows"]),
                            "building-color": new zo(Eo.paint_building["building-color"]),
                            "building-emissive-strength": new zo(Eo.paint_building["building-emissive-strength"]),
                            "building-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(t1) {
                    return new fd(t1);
                }
            },
            line: class extends Yo {
                constructor(t1, e, r, n){
                    const i = Rd();
                    super(t1, i, e, r, n), i.layout && (this.layout = new Io(i.layout)), this.gradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1;
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    if ("line-gradient" === t1) {
                        const t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = t1._styleExpression && t1._styleExpression.expression instanceof Ai, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e), this.paint._values["line-floorwidth"] = (()=>{
                        if (Ud) return Ud;
                        const t1 = Rd();
                        return Ud = new Od(t1.paint.properties["line-width"].specification), Ud.useIntegerZoom = !0, Ud;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new zd(t1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = Fd(this);
                    return {
                        config: new zl(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(t1) {
                    const e = t1, r = Nd(fc("line-width", this, e), fc("line-gap-width", this, e)), n = fc("line-offset", this, e);
                    return r / 2 + Math.abs(n) + dc(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    if (t1.queryGeometry.isAboveHorizon) return !1;
                    const o = mc(t1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), a = t1.pixelToTileUnitsFactor / 2 * Nd(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), l = this.paint.get("line-offset").evaluate(e, r);
                    return l && (n = function(t1, e) {
                        const r = [], n = new bt(0, 0);
                        for(let i = 0; i < t1.length; i++){
                            const s = t1[i], o = [];
                            for(let t1 = 0; t1 < s.length; t1++){
                                const r = s[t1], i = s[t1 + 1], a = 0 === t1 ? n : r.sub(s[t1 - 1])._unit()._perp(), l = t1 === s.length - 1 ? n : i.sub(r)._unit()._perp(), u = a._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), o.push(u._mult(e)._add(r));
                            }
                            r.push(o);
                        }
                        return r;
                    }(n, l * t1.pixelToTileUnitsFactor)), function(t1, e, r) {
                        for(let n = 0; n < e.length; n++){
                            const i = e[n];
                            if (t1.length >= 3) {
                                for(let e = 0; e < i.length; e++)if (lc(t1, i[e])) return !0;
                            }
                            if (tc(t1, i, r)) return !0;
                        }
                        return !1;
                    }(o, n, a);
                }
                isTileClipped() {
                    return this.hasNonElevatedBuckets;
                }
                isDraped(t1) {
                    return !this.hasElevatedBuckets;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("line-elevation-reference");
                }
            },
            symbol: wg,
            background: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: _g || (_g = new Po({
                            visibility: new So(Eo.layout_background.visibility)
                        })),
                        paint: Ag || (Ag = new Po({
                            "background-pitch-alignment": new So(Eo.paint_background["background-pitch-alignment"]),
                            "background-color": new So(Eo.paint_background["background-color"]),
                            "background-pattern": new So(Eo.paint_background["background-pattern"]),
                            "background-opacity": new So(Eo.paint_background["background-opacity"]),
                            "background-emissive-strength": new So(Eo.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D(t1) {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: Dg,
            "raster-particle": jg,
            sky: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Og || (Og = new Po({
                            visibility: new So(Eo.layout_sky.visibility)
                        })),
                        paint: Ug || (Ug = new Po({
                            "sky-type": new So(Eo.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new So(Eo.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new So(Eo.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new So(Eo.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new So(Eo.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new ko(Eo.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new So(Eo.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new So(Eo.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new So(Eo.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "sky-gradient" === t1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t1 && "sky-atmosphere-halo-color" !== t1 && "sky-atmosphere-color" !== t1 && "sky-atmosphere-sun-intensity" !== t1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = xh({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(t1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const e = t1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== e.azimuthal || this._lightPosition.polar !== e.polar;
                    }
                    return !1;
                }
                getCenter(t1, e) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = t1.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && Gt("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Gg(s.azimuthal, 90 - s.polar, e) : Gg(r[0], 90 - r[1], e);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return Gg(r[0], 90 - r[1], e);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(t1) {
                    this._skyboxInvalidated = !1, this._lightPosition = t1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const t1 = this.paint.get("sky-type");
                    return "atmosphere" === t1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === t1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        paint: Ng || (Ng = new Po({}))
                    }, e, null);
                }
            },
            model: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: dx || (dx = new Po({
                            visibility: new So(Eo.layout_model.visibility),
                            "model-id": new zo(Eo.layout_model["model-id"])
                        })),
                        paint: mx || (mx = new Po({
                            "model-opacity": new zo(Eo.paint_model["model-opacity"]),
                            "model-rotation": new zo(Eo.paint_model["model-rotation"]),
                            "model-scale": new zo(Eo.paint_model["model-scale"]),
                            "model-translation": new zo(Eo.paint_model["model-translation"]),
                            "model-color": new zo(Eo.paint_model["model-color"]),
                            "model-color-mix-intensity": new zo(Eo.paint_model["model-color-mix-intensity"]),
                            "model-type": new So(Eo.paint_model["model-type"]),
                            "model-cast-shadows": new So(Eo.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new So(Eo.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new So(Eo.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new zo(Eo.paint_model["model-emissive-strength"]),
                            "model-roughness": new zo(Eo.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new zo(Eo.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new So(Eo.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new So(Eo.paint_model["model-front-cutoff"]),
                            "model-color-use-theme": new zo({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(t1) {
                    return new fx(t1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D(t1) {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(t1) {
                    return t1 instanceof Tx ? Cn - 1 : 0;
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    if (!this.modelManager) return !1;
                    const o = this.modelManager, l = t1.tile.getBucket(this);
                    if (!(l && l instanceof fx)) return !1;
                    for(const r in l.instancesPerModel){
                        const n = l.instancesPerModel[r], i = void 0 !== e.id ? e.id : e.properties && e.properties.hasOwnProperty("id") ? e.properties.id : void 0;
                        if (n.idToFeaturesIndex.hasOwnProperty(i)) {
                            const e = n.features[n.idToFeaturesIndex[i]], u = o.getModel(r, this.scope);
                            if (!u) return !1;
                            let h = a();
                            const p = new Hl(0, 0), f = l.canonical;
                            let d = Number.MAX_VALUE;
                            for(let r = 0; r < e.instancedDataCount; ++r){
                                const i = 16 * (e.instancedDataOffset + r), o = n.instancedDataArray.float32, a = [
                                    o[i + 4],
                                    o[i + 5],
                                    o[i + 6]
                                ];
                                Fx(f, p, o[i], 0 | o[i + 1]), xx(h, u, s, p, e.rotation, e.scale, a, !1, !1, !1), "globe" === s.projection.name && (h = Qg(h, s));
                                const l = c([], s.projMatrix, h), m = t1.queryGeometry, y = tx(m.isPointQuery() ? m.screenBounds : m.screenGeometry, s, l, u.aabb);
                                null != y && (d = Math.min(y, d));
                            }
                            return d !== Number.MAX_VALUE && d;
                        }
                    }
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(t1, e, r) {
                    return !(!this.layout || e.isDataDriven() || r.isDataDriven() || "model-color" !== t1 && "model-color-mix-intensity" !== t1 && "model-rotation" !== t1 && "model-scale" !== t1 && "model-translation" !== t1 && "model-emissive-strength" !== t1);
                }
                _isPropertyZoomDependent(t1) {
                    const e = this._transitionablePaint._values[t1];
                    return null != e && null != e.value && null != e.value.expression && e.value.expression instanceof Ds;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            },
            clip: class extends Yo {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: yp || (yp = new Po({
                            "clip-layer-types": new So(Eo.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new So(Eo.layout_clip["clip-layer-scope"])
                        })),
                        paint: gp || (gp = new Po({}))
                    }, e, r, n);
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                }
                createBucket(t1) {
                    return new bp(t1);
                }
                is3D(t1) {
                    return !0;
                }
            }
        }, Rx = new sr(0, 0, 0), Ox = {
            PATH_RULE_NON_ZERO: 1,
            PATH_RULE_EVEN_ODD: 2
        }, Ux = {
            LINE_CAP_BUTT: 1,
            LINE_CAP_ROUND: 2,
            LINE_CAP_SQUARE: 3
        }, Nx = {
            LINE_JOIN_MITER: 1,
            LINE_JOIN_MITER_CLIP: 2,
            LINE_JOIN_ROUND: 3,
            LINE_JOIN_BEVEL: 4
        }, jx = {
            PAINT_ORDER_FILL_AND_STROKE: 1
        }, $x = {
            PATH_COMMAND_MOVE: 1,
            PATH_COMMAND_LINE: 2,
            PATH_COMMAND_QUAD: 3,
            PATH_COMMAND_CUBIC: 4,
            PATH_COMMAND_CLOSE: 5
        }, Gx = {
            MASK_TYPE_LUMINANCE: 1
        };
        function qx(t1, e, r) {
            1 === t1 && e.icons.push(function(t1, e) {
                return function(t1) {
                    if (t1.usvg_tree.height || (t1.usvg_tree.height = t1.usvg_tree.width), !t1.metadata) return t1;
                    const { metadata: e } = t1;
                    if (e.content_area) {
                        const { content_area: r } = e;
                        null == r.top && (r.top = r.left), null == r.width && (r.width = t1.usvg_tree.width), null == r.height && (r.height = r.width);
                    }
                    return e.stretch_x && e.stretch_x.length && Hx(e, "x"), e.stretch_y && e.stretch_y.length && Hx(e, "y"), t1;
                }(t1.readFields(Xx, {
                    name: void 0
                }, e));
            }(r, r.readVarint() + r.pos));
        }
        function Hx(t1, e) {
            const r = [], n = t1[`stretch_${e}`];
            let i = null;
            for(let t1 = 0; t1 < n.length; t1++)null === i ? i = 0 === r.length ? n[0] : r[r.length - 1][1] + n[t1] : (r.push([
                i,
                i + n[t1]
            ]), i = null);
            t1[`stretch_${e}_areas`] = r;
        }
        function Xx(t1, e, r) {
            1 === t1 ? e.name = r.readString() : 2 === t1 ? e.metadata = function(t1, e) {
                return t1.readFields(Zx, {
                    stretch_x: null,
                    stretch_y: null,
                    stretch_x_areas: null,
                    stretch_y_areas: null,
                    variables: []
                }, e);
            }(r, r.readVarint() + r.pos) : 3 === t1 && (e.usvg_tree = function(t1, e) {
                return t1.readFields(Kx, {
                    width: 20,
                    children: [],
                    linear_gradients: [],
                    radial_gradients: [],
                    clip_paths: [],
                    masks: []
                }, e);
            }(r, r.readVarint() + r.pos), e.data = "usvg_tree");
        }
        function Zx(t1, e, r) {
            1 === t1 ? e.stretch_x = r.readPackedVarint() : 2 === t1 ? e.stretch_y = r.readPackedVarint() : 3 === t1 ? e.content_area = function(t1, e) {
                return t1.readFields(Wx, {
                    left: 0
                }, e);
            }(r, r.readVarint() + r.pos) : 4 === t1 && e.variables.push(function(t1, e) {
                return t1.readFields(Yx, {
                    name: void 0
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function Wx(t1, e, r) {
            1 === t1 ? e.left = r.readVarint() : 2 === t1 ? e.width = r.readVarint() : 3 === t1 ? e.top = r.readVarint() : 4 === t1 && (e.height = r.readVarint());
        }
        function Yx(t1, e, r) {
            1 === t1 ? e.name = r.readString() : 2 === t1 && (e.rgb_color = sv(r.readVarint()), e.value = "rgb_color");
        }
        function Kx(t1, e, r) {
            1 === t1 ? e.width = e.height = r.readVarint() : 2 === t1 ? e.height = r.readVarint() : 3 === t1 ? e.children.push(Jx(r, r.readVarint() + r.pos)) : 4 === t1 ? e.linear_gradients.push(function(t1, e) {
                return t1.readFields(av, {
                    spread_method: 1,
                    stops: [],
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                }, e);
            }(r, r.readVarint() + r.pos)) : 5 === t1 ? e.radial_gradients.push(function(t1, e) {
                return t1.readFields(cv, {
                    spread_method: 1,
                    stops: [],
                    cx: .5,
                    cy: .5,
                    r: .5,
                    fx: .5,
                    fy: .5,
                    fr: 0
                }, e);
            }(r, r.readVarint() + r.pos)) : 7 === t1 ? e.clip_paths.push(function(t1, e) {
                return t1.readFields(hv, {
                    children: []
                }, e);
            }(r, r.readVarint() + r.pos)) : 8 === t1 && e.masks.push(function(t1, e) {
                const r = t1.readFields(pv, {
                    left: 0,
                    width: 20,
                    mask_type: Gx.MASK_TYPE_LUMINANCE,
                    children: []
                }, e);
                return null == r.height && (r.height = r.width), null == r.top && (r.top = r.left), r;
            }(r, r.readVarint() + r.pos));
        }
        function Jx(t1, e) {
            return t1.readFields(Qx, {}, e);
        }
        function Qx(t1, e, r) {
            1 === t1 ? (e.group = function(t1, e) {
                return t1.readFields(tv, {
                    opacity: 255,
                    children: []
                }, e);
            }(r, r.readVarint() + r.pos), e.node = "group") : 2 === t1 && (e.path = function(t1, e) {
                return t1.readFields(nv, {
                    paint_order: 1,
                    commands: [],
                    step: 1,
                    diffs: [],
                    rule: Ox.PATH_RULE_NON_ZERO
                }, e);
            }(r, r.readVarint() + r.pos), e.node = "path");
        }
        function tv(t1, e, r) {
            1 === t1 ? e.transform = ev(r, r.readVarint() + r.pos) : 2 === t1 ? e.opacity = r.readVarint() : 5 === t1 ? e.clip_path_idx = r.readVarint() : 6 === t1 ? e.mask_idx = r.readVarint() : 7 === t1 && e.children.push(Jx(r, r.readVarint() + r.pos));
        }
        function ev(t1, e) {
            return t1.readFields(rv, {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            }, e);
        }
        function rv(t1, e, r) {
            1 === t1 ? e.sx = r.readFloat() : 2 === t1 ? e.ky = r.readFloat() : 3 === t1 ? e.kx = r.readFloat() : 4 === t1 ? e.sy = r.readFloat() : 5 === t1 ? e.tx = r.readFloat() : 6 === t1 && (e.ty = r.readFloat());
        }
        function nv(t1, e, r) {
            1 === t1 ? e.fill = function(t1, e) {
                return t1.readFields(iv, {
                    rgb_color: Rx,
                    paint: "rgb_color",
                    opacity: 255
                }, e);
            }(r, r.readVarint() + r.pos) : 2 === t1 ? e.stroke = function(t1, e) {
                return t1.readFields(ov, {
                    rgb_color: Rx,
                    paint: "rgb_color",
                    dasharray: [],
                    dashoffset: 0,
                    miterlimit: 4,
                    opacity: 255,
                    width: 1,
                    linecap: 1,
                    linejoin: 1
                }, e);
            }(r, r.readVarint() + r.pos) : 3 === t1 ? e.paint_order = r.readVarint() : 5 === t1 ? r.readPackedVarint(e.commands) : 6 === t1 ? e.step = r.readFloat() : 7 === t1 ? r.readPackedSVarint(e.diffs) : 8 === t1 && (e.rule = r.readVarint());
        }
        function iv(t1, e, r) {
            1 === t1 ? (e.rgb_color = sv(r.readVarint()), e.paint = "rgb_color") : 2 === t1 ? (e.linear_gradient_idx = r.readVarint(), e.paint = "linear_gradient_idx") : 3 === t1 ? (e.radial_gradient_idx = r.readVarint(), e.paint = "radial_gradient_idx") : 5 === t1 && (e.opacity = r.readVarint());
        }
        function sv(t1) {
            return new sr((t1 >> 16 & 255) / 255, (t1 >> 8 & 255) / 255, (255 & t1) / 255, 1);
        }
        function ov(t1, e, r) {
            1 === t1 ? (e.rgb_color = sv(r.readVarint()), e.paint = "rgb_color") : 2 === t1 ? (e.linear_gradient_idx = r.readVarint(), e.paint = "linear_gradient_idx") : 3 === t1 ? (e.radial_gradient_idx = r.readVarint(), e.paint = "radial_gradient_idx") : 5 === t1 ? r.readPackedFloat(e.dasharray) : 6 === t1 ? e.dashoffset = r.readFloat() : 7 === t1 ? e.miterlimit = r.readFloat() : 8 === t1 ? e.opacity = r.readVarint() : 9 === t1 ? e.width = r.readFloat() : 10 === t1 ? e.linecap = r.readVarint() : 11 === t1 && (e.linejoin = r.readVarint());
        }
        function av(t1, e, r) {
            1 === t1 ? e.transform = ev(r, r.readVarint() + r.pos) : 2 === t1 ? e.spread_method = r.readVarint() : 3 === t1 ? e.stops.push(lv(r, r.readVarint() + r.pos)) : 4 === t1 ? e.x1 = r.readFloat() : 5 === t1 ? e.y1 = r.readFloat() : 6 === t1 ? e.x2 = r.readFloat() : 7 === t1 && (e.y2 = r.readFloat());
        }
        function lv(t1, e) {
            return t1.readFields(uv, {
                offset: 0,
                opacity: 255,
                rgb_color: Rx
            }, e);
        }
        function uv(t1, e, r) {
            1 === t1 ? e.offset = r.readFloat() : 2 === t1 ? e.opacity = r.readVarint() : 3 === t1 && (e.rgb_color = sv(r.readVarint()));
        }
        function cv(t1, e, r) {
            1 === t1 ? e.transform = ev(r, r.readVarint() + r.pos) : 2 === t1 ? e.spread_method = r.readVarint() : 3 === t1 ? e.stops.push(lv(r, r.readVarint() + r.pos)) : 4 === t1 ? e.cx = r.readFloat() : 5 === t1 ? e.cy = r.readFloat() : 6 === t1 ? e.r = r.readFloat() : 7 === t1 ? e.fx = r.readFloat() : 8 === t1 ? e.fy = r.readFloat() : 9 === t1 && (e.fr = r.readFloat());
        }
        function hv(t1, e, r) {
            1 === t1 ? e.transform = ev(r, r.readVarint() + r.pos) : 2 === t1 ? e.clip_path_idx = r.readVarint() : 3 === t1 && e.children.push(Jx(r, r.readVarint() + r.pos));
        }
        function pv(t1, e, r) {
            1 === t1 ? e.left = e.top = r.readFloat() : 2 === t1 ? e.width = e.height = r.readFloat() : 3 === t1 ? e.top = r.readFloat() : 4 === t1 ? e.height = r.readFloat() : 5 === t1 ? e.mask_type = r.readVarint() : 6 === t1 ? e.mask_idx = r.readVarint() : 7 === t1 && e.children.push(Jx(r, r.readVarint() + r.pos));
        }
        class fv {
            static calculate(t1 = {}, e = []) {
                const r = new Map, n = new Map;
                if (0 === Object.keys(t1).length) return r;
                e.forEach((t1)=>{
                    n.set(t1.name, t1.rgb_color || new sr(0, 0, 0));
                });
                for (const [e, i] of Object.entries(t1))n.has(e) ? r.set(n.get(e).toString(), i) : console.warn(`Ignoring unknown image variable "${e}"`);
                return r;
            }
        }
        function dv(t1, e = 255, r) {
            const n = e / 255, i = t1.toString(), s = r.has(i) ? r.get(i).clone() : t1.clone();
            return s.a *= n, s.toString();
        }
        function mv(t1, e) {
            if (!pe()) {
                const r = document.createElement("canvas");
                return r.width = t1, r.height = e, r;
            }
            return new OffscreenCanvas(t1, e);
        }
        function yv(t1, e) {
            const r = fv.calculate(e.params, t1.metadata ? t1.metadata.variables : []), n = t1.usvg_tree, i = n.width, s = n.height, o = e.transform ? e.transform : new DOMMatrix, a = Math.max(1, Math.round(i * o.a)), l = Math.max(1, Math.round(s * o.d)), u = new DOMMatrix([
                a / i,
                0,
                0,
                l / s,
                0,
                0
            ]), c = mv(a, l).getContext("2d");
            return gv(c, u, n, n, r), c.getImageData(0, 0, a, l);
        }
        function gv(t1, e, r, n, i) {
            for (const s of n.children)xv(t1, e, r, s, i);
        }
        function xv(t1, e, r, n, i) {
            n.group ? (t1.save(), function(t1, e, r, n, i) {
                const s = null != n.mask_idx ? r.masks[n.mask_idx] : null, o = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
                if (n.transform && (e = zv(n.transform).preMultiplySelf(e)), !function(t1, e, r) {
                    return 255 !== t1.opacity || e || r;
                }(n, null != o, null != s)) return void gv(t1, e, r, n, i);
                const a = mv(t1.canvas.width, t1.canvas.height), l = a.getContext("2d");
                gv(l, e, r, n, i), o && Iv(l, e, r, o), s && Sv(l, e, r, s, i), t1.globalAlpha = n.opacity / 255, t1.drawImage(a, 0, 0);
            }(t1, e, r, n.group, i), t1.restore()) : n.path && (t1.save(), function(t1, e, r, n, i) {
                t1.setTransform(e), n.paint_order === jx.PAINT_ORDER_FILL_AND_STROKE ? (vv(t1, r, n, i), wv(t1, r, n, i)) : (wv(t1, r, n, i), vv(t1, r, n, i));
            }(t1, e, r, n.path, i), t1.restore());
        }
        function vv(t1, e, r, n) {
            const i = r.fill;
            if (!i) return;
            const s = i.opacity / 255;
            switch(t1.save(), t1.beginPath(), kv(r, t1), i.paint){
                case "rgb_color":
                    t1.fillStyle = dv(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    {
                        const r = e.linear_gradients[i.linear_gradient_idx];
                        r.transform && t1.setTransform(zv(r.transform).preMultiplySelf(t1.getTransform())), t1.fillStyle = _v(t1, r, s, n);
                        break;
                    }
                case "radial_gradient_idx":
                    {
                        const r = e.radial_gradients[i.radial_gradient_idx];
                        r.transform && t1.setTransform(zv(r.transform).preMultiplySelf(t1.getTransform())), t1.fillStyle = Av(t1, r, s, n);
                    }
            }
            t1.fill(bv(r)), t1.restore();
        }
        function bv(t1) {
            return t1.rule === Ox.PATH_RULE_NON_ZERO ? "nonzero" : t1.rule === Ox.PATH_RULE_EVEN_ODD ? "evenodd" : void 0;
        }
        function wv(t1, e, r, n) {
            const i = r.stroke;
            if (!i) return;
            const s = Pv(r);
            t1.lineWidth = i.width, t1.miterLimit = i.miterlimit, t1.setLineDash(i.dasharray), t1.lineDashOffset = i.dashoffset;
            const o = i.opacity / 255;
            switch(i.paint){
                case "rgb_color":
                    t1.strokeStyle = dv(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    t1.strokeStyle = _v(t1, e.linear_gradients[i.linear_gradient_idx], o, n, !0);
                    break;
                case "radial_gradient_idx":
                    t1.strokeStyle = Av(t1, e.radial_gradients[i.radial_gradient_idx], o, n, !0);
            }
            switch(i.linejoin){
                case Nx.LINE_JOIN_MITER_CLIP:
                case Nx.LINE_JOIN_MITER:
                    t1.lineJoin = "miter";
                    break;
                case Nx.LINE_JOIN_ROUND:
                    t1.lineJoin = "round";
                    break;
                case Nx.LINE_JOIN_BEVEL:
                    t1.lineJoin = "bevel";
            }
            switch(i.linecap){
                case Ux.LINE_CAP_BUTT:
                    t1.lineCap = "butt";
                    break;
                case Ux.LINE_CAP_ROUND:
                    t1.lineCap = "round";
                    break;
                case Ux.LINE_CAP_SQUARE:
                    t1.lineCap = "square";
            }
            t1.stroke(s);
        }
        function _v(t1, e, r, n, i = !1) {
            if (1 === e.stops.length) {
                const t1 = e.stops[0];
                return dv(t1.rgb_color, t1.opacity * r, n);
            }
            const { x1: s, y1: o, x2: a, y2: l } = e;
            let u = new DOMPoint(s, o), c = new DOMPoint(a, l);
            if (i) {
                const t1 = zv(e.transform);
                u = t1.transformPoint(u), c = t1.transformPoint(c);
            }
            const h = t1.createLinearGradient(u.x, u.y, c.x, c.y);
            for (const t1 of e.stops)h.addColorStop(t1.offset, dv(t1.rgb_color, t1.opacity * r, n));
            return h;
        }
        function Av(t1, e, r, n, i = !1) {
            if (1 === e.stops.length) {
                const t1 = e.stops[0];
                return dv(t1.rgb_color, t1.opacity * r, n);
            }
            const s = zv(e.transform), { fx: o, fy: a, fr: l, cx: u, cy: c, r: h } = e;
            let p = new DOMPoint(o, a), f = new DOMPoint(u, c), d = l, m = h;
            if (i) {
                p = s.transformPoint(p), f = s.transformPoint(f);
                const t1 = (s.a + s.d) / 2;
                d = l * t1, m = e.r * t1;
            }
            const y = t1.createRadialGradient(p.x, p.y, d, f.x, f.y, m);
            for (const t1 of e.stops)y.addColorStop(t1.offset, dv(t1.rgb_color, t1.opacity * r, n));
            return y;
        }
        function Mv(t1, e, r, n) {
            const i = n.transform ? zv(n.transform).preMultiplySelf(e) : e, s = mv(t1.canvas.width, t1.canvas.height), o = s.getContext("2d");
            for (const t1 of n.children)if (t1.group) Mv(o, i, r, t1.group);
            else if (t1.path) {
                const e = t1.path, r = new Path2D;
                r.addPath(Pv(e), i), o.fill(r, bv(e));
            }
            const a = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
            a && Iv(o, i, r, a), t1.globalCompositeOperation = "source-over", t1.drawImage(s, 0, 0);
        }
        function Iv(t1, e, r, n) {
            const i = mv(t1.canvas.width, t1.canvas.height);
            Mv(i.getContext("2d"), e, r, n), t1.globalCompositeOperation = "destination-in", t1.drawImage(i, 0, 0);
        }
        function Sv(t1, e, r, n, i) {
            if (0 === n.children.length) return;
            const s = null != n.mask_idx ? r.masks[n.mask_idx] : null;
            s && Sv(t1, e, r, s, i);
            const o = t1.canvas.width, a = t1.canvas.height, l = mv(o, a), u = l.getContext("2d"), c = n.width, h = n.height, p = n.left, f = n.top, d = new Path2D, m = new Path2D;
            m.rect(p, f, c, h), d.addPath(m, e), u.clip(d);
            for (const t1 of n.children)xv(u, e, r, t1, i);
            const y = u.getImageData(0, 0, o, a), g = y.data;
            if (n.mask_type === Gx.MASK_TYPE_LUMINANCE) for(let t1 = 0; t1 < g.length; t1 += 4)g[t1 + 3] = g[t1 + 3] / 255 * (.2126 * g[t1] + .7152 * g[t1 + 1] + .0722 * g[t1 + 2]);
            u.putImageData(y, 0, 0), t1.globalCompositeOperation = "destination-in", t1.drawImage(l, 0, 0);
        }
        function zv(t1) {
            return t1 ? new DOMMatrix([
                t1.sx,
                t1.ky,
                t1.kx,
                t1.sy,
                t1.tx,
                t1.ty
            ]) : new DOMMatrix;
        }
        function kv(t1, e) {
            const r = t1.step;
            let n = t1.diffs[0] * r, i = t1.diffs[1] * r;
            e.moveTo(n, i);
            for(let s = 0, o = 2; s < t1.commands.length; s++)switch(t1.commands[s]){
                case $x.PATH_COMMAND_MOVE:
                    n += t1.diffs[o++] * r, i += t1.diffs[o++] * r, e.moveTo(n, i);
                    break;
                case $x.PATH_COMMAND_LINE:
                    n += t1.diffs[o++] * r, i += t1.diffs[o++] * r, e.lineTo(n, i);
                    break;
                case $x.PATH_COMMAND_QUAD:
                    {
                        const s = n + t1.diffs[o++] * r, a = i + t1.diffs[o++] * r;
                        n = s + t1.diffs[o++] * r, i = a + t1.diffs[o++] * r, e.quadraticCurveTo(s, a, n, i);
                        break;
                    }
                case $x.PATH_COMMAND_CUBIC:
                    {
                        const s = n + t1.diffs[o++] * r, a = i + t1.diffs[o++] * r, l = s + t1.diffs[o++] * r, u = a + t1.diffs[o++] * r;
                        n = l + t1.diffs[o++] * r, i = u + t1.diffs[o++] * r, e.bezierCurveTo(s, a, l, u, n, i);
                        break;
                    }
                case $x.PATH_COMMAND_CLOSE:
                    e.closePath();
            }
            return e;
        }
        function Pv(t1) {
            return kv(t1, new Path2D);
        }
        class Ev {
            constructor(t1){
                this.capacity = t1, this.cache = new Map;
            }
            get(t1) {
                if (!this.cache.has(t1)) return;
                const e = this.cache.get(t1);
                return this.cache.delete(t1), this.cache.set(t1, e), e;
            }
            put(t1, e) {
                this.cache.has(t1) ? this.cache.delete(t1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t1, e);
            }
            delete(t1) {
                this.cache.delete(t1);
            }
        }
        qs(Ev, "LRUCache");
        class Tv {
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
            static _getImage(t1) {
                return new yh(t1, t1.data);
            }
            getFromCache(t1, e, r) {
                return this.cacheMap.has(r) || this.cacheMap.set(r, new Ev(150)), this.cacheMap.get(r).get(Xo(t1.toString(), e));
            }
            setInCache(t1, e, r, n) {
                this.cacheDependenciesMap.has(n) || this.cacheDependenciesMap.set(n, new Map), this.cacheMap.has(n) || this.cacheMap.set(n, new Ev(150));
                const i = this.cacheDependenciesMap.get(n), s = Xo(t1.id.toString(), r);
                i.get(s) || i.set(s, new Set);
                const o = this.cacheMap.get(n), a = t1.toString();
                i.get(s).add(a), o.put(Xo(t1.toString(), r), e);
            }
            removeImagesFromCacheByIds(t1, e, r = 0) {
                if (!this.cacheMap.has(r) || !this.cacheDependenciesMap.has(r)) return;
                const n = this.cacheMap.get(r), i = this.cacheDependenciesMap.get(r);
                for (const r of t1){
                    const t1 = Xo(r.toString(), e);
                    if (i.has(t1)) {
                        for (const e of i.get(t1))n.delete(e);
                        i.delete(t1);
                    }
                }
            }
            rasterize(t1, e, r, n, i = yv) {
                const s = this.getFromCache(t1, r, n);
                if (s) return s.clone();
                const o = i(e.icon, t1.options), a = Tv._getImage(o);
                return this.setInCache(t1, a, r, n), a.clone();
            }
        }
        class Bv {
            constructor(t1){
                this.size = t1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(t1, e) {
                const r = this.toIdx(t1, e);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(t1, e) {
                return this.leaves[this.toIdx(t1, e)];
            }
            toIdx(t1, e) {
                return e * this.size + t1;
            }
        }
        function Vv(t1, e, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let o = 0; o < 3; o++)if (Math.abs(n[o]) < 1e-15) {
                if (r[o] < t1[o] || r[o] > e[o]) return null;
            } else {
                const a = 1 / n[o];
                let l = (t1[o] - r[o]) * a, u = (e[o] - r[o]) * a;
                if (l > u) {
                    const t1 = l;
                    l = u, u = t1;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function Cv(t1, e, r, n, i, s, o, a, l, u, c) {
            const h = n - t1, p = i - e, f = s - r, d = o - t1, m = a - e, y = l - r, g = c[1] * y - c[2] * m, x = c[2] * d - c[0] * y, v = c[0] * m - c[1] * d, b = h * g + p * x + f * v;
            if (Math.abs(b) < 1e-15) return null;
            const w = 1 / b, _ = u[0] - t1, A = u[1] - e, M = u[2] - r, I = (_ * g + A * x + M * v) * w;
            if (I < 0 || I > 1) return null;
            const S = A * f - M * p, z = M * h - _ * f, k = _ * p - A * h, P = (c[0] * S + c[1] * z + c[2] * k) * w;
            return P < 0 || I + P > 1 ? null : (d * S + m * z + y * k) * w;
        }
        function Fv(t1, e, r) {
            return (t1 - e) / (r - e);
        }
        function Dv(t1, e, r, n, i, s, o, a, l) {
            const u = 1 << r, c = s - n, h = o - i, p = (t1 + 1) / u * c + n, f = (e + 0) / u * h + i, d = (e + 1) / u * h + i;
            a[0] = (t1 + 0) / u * c + n, a[1] = f, l[0] = p, l[1] = d;
        }
        class Lv {
            constructor(t1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const e = function(t1) {
                    const e = Math.ceil(Math.log2(t1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, e));
                    const i = 1 / n, s = (t1, e, r, n, i)=>{
                        const s = n ? 1 : 0, o = (t1 + 1) * r - s, a = e * r, l = (e + 1) * r - s;
                        i[0] = t1 * r, i[1] = a, i[2] = o, i[3] = l;
                    };
                    let o = new Bv(n);
                    const a = [];
                    for(let e = 0; e < n * n; e++){
                        s(e % n, Math.floor(e / n), i, !1, a);
                        const r = Ov(a[0], a[1], t1), l = Ov(a[2], a[1], t1), u = Ov(a[2], a[3], t1), c = Ov(a[0], a[3], t1);
                        o.minimums.push(Math.min(r, l, u, c)), o.maximums.push(Math.max(r, l, u, c)), o.leaves.push(1);
                    }
                    for(r.push(o), n /= 2; n >= 1; n /= 2){
                        const t1 = r[r.length - 1];
                        o = new Bv(n);
                        for(let e = 0; e < n * n; e++){
                            s(e % n, Math.floor(e / n), 2, !0, a);
                            const r = t1.getElevation(a[0], a[1]), i = t1.getElevation(a[2], a[1]), l = t1.getElevation(a[2], a[3]), u = t1.getElevation(a[0], a[3]), c = t1.isLeaf(a[0], a[1]), h = t1.isLeaf(a[2], a[1]), p = t1.isLeaf(a[2], a[3]), f = t1.isLeaf(a[0], a[3]), d = Math.min(r.min, i.min, l.min, u.min), m = Math.max(r.max, i.max, l.max, u.max), y = c && h && p && f;
                            o.maximums.push(m), o.minimums.push(d), o.leaves.push(m - d <= 5 && y ? 1 : 0);
                        }
                        r.push(o);
                    }
                    return r;
                }(this.dem), r = e.length - 1, n = e[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e, 0, 0, r, 0);
            }
            raycastRoot(t1, e, r, n, i, s, o = 1) {
                return Vv([
                    t1,
                    e,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * o
                ], i, s);
            }
            raycast(t1, e, r, n, i, s, o = 1) {
                if (!this.nodeCount) return null;
                const a = this.raycastRoot(t1, e, r, n, i, s, o);
                if (null == a) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: a,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: a, t: f, nodex: d, nodey: m, depth: y } = p.pop();
                    if (this.leaves[a]) {
                        Dv(d, m, y, t1, e, r, n, c, h);
                        const a = 1 << y, l = (d + 0) / a, u = (d + 1) / a, p = (m + 0) / a, g = (m + 1) / a, x = Ov(l, p, this.dem) * o, v = Ov(u, p, this.dem) * o, b = Ov(u, g, this.dem) * o, w = Ov(l, g, this.dem) * o, _ = Cv(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, s), A = Cv(h[0], h[1], b, c[0], h[1], w, c[0], c[1], x, i, s), M = Math.min(null !== _ ? _ : Number.MAX_VALUE, null !== A ? A : Number.MAX_VALUE);
                        if (M !== Number.MAX_VALUE) return M;
                        {
                            const t1 = E([], i, s, f);
                            if (Rv(x, v, w, b, Fv(t1[0], c[0], h[0]), Fv(t1[1], c[1], h[1])) >= t1[2]) return f;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        Dv((d << 1) + this._siblingOffset[p][0], (m << 1) + this._siblingOffset[p][1], y + 1, t1, e, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[a] + p] * o;
                        const f = Vv(c, h, i, s);
                        if (null != f) {
                            const t1 = f;
                            l[p] = t1;
                            let e = !1;
                            for(let r = 0; r < g && !e; r++)t1 >= l[u[r]] && (u.splice(r, 0, p), e = !0);
                            e || (u[g] = p), g++;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++){
                        const e = u[t1];
                        p.push({
                            idx: this.childOffsets[a] + e,
                            t: l[e],
                            nodex: (d << 1) + this._siblingOffset[e][0],
                            nodey: (m << 1) + this._siblingOffset[e][1],
                            depth: y + 1
                        });
                    }
                }
                return null;
            }
            _addNode(t1, e, r) {
                return this.minimums.push(t1), this.maximums.push(e), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t1, e, r, n, i) {
                if (1 === t1[n].isLeaf(e, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, o = t1[s];
                let a = 0, l = 0;
                for(let t1 = 0; t1 < this._siblingOffset.length; t1++){
                    const n = 2 * e + this._siblingOffset[t1][0], i = 2 * r + this._siblingOffset[t1][1], s = o.getElevation(n, i), u = o.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (a |= 1 << t1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)a & 1 << n || this._construct(t1, 2 * e + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
        }
        function Rv(t1, e, r, n, i, s) {
            return ur(ur(t1, r, s), ur(e, n, s), i);
        }
        function Ov(t1, e, r) {
            const n = r.dim, i = Et(t1 * n - .5, 0, n - 1), s = Et(e * n - .5, 0, n - 1), o = Math.floor(i), a = Math.floor(s), l = Math.min(o + 1, n - 1), u = Math.min(a + 1, n - 1);
            return Rv(r.get(o, a), r.get(l, a), r.get(o, u), r.get(l, u), i - o, s - a);
        }
        const Uv = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function Nv(t1, e, r) {
            return (256 * t1 * 256 + 256 * e + r) / 10 - 1e4;
        }
        function jv(t1, e, r) {
            return 256 * t1 + e + r / 256 - 32768;
        }
        class $v {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(t1, e, r, n = !1){
                if (this.uid = t1, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void Gt(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e.height;
                const i = this.dim = e.height - 2, s = new Uint32Array(e.data.buffer);
                if (this.pixels = new Uint8Array(e.data.buffer), this.floatView = new Float32Array(e.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let t1 = 0; t1 < i; t1++)s[this._idx(-1, t1)] = s[this._idx(0, t1)], s[this._idx(i, t1)] = s[this._idx(i - 1, t1)], s[this._idx(t1, -1)] = s[this._idx(t1, 0)], s[this._idx(t1, i)] = s[this._idx(t1, i - 1)];
                    s[this._idx(-1, -1)] = s[this._idx(0, 0)], s[this._idx(i, -1)] = s[this._idx(i - 1, 0)], s[this._idx(-1, i)] = s[this._idx(0, i - 1)], s[this._idx(i, i)] = s[this._idx(i - 1, i - 1)];
                }
                const o = "terrarium" === r ? jv : Nv;
                for(let t1 = 0; t1 < s.length; ++t1){
                    const e = 4 * t1;
                    this.floatView[t1] = o(this.pixels[e], this.pixels[e + 1], this.pixels[e + 2]);
                }
                this._timestamp = fe.now();
            }
            _buildQuadTree() {
                this._tree = new Lv(this);
            }
            get(t1, e, r = !1) {
                r && (t1 = Et(t1, -1, this.dim), e = Et(e, -1, this.dim));
                const n = this._idx(t1, e);
                return this.floatView[n];
            }
            set(t1, e, r) {
                const n = this._idx(t1, e), i = this.floatView[n];
                return this.floatView[n] = r, r - i;
            }
            static getUnpackVector(t1) {
                return Uv[t1];
            }
            _idx(t1, e) {
                if (t1 < -1 || t1 >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t1 + 1);
            }
            static pack(t1, e) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = $v.getUnpackVector(e);
                let i = Math.floor((t1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new gh({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(t1, e, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, s = r * this.dim, o = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = o - 1;
                        break;
                    case 1:
                        o = s + 1;
                }
                const a = -e * this.dim, l = -r * this.dim;
                for(let e = s; e < o; e++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, e), i = 4 * this._idx(r + a, e + l);
                    this.pixels[n + 0] = t1.pixels[i + 0], this.pixels[n + 1] = t1.pixels[i + 1], this.pixels[n + 2] = t1.pixels[i + 2], this.pixels[n + 3] = t1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        function Gv(t1, e, r) {
            1 === t1 ? e.headerLength = r.readFixed32() : 2 === t1 ? e.x = r.readVarint() : 3 === t1 ? e.y = r.readVarint() : 4 === t1 ? e.z = r.readVarint() : 5 === t1 && e.layers.push(function(t1, e) {
                return t1.readFields(Wv, {
                    version: 0,
                    name: "",
                    units: "",
                    tileSize: 0,
                    buffer: 0,
                    pixelFormat: 0,
                    dataIndex: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function qv(t1, e, r) {
            1 === t1 ? (e.delta_filter = function(t1, e) {
                return t1.readFields(Hv, {
                    blockSize: 0
                }, e);
            }(r, r.readVarint() + r.pos), e.filter = "delta_filter") : 2 === t1 ? (r.readVarint(), e.filter = "zigzag_filter") : 3 === t1 ? (r.readVarint(), e.filter = "bitshuffle_filter") : 4 === t1 && (r.readVarint(), e.filter = "byteshuffle_filter");
        }
        function Hv(t1, e, r) {
            1 === t1 && (e.blockSize = r.readVarint());
        }
        function Xv(t1, e, r) {
            1 === t1 ? (r.readVarint(), e.codec = "gzip_data") : 2 === t1 ? (r.readVarint(), e.codec = "jpeg_image") : 3 === t1 ? (r.readVarint(), e.codec = "webp_image") : 4 === t1 && (r.readVarint(), e.codec = "png_image");
        }
        function Zv(t1, e, r) {
            let n = 0, i = 0;
            1 === t1 ? e.firstByte = r.readFixed64() : 2 === t1 ? e.lastByte = r.readFixed64() : 3 === t1 ? e.filters.push(function(t1, e) {
                return t1.readFields(qv, {}, e);
            }(r, r.readVarint() + r.pos)) : 4 === t1 ? e.codec = function(t1, e) {
                return t1.readFields(Xv, {}, e);
            }(r, r.readVarint() + r.pos) : 5 === t1 ? i = r.readFloat() : 6 === t1 ? n = r.readFloat() : 7 === t1 ? e.bands.push(r.readString()) : 8 === t1 ? e.offset = r.readDouble() : 9 === t1 && (e.scale = r.readDouble()), 0 === e.offset && (e.offset = i), 0 === e.scale && (e.scale = n);
        }
        function Wv(t1, e, r) {
            1 === t1 ? e.version = r.readVarint() : 2 === t1 ? e.name = r.readString() : 3 === t1 ? e.units = r.readString() : 4 === t1 ? e.tileSize = r.readVarint() : 5 === t1 ? e.buffer = r.readVarint() : 6 === t1 ? e.pixelFormat = r.readVarint() : 7 === t1 && e.dataIndex.push(function(t1, e) {
                return t1.readFields(Zv, {
                    firstByte: 0,
                    lastByte: 0,
                    filters: [],
                    codec: null,
                    offset: 0,
                    scale: 0,
                    bands: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function Yv(t1, e, r) {
            if (2 === t1) !function(t1, e, r) {
                t1.readFields(Kv, r, e);
            }(r, r.readVarint() + r.pos, e);
            else if (3 === t1) throw new Error("Not implemented");
        }
        function Kv(t1, e, r) {
            if (1 === t1) {
                let t1 = 0;
                const n = r.readVarint() + r.pos;
                for(; r.pos < n;)e[t1++] = r.readVarint();
            }
        }
        function Jv(t1, e) {
            if (4 !== e.length) throw new Error(`Expected data of dimension 4 but got ${e.length}.`);
            let r = e[3];
            for(let n = 2; n >= 1; n--){
                const i = 1 === n ? 1 : 0, s = 2 === n ? 1 : 0;
                for(let n = 0; n < e[0]; n++){
                    const o = e[1] * n;
                    for(let n = i; n < e[1]; n++){
                        const i = e[2] * (n + o);
                        for(let n = s; n < e[2]; n++){
                            const s = e[3] * (n + i);
                            for(let n = 0; n < e[3]; n++){
                                const e = s + n;
                                t1[e] += t1[e - r];
                            }
                        }
                    }
                }
                r *= e[n];
            }
            return t1;
        }
        function Qv(t1) {
            for(let e = 0, r = t1.length; e < r; e++)t1[e] = t1[e] >>> 1 ^ -(1 & t1[e]);
            return t1;
        }
        function tb(t1, e) {
            switch(e){
                case "uint32":
                    return t1;
                case "uint16":
                    for(let e = 0; e < t1.length; e += 2){
                        const r = t1[e], n = t1[e + 1];
                        t1[e] = (240 & r) >> 4 | (61440 & r) >> 8 | (240 & n) << 4 | 61440 & n, t1[e + 1] = 15 & r | (3840 & r) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return t1;
                case "uint8":
                    for(let e = 0; e < t1.length; e += 4){
                        const r = t1[e], n = t1[e + 1], i = t1[e + 2], s = t1[e + 3];
                        t1[e + 0] = (192 & r) >> 6 | (192 & n) >> 4 | (192 & i) >> 2 | 192 & s, t1[e + 1] = (48 & r) >> 4 | (48 & n) >> 2 | 48 & i | (48 & s) << 2, t1[e + 2] = (12 & r) >> 2 | 12 & n | (12 & i) << 2 | (12 & s) << 4, t1[e + 3] = 3 & r | (3 & n) << 2 | (3 & i) << 4 | (3 & s) << 6;
                    }
                    return t1;
                default:
                    throw new Error(`Invalid pixel format, "${e}"`);
            }
        }
        qs($v, "DEMData"), qs(Lv, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        var eb = Uint8Array, rb = Uint16Array, nb = Int32Array, ib = new eb([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), sb = new eb([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), ob = new eb([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), ab = function(t1, e) {
            for(var r = new rb(31), n = 0; n < 31; ++n)r[n] = e += 1 << t1[n - 1];
            var i = new nb(r[30]);
            for(n = 1; n < 30; ++n)for(var s = r[n]; s < r[n + 1]; ++s)i[s] = s - r[n] << 5 | n;
            return {
                b: r,
                r: i
            };
        }, lb = ab(ib, 2), ub = lb.b, cb = lb.r;
        ub[28] = 258, cb[258] = 28;
        for(var hb = ab(sb, 0).b, pb = new rb(32768), fb = 0; fb < 32768; ++fb){
            var db = (43690 & fb) >> 1 | (21845 & fb) << 1;
            pb[fb] = ((65280 & (db = (61680 & (db = (52428 & db) >> 2 | (13107 & db) << 2)) >> 4 | (3855 & db) << 4)) >> 8 | (255 & db) << 8) >> 1;
        }
        var mb = function(t1, e, r) {
            for(var n = t1.length, i = 0, s = new rb(e); i < n; ++i)t1[i] && ++s[t1[i] - 1];
            var o, a = new rb(e);
            for(i = 1; i < e; ++i)a[i] = a[i - 1] + s[i - 1] << 1;
            o = new rb(1 << e);
            var l = 15 - e;
            for(i = 0; i < n; ++i)if (t1[i]) for(var u = i << 4 | t1[i], c = e - t1[i], h = a[t1[i] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h)o[pb[h] >> l] = u;
            return o;
        }, yb = new eb(288);
        for(fb = 0; fb < 144; ++fb)yb[fb] = 8;
        for(fb = 144; fb < 256; ++fb)yb[fb] = 9;
        for(fb = 256; fb < 280; ++fb)yb[fb] = 7;
        for(fb = 280; fb < 288; ++fb)yb[fb] = 8;
        var gb = new eb(32);
        for(fb = 0; fb < 32; ++fb)gb[fb] = 5;
        var xb = mb(yb, 9), vb = mb(gb, 5), bb = function(t1) {
            for(var e = t1[0], r = 1; r < t1.length; ++r)t1[r] > e && (e = t1[r]);
            return e;
        }, wb = function(t1, e, r) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8) >> (7 & e) & r;
        }, _b = function(t1, e) {
            var r = e / 8 | 0;
            return (t1[r] | t1[r + 1] << 8 | t1[r + 2] << 16) >> (7 & e);
        }, Ab = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], Mb = function(t1, e, r) {
            var n = new Error(e || Ab[t1]);
            if (n.code = t1, Error.captureStackTrace && Error.captureStackTrace(n, Mb), !r) throw n;
            return n;
        }, Ib = new eb(0), Sb = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            Sb.decode(Ib, {
                stream: !0
            });
        } catch (t1) {}
        const zb = {
            gzip_data: "gzip"
        };
        class kb extends Error {
            constructor(t1){
                super(t1), this.name = "MRTError";
            }
        }
        const Pb = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, Eb = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, Tb = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let Bb;
        class Vb {
            constructor(t1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t1;
            }
            getLayer(t1) {
                const e = this.layers[t1];
                if (!e) throw new kb(`Layer '${t1}' not found`);
                return e;
            }
            getHeaderLength(t1) {
                const e = new Uint8Array(t1), r = new DataView(t1);
                if (13 !== e[0]) throw new kb("File is not a valid MRT.");
                return r.getUint32(1, !0);
            }
            parseHeader(t1) {
                const e = new Uint8Array(t1), r = this.getHeaderLength(t1);
                if (e.length < r) throw new kb(`Expected header with length >= ${r} but got buffer of length ${e.length}`);
                const n = function(t1, e) {
                    return t1.readFields(Gv, {
                        headerLength: 0,
                        x: 0,
                        y: 0,
                        z: 0,
                        layers: []
                    }, void 0);
                }(new Bb(e.subarray(0, r)));
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new kb(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const t1 of n.layers)this.layers[t1.name] = new Cb(t1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(t1) {
                const e = [], r = this.getLayer(t1.layerName);
                for (let n of t1.blockIndices){
                    const i = r.dataIndex[n], s = i.firstByte - t1.firstByte, o = i.lastByte - t1.firstByte;
                    if (r._blocksInProgress.has(n)) continue;
                    const a = {
                        layerName: r.name,
                        firstByte: s,
                        lastByte: o,
                        pixelFormat: r.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            i.bands.length
                        ].concat(r.bandShape),
                        buffer: r.buffer,
                        codec: i.codec.codec,
                        filters: i.filters.map((t1)=>t1.filter)
                    };
                    r._blocksInProgress.add(n), e.push(a);
                }
                return new Fb(e, ()=>{
                    e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex));
                }, (t1, n)=>{
                    if (e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex)), t1) throw t1;
                    n.forEach((t1)=>{
                        this.getLayer(t1.layerName).processDecodedData(t1);
                    });
                });
            }
        }
        class Cb {
            constructor({ version: t1, name: e, units: r, tileSize: n, pixelFormat: i, buffer: s, dataIndex: o }, a){
                if (this.version = t1, 1 !== this.version) throw new kb(`Cannot parse raster layer encoded with MRT version ${t1}`);
                this.name = e, this.units = r, this.tileSize = n, this.buffer = s, this.pixelFormat = Pb[i], this.dataIndex = o, this.bandShape = [
                    n + 2 * s,
                    n + 2 * s,
                    Eb[this.pixelFormat]
                ], this._decodedBlocks = new Ev(a ? a.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return Eb[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: t1 })=>t1).flat();
            }
            processDecodedData(t1) {
                const e = t1.blockIndex.toString();
                this._decodedBlocks.get(e) || this._decodedBlocks.put(e, t1.data);
            }
            getBlockForBand(t1) {
                let e = 0;
                switch(typeof t1){
                    case "string":
                        for (const [r, n] of this.dataIndex.entries()){
                            for (const [i, s] of n.bands.entries())if (s === t1) return {
                                bandIndex: e + i,
                                blockIndex: r,
                                blockBandIndex: i
                            };
                            e += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [r, n] of this.dataIndex.entries()){
                            if (t1 >= e && t1 < e + n.bands.length) return {
                                bandIndex: t1,
                                blockIndex: r,
                                blockBandIndex: t1 - e
                            };
                            e += n.bands.length;
                        }
                        break;
                    default:
                        throw new kb(`Invalid band \`${JSON.stringify(t1)}\`. Expected string or integer.`);
                }
                return {
                    blockIndex: -1,
                    blockBandIndex: -1
                };
            }
            getDataRange(t1) {
                let e = 1 / 0, r = -1 / 0;
                const n = [], i = new Set;
                for (const s of t1){
                    const { blockIndex: t1 } = this.getBlockForBand(s);
                    if (t1 < 0) throw new kb(`Invalid band: ${JSON.stringify(s)}`);
                    const o = this.dataIndex[t1];
                    n.includes(t1) || n.push(t1), i.add(t1), e = Math.min(e, o.firstByte), r = Math.max(r, o.lastByte);
                }
                if (i.size > this.cacheSize) throw new kb(`Number of blocks to decode (${i.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: e,
                    lastByte: r,
                    blockIndices: n
                };
            }
            hasBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0;
            }
            hasDataForBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0 && !!this._decodedBlocks.get(e.toString());
            }
            getBandView(t1) {
                const { blockIndex: e, blockBandIndex: r } = this.getBlockForBand(t1);
                if (e < 0) throw new kb(`Band not found: ${JSON.stringify(t1)}`);
                const n = this._decodedBlocks.get(e.toString());
                if (!n) throw new kb(`Data for band ${JSON.stringify(t1)} of layer "${this.name}" not decoded.`);
                const i = this.dataIndex[e], s = this.bandShape.reduce((t1, e)=>t1 * e, 1), o = r * s, a = n.subarray(o, o + s);
                return {
                    data: a,
                    bytes: new Uint8Array(a.buffer).subarray(a.byteOffset, a.byteOffset + a.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: i.offset,
                    scale: i.scale
                };
            }
        }
        Vb.setPbf = function(t1) {
            Bb = t1;
        };
        class Fb {
            constructor(t1, e, r){
                this.tasks = t1, this._onCancel = e, this._onComplete = r, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(t1, e) {
                this._finalized || (this._onComplete(t1, e), this._finalized = !0);
            }
        }
        function Db(t1, e) {
            const r = t1.json.bufferViews[e.bufferView], n = Jf[e.componentType];
            return new n(t1.buffers[r.buffer], (e.byteOffset || 0) + (r.byteOffset || 0), e.count * (r.byteStride && r.byteStride !== td[e.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : td[e.type]));
        }
        function Lb(t1, e, r, n) {
            const i = Jf[e.componentType], s = function(t1) {
                switch(t1){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(i), o = t1.json.bufferViews[e.bufferView], a = o.byteStride ? o.byteStride / i.BYTES_PER_ELEMENT : td[e.type], l = r.float32, u = l.length / r.capacity;
            for(let t1 = 0, r = 0; t1 < e.count * a; t1 += a, r += u)for(let e = 0; e < u; e++)l[r + e] = n[t1 + e] * s;
            r._trim();
        }
        function Rb(t1, e, r) {
            const n = t1.indices, i = t1.attributes, s = {};
            s.indexArray = new Aa;
            const o = e.json.accessors[n], a = o.count / 3;
            s.indexArray.reserve(a);
            const l = Db(e, o);
            for(let t1 = 0; t1 < a; t1++)s.indexArray.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
            s.indexArray._trim(), s.vertexArray = new ca;
            const u = e.json.accessors[i.POSITION];
            s.vertexArray.reserve(u.count);
            const c = Db(e, u);
            for(let t1 = 0; t1 < u.count; t1++)s.vertexArray.emplaceBack(c[3 * t1], c[3 * t1 + 1], c[3 * t1 + 2]);
            if (s.vertexArray._trim(), s.aabb = new qu(u.min, u.max), s.centroid = function(t1, e) {
                const r = [
                    0,
                    0,
                    0
                ], n = t1.length;
                if (n > 0) {
                    for(let i = 0; i < n; i++){
                        const n = 3 * t1[i];
                        r[0] += e[n], r[1] += e[n + 1], r[2] += e[n + 2];
                    }
                    r[0] /= n, r[1] /= n, r[2] /= n;
                }
                return r;
            }(l, c), void 0 !== i.COLOR_0) {
                const t1 = e.json.accessors[i.COLOR_0], r = td[t1.type], n = Db(e, t1);
                s.colorArray = 3 === r ? new ca : new ya, s.colorArray.resize(t1.count), Lb(e, t1, s.colorArray, n);
            }
            if (void 0 !== i.NORMAL) {
                s.normalArray = new ca;
                const t1 = e.json.accessors[i.NORMAL];
                s.normalArray.resize(t1.count);
                const r = Db(e, t1);
                Lb(e, t1, s.normalArray, r);
            }
            if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
                s.texcoordArray = new Ta;
                const t1 = e.json.accessors[i.TEXCOORD_0];
                s.texcoordArray.resize(t1.count);
                const r = Db(e, t1);
                Lb(e, t1, s.texcoordArray, r);
            }
            if (void 0 !== i._FEATURE_ID_RGBA4444) {
                const t1 = e.json.accessors[i._FEATURE_ID_RGBA4444];
                e.json.extensionsUsed && e.json.extensionsUsed.includes("EXT_meshopt_compression") && (s.featureData = Db(e, t1));
            }
            void 0 !== i._FEATURE_RGBA4444 && (s.featureData = new Uint32Array(Db(e, e.json.accessors[i._FEATURE_RGBA4444]).buffer));
            const h = t1.material;
            return s.material = function(t1, e) {
                const { emissiveFactor: r = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: i = .5, normalTexture: s, occlusionTexture: o, emissiveTexture: a, doubleSided: l } = t1, { baseColorFactor: u = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: c = 1, roughnessFactor: h = 1, baseColorTexture: p, metallicRoughnessTexture: f } = t1.pbrMetallicRoughness || {}, d = o ? e[o.index] : void 0;
                if (o && o.extensions && o.extensions.KHR_texture_transform && d) {
                    const t1 = o.extensions.KHR_texture_transform;
                    d.offsetScale = [
                        t1.offset[0],
                        t1.offset[1],
                        t1.scale[0],
                        t1.scale[1]
                    ];
                }
                return {
                    pbrMetallicRoughness: {
                        baseColorFactor: new sr(...u),
                        metallicFactor: c,
                        roughnessFactor: h,
                        baseColorTexture: p ? e[p.index] : void 0,
                        metallicRoughnessTexture: f ? e[f.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: new sr(...r),
                    alphaMode: n,
                    alphaCutoff: i,
                    normalTexture: s ? e[s.index] : void 0,
                    occlusionTexture: d,
                    emissionTexture: a ? e[a.index] : void 0,
                    defined: void 0 === t1.defined
                };
            }(void 0 !== h ? e.json.materials[h] : {
                defined: !1
            }, r), s;
        }
        function Ob(t1, e, r) {
            const { matrix: n, rotation: i, translation: s, scale: o, mesh: a, extras: l, children: u } = t1, c = {};
            if (c.matrix = n || function(t1, e, r, n) {
                var i = e[0], s = e[1], o = e[2], a = e[3], l = i + i, u = s + s, c = o + o, h = i * l, p = i * u, f = i * c, d = s * u, m = s * c, y = o * c, g = a * l, x = a * u, v = a * c, b = n[0], w = n[1], _ = n[2];
                return t1[0] = (1 - (d + y)) * b, t1[1] = (p + v) * b, t1[2] = (f - x) * b, t1[3] = 0, t1[4] = (p - v) * w, t1[5] = (1 - (h + y)) * w, t1[6] = (m + g) * w, t1[7] = 0, t1[8] = (f + x) * _, t1[9] = (m - g) * _, t1[10] = (1 - (h + d)) * _, t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
            }([], i || [
                0,
                0,
                0,
                1
            ], s || [
                0,
                0,
                0
            ], o || [
                1,
                1,
                1
            ]), void 0 !== a) {
                c.meshes = r[a];
                const t1 = c.anchor = [
                    0,
                    0
                ];
                for (const e of c.meshes){
                    const { min: r, max: n } = e.aabb;
                    t1[0] += r[0] + n[0], t1[1] += r[1] + n[1];
                }
                t1[0] = Math.floor(t1[0] / c.meshes.length / 2), t1[1] = Math.floor(t1[1] / c.meshes.length / 2);
            }
            if (l && (l.id && (c.id = l.id), l.lights && (c.lights = function(t1) {
                if (!t1.length) return [];
                const e = function(t1) {
                    const e = atob(t1), r = new Uint8Array(e.length);
                    for(let t1 = 0; t1 < e.length; t1++)r[t1] = e.codePointAt(t1);
                    return r;
                }(t1), r = [], n = e.length / 24, i = new Uint16Array(e.buffer), s = new Float32Array(e.buffer);
                for(let t1 = 0; t1 < n; t1++){
                    const e = i[2 * t1 * 6] / 30, n = i[2 * t1 * 6 + 1] / 30, o = i[2 * t1 * 6 + 10] / 100, a = s[6 * t1 + 1], l = s[6 * t1 + 2], u = s[6 * t1 + 3], c = s[6 * t1 + 4], h = u - a, p = c - l, f = Math.hypot(h, p);
                    r.push({
                        pos: [
                            a + .5 * h,
                            l + .5 * p,
                            n
                        ],
                        normal: [
                            p / f,
                            -h / f,
                            0
                        ],
                        width: f,
                        height: e,
                        depth: o,
                        points: [
                            a,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return r;
            }(l.lights))), u) {
                const t1 = [];
                for (const n of u)t1.push(Ob(e.json.nodes[n], e, r));
                c.children = t1;
            }
            return c;
        }
        function Ub(t1) {
            if (0 === t1.vertices.length || 0 === t1.indices.length) return null;
            const e = new xp(t1.vertices, t1.indices, 8, 256), [r, n] = [
                e.min.clone(),
                e.max.clone()
            ];
            return {
                vertices: t1.vertices,
                indices: t1.indices,
                grid: e,
                min: r,
                max: n
            };
        }
        function Nb(t1) {
            if (!t1.extras || !t1.extras.ground) return null;
            const e = t1.extras.ground;
            if (!e || !Array.isArray(e) || 0 === e.length) return null;
            const r = e[0];
            if (!r || !Array.isArray(r) || 0 === r.length) return null;
            const n = [];
            for (const t1 of r){
                if (!Array.isArray(t1) || 2 !== t1.length) continue;
                const e = t1[0], r = t1[1];
                "number" == typeof e && "number" == typeof r && n.push(new bt(e, r));
            }
            if (n.length < 3) return null;
            n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
            let i = 0;
            for(let t1 = 0; t1 < n.length; t1++){
                const e = n[t1], r = n[(t1 + 1) % n.length], s = n[(t1 + 2) % n.length];
                i += (e.x - r.x) * (s.y - r.y) - (s.x - r.x) * (e.y - r.y);
            }
            i > 0 && n.reverse();
            const s = Ah(n.flatMap((t1)=>[
                    t1.x,
                    t1.y
                ]), []);
            return 0 === s.length ? null : {
                vertices: n,
                indices: s
            };
        }
        function jb(t1, e) {
            const r = [], n = [];
            let i = 0;
            const s = [];
            for (const o of t1){
                i = r.length;
                const t1 = o.vertexArray.float32, a = o.indexArray.uint16;
                for(let n = 0; n < o.vertexArray.length; n++)s[0] = t1[3 * n + 0], s[1] = t1[3 * n + 1], s[2] = t1[3 * n + 2], R(s, s, e), r.push(new bt(s[0], s[1]));
                for(let t1 = 0; t1 < 3 * o.indexArray.length; t1++)n.push(a[t1] + i);
            }
            if (n.length % 3 != 0) return null;
            for(let t1 = 0; t1 < n.length; t1 += 3){
                const e = r[n[t1 + 0]], i = r[n[t1 + 1]], s = r[n[t1 + 2]];
                (e.x - i.x) * (s.y - i.y) - (s.x - i.x) * (e.y - i.y) > 0 && ([n[t1 + 1], n[t1 + 2]] = [
                    n[t1 + 2],
                    n[t1 + 1]
                ]);
            }
            return {
                vertices: r,
                indices: n
            };
        }
        function $b(t1) {
            const e = function(t1, e) {
                const r = [], n = WebGL2RenderingContext;
                if (t1.json.textures) for (const i of t1.json.textures){
                    const s = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== i.sampler && Object.assign(s, t1.json.samplers[i.sampler]), r.push({
                        image: e[i.source],
                        sampler: s,
                        uploaded: !1
                    });
                }
                return r;
            }(t1, t1.images), r = function(t1, e) {
                const r = [];
                for (const n of t1.json.meshes){
                    const i = [];
                    for (const r of n.primitives)i.push(Rb(r, t1, e));
                    r.push(i);
                }
                return r;
            }(t1, e), { scenes: n, scene: i, nodes: s } = t1.json, o = n ? n[i || 0].nodes : s, a = [];
            for (const e of o)a.push(Ob(s[e], t1, r));
            return function(t1, e, r) {
                const n = {}, i = new Set;
                for(let s = 0; s < t1.length; s++){
                    const t1 = r[e[s]];
                    if (!t1.extras) continue;
                    const o = t1.extras["mapbox:footprint:version"], a = t1.extras["mapbox:footprint:id"];
                    (o || a) && i.add(s), "1.0.0" === o && a && (n[a] = s);
                }
                for(let s = 0; s < t1.length; s++){
                    if (i.has(s)) continue;
                    const o = t1[s], a = r[e[s]];
                    if (!a.extras) continue;
                    let l = null;
                    o.id in n && (l = jb(t1[n[o.id]].meshes, o.matrix)), l || (l = Nb(a)), l && (o.footprint = Ub(l));
                }
                if (i.size > 0) {
                    const e = Array.from(i.values()).sort((t1, e)=>t1 - e);
                    for(let r = e.length - 1; r >= 0; r--)t1.splice(e[r], 1);
                }
            }(a, o, t1.json.nodes), a;
        }
        function Gb(t1) {
            t1.heightmap = new Float32Array(4096), t1.heightmap.fill(-1);
            const e = t1.vertexArray.float32, r = t1.aabb.min[0] - 1, n = t1.aabb.min[1] - 1, i = yx / (t1.aabb.max[0] - r + 2), s = yx / (t1.aabb.max[1] - n + 2);
            for(let o = 0; o < e.length; o += 3){
                const a = e[o + 2], l = (e[o + 0] - r) * i | 0, u = (e[o + 1] - n) * s | 0;
                a > t1.heightmap[u * yx + l] && (t1.heightmap[u * yx + l] = a);
            }
        }
        function qb(t1, e) {
            const r = {};
            r.indexArray = new Aa, r.indexArray.reserve(4 * t1.length), r.vertexArray = new ca, r.vertexArray.reserve(10 * t1.length), r.colorArray = new ya, r.vertexArray.reserve(10 * t1.length);
            let n = 0;
            for (const i of t1){
                const t1 = Math.min(10, Math.max(4, 1.3 * i.height)) * e, s = [
                    -i.normal[1],
                    i.normal[0],
                    0
                ], o = Math.min(.29, .1 * i.width / i.depth), a = i.width - 2 * i.depth * e * (o + .01), l = E([], i.pos, s, a / 2), u = E([], i.pos, s, -a / 2), c = [
                    l[0],
                    l[1],
                    l[2] + i.height
                ], h = [
                    u[0],
                    u[1],
                    u[2] + i.height
                ], p = E([], i.normal, s, o);
                P(p, p, t1);
                const f = E([], i.normal, s, -o);
                P(f, f, t1), M(p, l, p), M(f, u, f), l[2] += .1, u[2] += .1, r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(c[0], c[1], c[2]), r.vertexArray.emplaceBack(h[0], h[1], h[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]);
                const d = a / t1 / 2;
                r.colorArray.emplaceBack(-d - o, -1, d, .8), r.colorArray.emplaceBack(d + o, -1, d, .8), r.colorArray.emplaceBack(-d, 0, d, 1.3), r.colorArray.emplaceBack(d, 0, d, 1.3), r.colorArray.emplaceBack(d + o, -0.8, d, .7), r.colorArray.emplaceBack(d + o, -0.8, d, .7), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(d + o, -1.2, d, .8), r.colorArray.emplaceBack(d + o, -1.2, d, .8), r.indexArray.emplaceBack(6 + n, 4 + n, 8 + n), r.indexArray.emplaceBack(7 + n, 9 + n, 5 + n), r.indexArray.emplaceBack(0 + n, 1 + n, 2 + n), r.indexArray.emplaceBack(1 + n, 3 + n, 2 + n), n += 10;
            }
            const i = {
                defined: !0
            };
            i.emissiveFactor = sr.black;
            const s = {};
            return s.baseColorFactor = sr.white, i.pbrMetallicRoughness = s, r.material = i, r.aabb = new qu([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), r;
        }
        Vb.performDecoding = function(t1, e) {
            const r = new Uint8Array(t1);
            return Promise.all(e.tasks.map((t1)=>{
                const { layerName: e, firstByte: n, lastByte: i, pixelFormat: s, blockShape: o, blockIndex: a, filters: l, codec: u } = t1, c = r.subarray(n, i + 1), h = new Uint32Array(o[0] * o[1] * o[2]);
                let p;
                if ("gzip_data" !== u) throw new kb(`Unhandled codec: ${u}`);
                return p = (function(t1, e) {
                    if (!globalThis.DecompressionStream && "gzip_data" === e) return Promise.resolve(((s = function(t1) {
                        31 == t1[0] && 139 == t1[1] && 8 == t1[2] || Mb(6, "invalid gzip data");
                        var e = t1[3], r = 10;
                        4 & e && (r += 2 + (t1[10] | t1[11] << 8));
                        for(var n = (e >> 3 & 1) + (e >> 4 & 1); n > 0; n -= !t1[r++]);
                        return r + (2 & e);
                    }(i = t1)) + 8 > i.length && Mb(6, "invalid gzip data"), function(t1, e, r, n) {
                        var i = t1.length;
                        if (!i || e.f && !e.l) return r || new eb(0);
                        var s = !r, o = s || 2 != e.i, a = e.i;
                        s && (r = new eb(3 * i));
                        var l, u, c = function(t1) {
                            var e = r.length;
                            if (t1 > e) {
                                var n = new eb(Math.max(2 * e, t1));
                                n.set(r), r = n;
                            }
                        }, h = e.f || 0, p = e.p || 0, f = e.b || 0, d = e.l, m = e.d, y = e.m, g = e.n, x = 8 * i;
                        do {
                            if (!d) {
                                h = wb(t1, p, 1);
                                var v = wb(t1, p + 1, 3);
                                if (p += 3, !v) {
                                    var b = t1[(T = 4 + ((p + 7) / 8 | 0)) - 4] | t1[T - 3] << 8, w = T + b;
                                    if (w > i) {
                                        a && Mb(0);
                                        break;
                                    }
                                    o && c(f + b), r.set(t1.subarray(T, w), f), e.b = f += b, e.p = p = 8 * w, e.f = h;
                                    continue;
                                }
                                if (1 == v) d = xb, m = vb, y = 9, g = 5;
                                else if (2 == v) {
                                    var _ = wb(t1, p, 31) + 257, A = wb(t1, p + 10, 15) + 4, M = _ + wb(t1, p + 5, 31) + 1;
                                    p += 14;
                                    for(var I = new eb(M), S = new eb(19), z = 0; z < A; ++z)S[ob[z]] = wb(t1, p + 3 * z, 7);
                                    p += 3 * A;
                                    var k = bb(S), P = (1 << k) - 1, E = mb(S, k);
                                    for(z = 0; z < M;){
                                        var T, B = E[wb(t1, p, P)];
                                        if (p += 15 & B, (T = B >> 4) < 16) I[z++] = T;
                                        else {
                                            var V = 0, C = 0;
                                            for(16 == T ? (C = 3 + wb(t1, p, 3), p += 2, V = I[z - 1]) : 17 == T ? (C = 3 + wb(t1, p, 7), p += 3) : 18 == T && (C = 11 + wb(t1, p, 127), p += 7); C--;)I[z++] = V;
                                        }
                                    }
                                    var F = I.subarray(0, _), D = I.subarray(_);
                                    y = bb(F), g = bb(D), d = mb(F, y), m = mb(D, g);
                                } else Mb(1);
                                if (p > x) {
                                    a && Mb(0);
                                    break;
                                }
                            }
                            o && c(f + 131072);
                            for(var L = (1 << y) - 1, R = (1 << g) - 1, O = p;; O = p){
                                var U = (V = d[_b(t1, p) & L]) >> 4;
                                if ((p += 15 & V) > x) {
                                    a && Mb(0);
                                    break;
                                }
                                if (V || Mb(2), U < 256) r[f++] = U;
                                else {
                                    if (256 == U) {
                                        O = p, d = null;
                                        break;
                                    }
                                    var N = U - 254;
                                    U > 264 && (N = wb(t1, p, (1 << (G = ib[z = U - 257])) - 1) + ub[z], p += G);
                                    var j = m[_b(t1, p) & R], $ = j >> 4;
                                    if (j || Mb(3), p += 15 & j, D = hb[$], $ > 3) {
                                        var G = sb[$];
                                        D += _b(t1, p) & (1 << G) - 1, p += G;
                                    }
                                    if (p > x) {
                                        a && Mb(0);
                                        break;
                                    }
                                    o && c(f + 131072);
                                    var q = f + N;
                                    if (f < D) {
                                        var H = 0 - D, X = Math.min(D, q);
                                        for(H + f < 0 && Mb(3); f < X; ++f)r[f] = (void 0)[H + f];
                                    }
                                    for(; f < q; ++f)r[f] = r[f - D];
                                }
                            }
                            e.l = d, e.p = O, e.b = f, e.f = h, d && (h = 1, e.m = y, e.d = m, e.n = g);
                        }while (!h);
                        return f != r.length && s ? (l = r, (null == (u = f) || u > l.length) && (u = l.length), new eb(l.subarray(0, u))) : r.subarray(0, f);
                    }(i.subarray(s, -8), {
                        i: 2
                    }, new eb(((r = i)[(n = r.length) - 4] | r[n - 3] << 8 | r[n - 2] << 16 | r[n - 1] << 24) >>> 0))));
                    var r, n, i, s;
                    const o = zb[e];
                    if (!o) throw new Error(`Unhandled codec: ${e}`);
                    const a = new globalThis.DecompressionStream(o);
                    return new Response(new Blob([
                        t1
                    ]).stream().pipeThrough(a)).arrayBuffer().then((t1)=>new Uint8Array(t1));
                })(c, u).then((t1)=>((function(t1, e) {
                        t1.readFields(Yv, e);
                    })(new Bb(t1), h), new Tb[s](h.buffer))), p.then((t1)=>{
                    for(let e = l.length - 1; e >= 0; e--)switch(l[e]){
                        case "delta_filter":
                            Jv(t1, o);
                            break;
                        case "zigzag_filter":
                            Qv(t1);
                            break;
                        case "bitshuffle_filter":
                            tb(t1, s);
                            break;
                        default:
                            throw new kb(`Unhandled filter "${l[e]}"`);
                    }
                    return {
                        layerName: e,
                        blockIndex: a,
                        data: t1
                    };
                }).catch((t1)=>{
                    throw t1;
                });
            }));
        }, qs(Fb, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        }), qs(Vb, "MapboxRasterTile"), qs(Cb, "MapboxRasterLayer", {
            omit: [
                "_blocksInProgress"
            ]
        });
        class Hb {
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                return this._numberToString[t1];
            }
        }
        const Xb = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Zb {
            constructor(t1, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, this._z = e, this._x = r, this._y = n, this.properties = t1.properties, this.id = i;
            }
            clone() {
                const t1 = new Zb(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (t1.state = Object.assign({}, this.state)), this.layer && (t1.layer = Object.assign({}, this.layer)), this.source && (t1.source = this.source), this.sourceLayer && (t1.sourceLayer = this.sourceLayer), t1;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const e of Xb)void 0 !== this[e] && (t1[e] = this[e]);
                return t1;
            }
        }
        class Wb {
            constructor(t1, e){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new $s(Cn, 16, 0), this.featureIndexArray = new Xa, this.promoteId = e, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
            insert(t1, e, r, n, i, s = 0, o = 0) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const l = this.grid;
                for(let t1 = 0; t1 < e.length; t1++){
                    const r = e[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e = r[t1];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    0 !== o && (n[0] -= o, n[1] -= o, n[2] += o, n[3] += o), n[0] < Cn && n[1] < Cn && n[2] >= 0 && n[3] >= 0 && l.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new Pu.VectorTile(new um(this.rawTileData)).layers, this.sourceLayerCoder = new Hb(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const t1 in this.vtLayers)this.vtFeatures[t1] = [];
                }
                return this.vtLayers;
            }
            query(t1, e) {
                const { tilespaceGeometry: r, transform: n, tileTransform: i, pixelPosMatrix: s, availableImages: o, worldview: a } = e;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const l = r.bufferedTilespaceBounds, u = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (t1, e, n, i)=>uc(r.bufferedTilespaceGeometry, t1, e, n, i));
                u.sort(Kb);
                let c = null;
                n.elevation && u.length > 0 && (c = Mx.create(n.elevation, this.tileID));
                const h = {};
                let p;
                for(let e = 0; e < u.length; e++){
                    const l = u[e];
                    if (l === p) continue;
                    p = l;
                    const f = this.featureIndexArray.get(l);
                    let d = null;
                    this.is3DTile ? this.loadMatchingModelFeature(h, f, t1, r, n, a) : this.loadMatchingFeature(h, f, t1, o, a, (t1, e, o, a = 0)=>(d || (d = yu(t1, this.tileID.canonical, i)), e.queryIntersectsFeature(r, t1, o, d, this.z, n, s, c, a)));
                }
                return h;
            }
            loadMatchingFeature(t1, e, r, n, i, s) {
                const { featureIndex: o, bucketIndex: a, sourceLayerIndex: l, layoutVertexArrayOffset: u } = e, c = this.bucketLayerIDs[a], h = r.layers, p = Object.keys(h);
                if (p.length && !jt(p, c)) return;
                const f = r.sourceCache, d = this.sourceLayerCoder.decode(l), m = this.vtLayers[d].feature(o), y = this.getId(m, d);
                for(let e = 0; e < c.length; e++){
                    const r = c[e];
                    if (!h[r]) continue;
                    const { styleLayer: a, targets: l } = h[r];
                    let p = {};
                    void 0 !== y && (p = f.getFeatureState(a.sourceLayer, y));
                    const d = !s || s(m, a, p, u);
                    if (!d) continue;
                    const g = new Zb(m, this.z, this.x, this.y, y);
                    g.tile = this.tileID.canonical, g.state = p;
                    let x = this.serializedLayersCache.get(r);
                    x || (x = a.serialize(), x.id = r, this.serializedLayersCache.set(r, x)), g.source = x.source, g.sourceLayer = x["source-layer"], g.layer = Ct({}, x), g.layer.paint = Yb(x.paint, a.paint, m, p, n), g.layer.layout = Yb(x.layout, a.layout, m, p, n);
                    let v = !1;
                    for (const t1 of l){
                        this.updateFeatureProperties(g, t1);
                        const { filter: e } = t1;
                        if (e) {
                            if (m.properties = g.properties, e.needGeometry) {
                                const t1 = gu(m, !0);
                                if (!e.filter(new go(this.tileID.overscaledZ, {
                                    worldview: i
                                }), t1, this.tileID.canonical)) continue;
                            } else if (!e.filter(new go(this.tileID.overscaledZ, {
                                worldview: i
                            }), m)) continue;
                        }
                        v = !0, t1.targetId && this.addFeatureVariant(g, t1);
                    }
                    v && this.appendToResult(t1, r, o, g, d);
                }
            }
            loadMatchingModelFeature(t1, e, r, n, i, s) {
                const { featureIndex: o, bucketIndex: a } = e, l = this.bucketLayerIDs[a], u = r.layers, c = Object.keys(u);
                if (!c.length || jt(c, l)) for(let e = 0; e < l.length; e++){
                    const a = l[e], { styleLayer: c, targets: h } = u[a];
                    if ("model" !== c.type) continue;
                    const p = n.tile, f = p.getBucket(c);
                    if (!(f && f instanceof Tx)) continue;
                    const d = Dx(f, o, n, i);
                    if (!d) continue;
                    const { z: m, x: y, y: g } = p.tileID.canonical, { feature: x, intersectionZ: v, position: b } = d;
                    let w = {};
                    void 0 !== x.id && (w = r.sourceCache.getFeatureState(c.sourceLayer, x.id));
                    const _ = new Zb({}, m, y, g, x.id);
                    _.tile = this.tileID.canonical, _.state = w, _.properties = x.properties, _.geometry = {
                        type: "Point",
                        coordinates: [
                            b.lng,
                            b.lat
                        ]
                    };
                    let A = this.serializedLayersCache.get(a);
                    A || (A = c.serialize(), A.id = a, this.serializedLayersCache.set(a, A)), _.source = A.source, _.sourceLayer = A["source-layer"], _.layer = Ct({}, A);
                    let M = !1;
                    for (const t1 of h){
                        this.updateFeatureProperties(_, t1);
                        const { filter: e } = t1;
                        if (e) {
                            if (x.properties = _.properties, e.needGeometry) {
                                if (!e.filter(new go(this.tileID.overscaledZ, {
                                    worldview: s
                                }), x, this.tileID.canonical)) continue;
                            } else if (!e.filter(new go(this.tileID.overscaledZ, {
                                worldview: s
                            }), x)) continue;
                        }
                        M = !0, t1.targetId && this.addFeatureVariant(_, t1);
                    }
                    M && this.appendToResult(t1, a, o, _, v);
                }
            }
            updateFeatureProperties(t1, e, r) {
                if (e.properties) {
                    const n = {};
                    for(const i in e.properties){
                        const s = e.properties[i].evaluate({
                            zoom: this.z
                        }, t1._vectorTileFeature, t1.state, t1.tile, r);
                        null != s && (n[i] = s);
                    }
                    t1.properties = n;
                }
            }
            addFeatureVariant(t1, e, r) {
                const n = {
                    target: e.target,
                    namespace: e.namespace,
                    uniqueFeatureID: e.uniqueFeatureID
                };
                e.properties && (n.properties = t1.properties), t1.variants = t1.variants || {}, t1.variants[e.targetId] = t1.variants[e.targetId] || [], t1.variants[e.targetId].push(n);
            }
            appendToResult(t1, e, r, n, i) {
                let s = t1[e];
                void 0 === s && (s = t1[e] = []), s.push({
                    featureIndex: r,
                    feature: n,
                    intersectionZ: i
                });
            }
            lookupSymbolFeatures(t1, e, r, n, i, s) {
                const o = {};
                this.loadVTLayers();
                for (const a of t1)this.loadMatchingFeature(o, {
                    bucketIndex: e,
                    sourceLayerIndex: r,
                    featureIndex: a,
                    layoutVertexArrayOffset: 0
                }, n, i, s);
                return o;
            }
            loadFeature(t1) {
                const { featureIndex: e, sourceLayerIndex: r } = t1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[e]) return i[e];
                const s = this.vtLayers[n].feature(e);
                return i[e] = s, s;
            }
            hasLayer(t1) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e) {
                let r = t1.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[e];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const t1 = Cs(n);
                                if ("success" !== t1.result) {
                                    const e = t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", ");
                                    return void Gt(`Failed to create expression for promoteId: ${e}`);
                                }
                                this.promoteIdExpression = t1.value;
                            }
                            this.promoteIdExpression._evaluator || (this.promoteIdExpression._evaluator = new Kr), r = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, t1);
                        } else r = t1.properties[n];
                    }
                    "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
        }
        function Yb(t1, e, r, n, i) {
            return Ot(t1, (t1, s)=>{
                const o = e instanceof Io ? e.get(s) : null;
                return o && o.evaluate ? o.evaluate(r, n, void 0, i) : o;
            });
        }
        function Kb(t1, e) {
            return e - t1;
        }
        qs(Wb, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const Jb = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class Qb {
            static from(t1) {
                if (!(t1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t1, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Jb[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(t1, 2, 1), [o] = new Uint32Array(t1, 4, 1);
                return new Qb(o, s, i, t1);
            }
            constructor(t1, e = 64, r = Float64Array, n){
                if (isNaN(t1) || t1 < 0) throw new Error(`Unpexpected numItems value: ${t1}.`);
                this.numItems = +t1, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t1 < 65536 ? Uint16Array : Uint32Array;
                const i = Jb.indexOf(this.ArrayType), s = 2 * t1 * this.ArrayType.BYTES_PER_ELEMENT, o = t1 * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - o % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * t1), this._pos = 2 * t1, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + o + a), this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * t1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t1);
            }
            add(t1, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t1, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t1 = this._pos >> 1;
                if (t1 !== this.numItems) throw new Error(`Added ${t1} items when expected ${this.numItems}.`);
                return tw(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t1, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: o } = this, a = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= o) {
                        for(let o = h; o <= c; o++){
                            const a = s[2 * o], u = s[2 * o + 1];
                            a >= t1 && a <= r && u >= e && u <= n && l.push(i[o]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= t1 && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t1 <= f : e <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? r >= f : n >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return l;
            }
            within(t1, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, o = [
                    0,
                    n.length - 1,
                    0
                ], a = [], l = r * r;
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)iw(i[2 * r], i[2 * r + 1], t1, e) <= l && a.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    iw(f, d, t1, e) <= l && a.push(n[p]), (0 === u ? t1 - r <= f : e - r <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? t1 + r >= f : e + r >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return a;
            }
        }
        function tw(t1, e, r, n, i, s) {
            if (i - n <= r) return;
            const o = n + i >> 1;
            ew(t1, e, o, n, i, s), tw(t1, e, r, n, o - 1, 1 - s), tw(t1, e, r, o + 1, i, 1 - s);
        }
        function ew(t1, e, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const o = i - n + 1, a = r - n + 1, l = Math.log(o), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (o - u) / o) * (a - o / 2 < 0 ? -1 : 1);
                    ew(t1, e, r, Math.max(n, Math.floor(r - a * u / o + c)), Math.min(i, Math.floor(r + (o - a) * u / o + c)), s);
                }
                const o = e[2 * r + s];
                let a = n, l = i;
                for(rw(t1, e, n, r), e[2 * i + s] > o && rw(t1, e, n, i); a < l;){
                    for(rw(t1, e, a, l), a++, l--; e[2 * a + s] < o;)a++;
                    for(; e[2 * l + s] > o;)l--;
                }
                e[2 * n + s] === o ? rw(t1, e, n, l) : (l++, rw(t1, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function rw(t1, e, r, n) {
            nw(t1, r, n), nw(e, 2 * r, 2 * n), nw(e, 2 * r + 1, 2 * n + 1);
        }
        function nw(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function iw(t1, e, r, n) {
            const i = t1 - r, s = e - n;
            return i * i + s * s;
        }
        t1.$ = Jr, t1.A = Ye, t1.B = Fr, t1.C = Xo, t1.D = Df, t1.E = tr, t1.F = 2, t1.G = Zm, t1.H = Hm, t1.I = er, t1.J = Xr, t1.K = class extends ux {
        }, t1.L = pr, t1.M = To, t1.N = As, t1.O = bs, t1.P = bt, t1.Q = _s, t1.R = Be, t1.S = Vs, t1.T = Pg, t1.U = Bo, t1.V = ux, t1.W = Ls, t1.X = Cs, t1.Y = pi, t1.Z = di, t1._ = hi, t1.a = function(t1) {
            return ne.API_CDN_URL_REGEX.test(t1);
        }, t1.a$ = Dt, t1.a0 = ir, t1.a1 = Vo, t1.a2 = Ms, t1.a3 = ws, t1.a4 = function(t1) {
            const e = t1.value;
            let r = [];
            if (!e) return r;
            const n = Xr(e);
            return "string" !== n ? (r = r.concat([
                new ux(t1.key, e, `string expected, "${n}" found`)
            ]), r) : (cx(e, !0) || (r = r.concat([
                new ux(t1.key, e, `invalid url "${e}"`)
            ])), r);
        }, t1.a5 = Eo, t1.a6 = bo, t1.a7 = Po, t1.a8 = So, t1.a9 = class {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return Xt(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ur(t1.x, e.x, r),
                    y: ur(t1.y, e.y, r),
                    z: ur(t1.z, e.z, r),
                    azimuthal: ur(t1.azimuthal, e.azimuthal, r),
                    polar: ur(t1.polar, e.polar, r)
                };
            }
        }, t1.aA = Z, t1.aB = Cl, t1.aC = lc, t1.aD = Kl, t1.aE = cu, t1.aF = function(t1, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.aG = Xl, t1.aH = Jl, t1.aI = class {
            constructor(t1){
                this.entries = {}, this.scheduler = t1;
            }
            request(t1, e, r, n) {
                const i = this.entries[t1] = this.entries[t1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [t1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(t1, r);
                    }, e) : n(t1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const t1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        t1(r, n);
                    }, e) : t1(r, n);
                    setTimeout(()=>delete this.entries[t1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((t1)=>t1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[t1]));
                };
            }
        }, t1.aJ = function(t1, e, r) {
            const n = JSON.stringify(t1.request);
            return t1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    t1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: t1.isSymbolTile,
                zoom: t1.tileZoom
            }, (e)=>{
                const n = De(t1.request, (t1, n, i, s)=>{
                    t1 ? e(t1) : n && e(null, {
                        vectorTile: r ? void 0 : new Pu.VectorTile(new um(n)),
                        rawData: n,
                        cacheControl: i,
                        expires: s
                    });
                });
                return ()=>{
                    n.cancel(), e();
                };
            }, e);
        }, t1.aK = function(t1) {
            Me++, Me > xe && (t1.getActor().send("enforceCacheSizeLimit", ge), Me = 0);
        }, t1.aL = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }, t1.aM = _c, t1.aN = Dg, t1.aO = jg, t1.aP = Cg, t1.aQ = function(t1, e) {
            const r = document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e(null, r);
            };
            for(let e = 0; e < t1.length; e++){
                const n = document.createElement("source");
                Le(t1[e]) || (r.crossOrigin = "Anonymous"), n.src = t1[e], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.aR = Eg, t1.aS = function(t1) {
            return fetch(t1).then((t1)=>t1.arrayBuffer()).then((e)=>pd(e, 0, t1));
        }, t1.aT = $b, t1.aU = class {
            constructor(t1, e, r, n){
                this.id = t1, this.position = null != e ? new Hl(e[0], e[1]) : new Hl(0, 0), this.orientation = null != r ? r : [
                    0,
                    0,
                    0
                ], this.nodes = n, this.uploaded = !1, this.aabb = new qu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(t1, e) {
                if (c(t1.matrix, e, t1.matrix), t1.meshes) for (const e of t1.meshes){
                    const r = qu.applyTransformFast(e.aabb, t1.matrix);
                    this.aabb.encapsulate(r);
                }
                if (t1.children) for (const e of t1.children)this._applyTransformations(e, t1.matrix);
            }
            computeBoundsAndApplyParent() {
                const t1 = l([]);
                for (const e of this.nodes)this._applyTransformations(e, t1);
            }
            computeModelMatrix(t1, e, r, n, i, s, o = !1) {
                xx(this.matrix, this, t1.transform, this.position, e, r, n, i, s, o);
            }
            upload(t1) {
                if (!this.uploaded) {
                    for (const e of this.nodes)wx(e, t1);
                    for (const t1 of this.nodes)_x(t1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const t1 of this.nodes)Ax(t1);
            }
        }, t1.aV = Rt, t1.aW = Dy, t1.aX = tu, t1.aY = eu, t1.aZ = ia, t1.a_ = Aa, t1.aa = go, t1.ab = Ds, t1.ac = lu, t1.ad = R, t1.ae = _, t1.af = Tt, t1.ag = Io, t1.ah = Zc, t1.ai = ur, t1.aj = Cn, t1.ak = cr, t1.al = Mt, t1.am = sr, t1.an = class {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return function([t1, e]) {
                    const r = Xt([
                        1,
                        t1,
                        e
                    ]);
                    return {
                        x: r.x,
                        y: r.y,
                        z: r.z
                    };
                }(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ur(t1.x, e.x, r),
                    y: ur(t1.y, e.y, r),
                    z: ur(t1.z, e.z, r)
                };
            }
        }, t1.ao = function(t1, e, r = 0, n = !0) {
            const i = new bt(r, r), s = t1.sub(i), o = e.add(i), a = [
                s,
                new bt(o.x, s.y),
                o,
                new bt(s.x, o.y)
            ];
            return n && a.push(s.clone()), a;
        }, t1.ap = function(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; n++){
                const i = Bt(n - 1, -1, t1.length - 1), s = Bt(n + 1, -1, t1.length - 1), o = t1[n], a = t1[s], l = t1[i].sub(o).unit(), u = a.sub(o).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * e / Math.sin(c / 2));
                r.push(o.add(h));
            }
            return r;
        }, t1.aq = Ly, t1.ar = uc, t1.as = function(t1, e, r = 0) {
            return A(((e.x - r) * t1.scale - t1.x) * Cn, (e.y * t1.scale - t1.y) * Cn, ru(e.z, e.y));
        }, t1.at = j, t1.au = C, t1.av = Ru, t1.aw = Td, t1.ax = function(t1) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t1)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                min: new bt(e, r),
                max: new bt(n, i)
            };
        }, t1.ay = Et, t1.az = c, t1.b = function(t1) {
            return ne.API_FONTS_REGEX.test(t1);
        }, t1.b$ = function(t1, e, r) {
            r *= .5;
            var n = e[0], i = e[1], s = e[2], o = e[3], a = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + i * a, t1[1] = i * l - n * a, t1[2] = s * l + o * a, t1[3] = o * l - s * a, t1;
        }, t1.b0 = Oa, t1.b1 = mg, t1.b2 = function() {
            yo.isLoading() || yo.isLoaded() || "deferred" !== fo() || mo();
        }, t1.b3 = Co, t1.b4 = gu, t1.b5 = Zb, t1.b6 = Wt, t1.b7 = zd, t1.b8 = fp, t1.b9 = yu, t1.bA = function(t1, e) {
            const { x: r, y: n } = t1.point, i = Xc(r, n, t1.worldSize / t1._pixelsPerMercatorPixel, 0, 0);
            return c(i, i, Gc(Cc(e)));
        }, t1.bB = n, t1.bC = function(t1) {
            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1;
        }, t1.bD = function(t1, e) {
            return Math.hypot(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
        }, t1.bE = E, t1.bF = D, t1.bG = F, t1.bH = Lm, t1.bI = mm, t1.bJ = Dm, t1.bK = function(t1, e, r, n, i) {
            const s = 5 * e + 2;
            t1.float32[s + 0] = r, t1.float32[s + 1] = n, t1.float32[s + 2] = i;
        }, t1.bL = hg, t1.bM = Mf, t1.bN = Ku, t1.bO = Jd, t1.bP = Pp, t1.bQ = lx, t1.bR = Rp, t1.bS = Op, t1.bT = Sm, t1.bU = gy, t1.bV = Iy, t1.bW = Qb, t1.bX = Bt, t1.bY = P, t1.bZ = G, t1.b_ = Y, t1.ba = ra, t1.bb = Va, t1.bc = kc, t1.bd = tl, t1.be = Ah, t1.bf = Sg, t1.bg = function(t1, e) {
            const r = Zc(e.zoom);
            if (0 === r) return Cc(t1);
            const n = Rc(t1), i = Oc(n), s = Kl(n.getWest()) * e.worldSize, o = Kl(n.getEast()) * e.worldSize, a = Jl(n.getNorth()) * e.worldSize, l = Jl(n.getSouth()) * e.worldSize, c = [
                s,
                a,
                0
            ], h = [
                o,
                a,
                0
            ], p = [
                s,
                l,
                0
            ], f = [
                o,
                l,
                0
            ], d = u([], e.globeMatrix);
            return R(c, c, d), R(h, h, d), R(p, p, d), R(f, f, d), i[0] = Fc(i[0], p, r), i[1] = Fc(i[1], f, r), i[2] = Fc(i[2], h, r), i[3] = Fc(i[3], c, r), qu.fromPoints(i);
        }, t1.bh = $c, t1.bi = u, t1.bj = Uc, t1.bk = Fc, t1.bl = na, t1.bm = zc, t1.bn = y, t1.bo = h, t1.bp = Vb, t1.bq = um, t1.br = De, t1.bs = function(t1, e) {
            const r = [];
            for(const n in t1)n in e || r.push(n);
            return r;
        }, t1.bt = Vt, t1.bu = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.bv = wt, t1.bw = function(t1) {
            var e = new r(16);
            return e[0] = t1[0], e[1] = t1[1], e[2] = t1[2], e[3] = t1[3], e[4] = t1[4], e[5] = t1[5], e[6] = t1[6], e[7] = t1[7], e[8] = t1[8], e[9] = t1[9], e[10] = t1[10], e[11] = t1[11], e[12] = t1[12], e[13] = t1[13], e[14] = t1[14], e[15] = t1[15], e;
        }, t1.bx = l, t1.by = m, t1.bz = a, t1.c = se, t1.c$ = Of, t1.c0 = K, t1.c1 = Kt, t1.c2 = function(t1, e) {
            return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = e[3], t1;
        }, t1.c3 = x, t1.c4 = function(t1, e, r, n, i) {
            var s, o = 1 / Math.tan(e / 2);
            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (s = 1 / (n - i)), t1[14] = 2 * i * n * s) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.c5 = function(t1, e, r, n, i, s, o) {
            var a = 1 / (e - r), l = 1 / (n - i), u = 1 / (s - o);
            return t1[0] = -2 * a, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e + r) * a, t1[13] = (i + n) * l, t1[14] = (o + s) * u, t1[15] = 1, t1;
        }, t1.c6 = Ql, t1.c7 = function(t1, e, r) {
            t1[4 * e + 0] = r[0], t1[4 * e + 1] = r[1], t1[4 * e + 2] = r[2], t1[4 * e + 3] = r[3];
        }, t1.c8 = cl, t1.c9 = fl, t1.cA = Xg, t1.cB = v, t1.cC = qg, t1.cD = function(t1) {
            const e = qg(t1, !0);
            return n([], [
                e[0],
                e[1],
                e[4],
                e[5]
            ]);
        }, t1.cE = p, t1.cF = Ou, t1.cG = f, t1.cH = function(t1) {
            const { x: e, y: r } = t1.point, { lng: n, lat: i } = t1._center;
            return Xc(e, r, t1.worldSize, n, i);
        }, t1.cI = S, t1.cJ = It, t1.cK = Ac, t1.cL = Fl, t1.cM = function(t1, e, r) {
            let n = 0;
            for(let r = 0; r < 2; ++r){
                const i = 0;
                t1[r] > i && (n += (t1[r] - i) * (t1[r] - i)), e[r] < i && (n += (i - e[r]) * (i - e[r]));
            }
            return n;
        }, t1.cN = function(t1) {
            return t1 * t1 * t1 * t1 * t1;
        }, t1.cO = Yl, t1.cP = 45, t1.cQ = dl, t1.cR = function(t1, e, r) {
            const n = Math.sqrt(t1 * t1 + e * e + r * r), i = n > 0 ? Math.acos(r / n) * At : 0;
            let s = 0 !== t1 || 0 !== e ? Math.atan2(-e, -t1) * At + 90 : 0;
            return s < 0 && (s += 360), [
                n,
                s,
                i
            ];
        }, t1.cS = A, t1.cT = Xt, t1.cU = au, t1.cV = M, t1.cW = qu, t1.cX = I, t1.cY = function(t1) {
            return [
                Math.pow(t1[0], 1 / 2.2),
                Math.pow(t1[1], 1 / 2.2),
                Math.pow(t1[2], 1 / 2.2)
            ];
        }, t1.cZ = cx, t1.c_ = function(t1, e) {
            return t1.readFields(qx, {
                icons: []
            }, e);
        }, t1.ca = hl, t1.cb = pl, t1.cc = gl, t1.cd = Hl, t1.ce = ig, t1.cf = function() {
            var t1 = new r(4);
            return r != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
        }, t1.cg = function(t1, e, r) {
            var n = e[0], i = e[1], s = e[2], o = e[3], a = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + s * a, t1[1] = i * l + o * a, t1[2] = n * -a + s * l, t1[3] = i * -a + o * l, t1;
        }, t1.ch = function(t1, e) {
            return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3];
        }, t1.ci = N, t1.cj = function(t1) {
            return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
        }, t1.ck = it, t1.cl = U, t1.cm = wc, t1.cn = Gu, t1.co = Hg, t1.cp = bc, t1.cq = Lc, t1.cr = function(t1, e, r, n, i, s, o, a, l) {
            if ("globe" === l.name) return Lc(t1, e, new bc(r, n, i), !1);
            const u = Dy({
                z: r,
                x: n,
                y: i
            }, l);
            return new qu([
                (s + u.x / u.scale) * e,
                e * (u.y / u.scale),
                o
            ], [
                (s + u.x2 / u.scale) * e,
                e * (u.y2 / u.scale),
                a
            ]);
        }, t1.cs = function(t1, e, r) {
            return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1[3] = Math.min(e[3], r[3]), t1;
        }, t1.ct = function(t1, e, r) {
            return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1[3] = Math.max(e[3], r[3]), t1;
        }, t1.cu = function(t1) {
            const e = Math.round((t1 + 45 + 360) % 360 / 90) % 4;
            return St[e];
        }, t1.cv = nu, t1.cw = H, t1.cx = Dl, t1.cy = function(t1) {
            const e = l(new Float64Array(16));
            c(e, t1.pixelMatrix, t1.globeMatrix);
            const r = [
                0,
                Ul,
                0
            ], n = [
                0,
                Nl,
                0
            ];
            return R(r, r, e), R(n, n, e), [
                r[0] > 0 && r[0] <= t1.width && r[1] > 0 && r[1] <= t1.height && !Yc(t1, new Hl(t1.center.lat, 90)),
                n[0] > 0 && n[0] <= t1.width && n[1] > 0 && n[1] <= t1.height && !Yc(t1, new Hl(t1.center.lat, -90))
            ];
        }, t1.cz = function(t1, e) {
            const { scale: r } = t1.tileTransform, n = r * Cn / (t1.tileSize * Math.pow(2, e.zoom - t1.tileID.overscaledZ + t1.tileID.canonical.z));
            return function(t1, e, r) {
                var n = e[1], i = e[2], s = e[3], o = r[0], a = r[1];
                return t1[0] = e[0] * o, t1[1] = n * o, t1[2] = i * a, t1[3] = s * a, t1;
            }(new Float32Array(4), e.inverseAdjustmentMatrix, [
                n,
                n
            ]);
        }, t1.d = function(t1) {
            return ne.API_TILEJSON_REGEX.test(t1);
        }, t1.d$ = Da, t1.d0 = ry, t1.d1 = ey, t1.d2 = Ce, t1.d3 = co, t1.d4 = me, t1.d5 = We, t1.d6 = Nt, t1.d7 = function(t1) {
            const e = t1.indexOf(Ho);
            return e >= 0 ? t1.slice(0, e) : t1;
        }, t1.d8 = function(t1) {
            return t1.indexOf(Ho) >= 0;
        }, t1.d9 = function(t1) {
            const e = t1.lastIndexOf(Ho);
            return e >= 0 ? t1.slice(e + 1) : "";
        }, t1.dA = Hc, t1.dB = te, t1.dC = ee, t1.dD = 256, t1.dE = function(t1, e) {
            const r = [
                0,
                0,
                0
            ];
            return R(r, r, $c(Cc(e.canonical))), R(r, r, t1), r;
        }, t1.dF = (t1)=>({
                u_matrix: new gl(t1),
                u_texsize: new pl(t1),
                u_pixels_to_tile_units: new bl(t1),
                u_device_pixel_ratio: new hl(t1),
                u_width_scale: new hl(t1),
                u_floor_width_scale: new hl(t1),
                u_image: new cl(t1),
                u_units_to_pixels: new pl(t1),
                u_tile_units_to_pixels: new hl(t1),
                u_alpha_discard_threshold: new hl(t1),
                u_trim_offset: new pl(t1),
                u_trim_fade_range: new pl(t1),
                u_trim_color: new dl(t1),
                u_emissive_strength: new hl(t1),
                u_zbias_factor: new hl(t1),
                u_tile_to_meter: new hl(t1),
                u_ground_shadow_factor: new fl(t1),
                u_pattern_transition: new hl(t1)
            }), t1.dG = (t1)=>({
                u_matrix: new gl(t1),
                u_pixels_to_tile_units: new bl(t1),
                u_device_pixel_ratio: new hl(t1),
                u_width_scale: new hl(t1),
                u_floor_width_scale: new hl(t1),
                u_units_to_pixels: new pl(t1),
                u_dash_image: new cl(t1),
                u_gradient_image: new cl(t1),
                u_image_height: new hl(t1),
                u_texsize: new pl(t1),
                u_tile_units_to_pixels: new hl(t1),
                u_alpha_discard_threshold: new hl(t1),
                u_trim_offset: new pl(t1),
                u_trim_fade_range: new pl(t1),
                u_trim_color: new dl(t1),
                u_emissive_strength: new hl(t1),
                u_zbias_factor: new hl(t1),
                u_tile_to_meter: new hl(t1),
                u_ground_shadow_factor: new fl(t1)
            }), t1.dH = (t1)=>({
                u_camera_to_center_distance: new hl(t1),
                u_extrude_scale: new bl(t1),
                u_device_pixel_ratio: new hl(t1),
                u_matrix: new gl(t1),
                u_inv_rot_matrix: new gl(t1),
                u_merc_center: new pl(t1),
                u_tile_id: new fl(t1),
                u_zoom_transition: new hl(t1),
                u_up_dir: new fl(t1),
                u_emissive_strength: new hl(t1)
            }), t1.dI = wa, t1.dJ = Kd, t1.dK = eh, t1.dL = (t1, e, r, n, i, s)=>{
            const o = t1.transform, a = "globe" === o.projection.name;
            let l;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                if (a) {
                    const t1 = Hc(o.zoom, e.canonical) * o._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        t1,
                        0,
                        0,
                        t1
                    ]);
                } else l = o.calculatePixelsToTileUnitsMatrix(r);
            } else l = new Float32Array([
                o.pixelsToGLUnits[0],
                0,
                0,
                o.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: t1.transform.getCameraToCenterDistance(o.projection),
                u_matrix: t1.translatePosMatrix(e.projMatrix, r, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: fe.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: th,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: s.paint.get("circle-emissive-strength")
            };
            if (a) {
                u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [
                    e.canonical.x,
                    e.canonical.y,
                    1 << e.canonical.z
                ], u.u_zoom_transition = Zc(o.zoom);
                const t1 = i[0] * Cn, r = i[1] * Cn;
                u.u_up_dir = o.projection.upVector(new bc(0, 0, 0), t1, r);
            }
            return u;
        }, t1.dM = Fd, t1.dN = Dr, t1.dO = (t1, e, r, n, i, s, o, a, l, u)=>{
            const c = t1.transform, h = c.pitch < 15 ? Bd(.07, .7, Et((14 - c.zoom) / 5, 0, 1)) : .07, p = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: Cd(t1, e, r, n),
                u_texsize: e.imageAtlasTexture ? e.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: c.calculatePixelsToTileUnitsMatrix(e),
                u_device_pixel_ratio: i,
                u_width_scale: s,
                u_floor_width_scale: o,
                u_image: 0,
                u_tile_units_to_pixels: Vd(e, c),
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: a,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(p ? null : r.lut).toArray01(),
                u_emissive_strength: r.paint.get("line-emissive-strength"),
                u_zbias_factor: h,
                u_tile_to_meter: au(e.tileID.canonical, 0),
                u_ground_shadow_factor: l,
                u_pattern_transition: u
            };
        }, t1.dP = (t1, e, r, n, i, s, o, a, l, u)=>{
            const c = t1.transform, h = c.calculatePixelsToTileUnitsMatrix(e), p = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default"), f = c.pitch < 15 ? Bd(.07, .7, Et((14 - c.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: Cd(t1, e, r, n),
                u_pixels_to_tile_units: h,
                u_device_pixel_ratio: s,
                u_width_scale: o,
                u_floor_width_scale: a,
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: i,
                u_texsize: Dd(r) && e.lineAtlasTexture ? e.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Vd(e, t1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(p ? null : r.lut).toArray01(),
                u_emissive_strength: r.paint.get("line-emissive-strength"),
                u_zbias_factor: f,
                u_tile_to_meter: au(e.tileID.canonical, 0),
                u_ground_shadow_factor: u
            };
        }, t1.dQ = Lt, t1.dR = xh, t1.dS = ru, t1.dT = Mc, t1.dU = af, t1.dV = mf, t1.dW = Zp, t1.dX = 450, t1.dY = 7, t1.dZ = Fg, t1.d_ = ta, t1.da = function(t1) {
            const e = [], r = t1.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t1.db = function(t1, e, r, n) {
            return "custom" === t1.type ? new $g(t1, e) : new Lx[t1.type](t1, e, r, n);
        }, t1.dc = Ut, t1.dd = function(t1) {
            const e = t1.indexOf(Ho);
            return e >= 0 ? t1.slice(e + 1) : "";
        }, t1.de = class extends Zb {
            constructor(t1, e){
                super(t1._vectorTileFeature, t1._z, t1._x, t1._y, t1.id), t1.state && (this.state = Object.assign({}, t1.state)), this.target = e.target, this.namespace = e.namespace, e.properties && (this.properties = e.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = t1.source, this.sourceLayer = t1.sourceLayer, this.layer = t1.layer);
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.target = this.target, t1.namespace = this.namespace, t1;
            }
        }, t1.df = po, t1.dg = Fe, t1.dh = function(t1) {
            return t1({
                pluginStatus: lo,
                pluginURL: uo
            }), po.on("pluginStateChange", t1), t1;
        }, t1.di = ml, t1.dj = class extends ul {
            constructor(t1){
                super(t1), this.current = xl;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 9; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, t1.dk = zt, t1.dl = function(t1, e, r) {
            const n = Zc(r.zoom), i = t1.style.map._antialias, s = t1.terrain && t1.terrain.exaggeration() > 0;
            return 0 === n && !i && !s;
        }, t1.dm = function(t1) {
            const e = t1.pixelsPerMeter, r = e / Ql(1, t1.center.lat), n = l(new Float64Array(16));
            return h(n, n, [
                t1.point.x,
                t1.point.y,
                0
            ]), p(n, n, [
                r,
                r,
                e
            ]), Float32Array.from(n);
        }, t1.dn = Rc, t1.dp = function(t1) {
            const e = nu - 5;
            t1 = Et(t1, -80.051129, e) / e * 90;
            const r = Math.pow(Math.abs(Math.sin(Mt(t1))), 3);
            return Math.round(r * (Ol.length - 1));
        }, t1.dq = function(t1, e, r, n) {
            const i = e.getNorth(), s = e.getSouth(), a = e.getWest(), l = e.getEast(), u = 1 << t1.z, c = l - a, h = i - s, p = c / Rl, f = -h / Ol[r], d = [
                0,
                p,
                0,
                f,
                0,
                0,
                i,
                a,
                0
            ];
            if (t1.z > 0) {
                const t1 = 180 / n;
                o(d, d, [
                    t1 / c + 1,
                    0,
                    0,
                    0,
                    t1 / h + 1,
                    0,
                    -0.5 * t1 / p,
                    .5 * t1 / f,
                    1
                ]);
            }
            return d[2] = u, d[5] = t1.x, d[8] = t1.y, d;
        }, t1.dr = Cc, t1.ds = function(t1, e, r) {
            const n = l(new Float64Array(16)), i = (e / (1 << t1) - .5) * Math.PI * 2;
            return d(n, r.globeMatrix, i), Float32Array.from(n);
        }, t1.dt = class {
            isDataAvailableAtPoint(t1) {
                const e = this._source();
                if (this.isUsingMockSource() || !e || t1.y < 0 || t1.y > 1) return !1;
                const r = e.getSource().maxzoom, n = 1 << r, i = Math.floor(t1.x), s = Math.floor((t1.x - i) * n), o = Math.floor(t1.y * n), a = this.findDEMTileFor(new _c(r, i, r, s, o));
                return !(!a || !a.dem);
            }
            getAtPointOrZero(t1, e = 0) {
                return this.getAtPoint(t1, e) || 0;
            }
            getAtPoint(t1, e, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == e && (e = null);
                const n = this._source();
                if (!n) return e;
                if (t1.y < 0 || t1.y > 1) return e;
                const i = n.getSource().maxzoom, s = 1 << i, o = Math.floor(t1.x), a = t1.x - o, l = new _c(i, o, i, Math.floor(a * s), Math.floor(t1.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return e;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (a * h - u.tileID.canonical.x) * c.dim, f = (t1.y * h - u.tileID.canonical.y) * c.dim, d = Math.floor(p), m = Math.floor(f);
                return (r ? this.exaggeration() : 1) * ur(ur(c.get(d, m), c.get(d, m + 1), f - m), ur(c.get(d + 1, m), c.get(d + 1, m + 1), f - m), p - d);
            }
            getAtTileOffset(t1, e, r) {
                const n = 1 << t1.canonical.z;
                return this.getAtPointOrZero(new lu(t1.wrap + (t1.canonical.x + e / Cn) / n, (t1.canonical.y + r / Cn) / n));
            }
            getAtTileOffsetFunc(t1, e, r, n) {
                return (i)=>{
                    const s = this.getAtTileOffset(t1, i.x, i.y), o = n.upVector(t1.canonical, i.x, i.y);
                    return P(o, o, s * n.upVectorScale(t1.canonical, e, r).metersToTile), o;
                };
            }
            getForTilePoints(t1, e, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = Mx.create(this, t1, n);
                return !!i && (e.forEach((t1)=>{
                    t1[2] = this.exaggeration() * i.getElevationAt(t1[0], t1[1], r);
                }), !0);
            }
            getMinMaxForTile(t1) {
                if (this.isUsingMockSource()) return null;
                const e = this.findDEMTileFor(t1);
                if (!e || !e.dem) return null;
                const r = e.dem.tree, n = e.tileID, i = 1 << t1.canonical.z - n.canonical.z;
                let s = t1.canonical.x / i - n.canonical.x, o = t1.canonical.y / i - n.canonical.y, a = 0;
                for(let e = 0; e < t1.canonical.z - n.canonical.z && !r.leaves[a]; e++){
                    s *= 2, o *= 2;
                    const t1 = 2 * Math.floor(o) + Math.floor(s);
                    a = r.childOffsets[a] + t1, s %= 1, o %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[a],
                    max: this.exaggeration() * r.maximums[a]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(t1, e, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const t1 = this.visibleDemTiles;
                if (0 === t1.length) return null;
                let e = !1, r = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const i of t1){
                    const t1 = this.getMinMaxForTile(i.tileID);
                    t1 && (r = Math.min(r, t1.min), n = Math.max(n, t1.max), e = !0);
                }
                return e ? {
                    min: r,
                    max: n
                } : null;
            }
        }, t1.du = gh, t1.dv = Pc, t1.dw = function(t1, e) {
            return [
                Math.pow(t1[0], 2.2) * e,
                Math.pow(t1[1], 2.2) * e,
                Math.pow(t1[2], 2.2) * e
            ];
        }, t1.dx = i, t1.dy = function(t1, e) {
            var r = Math.sin(e), n = Math.cos(e);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.dz = O, t1.e = ne, t1.e$ = Hb, t1.e0 = 256, t1.e1 = Gc, t1.e2 = ca, t1.e3 = d, t1.e4 = function(t1, e) {
            return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[4], t1[4] = e[5], t1[5] = e[6], t1[6] = e[8], t1[7] = e[9], t1[8] = e[10], t1;
        }, t1.e5 = za, t1.e6 = ka, t1.e7 = cs, t1.e8 = function(t1, e, r, n, i) {
            return Et((t1 - e) / (r - e) * (i - n) + n, n, i);
        }, t1.e9 = J, t1.eA = function(t1, e, r) {
            return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1[2] = e[2] / r[2], t1;
        }, t1.eB = $, t1.eC = $l, t1.eD = B, t1.eE = function(t1, e, r, n) {
            return t1[0] = e, t1[1] = r, t1[2] = n, t1;
        }, t1.eF = function([t1, e, r]) {
            const n = Math.hypot(t1, e, r), i = Math.atan2(t1, r), s = .5 * Math.PI - Math.acos(-e / n);
            return new Hl(It(i), It(s));
        }, t1.eG = X, t1.eH = Wg, t1.eI = function(t1) {
            const e = t1.navigator ? t1.navigator.userAgent : null;
            return !!function(t1) {
                if (null == Yt) {
                    const e = t1.navigator ? t1.navigator.userAgent : null;
                    Yt = !!t1.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
                }
                return Yt;
            }(t1) && !(!e || !(e.match("Version/15.4") || e.match("Version/15.5") || e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/)));
        }, t1.eJ = function(t1, e) {
            ge = t1, xe = e;
        }, t1.eK = Yc, t1.eL = Wc, t1.eM = function(t1) {
            const e = [
                0,
                0,
                0
            ], r = l(new Float64Array(16));
            return c(r, t1.pixelMatrix, t1.globeMatrix), R(e, e, r), new bt(e[0], e[1]);
        }, t1.eN = function() {
            const t1 = Lf;
            t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Cf), Lf = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, t1.eO = function() {
            Of().acquire(Cf);
        }, t1.eP = fo, t1.eQ = function(t1, e, r = !1) {
            if (lo === oo.deferred || lo === oo.loading || lo === oo.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            uo = fe.resolveURL(t1), lo = oo.deferred, ao = e, ho(), r || mo();
        }, t1.eR = function(t1) {
            Gf = fe.resolveURL(t1), Hf || (Hf = new Df(Of(), new tr)), Hf.broadcast("setMeshoptUrl", Gf);
        }, t1.eS = Kf, t1.eT = function(t1) {
            jf = fe.resolveURL(t1), Hf || (Hf = new Df(Of(), new tr)), Hf.broadcast("setDracoUrl", jf);
        }, t1.eU = Yf, t1.eV = Vf, t1.eW = function(t1) {
            const e = _e();
            if (!e) return;
            const r = e.delete(ye);
            t1 && r.then(()=>t1()).catch(t1);
        }, t1.eX = Ff, t1.eY = qs, t1.eZ = mh, t1.e_ = ty, t1.ea = function(t1, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], o = e[4], a = e[5], l = e[6], u = e[7], c = e[8], h = c * o - a * u, p = -c * s + a * l, f = u * s - o * l, d = r * h + n * p + i * f;
            return d ? (t1[0] = h * (d = 1 / d), t1[1] = (-c * n + i * u) * d, t1[2] = (a * n - i * o) * d, t1[3] = p * d, t1[4] = (c * r - i * l) * d, t1[5] = (-a * r + i * s) * d, t1[6] = f * d, t1[7] = (-u * r + n * l) * d, t1[8] = (o * r - n * s) * d, t1) : null;
        }, t1.eb = V, t1.ec = su, t1.ed = Qg, t1.ee = function(t1, e) {
            if (t1 === e) {
                var r = e[1], n = e[2], i = e[3], s = e[6], o = e[7], a = e[11];
                t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = r, t1[6] = e[9], t1[7] = e[13], t1[8] = n, t1[9] = s, t1[11] = e[14], t1[12] = i, t1[13] = o, t1[14] = a;
            } else t1[0] = e[0], t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = e[1], t1[5] = e[5], t1[6] = e[9], t1[7] = e[13], t1[8] = e[2], t1[9] = e[6], t1[10] = e[10], t1[11] = e[14], t1[12] = e[3], t1[13] = e[7], t1[14] = e[11], t1[15] = e[15];
            return t1;
        }, t1.ef = b, t1.eg = [
            1,
            1,
            1
        ], t1.eh = class {
            constructor(t1, e, r, n){
                this.context = t1, this.format = n, this.size = r, this.texture = t1.gl.createTexture();
                const [i, s, o] = this.size, { gl: a } = t1;
                a.bindTexture(a.TEXTURE_3D, this.texture), t1.pixelStoreUnpackFlipY.set(!1), t1.pixelStoreUnpack.set(1), t1.pixelStoreUnpackPremultiplyAlpha.set(!1), a.texImage3D(a.TEXTURE_3D, 0, this.format, i, s, o, 0, zg(this.format), kg(this.format), e.data);
            }
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_3D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }, t1.ei = Mx, t1.ej = function(t1, e, n, i) {
            var s = new r(4);
            return s[0] = t1, s[1] = e, s[2] = n, s[3] = i, s;
        }, t1.ek = q, t1.el = function(t1, e, r, n) {
            var i = e[0], s = e[1], o = e[2], a = e[3];
            return t1[0] = i + n * (r[0] - i), t1[1] = s + n * (r[1] - s), t1[2] = o + n * (r[2] - o), t1[3] = a + n * (r[3] - a), t1;
        }, t1.em = gx, t1.en = xa, t1.eo = Ta, t1.ep = function(t1, e, n, i, s, o, a, l, u, c, h, p, f, d, m, y) {
            var g = new r(16);
            return g[0] = t1, g[1] = e, g[2] = n, g[3] = i, g[4] = s, g[5] = o, g[6] = a, g[7] = l, g[8] = u, g[9] = c, g[10] = h, g[11] = p, g[12] = f, g[13] = d, g[14] = m, g[15] = y, g;
        }, t1.eq = Gl, t1.er = Ea, t1.es = Pa, t1.et = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new bt(1 / 0, 1 / 0),
                    max: new bt(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(t1, e = !1) {
                const r = Cp(new bt(0, 0), new bt(Cn, Cn), t1), n = [];
                if (e && !Bp(r, this._globalClipBounds)) return n;
                for (const e of this._activeRegions){
                    if (e.hiddenByOverlap) continue;
                    if (!Bp(r, e)) continue;
                    const i = Fp(e.min, e.max, t1);
                    n.push({
                        min: i.min,
                        max: i.max,
                        sourceId: this._sourceIds[e.priority],
                        footprint: e.footprint,
                        footprintTileId: e.tileId,
                        order: e.order,
                        clipMask: e.clipMask,
                        clipScope: e.clipScope
                    });
                }
                return n;
            }
            setSources(t1) {
                this._setSources(t1.map((t1)=>({
                        getSourceId: ()=>t1.cache.id,
                        getFootprints: ()=>{
                            const e = [];
                            for (const r of t1.cache.getVisibleCoordinates()){
                                const n = t1.cache.getTile(r).buckets[t1.layer];
                                n && n.updateFootprints(r.toUnwrapped(), e);
                            }
                            return e;
                        },
                        getOrder: ()=>t1.order,
                        getClipMask: ()=>t1.clipMask,
                        getClipScope: ()=>t1.clipScope
                    })));
            }
            _addSource(t1) {
                const e = t1.getFootprints();
                if (0 === e.length) return;
                const r = t1.getOrder(), n = t1.getClipMask(), i = t1.getClipScope();
                for (const t1 of e){
                    if (!t1.footprint) continue;
                    const e = Cp(t1.footprint.min, t1.footprint.max, t1.id);
                    this._activeRegions.push({
                        min: e.min,
                        max: e.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: t1.id,
                        footprint: t1.footprint,
                        order: r,
                        clipMask: n,
                        clipScope: i
                    });
                }
                this._sourceIds.push(t1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((t1, e)=>t1.priority - e.priority || Ep(t1.min, e.min) || Ep(t1.max, e.max) || t1.order - e.order || t1.clipMask - e.clipMask || function(t1, e) {
                        const r = (t1, e)=>t1 + e;
                        return t1.length - e.length || t1.reduce(r, "").localeCompare(e.reduce(r, ""));
                    }(t1.clipScope, e.clipScope));
                let t1 = this._activeRegions.length !== this._prevRegions.length;
                if (!t1) {
                    let e = 0;
                    for(; !t1 && e !== this._activeRegions.length;){
                        const r = this._activeRegions[e], n = this._prevRegions[e];
                        t1 = r.priority !== n.priority || !Tp(r, n) || r.order !== n.order || r.clipMask !== n.clipMask || !wt(r.clipScope, n.clipScope), ++e;
                    }
                }
                if (t1) {
                    ++this._updateTime;
                    for (const t1 of this._activeRegions)t1.order !== kp && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t1.max.y));
                    const t1 = (t1)=>{
                        const e = this._activeRegions;
                        if (t1 >= e.length) return t1;
                        const r = e[t1].priority;
                        for(; t1 < e.length && e[t1].priority === r;)++t1;
                        return t1;
                    };
                    if (this._sourceIds.length > 1) {
                        let e = 0, r = t1(e);
                        for(; e !== r;){
                            let n = e;
                            const i = e;
                            for(; n !== r;){
                                const t1 = this._activeRegions[n];
                                t1.hiddenByOverlap = !1;
                                for(let e = 0; e < i; e++){
                                    const r = this._activeRegions[e];
                                    if (!r.hiddenByOverlap && t1.order === kp && Bp(t1, r) && (t1.hiddenByOverlap = Lp(t1.footprint, t1.tileId, r.footprint, r.tileId), t1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            e = r, r = t1(e);
                        }
                    }
                }
            }
            _setSources(t1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let e = t1.length - 1; e >= 0; e--)this._addSource(t1[e]);
                this._computeReplacement();
            }
        }, t1.eu = kp, t1.ev = class {
            constructor(t1){
                this._createGrid(t1), this._createPoles(t1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const t1 of this._poleSegments)t1.destroy();
                for (const t1 of this._gridSegments)t1.withSkirts.destroy(), t1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(t1, e) {
                const r = new ra, n = new Aa, i = [], s = t1 + 1 + 2, o = e[0] + 1, a = e[0] + 1 + (1 + e.length), l = (t1, e, r)=>{
                    let n = t1 === s - 1 ? t1 - 2 : 0 === t1 ? t1 : t1 - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        e
                    ];
                };
                for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, 0, !0));
                for(let t1 = 0; t1 < o; ++t1)for(let e = 0; e < s; ++e)r.emplaceBack(...l(e, t1, (0 === e || e === s - 1) && !0));
                for(let t1 = 0; t1 < e.length; ++t1){
                    const n = e[t1];
                    for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, n, !0));
                }
                for(let t1 = 0; t1 < e.length; ++t1){
                    const o = n.length, l = e[t1] + 1 + 2, u = new Aa;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, o = i ? s * (a - e.length + t1 - r) : s;
                        for(let t1 = 0; t1 < s - 1; t1++){
                            const e = r * s + t1;
                            0 === r || i || 0 === t1 || t1 === s - 2 ? (u.emplaceBack(e + 1, e, e + o), u.emplaceBack(e + o, e + o + 1, e + 1)) : (n.emplaceBack(e + 1, e, e + o), n.emplaceBack(e + o, e + o + 1, e + 1));
                        }
                    }
                    const c = tl.simpleSegment(0, o, r.length, n.length - o);
                    for(let t1 = 0; t1 < u.uint16.length; t1 += 3)n.emplaceBack(u.uint16[t1], u.uint16[t1 + 1], u.uint16[t1 + 2]);
                    const h = tl.simpleSegment(0, o, r.length, n.length - o);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(t1) {
                const e = this._fillGridMeshWithLods(Rl, Ol);
                this._gridSegments = e.segments, this._gridBuffer = t1.createVertexBuffer(e.vertices, kc.members), this._gridIndexBuffer = t1.createIndexBuffer(e.indices, !0);
            }
            _createPoles(t1) {
                const e = new Aa;
                for(let t1 = 0; t1 <= Rl; t1++)e.emplaceBack(0, t1 + 1, t1 + 2);
                this._poleIndexBuffer = t1.createIndexBuffer(e, !0);
                const r = new za, n = new za, i = new za, s = new za;
                this._poleSegments = [];
                for(let t1 = 0, e = 0; t1 < Fl; t1++){
                    const o = 360 / (1 << t1);
                    r.emplaceBack(0, -Cl, 0, .5, 0), n.emplaceBack(0, -Cl, 0, .5, 1), i.emplaceBack(0, -Cl, 0, .5, .5), s.emplaceBack(0, -Cl, 0, .5, .5);
                    for(let t1 = 0; t1 <= Rl; t1++){
                        let e = t1 / Rl, a = 0;
                        const l = ur(0, o, e), [u, c, h] = jl(Jc, Qc, l, Cl);
                        r.emplaceBack(u, c, h, e, a), n.emplaceBack(u, c, h, e, 1 - a);
                        const p = Mt(l);
                        e = .5 + .5 * Math.sin(p), a = .5 + .5 * Math.cos(p), i.emplaceBack(u, c, h, e, a), s.emplaceBack(u, c, h, e, 1 - a);
                    }
                    this._poleSegments.push(tl.simpleSegment(e, 0, 66, 64)), e += 66;
                }
                this._poleNorthVertexBuffer = t1.createVertexBuffer(r, Sc, !1), this._poleSouthVertexBuffer = t1.createVertexBuffer(n, Sc, !1), this._texturedPoleNorthVertexBuffer = t1.createVertexBuffer(i, Sc, !1), this._texturedPoleSouthVertexBuffer = t1.createVertexBuffer(s, Sc, !1);
            }
            getGridBuffers(t1, e) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    e ? this._gridSegments[t1].withSkirts : this._gridSegments[t1].withoutSkirts
                ];
            }
            getPoleBuffers(t1, e) {
                return [
                    e ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    e ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[t1]
                ];
            }
        }, t1.ew = kt, t1.ex = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t1.ey = Pt, t1.ez = ou, t1.f = function(t1) {
            return btoa(encodeURIComponent(t1).replace(/%([0-9A-F]{2})/g, (t1, e)=>String.fromCharCode(Number("0x" + e))));
        }, t1.f0 = Wb, t1.f1 = Ad, t1.f2 = Eu, t1.f3 = "hd_road_elevation", t1.f4 = Zu, t1.f5 = Ot, t1.f6 = ep, t1.f7 = Wm, t1.f8 = Xm, t1.f9 = function(t1, e, r, n, i, s, o, a = 1, l, u, c) {
            t1.createArrays(), t1.tilePixelRatio = Cn / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const h = t1.layers[0].layout, p = t1.layers[0]._unevaluatedLayout._values, f = {};
            f.scaleFactor = a, f.textSizeScaleRange = h.get("text-size-scale-range"), f.iconSizeScaleRange = h.get("icon-size-scale-range");
            const [d, m] = f.textSizeScaleRange, [y, g] = f.iconSizeScaleRange;
            f.textScaleFactor = Et(f.scaleFactor, d, m), f.iconScaleFactor = Et(f.scaleFactor, y, g);
            const x = p["text-size"], v = p["icon-size"];
            if ("composite" === t1.textSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.textSizeData;
                f.compositeTextSizes = [
                    x.possiblyEvaluate(new go(e, {
                        worldview: c
                    }), s),
                    x.possiblyEvaluate(new go(r, {
                        worldview: c
                    }), s)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.iconSizeData;
                f.compositeIconSizes = [
                    v.possiblyEvaluate(new go(e, {
                        worldview: c
                    }), s),
                    v.possiblyEvaluate(new go(r, {
                        worldview: c
                    }), s)
                ];
            }
            f.layoutTextSize = x.possiblyEvaluate(new go(o + 1, {
                worldview: c
            }), s), f.layoutIconSize = v.possiblyEvaluate(new go(o + 1, {
                worldview: c
            }), s), f.textMaxSize = x.possiblyEvaluate(new go(18, {
                worldview: c
            }), s);
            const b = h.get("symbol-placement"), w = "map" === h.get("text-rotation-alignment") && "point" !== b, _ = h.get("text-size");
            let A = !1;
            const M = [];
            for (const o of t1.features){
                const a = h.get("text-font").evaluate(o, {}, s).join(","), d = _.evaluate(o, {}, s) * f.textScaleFactor, m = f.layoutTextSize.evaluate(o, {}, s) * f.textScaleFactor, y = f.layoutIconSize.evaluate(o, {}, s) * f.iconScaleFactor, g = {
                    horizontal: {},
                    vertical: void 0
                }, x = o.text;
                let v, I = [
                    0,
                    0
                ];
                if (x) {
                    const n = x.toString(), u = h.get("text-letter-spacing").evaluate(o, {}, s) * Jd, c = h.get("text-line-height").evaluate(o, {}, s) * Jd, p = Js(n) ? u : 0, f = h.get("text-anchor").evaluate(o, {}, s), y = h.get("text-variable-anchor");
                    if (!y) {
                        const t1 = h.get("text-radial-offset").evaluate(o, {}, s);
                        if (t1) I = gy(f, [
                            t1 * Jd,
                            my
                        ]);
                        else {
                            const t1 = h.get("text-offset").evaluate(o, {}, s);
                            I = [
                                t1[0] * Jd,
                                t1[1] * Jd
                            ];
                        }
                    }
                    let v = w ? "center" : h.get("text-justify").evaluate(o, {}, s);
                    const _ = "point" === b, A = _ ? h.get("text-max-width").evaluate(o, {}, s) * Jd : 1 / 0, M = (s)=>{
                        t1.allowVerticalPlacement && Ks(n) && (g.vertical = xm(x, e, r, i, a, A, c, f, s, p, I, mm.vertical, !0, m, d, l));
                    };
                    if (!w && y) {
                        const t1 = "auto" === v ? y.map((t1)=>Iy(t1)) : [
                            v
                        ];
                        let n = !1;
                        for(let s = 0; s < t1.length; s++){
                            const o = t1[s];
                            if (!g.horizontal[o]) {
                                if (n) g.horizontal[o] = g.horizontal[0];
                                else {
                                    const t1 = xm(x, e, r, i, a, A, c, "center", o, p, I, mm.horizontal, !1, m, d, l);
                                    t1 && (g.horizontal[o] = t1, n = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        M("left");
                    } else {
                        if ("auto" === v && (v = Iy(f)), _ || h.get("text-writing-mode").indexOf("horizontal") >= 0 || !Ks(n)) {
                            const t1 = xm(x, e, r, i, a, A, c, f, v, p, I, mm.horizontal, !1, m, d, l);
                            t1 && (g.horizontal[v] = t1);
                        }
                        M(_ ? "left" : v);
                    }
                }
                let S, z, k, P, E, T, B = !1;
                const V = h.get("icon-text-fit").evaluate(o, {}, s);
                if (o.icon && o.icon.hasPrimary()) {
                    const e = by(o.icon, t1.iconSizeData, p["icon-size"], s, t1.zoom, o, l, f.iconScaleFactor, c);
                    S = e.iconPrimary, k = e.iconSecondary;
                    const r = S.toString();
                    if (z = n.get(r), z && (E = h.get("icon-offset").evaluate(o, {}, s), T = h.get("icon-anchor").evaluate(o, {}, s), v = Pm(i.get(r), k ? i.get(k.toString()) : void 0, E, T), B = z.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = z.sdf : t1.sdfIcons !== z.sdf && Gt("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (z.pixelRatio !== t1.pixelRatio || 0 !== h.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0)), k) {
                        const t1 = k.toString();
                        P = n.get(t1);
                    }
                }
                A = A || !(!o.icon || !o.icon.hasSecondary());
                const C = Ty(g.horizontal) || g.vertical;
                t1.iconsInText || (t1.iconsInText = !!C && C.iconsInText);
                const F = m * f.textScaleFactor / Jd, { defaultShapedIcon: D, verticallyShapedIcon: L } = Sy(t1, v, h, o, s, g, F, E, V);
                "none" !== V && v && (Tm(v) || Bm(v)) && (xy(0, z, S, v, D, V, u, n, i), xy(0, P, k, v, D, V, u, n, i), L && (xy(0, z, S, v, L, V, u, n, i), xy(0, P, k, v, L, V, u, n, i))), v = D, M.push({
                    feature: o,
                    shapedTextOrientations: g,
                    shapedText: C,
                    shapedIcon: v,
                    iconPrimary: S,
                    iconSecondary: k,
                    iconOffset: E,
                    iconAnchor: T,
                    verticallyShapedIcon: L,
                    layoutTextSize: m,
                    layoutIconSize: y,
                    textOffset: I,
                    isSDFIcon: B,
                    iconTextFit: V
                });
            }
            return {
                featureData: M,
                sizes: f,
                hasAnySecondaryIcon: A,
                textAlongLine: w,
                symbolPlacement: b
            };
        }, t1.fa = Ym, t1.fb = function(t1, e, r, n, i, s, o, a, l, u) {
            const { featureData: c, hasAnySecondaryIcon: h, sizes: p, textAlongLine: f, symbolPlacement: d } = e;
            for (const e of c){
                const { shapedIcon: r, verticallyShapedIcon: s, feature: c, shapedTextOrientations: m, shapedText: y, layoutTextSize: g, textOffset: x, isSDFIcon: v, iconPrimary: b, iconSecondary: w, iconTextFit: _, iconOffset: A } = e;
                _y(r, u.iconPositions, b, w), _y(s, u.iconPositions, b, w), Ay(m, u.iconPositions), wy(b, w, u.iconPositions), (y || r) && zy(t1, c, m, r, s, l, p, g, 0, x, v, n, i, o, a, h, _, A, f, d);
            }
            r && t1.generateCollisionDebugBuffers(s, t1.collisionBoxArray, p.textScaleFactor);
        }, t1.fc = Pu, t1.fd = $v, t1.fe = vt, t1.ff = ku, t1.fg = lm, t1.fh = dt, t1.fi = function(t1) {
            let e = 0;
            if (new Uint32Array(t1, 0, 1)[0] !== od) {
                const r = new Uint32Array(t1, 0, 7), [, , n, i, s, o] = r;
                e = r.byteLength + i + s + o + s, (n !== t1.byteLength || e >= t1.byteLength) && Gt("Invalid b3dm header information.");
            }
            return pd(t1, e);
        }, t1.fj = function(t1, e) {
            const r = $b(t1);
            for (const t1 of r){
                for (const e of t1.meshes)Gb(e);
                t1.lights && (t1.lightMeshIndex = t1.meshes.length, t1.meshes.push(qb(t1.lights, e)));
            }
            return r;
        }, t1.fk = Tx, t1.fl = Zt, t1.fm = Bf, t1.fn = yo, t1.fo = oo, t1.fp = function(t1) {
            Ae(), null != be && be.then((e)=>{
                e.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e.delete(r[n]).catch((t1)=>Gt(t1.message));
                }).catch((t1)=>Gt(t1.message));
            }).catch((t1)=>Gt(t1.message));
        }, t1.g = function(t1, e) {
            return Fe(Ct(t1, {
                method: "GET"
            }), e);
        }, t1.h = Ct, t1.i = function(t1) {
            return ne.API_STYLE_REGEX.test(t1) && !se(t1);
        }, t1.j = function(t1) {
            return 0 === t1.indexOf("mapbox:");
        }, t1.k = ie, t1.l = Ie, t1.m = function(t1) {
            return decodeURIComponent(atob(t1).split("").map((t1)=>"%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }, t1.n = function(t1, e) {
            return Fe(Ct(t1, {
                type: "json"
            }), e);
        }, t1.o = Ne, t1.p = function(t1, e) {
            return Fe(Ct(t1, {
                method: "POST"
            }), e);
        }, t1.q = fe, t1.r = yh, t1.s = function(t1) {
            try {
                const e = self[t1];
                return e.setItem("_mapbox_test_", 1), e.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }, t1.t = pe, t1.u = function() {
            return function t1(e) {
                return e ? (e ^ Math.random() * (16 >> e / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }, t1.v = function(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }, t1.w = Gt, t1.x = function() {
            return Rf || (Rf = new Ff), Rf;
        }, t1.y = Tv, t1.z = Ke;
    });
    define([
        "./shared"
    ], function(e) {
        function t1(e) {
            const t1 = e ? e.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function s(e) {
            if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return JSON.stringify(e);
            if (Array.isArray(e)) {
                let t1 = "[";
                for (const i of e)t1 += `${s(i)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const i of Object.keys(e).sort())t1 += `${i}:${s(e[i])},`;
            return `${t1}}`;
        }
        function i(t1) {
            let i = "";
            for (const o of e.bu)i += `/${s(t1[o])}`;
            return i;
        }
        class o {
            constructor(e){
                this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e && this.replace(e);
            }
            replace(e, t1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, [], t1);
            }
            update(t1, o, n) {
                this._options = n;
                for (const s of t1)this._layerConfigs[s.id] = s, (this._layers[s.id] = e.db(s, this.scope, null, this._options)).compileFilter(n), this.keyCache[s.id] && delete this.keyCache[s.id];
                for (const e of o)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const r = function(e, t1) {
                    const o = {};
                    for(let n = 0; n < e.length; n++){
                        const r = e[n];
                        let a = t1 && t1[r.id];
                        a || ("symbol" === r.type ? a = r.id : (a = i(r), "line" === r.type && r.paint && function e(t1) {
                            return "string" == typeof t1 && "line-progress" === t1 || (Array.isArray(t1) ? t1.some(e) : !(!t1 || "object" != typeof t1) && Object.values(t1).some(e));
                        }(r.paint["line-width"]) && (a += `/${s(r.paint["line-width"])}`))), t1 && (t1[r.id] = a);
                        let l = o[a];
                        l || (l = o[a] = []), l.push(r);
                    }
                    const n = [];
                    for(const e in o)n.push(o[e]);
                    return n;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e of r){
                    const t1 = e.map((e)=>this._layers[e.id]), s = t1[0];
                    if ("none" === s.visibility) continue;
                    const i = s.source || "";
                    let o = this.familiesBySource[i];
                    o || (o = this.familiesBySource[i] = {});
                    const n = s.sourceLayer || "_geojsonTileLayer";
                    let r = o[n];
                    r || (r = o[n] = []), r.push(t1);
                }
            }
        }
        const n = 1 * e.e_;
        class r {
            constructor(t1){
                const s = {}, i = [];
                for(const e in t1){
                    const o = t1[e], r = s[e] = {};
                    for(const e in o.glyphs){
                        const t1 = o.glyphs[+e];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const s = t1.metrics.localGlyph ? n : 1, a = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * s,
                            h: t1.bitmap.height + 2 * s
                        };
                        i.push(a), r[e] = a;
                    }
                }
                const { w: o, h: r } = e.H(i), a = new e.eZ({
                    width: o || 1,
                    height: r || 1
                });
                for(const i in t1){
                    const o = t1[i];
                    for(const t1 in o.glyphs){
                        const r = o.glyphs[+t1];
                        if (!r || 0 === r.bitmap.width || 0 === r.bitmap.height) continue;
                        const l = s[i][t1], c = r.metrics.localGlyph ? n : 1;
                        e.eZ.copy(r.bitmap, a, {
                            x: 0,
                            y: 0
                        }, {
                            x: l.x + c,
                            y: l.y + c
                        }, r.bitmap);
                    }
                }
                this.image = a, this.positions = s;
            }
        }
        e.eY(r, "GlyphAtlas");
        class a {
            constructor(t1){
                this.tileID = new e.aM(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.lut = t1.lut, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.scope = t1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.request && t1.request.collectResourceTiming, this.promoteId = t1.promoteId, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = e.aW(t1.tileID.canonical, t1.projection), this.projection = t1.projection, this.worldview = t1.worldview, this.localizableLayerIds = t1.localizableLayerIds, this.brightness = t1.brightness, this.extraShadowCaster = !!t1.extraShadowCaster, this.tessellationStep = t1.tessellationStep, this.scaleFactor = t1.scaleFactor, this.worldview = t1.worldview;
            }
            parse(t1, s, i, o, n, a) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e.b0;
                const c = new e.e$(Object.keys(t1.layers).sort()), h = new e.f0(this.tileID, this.promoteId);
                h.bucketLayerIDs = [];
                const u = {}, d = new e.f1(256, 256), f = {
                    featureIndex: h,
                    iconDependencies: new Map,
                    patternDependencies: new Map,
                    glyphDependencies: {},
                    lineAtlas: d,
                    availableImages: i,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    elevationFeatures: void 0
                }, p = [], g = s.familiesBySource[this.source];
                for(const s in g){
                    const n = t1.layers[s];
                    if (!n) continue;
                    let r = !1, a = !1, d = !1;
                    for (const e of g[s])"symbol" === e[0].type ? r = !0 : a = !0, e[0].is3D() && "model" !== e[0].type && (d = !0);
                    if (this.extraShadowCaster && !d) continue;
                    if (!0 === this.isSymbolTile && !r) continue;
                    if (!1 === this.isSymbolTile && !a) continue;
                    1 === n.version && e.w(`Vector tile source "${this.source}" layer "${s}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const m = c.encode(s), y = [];
                    let w = !1;
                    for(let t1 = 0, i = 0; t1 < n.length; t1++){
                        const o = n.feature(t1), r = h.getId(o, s);
                        if (this.localizableLayerIds && this.localizableLayerIds.has(s)) {
                            const e = o.properties ? o.properties.worldview : null;
                            if (this.worldview && "string" == typeof e) {
                                if ("all" === e) o.properties.$localized = !0;
                                else {
                                    if (!e.split(",").includes(this.worldview)) continue;
                                    o.properties.$localized = !0, o.properties.worldview = this.worldview;
                                }
                            }
                        }
                        !w && o.properties && o.properties.hasOwnProperty(e.f2) && (w = !0), y.push({
                            feature: o,
                            id: r,
                            index: i,
                            sourceLayerIndex: m
                        }), i++;
                    }
                    w && !f.elevationFeatures && t1.layers.hasOwnProperty(e.f3) && (f.elevationFeatures = e.f4.parseFrom(t1.layers[e.f3], this.canonical));
                    for (const t1 of g[s]){
                        const s = t1[0];
                        if (this.extraShadowCaster && (!s.is3D() || "model" === s.type)) continue;
                        if (void 0 !== this.isSymbolTile && "symbol" === s.type !== this.isSymbolTile) continue;
                        if (s.minzoom && this.zoom < Math.floor(s.minzoom)) continue;
                        if (s.maxzoom && this.zoom >= s.maxzoom) continue;
                        if ("none" === s.visibility) continue;
                        l(t1, this.zoom, f.brightness, i, this.worldview);
                        const n = u[s.id] = s.createBucket({
                            index: h.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            lut: this.lut,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: m,
                            sourceID: this.source,
                            projection: this.projection.spec,
                            tessellationStep: this.tessellationStep,
                            styleDefinedModelURLs: o,
                            worldview: this.worldview
                        });
                        h.bucketLayerIDs.push(t1.map((t1)=>e.C(t1.id, t1.scope)));
                        let r = n.prepare ? n.prepare() : null;
                        null != r ? (r = r.then(()=>n.populate(y, f, this.tileID.canonical, this.tileTransform)), p.push(r)) : n.populate(y, f, this.tileID.canonical, this.tileTransform);
                    }
                }
                const m = ()=>{
                    let s, o, p, g, m, y;
                    d.trim();
                    const w = {
                        type: "maybePrepare",
                        isSymbolTile: this.isSymbolTile,
                        zoom: this.zoom
                    }, v = ()=>{
                        if (s) return this.status = "done", a(s);
                        if (this.extraShadowCaster) this.status = "done", a(null, {
                            buckets: Object.values(u).filter((e)=>!e.isEmpty()),
                            featureIndex: h,
                            collisionBoxArray: null,
                            glyphAtlasImage: null,
                            lineAtlas: null,
                            imageAtlas: null,
                            brightness: f.brightness,
                            glyphMap: null,
                            iconMap: null,
                            glyphPositions: null
                        });
                        else if (o && p && g) {
                            const t1 = new r(o), s = new Map;
                            for (const [t1, i] of p.entries()){
                                const { imagePosition: o } = e.f7(t1, i, e.f8);
                                s.set(t1, o);
                            }
                            const a = {};
                            for(const n in u){
                                const r = u[n];
                                r instanceof e.b1 && (l(r.layers, this.zoom, f.brightness, i, this.worldview), a[n] = e.f9(r, o, t1.positions, p, s, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, m, this.worldview));
                            }
                            const c = {
                                iconsPending: !0,
                                patternsPending: !0
                            };
                            this.rasterizeIfNeeded(n, p, m, ()=>{
                                c.iconsPending = !1, x(a, t1, c);
                            }), this.rasterizeIfNeeded(n, g, y, ()=>{
                                c.patternsPending = !1, x(a, t1, c);
                            });
                        }
                    }, x = (t1, s, o, n)=>{
                        if (o.iconsPending || o.patternsPending) return;
                        const r = new e.fa(p, g, this.lut);
                        for(const s in u){
                            const o = u[s];
                            if (s in t1) e.fb(o, t1[s], this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, p, r);
                            else if (o.hasPattern && (o instanceof e.b7 || o instanceof e.b8 || o instanceof e.dU)) {
                                l(o.layers, this.zoom, f.brightness, i, this.worldview);
                                const e = Object.fromEntries(r.patternPositions);
                                o.addFeatures(f, this.tileID.canonical, e, i, this.tileTransform, this.brightness);
                            }
                        }
                        this.status = "done", a(null, {
                            buckets: Object.values(u).filter((e)=>!e.isEmpty()),
                            featureIndex: h,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: s.image,
                            lineAtlas: d,
                            imageAtlas: r,
                            brightness: f.brightness
                        });
                    };
                    if (!this.extraShadowCaster) {
                        const t1 = e.f5(f.glyphDependencies, (e)=>Object.keys(e).map(Number));
                        Object.keys(t1).length ? n.send("getGlyphs", {
                            uid: this.uid,
                            stacks: t1,
                            scope: this.scope
                        }, (e, t1)=>{
                            s || (s = e, o = t1, v());
                        }, void 0, !1, w) : o = {};
                        const i = Array.from(f.iconDependencies.keys()).map((t1)=>e.I.parse(t1));
                        i.length ? n.send("getImages", {
                            images: i,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "icons"
                        }, (e, t1)=>{
                            s || (s = e, p = new Map, m = this.updateImageMapAndGetImageTaskQueue(p, t1, f.iconDependencies), v());
                        }, void 0, !1, w) : (p = new Map, m = new Map);
                        const r = Array.from(f.patternDependencies.keys()).map((t1)=>e.I.parse(t1));
                        r.length ? n.send("getImages", {
                            images: r,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "patterns"
                        }, (e, t1)=>{
                            s || (s = e, g = new Map, y = this.updateImageMapAndGetImageTaskQueue(g, t1, f.patternDependencies), v());
                        }, void 0, !1, w) : (g = new Map, y = new Map);
                    }
                    if (f.elevationFeatures && f.elevationFeatures.length > 0) {
                        const s = [];
                        for (const t1 of Object.values(u))if (t1 instanceof e.b8) {
                            const e = t1.getUnevaluatedPortalGraph();
                            e && s.push(e);
                        }
                        const i = e.f6.evaluate(s);
                        for (const s of Object.values(u))if (s instanceof e.b8) {
                            const e = t1.layers[c.decode(s.sourceLayerIndex)];
                            s.setEvaluatedPortalGraph(i, e, this.tileID.canonical, f.availableImages, f.brightness);
                        }
                    }
                    v();
                };
                p.length > 0 ? Promise.allSettled(p).then(m).catch(a) : m();
            }
            rasterizeIfNeeded(e, t1, s, i) {
                Array.from(t1.values()).some((e)=>e.usvg) ? this.rasterize(e, t1, s, i) : i();
            }
            updateImageMapAndGetImageTaskQueue(e, t1, s) {
                const i = new Map;
                for (const o of t1.keys()){
                    const n = s.get(o) || [];
                    for (const s of n){
                        const o = s.toString(), n = t1.get(s.id.toString());
                        n.usvg ? i.has(o) || (i.set(o, s), e.set(o, Object.assign({}, n))) : e.set(o, n);
                    }
                }
                return i;
            }
            rasterize(e, t1, s, i) {
                this.rasterizeTask = e.send("rasterizeImages", {
                    scope: this.scope,
                    tasks: s
                }, (e, s)=>{
                    if (!e) for (const [e, i] of s.entries()){
                        const s = Object.assign(t1.get(e), {
                            data: i
                        });
                        t1.set(e, s);
                    }
                    i();
                });
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.cancel();
            }
        }
        function l(t1, s, i, o, n) {
            const r = new e.aa(s, {
                brightness: i,
                worldview: n
            });
            for (const e of t1)e.recalculate(r, o);
        }
        class c extends e.E {
            constructor(t1, s, i, o, n, r, a){
                super(), this.actor = t1, this.layerIndex = s, this.availableImages = i, this.availableModels = o, this.loadVectorData = r || e.aJ, this.loading = {}, this.loaded = {}, this.deduped = new e.aI(t1.scheduler), this.isSpriteLoaded = n, this.scheduler = t1.scheduler, this.brightness = a;
            }
            loadTile(s, i) {
                const o = s.uid, n = s && s.request, r = n && n.collectResourceTiming, l = this.loading[o] = new a(s);
                l.abort = this.loadVectorData(s, (a, c)=>{
                    const h = !this.loading[o];
                    if (delete this.loading[o], l.cancelRasterize(), h || a || !c) return l.status = "done", h || (this.loaded[o] = l), i(a);
                    const u = c.rawData, d = {};
                    c.expires && (d.expires = c.expires), c.cacheControl && (d.cacheControl = c.cacheControl), l.vectorTile = c.vectorTile || new e.fc.VectorTile(new e.bq(u));
                    const f = ()=>{
                        l.parse(l.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (s, o)=>{
                            if (s || !o) return i(s);
                            const a = {};
                            if (r) {
                                const e = t1(n);
                                e.length > 0 && (a.resourceTiming = JSON.parse(JSON.stringify(e)));
                            }
                            i(null, e.h({
                                rawTileData: u.slice(0)
                            }, o, d, a));
                        });
                    };
                    this.isSpriteLoaded ? f() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(f, {
                            type: "parseTile",
                            isSymbolTile: s.isSymbolTile,
                            zoom: s.tileZoom
                        }) : f();
                    }), this.loaded = this.loaded || {}, this.loaded[o] = l;
                });
            }
            reloadTile(t1, s) {
                const i = this.loaded, o = t1.uid;
                if (i && i[o]) {
                    const n = i[o];
                    n.scaleFactor = t1.scaleFactor, n.showCollisionBoxes = t1.showCollisionBoxes, n.projection = t1.projection, n.brightness = t1.brightness, n.tileTransform = e.aW(t1.tileID.canonical, t1.projection), n.extraShadowCaster = t1.extraShadowCaster, n.lut = t1.lut, n.worldview = t1.worldview;
                    const r = (e, t1)=>{
                        const i = n.reloadCallback;
                        i && (delete n.reloadCallback, n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, i)), s(e, t1);
                    };
                    "parsing" === n.status ? n.reloadCallback = r : "done" === n.status && (n.vectorTile ? n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, r) : r());
                } else s(null, void 0);
            }
            abortTile(e, t1) {
                const s = e.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        class h {
            loadTile(t1, s) {
                const { uid: i, encoding: o, rawImageData: n, padding: r } = t1, a = ImageBitmap && n instanceof ImageBitmap ? this.getImageData(n, r) : n;
                s(null, new e.fd(i, a, o, r < 1));
            }
            reloadTile(e, t1) {
                t1(null, null);
            }
            abortTile(e, t1) {
                t1();
            }
            removeTile(e, t1) {
                t1();
            }
            getImageData(e, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
                const s = this.offscreenCanvasContext.getImageData(-t1, -t1, e.width + 2 * t1, e.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s;
            }
        }
        e.bp.setPbf(e.bq);
        class u {
            constructor(t1){
                this._mrt = new e.bp(t1.partial ? 30 : 1 / 0), this._isHeaderLoaded = !1, this.uid = t1.uid, this.tileID = t1.tileID, this.source = t1.source;
            }
            parse(t1, s) {
                const i = this._mrt;
                this.status = "parsing", this._entireBuffer = t1;
                try {
                    i.parseHeader(t1), this._isHeaderLoaded = !0;
                    const o = [];
                    for(const s in i.layers){
                        const n = i.getLayer(s), r = n.getDataRange(n.getBandList()), a = i.createDecodingTask(r), l = t1.slice(r.firstByte, r.lastByte + 1), c = e.bp.performDecoding(l, a).then((e)=>a.complete(null, e)).catch((e)=>a.complete(e, null));
                        o.push(c);
                    }
                    Promise.allSettled(o).then(()=>s(null, i)).catch((e)=>s(e));
                } catch (e) {
                    s(e);
                }
            }
        }
        class d {
            constructor(e){
                this.actor = e, this.loading = {}, this.loaded = {};
            }
            loadTile(t1, s) {
                const i = t1.uid, o = t1.request, n = this.loading[i] = new u(t1), { cancel: r } = e.br(o, (e, t1, o, r)=>{
                    const a = !this.loading[i];
                    if (delete this.loading[i], a || e || !t1) return n.status = "done", a || (this.loaded[i] = n), s(e);
                    n.parse(t1, (e, t1)=>{
                        if (e || !t1) return s(e);
                        s(null, t1, o, r);
                    }), this.loaded[i] = n;
                });
                n.abort = r;
            }
            reloadTile(e, t1) {
                t1(null, void 0);
            }
            abortTile(e, t1) {
                const s = e.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e, t1) {
                const s = e.uid;
                this.loaded[s] && delete this.loaded[s], t1();
            }
            decodeRasterArray(t1, s) {
                e.bp.performDecoding(t1.buffer, t1.task).then((e)=>s(null, e)).catch((e)=>s(e));
            }
        }
        const f = e.fc.VectorTileFeature.prototype.toGeoJSON;
        class p {
            constructor(t1){
                this._feature = t1, this.extent = e.aj, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const s of this._feature.geometry)t1.push([
                        new e.P(s[0], s[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const s of this._feature.geometry){
                        const i = [];
                        for (const t1 of s)i.push(new e.P(t1[0], t1[1]));
                        t1.push(i);
                    }
                    return t1;
                }
            }
            toGeoJSON(e, t1, s) {
                return f.call(this, e, t1, s);
            }
        }
        class g {
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e.aj, this.length = t1.length, this._features = t1;
            }
            feature(e) {
                return new p(this._features[e]);
            }
        }
        class m {
            constructor(t1, s){
                this.name = t1, this.extent = e.aj, this.length = s.length, this._features = s;
            }
            feature(e) {
                return new p(this._features[e]);
            }
        }
        class y extends g {
            constructor(e){
                super([]), this.layers = {};
                for(const t1 in e)this.layers[t1] = new m(t1, e[t1]);
            }
        }
        const w = 64 / 4096, v = 128;
        class x {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e = [], t1) {
                for (const s of e){
                    const e = s.id;
                    if (null == e) continue;
                    let i = this.features.get(e);
                    i && this.updateCache(i, t1), s.geometry ? (i = I(s), this.updateCache(i, t1), this.features.set(e, i)) : this.features.delete(e), this.updateCache(i, t1);
                }
            }
            updateCache(e, t1) {
                for (const { canonical: s, uid: i } of Object.values(t1)){
                    const { z: o, x: n, y: r } = s;
                    b(e, Math.pow(2, o), n, r) && delete t1[i];
                }
            }
            getTile(e, t1, s) {
                const i = Math.pow(2, e), o = [];
                for (const e of this.features.values())b(e, i, t1, s) && o.push(T(e, i, t1, s));
                return {
                    features: o
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function b({ minX: e, minY: t1, maxX: s, maxY: i }, o, n, r) {
            return e < (n + 1 + w) / o && t1 < (r + 1 + w) / o && s > (n - w) / o && i > (r - w) / o;
        }
        function I(e) {
            const { id: t1, geometry: s, properties: i } = e;
            if (!s) return;
            if ("GeometryCollection" === s.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: o, coordinates: n } = s, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === o) S(n, a, r);
            else if ("MultiPoint" === o) for (const e of n)S(e, a, r);
            else if ("LineString" === o) r.type = 2, M(n, a, r);
            else if ("MultiLineString" === o) r.type = 2, P(n, a, r);
            else if ("Polygon" === o) r.type = 3, P(n, a, r, !0);
            else {
                if ("MultiPolygon" !== o) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e of n)P(e, a, r, !0);
            }
            return r;
        }
        function S([t1, s], i, o) {
            const n = e.aD(t1);
            let r = e.aH(s);
            r = r < 0 ? 0 : r > 1 ? 1 : r, i.push(n, r), o.minX = Math.min(o.minX, n), o.minY = Math.min(o.minY, r), o.maxX = Math.max(o.maxX, n), o.maxY = Math.max(o.maxY, r);
        }
        function M(e, t1, s, i = !1, o = !1) {
            const n = [];
            for (const t1 of e)S(t1, n, s);
            t1.push(n), i && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(n, o);
        }
        function P(e, t1, s, i = !1) {
            for(let o = 0; o < e.length; o++)M(e[o], t1, s, i, 0 === o);
        }
        function T(t1, s, i, o) {
            const { id: n, type: r, geometry: a, tags: l } = t1, c = [];
            if (1 === r) !function(t1, s, i, o, n) {
                for(let r = 0; r < t1.length; r += 2){
                    const a = Math.round(e.aj * (t1[r + 0] * s - i)), l = Math.round(e.aj * (t1[r + 1] * s - o));
                    n.push([
                        a,
                        l
                    ]);
                }
            }(a, s, i, o, c);
            else for (const e of a)k(e, s, i, o, c);
            return {
                id: n,
                type: r,
                geometry: c,
                tags: l
            };
        }
        function k(t1, s, i, o, n) {
            const r = -128, a = e.aj + v;
            let l;
            for(let c = 0; c < t1.length - 2; c += 2){
                let h = Math.round(e.aj * (t1[c + 0] * s - i)), u = Math.round(e.aj * (t1[c + 1] * s - o)), d = Math.round(e.aj * (t1[c + 2] * s - i)), f = Math.round(e.aj * (t1[c + 3] * s - o));
                const p = d - h, g = f - u;
                h < r && d < r || (h < r ? (u += Math.round(g * ((r - h) / p)), h = r) : d < r && (f = u + Math.round(g * ((r - h) / p)), d = r), u < r && f < r || (u < r ? (h += Math.round(p * ((r - u) / g)), u = r) : f < r && (d = h + Math.round(p * ((r - u) / g)), f = r), h >= a && d >= a || (h >= a ? (u += Math.round(g * ((a - h) / p)), h = a) : d >= a && (f = u + Math.round(g * ((a - h) / p)), d = a), u >= a && f >= a || (u >= a ? (h += Math.round(p * ((a - u) / g)), u = a) : f >= a && (d = h + Math.round(p * ((a - u) / g)), f = a), l && h === l[l.length - 1][0] && u === l[l.length - 1][1] || (l = [
                    [
                        h,
                        u
                    ]
                ], n.push(l)), l.push([
                    d,
                    f
                ])))));
            }
        }
        var L, _, C, j = {
            exports: {}
        }, D = function() {
            if (C) return j.exports;
            C = 1;
            var t1 = e.fg(), s = function() {
                if (_) return L;
                _ = 1;
                var t1 = e.fe(), s = e.ff().VectorTileFeature;
                function i(e, t1) {
                    this.options = t1 || {}, this.features = e, this.length = e.length;
                }
                function o(e, t1) {
                    this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                        e.geometry
                    ] : e.geometry, this.properties = e.tags, this.extent = t1 || 4096;
                }
                return L = i, i.prototype.feature = function(e) {
                    return new o(this.features[e], this.options.extent);
                }, o.prototype.loadGeometry = function() {
                    var e = this.rawGeometry;
                    this.geometry = [];
                    for(var s = 0; s < e.length; s++){
                        for(var i = e[s], o = [], n = 0; n < i.length; n++)o.push(new t1(i[n][0], i[n][1]));
                        this.geometry.push(o);
                    }
                    return this.geometry;
                }, o.prototype.bbox = function() {
                    this.geometry || this.loadGeometry();
                    for(var e = this.geometry, t1 = 1 / 0, s = -1 / 0, i = 1 / 0, o = -1 / 0, n = 0; n < e.length; n++)for(var r = e[n], a = 0; a < r.length; a++){
                        var l = r[a];
                        t1 = Math.min(t1, l.x), s = Math.max(s, l.x), i = Math.min(i, l.y), o = Math.max(o, l.y);
                    }
                    return [
                        t1,
                        i,
                        s,
                        o
                    ];
                }, o.prototype.toGeoJSON = s.prototype.toGeoJSON, L;
            }();
            function i(e) {
                var s = new t1;
                return function(e, t1) {
                    for(var s in e.layers)t1.writeMessage(3, o, e.layers[s]);
                }(e, s), s.finish();
            }
            function o(e, t1) {
                var s;
                t1.writeVarintField(15, e.version || 1), t1.writeStringField(1, e.name || ""), t1.writeVarintField(5, e.extent || 4096);
                var i = {
                    keys: [],
                    values: [],
                    keycache: {},
                    valuecache: {}
                };
                for(s = 0; s < e.length; s++)i.feature = e.feature(s), t1.writeMessage(2, n, i);
                var o = i.keys;
                for(s = 0; s < o.length; s++)t1.writeStringField(3, o[s]);
                var r = i.values;
                for(s = 0; s < r.length; s++)t1.writeMessage(4, h, r[s]);
            }
            function n(e, t1) {
                var s = e.feature;
                void 0 !== s.id && t1.writeVarintField(1, s.id), t1.writeMessage(2, r, e), t1.writeVarintField(3, s.type), t1.writeMessage(4, c, s);
            }
            function r(e, t1) {
                var s = e.feature, i = e.keys, o = e.values, n = e.keycache, r = e.valuecache;
                for(var a in s.properties){
                    var l = s.properties[a], c = n[a];
                    if (null !== l) {
                        void 0 === c && (i.push(a), n[a] = c = i.length - 1), t1.writeVarint(c);
                        var h = typeof l;
                        "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                        var u = h + ":" + l, d = r[u];
                        void 0 === d && (o.push(l), r[u] = d = o.length - 1), t1.writeVarint(d);
                    }
                }
            }
            function a(e, t1) {
                return (t1 << 3) + (7 & e);
            }
            function l(e) {
                return e << 1 ^ e >> 31;
            }
            function c(e, t1) {
                for(var s = e.loadGeometry(), i = e.type, o = 0, n = 0, r = s.length, c = 0; c < r; c++){
                    var h = s[c], u = 1;
                    1 === i && (u = h.length), t1.writeVarint(a(1, u));
                    for(var d = 3 === i ? h.length - 1 : h.length, f = 0; f < d; f++){
                        1 === f && 1 !== i && t1.writeVarint(a(2, d - 1));
                        var p = h[f].x - o, g = h[f].y - n;
                        t1.writeVarint(l(p)), t1.writeVarint(l(g)), o += p, n += g;
                    }
                    3 === i && t1.writeVarint(a(7, 1));
                }
            }
            function h(e, t1) {
                var s = typeof e;
                "string" === s ? t1.writeStringField(1, e) : "boolean" === s ? t1.writeBooleanField(7, e) : "number" === s && (e % 1 != 0 ? t1.writeDoubleField(3, e) : e < 0 ? t1.writeSVarintField(6, e) : t1.writeVarintField(5, e));
            }
            return j.exports = i, j.exports.fromVectorTileJs = i, j.exports.fromGeojsonVt = function(e, t1) {
                t1 = t1 || {};
                var o = {};
                for(var n in e)o[n] = new s(e[n].features, t1), o[n].name = n, o[n].version = t1.version, o[n].extent = t1.extent;
                return i({
                    layers: o
                });
            }, j.exports.GeoJSONWrapper = s, j.exports;
        }(), z = e.fh(D);
        const O = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, F = Math.fround || (A = new Float32Array(1), (e)=>(A[0] = +e, A[0]));
        var A;
        const Z = 3, N = 5, B = 6;
        class R {
            constructor(e){
                this.options = Object.assign(Object.create(O), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t1, minZoom: s, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const o = `prepare ${e.length} points`;
                t1 && console.time(o), this.points = e;
                const n = [];
                for(let t1 = 0; t1 < e.length; t1++){
                    const s = e[t1];
                    if (!s.geometry) continue;
                    const [i, o] = s.geometry.coordinates, r = F(Y(i)), a = F(G(o));
                    n.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && n.push(0);
                }
                let r = this.trees[i + 1] = this._createTree(n);
                t1 && console.timeEnd(o);
                for(let e = i; e >= s; e--){
                    const s = +Date.now();
                    r = this.trees[e] = this._createTree(this._cluster(r, e)), t1 && console.log("z%d: %d clusters in %dms", e, r.numItems, +Date.now() - s);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e, t1) {
                let s = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e[1]));
                let o = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) s = -180, o = 180;
                else if (s > o) {
                    const e = this.getClusters([
                        s,
                        i,
                        180,
                        n
                    ], t1), r = this.getClusters([
                        -180,
                        i,
                        o,
                        n
                    ], t1);
                    return e.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(Y(s), G(n), Y(o), G(i)), l = r.data, c = [];
                for (const e of a){
                    const t1 = this.stride * e;
                    c.push(l[t1 + N] > 1 ? X(l, t1, this.clusterProps) : this.points[l[t1 + Z]]);
                }
                return c;
            }
            getChildren(e) {
                const t1 = this._getOriginId(e), s = this._getOriginZoom(e), i = "No cluster with the specified id.", o = this.trees[s];
                if (!o) throw new Error(i);
                const n = o.data;
                if (t1 * this.stride >= n.length) throw new Error(i);
                const r = this.options.radius / (this.options.extent * Math.pow(2, s - 1)), a = o.within(n[t1 * this.stride], n[t1 * this.stride + 1], r), l = [];
                for (const t1 of a){
                    const s = t1 * this.stride;
                    n[s + 4] === e && l.push(n[s + N] > 1 ? X(n, s, this.clusterProps) : this.points[n[s + Z]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e, t1, s) {
                const i = [];
                return this._appendLeaves(i, e, t1 = t1 || 10, s = s || 0, 0), i;
            }
            getTile(e, t1, s) {
                const i = this.trees[this._limitZoom(e)], o = Math.pow(2, e), { extent: n, radius: r } = this.options, a = r / n, l = (s - a) / o, c = (s + 1 + a) / o, h = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / o, l, (t1 + 1 + a) / o, c), i.data, t1, s, o, h), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, l, 1, c), i.data, o, s, o, h), t1 === o - 1 && this._addTileFeatures(i.range(0, l, a / o, c), i.data, -1, s, o, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t1 = this._getOriginZoom(e) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const s = this.getChildren(e);
                    if (t1++, 1 !== s.length) break;
                    e = s[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e, t1, s, i, o) {
                const n = this.getChildren(t1);
                for (const t1 of n){
                    const n = t1.properties;
                    if (n && n.cluster ? o + n.point_count <= i ? o += n.point_count : o = this._appendLeaves(e, n.cluster_id, s, i, o) : o < i ? o++ : e.push(t1), e.length === s) break;
                }
                return o;
            }
            _createTree(t1) {
                const s = new e.bW(t1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t1.length; e += this.stride)s.add(t1[e], t1[e + 1]);
                return s.finish(), s.data = t1, s;
            }
            _addTileFeatures(e, t1, s, i, o, n) {
                for (const r of e){
                    const e = r * this.stride, a = t1[e + N] > 1;
                    let l, c, h;
                    if (a) l = E(t1, e, this.clusterProps), c = t1[e], h = t1[e + 1];
                    else {
                        const s = this.points[t1[e + Z]];
                        l = s.properties;
                        const [i, o] = s.geometry.coordinates;
                        c = Y(i), h = G(o);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * o - s)),
                                Math.round(this.options.extent * (h * o - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e + Z] : this.points[t1[e + Z]].id, void 0 !== d && (u.id = d), n.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t1) {
                const { radius: s, extent: i, reduce: o, minPoints: n } = this.options, r = s / (i * Math.pow(2, t1)), a = e.data, l = [], c = this.stride;
                for(let s = 0; s < a.length; s += c){
                    if (a[s + 2] <= t1) continue;
                    a[s + 2] = t1;
                    const i = a[s], h = a[s + 1], u = e.within(a[s], a[s + 1], r), d = a[s + N];
                    let f = d;
                    for (const e of u){
                        const s = e * c;
                        a[s + 2] > t1 && (f += a[s + N]);
                    }
                    if (f > d && f >= n) {
                        let e, n = i * d, r = h * d, p = -1;
                        const g = (s / c << 5) + (t1 + 1) + this.points.length;
                        for (const i of u){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const h = a[l + N];
                            n += a[l] * h, r += a[l + 1] * h, a[l + 4] = g, o && (e || (e = this._map(a, s, !0), p = this.clusterProps.length, this.clusterProps.push(e)), o(e, this._map(a, l)));
                        }
                        a[s + 4] = g, l.push(n / f, r / f, 1 / 0, g, -1, f), o && l.push(p);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[s + e]);
                        if (f > 1) for (const e of u){
                            const s = e * c;
                            if (!(a[s + 2] <= t1)) {
                                a[s + 2] = t1;
                                for(let e = 0; e < c; e++)l.push(a[s + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t1, s) {
                if (e[t1 + N] > 1) {
                    const i = this.clusterProps[e[t1 + B]];
                    return s ? Object.assign({}, i) : i;
                }
                const i = this.points[e[t1 + Z]].properties, o = this.options.map(i);
                return s && o === i ? Object.assign({}, o) : o;
            }
        }
        function X(e, t1, s) {
            var i;
            return {
                type: "Feature",
                id: e[t1 + Z],
                properties: E(e, t1, s),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e[t1], 360 * (i - .5)),
                        J(e[t1 + 1])
                    ]
                }
            };
        }
        function E(e, t1, s) {
            const i = e[t1 + N], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, n = e[t1 + B], r = -1 === n ? {} : Object.assign({}, s[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e[t1 + Z],
                point_count: i,
                point_count_abbreviated: o
            });
        }
        function Y(e) {
            return e / 360 + .5;
        }
        function G(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function J(e) {
            const t1 = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function V(e, t1, s, i) {
            let o = i;
            const n = t1 + (s - t1 >> 1);
            let r, a = s - t1;
            const l = e[t1], c = e[t1 + 1], h = e[s], u = e[s + 1];
            for(let i = t1 + 3; i < s; i += 3){
                const t1 = $(e[i], e[i + 1], l, c, h, u);
                if (t1 > o) r = i, o = t1;
                else if (t1 === o) {
                    const e = Math.abs(i - n);
                    e < a && (r = i, a = e);
                }
            }
            o > i && (r - t1 > 3 && V(e, t1, r, i), e[r + 2] = o, s - r > 3 && V(e, r, s, i));
        }
        function $(e, t1, s, i, o, n) {
            let r = o - s, a = n - i;
            if (0 !== r || 0 !== a) {
                const l = ((e - s) * r + (t1 - i) * a) / (r * r + a * a);
                l > 1 ? (s = o, i = n) : l > 0 && (s += r * l, i += a * l);
            }
            return r = e - s, a = t1 - i, r * r + a * a;
        }
        function U(e, t1, s, i) {
            const o = {
                id: e ?? null,
                type: t1,
                geometry: s,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) W(o, s);
            else if ("Polygon" === t1) W(o, s[0]);
            else if ("MultiLineString" === t1) for (const e of s)W(o, e);
            else if ("MultiPolygon" === t1) for (const e of s)W(o, e[0]);
            return o;
        }
        function W(e, t1) {
            for(let s = 0; s < t1.length; s += 3)e.minX = Math.min(e.minX, t1[s]), e.minY = Math.min(e.minY, t1[s + 1]), e.maxX = Math.max(e.maxX, t1[s]), e.maxY = Math.max(e.maxY, t1[s + 1]);
        }
        function q(e, t1, s, i) {
            if (!t1.geometry) return;
            const o = t1.geometry.coordinates;
            if (o && 0 === o.length) return;
            const n = t1.geometry.type, r = Math.pow(s.tolerance / ((1 << s.maxZoom) * s.extent), 2);
            let a = [], l = t1.id;
            if (s.promoteId ? l = t1.properties[s.promoteId] : s.generateId && (l = i || 0), "Point" === n) H(o, a);
            else if ("MultiPoint" === n) for (const e of o)H(e, a);
            else if ("LineString" === n) Q(o, a, r, !1);
            else if ("MultiLineString" === n) {
                if (s.lineMetrics) {
                    for (const s of o)a = [], Q(s, a, r, !1), e.push(U(l, "LineString", a, t1.properties));
                    return;
                }
                K(o, a, r, !1);
            } else if ("Polygon" === n) K(o, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        for (const o of t1.geometry.geometries)q(e, {
                            id: l,
                            geometry: o,
                            properties: t1.properties
                        }, s, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of o){
                    const t1 = [];
                    K(e, t1, r, !0), a.push(t1);
                }
            }
            e.push(U(l, n, a, t1.properties));
        }
        function H(e, t1) {
            t1.push(ee(e[0]), te(e[1]), 0);
        }
        function Q(e, t1, s, i) {
            let o, n, r = 0;
            for(let s = 0; s < e.length; s++){
                const a = ee(e[s][0]), l = te(e[s][1]);
                t1.push(a, l, 0), s > 0 && (r += i ? (o * l - a * n) / 2 : Math.sqrt(Math.pow(a - o, 2) + Math.pow(l - n, 2))), o = a, n = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, V(t1, 0, a, s), t1[a + 2] = 1, t1.size = Math.abs(r), t1.start = 0, t1.end = t1.size;
        }
        function K(e, t1, s, i) {
            for(let o = 0; o < e.length; o++){
                const n = [];
                Q(e[o], n, s, i), t1.push(n);
            }
        }
        function ee(e) {
            return e / 360 + .5;
        }
        function te(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function se(e, t1, s, i, o, n, r, a) {
            if (i /= t1, n >= (s /= t1) && r < i) return e;
            if (r < s || n >= i) return null;
            const l = [];
            for (const t1 of e){
                const e = t1.geometry;
                let n = t1.type;
                const r = 0 === o ? t1.minX : t1.minY, c = 0 === o ? t1.maxX : t1.maxY;
                if (r >= s && c < i) {
                    l.push(t1);
                    continue;
                }
                if (c < s || r >= i) continue;
                let h = [];
                if ("Point" === n || "MultiPoint" === n) ie(e, h, s, i, o);
                else if ("LineString" === n) oe(e, h, s, i, o, !1, a.lineMetrics);
                else if ("MultiLineString" === n) re(e, h, s, i, o, !1);
                else if ("Polygon" === n) re(e, h, s, i, o, !0);
                else if ("MultiPolygon" === n) for (const t1 of e){
                    const e = [];
                    re(t1, e, s, i, o, !0), e.length && h.push(e);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === n) {
                        for (const e of h)l.push(U(t1.id, n, e, t1.tags));
                        continue;
                    }
                    "LineString" !== n && "MultiLineString" !== n || (1 === h.length ? (n = "LineString", h = h[0]) : n = "MultiLineString"), "Point" !== n && "MultiPoint" !== n || (n = 3 === h.length ? "Point" : "MultiPoint"), l.push(U(t1.id, n, h, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function ie(e, t1, s, i, o) {
            for(let n = 0; n < e.length; n += 3){
                const r = e[n + o];
                r >= s && r <= i && ae(t1, e[n], e[n + 1], e[n + 2]);
            }
        }
        function oe(e, t1, s, i, o, n, r) {
            let a = ne(e);
            const l = 0 === o ? le : ce;
            let c, h, u = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const f = e[d], p = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], w = 0 === o ? f : p, v = 0 === o ? m : y;
                let x = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(p - y, 2))), w < s ? v > s && (h = l(a, f, p, m, y, s), r && (a.start = u + c * h)) : w > i ? v < i && (h = l(a, f, p, m, y, i), r && (a.start = u + c * h)) : ae(a, f, p, g), v < s && w >= s && (h = l(a, f, p, m, y, s), x = !0), v > i && w <= i && (h = l(a, f, p, m, y, i), x = !0), !n && x && (r && (a.end = u + c * h), t1.push(a), a = ne(e)), r && (u += c);
            }
            let d = e.length - 3;
            const f = e[d], p = e[d + 1], g = 0 === o ? f : p;
            g >= s && g <= i && ae(a, f, p, e[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && ae(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function ne(e) {
            const t1 = [];
            return t1.size = e.size, t1.start = e.start, t1.end = e.end, t1;
        }
        function re(e, t1, s, i, o, n) {
            for (const r of e)oe(r, t1, s, i, o, n, !1);
        }
        function ae(e, t1, s, i) {
            e.push(t1, s, i);
        }
        function le(e, t1, s, i, o, n) {
            const r = (n - t1) / (i - t1);
            return ae(e, n, s + (o - s) * r, 1), r;
        }
        function ce(e, t1, s, i, o, n) {
            const r = (n - s) / (o - s);
            return ae(e, t1 + (i - t1) * r, n, 1), r;
        }
        function he(e, t1) {
            const s = [];
            for(let i = 0; i < e.length; i++){
                const o = e[i], n = o.type;
                let r;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = ue(o.geometry, t1);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for (const e of o.geometry)r.push(ue(e, t1));
                } else if ("MultiPolygon" === n) {
                    r = [];
                    for (const e of o.geometry){
                        const s = [];
                        for (const i of e)s.push(ue(i, t1));
                        r.push(s);
                    }
                }
                s.push(U(o.id, n, r, o.tags));
            }
            return s;
        }
        function ue(e, t1) {
            const s = [];
            s.size = e.size, void 0 !== e.start && (s.start = e.start, s.end = e.end);
            for(let i = 0; i < e.length; i += 3)s.push(e[i] + t1, e[i + 1], e[i + 2]);
            return s;
        }
        function de(e, t1) {
            if (e.transformed) return e;
            const s = 1 << e.z, i = e.x, o = e.y;
            for (const n of e.features){
                const e = n.geometry, r = n.type;
                if (n.geometry = [], 1 === r) for(let r = 0; r < e.length; r += 2)n.geometry.push(fe(e[r], e[r + 1], t1, s, i, o));
                else for(let r = 0; r < e.length; r++){
                    const a = [];
                    for(let n = 0; n < e[r].length; n += 2)a.push(fe(e[r][n], e[r][n + 1], t1, s, i, o));
                    n.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function fe(e, t1, s, i, o, n) {
            return [
                Math.round(s * (e * i - o)),
                Math.round(s * (t1 * i - n))
            ];
        }
        function pe(e, t1, s, i, o) {
            const n = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: s,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e)ge(r, t1, n, o);
            return r;
        }
        function ge(e, t1, s, i) {
            const o = t1.geometry, n = t1.type, r = [];
            if (e.minX = Math.min(e.minX, t1.minX), e.minY = Math.min(e.minY, t1.minY), e.maxX = Math.max(e.maxX, t1.maxX), e.maxY = Math.max(e.maxY, t1.maxY), "Point" === n || "MultiPoint" === n) for(let t1 = 0; t1 < o.length; t1 += 3)r.push(o[t1], o[t1 + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === n) me(r, o, e, s, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(let t1 = 0; t1 < o.length; t1++)me(r, o[t1], e, s, "Polygon" === n, 0 === t1);
            else if ("MultiPolygon" === n) for(let t1 = 0; t1 < o.length; t1++){
                const i = o[t1];
                for(let t1 = 0; t1 < i.length; t1++)me(r, i[t1], e, s, !0, 0 === t1);
            }
            if (r.length) {
                let s = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    s = {};
                    for(const e in t1.tags)s[e] = t1.tags[e];
                    s.mapbox_clip_start = o.start / o.size, s.mapbox_clip_end = o.end / o.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: s
                };
                null !== t1.id && (a.id = t1.id), e.features.push(a);
            }
        }
        function me(e, t1, s, i, o, n) {
            const r = i * i;
            if (i > 0 && t1.size < (o ? r : i)) return void (s.numPoints += t1.length / 3);
            const a = [];
            for(let e = 0; e < t1.length; e += 3)(0 === i || t1[e + 2] > r) && (s.numSimplified++, a.push(t1[e], t1[e + 1])), s.numPoints++;
            o && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(a, n), e.push(a);
        }
        const ye = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class we {
            constructor(e, t1){
                const s = (t1 = this.options = function(e, t1) {
                    for(const s in t1)e[s] = t1[s];
                    return e;
                }(Object.create(ye), t1)).debug;
                if (s && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e, t1) {
                    const s = [];
                    if ("FeatureCollection" === e.type) for(let i = 0; i < e.features.length; i++)q(s, e.features[i], t1, i);
                    else q(s, "Feature" === e.type ? e : {
                        geometry: e
                    }, t1);
                    return s;
                }(e, t1);
                this.tiles = {}, this.tileCoords = [], s && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e, t1) {
                    const s = t1.buffer / t1.extent;
                    let i = e;
                    const o = se(e, 1, -1 - s, s, 0, -1, 2, t1), n = se(e, 1, 1 - s, 2 + s, 0, -1, 2, t1);
                    return (o || n) && (i = se(e, 1, -s, 1 + s, 0, -1, 2, t1) || [], o && (i = he(o, 1).concat(i)), n && (i = i.concat(he(n, -1)))), i;
                }(i, t1), i.length && this.splitTile(i, 0, 0, 0), s && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e, t1, s, i, o, n, r) {
                const a = [
                    e,
                    t1,
                    s,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), s = a.pop(), t1 = a.pop(), e = a.pop();
                    const h = 1 << t1, u = ve(t1, s, i);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = pe(e, t1, s, i, l), this.tileCoords.push({
                        z: t1,
                        x: s,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, s, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t1}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == o) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === o) continue;
                        if (null != o) {
                            const e = o - t1;
                            if (s !== n >> e || i !== r >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, p = .5 - f, g = .5 + f, m = 1 + f;
                    let y = null, w = null, v = null, x = null, b = se(e, h, s - f, s + g, 0, d.minX, d.maxX, l), I = se(e, h, s + p, s + m, 0, d.minX, d.maxX, l);
                    e = null, b && (y = se(b, h, i - f, i + g, 1, d.minY, d.maxY, l), w = se(b, h, i + p, i + m, 1, d.minY, d.maxY, l), b = null), I && (v = se(I, h, i - f, i + g, 1, d.minY, d.maxY, l), x = se(I, h, i + p, i + m, 1, d.minY, d.maxY, l), I = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * s, 2 * i), a.push(w || [], t1 + 1, 2 * s, 2 * i + 1), a.push(v || [], t1 + 1, 2 * s + 1, 2 * i), a.push(x || [], t1 + 1, 2 * s + 1, 2 * i + 1);
                }
            }
            getTile(e, t1, s) {
                e = +e, t1 = +t1, s = +s;
                const i = this.options, { extent: o, debug: n } = i;
                if (e < 0 || e > 24) return null;
                const r = 1 << e, a = ve(e, t1 = t1 + r & r - 1, s);
                if (this.tiles[a]) return de(this.tiles[a], o);
                n > 1 && console.log("drilling down to z%d-%d-%d", e, t1, s);
                let l, c = e, h = t1, u = s;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[ve(c, h, u)];
                return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e, t1, s), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? de(this.tiles[a], o) : null) : null;
            }
        }
        function ve(e, t1, s) {
            return 32 * ((1 << e) * s + t1) + e;
        }
        function xe(e, t1) {
            const s = e.tileID.canonical;
            if (!this._geoJSONIndex) return void t1(null, null);
            const i = this._geoJSONIndex.getTile(s.z, s.x, s.y);
            if (!i) return void t1(null, null);
            const o = (e)=>e.tags && "3d_elevation_id" in e.tags && "source" in e.tags && "elevation" === e.tags.source, n = i.features.filter((e)=>o(e));
            let r;
            if (n.length > 0) {
                const e = i.features.filter((e)=>!o(e));
                r = new y({
                    _geojsonTileLayer: e,
                    hd_road_elevation: n
                });
            } else r = new g(i.features);
            let a = z(r);
            0 === a.byteOffset && a.byteLength === a.buffer.byteLength || (a = new Uint8Array(a)), t1(null, {
                vectorTile: r,
                rawData: a.buffer
            });
        }
        class be extends c {
            constructor(e, t1, s, i, o, n, r){
                super(e, t1, s, i, o, xe, r), n && (this.loadGeoJSON = n), this._dynamicIndex = new x;
            }
            loadData(s, i) {
                const o = s && s.request, n = o && o.collectResourceTiming;
                this.loadGeoJSON(s, (r, a)=>{
                    if (r || !a) return i(r);
                    if ("object" != typeof a) return i(new Error(`Input data given to '${s.source}' is not a valid GeoJSON object.`));
                    {
                        try {
                            if (s.filter) {
                                const t1 = e.X(s.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === t1.result) throw new Error(t1.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                a.features = a.features.filter((e)=>t1.value.evaluate({
                                        zoom: 0
                                    }, e));
                            }
                            s.dynamic ? ("Feature" === a.type && (a = {
                                type: "FeatureCollection",
                                features: [
                                    a
                                ]
                            }), s.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a.features, this.loaded), s.cluster && (a.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s.cluster ? new R(function({ superclusterOptions: t1, clusterProperties: s }) {
                                if (!s || !t1) return t1;
                                const i = {}, o = {}, n = {
                                    accumulated: null,
                                    zoom: 0
                                }, r = {
                                    properties: null
                                }, a = Object.keys(s);
                                for (const t1 of a){
                                    const [n, r] = s[t1], a = e.X(r), l = e.X("string" == typeof n ? [
                                        n,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : n);
                                    i[t1] = a.value, o[t1] = l.value;
                                }
                                return t1.map = (e)=>{
                                    r.properties = e;
                                    const t1 = {};
                                    for (const e of a)t1[e] = i[e].evaluate(n, r);
                                    return t1;
                                }, t1.reduce = (e, t1)=>{
                                    r.properties = t1;
                                    for (const t1 of a)n.accumulated = e[t1], e[t1] = o[t1].evaluate(n, r);
                                }, t1;
                            }(s)).load(a.features) : s.dynamic ? this._dynamicIndex : function(e, t1) {
                                return new we(e, t1);
                            }(a, s.geojsonVtOptions);
                        } catch (e) {
                            return i(e);
                        }
                        const r = {};
                        if (n) {
                            const e = t1(o);
                            e && (r.resourceTiming = {}, r.resourceTiming[s.source] = JSON.parse(JSON.stringify(e)));
                        }
                        i(null, r);
                    }
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded;
                return s && s[e.uid] ? e.partial ? t1(null, void 0) : super.reloadTile(e, t1) : this.loadTile(e, t1);
            }
            loadGeoJSON(t1, s) {
                if (t1.request) e.n(t1.request, s);
                else {
                    if ("string" != typeof t1.data) return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    try {
                        return s(null, JSON.parse(t1.data));
                    } catch (e) {
                        return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterChildren(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterLeaves(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t1(e);
                }
            }
        }
        class Ie {
            constructor(t1, s, i){
                this.tileID = new e.aM(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t1.projection, this.brightness = s, this.worldview = i;
            }
            parse(t1, s, i, o) {
                this.status = "parsing";
                const n = new e.aM(i.tileID.overscaledZ, i.tileID.wrap, i.tileID.canonical.z, i.tileID.canonical.x, i.tileID.canonical.y), r = [], a = s.familiesBySource[i.source], l = new e.f0(n, i.promoteId);
                l.bucketLayerIDs = [], l.is3DTile = !0, e.fi(t1).then((t1)=>{
                    if (!t1) return o(new Error("Could not parse tile"));
                    const s = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("MAPBOX_mesh_features") || t1.json.asset.extras && t1.json.asset.extras.MAPBOX_mesh_features, c = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression"), h = new e.aa(this.zoom, {
                        brightness: this.brightness,
                        worldview: this.worldview
                    });
                    for(const o in a)for (const u of a[o]){
                        const o = u[0];
                        l.bucketLayerIDs.push(u.map((t1)=>e.C(t1.id, t1.scope))), o.recalculate(h, []);
                        const a = e.fj(t1, 1 / e.cU(i.tileID.canonical)), d = new e.fk(u, a, n, s, c, this.brightness, l, this.worldview);
                        s || (d.needsUpload = !0), r.push(d), d.evaluate(o);
                    }
                    this.status = "done", o(null, {
                        buckets: r,
                        featureIndex: l,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: null
                    });
                }).catch((e)=>o(new Error(e.message)));
            }
        }
        class Se {
            constructor(e, t1, s, i, o, n, r, a){
                this.actor = e, this.layerIndex = t1, this.availableImages = s, this.availableModels = i, this.brightness = r, this.loading = {}, this.loaded = {}, this.worldview = a;
            }
            loadTile(t1, s) {
                const i = t1.uid, o = this.loading[i] = new Ie(t1, this.brightness, this.worldview);
                e.br(t1.request, (e, n)=>{
                    const r = !this.loading[i];
                    return delete this.loading[i], r || e ? (o.status = "done", r || (this.loaded[i] = o), s(e)) : n && 0 !== n.byteLength ? void o.parse(n, this.layerIndex, t1, (e, t1)=>{
                        o.status = "done", this.loaded = this.loaded || {}, this.loaded[i] = o, e || !t1 ? s(e) : s(null, t1);
                    }) : (o.status = "done", this.loaded[i] = o, s());
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded, i = e.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.projection = e.projection, o.brightness = e.brightness;
                    const n = (s, i)=>{
                        o.reloadCallback && (delete o.reloadCallback, this.loadTile(e, t1)), t1(s, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = n : "done" === o.status && this.loadTile(e, t1);
                }
            }
            abortTile(e, t1) {
                const s = e.uid;
                this.loading[s] && delete this.loading[s], t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        class Me {
            constructor(t1){
                this.self = t1, this.actor = new e.fm(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new e.y, this.rtlPluginParsingListeners = [], this.projections = {}, this.defaultProjection = e.ce({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: c,
                    geojson: be,
                    "raster-dem": h,
                    "raster-array": d,
                    "batched-model": Se
                }, this.workerSources = {}, this.self.registerWorkerSource = (e, t1)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e.fn.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.fn.setState({
                        pluginStatus: e.fo.parsed,
                        pluginURL: e.fn.getPluginURL()
                    }), e.fn.applyArabicShaping = t1.applyArabicShaping, e.fn.processBidirectionalText = t1.processBidirectionalText, e.fn.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                    for (const e of this.rtlPluginParsingListeners)e(null, !0);
                    this.rtlPluginParsingListeners = [];
                };
            }
            clearCaches(e, t1, s) {
                delete this.layerIndexes[e], delete this.availableImages[e], delete this.availableModels[e], delete this.workerSources[e], s();
            }
            checkIfReady(e, t1, s) {
                s();
            }
            setReferrer(e, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, s) {
                this.isSpriteLoaded[t1] || (this.isSpriteLoaded[t1] = {});
                const { scope: i, isLoaded: o } = s;
                if (this.isSpriteLoaded[t1][i] = o, this.workerSources[t1] && this.workerSources[t1][i]) for(const s in this.workerSources[t1][i]){
                    const n = this.workerSources[t1][i][s];
                    for(const t1 in n){
                        const s = n[t1];
                        s instanceof c && (s.isSpriteLoaded = o, s.fire(new e.A("isSpriteLoaded")));
                    }
                }
            }
            setImages(e, t1, s) {
                this.availableImages[e] || (this.availableImages[e] = {});
                const { scope: i, images: o } = t1;
                if (this.availableImages[e][i] = o, this.workerSources[e] && this.workerSources[e][i]) {
                    for(const t1 in this.workerSources[e][i]){
                        const s = this.workerSources[e][i][t1];
                        for(const e in s)s[e].availableImages = o;
                    }
                    s();
                } else s();
            }
            setModels(e, { scope: t1, models: s }, i) {
                if (this.availableModels[e] || (this.availableModels[e] = {}), this.availableModels[e][t1] = s, this.workerSources[e] && this.workerSources[e][t1]) {
                    for(const i in this.workerSources[e][t1]){
                        const o = this.workerSources[e][t1][i];
                        for(const e in o)o[e].availableModels = s;
                    }
                    i();
                } else i();
            }
            setProjection(t1, s) {
                this.projections[t1] = e.ce(s);
            }
            setBrightness(e, t1, s) {
                this.brightness = t1, s();
            }
            setWorldview(e, t1, s) {
                this.worldview = t1, s();
            }
            setLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).replace(t1.layers, t1.options), s();
            }
            updateLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).update(t1.layers, t1.removedIds, t1.options), s();
            }
            loadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).loadTile(t1, s);
            }
            decodeRasterArray(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).decodeRasterArray(t1, s);
            }
            reloadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).reloadTile(t1, s);
            }
            abortTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).abortTile(t1, s);
            }
            removeTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).removeTile(t1, s);
            }
            removeSource(e, t1, s) {
                if (!(this.workerSources[e] && this.workerSources[e][t1.scope] && this.workerSources[e][t1.scope][t1.type] && this.workerSources[e][t1.scope][t1.type][t1.source])) return;
                const i = this.workerSources[e][t1.scope][t1.type][t1.source];
                delete this.workerSources[e][t1.scope][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, s) : s();
            }
            loadWorkerSource(e, t1, s) {
                try {
                    this.self.importScripts(t1.url), s();
                } catch (e) {
                    s(e.toString());
                }
            }
            syncRTLPluginState(t1, s, i) {
                if (e.fn.isParsed()) i(null, !0);
                else if (e.fn.isParsing()) this.rtlPluginParsingListeners.push(i);
                else try {
                    e.fn.setState(s);
                    const t1 = e.fn.getPluginURL();
                    !e.fn.isLoaded() || e.fn.isParsed() || e.fn.isParsing() || null == t1 || (e.fn.setState({
                        pluginStatus: e.fo.parsing,
                        pluginURL: e.fn.getPluginURL()
                    }), this.self.importScripts(t1), e.fn.isParsed() ? i(null, !0) : this.rtlPluginParsingListeners.push(i));
                } catch (e) {
                    i(e.toString());
                }
            }
            setDracoUrl(e, t1) {
                this.dracoUrl = t1;
            }
            getAvailableImages(e, t1) {
                this.availableImages[e] || (this.availableImages[e] = {});
                let s = this.availableImages[e][t1];
                return s || (s = []), s;
            }
            getAvailableModels(e, t1) {
                this.availableModels[e] || (this.availableModels[e] = {});
                let s = this.availableModels[e][t1];
                return s || (s = {}), s;
            }
            getLayerIndex(e, t1) {
                this.layerIndexes[e] || (this.layerIndexes[e] = {});
                let s = this.layerIndexes[e][t1];
                return s || (s = this.layerIndexes[e][t1] = new o, s.scope = t1), s;
            }
            getWorkerSource(e, t1, s, i) {
                const o = this.workerSources;
                return o[e] || (o[e] = {}), o[e][i] || (o[e][i] = {}), o[e][i][t1] || (o[e][i][t1] = {}), this.isSpriteLoaded[e] || (this.isSpriteLoaded[e] = {}), o[e][i][t1][s] || (o[e][i][t1][s] = new this.workerSourceTypes[t1]({
                    send: (t1, s, i, o, n, r)=>this.actor.send(t1, s, i, e, n, r),
                    scheduler: this.actor.scheduler
                }, this.getLayerIndex(e, i), this.getAvailableImages(e, i), this.getAvailableModels(e, i), this.isSpriteLoaded[e][i], void 0, this.brightness, this.worldview)), o[e][i][t1][s];
            }
            rasterizeImagesWorker(e, t1, s) {
                const i = new Map;
                for (const [s, { image: o, imageVariant: n }] of t1.tasks.entries()){
                    const r = this.imageRasterizer.rasterize(n, o, t1.scope, e);
                    i.set(s, r);
                }
                s(void 0, i);
            }
            removeRasterizedImages(e, t1, s) {
                this.imageRasterizer.removeImagesFromCacheByIds(t1.imageIds, t1.scope, e), s();
            }
            enforceCacheSizeLimit(t1, s) {
                e.fp(s);
            }
            getWorkerPerformanceMetrics(e, t1, s) {
                s(void 0, void 0);
            }
        }
        return e.fl(self) && (self.worker = new Me(self)), Me;
    });
    define([
        "./shared"
    ], function(e) {
        var t1 = "3.13.0";
        const i = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, o = {
            mark (e) {
                performance.mark(e);
            },
            measure (e, t1, i) {
                performance.measure(e, t1, i);
            }
        };
        function s(t1) {
            const i = t1.name.split("?")[0];
            return e.a(i) && i.includes("mapbox-gl.js") ? "javascript" : e.a(i) && i.includes("mapbox-gl.css") ? "css" : e.b(i) ? "fontRange" : e.c(i) ? "sprite" : e.i(i) ? "style" : e.d(i) ? "tilejson" : "other";
        }
        var r, n = {}, a = function() {
            if (r) return n;
            function e(e) {
                return !t1(e);
            }
            function t1(t1) {
                var o;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e = !0;
                    } catch (t1) {
                        e = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e;
                }() ? function() {
                    var e = document.createElement("canvas");
                    e.width = e.height = 1;
                    var t1 = e.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e.width;
                }() ? (void 0 === i[o = t1 && t1.failIfMajorPerformanceCaveat] && (i[o] = function(t1) {
                    var i, o = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.getContext("webgl2", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        i = o.createShader(o.VERTEX_SHADER);
                    } catch (e) {
                        return !1;
                    }
                    return !(!i || o.isContextLost()) && (o.shaderSource(i, "void main() {}"), o.compileShader(i), !0 === o.getShaderParameter(i, o.COMPILE_STATUS));
                }(o)), i[o] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            }
            r = 1, n.supported = e, n.notSupportedReason = t1;
            var i = {};
            return e.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            }, n;
        }();
        function l(e, t1, i) {
            const o = document.createElement(e);
            return null != t1 && (o.className = t1), i && i.appendChild(o), o;
        }
        function c(e, t1, i) {
            const o = document.createElementNS("http://www.w3.org/2000/svg", e);
            for (const e of Object.keys(t1))o.setAttributeNS(null, e, String(t1[e]));
            return i && i.appendChild(o), o;
        }
        const h = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, d = h && void 0 !== h.userSelect ? "userSelect" : "WebkitUserSelect";
        let u;
        function _() {
            h && d && (u = h[d], h[d] = "none");
        }
        function p() {
            h && d && (h[d] = u);
        }
        function f(e) {
            e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function g(e, t1) {
            const i = e.getBoundingClientRect();
            return x(e, i, t1);
        }
        function v(e, t1) {
            const i = e.getBoundingClientRect(), o = [];
            for(let s = 0; s < t1.length; s++)o.push(x(e, i, t1[s]));
            return o;
        }
        function y(e) {
            return /firefox/i.test(navigator.userAgent) && /macintosh/i.test(navigator.userAgent) && 2 === e.button && e.ctrlKey ? 0 : e.button;
        }
        function x(t1, i, o) {
            const s = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e.P((o.clientX - i.left) * s, (o.clientY - i.top) * s);
        }
        const b = "01", w = "NO_ACCESS_TOKEN";
        class T {
            constructor(e, t1, i){
                this._transformRequestFn = e, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e = function() {
                    let e = "";
                    for(let t1 = 0; t1 < 10; t1++)e += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            b,
                            e
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e.token, this._skuTokenExpiresAt = e.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e, t1) {
                return this._transformRequestFn && this._transformRequestFn(e, t1) || {
                    url: e
                };
            }
            normalizeStyleURL(i, o) {
                if (!e.j(i)) return i;
                const s = S(i);
                return s.params.push(`sdk=js-${t1}`), s.path = `/styles/v1${s.path}`, this._makeAPIURL(s, this._customAccessToken || o);
            }
            normalizeGlyphsURL(t1, i) {
                if (!e.j(t1)) return t1;
                const o = S(t1);
                return o.path = `/fonts/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeModelURL(t1, i) {
                if (!e.j(t1)) return t1;
                const o = S(t1);
                return o.path = `/models/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeSourceURL(t1, i, o, s) {
                if (!e.j(t1)) return t1;
                const r = S(t1);
                return r.path = `/v4/${r.authority}.json`, r.params.push("secure"), o && r.params.push(`language=${o}`), s && r.params.push(`worldview=${s}`), this._makeAPIURL(r, this._customAccessToken || i);
            }
            normalizeIconsetURL(t1, i) {
                const o = S(t1);
                return e.j(t1) ? (o.path = `/styles/v1${o.path}/iconset.pbf`, this._makeAPIURL(o, this._customAccessToken || i)) : I(o);
            }
            normalizeSpriteURL(t1, i, o, s) {
                const r = S(t1);
                return e.j(t1) ? (r.path = `/styles/v1${r.path}/sprite${i}${o}`, this._makeAPIURL(r, this._customAccessToken || s)) : (r.path += `${i}${o}`, I(r));
            }
            normalizeTileURL(t1, i, o) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !e.j(t1)) return t1;
                const s = S(t1);
                s.path = s.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i || o && "raster" !== s.authority && 512 === o ? "@2x" : ""}${e.l.supported ? ".webp" : "$1"}`), "raster" === s.authority ? s.path = `/${e.e.RASTER_URL_PREFIX}${s.path}` : "rasterarrays" === s.authority ? s.path = `/${e.e.RASTERARRAYS_URL_PREFIX}${s.path}` : "3dtiles" === s.authority ? s.path = `/${e.e.TILES3D_URL_PREFIX}${s.path}` : (s.path = s.path.replace(/^.+\/v4\//, "/"), s.path = `/${e.e.TILE_URL_VERSION}${s.path}`);
                const r = this._customAccessToken || function(e) {
                    for (const t1 of e){
                        const e = t1.match(/^access_token=(.*)$/);
                        if (e) return e[1];
                    }
                    return null;
                }(s.params) || e.e.ACCESS_TOKEN;
                return e.e.REQUIRE_ACCESS_TOKEN && r && this._skuToken && s.params.push(`sku=${this._skuToken}`), this._makeAPIURL(s, r);
            }
            canonicalizeTileURL(t1, i) {
                const o = S(t1);
                if (!o.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o.path.match(/\.[\w]+$/)) return t1;
                let s = "mapbox://";
                o.path.match(/^\/raster\/v1\//) ? s += `raster/${o.path.replace(`/${e.e.RASTER_URL_PREFIX}/`, "")}` : o.path.match(/^\/rasterarrays\/v1\//) ? s += `rasterarrays/${o.path.replace(`/${e.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : s += `tiles/${o.path.replace(`/${e.e.TILE_URL_VERSION}/`, "")}`;
                let r = o.params;
                return i && (r = r.filter((e)=>!e.match(/^access_token=/))), r.length && (s += `?${r.join("&")}`), s;
            }
            canonicalizeTileset(t1, i) {
                const o = !!i && e.j(i), s = [];
                for (const i of t1.tiles || [])e.k(i) ? s.push(this.canonicalizeTileURL(i, o)) : s.push(i);
                return s;
            }
            _makeAPIURL(t1, i) {
                const o = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", s = S(e.e.API_URL);
                if (t1.protocol = s.protocol, t1.authority = s.authority, "http" === t1.protocol) {
                    const e = t1.params.indexOf("secure");
                    e >= 0 && t1.params.splice(e, 1);
                }
                if ("/" !== s.path && (t1.path = `${s.path}${t1.path}`), !e.e.REQUIRE_ACCESS_TOKEN) return I(t1);
                if (i = i || e.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!i) throw new Error(`An API access token is required to use Mapbox GL. ${o}`);
                    if ("s" === i[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o}`);
                }
                return t1.params = t1.params.filter((e)=>-1 === e.indexOf("access_token")), t1.params.push(`access_token=${i || ""}`), I(t1);
            }
        }
        const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function S(e) {
            const t1 = e.match(E);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function I(e) {
            const t1 = e.params.length ? `?${e.params.join("&")}` : "";
            return `${e.protocol}://${e.authority}${e.path}${t1}`;
        }
        const C = "mapbox.eventData";
        function R(t1) {
            if (!t1) return null;
            const i = t1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(e.m(i[1]));
            } catch (e) {
                return null;
            }
        }
        class D {
            constructor(e){
                this.type = e, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t1) {
                const i = R(e.e.ACCESS_TOKEN);
                let o = "";
                return o = i && i.u ? e.f(i.u) : e.e.ACCESS_TOKEN || "", t1 ? `${C}.${t1}:${o}` : `${C}:${o}`;
            }
            fetchEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid");
                if (t1) try {
                    const e = localStorage.getItem(i);
                    e && (this.eventData = JSON.parse(e));
                    const t1 = localStorage.getItem(o);
                    t1 && (this.anonId = t1);
                } catch (t1) {
                    e.w("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), s = this.anonId;
                if (t1 && s) try {
                    localStorage.setItem(o, s), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i, JSON.stringify(this.eventData));
                } catch (t1) {
                    e.w("Unable to write to LocalStorage");
                }
            }
            processRequests(e) {}
            postEvent(t1, i, o, s) {
                if (!e.e.EVENTS_URL) return;
                const r = S(e.e.EVENTS_URL);
                r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const n = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, a = i ? e.h(n, i) : n, l = {
                    url: I(r),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = e.p(l, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            queueRequest(e, t1) {
                this.queue.push(e), this.processRequests(t1);
            }
        }
        const A = new class extends D {
            constructor(e){
                super("appUserTurnstile"), this._customAccessToken = e;
            }
            postTurnstileEvent(t1, i) {
                e.e.EVENTS_URL && e.e.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>e.j(t1) || e.k(t1)) && this.queueRequest(Date.now(), i);
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const o = R(e.e.ACCESS_TOKEN), s = o ? o.u : e.e.ACCESS_TOKEN;
                let r = s !== this.eventData.tokenU;
                e.v(this.anonId) || (this.anonId = e.u(), r = !0);
                const n = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e = new Date(this.eventData.lastSuccess), t1 = new Date(n), i = (n - this.eventData.lastSuccess) / 864e5;
                    r = r || i >= 1 || i < -1 || e.getDate() !== t1.getDate();
                } else r = !0;
                r ? this.postEvent(n, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e)=>{
                    e || (this.eventData.lastSuccess = n, this.eventData.tokenU = s);
                }, i) : this.processRequests();
            }
        }, L = A.postTurnstileEvent.bind(A), P = new class extends D {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.EVENTS_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: o, timestamp: s } = this.queue.shift();
                o && this.success[o] || (this.anonId || this.fetchEventData(), e.v(this.anonId) || (this.anonId = e.u()), this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e)=>{
                    e ? this.errorCb(e) : o && (this.success[o] = !0);
                }, i));
            }
            remove() {
                this.errorCb = null;
            }
        }, z = P.postMapLoadEvent.bind(P), M = new class extends D {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(t1) {
                let i = this.mapInstanceIdMap.get(t1);
                return i || (i = e.u(), this.mapInstanceIdMap.set(t1, i)), i;
            }
            getEventId(e) {
                const t1 = this.eventIdPerMapInstanceMap.get(e) || 0;
                return this.eventIdPerMapInstanceMap.set(e, t1 + 1), t1;
            }
            postStyleLoadEvent(t1, i) {
                const { map: o, style: s, importedStyles: r } = i;
                if (!e.e.EVENTS_URL || !t1 && !e.e.ACCESS_TOKEN) return;
                const n = this.getMapInstanceId(o), a = {
                    mapInstanceId: n,
                    eventId: this.getEventId(n),
                    style: s
                };
                r.length && (a.importedStyles = r), this.queueRequest({
                    timestamp: Date.now(),
                    payload: a
                }, t1);
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e);
            }
        }, O = M.postStyleLoadEvent.bind(M), F = new class extends D {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(t1, i) {
                e.e.EVENTS_URL && (t1 || e.e.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: i
                }, t1);
            }
            processRequests(o) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: r, performanceData: n } = this.queue.shift(), a = function(o) {
                    const r = performance.getEntriesByType("resource"), n = performance.getEntriesByType("mark"), a = function(e) {
                        const t1 = {};
                        if (e) {
                            for(const i in e)if ("other" !== i) for (const o of e[i]){
                                const e = `${i}ResolveRangeMin`, s = `${i}ResolveRangeMax`, r = `${i}RequestCount`, n = `${i}RequestCachedCount`;
                                t1[e] = Math.min(t1[e] || 1 / 0, o.startTime), t1[s] = Math.max(t1[s] || -1 / 0, o.responseEnd);
                                const a = (e)=>{
                                    void 0 === t1[e] && (t1[e] = 0), ++t1[e];
                                };
                                void 0 !== o.transferSize && 0 === o.transferSize && a(n), a(r);
                            }
                        }
                        return t1;
                    }(function(e, t1) {
                        const i = {};
                        if (e) for (const o of e){
                            const e = t1(o);
                            void 0 === i[e] && (i[e] = []), i[e].push(o);
                        }
                        return i;
                    }(r, s)), l = window.devicePixelRatio, c = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h = c ? c.effectiveType : void 0, d = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, u = (e, t1, i)=>{
                        null != i && e.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e in a)u(d.counters, e, a[e]);
                    if (o.interactionRange[0] !== 1 / 0 && o.interactionRange[1] !== -1 / 0 && (u(d.counters, "interactionRangeMin", o.interactionRange[0]), u(d.counters, "interactionRangeMax", o.interactionRange[1])), n) for (const e of Object.keys(i)){
                        const t1 = i[e], o = n.find((e)=>e.name === t1);
                        o && u(d.counters, t1, o.startTime);
                    }
                    return u(d.counters, "visibilityHidden", o.visibilityHidden), u(d.attributes, "style", function(t1) {
                        if (t1) for (const i of t1){
                            const t1 = i.name.split("?")[0];
                            if (e.i(t1)) {
                                const e = t1.split("/").slice(-2);
                                if (2 === e.length) return `mapbox://styles/${e[0]}/${e[1]}`;
                            }
                        }
                    }(r)), u(d.attributes, "terrainEnabled", o.terrainEnabled ? "true" : "false"), u(d.attributes, "fogEnabled", o.fogEnabled ? "true" : "false"), u(d.attributes, "projection", o.projection), u(d.attributes, "zoom", o.zoom), u(d.metadata, "devicePixelRatio", l), u(d.metadata, "connectionEffectiveType", h), u(d.metadata, "navigatorUserAgent", navigator.userAgent), u(d.metadata, "screenWidth", window.screen.width), u(d.metadata, "screenHeight", window.screen.height), u(d.metadata, "windowWidth", window.innerWidth), u(d.metadata, "windowHeight", window.innerHeight), u(d.metadata, "mapWidth", o.width / l), u(d.metadata, "mapHeight", o.height / l), u(d.metadata, "webglRenderer", o.renderer), u(d.metadata, "webglVendor", o.vendor), u(d.metadata, "sdkVersion", t1), u(d.metadata, "sdkIdentifier", "mapbox-gl-js"), d;
                }(n);
                for (const e of a.metadata);
                for (const e of a.counters);
                for (const e of a.attributes);
                this.postEvent(r, a, ()=>{}, o);
            }
        }, B = F.postPerformanceEvent.bind(F), k = new class extends D {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t1, i, o, s) {
                if (!e.e.API_URL || !e.e.SESSION_PATH) return;
                const r = S(e.e.API_URL + e.e.SESSION_PATH);
                r.params.push(`sku=${i || ""}`), r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const n = {
                    url: I(r),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = e.g(n, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            getSessionAPI(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.SESSION_PATH && e.e.API_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t1, timestamp: i } = this.queue.shift();
                t1 && this.success[t1] || this.getSession(i, this.skuToken, (e)=>{
                    e ? this.errorCb(e) : t1 && (this.success[t1] = !0);
                }, e);
            }
            remove() {
                this.errorCb = null;
            }
        }, N = k.getSessionAPI.bind(k), U = new Set;
        function j(e, t1) {
            t1 ? U.add(e) : U.delete(e);
        }
        class V {
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = {};
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e, t1) {
                this._updatedSourceCaches[e] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e) {
                delete this._updatedSourceCaches[e];
            }
            updateLayer(e) {
                const t1 = e.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e.id), this.setDirty();
            }
            removeLayer(e) {
                const t1 = e.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e.id] = e, this._updatedLayers[t1].delete(e.id), this._updatedPaintProps.delete(e.fqid), this.setDirty();
            }
            getRemovedLayer(e) {
                return this._removedLayers[e.scope] ? this._removedLayers[e.scope][e.id] : null;
            }
            discardLayerRemoval(e) {
                this._removedLayers[e.scope] && delete this._removedLayers[e.scope][e.id];
            }
            getLayerUpdatesByScope() {
                const e = {};
                for(const t1 in this._updatedLayers)e[t1] = e[t1] || {}, e[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e[t1] = e[t1] || {}, e[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e) {
                this._updatedPaintProps.add(e.fqid), this.setDirty();
            }
            getUpdatedImages(e) {
                return this._updatedImages[e] ? Array.from(this._updatedImages[e].values()) : [];
            }
            updateImage(t1, i) {
                this._updatedImages[i] = this._updatedImages[i] || new Set, this._updatedImages[i].add(e.I.toString(t1)), this.setDirty();
            }
            resetUpdatedImages(e) {
                this._updatedImages[e] && this._updatedImages[e].clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages = {};
            }
        }
        function G(e) {
            const { userImage: t1 } = e;
            return !!(t1 && t1.render && t1.render()) && (e.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class q extends e.E {
            constructor(t1){
                super(), this.imageProviders = new Map, this.images = new Map, this.updatedImages = new Map, this.callbackDispatchedThisFrame = new Map, this.loaded = new Map, this.requestors = [], this.patterns = new Map, this.patternsInFlight = new Set, this.atlasImage = new Map, this.atlasTexture = new Map, this.dirty = !0, this.spriteFormat = t1, "raster" !== t1 && e.t() && (this.imageRasterizerDispatcher = new e.D(e.x(), this, "Image Rasterizer Worker", 1));
            }
            addScope(t1) {
                this.loaded.set(t1, !1), this.imageProviders.set(t1, new Map), this.images.set(t1, new Map), this.updatedImages.set(t1, new Set), this.callbackDispatchedThisFrame.set(t1, new Set), this.patterns.set(t1, new Map), this.atlasImage.set(t1, new e.r({
                    width: 1,
                    height: 1
                }));
            }
            removeScope(e) {
                this.loaded.delete(e), this.imageProviders.delete(e), this.images.delete(e), this.updatedImages.delete(e), this.callbackDispatchedThisFrame.delete(e), this.patterns.delete(e), this.atlasImage.delete(e);
                const t1 = this.atlasTexture.get(e);
                t1 && (t1.destroy(), this.atlasTexture.delete(e));
            }
            addImageProvider(e, t1) {
                this.imageProviders.has(t1) || this.imageProviders.set(t1, new Map), this.imageProviders.get(t1).set(e.id, e);
            }
            removeImageProvider(e, t1) {
                this.imageProviders.has(t1) && this.imageProviders.get(t1).delete(e);
            }
            getPendingImageProviders() {
                const e = [];
                for (const t1 of this.imageProviders.values())for (const i of t1.values())i.hasPendingRequests() && e.push(i);
                return e;
            }
            get imageRasterizer() {
                return this._imageRasterizer || (this._imageRasterizer = new e.y), this._imageRasterizer;
            }
            isLoaded() {
                for (const e of this.loaded.keys())if (!this.loaded.get(e)) return !1;
                return !0;
            }
            setLoaded(e, t1) {
                if (this.loaded.get(t1) !== e && (this.loaded.set(t1, e), e)) {
                    for (const { ids: e, callback: i } of this.requestors)this._notify(e, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e, t1) {
                return !!this.getImage(e, t1);
            }
            getImage(e, t1) {
                return this.images.get(t1).get(e.toString());
            }
            addImage(e, t1, i) {
                this._validate(e, i) && this.images.get(t1).set(e.toString(), i);
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e, t1) {
                if (!e) return !0;
                let i = 0;
                for (const o of e){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e, t1) {
                if (!e) return !0;
                if (4 !== e.length) return !1;
                if (!t1.usvg) {
                    if (e[0] < 0 || t1.data.width < e[0]) return !1;
                    if (e[1] < 0 || t1.data.height < e[1]) return !1;
                    if (e[2] < 0 || t1.data.width < e[2]) return !1;
                    if (e[3] < 0 || t1.data.height < e[3]) return !1;
                }
                return !(e[2] < e[0] || e[3] < e[1]);
            }
            updateImage(e, t1, i) {
                const o = this.images.get(t1).get(e.toString());
                i.version = o.version + 1, this.images.get(t1).set(e.toString(), i), this.updatedImages.get(t1).add(e), this.removeFromImageRasterizerCache(e, t1);
            }
            clearUpdatedImages(e) {
                this.updatedImages.get(e).clear();
            }
            removeFromImageRasterizerCache(t1, i) {
                "raster" !== this.spriteFormat && (e.t() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", {
                    imageIds: [
                        t1
                    ],
                    scope: i
                }) : this.imageRasterizer.removeImagesFromCacheByIds([
                    t1
                ], i));
            }
            removeImage(e, t1) {
                const i = this.images.get(t1), o = i.get(e.toString());
                i.delete(e.toString()), this.patterns.get(t1).delete(e.toString()), this.removeFromImageRasterizerCache(e, t1), o.userImage && o.userImage.onRemove && o.userImage.onRemove();
            }
            listImages(t1) {
                return Array.from(this.images.get(t1).keys()).map((t1)=>e.I.from(t1));
            }
            getImages(e, t1, i) {
                const o = [], s = [], r = this.imageProviders.get(t1);
                for (const i of e){
                    if (!i.iconsetId) {
                        o.push(i);
                        continue;
                    }
                    const e = r.get(i.iconsetId);
                    e && (this.getImage(i, t1) ? s.push(i) : e.addPendingRequest(i));
                }
                if (0 === o.length) return void this._notify(s, t1, i);
                let n = !0;
                const a = !!this.loaded.get(t1), l = this.images.get(t1);
                if (!a) for (const e of o)l.has(e.toString()) || (n = !1);
                a || n ? this._notify(o, t1, i) : this.requestors.push({
                    ids: o,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages(e, t1) {
                const i = new Map, { tasks: o, scope: s } = e;
                for (const [e, t1] of o.entries()){
                    const o = this.getImage(t1.id, s);
                    o && i.set(e, {
                        image: o,
                        imageVariant: t1
                    });
                }
                this._rasterizeImages(s, i, t1);
            }
            _rasterizeImages(t1, i, o) {
                if (e.t()) this.imageRasterizerDispatcher.getActor().send("rasterizeImagesWorker", {
                    tasks: i,
                    scope: t1
                }, o);
                else {
                    const e = new Map;
                    for (const [o, { image: s, imageVariant: r }] of i.entries())e.set(o, this.imageRasterizer.rasterize(r, s, t1, 0));
                    o(void 0, e);
                }
            }
            getUpdatedImages(e) {
                return this.updatedImages.get(e) || new Set;
            }
            _notify(t1, i, o) {
                const s = this.images.get(i), r = new Map;
                for (const i of t1){
                    if (!s.get(i.toString())) {
                        if (i.iconsetId) continue;
                        this.fire(new e.A("styleimagemissing", {
                            id: i.name
                        }));
                    }
                    const t1 = s.get(i.toString());
                    if (!t1) {
                        e.w(`Image "${i.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                        continue;
                    }
                    const o = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        version: t1.version,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    };
                    t1.usvg && Object.assign(o, {
                        width: t1.icon.usvg_tree.width,
                        height: t1.icon.usvg_tree.height
                    }), r.set(e.I.toString(i), o);
                }
                o(null, r);
            }
            getPixelSize(e) {
                const { width: t1, height: i } = this.atlasImage.get(e);
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, o) {
                const s = t1.toString(), r = this.patterns.get(i), n = r.get(s), a = this.getImage(t1, i);
                if (!a) return null;
                if (n) {
                    if (n.position.version === a.version) return n.position;
                    n.position.version = a.version;
                } else {
                    if (a.usvg && !a.data) {
                        const r = this.getPatternInFlightId(s, i);
                        if (this.patternsInFlight.has(r)) return null;
                        this.patternsInFlight.add(r);
                        const n = new e.B(t1).scaleSelf(e.q.devicePixelRatio), l = new Map([
                            [
                                n.toString(),
                                {
                                    image: a,
                                    imageVariant: n
                                }
                            ]
                        ]);
                        return this._rasterizeImages(i, l, (e, t1)=>this.storePatternImage(n, i, a, o, t1)), null;
                    }
                    this.storePattern(t1, i, a);
                }
                return this._updatePatternAtlas(i, o), r.get(s).position;
            }
            getPatternInFlightId(t1, i) {
                return e.C(t1, i);
            }
            hasPatternsInFlight() {
                return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e, t1, i, o, s) {
                const r = e.toString(), n = s ? s.get(r) : void 0;
                n && (i.data = n, this.storePattern(e.id, t1, i), this._updatePatternAtlas(t1, o), this.patternsInFlight.delete(this.getPatternInFlightId(e.id.toString(), t1)));
            }
            storePattern(t1, i, o) {
                const s = {
                    w: o.data.width + 2 * e.F,
                    h: o.data.height + 2 * e.F,
                    x: 0,
                    y: 0
                }, r = new e.G(s, o, e.F);
                this.patterns.get(i).set(t1.toString(), {
                    bin: s,
                    position: r
                });
            }
            bind(t1, i) {
                const o = t1.gl;
                let s = this.atlasTexture.get(i);
                s ? this.dirty && (s.update(this.atlasImage.get(i)), this.dirty = !1) : (s = new e.T(t1, this.atlasImage.get(i), o.RGBA8), this.atlasTexture.set(i, s)), s.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const o = this.patterns.get(t1), s = Array.from(o.values()).map(({ bin: e })=>e), { w: r, h: n } = e.H(s), a = this.atlasImage.get(t1);
                a.resize({
                    width: r || 1,
                    height: n || 1
                });
                const l = this.images.get(t1);
                for (const [t1, { bin: s, position: r }] of o.entries()){
                    let o = r.padding;
                    const n = s.x + o, c = s.y + o, h = l.get(t1).data, d = h.width, u = h.height;
                    o = o > 1 ? o - 1 : o, e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c
                    }, {
                        width: d,
                        height: u
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: u - o
                    }, {
                        x: n,
                        y: c - o
                    }, {
                        width: d,
                        height: o
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c + u
                    }, {
                        width: d,
                        height: o
                    }, i), e.r.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: n - o,
                        y: c
                    }, {
                        width: o,
                        height: u
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c
                    }, {
                        width: o,
                        height: u
                    }, i), e.r.copy(h, a, {
                        x: d - o,
                        y: u - o
                    }, {
                        x: n - o,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: u - o
                    }, {
                        x: n + d,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c + u
                    }, {
                        width: o,
                        height: o
                    }, i), e.r.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: n - o,
                        y: c + u
                    }, {
                        width: o,
                        height: o
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for (const e of this.images.keys())this.callbackDispatchedThisFrame.set(e, new Set);
            }
            dispatchRenderCallbacks(e, t1) {
                const i = this.images.get(t1);
                for (const o of e){
                    if (this.callbackDispatchedThisFrame.get(t1).has(o.toString())) continue;
                    this.callbackDispatchedThisFrame.get(t1).add(o.toString());
                    const e = i.get(o.toString());
                    G(e) && this.updateImage(o, t1, e);
                }
            }
        }
        function Z(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec || {}, r = t1.objectElementValidators || {}, n = t1.style, a = t1.styleSpec;
            let l = [];
            const c = e.J(o);
            if ("object" !== c) return [
                new e.V(i, o, `object expected, ${c} found`)
            ];
            for(const t1 in o){
                const c = t1.split(".")[0];
                let h;
                r[c] ? h = r[c] : s[c] ? h = _e : r["*"] ? h = r["*"] : s["*"] && (h = _e), h ? l = l.concat(h({
                    key: (i ? `${i}.` : i) + t1,
                    value: o[t1],
                    valueSpec: s[c] || s["*"],
                    style: n,
                    styleSpec: a,
                    object: o,
                    objectKey: t1
                }, o)) : l.push(new e.K(i, o[t1], `unknown property "${t1}"`));
            }
            for(const t1 in s)r[t1] || s[t1].required && void 0 === s[t1].default && void 0 === o[t1] && l.push(new e.V(i, o, `missing required property "${t1}"`));
            return l;
        }
        function H(t1) {
            const i = t1.value, o = t1.valueSpec, s = t1.style, r = t1.styleSpec, n = t1.key, a = t1.arrayElementValidator || _e;
            if ("array" !== e.J(i)) return [
                new e.V(n, i, `array expected, ${e.J(i)} found`)
            ];
            if (o.length && i.length !== o.length) return [
                new e.V(n, i, `array length ${o.length} expected, length ${i.length} found`)
            ];
            if (o["min-length"] && i.length < o["min-length"]) return [
                new e.V(n, i, `array length at least ${o["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: o.value,
                values: o.values,
                minimum: o.minimum,
                maximum: o.maximum,
                function: void 0
            };
            r.$version < 7 && (l.function = o.function), "object" === e.J(o.value) && (l = o.value);
            let c = [];
            for(let e = 0; e < i.length; e++)c = c.concat(a({
                array: i,
                arrayIndex: e,
                value: i[e],
                valueSpec: l,
                style: s,
                styleSpec: r,
                key: `${n}[${e}]`
            }, !0));
            return c;
        }
        function W(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec;
            let r = e.J(o);
            if ("number" === r && o != o && (r = "NaN"), "number" !== r) return [
                new e.V(i, o, `number expected, ${r} found`)
            ];
            if ("minimum" in s) {
                let r = s.minimum;
                if ("array" === e.J(s.minimum) && (r = s.minimum[t1.arrayIndex]), o < r) return [
                    new e.V(i, o, `${o} is less than the minimum value ${r}`)
                ];
            }
            if ("maximum" in s) {
                let r = s.maximum;
                if ("array" === e.J(s.maximum) && (r = s.maximum[t1.arrayIndex]), o > r) return [
                    new e.V(i, o, `${o} is greater than the maximum value ${r}`)
                ];
            }
            return [];
        }
        function $(t1) {
            const i = t1.valueSpec, o = e.M(t1.value.type);
            let s, r, n, a = {};
            const l = "categorical" !== o && void 0 === t1.value.property, c = !l, h = "array" === e.J(t1.value.stops) && "array" === e.J(t1.value.stops[0]) && "object" === e.J(t1.value.stops[0][0]), d = Z({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === o) return [
                            new e.V(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let i = [];
                        const s = t1.value;
                        return i = i.concat(H({
                            key: t1.key,
                            value: s,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: u
                        })), "array" === e.J(s) && 0 === s.length && i.push(new e.V(t1.key, s, "array must have at least one stop")), i;
                    },
                    default: function(e) {
                        return _e({
                            key: e.key,
                            value: e.value,
                            valueSpec: i,
                            style: e.style,
                            styleSpec: e.styleSpec
                        });
                    }
                }
            });
            return "identity" === o && l && d.push(new e.V(t1.key, t1.value, 'missing required property "property"')), "identity" === o || t1.value.stops || d.push(new e.V(t1.key, t1.value, 'missing required property "stops"')), "exponential" === o && t1.valueSpec.expression && !e.N(t1.valueSpec) && d.push(new e.V(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (c && !e.O(t1.valueSpec) ? d.push(new e.V(t1.key, t1.value, "property functions not supported")) : l && !e.Q(t1.valueSpec) && d.push(new e.V(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== o && !h || void 0 !== t1.value.property || d.push(new e.V(t1.key, t1.value, '"property" property is required')), d;
            function u(t1) {
                let o = [];
                const s = t1.value, l = t1.key;
                if ("array" !== e.J(s)) return [
                    new e.V(l, s, `array expected, ${e.J(s)} found`)
                ];
                if (2 !== s.length) return [
                    new e.V(l, s, `array length 2 expected, length ${s.length} found`)
                ];
                if (h) {
                    if ("object" !== e.J(s[0])) return [
                        new e.V(l, s, `object expected, ${e.J(s[0])} found`)
                    ];
                    if (void 0 === s[0].zoom) return [
                        new e.V(l, s, "object stop key must have zoom")
                    ];
                    if (void 0 === s[0].value) return [
                        new e.V(l, s, "object stop key must have value")
                    ];
                    const i = e.M(s[0].zoom);
                    if ("number" != typeof i) return [
                        new e.V(l, s[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (n && n > i) return [
                        new e.V(l, s[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    i !== n && (n = i, r = void 0, a = {}), o = o.concat(Z({
                        key: `${l}[0]`,
                        value: s[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: W,
                            value: _
                        }
                    }));
                } else o = o.concat(_({
                    key: `${l}[0]`,
                    value: s[0],
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, s));
                return e.S(e.U(s[1])) ? o.concat([
                    new e.V(`${l}[1]`, s[1], "expressions are not allowed in function stops.")
                ]) : o.concat(_e({
                    key: `${l}[1]`,
                    value: s[1],
                    valueSpec: i,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function _(t1, n) {
                const l = e.J(t1.value), c = e.M(t1.value), h = null !== t1.value ? t1.value : n;
                if (s) {
                    if (l !== s) return [
                        new e.V(t1.key, h, `${l} stop domain type must match previous stop domain type ${s}`)
                    ];
                } else s = l;
                if ("number" !== l && "string" !== l && "boolean" !== l && "number" != typeof c && "string" != typeof c && "boolean" != typeof c) return [
                    new e.V(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== l && "categorical" !== o) {
                    let s = `number expected, ${l} found`;
                    return e.O(i) && void 0 === o && (s += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new e.V(t1.key, h, s)
                    ];
                }
                return "categorical" !== o || "number" !== l || "number" == typeof c && isFinite(c) && Math.floor(c) === c ? "categorical" !== o && "number" === l && "number" == typeof c && "number" == typeof r && void 0 !== r && c < r ? [
                    new e.V(t1.key, h, "stop domain values must appear in ascending order")
                ] : (r = c, "categorical" === o && c in a ? [
                    new e.V(t1.key, h, "stop domain values must be unique")
                ] : (a[c] = !0, [])) : [
                    new e.V(t1.key, h, `integer expected, found ${String(c)}`)
                ];
            }
        }
        function X(t1) {
            const i = ("property" === t1.expressionContext ? e.W : e.X)(e.U(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((i)=>new e.V(`${t1.key}${i.key}`, t1.value, i.message));
            const o = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !o.outputDefined()) return [
                new e.V(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e.Y(o)) return [
                new e.V(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return Y(o, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e.Z(o, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new e.V(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e._(o)) return [
                    new e.V(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Y(t1, i) {
            const o = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e of i.valueSpec.expression.parameters)o.delete(e);
            if (0 === o.size) return [];
            const s = [];
            return t1 instanceof e.$ && o.has(t1.name) ? [
                new e.V(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e)=>{
                s.push(...Y(e, i));
            }), s);
        }
        function K(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec, r = [];
            return Array.isArray(s.values) ? -1 === s.values.indexOf(e.M(o)) && r.push(new e.V(i, o, `expected one of [${s.values.join(", ")}], ${JSON.stringify(o)} found`)) : -1 === Object.keys(s.values).indexOf(e.M(o)) && r.push(new e.V(i, o, `expected one of [${Object.keys(s.values).join(", ")}], ${JSON.stringify(o)} found`)), r;
        }
        function J(t1) {
            return e.a1(e.U(t1.value)) ? X(e.L({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : Q(t1);
        }
        function Q(t1) {
            const i = t1.value, o = t1.key;
            if ("array" !== e.J(i)) return [
                new e.V(o, i, `array expected, ${e.J(i)} found`)
            ];
            const s = t1.styleSpec;
            let r, n = [];
            if (i.length < 1) return [
                new e.V(o, i, "filter array must have at least 1 element")
            ];
            switch(n = n.concat(K({
                key: `${o}[0]`,
                value: i[0],
                valueSpec: s.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), e.M(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e.M(i[1]) && n.push(new e.V(o, i, `"$type" cannot be use with operator "${i[0]}"`));
                case "==":
                case "!=":
                    3 !== i.length && n.push(new e.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    i.length >= 2 && (r = e.J(i[1]), "string" !== r && n.push(new e.V(`${o}[1]`, i[1], `string expected, ${r} found`)));
                    for(let a = 2; a < i.length; a++)r = e.J(i[a]), "$type" === e.M(i[1]) ? n = n.concat(K({
                        key: `${o}[${a}]`,
                        value: i[a],
                        valueSpec: s.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== r && "number" !== r && "boolean" !== r && n.push(new e.V(`${o}[${a}]`, i[a], `string, number, or boolean expected, ${r} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e = 1; e < i.length; e++)n = n.concat(Q({
                        key: `${o}[${e}]`,
                        value: i[e],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    r = e.J(i[1]), 2 !== i.length ? n.push(new e.V(o, i, `filter array for "${i[0]}" operator must have 2 elements`)) : "string" !== r && n.push(new e.V(`${o}[1]`, i[1], `string expected, ${r} found`));
            }
            return n;
        }
        function ee(t1, i) {
            const o = t1.key, s = t1.style, r = t1.layer, n = t1.styleSpec, a = t1.value, l = t1.objectKey, c = n[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(/^(.*)-use-theme$/);
            if ("paint" === i && h && c[h[1]]) return e.S(a) ? [].concat(_e({
                key: t1.key,
                value: a,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: s,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : _e({
                key: o,
                value: a,
                valueSpec: {
                    type: "string"
                },
                style: s,
                styleSpec: n
            });
            const d = l.match(/^(.*)-transition$/);
            if ("paint" === i && d && c[d[1]] && c[d[1]].transition) return _e({
                key: o,
                value: a,
                valueSpec: n.transition,
                style: s,
                styleSpec: n
            });
            const u = t1.valueSpec || c[l];
            if (!u) return [
                new e.K(o, a, `unknown property "${l}"`)
            ];
            let _;
            if ("string" === e.J(a) && e.O(u) && !u.tokens && (_ = /^{([^}]+)}$/.exec(a))) {
                const t1 = `\`{ "type": "identity", "property": ${_ ? JSON.stringify(_[1]) : '"_"'} }\``;
                return [
                    new e.V(o, a, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${t1}.`)
                ];
            }
            const p = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !s || s.glyphs || s.imports || p.push(new e.V(o, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e.a2(e.U(a)) && "identity" === e.M(a.type) && p.push(new e.V(o, a, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && r && r.layout && r.layout.hasOwnProperty("model-id") && e.O(u) && (e.a3(u) || e.Q(u))) {
                const t1 = e.W(e.U(a), u), i = t1.value.expression || t1.value._styleExpression.expression;
                i && !e.Z(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e._(i) && e.Y(i) || p.push(new e.V(o, a, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return p.concat(_e({
                key: t1.key,
                value: a,
                valueSpec: u,
                style: s,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function te(e) {
            return ee(e, "paint");
        }
        function ie(e) {
            return ee(e, "layout");
        }
        function oe(t1) {
            let i = [];
            const o = t1.value, s = t1.key, r = t1.style, n = t1.styleSpec;
            o.type || o.ref || i.push(new e.V(s, o, 'either "type" or "ref" is required'));
            let a = e.M(o.type);
            const l = e.M(o.ref);
            if (o.id) {
                const n = e.M(o.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = r.layers[a];
                    e.M(t1.id) === n && i.push(new e.V(s, o.id, `duplicate layer id "${o.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in o) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in o && i.push(new e.V(s, o[t1], `"${t1}" is prohibited for ref layers`));
                }), r.layers.forEach((i)=>{
                    e.M(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new e.V(s, o.ref, "ref cannot reference another ref layer")) : a = e.M(t1.type) : "string" == typeof l && i.push(new e.V(s, o.ref, `ref layer "${l}" not found`));
            } else if ("background" !== a && "sky" !== a && "slot" !== a) {
                if (o.source) {
                    const t1 = r.sources && r.sources[o.source], n = t1 && e.M(t1.type);
                    t1 ? "vector" === n && "raster" === a ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a raster source`)) : "raster" === n && "raster" !== a ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a vector source`)) : "vector" !== n || o["source-layer"] ? "raster-dem" === n && "hillshade" !== a ? i.push(new e.V(s, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n || [
                        "raster",
                        "raster-particle"
                    ].includes(a) ? "line" === a && o.paint && (o.paint["line-gradient"] || o.paint["line-trim-offset"]) && "geojson" === n && !t1.lineMetrics ? i.push(new e.V(s, o, `layer "${o.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a && "raster-array" !== n && i.push(new e.V(s, o.source, `layer "${o.id}" requires a 'raster-array' source.`)) : i.push(new e.V(s, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e.V(s, o, `layer "${o.id}" must specify a "source-layer"`)) : i.push(new e.V(s, o.source, `source "${o.source}" not found`));
                } else i.push(new e.V(s, o, 'missing required property "source"'));
            }
            return i = i.concat(Z({
                key: s,
                value: o,
                valueSpec: n.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>_e({
                            key: `${s}.type`,
                            value: o.type,
                            valueSpec: n.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: o,
                            objectKey: "type"
                        }),
                    filter: (t1)=>J(e.L({
                            layerType: a
                        }, t1)),
                    layout: (t1)=>Z({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>ie(e.L({
                                        layerType: a
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Z({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>te(e.L({
                                        layerType: a,
                                        layer: o
                                    }, t1))
                            }
                        })
                }
            })), i;
        }
        function se(t1) {
            const i = t1.value, o = t1.key, s = e.J(i);
            return "string" !== s ? [
                new e.V(o, i, `string expected, ${s} found`)
            ] : [];
        }
        const re = {
            promoteId: function t1({ key: i, value: o }) {
                if ("string" === e.J(o)) return se({
                    key: i,
                    value: o
                });
                if (Array.isArray(o)) {
                    const t1 = [], s = e.U(o), r = e.X(s);
                    return "error" === r.result && r.value.forEach((o)=>{
                        t1.push(new e.V(`${i}${o.key}`, null, `${o.message}`));
                    }), e.Z(r.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new e.V(`${i}`, null, "promoteId expression should be only feature dependent")), t1;
                }
                {
                    const e = [];
                    for(const s in o)e.push(...t1({
                        key: `${i}.${s}`,
                        value: o[s]
                    }));
                    return e;
                }
            }
        };
        function ne(t1) {
            const i = t1.value, o = t1.key, s = t1.styleSpec, r = t1.style;
            if (!i.type) return [
                new e.V(o, i, '"type" is required')
            ];
            const n = e.M(i.type);
            let a = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(n) && (i.url || i.tiles || a.push(new e.K(o, i, 'Either "url" or "tiles" is required.'))), n){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return a = a.concat(Z({
                        key: o,
                        value: i,
                        valueSpec: s[`source_${n.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: s,
                        objectElementValidators: re
                    })), a;
                case "geojson":
                    if (a = Z({
                        key: o,
                        value: i,
                        valueSpec: s.source_geojson,
                        style: r,
                        styleSpec: s,
                        objectElementValidators: re
                    }), i.cluster) for(const e in i.clusterProperties){
                        const [t1, s] = i.clusterProperties[e], r = "string" == typeof t1 ? [
                            t1,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e
                            ]
                        ] : t1;
                        a.push(...X({
                            key: `${o}.${e}.map`,
                            value: s,
                            expressionContext: "cluster-map"
                        })), a.push(...X({
                            key: `${o}.${e}.reduce`,
                            value: r,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return Z({
                        key: o,
                        value: i,
                        valueSpec: s.source_video,
                        style: r,
                        styleSpec: s
                    });
                case "image":
                    return Z({
                        key: o,
                        value: i,
                        valueSpec: s.source_image,
                        style: r,
                        styleSpec: s
                    });
                case "canvas":
                    return [
                        new e.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return K({
                        key: `${o}.type`,
                        value: i.type,
                        valueSpec: {
                            values: ae(s)
                        }
                    });
            }
        }
        function ae(e) {
            return e.source.reduce((t1, i)=>{
                const o = e[i];
                return "enum" === o.type.type && (t1 = t1.concat(Object.keys(o.type.values))), t1;
            }, []);
        }
        function le(t1) {
            const i = t1.value, o = t1.styleSpec, s = o.light, r = t1.style;
            let n = [];
            const a = e.J(i);
            if (void 0 === i) return n;
            if ("object" !== a) return n = n.concat([
                new e.V("light", i, `object expected, ${a} found`)
            ]), n;
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                n = n.concat(l && s[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: o
                }) : a && s[a[1]] && s[a[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: r,
                    styleSpec: o
                }) : s[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s[t1],
                    style: r,
                    styleSpec: o
                }) : [
                    new e.V(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        function ce(t1) {
            const i = t1.value;
            let o = [];
            if (!i) return o;
            const s = e.J(i);
            if ("object" !== s) return o = o.concat([
                new e.V("light-3d", i, `object expected, ${s} found`)
            ]), o;
            const r = t1.styleSpec, n = r["light-3d"], a = t1.key, l = t1.style, c = t1.style.lights;
            for (const t1 of [
                "type",
                "id"
            ])if (!(t1 in i)) return o = o.concat([
                new e.V("light-3d", i, `missing property ${t1} on light`)
            ]), o;
            if (i.type && c) for(let s = 0; s < t1.arrayIndex; s++){
                const t1 = e.M(i.type), r = c[s];
                e.M(r.type) === t1 && o.push(new e.V(a, i.id, `duplicate light type "${i.type}", previously defined at line ${r.id.__line__}`));
            }
            const h = `properties_light_${i.type}`;
            if (!(h in r)) return o = o.concat([
                new e.V("light-3d", i, `Invalid light type ${i.type}`)
            ]), o;
            const d = r[h];
            for(const s in i)if ("properties" === s) {
                const n = i[s], a = e.J(n);
                if ("object" !== a) return o = o.concat([
                    new e.V("properties", n, `object expected, ${a} found`)
                ]), o;
                for(const a in n){
                    const c = a.match(/^(.*)-transition$/), h = a.match(/^(.*)-use-theme$/);
                    o = o.concat(h && d[h[1]] ? _e({
                        key: s,
                        value: n[a],
                        valueSpec: {
                            type: "string"
                        },
                        style: l,
                        styleSpec: r
                    }) : c && d[c[1]] && d[c[1]].transition ? _e({
                        key: s,
                        value: i[s],
                        valueSpec: r.transition,
                        style: l,
                        styleSpec: r
                    }) : d[a] ? _e({
                        key: a,
                        value: n[a],
                        valueSpec: d[a],
                        style: l,
                        styleSpec: r
                    }) : [
                        new e.K(t1.key, n[a], `unknown property "${a}"`)
                    ]);
                }
            } else o = o.concat(n[s] ? _e({
                key: s,
                value: i[s],
                valueSpec: n[s],
                style: l,
                styleSpec: r
            }) : [
                new e.K(s, i[s], `unknown property "${s}"`)
            ]);
            return o;
        }
        function he(t1) {
            const i = t1.value, o = t1.key, s = t1.style, r = t1.styleSpec, n = r.terrain;
            let a = [];
            const l = e.J(i);
            if (void 0 === i) return a;
            if ("null" === l) return a;
            if ("object" !== l) return a = a.concat([
                new e.V("terrain", i, `object expected, ${l} found`)
            ]), a;
            for(const t1 in i){
                const o = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                a = a.concat(l && n[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: s,
                    styleSpec: r
                }) : o && n[o[1]] && n[o[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: s,
                    styleSpec: r
                }) : n[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: n[t1],
                    style: s,
                    styleSpec: r
                }) : [
                    new e.K(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                const t1 = s.sources && s.sources[i.source], r = t1 && e.M(t1.type);
                t1 ? "raster-dem" !== r && a.push(new e.V(o, i.source, `terrain cannot be used with a source of type ${String(r)}, it only be used with a "raster-dem" source type`)) : a.push(new e.V(o, i.source, `source "${i.source}" not found`));
            } else a.push(new e.V(o, i, 'terrain is missing required property "source"'));
            return a;
        }
        function de(t1) {
            const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.fog;
            let n = [];
            const a = e.J(i);
            if (void 0 === i) return n;
            if ("object" !== a) return n = n.concat([
                new e.V("fog", i, `object expected, ${a} found`)
            ]), n;
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                n = n.concat(l && r[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: s
                }) : a && r[a[1]] && r[a[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: o,
                    styleSpec: s
                }) : r[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: o,
                    styleSpec: s
                }) : [
                    new e.K(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        const ue = {
            "*": ()=>[],
            array: H,
            boolean: function(t1) {
                const i = t1.value, o = t1.key, s = e.J(i);
                return "boolean" !== s ? [
                    new e.V(o, i, `boolean expected, ${s} found`)
                ] : [];
            },
            number: W,
            color: function(t1) {
                const i = t1.key, o = t1.value, s = e.J(o);
                return "string" !== s ? [
                    new e.V(i, o, `color expected, ${s} found`)
                ] : null === e.a0.parseCSSColor(o) ? [
                    new e.V(i, o, `color expected, "${o}" found`)
                ] : [];
            },
            enum: K,
            filter: J,
            function: $,
            layer: oe,
            object: Z,
            source: ne,
            model: e.a4,
            light: le,
            "light-3d": ce,
            terrain: he,
            fog: de,
            string: se,
            formatted: function(e) {
                return 0 === se(e).length ? [] : X(e);
            },
            resolvedImage: function(e) {
                return 0 === se(e).length ? [] : X(e);
            },
            projection: function(t1) {
                const i = t1.value, o = t1.styleSpec, s = o.projection, r = t1.style;
                let n = [];
                const a = e.J(i);
                if ("object" === a) for(const e in i)n = n.concat(_e({
                    key: e,
                    value: i[e],
                    valueSpec: s[e],
                    style: r,
                    styleSpec: o
                }));
                else "string" !== a && (n = n.concat([
                    new e.V("projection", i, `object or string expected, ${a} found`)
                ]));
                return n;
            },
            import: function(t1) {
                const { value: i, styleSpec: o } = t1, { data: s, ...r } = i;
                Object.defineProperty(r, "__line__", {
                    value: i.__line__,
                    enumerable: !1
                });
                let n = Z(e.L({}, t1, {
                    value: r,
                    valueSpec: o.import
                }));
                return "" === e.M(r.id) && n.push(new e.V(`${t1.key}.id`, r, "import id can't be an empty string")), s && (n = n.concat(fe(s, o, {
                    key: `${t1.key}.data`
                }))), n;
            },
            iconset: function(t1) {
                const i = t1.value, o = t1.key, s = t1.styleSpec, r = t1.style;
                if (!i.type) return [
                    new e.V(o, i, '"type" is required')
                ];
                const n = e.M(i.type);
                let a = [];
                if (a = a.concat(Z({
                    key: o,
                    value: i,
                    valueSpec: s[`iconset_${n}`],
                    style: r,
                    styleSpec: s
                })), "source" === n && i.source) {
                    const t1 = r.sources && r.sources[i.source], s = t1 && e.M(t1.type);
                    t1 ? "raster-array" !== s && a.push(new e.V(o, i.source, `iconset cannot be used with a source of type ${String(s)}, it only be used with a "raster-array" source type`)) : a.push(new e.V(o, i.source, `source "${i.source}" not found`));
                }
                return a;
            }
        };
        function _e(t1, i = !1) {
            const o = t1.value, s = t1.valueSpec, r = t1.styleSpec;
            if (s.expression && e.a2(e.M(o))) return $(t1);
            if (s.expression && e.S(e.U(o))) return X(t1);
            if (s.type && ue[s.type]) {
                const o = ue[s.type](t1);
                return !0 === i && o.length > 0 && "array" === e.J(t1.value) ? X(t1) : o;
            }
            return Z(e.L({}, t1, {
                valueSpec: s.type ? r[s.type] : s
            }));
        }
        function pe(t1) {
            const i = t1.value, o = t1.key, s = se(t1);
            return s.length || (-1 === i.indexOf("{fontstack}") && s.push(new e.V(o, i, '"glyphs" url must include a "{fontstack}" token')), -1 === i.indexOf("{range}") && s.push(new e.V(o, i, '"glyphs" url must include a "{range}" token'))), s;
        }
        function fe(t1, i = e.a5, o = {}) {
            return _e({
                key: o.key || "",
                value: t1,
                valueSpec: i.$root,
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: pe,
                    "*": ()=>[]
                }
            });
        }
        function me(t1, i = e.a5) {
            return De(fe(t1, i));
        }
        const ge = (e)=>De(ne(e)), ve = (e)=>De(le(e)), ye = (e)=>De(ce(e)), xe = (e)=>De(he(e)), be = (e)=>De(de(e)), we = (t1)=>De(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.snow;
                let n = [];
                const a = e.J(i);
                if (void 0 === i) return n;
                if ("object" !== a) return n = n.concat([
                    new e.V("snow", i, `object expected, ${a} found`)
                ]), n;
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    n = n.concat(a && r[a[1]] && r[a[1]].transition ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.K(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return n;
            }(t1)), Te = (t1)=>De(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.rain;
                let n = [];
                const a = e.J(i);
                if (void 0 === i) return n;
                if ("object" !== a) return n = n.concat([
                    new e.V("rain", i, `object expected, ${a} found`)
                ]), n;
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    n = n.concat(a && r[a[1]] && r[a[1]].transition ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.K(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return n;
            }(t1)), Ee = (e)=>De(oe(e)), Se = (e)=>De(J(e)), Ie = (e)=>De(te(e)), Ce = (e)=>De(ie(e)), Re = (t1)=>De(e.a4(t1));
        function De(e) {
            return e.slice().sort((e, t1)=>e.line && t1.line ? e.line - t1.line : 0);
        }
        function Ae(t1, i) {
            let o = !1;
            if (i && i.length) for (const s of i)s instanceof e.K ? e.w(s.message) : (t1.fire(new e.z(new Error(s.message))), o = !0);
            return o;
        }
        let Le;
        class Pe extends e.E {
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e.a6(Le || (Le = new e.a7({
                    anchor: new e.a8(e.a5.light.anchor),
                    position: new e.a9(e.a5.light.position),
                    color: new e.a8(e.a5.light.color),
                    intensity: new e.a8(e.a5.light.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, t1, i = {}) {
                this._validate(ve, e, i) || (this._transitionable.setTransitionOrValue(e), this.id = t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Ae(this, t1.call(me, e.h({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a5
                })));
            }
        }
        let ze = class extends e.E {
            constructor(t1, i, o, s, r){
                super(), this.scope = o, this._transitionable = new e.a6(new e.a7({
                    source: new e.a8(e.a5.terrain.source),
                    exaggeration: new e.a8(e.a5.terrain.exaggeration)
                }), o, s), this._transitionable.setTransitionOrValue(t1, s), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i, this.worldview = r;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e, t1) {
                this._transitionable.setTransitionOrValue(e, t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e.aa(t1, {
                    worldview: this.worldview
                })).get("exaggeration");
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration;
                if (!t1) return null;
                const i = t1.value.expression;
                if (!i) return null;
                let o = -1, s = -1, r = 1;
                for (const t1 of i.zoomStops)r = i.evaluate(new e.aa(t1, {
                    worldview: this.worldview
                })), r > .01 ? (o = t1, s = -1) : s = t1;
                return r < .01 && o > 0 && s > o ? [
                    o,
                    s
                ] : null;
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e.ab;
            }
        };
        const Me = 45, Oe = 65, Fe = .05;
        function Be(t1, i, o, s) {
            const r = e.af(Me, Oe, o), [n, a] = ke(t1, s);
            let l = 1 - Math.min(1, Math.exp((i - n) / (a - n) * -6));
            return l *= l * l, l = Math.min(1, 1.00747 * l), l * r * t1.alpha;
        }
        function ke(e, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e.range[0] + i,
                e.range[1] + i
            ];
        }
        function Ne(t1, i, o, s, r) {
            const n = e.ad([], [
                i,
                o,
                s
            ], r.mercatorFogMatrix);
            return Be(t1, e.ae(n), r.pitch, r._fov);
        }
        function Ue(t1, i, o, s, r, n, a) {
            const l = [
                [
                    o,
                    s,
                    0
                ],
                [
                    r,
                    s,
                    0
                ],
                [
                    r,
                    n,
                    0
                ],
                [
                    o,
                    n,
                    0
                ]
            ];
            let c = Number.MAX_VALUE, h = -Number.MAX_VALUE;
            for (const t1 of l){
                const o = e.ad([], t1, i), s = e.ae(o);
                c = Math.min(c, s), h = Math.max(h, s);
            }
            return [
                Be(t1, c, a.pitch, a._fov),
                Be(t1, h, a.pitch, a._fov)
            ];
        }
        class je extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = new e.a7({
                    range: new e.a8(e.a5.fog.range),
                    color: new e.a8(e.a5.fog.color),
                    "color-use-theme": new e.a8({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e.a8(e.a5.fog["high-color"]),
                    "high-color-use-theme": new e.a8({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e.a8(e.a5.fog["space-color"]),
                    "space-color-use-theme": new e.a8({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e.a8(e.a5.fog["horizon-blend"]),
                    "star-intensity": new e.a8(e.a5.fog["star-intensity"]),
                    "vertical-range": new e.a8(e.a5.fog["vertical-range"])
                });
                this._transitionable = new e.a6(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e.ag(r), this.scope = o;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e.ah(t1.zoom), s = this.properties.get("range"), r = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e.ai(r[0], s[0], o),
                        e.ai(r[1], s[1], o)
                    ] : s,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(be, t1, o)) return;
                const s = e.h({}, t1);
                for (const t1 of Object.keys(e.a5.fog))void 0 === s[t1] && (s[t1] = e.a5.fog[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e.af(Me, Oe, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const s = e.ac.fromLngLat(i), r = o.elevation ? o.elevation.getAtPointOrZero(s) : 0;
                    return Ne(t1, s.x, s.y, r, o);
                }(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return Ue(this.state, i, 0, 0, e.aj, e.aj, this._transform);
            }
            getOpacityForBounds(e, t1, i, o, s) {
                return this._transform.projection.supportsFog ? Ue(this.state, e, t1, i, o, s, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e) {
                return this._transform.projection.supportsFog ? ke(this.state, e) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const o of i){
                    const i = t1.points[o];
                    let s;
                    if (i[2] >= 0) s = i;
                    else {
                        const r = t1.points[o - 4];
                        s = e.ak(r, i, r[2] / (r[2] - i[2]));
                    }
                    if (Ne(this.state, s[0], s[1], 0, this._transform) >= Fe) return !0;
                }
                return !1;
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Ae(this, t1.call(me, e.h({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a5
                })));
            }
        }
        let Ve, Ge, qe, Ze, He = class extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = Ve || (Ve = new e.a7({
                    density: new e.a8(e.a5.snow.density),
                    intensity: new e.a8(e.a5.snow.intensity),
                    color: new e.a8(e.a5.snow.color),
                    opacity: new e.a8(e.a5.snow.opacity),
                    vignette: new e.a8(e.a5.snow.vignette),
                    "vignette-color": new e.a8(e.a5.snow["vignette-color"]),
                    "center-thinning": new e.a8(e.a5.snow["center-thinning"]),
                    direction: new e.a8(e.a5.snow.direction),
                    "flake-size": new e.a8(e.a5.snow["flake-size"])
                }));
                this._transitionable = new e.a6(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ag(r), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.al(o[0]), r = -Math.max(e.al(o[1]), .01), n = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], a = this.properties.get("vignette"), l = this.properties.get("vignette-color");
                return l.a = a, {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.am(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(we, t1, o)) return;
                const s = e.h({}, t1);
                for (const t1 of Object.keys(e.a5.snow))void 0 === s[t1] && (s[t1] = e.a5.snow[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Ae(this, t1.call(me, e.h({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a5
                })));
            }
        }, We = class extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = Ge || (Ge = new e.a7({
                    density: new e.a8(e.a5.rain.density),
                    intensity: new e.a8(e.a5.rain.intensity),
                    color: new e.a8(e.a5.rain.color),
                    opacity: new e.a8(e.a5.rain.opacity),
                    vignette: new e.a8(e.a5.rain.vignette),
                    "vignette-color": new e.a8(e.a5.rain["vignette-color"]),
                    "center-thinning": new e.a8(e.a5.rain["center-thinning"]),
                    direction: new e.a8(e.a5.rain.direction),
                    "droplet-size": new e.a8(e.a5.rain["droplet-size"]),
                    "distortion-strength": new e.a8(e.a5.rain["distortion-strength"])
                }));
                this._transitionable = new e.a6(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ag(r), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.al(o[0]), r = -Math.max(e.al(o[1]), .01), n = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], a = this.properties.get("vignette-color");
                return a.a = this.properties.get("vignette"), {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.am(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Te, t1, o)) return;
                const s = e.h({}, t1);
                for (const t1 of Object.keys(e.a5.rain))void 0 === s[t1] && (s[t1] = e.a5.rain[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Ae(this, t1.call(me, e.h({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a5
                })));
            }
        };
        class $e extends e.E {
            constructor(t1, i, o, s){
                super(), this.scope = o, this._options = t1, this.properties = new e.ag(i), this._transitionable = new e.a6(i, o, new Map(s)), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e, t1) {
                this._options = e, this._transitionable.setTransitionOrValue(e.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        class Xe {
            constructor(e, t1, i, o){
                this.screenBounds = e, this.cameraPoint = t1, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
            }
            static createFromScreenPoints(t1, i) {
                let o, s;
                if (t1 instanceof e.P || "number" == typeof t1[0]) {
                    const r = e.P.convert(t1);
                    o = [
                        r
                    ], s = i.isPointAboveHorizon(r);
                } else {
                    const r = e.P.convert(t1[0]), n = e.P.convert(t1[1]), a = r.add(n)._div(2);
                    o = [
                        r,
                        n
                    ], s = e.ao(r, n).every((e)=>i.isPointAboveHorizon(e)) && i.isPointAboveHorizon(a);
                }
                return new Xe(o, i.getCameraPoint(), s, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e.ao(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.ao(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? s.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? s[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (s[3] = this.cameraPoint)), e.ap(s, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.ao(i, o, t1), r = this.cameraPoint.clone();
                switch(3 * ((r.y > i.y) + (r.y > o.y)) + ((r.x > i.x) + (r.x > o.x))){
                    case 0:
                        s[0] = r, s[4] = r.clone();
                        break;
                    case 1:
                        s.splice(1, 0, r);
                        break;
                    case 2:
                        s[1] = r;
                        break;
                    case 3:
                        s.splice(4, 0, r);
                        break;
                    case 5:
                        s.splice(2, 0, r);
                        break;
                    case 6:
                        s[3] = r;
                        break;
                    case 7:
                        s.splice(3, 0, r);
                        break;
                    case 8:
                        s[2] = r;
                }
                return s;
            }
            containsTile(t1, i, o, s = 0) {
                const r = t1.queryPadding / i._pixelsPerMercatorPixel + 1, n = o ? this._bufferedCameraMercator(r, i) : this._bufferedScreenMercator(r, i);
                let a = t1.tileID.wrap + (n.unwrapped ? s : 0);
                const l = n.polygon.map((i)=>e.aq(t1.tileTransform, i, a));
                if (!e.ar(l, 0, 0, e.aj, e.aj)) return;
                a = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? s : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e.as(t1.tileTransform, i, a)), h = c.map((t1)=>new e.P(t1[0], t1[1])), d = i.getFreeCameraOptions().position || new e.ac(0, 0, 0), u = e.as(t1.tileTransform, d, a), _ = c.map((t1)=>{
                    const i = e.at(t1, t1, u);
                    return e.au(i, i), new e.av(u, i);
                }), p = e.aw(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: _,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (f = e.ax(l), f.min.x = e.ay(f.min.x, 0, e.aj), f.min.y = e.ay(f.min.y, 0, e.aj), f.max.x = e.ay(f.max.x, 0, e.aj), f.max.y = e.ay(f.max.y, 0, e.aj), f),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e, t1) {
                const i = Je(e);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e), t1) : {
                        polygon: this.bufferedScreenGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e, t1) {
                const i = Je(e);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e), t1) : {
                        polygon: this.bufferedCameraGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e.az([], i.pixelMatrix, i.globeMatrix), s = [
                        0,
                        -e.aB,
                        0,
                        1
                    ], r = [
                        0,
                        e.aB,
                        0,
                        1
                    ], n = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e.aA(s, s, o), e.aA(r, r, o), e.aA(n, n, o);
                    const a = new e.P(s[0] / s[3], s[1] / s[3]), l = new e.P(r[0] / r[3], r[1] / r[3]), c = e.aC(t1, a) && s[3] < n[3], h = e.aC(t1, l) && r[3] < n[3];
                    if (!c && !h) return null;
                    const d = function(e, t1, i) {
                        for(let o = 1; o < e.length; o++){
                            const s = Ke(t1.pointCoordinate3D(e[o - 1]).x), r = Ke(t1.pointCoordinate3D(e[o]).x);
                            if (i < 0) {
                                if (s < r) return {
                                    idx: o,
                                    t: -s / (r - 1 - s)
                                };
                            } else if (r < s) return {
                                idx: o,
                                t: (1 - s) / (r + 1 - s)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!d) return null;
                    const { idx: u, t: _ } = d;
                    let p = u > 1 ? Ye(t1.slice(0, u), i) : [], f = u < t1.length ? Ye(t1.slice(u), i) : [];
                    p = p.map((t1)=>new e.P(Ke(t1.x), t1.y)), f = f.map((t1)=>new e.P(Ke(t1.x), t1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const g = e.ai(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, _);
                    let v;
                    return v = c ? [
                        new e.P(0, g),
                        new e.P(0, 0),
                        new e.P(1, 0),
                        new e.P(1, g)
                    ] : [
                        new e.P(1, g),
                        new e.P(1, 1),
                        new e.P(0, 1),
                        new e.P(0, g)
                    ], m.push(...v), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((t1)=>new e.ac(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const s = function(t1, i) {
                    let o = !1, s = -1 / 0, r = 0;
                    for(let e = 0; e < t1.length - 1; e++)t1[e].x > s && (s = t1[e].x, r = e);
                    for(let e = 0; e < t1.length - 1; e++){
                        const i = (r + e) % (t1.length - 1), s = t1[i], n = t1[i + 1];
                        Math.abs(s.x - n.x) > .5 && (s.x < n.x ? (s.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (n.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const n = e.aD(i.center.lng);
                    return o && n < Math.abs(n - 1) && t1.forEach((e)=>{
                        e.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(Ye(t1, i).map((t1)=>new e.P(Ke(t1.x), t1.y)), i);
                return {
                    polygon: s.polygon.map((t1)=>new e.ac(t1.x, t1.y)),
                    unwrapped: s.unwrapped
                };
            }
        }
        function Ye(t1, i) {
            return e.aE(t1, (e)=>{
                const t1 = i.pointCoordinate3D(e);
                e.x = t1.x, e.y = t1.y;
            }, 1 / 256);
        }
        function Ke(e) {
            return e < 0 ? 1 + e % 1 : e % 1;
        }
        function Je(e) {
            return 100 * e | 0;
        }
        function Qe(t1, i, o, s, r) {
            const n = function(o, s) {
                if (o) return r(o);
                if (s) {
                    if (t1.url && s.tiles && t1.tiles && delete t1.tiles, s.variants) {
                        if (!Array.isArray(s.variants)) return r(new Error("variants must be an array"));
                        for (const t1 of s.variants){
                            if (null == t1 || "object" != typeof t1 || t1.constructor !== Object) return r(new Error("variant must be an object"));
                            if (!Array.isArray(t1.capabilities)) return r(new Error("capabilities must be an array"));
                            if (1 === t1.capabilities.length && "meshopt" === t1.capabilities[0]) {
                                s = e.h(s, t1);
                                break;
                            }
                        }
                    }
                    const o = e.aF(e.h({}, s, t1), [
                        "tilejson",
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "extra_bounds",
                        "scheme",
                        "tileSize",
                        "encoding",
                        "vector_layers",
                        "raster_layers",
                        "worldview_options",
                        "worldview_default",
                        "worldview"
                    ]);
                    o.tiles = i.canonicalizeTileset(o, t1.url), r(null, o);
                }
            }, a = function(e, t1, i) {
                if (!e) return null;
                if (!t1 && !i) return e;
                i = i || e.worldview_default;
                const o = Object.values(e.language || {});
                if (0 === o.length) return null;
                const s = Object.values(e.worldview || {});
                if (0 === s.length) return null;
                const r = o.every((e)=>e === t1), n = s.every((e)=>e === i);
                return r && n ? e : t1 in (e.language_options || {}) || i in (e.worldview_options || {}) ? null : e.language_options && e.worldview_options ? e : null;
            }(t1.data, o, s);
            return a ? e.q.frame(()=>n(null, a)) : t1.url ? e.n(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, s), e.R.Source), n) : e.q.frame(()=>{
                const { data: e, ...i } = t1;
                n(null, i);
            });
        }
        function et(t1, i) {
            const o = Math.pow(2, i.z), s = Math.floor(e.aD(t1.getWest()) * o), r = Math.floor(e.aH(t1.getNorth()) * o), n = Math.ceil(e.aD(t1.getEast()) * o), a = Math.ceil(e.aH(t1.getSouth()) * o);
            return i.x >= s && i.x < n && i.y >= r && i.y < a;
        }
        class tt {
            constructor(t1, i, o){
                this.bounds = t1 ? e.aG.convert(this.validateBounds(t1)) : null, this.minzoom = i || 0, this.maxzoom = o || 24;
            }
            validateBounds(e) {
                return Array.isArray(e) && 4 === e.length ? [
                    Math.max(-180, e[0]),
                    Math.max(-90, e[1]),
                    Math.min(180, e[2]),
                    Math.min(90, e[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            addExtraBounds(t1) {
                if (t1) {
                    this.extraBounds || (this.extraBounds = []);
                    for (const i of t1)this.extraBounds.push(e.aG.convert(this.validateBounds(i)));
                }
            }
            contains(e) {
                if (e.z > this.maxzoom || e.z < this.minzoom) return !1;
                if (this.bounds && !et(this.bounds, e)) return !1;
                if (!this.extraBounds) return !0;
                for (const t1 of this.extraBounds)if (et(t1, e)) return !0;
                return !1;
            }
            static fromTileJSON(e) {
                if (!e.bounds && !e.extra_bounds) return null;
                const t1 = new tt(e.bounds, e.minzoom, e.maxzoom);
                return t1.addExtraBounds(e.extra_bounds), t1;
            }
        }
        class it extends e.E {
            constructor(t1, i, o, s){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e.h(this, e.aF(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = e.h({
                    type: "vector"
                }, i), this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(s), this._tileWorkers = {}, this._deduped = new e.aI;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.A("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                this._tileJSONRequest = Qe(this._options, this.map._requestManager, i, o, (s, r)=>{
                    if (this._tileJSONRequest = null, this._loaded = !0, s) i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.z(s));
                    else if (r) {
                        if (e.h(this, r), this.hasWorldviews = !!r.worldview_options, r.worldview_default && (this.worldviewDefault = r.worldview_default), r.vector_layers) {
                            this.vectorLayers = r.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                            for (const e of r.vector_layers)this.vectorLayerIds.push(e.id), r.worldview && r.worldview[e.source] && this.localizableLayerIds.add(e.id);
                        }
                        this.tileBounds = tt.fromTileJSON(r), L(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }));
                    }
                    t1 && t1(s);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.C(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.h({}, this._options);
            }
            loadTile(t1, i) {
                const o = t1.tileID.canonical.url(this.tiles, this.scheme), s = this.map._requestManager.normalizeTileURL(o), r = this.map._requestManager.transformRequest(s, e.R.Tile), n = this.map.style ? this.map.style.getLut(this.scope) : null, a = n ? {
                    image: n.image.clone()
                } : null, l = {
                    request: r,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    lut: a,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e.q.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: t1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep,
                    scaleFactor: this.map.getScaleFactor(),
                    worldview: this.map.getWorldview() || this.worldviewDefault
                };
                if (this.hasWorldviews && e.j(o) && (l.localizableLayerIds = this.localizableLayerIds), l.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", l, c.bind(this));
                else if (t1.actor = this._tileWorkers[s] = this._tileWorkers[s] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                else {
                    const i = e.aJ.call({
                        deduped: this._deduped
                    }, l, (e, i)=>{
                        e || !i ? c.call(this, e) : (l.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, t1.actor && t1.actor.send("loadTile", l, c.bind(this), void 0, !0));
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function c(o, s) {
                    return delete t1.request, t1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(s), t1.loadVectorData(s, this.map.painter), e.aK(this.dispatcher), i(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e, t1) {
                e.actor && e.actor.send("removeTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class ot extends e.E {
            constructor(t1, i, o, s){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(s), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e.h({
                    type: "raster"
                }, i), e.h(this, e.aF(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.A("dataloading", {
                    dataType: "source"
                }));
                const i = this.map.getWorldview();
                this._tileJSONRequest = Qe(this._options, this.map._requestManager, null, i, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e.z(i)) : o && (e.h(this, o), o.raster_layers && (this.rasterLayers = o.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e)=>e.id)), this.tileBounds = tt.fromTileJSON(o), L(o.tiles), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.C(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.h({}, this._options);
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            loadTile(t1, i) {
                const o = e.q.devicePixelRatio >= 2, s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e.o(this.map._requestManager.transformRequest(s, e.R.Tile), (o, s, r, n)=>(delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? (t1.state = "errored", i(o)) : s ? (this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: r,
                        expires: n
                    }), t1.setTexture(s, this.map.painter), t1.state = "loaded", e.aK(this.dispatcher), void i(null)) : i(null)));
            }
            abortTile(e, t1) {
                e.request && (e.request.cancel(), delete e.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class st extends ot {
            constructor(t1, i, o, s){
                super(t1, i, o, s), this.type = "raster-array", this.maxzoom = 22, this.partial = !0, this._options = e.h({
                    type: "raster-array"
                }, i);
            }
            triggerRepaint(e) {
                const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e.tileID), this.map.triggerRepaint();
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), s = this.map._requestManager.transformRequest(o, e.R.Tile), r = {
                    request: s,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    partial: this.partial
                };
                t1.source = this.id, t1.scope = this.scope, t1.requestParams = s, t1.actor || (t1.actor = this.dispatcher.getActor());
                const n = (e, o, s, r)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (e) {
                        if ("AbortError" === e.name) return;
                        return t1.state = "errored", i(e);
                    }
                    if (this.map._refreshExpiredTiles && o && t1.setExpiryData({
                        cacheControl: s,
                        expires: r
                    }), this.partial) t1.state = "empty";
                    else {
                        if (!o) return i(null);
                        t1.state = "loaded", t1._isHeaderLoaded = !0, t1._mrt = o;
                    }
                    i(null);
                };
                t1.request = this.partial ? t1.fetchHeader(void 0, n.bind(this)) : t1.actor.send("loadTile", r, n.bind(this), void 0, !0);
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(t1, i) {
                const o = t1.texture;
                o && o instanceof e.T ? (t1.destroy(!0), this.map.painter.saveTileTexture(o)) : (t1.destroy(), t1.flushQueues(), t1._isHeaderLoaded = !1, delete t1._mrt, delete t1.textureDescriptor), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), delete t1.request, delete t1.requestParams, delete t1.neighboringTiles, t1.state = "unloaded";
            }
            prepareTile(t1, i, o) {
                t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBand(i, o, (i, o)=>{
                    if (i) return t1.state = "errored", this.fire(new e.z(i)), void this.triggerRepaint(t1);
                    o && (t1._isHeaderLoaded = !0, t1.setTexture(o, this.map.painter), t1.state = "loaded", this.triggerRepaint(t1));
                }));
            }
            getInitialBand(e) {
                if (!this.rasterLayers) return 0;
                const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e), i = t1 && t1.fields, o = i && i.bands && i.bands;
                return o ? o[0] : 0;
            }
            getTextureDescriptor(t1, i, o) {
                if (!t1) return;
                const s = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                if (!s) return;
                let r = null;
                i instanceof e.aN ? r = i.paint.get("raster-array-band") : i instanceof e.aO && (r = i.paint.get("raster-particle-array-band"));
                const n = r || this.getInitialBand(s);
                if (null != n) {
                    if (t1.textureDescriptor) {
                        if (!t1.updateNeeded(s, n) || o) return Object.assign({}, t1.textureDescriptor, {
                            texture: t1.texture
                        });
                    } else this.prepareTile(t1, s, n);
                }
            }
            getImages(t1, i) {
                const o = new Map;
                for (const s of t1)for (const t1 of i){
                    const [i, r] = t1.split("/"), n = s.getLayer(i);
                    if (!n) continue;
                    if (!n.hasBand(r) || !n.hasDataForBand(r)) continue;
                    const { bytes: a, tileSize: l, buffer: c } = n.getBandView(r), h = l + 2 * c, d = {
                        data: new e.r({
                            width: h,
                            height: h
                        }, a),
                        pixelRatio: 2,
                        sdf: !1,
                        usvg: !1,
                        version: 0
                    };
                    o.set(t1, d);
                }
                return o;
            }
        }
        const rt = {
            vector: it,
            raster: ot,
            "raster-dem": class extends ot {
                constructor(t1, i, o, s){
                    super(t1, i, o, s), this.type = "raster-dem", this.maxzoom = 22, this._options = e.h({
                        type: "raster-dem"
                    }, i), this.encoding = i.encoding || "mapbox";
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function s(e, o) {
                        e && (t1.state = "errored", i(e)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e.o(this.map._requestManager.transformRequest(o, e.R.Tile), (function(o, r, n, a) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (r) {
                            this.map._refreshExpiredTiles && t1.setExpiryData({
                                cacheControl: n,
                                expires: a
                            });
                            const i = ImageBitmap && r instanceof ImageBitmap && e.t(), o = 1 - (r.width - e.aL(r.width)) / 2;
                            o < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = i ? r : e.q.getImageData(r, o), c = {
                                uid: t1.uid,
                                tileID: t1.tileID,
                                source: this.id,
                                type: this.type,
                                scope: this.scope,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: o
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadTile", c, s.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), s = (i.x - 1 + o) % o, r = 0 === i.x ? t1.wrap - 1 : t1.wrap, n = (i.x + 1 + o) % o, a = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e.aM(t1.overscaledZ, r, i.z, s, i.y).key] = {
                        backfilled: !1
                    }, l[new e.aM(t1.overscaledZ, a, i.z, n, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e.aM(t1.overscaledZ, r, i.z, s, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aM(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aM(t1.overscaledZ, a, i.z, n, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e.aM(t1.overscaledZ, r, i.z, s, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aM(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aM(t1.overscaledZ, a, i.z, n, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            "raster-array": st,
            geojson: class extends e.E {
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(s), this._data = i.data, this._options = e.h({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const r = e.aj / this.tileSize;
                    this.workerOptions = e.h({
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * r,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * r,
                            extent: e.aj,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e.aj,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * r,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic
                    }, i.workerOptions);
                }
                onAdd(e) {
                    this.map = e, this.setData(this._data);
                }
                setData(e) {
                    return this._data = e, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e.z(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e.z(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e = new Map;
                        for (const t1 of this._data.features)e.set(t1.id, t1);
                        for (const i of t1.features)e.set(i.id, i);
                        this._data.features = [
                            ...e.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterChildren(e, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterLeaves(e, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e.A("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = e.h({
                        append: t1
                    }, this.workerOptions);
                    i.scope = this.scope;
                    const o = this._data;
                    "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e.q.resolveURL(o), e.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                        if (this._loaded = !0, this._pendingLoad = null, i) this.fire(new e.z(i));
                        else {
                            const i = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (i.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e.A("data", i)), this._partialReload = !1, this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e.C(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const s = this.map.style ? this.map.style.getLut(this.scope) : null, r = s ? {
                        image: s.image.clone()
                    } : null, n = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: r,
                        scope: this.scope,
                        pixelRatio: e.q.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: n,
                        worldview: this.map.getWorldview()
                    };
                    t1.request = this.actor.send(o, a, (e, s)=>n && !s ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(), t1.aborted ? i(null) : e ? i(e) : (t1.loadVectorData(s, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e) {
                    e.request && (e.request.cancel(), delete e.request), e.aborted = !0;
                }
                unloadTile(e, t1) {
                    this.actor.send("removeTile", {
                        uid: e.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e.destroy();
                }
                onRemove(e) {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return e.h({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends e.aP {
                constructor(e, t1, i, o){
                    super(e, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e.R.Source).url);
                    e.aQ(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e.z(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e.z(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e) {
                    this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: e.aP,
            model: class extends e.E {
                constructor(e, t1, i, o){
                    super(), this.id = e, this.type = "model", this.models = [], this._loaded = !1, this._options = t1;
                }
                load() {
                    const t1 = [];
                    for(const i in this._options.models){
                        const o = this._options.models[i], s = e.aS(this.map._requestManager.transformRequest(o.uri, e.R.Model).url).then((t1)=>{
                            if (!t1) return;
                            const s = e.aT(t1), r = new e.aU(i, o.position, o.orientation, s);
                            r.computeBoundsAndApplyParent(), this.models.push(r);
                        }).catch((t1)=>{
                            this.fire(new e.z(new Error(`Could not load model ${i} from ${o.uri}: ${t1.message}`)));
                        });
                        t1.push(s);
                    }
                    Promise.allSettled(t1).then(()=>{
                        this._loaded = !0, this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        }));
                    }).catch((t1)=>{
                        this._loaded = !0, this.fire(new e.z(new Error(`Could not load models: ${t1.message}`)));
                    });
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                hasTransition() {
                    return !1;
                }
                loaded() {
                    return this._loaded;
                }
                getModels() {
                    return this.models;
                }
                loadTile(e, t1) {}
                serialize() {
                    return this._options;
                }
            },
            "batched-model": class extends e.E {
                constructor(e, t1, i, o){
                    super(), this.type = "batched-model", this.id = e, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(o);
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const t1 = e.C(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(t1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e.A("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                    this._tileJSONRequest = Qe(this._options, this.map._requestManager, i, o, (s, r)=>{
                        this._tileJSONRequest = null, this._loaded = !0, s ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.z(s))) : r && (e.h(this, r), r.bounds && (this.tileBounds = new tt(r.bounds, this.minzoom, this.maxzoom)), L(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(s);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e) {
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), s = {
                        request: this.map._requestManager.transformRequest(o, e.R.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: t1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        pixelRatio: e.q.devicePixelRatio,
                        promoteId: this.promoteId
                    };
                    if (t1.actor && "expired" !== t1.state) {
                        if ("loading" === t1.state) t1.reloadCallback = i;
                        else {
                            if (t1.buckets) {
                                const e = Object.values(t1.buckets);
                                for (const t1 of e)t1.dirty = !0;
                                return void (t1.state = "loaded");
                            }
                            t1.request = t1.actor.send("reloadTile", s, r.bind(this));
                        }
                    } else t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", s, r.bind(this), void 0, !0);
                    function r(e, o) {
                        return t1.aborted ? i(null) : e && 404 !== e.status ? i(e) : (this.map._refreshExpiredTiles && o && t1.setExpiryData(o), t1.loadModelData(o, this.map.painter), t1.state = "loaded", void i(null));
                    }
                }
                serialize() {
                    return e.h({}, this._options);
                }
            },
            canvas: class extends e.aP {
                constructor(t1, i, o, s){
                    super(t1, i, o, s), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e)=>!Array.isArray(e) || 2 !== e.length || e.some((e)=>"number" != typeof e)) || this.fire(new e.z(new e.V(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.z(new e.V(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e.z(new e.V(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e.z(new e.V(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.z(new e.V(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.z(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e) {
                    this.map = e, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e.aR || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e) || e <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e.E {
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(s), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e.z(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.z(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new tt(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.clearTiles = this._clearTiles.bind(this), i.coveringTiles = this._coveringTiles.bind(this), e.h(this, e.aF(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e.aF(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e.A("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e) {
                    this._implementation.onRemove && this._implementation.onRemove(e);
                }
                hasTile(e) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loadTile(e, t1) {
                    const { x: i, y: o, z: s } = e.tileID.canonical, r = new AbortController;
                    e.request = Promise.resolve(this._implementation.loadTile({
                        x: i,
                        y: o,
                        z: s
                    }, {
                        signal: r.signal
                    })).then((function(i) {
                        return delete e.request, e.aborted ? (e.state = "unloaded", t1(null)) : void 0 === i ? (e.state = "errored", t1(null)) : null === i ? (this.loadTileData(e, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e.state = "loaded", t1(null)) : function(e) {
                            return e instanceof ImageData || e instanceof HTMLCanvasElement || e instanceof ImageBitmap || e instanceof HTMLImageElement;
                        }(i) ? (this.loadTileData(e, i), e.state = "loaded", void t1(null)) : (e.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((i)=>{
                        "AbortError" !== i.name && (e.state = "errored", t1(i));
                    }), e.request.cancel = ()=>r.abort();
                }
                loadTileData(e, t1) {
                    e.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e, y: i, z: o } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e,
                            y: i,
                            z: o
                        });
                    }
                    i && i();
                }
                abortTile(e, t1) {
                    e.request && e.request.cancel && (e.request.cancel(), delete e.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e)=>({
                            x: e.canonical.x,
                            y: e.canonical.y,
                            z: e.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e.C(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, nt = function(t1, i, o, s) {
            const r = new rt[i.type](t1, i, o, s);
            if (r.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${r.id}`);
            return e.aV([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], r), r;
        };
        function at(e, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e) {
                if ("layerId" in e) return `layer:${e.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e.target)}`;
        }
        function lt(e, t1, i, o = "") {
            if (e.uniqueFeatureID) {
                const s = at(e, t1, o);
                if (i.has(s)) return !0;
                i.add(s);
            }
            return !1;
        }
        function ct(e, t1, i, o, s = !1) {
            const r = t1.sourceCache.transform, n = t1.sourceCache.tilesIn(e, t1.has3DLayers, s);
            n.sort(ut);
            const a = [];
            for (const e of n){
                const n = e.tile.queryRenderedFeatures(t1, e, i, o, r, s);
                Object.keys(n).length && a.push({
                    wrappedTileID: e.tile.tileID.wrapped().key,
                    queryResults: n
                });
            }
            return 0 === a.length ? {} : function(e) {
                const t1 = {}, i = {};
                for (const o of e){
                    const e = o.queryResults, s = o.wrappedTileID, r = i[s] = i[s] || {};
                    for(const i in e){
                        const o = e[i], s = r[i] = r[i] || {}, n = t1[i] = t1[i] || [];
                        for (const e of o)s[e.featureIndex] || (s[e.featureIndex] = !0, n.push(e));
                    }
                }
                return t1;
            }(a);
        }
        function ht(e, t1, i, o, s, r) {
            const n = {}, a = o.queryRenderedSymbols(e), l = [];
            for (const e of Object.keys(a).map(Number))l.push(s[e]);
            l.sort(ut);
            for (const e of l){
                const o = e.featureIndex.lookupSymbolFeatures(a[e.bucketInstanceId], e.bucketIndex, e.sourceLayerIndex, t1, i, r);
                for(const t1 in o){
                    const i = n[t1] = n[t1] || [], s = o[t1];
                    s.sort((t1, i)=>{
                        const o = e.featureSortOrder;
                        if (o) {
                            const e = o.indexOf(t1.featureIndex);
                            return o.indexOf(i.featureIndex) - e;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e of s)i.push(e);
                }
            }
            return n;
        }
        function dt(e, t1) {
            const i = e.getRenderableIds().map((t1)=>e.getTileByID(t1)), o = [], s = {};
            for(let e = 0; e < i.length; e++){
                const r = i[e], n = r.tileID.canonical.key;
                s[n] || (s[n] = !0, r.querySourceFeatures(o, t1));
            }
            return o;
        }
        function ut(e, t1) {
            const i = e.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function _t(e, t1) {
            const i = {};
            if (!t1) return i;
            for (const o of e){
                const e = o.layerIds.map((e)=>t1.getLayer(e)).filter(Boolean);
                if (0 !== e.length) {
                    o.layers = e, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((t1)=>e.filter((e)=>e.id === t1)[0]));
                    for (const t1 of e)i[t1.fqid] = o;
                }
            }
            return i;
        }
        const pt = 32, ft = 33, mt = new Uint16Array(8184);
        for(let e = 0; e < 2046; e++){
            let t1 = e + 2, i = 0, o = 0, s = 0, r = 0, n = 0, a = 0;
            for(1 & t1 ? s = r = n = pt : i = o = a = pt; (t1 >>= 1) > 1;){
                const e = i + s >> 1, l = o + r >> 1;
                1 & t1 ? (s = i, r = o, i = n, o = a) : (i = s, o = r, s = n, r = a), n = e, a = l;
            }
            const l = 4 * e;
            mt[l + 0] = i, mt[l + 1] = o, mt[l + 2] = s, mt[l + 3] = r;
        }
        const gt = new Uint16Array(2178), vt = new Uint8Array(1089), yt = new Uint16Array(1089);
        function xt(e) {
            return 0 === e ? -0.03125 : 32 === e ? .03125 : 0;
        }
        const bt = (()=>({
                type: 2,
                extent: e.aj,
                loadGeometry: ()=>[
                        [
                            new e.P(0, 0),
                            new e.P(e.aj + 1, 0),
                            new e.P(e.aj + 1, e.aj + 1),
                            new e.P(0, e.aj + 1),
                            new e.P(0, 0)
                        ]
                    ]
            }))();
        class wt {
            constructor(t1, i, o, s, r, n){
                this.tileID = t1, this.uid = e.a$(), this.uses = 0, this.tileSize = i, this.tileZoom = o, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = r, s && s.style && (this._lastUpdatedBrightness = s.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", s && s.transform && (this.projection = s.transform.projection), this.worldview = n;
            }
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e.q.now() || this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e.aW(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, o) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = _t(t1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.b1) {
                            if (this.hasSymbolBuckets = !0, !o) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.b1 && i.hasRTLText) {
                            this.hasRTLText = !0, e.b2();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e in this.buckets){
                        const t1 = this.buckets[e], o = i.style.getOwnLayer(e);
                        if (!o) continue;
                        const s = o.queryRadius(t1);
                        this.queryPadding = Math.max(this.queryPadding, s);
                    }
                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e.b0;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e in this.buckets)this.buckets[e].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e, t1, i) {
                e && (e.resourceTiming && (this.resourceTiming = e.resourceTiming), this.buckets = Object.assign({}, this.buckets, _t(e.buckets, t1.style)), e.featureIndex && (this.latestFeatureIndex = e.featureIndex));
            }
            getBucket(e) {
                return this.buckets[e.fqid];
            }
            upload(t1) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t1);
                }
                const i = t1.gl, o = this.imageAtlas;
                o && !o.uploaded && (this.imageAtlasTexture = new e.T(t1, o.image, i.RGBA8, {
                    useMipmap: !!o.patternPositions.size
                }), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new e.T(t1, this.glyphAtlasImage, i.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e.T(t1, this.lineAtlas.image, i.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e, this.imageAtlasTexture, i), !t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const o = t1.style.getBrightness();
                (this._lastUpdatedBrightness || o) && (this._lastUpdatedBrightness && o && Math.abs(this._lastUpdatedBrightness - o) < .001 || (this.updateBuckets(t1, this._lastUpdatedBrightness !== o), this._lastUpdatedBrightness = o));
            }
            queryRenderedFeatures(t1, i, o, s, r, n) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const a = function(t1, i) {
                    const o = e.bn([], [
                        .5 * t1.width,
                        .5 * -t1.height,
                        1
                    ]);
                    return e.bo(o, o, [
                        1,
                        -1,
                        0
                    ]), e.az(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
                }(r, this.tileID);
                return this.latestFeatureIndex.query(t1, {
                    tilespaceGeometry: i,
                    pixelPosMatrix: a,
                    transform: s,
                    availableImages: o,
                    tileTransform: this.tileTransform,
                    worldview: this.worldview
                });
            }
            querySourceFeatures(t1, i) {
                const o = this.latestFeatureIndex;
                if (!o || !o.rawTileData) return;
                const s = o.loadVTLayers(), r = i ? i.sourceLayer : "", n = s._geojsonTileLayer || s[r];
                if (!n) return;
                const a = e.b3(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, d = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < n.length; i++){
                    const s = n.feature(i);
                    if (a.needGeometry) {
                        const t1 = e.b4(s, !0);
                        if (!a.filter(new e.aa(this.tileID.overscaledZ, {
                            worldview: this.worldview
                        }), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new e.aa(this.tileID.overscaledZ, {
                        worldview: this.worldview
                    }), s)) continue;
                    const u = o.getId(s, r), _ = new e.b5(s, l, c, h, u);
                    _.tile = d, t1.push(_);
                }
            }
            loaded() {
                return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e.b6(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = e + Math.max(o, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e) {
                this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && e && this.updateBuckets(e);
            }
            updateBuckets(t1, i) {
                if (!this.latestFeatureIndex) return;
                if (!t1.style) return;
                const o = this.latestFeatureIndex.loadVTLayers(), s = t1.style.listImages(), r = t1.style.getBrightness();
                for(const n in this.buckets){
                    if (!t1.style.hasLayer(n)) continue;
                    const a = this.buckets[n], l = a.layers[0], c = l.sourceLayer || "_geojsonTileLayer", h = o[c], d = t1.style.getLayerSourceCache(l);
                    let u = {};
                    d && (u = d._state.getState(c, void 0));
                    const _ = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, p = Object.keys(u).length > 0 && !i;
                    p && !a.stateDependentLayers.length && !i || a.update(u, h, s, _, p ? a.stateDependentLayers : a.layers, i, r), (a instanceof e.b7 || a instanceof e.b8) && t1._terrain && t1._terrain.enabled && d && a.uploadPending() && t1._terrain._clearRenderCacheForTile(d.id, this.tileID);
                    const f = t1 && t1.style && t1.style.getOwnLayer(n);
                    f && (this.queryPadding = Math.max(this.queryPadding, f.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e.q.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e.q.now() + t1;
            }
            setTexture(t1, i) {
                const o = i.context, s = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1) : (this.texture = new e.T(o, t1, s.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE));
            }
            setDependencies(e, t1) {
                const i = {};
                for (const e of t1)i[e] = !0;
                this.dependencies[e] = i;
            }
            hasDependency(e, t1) {
                for (const i of e){
                    const e = this.dependencies[i];
                    if (e) {
                        for (const i of t1)if (e[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const o = e.b9(bt, this.tileID.canonical, this.tileTransform)[0], s = new e.ba, r = new e.bb;
                for(let e = 0; e < o.length; e++){
                    const { x: t1, y: i } = o[e];
                    s.emplaceBack(t1, i), r.emplaceBack(e);
                }
                r.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(r), this._tileDebugBuffer = t1.createVertexBuffer(s, e.bc.members), this._tileDebugSegments = e.bd.simpleSegment(0, 0, s.length, r.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const o = e.b9(bt, this.tileID.canonical, this.tileTransform)[0];
                let s, r;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const o = e.aW(t1, i), s = Math.pow(2, t1.z);
                        for(let r = 0; r < ft; r++)for(let n = 0; n < ft; n++){
                            const a = e.aX((t1.x + (n + xt(n)) / pt) / s), l = e.aY((t1.y + (r + xt(r)) / pt) / s), c = i.project(a, l), h = r * ft + n;
                            gt[2 * h + 0] = Math.round((c.x * o.scale - o.x) * e.aj), gt[2 * h + 1] = Math.round((c.y * o.scale - o.y) * e.aj);
                        }
                        vt.fill(0), yt.fill(0);
                        for(let e = 2045; e >= 0; e--){
                            const t1 = 4 * e, i = mt[t1 + 0], o = mt[t1 + 1], s = mt[t1 + 2], r = mt[t1 + 3], n = i + s >> 1, a = o + r >> 1, l = n + a - o, c = a + i - n, h = o * ft + i, d = r * ft + s, u = a * ft + n, _ = Math.hypot((gt[2 * h + 0] + gt[2 * d + 0]) / 2 - gt[2 * u + 0], (gt[2 * h + 1] + gt[2 * d + 1]) / 2 - gt[2 * u + 1]) >= 16;
                            vt[u] = vt[u] || (_ ? 1 : 0), e < 1022 && (vt[u] = vt[u] || vt[(o + c >> 1) * ft + (i + l >> 1)] || vt[(r + c >> 1) * ft + (s + l >> 1)]);
                        }
                        const r = new e.aZ, n = new e.a_;
                        let a = 0;
                        function l(t1, i) {
                            const o = i * ft + t1;
                            return 0 === yt[o] && (r.emplaceBack(gt[2 * o + 0], gt[2 * o + 1], t1 * e.aj / pt, i * e.aj / pt), yt[o] = ++a), yt[o] - 1;
                        }
                        function c(e, t1, i, o, s, r) {
                            const a = e + i >> 1, h = t1 + o >> 1;
                            if (Math.abs(e - s) + Math.abs(t1 - r) > 1 && vt[h * ft + a]) c(s, r, e, t1, a, h), c(i, o, s, r, a, h);
                            else {
                                const a = l(e, t1), c = l(i, o), h = l(s, r);
                                n.emplaceBack(a, c, h);
                            }
                        }
                        return c(0, 0, pt, pt, pt, 0), c(pt, pt, 0, 0, 0, pt), {
                            vertices: r,
                            indices: n
                        };
                    }(this.tileID.canonical, i);
                    s = t1.vertices, r = t1.indices;
                } else {
                    s = new e.aZ, r = new e.a_;
                    for (const { x: e, y: t1 } of o)s.emplaceBack(e, t1, 0, 0);
                    const t1 = e.be(s.int16.subarray(0, 4 * s.length), void 0, 4);
                    for(let e = 0; e < t1.length; e += 3)r.emplaceBack(t1[e], t1[e + 1], t1[e + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(s, e.bf.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(r), this._tileBoundsSegments = e.bd.simpleSegment(0, 0, s.length, r.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const o = i.projection;
                if (!o || "globe" !== o.name || i.freezeTileCoverage) return;
                const s = this.tileID.canonical, r = e.bg(s, i), n = e.bh(r), a = e.ah(i.zoom);
                let l;
                a > 0 && (l = e.bi(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, s, i, n, l, a), this._makeGlobeTileDebugTextBuffer(t1, s, i, n, l, a);
            }
            _globePoint(t1, i, o, s, r, n, a) {
                let l = e.bj(t1, i, o);
                if (n) {
                    const r = 1 << o.z, c = e.aD(s.center.lng), h = e.aH(s.center.lat), d = (o.x + .5) / r - c;
                    let u = 0;
                    d > .5 ? u = -1 : d < -0.5 && (u = 1);
                    let _ = (t1 / e.aj + o.x) / r + u, p = (i / e.aj + o.y) / r;
                    _ = (_ - c) * s._pixelsPerMercatorPixel + c, p = (p - h) * s._pixelsPerMercatorPixel + h;
                    const f = [
                        _ * s.worldSize,
                        p * s.worldSize,
                        0
                    ];
                    e.ad(f, f, n), l = e.bk(l, f, a);
                }
                return e.ad(l, l, r);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, o, s, r, n) {
                const a = new e.ba, l = new e.bb, c = new e.bl, h = (e, t1, h, d, u)=>{
                    const _ = (h - e) / (u - 1), p = (d - t1) / (u - 1), f = a.length;
                    for(let h = 0; h < u; h++){
                        const d = e + h * _, u = t1 + h * p;
                        a.emplaceBack(d, u);
                        const m = this._globePoint(d, u, i, o, s, r, n);
                        c.emplaceBack(m[0], m[1], m[2]), l.emplaceBack(f + h);
                    }
                }, d = e.aj;
                h(0, 0, d, 0, 16), h(d, 0, d, d, 16), h(d, d, 0, d, 16), h(0, d, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(a, e.bc.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e.bm.members), this._tileDebugSegments = e.bd.simpleSegment(0, 0, a.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, o, s, r, n) {
                const a = e.aj / 4, l = new e.ba, c = new e.a_, h = new e.bl, d = 25;
                c.reserve(32), l.reserve(d), h.reserve(d);
                const u = (e, t1)=>d * e + t1;
                for(let e = 0; e < d; e++){
                    const t1 = e * a;
                    for(let e = 0; e < d; e++){
                        const c = e * a;
                        l.emplaceBack(c, t1);
                        const d = this._globePoint(c, t1, i, o, s, r, n);
                        h.emplaceBack(d[0], d[1], d[2]);
                    }
                }
                for(let e = 0; e < 4; e++)for(let t1 = 0; t1 < 4; t1++){
                    const i = u(e, t1), o = u(e, t1 + 1), s = u(e + 1, t1), r = u(e + 1, t1 + 1);
                    c.emplaceBack(i, o, s), c.emplaceBack(s, o, r);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e.bc.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e.bm.members), this._tileDebugTextSegments = e.bd.simpleSegment(0, 0, d, 32);
            }
            destroy(t1 = !1) {
                for(const e in this.buckets)this.buckets[e].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t1 && this.texture && this.texture instanceof e.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        e.bp.setPbf(e.bq);
        class Tt extends wt {
            constructor(e, t1, i, o, s){
                super(e, t1, i, o, s), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = !1;
            }
            getLayers() {
                return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e) {
                return this._mrt && this._mrt.getLayer(e);
            }
            setTexture(t1, i) {
                const o = i.context, s = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1, {
                    premultiply: !1
                }) : this.texture = new e.T(o, t1, s.RGBA8, {
                    premultiply: !1
                });
            }
            flushQueues() {
                for(; this._workQueue.length;)this._workQueue.pop()();
                for(; this._fetchQueue.length;)this._fetchQueue.pop()();
            }
            fetchHeader(t1 = 16384, i) {
                const o = this._mrt = new e.bp(30), s = Object.assign({}, this.requestParams, {
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                });
                return this.entireBuffer = null, this.request = e.br(s, (e, s, r, n)=>{
                    if (e) i(e);
                    else try {
                        const e = o.getHeaderLength(s);
                        if (e > t1) return void (this.request = this.fetchHeader(e, i));
                        o.parseHeader(s), this._isHeaderLoaded = !0;
                        let a = 0;
                        for (const e of Object.values(o.layers))a = Math.max(a, e.dataIndex[e.dataIndex.length - 1].lastByte);
                        s.byteLength >= a && (this.entireBuffer = s), i(null, this.entireBuffer || s, r, n);
                    } catch (e) {
                        i(e);
                    }
                }), this.request;
            }
            fetchBand(t1, i, o) {
                const s = this._mrt;
                if (!this._isHeaderLoaded || !s) return void o(new Error("Tile header is not ready"));
                const r = this.actor;
                if (!r) return void o(new Error("Can't fetch tile band without an actor"));
                let n;
                const a = (e, s)=>{
                    n.complete(e, s), e ? o(e) : (this.updateTextureDescriptor(t1, i), o(null, this.textureDescriptor && this.textureDescriptor.img));
                }, l = (e, t1)=>{
                    if (e) return o(e);
                    const i = r.send("decodeRasterArray", {
                        type: "raster-array",
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        uid: this.uid,
                        buffer: t1,
                        task: n
                    }, a, void 0, !0);
                    this._workQueue.push(()=>{
                        i && i.cancel(), n.cancel();
                    });
                }, c = s.getLayer(t1);
                if (!c) return void o(new Error(`Unknown sourceLayer "${t1}"`));
                if (c.hasDataForBand(i)) return this.updateTextureDescriptor(t1, i), void o(null, this.textureDescriptor ? this.textureDescriptor.img : null);
                const h = c.getDataRange([
                    i
                ]);
                if (n = s.createDecodingTask(h), !n || n.tasks.length) {
                    if (this.flushQueues(), this.entireBuffer) l(null, this.entireBuffer.slice(h.firstByte, h.lastByte + 1));
                    else {
                        const t1 = Object.assign({}, this.requestParams, {
                            headers: {
                                Range: `bytes=${h.firstByte}-${h.lastByte}`
                            }
                        }), i = e.br(t1, l);
                        this._fetchQueue.push(()=>{
                            i.cancel(), n.cancel();
                        });
                    }
                } else o(null);
            }
            updateNeeded(e, t1) {
                return (!this.textureDescriptor || this.textureDescriptor.band !== t1 || this.textureDescriptor.layer !== e) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i) {
                if (!this._mrt) return;
                const o = this._mrt.getLayer(t1);
                if (!o || !o.hasBand(i) || !o.hasDataForBand(i)) return;
                const { bytes: s, tileSize: r, buffer: n, offset: a, scale: l } = o.getBandView(i), c = r + 2 * n, h = new e.r({
                    width: c,
                    height: c
                }, s), d = this.texture;
                d && d instanceof e.T && d.update(h, {
                    premultiply: !1
                }), this.textureDescriptor = {
                    layer: t1,
                    band: i,
                    img: h,
                    buffer: n,
                    offset: a,
                    tileSize: r,
                    format: o.pixelFormat,
                    mix: [
                        l,
                        256 * l,
                        65536 * l,
                        16777216 * l
                    ]
                };
            }
        }
        class Et {
            constructor(e, t1){
                this.max = e, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e in this.data)for (const t1 of this.data[e])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e, t1, i) {
                const o = e.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const s = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (s.timeout = setTimeout(()=>{
                    this.remove(e, s);
                }, i)), this.data[o].push(s), this.order.push(o), this.order.length > this.max) {
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            has(e) {
                return e.wrapped().key in this.data;
            }
            getAndRemove(e) {
                return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
            }
            _getAndRemoveByKey(e) {
                const t1 = this.data[e].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e].length && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t1.value;
            }
            getByKey(e) {
                const t1 = this.data[e];
                return t1 ? t1[0].value : null;
            }
            get(e) {
                return this.has(e) ? this.data[e.wrapped().key][0].value : null;
            }
            remove(e, t1) {
                if (!this.has(e)) return this;
                const i = e.wrapped().key, o = void 0 === t1 ? 0 : this.data[i].indexOf(t1), s = this.data[i][o];
                return this.data[i].splice(o, 1), s.timeout && clearTimeout(s.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(s.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e) {
                for(this.max = e; this.order.length > this.max;){
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            filter(e) {
                const t1 = [];
                for(const i in this.data)for (const o of this.data[i])e(o.value) || t1.push(o);
                for (const e of t1)this.remove(e.value.tileID, e);
            }
        }
        class St {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(t1, i, o) {
                const s = String(i);
                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][s] = this.stateChanges[t1][s] || {}, e.h(this.stateChanges[t1][s], o), null === this.deletedStates[t1]) {
                    this.deletedStates[t1] = {};
                    for(const e in this.state[t1])e !== s && (this.deletedStates[t1][e] = null);
                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][s]) {
                    this.deletedStates[t1][s] = {};
                    for(const e in this.state[t1][s])o[e] || (this.deletedStates[t1][s][e] = null);
                } else for(const e in o)this.deletedStates[t1] && this.deletedStates[t1][s] && null === this.deletedStates[t1][s][e] && delete this.deletedStates[t1][s][e];
            }
            removeFeatureState(e, t1, i) {
                if (null === this.deletedStates[e]) return;
                const o = String(t1);
                if (this.deletedStates[e] = this.deletedStates[e] || {}, i && void 0 !== t1) null !== this.deletedStates[e][o] && (this.deletedStates[e][o] = this.deletedStates[e][o] || {}, this.deletedStates[e][o][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e] && this.stateChanges[e][o]) for(i in this.deletedStates[e][o] = {}, this.stateChanges[e][o])this.deletedStates[e][o][i] = null;
                    else this.deletedStates[e][o] = null;
                } else this.deletedStates[e] = null;
            }
            getState(t1, i) {
                const o = this.state[t1] || {}, s = this.stateChanges[t1] || {}, r = this.deletedStates[t1];
                if (null === r) return {};
                if (void 0 !== i) {
                    const t1 = String(i), n = e.h({}, o[t1], s[t1]);
                    if (r) {
                        const e = r[i];
                        if (null === e) return {};
                        for(const t1 in e)delete n[t1];
                    }
                    return n;
                }
                const n = e.h({}, o, s);
                if (r) for(const e in r)delete n[e];
                return n;
            }
            initializeTileState(e, t1) {
                e.refreshFeatureState(t1);
            }
            coalesceChanges(t1, i) {
                const o = {};
                for(const t1 in this.stateChanges){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    for(const o in this.stateChanges[t1])this.state[t1][o] || (this.state[t1][o] = {}), e.h(this.state[t1][o], this.stateChanges[t1][o]), i[o] = this.state[t1][o];
                    o[t1] = i;
                }
                for(const t1 in this.deletedStates){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    if (null === this.deletedStates[t1]) for(const e in this.state[t1])i[e] = {}, this.state[t1][e] = {};
                    else for(const e in this.deletedStates[t1]){
                        if (null === this.deletedStates[t1][e]) this.state[t1][e] = {};
                        else if (this.state[t1][e]) for (const i of Object.keys(this.deletedStates[t1][e]))delete this.state[t1][e][i];
                        i[e] = this.state[t1][e];
                    }
                    o[t1] = o[t1] || {}, e.h(o[t1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o).length) for(const e in t1)t1[e].refreshFeatureState(i);
            }
        }
        class It extends e.E {
            constructor(e, t1, i){
                super(), this.id = e, this._onlySymbols = i, t1.on("data", (e)=>{
                    "source" === e.dataType && "metadata" === e.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e.dataType && "content" === e.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t1, this._tiles = {}, this._cache = new Et(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new St, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
            onAdd(e) {
                this.map = e, this._minTileCacheSize = void 0 === this._minTileCacheSize && e ? e._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e ? e._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e in this._tiles)if (!this._tiles[e].loaded()) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e, t1) {
                return e.isSymbolTile = this._onlySymbols, e.isExtraShadowCaster = this._shadowCasterTiles[e.tileID.key], this._source.loadTile(e, t1);
            }
            _unloadTile(e) {
                if (this._source.unloadTile) return this._source.unloadTile(e);
            }
            _abortTile(e) {
                if (this._source.abortTile) return this._source.abortTile(e);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e)=>e.tileID).sort(Ct).map((e)=>e.key);
            }
            getRenderableIds(t1, i) {
                const o = [];
                for(const e in this._tiles)this._isIdRenderable(+e, t1, i) && o.push(this._tiles[e]);
                return t1 ? o.sort((t1, i)=>{
                    const o = t1.tileID, s = i.tileID, r = new e.P(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), n = new e.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - s.overscaledZ || n.y - r.y || n.x - r.x;
                }).map((e)=>e.tileID.key) : o.map((e)=>e.tileID).sort(Ct).map((e)=>e.key);
            }
            hasRenderableParent(e) {
                const t1 = this.findLoadedParent(e, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e, t1, i) {
                return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t1 || !this._tiles[e].holdingForFade()) && (i || !this._shadowCasterTiles[e]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e in this._tiles)"errored" !== this._tiles[e].state && this._reloadTile(+e, "reloading");
                }
            }
            _reloadTile(e, t1) {
                const i = this._tiles[e];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e, t1)));
            }
            _tileLoaded(t1, i, o, s) {
                if (s) {
                    if (t1.state = "errored", 404 !== s.status) this._source.fire(new e.z(s, {
                        tile: t1
                    }));
                    else {
                        if (this._source.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e = this.map.painter.terrain;
                            this.update(this.transform, e.getScaledDemTileSize(), !0), e.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                } else t1.timeAdded = e.q.now(), "expired" === o && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), this._source.fire(new e.A("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(e) {
                const t1 = this.getRenderableIds();
                for(let o = 0; o < t1.length; o++){
                    const s = t1[o];
                    if (e.neighboringTiles && e.neighboringTiles[s]) {
                        const t1 = this.getTileByID(s);
                        i(e, t1), i(t1, e);
                    }
                }
                function i(e, t1) {
                    if (!e.dem || e.dem.borderReady) return;
                    e.needsHillshadePrepare = !0, e.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e.tileID.canonical.x;
                    const o = t1.tileID.canonical.y - e.tileID.canonical.y, s = Math.pow(2, e.tileID.canonical.z), r = t1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + s) ? i += s : 1 === Math.abs(i - s) && (i -= s)), t1.dem && e.dem && (e.dem.backfillBorder(t1.dem, i, o), e.neighboringTiles && e.neighboringTiles[r] && (e.neighboringTiles[r].backfilled = !0)));
                }
            }
            getTile(e) {
                return this.getTileByID(e.key);
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            _retainLoadedChildren(e, t1, i, o) {
                for(const s in this._tiles){
                    let r = this._tiles[s];
                    if (o[s] || !r.hasData() || r.tileID.overscaledZ <= t1 || r.tileID.overscaledZ > i) continue;
                    let n = r.tileID;
                    for(; r && r.tileID.overscaledZ > t1 + 1;){
                        const e = r.tileID.scaledTo(r.tileID.overscaledZ - 1);
                        r = this._tiles[e.key], r && r.hasData() && (n = e);
                    }
                    let a = n;
                    for(; a.overscaledZ > t1;)if (a = a.scaledTo(a.overscaledZ - 1), e[a.key]) {
                        o[n.key] = n;
                        break;
                    }
                }
            }
            findLoadedParent(e, t1) {
                if (e.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e.overscaledZ - 1; i >= t1; i--){
                    const t1 = e.scaledTo(i), o = this._getLoadedTile(t1);
                    if (o) return o;
                }
            }
            _getLoadedTile(e) {
                const t1 = this._tiles[e.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e.wrapped().key : e.canonical.key);
            }
            updateCacheSize(e, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e.width / t1) + 1, o = Math.ceil(e.height / t1) + 1, s = Math.floor(i * o * 5), r = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, s) : s, n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                this._cache.setMaxSize(n);
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - (void 0 === this._prevLng ? e : this._prevLng)) / 360);
                if (this._prevLng = e, t1) {
                    const e = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t1), e[o.tileID.key] = o;
                    }
                    this._tiles = e;
                    for(const e in this._timers)clearTimeout(this._timers[e]), delete this._timers[e];
                    for(const e in this._tiles)this._setTileReloadTimer(+e, this._tiles[e]);
                }
            }
            update(t1, i, o, s, r) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !o) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const n = "batched-model" === this._source.type;
                let a, l = this._source.maxzoom;
                const c = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (c && c.sourceCache === this && c.attenuationRange()) {
                    const e = c.attenuationRange()[0], t1 = Math.floor(e) - Math.log2(c.getDemUpscale());
                    l > t1 && (l = t1);
                }
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e.aM(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const s = t1.clone();
                        s.tileCoverLift = this.tileCoverLift, a = s.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: l,
                            roundZoom: this._source.roundZoom && !o,
                            reparseOverscaled: this._source.reparseOverscaled,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: n
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e.aM(1, 0, 1, 0, 0)), a.push(new e.aM(1, 0, 1, 1, 0)), a.push(new e.aM(1, 0, 1, 0, 1)), a.push(new e.aM(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: l,
                        roundZoom: this._source.roundZoom && !o,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: n
                    }), this._source.hasTile) {
                        const e = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e(t1));
                    }
                } else a = [];
                if (a.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !Rt(this._source.type)) {
                    const e = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !o
                    }), l = Math.min(e, this._source.maxzoom);
                    if (n) {
                        const e = t1.extendTileCover(a, l);
                        for (const t1 of e)a.push(t1);
                    } else if (r) {
                        const e = t1.extendTileCover(a, l, this.transform._camera.forward());
                        for (const t1 of e)a.push(t1);
                    } else if (this.castsShadows && s) {
                        const e = t1.extendTileCover(a, l, s);
                        for (const t1 of e)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const h = this._updateRetainedTiles(a);
                if (Rt(this._source.type) && 0 !== a.length) {
                    const t1 = {}, i = {}, o = Object.keys(h);
                    for (const s of o){
                        const o = h[s], r = this._tiles[s];
                        if (!r || r.fadeEndTime && r.fadeEndTime <= e.q.now()) continue;
                        const n = this.findLoadedParent(o, Math.max(o.overscaledZ - It.maxOverzooming, this._source.minzoom));
                        n && (this._addTile(n.tileID), t1[n.tileID.key] = n.tileID), i[s] = o;
                    }
                    const s = a[a.length - 1].overscaledZ;
                    for(const e in this._tiles){
                        const t1 = this._tiles[e];
                        if (h[e] || !t1.hasData()) continue;
                        let o = t1.tileID;
                        for(; o.overscaledZ > s;){
                            o = o.scaledTo(o.overscaledZ - 1);
                            const s = this._tiles[o.key];
                            if (s && s.hasData() && i[o.key]) {
                                h[e] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e in t1)h[e] || (this._coveredTiles[e] = !0, h[e] = t1[e]);
                }
                for(const e in h)this._tiles[e].clearFadeHold();
                const d = e.bs(this._tiles, h);
                for (const e of d){
                    const t1 = this._tiles[e];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e in this._tiles)this._tiles[e].holdingForFade() && this._removeTile(+e);
            }
            _updateRetainedTiles(e) {
                const t1 = {};
                if (0 === e.length) return t1;
                const i = {}, o = e.reduce((e, t1)=>Math.min(e, t1.overscaledZ), 1 / 0), s = e[0].overscaledZ, r = Math.max(s - It.maxOverzooming, this._source.minzoom), n = Math.max(s + It.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e){
                    const e = this._addTile(i);
                    t1[i.key] = i, e.hasData() || o < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, o, n, t1);
                for (const o of e){
                    let e = this._tiles[o.key];
                    if (e.hasData()) continue;
                    if (o.canonical.z >= this._source.maxzoom) {
                        const e = o.children(this._source.maxzoom)[0], i = this.getTile(e);
                        if (i && i.hasData()) {
                            t1[e.key] = e;
                            continue;
                        }
                    } else {
                        const e = o.children(this._source.maxzoom);
                        if (t1[e[0].key] && t1[e[1].key] && t1[e[2].key] && t1[e[3].key]) continue;
                    }
                    let s = e.wasRequested();
                    for(let n = o.overscaledZ - 1; n >= r; --n){
                        const r = o.scaledTo(n);
                        if (i[r.key]) break;
                        if (i[r.key] = !0, e = this.getTile(r), !e && s && (e = this._addTile(r)), e && (t1[r.key] = r, s = e.wasRequested(), e.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e in this._tiles){
                    const t1 = [];
                    let i, o = this._tiles[e].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        t1.push(o.key);
                        const e = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(e), i) break;
                        o = e;
                    }
                    for (const e of t1)this._loadedParentTiles[e] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const o = Boolean(i);
                if (!o) {
                    const e = this.map ? this.map.painter : null, o = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? new Tt(t1, o, this.transform.tileZoom, e, this._isRaster) : new wt(t1, o, this.transform.tileZoom, e, this._isRaster, this._source.worldview), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i.uses++, this._tiles[t1.key] = i, o || this._source.fire(new e.A("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e, t1) {
                e in this._timers && (clearTimeout(this._timers[e]), delete this._timers[e]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e] = setTimeout(()=>{
                    this._reloadTile(e, "expired"), delete this._timers[e];
                }, i));
            }
            _removeTile(e) {
                const t1 = this._tiles[e];
                t1 && (t1.uses--, delete this._tiles[e], this._timers[e] && (clearTimeout(this._timers[e]), delete this._timers[e]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e in this._tiles)this._removeTile(+e);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, o) {
                const s = [], r = this.transform;
                if (!r) return s;
                const n = "globe" === r.projection.name, a = e.aD(r.center.lng);
                for(const l in this._tiles){
                    const c = this._tiles[l];
                    if (o && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (n) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e.ay(a, ...Dt(t1, -1)) - a),
                                Math.abs(e.ay(a, ...Dt(t1, 1)) - a)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e.ay(a, ...Dt(t1, -1)) - a),
                                Math.abs(e.ay(a, ...Dt(t1, 0)) - a),
                                Math.abs(e.ay(a, ...Dt(t1, 1)) - a)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e of h){
                        const o = t1.containsTile(c, r, i, e);
                        o && s.push(o);
                    }
                }
                return s;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e) {
                return this._getRenderableCoordinates(e);
            }
            _getRenderableCoordinates(e, t1) {
                const i = this.getRenderableIds(e, t1).map((e)=>this._tiles[e].tileID), o = "globe" === this.transform.projection.name;
                for (const e of i)e.projMatrix = this.transform.calculateProjMatrix(e.toUnwrapped()), e.expandedProjMatrix = o ? this.transform.calculateProjMatrix(e.toUnwrapped(), !1, !0) : e.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e) {
                const t1 = e.slice(), i = this.transform._camera.position, o = this.transform._camera.forward(), s = {};
                for (const e of t1){
                    const t1 = 1 / (1 << e.canonical.z);
                    s[e.key] = ((e.canonical.x + .5) * t1 + e.wrap - i[0]) * o[0] + ((e.canonical.y + .5) * t1 - i[1]) * o[1] - i[2] * o[2];
                }
                return t1.sort((e, t1)=>s[e.key] - s[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Rt(this._source.type)) for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= e.q.now()) return !0;
                }
                return !1;
            }
            setFeatureState(e, t1, i) {
                this._state.updateState(e = e || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e, t1, i) {
                this._state.removeFeatureState(e = e || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e, t1) {
                return this._state.getState(e = e || "_geojsonTileLayer", t1);
            }
            setDependencies(e, t1, i) {
                const o = this._tiles[e];
                o && o.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e = ()=>{
                        this._sourceLoaded && (this._source.off("data", e), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e);
                }
                const o = new Map, s = Array.isArray(t1) ? t1 : [
                    t1
                ], r = this.map.painter.terrain, n = this.usedForTerrain && r ? r.getScaledDemTileSize() : this._source.tileSize;
                for (const e of s){
                    const t1 = e.coveringTiles({
                        tileSize: n,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e of t1)o.set(e.key, e);
                    this.usedForTerrain && e.updateElevation(!1);
                }
                const a = Array.from(o.values());
                e.bt(a, (e, t1)=>{
                    const i = new wt(e, this._source.tileSize * e.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                    this._loadTile(i, (e)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e, i);
                    });
                }, i);
            }
        }
        function Ct(e, t1) {
            const i = Math.abs(2 * e.wrap) - +(e.wrap < 0), o = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e.overscaledZ - t1.overscaledZ || o - i || t1.canonical.y - e.canonical.y || t1.canonical.x - e.canonical.x;
        }
        function Rt(e) {
            return "raster" === e || "image" === e || "video" === e || "custom" === e;
        }
        function Dt(e, t1) {
            const i = 1 << e.z;
            return [
                e.x / i + t1,
                (e.x + 1) / i + t1
            ];
        }
        It.maxOverzooming = 10, It.maxUnderzooming = 3;
        class At {
            constructor(e){
                this.style = e, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const o = this.style._mergedLayers[i];
                    if ("fill-extrusion" === o.type || "building" === o.type) this.layers.push({
                        layer: o,
                        visible: e,
                        visibilityChanged: t1
                    });
                    else if ("model" === o.type) {
                        const i = this.style.getLayerSource(o);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: o,
                            visible: e,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let o = !1;
                    "fill-extrusion" === i.type ? o = !i.isHidden(e) && i.paint.get("fill-extrusion-opacity") > 0 : "building" === i.type ? o = !i.isHidden(e) && i.paint.get("building-opacity") > 0 : "model" === i.type && (o = !i.isHidden(e) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !o && t1.visible, t1.visible = o;
                }
            }
            updateZOffset(e, t1) {
                this.currentBuildingBuckets = [];
                for (const e of this.layers){
                    const i = e.layer, o = this.style.getLayerSourceCache(i);
                    let s = 1;
                    "fill-extrusion" === i.type ? s = e.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i.type && (s = e.visible ? i.paint.get("building-vertical-scale") : 0);
                    let r = o ? o.getTile(t1) : null;
                    if (!r && o && t1.canonical.z > o.getSource().minzoom) {
                        let e = t1.scaledTo(Math.min(o.getSource().maxzoom, t1.overscaledZ - 1));
                        for(; e.overscaledZ >= o.getSource().minzoom && (r = o.getTile(e), !r && 0 !== e.overscaledZ);)e = e.scaledTo(e.overscaledZ - 1);
                    }
                    this.currentBuildingBuckets.push({
                        bucket: r ? r.getBucket(i) : null,
                        tileID: r ? r.tileID : t1,
                        verticalScale: s
                    });
                }
                e.hasAnyZOffset = !1;
                let i = !1;
                for(let o = 0; o < e.symbolInstances.length; o++){
                    const s = e.symbolInstances.get(o), r = s.zOffset, n = this._getHeightAtTileOffset(t1, s.tileAnchorX, s.tileAnchorY);
                    s.zOffset = n !== Number.NEGATIVE_INFINITY ? n : r, i || r === s.zOffset || (i = !0), e.hasAnyZOffset || 0 === s.zOffset || (e.hasAnyZOffset = !0);
                }
                i && (e.zOffsetBuffersNeedUpload = !0, e.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(t1, i, o, s) {
                let r = i, n = o;
                if (t1.canonical.z !== s.canonical.z) {
                    const a = s.canonical, l = 1 / (1 << t1.canonical.z - a.z);
                    r = (i + t1.canonical.x * e.aj) * l - a.x * e.aj | 0, n = (o + t1.canonical.y * e.aj) * l - a.y * e.aj | 0;
                }
                return {
                    tileX: r,
                    tileY: n
                };
            }
            _getHeightAtTileOffset(e, t1, i) {
                let o, s;
                for(let r = 0; r < this.layers.length; ++r){
                    const n = this.layers[r].layer;
                    if ("fill-extrusion" !== n.type && "building" !== n.type) continue;
                    const { bucket: a, tileID: l, verticalScale: c } = this.currentBuildingBuckets[r];
                    if (!a) continue;
                    const { tileX: h, tileY: d } = this._mapCoordToOverlappingTile(e, t1, i, l), u = a.getHeightAtTileCoord(h, d);
                    u && void 0 !== u.height && (u.hidden ? o = u.height : s = Math.max(u.height * c, s || 0));
                }
                if (void 0 !== s) return s;
                for(let s = 0; s < this.layers.length; ++s){
                    const r = this.layers[s];
                    if ("model" !== r.layer.type || !r.visible) continue;
                    const { bucket: n, tileID: a } = this.currentBuildingBuckets[s];
                    if (!n) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e, t1, i, a), h = n.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== o ? Math.min(h.maxHeight, o) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        function Lt(t1, i) {
            const o = {};
            for(const e in t1)"ref" !== e && (o[e] = t1[e]);
            return e.bu.forEach((e)=>{
                e in i && (o[e] = i[e]);
            }), o;
        }
        function Pt(e) {
            e = e.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e.length; i++)t1[e[i].id] = e[i];
            for(let i = 0; i < e.length; i++)"ref" in e[i] && (e[i] = Lt(e[i], t1[e[i].ref]));
            return e;
        }
        const zt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setSnow: "setSnow",
            setRain: "setRain",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            updateImport: "updateImport",
            addIconset: "addIconset",
            removeIconset: "removeIconset"
        };
        function Mt(e, t1, i) {
            i.push({
                command: zt.addSource,
                args: [
                    e,
                    t1[e]
                ]
            });
        }
        function Ot(e, t1, i) {
            t1.push({
                command: zt.removeSource,
                args: [
                    e
                ]
            }), i[e] = !0;
        }
        function Ft(e, t1, i, o) {
            Ot(e, i, o), Mt(e, t1, i);
        }
        function Bt(t1, i, o) {
            let s;
            for(s in t1[o])if (t1[o].hasOwnProperty(s) && "data" !== s && !e.bv(t1[o][s], i[o][s])) return !1;
            for(s in i[o])if (i[o].hasOwnProperty(s) && "data" !== s && !e.bv(t1[o][s], i[o][s])) return !1;
            return !0;
        }
        function kt(t1, i, o, s, r, n) {
            let a;
            for(a in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(a) && (e.bv(t1[a], i[a]) || o.push({
                command: n,
                args: [
                    s,
                    a,
                    i[a],
                    r
                ]
            }));
            for(a in i)i.hasOwnProperty(a) && !t1.hasOwnProperty(a) && (e.bv(t1[a], i[a]) || o.push({
                command: n,
                args: [
                    s,
                    a,
                    i[a],
                    r
                ]
            }));
        }
        function Nt(e) {
            return e.id;
        }
        function Ut(e, t1) {
            return e[t1.id] = t1, e;
        }
        class jt {
            constructor(e, t1){
                this.reset(e, t1);
            }
            reset(e, t1) {
                this.points = e || [], this._distances = [
                    0
                ];
                for(let e = 1; e < this.points.length; e++)this._distances[e] = this._distances[e - 1] + this.points[e].dist(this.points[e - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e.ay(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const s = t1 * this.paddedLength + this.padding;
                for(; o < s && i < this._distances.length;)o = this._distances[++i];
                const r = i - 1, n = this._distances[r], a = o - n, l = a > 0 ? (s - n) / a : 0;
                return this.points[r].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        class Vt {
            constructor(e, t1, i){
                const o = this.boxCells = [], s = this.circleCells = [];
                this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e = 0; e < this.xCellCount * this.yCellCount; e++)o.push([]), s.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t1, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e, t1, i, o, s) {
                this._forEachCell(t1, i, o, s, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(s);
            }
            insertCircle(e, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e, t1, i, o, s, r) {
                this.boxCells[s].push(r);
            }
            _insertCircleCell(e, t1, i, o, s, r) {
                this.circleCells[s].push(r);
            }
            _query(e, t1, i, o, s, r) {
                if (i < 0 || e > this.width || o < 0 || t1 > this.height) return !s && [];
                const n = [];
                if (e <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (s) return !0;
                    for(let e = 0; e < this.boxKeys.length; e++)n.push({
                        key: this.boxKeys[e],
                        x1: this.bboxes[4 * e],
                        y1: this.bboxes[4 * e + 1],
                        x2: this.bboxes[4 * e + 2],
                        y2: this.bboxes[4 * e + 3]
                    });
                    for(let e = 0; e < this.circleKeys.length; e++){
                        const t1 = this.circles[3 * e], i = this.circles[3 * e + 1], o = this.circles[3 * e + 2];
                        n.push({
                            key: this.circleKeys[e],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return r ? n.filter(r) : n;
                }
                return this._forEachCell(e, t1, i, o, this._queryCell, n, {
                    hitTest: s,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), s ? n.length > 0 : n;
            }
            _queryCircle(e, t1, i, o, s) {
                const r = e - i, n = e + i, a = t1 - i, l = t1 + i;
                if (n < 0 || r > this.width || l < 0 || a > this.height) return !o && [];
                const c = [];
                return this._forEachCell(r, a, n, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s), o ? c.length > 0 : c;
            }
            query(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !1, s);
            }
            hitTest(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !0, s);
            }
            hitTestCircle(e, t1, i, o) {
                return this._queryCircle(e, t1, i, !0, o);
            }
            _queryCell(e, t1, i, o, s, r, n, a) {
                const l = n.seenUids, c = this.boxCells[s];
                if (null !== c) {
                    const s = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e <= s[c + 2] && t1 <= s[c + 3] && i >= s[c + 0] && o >= s[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (n.hitTest) return r.push(!0), !0;
                            r.push({
                                key: this.boxKeys[h],
                                x1: s[c],
                                y1: s[c + 1],
                                x2: s[c + 2],
                                y2: s[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[s];
                if (null !== h) {
                    const s = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(s[h], s[h + 1], s[h + 2], e, t1, i, o) && (!a || a(this.circleKeys[c]))) {
                            if (n.hitTest) return r.push(!0), !0;
                            {
                                const e = s[h], t1 = s[h + 1], i = s[h + 2];
                                r.push({
                                    key: this.circleKeys[c],
                                    x1: e - i,
                                    y1: t1 - i,
                                    x2: e + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e, t1, i, o, s, r, n, a) {
                const l = n.circle, c = n.seenUids, h = this.boxCells[s];
                if (null !== h) {
                    const e = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e[i + 0], e[i + 1], e[i + 2], e[i + 3]) && (!a || a(this.boxKeys[t1]))) return r.push(!0), !0;
                    }
                }
                const d = this.circleCells[s];
                if (null !== d) {
                    const e = this.circles;
                    for (const t1 of d)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e[i], e[i + 1], e[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t1]))) return r.push(!0), !0;
                    }
                }
            }
            _forEachCell(e, t1, i, o, s, r, n, a) {
                const l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), d = this._convertToYCellCoord(o);
                for(let u = l; u <= h; u++)for(let l = c; l <= d; l++)if (s.call(this, e, t1, i, o, this.xCellCount * l + u, r, n, a)) return;
            }
            _convertToXCellCoord(e) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
            }
            _convertToYCellCoord(e) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
            }
            _circlesCollide(e, t1, i, o, s, r) {
                const n = o - e, a = s - t1, l = i + r;
                return l * l > n * n + a * a;
            }
            _circleAndRectCollide(e, t1, i, o, s, r, n) {
                const a = (r - o) / 2, l = Math.abs(e - (o + a));
                if (l > a + i) return !1;
                const c = (n - s) / 2, h = Math.abs(t1 - (s + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const d = l - a, u = h - c;
                return d * d + u * u <= i * i;
            }
        }
        const Gt = {
            unknown: 0,
            flipRequired: 1,
            flipNotRequired: 2
        }, qt = Math.tan(85 * Math.PI / 180);
        function Zt(t1, i, o, s, r, n, a) {
            const l = e.bz();
            if (o) {
                if ("globe" === n.name) {
                    const t1 = e.bA(r, i);
                    e.az(l, l, t1);
                } else {
                    const t1 = e.bB([], a);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], s || e.by(l, l, r.angle);
                }
            } else e.az(l, r.labelPlaneMatrix, t1);
            return l;
        }
        function Ht(e, t1, i, o, s, r, n) {
            const a = Zt(e, t1, i, o, s, r, n);
            return "globe" === r.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function Wt(t1, i, o, s, r, n, a) {
            if (o) {
                if ("globe" === n.name) {
                    const l = Zt(t1, i, o, s, r, n, a);
                    return e.bi(l, l), e.az(l, t1, l), l;
                }
                {
                    const i = e.bw(t1), o = e.bx([]);
                    return o[0] = a[0], o[1] = a[1], o[4] = a[2], o[5] = a[3], e.az(i, i, o), s || e.by(i, i, -r.angle), i;
                }
            }
            return r.glCoordMatrix;
        }
        function $t(t1, i, o, s) {
            const r = [
                t1,
                i,
                o,
                1
            ];
            o ? e.aA(r, r, s) : ri(r, r, s);
            const n = r[3];
            return r[0] /= n, r[1] /= n, r[2] /= n, r;
        }
        function Xt(e, t1) {
            return Math.min(.5 + e / t1 * .5, 1.5);
        }
        function Yt(e, t1) {
            const i = e[0] / e[3], o = e[1] / e[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function Kt(t1, i, o, s, r, n, a, l, c, h) {
            const d = o.transform, u = s ? t1.textSizeData : t1.iconSizeData, _ = e.bH(u, o.transform.zoom), p = "globe" === d.projection.name, f = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], m = s ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            m.clear();
            let g = null;
            p && (g = s ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const v = t1.lineVertexArray, y = s ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, x = o.transform.width / o.transform.height;
            let b, w = !1;
            for(let s = 0; s < y.length; s++){
                const p = y.get(s), { numGlyphs: T, writingMode: E } = p;
                if (E !== e.bI.vertical || w || b === e.bI.horizontal || (w = !0), b = E, (p.hidden || E === e.bI.vertical) && !w) {
                    si(T, m);
                    continue;
                }
                w = !1;
                const S = new e.P(p.tileAnchorX, p.tileAnchorY);
                let { x: I, y: C, z: R } = d.projection.projectTilePoint(S.x, S.y, h.canonical);
                if (c) {
                    const [e, t1, i] = c(S);
                    I += e, C += t1, R += i;
                }
                const D = [
                    I,
                    C,
                    R,
                    1
                ];
                if (e.aA(D, D, i), !Yt(D, f)) {
                    si(T, m);
                    continue;
                }
                const A = D[3], L = Xt(o.transform.getCameraToCenterDistance(d.projection), A), P = e.bJ(u, _, p), z = a ? P / L : P * L, M = $t(I, C, R, r);
                if (M[3] <= 0) {
                    si(T, m);
                    continue;
                }
                let O = {};
                const F = e.al(t1.layers[0].layout.get("text-max-angle")), B = Math.cos(F), k = a ? null : c, N = ei(p, z, !1, l, i, r, n, t1.glyphOffsetArray, v, m, g, M, S, O, x, k, d.projection, h, a, B);
                w = N.useVertical, k && N.needsFlipping && (O = {}), (N.notEnoughRoom || w || N.needsFlipping && ei(p, z, !0, l, i, r, n, t1.glyphOffsetArray, v, m, g, M, S, O, x, k, d.projection, h, a, B).notEnoughRoom) && si(T, m);
            }
            s ? (t1.text.dynamicLayoutVertexBuffer.updateData(m), g && t1.text.globeExtVertexBuffer && t1.text.globeExtVertexBuffer.updateData(g)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(m), g && t1.icon.globeExtVertexBuffer && t1.icon.globeExtVertexBuffer.updateData(g));
        }
        function Jt(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m) {
            const { lineStartIndex: g, glyphStartIndex: v, segment: y } = a, x = v + a.numGlyphs, b = g + a.lineLength, w = t1.getoffsetX(v), T = t1.getoffsetX(x - 1), E = oi(e * w, i, o, s, r, n, y, g, b, l, c, h, d, u, !0, _, p, f, m);
            if (!E) return null;
            const S = oi(e * T, i, o, s, r, n, y, g, b, l, c, h, d, u, !0, _, p, f, m);
            return S ? {
                first: E,
                last: S
            } : null;
        }
        function Qt(t1, i, o, s) {
            return t1 === e.bI.horizontal && Math.abs(s) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e.bI.vertical ? s > 0 ? {
                needsFlipping: !0
            } : null : i !== Gt.unknown && function(e, t1) {
                return 0 === e || Math.abs(t1 / e) > qt;
            }(o, s) ? i === Gt.flipRequired ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function ei(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x) {
            const b = i / 24, w = t1.lineOffsetX * b, T = t1.lineOffsetY * b, { lineStartIndex: E, glyphStartIndex: S, numGlyphs: I, segment: C, writingMode: R, flipState: D } = t1, A = E + t1.lineLength, L = (t1)=>{
                if (d) {
                    const [i, o, s] = t1.up, r = h.length;
                    e.bK(d, r + 0, i, o, s), e.bK(d, r + 1, i, o, s), e.bK(d, r + 2, i, o, s), e.bK(d, r + 3, i, o, s);
                }
                const [i, o, s] = t1.point;
                e.bL(h, i, o, s, t1.angle);
            };
            if (I > 1) {
                const e = Jt(b, l, w, T, o, u, _, t1, c, n, p, m, !1, g, v, y, x);
                if (!e) return {
                    notEnoughRoom: !0
                };
                if (s && !o) {
                    let [i, o, s] = e.first.point, [r, n, l] = e.last.point;
                    [i, o] = $t(i, o, s, a), [r, n] = $t(r, n, l, a);
                    const c = Qt(R, D, (r - i) * f, n - o);
                    if (t1.flipState = c && c.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, c) return c;
                }
                L(e.first);
                for(let e = S + 1; e < S + I - 1; e++){
                    const t1 = oi(b * l.getoffsetX(e), w, T, o, u, _, C, E, A, c, n, p, m, !1, !1, g, v, y, x);
                    if (!t1) return h.length -= 4 * (e - S), {
                        notEnoughRoom: !0
                    };
                    L(t1);
                }
                L(e.last);
            } else {
                if (s && !o) {
                    const i = $t(_.x, _.y, 0, r), o = E + C + 1, s = new e.P(c.getx(o), c.gety(o)), n = $t(s.x, s.y, 0, r), a = n[3] > 0 ? n : ii(_, s, i, 1, r, void 0, g, v.canonical), l = Qt(R, D, (a[0] - i[0]) * f, a[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, l) return l;
                }
                const i = oi(b * l.getoffsetX(S), w, T, o, u, _, C, E, A, c, n, p, m, !1, !1, g, v, y, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                L(i);
            }
            return {};
        }
        function ti(e, t1, i, o, s) {
            const { x: r, y: n, z: a } = o.projectTilePoint(e.x, e.y, t1);
            if (!s) return $t(r, n, a, i);
            const [l, c, h] = s(e);
            return $t(r + l, n + c, a + h, i);
        }
        function ii(t1, i, o, s, r, n, a, l) {
            const c = ti(t1.sub(i)._unit()._add(t1), l, r, a, n);
            return e.at(c, o, c), e.au(c, c), e.bE(c, o, c, s);
        }
        function oi(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y) {
            const x = s ? t1 - i : t1 + i;
            let b = x > 0 ? 1 : -1, w = 0;
            s && (b *= -1, w = Math.PI), b < 0 && (w += Math.PI);
            let T = l + a + (b > 0 ? 0 : 1) | 0, E = r, S = r, I = 0, C = 0;
            const R = Math.abs(x), D = [], A = [];
            let L = n, P = L, z = e.bC([]);
            const M = ()=>ii(P, L, S, R - I + 1, d, _, m, g.canonical);
            for(; I + C <= R;){
                if (T += b, T < l || T >= c) return null;
                if (S = E, P = L, D.push(S), p && A.push(P), L = new e.P(h.getx(T), h.gety(T)), E = u[T], !E) {
                    const e = ti(L, g.canonical, d, m, _);
                    E = e[3] > 0 ? u[T] = e : M();
                }
                I += C;
                const t1 = e.at([], E, S), i = e.bD(S, E);
                if (o && i > 0 && C > 0 && e.bG(z, t1) / (C * i) < y) return null;
                C = i, z = t1;
            }
            f && _ && (u[T] && (E = M(), C = e.bD(S, E), z = e.at([], E, S)), u[T] = E);
            const O = (R - I) / C, F = L.sub(P)._mult(O)._add(P), B = e.bE([], S, z, O);
            let k = [
                0,
                0,
                1
            ], N = z[0], U = z[1];
            if (v && (k = m.upVector(g.canonical, F.x, F.y), 0 !== k[0] || 0 !== k[1] || 1 !== k[2])) {
                const t1 = [
                    k[2],
                    0,
                    -k[0]
                ], i = e.bF([], k, t1);
                e.au(t1, t1), e.au(i, i), N = e.bG(z, t1), U = e.bG(z, i);
            }
            if (o) {
                const t1 = e.bF([], k, z);
                e.au(t1, t1), e.bE(B, B, t1, o * b);
            }
            const j = w + Math.atan2(U, N);
            return D.push(B), p && A.push(F), {
                point: B,
                angle: j,
                path: D,
                tilePath: A,
                up: k
            };
        }
        function si(e, t1) {
            const i = t1.length, o = i + 4 * e;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function ri(e, t1, i) {
            const o = t1[0], s = t1[1];
            return e[0] = i[0] * o + i[4] * s + i[12], e[1] = i[1] * o + i[5] * s + i[13], e[3] = i[3] * o + i[7] * s + i[15], e;
        }
        const ni = 100;
        class ai {
            constructor(e, t1, i = new Vt(e.width + 200, e.height + 200, 25), o = new Vt(e.width + 200, e.height + 200, 25)){
                this.transform = e, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + ni, this.screenBottomBoundary = e.height + ni, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.fogState = t1;
            }
            placeCollisionBox(e, t1, i, o, s, r, n, a) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const d = i.elevation, u = i.tileID, _ = e.getProjection();
                if (d && u) {
                    const [e, t1, o] = _.upVector(u.canonical, i.tileAnchorX, i.tileAnchorY), s = _.upVectorScale(u.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e * d * s, c += t1 * d * s, h += o * d * s;
                }
                const p = this.projectAndGetPerspectiveRatio(n, l, c, h, i.tileID, "globe" === _.name || !!d || this.transform.pitch > 0, _), f = r * p.perspectiveRatio, m = (i.x1 * t1 + o.x - i.padding) * f + p.point.x, g = (i.y1 * t1 + o.y - i.padding) * f + p.point.y, v = (i.x2 * t1 + o.x + i.padding) * f + p.point.x, y = (i.y2 * t1 + o.y + i.padding) * f + p.point.y, x = p.perspectiveRatio <= .55 || p.occluded;
                return !this.isInsideGrid(m, g, v, y) || !s && this.grid.hitTest(m, g, v, y, a) || x ? {
                    box: [],
                    offscreen: !1,
                    occluded: p.occluded
                } : {
                    box: [
                        m,
                        g,
                        v,
                        y
                    ],
                    offscreen: this.isOffscreen(m, g, v, y),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f) {
                const m = [], g = this.transform.elevation, v = t1.getProjection(), y = g ? g.getAtTileOffsetFunc(f, this.transform.center.lat, this.transform.worldSize, v) : null, x = new e.P(o.tileAnchorX, o.tileAnchorY);
                let { x: b, y: w, z: T } = v.projectTilePoint(x.x, x.y, f.canonical);
                if (y) {
                    const [e, t1, i] = y(x);
                    b += e, w += t1, T += i;
                }
                const E = "globe" === v.name, S = this.projectAndGetPerspectiveRatio(a, b, w, T, f, E || !!g || this.transform.pitch > 0, v), { perspectiveRatio: I } = S, C = (d ? n / I : n * I) / e.bO, R = $t(b, w, T, l), D = o.lineOffsetX * C, A = o.lineOffsetY * C, L = e.al(t1.layers[0].layout.get("text-max-angle")), P = Math.cos(L), z = S.signedDistanceFromCamera > 0 ? Jt(C, r, D, A, !1, R, x, o, s, l, {}, g && !d ? y : null, d && !!g, v, f, d, P) : null;
                let M = !1, O = !1, F = !0;
                if (z && !S.occluded) {
                    const t1 = .5 * _ * I + p, o = new e.P(-100, -100), s = new e.P(this.screenRightBoundary, this.screenBottomBoundary), r = new jt, { first: n, last: a } = z, l = n.path.length;
                    let d = [];
                    for(let e = l - 1; e >= 1; e--)d.push(n.path[e]);
                    for(let e = 1; e < a.path.length; e++)d.push(a.path[e]);
                    const f = 2.5 * t1;
                    c && (d = d.map(([e, t1, i], o)=>(y && !E && (i = y(o < l - 1 ? n.tilePath[l - 1 - o] : a.tilePath[o - l + 2])[2]), $t(e, t1, i, c))), d.some((e)=>e[3] <= 0) && (d = []));
                    let g = [];
                    if (d.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, r = 1 / 0, n = -1 / 0;
                        for (const e of d)t1 = Math.min(t1, e[0]), r = Math.min(r, e[1]), i = Math.max(i, e[0]), n = Math.max(n, e[1]);
                        i >= o.x && t1 <= s.x && n >= o.y && r <= s.y && (g = [
                            d.map((t1)=>new e.P(t1[0], t1[1]))
                        ], (t1 < o.x || i > s.x || r < o.y || n > s.y) && (g = e.bM(g, o.x, o.y, s.x, s.y)));
                    }
                    for (const e of g){
                        r.reset(e, .25 * t1);
                        let o = 0;
                        o = r.length <= .5 * t1 ? 1 : Math.ceil(r.paddedLength / f) + 1;
                        for(let e = 0; e < o; e++){
                            const s = e / Math.max(o - 1, 1), n = r.lerp(s), a = n.x + ni, l = n.y + ni;
                            m.push(a, l, t1, 0);
                            const c = a - t1, d = l - t1, _ = a + t1, p = l + t1;
                            if (F = F && this.isOffscreen(c, d, _, p), O = O || this.isInsideGrid(c, d, _, p), !i && this.grid.hitTestCircle(a, l, t1, u) && (M = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: M,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !h && M || !O ? [] : m,
                    offscreen: F,
                    collisionDetected: M,
                    occluded: S.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, s = 1 / 0, r = -1 / 0, n = -1 / 0;
                for (const a of t1){
                    const t1 = new e.P(a.x + ni, a.y + ni);
                    o = Math.min(o, t1.x), s = Math.min(s, t1.y), r = Math.max(r, t1.x), n = Math.max(n, t1.y), i.push(t1);
                }
                const a = this.grid.query(o, s, r, n).concat(this.ignoredGrid.query(o, s, r, n)), l = {}, c = {};
                for (const t1 of a){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const s = [
                        new e.P(t1.x1, t1.y1),
                        new e.P(t1.x2, t1.y1),
                        new e.P(t1.x2, t1.y2),
                        new e.P(t1.x1, t1.y2)
                    ];
                    e.bN(i, s) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e, t1, i, o, s) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                }, e[0], e[1], e[2], e[3]);
            }
            insertCollisionCircles(e, t1, i, o, s) {
                const r = t1 ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                };
                for(let t1 = 0; t1 < e.length; t1 += 4)r.insertCircle(n, e[t1], e[t1 + 1], e[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, s, r, n, a) {
                const l = [
                    i,
                    o,
                    s,
                    1
                ];
                let c = !1;
                if (s || this.transform.pitch > 0) {
                    if (e.aA(l, l, t1), this.fogState && r && "globe" !== a.name) {
                        const t1 = function(t1, i, o, s, r, n) {
                            const a = n.calculateFogTileMatrix(r), l = [
                                i,
                                o,
                                s
                            ];
                            return e.ad(l, l, a), Be(t1, e.ae(l), n.pitch, n._fov);
                        }(this.fogState, i, o, s, r.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else ri(l, l, t1);
                const h = l[3];
                return {
                    point: new e.P((l[0] / h + 1) / 2 * this.transform.width + ni, (-l[1] / h + 1) / 2 * this.transform.height + ni),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: n && l[2] > h || c
                };
            }
            isOffscreen(e, t1, i, o) {
                return i < ni || e >= this.screenRightBoundary || o < ni || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e, t1, i, o) {
                return i >= 0 && e < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e.bx([]);
                return e.bo(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        function li(t1, i, o) {
            const s = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e.az(new Float32Array(16), t1.projMatrix, s);
        }
        function ci(e, t1, i) {
            if (t1.projection.name === i.projection.name) return e.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), li(o, t1.getProjection(), e);
        }
        function hi(e, t1, i) {
            return t1.name === i.projection.name ? e.projMatrix : li(i, t1, e);
        }
        class di {
            constructor(e, t1, i, o){
                this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class ui {
            constructor(e, t1, i, o, s, r = !1){
                this.text = new di(e ? e.text : null, t1, i, s), this.icon = new di(e ? e.icon : null, t1, o, s), this.clipped = r;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class _i {
            constructor(e, t1, i, o = !1){
                this.text = e, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class pi {
            constructor(){
                this.invProjMatrix = e.bz(), this.viewportMatrix = e.bz(), this.circles = [];
            }
        }
        class fi {
            constructor(e, t1, i, o, s){
                this.bucketInstanceId = e, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = s;
            }
        }
        class mi {
            constructor(e){
                this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e] = {
                        ID: t1,
                        predicate: (e)=>e.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e];
            }
        }
        function gi(t1, i, o, s, r) {
            const { horizontalAlign: n, verticalAlign: a } = e.bT(t1), l = -(n - .5) * i, c = -(a - .5) * o, h = e.bU(t1, s);
            return new e.P(l + h[0] * r, c + h[1] * r);
        }
        function vi(t1, i, o, s, r) {
            const n = new e.P(t1, i);
            return o && n._rotate(s ? r : -r), n;
        }
        class yi {
            constructor(e, t1, i, o, s, r){
                this.transform = e.clone(), this.projection = e.projection.name, this.collisionIndex = new ai(this.transform, s), this.buildingIndex = r, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new mi(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(t1, i, o, s, r = 1) {
                const n = o.getBucket(i), a = o.latestFeatureIndex;
                if (!n || !a || i.fqid !== n.layerIds[0]) return;
                const l = n.layers[0].layout, c = n.layers[0].paint, h = o.collisionBoxArray, d = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / e.aj, _ = o.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const p = (f = o.tileID, m = n.getProjection(), g = this.transform, m.name === this.projection ? g.calculateProjMatrix(f.toUnwrapped()) : li(g, m, f));
                var f, m, g;
                const v = "map" === l.get("text-pitch-alignment"), y = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const x = i.dynamicFilter(), b = i.dynamicFilterNeedsFeature(), w = this.transform.calculatePixelsToTileUnitsMatrix(o), T = Ht(p, o.tileID.canonical, v, y, this.transform, n.getProjection(), w);
                let E = null;
                if (v) {
                    const t1 = Wt(p, o.tileID.canonical, v, y, this.transform, n.getProjection(), w);
                    E = e.az([], this.transform.labelPlaneMatrix, t1);
                }
                let S = null;
                x && o.latestFeatureIndex && (S = {
                    unwrappedTileID: _,
                    dynamicFilter: x,
                    dynamicFilterNeedsFeature: b
                }), this.retainedQueryData[n.bucketInstanceId] = new fi(n.bucketInstanceId, a, n.sourceLayerIndex, n.index, o.tileID);
                const [I, C] = n.layers[0].layout.get("text-size-scale-range"), R = e.ay(r, I, C), [D, A] = l.get("icon-size-scale-range"), L = e.ay(r, D, A), P = {
                    bucket: n,
                    layout: l,
                    paint: c,
                    posMatrix: p,
                    textLabelPlaneMatrix: T,
                    labelToScreenMatrix: E,
                    clippingData: S,
                    scale: d,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e.bH(n.textSizeData, this.transform.zoom, R),
                    partiallyEvaluatedIconSize: e.bH(n.iconSizeData, this.transform.zoom, L),
                    collisionGroup: this.collisionGroups.get(n.sourceID),
                    latestFeatureIndex: o.latestFeatureIndex
                };
                if (s) for (const e of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: s } = e;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: s,
                        parameters: P
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: P
                });
            }
            attemptAnchorPlacement(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g) {
                const { textOffset0: v, textOffset1: y, crossTileID: x } = d, b = [
                    v,
                    y
                ], w = gi(e, i, o, b, s), T = this.collisionIndex.placeCollisionBox(_, s, t1, vi(w.x, w.y, r, n, this.transform.angle), h, a, l, c.predicate);
                if (f) {
                    const e = _.getSymbolInstanceIconSize(g, this.transform.zoom, d.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(_, e, f, vi(w.x, w.y, r, n, this.transform.angle), h, a, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[x] && this.prevPlacement.placements[x] && this.prevPlacement.placements[x].text && (t1 = this.prevPlacement.variableOffsets[x].anchor), this.variableOffsets[x] = {
                        textOffset: b,
                        width: i,
                        height: o,
                        anchor: e,
                        textScale: s,
                        prevAnchor: t1
                    }, this.markUsedJustification(_, e, d, p), _.allowVerticalPlacement && (this.markUsedOrientation(_, p, d), this.placedOrientations[x] = p), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, s, r = 1) {
                const { bucket: n, layout: a, paint: l, posMatrix: c, textLabelPlaneMatrix: h, labelToScreenMatrix: d, clippingData: u, textPixelRatio: _, holdingForFade: p, collisionBoxArray: f, partiallyEvaluatedTextSize: m, partiallyEvaluatedIconSize: g, collisionGroup: v, latestFeatureIndex: y } = t1.parameters, x = a.get("text-optional"), b = a.get("icon-optional"), w = a.get("text-allow-overlap"), T = a.get("icon-allow-overlap"), E = "map" === a.get("text-rotation-alignment"), S = "map" === a.get("text-pitch-alignment"), I = l.get("symbol-z-offset"), C = "sea" === a.get("symbol-elevation-reference"), [R, D] = a.get("text-size-scale-range"), [A, L] = a.get("icon-size-scale-range"), P = e.ay(r, R, D), z = e.ay(r, A, L);
                this.transform.setProjection(n.projection);
                let M = w && (T || !n.hasIconData() || b), O = T && (w || !n.hasTextData() || x);
                const F = !I.isConstant();
                !n.collisionArrays && f && n.deserializeCollisionBoxes(f), o && s && n.updateCollisionDebugBuffers(this.transform.zoom, f, P, z);
                const B = (t1, s, l)=>{
                    const { crossTileID: f, numVerticalGlyphVertices: R } = t1;
                    let D = null;
                    if (u && u.dynamicFilterNeedsFeature || F) {
                        const e = this.retainedQueryData[n.bucketInstanceId];
                        D = y.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: e.bucketIndex,
                            sourceLayerIndex: e.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        });
                    }
                    if (u && !(0, u.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch
                    }, D, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new e.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(u.unwrappedTileID))) return this.placements[f] = new _i(!1, !1, !1, !0), void i.add(f);
                    const A = I.evaluate(D, {});
                    if (i.has(f)) return;
                    if (p) return void (this.placements[f] = new _i(!1, !1, !1));
                    let L = !1, P = !1, z = !0, B = !1, k = !1, N = null, U = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, j = {
                        box: null
                    }, V = null, G = null, q = null, Z = 0, H = 0, W = 0;
                    l.textFeatureIndex ? Z = l.textFeatureIndex : t1.useRuntimeCollisionCircles && (Z = t1.featureIndex), l.verticalTextFeatureIndex && (H = l.verticalTextFeatureIndex);
                    const $ = (e)=>{
                        e.tileID = this.retainedQueryData[n.bucketInstanceId].tileID;
                        const i = this.transform.elevation;
                        e.elevation = C ? A : A + (i ? i.getAtTileOffset(e.tileID, e.tileAnchorX, e.tileAnchorY) : 0), e.elevation += t1.zOffset;
                    }, X = l.textBox;
                    if (X) {
                        $(X);
                        const i = (i)=>{
                            let o = e.bI.horizontal;
                            if (n.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e = this.prevPlacement.placedOrientations[f];
                                e && (this.placedOrientations[f] = e, o = e, this.markUsedOrientation(n, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (n.allowVerticalPlacement && R > 0 && l.verticalTextBox) {
                                for (const o of n.writingModes)if (o === e.bI.vertical ? (U = i(), j = U) : U = t1(), U && U.box && U.box.length) break;
                            } else U = t1();
                        };
                        if (a.get("text-variable-anchor")) {
                            let r = a.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[f]) {
                                const e = this.prevPlacement.variableOffsets[f];
                                r.indexOf(e.anchor) > 0 && (r = r.filter((t1)=>t1 !== e.anchor), r.unshift(e.anchor));
                            }
                            const h = (e, i, o)=>{
                                const a = n.getSymbolInstanceTextSize(m, t1, this.transform.zoom, s), l = (e.x2 - e.x1) * a + 2 * e.padding, h = (e.y2 - e.y1) * a + 2 * e.padding, d = t1.hasIconTextFit && !T ? i : null;
                                d && $(d);
                                let u = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const p = w ? 2 * r.length : r.length;
                                for(let i = 0; i < p; ++i){
                                    const p = this.attemptAnchorPlacement(r[i % r.length], e, l, h, a, E, S, _, c, v, i >= r.length, t1, s, n, o, d, m, g);
                                    if (p && (u = p.placedGlyphBoxes, u && u.box && u.box.length)) {
                                        L = !0, N = p.shift;
                                        break;
                                    }
                                }
                                return u;
                            };
                            o(()=>h(X, l.iconBox, e.bI.horizontal), ()=>{
                                const t1 = l.verticalTextBox;
                                return t1 && $(t1), n.allowVerticalPlacement && !(U && U.box && U.box.length) && R > 0 && t1 ? h(t1, l.verticalIconBox, e.bI.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), U && (L = U.box, z = U.offscreen, B = U.occluded);
                            const d = i(!(!U || !U.box));
                            if (!L && this.prevPlacement) {
                                const e = this.prevPlacement.variableOffsets[f];
                                e && (this.variableOffsets[f] = e, this.markUsedJustification(n, e.anchor, t1, d));
                            }
                        } else {
                            const a = (i, o)=>{
                                const a = n.getSymbolInstanceTextSize(m, t1, this.transform.zoom, s, r), l = this.collisionIndex.placeCollisionBox(n, a, i, new e.P(0, 0), w, _, c, v.predicate);
                                return l && l.box && l.box.length && (this.markUsedOrientation(n, o, t1), this.placedOrientations[f] = o), l;
                            };
                            o(()=>a(X, e.bI.horizontal), ()=>{
                                const t1 = l.verticalTextBox;
                                return n.allowVerticalPlacement && R > 0 && t1 ? ($(t1), a(t1, e.bI.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!(U && U.box && U.box.length));
                        }
                    }
                    if (V = U, L = V && V.box && V.box.length > 0, z = V && V.offscreen, B = V && V.occluded, t1.useRuntimeCollisionCircles) {
                        const i = n.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex), s = e.bJ(n.textSizeData, m, i), r = a.get("text-padding");
                        G = this.collisionIndex.placeCollisionCircles(n, w, i, n.lineVertexArray, n.glyphOffsetArray, s, c, h, d, o, S, v.predicate, t1.collisionCircleDiameter * s / e.bO, r, this.retainedQueryData[n.bucketInstanceId].tileID), L = w || G.circles.length > 0 && !G.collisionDetected, z = z && G.offscreen, B = G.occluded;
                    }
                    if (l.iconFeatureIndex && (W = l.iconFeatureIndex), l.iconBox) {
                        const i = (i)=>{
                            $(i);
                            const o = t1.hasIconTextFit && N ? vi(N.x, N.y, E, S, this.transform.angle) : new e.P(0, 0), s = n.getSymbolInstanceIconSize(g, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(n, s, i, o, T, _, c, v.predicate);
                        };
                        j && j.box && j.box.length && l.verticalIconBox ? (q = i(l.verticalIconBox), P = q.box.length > 0) : (q = i(l.iconBox), P = q.box.length > 0), z = z && q.offscreen, k = q.occluded;
                    }
                    const Y = x || 0 === t1.numHorizontalGlyphVertices && 0 === R, K = b || 0 === t1.numIconVertices;
                    if (Y || K ? K ? Y || (P = P && L) : L = P && L : P = L = P && L, L && V && V.box && this.collisionIndex.insertCollisionBox(V.box, a.get("text-ignore-placement"), n.bucketInstanceId, j && j.box && H ? H : Z, v.ID), P && q && this.collisionIndex.insertCollisionBox(q.box, a.get("icon-ignore-placement"), n.bucketInstanceId, W, v.ID), G && (L && this.collisionIndex.insertCollisionCircles(G.circles, a.get("text-ignore-placement"), n.bucketInstanceId, Z, v.ID), o)) {
                        const e = n.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e] = new pi);
                        for(let e = 0; e < G.circles.length; e += 4)t1.circles.push(G.circles[e + 0]), t1.circles.push(G.circles[e + 1]), t1.circles.push(G.circles[e + 2]), t1.circles.push(G.collisionDetected ? 1 : 0);
                    }
                    const J = "globe" !== n.projection.name;
                    M = M && (J || !B), O = O && (J || !k), this.placements[f] = new _i(L || M, P || O, z || n.justReloaded), i.add(f);
                }, k = this.retainedQueryData[n.bucketInstanceId].tileID;
                if ("offset" === n.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(n, k), "road" === n.elevationType && n.updateRoadElevation(k.canonical), n.updateZOffset(), n.sortFeaturesByY) {
                    const t1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t1.length - 1; e >= 0; --e){
                        const i = t1[e];
                        B(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                    n.hasAnyZOffset && e.w(`${n.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (n.hasAnyZOffset) {
                    const e = n.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e.length; ++t1){
                        const i = e[t1];
                        B(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let e = t1.symbolInstanceStart; e < t1.symbolInstanceEnd; e++)B(n.symbolInstances.get(e), e, n.collisionArrays[e]);
                if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[n.bucketInstanceId];
                    e.bi(t1.invProjMatrix, c), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, s) {
                const { leftJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e.bV(i), d = s === e.bI.vertical ? l : "left" === h ? r : "center" === h ? n : "right" === h ? a : -1;
                r >= 0 && (t1.text.placedSymbolArray.get(r).crossTileID = d >= 0 && r !== d ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = d >= 0 && n !== d ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = d >= 0 && a !== d ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = d >= 0 && l !== d ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const s = i === e.bI.horizontal || i === e.bI.horizontalOnly ? i : 0, r = i === e.bI.vertical ? i : 0, { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                n >= 0 && (h.get(n).placedOrientation = s), a >= 0 && (h.get(a).placedOrientation = s), l >= 0 && (h.get(l).placedOrientation = s), c >= 0 && (h.get(c).placedOrientation = r);
            }
            commit(e) {
                this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e) : 1, s = t1 ? t1.opacities : {}, r = t1 ? t1.variableOffsets : {}, n = t1 ? t1.placedOrientations : {};
                for(const e in this.placements){
                    const t1 = this.placements[e], r = s[e];
                    r ? (this.opacities[e] = new ui(r, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== r.text.placed || t1.icon !== r.icon.placed) : (this.opacities[e] = new ui(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e in s){
                    const t1 = s[e];
                    if (!this.opacities[e]) {
                        const s = new ui(t1, o, !1, !1);
                        s.isHidden() || (this.opacities[e] = s, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e in r)this.variableOffsets[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.variableOffsets[e] = r[e]);
                for(const e in n)this.placedOrientations[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.placedOrientations[e] = n[e]);
                i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e);
            }
            updateLayerOpacities(e, t1, i, o) {
                const s = new Set;
                for (const r of t1){
                    const t1 = r.getBucket(e);
                    t1 && r.latestFeatureIndex && e.fqid === t1.layerIds[0] && (this.updateBucketOpacities(t1, s, r, r.collisionBoxArray, i, o, r.tileID, e.scope), "offset" === t1.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(t1, r.tileID), "road" === t1.elevationType && t1.updateRoadElevation(r.tileID.canonical), t1.updateZOffset());
                }
            }
            updateBucketOpacities(t1, i, o, s, r, n, a, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, d = !!t1.layers[0].dynamicFilter(), u = new ui(null, 0, !1, !1, !0), _ = c.get("text-allow-overlap"), p = c.get("icon-allow-overlap"), f = c.get("text-variable-anchor"), m = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), v = h.get("symbol-z-offset"), y = "sea" === c.get("symbol-elevation-reference"), x = !v.isConstant(), b = new ui(null, 0, _ && (p || !t1.hasIconData() || c.get("icon-optional")), p && (_ || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && s && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(s);
                const w = (e, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                n && t1.updateReplacement(a, n);
                for(let s = 0; s < t1.symbolInstances.length; s++){
                    const c = t1.symbolInstances.get(s), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: _, crossTileID: p, numIconVertices: E, tileAnchorX: S, tileAnchorY: I } = c;
                    let C = null;
                    const R = this.retainedQueryData[t1.bucketInstanceId];
                    x && c && R && (C = o.latestFeatureIndex.loadFeature({
                        featureIndex: c.featureIndex,
                        bucketIndex: R.bucketIndex,
                        sourceLayerIndex: R.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const D = v.evaluate(C, {}), A = i.has(p);
                    let L = this.opacities[p];
                    A ? L = u : L || (L = b, this.opacities[p] = L), i.add(p);
                    const P = h > 0 || _ > 0, z = E > 0, M = this.placedOrientations[p], O = M === e.bI.vertical, F = M === e.bI.horizontal || M === e.bI.horizontalOnly;
                    !P && !z || L.isHidden() || T++;
                    let B = !1;
                    if ((P || z) && n) for (const i of t1.activeReplacements){
                        if (e.bP(i, r, e.bQ.Symbol, l)) continue;
                        if (i.min.x > S || S > i.max.x || i.min.y > I || I > i.max.y) continue;
                        const t1 = e.bR(S, I, a.canonical, i.footprintTileId.canonical);
                        if (B = e.bS(t1, i.footprint), B) break;
                    }
                    if (P) {
                        const e = B ? Di : Ri(L.text);
                        w(t1.text, h, O ? Di : e), w(t1.text, _, F ? Di : e);
                        const i = L.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: r, verticalPlacedTextSymbolIndex: n } = c, a = t1.text.placedSymbolArray, l = i || O ? 1 : 0;
                        o >= 0 && (a.get(o).hidden = l), s >= 0 && (a.get(s).hidden = l), r >= 0 && (a.get(r).hidden = l), n >= 0 && (a.get(n).hidden = i || F ? 1 : 0);
                        const d = this.variableOffsets[p];
                        d && this.markUsedJustification(t1, d.anchor, c, M);
                        const u = this.placedOrientations[p];
                        u && (this.markUsedJustification(t1, "left", c, u), this.markUsedOrientation(t1, u, c));
                    }
                    if (z) {
                        const e = B ? Di : Ri(L.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = c, s = t1.icon.placedSymbolArray, r = L.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, E, O ? Di : e), s.get(i).hidden = r), o >= 0 && (w(t1.icon, c.numVerticalIconVertices, F ? Di : e), s.get(o).hidden = r);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[s];
                        if (i) {
                            let o = new e.P(0, 0), s = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (f) {
                                    const e = this.variableOffsets[p];
                                    e ? (o = gi(e.anchor, e.width, e.height, e.textOffset, e.textScale), m && o._rotate(g ? this.transform.angle : -this.transform.angle)) : s = !1;
                                }
                                d && (s = !L.clipped), i.textBox && xi(t1.textCollisionBox.collisionVertexArray, L.text.placed, !s || O, D, y, o.x, o.y), i.verticalTextBox && xi(t1.textCollisionBox.collisionVertexArray, L.text.placed, !s || F, D, y, o.x, o.y);
                            }
                            const r = s && Boolean(!F && i.verticalIconBox);
                            i.iconBox && xi(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, r, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0), i.verticalIconBox && xi(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, !r, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e.invProjMatrix, t1.placementViewportMatrix = e.viewportMatrix, t1.collisionCircleArray = e.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e) {
                return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e) {
                return Math.max(0, (this.transform.zoom - e) / 1.5);
            }
            hasTransitions(e) {
                return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function xi(e, t1, i, o, s, r, n) {
            e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0);
        }
        const bi = Math.pow(2, 25), wi = Math.pow(2, 24), Ti = Math.pow(2, 17), Ei = Math.pow(2, 16), Si = Math.pow(2, 9), Ii = Math.pow(2, 8), Ci = Math.pow(2, 1);
        function Ri(e) {
            if (0 === e.opacity && !e.placed) return 0;
            if (1 === e.opacity && e.placed) return 4294967295;
            const t1 = e.placed ? 1 : 0, i = Math.floor(127 * e.opacity);
            return i * bi + t1 * wi + i * Ti + t1 * Ei + i * Si + t1 * Ii + i * Ci + t1;
        }
        const Di = 0;
        class Ai {
            constructor(e){
                this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && void 0 !== e.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e, t1, i, o, s, r) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e.length;)if (t1.getBucketParts(n, o, e[this._currentTileIndex], this._sortAcrossTiles, r), this._currentTileIndex++, s()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e, t1)=>e.sortKey - t1.sortKey)); this._currentPartIndex < n.length;){
                    const e = n[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e, this._seenCrossTileIDs, i, 0 === e.symbolInstanceStart, r), this._currentPartIndex++, s()) return !0;
                }
                return !1;
            }
        }
        class Li {
            constructor(e, t1, i, o, s, r, n, a, l){
                this.placement = new yi(e, s, r, n, a, l), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o, s, r) {
                const n = e.q.now(), a = ()=>{
                    const t1 = e.q.now() - n;
                    return !this._forceFullPlacement && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const n = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && (!n.minzoom || n.minzoom <= l) && (!n.maxzoom || n.maxzoom > l)) {
                        const t1 = n, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), d = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), u = h && d, _ = this._inProgressLayer = this._inProgressLayer || new Ai(t1), p = e.C(n.source, n.scope);
                        if (_.continuePlacement(i || u ? s[p] : o[p], this.placement, this._showCollisionBoxes, n, a, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e) {
                return this.placement.commit(e), this.placement;
            }
        }
        const Pi = 512 / e.aj / 2;
        class zi {
            constructor(t1, i, o){
                this.tileID = t1, this.bucketInstanceId = o, this.index = new e.bW(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const s = t1.canonical.x * e.aj, r = t1.canonical.y * e.aj;
                for(let e = 0; e < i.length; e++){
                    const { key: t1, crossTileID: o, tileAnchorX: n, tileAnchorY: a } = i.get(e), l = Math.floor((s + n) * Pi), c = Math.floor((r + a) * Pi);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
            findMatches(t1, i, o) {
                const s = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), r = Pi / Math.pow(2, i.canonical.z - this.tileID.canonical.z), n = i.canonical.x * e.aj, a = i.canonical.y * e.aj;
                for(let e = 0; e < t1.length; e++){
                    const i = t1.get(e);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, d = Math.floor((n + c) * r), u = Math.floor((a + h) * r), _ = this.index.range(d - s, u - s, d + s, u + s).sort((e, t1)=>e - t1);
                    for (const e of _){
                        const t1 = this.crossTileIDs[e];
                        if (this.keys[e] === l && !o.has(t1)) {
                            o.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class Mi {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Oi {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - this.lng) / 360);
                if (0 !== t1) for(const e in this.indexes){
                    const i = this.indexes[e], o = {};
                    for(const e in i){
                        const s = i[e];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + t1), o[s.tileID.key] = s;
                    }
                    this.indexes[e] = o;
                }
                this.lng = e;
            }
            addBucket(e, t1, i) {
                if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                    if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
                }
                for(let e = 0; e < t1.symbolInstances.length; e++)t1.symbolInstances.get(e).crossTileID = 0;
                this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = new Set);
                const o = this.usedCrossTileIDs[e.overscaledZ];
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    if (Number(i) > e.overscaledZ) for(const i in s){
                        const r = s[i];
                        r.tileID.isChildOf(e) && r.findMatches(t1.symbolInstances, e, o);
                    }
                    else {
                        const r = s[e.scaledTo(Number(i)).key];
                        r && r.findMatches(t1.symbolInstances, e, o);
                    }
                }
                for(let e = 0; e < t1.symbolInstances.length; e++){
                    const s = t1.symbolInstances.get(e);
                    s.crossTileID || (s.crossTileID = i.generate(), o.add(s.crossTileID));
                }
                return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new zi(e, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e].delete(i);
            }
            removeStaleBuckets(e) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const s in o)e[o[s].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[s]), delete o[s], t1 = !0);
                }
                return t1;
            }
        }
        class Fi {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Mi, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e, t1, i, o) {
                let s = this.layerIndexes[e.fqid];
                void 0 === s && (s = this.layerIndexes[e.fqid] = new Oi);
                let r = !1;
                const n = {};
                "globe" !== o.name && s.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e);
                    t1 && e.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, t1, this.crossTileIDs) && (r = !0), n[t1.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(n) && (r = !0), r;
            }
            pruneUnusedLayers(e) {
                const t1 = {};
                e.forEach((e)=>{
                    t1[e] = !0;
                });
                for(const e in this.layerIndexes)t1[e] || delete this.layerIndexes[e];
            }
        }
        const Bi = 771;
        class ki {
            constructor(e, t1, i, o){
                this.blendFunction = e, this.blendColor = t1.toNonPremultipliedRenderColor(null), this.mask = i, this.blendEquation = o;
            }
        }
        ki.Replace = [
            1,
            0,
            1,
            0
        ], ki.disabled = new ki(ki.Replace, e.am.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), ki.unblended = new ki(ki.Replace, e.am.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.alphaBlended = new ki([
            1,
            Bi,
            1,
            Bi
        ], e.am.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.alphaBlendedNonPremultiplied = new ki([
            770,
            Bi,
            770,
            Bi
        ], e.am.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.multiply = new ki([
            774,
            0,
            774,
            0
        ], e.am.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Ni {
            constructor(e, t1, i){
                this.func = e, this.mask = t1, this.range = i;
            }
        }
        Ni.ReadOnly = !1, Ni.ReadWrite = !0, Ni.disabled = new Ni(519, Ni.ReadOnly, [
            0,
            1
        ]);
        const Ui = 7680;
        class ji {
            constructor(e, t1, i, o, s, r){
                this.test = e, this.ref = t1, this.mask = i, this.fail = o, this.depthFail = s, this.pass = r;
            }
        }
        ji.disabled = new ji({
            func: 519,
            mask: 0
        }, 0, 0, Ui, Ui, Ui);
        const Vi = 1029, Gi = 2305;
        class qi {
            constructor(e, t1, i){
                this.enable = e, this.mode = t1, this.frontFace = i;
            }
        }
        function Zi(t1, i) {
            const o = e.c1(t1, 3);
            e.c3(t1, i), e.c7(t1, 3, o);
        }
        function Hi(t1, i) {
            const o = e.b_([]);
            return e.b$(o, o, -i), e.c0(o, o, -t1), o;
        }
        function Wi(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], s = [
                i[0],
                i[1],
                0
            ];
            if (e.ae(o) >= 1e-15) {
                const t1 = e.au([], o);
                e.bY(s, t1, e.bG(s, t1)), i[0] = s[0], i[1] = s[1];
            }
            const r = e.bF([], i, t1);
            if (e.bZ(r) < 1e-15) return null;
            const n = Math.atan2(-r[1], r[0]);
            return Hi(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), n);
        }
        qi.disabled = new qi(!1, Vi, Gi), qi.backCCW = new qi(!0, Vi, Gi), qi.backCW = new qi(!0, Vi, 2304), qi.frontCW = new qi(!0, 1028, 2304), qi.frontCCW = new qi(!0, 1028, Gi);
        class $i {
            constructor(e, t1){
                this.position = e, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e.ac ? t1 : new e.ac(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e.bX(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i) {
                if (this.orientation = null, !this.position) return;
                const o = this.position, s = this._elevation ? this._elevation.getAtPointOrZero(e.ac.fromLngLat(t1)) : 0, r = e.ac.fromLngLat(t1, s), n = [
                    r.x - o.x,
                    r.y - o.y,
                    r.z - o.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = Wi(n, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Hi(e.al(t1), e.al(-i));
            }
        }
        class Xi {
            constructor(t1, i){
                this._transform = e.bx([]), this.orientation = i, this.position = t1;
            }
            get mercatorPosition() {
                const t1 = this.position;
                return new e.ac(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e.c1(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e.c7(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e.b_([]), t1 && Zi(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e[0] * e[0] + e[1] * e[1]), -e[2])
                };
            }
            setPitchBearing(e, t1) {
                this._orientation = Hi(e, t1), Zi(this._transform, this._orientation);
            }
            forward() {
                const t1 = e.c1(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e.c1(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e.c1(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e.bi(o, this.getWorldToCamera(t1, i)), o;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(t1, i, o) {
                const s = this.position;
                e.bY(s, s, -t1);
                const r = new Float64Array(16);
                return e.bn(r, [
                    o,
                    o,
                    o
                ]), e.bo(r, r, s), r[10] *= i, r;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), s = new Float64Array(4), r = this.position;
                return e.c2(s, this._orientation), e.bY(r, r, -t1), e.c3(o, s), e.bo(o, o, r), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, s) {
                const r = new Float64Array(16);
                return e.c4(r, t1, i, o, s), r;
            }
            getCameraToClipOrthographic(t1, i, o, s, r, n) {
                const a = new Float64Array(16);
                return e.c5(a, t1, i, o, s, r, n), a;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e.c6(t1, i ? e.aY(this.position[1]) : this.position[1]), s = this.forward();
                return (o - this.position[2]) / s[2];
            }
            clone() {
                return new Xi([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const Yi = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            LUT: 10,
            ShadowMap0: 11
        };
        class Ki {
            constructor(e = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e) || e < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e, this.bottom = t1, this.left = i, this.right = o;
            }
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e.ai(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e.ai(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e.ai(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e.ai(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e.ay((this.left + t1 - this.right) / 2, 0, t1), s = e.ay((this.top + i - this.bottom) / 2, 0, i);
                return new e.P(o, s);
            }
            equals(e) {
                return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
            }
            clone() {
                return new Ki(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        const Ji = 15;
        class Qi {
            constructor(t1, i, o, s, r, n, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === r || r, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = o ?? 0, this._maxPitch = s ?? 60, this.setProjection(n), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new e.cd(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Ki, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Xi, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1, this._allowWorldUnderZoom = !1;
            }
            clone() {
                const e = new Qi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
                return e._elevation = this._elevation, e._centerAltitude = this._centerAltitude, e._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e.tileSize = this.tileSize, e.mercatorFromTransition = this.mercatorFromTransition, e.width = this.width, e.height = this.height, e.cameraElevationReference = this.cameraElevationReference, e._center = this._center, e._setZoom(this.zoom), e._seaLevelZoom = this._seaLevelZoom, e.angle = this.angle, e._fov = this._fov, e._pitch = this._pitch, e._nearZ = this._nearZ, e._farZ = this._farZ, e._averageElevation = this._averageElevation, e._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e._unmodified = this._unmodified, e._edgeInsets = this._edgeInsets.clone(), e._camera = this._camera.clone(), e._calcMatrices(), e.freezeTileCoverage = this.freezeTileCoverage, e.frustumCorners = this.frustumCorners, e._allowWorldUnderZoom = this._allowWorldUnderZoom, e;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < Ji;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e) {
                this._elevation !== e && (this._elevation = e, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e.aF(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(t1) {
                this.projectionOptions = t1 || {
                    name: "mercator"
                };
                const i = this.projection ? this.getProjection() : void 0;
                this.projection = e.ce(this.projectionOptions);
                const o = this.getProjection(), s = !e.bv(i, o);
                return s && this._calcMatrices(), this.mercatorFromTransition = !1, s;
            }
            setOrthographicProjectionAtLowPitch(e) {
                return this._orthographicProjectionAtLowPitch !== e && (this._orthographicProjectionAtLowPitch = e, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e.ce({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e) {
                this._minZoom !== e && (this._minZoom = e, this.zoom = Math.max(this.zoom, e));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e) {
                this._maxZoom !== e && (this._maxZoom = e, this.zoom = Math.min(this.zoom, e));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e) {
                this._minPitch !== e && (this._minPitch = e, this.pitch = Math.max(this.pitch, e));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e) {
                this._maxPitch !== e && (this._maxPitch = e, this.pitch = Math.min(this.pitch, e));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e) {
                void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get cameraWorldSize() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e.c6(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e.P(this.width, this.height);
            }
            get bearing() {
                return e.bX(this.rotation, -180, 180);
            }
            set bearing(e) {
                this.rotation = e;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e.cf(), e.cg(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e.ay(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e.al(t1), this._calcMatrices());
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e);
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e) {
                this._averageElevation = e, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e) {
                const t1 = Math.min(Math.max(e, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e) {
                this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e) {
                this._tileCoverLift !== e && (this._tileCoverLift = e);
            }
            _updateCameraOnTerrain() {
                const e = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                if (void 0 === this._centerAltitudeValidForExaggeration) return;
                const e = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
                this._seaLevelZoom = this._zoomFromMercatorZ(e);
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let s = 0, r = 0;
                for(let n = 0; n < i.length; n++){
                    const a = new e.P(i[n][0] * this.width, o + i[n][1] * (this.height - o)), l = t1.pointCoordinate(a);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    s += l[3] * c, r += c;
                }
                return 0 === r ? NaN : s / r;
            }
            get center() {
                return this._center;
            }
            set center(e) {
                e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e), s = this._mercatorZfromZoom(this._maxZoom), r = Math.max(o - i, s);
                this._setZoom(this._zoomFromMercatorZ(r));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e) {
                this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const s = e.ae(e.at([], this._camera.position, o));
                return e.ay(this._zoomFromMercatorZ(s), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e.ch(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e.ci(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new $i;
                return i.position = new e.ac(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e.cj(t1)) return !1;
                e.ck(t1, t1);
                const i = e.cl([], [
                    0,
                    0,
                    -1
                ], t1), o = e.cl([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const s = Wi(i, o);
                return !!s && (this._camera.orientation = s, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, s = this.cameraToCenterDistance;
                t1[2] = e.ay(t1[2], s / o, s / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e) {
                return this._edgeInsets.equals(e);
            }
            interpolatePadding(e, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e) {
                const t1 = (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e.cm(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e.P(0, 0)), s = this.pointCoordinate(new e.P(this.width, 0)), r = this.pointCoordinate(new e.P(this.width, this.height)), n = this.pointCoordinate(new e.P(0, this.height)), a = Math.floor(Math.min(o.x, s.x, r.x, n.x)), l = Math.floor(Math.max(o.x, s.x, r.x, n.x)), c = 1;
                    for(let o = a - c; o <= l + c; o++)0 !== o && i.push(new e.cm(o, t1));
                }
                return i;
            }
            isLODDisabled(e) {
                return (!e || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t1, i, o) {
                let s = [];
                const r = null != o, n = !r;
                if (n && this.zoom < i) return s;
                if (r && 0 === o[0] && 0 === o[1]) return s;
                const a = new Set, l = (t1, i, o, r, n)=>{
                    const l = e.cK(i, t1, o, r, n);
                    a.has(l) || (s.push(new e.aM(t1, i, o, r, n)), a.add(l));
                };
                for(let e = 0; e < t1.length; e++){
                    const s = t1[e];
                    if (n && s.canonical.z !== i) continue;
                    const a = s.canonical, c = s.overscaledZ, h = s.wrap, d = 1 << a.z, u = a.x + 1 < d, _ = a.x > 0, p = a.y + 1 < d, f = a.y > 0, m = s.wrap - (_ ? 0 : 1), g = s.wrap + (u ? 0 : 1), v = _ ? a.x - 1 : d - 1, y = u ? a.x + 1 : 0;
                    if (r) o[0] < 0 ? (l(c, g, a.z, y, a.y), o[1] < 0 && p && (l(c, h, a.z, a.x, a.y + 1), l(c, g, a.z, y, a.y + 1)), o[1] > 0 && f && (l(c, h, a.z, a.x, a.y - 1), l(c, g, a.z, y, a.y - 1))) : o[0] > 0 ? (l(c, m, a.z, v, a.y), o[1] < 0 && p && (l(c, h, a.z, a.x, a.y + 1), l(c, m, a.z, v, a.y + 1)), o[1] > 0 && f && (l(c, h, a.z, a.x, a.y - 1), l(c, m, a.z, v, a.y - 1))) : o[1] < 0 && p ? l(c, h, a.z, a.x, a.y + 1) : f && l(c, h, a.z, a.x, a.y - 1);
                    else {
                        const e = s.visibleQuadrants;
                        1 & e && (l(c, m, a.z, v, a.y), f && (l(c, h, a.z, a.x, a.y - 1), l(c, m, a.z, v, a.y - 1))), 2 & e && (l(c, g, a.z, y, a.y), f && (l(c, h, a.z, a.x, a.y - 1), l(c, g, a.z, y, a.y - 1))), 4 & e && (l(c, m, a.z, v, a.y), p && (l(c, h, a.z, a.x, a.y + 1), l(c, m, a.z, v, a.y + 1))), 8 & e && (l(c, g, a.z, y, a.y), p && (l(c, h, a.z, a.x, a.y + 1), l(c, g, a.z, y, a.y + 1)));
                    }
                }
                const c = [];
                for (const e of s)s.some((t1)=>e.isChildOf(t1)) || c.push(e);
                if (s = c.filter((e)=>!t1.some((t1)=>!!(e.overscaledZ < i && t1.isChildOf(e)) || e.equals(t1) || e.isChildOf(t1))), n) {
                    const e = 1 << i, t1 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o = [
                        e * t1.x,
                        e * t1.y
                    ], r = 4, n = r * r;
                    s = s.filter((e)=>{
                        const t1 = e.canonical.x + .5 - o[0], i = e.canonical.y + .5 - o[1];
                        return t1 * t1 + i * i < n;
                    });
                }
                return s;
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, s = this.elevation && this.elevation.exaggeration(), r = s && !t1.isTerrainDEM, n = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const a = this.locationCoordinate(this.center), l = this.center.lat, c = 1 << i, h = [
                    c * a.x,
                    c * a.y,
                    0
                ], d = "globe" === this.projection.name, u = !d, _ = e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, u), p = d ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = c * e.c6(1, this.center.lat), m = this._camera.position[2] / e.c6(1, this.center.lat), g = [
                    c * p.x,
                    c * p.y,
                    m * (u ? 1 : f)
                ], v = d || s, y = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? i : 0;
                let b;
                if (this._elevation && t1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e = this._elevation.getMinMaxForVisibleTiles();
                    b = e ? e.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = t1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T = this.projection.isReprojectedInTileSpace ? e.co(this) : 1, E = (t1)=>{
                    const i = 1 / 4e4, o = new e.ac(t1.x + i, t1.y, t1.z), s = new e.ac(t1.x, t1.y + i, t1.z), r = t1.toLngLat(), n = o.toLngLat(), a = s.toLngLat(), l = this.locationCoordinate(r), c = this.locationCoordinate(n), h = this.locationCoordinate(a), d = Math.hypot(c.x - l.x, c.y - l.y), u = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(d * u) * T / i;
                }, S = (t1)=>{
                    const i = b, o = w;
                    return {
                        aabb: e.cr(this, c, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, I = [];
                let C = [];
                const R = i, D = t1.reparseOverscaled ? o : i, A = (m - this._centerAltitude) * f, L = (e)=>{
                    if (!this._elevation || !e.tileID || !n) return;
                    const t1 = this._elevation.getMinMaxForTile(e.tileID), i = e.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e.shouldSplit = z(e), e.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (e, t1)=>{
                    if (.707 * t1 < e) return 1;
                    const i = t1 / e;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, z = (t1)=>{
                    if (t1.zoom < x) return !0;
                    if (t1.zoom === R) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(g), s = t1.aabb.distanceY(g);
                    let a = A, c = 1;
                    if (d) {
                        a = t1.aabb.distanceZ(g);
                        const i = Math.pow(2, t1.zoom), o = e.aY((t1.y + 1) / i), s = e.aY(t1.y / i), r = Math.min(Math.max(l, o), s), n = e.cO(r) / e.cO(l);
                        if (c = r === l ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, n / this._mercatorScaleRatio), this.zoom <= e.cL && t1.zoom === R - 1 && n >= .9) return !0;
                    } else if (r && (a = t1.aabb.distanceZ(g) * f), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = E(new e.ac((t1.x + .5) / i, (t1.y + .5) / i));
                        c = o > .85 ? 1 : o;
                    }
                    if (!n) {
                        const e = Math.sqrt(i * i + s * s + a * a);
                        let o = (1 << R - t1.zoom) * y * c;
                        return o *= P(Math.max(a, A), e), e < o;
                    }
                    let u = Number.MAX_VALUE, _ = 0;
                    const p = t1.aabb.getCorners(), m = [];
                    for (const t1 of p){
                        e.at(m, t1, g), d || (r ? m[2] *= f : m[2] = A);
                        const i = e.bG(m, this._camera.forward());
                        i < u && (u = i, _ = Math.abs(m[2]));
                    }
                    let v = (1 << R - t1.zoom) * y * c;
                    if (v *= P(Math.max(_, A), u), u < v) return !0;
                    const b = t1.aabb.closestPoint(h);
                    return b[0] === h[0] && b[1] === h[1];
                };
                if (this.renderWorldCopies) for(let e = 1; e <= 3; e++)I.push(S(-e)), I.push(S(e));
                for(I.push(S(0)); I.length > 0;){
                    const o = I.pop(), s = o.x, a = o.y;
                    let l = o.fullyVisible;
                    const u = ()=>"globe" === this.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
                    if (!l) {
                        let t1 = v ? o.aabb.intersects(_) : o.aabb.intersectsFlat(_);
                        if (0 === t1 && u()) {
                            const i = new e.cp(o.zoom, s, a);
                            t1 = e.cq(this, c, i, !0).intersects(_);
                        }
                        if (0 === t1) continue;
                        l = 2 === t1;
                    }
                    if (o.zoom !== R && z(o)) for(let t1 = 0; t1 < 4; t1++){
                        const i = (s << 1) + t1 % 2, h = (a << 1) + (t1 >> 1), u = {
                            aabb: n ? o.aabb.quadrant(t1) : e.cr(this, c, o.zoom + 1, i, h, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: h,
                            wrap: o.wrap,
                            fullyVisible: l,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        r && !d && (u.tileID = new e.aM(o.zoom + 1 === R ? D : o.zoom + 1, o.wrap, o.zoom + 1, i, h), L(u)), I.push(u);
                    }
                    else {
                        const r = o.zoom === R ? D : o.zoom;
                        if (t1.minzoom && t1.minzoom > r) continue;
                        let n = 0;
                        if (!l) {
                            let i = v ? o.aabb.intersectsPrecise(_) : o.aabb.intersectsPreciseFlat(_);
                            if (0 === i && u()) {
                                const t1 = new e.cp(o.zoom, s, a);
                                i = e.cq(this, c, t1, !0).intersectsPrecise(_);
                            }
                            if (0 === i) continue;
                            if (t1.calculateQuadrantVisibility) {
                                if (_.containsPoint(o.aabb.center)) n = 15;
                                else for(let e = 0; e < 4; e++)0 !== o.aabb.quadrant(e).intersects(_) && (n |= 1 << e);
                            }
                        }
                        const d = h[0] - (.5 + s + (o.wrap << o.zoom)) * (1 << i - o.zoom), p = h[1] - .5 - a, f = o.tileID ? o.tileID : new e.aM(r, o.wrap, o.zoom, s, a);
                        t1.calculateQuadrantVisibility && (f.visibleQuadrants = n), C.push({
                            tileID: f,
                            distanceSq: d * d + p * p
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    C = C.filter((s)=>{
                        const r = [
                            0,
                            0,
                            0,
                            1
                        ], n = [
                            e.aj,
                            e.aj,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(s.tileID.toUnwrapped());
                        e.aA(r, r, a), e.aA(n, n, a);
                        const l = e.cs([], r, n), c = e.ct([], r, n), h = e.cM(l, c);
                        if (0 === h) return !0;
                        let d = !1;
                        const u = this._elevation;
                        if (u && h > i && 0 !== o) {
                            const i = this.calculateProjMatrix(s.tileID.toUnwrapped());
                            let r;
                            t1.isTerrainDEM || (r = u.getMinMaxForTile(s.tileID)), r || (r = {
                                min: w,
                                max: b
                            });
                            const n = e.cu(this.rotation), a = [
                                n[0] * e.aj,
                                n[1] * e.aj,
                                r.max
                            ];
                            e.ad(a, a, i), d = (1 - a[1]) * this.height * .5 < o;
                        }
                        return h < i || d;
                    });
                }
                return C.sort((e, t1)=>e.distanceSq - t1.distanceSq).map((e)=>e.tileID);
            }
            resize(e, t1) {
                this.width = e, this.height = t1, this.pixelsToGLUnits = [
                    2 / e,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e) {
                return Math.pow(2, e);
            }
            scaleZoom(e) {
                return Math.log(e) / Math.LN2;
            }
            project(t1) {
                const i = e.ay(t1.lat, -85.051129, e.cv), o = this.projection.project(t1.lng, i);
                return new e.P(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e) {
                return this.projection.unproject(e.x / this.worldSize, e.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e.c6(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, s;
                const r = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e = this.worldSize;
                    o = (i.x - r.x) / e, s = (i.y - r.y) / e;
                } else {
                    const e = this.pointCoordinate(i), t1 = this.pointCoordinate(r);
                    o = e.x - t1.x, s = e.y - t1.y;
                }
                const n = this.locationCoordinate(t1);
                this.setLocation(new e.ac(n.x - o, n.y - s));
            }
            setLocation(e) {
                this.center = this.coordinateLocation(e), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e, t1) {
                return this.projection.locationPoint(this, e, t1);
            }
            locationPoint3D(e, t1) {
                return this.projection.locationPoint(this, e, t1, !0);
            }
            pointLocation(e) {
                return this.coordinateLocation(this.pointCoordinate(e));
            }
            pointLocation3D(e, t1) {
                return this.coordinateLocation(this.pointCoordinate3D(e, t1));
            }
            locationCoordinate(t1, i) {
                const o = i ? e.c6(i, t1.lat) : void 0, s = this.projection.project(t1.lng, t1.lat);
                return new e.ac(s.x, s.y, o);
            }
            coordinateLocation(e) {
                return this.projection.unproject(e.x, e.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, s = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], r = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.aA(s, s, this.pixelMatrixInverse), e.aA(r, r, this.pixelMatrixInverse);
                const n = r[3];
                e.cw(s, s, 1 / s[3]), e.cw(r, r, 1 / n);
                const a = s[2], l = r[2];
                return {
                    p0: s,
                    p1: r,
                    t: a === l ? 0 : (o - a) / (l - a)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e.aA(i, i, this.pixelMatrixInverse), e.aA(o, o, this.pixelMatrixInverse), e.cw(i, i, 1 / i[3]), e.cw(o, o, 1 / o[3]), i[2] = e.c6(i[2], this._center.lat) * this.worldSize, o[2] = e.c6(o[2], this._center.lat) * this.worldSize, e.cw(i, i, 1 / this.worldSize), e.cw(o, o, 1 / this.worldSize), new e.av([
                    i[0],
                    i[1],
                    i[2]
                ], e.au([], e.at([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: s } = t1, r = e.c6(i[2], this._center.lat), n = e.c6(o[2], this._center.lat);
                return new e.ac(e.ai(i[0], o[0], s) / this.worldSize, e.ai(i[1], o[1], s) / this.worldSize, e.ai(r, n, s));
            }
            pointCoordinate(e, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e.x, e.y, t1);
            }
            pointCoordinate3D(t1, i) {
                if (!this.elevation) return this.pointCoordinate(t1, i);
                let o = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (o) return new e.ac(o[0], o[1], o[2]);
                let s = 0, r = this.horizonLineFromTop();
                if (t1.y > r) return this.pointCoordinate(t1, i);
                const n = .02 * r, a = t1.clone();
                for(let t1 = 0; t1 < 10 && r - s > n; t1++){
                    a.y = e.ai(s, r, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (r = a.y, o = t1) : s = a.y;
                }
                return o ? new e.ac(o[0], o[1], o[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e) {
                return this.projection.isPointAboveHorizon(this, e);
            }
            isPointOnSurface(t1) {
                if (t1.y < 0 || t1.y > this.height || t1.x < 0 || t1.x > this.width) return !1;
                if (this.elevation || this.zoom >= e.cx) return !this.isPointAboveHorizon(t1);
                const i = this.pointCoordinate(t1);
                return i.y >= 0 && i.y <= 1;
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, s = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e.aA(s, s, this.pixelMatrix), s[3] > 0 ? new e.P(s[0] / s[3], s[1] / s[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, s = this.width - this._edgeInsets.right, r = this.pointLocation3D(new e.P(i, t1)), n = this.pointLocation3D(new e.P(s, t1)), a = this.pointLocation3D(new e.P(s, o)), l = this.pointLocation3D(new e.P(i, o));
                let c = Math.min(r.lng, n.lng, a.lng, l.lng), h = Math.max(r.lng, n.lng, a.lng, l.lng), d = Math.min(r.lat, n.lat, a.lat, l.lat), u = Math.max(r.lat, n.lat, a.lat, l.lat);
                const _ = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (t1, i, o, s, r)=>{
                    const n = (t1 + o) / 2, a = (i + s) / 2, l = new e.P(n, a), { lng: m, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - m, d - g, m - h, g - u);
                    c = Math.min(c, m), h = Math.max(h, m), d = Math.min(d, g), u = Math.max(u, g), (r < p || v > _) && (f(t1, i, n, a, r + 1), f(n, a, o, s, r + 1));
                };
                if (f(i, t1, s, t1, 1), f(s, t1, s, o, 1), f(s, o, i, o, 1), f(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e.cy(this);
                    t1 ? (u = 90, h = 180, c = -180) : i && (d = -90, h = 180, c = -180);
                }
                return new e.aG(new e.cd(c, d), new e.cd(h, u));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: s } = this._edgeInsets, r = this.height - this._edgeInsets.bottom, n = this.width - this._edgeInsets.right, a = new e.P(s, o), l = new e.P(n, o), c = new e.P(n, r), h = new e.P(s, r);
                let d = this.pointCoordinate(a, t1), u = this.pointCoordinate(l, t1);
                const _ = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), f = (e, t1)=>(t1.y - e.y) / (t1.x - e.x);
                return d.y > 1 && u.y >= 0 ? d = new e.ac((1 - p.y) / f(p, d) + p.x, 1) : d.y < 0 && u.y <= 1 && (d = new e.ac(-p.y / f(p, d) + p.x, 0)), u.y > 1 && d.y >= 0 ? u = new e.ac((1 - _.y) / f(_, u) + _.x, 1) : u.y < 0 && d.y <= 1 && (u = new e.ac(-_.y / f(_, u) + _.x, 0)), (new e.aG).extend(this.coordinateLocation(d)).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(_));
            }
            _getBoundsRectangularTerrain() {
                const e = this.elevation;
                if (!e.visibleDemTiles.length || e.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e.visibleDemTiles.reduce((e, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e.min = Math.min(e.min, i.minimums[0]), e.max = Math.max(e.max, i.maximums[0]);
                    }
                    return e;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e.exaggeration(), t1.max * e.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -85.051129, this.maxLat = e.cv, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.aD(this.minLng) * this.tileSize, this.worldMaxX = e.aD(this.maxLng) * this.tileSize, this.worldMinY = e.aH(this.maxLat) * this.tileSize, this.worldMaxY = e.aH(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e, t1) {
                return this.projection.createTileMatrix(this, t1, e);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const s = t1.canonical, r = 1 / this.height, n = this.cameraWorldSize, a = n / this.zoomScale(s.z), l = (s.x + Math.pow(2, s.z) * t1.wrap) * a, c = s.y * a, h = this.point;
                h.x *= n / this.worldSize, h.y *= n / this.worldSize;
                const d = this.angle, u = Math.sin(-d), _ = -Math.cos(-d);
                return o[i] = {
                    bearing: [
                        u,
                        _
                    ],
                    center: [
                        (h.x - l) * r,
                        (h.y - c) * r
                    ],
                    scale: a / e.aj * r
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const s = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e.az(s, this.worldToFogMatrix, s), o[i] = new Float32Array(s), o[i];
            }
            calculateProjMatrix(t1, i = !1, o = !1) {
                const s = t1.key;
                let r;
                if (r = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, r[s]) return r[s];
                const n = this.calculatePosMatrix(t1, this.worldSize);
                let a;
                return a = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e.az(n, a, n), r[s] = new Float32Array(n), r[s];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const s = e.cz(t1, this);
                return o[i] = s, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e.bn([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e.az(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e.c6(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), s = this._camera.forward(), r = e.c6(1, this._center.lat);
                o[2] /= r, s[2] /= r, e.au(s, s);
                const n = t1.raycast(o, s, t1.exaggeration());
                if (n) {
                    const t1 = e.bE([], o, s, n), i = new e.ac(t1[0], t1[1], e.c6(t1[2], e.aY(t1[1]))), a = (i.z + e.ae([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * r
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e.c6(1, this._center.lat) * this.worldSize, s = this._computeCameraPosition(o), r = i.getAtPointOrZero(new e.ac(...s)), n = this.pixelsPerMeter / this.worldSize * r, a = this._minimumHeightOverTerrain(), l = s[2] - n;
                if (l <= a) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            s[0],
                            s[1],
                            t1.z - s[2]
                        ], o = e.ae(i);
                        i[2] -= (a - l) / this._pixelsPerMercatorPixel;
                        const r = e.ae(i);
                        if (0 === r) return;
                        e.bY(i, i, o / r * this._pixelsPerMercatorPixel), this._camera.position = [
                            s[0],
                            s[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e.ay(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e.ay(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: s } = this.point;
                let r = 0, n = o, a = s;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, d = this.worldMaxY * this.scale;
                if (s - c < h && (a = h + c), s + c > d && (a = d - c), d - h < this.height && (r = Math.max(r, this.height / (d - h)), a = (d + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e + t1) / 2;
                    n = (o + i + this.worldSize) % this.worldSize - i, n - l < e && (n = e + l), n + l > t1 && (n = t1 - l), t1 - e < this.width && (r = Math.max(r, this.width / (t1 - e)), n = (t1 + e) / 2);
                }
                n === o && a === s || this._allowWorldUnderZoom || (this.center = this.unproject(new e.P(n, a))), r && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(r)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e = Math.max(e, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = "globe" === this.projection.name, o = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e.c6(1, this.center.lat) / e.c6(1, e.cP));
                const s = e.cA(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, s), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? o : 1, n = this._camera.getWorldToCamera(this.worldSize, r);
                let a;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -t1.x / this.width, l[9] = 2 * t1.y / this.height, this.isOrthographic) {
                    let i = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), o = i * this.aspect, s = -o, r = -i;
                    o -= t1.x, s -= t1.x, i += t1.y, r += t1.y, a = this._camera.getCameraToClipOrthographic(s, o, r, i, this._nearZ, this._farZ), ((t1, i, o, s)=>{
                        for(let r = 0; r < 16; r++)t1[r] = e.ai(i[r], o[r], s);
                    })(a, a, l, e.cN(this.pitch >= Ji ? 1 : this.pitch / Ji));
                } else a = l;
                const c = e.cB([], l, n);
                let h = e.cB([], a, n);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e.bx([]);
                    e.bo(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e.az(i, i, e.cC(this)), e.bo(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e.az(h, h, i), e.az(c, c, i), this.inverseAdjustmentMatrix = e.cD(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = e.cE([], h, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = h, this.invProjMatrix = e.bi(new Float64Array(16), this.projMatrix), i) {
                    const i = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    i[8] = 2 * -t1.x / this.width, i[9] = 2 * t1.y / this.height, this.expandedFarZProjMatrix = e.cB([], i, n);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const d = e.bi([], a);
                this.frustumCorners = e.cF.fromInvProjectionMatrix(d, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
                const u = new Float32Array(16);
                e.bx(u), e.cE(u, u, [
                    1,
                    -1,
                    1
                ]), e.cG(u, u, this._pitch), e.by(u, u, this.angle);
                const _ = e.c4(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = e.bw(_);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                _[8] = 2 * -t1.x / this.width, _[9] = 2 * (t1.y + p) / this.height, this.skyboxMatrix = e.az(u, _, u);
                const f = this.point, m = f.x, g = f.y, v = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), b = Math.sin(this.angle), w = m - Math.round(m) + x * v + b * y, T = g - Math.round(g) + x * y + b * v, E = new Float64Array(h);
                if (e.bo(E, E, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = E, h = e.bz(), e.cE(h, h, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e.bo(h, h, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = h, h = e.bz(), e.cE(h, h, [
                    1,
                    -1,
                    1
                ]), e.bo(h, h, [
                    -1,
                    -1,
                    0
                ]), e.cE(h, h, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = h, this.pixelMatrix = e.az(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e.bi(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e.cH(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e.ad(t1, t1, n), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = h;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, s = 1 / this.height / this._pixelsPerMercatorPixel, r = [
                    t1,
                    t1,
                    i
                ];
                e.bY(r, r, s), e.bY(o, o, -1), e.cI(o, o, r);
                const n = e.bz();
                e.bo(n, n, o), e.cE(n, n, r), this.mercatorFogMatrix = n, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, s);
            }
            _computeCameraPosition(e) {
                const t1 = (e = e || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, s = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * s,
                    o.y / this.worldSize - i[1] * s,
                    e / this.worldSize * this._centerAltitude - i[2] * s
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], s = t1[2];
                let r = 1;
                this.projection.wrap && (this.center = this.center.wrap()), s > 0 && (r = Math.min((i - o) / s, 1)), this._camera.position = e.bE([], this._camera.position, t1, r), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: s } = this._camera.getPitchBearing(), r = e.c6(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, n = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.al(this._maxPitch)), a = Math.max((t1[2] - r) / Math.cos(o), n), l = this._zoomFromMercatorZ(a);
                e.bE(t1, t1, i, a), this._pitch = e.ay(o, e.al(this.minPitch), e.al(this.maxPitch)), this.angle = e.bX(s, -Math.PI, Math.PI), this._setZoom(e.ay(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e.ac(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e) {
                return Math.pow(2, e) * this.tileSize;
            }
            _mercatorZfromZoom(e) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e);
            }
            _minimumHeightOverTerrain() {
                const e = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e);
            }
            _zoomFromMercatorZ(e) {
                return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e.cx, s = 0, r = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e = i + .5 * (o - i), n = this.tileSize * Math.pow(2, e), a = this.getCameraToCenterDistance(this.projection, e, n), l = this.scaleZoom(a / (Math.max(0, t1) * this.tileSize)), c = Math.abs(e - l);
                    c < r && (r = c, s = e), e < l ? i = e : o = e;
                }
                return s;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), s = Math.max(t1.x, i.x), r = Math.min(t1.y, i.y), n = Math.max(t1.y, i.y);
                if (r < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new e.P(o, r),
                    new e.P(s, n),
                    new e.P(o, n),
                    new e.P(s, r)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e of a){
                    const t1 = this.pointRayIntersection(e);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e.cJ(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e.ae(e.at([], this._camera.position, t1)), s = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(s);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], s) {
                        const r = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e.aA(r, r, s);
                        const n = r[3] = Math.max(r[3], 1e-6);
                        return r[0] /= n, r[1] /= n, r[2] /= n, r;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e.P(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e.P(0, t1));
                }
            }
            getCameraToCenterDistance(t1, i = this.zoom, o = this.worldSize) {
                const s = e.cA(t1, i, this.width, this.height, 1024), r = t1.pixelSpaceConversion(this.center.lat, o, s);
                let n = .5 / Math.tan(.5 * this._fov) * this.height * r;
                return this.isOrthographic && (n = e.ai(1, n, e.cN(this.pitch >= Ji ? 1 : this.pitch / Ji))), n;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e.az(t1, t1, this.globeMatrix), t1;
            }
            getFrustum(t1) {
                return e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, "meters" === this.projection.zAxisUnit);
            }
        }
        const eo = (t1, i)=>{
            if (i > 0 && t1.terrain && e.w("Cutoff is currently disabled on terrain"), i <= 0 || t1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = t1.transform, s = Math.max(Math.abs(o._zoom - (t1.minCutoffZoom - 1)), 1), r = o.isLODDisabled(!1) ? e.af(60, 45, o.pitch) : e.af(30, 15, o.pitch), n = o._farZ - o._nearZ, a = i * o.height, l = ((1 - (c = r)) * o.cameraToCenterDistance + c * (o._farZ + a)) * s;
            var c;
            return {
                shouldRenderCutoff: r < 1,
                uniformValues: {
                    u_cutoff_params: [
                        o._nearZ,
                        o._farZ,
                        (l - o._nearZ) / n,
                        (l - a - o._nearZ) / n
                    ]
                }
            };
        }, to = {
            cascadeCount: 2,
            normalOffset: 3,
            shadowMapResolution: 2048
        };
        class io {
            constructor(e, t1){
                this.aabb = e, this.lastCascade = t1;
            }
        }
        class oo {
            add(e, t1) {
                const i = this.receivers[e.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e.key] = new io(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e) {
                return this.receivers[e.key];
            }
            computeRequiredCascades(t1, i, o) {
                const s = e.cW.fromPoints(t1.points);
                let r = 0;
                for(const t1 in this.receivers){
                    const n = this.receivers[t1];
                    if (!n) continue;
                    if (!s.intersectsAabb(n.aabb)) continue;
                    n.aabb.min = s.closestPoint(n.aabb.min), n.aabb.max = s.closestPoint(n.aabb.max);
                    const a = n.aabb.getCorners();
                    for(let t1 = 0; t1 < o.length; t1++){
                        let s = !0;
                        for (const r of a){
                            const n = [
                                r[0] * i,
                                r[1] * i,
                                r[2]
                            ];
                            if (e.ad(n, n, o[t1].matrix), n[0] < -1 || n[0] > 1 || n[1] < -1 || n[1] > 1) {
                                s = !1;
                                break;
                            }
                        }
                        if (n.lastCascade = t1, r = Math.max(r, t1), s) break;
                    }
                }
                return r + 1;
            }
        }
        class so {
            constructor(e){
                this.painter = e, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new oo, this._depthMode = new Ni(e.context.gl.LEQUAL, Ni.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this._forceDisable = !1, this.useNormalOffset = !1, e.tp.registerParameter(this, [
                    "Shadows"
                ], "_forceDisable", {
                    label: "forceDisable"
                }, ()=>{
                    this.painter.style.map.triggerRepaint();
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "cascadeCount", {
                    min: 1,
                    max: 2,
                    step: 1
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "normalOffset", {
                    min: 0,
                    max: 10,
                    step: .05
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "shadowMapResolution", {
                    min: 32,
                    max: 2048,
                    step: 32
                }), e.tp.registerBinding(this, [
                    "Shadows"
                ], "_numCascadesToRender", {
                    readonly: !0,
                    label: "numCascadesToRender"
                });
            }
            destroy() {
                for (const e of this._cascades)e.texture.destroy(), e.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(t1, i) {
                const o = this.painter;
                if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !i || !i.properties) return;
                const s = i.properties.get("shadow-intensity");
                if (!i.shadowsEnabled() || s <= 0) return;
                if (this._shadowLayerCount = o.style.order.reduce((e, i)=>{
                    const s = o.style._mergedLayers[i];
                    return e + (s.hasShadowPass() && !s.isHidden(t1.zoom) ? 1 : 0);
                }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
                const r = o.context, n = to.shadowMapResolution, a = to.shadowMapResolution;
                if (0 === this._cascades.length || to.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                    this._cascades = [];
                    for(let t1 = 0; t1 < to.cascadeCount; ++t1){
                        const t1 = o._shadowMapDebug, i = r.gl, s = r.createFramebuffer(n, a, t1, "texture"), l = new e.T(r, {
                            width: n,
                            height: a,
                            data: null
                        }, i.DEPTH_COMPONENT16);
                        if (s.depthAttachment.set(l.texture), t1) {
                            const t1 = new e.T(r, {
                                width: n,
                                height: a,
                                data: null
                            }, i.RGBA8);
                            s.colorAttachment.set(t1.texture);
                        }
                        this._cascades.push({
                            framebuffer: s,
                            texture: l,
                            matrix: [],
                            far: 0,
                            boundingSphereRadius: 0,
                            frustum: new e.cn,
                            scale: 0
                        });
                    }
                }
                this.shadowDirection = no(i);
                let l = 0;
                if (t1.elevation) {
                    const e = t1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    e.visibleDemTiles.filter((e)=>e.dem).forEach((e)=>{
                        const t1 = e.dem.tree;
                        i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                    }), 1e4 !== i[0] && (l = (i[1] - i[0]) * e.exaggeration());
                }
                const c = 1.5 * t1.cameraToCenterDistance, h = 3 * c, d = new Float64Array(16);
                for(let i = 0; i < this._cascades.length; ++i){
                    const o = this._cascades[i];
                    let s = t1.height / 50, r = 1;
                    1 === to.cascadeCount ? r = h : 0 === i ? r = c : (s = c, r = h);
                    const [n, a] = lo(t1, this.shadowDirection, s, r, to.shadowMapResolution, l);
                    o.scale = t1.scale, o.matrix = n, o.boundingSphereRadius = a, e.bi(d, o.matrix), o.frustum = e.cn.fromInvProjectionMatrix(d, 1, 0, !0), o.far = r;
                }
                const u = this._cascades.length - 1;
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[u].far,
                    this._cascades[u].far
                ], this._uniformValues.u_shadow_intensity = s, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = 1 / to.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = to.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Yi.ShadowMap0, this._uniformValues.u_shadowmap_1 = Yi.ShadowMap0 + 1, this._groundShadowTiles = o.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const _ = o.transform.elevation;
                for (const e of this._groundShadowTiles){
                    let t1 = {
                        min: 0,
                        max: 0
                    };
                    if (_) {
                        const i = _.getMinMaxForTile(e);
                        i && (t1 = i);
                    }
                    this.addShadowReceiver(e.toUnwrapped(), t1.min, t1.max);
                }
            }
            get enabled() {
                return this._enabled && !this._forceDisable;
            }
            set enabled(e) {
                this._enabled = e;
            }
            drawShadowPass(t1, i) {
                if (!this.enabled) return;
                const o = this.painter, s = o.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), s.viewport.set([
                    0,
                    0,
                    to.shadowMapResolution,
                    to.shadowMapResolution
                ]);
                for(let r = 0; r < this._numCascadesToRender; ++r){
                    o.currentShadowCascade = r, s.bindFramebuffer.set(this._cascades[r].framebuffer.framebuffer), s.clear({
                        color: e.am.white,
                        depth: 1
                    });
                    for (const e of t1.order){
                        const s = t1._mergedLayers[e];
                        if (!s.hasShadowPass() || s.isHidden(o.transform.zoom)) continue;
                        const r = t1.getLayerSourceCache(s), n = r ? i[r.id] : void 0;
                        ("model" === s.type || n && n.length) && o.renderLayer(o, r, s, n);
                    }
                }
                o.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this.enabled) return;
                const e = this.painter, t1 = e.style, i = e.context, o = i.gl, s = t1.directionalLight, r = t1.ambientLight;
                if (!s || !r) return;
                const n = [], a = eo(e, e.longestCutoffRange);
                a.shouldRenderCutoff && n.push("RENDER_CUTOFF"), n.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && n.push("NORMAL_OFFSET");
                const l = ao(t1, s, r), c = new Ni(o.LEQUAL, Ni.ReadOnly, e.depthRangeFor3D), h = new ji({
                    func: o.EQUAL,
                    mask: 255
                }, 0, 255, o.KEEP, o.KEEP, o.KEEP);
                for (const t1 of this._groundShadowTiles){
                    const s = t1.toUnwrapped(), r = e.isTileAffectedByFog(t1), d = e.getOrCreateProgram("groundShadow", {
                        defines: n,
                        overrideFog: r
                    });
                    this.setupShadows(s, d), e.uploadCommonUniforms(i, d, s, null, a);
                    const u = {
                        u_matrix: e.transform.calculateProjMatrix(s),
                        u_ground_shadow_factor: l
                    };
                    d.draw(e, o.TRIANGLES, c, h, ki.multiply, qi.disabled, u, "ground_shadow", e.tileExtentBuffer, e.quadTriangleIndexBuffer, e.tileExtentSegments, null, e.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? ki.unblended : ki.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getShadowCastingLayerCount() {
                return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(t1) {
                const i = this.painter.transform, o = i.calculatePosMatrix(t1, i.worldSize);
                return e.az(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
            }
            calculateShadowPassMatrixFromMatrix(t1) {
                return e.az(t1, this._cascades[this.painter.currentShadowCascade].matrix, t1), Float32Array.from(t1);
            }
            setupShadows(t1, i, o, s = 0) {
                if (!this.enabled) return;
                const r = this.painter.transform, n = this.painter.context, a = n.gl, l = this._uniformValues, c = new Float64Array(16), h = r.calculatePosMatrix(t1, r.worldSize);
                for(let t1 = 0; t1 < this._cascades.length; t1++)e.az(c, this._cascades[t1].matrix, h), l[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c), n.activeTexture.set(a.TEXTURE0 + Yi.ShadowMap0 + t1), this._cascades[t1].texture.bindExtraParam(a.LINEAR, a.LINEAR, a.CLAMP_TO_EDGE, a.CLAMP_TO_EDGE, a.GREATER);
                if (this.useNormalOffset = !!o, this.useNormalOffset) {
                    const i = e.cU(t1.canonical), n = 2 / r.tileSize * e.aj / to.shadowMapResolution, a = n * this._cascades[0].boundingSphereRadius, c = n * this._cascades[this._cascades.length - 1].boundingSphereRadius, h = ("vector-tile" === o ? 1 : 3) / Math.pow(2, s - t1.canonical.z - (1 - r.zoom + Math.floor(r.zoom)));
                    l.u_shadow_normal_offset = [
                        i,
                        a * h,
                        c * h
                    ], l.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else l.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(n, l);
            }
            setupShadowsFromMatrix(t1, i, o = !1) {
                if (!this.enabled) return;
                const s = this.painter.context, r = s.gl, n = this._uniformValues, a = new Float64Array(16);
                for(let i = 0; i < to.cascadeCount; i++)e.az(a, this._cascades[i].matrix, t1), n[0 === i ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(a), s.activeTexture.set(r.TEXTURE0 + Yi.ShadowMap0 + i), this._cascades[i].texture.bindExtraParam(r.LINEAR, r.LINEAR, r.CLAMP_TO_EDGE, r.CLAMP_TO_EDGE, r.GREATER);
                if (this.useNormalOffset = o, o) {
                    const e = to.normalOffset;
                    n.u_shadow_normal_offset = [
                        1,
                        e,
                        e
                    ], n.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else n.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(s, n);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t1, i, o, s) {
                if (s[2] >= 0) return {};
                const r = (function(t1, i, o) {
                    const s = o / (1 << t1.canonical.z);
                    return new e.cW([
                        t1.canonical.x * s + t1.wrap * o,
                        t1.canonical.y * s + t1.wrap * o,
                        0
                    ], [
                        (t1.canonical.x + 1) * s + t1.wrap * o,
                        (t1.canonical.y + 1) * s + t1.wrap * o,
                        i
                    ]);
                })(t1, i, o).getCorners(), n = i / -s[2];
                s[0] < 0 ? (e.cV(r[0], r[0], [
                    s[0] * n,
                    0,
                    0
                ]), e.cV(r[3], r[3], [
                    s[0] * n,
                    0,
                    0
                ])) : s[0] > 0 && (e.cV(r[1], r[1], [
                    s[0] * n,
                    0,
                    0
                ]), e.cV(r[2], r[2], [
                    s[0] * n,
                    0,
                    0
                ])), s[1] < 0 ? (e.cV(r[0], r[0], [
                    0,
                    s[1] * n,
                    0
                ]), e.cV(r[1], r[1], [
                    0,
                    s[1] * n,
                    0
                ])) : s[1] > 0 && (e.cV(r[2], r[2], [
                    0,
                    s[1] * n,
                    0
                ]), e.cV(r[3], r[3], [
                    0,
                    s[1] * n,
                    0
                ]));
                const a = {};
                return a.vertices = r, a.planes = [
                    ro(r[1], r[0], r[4]),
                    ro(r[2], r[1], r[5]),
                    ro(r[3], r[2], r[6]),
                    ro(r[0], r[3], r[7])
                ], a;
            }
            addShadowReceiver(t1, i, o) {
                this._receivers.add(t1, e.cW.fromTileIdAndHeight(t1, i, o));
            }
            getMaxCascadeForTile(e) {
                const t1 = this._receivers.get(e);
                return t1 && t1.lastCascade ? t1.lastCascade : 0;
            }
        }
        function ro(t1, i, o) {
            const s = e.at([], o, i), r = e.at([], t1, i), n = e.bF([], s, r), a = e.ae(n);
            return 0 === a ? [
                0,
                0,
                1,
                0
            ] : (e.bY(n, n, 1 / a), [
                n[0],
                n[1],
                n[2],
                -e.bG(n, i)
            ]);
        }
        function no(t1) {
            const i = t1.properties.get("direction"), o = e.cR(i.x, i.y, i.z);
            o[2] = e.ay(o[2], 0, 75);
            const s = e.cT([
                o[0],
                o[1],
                o[2]
            ]);
            return e.cS(s.x, s.y, s.z);
        }
        function ao(t1, i, o) {
            const s = "none" === i.properties.get("color-use-theme"), r = i.properties.get("color"), n = i.properties.get("intensity"), a = i.properties.get("direction"), l = [
                a.x,
                a.y,
                a.z
            ], c = "none" === o.properties.get("color-use-theme"), h = o.properties.get("color"), d = o.properties.get("intensity"), u = Math.max(e.bG([
                0,
                0,
                1
            ], l), 0), _ = [
                0,
                0,
                0
            ];
            e.bY(_, h.toPremultipliedRenderColor(c ? null : t1.getLut(i.scope)).toArray01Linear().slice(0, 3), d);
            const p = [
                0,
                0,
                0
            ];
            return e.bY(p, r.toPremultipliedRenderColor(s ? null : t1.getLut(o.scope)).toArray01Linear().slice(0, 3), u * n), e.cY([
                _[0] > 0 ? _[0] / (_[0] + p[0]) : 0,
                _[1] > 0 ? _[1] / (_[1] + p[1]) : 0,
                _[2] > 0 ? _[2] / (_[2] + p[2]) : 0
            ]);
        }
        function lo(t1, i, o, s, r, n) {
            const a = t1.zoom, l = t1.scale, c = t1.worldSize, h = 1 / c, d = t1.aspect, u = Math.sqrt(1 + d * d) * Math.tan(.5 * t1.fovX), _ = u * u, p = s - o, f = s + o;
            let m, g;
            _ > p / f ? (m = s, g = s * u) : (m = .5 * f * (1 + _), g = .5 * Math.sqrt(p * p + 2 * (s * s + o * o) * _ + f * f * _ * _));
            const v = t1.projection.pixelsPerMeter(t1.center.lat, c), y = t1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * h
            ];
            e.ad(x, x, y);
            let b = g * h;
            const w = t1._edgeInsets;
            if (!(0 === w.left && 0 === w.top && 0 === w.right && 0 === w.bottom || w.left === w.right && w.top === w.bottom)) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, "meters" === t1.projection.zAxisUnit ? v : 1), r = t1._camera.getCameraToClipPerspective(t1._fov, t1.width / t1.height, o, s);
                r[8] = 2 * -t1.centerOffset.x / t1.width, r[9] = 2 * t1.centerOffset.y / t1.height;
                const n = new Float64Array(16);
                e.cB(n, r, i);
                const h = new Float64Array(16);
                e.bi(h, n);
                const d = e.cn.fromInvProjectionMatrix(h, c, a, !0);
                for (const i of d.points){
                    const o = ((T = i)[0] /= l, T[1] /= l, T[2] = e.c6(T[2], t1._center.lat), T);
                    b = Math.max(b, e.bZ(e.cX([], x, o)));
                }
            }
            var T;
            b *= r / (r - 1);
            const E = Math.acos(i[2]), S = Math.atan2(-i[0], -i[1]), I = new Xi;
            I.position = x, I.setPitchBearing(E, S);
            const C = I.getWorldToCamera(c, v), R = b * c, D = Math.min(t1._mercatorZfromZoom(17) * c * -2, -2 * R), A = I.getCameraToClipOrthographic(-R, R, -R, R, D, (R + n * v) / i[2]), L = new Float64Array(16);
            e.az(L, A, C);
            const P = e.cS(Math.floor(1e6 * x[0]) / 1e6 * c, Math.floor(1e6 * x[1]) / 1e6 * c, 0), z = .5 * r, M = [
                0,
                0,
                0
            ];
            e.ad(M, P, L), e.bY(M, M, z);
            const O = [
                Math.floor(M[0]),
                Math.floor(M[1]),
                Math.floor(M[2])
            ], F = [
                0,
                0,
                0
            ];
            e.at(F, M, O), e.bY(F, F, -1 / z);
            const B = new Float64Array(16);
            return e.bx(B), e.bo(B, B, F), e.az(L, B, L), [
                L,
                R
            ];
        }
        class co extends e.E {
            constructor(e){
                super(), this.requestManager = e, this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            loadModel(t1, i) {
                return e.aS(this.requestManager.transformRequest(i, e.R.Model).url).then((i)=>{
                    if (!i) return;
                    const o = e.aT(i), s = new e.aU(t1, void 0, void 0, o);
                    return s.computeBoundsAndApplyParent(), s;
                }).catch((o)=>{
                    if (o && 404 === o.status) return null;
                    this.fire(new e.z(new Error(`Could not load model ${t1} from ${i}: ${o.message}`)));
                });
            }
            load(t1, i, o = {
                forceReload: !1
            }) {
                this.models[i] || (this.models[i] = {});
                const s = Object.keys(t1), r = [], n = [];
                for (const e of s){
                    const s = t1[e];
                    this.hasURLBeenRequested(s) && !o.forceReload || (this.modelByURL[s] = {
                        modelId: e,
                        scope: i
                    }, r.push(this.loadModel(e, s)), n.push(e)), this.models[i][e] || (this.models[i][e] = {
                        model: null,
                        numReferences: 1
                    });
                }
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + n.length, Promise.allSettled(r).then((t1)=>{
                    for(let e = 0; e < t1.length; e++){
                        const { status: o } = t1[e];
                        if ("rejected" === o) continue;
                        const { value: s } = t1[e];
                        this.models[i][n[e]] || (this.models[i][n[e]] = {
                            model: null,
                            numReferences: 1
                        }), this.models[i][n[e]].model = s;
                    }
                    this.numModelsLoading[i] -= n.length, this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e.z(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e in this.numModelsLoading)if (this.numModelsLoading[e] > 0) return !1;
                return !0;
            }
            hasModel(e, t1, i = {
                exactIdMatch: !1
            }) {
                return !!(i.exactIdMatch ? this.getModel(e, t1) : this.getModelByURL(this.modelUris[t1][e]));
            }
            getModel(e, t1) {
                return this.models[t1] || (this.models[t1] = {}), this.models[t1][e] ? this.models[t1][e].model : void 0;
            }
            getModelByURL(e) {
                if (!e) return null;
                const t1 = this.modelByURL[e];
                return t1 ? this.models[t1.scope][t1.modelId].model : null;
            }
            hasModelBeenAdded(e, t1) {
                return this.models[t1] && void 0 !== this.models[t1][e];
            }
            getModelURIs(e) {
                return this.modelUris[e] || {};
            }
            addModel(e, t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = this.requestManager.normalizeModelURL(t1);
                if ((this.hasModel(e, i, {
                    exactIdMatch: !0
                }) || this.hasModelBeenAdded(e, i)) && this.modelUris[i][e] === o) this.models[i][e].numReferences++;
                else if (this.hasURLBeenRequested(o)) {
                    const { scope: e, modelId: t1 } = this.modelByURL[o];
                    this.models[e][t1].numReferences++;
                } else this.modelUris[i][e] = o, this.load({
                    [e]: this.modelUris[i][e]
                }, i);
            }
            addModelURLs(e, t1) {
                this.models[t1] || (this.models[t1] = {}), this.modelUris[t1] || (this.modelUris[t1] = {});
                const i = this.modelUris[t1];
                for(const t1 in e)i[t1] = this.requestManager.normalizeModelURL(e[t1]);
            }
            reloadModels(e) {
                this.load(this.modelUris[e], e, {
                    forceReload: !0
                });
            }
            addModelsFromBucket(t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = {};
                for (const s of t1)this.hasModel(s, i, {
                    exactIdMatch: !0
                }) || this.hasURLBeenRequested(s) ? this.models[i][s].numReferences++ : this.modelUris[i][s] && !this.hasURLBeenRequested(s) ? o[s] = this.modelUris[i][s] : !this.hasURLBeenRequested(s) && e.cZ(s, !1) && (this.modelUris[i][s] = this.requestManager.normalizeModelURL(s), o[s] = this.modelUris[i][s]);
                this.load(o, i);
            }
            hasURLBeenRequested(e) {
                return void 0 !== this.modelByURL[e];
            }
            removeModel(e, t1, i = !1) {
                if (this.models[t1] && this.models[t1][e] && (this.models[t1][e].numReferences--, 0 === this.models[t1][e].numReferences)) {
                    const o = this.modelUris[t1][e];
                    i || delete this.modelUris[t1][e], delete this.modelByURL[o];
                    const s = this.models[t1][e].model;
                    if (!s) return;
                    delete this.models[t1][e], s.destroy();
                }
            }
            destroy() {
                for (const e of Object.keys(this.models))for (const t1 of Object.keys(this.models[e])){
                    const i = this.models[e][t1].model;
                    delete this.models[e][t1], i && i.destroy();
                }
                this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            listModels(e) {
                return this.models[e] || (this.models[e] = {}), Object.keys(this.models[e]);
            }
            upload(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e.context);
            }
        }
        const ho = new e.a7({
            data: new e.a8(e.a5.colorTheme.data)
        }), uo = {
            "mbx-indoor-active-floorplans": {
                default: [
                    "literal",
                    []
                ]
            },
            "mbx-indoor-underground": {
                default: [
                    "literal",
                    !1
                ]
            },
            "mbx-indoor-loaded-levels": {
                default: [
                    "literal",
                    []
                ]
            },
            "mbx-indoor-level-height": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-base": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-selected": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-overlapped": {
                default: [
                    "literal",
                    {}
                ]
            }
        };
        function _o(e) {
            return e = e || {}, Object.assign(e, uo);
        }
        class po extends e.E {
            constructor(t1){
                super(), this.mergeFloors = !0, this._scope = void 0, this._queryFeatureSetId = void 0, this._buildingEntryFeatureSetId = void 0, this._selectedFloorplan = void 0, this._indoorData = void 0, this._floorplanStates = {}, e.aV([
                    "_onLoad",
                    "_onMove",
                    "_checkFloorplanVisible"
                ], this), this._map = t1, this._checkFloorplanVisible(), this._map.on("load", this._onLoad), this._map.on("move", this._onMove);
            }
            destroy() {
                this._map.indoor.off("load", this._onLoad), this._map.indoor.off("move", this._onMove), this._map = void 0;
            }
            _onLoad() {
                this._map.style.forEachFragmentStyle((t1)=>{
                    t1.stylesheet.indoor && (this._queryFeatureSetId ? this.fire(new e.z(new Error("Multiple indoor map styles detected, simultaneous usage is not allowed currently."))) : (this._queryFeatureSetId = t1.stylesheet.indoor.floorplanFeaturesetId, this._buildingEntryFeatureSetId = t1.stylesheet.indoor.buildingFeaturesetId, this._scope = t1.scope));
                }), this._queryFeatureSetId && this._buildingEntryFeatureSetId && this._map.addInteraction("mbx-indoor-buildingclick", {
                    type: "click",
                    target: {
                        featuresetId: this._buildingEntryFeatureSetId,
                        importId: this._scope
                    },
                    handler: (e)=>(e.feature && e.feature.properties.floorplan && this.selectFloorplan(e.feature.properties.floorplan), !0)
                }), this._checkFloorplanVisible();
            }
            _onMove() {
                this._checkFloorplanVisible();
            }
            _checkFloorplanVisible() {
                if (!this._queryFeatureSetId) return;
                if (!this._map.isStyleLoaded()) return;
                const t1 = ()=>{
                    this._indoorData = void 0, this._selectedFloorplan = void 0, this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !1), this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", [
                        "literal",
                        []
                    ]), this.fire(new e.A("floorplangone"));
                };
                if (this._map.transform.zoom < 13) return void t1();
                const i = {
                    target: {
                        featuresetId: this._queryFeatureSetId,
                        importId: this._scope
                    }
                }, o = this._map.transform.width, s = this._map.transform.height, r = o * (2 / 3), n = s * (2 / 3), a = .5 * (o - r), l = .5 * (s - n), c = [
                    new e.P(a, l),
                    new e.P(a + r, l + n)
                ], h = this._map.queryRenderedFeatures(c, i);
                h.length > 0 ? this._selectedFloorplan && h[0].properties.id === this._selectedFloorplan.properties.id || (this._selectedFloorplan = h[0], this._floorplanSelected()) : t1();
            }
            _floorplanSelected() {
                this._indoorData = JSON.parse(this._selectedFloorplan.properties["indoor-data"]), this._indoorData.id = this._selectedFloorplan.properties.id, this._floorplanStates[this._indoorData.id] = this._floorplanStates[this._indoorData.id] || {}, this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", [
                    "literal",
                    [
                        this._indoorData.id
                    ]
                ]);
                const t1 = this._floorplanStates[this._indoorData.id].selectedBuilding, i = t1 ? this._indoorData.buildings.find((e)=>e.id === t1) : this._indoorData.buildings.length > 0 ? this._indoorData.buildings[0] : null, o = this._floorplanStates[this._indoorData.id].selectedLevel, s = this._indoorData.levels.find((e)=>e.id === o), r = this._indoorData.levels.find((e)=>!(!i || !i.levels) && 0 === Number(e.levelOrder) && i.levels.includes(e.id)), n = s ? s.id : r ? r.id : void 0;
                this.fire(new e.A("floorplanselected", {
                    buildings: this._indoorData.buildings,
                    levels: this._indoorData.levels,
                    selectedLevelId: n
                })), i && this._buildingSelected(i, !1), n && this._levelSelected(n);
            }
            _buildingSelected(t1, i) {
                if (!t1 || !t1.id) return void console.warn("IndoorManager: Building or building id is undefined");
                i && t1.extent && this._map.fitBounds(t1.extent, {
                    pitch: this._map.getPitch(),
                    bearing: this._map.getBearing()
                }), this._floorplanStates[this._indoorData.id].selectedBuilding = t1 ? t1.id : void 0;
                const o = this._indoorData.levels.filter((e)=>t1.levels.includes(e.id));
                this.fire(new e.A("buildingselected", {
                    buildingId: t1.id,
                    levels: o
                }));
            }
            _levelSelected(t1) {
                const i = this._indoorData.levels.find((e)=>e.id === t1);
                i ? (this._updateLevels(i, !0), this.fire(new e.A("levelselected", {
                    levelId: i.id
                }))) : console.warn(`IndoorManager: Level with ID ${t1} not found in the current floorplan.`);
            }
            _updateLevels(e, t1) {
                if (!e || !e.id) throw new Error("IndoorManager: Selected level or level ID is undefined");
                function i(e) {
                    const t1 = e.indexOf("/floor/");
                    if (-1 === t1) return e;
                    const i = t1 + 7, o = e.indexOf("/", i);
                    return -1 === o ? e.slice(i) : e.slice(i, o);
                }
                this._floorplanStates[this._indoorData.id].selectedLevel = e.id;
                const o = [], s = {}, r = {}, n = {}, a = {};
                for (const t1 of this._indoorData.levels){
                    if (o.push(t1.id), s[t1.id] = t1.levelOrder >= 0 ? 3 * Math.abs(t1.levelOrder + 1) : 3 * Math.abs(t1.levelOrder), r[t1.id] = t1.levelOrder >= 0 ? 3 * t1.levelOrder : 0, this.mergeFloors) {
                        const o = i(e.id), s = i(t1.id);
                        n[t1.id] = s === o ? "true" : "false";
                    } else n[t1.id] = t1.id === e.id ? "true" : "false";
                    a[t1.id] = t1.levelOrder < e.levelOrder ? "true" : "false";
                }
                this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", [
                    "literal",
                    o
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-height", [
                    "literal",
                    s
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-base", [
                    "literal",
                    r
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-selected", [
                    "literal",
                    n
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-overlapped", [
                    "literal",
                    a
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-underground", e.levelOrder < 0);
            }
            selectFloorplan(t1) {
                const i = {
                    target: {
                        featuresetId: this._queryFeatureSetId,
                        importId: this._scope
                    }
                }, o = [
                    new e.P(0, 0),
                    new e.P(this._map.transform.width, this._map.transform.height)
                ], s = this._map.queryRenderedFeatures(o, i);
                if (s.length > 0) {
                    for (const e of s)if (JSON.parse(e.properties["indoor-data"]).id === t1) {
                        this._selectedFloorplan = e, this._floorplanSelected();
                        break;
                    }
                }
            }
            selectBuilding(e) {
                const t1 = this._indoorData.buildings.find((t1)=>t1.id === e);
                this._buildingSelected(t1, !0);
            }
            selectLevel(e) {
                this._levelSelected(e);
            }
        }
        function fo(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e.q.devicePixelRatio, { left: o, top: s, width: r, height: n } = t1.metadata.content_area, a = o * i, l = s * i;
            return [
                a,
                l,
                a + r * i,
                l + n * i
            ];
        }
        function mo(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e.q.devicePixelRatio,
                    i * e.q.devicePixelRatio
                ]);
        }
        class go {
            constructor(e, t1, i){
                this.id = e, this.scope = t1, this.sourceCache = i, this.pendingRequests = new Set, this.missingRequests = new Set;
            }
            addPendingRequest(e) {
                this.missingRequests.has(e.name) || this.pendingRequests.has(e.name) || this.pendingRequests.add(e.name);
            }
            hasPendingRequests() {
                return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
                const t1 = new Map;
                if (!this.sourceCache.loaded()) return t1;
                const i = this.sourceCache.getVisibleCoordinates();
                if (0 === i.length) return t1;
                const o = this.sourceCache.getSource();
                if (!(o instanceof st)) return t1;
                const s = i.map((e)=>this.sourceCache.getTile(e)), r = o.getImages(s, Array.from(this.pendingRequests));
                for (const [i, o] of r)t1.set(e.I.from({
                    name: i,
                    iconsetId: this.id
                }), o), this.pendingRequests.delete(i);
                for (const e of this.pendingRequests)this.missingRequests.add(e);
                return this.pendingRequests.clear(), t1;
            }
        }
        const vo = (e, t1)=>Ae(e, t1 && t1.filter((e)=>"source.canvas" !== e.identifier)), yo = e.aF(zt, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport",
            "addIconset",
            "removeIconset"
        ]), xo = e.aF(zt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), bo = new Set([
            "background",
            "sky",
            "slot",
            "custom"
        ]), wo = {
            version: 8,
            layers: [],
            sources: {}
        }, To = {
            duration: 300,
            delay: 0
        };
        class Eo extends e.E {
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = e.h({}, To), this._buildingIndex = new At(this), this.crossTileSymbolIndex = new Fi, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = i.styleChanges || new V, this.dispatcher = i.dispatcher ? i.dispatcher : new e.D(e.c$(), this), i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new q(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e.d0(t1._requestManager, i.localFontFamily ? e.d1.all : i.localIdeographFontFamily ? e.d1.ideographs : e.d1.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new co(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig, this.dispatcher.broadcast("setReferrer", e.d2());
                const o = this;
                this._rtlTextPluginCallback = Eo.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e.d3(t1), i && i.every((e)=>e)) for(const e in o._sourceCaches){
                            const t1 = o._sourceCaches[e], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e)=>{
                    if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
                    const t1 = this.getOwnSource(e.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e in this._layers){
                        const i = this._layers[e];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e) {
                return e ? ("string" == typeof e ? this.loadURL(e) : this.loadJSON(e), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e.j(t1)) return t1;
                    const i = e.d4(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e) {
                        return i;
                    }
                    return i;
                }
                return `json://${e.d5(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, o) {
                this.globalId = this._getGlobalId(t1);
                const s = (e, t1)=>{
                    try {
                        t1(null, this.setState(e, o));
                    } catch (e) {
                        t1(e, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const o = this.map._requestManager.normalizeStyleURL(t1), r = this.map._requestManager.transformRequest(o, e.R.Style);
                    e.n(r, (t1, o)=>{
                        t1 ? this.fire(new e.z(t1)) : o && s(o, i);
                    });
                } else "object" == typeof t1 && s(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e.j(t1);
                this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const s = this.importsCache.get(t1);
                if (s) return this._load(s, o);
                const r = this.map._requestManager.transformRequest(t1, e.R.Style);
                this._request = e.n(r, (i, s)=>{
                    if (this._request = null, i) this.fire(new e.z(i));
                    else if (s) return this.importsCache.set(t1, s), this._load(s, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                })), this.globalId = this._getGlobalId(t1), this._request = e.q.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                })), this._load(wo, !1);
            }
            _loadImports(t1, i, o) {
                if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const s = [];
                for (const e of t1){
                    const t1 = this._createFragmentStyle(e), r = new Promise((e)=>{
                        t1.once("style.import.load", e), t1.once("error", e);
                    }).then(()=>this.mergeAll());
                    if (s.push(r), this.resolvedImports.has(e.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const n = e.data || this.importsCache.get(e.url);
                    n ? (t1.loadJSON(n, {
                        validate: i
                    }), this._isInternalStyle(n) && (t1.globalId = null)) : e.url ? t1.loadURL(e.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const a = {
                        style: t1,
                        id: e.id,
                        config: e.config
                    };
                    if (o) {
                        const e = this.fragments.findIndex(({ id: e })=>e === o);
                        this.fragments = this.fragments.slice(0, e).concat(a).concat(this.fragments.slice(e));
                    } else this.fragments.push(a);
                }
                return Promise.allSettled(s);
            }
            getImportGlobalIds(e = this, t1 = new Set) {
                for (const i of e.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e.C(t1.id, this.scope) : t1.id;
                let o;
                const s = this._initialConfig && this._initialConfig[i];
                (t1.config || s) && (o = e.h({}, t1.config, s));
                const r = new Eo(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: o,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    configDependentLayers: this._configDependentLayers
                });
                return r.setEventedParent(this.map, {
                    style: r
                }), r;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e) {
                return this.isRootStyle() && (e.fragment || !!e.schema && !1 !== e.fragment);
            }
            _load(t1, i) {
                const o = t1.indoor ? _o(t1.schema) : t1.schema;
                if (this._isInternalStyle(t1)) {
                    const o = e.h({}, wo, {
                        imports: [
                            {
                                id: "basemap",
                                data: t1,
                                url: ""
                            }
                        ]
                    });
                    return void this._load(o, i);
                }
                if (this.updateConfig(this._config, o), i && vo(this, me(t1))) return;
                this._loaded = !0, this.stylesheet = e.d6(t1);
                const s = ()=>{
                    for(const e in t1.sources)this.addSource(e, t1.sources[e], {
                        validate: !1,
                        isInitialLoad: !0
                    });
                    if (t1.iconsets) for(const e in t1.iconsets)this.addIconset(e, t1.iconsets[e]);
                    t1.sprite ? this._loadIconset(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    })), this.setGlyphsUrl(t1.glyphs);
                    const o = Pt(this.stylesheet.layers);
                    if (this._order = o.map((e)=>e.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e = this.stylesheet.lights[0];
                            this.light = new Pe(e.properties, e.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new Pe(this.stylesheet.light)), this._layers = {};
                    for (const t1 of o){
                        const i = e.db(t1, this.scope, this._styleColorTheme.lut, this.options);
                        0 !== i.configDependencies.size && this._configDependentLayers.add(i.fqid), i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i;
                        const o = this.getOwnLayerSourceCache(i), s = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        o && i.canCastShadows() && s && (o.castsShadows = !0);
                    }
                    this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                    const s = this.stylesheet.terrain;
                    s && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(s, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                    const r = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(), this.fire(new e.A(r ? "style.load" : "style.import.load"));
                    }).catch((t1)=>{
                        this.fire(new e.z(new Error("Failed to load imports", t1))), this.fire(new e.A(r ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(), this.fire(new e.A(r ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const r = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (r) {
                    const t1 = this._evaluateColorThemeData(r);
                    this._loadColorTheme(t1).then(()=>{
                        s();
                    }).catch((t1)=>{
                        e.w(`Couldn't load color theme from the stylesheet: ${t1}`), s();
                    });
                } else this._styleColorTheme.lut = null, s();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            mergeAll() {
                let t1, i, o, s, r, n, a, l, c, h;
                const d = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e)=>{
                    if (e.stylesheet) {
                        if (null != e.light && (t1 = e.light), e.stylesheet.lights) for (const t1 of e.stylesheet.lights)"ambient" === t1.type && null != e.ambientLight && (i = e.ambientLight), "directional" === t1.type && null != e.directionalLight && (o = e.directionalLight);
                        s = this._prioritizeTerrain(s, e.terrain, e.stylesheet.terrain), e.stylesheet.fog && null != e.fog && (r = e.fog), e.stylesheet.snow && null != e.snow && (n = e.snow), e.stylesheet.rain && null != e.rain && (a = e.rain), null != e.stylesheet.camera && (h = e.stylesheet.camera), null != e.stylesheet.projection && (l = e.stylesheet.projection), null != e.stylesheet.transition && (c = e.stylesheet.transition), d[e.scope] = e._styleColorTheme;
                    }
                }), this.light = t1, this.ambientLight = i, this.directionalLight = o, this.fog = r, this.snow = n, this.rain = a, this._styleColorThemeForScope = d, null === s ? delete this.terrain : this.terrain = s, this.camera = h || {
                    "camera-projection": "perspective"
                }, this.projection = l || {
                    name: "mercator"
                }, this.transition = e.h({}, To, c), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e) {
                const t1 = (i)=>{
                    for (const e of i.fragments)t1(e.style);
                    e(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e, t1, i) {
                const o = e && 0 === e.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : o ? e : null : null != t1 && (!e || o || t1 && 1 === t1.drapeRenderMode) ? t1 : e;
            }
            mergeTerrain() {
                let e;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e = this._prioritizeTerrain(e, t1.terrain, t1.stylesheet.terrain);
                }), null === e ? delete this.terrain : this.terrain = e;
            }
            mergeProjection() {
                let e;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e = t1.stylesheet.projection);
                }), this.projection = e || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const t1 = {}, i = {}, o = {};
                this.forEachFragmentStyle((s)=>{
                    for(const i in s._sourceCaches){
                        const o = e.C(i, s.scope);
                        t1[o] = s._sourceCaches[i];
                    }
                    for(const t1 in s._otherSourceCaches){
                        const o = e.C(t1, s.scope);
                        i[o] = s._otherSourceCaches[t1];
                    }
                    for(const t1 in s._symbolSourceCaches){
                        const i = e.C(t1, s.scope);
                        o[i] = s._symbolSourceCaches[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o;
            }
            mergeLayers() {
                const t1 = {}, i = [], o = {};
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((o)=>{
                    for (const s of o._order){
                        const r = o._layers[s];
                        if ("slot" === r.type) {
                            const i = e.d7(s);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        r.slot && t1[r.slot] ? t1[r.slot].push(r) : i.push(r);
                    }
                }), this._mergedOrder = [];
                const s = (i = [])=>{
                    for (const r of i)if ("slot" === r.type) {
                        const i = e.d7(r.id);
                        t1[i] && s(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e.C(r.id, r.scope);
                        this._mergedOrder.push(t1), o[t1] = r, r.is3D(!!this.terrain) && (this._has3DLayers = !0), "circle" === r.type && (this._hasCircleLayers = !0), "symbol" === r.type && (this._hasSymbolLayers = !0), "clip" === r.type && (this._clipLayerPresent = !0);
                    }
                };
                s(i), this._mergedOrder.sort((e, t1)=>{
                    const i = o[e], s = o[t1];
                    return i.hasInitialOcclusionOpacityProperties ? s.is3D(!!this.terrain) ? 1 : 0 : i.is3D(!!this.terrain) && s.hasInitialOcclusionOpacityProperties ? -1 : 0;
                }), this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(t1) {
                return this.stylesheet.camera = e.h({}, this.stylesheet.camera, t1), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, o, s) {
                    const r = e.h({}, i);
                    for (const t1 of Object.keys(e.a5.colorTheme))void 0 === r[t1] && (r[t1] = e.a5.colorTheme[t1].default);
                    const n = new e.a6(ho, t1, new Map(o));
                    return n.setTransitionOrValue(r, o), n.untransitioned().possiblyEvaluate(new e.aa(0, {
                        worldview: void 0
                    }));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((o, s)=>{
                    const r = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void o();
                    let n = t1;
                    n.startsWith(r) || (n = r + n);
                    const a = e.I.from("mapbox-reserved-lut"), l = new Image;
                    l.src = n, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, s(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: r, height: n, data: c } = e.q.getImageData(l);
                        if (n > 32) return void s(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (r !== n * n) return void s(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(a) && this.removeImage(a), this.addImage(a, {
                            data: new e.r({
                                width: r,
                                height: n
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(a, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, o()) : s(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e) {
                const t1 = this._styleColorThemeForScope[e];
                return t1 ? t1.lut : null;
            }
            setProjection(e) {
                e ? this.stylesheet.projection = e : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let s, r, n;
                    const a = e.q.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e.n(i.transformRequest(i.normalizeSpriteURL(t1, a, ".json"), e.R.SpriteJSON), (e, t1)=>{
                        l = null, n || (n = e, s = t1, h());
                    }), c = e.o(i.transformRequest(i.normalizeSpriteURL(t1, a, ".png"), e.R.SpriteImage), (e, t1)=>{
                        c = null, n || (n = e, r = t1, h());
                    });
                    function h() {
                        if (n) o(n);
                        else if (s && r) {
                            const t1 = e.q.getImageData(r), i = {};
                            for(const o in s){
                                const { width: r, height: n, x: a, y: l, sdf: c, pixelRatio: h, stretchX: d, stretchY: u, content: _ } = s[o], p = new e.r({
                                    width: r,
                                    height: n
                                });
                                e.r.copy(t1, p, {
                                    x: a,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: r,
                                    height: n
                                }, null), i[o] = {
                                    data: p,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: d,
                                    stretchY: u,
                                    content: _,
                                    usvg: !1
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e.z(t1));
                    else if (i) {
                        const t1 = new Map;
                        for(const o in i)t1.set(e.I.from(o), i[o]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                });
            }
            addIconset(t1, i) {
                if ("sprite" === i.type) return void this._loadSprite(i.url);
                const o = this.getOwnSourceCache(i.source);
                if (!o) return void this.fire(new e.z(new Error(`Source "${i.source}" as specified by iconset "${t1}" does not exist and cannot be used as an iconset source`)));
                const s = o.getSource();
                if ("raster-array" !== s.type) return void this.fire(new e.z(new Error(`Source "${i.source}" as specified by iconset "${t1}" is not a "raster-array" source and cannot be used as an iconset source`)));
                s.partial = !1;
                const r = new go(t1, this.scope, o);
                this.imageManager.addImageProvider(r, this.scope);
            }
            removeIconset(e) {
                this.imageManager.removeImageProvider(e, this.scope);
            }
            _loadIconset(t1) {
                if (!e.j(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat;
                var o, s;
                this._spriteRequest = (s = (o, s)=>{
                    if (this._spriteRequest = null, o) i ? this._loadSprite(t1) : this.fire(new e.z(o));
                    else if (s) {
                        const t1 = new Map;
                        for(const i in s)t1.set(e.I.from(i), s[i]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                }, e.br((o = this.map._requestManager).transformRequest(o.normalizeIconsetURL(t1), e.R.Iconset), (t1, i)=>{
                    if (t1) return void s(t1);
                    const o = {}, r = e.c_(new e.bq(i));
                    for (const t1 of r.icons){
                        const i = {
                            version: 1,
                            pixelRatio: e.q.devicePixelRatio,
                            content: fo(t1),
                            stretchX: t1.metadata ? mo(t1.metadata.stretch_x_areas) : void 0,
                            stretchY: t1.metadata ? mo(t1.metadata.stretch_y_areas) : void 0,
                            sdf: !1,
                            usvg: !0,
                            icon: t1
                        };
                        o[t1.name] = i;
                    }
                    s(null, o);
                }));
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e.z(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e in this._sourceCaches)if (!this._sourceCaches[e].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (this.imageManager.hasPatternsInFlight()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e } of this.fragments)if (!e.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e.data = i.style.serialize()), e;
                });
            }
            _serializeSources() {
                const e = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e[i.id] || (e[i.id] = i.serialize());
                }
                return e;
            }
            _serializeLayers(e) {
                const t1 = [];
                for (const i of e){
                    const e = this._layers[i];
                    e && "custom" !== e.type && t1.push(e.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e in this._sourceCaches)if (this._sourceCaches[e].hasTransition()) return !0;
                for(const e in this._layers)if (this._layers[e].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e) {
                return e ? this.order : this._mergedOrder;
            }
            isLayerDraped(e) {
                return !!this.terrain && e.isDraped(this.getLayerSourceCache(e));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e.z(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e.z(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            precompilePrograms(e, t1) {
                const i = this.map.painter;
                if (i) for(let o = e.minzoom || 0; o < (e.maxzoom || 25.5); o++){
                    const o = e.getProgramIds();
                    if (o) for (const s of o){
                        const o = e.getDefaultProgramParams(s, t1.zoom, this._styleColorTheme.lut);
                        o && (i.style = this, this.fog && (i._fogVisible = !0, o.overrideFog = !0, i.getOrCreateProgram(s, o)), i._fogVisible = !1, o.overrideFog = !1, i.getOrCreateProgram(s, o), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o.overrideRtt = !0, i.getOrCreateProgram(s, o)));
                    }
                }
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i)), t1.worldview !== this._worldview && (this._worldview = t1.worldview, this.dispatcher.broadcast("setWorldview", this._worldview));
                const o = this._changes.isDirty();
                let s = !1;
                if (this._changes.isDirty()) {
                    const e = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e){
                        const { updatedIds: i, removedIds: o } = e[t1];
                        (i || o) && (this._updateWorkerLayers(t1, i, o), s = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const r = {};
                for(const e in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e];
                    r[e] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                for (const e of this._mergedOrder){
                    const i = this._mergedLayers[e];
                    if (i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e = this.getLayerSourceCache(i);
                        e && (e.used = !0, e.tileCoverLift = Math.max(e.tileCoverLift, i.tileCoverLift()));
                    }
                    !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(()=>{
                        this.precompilePrograms(i, t1);
                    }) : this.precompilePrograms(i, t1));
                }
                this._shouldPrecompile && (this._precompileDone = !0), this.terrain && s && this.mergeLayers();
                const n = this.imageManager.getPendingImageProviders();
                for (const e of n)e.sourceCache.used = !0;
                for(const t1 in r){
                    const i = this._mergedSourceCaches[t1];
                    r[t1] !== i.used && i.getSource().fire(new e.A("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), this.imageManager.clearUpdatedImages(this.scope), o && this.fire(new e.A("data", {
                    dataType: "style"
                }));
            }
            updateImageProviders() {
                const e = this.imageManager.getPendingImageProviders();
                for (const t1 of e){
                    const e = t1.resolvePendingRequests(), i = this.getFragmentStyle(t1.scope);
                    i && i.addImages(e);
                }
            }
            _updateTilesForChangedImages() {
                const e = {};
                for(const t1 in this._mergedSourceCaches){
                    const i = this._mergedSourceCaches[t1].getSource().scope;
                    e[i] = e[i] || this._changes.getUpdatedImages(i), 0 !== e[i].length && this._mergedSourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e[i]);
                }
                for(const t1 in e)this._changes.resetUpdatedImages(t1);
            }
            _updateWorkerLayers(e, t1, i) {
                const o = this.getFragmentStyle(e);
                o && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? o._serializeLayers(t1) : [],
                    scope: e,
                    removedIds: i || [],
                    options: o.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), vo(this, me(t1))) return !1;
                (t1 = e.d6(t1)).layers = Pt(t1.layers);
                const o = (function(t1, i) {
                    if (!t1) return [
                        {
                            command: zt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!e.bv(t1.version, i.version)) return [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        if (e.bv(t1.center, i.center) || o.push({
                            command: zt.setCenter,
                            args: [
                                i.center
                            ]
                        }), e.bv(t1.zoom, i.zoom) || o.push({
                            command: zt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), e.bv(t1.bearing, i.bearing) || o.push({
                            command: zt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), e.bv(t1.pitch, i.pitch) || o.push({
                            command: zt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), e.bv(t1.sprite, i.sprite) || o.push({
                            command: zt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), e.bv(t1.glyphs, i.glyphs) || o.push({
                            command: zt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), e.bv(t1.imports, i.imports) || function(t1 = [], i = [], o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map(Nt), r = i.map(Nt), n = t1.reduce(Ut, {}), a = i.reduce(Ut, {}), l = s.slice();
                            let c, h, d, u;
                            for(c = 0, h = 0; c < s.length; c++)d = s[c], a.hasOwnProperty(d) ? h++ : (o.push({
                                command: zt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, h), 1));
                            for(c = 0, h = 0; c < r.length; c++)d = r[r.length - 1 - c], l[l.length - 1 - c] !== d && (n.hasOwnProperty(d) ? (o.push({
                                command: zt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - h), 1)) : h++, u = l[l.length - c], o.push({
                                command: zt.addImport,
                                args: [
                                    a[d],
                                    u
                                ]
                            }), l.splice(l.length - c, 0, d));
                            for (const t1 of i){
                                const i = n[t1.id];
                                i && (delete i.data, e.bv(i, t1) || o.push({
                                    command: zt.updateImport,
                                    args: [
                                        t1.id,
                                        t1
                                    ]
                                }));
                            }
                        }(t1.imports, i.imports, o), e.bv(t1.transition, i.transition) || o.push({
                            command: zt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), e.bv(t1.light, i.light) || o.push({
                            command: zt.setLight,
                            args: [
                                i.light
                            ]
                        }), e.bv(t1.fog, i.fog) || o.push({
                            command: zt.setFog,
                            args: [
                                i.fog
                            ]
                        }), e.bv(t1.snow, i.snow) || o.push({
                            command: zt.setSnow,
                            args: [
                                i.snow
                            ]
                        }), e.bv(t1.rain, i.rain) || o.push({
                            command: zt.setRain,
                            args: [
                                i.rain
                            ]
                        }), e.bv(t1.projection, i.projection) || o.push({
                            command: zt.setProjection,
                            args: [
                                i.projection
                            ]
                        }), e.bv(t1.lights, i.lights) || o.push({
                            command: zt.setLights,
                            args: [
                                i.lights
                            ]
                        }), e.bv(t1.camera, i.camera) || o.push({
                            command: zt.setCamera,
                            args: [
                                i.camera
                            ]
                        }), e.bv(t1.iconsets, i.iconsets) || function(t1, i, o) {
                            let s;
                            for(s in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(s) && (i.hasOwnProperty(s) || o.push({
                                command: zt.removeIconset,
                                args: [
                                    s
                                ]
                            }));
                            for(s in i){
                                if (!i.hasOwnProperty(s)) continue;
                                const r = i[s];
                                t1.hasOwnProperty(s) ? e.bv(t1[s], r) || (o.push({
                                    command: zt.removeIconset,
                                    args: [
                                        s
                                    ]
                                }), o.push({
                                    command: zt.addIconset,
                                    args: [
                                        s,
                                        r
                                    ]
                                })) : o.push({
                                    command: zt.addIconset,
                                    args: [
                                        s,
                                        r
                                    ]
                                });
                            }
                        }(t1.iconsets, i.iconsets, o), !e.bv(t1["color-theme"], i["color-theme"])) return [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        const s = {}, r = [];
                        !function(t1, i, o, s) {
                            let r;
                            for(r in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(r) && (i.hasOwnProperty(r) || Ot(r, o, s));
                            for(r in i){
                                if (!i.hasOwnProperty(r)) continue;
                                const n = i[r];
                                t1.hasOwnProperty(r) ? e.bv(t1[r], n) || ("geojson" === t1[r].type && "geojson" === n.type && Bt(t1, i, r) ? o.push({
                                    command: zt.setGeoJSONSourceData,
                                    args: [
                                        r,
                                        n.data
                                    ]
                                }) : Ft(r, i, o, s)) : Mt(r, i, o);
                            }
                        }(t1.sources, i.sources, r, s);
                        const n = [];
                        t1.layers && t1.layers.forEach((e)=>{
                            e.source && s[e.source] ? o.push({
                                command: zt.removeLayer,
                                args: [
                                    e.id
                                ]
                            }) : n.push(e);
                        });
                        let a = t1.terrain;
                        a && s[a.source] && (o.push({
                            command: zt.setTerrain,
                            args: [
                                void 0
                            ]
                        }), a = void 0), o = o.concat(r), e.bv(a, i.terrain) || o.push({
                            command: zt.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(t1, i, o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map(Nt), r = i.map(Nt), n = t1.reduce(Ut, {}), a = i.reduce(Ut, {}), l = s.slice(), c = Object.create(null);
                            let h, d, u, _, p, f, m;
                            for(h = 0, d = 0; h < s.length; h++)u = s[h], a.hasOwnProperty(u) ? d++ : (o.push({
                                command: zt.removeLayer,
                                args: [
                                    u
                                ]
                            }), l.splice(l.indexOf(u, d), 1));
                            for(h = 0, d = 0; h < r.length; h++)u = r[r.length - 1 - h], l[l.length - 1 - h] !== u && (n.hasOwnProperty(u) ? (o.push({
                                command: zt.removeLayer,
                                args: [
                                    u
                                ]
                            }), l.splice(l.lastIndexOf(u, l.length - d), 1)) : d++, f = l[l.length - h], o.push({
                                command: zt.addLayer,
                                args: [
                                    a[u],
                                    f
                                ]
                            }), l.splice(l.length - h, 0, u), c[u] = !0);
                            for(h = 0; h < r.length; h++)if (u = r[h], _ = n[u], p = a[u], !c[u] && !e.bv(_, p)) {
                                if (e.bv(_.source, p.source) && e.bv(_["source-layer"], p["source-layer"]) && e.bv(_.type, p.type)) {
                                    for(m in kt(_.layout, p.layout, o, u, null, zt.setLayoutProperty), kt(_.paint, p.paint, o, u, null, zt.setPaintProperty), e.bv(_.slot, p.slot) || o.push({
                                        command: zt.setSlot,
                                        args: [
                                            u,
                                            p.slot
                                        ]
                                    }), e.bv(_.filter, p.filter) || o.push({
                                        command: zt.setFilter,
                                        args: [
                                            u,
                                            p.filter
                                        ]
                                    }), e.bv(_.minzoom, p.minzoom) && e.bv(_.maxzoom, p.maxzoom) || o.push({
                                        command: zt.setLayerZoomRange,
                                        args: [
                                            u,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), _)_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? kt(_[m], p[m], o, u, m.slice(6), zt.setPaintProperty) : e.bv(_[m], p[m]) || o.push({
                                        command: zt.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? kt(_[m], p[m], o, u, m.slice(6), zt.setPaintProperty) : e.bv(_[m], p[m]) || o.push({
                                        command: zt.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else o.push({
                                    command: zt.removeLayer,
                                    args: [
                                        u
                                    ]
                                }), f = l[l.lastIndexOf(u) + 1], o.push({
                                    command: zt.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(n, i.layers, o);
                    } catch (e) {
                        console.warn("Unable to compute style diff:", e), o = [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), t1).filter((e)=>!(e.command in xo));
                if (0 === o.length) return !1;
                const s = o.filter((e)=>!(e.command in yo));
                if (s.length > 0) throw new Error(`Unimplemented: ${s.map((e)=>e.command).join(", ")}.`);
                const r = [];
                return o.forEach((e)=>{
                    r.push(this[e.command](...e.args));
                }), i && Promise.all(r).then(i).catch(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            _updateWorkerImages() {
                this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                });
            }
            _updateWorkerModels() {
                this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", {
                    scope: this.scope,
                    models: this._availableModels
                });
            }
            addImages(t1) {
                for (const [i, o] of t1.entries()){
                    if (this.getImage(i)) return this.fire(new e.z(new Error(`An image with the name "${i.name}" already exists.`)));
                    this.imageManager.addImage(i, this.scope, o), this._changes.updateImage(i, this.scope);
                }
                return this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e.z(new Error(`An image with the name "${t1.name}" already exists.`))) : (this.imageManager.addImage(t1, this.scope, i), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this);
            }
            updateImage(t1, i, o = !1) {
                this.imageManager.updateImage(t1, this.scope, i), o && (this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })));
            }
            getImage(e) {
                return this.imageManager.getImage(e, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this) : this.fire(new e.z(new Error("No image with this name exists.")));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addModelURLs(t1) {
                return this.modelManager.addModelURLs(t1, this.scope), this._updateWorkerModels(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this;
            }
            addModel(t1, i, o = {}) {
                return this._checkLoaded(), this._validate(Re, `models.${t1}`, i, null, o) || (this.modelManager.addModel(t1, i, this.scope), this.fire(new e.A("data", {
                    dataType: "style"
                }))), this;
            }
            hasModel(e) {
                return this.modelManager.hasModel(e, this.scope);
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.scope), this.fire(new e.A("data", {
                    dataType: "style"
                })), this) : this.fire(new e.z(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(ge, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const s = nt(t1, i, this.dispatcher, this);
                s.scope = this.scope, s.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(s.id),
                        source: s.serialize(),
                        sourceId: s.id
                    }));
                const r = (t1)=>{
                    const i = (t1 ? "symbol:" : "other:") + s.id, o = e.C(i, this.scope), r = this._sourceCaches[i] = new It(o, s, t1);
                    (t1 ? this._symbolSourceCaches : this._otherSourceCaches)[s.id] = r, r.onAdd(this.map);
                };
                r(!1), "vector" !== i.type && "geojson" !== i.type || r(!0), s.onAdd && s.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                if (this.stylesheet.iconsets) {
                    const i = Object.entries(this.stylesheet.iconsets).find(([e, i])=>"source" === i.type && i.source === t1);
                    if (i) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while iconset "${i[0]}" is using it.`)));
                }
                const o = this.getOwnSourceCaches(t1);
                for (const t1 of o){
                    const i = e.d7(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e.A("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e, t1) {
                this._checkLoaded(), this.getOwnSource(e).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e) {
                const t1 = this.getOwnSourceCache(e);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e.push(i.getSource());
                }
                return e;
            }
            areTilesLoaded() {
                const e = this._mergedSourceCaches;
                for(const t1 in e){
                    const i = e[t1]._tiles;
                    for(const e in i){
                        const t1 = i[e];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const o of t1){
                    if (this._validate(ye, "lights", o)) return;
                    switch(o.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const e = this.ambientLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.ambientLight = new $e(o, qe || (qe = new e.a7({
                                color: new e.a8(e.a5.properties_light_ambient.color),
                                "color-use-theme": new e.a8({
                                    type: "string",
                                    default: "default",
                                    "property-type": "data-constant"
                                }),
                                intensity: new e.a8(e.a5.properties_light_ambient.intensity)
                            })), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const e = this.directionalLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.directionalLight = new $e(o, Ze || (Ze = new e.a7({
                                direction: new e.an(e.a5.properties_light_directional.direction),
                                color: new e.a8(e.a5.properties_light_directional.color),
                                "color-use-theme": new e.a8({
                                    type: "string",
                                    default: "default",
                                    "property-type": "data-constant"
                                }),
                                intensity: new e.a8(e.a5.properties_light_directional.intensity),
                                "cast-shadows": new e.a8(e.a5.properties_light_directional["cast-shadows"]),
                                "shadow-quality": new e.a8(e.a5.properties_light_directional["shadow-quality"]),
                                "shadow-intensity": new e.a8(e.a5.properties_light_directional["shadow-intensity"])
                            })), this.scope, this.options);
                    }
                }
                const o = Object.assign(i, {
                    worldview: this.map.getWorldview()
                }), s = new e.aa(this.z || 0, o);
                this.ambientLight && this.ambientLight.recalculate(s), this.directionalLight && this.directionalLight.recalculate(s), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const o = (e)=>.2126 * (e[0] <= .03928 ? e[0] / 12.92 : Math.pow((e[0] + .055) / 1.055, 2.4)) + .7152 * (e[1] <= .03928 ? e[1] / 12.92 : Math.pow((e[1] + .055) / 1.055, 2.4)) + .0722 * (e[2] <= .03928 ? e[2] / 12.92 : Math.pow((e[2] + .055) / 1.055, 2.4)), s = t1.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), r = t1.properties.get("intensity"), n = t1.properties.get("direction"), a = 1 - e.cR(n.x, n.y, n.z)[2] / 90, l = o(s) * r * a, c = i.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h = i.properties.get("intensity"), d = o(c) * h;
                return Number(((l + d) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e = [];
                return this.directionalLight && e.push(this.directionalLight.get()), this.ambientLight && e.push(this.ambientLight.get()), e;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (null == t1 || "" === t1 && this.isRootStyle()) return this;
                if (e.d8(t1)) {
                    const i = e.d9(t1), o = this.fragments.find(({ id: e })=>e === i);
                    if (!o) return;
                    const s = e.d7(t1);
                    return o.style.getFragmentStyle(s);
                }
                {
                    const e = this.fragments.find(({ id: e })=>e === t1);
                    return e ? e.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = {}, o = (e, t1 = "")=>`${e}::${t1}`;
                this._featuresetSelectors = {};
                for(const s in t1){
                    const r = this._featuresetSelectors[s] = [];
                    for (const n of t1[s].selectors){
                        if (n.featureNamespace) {
                            const t1 = this.getOwnLayer(n.layer);
                            if (!t1) {
                                e.w(`Layer is undefined for selector: ${n.layer}`);
                                continue;
                            }
                            const r = o(t1.source, t1.sourceLayer);
                            if (r in i && i[r] !== n.featureNamespace) {
                                e.w(`"featureNamespace ${n.featureNamespace} of featureset ${s}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            i[r] = n.featureNamespace;
                        }
                        let t1;
                        if (n.properties) for(const i in n.properties){
                            const o = e.X(n.properties[i]);
                            "success" === o.result && (t1 = t1 || {}, t1[i] = o.value);
                        }
                        r.push({
                            layerId: n.layer,
                            namespace: n.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: n._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e) {
                const t1 = this.getFragmentStyle(e);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e in t1.stylesheet.featuresets)i.push({
                    featuresetId: e,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const o = this.getFragmentStyle(i), s = o.stylesheet.featuresets;
                if (!s || !s[t1]) return this.fire(new e.z(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const r = [];
                for (const e of s[t1].selectors){
                    const t1 = o.getOwnLayer(e.layer);
                    t1 && r.push(t1);
                }
                return r;
            }
            getConfigProperty(t1, i) {
                const o = this.getFragmentStyle(t1);
                if (!o) return null;
                const s = e.C(i, o.scope), r = o.options.get(s), n = r ? r.value || r.default : null;
                return n ? n.serialize() : null;
            }
            setConfigProperty(t1, i, o) {
                const s = this.getFragmentStyle(t1);
                if (!s) return;
                const r = s.stylesheet.indoor ? _o(s.stylesheet.schema) : s.stylesheet.schema;
                if (!r || !r[i]) return;
                const n = e.X(o);
                if ("success" !== n.result) return void vo(this, n.value);
                const a = n.value.expression, l = e.C(i, s.scope), c = s.options.get(l);
                if (!c) return;
                let h;
                const { minValue: d, maxValue: u, stepValue: _, type: p, values: f } = r[i], m = e.X(r[i].default);
                "success" === m.result && (h = m.value.expression), h ? (this.options.set(l, Object.assign({}, c, {
                    value: a,
                    default: h,
                    minValue: d,
                    maxValue: u,
                    stepValue: _,
                    type: p,
                    values: f
                })), this.updateConfigDependencies(i)) : this.fire(new e.z(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const o = i.stylesheet.schema;
                if (!o) return null;
                const s = {};
                for(const t1 in o){
                    const o = e.C(t1, i.scope), r = i.options.get(o), n = r ? r.value || r.default : null;
                    s[t1] = n ? n.serialize() : null;
                }
                return s;
            }
            setConfig(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e) {
                const t1 = this.getFragmentStyle(e);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const o in i){
                        let s, r;
                        const n = e.X(i[o].default);
                        if ("success" === n.result && (s = n.value.expression), t1 && void 0 !== t1[o]) {
                            const i = e.X(t1[o]);
                            "success" === i.result && (r = i.value.expression);
                        }
                        const { minValue: a, maxValue: l, stepValue: c, type: h, values: d } = i[o];
                        if (s) {
                            const t1 = e.C(o, this.scope);
                            this.options.set(t1, {
                                default: s,
                                value: r,
                                minValue: a,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: d
                            });
                        } else this.fire(new e.z(new Error(`No schema defined for config option "${o}".`)));
                    }
                    else this.fire(new e.z(new Error("Attempting to set config for a style without schema.")));
                }
            }
            updateConfigDependencies(e) {
                for (const t1 of this._configDependentLayers){
                    const i = this.getLayer(t1);
                    if (i) {
                        if (e && !i.configDependencies.has(e)) continue;
                        i.possiblyEvaluateVisibility(), this._updateLayer(i);
                    }
                }
                this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e)=>{
                    const t1 = e._styleColorTheme.colorThemeOverride ? e._styleColorTheme.colorThemeOverride : e._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e._evaluateColorThemeData(t1);
                        (!e._styleColorTheme.lut && "" !== i || e._styleColorTheme.lut && i !== e._styleColorTheme.lut.data) && e.setColorTheme(t1);
                    }
                }), this._changes.setDirty();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const s = t1.id;
                if (this._layers[s]) return void this.fire(new e.z(new Error(`Layer with id "${s}" already exists on this map`)));
                let r;
                if ("custom" === t1.type) {
                    if (vo(this, e.da(t1))) return;
                    r = e.db(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(s, t1.source), t1 = e.d6(t1), t1 = e.h(t1, {
                        source: s
                    })), this._validate(Ee, `layers.${s}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    r = e.db(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(r), r.setEventedParent(this, {
                        layer: {
                            id: s
                        }
                    });
                }
                0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid);
                let n = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.z(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    r.slot === this._layers[i].slot ? n = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(n, 0, s), this._layerOrderChanged = !0, this._layers[s] = r;
                const a = this.getOwnLayerSourceCache(r), l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                a && r.canCastShadows() && l && (a.castsShadows = !0);
                const c = this._changes.getRemovedLayer(r);
                if (c && r.source && a && "custom" !== r.type) {
                    this._changes.discardLayerRemoval(r);
                    const t1 = e.C(r.source, r.scope);
                    c.type !== r.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), a.pause());
                }
                this._updateLayer(r), r.onAdd && r.onAdd(this.map), r.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (!o) return;
                if (t1 === i) return;
                const s = this._order.indexOf(t1);
                this._order.splice(s, 1);
                let r = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.z(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot === this._layers[i].slot ? r = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(r, 0, t1), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
            }
            removeLayer(e) {
                this._checkLoaded();
                const t1 = this._checkLayer(e);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e);
                this._order.splice(i, 1), delete this._layers[e], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t1.fqid), this._changes.removeLayer(t1);
                const o = this.getOwnLayerSourceCache(t1);
                if (o && o.castsShadows) {
                    let e = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e = !0;
                        break;
                    }
                    o.castsShadows = e;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e) {
                return this._layers[e];
            }
            hasLayer(e) {
                return e in this._mergedLayers;
            }
            hasLayerType(e) {
                for(const t1 in this._layers)if (this._layers[t1].type === e) return !0;
                return !1;
            }
            setLayerZoomRange(e, t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(e);
                o && (o.minzoom === t1 && o.maxzoom === i || (null != t1 && (o.minzoom = t1), null != i && (o.maxzoom = i), this._updateLayer(o)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, o = {}) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (s && !e.bv(s.filter, i)) return null == i ? (s.filter = void 0, void this._updateLayer(s)) : void (this._validate(Se, `layers.${s.id}.filter`, i, {
                    layerType: s.type
                }, o) || (s.filter = e.d6(i), this._updateLayer(s)));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e.d6(i.filter);
            }
            setLayoutProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (r && !e.bv(r.getLayoutProperty(i), o)) {
                    if (null != o && (!s || !1 !== s.validate) && vo(r, Ce.call(me, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: r.type,
                        objectKey: i,
                        value: o,
                        styleSpec: e.a5,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    r.setLayoutProperty(i, o), 0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid), this._updateLayer(r);
                }
            }
            getLayoutProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (!r) return;
                if (e.bv(r.getPaintProperty(i), o)) return;
                if (null != o && (!s || !1 !== s.validate) && vo(r, Ie.call(me, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: r.type,
                    objectKey: i,
                    value: o,
                    styleSpec: e.a5
                }))) return;
                const n = r.setPaintProperty(i, o);
                0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid), n && this._updateLayer(r), this._changes.updatePaintProperties(r);
            }
            getPaintProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.setFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.setFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = t1.sourceLayer, r = this._checkSource(o);
                if (!r) return;
                const n = r.type;
                if ("geojson" === n && s) return void this.fire(new e.z(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === n && !s) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e.z(new Error("The feature id parameter must be provided.")));
                const a = this.getOwnSourceCaches(o);
                for (const e of a)e.setFeatureState(s, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.removeFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.removeFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = this._checkSource(o);
                if (!s) return;
                const r = s.type, n = "vector" === r ? t1.sourceLayer : void 0;
                if ("vector" === r && !n) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e.z(new Error("A feature id is required to remove its specific state property.")));
                const a = this.getOwnSourceCaches(o);
                for (const e of a)e.removeFeatureState(n, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: o, importId: s } = t1.target, r = this.getFragmentStyle(s), n = r.getFeaturesetLayers(o);
                        for (const { source: o, sourceLayer: s } of n){
                            const n = r.getFeatureState({
                                id: t1.id,
                                source: o,
                                sourceLayer: s
                            });
                            if (n && !i) i = n;
                            else if (!e.bv(i, n)) return void this.fire(new e.z(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        i = this.getFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, o = t1.sourceLayer, s = this._checkSource(i);
                if (s) {
                    if ("vector" !== s.type || o) return void 0 === t1.id && this.fire(new e.z(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(t1) {
                return this.stylesheet.transition = e.h({}, this.stylesheet.transition, t1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return e.h({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e.dc({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    iconsets: this.stylesheet.iconsets,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e)=>void 0 !== e);
            }
            _updateFilteredLayers(e) {
                for (const t1 of Object.values(this._mergedLayers))e(t1) && this._updateLayer(t1);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), o = e.C(t1.source, t1.scope), s = this._changes.getUpdatedSourceCaches();
                t1.source && !s[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e) {
                const t1 = (e)=>this._mergedLayers[e].is3D(!!this.terrain), i = this.order, o = {}, s = [];
                for(let r = i.length - 1; r >= 0; r--){
                    const n = i[r];
                    if (t1(n)) {
                        o[n] = r;
                        for (const t1 of e){
                            const e = t1[n];
                            if (e) for (const t1 of e)s.push(t1);
                        }
                    }
                }
                s.sort((e, t1)=>t1.intersectionZ - e.intersectionZ);
                const r = [];
                for(let n = i.length - 1; n >= 0; n--){
                    const a = i[n];
                    if (t1(a)) for(let e = s.length - 1; e >= 0; e--){
                        const t1 = s[e].feature;
                        if (t1.layer && o[t1.layer.id] < n) break;
                        r.push(t1), s.pop();
                    }
                    else for (const t1 of e){
                        const e = t1[a];
                        if (e) for (const t1 of e)r.push(t1.feature);
                    }
                }
                return r;
            }
            queryRenderedFeatures(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Se, "queryRenderedFeatures.filter", i.filter, null, i), s = e.b3(i.filter));
                const r = {}, n = (e)=>{
                    if (bo.has(e.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e), i = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e.is3D(!!this.terrain) && (i.has3DLayers = !0), i.layers[e.fqid] = i.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, i.layers[e.fqid].targets.push({
                        filter: s
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e.z(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e.z(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        n(i);
                    }
                } else for(const e in this._layers)n(this._layers[e]);
                const a = this._queryRenderedFeatures(t1, r, o), l = this._flattenAndSortRenderedFeatures(a), c = [];
                for (const t1 of l)e.dd(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Se, "queryRenderedFeatures.filter", i.filter, null, i), s = e.b3(i.filter));
                const r = "mock", n = [];
                if (i && i.target) n.push(Object.assign({}, i, {
                    targetId: r,
                    filter: s
                }));
                else {
                    const e = this.getFeaturesetDescriptors();
                    for (const t1 of e)n.push({
                        targetId: r,
                        filter: s,
                        target: t1
                    });
                    for (const { style: e } of this.fragments){
                        const t1 = e.getFeaturesetDescriptors();
                        for (const e of t1)n.push({
                            targetId: r,
                            filter: s,
                            target: e
                        });
                    }
                }
                const a = this.queryRenderedTargets(t1, n, o), l = [], c = new Set;
                for (const t1 of a)for (const i of t1.variants[r])lt(i, t1, c) || l.push(new e.de(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, o) {
                const s = {}, r = (e, t1, i, o)=>{
                    const r = s[t1.id] = s[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (r.layers[e.fqid] = r.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, e.is3D(!!this.terrain) && (r.has3DLayers = !0), !o) return i.uniqueFeatureID = !1, void r.layers[e.fqid].targets.push(i);
                    r.layers[e.fqid].targets.push(Object.assign({}, i, {
                        namespace: o.namespace,
                        properties: o.properties,
                        uniqueFeatureID: o.uniqueFeatureID
                    }));
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: o } = t1.target, s = this.getFragmentStyle(o);
                    if (!s || !s._featuresetSelectors) continue;
                    const n = s._featuresetSelectors[i];
                    if (!n) {
                        this.fire(new e.z(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e of n){
                        const i = s.getOwnLayer(e.layerId);
                        i && !bo.has(i.type) && r(i, s.getOwnLayerSourceCache(i), t1, e);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e } = t1.target, i = this.getLayer(e);
                    if (!i || bo.has(i.type)) continue;
                    r(i, this.getLayerSourceCache(i), t1);
                }
                const n = this._queryRenderedFeatures(t1, s, o);
                return this._flattenAndSortRenderedFeatures(n);
            }
            _queryRenderedFeatures(e, t1, i) {
                const o = [], s = !!this.map._showQueryGeometry, r = Xe.createFromScreenPoints(e, i);
                for(const e in t1){
                    const n = ct(r, t1[e], this._availableImages, i, s);
                    Object.keys(n).length && o.push(n);
                }
                if (this.placement) for(const e in t1){
                    if (!t1[e].sourceCache._onlySymbols) continue;
                    const i = ht(r.screenGeometry, t1[e], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                    Object.keys(i).length && o.push(i);
                }
                return o;
            }
            querySourceFeatures(e, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Se, "querySourceFeatures.filter", i, null, t1);
                let o = [];
                const s = this.getOwnSourceCaches(e);
                for (const e of s)o = o.concat(dt(e, t1));
                return o;
            }
            addSourceType(e, t1, i) {
                return Eo.getSourceType(e) ? i(new Error(`A source type called "${e}" already exists.`)) : (Eo.setSourceType(e, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, o = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let r = !1;
                for(const i in t1)if (!e.bv(t1[i], s[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const n = this._getTransitionParameters();
                this.light.setLight(t1, i, o), this.light.updateTransitions(n);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.q.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let o = t1;
                const s = null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("object" == typeof o.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, o.source), o = e.d6(o), o = e.h(o, {
                            source: t1
                        });
                    }
                    const t1 = e.h({}, o), i = {};
                    if (this.terrain && s) {
                        t1.source = this.terrain.get().source;
                        const e = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e && (i.style = e.serialize());
                    }
                    if (this._validate(xe, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !s || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!o) return;
                    this._createTerrain(o, i), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, s = i.get();
                    for (const t1 of Object.keys(e.a5.terrain))!o.hasOwnProperty(t1) && e.a5.terrain[t1].default && (o[t1] = e.a5.terrain[t1].default);
                    for(const o in t1)if (!e.bv(t1[o], s[o])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const o = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(o), this.fire(new e.A("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e) {
                const t1 = this.fog = new je(e, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e) {
                const t1 = this.snow = new He(e, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e) {
                const t1 = this.rain = new We(e, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e of this.map._markers)e._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), !t1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog;
                    if (!e.bv(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.fog = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createFog(t1);
                this._markersNeedUpdate = !0;
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e.bv(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e.bv(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e in this._layers)this._layers[e].lut = this._styleColorTheme.lut;
                    for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const o = this._evaluateColorThemeData(i);
                this._loadColorTheme(o).then(()=>{
                    this.fire(new e.A("colorthemeset")), t1();
                }).catch((t1)=>{
                    e.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e.q.now(),
                    transition: e.h(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e, t1) {
                const i = this.terrain = new ze(e, t1, this.scope, this.options, this.map.getWorldview());
                1 === t1 && (this.stylesheet.terrain = e), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const o = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, s, r = {}) {
                if (r && !1 === r.validate) return !1;
                const n = e.h({}, this.serialize());
                return vo(this, t1.call(me, e.h({
                    key: i,
                    style: n,
                    value: o,
                    styleSpec: e.a5
                }, s)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.df.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e in this._mergedLayers)this._mergedLayers[e].setEventedParent(null);
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles(), this._mergedSourceCaches[e].setEventedParent(null);
                this.imageManager.removeScope(this.scope), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.clearTiles();
            }
            clearSources() {
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles();
            }
            reloadSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.resume(), e.reload();
            }
            reloadSources() {
                for (const e of this.getSources())e.reload && e.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e)=>{
                    e.modelManager.reloadModels(e.scope);
                });
            }
            updateSources(e) {
                let t1;
                this.directionalLight && (t1 = no(this.directionalLight));
                const i = new Set;
                for(const e in this._mergedLayers){
                    const t1 = this._mergedLayers[e];
                    t1.hasElevation() && !i.has(t1.source) && i.add(t1.source);
                }
                for(const o in this._mergedSourceCaches){
                    const s = this._mergedSourceCaches[o], r = i.has(s._source.id);
                    s.update(e, void 0, void 0, t1, r);
                }
            }
            _generateCollisionBoxes() {
                for(const e in this._sourceCaches){
                    const t1 = this._sourceCaches[e];
                    t1.resume(), t1.reload();
                }
            }
            _updatePlacement(t1, i, o, s, r, n, a = !1) {
                let l = !1, c = !1;
                const h = {}, d = {};
                for (const t1 of this._mergedOrder){
                    const o = this._mergedLayers[t1];
                    if ("symbol" !== o.type) continue;
                    const s = e.C(o.source, o.scope);
                    let r = h[s];
                    if (!r) {
                        const e = this.getLayerSourceCache(o);
                        if (!e) continue;
                        const t1 = e.getRenderableIds(!0).map((t1)=>e.getTileByID(t1));
                        d[s] = t1.slice(), r = h[s] = t1.sort((e, t1)=>t1.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const n = this.crossTileSymbolIndex.addLayer(o, r, i.center.lng, i.projection);
                    l = l || n;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), a = a || this._layerOrderChanged || 0 === s, this._layerOrderChanged && this.fire(new e.A("neworder")), (a || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.q.now(), i.zoom)) && (this.pauseablePlacement = new Li(i, this._mergedOrder, a, o, s, r, this.placement, this.fog && i.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h, d, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.q.now()), c = !0), l && this.pauseablePlacement.placement.setStale()), c || l) {
                    this._buildingIndex.onNewFrame(i.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const i = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== i.type) continue;
                        const o = this.isLayerClipped(i);
                        this.placement.updateLayerOpacities(i, h[e.C(i.source, i.scope)], t1, o ? n : null);
                    }
                }
                return {
                    needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.q.now())
                };
            }
            _releaseSymbolFadeTiles() {
                for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== o.findIndex(({ id: e })=>e === t1.id)) return void this.fire(new e.z(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return o.push(t1), this._loadImports([
                    t1
                ], !0);
                const s = o.findIndex(({ id: e })=>e === i);
                return -1 === s && this.fire(new e.z(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = o.slice(0, s).concat(t1).concat(o.slice(s)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports || [], s = this.getImportIndex(t1);
                return -1 === s ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== o[s].url && this.setImportUrl(t1, i.url), e.bv(i.config, o[s].config) || this.setImportConfig(t1, i.config, i.data.schema), e.bv(i.data, o[s].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const o = this.getImportIndex(e);
                if (-1 === o) return this;
                const s = this.getImportIndex(t1);
                if (-1 === s) return this;
                const r = i[o], n = this.fragments[o];
                return i = i.filter(({ id: t1 })=>t1 !== e), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e), this.stylesheet.imports = i.slice(0, s).concat(r).concat(i.slice(s)), this.fragments = this.fragments.slice(0, s).concat(n).concat(this.fragments.slice(s)), this.mergeLayers(), this;
            }
            setImportUrl(e, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], o = this.getImportIndex(e);
                if (-1 === o) return this;
                i[o].url = t1;
                const s = this.fragments[o];
                return s.style = this._createFragmentStyle(i[o]), s.style.on("style.import.load", ()=>this.mergeAll()), s.style.loadURL(t1), this;
            }
            setImportData(e, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e), o = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e, o[i].url));
            }
            setImportConfig(e, t1, i) {
                this._checkLoaded();
                const o = this.getImportIndex(e), s = this.stylesheet.imports || [];
                if (-1 === o) return this;
                t1 ? s[o].config = t1 : delete s[o].config;
                const r = this.fragments[o];
                i && r.style.stylesheet && (r.style.stylesheet.schema = i);
                const n = r.style.stylesheet && r.style.stylesheet.schema;
                return r.config = t1, r.style.updateConfig(t1, n), this.updateConfigDependencies(), this;
            }
            removeImport(e) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e)=>e.id === t1);
                return -1 === i && this.fire(new e.z(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e) {
                return this._mergedLayers[e];
            }
            getSources() {
                const e = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e.push(i.getSource());
                }
                return e;
            }
            getSource(e, t1) {
                const i = this.getSourceCache(e, t1);
                return i && i.getSource();
            }
            getLayerSource(e) {
                const t1 = this.getLayerSourceCache(e);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const o = e.C(t1, i);
                return this._mergedOtherSourceCaches[o];
            }
            getLayerSourceCache(t1) {
                const i = e.C(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e) {
                if (null == e) return Object.values(this._mergedSourceCaches);
                const t1 = [];
                return this._mergedOtherSourceCaches[e] && t1.push(this._mergedOtherSourceCaches[e]), this._mergedSymbolSourceCaches[e] && t1.push(this._mergedSymbolSourceCaches[e]), t1;
            }
            updateSourceCaches() {
                const e = this._changes.getUpdatedSourceCaches();
                for(const t1 in e){
                    const i = e[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e);
                }
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e) {
                this.stylesheet.glyphs = e, this.glyphManager.setURL(e, this.scope);
            }
            getImages(t1, i, o) {
                this.imageManager.getImages(i.images, i.scope, o), this._updateTilesForChangedImages();
                const s = (t1)=>{
                    if (t1) {
                        const o = i.images.map((t1)=>e.I.toString(t1));
                        t1.setDependencies(i.tileID.key, i.type, o);
                    }
                }, r = e.C(i.source, i.scope);
                s(this._mergedOtherSourceCaches[r]), s(this._mergedSymbolSourceCaches[r]);
            }
            rasterizeImages(e, t1, i) {
                this.imageManager.rasterizeImages(t1, i);
            }
            getGlyphs(e, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, t1.scope, i);
            }
            getResource(t1, i, o) {
                return e.dg(i, o);
            }
            getOwnSourceCache(e) {
                return this._otherSourceCaches[e];
            }
            getOwnLayerSourceCache(e) {
                return "symbol" === e.type ? this._symbolSourceCaches[e.source] : this._otherSourceCaches[e.source];
            }
            getOwnSourceCaches(e) {
                const t1 = [];
                return this._otherSourceCaches[e] && t1.push(this._otherSourceCaches[e]), this._symbolSourceCaches[e] && t1.push(this._symbolSourceCaches[e]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e.z(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e)=>e.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e.type && "building" !== e.type) return !1;
                const i = "fill-extrusion" === e.type && "building" === e.sourceLayer, o = "building" === e.type;
                if (e.is3D(!!this.terrain)) {
                    if (i || o || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e.type) return !0;
                } else if ("symbol" === e.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.fragments.forEach((e)=>{
                    e.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        Eo.getSourceType = function(e) {
            return rt[e];
        }, Eo.setSourceType = function(e, t1) {
            rt[e] = t1;
        }, Eo.registerForPluginStateChange = e.dh;
        var So = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", Io = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", Co = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", Ro = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", Do = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", Ao = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", Lo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", Po = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", zo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", Mo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", Oo = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {highp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z*0.5+0.5-bias);return texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const Fo = [];
        Vo(So, Fo), Vo(Co, Fo), Vo(Io, Fo);
        const Bo = {
            "_prelude_fog.vertex.glsl": Ao,
            "_prelude_terrain.vertex.glsl": Do,
            "_prelude_shadow.vertex.glsl": Mo,
            "_prelude_fog.fragment.glsl": Lo,
            "_prelude_shadow.fragment.glsl": Oo,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
            "_prelude_raster_array.glsl": Po,
            "_prelude_raster_particle.glsl": zo
        }, ko = {};
        Go("", Do), Go(Lo, Ao), Go(Oo, Mo), Go(Po, ""), Go(zo, "");
        const No = Go(Io, Co), Uo = So;
        var jo = {
            background: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            building: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in highp vec3 v_normal;in highp float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\nuniform lowp float u_opacity;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 apply_lighting_linear(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec4 color=vec4(v_color.rgb,1.0);vec3 normal=normalize(v_normal);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nshadowed_lighting_factor=dot(normal,u_lighting_directional_dir);\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=mix(color.rgb,v_color.rgb,v_color.a);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_height));\n#endif\ncolor.rgb=linearTosRGB(color.rgb);color*=u_opacity;\n#ifdef RENDER_CUTOFF\ncolor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_height);\n#endif\nglFragColor=color; \n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;in vec3 a_normal_3f;out vec4 v_color;out highp vec3 v_normal;out highp float v_height;uniform mat4 u_matrix;uniform mat4 u_normal_matrix;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define-attribute-vertex-shader-only highp vec2 part_color_emissive\nvoid main() {\n#pragma mapbox: initialize-attribute-custom highp vec2 part_color_emissive\nvec4 color_emissive=decode_color(part_color_emissive);v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);v_normal=vec3(u_normal_matrix*vec4(a_normal_3f,0.0));vec3 pos=a_pos_3f;v_height=pos.z;gl_Position=u_matrix*vec4(pos,1.0);\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);v_depth_shadows=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            buildingDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;void main() {gl_Position=u_matrix*vec4(a_pos_3f,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
            circle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: Go("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: Go('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: Go("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: Go("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: Go("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: Go("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            elevatedStructuresDepth: Go("void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=vec4(0.);\n#endif\n}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"),
            elevatedStructuresDepthReconstruct: Go("#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}"),
            elevatedStructures: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat shadowed_lighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb=apply_lighting(color.rgb,transformed_normal,shadowed_lighting_factor);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_height);\n#endif\nglFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;in float a_height;in vec3 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=a_pos_normal_3/16384.0;v_height=a_height;vec3 pos=vec3(a_pos,a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fill: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=opacity;\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'),
            fillOutline: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,h);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillExtrusionDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: Go('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: Go("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: Go("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)\nin vec3 a_z_offset_width;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);halfwidth=(u_width_scale*(left==1.0 ? a_z_offset_width.y : a_z_offset_width.z))/2.0;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\noffset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float line_progress=a_packed[2];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            linePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nuniform float u_emissive_strength;\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec3 a_z_offset_width;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            raster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            rasterParticle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: Go("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: Go("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: Go('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"),
            symbol: Go('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\n#endif\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\n#endif\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);    \n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n#endif\n#endif\n}'),
            terrainRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: Go("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: Go('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Ro),
            skyboxGradient: Go('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Ro),
            skyboxCapture: Go("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: Go('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: Go("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            snowParticle: Go("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: Go("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: Go("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            occlusion: Go("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function Vo(e, t1) {
            const i = e.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e of i)if (e = e.trim(), "#" === e[0] && e.includes("if") && !e.includes("endif")) {
                e = e.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e.split(" ");
                for (const e of i)t1.includes(e) || t1.push(e);
            }
        }
        function Go(e, t1) {
            const i = /#include\s+"([^"]+)"/g, o = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let s = t1.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            s && (s = s.map((e)=>{
                const t1 = e.split(" ");
                return t1[t1.length - 1];
            }), s = [
                ...new Set(s)
            ]);
            const r = {}, n = [], a = [];
            if (e = e.replace(i, (e, t1)=>(a.push(t1), "")), (t1 = t1.replace(i, (e, t1)=>(n.push(t1), ""))).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
            let l = [
                ...Fo
            ];
            Vo(e, l), Vo(t1, l);
            for (const e of [
                ...n,
                ...a
            ])Bo[e] || console.error(`Undefined include: ${e}`), ko[e] || (ko[e] = [], Vo(Bo[e], ko[e])), l = [
                ...l,
                ...ko[e]
            ];
            return {
                fragmentSource: e = e.replace(o, (e, t1, i, o, s)=>(r[s] = !0, "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nin ${i} ${o} ${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    in ${i} ${o} ${s};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(o, (e, t1, i, o, s)=>{
                    const n = "float" === o ? "vec2" : o, a = s.match(/color/) ? "color" : n;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\nin ${i} ${o} a_${s};\n#endif\n` : r[s] ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nin ${i} ${n} a_${s};\nout ${i} ${o} ${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize" === t1 ? "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = a_${s};\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = unpack_mix_${a}(a_${s}, u_${s}_t);\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    in ${i} ${o} a_${s};\n    out ${i} ${o} ${s};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    ${s} = a_${s};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nin ${i} ${n} a_${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "define-instanced" === t1 ? "mat4" === a ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${s}0;\nin vec4 a_${s}1;\nin vec4 a_${s}2;\nin vec4 a_${s}3;\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${i} ${n} a_${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    ${i} ${o} ${s} = a_${s};\n#endif\n` : "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = a_${s};\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = unpack_mix_${a}(a_${s}, u_${s}_t);\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n`;
                }),
                staticAttributes: s,
                usedDefines: l,
                vertexIncludes: n,
                fragmentIncludes: a
            };
        }
        class qo {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e, t1, i, o, s, r, n, a) {
                this.context = e;
                let l = this.boundPaintVertexBuffers.length !== o.length;
                for(let e = 0; !l && e < o.length; e++)this.boundPaintVertexBuffers[e] !== o[e] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== n.length;
                for(let e = 0; !c && e < n.length; e++)this.boundDynamicVertexBuffers[e] !== n[e] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== s || this.boundVertexOffset !== r) this.freshBind(t1, i, o, s, r, n, a);
                else {
                    e.bindVertexArrayOES.set(this.vao);
                    for (const i of n)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e.gl, t1, a));
                    s && s.dynamicDraw && s.bind();
                }
            }
            freshBind(e, t1, i, o, s, r, n) {
                const a = e.numAttributes, l = this.context, c = l.gl;
                this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = s, this.boundDynamicVertexBuffers = r, t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s);
                for (const t1 of i)t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s);
                for (const t1 of r)t1 && (t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s), n && t1.instanceCount && t1.setVertexAttribDivisor(c, e, n));
                o && o.bind(), l.currentNumAttributes = a;
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function Zo(t1, i) {
            const o = Math.pow(2, i.canonical.z), s = i.canonical.y;
            return [
                new e.ac(0, s / o).toLngLat().lat,
                new e.ac(0, (s + 1) / o).toLngLat().lat
            ];
        }
        function Ho(t1, i, o, s, r, n, a) {
            const l = t1.context, c = l.gl, h = o.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const d = t1.isTileAffectedByFog(i), u = t1.getOrCreateProgram("hillshade", {
                overrideFog: d
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
            const _ = ((t1, i, o, s)=>{
                const r = o.paint.get("hillshade-shadow-color"), n = "none" === o.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a = o.paint.get("hillshade-highlight-color"), l = "none" === o.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = o.paint.get("hillshade-accent-color"), h = "none" === o.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d = o.paint.get("hillshade-emissive-strength");
                let u = e.al(o.paint.get("hillshade-illumination-direction"));
                if ("viewport" === o.paint.get("hillshade-illumination-anchor")) u -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), o = e.cR(i.x, i.y, i.z);
                    u = e.al(o[1]);
                }
                const _ = !t1.options.moving;
                return {
                    u_matrix: s || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), _),
                    u_image: 0,
                    u_latrange: Zo(0, i.tileID),
                    u_light: [
                        o.paint.get("hillshade-exaggeration"),
                        u
                    ],
                    u_shadow: r.toPremultipliedRenderColor(n ? null : o.lut),
                    u_highlight: a.toPremultipliedRenderColor(l ? null : o.lut),
                    u_emissive_strength: d,
                    u_accent: c.toPremultipliedRenderColor(h ? null : o.lut)
                };
            })(t1, o, s, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, u, i.toUnwrapped());
            const { tileBoundsBuffer: p, tileBoundsIndexBuffer: f, tileBoundsSegments: m } = t1.getTileBoundsBuffers(o);
            u.draw(t1, c.TRIANGLES, r, n, a, qi.disabled, _, s.id, p, f, m);
        }
        function Wo(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const s = t1.context, r = s.gl;
            s.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const n = o.getPixels();
            i.demTexture ? i.demTexture.update(n, {
                premultiply: !1
            }) : i.demTexture = new e.T(s, n, r.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function $o(t1, i, o) {
            const s = t1.context, r = s.gl;
            if (!i.dem) return;
            const n = i.dem;
            if (s.activeTexture.set(r.TEXTURE1), Wo(t1, i, n), !i.demTexture) return;
            i.demTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE);
            const a = n.dim;
            s.activeTexture.set(r.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e.T(s, {
                    width: a,
                    height: a,
                    data: null
                }, r.RGBA8);
                t1.bind(r.LINEAR, r.CLAMP_TO_EDGE), l = i.hillshadeFBO = s.createFramebuffer(a, a, !0, "renderbuffer"), l.colorAttachment.set(t1.texture);
            }
            s.bindFramebuffer.set(l.framebuffer), s.viewport.set([
                0,
                0,
                a,
                a
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: d } = t1.getMercatorTileBoundsBuffers(), u = [];
            t1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(t1, r.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.disabled, ((t1, i)=>{
                const o = i.stride, s = e.bz();
                return e.c5(s, 0, e.aj, -8192, 0, 0, 1), e.bo(s, s, [
                    0,
                    -8192,
                    0
                ]), {
                    u_matrix: s,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, n), o.id, c, h, d), i.needsHillshadePrepare = !1;
        }
        class Xo {
            constructor(e){
                this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Yo extends Xo {
            getDefault() {
                return e.am.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class Ko extends Xo {
            getDefault() {
                return 1;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
            }
        }
        class Jo extends Xo {
            getDefault() {
                return 0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
            }
        }
        class Qo extends Xo {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class es extends Xo {
            getDefault() {
                return !0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
            }
        }
        class ts extends Xo {
            getDefault() {
                return 255;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
            }
        }
        class is extends Xo {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e) {
                const t1 = this.current;
                (e.func !== t1.func || e.ref !== t1.ref || e.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
            }
        }
        class os extends Xo {
            getDefault() {
                const e = this.gl;
                return [
                    e.KEEP,
                    e.KEEP,
                    e.KEEP
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
            }
        }
        class ss extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e, this.dirty = !1;
            }
        }
        class rs extends Xo {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class ns extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e, this.dirty = !1;
            }
        }
        class as extends Xo {
            getDefault() {
                return this.gl.LESS;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
            }
        }
        class ls extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e, this.dirty = !1;
            }
        }
        class cs extends Xo {
            getDefault() {
                const e = this.gl;
                return [
                    e.ONE,
                    e.ZERO,
                    e.ONE,
                    e.ZERO
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class hs extends Xo {
            getDefault() {
                return e.am.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class ds extends Xo {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e, e), this.current = e, this.dirty = !1);
            }
        }
        class us extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e, this.dirty = !1;
            }
        }
        class _s extends Xo {
            getDefault() {
                return this.gl.BACK;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
            }
        }
        class ps extends Xo {
            getDefault() {
                return this.gl.CCW;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
            }
        }
        let fs = class extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
            }
        };
        class ms extends Xo {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
            }
        }
        class gs extends Xo {
            getDefault() {
                const e = this.gl;
                return [
                    0,
                    0,
                    e.drawingBufferWidth,
                    e.drawingBufferHeight
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class vs extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ys extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class xs extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e), this.current = e, this.dirty = !1;
            }
        }
        class bs extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ws extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Ts extends Xo {
            getDefault() {
                return null;
            }
            set(e) {
                this.gl && (e !== this.current || this.dirty) && (this.gl.bindVertexArray(e), this.current = e, this.dirty = !1);
            }
        }
        class Es extends Xo {
            getDefault() {
                return 4;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
            }
        }
        class Ss extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Is extends Xo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Cs extends Xo {
            constructor(e, t1){
                super(e), this.context = e, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class Rs extends Cs {
            setDirty() {
                this.dirty = !0;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Ds extends Cs {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class As extends Cs {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Ls extends Ds {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const Ps = (e, t1, i)=>({
                u_matrix: e,
                u_image0: 0,
                u_skirt_height: t1,
                u_ground_shadow_factor: i
            }), zs = (e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f)=>({
                u_proj_matrix: Float32Array.from(e),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: s,
                u_merc_center: r,
                u_image0: 0,
                u_frustum_tl: n,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: d,
                u_viewport: u,
                u_grid_matrix: f ? Float32Array.from(f) : new Float32Array(9),
                u_skirt_height: _,
                u_far_z_cutoff: p
            });
        function Ms(e, t1) {
            return null != e && null != t1 && !(!e.hasData() || !t1.hasData()) && null != e.demTexture && null != t1.demTexture && e.tileID.key !== t1.tileID.key;
        }
        const Os = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e, t1, i, o, s) {
                if (e in this.operations) {
                    const t1 = this.operations[e];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e] = {
                    startTime: o,
                    phase: 0,
                    duration: s,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e) {
                if (!(e in this.operations)) return null;
                const t1 = this.operations[e];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e, t1) {
                return !!e.queued && (e.from = e.to, e.to = e.queued, e.queued = null, e.phase = 0, e.startTime = t1, !0);
            }
            _validOp(e) {
                return e.from.hasData() && e.to.hasData();
            }
        }, Fs = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function Bs(e, t1, i) {
            if (0 === t1) return 0;
            const o = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e) * Math.max(t1, 1) * o;
        }
        function ks(e, t1) {
            const i = 1 << e.z;
            return !t1 && (0 === e.x || e.x === i - 1) || 0 === e.y || e.y === i - 1;
        }
        const Ns = (e)=>({
                u_matrix: e
            });
        function Us(t1, i, o, s, r) {
            if (r > 0) {
                const n = e.q.now(), a = (n - t1.timeAdded) / r, l = i ? (n - i.timeAdded) / r : -1, c = o.getSource(), h = s.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), u = d && t1.refreshedUponExpiration ? 1 : e.ay(d ? a : 1 - l, 0, 1);
                return t1.refreshedUponExpiration && a >= 1 && (t1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - u
                } : {
                    opacity: u,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class js extends It {
            constructor(t1){
                const i = {
                    type: "raster-dem",
                    maxzoom: t1.transform.maxZoom
                }, o = new e.D(e.c$(), null), s = nt("mock-dem", i, o, t1.style);
                super("mock-dem", s, !1), s.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e, t1) {
                e.state = "loaded", t1(null);
            }
        }
        class Vs extends It {
            constructor(t1){
                const i = nt("proxy", {
                    type: "geojson",
                    maxzoom: t1.transform.maxZoom
                }, new e.D(e.c$(), null), t1.style);
                super("proxy", i, !1), i.setEventedParent(this), this.map = this.getSource().map = t1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e, t1, i) {
                if (e.freezeTileCoverage) return;
                this.transform = e;
                const o = e.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t1, i)=>{
                    if (t1[i.key] = "", !this._tiles[i.key]) {
                        const t1 = new wt(i, this._source.tileSize * i.overscaleFactor(), e.tileZoom, void 0, void 0, this._source.worldview);
                        t1.state = "loaded", this._tiles[i.key] = t1;
                    }
                    return t1;
                }, {});
                for(const e in this._tiles)e in o || (this.freeFBO(e), this._tiles[e].unloadVectorData(), delete this._tiles[e]);
            }
            freeFBO(e) {
                const t1 = this.proxyCachedFBO[e];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e)=>e.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Gs extends e.aM {
            constructor(e, t1, i){
                super(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class qs extends e.dt {
            constructor(t1, i){
                super(), this._debugParams = {
                    sortTilesHiZFirst: !0,
                    disableRenderCache: !1
                }, t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "sortTilesHiZFirst", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "disableRenderCache", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerButton([
                    "Terrain"
                ], "Invalidate Render Cache", ()=>{
                    this.invalidateRenderCache = !0, this._style.map.triggerRepaint();
                }), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, s, r] = function(t1) {
                    const i = new e.ba, o = new e.a_, s = 131;
                    i.reserve(17161), o.reserve(33800);
                    const r = e.aj / 128, n = e.aj + r / 2, a = n + r;
                    for(let t1 = -64; t1 < a; t1 += r)for(let o = -64; o < a; o += r){
                        const s = o < 0 || o > n || t1 < 0 || t1 > n ? 24575 : 0, r = e.ay(Math.round(o), 0, e.aj), a = e.ay(Math.round(t1), 0, e.aj);
                        i.emplaceBack(r + s, a);
                    }
                    const l = (e, t1)=>{
                        const i = t1 * s + e;
                        o.emplaceBack(i + 1, i, i + s), o.emplaceBack(i + s, i + s + 1, i + 1);
                    };
                    for(let e = 1; e < 129; e++)for(let t1 = 1; t1 < 129; t1++)l(t1, e);
                    return [
                        0,
                        129
                    ].forEach((e)=>{
                        for(let t1 = 0; t1 < 130; t1++)l(t1, e), l(e, t1);
                    }), [
                        i,
                        o,
                        32768
                    ];
                }(), n = t1.context;
                this.gridBuffer = n.createVertexBuffer(o, e.bc.members), this.gridIndexBuffer = n.createIndexBuffer(s), this.gridSegments = e.bd.simpleSegment(0, 0, o.length, s.length), this.gridNoSkirtSegments = e.bd.simpleSegment(0, 0, o.length, r), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Vs(i.map), this.orthoMatrix = e.bz(), e.c5(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e.aj, 0, e.aj, 0, 1);
                const a = n.gl;
                this._overlapStencilMode = new ji({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new js(i.map), this._pendingGroundEffectLayers = [];
            }
            set style(e) {
                e.on("data", this._onStyleDataEvent.bind(this)), this._style = e, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const s = t1.terrain.properties, r = 0 === t1.terrain.drapeRenderMode, n = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.q.now();
                    const a = t1.terrain && t1.terrain.scope, l = s.get("source"), c = r ? this._mockSourceCache : t1.getSourceCache(l, a);
                    if (!c) return void e.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = n ? this.calculateExaggeration(i) : s.get("exaggeration"), !i.projection.requiresDraping && n && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, o = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = o;
                const s = null != i ? o - i : Number.MAX_VALUE;
                if (Math.abs(s) < 2) return this._exaggeration;
                const r = t1.zoom, n = this._style.terrain;
                if (!this._previousUpdateTimestamp) return n.getExaggeration(r);
                let a = r - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = r;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(r - c) > .5 && (a = .5 * (r - c + a)), a * s < 0 && (c += a)), this._evaluationZoom = c;
                const h = n.getExaggeration(c), d = h === n.getExaggeration(Math.max(0, c - .1));
                if (d && Math.abs(h - this._exaggeration) < .01) return h;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (d || h < .1 || Math.abs(a) < 1e-4) && (u = Math.min(.2, 4 * u)), e.ai(this._exaggeration, h, u);
            }
            resetTileLookupCache(e) {
                this._findCoveringTileCache[e] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e) {
                e.coord && "source" === e.dataType ? this._clearRenderCacheForTile(e.sourceCacheId, e.coord) : "style" === e.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e)=>e.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e,
                    e
                ];
            }
            set useVertexMorphing(e) {
                this._useVertexMorphing = e;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e.ac.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const s = this.proxyCoords = i.getIds().map((e)=>{
                    const t1 = i.getTileByID(e).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), s = new e.P(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), r = new e.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), n = s.mult(1 << t1.canonical.z);
                        return n.x -= .5, n.y -= .5, n.distSqr(o) - n.distSqr(r);
                    });
                }(s, this.painter);
                const r = this.proxyToSource || {};
                this.proxyToSource = {}, s.forEach((e)=>{
                    this.proxyToSource[e.key] = {};
                }), this.terrainTileForTile = {};
                const n = this._style._mergedSourceCaches;
                for(const e in n){
                    const i = n[e];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e], r), i.usedForTerrain) continue;
                    const o = t1[e];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = s.map((e)=>new Gs(e, e.key, this.orthoMatrix)), this._assignTerrainTiles(s), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(r), this.renderingToTexture = !1;
                const a = {};
                this._visibleDemTiles = [];
                for (const e of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e) {
                this._initializing || e.forEach((e)=>{
                    if (this.terrainTileForTile[e.key]) return;
                    const t1 = this._findTileCoveringTileID(e, this.sourceCache);
                    t1 && (this.terrainTileForTile[e.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e = this.painter.context, t1 = e.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], s = o.dem;
                    !s || o.demTexture && !o.needsDEMTextureUpload || (e.activeTexture.set(t1.TEXTURE1), Wo(this.painter, o, s));
                }
            }
            _prepareDemTileUniforms(e, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const s = e.tileID.canonical, r = Math.pow(2, t1.tileID.canonical.z - s.z), n = o || "";
                return i[`u_dem_tl${n}`] = [
                    s.x * r % 1,
                    s.y * r % 1
                ], i[`u_dem_scale${n}`] = r, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e++, t1 + o;
                }, 0);
                return e ? t1 / e : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), s = new e.du({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    o
                ]));
                this._emptyDEMTextureDirty = !1;
                let r = this._emptyDEMTexture;
                return r ? r.update(s, {
                    premultiply: !1
                }) : r = this._emptyDEMTexture = new e.T(t1, s, i.R32F, {
                    premultiply: !1
                }), r;
            }
            setupElevationDraw(t1, i, o) {
                const s = this.painter.context, r = s.gl, n = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                n.u_exaggeration = this.exaggeration();
                let a = null, l = null, c = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    c = o.morphing.phase, e && i && (this._prepareDemTileUniforms(t1, e, n, "_prev") && (l = e), this._prepareDemTileUniforms(t1, i, n) && (a = i));
                }
                const h = (e)=>e && e.demTexture && this.painter.linearFloatFilteringSupported() ? r.LINEAR : r.NEAREST;
                let d = null;
                var u;
                if (this.enabled ? l && a ? (d = a.demTexture, s.activeTexture.set(r.TEXTURE4), l.demTexture.bind(h(l), r.CLAMP_TO_EDGE), n.u_dem_lerp = c) : (a = this.terrainTileForTile[t1.tileID.key], d = this._prepareDemTileUniforms(t1, a, n) ? a.demTexture : this.emptyDEMTexture) : d = this.emptyDEMTexture, s.activeTexture.set(r.TEXTURE2), d && (n.u_dem_size = 1 === (u = d).size[0] ? 1 : u.size[0] - 2, d.bind(h(a), r.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, n), o && o.useMeterToDem && a) {
                    const t1 = (1 << a.tileID.canonical.z) * e.c6(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    n.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (n.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(s, n), "globe" === this.painter.transform.projection.name) {
                    const e = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(s, e);
                }
            }
            globeUniformValues(t1, i, o) {
                const s = t1.projection;
                return {
                    u_tile_tl_up: s.upVector(i, 0, 0),
                    u_tile_tr_up: s.upVector(i, e.aj, 0),
                    u_tile_br_up: s.upVector(i, e.aj, e.aj),
                    u_tile_bl_up: s.upVector(i, 0, e.aj),
                    u_tile_up_scale: o ? e.dv(1) : s.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, s, r) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, s, r) {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.transform, d = e.dl(t1, n, h), u = (e, i)=>{
                            if (c === i) return;
                            const o = [
                                Fs[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && o.push("CUSTOM_ANTIALIASING");
                            const s = t1.isTileAffectedByFog(e);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: o,
                                overrideFog: s
                            }), c = i;
                        }, _ = t1.colorModeForRenderPass(), p = new Ni(a.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D);
                        Os.update(r);
                        const f = e.dm(h), m = [
                            e.aD(h.center.lng),
                            e.aH(h.center.lat)
                        ], g = t1.globeSharedBuffers, v = [
                            h.width * e.q.devicePixelRatio,
                            h.height * e.q.devicePixelRatio
                        ], y = Float32Array.from(h.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, d = Bs(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const b = a.TRIANGLES;
                            for (const c of s){
                                const s = o.getTile(c), w = ji.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                Ms(T, E) && Os.newMorphing(c.key, T, E, r, 250), n.activeTexture.set(a.TEXTURE0), s.texture && s.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const S = Os.getMorphValuesForProxy(c.key), I = S ? 1 : 0;
                                S && e.L(x, {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e.dk(S.phase)
                                    }
                                });
                                const C = e.dn(c.canonical), R = e.dp(C.getCenter().lat), D = e.dq(c.canonical, C, R, h.worldSize / h._pixelsPerMercatorPixel), A = e.bh(e.dr(c.canonical)), L = zs(h.expandedFarZProjMatrix, y, f, A, e.ah(h.zoom), m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, d, h._farZ, D);
                                if (u(c, I), l && (i.setupElevationDraw(s, l, x), t1.uploadCommonUniforms(n, l, c.toUnwrapped()), g)) {
                                    const [e, i, o] = g.getGridBuffers(R, 0 !== d);
                                    l.draw(t1, b, p, w, _, qi.backCCW, L, "globe_raster", e, i, o);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const r = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && r.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: r
                            });
                            for (const r of s){
                                const { x: s, y: c, z: d } = r.canonical, u = 0 === c, f = c === (1 << d) - 1, [y, b, w, T] = g.getPoleBuffers(d, !1);
                                if (T && (u || f)) {
                                    const c = o.getTile(r);
                                    n.activeTexture.set(a.TEXTURE0), c.texture && c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let g = e.ds(d, s, h);
                                    const E = e.bh(e.dr(r.canonical)), S = (e, i)=>e.draw(t1, a.TRIANGLES, p, ji.disabled, _, qi.disabled, zs(h.expandedFarZProjMatrix, g, g, E, 0, m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ), "globe_pole_raster", i, w, T);
                                    i.setupElevationDraw(c, l, x), t1.uploadCommonUniforms(n, l, r.toUnwrapped()), u && t1.renderDefaultNorthPole && S(l, y), f && t1.renderDefaultSouthPole && (g = e.cE(e.bz(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), S(l, b));
                                }
                            }
                        }
                    }(t1, i, o, s, r);
                    else {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.shadowRenderer, d = eo(t1, t1.longestCutoffRange), u = (e)=>{
                            if (c === e) return;
                            const i = [];
                            i.push(Fs[e]), d.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e;
                        }, _ = t1.colorModeForRenderPass(), p = new Ni(a.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D);
                        Os.update(r);
                        const f = t1.transform, m = Bs(f.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (g = ao(t1.style, e, i));
                        }
                        {
                            c = -1;
                            const v = a.TRIANGLES, [y, x] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of s){
                                const s = o.getTile(c), b = ji.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                Ms(w, T) && Os.newMorphing(c.key, w, T, r, 250), n.activeTexture.set(a.TEXTURE0), s.texture && s.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const E = Os.getMorphValuesForProxy(c.key), S = E ? 1 : 0;
                                let I;
                                E && (I = {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: e.dk(E.phase)
                                    }
                                });
                                const C = Ps(c.projMatrix, ks(c.canonical, f.renderWorldCopies) ? m / 10 : m, g);
                                if (u(S), !l) continue;
                                i.setupElevationDraw(s, l, I);
                                const R = c.toUnwrapped();
                                h && h.setupShadows(R, l), t1.uploadCommonUniforms(n, l, R, null, d), l.draw(t1, v, p, b, _, qi.backCCW, C, "terrain_raster", i.gridBuffer, y, x);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, s = this.proxySourceCache, r = this.proxiedCoords[s.id], n = this._drapedRenderBatches.shift(), a = i.style.order, l = [];
                let c = 0;
                for (const h of r){
                    const r = s.getTileByID(h.proxyTileKey), d = s.proxyCachedFBO[h.key] ? s.proxyCachedFBO[h.key][t1] : void 0, u = void 0 !== d ? s.renderCache[d] : this.pool[c++], _ = void 0 !== d;
                    if (r.texture = u.tex, _ && !u.dirty) {
                        l.push(r.tileID);
                        continue;
                    }
                    let p;
                    o.bindFramebuffer.set(u.fb.framebuffer), this.renderedToTile = !1, u.dirty && (o.clear({
                        color: e.am.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e = n.start; e <= n.end; ++e){
                        const t1 = i.style._mergedLayers[a[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const n = r;
                        o.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (s ? s.id : null) && (this._setupStencil(u, r, t1, s), p = s ? s.id : null), i.renderLayer(i, s, t1, n);
                    }
                    if (0 === this._drapedRenderBatches.length) for (const e of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[a[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const n = r;
                        o.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (s ? s.id : null) && (this._setupStencil(u, r, t1, s), p = s ? s.id : null), i.renderLayer(i, s, t1, n);
                    }
                    this.renderedToTile ? (u.dirty = !0, l.push(r.tileID)) : _ || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), n.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e) {
                const t1 = e.order.length;
                let i = -1, o = t1;
                for(let s = 0; s < t1; ++s)this._style.isLayerDraped(e._mergedLayers[e.order[s]]) ? i = Math.max(i, s) : o = Math.min(o, s);
                return o > i;
            }
            getMinElevationBelowMSL() {
                let e = 0;
                return this._visibleDemTiles.filter((e)=>e.dem).forEach((t1)=>{
                    e = Math.min(e, t1.dem.tree.minimums[0]);
                }), 0 === e ? e : (e - 30) * this._exaggeration;
            }
            raycast(e, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e)=>e.dem).map((o)=>{
                    const s = o.tileID, r = 1 << s.overscaledZ, { x: n, y: a } = s.canonical, l = n / r, c = (n + 1) / r, h = a / r, d = (a + 1) / r;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: d,
                        t: o.dem.tree.raycastRoot(l, h, c, d, e, t1, i),
                        tile: o
                    };
                });
                o.sort((e, t1)=>(null !== e.t ? e.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const s of o){
                    if (null == s.t) return null;
                    const o = s.tile.dem.tree.raycast(s.minx, s.miny, s.maxx, s.maxy, e, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const s = new e.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA8);
                s.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const r = t1.createFramebuffer(o[0], o[1], !0, null);
                return r.colorAttachment.set(s.texture), r.depthAttachment = new Ls(t1, r.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, r.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : r.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: r,
                    tex: s,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._debugParams.disableRenderCache) return !0;
                if (this._style.hasLightTransitions()) return !0;
                for(const e in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e].hasTransition()) return !0;
                return this._style.order.some((e)=>{
                    const t1 = this._style._mergedLayers[e], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e of this._style.getSources())if (e instanceof it) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._mergedLayers[this._style.order[t1]], s = this._style.getLayerSourceCache(o);
                    if (s && !i[s.id] && !o.isHidden(this.painter.transform.zoom) && "line" === o.type && o.widthExpression() instanceof e.ab) {
                        i[s.id] = !0;
                        for (const e of this.proxyCoords){
                            const t1 = this.proxyToSource[e.key][s.id];
                            if (t1) for (const e of t1)this._clearRenderCacheForTile(s.id, e);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof ot) {
                    e = !0;
                    break;
                }
                if (!e) return;
                const t1 = {};
                for(let e = 0; e < this._style.order.length; ++e){
                    const i = this._style._mergedLayers[this._style.order[e]], o = this._style.getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const s = i.paint.get("raster-fade-duration");
                    for (const e of this.proxyCoords){
                        const t1 = this.proxyToSource[e.key][o.id];
                        if (t1) for (const e of t1){
                            const t1 = Us(o.getTile(e), o.findLoadedParent(e, 0), o, this.painter.transform, s);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const o = [];
                this._pendingGroundEffectLayers = [];
                let s, r = 0, n = this._style._mergedLayers[t1[r]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++r < i;)n = this._style._mergedLayers[t1[r]];
                for(; r < i; ++r){
                    const e = this._style._mergedLayers[t1[r]];
                    e.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e) ? void 0 === s && (s = r) : ("fill-extrusion" === e.type && this._pendingGroundEffectLayers.push(r), void 0 !== s && (o.push({
                        start: s,
                        end: r - 1
                    }), s = void 0)));
                }
                if (void 0 !== s && o.push({
                    start: s,
                    end: r - 1
                }), 0 !== o.length) {
                    const t1 = o[o.length - 1];
                    this._pendingGroundEffectLayers.every((e)=>e > t1.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = o;
            }
            _setupRenderCache(e) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e.length; ++i){
                            const o = Object.values(e[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let s = i.length - 1; s >= 0; s--){
                    const r = i[s];
                    if (t1.getTileByID(r.key), void 0 !== t1.proxyCachedFBO[r.key]) {
                        const i = e[r.key], s = this.proxyToSource[r.key];
                        let n = 0;
                        for(const e in s){
                            const t1 = s[e], r = i[e];
                            if (!r || r.length !== t1.length || t1.some((t1, i)=>t1 !== r[i] || o[e] && o[e].hasOwnProperty(t1.key))) {
                                n = -1;
                                break;
                            }
                            ++n;
                        }
                        for(const e in t1.proxyCachedFBO[r.key])t1.renderCache[t1.proxyCachedFBO[r.key][e]].dirty = n < 0 || n !== Object.values(i).length;
                    }
                }
                const s = [
                    ...this._drapedRenderBatches
                ];
                s.sort((e, t1)=>t1.end - t1.start - (e.end - e.start));
                for (const e of s)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const s = this.painter.context, r = s.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let n;
                if (i.isTileClipped()) n = t1.length, this._overlapStencilMode.test = {
                    func: r.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    n = 1, this._overlapStencilMode.test = {
                        func: r.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + n > 255 && (s.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += n, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e.key]), this._overlapStencilMode) : ji.disabled;
            }
            _renderTileClippingMasks(e, t1) {
                const i = this.painter, o = this.painter.context, s = o.gl;
                i._tileClippingMaskIDs = {}, o.setColorMode(ki.disabled), o.setDepthMode(Ni.disabled);
                const r = i.getOrCreateProgram("clippingMask");
                for (const o of e){
                    const e = i._tileClippingMaskIDs[o.key] = --t1;
                    r.draw(i, s.TRIANGLES, Ni.disabled, new ji({
                        func: s.ALWAYS,
                        mask: 0
                    }, e, 255, s.KEEP, s.KEEP, s.REPLACE), ki.disabled, qi.disabled, Ns(o.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.aA(o, o, i.pixelMatrixInverse), e.cw(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const s = i._camera.position, r = e.c6(1, i.center.lat), n = [
                    s[0],
                    s[1],
                    s[2] / r,
                    0
                ], a = e.cX([], o.slice(0, 3), n);
                e.au(a, a);
                const l = this.raycast(n, a, this._exaggeration);
                return null !== l && l ? (e.bE(n, n, a, l), n[3] = n[2], n[2] *= r, n) : null;
            }
            _setupProxiedCoordsForOrtho(t1, i, o) {
                if (t1.getSource() instanceof e.aP) return this._setupProxiedCoordsForImageSource(t1, i, o);
                this._findCoveringTileCache[t1.id] = this._findCoveringTileCache[t1.id] || {};
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords;
                for(let e = 0; e < r.length; e++){
                    const i = r[e], n = this._findTileCoveringTileID(i, t1);
                    if (n) {
                        const e = this._createProxiedId(i, n, o[i.key] && o[i.key][t1.id]);
                        s.push(e), this.proxyToSource[i.key][t1.id] = [
                            e
                        ];
                    }
                }
                let n = !1;
                const a = new Set;
                for(let e = 0; e < i.length; e++){
                    const r = t1.getTile(i[e]);
                    if (!r || !r.hasData()) continue;
                    const l = this._findTileCoveringTileID(r.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== r.tileID.canonical.z) {
                        const e = this.proxyToSource[l.tileID.key][t1.id], i = this._createProxiedId(l.tileID, r, o[l.tileID.key] && o[l.tileID.key][t1.id]);
                        e ? e.splice(e.length - 1, 0, i) : this.proxyToSource[l.tileID.key][t1.id] = [
                            i
                        ];
                        const c = this.proxyToSource[l.tileID.key][t1.id];
                        a.has(c) || a.add(c), s.push(i), n = !0;
                    }
                }
                if (this._sourceTilesOverlap[t1.id] = n, n && this._debugParams.sortTilesHiZFirst) for (const e of a)e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords, n = t1.getSource(), a = n.tileID;
                if (!a) return;
                const l = new e.P(a.x, a.y)._div(1 << a.z), c = n.coordinates.map(e.ac.fromLngLat).reduce((e, t1)=>(e.min.x = Math.min(e.min.x, t1.x - l.x), e.min.y = Math.min(e.min.y, t1.y - l.y), e.max.x = Math.max(e.max.x, t1.x - l.x), e.max.y = Math.max(e.max.y, t1.y - l.y), e), {
                    min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), s = t1.canonical.y / (1 << t1.canonical.z), r = e.aj / (1 << t1.canonical.z), n = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return o + r < n + c.min.x || o > n + c.max.x || s + r < a + c.min.y || s > a + c.max.y;
                };
                for(let e = 0; e < r.length; e++){
                    const n = r[e];
                    for(let e = 0; e < i.length; e++){
                        const r = t1.getTile(i[e]);
                        if (!r || !r.hasData()) continue;
                        if (h(n, r.tileID)) continue;
                        const a = this._createProxiedId(n, r, o[n.key] && o[n.key][t1.id]), l = this.proxyToSource[n.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[n.key][t1.id] = [
                            a
                        ], s.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let s = this.orthoMatrix;
                if (o) {
                    const e = o.find((e)=>e.key === i.tileID.key);
                    if (e) return e;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let r, n, a;
                    s = e.bz();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (r = e.aj >> o, n = r * ((i.tileID.canonical.x << o) - t1.canonical.x + l), a = r * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (r = e.aj << -o, n = e.aj * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), a = e.aj * (i.tileID.canonical.y - (t1.canonical.y << -o))), e.c5(s, 0, r, 0, r, 0, 1), e.bo(s, s, [
                        n,
                        a,
                        0
                    ]);
                }
                return new Gs(i.tileID, t1.key, s);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const s = this._findCoveringTileCache[i.id], r = s[t1.key];
                if (o = r ? i.getTileByID(r) : null, o && o.hasData() || null === r) return o;
                let n = o ? o.tileID : t1, a = n.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!r) {
                    const s = i.getSource().maxzoom;
                    if (t1.canonical.z >= s) {
                        const o = t1.canonical.z - s;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), n = new e.aM(a, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (a = s, n = new e.aM(a, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    n.key !== t1.key && (c.push(n.key), o = i.getTile(n));
                }
                const h = (e)=>{
                    c.forEach((t1)=>{
                        s[t1] = e;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!o || !o.hasData()); a--){
                    o && h(o.tileID.key);
                    const e = n.calculateScaledKey(a);
                    if (o = i.getTileByID(e), o && o.hasData()) break;
                    const t1 = s[e];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e) {
                return this.enabled ? this._findTileCoveringTileID(e, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e, t1) {
                let i = this._tilesDirty[e];
                i || (i = this._tilesDirty[e] = {}), i[t1.key] = !0;
            }
        }
        function Zs(t1, i, o) {
            const s = function(t1, i, o) {
                const s = e.bG(i, t1), r = e.bG(o, [
                    .2126,
                    .7152,
                    .0722
                ]), n = (e, t1, i)=>(1 - i) * e + i * t1, a = n(1 - .3 * Math.min(r, 1), 1, Math.min(s + 1, 1));
                return n(.92, 1, Math.asin(e.ay(i[2], -1, 1)) / Math.PI + .5) * a;
            }(t1, [
                0,
                0,
                1
            ], i), r = [
                0,
                0,
                0
            ];
            e.bY(r, o.slice(0, 3), s);
            const n = [
                0,
                0,
                0
            ];
            e.bY(n, i.slice(0, 3), t1[2]);
            const a = [
                0,
                0,
                0
            ];
            return e.cV(a, r, n), e.cY(a);
        }
        const Hs = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], Ws = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "elevatedStructures",
            "model",
            "symbol"
        ];
        class $s {
            static cacheKey(e, t1, i, o) {
                let s = `${t1}${o ? o.cacheKey : ""}`;
                for (const t1 of i)e.usedDefines.includes(t1) && (s += `/${t1}`);
                return s;
            }
            constructor(t1, i, o, s, r, n){
                const a = t1.gl;
                this.program = a.createProgram(), this.configuration = s, this.name = i, this.fixedDefines = [
                    ...n
                ];
                const l = s ? s.getBinderAttributes() : [], c = (o.staticAttributes || []).concat(l);
                let h = s ? s.defines() : [];
                h = h.concat(n.map((e)=>`#define ${e}`));
                const d = "#version 300 es\n";
                let u = d + h.concat("precision mediump float;", Uo, No.fragmentSource).join("\n");
                for (const e of o.fragmentIncludes)u += `\n${Bo[e]}`;
                u += `\n${o.fragmentSource}`;
                let _ = d + h.concat("precision highp float;", Uo, No.vertexSource).join("\n");
                for (const e of o.vertexIncludes)_ += `\n${Bo[e]}`;
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && -1 !== o.vertexSource.indexOf("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && (_ += "\nuniform int u_instanceID;\n"), _ += `\n${o.vertexSource}`, this.forceManualRenderingForInstanceIDShaders && (_ = _.replaceAll("gl_InstanceID", "u_instanceID"));
                const p = a.createShader(a.FRAGMENT_SHADER);
                if (a.isContextLost()) return void (this.failedToCreate = !0);
                a.shaderSource(p, u), a.compileShader(p), a.attachShader(this.program, p);
                const f = a.createShader(a.VERTEX_SHADER);
                if (a.isContextLost()) this.failedToCreate = !0;
                else {
                    a.shaderSource(f, _), a.compileShader(f), a.attachShader(this.program, f), this.attributes = {}, this.numAttributes = c.length;
                    for(let e = 0; e < this.numAttributes; e++)if (c[e]) {
                        const t1 = c[e].startsWith("a_") ? c[e] : `a_${c[e]}`;
                        a.bindAttribLocation(this.program, e, t1), this.attributes[t1] = e;
                    }
                    a.linkProgram(this.program), a.deleteShader(f), a.deleteShader(p), this.fixedUniforms = r(t1), this.binderUniforms = s ? s.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                            u_instanceID: new e.c8(t1)
                        }))(t1)), (n.includes("TERRAIN") || -1 !== i.indexOf("symbol") || -1 !== i.indexOf("circle")) && (this.terrainUniforms = ((t1)=>({
                            u_dem: new e.c8(t1),
                            u_dem_prev: new e.c8(t1),
                            u_dem_tl: new e.cb(t1),
                            u_dem_scale: new e.ca(t1),
                            u_dem_tl_prev: new e.cb(t1),
                            u_dem_scale_prev: new e.ca(t1),
                            u_dem_size: new e.ca(t1),
                            u_dem_lerp: new e.ca(t1),
                            u_exaggeration: new e.ca(t1),
                            u_depth: new e.c8(t1),
                            u_depth_size_inv: new e.cb(t1),
                            u_depth_range_unpack: new e.cb(t1),
                            u_occluder_half_size: new e.ca(t1),
                            u_occlusion_depth_offset: new e.ca(t1),
                            u_meter_to_dem: new e.ca(t1),
                            u_label_plane_matrix_inv: new e.cc(t1)
                        }))(t1)), n.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                            u_tile_tl_up: new e.c9(t1),
                            u_tile_tr_up: new e.c9(t1),
                            u_tile_br_up: new e.c9(t1),
                            u_tile_bl_up: new e.c9(t1),
                            u_tile_up_scale: new e.ca(t1)
                        }))(t1)), n.includes("FOG") && (this.fogUniforms = ((t1)=>({
                            u_fog_matrix: new e.cc(t1),
                            u_fog_range: new e.cb(t1),
                            u_fog_color: new e.cQ(t1),
                            u_fog_horizon_blend: new e.ca(t1),
                            u_fog_vertical_limit: new e.cb(t1),
                            u_fog_temporal_offset: new e.ca(t1),
                            u_frustum_tl: new e.c9(t1),
                            u_frustum_tr: new e.c9(t1),
                            u_frustum_br: new e.c9(t1),
                            u_frustum_bl: new e.c9(t1),
                            u_globe_pos: new e.c9(t1),
                            u_globe_radius: new e.ca(t1),
                            u_globe_transition: new e.ca(t1),
                            u_is_globe: new e.c8(t1),
                            u_viewport: new e.cb(t1)
                        }))(t1)), n.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t1)=>({
                            u_cutoff_params: new e.cQ(t1)
                        }))(t1)), n.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                            u_lighting_ambient_color: new e.c9(t1),
                            u_lighting_directional_dir: new e.c9(t1),
                            u_lighting_directional_color: new e.c9(t1),
                            u_ground_radiance: new e.c9(t1)
                        }))(t1)), n.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t1)=>({
                            u_light_matrix_0: new e.cc(t1),
                            u_light_matrix_1: new e.cc(t1),
                            u_fade_range: new e.cb(t1),
                            u_shadow_normal_offset: new e.c9(t1),
                            u_shadow_intensity: new e.ca(t1),
                            u_shadow_texel_size: new e.ca(t1),
                            u_shadow_map_resolution: new e.ca(t1),
                            u_shadow_direction: new e.c9(t1),
                            u_shadow_bias: new e.c9(t1),
                            u_shadowmap_0: new e.c8(t1),
                            u_shadowmap_1: new e.c8(t1)
                        }))(t1));
                }
            }
            setTerrainUniformValues(e, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setGlobeUniformValues(e, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setFogUniformValues(e, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setCutoffUniformValues(e, t1) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setLightsUniformValues(e, t1) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setShadowUniformValues(e, t1) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e.program.set(this.program);
                for(const e in t1)i[e].set(this.program, e, t1[e]);
            }
            _drawDebugWireframe(t1, i, o, s, r, n, a, l, c, h) {
                const d = t1.options.wireframe;
                if (!1 === d.terrain && !1 === d.layers2D && !1 === d.layers3D) return;
                const u = t1.context;
                if (!(()=>!(!d.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!d.layers2D || t1._terrain && t1._terrain.renderingToTexture || !Hs.includes(this.name)) || !(!d.layers3D || !Ws.includes(this.name)))()) return;
                const _ = u.gl, p = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, r, u);
                if (!p) return;
                const f = [
                    ...this.fixedDefines
                ];
                f.push("DEBUG_WIREFRAME");
                const m = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                u.program.set(m.program);
                const g = (e, t1, i)=>{
                    if (t1[e] && i[e]) for(const o in t1[e])i[e][o] && i[e][o].set(i.program, o, t1[e][o].current);
                };
                c && c.setUniforms(m.program, u, m.binderUniforms, a, {
                    zoom: l
                }), g("fixedUniforms", this, m), g("terrainUniforms", this, m), g("globeUniforms", this, m), g("fogUniforms", this, m), g("lightsUniforms", this, m), g("shadowUniforms", this, m), p.bind(), u.setColorMode(new ki([
                    _.ONE,
                    _.ONE_MINUS_SRC_ALPHA,
                    _.ZERO,
                    _.ONE
                ], e.am.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), u.setDepthMode(new Ni(i.func === _.LESS ? _.LEQUAL : i.func, Ni.ReadOnly, i.range)), u.setStencilMode(ji.disabled);
                const v = 3 * n.primitiveLength * 2, y = 3 * n.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e = h || 1;
                    for(let t1 = 0; t1 < e; ++t1)m.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                } else h && h > 1 ? _.drawElementsInstanced(_.LINES, v, _.UNSIGNED_SHORT, y, h) : _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                r.bind(), u.program.set(this.program), u.setDepthMode(i), u.setStencilMode(o), u.setColorMode(s);
            }
            checkUniforms(e, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const o of Object.keys(i))if (!i[o].initialized) throw new Error(`Program '${this.name}', from draw '${e}': uniform ${o} not set but required by ${t1} being defined`);
                }
            }
            draw(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f) {
                const m = e.context, g = m.gl;
                if (this.failedToCreate) return;
                m.program.set(this.program), m.setDepthMode(i), m.setStencilMode(o), m.setColorMode(s), m.setCullFace(r);
                for (const e of Object.keys(this.fixedUniforms))this.fixedUniforms[e].set(this.program, e, n[e]);
                _ && _.setUniforms(this.program, m, this.binderUniforms, d, {
                    zoom: u
                });
                const v = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(a, "RENDER_SHADOWS", this.shadowUniforms);
                const y = f && f > 0 ? 1 : void 0;
                for (const r of h.get()){
                    const n = r.vaos || (r.vaos = {});
                    if ((n[a] || (n[a] = new qo)).bind(m, this, l, _ ? _.getPaintVertexBuffers() : [], c, r.vertexOffset, p || [], y), this.forceManualRenderingForInstanceIDShaders) {
                        const e = f || 1;
                        for(let i = 0; i < e; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    } else f && f > 1 ? g.drawElementsInstanced(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2, f) : c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    t1 === g.TRIANGLES && c && this._drawDebugWireframe(e, i, o, s, c, r, d, u, _, f);
                }
            }
        }
        function Xs(t1, i, o = 0) {
            const s = Math.pow(2, i.tileID.overscaledZ), r = i.tileSize * Math.pow(2, t1.transform.tileZoom) / s, n = r * (i.tileID.canonical.x + i.tileID.wrap * s), a = r * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / e.aw(i, 1, t1.transform.tileZoom),
                u_pixel_coord_upper: [
                    n >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & a
                ],
                u_pattern_transition: o
            };
        }
        const Ys = {
            terrain: 0,
            flat: 1
        }, Ks = e.bz(), Js = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v)=>{
            const y = i.style.light, x = y.properties.get("position"), b = [
                x.x,
                x.y,
                x.z
            ], w = e.dx();
            "viewport" === y.properties.get("anchor") && (e.dy(w, -i.transform.angle), e.dz(b, b, w));
            const T = y.properties.get("color").toPremultipliedRenderColor(null), E = i.transform, S = {
                u_matrix: t1,
                u_lightpos: b,
                u_lightintensity: y.properties.get("intensity"),
                u_lightcolor: [
                    T.r,
                    T.g,
                    T.b
                ],
                u_vertical_gradient: +o,
                u_opacity: s,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Ks,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: Ys[h],
                u_base_type: Ys[d],
                u_ao: r,
                u_edge_radius: n,
                u_width_scale: a,
                u_flood_light_color: f,
                u_vertical_scale: m,
                u_flood_light_intensity: g,
                u_ground_shadow_factor: v
            };
            return "globe" === E.projection.name && (S.u_tile_id = [
                l.canonical.x,
                l.canonical.y,
                1 << l.canonical.z
            ], S.u_zoom_transition = u, S.u_inv_rot_matrix = p, S.u_merc_center = _, S.u_up_dir = E.projection.upVector(new e.cp(0, 0, 0), _[0] * e.aj, _[1] * e.aj), S.u_height_lift = c), S;
        }, Qs = (e, t1, i, o, s, r)=>({
                u_matrix: e,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: o,
                u_height_type: Ys[s],
                u_base_type: Ys[r]
            }), er = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v)=>{
            const y = Js(t1, i, o, s, r, n, a, l, h, d, u, _, p, f, m, g, 1, [
                0,
                0,
                0
            ]), x = {
                u_height_factor: -Math.pow(2, l.overscaledZ) / c.tileSize / 8
            };
            return e.h(y, Xs(i, c, v), x);
        }, tr = (e, t1, i)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_ground_shadow_factor: i
            }), ir = (t1, i, o, s, r, n = 0)=>e.h(tr(t1, i, r), Xs(o, s, n)), or = (e, t1, i, o)=>({
                u_matrix: e,
                u_world: i,
                u_emissive_strength: t1,
                u_ground_shadow_factor: o
            }), sr = (t1, i, o, s, r, n, a = 0)=>e.h(ir(t1, i, o, s, n, a), {
                u_world: r
            }), rr = (e, t1)=>({
                u_matrix: e,
                u_ground_shadow_factor: t1
            }), nr = (e, t1, i, o, s)=>({
                u_matrix: e,
                u_camera_pos: [
                    t1[0],
                    t1[1],
                    t1[2]
                ],
                u_depth_bias: i,
                u_height_scale: o,
                u_reset_depth: s
            }), ar = (t1, i, o, s)=>{
            const r = e.aj / o.tileSize;
            return {
                u_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(s),
                u_extrude_scale: [
                    i.pixelsToGLUnits[0] / r,
                    i.pixelsToGLUnits[1] / r
                ]
            };
        }, lr = (e, t1, i = 1)=>({
                u_matrix: e,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), cr = e.bz(), hr = (t1, i, o, s, r, n, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e.dA(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e.aw(o, 1, n), d = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: cr,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                d.u_inv_rot_matrix = s, d.u_merc_center = r, d.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], d.u_zoom_transition = e.ah(l.zoom);
                const t1 = r[0] * e.aj, o = r[1] * e.aj;
                d.u_up_dir = l.projection.upVector(new e.cp(0, 0, 0), t1, o);
            }
            return d;
        };
        function dr(e, [t1, i, o, s], [r, n]) {
            if (r === n) return [
                0,
                0,
                0,
                0
            ];
            const a = 255 * (e - 1) / (e * (n - r));
            return [
                t1 * a,
                i * a,
                o * a,
                s * a
            ];
        }
        function ur(e, t1, [i, o]) {
            return i === o ? 0 : .5 / e + (t1 - i) * (e - 1) / (e * (o - i));
        }
        const _r = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x, b)=>({
                u_matrix: t1,
                u_normalize_matrix: i,
                u_globe_matrix: o,
                u_merc_matrix: s,
                u_grid_matrix: r,
                u_tl_parent: n,
                u_scale_parent: h,
                u_fade_t: d.mix,
                u_opacity: d.opacity * u.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: u.paint.get("raster-brightness-min"),
                u_brightness_high: u.paint.get("raster-brightness-max"),
                u_saturation_factor: e.dC(u.paint.get("raster-saturation")),
                u_contrast_factor: e.dB(u.paint.get("raster-contrast")),
                u_spin_weights: pr(u.paint.get("raster-hue-rotate")),
                u_perspective_transform: _,
                u_raster_elevation: p,
                u_zoom_transition: a,
                u_merc_center: l,
                u_cutoff_params: c,
                u_colorization_mix: dr(e.dD, m, v),
                u_colorization_offset: ur(e.dD, g, v),
                u_color_ramp: f,
                u_texture_offset: [
                    x / (y + 2 * x),
                    y / (y + 2 * x)
                ],
                u_texture_res: [
                    y + 2 * x,
                    y + 2 * x
                ],
                u_emissive_strength: b
            });
        function pr(e) {
            e *= Math.PI / 180;
            const t1 = Math.sin(e), i = Math.cos(e);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const fr = .05, mr = (e, t1, i, o, s, r, n, a, l, c, h, d)=>({
                u_matrix: e,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: o,
                u_grid_matrix: s,
                u_tl_parent: r,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: d,
                u_zoom_transition: n,
                u_merc_center: a,
                u_cutoff_params: l
            }), gr = (e, t1, i, o, s, r, n, a, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: o,
                u_color_ramp: r,
                u_velocity_res: s,
                u_max_speed: n,
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    fr,
                    fr
                ]
            }), vr = (e, t1, i, o, s, r, n, a, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: o,
                u_max_speed: s,
                u_speed_factor: r,
                u_reset_rate: n,
                u_rand_seed: Math.random(),
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    fr,
                    fr
                ]
            }), yr = e.bz(), xr = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x, b, w, T, E)=>{
            const S = r.transform, I = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: S.getCameraToCenterDistance(y),
                u_rotate_symbol: +o,
                u_aspect_ratio: S.width / S.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: n,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +h,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +s,
                u_texsize: d,
                u_texsize_icon: u,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: yr,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: yr,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: w,
                u_icon_transition: T || 0,
                u_gamma_scale: s ? r.transform.getCameraToCenterDistance(y) * Math.cos(r.terrain ? 0 : r.transform._pitch) : 1,
                u_device_pixel_ratio: e.q.devicePixelRatio,
                u_is_halo: 1,
                u_scale_factor: E || 1,
                u_ground_shadow_factor: x,
                u_inv_matrix: e.bi(e.bz(), a),
                u_normal_scale: b
            };
            return "globe" === y.name && (I.u_tile_id = [
                p.canonical.x,
                p.canonical.y,
                1 << p.canonical.z
            ], I.u_zoom_transition = f, I.u_inv_rot_matrix = g, I.u_merc_center = m, I.u_camera_forward = S._camera.forward(), I.u_ecef_origin = e.dE(S.globeMatrix, p.toUnwrapped()), I.u_tile_matrix = Float32Array.from(S.globeMatrix), I.u_up_vector = v), I;
        }, br = (e, t1, i, o)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: o
            }), wr = (t1, i, o, s, r, n, a, l, c)=>e.h(function(t1, i, o, s, r, n) {
                const { width: a, height: l } = s.imageManager.getPixelSize(i), c = Math.pow(2, n.tileID.overscaledZ), h = n.tileSize * Math.pow(2, s.transform.tileZoom) / c, d = h * (n.tileID.canonical.x + n.tileID.wrap * c), u = h * n.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        a,
                        l
                    ],
                    u_pattern_size: o.displaySize,
                    u_pattern_units_to_pixels: r ? [
                        s.transform.width,
                        -1 * s.transform.height
                    ] : [
                        1 / e.aw(n, 1, s.transform.tileZoom),
                        1 / e.aw(n, 1, s.transform.tileZoom)
                    ],
                    u_pixel_coord_upper: [
                        d >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & d,
                        65535 & u
                    ]
                };
            }(0, n, a, s, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: o
            }), Tr = new Float32Array(e.bx([])), Er = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p = [
            0,
            0,
            0
        ], f)=>{
            const m = r.style.light, g = m.properties.get("position"), v = [
                -g.x,
                -g.y,
                g.z
            ], y = e.dx();
            "viewport" === m.properties.get("anchor") && (e.dy(y, -r.transform.angle), e.dz(v, v, y));
            const x = "MASK" === d.alphaMode, b = m.properties.get("color").toNonPremultipliedRenderColor(null), w = _.paint.get("model-ambient-occlusion-intensity"), T = _.paint.get("model-color").constantOr(e.am.white).toNonPremultipliedRenderColor(null);
            return T.a = _.paint.get("model-color-mix-intensity").constantOr(0), {
                u_matrix: t1,
                u_lighting_matrix: i,
                u_normal_matrix: o,
                u_node_matrix: s || Tr,
                u_lightpos: v,
                u_lightintensity: m.properties.get("intensity"),
                u_lightcolor: [
                    b.r,
                    b.g,
                    b.b
                ],
                u_camera_pos: p,
                u_opacity: n,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +x,
                u_alphaCutoff: d.alphaCutoff,
                u_baseColorFactor: a.toNonPremultipliedRenderColor(null).toArray01(),
                u_emissiveFactor: l.toNonPremultipliedRenderColor(null).toArray01(),
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: Yi.BaseColor,
                u_metallicRoughnessTexture: Yi.MetallicRoughness,
                u_normalTexture: Yi.Normal,
                u_occlusionTexture: Yi.Occlusion,
                u_emissionTexture: Yi.Emission,
                u_lutTexture: Yi.LUT,
                u_color_mix: T.toArray01(),
                u_aoIntensity: w,
                u_emissive_strength: u,
                u_occlusionTextureTransform: f || [
                    0,
                    0,
                    0,
                    0
                ]
            };
        }, Sr = (e, t1 = Tr, i = Tr)=>({
                u_matrix: e,
                u_instance: t1,
                u_node_matrix: i
            }), Ir = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_lightpos: new e.c9(t1),
                    u_lightintensity: new e.ca(t1),
                    u_lightcolor: new e.c9(t1),
                    u_vertical_gradient: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_edge_radius: new e.ca(t1),
                    u_width_scale: new e.ca(t1),
                    u_ao: new e.cb(t1),
                    u_height_type: new e.c8(t1),
                    u_base_type: new e.c8(t1),
                    u_tile_id: new e.c9(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_inv_rot_matrix: new e.cc(t1),
                    u_merc_center: new e.cb(t1),
                    u_up_dir: new e.c9(t1),
                    u_height_lift: new e.ca(t1),
                    u_flood_light_color: new e.c9(t1),
                    u_vertical_scale: new e.ca(t1),
                    u_flood_light_intensity: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            fillExtrusionDepth: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_edge_radius: new e.ca(t1),
                    u_width_scale: new e.ca(t1),
                    u_vertical_scale: new e.ca(t1),
                    u_height_type: new e.c8(t1),
                    u_base_type: new e.c8(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_lightpos: new e.c9(t1),
                    u_lightintensity: new e.ca(t1),
                    u_lightcolor: new e.c9(t1),
                    u_vertical_gradient: new e.ca(t1),
                    u_height_factor: new e.ca(t1),
                    u_edge_radius: new e.ca(t1),
                    u_width_scale: new e.ca(t1),
                    u_ao: new e.cb(t1),
                    u_height_type: new e.c8(t1),
                    u_base_type: new e.c8(t1),
                    u_tile_id: new e.c9(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_inv_rot_matrix: new e.cc(t1),
                    u_merc_center: new e.cb(t1),
                    u_up_dir: new e.c9(t1),
                    u_height_lift: new e.ca(t1),
                    u_image: new e.c8(t1),
                    u_texsize: new e.cb(t1),
                    u_pixel_coord_upper: new e.cb(t1),
                    u_pixel_coord_lower: new e.cb(t1),
                    u_tile_units_to_pixels: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_pattern_transition: new e.ca(t1)
                }),
            fillExtrusionGroundEffect: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_opacity: new e.ca(t1),
                    u_ao_pass: new e.ca(t1),
                    u_meter_to_tile: new e.ca(t1),
                    u_ao: new e.cb(t1),
                    u_flood_light_intensity: new e.ca(t1),
                    u_flood_light_color: new e.c9(t1),
                    u_attenuation: new e.ca(t1),
                    u_edge_radius: new e.ca(t1),
                    u_fb: new e.c8(t1),
                    u_fb_size: new e.ca(t1),
                    u_dynamic_offset: new e.ca(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_image: new e.c8(t1),
                    u_texsize: new e.cb(t1),
                    u_pixel_coord_upper: new e.cb(t1),
                    u_pixel_coord_lower: new e.cb(t1),
                    u_tile_units_to_pixels: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1),
                    u_pattern_transition: new e.ca(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_world: new e.cb(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_world: new e.cb(t1),
                    u_image: new e.c8(t1),
                    u_texsize: new e.cb(t1),
                    u_pixel_coord_upper: new e.cb(t1),
                    u_pixel_coord_lower: new e.cb(t1),
                    u_tile_units_to_pixels: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1),
                    u_pattern_transition: new e.ca(t1)
                }),
            building: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_normal_matrix: new e.cc(t1),
                    u_opacity: new e.ca(t1)
                }),
            buildingDepth: (t1)=>({
                    u_matrix: new e.cc(t1)
                }),
            elevatedStructuresDepth: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_depth_bias: new e.ca(t1)
                }),
            elevatedStructures: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            elevatedStructuresDepthReconstruct: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_camera_pos: new e.c9(t1),
                    u_depth_bias: new e.ca(t1),
                    u_height_scale: new e.ca(t1),
                    u_reset_depth: new e.ca(t1)
                }),
            circle: e.dH,
            collisionBox: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_camera_to_center_distance: new e.ca(t1),
                    u_extrude_scale: new e.cb(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_inv_matrix: new e.cc(t1),
                    u_camera_to_center_distance: new e.ca(t1),
                    u_viewport_size: new e.cb(t1)
                }),
            debug: (t1)=>({
                    u_color: new e.di(t1),
                    u_matrix: new e.cc(t1),
                    u_overlay: new e.c8(t1),
                    u_overlay_scale: new e.ca(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e.cc(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e.ca(t1),
                    u_intensity: new e.ca(t1),
                    u_matrix: new e.cc(t1),
                    u_inv_rot_matrix: new e.cc(t1),
                    u_merc_center: new e.cb(t1),
                    u_tile_id: new e.c9(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_up_dir: new e.c9(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e.c8(t1),
                    u_color_ramp: new e.c8(t1),
                    u_opacity: new e.ca(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_image: new e.c8(t1),
                    u_latrange: new e.cb(t1),
                    u_light: new e.cb(t1),
                    u_shadow: new e.di(t1),
                    u_highlight: new e.di(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_accent: new e.di(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_image: new e.c8(t1),
                    u_dimension: new e.cb(t1),
                    u_zoom: new e.ca(t1)
                }),
            line: e.dG,
            linePattern: e.dF,
            raster: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_normalize_matrix: new e.cc(t1),
                    u_globe_matrix: new e.cc(t1),
                    u_merc_matrix: new e.cc(t1),
                    u_grid_matrix: new e.dj(t1),
                    u_tl_parent: new e.cb(t1),
                    u_scale_parent: new e.ca(t1),
                    u_fade_t: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_image0: new e.c8(t1),
                    u_image1: new e.c8(t1),
                    u_brightness_low: new e.ca(t1),
                    u_brightness_high: new e.ca(t1),
                    u_saturation_factor: new e.ca(t1),
                    u_contrast_factor: new e.ca(t1),
                    u_spin_weights: new e.c9(t1),
                    u_perspective_transform: new e.cb(t1),
                    u_raster_elevation: new e.ca(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_merc_center: new e.cb(t1),
                    u_cutoff_params: new e.cQ(t1),
                    u_colorization_mix: new e.cQ(t1),
                    u_colorization_offset: new e.ca(t1),
                    u_color_ramp: new e.c8(t1),
                    u_texture_offset: new e.cb(t1),
                    u_texture_res: new e.cb(t1),
                    u_emissive_strength: new e.ca(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_normalize_matrix: new e.cc(t1),
                    u_globe_matrix: new e.cc(t1),
                    u_merc_matrix: new e.cc(t1),
                    u_grid_matrix: new e.dj(t1),
                    u_tl_parent: new e.cb(t1),
                    u_scale_parent: new e.ca(t1),
                    u_fade_t: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_image0: new e.c8(t1),
                    u_image1: new e.c8(t1),
                    u_raster_elevation: new e.ca(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_merc_center: new e.cb(t1),
                    u_cutoff_params: new e.cQ(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e.c8(t1),
                    u_opacity: new e.ca(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e.c8(t1),
                    u_particle_texture_side_len: new e.ca(t1),
                    u_tile_offset: new e.cb(t1),
                    u_velocity: new e.c8(t1),
                    u_color_ramp: new e.c8(t1),
                    u_velocity_res: new e.cb(t1),
                    u_max_speed: new e.ca(t1),
                    u_uv_offset: new e.cb(t1),
                    u_data_scale: new e.cb(t1),
                    u_data_offset: new e.ca(t1),
                    u_particle_pos_scale: new e.ca(t1),
                    u_particle_pos_offset: new e.cb(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e.c8(t1),
                    u_particle_texture_side_len: new e.ca(t1),
                    u_velocity: new e.c8(t1),
                    u_velocity_res: new e.cb(t1),
                    u_max_speed: new e.ca(t1),
                    u_speed_factor: new e.ca(t1),
                    u_reset_rate: new e.ca(t1),
                    u_rand_seed: new e.ca(t1),
                    u_uv_offset: new e.cb(t1),
                    u_data_scale: new e.cb(t1),
                    u_data_offset: new e.ca(t1),
                    u_particle_pos_scale: new e.ca(t1),
                    u_particle_pos_offset: new e.cb(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e.c8(t1),
                    u_is_size_feature_constant: new e.c8(t1),
                    u_size_t: new e.ca(t1),
                    u_size: new e.ca(t1),
                    u_camera_to_center_distance: new e.ca(t1),
                    u_rotate_symbol: new e.c8(t1),
                    u_aspect_ratio: new e.ca(t1),
                    u_fade_change: new e.ca(t1),
                    u_matrix: new e.cc(t1),
                    u_label_plane_matrix: new e.cc(t1),
                    u_coord_matrix: new e.cc(t1),
                    u_is_text: new e.c8(t1),
                    u_elevation_from_sea: new e.c8(t1),
                    u_pitch_with_map: new e.c8(t1),
                    u_texsize: new e.cb(t1),
                    u_texsize_icon: new e.cb(t1),
                    u_texture: new e.c8(t1),
                    u_texture_icon: new e.c8(t1),
                    u_gamma_scale: new e.ca(t1),
                    u_device_pixel_ratio: new e.ca(t1),
                    u_tile_id: new e.c9(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_inv_rot_matrix: new e.cc(t1),
                    u_merc_center: new e.cb(t1),
                    u_camera_forward: new e.c9(t1),
                    u_tile_matrix: new e.cc(t1),
                    u_up_vector: new e.c9(t1),
                    u_ecef_origin: new e.c9(t1),
                    u_is_halo: new e.c8(t1),
                    u_icon_transition: new e.ca(t1),
                    u_color_adj_mat: new e.cc(t1),
                    u_scale_factor: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1),
                    u_inv_matrix: new e.cc(t1),
                    u_normal_scale: new e.ca(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_color: new e.di(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_image: new e.c8(t1),
                    u_pattern_tl: new e.cb(t1),
                    u_pattern_br: new e.cb(t1),
                    u_texsize: new e.cb(t1),
                    u_pattern_size: new e.cb(t1),
                    u_pixel_coord_upper: new e.cb(t1),
                    u_pixel_coord_lower: new e.cb(t1),
                    u_pattern_units_to_pixels: new e.cb(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_image0: new e.c8(t1),
                    u_skirt_height: new e.ca(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_sun_direction: new e.c9(t1),
                    u_cubemap: new e.c8(t1),
                    u_opacity: new e.ca(t1),
                    u_temporal_offset: new e.ca(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_color_ramp: new e.c8(t1),
                    u_center_direction: new e.c9(t1),
                    u_radius: new e.ca(t1),
                    u_opacity: new e.ca(t1),
                    u_temporal_offset: new e.ca(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e.dj(t1),
                    u_sun_direction: new e.c9(t1),
                    u_sun_intensity: new e.ca(t1),
                    u_color_tint_r: new e.cQ(t1),
                    u_color_tint_m: new e.cQ(t1),
                    u_luminance: new e.ca(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e.cc(t1),
                    u_globe_matrix: new e.cc(t1),
                    u_normalize_matrix: new e.cc(t1),
                    u_merc_matrix: new e.cc(t1),
                    u_zoom_transition: new e.ca(t1),
                    u_merc_center: new e.cb(t1),
                    u_image0: new e.c8(t1),
                    u_grid_matrix: new e.dj(t1),
                    u_skirt_height: new e.ca(t1),
                    u_far_z_cutoff: new e.ca(t1),
                    u_frustum_tl: new e.c9(t1),
                    u_frustum_tr: new e.c9(t1),
                    u_frustum_br: new e.c9(t1),
                    u_frustum_bl: new e.c9(t1),
                    u_globe_pos: new e.c9(t1),
                    u_globe_radius: new e.ca(t1),
                    u_viewport: new e.cb(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e.c9(t1),
                    u_frustum_tr: new e.c9(t1),
                    u_frustum_br: new e.c9(t1),
                    u_frustum_bl: new e.c9(t1),
                    u_horizon: new e.ca(t1),
                    u_transition: new e.ca(t1),
                    u_fadeout_range: new e.ca(t1),
                    u_color: new e.cQ(t1),
                    u_high_color: new e.cQ(t1),
                    u_space_color: new e.cQ(t1),
                    u_temporal_offset: new e.ca(t1),
                    u_horizon_angle: new e.ca(t1)
                }),
            model: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_lighting_matrix: new e.cc(t1),
                    u_normal_matrix: new e.cc(t1),
                    u_node_matrix: new e.cc(t1),
                    u_lightpos: new e.c9(t1),
                    u_lightintensity: new e.ca(t1),
                    u_lightcolor: new e.c9(t1),
                    u_camera_pos: new e.c9(t1),
                    u_opacity: new e.ca(t1),
                    u_baseColorFactor: new e.cQ(t1),
                    u_emissiveFactor: new e.cQ(t1),
                    u_metallicFactor: new e.ca(t1),
                    u_roughnessFactor: new e.ca(t1),
                    u_baseTextureIsAlpha: new e.c8(t1),
                    u_alphaMask: new e.c8(t1),
                    u_alphaCutoff: new e.ca(t1),
                    u_baseColorTexture: new e.c8(t1),
                    u_metallicRoughnessTexture: new e.c8(t1),
                    u_normalTexture: new e.c8(t1),
                    u_occlusionTexture: new e.c8(t1),
                    u_emissionTexture: new e.c8(t1),
                    u_lutTexture: new e.c8(t1),
                    u_color_mix: new e.cQ(t1),
                    u_aoIntensity: new e.ca(t1),
                    u_emissive_strength: new e.ca(t1),
                    u_occlusionTextureTransform: new e.cQ(t1)
                }),
            modelDepth: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_instance: new e.cc(t1),
                    u_node_matrix: new e.cc(t1)
                }),
            groundShadow: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_ground_shadow_factor: new e.c9(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_up: new e.c9(t1),
                    u_right: new e.c9(t1),
                    u_intensity_multiplier: new e.ca(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e.cc(t1),
                    u_projection: new e.cc(t1),
                    u_time: new e.ca(t1),
                    u_cam_pos: new e.c9(t1),
                    u_velocityConeAperture: new e.ca(t1),
                    u_velocity: new e.ca(t1),
                    u_horizontalOscillationRadius: new e.ca(t1),
                    u_horizontalOscillationRate: new e.ca(t1),
                    u_boxSize: new e.ca(t1),
                    u_billboardSize: new e.ca(t1),
                    u_simpleShapeParameters: new e.cb(t1),
                    u_screenSize: new e.cb(t1),
                    u_thinningCenterPos: new e.cb(t1),
                    u_thinningShape: new e.c9(t1),
                    u_thinningAffectedRatio: new e.ca(t1),
                    u_thinningParticleOffset: new e.ca(t1),
                    u_particleColor: new e.cQ(t1),
                    u_direction: new e.c9(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e.cc(t1),
                    u_projection: new e.cc(t1),
                    u_time: new e.ca(t1),
                    u_cam_pos: new e.c9(t1),
                    u_texScreen: new e.c8(t1),
                    u_velocityConeAperture: new e.ca(t1),
                    u_velocity: new e.ca(t1),
                    u_boxSize: new e.ca(t1),
                    u_rainDropletSize: new e.cb(t1),
                    u_distortionStrength: new e.ca(t1),
                    u_rainDirection: new e.c9(t1),
                    u_color: new e.cQ(t1),
                    u_screenSize: new e.cb(t1),
                    u_thinningCenterPos: new e.cb(t1),
                    u_thinningShape: new e.c9(t1),
                    u_thinningAffectedRatio: new e.ca(t1),
                    u_thinningParticleOffset: new e.ca(t1),
                    u_shapeDirectionalPower: new e.ca(t1),
                    u_shapeNormalPower: new e.ca(t1),
                    u_mode: new e.ca(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e.c9(t1),
                    u_vignetteColor: new e.cQ(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e.cc(t1),
                    u_anchorPos: new e.c9(t1),
                    u_screenSizePx: new e.cb(t1),
                    u_occluderSizePx: new e.cb(t1),
                    u_color: new e.cQ(t1)
                })
        };
        class Cr {
            constructor(e, t1, i, o){
                this.id = Cr.uniqueIdxCounter, Cr.uniqueIdxCounter++, this.context = e;
                const s = e.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || o || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e) {
                this.id = Cr.uniqueIdxCounter, Cr.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        Cr.uniqueIdxCounter = 0;
        const Rr = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Dr {
            constructor(e, t1, i, o, s, r){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.instanceCount = r, this.context = e;
                const n = e.gl;
                this.buffer = n.createBuffer(), e.bindVertexBuffer.set(this.buffer), n.bufferData(n.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || s || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            enableAttributes(e, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.attributes[this.attributes[i].name];
                    void 0 !== o && e.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = this.attributes[o], r = t1.attributes[s.name];
                    void 0 !== r && e.vertexAttribPointer(r, s.components, e[Rr[s.type]], !1, this.itemSize, s.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = t1.attributes[this.attributes[o].name];
                    void 0 !== s && this.instanceCount && this.instanceCount > 0 && e.vertexAttribDivisor(s, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Ar {
            constructor(e, t1, i, o, s){
                this.context = e, this.width = t1, this.height = i;
                const r = this.framebuffer = e.gl.createFramebuffer();
                o && (this.colorAttachment = new Rs(e, r)), s && (this.depthAttachmentType = s, this.depthAttachment = "renderbuffer" === s ? new Ds(e, r) : new As(e, r));
            }
            destroy() {
                const e = this.context.gl;
                if (this.colorAttachment) {
                    const t1 = this.colorAttachment.get();
                    t1 && e.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteTexture(t1);
                    }
                }
                e.deleteFramebuffer(this.framebuffer);
            }
        }
        class Lr {
            constructor(e, t1){
                this.gl = e, this.clearColor = new Yo(this), this.clearDepth = new Ko(this), this.clearStencil = new Jo(this), this.colorMask = new Qo(this), this.depthMask = new es(this), this.stencilMask = new ts(this), this.stencilFunc = new is(this), this.stencilOp = new os(this), this.stencilTest = new ss(this), this.depthRange = new rs(this), this.depthTest = new ns(this), this.depthFunc = new as(this), this.blend = new ls(this), this.blendFunc = new cs(this), this.blendColor = new hs(this), this.blendEquation = new ds(this), this.cullFace = new us(this), this.cullFaceSide = new _s(this), this.frontFace = new ps(this), this.program = new fs(this), this.activeTexture = new ms(this), this.viewport = new gs(this), this.bindFramebuffer = new vs(this), this.bindRenderbuffer = new ys(this), this.bindTexture = new xs(this), this.bindVertexBuffer = new bs(this), this.bindElementBuffer = new ws(this), this.bindVertexArrayOES = new Ts(this), this.pixelStoreUnpack = new Es(this), this.pixelStoreUnpackPremultiplyAlpha = new Ss(this), this.pixelStoreUnpackFlipY = new Is(this), this.options = t1 ? Object.assign({}, t1) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.maxPointSize = e.getParameter(e.ALIASED_POINT_SIZE_RANGE)[1];
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e, t1, i) {
                return new Cr(this, e, t1, i);
            }
            createVertexBuffer(e, t1, i, o, s) {
                return new Dr(this, e, t1, i, o, s);
            }
            createRenderbuffer(e, t1, i) {
                const o = this.gl, s = o.createRenderbuffer();
                return this.bindRenderbuffer.set(s), o.renderbufferStorage(o.RENDERBUFFER, e, t1, i), this.bindRenderbuffer.set(null), s;
            }
            createFramebuffer(e, t1, i, o) {
                return new Ar(this, e, t1, i, o);
            }
            clear({ color: e, depth: t1, stencil: i, colorMask: o }) {
                const s = this.gl;
                let r = 0;
                e && (r |= s.COLOR_BUFFER_BIT, this.clearColor.set(e.toNonPremultipliedRenderColor(null)), this.colorMask.set(o || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (r |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (r |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(r);
            }
            setCullFace(e) {
                !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
            }
            setDepthMode(e) {
                e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e) {
                e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([
                    e.fail,
                    e.depthFail,
                    e.pass
                ]), this.stencilFunc.set({
                    func: e.test.func,
                    ref: e.ref,
                    mask: e.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e.bv(t1.blendFunction, ki.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        let Pr;
        function zr(t1, i, o, s, r, n, a) {
            const l = t1.context, c = l.gl, h = t1.transform, d = t1.getOrCreateProgram("collisionBox"), u = [];
            let _ = 0, p = 0;
            for(let l = 0; l < s.length; l++){
                const f = s[l], m = i.getTile(f), g = m.getBucket(o);
                if (!g) continue;
                const v = ci(f, g, h);
                let y = v;
                0 === r[0] && 0 === r[1] || (y = t1.translatePosMatrix(v, m, r, n));
                const x = a ? g.textCollisionBox : g.iconCollisionBox, b = g.collisionCircleArray;
                if (b.length > 0) {
                    const t1 = e.bz(), i = y;
                    e.cB(t1, g.placementInvProjMatrix, h.glCoordMatrix), e.cB(t1, t1, g.placementViewportMatrix), u.push({
                        circleArray: b,
                        circleOffset: p,
                        transform: i,
                        invTransform: t1,
                        projection: g.getProjection()
                    }), _ += b.length / 4, p = _;
                }
                x && (t1.terrain && t1.terrain.setupElevationDraw(m, d), d.draw(t1, c.LINES, Ni.disabled, ji.disabled, t1.colorModeForRenderPass(), qi.disabled, ar(y, h, m, g.getProjection()), o.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, h.zoom, null, [
                    x.collisionVertexBuffer,
                    x.collisionVertexBufferExt
                ]));
            }
            if (!a || !u.length) return;
            const f = t1.getOrCreateProgram("collisionCircle"), m = new e.dI;
            m.resize(4 * _), m._trim();
            let g = 0;
            for (const e of u)for(let t1 = 0; t1 < e.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e.circleArray[i + 0], s = e.circleArray[i + 1], r = e.circleArray[i + 2], n = e.circleArray[i + 3];
                m.emplace(g++, o, s, r, n, 0), m.emplace(g++, o, s, r, n, 1), m.emplace(g++, o, s, r, n, 2), m.emplace(g++, o, s, r, n, 3);
            }
            (!Pr || Pr.length < 2 * _) && (Pr = function(t1) {
                const i = 2 * t1, o = new e.a_;
                o.resize(i), o._trim();
                for(let e = 0; e < i; e++){
                    const t1 = 6 * e;
                    o.uint16[t1 + 0] = 4 * e + 0, o.uint16[t1 + 1] = 4 * e + 1, o.uint16[t1 + 2] = 4 * e + 2, o.uint16[t1 + 3] = 4 * e + 2, o.uint16[t1 + 4] = 4 * e + 3, o.uint16[t1 + 5] = 4 * e + 0;
                }
                return o;
            }(_));
            const v = l.createIndexBuffer(Pr, !0), y = l.createVertexBuffer(m, e.dJ.members, !0);
            for (const i of u){
                const s = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (x = h).getCameraToCenterDistance(i.projection),
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                f.draw(t1, c.TRIANGLES, Ni.disabled, ji.disabled, t1.colorModeForRenderPass(), qi.disabled, s, o.id, y, v, e.bd.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            var x;
            y.destroy(), v.destroy();
        }
        const Mr = e.bz();
        function Or(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e.az([], i, t1.globeMatrix);
            e.bi(o, o);
            const s = [
                0,
                0,
                0
            ], r = [
                0,
                1,
                0,
                0
            ];
            return e.aA(r, r, o), s[0] = r[0], s[1] = r[1], s[2] = r[2], e.au(s, s), s;
        }
        function Fr({ width: t1, height: i, anchor: o, textOffset: s, textScale: r }, n) {
            const { horizontalAlign: a, verticalAlign: l } = e.bT(o), c = -(a - .5) * t1, h = -(l - .5) * i, d = e.bU(o, s);
            return new e.P((c / r + d[0]) * n, (h / r + d[1]) * n);
        }
        function Br(t1, i, o, s, r, n, a, l, c, h) {
            const d = t1.text.placedSymbolArray, u = t1.text.dynamicLayoutVertexArray, _ = t1.icon.dynamicLayoutVertexArray, p = {}, f = t1.getProjection(), m = hi(a, f, r), g = r.elevation, v = f.upVectorScale(a.canonical, r.center.lat, r.worldSize).metersToTile;
            u.clear();
            for(let _ = 0; _ < d.length; _++){
                const y = d.get(_), { tileAnchorX: x, tileAnchorY: b, numGlyphs: w } = y, T = y.hidden || !y.crossTileID || t1.allowVerticalPlacement && !y.placedOrientation ? null : s[y.crossTileID];
                if (T) {
                    let s = 0, d = 0, _ = 0;
                    if (g) {
                        const e = g ? g.getAtTileOffset(a, x, b) : 0, [t1, i, o] = f.upVector(a.canonical, x, b);
                        s = e * t1 * v, d = e * i * v, _ = e * o * v;
                    }
                    let [E, S, I, C] = $t(y.projectedAnchorX + s, y.projectedAnchorY + d, y.projectedAnchorZ + _, o ? m : n);
                    const R = Xt(r.getCameraToCenterDistance(f), C);
                    let D = e.bJ(t1.textSizeData, c, y) * R / e.bO;
                    o && (D *= t1.tilePixelRatio / l);
                    const A = Fr(T, D);
                    o ? ({ x: E, y: S, z: I } = f.projectTilePoint(x + A.x, b + A.y, a.canonical), [E, S, I] = $t(E + s, S + d, I + _, n)) : (i && A._rotate(-r.angle), E += A.x, S += A.y, I = 0);
                    const L = t1.allowVerticalPlacement && y.placedOrientation === e.bI.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < w; t1++)e.bL(u, E, S, I, L);
                    h && y.associatedIconIndex >= 0 && (p[y.associatedIconIndex] = {
                        x: E,
                        y: S,
                        z: I,
                        angle: L
                    });
                } else si(w, u);
            }
            if (h) {
                _.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: s } = o, r = p[t1];
                    if (o.hidden || !r) si(s, _);
                    else {
                        const { x: t1, y: i, z: o, angle: n } = r;
                        for(let r = 0; r < s; r++)e.bL(_, t1, i, o, n);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(_);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(u);
        }
        function kr(t1, i, o, s, r, n, a = {}) {
            const l = o.paint.get("icon-translate"), c = o.paint.get("text-translate"), h = o.paint.get("icon-translate-anchor"), d = o.paint.get("text-translate-anchor"), u = o.layout.get("icon-rotation-alignment"), _ = o.layout.get("text-rotation-alignment"), p = o.layout.get("icon-pitch-alignment"), f = o.layout.get("text-pitch-alignment"), m = o.layout.get("icon-keep-upright"), g = o.layout.get("text-keep-upright"), v = o.paint.get("icon-color-saturation"), y = o.paint.get("icon-color-contrast"), x = o.paint.get("icon-color-brightness-min"), b = o.paint.get("icon-color-brightness-max"), w = "sea" === o.layout.get("symbol-elevation-reference"), T = t1.context, E = T.gl, S = t1.transform, I = "map" === u, C = "map" === _, R = "map" === p, D = "map" === f, A = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let L = !1;
            const P = t1.depthModeForSublayer(0, Ni.ReadOnly), z = new Ni(t1.context.gl.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D), M = [
                e.aD(S.center.lng),
                e.aH(S.center.lat)
            ], O = o.layout.get("text-variable-anchor"), F = "globe" === S.projection.name, B = [], k = [
                0,
                -1,
                0
            ];
            for (const r of s){
                const s = i.getTile(r), n = s.getBucket(o);
                if (!n) continue;
                if ("mercator" === n.projection.name && F) continue;
                if (n.fullyClipped) continue;
                const u = "globe" === n.projection.name, _ = u ? e.ah(S.zoom) : 0, p = hi(r, n.getProjection(), S), f = S.calculatePixelsToTileUnitsMatrix(s), T = O && n.hasTextData(), N = n.hasIconTextFit() && T && n.hasIconData(), U = n.getProjection().createInversionMatrix(S, r.canonical), j = (1 << s.tileID.canonical.z) * e.aj / t1.transform.worldSize, V = (e)=>{
                    let i = [
                        0,
                        0,
                        0
                    ];
                    if (e) {
                        const e = t1.style.directionalLight, o = t1.style.ambientLight;
                        e && o && (i = ao(t1.style, e, o));
                    }
                    return i;
                }, G = (e)=>{
                    S.depthOcclusionForSymbolsAndCircles && (o.hasInitialOcclusionOpacityProperties || t1.terrain) && (e.push("DEPTH_D24"), e.push("DEPTH_OCCLUSION"));
                }, q = ()=>{
                    const i = I && "point" !== o.layout.get("symbol-placement"), a = [];
                    G(a);
                    const c = i || N, d = "road" === n.elevationType && R, g = t1.shadowRenderer, T = d && !!g && g.enabled, C = V(T), D = d ? z : P, A = o.paint.get("icon-image-cross-fade");
                    t1.terrainRenderModeElevated() && R && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), c && a.push("PROJECTED_POS_ON_VIEWPORT")), A > 0 && a.push("ICON_TRANSITION"), n.icon.zOffsetVertexBuffer && a.push("Z_OFFSET"), 0 === v && 0 === y && 0 === x && 1 === b || a.push("COLOR_ADJUSTMENT"), n.sdfIcons && a.push("RENDER_SDF"), T && a.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), d && n.icon.orientationVertexBuffer && a.push("ELEVATED_ROADS");
                    const L = n.icon.programConfigurations.get(o.id), O = t1.getOrCreateProgram("symbol", {
                        config: L,
                        defines: a
                    }), B = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], q = n.iconSizeData, Z = e.bH(q, S.zoom), H = R || !S.isOrthographic, W = Zt(p, s.tileID.canonical, R, I, S, n.getProjection(), f), $ = Wt(p, s.tileID.canonical, R, I, S, n.getProjection(), f), X = t1.translatePosMatrix($, s, l, h, !0), Y = t1.translatePosMatrix(p, s, l, h), K = c ? Mr : W, J = I && !R && !i;
                    let Q = k;
                    !F && !S.mercatorFromTransition || I || (Q = Or(S));
                    const ee = u ? Q : k, te = o.getColorAdjustmentMatrix(v, y, x, b), ie = xr(q.kind, Z, J, R, t1, Y, K, X, w, !1, B, [
                        0,
                        0
                    ], 0, r, _, M, U, ee, n.getProjection(), C, j, te, A, null), oe = s.imageAtlasTexture ? s.imageAtlasTexture : null, se = 1 !== o.layout.get("icon-size").constantOr(0) || n.iconsNeedLinear, re = n.sdfIcons || t1.options.rotating || t1.options.zooming || se || H ? E.LINEAR : E.NEAREST, ne = n.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1), ae = t1.terrain && R && i ? e.bi(e.bz(), W) : Mr;
                    if (i && n.icon) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(r, S.center.lat, S.worldSize, n.getProjection()) : null, o = Ht(p, s.tileID.canonical, R, I, S, n.getProjection(), f);
                        Kt(n, p, t1, !1, o, $, R, m, i, r);
                    }
                    return {
                        program: O,
                        buffers: n.icon,
                        uniformValues: ie,
                        atlasTexture: oe,
                        atlasTextureIcon: null,
                        atlasInterpolation: re,
                        atlasInterpolationIcon: null,
                        isSDF: n.sdfIcons,
                        hasHalo: ne,
                        depthMode: D,
                        tile: s,
                        renderWithShadows: T,
                        labelPlaneMatrixInv: ae
                    };
                }, Z = ()=>{
                    const i = C && "point" !== o.layout.get("symbol-placement"), a = [], l = i || O || N, h = "road" === n.elevationType && D, m = t1.shadowRenderer, v = h && !!m && m.enabled, y = V(v), x = h ? z : P;
                    t1.terrainRenderModeElevated() && D && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), l && a.push("PROJECTED_POS_ON_VIEWPORT")), n.text.zOffsetVertexBuffer && a.push("Z_OFFSET"), n.iconsInText && a.push("RENDER_TEXT_AND_SYMBOL"), a.push("RENDER_SDF"), v && a.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), h && n.text.orientationVertexBuffer && a.push("ELEVATED_ROADS"), G(a);
                    const b = n.text.programConfigurations.get(o.id), T = t1.getOrCreateProgram("symbol", {
                        config: b,
                        defines: a
                    });
                    let I, R = [
                        0,
                        0
                    ], A = null;
                    const L = n.textSizeData;
                    n.iconsInText && (R = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], A = s.imageAtlasTexture ? s.imageAtlasTexture : null, I = D || !S.isOrthographic || t1.options.rotating || t1.options.zooming || "composite" === L.kind || "camera" === L.kind ? E.LINEAR : E.NEAREST);
                    const B = s.glyphAtlasTexture ? s.glyphAtlasTexture.size : [
                        0,
                        0
                    ], q = o.layout.get("text-size-scale-range"), Z = e.ay(t1.scaleFactor, q[0], q[1]), H = e.bH(L, S.zoom, Z), W = Zt(p, s.tileID.canonical, D, C, S, n.getProjection(), f), $ = Wt(p, s.tileID.canonical, D, C, S, n.getProjection(), f), X = t1.translatePosMatrix($, s, c, d, !0), Y = t1.translatePosMatrix(p, s, c, d), K = l ? Mr : W, J = C && !D && !i;
                    let Q = k;
                    !F && !S.mercatorFromTransition || C || (Q = Or(S));
                    const ee = xr(L.kind, H, J, D, t1, Y, K, X, w, !0, B, R, 0, r, _, M, U, u ? Q : k, n.getProjection(), y, j, null, null, Z), te = s.glyphAtlasTexture ? s.glyphAtlasTexture : null, ie = E.LINEAR, oe = 0 !== o.paint.get("text-halo-width").constantOr(1), se = t1.terrain && D && i ? e.bi(e.bz(), W) : Mr;
                    if (i && n.text) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(r, S.center.lat, S.worldSize, n.getProjection()) : null, o = Ht(p, s.tileID.canonical, D, C, S, n.getProjection(), f);
                        Kt(n, p, t1, !0, o, $, D, g, i, r);
                    }
                    return {
                        program: T,
                        buffers: n.text,
                        uniformValues: ee,
                        atlasTexture: te,
                        atlasTextureIcon: A,
                        atlasInterpolation: ie,
                        atlasInterpolationIcon: I,
                        isSDF: !0,
                        hasHalo: oe,
                        depthMode: x,
                        tile: s,
                        renderWithShadows: v,
                        labelPlaneMatrixInv: se
                    };
                }, H = n.icon.segments.get().length, W = n.text.segments.get().length, $ = H && !a.onlyText ? q() : null, X = W && !a.onlyIcons ? Z() : null, Y = o.paint.get("icon-opacity").constantOr(1), K = o.paint.get("text-opacity").constantOr(1);
                if (A && n.canOverlap) {
                    L = !0;
                    const t1 = Y && !a.onlyText ? n.icon.segments.get() : [], i = K && !a.onlyIcons ? n.text.segments.get() : [];
                    for (const i of t1)B.push({
                        segments: new e.bd([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: $
                    });
                    for (const t1 of i)B.push({
                        segments: new e.bd([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: X
                    });
                } else a.onlyText || B.push({
                    segments: Y ? n.icon.segments : new e.bd([]),
                    sortKey: 0,
                    state: $
                }), a.onlyIcons || B.push({
                    segments: K ? n.text.segments : new e.bd([]),
                    sortKey: 0,
                    state: X
                });
            }
            L && B.sort((e, t1)=>e.sortKey - t1.sortKey);
            for (const e of B){
                const i = e.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: S.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(S.depthOcclusionForSymbolsAndCircles, i.program), T.activeTexture.set(E.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, E.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (T.activeTexture.set(E.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, E.CLAMP_TO_EDGE, !0)), i.renderWithShadows && t1.shadowRenderer.setupShadows(i.tile.tileID.toUnwrapped(), i.program, "vector-tile", i.tile.tileID.overscaledZ), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const s = i.uniformValues;
                        s.u_is_halo = 1, Nr(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, s, 2), s.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const s = i.uniformValues;
                            i.hasHalo && (s.u_is_halo = 1, Nr(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, s, 1)), s.u_is_halo = 0;
                        }
                        Nr(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, i.uniformValues, 1);
                    }
                }
            }
        }
        function Nr(e, t1, i, o, s, r, n, a, l, c) {
            const h = [
                e.dynamicLayoutVertexBuffer,
                e.opacityVertexBuffer,
                e.iconTransitioningVertexBuffer,
                e.globeExtVertexBuffer,
                e.zOffsetVertexBuffer,
                e.orientationVertexBuffer
            ];
            s.draw(o, o.context.gl.TRIANGLES, r, n, a, qi.disabled, l, i.id, e.layoutVertexBuffer, e.indexBuffer, t1, i.paint, o.transform.zoom, e.programConfigurations.get(i.id), h, c);
        }
        function Ur(t1, i) {
            const o = 1 << t1.canonical.z, s = (i.x * o - t1.canonical.x - t1.wrap * o) * e.aj, r = (i.y * o - t1.canonical.y) * e.aj, n = e.dS(i.z, i.y);
            return e.cS(s, r, n);
        }
        function jr(t1, i, o, s, r) {
            if (!o.layout || "none" === o.layout.get("fill-elevation-reference")) return;
            const n = t1.context.gl, a = new Ni(t1.context.gl.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D), l = new Ni(t1.context.gl.GREATER, Ni.ReadWrite, t1.depthRangeFor3D), c = function(t1) {
                const i = e.cJ(t1.pitch);
                let o = .01;
                return t1.isOrthographic && (o = e.ai(1e-4, o, e.cN(i >= Ji ? 1 : i / Ji))), 2 * o;
            }(t1.transform), h = t1.transform.getFreeCameraOptions().position, d = "elevatedStructuresDepthReconstruct", u = t1.getOrCreateProgram(d, {
                defines: [
                    "DEPTH_RECONSTRUCTION"
                ]
            }), _ = t1.getOrCreateProgram(d);
            for (const e of s){
                const s = i.getTile(e), d = s.getBucket(o);
                if (!d) continue;
                const p = d.elevatedStructures;
                if (!p) continue;
                const f = d.elevationBufferData.heightRange, m = Ur(e.toUnwrapped(), h), g = t1.translatePosMatrix(e.projMatrix, s, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                let v, y, x, b;
                if ("initialize" === r) {
                    if (!f || f.min >= 1 || 0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = nr(g, m, c, 1, 0), y = a, x = p.depthSegments, b = u;
                } else if ("reset" === r) {
                    if (!f || f.min >= 0 || 0 === p.maskSegments.segments[0].primitiveLength) continue;
                    v = nr(g, m, 0, 0, 1), y = l, x = p.maskSegments, b = u;
                } else if ("geometry" === r) {
                    if (0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = nr(g, m, c, 1, 0), y = a, x = p.depthSegments, b = _;
                }
                b.draw(t1, n.TRIANGLES, y, ji.disabled, ki.disabled, qi.disabled, v, o.id, p.vertexBuffer, p.indexBuffer, x, o.paint, t1.transform.zoom);
            }
        }
        function Vr(t1, i, o) {
            const { painter: s, sourceCache: r, layer: n, coords: a, colorMode: l, elevationType: c, terrainEnabled: h, pass: d } = t1, u = s.context.gl, _ = n.paint.get("fill-pattern"), p = n.paint.get("fill-pattern-cross-fade"), f = _.constantOr(null);
            let m = c;
            "road" !== c || i && !h || (m = "none");
            const g = "road" === m, v = t1.painter.shadowRenderer, y = g && !!v && v.enabled, x = new Ni(s.context.gl.LEQUAL, Ni.ReadOnly, s.depthRangeFor3D);
            let b = [
                0,
                0,
                0
            ];
            if (y) {
                const e = s.style.directionalLight, t1 = s.style.ambientLight;
                e && t1 && (b = ao(s.style, e, t1));
            }
            const w = _ && _.constantOr(1), T = (t1, d)=>{
                let _, m, T, E, S;
                d ? (_ = w && !n.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", T = u.LINES) : (_ = w ? "fillPattern" : "fill", T = u.TRIANGLES);
                for (const I of a){
                    const a = r.getTile(I);
                    if (w && !a.patternsLoaded()) continue;
                    const C = a.getBucket(n);
                    if (!C) continue;
                    const R = i ? C.elevationBufferData : C.bufferData;
                    if (R.isEmpty()) continue;
                    s.prepareDrawTile();
                    const D = R.programConfigurations.get(n.id), A = s.isTileAffectedByFog(I), L = [], P = [];
                    g && (L.push("ELEVATED_ROADS"), P.push(R.elevatedLayoutVertexBuffer)), y && L.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), w && (s.context.activeTexture.set(u.TEXTURE0), a.imageAtlasTexture && a.imageAtlasTexture.bind(u.LINEAR, u.CLAMP_TO_EDGE), D.updatePaintBuffers());
                    let z = !1;
                    if (f && a.imageAtlas) {
                        const t1 = a.imageAtlas, i = e.dN.from(f), o = i.getPrimary().scaleSelf(e.q.devicePixelRatio).toString(), s = i.getSecondary(), r = t1.patternPositions.get(o), n = s ? t1.patternPositions.get(s.scaleSelf(e.q.devicePixelRatio).toString()) : null;
                        z = !!r && !!n, r && D.setConstantPatternPositions(r, n);
                    }
                    p > 0 && (z || D.getPatternTransitionVertexBuffer("fill-pattern")) && L.push("FILL_PATTERN_TRANSITION");
                    const M = s.getOrCreateProgram(_, {
                        config: D,
                        overrideFog: A,
                        defines: L
                    }), O = s.translatePosMatrix(I.projMatrix, a, n.paint.get("fill-translate"), n.paint.get("fill-translate-anchor"));
                    y && v.setupShadows(a.tileID.toUnwrapped(), M, "vector-tile", a.tileID.overscaledZ);
                    const F = n.paint.get("fill-emissive-strength");
                    if (d) {
                        E = R.lineIndexBuffer, S = R.lineSegments;
                        const e = s.terrain && s.terrain.renderingToTexture ? s.terrain.drapeBufferSize : [
                            u.drawingBufferWidth,
                            u.drawingBufferHeight
                        ];
                        m = "fillOutlinePattern" === _ && w ? sr(O, F, s, a, e, b, p) : or(O, F, e, b);
                    } else E = R.indexBuffer, S = R.triangleSegments, m = w ? ir(O, F, s, a, b, p) : tr(O, F, b);
                    s.uploadCommonUniforms(s.context, M, I.toUnwrapped());
                    let B = t1;
                    ("road" === c && !h || "offset" === c) && (B = x), M.draw(s, T, B, o || s.stencilModeForClipping(I), l, qi.disabled, m, n.id, R.layoutVertexBuffer, E, S, n.paint, s.transform.zoom, D, P);
                }
            };
            s.renderPass === d && T(s.depthModeForSublayer(1, "opaque" === s.renderPass ? Ni.ReadWrite : Ni.ReadOnly), !1), "none" === m && "translucent" === s.renderPass && n.paint.get("fill-antialias") && T(s.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, Ni.ReadOnly), !0);
        }
        function Gr(t1, i, o, s, r, n, a, l) {
            o.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, d = t1.transform, u = o.paint.get("fill-extrusion-pattern"), _ = o.paint.get("fill-extrusion-pattern-cross-fade"), p = u.constantOr(null), f = u.constantOr(1), m = o.paint.get("fill-extrusion-opacity"), g = t1.style.enable3dLights(), v = o.paint.get(g && !f ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), y = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                v
            ], x = o.layout.get("fill-extrusion-edge-radius"), b = x > 0 && !o.paint.get("fill-extrusion-rounded-roof"), w = b ? 0 : x, T = "globe" === d.projection.name ? e.dV() : 0, E = "globe" === d.projection.name, S = E ? e.ah(d.zoom) : 0, I = [
                e.aD(d.center.lng),
                e.aH(d.center.lat)
            ], C = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), R = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(C ? null : o.lut).toArray01().slice(0, 3), D = o.paint.get("fill-extrusion-flood-light-intensity"), A = o.paint.get("fill-extrusion-vertical-scale"), L = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1), P = o.paint.get("fill-extrusion-height-alignment"), z = o.paint.get("fill-extrusion-base-alignment"), M = eo(t1, o.paint.get("fill-extrusion-cutoff-fade-range")), O = [];
            let F;
            E && O.push("PROJECTION_GLOBE_VIEW"), y[0] > 0 && O.push("FAUX_AO"), b && O.push("ZERO_ROOF_RADIUS"), l && O.push("HAS_CENTROID"), D > 0 && O.push("FLOOD_LIGHT"), M.shouldRenderCutoff && O.push("RENDER_CUTOFF"), L && O.push("RENDER_WALL_MODE");
            const B = "shadow" === t1.renderPass, k = t1.shadowRenderer, N = B && !!k, U = B ? qi.disabled : qi.backCCW;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let j = [
                0,
                0,
                0
            ];
            if (k) {
                const e = t1.style.directionalLight, i = t1.style.ambientLight;
                e && i && (j = ao(t1.style, e, i)), B || (O.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), k.useNormalOffset && O.push("NORMAL_OFFSET")), F = O.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const V = N ? "fillExtrusionDepth" : f ? "fillExtrusionPattern" : "fillExtrusion", G = o.getLayerRenderingStats();
            for (const u of s){
                const s = i.getTile(u), g = s.getBucket(o);
                if (!g || g.projection.name !== d.projection.name) continue;
                let v = !1;
                k && (v = 0 === k.getMaxCascadeForTile(u.toUnwrapped()));
                const x = t1.isTileAffectedByFog(u), b = g.programConfigurations.get(o.id);
                let C = !1;
                if (p && s.imageAtlas) {
                    const t1 = s.imageAtlas, i = e.dN.from(p), o = i.getPrimary().scaleSelf(e.q.devicePixelRatio).toString(), r = i.getSecondary(), n = t1.patternPositions.get(o), a = r ? t1.patternPositions.get(r.scaleSelf(e.q.devicePixelRatio).toString()) : null;
                    C = !!n && !!a, n && b.setConstantPatternPositions(n, a);
                }
                _ > 0 && (C || b.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && O.push("FILL_EXTRUSION_PATTERN_TRANSITION");
                const N = t1.getOrCreateProgram(V, {
                    config: b,
                    defines: v ? F : O,
                    overrideFog: x
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(s, N, {
                    useMeterToDem: !0
                }), !g.centroidVertexBuffer) {
                    const e = N.attributes.a_centroid_pos;
                    void 0 !== e && h.vertexAttrib2f(e, 0, 0);
                }
                !B && k && k.setupShadows(s.tileID.toUnwrapped(), N, "vector-tile", s.tileID.overscaledZ), f && (t1.context.activeTexture.set(h.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers());
                const q = o.paint.get("fill-extrusion-vertical-gradient"), Z = 1 / g.tileToMeter;
                let H;
                if (B && k) {
                    if (Xr(s.tileID, g, t1)) continue;
                    const e = k.calculateShadowPassMatrixFromTile(s.tileID.toUnwrapped());
                    H = Qs(e, w, Z, A, P, z);
                } else {
                    const e = t1.translatePosMatrix(u.expandedProjMatrix, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = d.projection.createInversionMatrix(d, u.canonical);
                    H = f ? er(e, t1, q, m, y, w, Z, u, s, T, P, z, S, I, i, R, A, _) : Js(e, t1, q, m, y, w, Z, u, T, P, z, S, I, i, R, A, D, j);
                }
                t1.uploadCommonUniforms(c, N, u.toUnwrapped(), null, M);
                let W = g.segments;
                if ("mercator" === d.projection.name && !B && (W = g.getVisibleSegments(s.tileID, t1.terrain, t1.transform.getFrustum(0)), !W.get().length)) continue;
                if (G) {
                    if (B) for (const e of W.get())G.numRenderedVerticesInShadowPass += e.primitiveLength;
                    else for (const e of W.get())G.numRenderedVerticesInTransparentPass += e.primitiveLength;
                }
                const $ = [];
                (t1.terrain || l) && $.push(g.centroidVertexBuffer), E && $.push(g.layoutVertexExtBuffer), L && $.push(g.wallVertexBuffer), N.draw(t1, c.gl.TRIANGLES, r, n, a, U, H, o.id, g.layoutVertexBuffer, g.indexBuffer, W, o.paint, t1.transform.zoom, b, $);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        function qr(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y) {
            const x = t1.context, b = x.gl, w = t1.transform, T = t1.transform.zoom, E = [], S = eo(t1, o.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === h ? (E.push("CLEAR_SUBPASS"), y && (E.push("CLEAR_FROM_TEXTURE"), x.activeTexture.set(b.TEXTURE0), y.bind(b.LINEAR, b.CLAMP_TO_EDGE))) : "sdf" === h && E.push("SDF_SUBPASS"), g && E.push("HAS_CENTROID"), S.shouldRenderCutoff && E.push("RENDER_CUTOFF");
            const I = o.layout.get("fill-extrusion-edge-radius"), C = (e, i, s, h, v)=>{
                const b = i.programConfigurations.get(o.id), w = t1.isTileAffectedByFog(e), C = t1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: E,
                    overrideFog: w
                }), R = ((e, t1, i, o, s, r, n, a, l, c, h)=>({
                        u_matrix: t1,
                        u_opacity: i,
                        u_ao_pass: o ? 1 : 0,
                        u_meter_to_tile: s,
                        u_ao: r,
                        u_flood_light_intensity: n,
                        u_flood_light_color: a,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h,
                        u_dynamic_offset: 1
                    }))(0, h, d, c, v, [
                    u,
                    _ * v
                ], p, f, m, T >= 17 ? 0 : I * v, y ? y.size[0] : 0), D = [];
                g && D.push(i.hiddenByLandmarkVertexBuffer), t1.uploadCommonUniforms(x, C, e.toUnwrapped(), null, S), C.draw(t1, x.gl.TRIANGLES, r, n, a, l, R, o.id, i.vertexBuffer, i.indexBuffer, s, o.paint, T, b, D);
            };
            for (const r of s){
                const s = i.getTile(r), n = s.getBucket(o);
                if (!n || n.projection.name !== w.projection.name || !n.groundEffect || n.groundEffect && !n.groundEffect.hasData()) continue;
                const a = n.groundEffect, l = 1 / n.tileToMeter;
                {
                    const e = t1.translatePosMatrix(r.projMatrix, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = a.getDefaultSegment();
                    C(r, a, i, e, l);
                }
                if (v) for(let n = 0; n < 4; n++){
                    const a = e.dT[n](r), c = i.getTile(a);
                    if (!c) continue;
                    const h = c.getBucket(o);
                    if (!h || h.projection.name !== w.projection.name || !h.groundEffect || h.groundEffect && !h.groundEffect.hasData()) continue;
                    const d = h.groundEffect;
                    let u, _;
                    0 === n ? (u = [
                        -8192,
                        0,
                        0
                    ], _ = 1) : 1 === n ? (u = [
                        e.aj,
                        0,
                        0
                    ], _ = 0) : 2 === n ? (u = [
                        0,
                        -8192,
                        0
                    ], _ = 3) : (u = [
                        0,
                        e.aj,
                        0
                    ], _ = 2);
                    const p = d.regionSegments[_];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    e.bo(f, r.projMatrix, u), C(r, d, p, t1.translatePosMatrix(f, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), l);
                }
            }
        }
        function Zr(t1, i, o, s, r, n, a) {
            0 === s.centroidVertexArray.length && s.createCentroidsBuffer();
            const l = n ? n.findDEMTileFor(o) : null;
            if (!(l && l.dem || a)) return;
            n && l && l.dem && s.selfDEMTileTimestamp !== l.dem._timestamp && (s.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], s.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1)=>new e.P(Math.ceil((t1 + e.dX) * e.dY), 0), h = (e)=>{
                const t1 = i.getSource().minzoom, o = (e)=>{
                    const t1 = i.getTileByID(e);
                    if (t1 && t1.hasData()) return t1.getBucket(r);
                }, s = [
                    0,
                    -1,
                    1
                ];
                for (const i of s){
                    if (e.overscaledZ + i < t1) continue;
                    const s = o(e.calculateScaledKey(e.overscaledZ + i));
                    if (s) return s;
                }
            }, d = [
                0,
                0,
                0
            ], u = (t1, i)=>(d[0] = Math.min(t1.min.y, i.min.y), d[1] = Math.max(t1.max.y, i.max.y), d[2] = e.aj - i.min.x > t1.max.x ? i.min.x - e.aj : t1.max.x, d), _ = (t1, i)=>(d[0] = Math.min(t1.min.x, i.min.x), d[1] = Math.max(t1.max.x, i.max.x), d[2] = e.aj - i.min.y > t1.max.y ? i.min.y - e.aj : t1.max.y, d), p = [
                (e, t1)=>u(e, t1),
                (e, t1)=>u(t1, e),
                (e, t1)=>_(e, t1),
                (e, t1)=>_(t1, e)
            ], f = (t1, i, s, r, a, c, h)=>{
                if (!n) return 0;
                const d = [
                    [
                        c ? s : t1,
                        c ? t1 : s,
                        0
                    ],
                    [
                        c ? s : i,
                        c ? i : s,
                        0
                    ]
                ], u = h < 0 ? e.aj + h : h, _ = [
                    c ? u : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : u,
                    0
                ];
                return 0 === s && h < 0 || 0 !== s && h > 0 ? n.getForTilePoints(a, [
                    _
                ], !0, r) : d.push(_), n.getForTilePoints(o, d, !0, l), Math.max(d[0][2], d[1][2], _[2]) / n.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = s.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const r = e.dT[t1](o), l = h(r);
                if (!(l && l instanceof e.dU)) continue;
                const d = n ? n.findDEMTileFor(r) : null;
                if (!(d && d.dem || a)) continue;
                if (n && d && d.dem && s.borderDEMTileTimestamp[t1] !== d.dem._timestamp && (s.borderDoneWithNeighborZ[t1] = -1, s.borderDEMTileTimestamp[t1] = d.dem._timestamp), s.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const u = (t1 < 2 ? 1 : 5) - t1, _ = l.borderDoneWithNeighborZ[u] !== s.canonical.z, v = l.borderFeatureIndices[u];
                let y = 0;
                if (s.canonical.z !== l.canonical.z) {
                    for (const e of i)s.showCentroid(s.featuresOnBorder[e]);
                    if (_) for (const e of v)l.showCentroid(l.featuresOnBorder[e]);
                    s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[u] = s.canonical.z;
                }
                for (const o of i){
                    const i = s.featuresOnBorder[o], n = s.centroidData[i.centroidDataIndex], h = i.borders[t1];
                    let _;
                    for(; y < v.length;){
                        _ = l.featuresOnBorder[v[y]];
                        const e = _.borders[u];
                        if (e[1] > h[0] + 3 || e[0] > h[0] - 3) break;
                        l.showCentroid(_), y++;
                    }
                    if (_ && y < v.length) {
                        const o = y;
                        let x = 0;
                        for(; !(_.borders[u][0] > h[1] - 3) && (x++, ++y !== v.length);)_ = l.featuresOnBorder[v[y]];
                        _ = l.featuresOnBorder[v[o]];
                        let b = !1;
                        if (x >= 1) {
                            const e = _.borders[u];
                            Math.abs(h[0] - e[0]) < 3 && Math.abs(h[1] - e[1]) < 3 && (x = 1, b = !0, y = o + 1);
                        } else if (0 === x) {
                            s.showCentroid(i);
                            continue;
                        }
                        const w = l.centroidData[_.centroidDataIndex];
                        a && b && (((m = n).flags | (g = w).flags) & e.dW ? (m.flags |= e.dW, g.flags |= e.dW) : (m.flags &= 2147483647, g.flags &= 2147483647));
                        const T = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                        if (x > 1) y = o, n.centroidXY = w.centroidXY = new e.P(0, 0);
                        else if (d && d.dem && !T) {
                            const i = p[t1](n, w), o = t1 % 2 ? e.aj - 1 : 0, s = f(i[0], Math.min(e.aj - 1, i[1]), o, d, r, t1 < 2, i[2]);
                            n.centroidXY = w.centroidXY = c(s);
                        } else T ? n.centroidXY = w.centroidXY = new e.P(0, 0) : (n.centroidXY = s.encodeBorderCentroid(i), w.centroidXY = l.encodeBorderCentroid(_));
                        s.writeCentroidToBuffer(n), l.writeCentroidToBuffer(w);
                    } else s.showCentroid(i);
                }
                s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[u] = s.canonical.z;
            }
            var m, g;
            (s.needsCentroidUpdate || !s.centroidVertexBuffer && 0 !== s.centroidVertexArray.length) && s.uploadCentroid(t1);
        }
        const Hr = [
            1,
            0,
            0
        ], Wr = [
            0,
            1,
            0
        ], $r = [
            0,
            0,
            1
        ];
        function Xr(t1, i, o) {
            const s = o.transform, r = o.shadowRenderer;
            if (!r) return !0;
            const n = t1.toUnwrapped(), a = s.tileSize * r._cascades[o.currentShadowCascade].scale;
            let l = i.maxHeight;
            if (s.elevation) {
                const e = s.elevation.getMinMaxForTile(t1);
                e && (l += e.max);
            }
            const c = [
                ...r.shadowDirection
            ];
            c[2] = -c[2];
            const h = r.computeSimplifiedTileShadowVolume(n, l, a, c);
            if (!h) return !1;
            const d = [
                Hr,
                Wr,
                $r,
                c,
                [
                    c[0],
                    0,
                    c[2]
                ],
                [
                    0,
                    c[1],
                    c[2]
                ]
            ], u = "globe" === s.projection.name, _ = s.scaleZoom(a), p = e.cn.fromInvProjectionMatrix(s.invProjMatrix, s.worldSize, _, !u), f = r.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(h.vertices, h.planes, d) || 0 === f.intersectsPrecise(h.vertices, h.planes, d);
        }
        function Yr(t1) {
            return [
                t1[0] * e.dZ,
                t1[1] * e.dZ,
                t1[2] * e.dZ,
                0
            ];
        }
        function Kr(t1, i, o, s, r, n, a, l, c) {
            const h = s.getSource(), d = o.globeSharedBuffers;
            if (!d) return;
            let u, _, p;
            if (i && (u = s.getTile(i)), h instanceof e.aP ? (_ = h.texture, p = e.ds(0, 0, o.transform)) : u && i && (_ = u.texture, p = e.ds(i.canonical.z, i.canonical.x, o.transform)), !_ || !p) return;
            t1 || (p = e.cE(e.bz(), p, [
                1,
                -1,
                1
            ]));
            const f = o.context, m = f.gl, g = "nearest" === r.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR, v = o.colorModeForDrapableLayerRenderPass(n), y = a.defines;
            y.push("GLOBE_POLES");
            const x = new Ni(m.LEQUAL, Ni.ReadWrite, o.depthRangeFor3D), b = Float32Array.from(o.transform.expandedFarZProjMatrix), w = Float32Array.from(e.bh(e.dr(new e.cp(0, 0, 0))));
            o.terrain && o.terrain.prepareDrawTile(), f.activeTexture.set(m.TEXTURE0), _.bind(g, m.CLAMP_TO_EDGE), f.activeTexture.set(m.TEXTURE1), _.bind(g, m.CLAMP_TO_EDGE), "useMipmap" in _ && f.extTextureFilterAnisotropic && o.transform.pitch > 20 && m.texParameterf(m.TEXTURE_2D, f.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f.extTextureFilterAnisotropicMax);
            const [T, E, S, I] = i ? d.getPoleBuffers(i.canonical.z, !1) : d.getPoleBuffers(0, !0), C = r.paint.get("raster-elevation");
            let R;
            t1 ? (R = T, o.renderDefaultNorthPole = 0 !== C) : (R = E, o.renderDefaultSouthPole = 0 !== C);
            const D = Yr(a.mix), A = ((e, t1, i, o, s, r, n, a, l, c, h, d, u)=>_r(e, t1, i, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], o, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, r, [
                    0,
                    0
                ], a, 2, c, h, d, 1, 0, u))(b, w, p, e.ah(o.transform.zoom), 0, r, 0, C, 0, D, a.offset, a.range, n), L = o.getOrCreateProgram("raster", {
                defines: y
            });
            o.uploadCommonUniforms(f, L, null), L.draw(o, m.TRIANGLES, x, c, v, l, A, r.id, R, S, I);
        }
        function Jr(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        function Qr(e, t1, i, o) {
            if (e) return t1 instanceof st && e instanceof Tt ? t1.getTextureDescriptor(e, i, !0) : {
                texture: e.texture,
                mix: Yr(o.mix),
                offset: o.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        var en = e.d_([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class tn {
            constructor(t1, i, o, s){
                const r = {
                    width: o[0],
                    height: o[1],
                    data: null
                }, n = t1.gl;
                this.targetColorTexture = new e.T(t1, r, n.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e.T(t1, r, n.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, s), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const o = this.context.gl, s = i.width * i.height;
                this.particleTexture0 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const r = new e.d$;
                r.reserve(s);
                for(let e = 0; e < s; e++)r.emplaceBack(e);
                this.particleIndexBuffer = this.context.createVertexBuffer(r, en.members, !0), this.particleSegment = e.bd.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e.q.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function on(t1, i, o) {
            if (!t1) return null;
            const s = i.getTextureDescriptor(t1, o, !0);
            if (!s) return null;
            let { texture: r, mix: n, offset: a, tileSize: l, buffer: c, format: h } = s;
            if (!r || !h) return null;
            let d = !1;
            return "uint32" === h && (d = !0, n[3] = 0, n = dr(e.e0, n, [
                0,
                o.paint.get("raster-particle-max-speed")
            ]), a = ur(e.e0, a, [
                0,
                o.paint.get("raster-particle-max-speed")
            ])), {
                texture: r,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: d,
                scale: n,
                offset: a,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function sn(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        const rn = new e.am(1, 0, 0, 1), nn = new e.am(0, 1, 0, 1), an = new e.am(0, 0, 1, 1), ln = new e.am(1, 0, 1, 1), cn = new e.am(0, 1, 1, 1);
        function hn(t1, i, o, s, r, n) {
            for(let a = 0; a < o.length; a++)if (r) {
                const r = 1, l = .8, c = new e.am(s.r * l, s.g * l, s.b * l, 1);
                dn(t1, i, o[a], s, -1, -1, n), dn(t1, i, o[a], s, -1, r, n), dn(t1, i, o[a], s, r, r, n), dn(t1, i, o[a], s, r, -1, n), dn(t1, i, o[a], c, 0, 0, n);
            } else dn(t1, i, o[a], s, 0, 0, n);
        }
        function dn(t1, i, o, s, r, n, a) {
            const l = t1.context, c = t1.transform, h = l.gl, d = "globe" === c.projection.name, u = d ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let _ = e.bw(o.projMatrix);
            if (d && e.ah(c.zoom) > 0) {
                const t1 = e.bg(o.canonical, c), i = e.e1(t1);
                _ = e.az(new Float32Array(16), c.globeMatrix, i), e.az(_, c.projMatrix, _);
            }
            const p = e.bz();
            p[12] += 2 * r / (e.q.devicePixelRatio * c.width), p[13] += 2 * n / (e.q.devicePixelRatio * c.height), e.az(_, p, _);
            const f = t1.getOrCreateProgram("debug", {
                defines: u
            }), m = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(m, f);
            const g = Ni.disabled, v = ji.disabled, y = t1.colorModeForRenderPass(), x = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), d ? m._makeGlobeTileDebugBuffers(t1.context, c) : m._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const b = m._tileDebugBuffer || t1.debugBuffer, w = m._tileDebugIndexBuffer || t1.debugIndexBuffer, T = m._tileDebugSegments || t1.debugSegments;
            if (f.draw(t1, h.LINE_STRIP, g, v, y, qi.disabled, lr(_, s.toPremultipliedRenderColor(null)), x, b, w, T, null, null, null, [
                m._globeTileDebugBorderBuffer
            ]), a) {
                const e = m.latestRawTileData, i = Math.floor((e && e.byteLength || 0) / 1024);
                let s = o.canonical.toString();
                o.overscaledZ !== o.canonical.z && (s += ` => ${o.overscaledZ}`), s += ` ${m.state}`, s += ` ${i}kb`, function(e, t1) {
                    e.initDebugOverlayCanvas();
                    const i = e.debugOverlayCanvas, o = e.context.gl, s = e.debugOverlayCanvas.getContext("2d");
                    s.clearRect(0, 0, i.width, i.height), s.shadowColor = "white", s.shadowBlur = 2, s.lineWidth = 1.5, s.strokeStyle = "white", s.textBaseline = "top", s.font = "bold 36px Open Sans, sans-serif", s.fillText(t1, 5, 5), s.strokeText(t1, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
                }(t1, s);
            }
            const E = i.getTile(o).tileSize, S = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5, I = m._tileDebugTextBuffer || t1.debugBuffer, C = m._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, R = m._tileDebugTextSegments || t1.debugSegments;
            f.draw(t1, h.TRIANGLES, g, v, ki.alphaBlended, qi.disabled, lr(_, e.am.transparent.toPremultipliedRenderColor(null), S), x, I, C, R, null, null, null, [
                m._globeTileDebugTextBuffer
            ]);
        }
        function un(e, t1, i, o) {
            pn(e, 0, t1 + i / 2, e.transform.width, i, o);
        }
        function _n(e, t1, i, o) {
            pn(e, t1 - i / 2, 0, i, e.transform.height, o);
        }
        function pn(t1, i, o, s, r, n) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e.q.devicePixelRatio, o * e.q.devicePixelRatio, s * e.q.devicePixelRatio, r * e.q.devicePixelRatio), a.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        const fn = e.d_([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: mn } = fn;
        function gn(e, t1, i, o) {
            e.emplaceBack(t1, i, o);
        }
        class vn {
            constructor(t1){
                this.vertexArray = new e.e2, this.indices = new e.a_, gn(this.vertexArray, -1, -1, 1), gn(this.vertexArray, 1, -1, 1), gn(this.vertexArray, -1, 1, 1), gn(this.vertexArray, 1, 1, 1), gn(this.vertexArray, -1, -1, -1), gn(this.vertexArray, 1, -1, -1), gn(this.vertexArray, -1, 1, -1), gn(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, mn), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e.bd.simpleSegment(0, 0, 36, 12);
            }
        }
        function yn(t1, i, o, s, r, n) {
            const a = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), d = ((e, t1, i, o, s)=>({
                    u_matrix_3f: e,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ],
                    u_luminance: 5e-5
                }))(e.e4(e.dx(), s), r, h, l.toPremultipliedRenderColor(null), c.toPremultipliedRenderColor(null));
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + n, i.skyboxTexture, 0), o.draw(t1, a.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.frontCW, d, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const xn = e.d_([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class bn {
            constructor(t1){
                const i = new e.e5;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e.a_;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, xn.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e.bd.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const wn = e.d_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class Tn {
            constructor(){
                this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
            }
        }
        class En {
            constructor(t1){
                this.colorModeAlphaBlendedWriteRGB = new ki([
                    1,
                    Bi,
                    1,
                    Bi
                ], e.am.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new ki([
                    1,
                    0,
                    1,
                    0
                ], e.am.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = new Tn, this.updateNeeded = !0, t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "starsCount", {
                    min: 100,
                    max: 16e3,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeMultiplier", {
                    min: .01,
                    max: 2,
                    step: .01
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "intensityRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                });
            }
            update(t1) {
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new bn(i);
                    const t1 = this.params.sizeRange, o = this.params.intensityRange, s = function(t1) {
                        const i = e.e7(30), o = [];
                        for(let s = 0; s < t1; ++s){
                            const t1 = 2 * Math.PI * i(), s = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            o.push(e.cS(Math.cos(s) * Math.cos(t1), Math.cos(s) * Math.sin(t1), Math.sin(s)));
                        }
                        return o;
                    }(this.params.starsCount), r = e.e7(300), n = new e.e6, a = new e.a_;
                    let l = 0;
                    for(let i = 0; i < s.length; ++i){
                        const c = e.bY([], s[i], 200), h = Math.max(0, 1 + .01 * t1 * (1 * r() - .5)), d = Math.max(0, 1 + .01 * o * (1 * r() - .5));
                        n.emplaceBack(c[0], c[1], c[2], -1, -1, h, d), n.emplaceBack(c[0], c[1], c[2], 1, -1, h, d), n.emplaceBack(c[0], c[1], c[2], 1, 1, h, d), n.emplaceBack(c[0], c[1], c[2], -1, 1, h, d), a.emplaceBack(l + 0, l + 1, l + 2), a.emplaceBack(l + 0, l + 2, l + 3), l += 4;
                    }
                    this.starsVx = i.createVertexBuffer(n, wn.members), this.starsIdx = i.createIndexBuffer(a), this.starsSegments = e.bd.simpleSegment(0, 0, n.length, a.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t1, i) {
                const o = t1.context, s = o.gl, r = t1.transform, n = new Ni(s.LEQUAL, Ni.ReadOnly, [
                    0,
                    1
                ]), a = e.ah(r.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : l).toArray01(), d = "none" === i.properties.get("high-color-use-theme"), u = i.properties.get("high-color").toNonPremultipliedRenderColor(d ? null : l).toArray01(), _ = "none" === i.properties.get("space-color-use-theme"), p = i.properties.get("space-color").toNonPremultipliedRenderColor(_ ? null : l).toArray01(), f = 5e-4, m = e.e8(i.properties.get("horizon-blend"), 0, 1, f, .25), g = e.dl(t1, o, r) && m === f ? r.worldSize / (2 * Math.PI * 1.025) - 1 : r.globeRadius, v = t1.frameCounter / 1e3 % 1, y = e.ae(r.globeCenterInViewSpace), x = Math.sqrt(Math.pow(y, 2) - Math.pow(g, 2)), b = Math.acos(x / y), w = (e)=>{
                    const i = "globe" === r.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    e && i.push("ALPHA_PASS");
                    const l = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: i
                    }), c = ((e, t1, i, o, s, r, n, a, l, c, h, d)=>({
                            u_frustum_tl: e,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: o,
                            u_horizon: s,
                            u_transition: r,
                            u_fadeout_range: n,
                            u_color: a,
                            u_high_color: l,
                            u_space_color: c,
                            u_temporal_offset: h,
                            u_horizon_angle: d
                        }))(r.frustumCorners.TL, r.frustumCorners.TR, r.frustumCorners.BR, r.frustumCorners.BL, r.frustumCorners.horizon, a, m, h, u, p, v, b);
                    t1.uploadCommonUniforms(o, l);
                    const d = this.atmosphereBuffer;
                    d && l.draw(t1, s.TRIANGLES, n, ji.disabled, e ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, qi.backCW, c, e ? "atmosphere_glow_alpha" : "atmosphere_glow", d.vertexBuffer, d.indexBuffer, d.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const o = e.ay(i.properties.get("star-intensity"), 0, 1);
                if (0 === o) return;
                const s = t1.context, r = s.gl, n = t1.transform, a = t1.getOrCreateProgram("stars"), l = e.b_([]);
                e.c0(l, l, -n._pitch), e.b$(l, l, -n.angle), e.c0(l, l, e.al(n._center.lat)), e.e9(l, l, -e.al(n._center.lng));
                const c = e.c3(new Float32Array(16), l), h = e.az([], n.starsProjMatrix, c), d = e.e4([], c), u = e.ea([], d), _ = [
                    0,
                    1,
                    0
                ];
                e.dz(_, _, u), e.bY(_, _, this.params.sizeMultiplier);
                const p = [
                    1,
                    0,
                    0
                ];
                e.dz(p, p, u), e.bY(p, p, this.params.sizeMultiplier);
                const f = (m = _, g = p, v = o, {
                    u_matrix: Float32Array.from(h),
                    u_up: m,
                    u_right: g,
                    u_intensity_multiplier: v
                });
                var m, g, v;
                t1.uploadCommonUniforms(s, a), this.starsVx && this.starsIdx && a.draw(t1, r.TRIANGLES, Ni.disabled, ji.disabled, this.colorModeAlphaBlendedWriteRGB, qi.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        function Sn(t1, i) {
            const o = [
                ...t1
            ], s = i.cameraWorldSizeForFog / i.worldSize, r = e.bx([]);
            return e.cE(r, r, [
                s,
                s,
                1
            ]), e.az(o, r, o), e.az(o, i.worldToFogMatrix, o), o;
        }
        function In(t1, i, o, s, r) {
            const n = o.material, a = s.context, { baseColorTexture: l, metallicRoughnessTexture: c } = n.pbrMetallicRoughness, { normalTexture: h, occlusionTexture: d, emissionTexture: u } = n;
            function _(e, i, o) {
                if (e && (t1.push(i), a.activeTexture.set(a.gl.TEXTURE0 + o), e.gfxTexture)) {
                    const { minFilter: t1, magFilter: i, wrapS: o, wrapT: s } = e.sampler;
                    e.gfxTexture.bindExtraParam(t1, i, o, s);
                }
            }
            _(l, "HAS_TEXTURE_u_baseColorTexture", Yi.BaseColor), _(c, "HAS_TEXTURE_u_metallicRoughnessTexture", Yi.MetallicRoughness), _(h, "HAS_TEXTURE_u_normalTexture", Yi.Normal), _(d, "HAS_TEXTURE_u_occlusionTexture", Yi.Occlusion), _(u, "HAS_TEXTURE_u_emissionTexture", Yi.Emission), r && (r.texture || (r.texture = new e.eh(s.context, r.image, [
                r.image.height,
                r.image.height,
                r.image.height
            ], a.gl.RGBA8)), a.activeTexture.set(a.gl.TEXTURE0 + Yi.LUT), r.texture && r.texture.bind(a.gl.LINEAR, a.gl.CLAMP_TO_EDGE), t1.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t1.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t1.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t1.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t1.push("HAS_ATTRIBUTE_a_pbr"), t1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== n.alphaMode && "MASK" !== n.alphaMode || t1.push("UNPREMULT_TEXTURE_IN_SHADER"), n.defined || t1.push("DIFFUSE_SHADED");
            const p = s.shadowRenderer;
            p && (t1.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), p.useNormalOffset && t1.push("NORMAL_OFFSET"));
        }
        function Cn(t1, i, o, s, r, n) {
            const a = o.paint.get("model-opacity").constantOr(1), l = i.context, c = new Ni(i.context.gl.LEQUAL, Ni.ReadWrite, i.depthRangeFor3D), h = i.transform, d = t1.mesh, u = d.material, _ = u.pbrMetallicRoughness, p = i.style.fog;
            let f;
            f = "pixels" === i.transform.projection.zAxisUnit ? [
                ...t1.nodeModelMatrix
            ] : e.az([], s.zScaleMatrix, t1.nodeModelMatrix), e.az(f, s.negCameraPosMatrix, f);
            const m = e.bi([], f);
            e.ee(m, m);
            const g = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = o.paint.get("model-emissive-strength").constantOr(0), y = Er(new Float32Array(t1.worldViewProjection), new Float32Array(f), new Float32Array(m), null, i, a, _.baseColorFactor, u.emissiveFactor, _.metallicFactor, _.roughnessFactor, u, v, o), x = {
                defines: []
            }, b = [], w = i.shadowRenderer;
            w && (w.useNormalOffset = !1), In(x.defines, b, d, i, g ? null : o.lut);
            let T = null;
            if (p) {
                const e = Sn(t1.nodeModelMatrix, i.transform);
                if (T = new Float32Array(e), "globe" !== h.projection.name) {
                    const t1 = d.aabb.min, i = d.aabb.max, [o, s] = p.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                    x.overrideFog = o >= Fe || s >= Fe;
                }
            }
            const E = eo(i, o.paint.get("model-cutoff-fade-range"));
            E.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const S = i.getOrCreateProgram("model", x);
            i.uploadCommonUniforms(l, S, null, T, E), "shadow" !== i.renderPass && w && w.setupShadowsFromMatrix(t1.nodeModelMatrix, S), S.draw(i, l.gl.TRIANGLES, c, r, n, d.material.doubleSided ? qi.disabled : qi.backCCW, y, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, i.transform.zoom, void 0, b);
        }
        function Rn(t1, i, o, s, r, n, a) {
            let l;
            l = "globe" === t1.projection.name ? e.ed(o, t1) : [
                ...o
            ], e.az(l, l, i.matrix);
            const c = e.az([], s, l);
            if (i.meshes) for (const o of i.meshes){
                if ("BLEND" !== o.material.alphaMode) {
                    a.push({
                        mesh: o,
                        depth: 0,
                        modelIndex: r,
                        worldViewProjection: c,
                        nodeModelMatrix: l
                    });
                    continue;
                }
                const i = e.ad([], o.centroid, c);
                !t1.isOrthographic && i[2] <= 0 || n.push({
                    mesh: o,
                    depth: i[2],
                    modelIndex: r,
                    worldViewProjection: c,
                    nodeModelMatrix: l
                });
            }
            if (i.children) for (const e of i.children)Rn(t1, e, o, s, r, n, a);
        }
        function Dn(e, t1, i, o) {
            const s = i.shadowRenderer;
            if (!s) return;
            const r = s.getShadowPassDepthMode(), n = s.getShadowPassColorMode(), a = s.calculateShadowPassMatrixFromMatrix(t1), l = Sr(a);
            i.getOrCreateProgram("modelDepth", {
                defines: i._shadowMapDebug ? [] : [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, r, ji.disabled, n, qi.backCCW, l, o.id, e.vertexBuffer, e.indexBuffer, e.segments, o.paint, i.transform.zoom, void 0, void 0);
        }
        function An(t1, i, o) {
            const s = i.updateZoomBasedPaintProperties(), r = function(t1, i, o) {
                let s, r, n, a = t1.terrain ? t1.terrain.exaggeration() : 0;
                if (t1.terrain && a > 0) {
                    const i = t1.terrain, r = i.findDEMTileFor(o);
                    r && r.dem ? s = e.ei.create(i, o, r) : a = 0;
                }
                if (0 === a && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), a === i.validForExaggeration && (0 === a || s && s._demTile && s._demTile.tileID === i.validForDEMTile.id && s._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
                for(const e in i.instancesPerModel){
                    const t1 = i.instancesPerModel[e];
                    for(let e = 0; e < t1.instancedDataArray.length; ++e){
                        const o = (s ? a * s.getElevationAt(0 | t1.instancedDataArray.float32[16 * e], 0 | t1.instancedDataArray.float32[16 * e + 1], !0, !0) : 0) + t1.instancesEvaluatedElevation[e];
                        t1.instancedDataArray.float32[16 * e + 6] = o, r = r ? Math.min(i.terrainElevationMin, o) : o, n = n ? Math.max(i.terrainElevationMax, o) : o;
                    }
                }
                return i.terrainElevationMin = r || 0, i.terrainElevationMax = n || 0, i.validForExaggeration = a, i.validForDEMTile = s && s._demTile ? {
                    id: s._demTile.tileID,
                    timestamp: s._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(t1, i, o);
            (s || r) && (i.uploaded = !1, i.upload(t1.context));
        }
        const Ln = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new e.cW([
                0,
                0,
                0
            ], [
                e.aj,
                e.aj,
                0
            ])
        };
        function Pn(t1, i) {
            const o = 1 << t1.canonical.z, s = i.getFreeCameraOptions().position, r = i.elevation, n = t1.canonical.x / o, a = (t1.canonical.x + 1) / o, l = t1.canonical.y / o, c = (t1.canonical.y + 1) / o;
            let h = i._centerAltitude;
            if (r) {
                const e = r.getMinMaxForTile(t1);
                e && e.max > h && (h = e.max);
            }
            const d = e.ay(s.x, n, a) - s.x, u = e.ay(s.y, l, c) - s.y, _ = e.c6(h, i.center.lat) - s.z;
            return i._zoomFromMercatorZ(Math.sqrt(d * d + u * u + _ * _));
        }
        function zn(e, t1, i, o, s, r, n) {
            const a = e.context, l = "shadow" === e.renderPass, c = e.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Ni(a.gl.LEQUAL, Ni.ReadWrite, e.depthRangeFor3D), d = e.isTileAffectedByFog(r);
            if (i.meshes) for (const u of i.meshes){
                const _ = [
                    "MODEL_POSITION_ON_GPU"
                ], p = [];
                let f, m, g;
                o.instancedDataArray.length > 20 && _.push("INSTANCED_ARRAYS");
                const v = eo(e, t1.paint.get("model-cutoff-fade-range"));
                if (v.shouldRenderCutoff && _.push("RENDER_CUTOFF"), l && c) f = e.getOrCreateProgram("modelDepth", {
                    defines: _
                }), m = Sr(n.shadowTileMatrix, n.shadowTileMatrix, Float32Array.from(i.matrix)), g = c.getShadowPassColorMode();
                else {
                    In(_, p, u, e, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), f = e.getOrCreateProgram("model", {
                        defines: _,
                        overrideFog: d
                    });
                    const o = u.material, l = o.pbrMetallicRoughness, h = t1.paint.get("model-opacity").constantOr(1), y = t1.paint.get("model-emissive-strength").constantOr(0);
                    m = Er(r.expandedProjMatrix, Float32Array.from(i.matrix), new Float32Array(16), null, e, h, l.baseColorFactor, o.emissiveFactor, l.metallicFactor, l.roughnessFactor, o, y, t1, s), c && (n.shadowUniformsInitialized ? f.setShadowUniformValues(a, c.getShadowUniformValues()) : (c.setupShadows(r.toUnwrapped(), f, "model-tile", r.overscaledZ), n.shadowUniformsInitialized = !0)), g = v.shouldRenderCutoff || h < 1 || "OPAQUE" !== o.alphaMode ? ki.alphaBlended : ki.unblended;
                }
                e.uploadCommonUniforms(a, f, r.toUnwrapped(), null, v);
                const y = u.material.doubleSided ? qi.disabled : qi.backCCW;
                if (o.instancedDataArray.length > 20) p.push(o.instancedDataBuffer), f.draw(e, a.gl.TRIANGLES, h, ji.disabled, g, y, m, t1.id, u.vertexBuffer, u.indexBuffer, u.segments, t1.paint, e.transform.zoom, void 0, p, o.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let s = 0; s < o.instancedDataArray.length; ++s)m[i] = new Float32Array(o.instancedDataArray.arrayBuffer, 64 * s, 16), f.draw(e, a.gl.TRIANGLES, h, ji.disabled, g, y, m, t1.id, u.vertexBuffer, u.indexBuffer, u.segments, t1.paint, e.transform.zoom, void 0, p);
                }
            }
            if (i.children) for (const a of i.children)zn(e, t1, a, o, s, r, n);
        }
        const Mn = [
            1,
            -1,
            1
        ];
        function On(t1, i, o, s) {
            if (!o.modelManager) return !0;
            const r = o.modelManager;
            if (!o.shadowRenderer) return !0;
            const n = o.shadowRenderer, a = i.aabb;
            let l = !0, c = t1.maxHeight;
            if (0 === c) {
                let e = 0;
                for(const i in t1.instancesPerModel){
                    const t1 = r.getModel(i, s);
                    t1 ? e = Math.max(e, Math.max(Math.max(t1.aabb.max[0], t1.aabb.max[1]), t1.aabb.max[2])) : l = !1;
                }
                c = t1.maxScale * e * 1.41 + t1.maxVerticalOffset, l && (t1.maxHeight = c);
            }
            a.max[2] = c, a.min[2] += t1.terrainElevationMin, a.max[2] += t1.terrainElevationMax, e.ad(a.min, a.min, i.tileMatrix), e.ad(a.max, a.max, i.tileMatrix);
            const h = a.intersects(n.getCurrentCascadeFrustum());
            return 0 === o.currentShadowCascade && (t1.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
        }
        function Fn(t1, i) {
            const o = t1.uniformValues.u_cutoff_params[0], s = t1.uniformValues.u_cutoff_params[1], r = t1.uniformValues.u_cutoff_params[2], n = t1.uniformValues.u_cutoff_params[3];
            return s === o || n === r ? 1 : e.ay(((i - o) / (s - o) - r) / (n - r), 0, 1);
        }
        function Bn(t1, i, o, s) {
            if (i.pitch < 20) return 1;
            const r = i.getWorldToCameraMatrix();
            e.az(r, r, t1);
            const n = e.ej(o.min[0], o.min[1], o.min[2], 1);
            let a = e.aA(e.ek(), n, r), l = a, c = a;
            n[1] = o.max[1], a = e.aA(e.ek(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, n[0] = o.max[0], a = e.aA(e.ek(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, n[1] = o.min[1], a = e.aA(e.ek(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c;
            const h = e.ay(s[0], 0, 1), d = 100 * i.pixelsPerMeter * e.ay(s[1], 0, 1), u = e.ay(s[2], 0, 1), _ = e.el(e.ek(), l, c, h), p = Math.tan(.5 * i.fovX), f = -_[2] * p;
            if (0 === d) return _[1] < -Math.abs(f) ? u : 1;
            const m = (-Math.abs(f) - _[1]) / d, g = (e, t1, i)=>(1 - i) * e + i * t1, v = e.ay(g(1, u, m), u, 1);
            return g(1, v, e.ay((i.pitch - 20) / 20, 0, 1));
        }
        class kn {
        }
        class Nn {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, o) {
                {
                    const e = this._storage.get(i.id);
                    if (e) return e.lastUsedFrameIdx = t1, e.buf;
                }
                const s = o.gl, r = s.getBufferParameter(s.ELEMENT_ARRAY_BUFFER, s.BUFFER_SIZE), n = new ArrayBuffer(r), a = new Int16Array(n);
                s.getBufferSubData(s.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n));
                const l = new e.en;
                for(let e = 0; e < r / 2; e += 3){
                    const t1 = a[e], i = a[e + 1], o = a[e + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, o), l.emplaceBack(o, t1);
                }
                const c = o.bindVertexArrayOES.current, h = new kn;
                return h.buf = new Cr(o, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
            }
            update(e) {
                for (const [t1, i] of this._storage)e - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e);
            }
        }
        class Un {
            constructor(e){
                this.occluderSize = 30, this.depthOffset = -0.0001, e.registerParameter(this, [
                    "Occlusion"
                ], "occluderSize", {
                    min: 1,
                    max: 100,
                    step: 1
                }), e.registerParameter(this, [
                    "Occlusion"
                ], "depthOffset", {
                    min: -0.05,
                    max: 0,
                    step: 1e-5
                });
            }
        }
        const jn = e.d_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]);
        class Vn {
            registerParameter() {}
            registerButton() {}
            registerBinding() {}
            refreshUI() {}
        }
        class Gn {
            constructor(e, t1){
                this.revealStart = 11, this.revealRange = 2, e.registerParameter(this, [
                    ...t1,
                    "Reveal"
                ], "revealStart", {
                    min: 0,
                    max: 17,
                    step: .05
                }), e.registerParameter(this, [
                    ...t1,
                    "Reveal"
                ], "revealRange", {
                    min: .1,
                    max: 5.1,
                    step: .05
                });
            }
        }
        const qn = e.d_([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class Zn {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const o = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e.eo, o = new e.a_;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), o.emplaceBack(0, 1, 2), o.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, qn.members), this.vignetteIdx = t1.context.createIndexBuffer(o);
                }
                const s = e.bd.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, o);
                    const e = {
                        u_vignetteShape: (r = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: r.vignetteColor
                    };
                    o.draw(t1, t1.context.gl.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, e, "vignette", this.vignetteVx, this.vignetteIdx, s);
                }
                var r;
            }
        }
        class Hn {
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t1, i) {
                const o = t1.getFreeCameraOptions().position, s = o.toAltitude(), r = o.toLngLat(), n = e.al(r.lng), a = e.al(r.lat), l = t1.pixelsPerMeter / i, c = n * e.eq, h = e.eq * Math.log(Math.tan(Math.PI / 4 + a / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e = -this._offsetYPrev + h, t1 = -this._elevationPrev + s;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = s;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
        }
        function Wn(e, t1) {
            return [
                -(e[0] - Math.floor(e[0] / t1) * t1),
                -(e[1] - Math.floor(e[1] / t1) * t1),
                -(e[2] - Math.floor(e[2] / t1) * t1)
            ];
        }
        function $n(t1) {
            const i = e.e7(1323123451230), o = [];
            for(let s = 0; s < t1; ++s){
                const t1 = 2 * i() - 1, s = 2 * i() - 1, r = 2 * i() - 1;
                o.push(e.cS(t1, s, r));
            }
            return o;
        }
        function Xn(t1, i, o, s, r) {
            const n = e.ay((r - o) / (s - o), 0, 1);
            return (1 - n) * t1 + n * i;
        }
        class Yn {
            constructor(e){
                this._movement = new Hn, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Zn, this._ppmScaleFactor = e;
            }
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const o = t1.transform;
                this._movement.update(o, this._ppmScaleFactor);
                const s = o.starsProjMatrix, r = e.b_([]);
                e.c0(r, r, e.al(90) - o._pitch), e.b$(r, r, -o.angle);
                const n = e.c3(new Float32Array(16), r), a = e.ep(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), l = e.ee([], a), c = e.az([], l, n), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: s,
                    modelviewMatrix: c
                };
            }
        }
        class Kn extends Yn {
            constructor(e){
                super(4.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .5,
                    timeFactor: 1,
                    velocityConeAperture: 0,
                    velocity: 300,
                    boxSize: 2500,
                    dropletSizeX: 1,
                    dropletSizeYScale: 10,
                    distortionStrength: 70,
                    screenThinning: {
                        intensity: .57,
                        start: .46,
                        range: 1.17,
                        fadePower: .17,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: .66,
                        g: .68,
                        b: .74,
                        a: .7
                    },
                    direction: {
                        x: -50,
                        y: -35
                    },
                    shapeDirPower: 2,
                    shapeNormalPower: 1
                }, this._revealParams = new Gn(e.tp, [
                    "Precipitation",
                    "Rain"
                ]), this._vignetteParams = {
                    strength: 1,
                    start: .7,
                    range: 1,
                    fadePower: .4,
                    color: {
                        r: .27,
                        g: .27,
                        b: .27,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = $n(this.particlesCount), o = new e.er, s = new e.a_;
                    let r = 0;
                    const n = e.e7(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], a = [
                            2 * n() - 1,
                            n(),
                            n(),
                            n()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...a), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...a), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, jn.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.rain) return;
                const i = this._params.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, o = t1.transform.zoom;
                if (i.revealStart > o) return;
                const s = Xn(0, 1, i.revealStart, i.revealStart + i.revealRange, o);
                if (!this.particlesVx || !this.particlesIdx) return;
                const r = structuredClone(this._params);
                let n = [
                    -r.direction.x,
                    r.direction.y,
                    -100
                ];
                e.au(n, n);
                const a = structuredClone(this._vignetteParams);
                a.strength *= s, r.overrideStyleParameters || (r.intensity = t1.style.rain.state.density, r.timeFactor = t1.style.rain.state.intensity, r.color = structuredClone(t1.style.rain.state.color), n = structuredClone(t1.style.rain.state.direction), r.screenThinning.intensity = t1.style.rain.state.centerThinning, r.dropletSizeX = t1.style.rain.state.dropletSize[0], r.dropletSizeYScale = t1.style.rain.state.dropletSize[1] / t1.style.rain.state.dropletSize[0], r.distortionStrength = 100 * t1.style.rain.state.distortionStrength, a.strength = 1, a.color = structuredClone(t1.style.rain.state.vignetteColor));
                const l = this.updateOnRender(t1, r.timeFactor), c = t1.context, h = c.gl, d = t1.transform;
                this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e.T(c, {
                    width: t1.width,
                    height: t1.height,
                    data: null
                }, h.RGBA8)), r.distortionStrength > 0 && (c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), h.copyTexSubImage2D(h.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                const u = t1.getOrCreateProgram("rainParticle");
                t1.uploadCommonUniforms(c, u), c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE);
                const _ = [
                    r.color.r,
                    r.color.g,
                    r.color.b,
                    r.color.a
                ], p = (i, o)=>{
                    const s = Wn(this._movement.getPosition(), i), a = r.dropletSizeX, c = r.dropletSizeX * r.dropletSizeYScale, p = t1.width / 2, f = t1.height / 2, m = Xn(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), g = Xn(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), v = Xn(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), y = (x = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: s,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        boxSize: i,
                        rainDropletSize: [
                            a,
                            c
                        ],
                        distortionStrength: r.distortionStrength,
                        rainDirection: n,
                        color: _,
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            p,
                            f
                        ],
                        thinningShape: [
                            m,
                            g,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: v,
                        shapeDirectionalPower: r.shapeDirPower,
                        shapeNormalPower: r.shapeNormalPower,
                        mode: o ? 0 : 1
                    }, {
                        u_modelview: Float32Array.from(x.modelview),
                        u_projection: Float32Array.from(x.projection),
                        u_time: x.time,
                        u_cam_pos: x.camPos,
                        u_texScreen: 0,
                        u_velocityConeAperture: x.velocityConeAperture,
                        u_velocity: x.velocity,
                        u_boxSize: x.boxSize,
                        u_rainDropletSize: x.rainDropletSize,
                        u_distortionStrength: x.distortionStrength,
                        u_rainDirection: x.rainDirection,
                        u_color: x.color,
                        u_screenSize: x.screenSize,
                        u_thinningCenterPos: x.thinningCenterPos,
                        u_thinningShape: x.thinningShape,
                        u_thinningAffectedRatio: x.thinningAffectedRatio,
                        u_thinningParticleOffset: x.thinningParticleOffset,
                        u_shapeDirectionalPower: x.shapeDirectionalPower,
                        u_shapeNormalPower: x.shapeNormalPower,
                        u_mode: x.mode
                    });
                    var x;
                    const b = Math.round(r.intensity * this.particlesCount), w = e.bd.simpleSegment(0, 0, 4 * b, 2 * b);
                    u.draw(t1, h.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, y, "rain_particles", this.particlesVx, this.particlesIdx, w);
                };
                r.distortionStrength > 0 && p(r.boxSize, !0), p(r.boxSize, !1), this._vignette.draw(t1, a);
            }
        }
        const Jn = e.d_([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]);
        class Qn extends Yn {
            constructor(e){
                super(2.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .85,
                    timeFactor: .75,
                    velocityConeAperture: 70,
                    velocity: 40,
                    horizontalOscillationRadius: 4,
                    horizontalOscillationRate: 1.5,
                    boxSize: 2e3,
                    billboardSize: 2,
                    shapeFadeStart: .27,
                    shapeFadePower: .21,
                    screenThinning: {
                        intensity: .4,
                        start: .15,
                        range: 1.4,
                        fadePower: .24,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    },
                    direction: {
                        x: -50,
                        y: -35
                    }
                }, this._revealParams = new Gn(e.tp, [
                    "Precipitation",
                    "Snow"
                ]), this._vignetteParams = {
                    strength: .3,
                    start: .78,
                    range: .46,
                    fadePower: .2,
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = $n(this.particlesCount), o = new e.es, s = new e.a_;
                    let r = 0;
                    const n = e.e7(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], a = n(), l = n(), c = n(), h = [
                            e / t1.length,
                            a,
                            l,
                            c
                        ], d = [
                            n(),
                            n()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...d), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, Jn.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.snow) return;
                const i = structuredClone(this._params);
                let o = [
                    -i.direction.x,
                    i.direction.y,
                    -100
                ];
                e.au(o, o);
                const s = structuredClone(this._vignetteParams), r = i.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, n = t1.transform.zoom;
                if (r.revealStart > n) return;
                const a = Xn(0, 1, r.revealStart, r.revealStart + r.revealRange, n);
                s.strength *= a, i.overrideStyleParameters || (i.intensity = t1.style.snow.state.density, i.timeFactor = t1.style.snow.state.intensity, i.color = structuredClone(t1.style.snow.state.color), o = structuredClone(t1.style.snow.state.direction), i.screenThinning.intensity = t1.style.snow.state.centerThinning, i.billboardSize = 2.79 * t1.style.snow.state.flakeSize, s.strength = 1, s.color = structuredClone(t1.style.snow.state.vignetteColor));
                const l = this.updateOnRender(t1, i.timeFactor);
                if (!this.particlesVx || !this.particlesIdx) return;
                const c = t1.context, h = c.gl, d = t1.transform, u = t1.getOrCreateProgram("snowParticle");
                t1.uploadCommonUniforms(c, u), ((i, s, r)=>{
                    const n = Wn(this._movement.getPosition(), i), a = d.width / 2, c = d.height / 2, _ = Xn(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), p = Xn(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), f = Xn(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), m = (g = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: n,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        horizontalOscillationRadius: r.horizontalOscillationRadius,
                        horizontalOscillationRate: r.horizontalOscillationRate,
                        boxSize: i,
                        billboardSize: 1 * r.billboardSize,
                        simpleShapeParameters: [
                            r.shapeFadeStart,
                            r.shapeFadePower
                        ],
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            a,
                            c
                        ],
                        thinningShape: [
                            _,
                            p,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: f,
                        color: [
                            r.color.r,
                            r.color.g,
                            r.color.b,
                            r.color.a
                        ],
                        direction: o
                    }, {
                        u_modelview: Float32Array.from(g.modelview),
                        u_projection: Float32Array.from(g.projection),
                        u_time: g.time,
                        u_cam_pos: g.camPos,
                        u_velocityConeAperture: g.velocityConeAperture,
                        u_velocity: g.velocity,
                        u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                        u_horizontalOscillationRate: g.horizontalOscillationRate,
                        u_boxSize: g.boxSize,
                        u_billboardSize: g.billboardSize,
                        u_simpleShapeParameters: g.simpleShapeParameters,
                        u_screenSize: g.screenSize,
                        u_thinningCenterPos: g.thinningCenterPos,
                        u_thinningShape: g.thinningShape,
                        u_thinningAffectedRatio: g.thinningAffectedRatio,
                        u_thinningParticleOffset: g.thinningParticleOffset,
                        u_particleColor: g.color,
                        u_direction: g.direction
                    });
                    var g;
                    const v = Math.round(r.intensity * this.particlesCount), y = e.bd.simpleSegment(0, 0, 4 * v, 2 * v);
                    this.particlesVx && this.particlesIdx && u.draw(t1, h.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, m, "snow_particles", this.particlesVx, this.particlesIdx, y);
                })(i.boxSize, 0, i), this._vignette.draw(t1, s);
            }
        }
        const ea = {
            symbol: function(t1, i, o, s, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = ji.disabled, a = t1.colorModeForRenderPass(), l = o.layout.get("text-variable-anchor"), c = o.layout.get("text-size-scale-range"), h = e.ay(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, o, s, r, n, a, l) {
                    const c = i.transform, h = "map" === r, d = "map" === n;
                    for (const i of t1){
                        const t1 = s.getTile(i), r = t1.getBucket(o);
                        if (!r || !r.text || !r.text.segments.get().length) continue;
                        const n = e.bH(r.textSizeData, c.zoom, l), u = hi(i, r.getProjection(), c), _ = c.calculatePixelsToTileUnitsMatrix(t1), p = Zt(u, t1.tileID.canonical, d, h, c, r.getProjection(), _), f = r.hasIconTextFit() && r.hasIconData();
                        n && Br(r, h, d, a, c, p, i, Math.pow(2, c.zoom - t1.tileID.overscaledZ), n, f);
                    }
                }(s, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), r, h);
                const d = 0 !== o.paint.get("icon-opacity").constantOr(1), u = 0 !== o.paint.get("text-opacity").constantOr(1);
                void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (d || u) ? kr(t1, i, o, s, n, a) : (d && kr(t1, i, o, s, n, a, {
                    onlyIcons: !0
                }), u && kr(t1, i, o, s, n, a, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && (zr(t1, i, o, s, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), zr(t1, i, o, s, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("circle-opacity"), n = o.paint.get("circle-stroke-width"), a = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1), c = o.paint.get("circle-emissive-strength");
                if (0 === r.constantOr(1) && (0 === n.constantOr(1) || 0 === a.constantOr(1))) return;
                const h = t1.context, d = h.gl, u = t1.transform, _ = !(!t1.terrain || !t1.terrain.enabled), p = o.layout.get("circle-elevation-reference"), f = t1.depthModeForSublayer(0, Ni.ReadOnly), m = new Ni(t1.context.gl.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D), g = "none" === p || _ ? f : m, v = ji.disabled, y = t1.colorModeForDrapableLayerRenderPass(c), x = "globe" === u.projection.name, b = [
                    e.aD(u.center.lng),
                    e.aH(u.center.lat)
                ], w = [];
                for(let r = 0; r < s.length; r++){
                    const n = s[r], a = i.getTile(n), c = a.getBucket(o);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), d = c.layoutVertexBuffer, _ = c.globeExtVertexBuffer, p = c.indexBuffer, f = e.dK(o), m = [
                        _
                    ], g = t1.isTileAffectedByFog(n);
                    x && f.push("PROJECTION_GLOBE_VIEW"), f.push("DEPTH_D24"), t1.terrain && u.depthOcclusionForSymbolsAndCircles && f.push("DEPTH_OCCLUSION"), c.hasElevation && (f.push("ELEVATED_ROADS"), m.push(c.elevatedLayoutVertexBuffer));
                    const v = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: f,
                        overrideFog: g
                    }), y = u.projection.createInversionMatrix(u, n.canonical), T = {
                        programConfiguration: h,
                        program: v,
                        layoutVertexBuffer: d,
                        dynamicBuffers: m,
                        indexBuffer: p,
                        uniformValues: e.dL(t1, n, a, y, b, o),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)w.push({
                            segments: new e.bd([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: T
                        });
                    } else w.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: T
                    });
                }
                l && w.sort((e, t1)=>e.sortKey - t1.sortKey);
                const T = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const e of w){
                    const { programConfiguration: i, program: s, layoutVertexBuffer: r, dynamicBuffers: n, indexBuffer: a, uniformValues: l, tile: c } = e.state, _ = e.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(c, s, T), t1.uploadCommonUniforms(h, s, c.tileID.toUnwrapped()), s.draw(t1, d.TRIANGLES, g, v, y, qi.disabled, l, o.id, r, a, _, o.paint, u.zoom, i, n);
                }
            },
            heatmap: function(t1, i, o, s) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const r = t1.context, n = r.gl, a = ji.disabled, l = new ki([
                            n.ONE,
                            n.ONE,
                            n.ONE,
                            n.ONE
                        ], e.am.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e, t1, i, o) {
                            const s = e.gl, r = t1.width * o, n = t1.height * o;
                            e.activeTexture.set(s.TEXTURE1), e.viewport.set([
                                0,
                                0,
                                r,
                                n
                            ]);
                            let a = i.heatmapFbo;
                            if (!a || a && (a.width !== r || a.height !== n)) {
                                a && a.destroy();
                                const t1 = s.createTexture();
                                s.bindTexture(s.TEXTURE_2D, t1), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), a = i.heatmapFbo = e.createFramebuffer(r, n, !0, null), function(e, t1, i, o, s, r) {
                                    const n = e.gl;
                                    n.texImage2D(n.TEXTURE_2D, 0, e.extRenderToTextureHalfFloat ? n.RGBA16F : n.RGBA, s, r, 0, n.RGBA, e.extRenderToTextureHalfFloat ? n.HALF_FLOAT : n.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(e, 0, t1, a, r, n);
                            } else s.bindTexture(s.TEXTURE_2D, a.colorAttachment.get()), e.bindFramebuffer.set(a.framebuffer);
                        }(r, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), r.clear({
                            color: e.am.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, d = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], u = h ? qi.frontCCW : qi.disabled, _ = [
                            e.aD(c.center.lng),
                            e.aH(c.center.lat)
                        ];
                        for(let e = 0; e < s.length; e++){
                            const p = s[e];
                            if (i.hasRenderableParent(p)) continue;
                            const f = i.getTile(p), m = f.getBucket(o);
                            if (!m || m.projection.name !== c.projection.name) continue;
                            const g = t1.isTileAffectedByFog(p), v = m.programConfigurations.get(o.id), y = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: d,
                                overrideFog: g
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, y), t1.uploadCommonUniforms(r, y, p.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, p.canonical);
                            y.draw(t1, n.TRIANGLES, Ni.disabled, a, l, u, hr(t1, p, f, b, _, x, o.paint.get("heatmap-intensity")), o.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, o.paint, t1.transform.zoom, v, h ? [
                                m.globeExtVertexBuffer
                            ] : null);
                        }
                        r.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, s = o.gl, r = i.heatmapFbo;
                        if (!r) return;
                        o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, r.colorAttachment.get()), o.activeTexture.set(s.TEXTURE1);
                        let n = i.colorRampTexture;
                        n || (n = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), n.bind(s.LINEAR, s.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, s.TRIANGLES, Ni.disabled, ji.disabled, t1.colorModeForRenderPass(), qi.disabled, ((e, t1, i, o)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("line-opacity"), n = o.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === n.constantOr(1)) return;
                const a = o.paint.get("line-emissive-strength"), l = o.paint.get("line-occlusion-opacity"), c = o.layout.get("line-elevation-reference"), h = "meters" === o.layout.get("line-width-unit"), d = "sea" === c, u = !(!t1.terrain || !t1.terrain.enabled), _ = t1.context, p = _.gl;
                if (o.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
                const f = o.layout.get("line-cross-slope"), m = void 0 !== f, g = f < 1, v = t1.colorModeForDrapableLayerRenderPass(a), y = t1.terrain && t1.terrain.renderingToTexture, x = y ? 1 : e.q.devicePixelRatio, b = o.paint.get("line-dasharray"), w = b.constantOr(1), T = o.layout.get("line-cap"), E = b.constantOr(null), S = T.constantOr(null), I = o.paint.get("line-pattern"), C = I.constantOr(1), R = o.paint.get("line-pattern-cross-fade"), D = I.constantOr(null), A = o.paint.get("line-opacity").constantOr(1);
                let L = !C && 1 !== A || t1.depthOcclusion && l > 0 && l < 1;
                const P = o.paint.get("line-gradient"), z = C ? "linePattern" : "line", M = e.dM(o);
                let O;
                if (y && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (L = !1), 0 !== l && t1.depthOcclusion) {
                    const t1 = o.paint._values["line-opacity"];
                    t1 && t1.value && "constant" === t1.value.kind ? O = t1.value : e.w(`Occlusion opacity for layer ${o.id} is supported only when line-opacity isn't data-driven.`);
                }
                "constant" !== n.value.kind && !1 === n.value.isLineProgressConstant && M.push("VARIABLE_LINE_WIDTH");
                const F = (s, r, n, a, c, u)=>{
                    for (const f of s){
                        const s = i.getTile(f);
                        if (C && !s.patternsLoaded()) continue;
                        const m = s.getBucket(o);
                        if (!m) continue;
                        if ("none" !== m.elevationType && !c || "none" === m.elevationType && c) continue;
                        t1.prepareDrawTile();
                        const g = [
                            ...r
                        ], b = t1.shadowRenderer, T = "road" === m.elevationType && !!b && b.enabled;
                        let I = [
                            0,
                            0,
                            0
                        ];
                        if (T) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (I = ao(t1.style, e, i)), g.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                        }
                        const M = m.programConfigurations.get(o.id);
                        let F = !1;
                        if (D && s.imageAtlas) {
                            const t1 = e.dN.from(D), i = t1.getPrimary().scaleSelf(x).toString(), o = s.imageAtlas.patternPositions.get(i), r = t1.getSecondary(), n = r ? s.imageAtlas.patternPositions.get(r.scaleSelf(x).toString()) : null;
                            F = !!o && !!n, o && M.setConstantPatternPositions(o, n);
                        }
                        R > 0 && (F || M.getPatternTransitionVertexBuffer("line-pattern")) && g.push("LINE_PATTERN_TRANSITION");
                        const B = t1.isTileAffectedByFog(f), k = t1.getOrCreateProgram(z, {
                            config: M,
                            defines: g,
                            overrideFog: B,
                            overrideRtt: !c && void 0
                        });
                        if (!C && E && S && s.lineAtlas) {
                            const e = s.lineAtlas.getDash(E, S);
                            e && M.setConstantPatternPositions(e);
                        }
                        T && b.setupShadows(s.tileID.toUnwrapped(), k, "vector-tile", s.tileID.overscaledZ);
                        let [N, U] = o.paint.get("line-trim-offset");
                        if ("round" === S || "square" === S) {
                            const e = 1;
                            N !== U && (0 === N && (N -= e), 1 === U && (U += e));
                        }
                        const j = y ? f.projMatrix : null, V = h ? 1 / m.tileToMeter / e.aw(s, 1, t1.transform.zoom) : 1, G = h ? 1 / m.tileToMeter / e.aw(s, 1, Math.floor(t1.transform.zoom)) : 1, q = C ? e.dO(t1, s, o, j, x, V, G, [
                            N,
                            U
                        ], I, R) : e.dP(t1, s, o, j, m.lineClipsArray.length, x, V, G, [
                            N,
                            U
                        ], I);
                        if (P) {
                            const s = m.gradients[o.id];
                            let r = s.texture;
                            if (o.gradientVersion !== s.version) {
                                let n = 256;
                                if (o.stepInterpolant) {
                                    const o = i.getSource().maxzoom, s = f.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - f.canonical.z) : 1;
                                    n = e.ay(e.dQ(m.maxLineLength / e.aj * 1024 * s), 256, _.maxTextureSize);
                                }
                                s.gradient = e.dR({
                                    expression: o.gradientExpression(),
                                    evaluationKey: "lineProgress",
                                    resolution: n,
                                    image: s.gradient || void 0,
                                    clips: m.lineClipsArray
                                }), s.texture ? s.texture.update(s.gradient) : s.texture = new e.T(_, s.gradient, p.RGBA8), s.version = o.gradientVersion, r = s.texture;
                            }
                            _.activeTexture.set(p.TEXTURE1), r.bind(o.stepInterpolant ? p.NEAREST : p.LINEAR, p.CLAMP_TO_EDGE);
                        }
                        w && (_.activeTexture.set(p.TEXTURE0), s.lineAtlasTexture && s.lineAtlasTexture.bind(p.LINEAR, p.REPEAT), M.updatePaintBuffers()), C && (_.activeTexture.set(p.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), M.updatePaintBuffers()), c && !d && t1.terrain.setupElevationDraw(s, k), t1.uploadCommonUniforms(_, k, f.toUnwrapped());
                        const Z = (e)=>{
                            null != O && (O.value = A * l), k.draw(t1, p.TRIANGLES, n, e, v, qi.disabled, q, o.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, o.paint, t1.transform.zoom, M, [
                                m.layoutVertexBuffer2,
                                m.patternVertexBuffer,
                                m.zOffsetVertexBuffer
                            ]), null != O && (O.value = A);
                        };
                        if (L && !c) {
                            const e = t1.stencilModeForClipping(f).ref;
                            0 === e && y && _.clear({
                                stencil: 0
                            });
                            const i = {
                                func: p.EQUAL,
                                mask: 255
                            };
                            q.u_alpha_discard_threshold = .8, Z(new ji(i, e, 255, p.KEEP, p.KEEP, p.INVERT)), q.u_alpha_discard_threshold = 0, Z(new ji(i, e, 255, p.KEEP, p.KEEP, p.KEEP));
                        } else q.u_alpha_discard_threshold = L && c && u ? .8 : 0, Z(c ? a : t1.stencilModeForClipping(f));
                    }
                };
                let B = t1.depthModeForSublayer(0, Ni.ReadOnly);
                const k = new Ni(t1.depthOcclusion ? p.GREATER : p.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D);
                if (o.hasNonElevatedBuckets) {
                    const i = !y && t1.terrain;
                    0 !== l && i ? e.w(`Occlusion opacity for layer ${o.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${o.id}.`) : F(s, M, B, ji.disabled, !1, !0);
                }
                if (o.hasElevatedBuckets) {
                    "hd-road-markup" === c ? u || (B = k, M.push("ELEVATED_ROADS")) : (M.push("ELEVATED"), B = k, m && M.push(g ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), d && M.push("ELEVATION_REFERENCE_SEA"));
                    const e = L ? t1.stencilModeFor3D() : ji.disabled;
                    t1.forceTerrainMode = !0, F(s, M, B, e, !0, !0), L && F(s, M, B, e, !0, !1), t1.forceTerrainMode = !1;
                }
                L && (t1.resetStencilClippingMasks(), y && _.clear({
                    stencil: 0
                })), 0 === l || t1.depthOcclusion || y || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
            },
            fill: function(t1, i, o, s) {
                const r = o.paint.get("fill-color"), n = o.paint.get("fill-opacity");
                if (0 === n.constantOr(1)) return;
                const a = o.paint.get("fill-emissive-strength"), l = t1.colorModeForDrapableLayerRenderPass(a), c = o.paint.get("fill-pattern"), h = t1.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === r.constantOr(e.am.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                let d = "none";
                "none" !== o.layout.get("fill-elevation-reference") ? d = "road" : 0 !== o.paint.get("fill-z-offset").constantOr(1) && (d = "offset");
                const u = !(!t1.terrain || !t1.terrain.enabled), _ = {
                    painter: t1,
                    sourceCache: i,
                    layer: o,
                    coords: s,
                    colorMode: l,
                    elevationType: d,
                    terrainEnabled: u,
                    pass: h
                };
                if ("shadow" !== t1.renderPass) {
                    if ("offset" !== d) {
                        if (Vr(_, !1), "road" === d) {
                            const e = !u && "translucent" === t1.renderPass;
                            e && jr(t1, i, o, s, "geometry"), Vr(_, !0, ji.disabled), e && function(e) {
                                const { painter: t1, sourceCache: i, layer: o, coords: s, colorMode: r } = e, n = t1.context.gl, a = e.painter.shadowRenderer, l = !!a && a.enabled, c = new Ni(t1.context.gl.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D);
                                let h = [
                                    0,
                                    0,
                                    0
                                ];
                                if (l) {
                                    const e = t1.style.directionalLight, i = t1.style.ambientLight;
                                    e && i && (h = ao(t1.style, e, i));
                                }
                                const d = (e)=>{
                                    for (const d of s){
                                        const s = i.getTile(d), u = s.getBucket(o);
                                        if (!u) continue;
                                        const _ = u.elevatedStructures;
                                        if (!_) continue;
                                        let p, f;
                                        if (e ? (p = _.renderableBridgeSegments, f = _.bridgeProgramConfigurations.get(o.id)) : (p = _.renderableTunnelSegments, f = _.tunnelProgramConfigurations.get(o.id)), !p || 0 === p.segments[0].primitiveLength) continue;
                                        f.updatePaintBuffers(), t1.prepareDrawTile();
                                        const m = t1.isTileAffectedByFog(d), g = [];
                                        l && g.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                                        const v = t1.getOrCreateProgram("elevatedStructures", {
                                            config: f,
                                            overrideFog: m,
                                            defines: g
                                        }), y = t1.translatePosMatrix(d.projMatrix, s, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                                        l && a.setupShadows(s.tileID.toUnwrapped(), v, "vector-tile", s.tileID.overscaledZ);
                                        const x = rr(y, h);
                                        t1.uploadCommonUniforms(t1.context, v, d.toUnwrapped()), v.draw(t1, n.TRIANGLES, c, ji.disabled, r, qi.backCCW, x, o.id, _.vertexBuffer, _.indexBuffer, p, o.paint, t1.transform.zoom, f, [
                                            _.vertexBufferNormal
                                        ]);
                                    }
                                };
                                d(!0), d(!1);
                            }(_);
                        }
                    } else Vr(_, !1, t1.stencilModeFor3D());
                } else t1.shadowRenderer && "road" === d && !u && function(e) {
                    const { painter: t1, sourceCache: i, layer: o, coords: s } = e, r = t1.context.gl, n = e.painter.shadowRenderer;
                    for (const e of s){
                        const s = i.getTile(e), a = s.getBucket(o);
                        if (!a) continue;
                        const l = a.elevatedStructures;
                        if (!l) continue;
                        if (!l.shadowCasterSegments || 0 === l.shadowCasterSegments.segments[0].primitiveLength) continue;
                        t1.prepareDrawTile();
                        const c = a.bufferData.programConfigurations.get(o.id), h = t1.isTileAffectedByFog(e), d = t1.getOrCreateProgram("elevatedStructuresDepth", {
                            config: c,
                            overrideFog: h
                        }), u = n.calculateShadowPassMatrixFromTile(s.tileID.toUnwrapped());
                        t1.uploadCommonUniforms(t1.context, d, e.toUnwrapped());
                        const _ = {
                            u_matrix: u,
                            u_depth_bias: .001
                        };
                        d.draw(t1, r.TRIANGLES, n.getShadowPassDepthMode(), ji.disabled, n.getShadowPassColorMode(), qi.disabled, _, o.id, l.vertexBuffer, l.indexBuffer, l.shadowCasterSegments, o.paint, t1.transform.zoom, c);
                    }
                }(_);
            },
            "fill-extrusion": function(t1, i, o, s) {
                const r = o.paint.get("fill-extrusion-opacity"), n = t1.context, a = n.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === r) return;
                const h = t1.conflationActive && t1.style.isLayerClipped(o, i.getSource()), d = t1.style.order.indexOf(o.fqid);
                if (h && function(e, t1, i, o, s) {
                    for (const r of o){
                        const o = t1.getTile(r).getBucket(i);
                        o && (o.updateReplacement(r, e.replacementSource, s), o.uploadCentroid(e.context));
                    }
                }(t1, i, o, s, d), l || h) for (const e of s){
                    const s = i.getTile(e).getBucket(o);
                    s && Zr(t1.context, i, e, s, o, l, h);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    const n = t1.shadowRenderer;
                    if (l && r < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.ab) return;
                    const a = n.getShadowPassDepthMode(), c = n.getShadowPassColorMode();
                    Gr(t1, i, o, s, a, ji.disabled, c, h);
                } else if ("translucent" === t1.renderPass) {
                    const d = !o.paint.get("fill-extrusion-pattern").constantOr(1), u = o.paint.get("fill-extrusion-color").constantOr(e.am.white);
                    if (!c && 0 !== u.a) {
                        const e = new Ni(t1.context.gl.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D);
                        1 === r && d ? Gr(t1, i, o, s, e, ji.disabled, ki.unblended, h) : (Gr(t1, i, o, s, e, ji.disabled, ki.disabled, h), Gr(t1, i, o, s, e, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), h), t1.resetStencilClippingMasks());
                    }
                    if (t1.style.enable3dLights() && d && (!l && "globe" !== t1.transform.projection.name || c)) {
                        const r = o.paint.get("fill-extrusion-opacity"), d = o.paint.get("fill-extrusion-ambient-occlusion-intensity"), u = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), _ = o.paint.get("fill-extrusion-flood-light-intensity"), p = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), f = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(p ? null : o.lut).toArray01().slice(0, 3), m = d > 0 && u > 0, g = _ > 0, v = (e, t1, i)=>(1 - i) * e + i * t1, y = (n)=>{
                            const l = t1.depthModeForSublayer(1, Ni.ReadOnly, a.LEQUAL, !0), c = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), p = v(.1, 3, c), m = t1._showOverdrawInspector;
                            if (!m) {
                                const c = new ji({
                                    func: a.ALWAYS,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), m = new ki([
                                    a.ONE,
                                    a.ONE,
                                    a.ONE,
                                    a.ONE
                                ], e.am.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], a.MIN);
                                qr(t1, i, o, s, l, c, m, qi.disabled, n, "sdf", r, d, u, _, f, p, h, !1);
                            }
                            {
                                const c = m ? ji.disabled : new ji({
                                    func: a.EQUAL,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.DECR, a.DECR), g = m ? t1.colorModeForRenderPass() : new ki([
                                    a.ONE_MINUS_DST_ALPHA,
                                    a.DST_ALPHA,
                                    a.ONE,
                                    a.ONE
                                ], e.am.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                qr(t1, i, o, s, l, c, g, qi.disabled, n, "color", r, d, u, _, f, p, h, !1);
                            }
                        };
                        if (c) {
                            const c = (n, l, c)=>{
                                const p = t1.depthModeForSublayer(1, Ni.ReadOnly, a.LEQUAL, !1), m = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), g = v(.1, 3, m);
                                {
                                    const c = new ki([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e.am.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    qr(t1, i, o, s, p, ji.disabled, c, qi.disabled, n, "clear", r, d, u, _, f, g, h, l);
                                }
                                {
                                    const c = new ji({
                                        func: a.ALWAYS,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), m = new ki([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e.am.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a.MIN);
                                    qr(t1, i, o, s, p, c, m, qi.disabled, n, "sdf", r, d, u, _, f, g, h, l);
                                }
                                {
                                    const c = n ? a.ZERO : a.ONE_MINUS_DST_ALPHA, m = new ji({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.DECR, a.DECR), v = new ki([
                                        c,
                                        a.DST_ALPHA,
                                        a.ONE_MINUS_DST_ALPHA,
                                        a.ZERO
                                    ], e.am.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    qr(t1, i, o, s, p, m, v, qi.disabled, n, "color", r, d, u, _, f, g, h, l);
                                }
                                {
                                    const m = new ki([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        n ? a.ZERO : a.ONE
                                    ], e.am.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n ? a.FUNC_ADD : a.MAX);
                                    qr(t1, i, o, s, p, ji.disabled, m, qi.disabled, n, "clear", r, d, u, _, f, g, h, l, c);
                                }
                            };
                            if (m || g) {
                                let i;
                                if (t1.prepareDrawTile(), l) {
                                    const t1 = l.drapeBufferSize[0], o = l.drapeBufferSize[1];
                                    i = l.framebufferCopyTexture, i && (!i || i.size[0] === t1 && i.size[1] === o) || (i && i.destroy(), i = l.framebufferCopyTexture = new e.T(n, new e.r({
                                        width: t1,
                                        height: o
                                    }), a.RGBA8)), i.bind(a.LINEAR, a.CLAMP_TO_EDGE), a.copyTexSubImage2D(a.TEXTURE_2D, 0, 0, 0, 0, 0, t1, o);
                                }
                                m && c(!0, !1, i), g && c(!1, !0, i);
                            }
                        } else m && y(!0), g && y(!1), (m || g) && t1.resetStencilClippingMasks();
                    }
                }
            },
            building: function(e, t1, i, o) {},
            hillshade: function(e, t1, i, o) {
                if ("offscreen" !== e.renderPass && "translucent" !== e.renderPass) return;
                if (e.style.disableElevatedTerrain) return;
                const s = e.context, r = e.terrain && e.terrain.renderingToTexture, [n, a] = "translucent" !== e.renderPass || r ? [
                    {},
                    o
                ] : e.stencilConfigForOverlap(o);
                for (const o of a){
                    const s = t1.getTile(o);
                    if (s.needsHillshadePrepare && "offscreen" === e.renderPass) $o(e, s, i);
                    else if ("translucent" === e.renderPass) {
                        const t1 = e.depthModeForSublayer(0, Ni.ReadOnly), a = i.paint.get("hillshade-emissive-strength"), l = e.colorModeForDrapableLayerRenderPass(a), c = r && e.terrain ? e.terrain.stencilModeForRTTOverlap(o) : n[o.overscaledZ];
                        Ho(e, o, s, i, t1, c, l);
                    }
                }
                s.viewport.set([
                    0,
                    0,
                    e.width,
                    e.height
                ]), e.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, s, r, n) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === o.paint.get("raster-opacity")) return;
                const a = "globe" === t1.transform.projection.name, l = 0 !== o.paint.get("raster-elevation"), c = l && a;
                if (t1.renderElevatedRasterBackface && !c) return;
                const h = t1.context, d = h.gl, u = i.getSource(), _ = function(t1, i, o, s) {
                    const r = i.paint.get("raster-color"), n = "raster-array" === t1.type, a = [], l = i.paint.get("raster-resampling"), c = i.paint.get("raster-color-mix");
                    let h = i.paint.get("raster-color-range");
                    const d = [
                        c[0],
                        c[1],
                        c[2],
                        0
                    ], u = c[3];
                    let _ = "nearest" === l ? s.NEAREST : s.LINEAR;
                    if (n && (a.push("RASTER_ARRAY"), r || a.push("RASTER_COLOR"), "linear" === l && a.push("RASTER_ARRAY_LINEAR"), _ = s.NEAREST, !h && t1.rasterLayers)) {
                        const e = t1.rasterLayers.find(({ id: e })=>e === i.sourceLayer);
                        e && e.fields && e.fields.range && (h = e.fields.range);
                    }
                    if (h = h || [
                        0,
                        1
                    ], r) {
                        a.push("RASTER_COLOR"), o.activeTexture.set(s.TEXTURE2), i.updateColorRamp(h);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), t1.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    }
                    return {
                        mix: d,
                        range: h,
                        offset: u,
                        defines: a,
                        resampling: _
                    };
                }(u, o, h, d);
                if (u instanceof e.aP && !s.length && !a) return;
                const p = o.paint.get("raster-emissive-strength"), f = t1.colorModeForDrapableLayerRenderPass(p), m = t1.terrain && t1.terrain.renderingToTexture, g = !t1.options.moving, v = "nearest" === o.paint.get("raster-resampling") ? d.NEAREST : d.LINEAR;
                if (u instanceof e.aP && !s.length && (u.onNorthPole || u.onSouthPole)) {
                    const e = l ? t1.stencilModeFor3D() : ji.disabled;
                    return void Kr(!!u.onNorthPole, null, t1, i, o, p, _, qi.disabled, e);
                }
                if (!s.length) return;
                const [y, x] = u instanceof e.aP || m ? [
                    {},
                    s
                ] : t1.stencilConfigForOverlap(s), b = x[x.length - 1].overscaledZ;
                c && _.defines.push("PROJECTION_GLOBE_VIEW"), l && _.defines.push("RENDER_CUTOFF");
                const w = (s, r, x)=>{
                    for (const w of s){
                        const s = w.toUnwrapped(), T = i.getTile(w);
                        if (m && (!T || !T.hasData())) continue;
                        h.activeTexture.set(d.TEXTURE0);
                        const E = Qr(T, u, o, _);
                        if (!E || !E.texture) continue;
                        const { texture: S, mix: I, offset: C, tileSize: R, buffer: D } = E;
                        let A, L;
                        m ? (A = Ni.disabled, L = w.projMatrix) : l ? (A = new Ni(d.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D), L = a ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(s, g)) : (A = t1.depthModeForSublayer(w.overscaledZ - b, 1 === o.paint.get("raster-opacity") ? Ni.ReadWrite : Ni.ReadOnly, d.LESS), L = t1.transform.calculateProjMatrix(s, g));
                        const P = t1.terrain && m ? t1.terrain.stencilModeForRTTOverlap(w) : y[w.overscaledZ], z = n ? 0 : o.paint.get("raster-fade-duration");
                        T.registerFadeDuration(z);
                        const M = i.findLoadedParent(w, 0), O = Us(T, M, i, t1.transform, z);
                        let F, B;
                        t1.terrain && t1.terrain.prepareDrawTile(), h.activeTexture.set(d.TEXTURE0), S.bind(v, d.CLAMP_TO_EDGE), h.activeTexture.set(d.TEXTURE1), M ? (M.texture && M.texture.bind(v, d.CLAMP_TO_EDGE), F = Math.pow(2, M.tileID.overscaledZ - T.tileID.overscaledZ), B = [
                            T.tileID.canonical.x * F % 1,
                            T.tileID.canonical.y * F % 1
                        ]) : S.bind(v, d.CLAMP_TO_EDGE), "useMipmap" in S && h.extTextureFilterAnisotropic && t1.transform.pitch > 20 && d.texParameterf(d.TEXTURE_2D, h.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h.extTextureFilterAnisotropicMax);
                        const k = t1.transform;
                        let N;
                        const U = l ? Jr(k) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let j, V, G, q, Z, H = 0;
                        if (c && u instanceof e.aP && u.coordinates.length > 3) j = Float32Array.from(e.bh(e.dr(new e.cp(0, 0, 0)))), V = Float32Array.from(k.globeMatrix), G = Float32Array.from(e.dm(k)), q = [
                            e.aD(k.center.lng),
                            e.aH(k.center.lat)
                        ], N = u.elevatedGlobePerspectiveTransform, Z = u.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (c) {
                            const t1 = e.dn(w.canonical);
                            H = e.dp(t1.getCenter().lat), j = Float32Array.from(e.bh(e.dr(w.canonical))), V = Float32Array.from(k.globeMatrix), G = Float32Array.from(e.dm(k)), q = [
                                e.aD(k.center.lng),
                                e.aH(k.center.lat)
                            ], N = [
                                0,
                                0
                            ], Z = Float32Array.from(e.dq(w.canonical, t1, H, k.worldSize / k._pixelsPerMercatorPixel));
                        } else N = u instanceof e.aP ? u.perspectiveTransform : [
                            0,
                            0
                        ], j = new Float32Array(16), V = new Float32Array(9), G = new Float32Array(16), q = [
                            0,
                            0
                        ], Z = new Float32Array(9);
                        const W = _r(L, j, V, G, Z, B || [
                            0,
                            0
                        ], e.ah(t1.transform.zoom), q, U, F || 1, O, o, N, l ? o.paint.get("raster-elevation") : 0, 2, I, C, _.range, R, D, p), $ = t1.isTileAffectedByFog(w), X = t1.getOrCreateProgram("raster", {
                            defines: _.defines,
                            overrideFog: $
                        });
                        if (t1.uploadCommonUniforms(h, X, s), u instanceof e.aP) {
                            const i = u.elevatedGlobeVertexBuffer, s = u.elevatedGlobeIndexBuffer;
                            if (m || !a) u.boundsBuffer && u.boundsSegments && X.draw(t1, d.TRIANGLES, A, ji.disabled, f, qi.disabled, W, o.id, u.boundsBuffer, t1.quadTriangleIndexBuffer, u.boundsSegments);
                            else if (i && s) {
                                const n = k.zoom <= e.cL ? u.elevatedGlobeSegments : u.getSegmentsForLongitude(k.center.lng);
                                n && X.draw(t1, d.TRIANGLES, A, ji.disabled, f, r, W, o.id, i, s, n);
                            }
                        } else if (c) {
                            A = new Ni(d.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D);
                            const e = t1.globeSharedBuffers;
                            if (e) {
                                const [i, s, n] = e.getGridBuffers(H, !1);
                                X.draw(t1, d.TRIANGLES, A, x || P, t1.colorModeForRenderPass(), r, W, o.id, i, s, n);
                            }
                        } else {
                            const { tileBoundsBuffer: e, tileBoundsIndexBuffer: i, tileBoundsSegments: s } = t1.getTileBoundsBuffers(T);
                            X.draw(t1, d.TRIANGLES, A, P, f, qi.disabled, W, o.id, e, i, s);
                        }
                    }
                    if (!(u instanceof e.aP) && c) for (const e of s){
                        const s = e.canonical.y === (1 << e.canonical.z) - 1;
                        0 === e.canonical.y && Kr(!0, e, t1, i, o, p, _, r, x || ji.disabled), s && Kr(!1, e, t1, i, o, p, _, r === qi.frontCW ? qi.backCW : qi.frontCW, x || ji.disabled);
                    }
                };
                c ? w(x, t1.renderElevatedRasterBackface ? qi.backCW : qi.frontCW, t1.stencilModeFor3D()) : w(x, qi.disabled, void 0), t1.resetStencilClippingMasks();
            },
            "raster-particle": function(t1, i, o, s, r, n) {
                "offscreen" === t1.renderPass && function(t1, i, o, s) {
                    if (!s.length) return;
                    const r = t1.context, n = r.gl, a = i.getSource();
                    if (!(a instanceof st)) return;
                    const l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
                    let c = o.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(e) {
                            const t1 = e * e, i = new Uint8Array(4 * t1), o = function(e) {
                                return e |= 0, e = Math.imul(2747636419 ^ e, 2654435769), e = Math.imul(e ^ e >>> 16, 2654435769), ((e = Math.imul(e ^ e >>> 16, 2654435769)) >>> 0) / 4294967296;
                            }, s = 1 / 1.1;
                            for(let e = 0; e < t1; e++){
                                const t1 = s * (o(2 * e + 0) + fr), r = s * (o(2 * e + 1) + fr), n = 255 * t1 % 1, a = 255 * r % 1, l = n, c = r - a / 255, h = a;
                                i[4 * e + 0] = 255 * (t1 - n / 255), i[4 * e + 1] = 255 * l, i[4 * e + 2] = 255 * c, i[4 * e + 3] = 255 * h;
                            }
                            return i;
                        }(l);
                        c = o.particlePositionRGBAImage = new e.r({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = o.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = r.createFramebuffer(l, l, !0, null)) : h = o.particleFramebuffer = r.createFramebuffer(l, l, !0, null);
                    const d = [];
                    for (const e of s){
                        const t1 = i.getTile(e);
                        if (!(t1 instanceof Tt)) continue;
                        const s = on(t1, a, o);
                        if (!s) continue;
                        const n = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = o.tileFramebuffer;
                        h || (h = o.tileFramebuffer = r.createFramebuffer(n[0], n[1], !0, null));
                        let u = t1.rasterParticleState;
                        u || (u = t1.rasterParticleState = new tn(r, e, n, c));
                        const _ = u.update(o.lastInvalidatedAt);
                        u.particleTextureDimension !== l && u.updateParticleTexture(e, c);
                        const p = u.targetColorTexture;
                        u.targetColorTexture = u.backgroundColorTexture, u.backgroundColorTexture = p;
                        const f = u.particleTexture0;
                        u.particleTexture0 = u.particleTexture1, u.particleTexture1 = f, d.push([
                            e,
                            s,
                            u,
                            _
                        ]);
                    }
                    if (0 === d.length) return;
                    const u = e.q.now(), _ = o.previousDrawTimestamp ? .001 * (u - o.previousDrawTimestamp) : .0167;
                    if (o.previousDrawTimestamp = u, o.hasColorMap()) {
                        r.activeTexture.set(n.TEXTURE0 + 2);
                        let t1 = o.colorRampTexture;
                        t1 || (t1 = o.colorRampTexture = new e.T(r, o.colorRamp, n.RGBA8)), t1.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    }
                    r.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function(t1, i, o) {
                        const s = t1.context, r = s.gl, n = i.tileFramebuffer;
                        s.activeTexture.set(r.TEXTURE0);
                        const a = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of o){
                            const [, , o, h] = c;
                            n.colorAttachment.set(o.targetColorTexture.texture), s.viewport.set([
                                0,
                                0,
                                n.width,
                                n.height
                            ]), s.clear({
                                color: e.am.transparent
                            }), h && (o.backgroundColorTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), l.draw(t1, r.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, a, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, o, d), function(t1, i, o, s) {
                        const r = t1.context, n = r.gl, a = o.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = o.paint.get("raster-particle-max-speed");
                        for (const h of s){
                            const [s, d, u] = h;
                            r.activeTexture.set(n.TEXTURE0 + 0), d.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.colorAttachment.set(u.targetColorTexture.texture);
                            const _ = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: d.defines,
                                overrideFog: !1
                            });
                            r.activeTexture.set(n.TEXTURE0 + 1);
                            const p = d.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e.dT[t1](s));
                            p.push(s);
                            const f = s.canonical.x, m = s.canonical.y;
                            for (const e of p){
                                const r = i.getTile(l ? e.wrapped() : e);
                                if (!r) continue;
                                const a = r.rasterParticleState;
                                if (!a) continue;
                                const h = e.canonical.x + (1 << e.canonical.z) * (e.wrap - s.wrap), u = e.canonical.y;
                                a.particleTexture0.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                                const p = gr(1, a.particleTexture0.size[0], [
                                    h - f,
                                    u - m
                                ], 0, d.texture.size, 2, c, d.textureOffset, d.scale, d.offset);
                                _.draw(t1, n.POINTS, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, p, o.id, a.particleIndexBuffer, void 0, a.particleSegment);
                            }
                        }
                    }(t1, i, o, d), r.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function(t1, i, o, s) {
                        const r = t1.context, n = r.gl, a = i.paint.get("raster-particle-max-speed"), l = s * i.paint.get("raster-particle-speed-factor") * .15, c = function(e) {
                            return Math.pow(e, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        r.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const s of o){
                            const [, o, d] = s;
                            r.activeTexture.set(n.TEXTURE0 + 0), o.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), r.activeTexture.set(n.TEXTURE0 + 1);
                            const u = d.particleTexture0;
                            u.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                            const _ = vr(1, u.size[0], 0, o.texture.size, a, l, c, o.textureOffset, o.scale, o.offset);
                            h.colorAttachment.set(d.particleTexture1.texture), r.clear({
                                color: e.am.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: o.defines
                            }).draw(t1, n.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.disabled, _, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, o, d, _);
                }(t1, i, o, s), "translucent" === t1.renderPass && (function(t1, i, o, s, r) {
                    const n = t1.context, a = n.gl, l = i.getSource().tileSize, c = 5 * (1 - e.af(e.cx, e.cx + 1, t1.transform.zoom)) * l + o.paint.get("raster-particle-elevation"), h = !t1.options.moving, d = "globe" === t1.transform.projection.name;
                    if (!s.length) return;
                    const [u, _] = t1.stencilConfigForOverlap(s), p = [];
                    d && p.push("PROJECTION_GLOBE_VIEW");
                    const f = t1.stencilModeFor3D();
                    for (const s of _){
                        const r = s.toUnwrapped(), l = i.getTile(s);
                        if (!l.rasterParticleState) continue;
                        const _ = l.rasterParticleState, m = 100;
                        l.registerFadeDuration(m);
                        const g = i.findLoadedParent(s, 0), v = Us(l, g, i, t1.transform, m);
                        let y, x;
                        t1.terrain && t1.terrain.prepareDrawTile(), n.activeTexture.set(a.TEXTURE0), _.targetColorTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), n.activeTexture.set(a.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), y = Math.pow(2, g.tileID.overscaledZ - l.tileID.overscaledZ), x = [
                            l.tileID.canonical.x * y % 1,
                            l.tileID.canonical.y * y % 1
                        ]) : _.targetColorTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                        const b = d ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(r, h), w = t1.transform, T = sn(w), E = e.dn(s.canonical), S = e.dp(E.getCenter().lat);
                        let I, C, R, D, A;
                        d ? (I = Float32Array.from(e.bh(e.dr(s.canonical))), C = Float32Array.from(w.globeMatrix), R = Float32Array.from(e.dm(w)), D = [
                            e.aD(w.center.lng),
                            e.aH(w.center.lat)
                        ], A = Float32Array.from(e.dq(s.canonical, E, S, w.worldSize / w._pixelsPerMercatorPixel))) : (I = new Float32Array(16), C = new Float32Array(9), R = new Float32Array(16), D = [
                            0,
                            0
                        ], A = new Float32Array(9));
                        const L = mr(b, I, C, R, A, x || [
                            0,
                            0
                        ], e.ah(t1.transform.zoom), D, T, y || 1, v, c), P = t1.isTileAffectedByFog(s), z = t1.getOrCreateProgram("rasterParticle", {
                            defines: p,
                            overrideFog: P
                        });
                        if (t1.uploadCommonUniforms(n, z, r), d) {
                            const e = new Ni(a.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D), i = 0, s = t1.globeSharedBuffers;
                            if (s) {
                                const [r, n, l] = s.getGridBuffers(S, 0 !== i);
                                z.draw(t1, a.TRIANGLES, e, f, ki.alphaBlended, t1.renderElevatedRasterBackface ? qi.frontCCW : qi.backCCW, L, o.id, r, n, l);
                            }
                        } else {
                            const e = t1.depthModeForSublayer(0, Ni.ReadOnly), i = u[s.overscaledZ], { tileBoundsBuffer: r, tileBoundsIndexBuffer: n, tileBoundsSegments: c } = t1.getTileBoundsBuffers(l);
                            z.draw(t1, a.TRIANGLES, e, i, ki.alphaBlended, qi.disabled, L, o.id, r, n, c);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, o, s), t1.style.map.triggerRepaint());
            },
            background: function(t1, i, o, s) {
                const r = o.paint.get("background-color"), n = "none" === o.paint.get("background-color-use-theme").constantOr("default"), a = o.paint.get("background-opacity"), l = o.paint.get("background-emissive-strength"), c = "viewport" === o.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const h = t1.context, d = h.gl, u = t1.transform, _ = u.tileSize, p = o.paint.get("background-pattern");
                let f;
                if (void 0 !== p) {
                    if (null === p) return;
                    if (f = t1.imageManager.getPattern(e.I.from(p.toString()), o.scope, t1.style.getLut(o.scope)), !f) return;
                }
                const m = !p && 1 === r.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== m) return;
                const g = ji.disabled, v = t1.depthModeForSublayer(0, "opaque" === m ? Ni.ReadWrite : Ni.ReadOnly), y = t1.colorModeForDrapableLayerRenderPass(l), x = p ? "backgroundPattern" : "background";
                let b, w = s;
                if (w || (b = t1.getBackgroundTiles(), w = Object.values(b).map((e)=>e.tileID)), p && (h.activeTexture.set(d.TEXTURE0), t1.imageManager.bind(t1.context, o.scope)), c) {
                    const i = t1.getOrCreateProgram(x, {
                        overrideFog: !1,
                        overrideRtt: !0
                    }), s = new Float32Array(e.bx([])), h = new e.aM(0, 0, 0, 0, 0), u = p ? wr(s, l, a, t1, 0, o.scope, f, c, {
                        tileID: h,
                        tileSize: _
                    }) : br(s, l, a, r.toPremultipliedRenderColor(n ? null : o.lut));
                    i.draw(t1, d.TRIANGLES, v, g, y, qi.disabled, u, o.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                } else for (const e of w){
                    const m = t1.isTileAffectedByFog(e), w = t1.getOrCreateProgram(x, {
                        overrideFog: m
                    }), T = e.toUnwrapped(), E = s ? e.projMatrix : t1.transform.calculateProjMatrix(T);
                    t1.prepareDrawTile();
                    const S = i ? i.getTile(e) : b ? b[e.key] : new wt(e, _, u.zoom, t1), I = p ? wr(E, l, a, t1, 0, o.scope, f, c, {
                        tileID: e,
                        tileSize: _
                    }) : br(E, l, a, r.toPremultipliedRenderColor(n ? null : o.lut));
                    t1.uploadCommonUniforms(h, w, T);
                    const { tileBoundsBuffer: C, tileBoundsIndexBuffer: R, tileBoundsSegments: D } = t1.getTileBoundsBuffers(S);
                    w.draw(t1, d.TRIANGLES, v, g, y, qi.disabled, I, o.id, C, R, D);
                }
            },
            sky: function(t1, i, o) {
                const s = t1._atmosphere ? e.ah(t1.transform.zoom) : 1, r = o.paint.get("sky-opacity") * s;
                if (0 === r) return;
                const n = t1.context, a = o.paint.get("sky-type"), l = new Ni(n.gl.LEQUAL, Ni.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === a ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i, o, s) {
                    const r = t1.context, n = r.gl;
                    let a = i.skyboxFbo;
                    if (!a) {
                        a = i.skyboxFbo = r.createFramebuffer(32, 32, !0, null), i.skyboxGeometry = new vn(r), i.skyboxTexture = r.gl.createTexture(), n.bindTexture(n.TEXTURE_CUBE_MAP, i.skyboxTexture), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_MAG_FILTER, n.LINEAR);
                        for(let e = 0; e < 6; ++e)n.texImage2D(n.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, n.RGBA, 32, 32, 0, n.RGBA, n.UNSIGNED_BYTE, null);
                    }
                    r.bindFramebuffer.set(a.framebuffer), r.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const l = i.getCenter(t1, !0), c = t1.getOrCreateProgram("skyboxCapture"), h = new Float64Array(16);
                    e.bx(h), e.e3(h, h, .5 * -Math.PI), yn(t1, i, c, h, l, 0), e.bx(h), e.e3(h, h, .5 * Math.PI), yn(t1, i, c, h, l, 1), e.bx(h), e.cG(h, h, .5 * -Math.PI), yn(t1, i, c, h, l, 2), e.bx(h), e.cG(h, h, .5 * Math.PI), yn(t1, i, c, h, l, 3), e.bx(h), yn(t1, i, c, h, l, 4), e.bx(h), e.e3(h, h, Math.PI), yn(t1, i, c, h, l, 5), r.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(e, t1, i, o, s) {
                    const r = e.context, n = r.gl, a = e.transform, l = e.getOrCreateProgram("skybox");
                    r.activeTexture.set(n.TEXTURE0), n.bindTexture(n.TEXTURE_CUBE_MAP, t1.skyboxTexture);
                    const c = ((e, t1, i, o, s)=>({
                            u_matrix: e,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: s
                        }))(a.skyboxMatrix, t1.getCenter(e, !1), 0, o, s);
                    e.uploadCommonUniforms(r, l), l.draw(e, n.TRIANGLES, i, ji.disabled, e.colorModeForRenderPass(), qi.backCW, c, "skybox", t1.skyboxGeometry.vertexBuffer, t1.skyboxGeometry.indexBuffer, t1.skyboxGeometry.segment);
                }(t1, o, l, r, c) : "gradient" === a && "sky" === t1.renderPass && function(t1, i, o, s, r) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new vn(n)), n.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e.T(n, i.colorRamp, a.RGBA8)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const d = ((t1, i, o, s, r)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e.al(o),
                            u_opacity: s,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), s, r);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, o, ji.disabled, t1.colorModeForRenderPass(), qi.backCW, d, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, l, r, c);
            },
            custom: function(t1, i, o, s) {
                const r = t1.context, n = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = n.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(n, r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ah(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(n, r.gl, t1.transform.customLayerMatrix());
                            r.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const e = n.renderToTile;
                            if (e) {
                                const i = s[0].canonical, o = {
                                    x: i.x + s[0].wrap * (n.wrapTileId ? 0 : 1 << i.z),
                                    y: i.y,
                                    z: i.z
                                };
                                r.setDepthMode(Ni.disabled), r.setStencilMode(ji.disabled), r.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), e.call(n, r.gl, o), r.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), r.setStencilMode(ji.disabled);
                        const i = "3d" === n.renderingMode ? new Ni(t1.context.gl.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Ni.ReadOnly);
                        if (r.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            n.render(r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ah(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else n.render(r.gl, t1.transform.customLayerMatrix());
                        r.setDirty(), t1.setBaseState(), r.bindFramebuffer.set(null);
                    }
                } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(t1, i, o, s) {
                if ("opaque" === t1.renderPass) return;
                const r = o.paint.get("model-opacity").constantOr(1);
                if (0 === r) return;
                const n = o.paint.get("model-cast-shadows");
                if ("shadow" === t1.renderPass) {
                    if (!n) return;
                    if (t1.terrain && r < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e.ab) return;
                }
                const a = t1.shadowRenderer, l = o.paint.get("model-receive-shadows");
                a && (a.useNormalOffset = !0, l || (a.enabled = !1));
                const c = ()=>{
                    a && (a.useNormalOffset = !0, l || (a.enabled = !0));
                }, h = i.getSource();
                if ("light-beam" === t1.renderPass && "batched-model" !== h.type) return;
                if ("vector" === h.type || "geojson" === h.type) return function(t1, i, o, s, r) {
                    const n = t1.transform;
                    if ("mercator" !== n.projection.name) return void e.w(`Drawing 3D models for ${n.projection.name} projection is not yet implemented`);
                    const a = n.getFreeCameraOptions().position;
                    if (!t1.modelManager) return;
                    const l = t1.modelManager;
                    o.modelManager = l;
                    const c = t1.shadowRenderer;
                    if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const h = o._unevaluatedLayout._values["model-id"], d = Object.assign({}, o.layout.get("model-id").parameters), u = t1.style.order.indexOf(o.fqid);
                    for (const _ of s){
                        const s = i.getTile(_).getBucket(o);
                        if (!s || s.projection.name !== n.projection.name) continue;
                        const p = s.getModelUris();
                        p && !s.modelsRequested && (l.addModelsFromBucket(p, r), s.modelsRequested = !0);
                        const f = Pn(_, n);
                        d.zoom = f;
                        const m = h.possiblyEvaluate(d);
                        if (An(t1, s, _), Ln.shadowUniformsInitialized = !1, Ln.useSingleShadowCascade = !!c && 0 === c.getMaxCascadeForTile(_.toUnwrapped()), "shadow" === t1.renderPass && c) {
                            if (1 === t1.currentShadowCascade && s.isInsideFirstShadowMapFrustum) continue;
                            const i = n.calculatePosMatrix(_.toUnwrapped(), n.worldSize);
                            if (Ln.tileMatrix.set(i), Ln.shadowTileMatrix = Float32Array.from(c.calculateShadowPassMatrixFromMatrix(i)), Ln.aabb.min.fill(0), Ln.aabb.max[0] = Ln.aabb.max[1] = e.aj, Ln.aabb.max[2] = 0, On(s, Ln, t1, o.scope)) continue;
                        }
                        const g = 1 << _.canonical.z, v = [
                            ((a.x - _.wrap) * g - _.canonical.x) * e.aj,
                            (a.y * g - _.canonical.y) * e.aj,
                            a.z * g * e.aj
                        ];
                        t1.conflationActive && Object.keys(s.instancesPerModel).length > 0 && t1.style.isLayerClipped(o, i.getSource()) && s.updateReplacement(_, t1.replacementSource, u, r) && (s.uploaded = !1, s.upload(t1.context));
                        for(let e in s.instancesPerModel){
                            const i = s.instancesPerModel[e];
                            i.features.length > 0 && (e = m.evaluate(i.features[0].feature, {}));
                            const n = l.getModel(e, r);
                            if (n || l.hasURLBeenRequested(e) || s.modelUris.includes(e) || (s.modelUris.push(e), s.modelsRequested = !1), n && n.uploaded) for (const e of n.nodes)zn(t1, o, e, i, v, _, Ln);
                        }
                    }
                }(t1, i, o, s, "vector" === h.type ? o.scope : ""), void c();
                if (!h.loaded()) return;
                if ("batched-model" === h.type) return function(t1, i, o, s) {
                    o.resetLayerRenderingStats(t1);
                    const r = t1.context, n = t1.transform, a = t1.style.fog, l = t1.shadowRenderer;
                    if ("mercator" !== n.projection.name) return void e.w(`Drawing 3D landmark models for ${n.projection.name} projection is not yet implemented`);
                    const c = t1.transform.getFreeCameraOptions().position, h = e.bY([], [
                        c.x,
                        c.y,
                        c.z
                    ], t1.transform.worldSize), d = e.eb([], h), u = e.bx([]), _ = e.ec(n.center.lat, n.zoom), p = e.bn([], [
                        1,
                        1,
                        1 / _
                    ]);
                    e.bo(u, u, d);
                    const f = o.paint.get("model-opacity").constantOr(1), m = new Ni(r.gl.LEQUAL, Ni.ReadWrite, t1.depthRangeFor3D), g = new Ni(r.gl.LEQUAL, Ni.ReadOnly, t1.depthRangeFor3D), v = new e.cW([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), y = "shadow" === t1.renderPass, x = y && l ? l.getCurrentCascadeFrustum() : n.getFrustum(n.scaleZoom(n.worldSize)), b = o.paint.get("model-front-cutoff"), w = b[2] < 1, T = eo(t1, o.paint.get("model-cutoff-fade-range")), E = o.getLayerRenderingStats();
                    (function(e, t1, i, o) {
                        const s = e.terrain ? e.terrain.exaggeration() : 0, r = e.transform.zoom;
                        for (const n of o){
                            const o = t1.getTile(n).getBucket(i);
                            o && (o.setFilter(i.filter), e.conflationActive && o.updateReplacement(n, e.replacementSource), o.evaluateTransform(e, i), e.terrain && s > 0 && o.elevationUpdate(e.terrain, s, n, i.source), o.needsReEvaluation(e, r, i) && o.evaluate(i));
                        }
                    })(t1, i, o, s), function() {
                        let c, d, S;
                        w ? (c = s.length - 1, d = -1, S = -1) : (c = 0, d = s.length, S = 1);
                        const I = new Float64Array(16), C = e.ef(), R = new e.P(0, 0);
                        for(let D = c; D !== d; D += S){
                            const c = s[D], d = i.getTile(c).getBucket(o);
                            if (!d || !d.uploaded) continue;
                            let S = !1;
                            l && (S = 0 === l.getMaxCascadeForTile(c.toUnwrapped()));
                            const A = n.calculatePosMatrix(c.toUnwrapped(), n.worldSize), L = d.modelTraits;
                            !y && w && (e.bi(I, A), e.ad(C, h, I), R.x = C[0], R.y = C[1]);
                            const P = [];
                            d.setFilter(o.filter);
                            for (const i of d.getNodesInfo()){
                                if (i.hiddenByReplacement) continue;
                                if (!i.node.meshes) continue;
                                const o = i.node;
                                let s = 0;
                                t1.terrain && o.elevation && (s = o.elevation * t1.terrain.exaggeration());
                                const r = (()=>{
                                    const t1 = i.aabb;
                                    return v.min = [
                                        ...t1.min
                                    ], v.max = [
                                        ...t1.max
                                    ], v.min[2] += s, v.max[2] += s, e.ad(v.min, v.min, A), e.ad(v.max, v.max, A), v;
                                })(), a = i.evaluatedScale;
                                if (a[0] <= 1 && a[1] <= 1 && a[2] <= 1 && 0 === r.intersects(x)) continue;
                                if (!y && w) {
                                    const t1 = 1 / 6;
                                    i.cameraCollisionOpacity = h[0] > r.min[0] && h[0] < r.max[0] && h[1] > r.min[1] && h[1] < r.max[1] && h[2] * _ < r.max[2] && o.footprint && e.bS(R, o.footprint) ? Math.max(i.cameraCollisionOpacity - t1, 0) : Math.min(1, i.cameraCollisionOpacity + t1);
                                }
                                const l = [
                                    ...A
                                ], d = 1 / e.cU(c.canonical), u = o.anchor ? o.anchor[0] : 0, p = o.anchor ? o.anchor[1] : 0;
                                e.bo(l, l, [
                                    u * (a[0] - 1) + i.evaluatedTranslation[0] * d,
                                    p * (a[1] - 1) + i.evaluatedTranslation[1] * d,
                                    s + i.evaluatedTranslation[2]
                                ]), e.ci(a, e.eg) || e.cE(l, l, a);
                                const m = e.az([], l, o.matrix), g = e.az([], n.expandedFarZProjMatrix, m), E = e.az([], n.expandedFarZProjMatrix, l), S = e.aA([], [
                                    u,
                                    p,
                                    s,
                                    1
                                ], g)[2];
                                o.hidden = !1;
                                let I = f;
                                y || (w && (I *= i.cameraCollisionOpacity, I *= Bn(l, n, i.aabb, b)), I *= Fn(T, S)), 0 !== I ? P.push({
                                    nodeInfo: i,
                                    depth: S,
                                    opacity: I,
                                    wvpForNode: g,
                                    wvpForTile: E,
                                    nodeModelMatrix: m,
                                    tileModelMatrix: l
                                }) : o.hidden = !0;
                            }
                            y || P.sort((e, t1)=>!w || 1 === e.opacity && 1 === t1.opacity ? e.depth < t1.depth ? -1 : 1 : 1 === e.opacity ? -1 : 1 === t1.opacity ? 1 : e.depth > t1.depth ? -1 : 1);
                            for (const i of P){
                                const s = i.nodeInfo, c = s.node;
                                let h = e.az([], p, i.tileModelMatrix);
                                e.az(h, u, h);
                                const d = e.bi([], h);
                                e.ee(d, d), e.cE(d, d, Mn), h = e.az(h, h, c.matrix);
                                const _ = "light-beam" === t1.renderPass, f = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = L & e.em.HasMapboxMeshFeatures, x = v ? 0 : s.evaluatedRMEA[0][2];
                                for(let e = 0; e < c.meshes.length; ++e){
                                    const u = c.meshes[e], p = e === c.lightMeshIndex;
                                    let b = i.wvpForNode;
                                    if (p) {
                                        if (!_ && !t1.terrain && t1.shadowRenderer) {
                                            t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                                            continue;
                                        }
                                        b = i.wvpForTile;
                                    } else if (_) continue;
                                    const w = {
                                        defines: []
                                    }, T = [];
                                    if (!y && l && (l.useNormalOffset = !!u.normalBuffer), In(w.defines, T, u, t1, f ? null : o.lut), v || w.defines.push("DIFFUSE_SHADED"), S && w.defines.push("SHADOWS_SINGLE_CASCADE"), E && (y ? E.numRenderedVerticesInShadowPass += u.vertexArray.length : E.numRenderedVerticesInTransparentPass += u.vertexArray.length), y) {
                                        Dn(u, i.nodeModelMatrix, t1, o);
                                        continue;
                                    }
                                    let I = null;
                                    if (a) {
                                        const e = Sn(i.nodeModelMatrix, t1.transform);
                                        if (I = new Float32Array(e), "globe" !== n.projection.name) {
                                            const t1 = u.aabb.min, i = u.aabb.max, [o, s] = a.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                                            w.overrideFog = o >= Fe || s >= Fe;
                                        }
                                    }
                                    const C = u.material;
                                    let R;
                                    C.occlusionTexture && C.occlusionTexture.offsetScale && (R = C.occlusionTexture.offsetScale, w.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                                    const D = t1.getOrCreateProgram("model", w);
                                    !y && l && l.setupShadowsFromMatrix(i.tileModelMatrix, D, l.useNormalOffset), t1.uploadCommonUniforms(r, D, null, I);
                                    const A = C.pbrMetallicRoughness;
                                    A.metallicFactor = .9, A.roughnessFactor = .5;
                                    const L = Er(new Float32Array(b), new Float32Array(h), new Float32Array(d), new Float32Array(c.matrix), t1, i.opacity, A.baseColorFactor, C.emissiveFactor, A.metallicFactor, A.roughnessFactor, C, x, o, [
                                        0,
                                        0,
                                        0
                                    ], R);
                                    !p && (s.hasTranslucentParts || i.opacity < 1) && D.draw(t1, r.gl.TRIANGLES, m, ji.disabled, ki.disabled, qi.backCCW, L, o.id, u.vertexBuffer, u.indexBuffer, u.segments, o.paint, t1.transform.zoom, void 0, T), D.draw(t1, r.gl.TRIANGLES, p ? g : m, ji.disabled, p || i.opacity < 1 || s.hasTranslucentParts ? ki.alphaBlended : ki.unblended, qi.backCCW, L, o.id, u.vertexBuffer, u.indexBuffer, u.segments, o.paint, t1.transform.zoom, void 0, T);
                                }
                            }
                        }
                    }();
                }(t1, i, o, s), void c();
                if ("model" !== h.type) return;
                const d = h.getModels(), u = [], _ = t1.transform.getFreeCameraOptions().position, p = e.bY([], [
                    _.x,
                    _.y,
                    _.z
                ], t1.transform.worldSize);
                e.eb(p, p);
                const f = [], m = [];
                let g = 0;
                for (const i of d){
                    const s = o.paint.get("model-rotation").constantOr(null), r = o.paint.get("model-scale").constantOr(null), n = o.paint.get("model-translation").constantOr(null);
                    i.computeModelMatrix(t1, s, r, n, !0, !0, !1);
                    const a = e.bx([]), l = e.ec(i.position.lat, t1.transform.zoom), c = e.bn([], [
                        1,
                        1,
                        1 / l
                    ]);
                    e.bo(a, a, p), u.push({
                        zScaleMatrix: c,
                        negCameraPosMatrix: a
                    });
                    for (const e of i.nodes)Rn(t1.transform, e, i.matrix, t1.transform.expandedFarZProjMatrix, g, f, m);
                    g++;
                }
                if (f.sort((e, t1)=>t1.depth - e.depth), "shadow" !== t1.renderPass) {
                    if (1 === r) for (const e of m)Cn(e, t1, o, u[e.modelIndex], ji.disabled, t1.colorModeForRenderPass());
                    else {
                        for (const e of m)Cn(e, t1, o, u[e.modelIndex], ji.disabled, ki.disabled);
                        for (const e of m)Cn(e, t1, o, u[e.modelIndex], t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                        t1.resetStencilClippingMasks();
                    }
                    for (const e of f)Cn(e, t1, o, u[e.modelIndex], ji.disabled, t1.colorModeForRenderPass());
                    c();
                } else {
                    for (const e of m)Dn(e.mesh, e.nodeModelMatrix, t1, o);
                    for (const e of f)Dn(e.mesh, e.nodeModelMatrix, t1, o);
                    c();
                }
            }
        }, ta = {
            line: function(e, t1, i) {
                if (e.hasElevatedBuckets = !1, e.hasNonElevatedBuckets = !1, void 0 !== e._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e._unevaluatedLayout.getValue("line-z-offset")) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const o of i){
                            const i = t1.getTile(o).getBucket(e);
                            if (i && ("none" !== i.elevationType ? e.hasElevatedBuckets = !0 : e.hasNonElevatedBuckets = !0, e.hasElevatedBuckets && e.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e.hasNonElevatedBuckets = !0;
            },
            model: function(e, t1, i) {
                const o = t1.getSource();
                if (!o.loaded()) return;
                if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, "vector" === o.type ? e.scope : ""));
                if ("batched-model" === o.type) return;
                if ("model" !== o.type) return;
                const s = o.getModels();
                for (const e of s)e.upload(i.context);
            },
            raster: function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof st && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const n = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of n)e.updateNeeded(s, r) && o.prepareTile(e, s, r);
            },
            "raster-particle": function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof st && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-particle-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const n = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of n)e.updateNeeded(s, r) && o.prepareTile(e, s, r);
            }
        }, ia = {
            fill: jr
        }, oa = {
            fill: function(e, t1, i, o) {
                if (!i.layout || "none" === i.layout.get("fill-elevation-reference")) return;
                const s = e.context.gl, r = new Ni(s.LEQUAL, Ni.ReadOnly, e.depthRangeFor3D), n = new ji({
                    func: s.ALWAYS,
                    mask: 255
                }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), a = e.transform.getFreeCameraOptions().position, l = e.getOrCreateProgram("elevatedStructuresDepthReconstruct", {
                    defines: [
                        "DEPTH_RECONSTRUCTION"
                    ]
                });
                for (const c of o){
                    const o = t1.getTile(c), h = o.getBucket(i);
                    if (!h) continue;
                    const d = h.elevatedStructures;
                    if (!d || 0 === d.maskSegments.segments[0].primitiveLength) continue;
                    const u = Ur(c.toUnwrapped(), a), _ = e.translatePosMatrix(c.projMatrix, o, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), p = nr(_, u, 0, 0, 0);
                    l.draw(e, s.TRIANGLES, r, n, ki.disabled, qi.disabled, p, i.id, d.vertexBuffer, d.indexBuffer, d.maskSegments, i.paint, e.transform.zoom);
                }
            }
        };
        class sa {
            constructor(t1, i, o, s, r, n){
                this.context = new Lr(t1, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r, this._timeStamp = e.q.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
                    forceEnablePrecipitation: !1,
                    showTerrainProxyTiles: !1,
                    fpsWindow: 30,
                    continousRedraw: !1,
                    enabledLayers: {}
                };
                const a = [
                    "fill",
                    "line",
                    "symbol",
                    "circle",
                    "heatmap",
                    "fill-extrusion",
                    "building",
                    "raster",
                    "raster-particle",
                    "hillshade",
                    "model",
                    "background",
                    "sky"
                ];
                for (const e of a)this._debugParams.enabledLayers[e] = !0;
                r.registerParameter(this._debugParams, [
                    "Terrain"
                ], "showTerrainProxyTiles", {}, ()=>{
                    this.style.map.triggerRepaint();
                }), r.registerParameter(this._debugParams, [
                    "Precipitation"
                ], "forceEnablePrecipitation"), r.registerParameter(this._debugParams, [
                    "FPS"
                ], "fpsWindow", {
                    min: 1,
                    max: 100,
                    step: 1
                }), r.registerBinding(this._debugParams, [
                    "FPS"
                ], "continousRedraw", {
                    readonly: !0,
                    label: "continuous redraw"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "value"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "graph",
                    view: "graph",
                    min: 0,
                    max: 200
                });
                for (const e of a)r.registerParameter(this._debugParams.enabledLayers, [
                    "Debug",
                    "Layers"
                ], e);
                this.occlusionParams = new Un(r), this.setup(), this.numSublayers = It.maxUnderzooming + It.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e.et, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new so(this), this._wireframeDebugCache = new Nn, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const l = new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e.T(this.context, l, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = s, this.worldview = n;
            }
            updateTerrain(e, t1) {
                const i = !!e && !!e.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new qs(this, e));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e, this.transform, t1), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
            }
            _updateFog(e) {
                const t1 = e.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const s = i + .78 * (o - i);
                this.transform.fogCullDistSq = s * s;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e) {
                e && !this._terrain && (this._terrain = new qs(this, this.style)), this._forceTerrainMode = e;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e.q.devicePixelRatio, this.height = i * e.q.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e of this.style.order)this.style._mergedLayers[e].resize();
            }
            setup() {
                const t1 = this.context, i = new e.ba;
                i.emplaceBack(0, 0), i.emplaceBack(e.aj, 0), i.emplaceBack(0, e.aj), i.emplaceBack(e.aj, e.aj), this.tileExtentBuffer = t1.createVertexBuffer(i, e.bc.members), this.tileExtentSegments = e.bd.simpleSegment(0, 0, 4, 2);
                const o = new e.ba;
                o.emplaceBack(0, 0), o.emplaceBack(e.aj, 0), o.emplaceBack(0, e.aj), o.emplaceBack(e.aj, e.aj), this.debugBuffer = t1.createVertexBuffer(o, e.bc.members), this.debugSegments = e.bd.simpleSegment(0, 0, 4, 5);
                const s = new e.ba;
                s.emplaceBack(-1, -1), s.emplaceBack(1, -1), s.emplaceBack(-1, 1), s.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(s, e.bc.members), this.viewportSegments = e.bd.simpleSegment(0, 0, 4, 2);
                const r = new e.aZ;
                r.emplaceBack(0, 0, 0, 0), r.emplaceBack(e.aj, 0, e.aj, 0), r.emplaceBack(0, e.aj, 0, e.aj), r.emplaceBack(e.aj, e.aj, e.aj, e.aj), this.mercatorBoundsBuffer = t1.createVertexBuffer(r, e.bf.members), this.mercatorBoundsSegments = e.bd.simpleSegment(0, 0, 4, 2);
                const n = new e.a_;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(n);
                const a = new e.bb;
                for (const e of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e.T(t1, new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e.bz();
                const l = this.context.gl;
                this.stencilClearMode = new ji({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e) {
                return e._makeTileBoundsBuffers(this.context, this.transform.projection), e._tileBoundsBuffer ? {
                    tileBoundsBuffer: e._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e._tileBoundsIndexBuffer,
                    tileBoundsSegments: e._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e.TRIANGLES, Ni.disabled, this.stencilClearMode, ki.disabled, qi.disabled, Ns(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e, t1, i) {
                if (!t1 || this.currentStencilSource === t1.id || !e.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e = !1;
                    for (const t1 of i)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e = !0;
                        break;
                    }
                    if (!e) return;
                }
                this.currentStencilSource = t1.id;
                const o = this.context, s = o.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), o.setColorMode(ki.disabled), o.setDepthMode(Ni.disabled);
                const r = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e of i){
                    const i = t1.getTile(e), o = this._tileClippingMaskIDs[e.key] = this.nextStencilID++, { tileBoundsBuffer: n, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    r.draw(this, s.TRIANGLES, Ni.disabled, new ji({
                        func: s.ALWAYS,
                        mask: 0
                    }, o, 255, s.KEEP, s.KEEP, s.REPLACE), ki.disabled, qi.disabled, Ns(e.projMatrix), "$clipping", n, a, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e = this.nextStencilID++, t1 = this.context.gl;
                return new ji({
                    func: t1.NOTEQUAL,
                    mask: 255
                }, e, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilModeForClipping(e) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e);
                const t1 = this.context.gl;
                return new ji({
                    func: t1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e.key], 0, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilConfigForOverlap(e) {
                const t1 = this.context.gl, i = e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ), o = i[i.length - 1].overscaledZ, s = i[0].overscaledZ - o + 1;
                if (s > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + s > 256 && this.clearStencil();
                    const e = {};
                    for(let i = 0; i < s; i++)e[i + o] = new ji({
                        func: t1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
                    return this.nextStencilID += s, [
                        e,
                        i
                    ];
                }
                return [
                    {
                        [o]: ji.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new ki([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e.am(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? ki.unblended : ki.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new ki([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e.am(0, 0, 0, void 0 === t1 ? 0 : t1), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e, t1, i, o = !1) {
                if (this.depthOcclusion) return new Ni(this.context.gl.GREATER, Ni.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !o) return Ni.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
                return new Ni(i || this.context.gl.LEQUAL, t1, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), o = Math.ceil(this.height), s = this.context.bindFramebuffer.get(), r = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new Ar(this.context, i, o, !1, "texture"), this.depthTexture = new e.T(this.context, {
                    width: i,
                    height: o,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(s), t1.bindTexture(t1.TEXTURE_2D, r), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
                this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e, t1)=>e + t1 / this._fpsHistory.length, 0));
            }
            render(t1, i) {
                const o = e.q.now();
                this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t1.map.repaint, this.style = t1, this.options = i;
                const s = this.style._mergedLayers, r = !(!this.terrain || !this.terrain.enabled), n = ()=>this.style._getOrder(r).filter((e)=>{
                        const t1 = s[e];
                        return !(t1.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t1.type];
                    });
                let a = n(), l = !1, c = !1;
                for (const e of a){
                    const t1 = s[e];
                    "circle" === t1.type && (l = !0), "symbol" === t1.type && (t1.hasInitialOcclusionOpacityProperties ? c = !0 : l = !0);
                }
                let h = a.map((e)=>s[e]);
                const d = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e.q.now()), this.imageManager.beginFrame();
                let u = 0, _ = !1;
                for(const e in d){
                    const t1 = d[e];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++u);
                }
                let p = !1;
                for (const e of h)e.isHidden(this.transform.zoom) || ("clip" === e.type && (p = !0), this.prepareLayer(e));
                const f = {}, m = {}, g = {}, v = {}, y = {};
                for(const e in d){
                    const t1 = d[e];
                    f[e] = t1.getVisibleCoordinates(), m[e] = f[e].slice().reverse(), g[e] = t1.getVisibleCoordinates(!0).reverse(), v[e] = t1.getShadowCasterCoordinates(), y[e] = t1.sortCoordinatesByDistance(f[e]);
                }
                const x = (e)=>{
                    const t1 = this.style.getLayerSourceCache(e);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (u || p || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let o = 0;
                    for (const e of h)this.isSourceForClippingOrConflation(e, x(e)) && (t1.push(e), i.push(o)), o++;
                    if (t1 && (p || t1.length > 1) || this._clippingActiveLastFrame) {
                        p = !1;
                        const o = [];
                        for(let s = 0; s < t1.length; s++){
                            const r = t1[s], n = i[s], a = this.style.getLayerSourceCache(r);
                            if (!a || !a.used || !a.getSource().usedInConflation && "clip" !== r.type) continue;
                            let l = e.eu, c = e.bQ.None;
                            const h = [];
                            let d = !0;
                            if ("clip" === r.type) {
                                l = n;
                                for (const t1 of r.layout.get("clip-layer-types"))c |= "model" === t1 ? e.bQ.Model : "symbol" === t1 ? e.bQ.Symbol : e.bQ.FillExtrusion;
                                for (const e of r.layout.get("clip-layer-scope"))h.push(e);
                                r.isHidden(this.transform.zoom) ? d = !1 : p = !0;
                            }
                            d && o.push({
                                layer: r.fqid,
                                cache: a,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(o), _ = !0;
                    }
                }
                this._clippingActiveLastFrame = p, _ || this.replacementSource.clear(), this.conflationActive = _, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e = 0; e < h.length; e++){
                    const t1 = h[e], i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e = x(t1);
                        e && (this.minCutoffZoom = Math.max(e.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D(r) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e), this._lastOcclusionLayer = e);
                }
                const b = this.style && this.style.fog;
                b ? (this._fogVisible = 0 !== b.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = b.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(g), this.opaquePassCutoff = 0, a = n(), h = a.map((e)=>s[e]));
                const w = this._shadowRenderer;
                if (w) {
                    w.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e in d)for (const t1 of f[e]){
                        let e = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e = this.terrain.getMinMaxForTile(t1) || e), w.addShadowReceiver(t1.toUnwrapped(), e.min, e.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.ev(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new En(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                const T = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), E = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
                if (T && !this._snow && (this._snow = new Qn(this)), !T && this._snow && (this._snow.destroy(), delete this._snow), E && !this._rain && (this._rain = new Kn(this)), !E && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), !U.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e of h){
                    const i = t1.getLayerSourceCache(e);
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const o = i ? m[i.id] : void 0;
                    ("custom" === e.type || "raster" === e.type || "raster-particle" === e.type || e.isSky() || o && o.length) && this.renderLayer(this, i, e, o);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (h.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, v)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const S = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), I = (()=>{
                    if (i.showOverdrawInspector) return e.am.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!S) {
                            const o = "none" === t1.properties.get("color-use-theme"), s = t1.properties.get("color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e.am(...s);
                        }
                        if (S) {
                            const o = "none" === t1.properties.get("space-color-use-theme"), s = t1.properties.get("space-color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e.am(...s);
                        }
                    }
                    return e.am.transparent;
                })();
                if (this.context.clear({
                    color: I,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) continue;
                    const o = i ? (e.is3D(r) ? y : m)[i.id] : void 0;
                    this._renderTileClippingMasks(e, i, o), this.renderLayer(this, i, e, o);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.ah(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    e.isSky() && this.renderLayer(this, i, e, i ? m[i.id] : void 0);
                }
                function C(e, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e.type ? g : e.is3D(r) ? y : m)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < a.length;){
                        const e = h[this.currentLayer];
                        if ("raster" === e.type || "raster-particle" === e.type) {
                            const i = t1.getLayerSourceCache(e);
                            this.renderLayer(this, i, e, C(e, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                let R = 0;
                w && (R = w.getShadowCastingLayerCount());
                let D = !1, A = -1;
                for(let e = 0; e < a.length; ++e){
                    const t1 = h[e];
                    t1.isHidden(this.transform.zoom) || t1.is3D(r) && (A = e);
                }
                c && -1 === A && (l = !0);
                let L = !1;
                for(; this.currentLayer < a.length;){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e)) {
                        if (e.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (!L && e.is3D(r) && !r) {
                            const e = this.currentLayer, t1 = (e)=>{
                                for(this.currentLayer = 0; this.currentLayer < h.length; this.currentLayer++){
                                    const t1 = h[this.currentLayer];
                                    if (ia[t1.type]) {
                                        const i = this.style.getLayerSourceCache(t1);
                                        ia[t1.type](this, i, t1, C(t1, i), e);
                                    }
                                }
                            };
                            t1("initialize"), t1("reset"), this.currentLayer = e, L = !0;
                        }
                        if (l && !D && this.terrain && !this.transform.isOrthographic && (D = !0, this.blitDepth()), c && -1 !== A && this.currentLayer === A + 1 && !this.transform.isOrthographic && this.blitDepth(), this.terrain || this._renderTileClippingMasks(e, i, i ? f[i.id] : void 0), this.renderLayer(this, i, e, C(e, i)), !this.terrain && w && R > 0 && e.hasShadowPass() && 0 == --R) {
                            {
                                this.clearStencil();
                                const e = this.currentLayer;
                                for(this.currentLayer = 0; this.currentLayer < h.length; this.currentLayer++){
                                    const e = h[this.currentLayer];
                                    if (oa[e.type]) {
                                        const t1 = this.style.getLayerSourceCache(e);
                                        oa[e.type](this, t1, e, C(e, t1));
                                    }
                                }
                                this.currentLayer = e;
                            }
                            if (w.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                                const e = this.currentLayer;
                                for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e; this.currentLayer++){
                                    const e = h[this.currentLayer];
                                    if (!e.hasLightBeamPass()) continue;
                                    const i = t1.getLayerSourceCache(e);
                                    this.renderLayer(this, i, e, i ? m[i.id] : void 0);
                                }
                                this.currentLayer = e, this.renderPass = "translucent";
                            }
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e of this.layersWithOcclusionOpacity){
                                this.currentLayer = e;
                                const i = h[this.currentLayer], o = t1.getLayerSourceCache(i), s = o ? m[o.id] : void 0;
                                this.terrain || this._renderTileClippingMasks(i, o, o ? f[o.id] : void 0), this.renderLayer(this, o, i, s);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    h.forEach((e)=>{
                        const o = t1.getLayerSourceCache(e);
                        o && !e.isHidden(this.transform.zoom) && o.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                    }), i && this.options.showTileBoundaries && hn(this, i, i.getVisibleCoordinates(), e.am.red, !1, this.options.showParseStatus);
                }
                this.terrain && this._debugParams.showTerrainProxyTiles && hn(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.am(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(e) {
                    const t1 = e.transform.padding;
                    un(e, e.transform.height - (t1.top || 0), 3, rn), un(e, t1.bottom || 0, 3, nn), _n(e, t1.left || 0, 3, an), _n(e, e.transform.width - (t1.right || 0), 3, ln);
                    const i = e.transform.centerPoint;
                    !function(e, t1, i, o) {
                        pn(e, t1 - 1, i - 10, 2, 20, o), pn(e, t1 - 10, i - 1, 20, 2, o);
                    }(e, i.x, e.transform.height - i.y, cn);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _ || (this.conflationActive = !1);
            }
            prepareLayer(e) {
                this.gpuTimingStart(e);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e.type);
                if (ta[e.type] && (i || this.terrain && "custom" === e.type)) {
                    const t1 = this.style.getLayerSourceCache(e);
                    ta[e.type](e, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e.transform.projection.unsupportedLayers && e.transform.projection.unsupportedLayers.includes(i.type) && (!e.terrain || "custom" !== i.type) || "clip" === i.type || ea[i.type](e, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = this.gpuTimers[e.id];
                o || (o = this.gpuTimers[e.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), o.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, o.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e = this.gpuTimers;
                return this.gpuTimers = {}, e;
            }
            collectDeferredRenderGpuQueries() {
                const e = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e;
            }
            queryGpuTimers(e) {
                const t1 = {};
                for(const i in e){
                    const o = e[i], s = this.context.extTimerQuery, r = s.getQueryParameter(o.query, this.context.gl.QUERY_RESULT) / 1e6;
                    s.deleteQueryEXT(o.query), t1[i] = r;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const o of e)i += t1.getQueryParameter(o, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(o);
                return i;
            }
            translatePosMatrix(t1, i, o, s, r) {
                if (!o[0] && !o[1]) return t1;
                const n = r ? "map" === s ? this.transform.angle : 0 : "viewport" === s ? -this.transform.angle : 0;
                if (n) {
                    const e = Math.sin(n), t1 = Math.cos(n);
                    o = [
                        o[0] * t1 - o[1] * e,
                        o[0] * e + o[1] * t1
                    ];
                }
                const a = [
                    r ? o[0] : e.aw(i, o[0], this.transform.zoom),
                    r ? o[1] : e.aw(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e.bo(l, t1, a), l;
            }
            saveTileTexture(e) {
                const t1 = e.size[0], i = this._tileTextures[t1];
                i ? i.push(e) : this._tileTextures[t1] = [
                    e
                ];
            }
            getTileTexture(e) {
                const t1 = this._tileTextures[e];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e, t1, i) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, s = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e || "terrainRaster" === e ? (s.push("LIGHTING_3D_MODE"), s.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || s.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass && (this._shadowMapDebug || s.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (s.push("TERRAIN"), this.linearFloatFilteringSupported() && s.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && s.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || s.push("FOG", "FOG_DITHERING"), o && s.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && s.push("OVERDRAW_INSPECTOR"), s;
            }
            getOrCreateProgram(e, t1) {
                this.cache = this.cache || {};
                const i = t1 && t1.defines || [], o = t1 && t1.config, s = this.currentGlobalDefines(e, t1 && t1.overrideFog, t1 && t1.overrideRtt).concat(i), r = $s.cacheKey(jo[e], e, s, o);
                return this.cache[r] || (this.cache[r] = new $s(this.context, e, jo[e], o, Ir[e], s)), this.cache[r];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i) {
                if (this.style.enable3dLights()) {
                    const o = this.style.directionalLight, s = this.style.ambientLight;
                    if (o && s) {
                        const r = ((t1, i, o)=>{
                            const s = t1.properties.get("direction"), r = "none" === t1.properties.get("color-use-theme"), n = t1.properties.get("color").toNonPremultipliedRenderColor(r ? null : o.getLut(t1.scope)).toArray01(), a = t1.properties.get("intensity"), l = "none" === i.properties.get("color-use-theme"), c = i.properties.get("color").toNonPremultipliedRenderColor(l ? null : o.getLut(i.scope)).toArray01(), h = i.properties.get("intensity"), d = [
                                s.x,
                                s.y,
                                s.z
                            ], u = e.dw(c, h), _ = e.dw(n, a);
                            return {
                                u_lighting_ambient_color: u,
                                u_lighting_directional_dir: d,
                                u_lighting_directional_color: _,
                                u_ground_radiance: Zs(d, _, u)
                            };
                        })(o, s, this.style);
                        i.setLightsUniformValues(t1, r);
                    }
                }
            }
            uploadCommonUniforms(t1, i, o, s, r) {
                if (this.uploadCommonLightUniforms(t1, i), this.terrain && this.terrain.renderingToTexture) return;
                const n = this.style.fog;
                if (n) {
                    const r = n.getOpacity(this.transform.pitch), a = ((t1, i, o, s, r, n, a, l, c, h, d, u)=>{
                        const _ = t1.transform, p = "none" === i.properties.get("color-use-theme"), f = i.properties.get("color").toNonPremultipliedRenderColor(p ? null : t1.style.getLut(i.scope)).toArray01();
                        f[3] = s;
                        const m = t1.frameCounter / 1e3 % 1, [g, v] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : u || t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: f,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(g, v),
                                v
                            ],
                            u_fog_temporal_offset: m,
                            u_frustum_tl: r,
                            u_frustum_tr: n,
                            u_frustum_br: a,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: d,
                            u_globe_transition: e.ah(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, n, o, r, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e.q.devicePixelRatio,
                        this.transform.height * e.q.devicePixelRatio
                    ], s);
                    i.setFogUniformValues(t1, a);
                }
                r && i.setCutoffUniformValues(t1, r.uniformValues);
            }
            setTileLoadedFlag(e) {
                this.tileLoaded = e;
            }
            saveCanvasCopy() {
                const e = this.canvasCopy();
                e && (this.frameCopies.push(e), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e = this.context.gl, t1 = e.createTexture();
                return e.bindTexture(e.TEXTURE_2D, t1), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, e.drawingBufferWidth, e.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e = this.style && this.style.fog;
                return !!e && 0 !== e.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const o of i)t1[o.key] = e[o.key] || new wt(o, 512, this.transform.tileZoom, this, void 0, this.worldview);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e, t1) {
                return !(!e.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e.type && (e.minzoom && e.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(e) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t1 = this._cachedTileFogOpacities[e.key];
                return t1 || (this._cachedTileFogOpacities[e.key] = t1 = this.style.fog.getOpacityForTile(e)), t1[0] >= Fe || t1[1] >= Fe;
            }
            setupDepthForOcclusion(e, t1, i) {
                const o = this.context, s = o.gl, r = !!i;
                var n;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), o.activeTexture.set(s.TEXTURE3), e && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((n = this.depthRangeFor3D)[1] - n[0]),
                    -1 - 2 * n[0] / (n[1] - n[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), o.activeTexture.set(s.TEXTURE0), r || t1.setTerrainUniformValues(o, i);
            }
        }
        function ra(e, t1) {
            let i = !1, o = null;
            const s = ()=>{
                o = null, i && (e(), o = setTimeout(s, t1), i = !1);
            };
            return ()=>(i = !0, o || s(), o);
        }
        class na {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e.aV([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = ra(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e) {
                return this._map = e, window.addEventListener("hashchange", this._onHashChange, !1), e.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e = this._map;
                if (!e) return "";
                const t1 = aa(e);
                if (this._hashName) {
                    const e = this._hashName;
                    let i = !1;
                    const o = location.hash.slice(1).split("&").map((o)=>{
                        const s = o.split("=")[0];
                        return s === e ? (i = !0, `${s}=${t1}`) : o;
                    }).filter((e)=>e);
                    return i || o.push(`${e}=${t1}`), `#${o.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e.split("&").map((e)=>e.split("=")).forEach((e)=>{
                        e[0] === this._hashName && (t1 = e);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e.split("/");
            }
            _onHashChange() {
                const e = this._map;
                if (!e) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e)=>isNaN(Number(e)))) {
                    const i = e.dragRotate.isEnabled() && e.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e.getBearing();
                    return e.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
        }
        function aa(e, t1) {
            const i = e.getCenter(), o = Math.round(100 * e.getZoom()) / 100, s = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), r = Math.pow(10, s), n = Math.round(i.lng * r) / r, a = Math.round(i.lat * r) / r, l = e.getBearing(), c = e.getPitch();
            let h = t1 ? `/${n}/${a}/${o}` : `${o}/${a}/${n}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const la = {
            linearity: .3,
            easing: e.ew(0, 0, .3, 1)
        }, ca = e.h({
            deceleration: 2500,
            maxSpeed: 1400
        }, la), ha = e.h({
            deceleration: 20,
            maxSpeed: 1400
        }, la), da = e.h({
            deceleration: 1e3,
            maxSpeed: 360
        }, la), ua = e.h({
            deceleration: 1e3,
            maxSpeed: 90
        }, la);
        class _a {
            constructor(e){
                this._map = e, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e.q.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e.q.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e } of this._inertiaBuffer)i.zoom += e.zoomDelta || 0, i.bearing += e.bearingDelta || 0, i.pitch += e.pitchDelta || 0, e.panDelta && i.pan._add(e.panDelta), e.around && (i.around = e.around), e.pinchAround && (i.pinchAround = e.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    const r = fa(i.pan.mag(), o, e.h({}, ca, t1 || {}));
                    s.offset = i.pan.mult(r.amount / i.pan.mag()), s.center = this._map.transform.center, pa(s, r);
                }
                if (i.zoom) {
                    const e = fa(i.zoom, o, ha);
                    s.zoom = this._map.transform.zoom + e.amount, pa(s, e);
                }
                if (i.bearing) {
                    const t1 = fa(i.bearing, o, da);
                    s.bearing = this._map.transform.bearing + e.ay(t1.amount, -179, 179), pa(s, t1);
                }
                if (i.pitch) {
                    const e = fa(i.pitch, o, ua);
                    s.pitch = this._map.transform.pitch + e.amount, pa(s, e);
                }
                if (s.zoom || s.bearing) {
                    const e = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = e ? this._map.unproject(e) : this._map.getCenter();
                }
                return this.clear(), s.noMoveStart = !0, s;
            }
        }
        function pa(e, t1) {
            (!e.duration || e.duration < t1.duration) && (e.duration = t1.duration, e.easing = t1.easing);
        }
        function fa(t1, i, o) {
            const { maxSpeed: s, linearity: r, deceleration: n } = o, a = e.ay(t1 * r / (i / 1e3), -s, s), l = Math.abs(a) / (n * r);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class ma extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o, s = {}){
                const r = g(i.getCanvasContainer(), o), n = i.unproject(r);
                super(t1, e.h({
                    point: r,
                    lngLat: n,
                    originalEvent: o
                }, s)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class ga extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const s = "touchend" === t1 ? o.changedTouches : o.touches, r = v(i.getCanvasContainer(), s), n = r.map((e)=>i.unproject(e)), a = r.reduce((e, t1, i, o)=>e.add(t1.div(o.length)), new e.P(0, 0));
                super(t1, {
                    points: r,
                    point: a,
                    lngLats: n,
                    lngLat: i.unproject(a),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class va extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class ya {
            constructor(e, t1){
                this._map = e, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e) {
                return this._firePreventable(new va(this._map, e));
            }
            mousedown(e, t1) {
                return this._mousedownPos = t1, this._firePreventable(new ma(e.type, this._map, e));
            }
            mouseup(e) {
                this._map.fire(new ma(e.type, this._map, e));
            }
            preclick(t1) {
                const i = e.h({}, t1);
                i.type = "preclick", this._map.fire(new ma(i.type, this._map, i));
            }
            click(e, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e), this._map.fire(new ma(e.type, this._map, e)));
            }
            dblclick(e) {
                return this._firePreventable(new ma(e.type, this._map, e));
            }
            mouseover(e) {
                this._map.fire(new ma(e.type, this._map, e));
            }
            mouseout(e) {
                this._map.fire(new ma(e.type, this._map, e));
            }
            touchstart(e) {
                return this._firePreventable(new ga(e.type, this._map, e));
            }
            touchmove(e) {
                this._map.fire(new ga(e.type, this._map, e));
            }
            touchend(e) {
                this._map.fire(new ga(e.type, this._map, e));
            }
            touchcancel(e) {
                this._map.fire(new ga(e.type, this._map, e));
            }
            _firePreventable(e) {
                if (this._map.fire(e), e.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class xa {
            constructor(e){
                this._map = e;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e) {
                this._map.fire(new ma(e.type, this._map, e));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new ma("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e) {
                this._delayContextMenu ? this._contextMenuEvent = e : this._map.fire(new ma(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class ba {
            constructor(e, t1){
                this._map = e, this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e, t1) {
                this.isEnabled() && e.shiftKey && 0 === e.button && (_(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, s = this._lastPos;
                if (!o || !s || s.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e));
                const r = Math.min(o.x, i.x), n = Math.max(o.x, i.x), a = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${r}px,${a}px)`, this._box.style.width = n - r + "px", this._box.style.height = c - a + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, s = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), m(), o.x !== s.x || o.y !== s.y) return this._map.fire(new e.A("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e)=>e.fitScreenCoordinates(o, s, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e) {
                this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e.A(t1, {
                    originalEvent: i
                }));
            }
        }
        function wa(e, t1) {
            const i = {};
            for(let o = 0; o < e.length; o++)i[e[o].identifier] = t1[o];
            return i;
        }
        class Ta {
            constructor(e){
                this.reset(), this.numTouches = e.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e.P(0, 0);
                    for (const e of t1)i._add(e);
                    return i.div(t1.length);
                }(i), this.touches = wa(o, i)));
            }
            touchmove(e, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = wa(i, t1);
                for(const e in this.touches){
                    const t1 = o[e];
                    (!t1 || t1.dist(this.touches[e]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e, t1, i) {
                if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e = !this.aborted && this.centroid;
                    if (this.reset(), e) return e;
                }
            }
        }
        class Ea {
            constructor(e){
                this.singleTap = new Ta(e), this.numTaps = e.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e, t1, i) {
                this.singleTap.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this.singleTap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this.singleTap.touchend(e, t1, i);
                if (o) {
                    const t1 = e.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class Sa {
            constructor(){
                this._zoomIn = new Ea({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Ea({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e, t1, i) {
                this._zoomIn.touchstart(e, t1, i), this._zoomOut.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this._zoomIn.touchmove(e, t1, i), this._zoomOut.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this._zoomIn.touchend(e, t1, i), s = this._zoomOut.touchend(e, t1, i);
                return o ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e
                        })
                }) : s ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(s)
                        }, {
                            originalEvent: e
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const Ia = {
            0: 1,
            2: 2
        }, Ca = {
            Control: "ctrlKey",
            Alt: "altKey",
            Shift: "shiftKey",
            Meta: "metaKey"
        };
        class Ra {
            constructor(e){
                this.reset(), this._clickTolerance = e.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e, t1) {
                return !1;
            }
            _move(e, t1) {
                return {};
            }
            mousedown(e, t1) {
                if (this._lastPoint) return;
                const i = y(e);
                this._correctButton(e, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e.preventDefault(), null != this._eventButton && function(e, t1) {
                        const i = Ia[t1];
                        return void 0 === e.buttons || (e.buttons & i) !== i;
                    }(e, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e) {
                this._lastPoint && y(e) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Da extends Ra {
            mousedown(e, t1) {
                super.mousedown(e, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e, t1) {
                return 0 === t1 && !e.ctrlKey;
            }
            _move(e, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e)
                };
            }
        }
        class Aa extends Ra {
            constructor(e){
                super(e), this._pitchRotateKey = e.pitchRotateKey ? Ca[e.pitchRotateKey] : void 0;
            }
            _correctButton(e, t1) {
                return this._pitchRotateKey ? 0 === t1 && e[this._pitchRotateKey] : 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = .8 * (t1.x - e.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e) {
                this._pitchRotateKey || e.preventDefault();
            }
        }
        class La extends Ra {
            constructor(e){
                super(e), this._pitchRotateKey = e.pitchRotateKey ? Ca[e.pitchRotateKey] : void 0;
            }
            _correctButton(e, t1) {
                return this._pitchRotateKey ? 0 === t1 && e[this._pitchRotateKey] : 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = -0.5 * (t1.y - e.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e) {
                this._pitchRotateKey || e.preventDefault();
            }
        }
        class Pa {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e.aV([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
            }
            touchstart(e, t1, i) {
                return this._calculateTransform(e, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e.ex()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e, t1, i) {
                this._calculateTransform(e, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const s = wa(o, i), r = new e.P(0, 0), n = new e.P(0, 0);
                let a = 0;
                for(const e in s){
                    const t1 = s[e], i = this._touches[e];
                    i && (r._add(t1), n._add(t1.sub(i)), a++, s[e] = t1);
                }
                if (this._touches = s, a < this._minTouches || !n.mag()) return;
                const l = n.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: r.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class za {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e) {}
            _move(e, t1, i) {
                return {};
            }
            touchstart(e, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e.preventDefault();
                const [s, r] = o, n = Ma(i, t1, s), a = Ma(i, t1, r);
                if (!n || !a) return;
                const l = this._aroundCenter ? null : n.add(a).div(2);
                return this._move([
                    n,
                    a
                ], l, e);
            }
            touchend(e, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, s] = this._firstTwoTouches, r = Ma(i, t1, o), n = Ma(i, t1, s);
                r && n || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e) {
                this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Ma(e, t1, i) {
            for(let o = 0; o < e.length; o++)if (e[o].identifier === i) return t1[o];
        }
        function Oa(e, t1) {
            return Math.log(e / t1) / Math.LN2;
        }
        class Fa extends za {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e) {
                this._startDistance = this._distance = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._distance;
                if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(Oa(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Oa(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function Ba(e, t1) {
            return 180 * e.angleWith(t1) / Math.PI;
        }
        class ka extends za {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e) {
                this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._vector;
                if (this._vector = e[0].sub(e[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: Ba(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e) {
                this._minDiameter = Math.min(this._minDiameter, e.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = Ba(e, i);
                return Math.abs(o) < t1;
            }
        }
        function Na(e) {
            return Math.abs(e.y) > Math.abs(e.x);
        }
        class Ua extends za {
            constructor(e){
                super(), this._map = e;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e) {
                this._lastPoints = e, Na(e[0].sub(e[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const s = this._lastPoints;
                if (!s) return;
                const r = t1[0].sub(s[0]), n = t1[1].sub(s[1]);
                return this._map._cooperativeGestures && !e.ex() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r, n, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (r.y + n.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e.mag() >= 2, s = t1.mag() >= 2;
                if (!o && !s) return;
                if (!o || !s) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const r = e.y > 0 == t1.y > 0;
                return Na(e) && Na(t1) && r;
            }
        }
        const ja = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Va {
            constructor(){
                const e = ja;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e) {
                if (e.altKey || e.ctrlKey || e.metaKey) return;
                let t1 = 0, i = 0, o = 0, s = 0, r = 0;
                switch(e.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e.shiftKey ? i = -1 : (e.preventDefault(), s = -1);
                        break;
                    case 39:
                        e.shiftKey ? i = 1 : (e.preventDefault(), s = 1);
                        break;
                    case 38:
                        e.shiftKey ? o = 1 : (e.preventDefault(), r = -1);
                        break;
                    case 40:
                        e.shiftKey ? o = -1 : (e.preventDefault(), r = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (n)=>{
                        const a = n.getZoom();
                        n.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Ga,
                            zoom: t1 ? Math.round(a) + t1 * (e.shiftKey ? 2 : 1) : a,
                            bearing: n.getBearing() + i * this._bearingStep,
                            pitch: n.getPitch() + o * this._pitchStep,
                            offset: [
                                -s * this._panStep,
                                -r * this._panStep
                            ],
                            center: n.getCenter()
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function Ga(e) {
            return e * (2 - e);
        }
        const qa = 4.000244140625, Za = 1 / 450;
        class Ha {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Za, e.aV([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e) {
                this._defaultZoomRate = e;
            }
            setWheelZoomRate(e) {
                this._wheelZoomRate = e;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e.ex())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e.q.now(), s = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % qa == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : s > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(s * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = g(this._el, e);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e = "wheel" === this._type && Math.abs(this._delta) > qa ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const s = i(), r = Math.pow(2, s), n = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : r;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(n * o))), "wheel" === this._type && (this._startZoom = s, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), s = this._startZoom, r = this._easing;
                let n, a = !1;
                if ("wheel" === this._type && s && r) {
                    const t1 = Math.min((e.q.now() - this._lastWheelEventTime) / 200, 1), i = r(t1);
                    n = e.ai(s, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else n = o, a = !0;
                this._active = !0, a && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = n - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e.ey;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e.q.now() - t1.start) / t1.duration, s = t1.easing(o + .01) - t1.easing(o), r = .27 / Math.sqrt(s * s + 1e-4) * .01, n = Math.sqrt(.0729 - r * r);
                    i = e.ew(r, n, .25, 1);
                }
                return this._prevEase = {
                    start: e.q.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class Wa {
            constructor(e, t1){
                this._clickZoom = e, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class $a {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e, t1) {
                return e.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Xa {
            constructor(){
                this._tap = new Ea({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e, t1, i) {
                this._swipePoint || (this._tapTime && e.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e, t1, i));
            }
            touchmove(e, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], s = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e.preventDefault(), this._active = !0, {
                            zoomDelta: s / 128
                        };
                    }
                } else this._tap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e, t1, i) && (this._tapTime = e.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ya {
            constructor(e, t1, i){
                this._el = e, this._mousePan = t1, this._touchPan = i;
            }
            enable(e) {
                this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Ka {
            constructor(e, t1, i){
                this._pitchWithRotate = e.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class Ja {
            constructor(e, t1, i, o){
                this._el = e, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e) {
                this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const Qa = (e)=>e.zoom || e.drag || e.pitch || e.rotate;
        class el extends e.A {
        }
        class tl {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const o = e.at([], i, t1);
                this.radius = e.ae(o[2] < 0 ? e.eA([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e.eA(t1, t1, this.constants), e.au(t1, t1), e.eB(t1, t1, this.constants);
                const i = e.bY([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e.bY([], [
                        0,
                        0,
                        1
                    ], e.bG(i, [
                        0,
                        0,
                        1
                    ])), o = e.bY([], e.au([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), s = e.cV([], i, e.bY([], e.at([], e.cV([], o, t1), i), 2));
                    i[0] = s[0], i[1] = s[1];
                }
                return i;
            }
        }
        function il(e) {
            return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta;
        }
        class ol {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new _a(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new tl, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e.aV([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.addEventListener(t1, o, i);
                }
            }
            destroy() {
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.removeEventListener(t1, o, i);
                }
            }
            _addDefaultHandlers(e) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new ya(t1, e));
                const o = t1.boxZoom = new ba(t1, e);
                this._add("boxZoom", o);
                const s = new Sa, r = new $a;
                t1.doubleClickZoom = new Wa(r, s), this._add("tapZoom", s), this._add("clickZoom", r);
                const n = new Xa;
                this._add("tapDragZoom", n);
                const a = t1.touchPitch = new Ua(t1);
                this._add("touchPitch", a);
                const l = new Aa(e), c = new La(e);
                t1.dragRotate = new Ka(e, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new Da(e), d = new Pa(t1, e);
                t1.dragPan = new Ya(i, h, d), this._add("mousePan", h), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const u = new ka, _ = new Fa;
                t1.touchZoomRotate = new Ja(i, _, u, n), this._add("touchRotate", u, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", _, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new xa(t1));
                const p = t1.scrollZoom = new Ha(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const f = t1.keyboard = new Va;
                this._add("keyboard", f);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e.interactive && e[i] && t1[i].enable(e[i]);
            }
            _add(e, t1, i) {
                this._handlers.push({
                    handlerName: e,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e] = t1;
            }
            stop(e) {
                if (!this._updatingCamera) {
                    for (const { handler: e } of this._handlers)e.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e } of this._handlers)if (e.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Qa(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e, t1, i) {
                for(const o in e)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e) {
                this.handleEvent(e, `${e.type}Window`);
            }
            _getMapTouches(e) {
                const t1 = [];
                for (const i of e)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e.type, o = i ? void 0 : e, s = {
                    needsRenderFrame: !1
                }, r = {}, n = {}, a = e.touches ? this._getMapTouches(e.touches) : void 0, l = a ? v(this._el, a) : i ? void 0 : g(this._el, e);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let d;
                    this._blockedByActive(n, h, i) ? c.reset() : c[t1 || e.type] && (d = c[t1 || e.type](e, l, a), this.mergeHandlerResult(s, r, d, i, o), d && d.needsRenderFrame && this._triggerRenderFrame()), (d || c.isActive()) && (n[i] = c);
                }
                const c = {};
                for(const e in this._previousActiveHandlers)n[e] || (c[e] = o);
                this._previousActiveHandlers = n, (Object.keys(c).length || il(s)) && (this._changes.push([
                    s,
                    r,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(n).length || il(s)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = s;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(t1, i, o, s, r) {
                if (!o) return;
                e.h(t1, o);
                const n = {
                    handlerName: s,
                    originalEvent: o.originalEvent || r
                };
                void 0 !== o.zoomDelta && (i.zoom = n), void 0 !== o.panDelta && (i.drag = n), void 0 !== o.pitchDelta && (i.pitch = n), void 0 !== o.bearingDelta && (i.rotate = n);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [s, r, n] of this._changes)s.panDelta && (t1.panDelta = (t1.panDelta || new e.P(0, 0))._add(s.panDelta)), s.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (t1.around = s.around), void 0 !== s.aroundCoord && (t1.aroundCoord = s.aroundCoord), void 0 !== s.pinchAround && (t1.pinchAround = s.pinchAround), s.noInertia && (t1.noInertia = s.noInertia), e.h(i, r), e.h(o, n);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const s = this._map, r = s.transform, n = (e)=>[
                        e.x,
                        e.y,
                        e.z
                    ];
                if (((e)=>{
                    const t1 = this._eventsInProgress.drag;
                    return t1 && !this._handlersById[t1.handlerName].isActive();
                })() && !il(t1)) {
                    const e = r.zoom;
                    r.cameraElevationReference = "sea", null != this._originalZoom && r._orthographicProjectionAtLowPitch && "globe" !== r.projection.name && 0 === r.pitch ? (r.cameraElevationReference = "ground", r.zoom = this._originalZoom) : (r.recenterOnTerrain(), r.cameraElevationReference = "ground"), e !== r.zoom && this._map._update(!0);
                }
                if (r._isCameraConstrained && s._stop(!0), !il(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: d, aroundCoord: u, pinchAround: _ } = t1;
                r._isCameraConstrained && (l > 0 && (l = 0), r._isCameraConstrained = !1), void 0 !== _ && (d = _), (l || ((e)=>i[e] && !this._eventsInProgress[e])("drag")) && d && (this._dragOrigin = n(r.pointCoordinate3D(d)), this._originalZoom = r.zoom, this._trackingEllipsoid.setup(r._camera.position, this._dragOrigin)), r.cameraElevationReference = "sea", s._stop(!0), d = d || s.transform.centerPoint, c && (r.bearing += c), h && (r.pitch += h), r._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === r.projection.name) {
                        const e = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(d).dir), t1 = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(d.sub(a)).dir);
                        p[0] = t1[0] - e[0], p[1] = t1[1] - e[1];
                    } else {
                        const t1 = r.pointCoordinate(d);
                        if ("globe" === r.projection.name) {
                            a = a.rotate(-r.angle);
                            const i = r._pixelsPerMercatorPixel / r.worldSize;
                            p[0] = -a.x * e.ez(e.aY(t1.y)) * i, p[1] = -a.y * e.ez(r.center.lat) * i;
                        } else {
                            const e = r.pointCoordinate(d.sub(a));
                            t1 && e && (p[0] = e.x - t1.x, p[1] = e.y - t1.y);
                        }
                    }
                }
                const f = r.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = n(u || r.pointCoordinate3D(d)), i = {
                        dir: e.au([], e.at([], t1, r._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = r.zoomDeltaToMovement(t1, l);
                        e.bY(m, i.dir, o);
                    }
                }
                const g = e.cV(p, p, m);
                r._translateCameraConstrained(g), l && Math.abs(r.zoom - f) > 1e-4 && r.recenterOnTerrain(), r.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const s = Qa(this._eventsInProgress), r = Qa(t1), n = {};
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._eventsInProgress[e] || (n[`${e}start`] = i), this._eventsInProgress[e] = t1[e];
                }
                !s && r && this._fireEvent("movestart", r.originalEvent);
                for(const e in n)this._fireEvent(e, n[e]);
                r && this._fireEvent("move", r.originalEvent);
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._fireEvent(e, i);
                }
                const a = {};
                let l;
                for(const e in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e], l = i[t1] || o, a[`${e}end`] = l);
                }
                for(const e in a)this._fireEvent(e, a[e]);
                const c = Qa(this._eventsInProgress);
                if (o && (s || r) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e)=>0 !== e && -this._bearingSnap < e && e < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e.A("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e.A(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e)=>{
                    this._frameId = void 0, this.handleEvent(new el("renderFrame", {
                        timeStamp: e
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const sl = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class rl extends e.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e.aV([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e.cd(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e, t1) {
                return this.jumpTo({
                    center: e
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e.P.convert(t1).mult(-1), this.panTo(this.transform.center, e.h({
                    offset: t1
                }, i), o);
            }
            panTo(t1, i, o) {
                return this.easeTo(e.h({
                    center: t1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e, t1) {
                return this.jumpTo({
                    zoom: e
                }, t1), this;
            }
            zoomTo(t1, i, o) {
                return this.easeTo(e.h({
                    zoom: t1
                }, i), o);
            }
            zoomIn(e, t1) {
                return this.zoomTo(this.getZoom() + 1, e, t1), this;
            }
            zoomOut(e, t1) {
                return this.zoomTo(this.getZoom() - 1, e, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e, t1) {
                return this.jumpTo({
                    bearing: e
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e, t1) {
                return this.jumpTo({
                    padding: e
                }, t1), this;
            }
            rotateTo(t1, i, o) {
                return this.easeTo(e.h({
                    bearing: t1
                }, i), o);
            }
            resetNorth(t1, i) {
                return this.rotateTo(0, e.h({
                    duration: 1e3
                }, t1), i), this;
            }
            resetNorthPitch(t1, i) {
                return this.easeTo(e.h({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t1), i), this;
            }
            snapToNorth(e, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e, t1) {
                return this.jumpTo({
                    pitch: e
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e.aG.convert(t1);
                const o = i && i.bearing || 0, s = i && i.pitch || 0, r = t1.getNorthWest(), n = t1.getSouthEast();
                return this._cameraForBounds(this.transform, r, n, o, s, i);
            }
            _extendPadding(t1) {
                const i = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == t1 ? e.h({}, i, this.transform.padding) : "number" == typeof t1 ? {
                    top: t1,
                    bottom: t1,
                    right: t1,
                    left: t1
                } : e.h({}, i, t1);
            }
            _extendCameraOptions(t1) {
                return (t1 = e.h({
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, t1)).padding = this._extendPadding(t1.padding), t1;
            }
            _minimumAABBFrustumDistance(e, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e.aspect ? i / (2 * Math.tan(.5 * e.fovX) * e.aspect) : o / (2 * Math.tan(.5 * e.fovY) * e.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, s, r, n) {
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = s, a.pitch = r;
                const c = e.cd.convert(i), h = e.cd.convert(o), d = .5 * (c.lat + h.lat), u = .5 * (c.lng + h.lng), _ = e.eC(d, u), p = e.au([], _), f = e.au([], e.bF([], p, [
                    0,
                    1,
                    0
                ])), m = e.bF([], f, p), g = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    _,
                    e.eC(c.lat, c.lng),
                    e.eC(h.lat, c.lng),
                    e.eC(h.lat, h.lng),
                    e.eC(c.lat, h.lng),
                    e.eC(d, c.lng),
                    e.eC(d, h.lng),
                    e.eC(c.lat, u),
                    e.eC(h.lat, u)
                ];
                let y = e.cW.fromPoints(v.map((t1)=>[
                        e.bG(f, t1),
                        e.bG(m, t1),
                        e.bG(p, t1)
                    ]));
                const x = e.ad([], y.center, g);
                0 === e.eD(x) && e.eE(x, 0, 0, 1), e.au(x, x), e.bY(x, x, e.aB), a.center = e.eF(x);
                const b = a.getWorldToCameraMatrix(), w = e.bi(new Float64Array(16), b);
                y = e.cW.applyTransform(y, e.az([], b, g));
                const T = this._extendAABB(y, a, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                y = T, e.ad(x, x, b);
                const E = .5 * (y.max[2] - y.min[2]), S = this._minimumAABBFrustumDistance(a, y), I = e.bY([], [
                    0,
                    0,
                    1
                ], E), C = e.cV(I, x, I), R = S + (0 === a.pitch ? 0 : e.bD(x, C)), D = a.globeCenterInViewSpace, A = e.at([], x, [
                    D[0],
                    D[1],
                    D[2]
                ]);
                e.au(A, A), e.bY(A, A, R);
                const L = e.cV([], x, A);
                e.ad(L, L, w);
                const P = e.eq / e.aB, z = e.ae(L), M = e.c6(Math.max(z * P - e.eq, Number.EPSILON), 0), O = Math.min(a.zoomFromMercatorZAdjusted(M), l.maxZoom);
                return O > .5 * (e.cL + e.cx) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = O, this._cameraForBounds(a, i, o, s, r, n)) : {
                    center: a.center,
                    zoom: O,
                    bearing: s,
                    pitch: r
                };
            }
            _extendAABB(t1, i, o, s) {
                const r = .5 * ((o.padding.left || 0) + (o.padding.right || 0)), n = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)), a = n, l = r, c = r, h = n, d = i.width - (l + c), u = i.height - (a + h), _ = e.at([], t1.max, t1.min), p = Math.min(d / _[0], u / _[1]), f = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
                if (isNaN(f)) return null;
                const m = i.scale / i.zoomScale(f), g = new e.cW([
                    t1.min[0] - l * m,
                    t1.min[1] - h * m,
                    t1.min[2]
                ], [
                    t1.max[0] + c * m,
                    t1.max[1] + a * m,
                    t1.max[2]
                ]), v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e.P(o.offset.x, o.offset.y) : e.P.convert(o.offset)).rotate(-e.al(s));
                return g.center[0] -= v.x * m, g.center[1] += v.y * m, g;
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = e.h({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e.ac.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, s, r, n) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, s, r, n);
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = s, a.pitch = r;
                const c = e.cd.convert(i), h = e.cd.convert(o), d = new e.cd(c.lng, h.lat), u = new e.cd(h.lng, c.lat), _ = a.project(c), p = a.project(h), f = this.queryTerrainElevation(c), m = this.queryTerrainElevation(h), g = this.queryTerrainElevation(d), v = this.queryTerrainElevation(u), y = [
                    [
                        _.x,
                        _.y,
                        Math.min(f || 0, m || 0, g || 0, v || 0)
                    ],
                    [
                        p.x,
                        p.y,
                        Math.max(f || 0, m || 0, g || 0, v || 0)
                    ]
                ];
                let x = e.cW.fromPoints(y);
                const b = a.getWorldToCameraMatrix(), w = e.bi(new Float64Array(16), b);
                x = e.cW.applyTransform(x, b);
                const T = this._extendAABB(x, a, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                x = T;
                const E = .5 * e.at([], x.max, x.min)[2], S = this._minimumAABBFrustumDistance(a, x), I = [
                    0,
                    0,
                    1,
                    0
                ];
                e.aA(I, I, b), e.eG(I, I);
                const C = e.bY([], I, S + E), R = e.cV([], x.center, C);
                e.ad(x.center, x.center, w), e.ad(R, R, w);
                const D = a.unproject(new e.P(x.center[0], x.center[1])), A = e.eH(a.projection, D), L = Math.pow(2, A), P = Math.min(a._zoomFromMercatorZ(R[2] * a.pixelsPerMeter * L / a.worldSize), l.maxZoom);
                return a.mercatorFromTransition && P < .5 * (e.cL + e.cx) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = P, this._cameraForBounds(a, i, o, s, r, n)) : {
                    center: D,
                    zoom: P,
                    bearing: s,
                    pitch: r
                };
            }
            fitBounds(e, t1, i) {
                const o = this.cameraForBounds(e, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, s, r) {
                const n = e.P.convert(t1), a = e.P.convert(i), l = new e.P(Math.min(n.x, a.x), Math.min(n.y, a.y)), c = new e.P(Math.max(n.x, a.x), Math.max(n.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n, a)) return this;
                const h = this.transform.pointLocation3D(l), d = this.transform.pointLocation3D(c), u = this.transform.pointLocation3D(new e.P(l.x, c.y)), _ = this.transform.pointLocation3D(new e.P(c.x, l.y)), p = [
                    Math.min(h.lng, d.lng, u.lng, _.lng),
                    Math.min(h.lat, d.lat, u.lat, _.lat)
                ], f = [
                    Math.max(h.lng, d.lng, u.lng, _.lng),
                    Math.max(h.lat, d.lat, u.lat, _.lat)
                ], m = s && s.pitch ? s.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, f, o, m, s);
                return this._fitInternal(g, s, r);
            }
            _fitInternal(t1, i, o) {
                return t1 ? (i = e.h(t1, i)).linear ? this.easeTo(i, o) : this.flyTo(i, o) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let s = !1, r = !1, n = !1;
                "zoom" in t1 && o.zoom !== +t1.zoom && (s = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e.cd.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (r = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (n = !0, o.pitch = +t1.pitch);
                const a = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !o.isPaddingEqual(a)) {
                    if (!1 === t1.retainPadding) {
                        const e = o.clone();
                        e.padding = a, o.setLocationAtPoint(o.center, e.centerPoint);
                    } else o.padding = a;
                }
                return t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e.A("movestart", i)).fire(new e.A("move", i)), s && this.fire(new e.A("zoomstart", i)).fire(new e.A("zoom", i)).fire(new e.A("zoomend", i)), r && this.fire(new e.A("rotatestart", i)).fire(new e.A("rotate", i)).fire(new e.A("rotateend", i)), n && this.fire(new e.A("pitchstart", i)).fire(new e.A("pitch", i)).fire(new e.A("pitchend", i)), this.fire(new e.A("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e.w(sl), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e.w(sl), this;
                this.stop();
                const s = o.zoom, r = o.pitch, n = o.bearing;
                o.setFreeCameraOptions(t1);
                const a = s !== o.zoom, l = r !== o.pitch, c = n !== o.bearing;
                return this.fire(new e.A("movestart", i)).fire(new e.A("move", i)), a && this.fire(new e.A("zoomstart", i)).fire(new e.A("zoom", i)).fire(new e.A("zoomend", i)), c && this.fire(new e.A("rotatestart", i)).fire(new e.A("rotate", i)).fire(new e.A("rotateend", i)), l && this.fire(new e.A("pitchstart", i)).fire(new e.A("pitch", i)).fire(new e.A("pitchend", i)), this.fire(new e.A("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = e.h({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e.ey
                }, t1)).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : n, d = this._extendPadding(t1.padding), u = e.P.convert(t1.offset);
                let _, p, f;
                if ("globe" === o.projection.name) {
                    const i = e.ac.fromLngLat(o.center), s = u.rotate(-o.angle);
                    i.x += s.x / o.worldSize, i.y += s.y / o.worldSize;
                    const r = i.toLngLat(), n = e.cd.convert(t1.center || r);
                    this._normalizeCenter(n), _ = o.centerPoint.add(s), p = new e.P(i.x, i.y).mult(o.worldSize), f = new e.P(e.aD(n.lng), e.aH(n.lat)).mult(o.worldSize).sub(p);
                } else {
                    _ = o.centerPoint.add(u);
                    const i = o.pointLocation(_), s = e.cd.convert(t1.center || i);
                    this._normalizeCenter(s), p = o.project(i), f = o.project(s).sub(p);
                }
                const m = o.zoomScale(l - s);
                let g, v;
                t1.around && (g = e.cd.convert(t1.around), v = o.locationPoint(g));
                const y = this._zooming || l !== s, x = this._rotating || r !== c, b = this._pitching || h !== n, w = !o.isPaddingEqual(d), T = !1 === t1.retainPadding ? o.clone() : o, E = (o)=>(E)=>{
                        if (y && (o.zoom = e.ai(s, l, E)), x && (o.bearing = e.ai(r, c, E)), b && (o.pitch = e.ai(n, h, E)), w && (T.interpolatePadding(a, d, E), _ = T.centerPoint.add(u)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e = o.zoomScale(o.zoom - s), t1 = l > s ? Math.min(2, m) : Math.max(.5, m), i = Math.pow(t1, 1 - E), r = o.unproject(p.add(f.mult(E * i)).mult(e));
                            o.setLocationAtPoint(o.renderWorldCopies ? r.wrap() : r, _);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(E, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                const S = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = y, this._rotating = x, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, S), this._ease(E(o), (e)=>{
                    "sea" === o.cameraElevationReference && o.recenterOnTerrain(), this._afterEase(i, e);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e.A("movestart", t1)), this._zooming && !o.zooming && this.fire(new e.A("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e.A("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e.A("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e.A("move", t1)), this._zooming && this.fire(new e.A("zoom", t1)), this._rotating && this.fire(new e.A("rotate", t1)), this._pitching && this.fire(new e.A("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, s = this._rotating, r = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e.A("zoomend", t1)), s && this.fire(new e.A("rotateend", t1)), r && this.fire(new e.A("pitchend", t1)), this.fire(new e.A("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const o = e.aF(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = e.h({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e.ey
                }, t1);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? e.ay(+t1.zoom, o.minZoom, o.maxZoom) : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : n, d = this._extendPadding(t1.padding), u = o.zoomScale(l - s), _ = e.P.convert(t1.offset);
                let p = o.centerPoint.add(_);
                const f = o.pointLocation(p), m = e.cd.convert(t1.center || f);
                this._normalizeCenter(m);
                const g = o.project(f), v = o.project(m).sub(g);
                let y = t1.curve;
                const x = Math.max(o.width, o.height), b = x / u, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e.ay(Math.min(t1.minZoom, s, l), o.minZoom, o.maxZoom), r = x / o.zoomScale(i - s);
                    y = Math.sqrt(r / w * 2);
                }
                const T = y * y;
                function E(e) {
                    const t1 = (b * b - x * x + (e ? -1 : 1) * T * T * w * w) / (2 * (e ? b : x) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function S(e) {
                    return (Math.exp(e) - Math.exp(-e)) / 2;
                }
                function I(e) {
                    return (Math.exp(e) + Math.exp(-e)) / 2;
                }
                const C = E(0);
                let R = function(e) {
                    return I(C) / I(C + y * e);
                }, D = function(e) {
                    var t1;
                    return x * ((I(C) * (S(t1 = C + y * e) / I(t1)) - S(C)) / T) / w;
                }, A = (E(1) - C) / y;
                if (Math.abs(w) < 1e-6 || !isFinite(A)) {
                    if (Math.abs(x - b) < 1e-6) return this.easeTo(t1, i);
                    const e = b < x ? -1 : 1;
                    A = Math.abs(Math.log(b / x)) / y, D = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e * y * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * A / ("screenSpeed" in t1 ? +t1.screenSpeed / y : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const L = r !== c, P = h !== n, z = !o.isPaddingEqual(d), M = !1 === t1.retainPadding ? o.clone() : o, O = (o)=>(u)=>{
                        const f = u * A, y = 1 / R(f);
                        o.zoom = 1 === u ? l : s + o.scaleZoom(y), L && (o.bearing = e.ai(r, c, u)), P && (o.pitch = e.ai(n, h, u)), z && (M.interpolatePadding(a, d, u), p = M.centerPoint.add(_));
                        const x = 1 === u ? m : o.unproject(g.add(v.mult(D(f))).mult(y));
                        return o.setLocationAtPoint(o.renderWorldCopies ? x.wrap() : x, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(O, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                return this._zooming = !0, this._rotating = L, this._pitching = P, this._padding = z, this._prepareEase(i, !1), this._ease(O(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e) {}
            _cancelRenderFrame(e) {}
            _stop(e, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e = this._onEaseEnd;
                    this._onEaseEnd = void 0, e.call(this, t1);
                }
                if (!e) {
                    const e = this.handlers;
                    e && e.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e.q.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e.q.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e.bX(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e.lng - t1.center.lng;
                e.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e.q.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), s = [], r = e(i.clone());
                for(let e = 0; e <= o; e++){
                    const t1 = r(e / o);
                    s.push(t1.clone());
                }
                return s;
            }
            _preloadTiles(e, t1) {}
        }
        class nl {
            constructor(t1 = {}){
                this.options = t1, e.aV([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e) {
                const t1 = this.options && this.options.compact, i = e._getUIString("AttributionControl.ToggleAttribution");
                this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const o = l("span", "mapboxgl-ctrl-icon", this._compactButton);
                return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e.e.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e, t1, o)=>(t1.value && (e += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e), "?");
                    t1.href = `${e.e.FEEDBACK_URL}/${o}#${aa(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e) {
                !e || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType && "style" !== e.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e = [];
                if (this._map.style.stylesheet) {
                    const e = this._map.style.stylesheet;
                    this.styleOwner = e.owner, this.styleId = e.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e.indexOf(t1.attribution) < 0 && e.push(t1.attribution);
                    }
                }
                e.sort((e, t1)=>e.length - t1.length), e = e.filter((t1, i)=>{
                    for(let o = i + 1; o < e.length; o++)if (e[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = [
                    ...this.options.customAttribution,
                    ...e
                ] : e.unshift(this.options.customAttribution));
                const i = e.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class al {
            constructor(){
                e.aV([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e) {
                this._map = e, this._container = l("div", "mapboxgl-ctrl");
                const t1 = l("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e) {
                e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e = this._map.style._sourceCaches;
                if (0 === Object.entries(e).length) return !0;
                for(const t1 in e){
                    const i = e[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e = this._container.children;
                if (e.length) {
                    const t1 = e[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class ll {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e) return void (t1.cancelled = !0);
            }
            run(e = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class cl {
            constructor(e){
                this.jumpTo(e);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e.dk((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e) {
                return e >= this._startTime && e <= this._endTime;
            }
            jumpTo(e) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e, this._end = e;
            }
            easeTo(e, t1, i) {
                this._start = this.getValue(t1), this._end = e, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const hl = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class dl extends e.A {
            constructor(e, t1, i, o){
                const { point: s, lngLat: r, originalEvent: n, target: a } = e;
                super(e.type, {
                    point: s,
                    lngLat: r,
                    originalEvent: n,
                    target: a
                }), this.preventDefault = ()=>{
                    e.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = o;
            }
        }
        class ul {
            constructor(e){
                this.map = e, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const o = i.filter;
                let s = i.type;
                o && this.filters.set(t1, e.b3(o)), "mouseover" === s && (s = "mouseenter"), "mouseout" === s && (s = "mouseleave");
                const r = this.interactionsByType.get(s) || new Map;
                "mouseenter" === s || "mouseleave" === s ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === r.size && this.map.on(s, this.handleType), 0 === r.size && this.interactionsByType.set(s, r), r.set(t1, i), this.typeById.set(t1, s);
            }
            get(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e) : void 0;
            }
            remove(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                this.typeById.delete(e), this.filters.delete(e);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e, t1) {
                const i = [];
                for (const [e, o] of t1)o.target && i.push({
                    targetId: e,
                    target: o.target,
                    filter: this.filters.get(e)
                });
                return this.map.style.queryRenderedTargets(e, i, this.map.transform);
            }
            handleMove(e) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e.type = "mouseenter", this.handleType(e, t1));
                const i = new Map;
                for (const [e, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e) || i.set(t1.id, t1);
                i.size && (e.type = "mouseleave", this.handleType(e, Array.from(i.values())));
            }
            handleOut(e) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e })=>e);
                t1.length && (e.type = "mouseleave", this.handleType(e, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const o = "mouseenter" === t1.type;
                if (o && !this.interactionsByType.has(t1.type)) return void e.w("mouseenter interaction required for mouseleave to work.");
                const s = Array.from(this.interactionsByType.get(t1.type)).reverse(), r = !!i;
                i = i || this.queryTargets(t1.point, s);
                let n = !1;
                const a = new Set;
                for (const l of i){
                    for (const [i, c] of s){
                        if (!c.target) continue;
                        const s = l.variants ? l.variants[i] : null;
                        if (s) {
                            for (const h of s){
                                if (lt(h, l, a, i)) continue;
                                const s = new e.de(l, h), d = at(h, l, i);
                                r && (s.state = this.map.getFeatureState(s));
                                const u = o ? this.prevHoveredFeatures.get(d) : null, _ = new dl(t1, i, c, s), p = u ? u.stop : c.handler(_);
                                if (o && this.hoveredFeatures.set(d, {
                                    feature: l,
                                    stop: p
                                }), !1 !== p) {
                                    n = !0;
                                    break;
                                }
                            }
                            if (n) break;
                        }
                    }
                    if (n) break;
                }
                if (!n) for (const [e, i] of s){
                    const { handler: o, target: s } = i;
                    if (!s && !1 !== o(new dl(t1, e, i, null))) break;
                }
            }
        }
        function _l(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e = new Set(t1), o = new Set(i);
                return e.size === o.size && t1.every((e)=>o.has(e));
            }
            return e.bv(t1, i);
        }
        const pl = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1,
            spriteFormat: "auto"
        }, fl = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class ml {
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new Aa({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new La({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e.aV([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e, t1) {
                this.mouseRotate.mousedown(e, t1), this.mousePitch && this.mousePitch.mousedown(e, t1), _();
            }
            move(e, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e, t1), s = o && o.bearingDelta;
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e, t1), s = o && o.pitchDelta;
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const e = this.element;
                e.removeEventListener("mousedown", this.mousedown), e.removeEventListener("touchstart", this.touchstart), e.removeEventListener("touchmove", this.touchmove), e.removeEventListener("touchend", this.touchend), e.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t1) {
                this.down(e.h({}, t1, {
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }), g(this.element, t1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e) {
                this.move(e, g(this.element, e));
            }
            mouseup(e) {
                this.mouseRotate.mouseupWindow(e), this.mousePitch && this.mousePitch.mouseupWindow(e), this.offTemp();
            }
            touchstart(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e.preventDefault()
                }, this._startPos));
            }
            touchmove(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e.targetTouches)[0], this.move({
                    preventDefault: ()=>e.preventDefault()
                }, this._lastPos));
            }
            touchend(e) {
                0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function gl(t1, i, o) {
            if (t1 = new e.cd(t1.lng, t1.lat), i) {
                const s = new e.cd(t1.lng - 360, t1.lat), r = new e.cd(t1.lng + 360, t1.lat), n = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), a = o.locationPoint3D(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint3D(s).distSqr(i) < a && (l || Math.abs(s.lng - o.center.lng) < n) ? t1 = s : o.locationPoint3D(r).distSqr(i) < a && (l || Math.abs(r.lng - o.center.lng) < n) && (t1 = r);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e = o.locationPoint3D(t1);
                if (e.x >= 0 && e.y >= 0 && e.x <= o.width && e.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const vl = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        }, yl = {
            rotation: 0,
            rotationAlignment: "auto",
            pitchAlignment: "auto",
            occludedOpacity: .2,
            altitude: 0
        };
        class xl extends e.E {
            constructor(t1, i){
                super(), (t1 instanceof HTMLElement || i) && (t1 = e.h({
                    element: t1
                }, i)), e.aV([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this);
                const { anchor: o = "center", color: s = "#3FB1CE", scale: r = 1, draggable: n = !1, clickTolerance: a = 0, rotation: l = yl.rotation, rotationAlignment: c = yl.rotationAlignment, pitchAlignment: h = yl.pitchAlignment, occludedOpacity: d = yl.occludedOpacity, altitude: u = yl.altitude } = t1 || {};
                this._anchor = o, this._color = s, this._scale = r, this._draggable = n, this._clickTolerance = a, this._rotation = l, this._rotationAlignment = c, this._pitchAlignment = h, this._occludedOpacity = d, this._altitude = u, this._state = "inactive", this._isDragging = !1, this._updateMoving = ()=>this._update(!0), t1 && t1.element ? (this._element = t1.element, this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    0
                ])) : (this._defaultMarker = !0, this._element = this._createDefaultMarker(), this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    -14
                ])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e)=>{
                    e.preventDefault();
                }), this._element.addEventListener("mousedown", (e)=>{
                    e.preventDefault();
                });
                const _ = this._element.classList;
                for(const e in vl)_.remove(`mapboxgl-marker-anchor-${e}`);
                _.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const p = t1 && t1.className ? t1.className.trim().split(/\s+/) : [];
                _.add(...p), this._popup = null;
            }
            _createDefaultMarker() {
                const e = l("div"), t1 = c("svg", {
                    display: "block",
                    height: 41 * this._scale + "px",
                    width: 27 * this._scale + "px",
                    viewBox: "0 0 27 41"
                }, e);
                if (0 === this._altitude) {
                    const e = c("radialGradient", {
                        id: "shadowGradient"
                    }, c("defs", {}, t1));
                    c("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, e), c("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, e), c("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, t1);
                }
                return c("path", {
                    fill: this._color,
                    d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                }, t1), c("path", {
                    opacity: .25,
                    d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                }, t1), c("circle", {
                    fill: "white",
                    cx: 13.5,
                    cy: 13.5,
                    r: 5.5
                }, t1), e;
            }
            addTo(e) {
                return e === this._map || (this.remove(), this._map = e, e.getCanvasContainer().appendChild(this._element), e.on("move", this._updateMoving), e.on("moveend", this._update), e.on("remove", this._clearFadeTimer), e._addMarker(this), this.setDraggable(this._draggable), this._update(), e.on("click", this._onMapClick)), this;
            }
            remove() {
                const e = this._map;
                return e && (e.off("click", this._onMapClick), e.off("move", this._updateMoving), e.off("moveend", this._update), e.off("mousedown", this._addDragHandler), e.off("touchstart", this._addDragHandler), e.off("mouseup", this._onUp), e.off("touchend", this._onUp), e.off("mousemove", this._onMove), e.off("touchmove", this._onMove), e.off("remove", this._clearFadeTimer), e._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e.cd.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            setAltitude(e) {
                return e === this._altitude || (this._defaultMarker && (0 === this._altitude && 0 !== e || 0 !== this._altitude && 0 === e) && (this._element = this._createDefaultMarker()), this._altitude = e || yl.altitude, this._update()), this;
            }
            getAltitude() {
                return this._altitude;
            }
            getElement() {
                return this._element;
            }
            setPopup(e) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
                    if (!("offset" in e.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -38.1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -13.5,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e, e._marker = this, e._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e) {
                const t1 = e.code, i = e.charCode || e.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e) {
                const t1 = e.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e = this._popup;
                return e ? (e.isOpen() ? (e.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e = this._map, t1 = this._pos;
                if (!e || !t1) return !1;
                const i = e.unproject(t1, this._altitude), o = e.getFreeCameraOptions();
                if (!o.position) return !1;
                const s = o.position.toLngLat();
                return s.distanceTo(i) < .9 * s.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i, this._altitude);
                let s;
                t1._showingGlobe() && e.eK(t1.transform, this._lngLat) ? s = 0 : (s = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (s *= this._occludedOpacity)), this._element.style.opacity = `${s}`, this._element.style.pointerEvents = s > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(s), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e = this._pos;
                if (!e || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e.x}px,${e.y}px)\n            ${vl[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e = i.getPitch();
                    return e ? `rotateX(${e}deg)` : "";
                }
                const s = e.cJ(e.eL(i.transform, this._lngLat)), r = t1.sub(e.eM(i.transform)), n = Math.abs(r.x) + Math.abs(r.y);
                if (0 === n) return "";
                const a = s / n;
                return `rotateX(${-r.y * a}deg) rotateY(${r.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const s = this.getRotationAlignment();
                if ("map" === s) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e.cd(this._lngLat.lng, this._lngLat.lat + .001), this._altitude), s = i.project(new e.cd(this._lngLat.lng, this._lngLat.lat - .001), this._altitude).sub(t1);
                        o = e.cJ(Math.atan2(s.y, s.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === s) {
                    const s = e.af(4, 6, i.getZoom()), r = e.eM(i.transform);
                    r.y += s * i.transform.height;
                    const n = t1.sub(r), a = e.cJ(Math.atan2(n.y, n.x));
                    o = (a > 90 ? a - 270 : a + 90) * (1 - s);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(e) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = gl(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat, this._altitude), !0 === e ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.getTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e.P.convert(t1), this._update(), this;
            }
            addClassName(e) {
                return this._element.classList.add(e), this;
            }
            removeClassName(e) {
                return this._element.classList.remove(e), this;
            }
            toggleClassName(e) {
                return this._element.classList.toggle(e);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, s = this._positionDelta;
                if (o && s) {
                    if (!this._isDragging) {
                        const e = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(s), this._lngLat = i.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.A("dragstart"))), this.fire(new e.A("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.A("dragend")), this._state = "inactive";
            }
            _addDragHandler(e) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(i), this._pointerdownPos = e.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e) {
                this._draggable = !!e;
                const t1 = this._map;
                return t1 && (e ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e) {
                return this._rotation = e || yl.rotation, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e) {
                return this._rotationAlignment = e || yl.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e) {
                return this._pitchAlignment = e || yl.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e) {
                return this._occludedOpacity = e || yl.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const bl = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, wl = {
            maxWidth: 100,
            unit: "metric"
        }, Tl = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, El = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            altitude: 0
        }, Sl = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Il(t1 = new e.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e.P(0, t1);
                    case "top-left":
                        return new e.P(o, o);
                    case "top-right":
                        return new e.P(-o, o);
                    case "bottom":
                        return new e.P(0, -t1);
                    case "bottom-left":
                        return new e.P(o, -o);
                    case "bottom-right":
                        return new e.P(-o, -o);
                    case "left":
                        return new e.P(t1, 0);
                    case "right":
                        return new e.P(-t1, 0);
                }
                return new e.P(0, 0);
            }
            return t1 instanceof e.P || Array.isArray(t1) ? e.P.convert(t1) : e.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const Cl = {
            version: t1,
            supported: a.supported,
            setRTLTextPlugin: e.eQ,
            getRTLTextPluginStatus: e.eP,
            Map: class extends rl {
                constructor(t1){
                    o.mark(i.create);
                    const s = t1;
                    if (null != (t1 = e.h({}, pl, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e.eI(window) && (t1.antialias = !1, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Qi(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies, null, null), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new ll, this._domRenderTaskQueue = new ll, this._controls = [], this._markers = [], this._popups = [], this._mapId = e.a$(), this._locale = e.h({}, hl, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._scaleFactorChanged = !1, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new cl(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = t1.scaleFactor, this._requestManager = new T(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? Object.assign({}, t1.contextCreateOptions) : {}, "string" == typeof t1.container) {
                        const e = document.getElementById(t1.container);
                        if (!e) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = t1.spriteFormat, e.aV([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._tp || (this._tp = new Vn), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showOverdrawInspector"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileBoundaries"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showParseStatus"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "repaint"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileAABBs"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showPadding"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showCollisionBoxes", {
                        noSave: !0
                    }), this._tp.registerParameter(this.transform, [
                        "Debug"
                    ], "freezeTileCoverage", {
                        noSave: !0
                    }, ()=>{
                        this._update();
                    }), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showTerrainWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers2DWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers3DWireframe"), this._tp.registerParameter(this, [
                        "Scaling"
                    ], "_scaleFactor", {
                        min: .1,
                        max: 10,
                        step: .1
                    }, ()=>{
                        this.setScaleFactor(this._scaleFactor);
                    }), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new ol(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, (t1.style || !t1.testMode) && this.setStyle(t1.style || e.e.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), this.indoor = new po(this), t1.hash && (this._hash = new na("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == s.center && null == s.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const i = t1.bounds;
                        i && (this.resize(), this.fitBounds(i, e.h({}, t1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new nl({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new al, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e.A(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e.A(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new ul(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e.z(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const s = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? s.insertBefore(o, s.firstChild) : s.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e.z(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e) {
                    return this._controls.indexOf(e) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e.A("movestart", t1)).fire(new e.A("move", t1)), this.fire(new e.A("resize", t1)), i && this.fire(new e.A("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e.aG.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e) {
                    return this._scaleFactor = e, this.painter.scaleFactor = e, this._tp.refreshUI(), this._scaleFactorChanged = !0, this.style._updateFilteredLayers((e)=>"symbol" === e.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e) {
                    return this.transform.renderWorldCopies = e, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e) {
                    return "auto" === e ? navigator.language : Array.isArray(e) ? 0 === e.length ? void 0 : e.map((e)=>"auto" === e ? navigator.language : e) : e;
                }
                setLanguage(e) {
                    const t1 = this._parseLanguage(e);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e of this._controls)e._setLanguage && e._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e) {
                    return this.style && e !== this._worldview ? (this._worldview = e, this._styleDirty = !0, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e) {
                    return this._lazyInitEmptyStyle(), e ? "string" == typeof e && (e = {
                        name: e
                    }) : e = null, this._useExplicitProjection = !!e, this._prioritizeAndUpdateProjection(e, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e.cx ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e.cx && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(!0));
                }
                _prioritizeAndUpdateProjection(e, t1) {
                    return this._updateProjection(e || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    return i = "globe" === t1.name && this.transform.zoom >= e.cx ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate(), i && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1, i) {
                    return this.transform.locationPoint3D(e.cd.convert(t1), i);
                }
                unproject(t1, i) {
                    return this.transform.pointLocation3D(e.P.convert(t1), i);
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e, t1, i) {
                    const o = (e)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const o = t1.filter((e)=>this.getLayer(e));
                            i = o.length ? this.queryRenderedFeatures(e, {
                                layers: o
                            }) : [];
                        } else i = this.queryRenderedFeatures(e, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e || "mouseover" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            const r = o(t1.point);
                            r.length ? s || (s = !0, i.call(this, new ma(e, this, t1.originalEvent, {
                                features: r
                            }))) : s = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: ()=>{
                                    s = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e || "mouseout" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            o(t1.point).length ? s = !0 : s && (s = !1, i.call(this, new ma(e, this, t1.originalEvent)));
                        }, n = (t1)=>{
                            s && (s = !1, i.call(this, new ma(e, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const s = (e)=>{
                            const t1 = o(e.point);
                            t1.length && (e.features = t1, i.call(this, e), delete e.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e]: s
                            }
                        };
                    }
                }
                on(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(o);
                    for(const e in o.delegates)this.on(e, o.delegates[e]);
                    return this;
                }
                once(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    for(const e in o.delegates)this.once(e, o.delegates[e]);
                    return this;
                }
                off(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._delegatedListeners ? this._delegatedListeners[e] : void 0;
                    return o && ((e)=>{
                        for(let o = 0; o < e.length; o++){
                            const s = e[o];
                            if (s.listener === i && _l(s.targets, t1)) {
                                for(const e in s.delegates)this.off(e, s.delegates[e]);
                                return e.splice(o, 1), this;
                            }
                        }
                    })(o), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e.concat(i);
                    }
                    let o = !0;
                    if (i.target && (o = this._isTargetValid(i.target), o && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let s = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e of i.layers)if (!this._isValidId(e)) {
                            s = !1;
                            break;
                        }
                        if (s && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let r = [];
                    return s && (r = r.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), o && (r = r.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), r;
                }
                querySourceFeatures(e, t1) {
                    return !e || "string" == typeof e && !this._isValidId(e) ? [] : this.style.querySourceFeatures(e, t1);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t1));
                }
                addInteraction(e, t1) {
                    return this._interactions.add(e, t1), this;
                }
                removeInteraction(e) {
                    return this._interactions.remove(e), this;
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(e) {
                    return this._cooperativeGestures = e, this;
                }
                setStyle(t1, i) {
                    return i = e.h({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i), this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t1, (o, s)=>{
                        if (o) {
                            const s = "string" == typeof o ? o : o instanceof Error ? o.message : o.error;
                            e.w(`Unable to perform style diff: ${s}. Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                        } else s && this._update(!0);
                    }, ()=>this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e) {
                    const t1 = this._locale[e];
                    if (null == t1) throw new Error(`Missing UI string '${e}'`);
                    return t1;
                }
                _updateStyle(t1, i) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t1) {
                        const o = e.h({}, i);
                        i && i.config && (o.initialConfig = i.config, delete o.config), this.style = new Eo(this, o).load(t1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new Eo(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e.z(new Error("IDs can't be empty."))), !1) : !e.d8(t1) || (this.fire(new e.z(new Error(`IDs can't contain special symbols: "${t1}".`))), !1);
                }
                _isTargetValid(e) {
                    return "featuresetId" in e ? this._isValidId("importId" in e ? e.importId : e.featuresetId) : "layerId" in e && this._isValidId(e.layerId);
                }
                _areTargetsValid(e) {
                    if (Array.isArray(e)) {
                        for (const t1 of e)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e);
                }
                addSource(e, t1) {
                    return this._isValidId(e) ? (this._lazyInitEmptyStyle(), this.style.addSource(e, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e) {
                    return !!this._isValidId(e) && !!this.style && this.style._isSourceCacheLoaded(e);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                addSourceType(e, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e, t1, i);
                }
                removeSource(e) {
                    return this._isValidId(e) ? (this.style.removeSource(e), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e) {
                    return this._isValidId(e) ? this.style.getOwnSource(e) : null;
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: s = !1, stretchX: r, stretchY: n, content: a } = {}) {
                    this._lazyInitEmptyStyle();
                    const l = e.I.from(t1);
                    if (i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: t1, height: c, data: h } = e.q.getImageData(i);
                        this.style.addImage(l, {
                            data: new e.r({
                                width: t1,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: n,
                            content: a,
                            sdf: s,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e.z(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: c, height: h } = i, d = i;
                        this.style.addImage(l, {
                            data: new e.r({
                                width: c,
                                height: h
                            }, new Uint8Array(d.data)),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: n,
                            content: a,
                            sdf: s,
                            usvg: !1,
                            version: 0,
                            userImage: d
                        }), d.onAdd && d.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const o = e.I.from(t1), s = this.style.getImage(o);
                    if (!s) return void this.fire(new e.z(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const r = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e.q.getImageData(i) : i, { width: n, height: a, data: l } = r;
                    if (void 0 === n || void 0 === a) return void this.fire(new e.z(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (n !== (s.usvg ? s.icon.usvg_tree.width : s.data.width) || a !== (s.usvg ? s.icon.usvg_tree.height : s.data.height)) return void this.fire(new e.z(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${s.data.width}, ${s.data.height})`)));
                    const c = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let h = !1;
                    s.usvg ? (s.data = new e.r({
                        width: n,
                        height: a
                    }, new Uint8Array(l)), s.usvg = !1, s.icon = void 0, h = !0) : s.data.replace(l, c), this.style.updateImage(o, s, h);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(e.I.from(t1)) : (this.fire(new e.z(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(e.I.from(t1));
                }
                loadImage(t1, i) {
                    e.o(this._requestManager.transformRequest(t1, e.R.Image), (t1, o)=>{
                        i(t1, o instanceof HTMLImageElement ? e.q.getImageData(o) : o);
                    });
                }
                listImages() {
                    return this.style.listImages().map((e)=>e.name);
                }
                addModel(e, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e.z(new Error("Missing required model id"))), !1);
                }
                removeModel(e) {
                    this.style.removeModel(e);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e, t1) {
                    return this._isValidId(e.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e, t1), this._update(!0)) : this;
                }
                getSlot(e) {
                    const t1 = this.getLayer(e);
                    return t1 && t1.slot || null;
                }
                setSlot(e, t1) {
                    return this.style.setSlot(e, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(t1, i) {
                    return this.style.addImport(t1, i).catch((t1)=>this.fire(new e.z(new Error("Failed to add import", t1)))), this;
                }
                updateImport(e, t1) {
                    return "string" != typeof t1 && t1.id !== e ? (this.removeImport(e), this.addImport(t1)) : (this.style.updateImport(e, t1), this._update(!0));
                }
                removeImport(e) {
                    return this.style.removeImport(e), this;
                }
                moveImport(e, t1) {
                    return this.style.moveImport(e, t1), this._update(!0);
                }
                moveLayer(e, t1) {
                    return this._isValidId(e) ? (this.style.moveLayer(e, t1), this._update(!0)) : this;
                }
                removeLayer(e) {
                    return this._isValidId(e) ? (this.style.removeLayer(e), this._update(!0)) : this;
                }
                getLayer(e) {
                    if (!this._isValidId(e)) return null;
                    const t1 = this.style.getOwnLayer(e);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e, t1, i) {
                    return this._isValidId(e) ? (this.style.setLayerZoomRange(e, t1, i), this._update(!0)) : this;
                }
                setFilter(e, t1, i = {}) {
                    return this._isValidId(e) ? (this.style.setFilter(e, t1, i), this._update(!0)) : this;
                }
                getFilter(e) {
                    return this._isValidId(e) ? this.style.getFilter(e) : null;
                }
                setPaintProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setPaintProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getPaintProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getPaintProperty(e, t1) : null;
                }
                setLayoutProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setLayoutProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getLayoutProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getLayoutProperty(e, t1) : null;
                }
                getGlyphsUrl() {
                    return this.style.getGlyphsUrl();
                }
                setGlyphsUrl(e) {
                    return this.style.setGlyphsUrl(e), this._update(!0);
                }
                getSchema(e) {
                    return this.style.getSchema(e);
                }
                setSchema(e, t1) {
                    return this.style.setSchema(e, t1), this._update(!0);
                }
                getConfig(e) {
                    return this.style.getConfig(e);
                }
                setConfig(e, t1) {
                    return this.style.setConfig(e, t1), this._update(!0);
                }
                getConfigProperty(e, t1) {
                    return this.style.getConfigProperty(e, t1);
                }
                setConfigProperty(e, t1, i) {
                    return this.style.setConfigProperty(e, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e) {
                    return this.style.getFeaturesetDescriptors(e);
                }
                setLights(e) {
                    if (this._lazyInitEmptyStyle(), e && 1 === e.length && "flat" === e[0].type) {
                        const t1 = e[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e = this.style.getLights() || [];
                    return 0 === e.length && e.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e;
                }
                setLight(e, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e) {
                    return this._lazyInitEmptyStyle(), !e && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e), this._update(!0);
                }
                setImportColorTheme(e, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e, t1), this._update(!0);
                }
                setCamera(e) {
                    return this.style.setCamera(e), this._triggerCameraUpdate(e);
                }
                _triggerCameraUpdate(e) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.cd.convert(t1), this.transform) : 0;
                }
                setFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.setFeatureState(e, t1), this._update());
                }
                removeFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.removeFeatureState(e, t1), this._update());
                }
                getFeatureState(e) {
                    return e.source && !this._isValidId(e.source) ? null : this.style.getFeatureState(e);
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, o, s, r = this._container;
                    for(; r && (!o || !s);){
                        const e = window.getComputedStyle(r).transform;
                        e && "none" !== e && (i = e.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (s = i[3])), r = r.parentElement;
                    }
                    this._containerWidth = o ? Math.abs(e / o) : e, this._containerHeight = s ? Math.abs(t1 / s) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e = this._container;
                    e.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e);
                    this._canvas = l("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = l("div", "mapboxgl-control-container", e), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e)=>{
                        o[e] = l("div", `mapboxgl-ctrl-${e}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e.q.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e) {
                    this._markers.push(e);
                }
                _removeMarker(e) {
                    const t1 = this._markers.indexOf(e);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e) {
                    this._popups.push(e);
                }
                _removePopup(e) {
                    const t1 = this._popups.indexOf(e);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = e.h({}, a.supported.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), i = this._canvas.getContext("webgl2", t1);
                    i ? (j(i, !0), this.painter = new sa(i, this._contextCreateOptions, this.transform, this._scaleFactor, this._tp, this._worldview), this.on("data", (e)=>{
                        "source" === e.dataType && this.painter.setTileLoadedFlag(!0);
                    }), e.l.testSupport(i)) : this.fire(new e.z(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.A("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e.A("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e) {
                    if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e) {
                    return this.style ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e) {
                    return this._update(), this._renderTaskQueue.add(e);
                }
                _cancelRenderFrame(e) {
                    this._renderTaskQueue.remove(e);
                }
                _requestDomTask(e) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e() : this._domRenderTaskQueue.add(e);
                }
                _render(t1) {
                    let s;
                    this.fire(new e.A("renderstart")), ++this._frameId;
                    const r = this.painter.context.extTimerQuery, n = e.q.now(), a = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (s = a.createQuery(), a.beginQuery(r.TIME_ELAPSED_EXT, s)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const l = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e.q.now(), s = new e.aa(t1, {
                            now: o,
                            fadeDuration: l,
                            pitch: i,
                            transition: this.style.transition,
                            worldview: this._worldview
                        });
                        this.style.update(s);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let c = !1;
                    this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), c = this._updateAverageElevation(n), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : c = this._updateAverageElevation(n);
                    const h = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, this.painter.replacementSource, this._scaleFactorChanged);
                    if (this._scaleFactorChanged && (this._scaleFactorChanged = !1), h && (this._placementDirty = h.needsRerender), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: l,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e.A("render")), this.loaded() && !this._loaded && (this._loaded = !0, o.mark(i.load), this.fire(new e.A("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = !0), this.style && !this.style.modelManager.isLoaded() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), s) {
                        const t1 = e.q.now() - n;
                        a.endQuery(r.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const i = a.getQueryParameter(s, a.QUERY_RESULT) / 1e6;
                            a.deleteQuery(s), this.fire(new e.A("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e.A("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e.A("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const d = this._sourcesDirty || this._styleDirty || this._placementDirty || c;
                    if (d || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (c = this._updateAverageElevation(n, !0)), c) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e.A("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e.A("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0, o.mark(i.fullLoad), this._performanceMetricsCollection && B(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e) {
                    for (const t1 of this._markers)e && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e, t1 = !1) {
                    const i = (e)=>(this.transform.averageElevation = e, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (o || (t1 || e - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e)) {
                        const t1 = this.transform.averageElevation;
                        let s = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(s) ? s = 0 : this._averageElevationLastSampledAt = e;
                        const r = Math.abs(t1 - s);
                        if (r > 1) {
                            if (this._isInitialLoad || o) return this._averageElevation.jumpTo(s), i(s);
                            this._averageElevation.easeTo(s, e, 300);
                        } else if (r > 1e-4) return this._averageElevation.jumpTo(s), i(s);
                    }
                    return !!this._averageElevation.isEasing(e) && i(this._averageElevation.getValue(e));
                }
                _authenticate() {
                    N(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === w || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            j(t1, !1), this._logoControl instanceof al && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.z(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), z(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && O(this._requestManager._customAccessToken, {
                        map: this,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _updateTerrain() {
                    const e = this._isDragging();
                    this.painter.updateTerrain(this.style, e);
                }
                _calculateSpeedIndex() {
                    const e = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function s(e) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(s(e), t1.canvasCopies.map(s), t1.timeStamps);
                }
                _canvasPixelComparison(e, t1, i) {
                    let o = i[1] - i[0];
                    const s = e.length / 4;
                    for(let r = 0; r < t1.length; r++){
                        const n = t1[r];
                        let a = 0;
                        for(let t1 = 0; t1 < n.length; t1 += 4)n[t1] === e[t1] && n[t1 + 1] === e[t1 + 1] && n[t1 + 2] === e[t1 + 2] && n[t1 + 3] === e[t1 + 3] && (a += 1);
                        o += (i[r + 2] - i[r + 1]) * (1 - a / s);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e of this._controls)e.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.indoor.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), U.delete(this.painter.context.gl), k.remove(), P.remove(), this._removed = !0, this.fire(new e.A("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e.q.frame((e)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e.bt(i, (e, i)=>e._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e) {
                    this._trackResize && this.resize({
                        originalEvent: e
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e) {
                    this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._tp.refreshUI(), this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e) {
                    this._showParseStatus !== e && (this._showParseStatus = e, this._tp.refreshUI(), this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e) {
                    this._showTerrainWireframe !== e && (this._showTerrainWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e) {
                    this._showLayers2DWireframe !== e && (this._showLayers2DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e) {
                    this._showLayers3DWireframe !== e && (this._showLayers3DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e) {
                    this._speedIndexTiming !== e && (this._speedIndexTiming = e, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e) {
                    this._showPadding !== e && (this._showPadding = e, this._tp.refreshUI(), this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e) {
                    this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, this._tp.refreshUI(), e ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e) {
                    this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._tp.refreshUI(), this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e) {
                    this._repaint !== e && (this._repaint = e, this._tp.refreshUI(), this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e) {
                    this._vertices = e, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e) {
                    this._showTileAABBs !== e && (this._showTileAABBs = e, this._tp.refreshUI(), e && this._update());
                }
                _setCacheLimits(t1, i) {
                    e.eJ(t1, i);
                }
                get version() {
                    return t1;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = e.h({}, fl, t1), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.options.showZoom && (e.aV([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.aV([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e
                        }) : t1.resetNorth({}, {
                            originalEvent: e
                        }));
                    }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = e.getZoom(), i = t1 === e.getMaxZoom(), o = t1 === e.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e.transform.angle * (180 / Math.PI)}deg)`;
                    e._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e) {
                    return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e.on("pitch", this._rotateCompassArrow), e.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ml(e, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e = this._map;
                    e && (this._container.remove(), this.options.showZoom && e.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e.off("pitch", this._rotateCompassArrow), e.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e, t1) {
                    const i = l("button", e, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e.setAttribute("aria-label", i), e.firstElementChild && e.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = e.h({
                        geolocation: i
                    }, bl, t1), e.aV([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = ra(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e) {
                    return this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>t1("denied" !== e.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e) {
                    const t1 = this._map.getMaxBounds(), i = e.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e.A("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("geolocate", t1)), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e.cd(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, s = this._map.getBearing(), r = e.h({
                        bearing: s
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e.cd(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e.c6(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("error", t1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new xl({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new xl({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.A("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e) {
                    this._userLocationDotMarker && (e.webkitCompassHeading ? this._heading = e.webkitCompassHeading : !0 === e.absolute && (this._heading = -1 * e.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e.A("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.A("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.A("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const e = ()=>{
                        "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
                    };
                    "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e();
                    }).catch(console.error) : e();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: nl,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = e.h({}, wl, t1), this._isNumberFormatSupported = function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "short",
                                unit: "meter"
                            }), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), e.aV([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e / 2, s = t1.unproject([
                        o,
                        i
                    ]), r = t1.unproject([
                        o + e,
                        i
                    ]), n = s.distanceTo(r);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * n;
                        t1 > 5280 ? this._setScale(e, t1 / 5280, "mile") : this._setScale(e, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e, n / 1852, "nautical-mile") : n >= 1e3 ? this._setScale(e, n / 1e3, "kilometer") : this._setScale(e, n, "meter");
                }
                _setScale(e, t1, i) {
                    this._map._requestDomTask(()=>{
                        const o = function(e) {
                            const t1 = Math.pow(10, `${Math.floor(e)}`.length - 1);
                            let i = e / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                                return Math.round(e * t1) / t1;
                            }(i), t1 * i;
                        }(t1), s = o / t1;
                        this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(o) : `${o}&nbsp;${Tl[i]}`, this._container.style.width = e * s + "px";
                    });
                }
                onAdd(e) {
                    return this._map = e, this._language = e.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e) {
                    this._language = e, this._update();
                }
                setUnit(e) {
                    this.options.unit = e, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e.w("Full screen control 'container' must be a DOM element.")), e.aV([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            Popup: class extends e.E {
                constructor(t1){
                    super(), this.options = e.h(Object.create(El), t1), this._altitude = this.options.altitude, e.aV([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e.A("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e.A("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e.cd.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                getAltitude() {
                    return this._altitude;
                }
                setAltitude(e) {
                    return this._altitude = e, this._update(), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e = this._map;
                    return e && (e.off("move", this._update), e.on("mousemove", this._onMouseEvent), e.on("drag", this._onMouseEvent), e._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e) {
                    return this.setDOMContent(document.createTextNode(e));
                }
                setHTML(e) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = e; o = i.firstChild, o;)t1.appendChild(o);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e) {
                    return this.options.maxWidth = e, this._update(), this;
                }
                setDOMContent(e) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e), this.options.closeButton) {
                        const e = this._closeButton = l("button", "mapboxgl-popup-close-button", t1);
                        e.type = "button", e.setAttribute("aria-label", "Close popup"), e.innerHTML = '<span aria-hidden="true">&#215;</span>', e.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e) {
                    return this._classList.add(e), this._updateClassList(), this;
                }
                removeClassName(e) {
                    return this._classList.delete(e), this._updateClassList(), this;
                }
                setOffset(e) {
                    return this.options.offset = e, this._update(), this;
                }
                toggleClassName(e) {
                    let t1;
                    return this._classList.delete(e) ? t1 = !1 : (this._classList.add(e), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e) {
                    this._update(e.point);
                }
                _getAnchor(e) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const s = i.offsetWidth, r = i.offsetHeight, n = o.x < s / 2, a = o.x > t1.transform.width - s / 2;
                    if (o.y + e < r) return n ? "top-left" : a ? "top-right" : "top";
                    if (o.y > t1.transform.height - r) {
                        if (n) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return n ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e = this._container;
                    if (!e) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let s = this._container;
                    if (s || (s = this._container = l("div", "mapboxgl-popup", i.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", s), s.appendChild(o)), this.options.maxWidth && s.style.maxWidth !== this.options.maxWidth && (s.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = gl(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const o = this._pos = this._trackPointer && t1 instanceof e.P ? t1 : i.project(this._lngLat, this._altitude), s = Il(this.options.offset), r = this._anchor = this._getAnchor(s.y), n = Il(this.options.offset, r), a = o.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && r && (this._container.style.transform = `${vl[r]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e.eK(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e = this._container.querySelector(Sl);
                    e && e.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e) {
                    this._container && (this._container.style.opacity = `${e}`), this._content && (this._content.style.pointerEvents = e ? "auto" : "none");
                }
            },
            Marker: xl,
            Style: Eo,
            LngLat: e.cd,
            LngLatBounds: e.aG,
            Point: e.P,
            MercatorCoordinate: e.ac,
            FreeCameraOptions: $i,
            Evented: e.E,
            config: e.e,
            prewarm: e.eO,
            clearPrewarmedResources: e.eN,
            get accessToken () {
                return e.e.ACCESS_TOKEN;
            },
            set accessToken (t){
                e.e.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e.e.API_URL;
            },
            set baseApiUrl (t){
                e.e.API_URL = t;
            },
            get workerCount () {
                return e.eX.workerCount;
            },
            set workerCount (t){
                e.eX.workerCount = t;
            },
            get maxParallelImageRequests () {
                return e.e.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e.e.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e.eW(t1);
            },
            get workerUrl () {
                return e.eV.workerUrl;
            },
            set workerUrl (t){
                e.eV.workerUrl = t;
            },
            get workerClass () {
                return e.eV.workerClass;
            },
            set workerClass (t){
                e.eV.workerClass = t;
            },
            get workerParams () {
                return e.eV.workerParams;
            },
            set workerParams (t){
                e.eV.workerParams = t;
            },
            get dracoUrl () {
                return e.eU();
            },
            set dracoUrl (t){
                e.eT(t);
            },
            get meshoptUrl () {
                return e.eS();
            },
            set meshoptUrl (t){
                e.eR(t);
            },
            setNow: e.q.setNow,
            restoreNow: e.q.restoreNow
        };
        return Cl;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});


var $92af916dd9113551$exports = {};
$92af916dd9113551$exports = JSON.parse("[{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.6670019,\"lat\":45.0176181},{\"lng\":9.0078954,\"lat\":50.0819515},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-76.3952429,\"lat\":40.1637359},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":70.8028377,\"lat\":22.3053263},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-70.8645872,\"lat\":43.2625585},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.2585107,\"lat\":25.7331105},{\"lng\":6.1961189,\"lat\":45.8597877},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":3.0105105,\"lat\":42.704359},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.1320819,\"lat\":43.63233},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.582876,\"lat\":49.8585784},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":11.8627403,\"lat\":45.3951113},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.4779448,\"lat\":46.3731303},{\"lng\":6.0577244,\"lat\":46.333849},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.2655785,\"lat\":39.1713082},{\"lng\":-83.4571058,\"lat\":34.203997},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":3.9107676,\"lat\":43.6611507},{\"lng\":-82.1811947,\"lat\":28.2336196},{\"lng\":-91.580705,\"lat\":41.6759977},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":4.5098046,\"lat\":45.4748298},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-121.8901232,\"lat\":38.0181745},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-122.29214,\"lat\":47.1849009},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":6.9890508,\"lat\":50.7627913},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-0.3727503,\"lat\":49.320622},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":-71.6885443,\"lat\":43.7572734},{\"lng\":-74.9813349,\"lat\":44.6697996},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":114.1800713,\"lat\":22.3159018},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-1.5695287,\"lat\":47.1905456},{\"lng\":-92.1052679,\"lat\":46.7838287},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.5496148,\"lat\":33.9528472},{\"lng\":-74.6004341,\"lat\":40.3334409},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":2.6200032,\"lat\":48.8457347},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":8.6288,\"lat\":49.6977},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1991229,\"lat\":51.4989948},{\"lng\":-71.7614891,\"lat\":42.5267443},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3668279,\"lat\":50.8331141},{\"lng\":18.016667,\"lat\":59.366667},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.2401542,\"lat\":47.6238204},{\"lng\":8.87722,\"lat\":49.2553},{\"lng\":74.6043881,\"lat\":42.868594},{\"lng\":-121.9856782,\"lat\":47.7423219},{\"lng\":20.441944,\"lat\":-34.021111},{\"lng\":-79.8956803,\"lat\":43.3314156},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-75.9768632,\"lat\":43.0020107},{\"lng\":-93.0815678,\"lat\":37.0011646},{\"lng\":-76.9274072,\"lat\":38.6023935},{\"lng\":13.0591397,\"lat\":52.4009309},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-75.7515682,\"lat\":39.6828358},{\"lng\":7.4492808,\"lat\":48.4088704},{\"lng\":-109.92006,\"lat\":22.8938884},{\"lng\":-75.3499124,\"lat\":39.9020565},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.4881846,\"lat\":44.9259011},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.644097,\"lat\":34.1446643},{\"lng\":-89.262291,\"lat\":35.5939671},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":0.1967849,\"lat\":48.0073849},{\"lng\":6.6916476,\"lat\":51.1981778},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":8.5837524,\"lat\":50.3012792},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.4041725,\"lat\":39.516644},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-88.1361888,\"lat\":42.1539141},{\"lng\":2.48291,\"lat\":48.9031},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":8.550301,\"lat\":48.7502439},{\"lng\":-6.6833615,\"lat\":53.651908},{\"lng\":8.5830859,\"lat\":47.3176276},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":3.2876843,\"lat\":49.8465253},{\"lng\":-88.1897393,\"lat\":41.7828751},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":-74.0120817,\"lat\":40.2203907},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":76.9628425,\"lat\":11.0018115},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":2.7015872,\"lat\":48.4049375},{\"lng\":-77.1929215,\"lat\":39.1399187},{\"lng\":10.2511001,\"lat\":53.5098898},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":6.6617476,\"lat\":46.5098019},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-89.9841627,\"lat\":38.5135805},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-75.3788141,\"lat\":37.9331799},{\"lng\":-73.8587461,\"lat\":41.0762077},{\"lng\":2.5060144,\"lat\":48.8608712},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.3464675,\"lat\":42.512807},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.450394,\"lat\":45.5262762},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-117.9859054,\"lat\":33.7578725},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":7.6824892,\"lat\":45.0677551},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3745921,\"lat\":50.8498357},{\"lng\":2.3796245,\"lat\":48.9960813},{\"lng\":-1.3741375,\"lat\":52.7257981},{\"lng\":-122.232523,\"lat\":37.4863239},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-88.3021092,\"lat\":36.6106122},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":100.4230508,\"lat\":13.7803993},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.4880064,\"lat\":29.8909508},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-3.391696,\"lat\":51.9472048},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.7949873,\"lat\":55.17108},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.0832674,\"lat\":50.8765528},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.399513,\"lat\":26.1003392},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.4172117,\"lat\":48.6998552},{\"lng\":-0.6259875,\"lat\":48.4944837},{\"lng\":9.976727,\"lat\":56.6488769},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":8.6918153,\"lat\":47.253174},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-124.1027898,\"lat\":40.966005},{\"lng\":7.5029213,\"lat\":43.7753495},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":6.4779448,\"lat\":46.3731303},{\"lng\":2.7015872,\"lat\":48.4049375},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":4.7934767,\"lat\":45.7362255},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":8.3054682,\"lat\":47.0505452},{\"lng\":37.6742652,\"lat\":-6.8254864},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.3745921,\"lat\":50.8498357},{\"lng\":-1.8538889,\"lat\":46.6286111},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-58.4664257,\"lat\":-34.8192731},{\"lng\":2.3019814,\"lat\":48.8211559},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-157.804184,\"lat\":21.418555},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":127.0473,\"lat\":37.5177},{\"lng\":-61.0055945,\"lat\":14.5906832},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":0.2827942,\"lat\":51.5093771},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.1496735,\"lat\":43.6306683},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.8723084,\"lat\":26.640628},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-85.7196893,\"lat\":34.4442547},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":2.134529,\"lat\":48.7018823},{\"lng\":2.1066273,\"lat\":48.8972505},{\"lng\":8.4611036,\"lat\":47.1823761},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.7144158,\"lat\":45.3663548},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.634158,\"lat\":33.2483858},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":2.4818087,\"lat\":48.6137734},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.4547891,\"lat\":42.9956397},{\"lng\":6.3121658,\"lat\":46.0672189},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-70.7939307,\"lat\":42.1617681},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-79.310989,\"lat\":45.041508},{\"lng\":-122.0402399,\"lat\":37.5296593},{\"lng\":-80.8100724,\"lat\":35.5848596},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-80.4742261,\"lat\":35.6709727},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-74.60988,\"lat\":40.5742696},{\"lng\":25.1919784,\"lat\":37.0651494},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-118.644097,\"lat\":34.1446643},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.4621381,\"lat\":53.3783713},{\"lng\":-88.4069744,\"lat\":44.2613967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.2662784,\"lat\":19.416149},{\"lng\":6.1301614,\"lat\":43.1202573},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-1.6171482,\"lat\":48.088155},{\"lng\":-1.257412,\"lat\":51.4024177},{\"lng\":-71.100082,\"lat\":43.115019},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-78.1652404,\"lat\":39.1852184},{\"lng\":-85.865235,\"lat\":42.870889},{\"lng\":-77.4579783,\"lat\":38.4167265},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7068005,\"lat\":50.0774496},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.5204498,\"lat\":45.3188331},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":-3.5211361,\"lat\":50.4652392},{\"lng\":-94.9445572,\"lat\":32.728803},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-117.1827445,\"lat\":34.0550328},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-118.4388067,\"lat\":33.9541453},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-76.3070273,\"lat\":41.1264315},{\"lng\":-72.409797,\"lat\":42.4521519},{\"lng\":-72.6158096,\"lat\":40.9733195},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-76.7918234,\"lat\":39.4148436},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-94.2471515,\"lat\":36.0420248},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-0.3394758,\"lat\":53.7435722},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.4995234,\"lat\":37.5980374},{\"lng\":6.6548702,\"lat\":46.2346174},{\"lng\":2.2368863,\"lat\":48.8841522},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-89.031784,\"lat\":42.5083272},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-76.7074042,\"lat\":37.2708788},{\"lng\":-77.2726393,\"lat\":39.3827893},{\"lng\":5.2828123,\"lat\":45.5872259},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.7279185,\"lat\":42.8192943},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-80.2389899,\"lat\":27.2379528},{\"lng\":-83.4675021,\"lat\":42.3712},{\"lng\":-75.3112095,\"lat\":40.7423309},{\"lng\":-92.1476353,\"lat\":32.5184775},{\"lng\":-75.2188589,\"lat\":38.324505},{\"lng\":-121.8746789,\"lat\":37.6624312},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":5.2232175,\"lat\":46.6291425},{\"lng\":-122.8718605,\"lat\":42.3264181},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":98.3891503,\"lat\":7.8847901},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":2.0030818,\"lat\":48.980925},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":-88.4069744,\"lat\":44.2613967},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3476583,\"lat\":46.4976734},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":105.8406959,\"lat\":21.0242596},{\"lng\":-100.7654232,\"lat\":41.1238873},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":-71.1244963,\"lat\":42.2556543},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.702183,\"lat\":49.01072},{\"lng\":-122.643224,\"lat\":48.2931559},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-1.5695287,\"lat\":47.1905456},{\"lng\":-0.2441765,\"lat\":44.4701196},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-78.8688833,\"lat\":38.4493315},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":0.8722566,\"lat\":51.148555},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-80.7325345,\"lat\":28.3556635},{\"lng\":-51.2303767,\"lat\":-30.0324999},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-84.4549262,\"lat\":33.4487257},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":10.3952118,\"lat\":63.4304475},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.6587085,\"lat\":40.2337289},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":3.9070658,\"lat\":47.4885365},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.3068482,\"lat\":48.9699732},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-81.4412259,\"lat\":41.3897764},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-72.5886727,\"lat\":42.1018764},{\"lng\":2.0949768,\"lat\":48.9938791},{\"lng\":2.4530731,\"lat\":48.7771486},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-88.1836965,\"lat\":42.3966874},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-76.2494453,\"lat\":36.7168315},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":-93.5885717,\"lat\":44.0172242},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":75.8681996,\"lat\":22.7203616},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":6.9292641,\"lat\":46.9895828},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-81.5345547,\"lat\":28.4944695},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.1386547,\"lat\":26.8233946},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":0.7650348,\"lat\":45.1724869},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":73.053721,\"lat\":33.5915446},{\"lng\":6.0812467,\"lat\":46.1444789},{\"lng\":-79.697545,\"lat\":40.4284015},{\"lng\":-84.1401926,\"lat\":34.2073196},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-3.2510247,\"lat\":47.6975924},{\"lng\":-158.009166,\"lat\":21.3866667},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":71.4719683,\"lat\":30.197838},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":6.6349892,\"lat\":45.4140984},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":3.6159046,\"lat\":47.9933948},{\"lng\":-2.0260409,\"lat\":48.649518},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":10.7571408,\"lat\":48.1479335},{\"lng\":-119.9843482,\"lat\":38.9332411},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-78.6177611,\"lat\":42.7689141},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":10.281931,\"lat\":47.5135363},{\"lng\":2.4516055,\"lat\":48.8897751},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-86.8919011,\"lat\":40.4191229},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":2.4530731,\"lat\":48.7771486},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-84.7721823,\"lat\":37.6456488},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.1709524,\"lat\":45.7768401},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-120.8465941,\"lat\":37.4946568},{\"lng\":-105.0811573,\"lat\":39.8005505},{\"lng\":2.3002885,\"lat\":48.9875044},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.9804153,\"lat\":46.236193},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":7.2156901,\"lat\":51.1406481},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":4.3628851,\"lat\":48.9566218},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-112.583776,\"lat\":33.3703197},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":-97.2271249,\"lat\":32.9299655},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":4.1395124,\"lat\":51.1646685},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-84.0176904,\"lat\":33.6676103},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":11.3525415,\"lat\":55.4061196},{\"lng\":-87.0717718,\"lat\":20.6269889},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-88.207301,\"lat\":40.1117174},{\"lng\":-8.4362569,\"lat\":41.6488247},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-71.3084633,\"lat\":41.7407661},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":104.9224426,\"lat\":11.568271},{\"lng\":-3.1502007,\"lat\":48.5618483},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-97.371118,\"lat\":30.3495084},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":0.4065503,\"lat\":52.2443103},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-86.3119346,\"lat\":36.4817111},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-121.4415851,\"lat\":49.3799779},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-76.6220212,\"lat\":39.4482981},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.8062224,\"lat\":47.6980235},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-84.5597128,\"lat\":38.2099837},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.9367107,\"lat\":40.5584882},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-75.9125187,\"lat\":42.098698},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-117.7197785,\"lat\":34.0966764},{\"lng\":-121.176058,\"lat\":38.6779591},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-86.2483921,\"lat\":43.2341813},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":0.6176112,\"lat\":44.2015827},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-15.4349015,\"lat\":28.1288694},{\"lng\":7.2439029,\"lat\":47.1402077},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-80.7440174,\"lat\":34.9248125},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-90.0367512,\"lat\":32.612602},{\"lng\":-72.7395401,\"lat\":41.7162112},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":2.02135,\"lat\":47.9019},{\"lng\":-74.5659848,\"lat\":40.4138861},{\"lng\":-118.144155,\"lat\":34.1476507},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-57.5482079,\"lat\":-37.9976168},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":6.51777,\"lat\":46.5461677},{\"lng\":-88.580956,\"lat\":47.126871},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":75.2763203,\"lat\":17.8499067},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-74.0844894,\"lat\":41.7464972},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-95.5377215,\"lat\":29.6185669},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-119.8276389,\"lat\":34.4358295},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.8937398,\"lat\":41.1365122},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-81.3885899,\"lat\":28.6619154},{\"lng\":12.918914,\"lat\":50.8323531},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":3.0681174,\"lat\":45.776018},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-89.216655,\"lat\":37.7274692},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":9.7423762,\"lat\":47.4136351},{\"lng\":2.8773541,\"lat\":48.9582708},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.3227803,\"lat\":38.7919683},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-0.3033105,\"lat\":51.3937557},{\"lng\":-1.0886623,\"lat\":50.7888796},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":-0.6486943,\"lat\":44.8854667},{\"lng\":-104.5229518,\"lat\":33.3943282},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":17.7821882,\"lat\":48.4791862},{\"lng\":-84.2946539,\"lat\":37.7478572},{\"lng\":-118.7381293,\"lat\":34.1431615},{\"lng\":-86.8425761,\"lat\":21.1527467},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":15.4382786,\"lat\":47.0708678},{\"lng\":-101.8371192,\"lat\":35.20729},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-70.8873511,\"lat\":42.6046209},{\"lng\":-5.5352463,\"lat\":50.1194794},{\"lng\":-0.2157507,\"lat\":51.5566986},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":1.3549991,\"lat\":44.0175835},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-71.2804301,\"lat\":41.9439695},{\"lng\":1.9871825,\"lat\":48.8214478},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-0.0144629,\"lat\":51.5110713},{\"lng\":98.9858802,\"lat\":18.7882778},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.1561947,\"lat\":45.6484505},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-71.0619957,\"lat\":42.3778749},{\"lng\":2.4309703,\"lat\":48.8012045},{\"lng\":121.4589414,\"lat\":25.061706},{\"lng\":-0.4440957,\"lat\":44.9954151},{\"lng\":-0.1726236,\"lat\":51.6482779},{\"lng\":5.7086562,\"lat\":46.8348315},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.9036592,\"lat\":37.570148},{\"lng\":-89.5119565,\"lat\":43.0962919},{\"lng\":-70.2177099,\"lat\":44.0990717},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":-97.6736292,\"lat\":29.8832105},{\"lng\":7.1116845,\"lat\":43.7224167},{\"lng\":-69.2276,\"lat\":45.183489},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-116.4139839,\"lat\":34.1236205},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.5212467,\"lat\":42.5069391},{\"lng\":-121.802173,\"lat\":36.6844029},{\"lng\":5.1580574,\"lat\":45.614003},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-83.9478911,\"lat\":42.0554875},{\"lng\":-94.6851702,\"lat\":38.9742502},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.4396714,\"lat\":48.8474508},{\"lng\":-88.5223353,\"lat\":34.9343599},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.4809129,\"lat\":48.7489857},{\"lng\":-78.4457422,\"lat\":40.9908706},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-88.7774734,\"lat\":46.8591287},{\"lng\":-86.2045442,\"lat\":32.5378668},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-71.6854725,\"lat\":43.3260376},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-120.6707255,\"lat\":35.4894169},{\"lng\":8.7473608,\"lat\":50.3681107},{\"lng\":2.4252507,\"lat\":6.3676953},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.30551,\"lat\":48.9026},{\"lng\":2.5358323,\"lat\":48.8853743},{\"lng\":10.5966672,\"lat\":35.7613215},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":5.6062495,\"lat\":43.1758591},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":1.7140683,\"lat\":48.9891971},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-75.0629531,\"lat\":42.453492},{\"lng\":-71.296806,\"lat\":46.944403},{\"lng\":76.2444378,\"lat\":9.9679032},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.4649038,\"lat\":35.6571367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-106.1311288,\"lat\":38.8422178},{\"lng\":-78.0419281,\"lat\":42.2446061},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-73.7131153,\"lat\":41.2815783},{\"lng\":139.6638239,\"lat\":35.7077741},{\"lng\":-74.0410865,\"lat\":40.8871438},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-111.9866954,\"lat\":40.6967891},{\"lng\":3.0360448,\"lat\":48.1650409},{\"lng\":-122.561503,\"lat\":37.9744323},{\"lng\":-1.7594444,\"lat\":46.6986111},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-0.6179871,\"lat\":48.3044218},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.0018401,\"lat\":41.093429},{\"lng\":-70.8092074,\"lat\":42.0714907},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-82.9295287,\"lat\":40.126139},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.016107,\"lat\":5.320357},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-79.6411594,\"lat\":39.6586918},{\"lng\":-85.8283224,\"lat\":33.6624824},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-0.5597383,\"lat\":48.5727431},{\"lng\":-80.23727,\"lat\":26.3100794},{\"lng\":-111.6587085,\"lat\":40.2337289},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-116.9589086,\"lat\":33.7839664},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.4460583,\"lat\":37.3562229},{\"lng\":-121.2810611,\"lat\":38.7071247},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-1.4992075,\"lat\":47.2035029},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.3939844,\"lat\":43.6637121},{\"lng\":-121.655037,\"lat\":36.6744117},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-88.9416829,\"lat\":35.9808073},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.2099992,\"lat\":44.9754211},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":121.4511111,\"lat\":31.2515439},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":19.2691151,\"lat\":42.4321076},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":2.2105491,\"lat\":48.9250016},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.9688719,\"lat\":48.226109},{\"lng\":-83.1427148,\"lat\":42.8653073},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":121.0589931,\"lat\":14.5637482},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-3.0509812,\"lat\":53.8179442},{\"lng\":-122.039966,\"lat\":38.2493581},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":6.7360182,\"lat\":43.4330308},{\"lng\":-71.6097744,\"lat\":42.4342336},{\"lng\":-79.625599,\"lat\":40.4181235},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-74.2390353,\"lat\":40.7987113},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.0117661,\"lat\":51.1322179},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":-123.204785,\"lat\":44.2191935},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-76.0704906,\"lat\":42.5842136},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":7.0134418,\"lat\":43.5515198},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":2.2411289,\"lat\":43.6053809},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-120.310349,\"lat\":47.4234599},{\"lng\":2.8709277,\"lat\":42.7683568},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.5783856,\"lat\":46.1825453},{\"lng\":166.442419,\"lat\":-22.2745264},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-78.1677784,\"lat\":43.9595998},{\"lng\":-112.0154991,\"lat\":41.5110434},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-79.7919754,\"lat\":36.0726355},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-117.6029341,\"lat\":33.6408845},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-81.2595731,\"lat\":40.8375307},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":0.8657641,\"lat\":46.5666888},{\"lng\":-71.5517636,\"lat\":-33.0244535},{\"lng\":2.1614464,\"lat\":48.4344621},{\"lng\":1.3549991,\"lat\":44.0175835},{\"lng\":5.778361,\"lat\":45.2097372},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.0942792,\"lat\":48.8990413},{\"lng\":-105.0811573,\"lat\":39.8005505},{\"lng\":5.5910751,\"lat\":45.3631386},{\"lng\":4.0746257,\"lat\":48.2971626},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":3.0043728,\"lat\":42.6176479},{\"lng\":-117.7197785,\"lat\":34.0966764},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-0.6486943,\"lat\":44.8854667},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-0.3699697,\"lat\":50.8115402},{\"lng\":121.4710784,\"lat\":25.0267902},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-81.1655408,\"lat\":34.9603293},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-81.1802101,\"lat\":34.0884688},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-1.1609361,\"lat\":44.3907065},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":0.7184407,\"lat\":45.1909365},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":4.6869716,\"lat\":45.9264129},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-1.5113138,\"lat\":46.6858331},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":4.8322266,\"lat\":46.3036683},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":7.7484488,\"lat\":48.6047148},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-90.3854141,\"lat\":43.3355298},{\"lng\":-75.1162306,\"lat\":40.1507046},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":6.8827786,\"lat\":49.287307},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-77.4806603,\"lat\":37.7594012},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-77.4752667,\"lat\":38.7509488},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.8738344,\"lat\":48.1758188},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-87.8709308,\"lat\":42.9744081},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-116.962526,\"lat\":32.7947731},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1438863,\"lat\":39.770683},{\"lng\":1.9533495,\"lat\":43.3192021},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":42.5043596,\"lat\":18.2164282},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-66.9146008,\"lat\":10.5060934},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-0.454723,\"lat\":44.9711192},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.7131153,\"lat\":41.2815783},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":5.0135224,\"lat\":52.1073555},{\"lng\":19.1585805,\"lat\":48.7383895},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":99.9956193,\"lat\":9.5013944},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.3018662,\"lat\":51.6201654},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":0.077533,\"lat\":46.621605},{\"lng\":-86.2307992,\"lat\":30.3466423},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.4315213,\"lat\":43.6403659},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-71.0037374,\"lat\":42.2509914},{\"lng\":-80.0666026,\"lat\":26.5256179},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-77.3465081,\"lat\":37.5131191},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":-0.2163018,\"lat\":51.4625314},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.5215973,\"lat\":42.9751766},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":-121.387742,\"lat\":36.2231079},{\"lng\":58.5938134,\"lat\":23.6123628},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":5.3882954,\"lat\":47.1936509},{\"lng\":-68.672791,\"lat\":44.883607},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-78.9636394,\"lat\":43.0183219},{\"lng\":-74.2870925,\"lat\":41.9673148},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":55.4776174,\"lat\":-21.341298},{\"lng\":-2.6992717,\"lat\":53.7593363},{\"lng\":2.9191579,\"lat\":42.7452716},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-83.5135665,\"lat\":41.9153358},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-75.4482522,\"lat\":39.8742784},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.559849,\"lat\":34.4131941},{\"lng\":-120.9968892,\"lat\":37.6393419},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-72.0997804,\"lat\":41.3556187},{\"lng\":6.1983858,\"lat\":46.1884304},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.4154549,\"lat\":36.7329712},{\"lng\":-116.962526,\"lat\":32.7947731},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.2079468,\"lat\":43.9540167},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.926018,\"lat\":33.4942189},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":76.214621,\"lat\":10.5270099},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":5.8389606,\"lat\":51.8425749},{\"lng\":-103.4885462,\"lat\":38.9208296},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-70.8578253,\"lat\":42.500096},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":-76.7080456,\"lat\":39.385227},{\"lng\":12.3063909,\"lat\":55.9285735},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-85.6165976,\"lat\":44.7606481},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-106.1130821,\"lat\":37.6000793},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-79.5443274,\"lat\":40.3024514},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-73.2435218,\"lat\":40.7276525},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.2470646,\"lat\":52.2316268},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.510611,\"lat\":48.8137847},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.810138,\"lat\":39.9234046},{\"lng\":-80.4136767,\"lat\":37.2296566},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-71.0183787,\"lat\":42.0834335},{\"lng\":7.4817123,\"lat\":48.4623358},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0072568,\"lat\":40.8860164},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":2.2465748,\"lat\":48.9069349},{\"lng\":10.5935183,\"lat\":35.8749788},{\"lng\":-90.8683119,\"lat\":38.8244136},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":-121.2736022,\"lat\":38.1342805},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-122.3520327,\"lat\":48.24216},{\"lng\":-119.9036592,\"lat\":37.570148},{\"lng\":-77.859581,\"lat\":39.2891836},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":-83.1895249,\"lat\":40.5885271},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-105.07498,\"lat\":40.3977612},{\"lng\":-91.8572479,\"lat\":47.901571},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":19.883611,\"lat\":-33.802222},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":7.3779933,\"lat\":51.0186197},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.1677298,\"lat\":47.2473358},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-122.2688522,\"lat\":37.5600336},{\"lng\":-87.5675258,\"lat\":33.2095614},{\"lng\":-117.2414989,\"lat\":33.5939372},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":6.1642972,\"lat\":45.8333544},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-91.2514355,\"lat\":43.8122836},{\"lng\":-73.7853915,\"lat\":43.0821793},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":6.9787389,\"lat\":45.449556},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.2444145,\"lat\":-3.749365},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-121.2999485,\"lat\":38.2546373},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1162306,\"lat\":40.1507046},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-78.8336218,\"lat\":35.6512655},{\"lng\":-107.0603126,\"lat\":38.6476702},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-82.0119202,\"lat\":31.4876934},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":79.8542005,\"lat\":6.9388614},{\"lng\":2.1882897,\"lat\":48.8086297},{\"lng\":-123.057938,\"lat\":49.0846258},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":-71.0037374,\"lat\":42.2509914},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-75.2215651,\"lat\":40.1545535},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.7529071,\"lat\":36.9092773},{\"lng\":-76.6932818,\"lat\":42.8397906},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-85.8530544,\"lat\":41.2381017},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":-88.4474302,\"lat\":42.3147529},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.6503982,\"lat\":41.0413873},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-95.677556,\"lat\":39.049011},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-72.9020069,\"lat\":41.3836233},{\"lng\":-84.5930113,\"lat\":35.4428864},{\"lng\":-64.8004265,\"lat\":46.0985679},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-0.7095942,\"lat\":45.5970869},{\"lng\":-0.4968888,\"lat\":44.7846424},{\"lng\":4.8111564,\"lat\":43.6384838},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-95.3489561,\"lat\":32.2031228},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.7465033,\"lat\":52.0348915},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-85.2527381,\"lat\":37.5697869},{\"lng\":-117.7075526,\"lat\":33.5225261},{\"lng\":2.30551,\"lat\":48.9026},{\"lng\":-85.5872286,\"lat\":42.291707},{\"lng\":-122.3774952,\"lat\":47.8105738},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":6.9129921,\"lat\":46.4310831},{\"lng\":-112.468812,\"lat\":34.539984},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.1974329,\"lat\":51.6663189},{\"lng\":1.6118771,\"lat\":50.7259985},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":1.5190466,\"lat\":46.5885956},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.8620367,\"lat\":41.1613168},{\"lng\":-0.6486943,\"lat\":44.8854667},{\"lng\":2.1779083,\"lat\":48.9134112},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.4828123,\"lat\":41.1362729},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":-0.4881846,\"lat\":44.9259011},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":-94.419079,\"lat\":39.246479},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":1.819207,\"lat\":48.6452851},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.571382,\"lat\":40.5992395},{\"lng\":13.4795839,\"lat\":55.4488689},{\"lng\":-111.8627989,\"lat\":40.5247777},{\"lng\":-76.1193678,\"lat\":43.1756235},{\"lng\":-93.7465075,\"lat\":40.740465},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-0.0699321,\"lat\":51.4734122},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-0.9700664,\"lat\":51.4564242},{\"lng\":7.2113271,\"lat\":47.9094629},{\"lng\":105.8406959,\"lat\":21.0242596},{\"lng\":-121.8989248,\"lat\":37.4332273},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-118.8820414,\"lat\":34.285558},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-72.8173481,\"lat\":41.2746962},{\"lng\":-92.4398402,\"lat\":35.0891932},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-94.5163876,\"lat\":46.8202373},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.3337954,\"lat\":43.6882557},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-97.4649038,\"lat\":35.6571367},{\"lng\":-118.427027,\"lat\":34.2625025},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.6082177,\"lat\":43.1147515},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":5.4389442,\"lat\":43.7729328},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-88.8893818,\"lat\":30.4007626},{\"lng\":-80.0983887,\"lat\":-2.2895167},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-73.0256609,\"lat\":41.2784304},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":16.7792466,\"lat\":48.0198451},{\"lng\":-81.1763421,\"lat\":35.9219402},{\"lng\":-81.5960705,\"lat\":31.8477347},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3145039,\"lat\":48.9525181},{\"lng\":-87.900671,\"lat\":41.8096132},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-73.3501301,\"lat\":40.704371},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.0614686,\"lat\":43.08436},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":3.4228323,\"lat\":43.4611777},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-76.6042521,\"lat\":40.153364},{\"lng\":-72.5688547,\"lat\":40.8423345},{\"lng\":-73.1212214,\"lat\":41.8006523},{\"lng\":-107.8766,\"lat\":37.2769484},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-75.4712794,\"lat\":40.6022059},{\"lng\":-106.0465486,\"lat\":39.4829124},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-118.3692894,\"lat\":34.0923014},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.2286765,\"lat\":46.0961011},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-71.6828444,\"lat\":41.7000996},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-75.5779807,\"lat\":39.0084464},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8100724,\"lat\":35.5848596},{\"lng\":-2.9778916,\"lat\":51.3471927},{\"lng\":-85.843139,\"lat\":44.723889},{\"lng\":-82.5338633,\"lat\":28.483576},{\"lng\":-71.1470037,\"lat\":42.8384221},{\"lng\":17.9681359,\"lat\":59.3628802},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-69.274292,\"lat\":44.211741},{\"lng\":-74.2734808,\"lat\":40.7312123},{\"lng\":-71.4165905,\"lat\":42.2773177},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":6.876568,\"lat\":50.8807379},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-97.9030785,\"lat\":31.124062},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-72.7420399,\"lat\":41.7620447},{\"lng\":118.7788631,\"lat\":32.0438284},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":44.507897,\"lat\":40.1553328},{\"lng\":-74.0308504,\"lat\":40.9543943},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-0.6486943,\"lat\":44.8854667},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-74.6597376,\"lat\":40.3496953},{\"lng\":-75.3015714,\"lat\":40.0792766},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-84.8561524,\"lat\":45.0644549},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-96.0940696,\"lat\":33.1104423},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-1.1491319,\"lat\":44.6316943},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-93.2020856,\"lat\":44.4294359},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.2385432,\"lat\":48.8126688},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-3.2254545,\"lat\":57.4707462},{\"lng\":-95.5100213,\"lat\":29.7326068},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":9.404651,\"lat\":45.531574},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.8706239,\"lat\":47.6846685},{\"lng\":-93.0372808,\"lat\":44.8906694},{\"lng\":-71.1564428,\"lat\":42.4153739},{\"lng\":-75.8543591,\"lat\":42.8484003},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-74.4032354,\"lat\":40.8623835},{\"lng\":-82.005019,\"lat\":39.9401426},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-111.8486019,\"lat\":40.3881114},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":17.6346815,\"lat\":47.687609},{\"lng\":5.2298398,\"lat\":45.6230017},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":0.9147818,\"lat\":45.2740403},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":-68.7713289,\"lat\":44.8016255},{\"lng\":-95.2359403,\"lat\":38.9719137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":12.4483489,\"lat\":55.6898267},{\"lng\":-76.42977,\"lat\":36.9775016},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.4916592,\"lat\":48.8387639},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-84.425589,\"lat\":42.2416466},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":-72.9724768,\"lat\":43.6084792},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-1.3824404,\"lat\":54.9061115},{\"lng\":-0.0746149,\"lat\":47.6968408},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.4034182,\"lat\":50.8720096},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-72.7420399,\"lat\":41.7620447},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-73.8755317,\"lat\":41.9950884},{\"lng\":-123.3417381,\"lat\":43.216505},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.2860371,\"lat\":34.2475493},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.7771661,\"lat\":40.4574358},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-97.8772103,\"lat\":29.9892928},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-73.362773,\"lat\":42.1939364},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-96.3455991,\"lat\":30.6183939},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":3.6959771,\"lat\":43.4014434},{\"lng\":-84.6154897,\"lat\":34.0234337},{\"lng\":2.30551,\"lat\":48.9026},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":1.9988356,\"lat\":48.7760957},{\"lng\":-95.1291755,\"lat\":47.5199538},{\"lng\":1.1510164,\"lat\":49.0268903},{\"lng\":-81.684004,\"lat\":36.2187873},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.194463,\"lat\":45.2100367},{\"lng\":-79.2894688,\"lat\":37.2337555},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-92.4116886,\"lat\":41.0195659},{\"lng\":-81.5231597,\"lat\":40.7965119},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.4164151,\"lat\":46.2862206},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-122.4737053,\"lat\":47.4208759},{\"lng\":-74.0279152,\"lat\":40.2001133},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-105.0372046,\"lat\":39.8366528},{\"lng\":-117.173895,\"lat\":46.7304268},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":47.9734174,\"lat\":29.3796532},{\"lng\":-73.0568716,\"lat\":43.176909},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-0.3891355,\"lat\":39.4200749},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-71.8046023,\"lat\":42.5854371},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-92.1880907,\"lat\":43.8446296},{\"lng\":13.0006423,\"lat\":48.7814115},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-72.1033194,\"lat\":-36.6066616},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":-0.0215164,\"lat\":51.4758453},{\"lng\":-70.082796,\"lat\":41.7601093},{\"lng\":-96.5716694,\"lat\":39.1836082},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-87.2919449,\"lat\":34.4817816},{\"lng\":2.9207275,\"lat\":42.5428648},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-61.558498,\"lat\":10.7358489},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-90.7327362,\"lat\":29.6494109},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-84.1441046,\"lat\":34.0028569},{\"lng\":-79.8725386,\"lat\":36.6915262},{\"lng\":100.567508,\"lat\":13.8282197},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-72.2505752,\"lat\":41.8119557},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-72.524362,\"lat\":40.8695775},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-120.1835765,\"lat\":39.3279454},{\"lng\":-0.3234333,\"lat\":45.01906},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.4718201,\"lat\":40.5892696},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-77.7145945,\"lat\":39.1366223},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-70.9754432,\"lat\":41.9902206},{\"lng\":-97.6200043,\"lat\":30.4393696},{\"lng\":4.3737121,\"lat\":50.8676041},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-100.4100445,\"lat\":20.6004322},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.2810994,\"lat\":42.03726},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-73.6731749,\"lat\":42.4134168},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-88.9843937,\"lat\":40.5092961},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":-111.651822,\"lat\":35.1987522},{\"lng\":2.4875193,\"lat\":48.8716626},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-97.2271249,\"lat\":32.9299655},{\"lng\":-74.9746136,\"lat\":40.0384448},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-86.1095429,\"lat\":39.6136987},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-77.5205485,\"lat\":40.0507198},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-1.7616499,\"lat\":43.3641518},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.9993505,\"lat\":44.1634663},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-122.2566367,\"lat\":38.1040864},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-81.4828123,\"lat\":41.1362729},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-104.7612638,\"lat\":39.5184514},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-75.9125187,\"lat\":42.098698},{\"lng\":7.219985,\"lat\":51.5380394},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-91.2514355,\"lat\":43.8122836},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-90.1740313,\"lat\":44.6662287},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.5822632,\"lat\":33.8188333},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-4.1927219,\"lat\":40.7148269},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.659179,\"lat\":42.451377},{\"lng\":-73.6652451,\"lat\":43.3618532},{\"lng\":-82.1257074,\"lat\":38.0364535},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.1304176,\"lat\":40.0687271},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":7.1513834,\"lat\":43.6612012},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-107.812285,\"lat\":37.9374939},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-87.6835974,\"lat\":30.4065868},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-73.7056955,\"lat\":40.6631362},{\"lng\":-84.2332718,\"lat\":39.5522815},{\"lng\":-157.924442,\"lat\":21.6438449},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-86.8689419,\"lat\":35.925206},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":-80.9271271,\"lat\":29.0258132},{\"lng\":-111.9383931,\"lat\":41.0349847},{\"lng\":-3.3660907,\"lat\":47.7477336},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-87.7521069,\"lat\":42.0262972},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":113.2592945,\"lat\":23.1301964},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-118.11711,\"lat\":34.5793131},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.75596,\"lat\":51.6317449},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-86.9352842,\"lat\":34.4434282},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-80.0728201,\"lat\":26.4614625},{\"lng\":-75.0629531,\"lat\":42.453492},{\"lng\":-79.5656326,\"lat\":43.6435559},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":2.4516055,\"lat\":48.8897751},{\"lng\":-73.7164845,\"lat\":40.7242205},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-75.2782317,\"lat\":40.2109404},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":-94.5649938,\"lat\":37.1767058},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-2.7603283,\"lat\":48.5141134},{\"lng\":-75.3433705,\"lat\":40.1148787},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-83.9463359,\"lat\":42.4567013},{\"lng\":-117.826166,\"lat\":33.7458511},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-92.4453558,\"lat\":31.3119463},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":105.8406959,\"lat\":21.0242596},{\"lng\":-85.9724787,\"lat\":34.72425},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":-95.6349463,\"lat\":29.6196787},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-77.2987377,\"lat\":38.896795},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-8.8932341,\"lat\":38.5241783},{\"lng\":8.4860144,\"lat\":47.1975084},{\"lng\":-77.3724593,\"lat\":35.613224},{\"lng\":2.1868998,\"lat\":48.9229416},{\"lng\":-92.2896267,\"lat\":34.7465071},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-73.4945668,\"lat\":41.146763},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":6.1069469,\"lat\":46.0338359},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":2.1802832,\"lat\":48.87778},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-122.2566367,\"lat\":38.1040864},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-91.8992837,\"lat\":30.2735323},{\"lng\":-118.4720281,\"lat\":34.4233293},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-2.0260409,\"lat\":48.649518},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-84.0199108,\"lat\":33.857328},{\"lng\":6.4086189,\"lat\":46.0775797},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-96.4058782,\"lat\":42.4966815},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-76.2899539,\"lat\":36.8493695},{\"lng\":-78.669997,\"lat\":42.9005956},{\"lng\":1.534421,\"lat\":38.9846117},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.1259014,\"lat\":48.7739339},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-1.1491319,\"lat\":44.6316943},{\"lng\":-118.2478471,\"lat\":34.1469416},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-71.0304858,\"lat\":43.5539309},{\"lng\":-73.9442812,\"lat\":41.117785},{\"lng\":-83.4754913,\"lat\":42.48059},{\"lng\":-124.08284,\"lat\":40.866517},{\"lng\":1.8538446,\"lat\":50.9524769},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":-95.2864299,\"lat\":29.5639758},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-58.1624465,\"lat\":6.8137426},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.6075,\"lat\":43.291698},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.9293862,\"lat\":50.9239397},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-79.988494,\"lat\":40.674863},{\"lng\":-47.1355473,\"lat\":-23.5304843},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.7771661,\"lat\":40.4574358},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.053813,\"lat\":42.0850703},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-95.8937398,\"lat\":41.1365122},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-76.2494453,\"lat\":36.7168315},{\"lng\":11.3525415,\"lat\":55.4061196},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-71.1736669,\"lat\":42.5464828},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.4030556,\"lat\":49.9216667},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.7057035,\"lat\":42.9132581},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":35.4873214,\"lat\":38.7219011},{\"lng\":9.7062018,\"lat\":4.0429389},{\"lng\":-7.6200284,\"lat\":33.5945144},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":-101.296273,\"lat\":48.23251},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-97.8772103,\"lat\":29.9892928},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-92.1724265,\"lat\":38.577359},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":173.9545856,\"lat\":-41.5118691},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-118.3293255,\"lat\":33.8317716},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":6.2341093,\"lat\":46.1934005},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.657047,\"lat\":49.1039289},{\"lng\":-120.1835765,\"lat\":39.3279454},{\"lng\":-73.2435218,\"lat\":40.7276525},{\"lng\":-88.7713953,\"lat\":41.8903447},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.822871,\"lat\":29.7957633},{\"lng\":2.6041207,\"lat\":44.2902029},{\"lng\":-76.895924,\"lat\":37.1118778},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-48.5496098,\"lat\":-27.5973002},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":2.0381228,\"lat\":48.7698937},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-0.6450841,\"lat\":53.5922488},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-79.9414313,\"lat\":37.270973},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-92.5310689,\"lat\":45.1968942},{\"lng\":-71.9698085,\"lat\":42.1340806},{\"lng\":-1.1518287,\"lat\":51.8988832},{\"lng\":-73.4078968,\"lat\":41.1175966},{\"lng\":-122.1768209,\"lat\":48.0517429},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-93.7477839,\"lat\":32.5135356},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0004744,\"lat\":43.8020626},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-74.1304176,\"lat\":40.0687271},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-116.4139839,\"lat\":34.1236205},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-98.5020777,\"lat\":33.9004572},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.309939,\"lat\":39.3600586},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":1.8967943,\"lat\":43.9016766},{\"lng\":7.4900618,\"lat\":48.6217367},{\"lng\":-73.343167,\"lat\":40.9009595},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-91.1869659,\"lat\":30.4494155},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.5116471,\"lat\":28.6732806},{\"lng\":-92.4398402,\"lat\":35.0891932},{\"lng\":-92.4364298,\"lat\":39.4201137},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-83.5378173,\"lat\":41.6529143},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.3002885,\"lat\":48.9875044},{\"lng\":-89.2726708,\"lat\":40.7213015},{\"lng\":-74.5240422,\"lat\":39.3898388},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":-79.7919754,\"lat\":36.0726355},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-90.9562125,\"lat\":30.4868564},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-112.281933,\"lat\":33.6290111},{\"lng\":-83.1876578,\"lat\":35.9670412},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":6.6836292,\"lat\":46.5341057},{\"lng\":-118.4492148,\"lat\":34.3076252},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-91.0465742,\"lat\":39.4492151},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-77.466733,\"lat\":39.308889},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.5236066,\"lat\":52.2646577},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-1.4246132,\"lat\":46.1941088},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":-0.7697191,\"lat\":44.6063022},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":4.0493919,\"lat\":36.7137843},{\"lng\":-76.9832568,\"lat\":39.8005316},{\"lng\":-0.9786725,\"lat\":51.9983175},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-81.7832912,\"lat\":32.4490141},{\"lng\":-1.9254545,\"lat\":46.692985},{\"lng\":-92.3801187,\"lat\":36.3361391},{\"lng\":-70.6624608,\"lat\":42.6153595},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":121.0744942,\"lat\":14.5270538},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":-74.0093129,\"lat\":40.7856117},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-71.1843236,\"lat\":42.3652518},{\"lng\":44.0229853,\"lat\":36.198},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-72.0759008,\"lat\":41.5243537},{\"lng\":-87.9802164,\"lat\":42.0811563},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":-122.232523,\"lat\":37.4863239},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-84.408275,\"lat\":39.3303357},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-75.1721232,\"lat\":39.7940026},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":2.3340758,\"lat\":48.7945413},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":-72.9020069,\"lat\":41.3836233},{\"lng\":-58.7950701,\"lat\":-34.3453213},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-83.0929645,\"lat\":39.8814519},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":9.3762397,\"lat\":47.425618},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-122.32642,\"lat\":48.4200462},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-84.5930113,\"lat\":35.4428864},{\"lng\":-105.6151839,\"lat\":41.3087527},{\"lng\":3.3279296,\"lat\":48.0056204},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-108.49607,\"lat\":45.7874957},{\"lng\":-85.9529685,\"lat\":42.9903205},{\"lng\":-87.9802164,\"lat\":42.0811563},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-120.5785796,\"lat\":35.1235374},{\"lng\":-110.111445,\"lat\":48.179976},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-84.5147454,\"lat\":33.883887},{\"lng\":-117.019529,\"lat\":32.5317397},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-88.7774734,\"lat\":46.8591287},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":-84.2747329,\"lat\":34.0709576},{\"lng\":-87.4139119,\"lat\":39.4667025},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.7974133,\"lat\":40.9880495},{\"lng\":2.4151151,\"lat\":48.6538754},{\"lng\":-122.232523,\"lat\":37.4863239},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.072557,\"lat\":38.1495947},{\"lng\":-122.1180201,\"lat\":37.8857582},{\"lng\":-74.4032354,\"lat\":40.8623835},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.3134994,\"lat\":44.821906},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":-98.9472344,\"lat\":40.4906216},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-90.7195348,\"lat\":29.5957696},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-80.7093066,\"lat\":38.6641653},{\"lng\":-3.4085863,\"lat\":51.6125883},{\"lng\":-89.0226793,\"lat\":42.6829765},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.1060506,\"lat\":40.7099343},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-117.7517496,\"lat\":34.0553813},{\"lng\":-73.4036319,\"lat\":40.8472369},{\"lng\":73.8282141,\"lat\":15.4989946},{\"lng\":-42.0189227,\"lat\":-22.8804369},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":2.134529,\"lat\":48.7018823},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-122.0832101,\"lat\":37.3893889},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-51.2303767,\"lat\":-30.0324999},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":6.0243622,\"lat\":47.2380222},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-87.7834769,\"lat\":42.7313756},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":2.5221284,\"lat\":48.7711323},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-71.2503157,\"lat\":41.6024068},{\"lng\":-73.513589,\"lat\":40.663289},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-118.11711,\"lat\":34.5793131},{\"lng\":-75.2099866,\"lat\":40.6916081},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-86.6694413,\"lat\":35.9522852},{\"lng\":-76.5932369,\"lat\":40.3088578},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":8.6238228,\"lat\":47.3324061},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-77.4752667,\"lat\":38.7509488},{\"lng\":0.0504338,\"lat\":52.4549017},{\"lng\":-99.1332716,\"lat\":19.4933046},{\"lng\":12.3063909,\"lat\":55.9285735},{\"lng\":6.4813654,\"lat\":46.5047105},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.5588696,\"lat\":44.7896878},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.7761955,\"lat\":35.1556451},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.9105031,\"lat\":48.5515697},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.8919011,\"lat\":40.4191229},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-80.3819984,\"lat\":36.0215258},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-117.575173,\"lat\":34.1033192},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-48.5496098,\"lat\":-27.5973002},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-73.7676998,\"lat\":41.157284},{\"lng\":15.3122511,\"lat\":-4.32171},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-85.5872286,\"lat\":42.291707},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3905714,\"lat\":45.6134459},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-84.1457505,\"lat\":33.8062166},{\"lng\":-89.0078418,\"lat\":34.4942683},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":2.4516055,\"lat\":48.8897751},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.6078667,\"lat\":42.4773097},{\"lng\":7.8191185,\"lat\":51.681281},{\"lng\":-79.1802994,\"lat\":35.4798757},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.462609,\"lat\":44.1858193},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.984579,\"lat\":28.8759024},{\"lng\":-86.8647316,\"lat\":39.6444898},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-93.6648083,\"lat\":45.210202},{\"lng\":-91.5195542,\"lat\":30.4913049},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.227781,\"lat\":52.0266526},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-111.926018,\"lat\":33.4942189},{\"lng\":46.7160104,\"lat\":24.638916},{\"lng\":-71.6874099,\"lat\":42.4212463},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-101.2623797,\"lat\":19.6546004},{\"lng\":-75.1268413,\"lat\":40.0770553},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":1.3018796,\"lat\":45.1292139},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-76.3490396,\"lat\":39.5355063},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.767357,\"lat\":51.8586611},{\"lng\":33.3638783,\"lat\":35.1746503},{\"lng\":-77.1516844,\"lat\":39.0817985},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-124.1707558,\"lat\":40.8018746},{\"lng\":-84.5810418,\"lat\":33.5670562},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.7926335,\"lat\":41.1328736},{\"lng\":-75.0307264,\"lat\":39.9348351},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-71.1187829,\"lat\":42.332918},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-89.8614765,\"lat\":36.8125531},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-77.3469994,\"lat\":38.0498524},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-82.0041758,\"lat\":28.9269978},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":-86.1283681,\"lat\":39.9784186},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-122.391675,\"lat\":40.5863563},{\"lng\":-2.7209129,\"lat\":56.0581178},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-0.5097654,\"lat\":50.9575636},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":76.2444378,\"lat\":9.9679032},{\"lng\":5.1580574,\"lat\":45.614003},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":-70.8089397,\"lat\":43.2344819},{\"lng\":-79.7093339,\"lat\":40.3301738},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":3.3331703,\"lat\":46.5660526},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.1980154,\"lat\":43.0704473},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":1.874318,\"lat\":43.0880677},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-120.375716,\"lat\":35.3540209},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.4530731,\"lat\":48.7771486},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.48291,\"lat\":48.9031},{\"lng\":-87.6305899,\"lat\":46.4481521},{\"lng\":-77.6573514,\"lat\":36.4558016},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":-48.2767837,\"lat\":-18.9188041},{\"lng\":-84.309939,\"lat\":39.3600586},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":-95.0877465,\"lat\":39.109724},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-75.613172,\"lat\":41.0164681},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":4.6009798,\"lat\":46.0055024},{\"lng\":7.0650378,\"lat\":46.7207716},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-72.8173481,\"lat\":41.2746962},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.4542915,\"lat\":44.6960855},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.599472,\"lat\":32.7666103},{\"lng\":-72.7420399,\"lat\":41.7620447},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-0.5992399,\"lat\":44.8661755},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-1.4264097,\"lat\":53.2352134},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.7761489,\"lat\":44.8405364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-86.9352842,\"lat\":34.4434282},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-74.1866348,\"lat\":41.3304767},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":6.083862,\"lat\":50.776351},{\"lng\":-111.8874688,\"lat\":40.9804423},{\"lng\":-74.8006895,\"lat\":40.2688105},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-97.0585717,\"lat\":36.1156306},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-76.6077213,\"lat\":36.057938},{\"lng\":-76.492786,\"lat\":38.9786401},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.2094566,\"lat\":42.7135472},{\"lng\":7.6072743,\"lat\":48.6636843},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-59.1932003,\"lat\":-27.6048829},{\"lng\":-85.3094883,\"lat\":35.0457219},{\"lng\":-90.1767012,\"lat\":30.0018546},{\"lng\":-118.4720281,\"lat\":34.4233293},{\"lng\":2.2897124,\"lat\":48.7997756},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":3.9452194,\"lat\":50.4431879},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-82.1073583,\"lat\":41.3673191},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-77.0722227,\"lat\":39.1469872},{\"lng\":-80.7440174,\"lat\":34.9248125},{\"lng\":-3.7331808,\"lat\":40.3070639},{\"lng\":5.80266,\"lat\":45.2264498},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":-78.920589,\"lat\":42.49645},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":-121.387742,\"lat\":36.2231079},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-3.8287012,\"lat\":53.2811822},{\"lng\":-0.4450604,\"lat\":44.6964363},{\"lng\":-1.5216228,\"lat\":43.4367292},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-97.4649038,\"lat\":35.6571367},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.8689419,\"lat\":35.925206},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-78.7998691,\"lat\":35.5843849},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.5547038,\"lat\":33.3496662},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":-75.387693,\"lat\":39.9167783},{\"lng\":-71.0811622,\"lat\":42.3440285},{\"lng\":-3.7331808,\"lat\":40.3070639},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":2.3469255,\"lat\":48.7714153},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-97.9883477,\"lat\":30.4601975},{\"lng\":-111.834914,\"lat\":41.7313063},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":6.2736727,\"lat\":50.8150263},{\"lng\":-116.8776005,\"lat\":33.0472806},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-122.4168664,\"lat\":37.6535403},{\"lng\":-85.0985474,\"lat\":32.5401394},{\"lng\":-79.5066895,\"lat\":36.1029132},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-72.8557306,\"lat\":41.6653064},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":80.6160469,\"lat\":16.5115306},{\"lng\":-90.7033292,\"lat\":38.7902503},{\"lng\":-90.0040817,\"lat\":32.6308318},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0437839,\"lat\":41.1130231},{\"lng\":-74.892082,\"lat\":44.928106},{\"lng\":-1.8752368,\"lat\":50.8801244},{\"lng\":2.3568948,\"lat\":48.9973824},{\"lng\":-17.447938,\"lat\":14.693425},{\"lng\":2.433498,\"lat\":44.2767537},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":8.1957974,\"lat\":52.5212651},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.3811273,\"lat\":38.438232},{\"lng\":-85.0766113,\"lat\":33.5801103},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-86.2483921,\"lat\":43.2341813},{\"lng\":6.876568,\"lat\":50.8807379},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-122.3455263,\"lat\":37.9621457},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-79.6644748,\"lat\":36.3548586},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-111.9741925,\"lat\":41.0751048},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-77.3005305,\"lat\":41.7486838},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-71.7054364,\"lat\":42.6672938},{\"lng\":-96.0083018,\"lat\":32.7092955},{\"lng\":-71.2925571,\"lat\":42.2964859},{\"lng\":3.8969928,\"lat\":7.3786064},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-75.082115,\"lat\":40.2962179},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-105.220306,\"lat\":20.6407176},{\"lng\":-90.8887413,\"lat\":43.5569174},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.1238767,\"lat\":47.6694141},{\"lng\":-80.3123023,\"lat\":43.3600536},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":-119.9843482,\"lat\":38.9332411},{\"lng\":-72.7795419,\"lat\":41.6612104},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":-117.9463717,\"lat\":33.7746292},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-87.9822969,\"lat\":43.2219088},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-73.4856789,\"lat\":41.4664832},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-120.1381144,\"lat\":34.5960774},{\"lng\":-111.926018,\"lat\":33.4942189},{\"lng\":-117.826166,\"lat\":33.7458511},{\"lng\":-116.875289,\"lat\":33.9255685},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":9.2719656,\"lat\":47.6955538},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-118.8375937,\"lat\":34.1705609},{\"lng\":-76.9314571,\"lat\":40.4691049},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-7.2514438,\"lat\":52.6506255},{\"lng\":-113.584131,\"lat\":37.104153},{\"lng\":-88.0125794,\"lat\":44.5126379},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-119.119919,\"lat\":46.2087066},{\"lng\":-73.0151084,\"lat\":40.7656539},{\"lng\":4.3737121,\"lat\":50.8676041},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-116.392326,\"lat\":43.6086295},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-114.363662,\"lat\":43.680741},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-81.83511,\"lat\":41.3144733},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-73.5293246,\"lat\":40.7695303},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3268669,\"lat\":48.7316381},{\"lng\":-73.1358091,\"lat\":-40.5736955},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-80.3503283,\"lat\":27.2939333},{\"lng\":-83.8843455,\"lat\":34.227602},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":1.9009994,\"lat\":50.4249356},{\"lng\":5.0735802,\"lat\":52.653272},{\"lng\":-90.5040214,\"lat\":43.978576},{\"lng\":6.8418655,\"lat\":46.4602978},{\"lng\":-89.8481652,\"lat\":40.0117151},{\"lng\":2.3633048,\"lat\":48.7921098},{\"lng\":-80.4742261,\"lat\":35.6709727},{\"lng\":-89.216655,\"lat\":37.7274692},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":12.6992687,\"lat\":50.586993},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.9251809,\"lat\":34.1851017},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-82.4333742,\"lat\":42.9760854},{\"lng\":-119.9843482,\"lat\":38.9332411},{\"lng\":20.4568974,\"lat\":44.8178131},{\"lng\":-85.0766113,\"lat\":33.5801103},{\"lng\":-51.2303767,\"lat\":-30.0324999},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-2.7397217,\"lat\":51.1267494},{\"lng\":2.2792058,\"lat\":48.9911296},{\"lng\":-73.343167,\"lat\":40.9009595},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":-74.1242816,\"lat\":40.8120247},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":10.135555,\"lat\":54.3227085},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.4979963,\"lat\":40.6460921},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-17.447938,\"lat\":14.693425},{\"lng\":-4.3965573,\"lat\":48.4075514},{\"lng\":-79.0287742,\"lat\":-8.1116778},{\"lng\":9.4978479,\"lat\":51.3157833},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-1.5294444,\"lat\":46.8244444},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-121.1246966,\"lat\":37.7394666},{\"lng\":-0.1872229,\"lat\":44.8304495},{\"lng\":5.8279653,\"lat\":51.4283287},{\"lng\":11.7299205,\"lat\":48.1475774},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-2.8690655,\"lat\":47.6554463},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-116.8776005,\"lat\":33.0472806},{\"lng\":4.031926,\"lat\":49.2577886},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":-84.1457505,\"lat\":33.8062166},{\"lng\":-58.4026638,\"lat\":-34.7572582},{\"lng\":-96.6705503,\"lat\":33.1031744},{\"lng\":46.7160104,\"lat\":24.638916},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-85.8155576,\"lat\":42.0258779},{\"lng\":-84.0373054,\"lat\":41.8975152},{\"lng\":-87.8569745,\"lat\":41.900299},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":91.753943,\"lat\":26.1805978},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":5.4710661,\"lat\":43.455613},{\"lng\":-83.7846458,\"lat\":42.5316918},{\"lng\":-6.8408929,\"lat\":34.0218454},{\"lng\":-81.3578047,\"lat\":41.1513108},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-74.0643065,\"lat\":40.3470543},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-87.8445119,\"lat\":42.1711365},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-87.8495946,\"lat\":41.4979467},{\"lng\":-1.1964165,\"lat\":53.1443785},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":2.2765575,\"lat\":49.1512109},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-75.6059638,\"lat\":39.9597213},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-93.9585295,\"lat\":44.3238384},{\"lng\":-77.1929215,\"lat\":39.1399187},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-91.6704053,\"lat\":41.9758872},{\"lng\":-75.5243682,\"lat\":39.158168},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-73.790959,\"lat\":42.2528649},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":0.983698,\"lat\":47.4110351},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-78.8893999,\"lat\":38.0686668},{\"lng\":2.8319805,\"lat\":50.4291723},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":7.3625953,\"lat\":48.7419909},{\"lng\":-81.345941,\"lat\":41.239223},{\"lng\":-82.1518927,\"lat\":36.9440023},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-122.0660914,\"lat\":48.0197794},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":7.7523716,\"lat\":48.6148396},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-92.0178202,\"lat\":30.2262187},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":5.8008839,\"lat\":43.1177238},{\"lng\":-4.400979,\"lat\":48.4346366},{\"lng\":-80.6072138,\"lat\":36.4993877},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":-74.4118169,\"lat\":40.3178867},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-88.207301,\"lat\":40.1117174},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-89.8739753,\"lat\":35.2045329},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-87.9403418,\"lat\":41.8994745},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":-100.3917424,\"lat\":20.5922997},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":-88.7774734,\"lat\":46.8591287},{\"lng\":-77.7191081,\"lat\":39.6430455},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-74.3592296,\"lat\":40.7182356},{\"lng\":-123.1342796,\"lat\":49.7588883},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-118.6058382,\"lat\":34.1684364},{\"lng\":-74.3229264,\"lat\":40.6517692},{\"lng\":-89.7045439,\"lat\":39.676163},{\"lng\":-75.9015974,\"lat\":37.4059695},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-117.035864,\"lat\":32.9628234},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.1566107,\"lat\":45.0060767},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.0324321,\"lat\":44.6092335},{\"lng\":-87.3653136,\"lat\":41.4169806},{\"lng\":-95.7507897,\"lat\":30.2095594},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":12.5178995,\"lat\":55.6539644},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-84.0199108,\"lat\":33.857328},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":14.0139733,\"lat\":51.1825771},{\"lng\":-122.0660914,\"lat\":48.0197794},{\"lng\":-104.969565,\"lat\":39.5497243},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.8953815,\"lat\":40.5710454},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-82.7535049,\"lat\":39.8842304},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":11.479351,\"lat\":47.8646925},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":3.6959771,\"lat\":43.4014434},{\"lng\":-73.7629097,\"lat\":41.0339862},{\"lng\":-0.5732063,\"lat\":51.2356068},{\"lng\":6.9477708,\"lat\":48.2873153},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-98.3252932,\"lat\":26.2159066},{\"lng\":-100.8307739,\"lat\":20.5222851},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-119.8276389,\"lat\":34.4358295},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-88.0434304,\"lat\":42.1105502},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1304588,\"lat\":40.3100446},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.636465,\"lat\":38.2325829},{\"lng\":-0.3311238,\"lat\":51.5714876},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":-71.8225254,\"lat\":43.1797486},{\"lng\":-74.0098299,\"lat\":41.5000767},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-122.5246791,\"lat\":47.6515096},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.2472478,\"lat\":45.618344},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-114.9822486,\"lat\":36.0319843},{\"lng\":-68.7713289,\"lat\":44.8016255},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-82.1981764,\"lat\":33.4504157},{\"lng\":-93.530214,\"lat\":47.237166},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":120.6962716,\"lat\":16.3800747},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-73.6450664,\"lat\":40.6574186},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":4.668101,\"lat\":45.8910218},{\"lng\":-80.3414693,\"lat\":33.9204354},{\"lng\":-0.2678212,\"lat\":51.3326098},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":7.3579641,\"lat\":48.0777517},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-71.630859,\"lat\":43.695667},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-111.9741925,\"lat\":41.0751048},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-73.8645734,\"lat\":42.2173102},{\"lng\":-75.5149128,\"lat\":40.1303822},{\"lng\":0.0483875,\"lat\":50.7945315},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-119.700583,\"lat\":45.839855},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":-117.2919818,\"lat\":33.0369867},{\"lng\":2.3469255,\"lat\":48.7714153},{\"lng\":-77.6460477,\"lat\":38.975841},{\"lng\":-93.9585295,\"lat\":44.3238384},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-72.0807772,\"lat\":42.1084385},{\"lng\":-93.3023898,\"lat\":45.1728923},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":6.9881194,\"lat\":51.0324743},{\"lng\":25.3258422,\"lat\":60.3001908},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-73.8755317,\"lat\":41.9950884},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-78.8660527,\"lat\":43.0407742},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-71.6472988,\"lat\":43.4442432},{\"lng\":-80.0394977,\"lat\":40.3275697},{\"lng\":-95.6971686,\"lat\":29.9691116},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-87.9751964,\"lat\":41.7950525},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-108.56448,\"lat\":39.0672568},{\"lng\":-89.6272791,\"lat\":44.9597858},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":5.6039516,\"lat\":46.9756991},{\"lng\":-82.7342919,\"lat\":35.2334472},{\"lng\":-84.6266111,\"lat\":38.9989499},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-93.5885717,\"lat\":44.0172242},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-72.1290542,\"lat\":41.343025},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-88.083406,\"lat\":42.0333608},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.1386015,\"lat\":41.0799898},{\"lng\":-77.2676335,\"lat\":38.636447},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.1040242,\"lat\":50.9391812},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-95.7607832,\"lat\":29.5821811},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-82.6418883,\"lat\":39.7886111},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-76.5528831,\"lat\":39.155816},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-111.8486019,\"lat\":40.3881114},{\"lng\":24.8762702,\"lat\":42.0073633},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-96.9146374,\"lat\":19.5408338},{\"lng\":-1.4852861,\"lat\":51.7838848},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-81.8723084,\"lat\":26.640628},{\"lng\":-83.1933893,\"lat\":37.2489635},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-86.5819394,\"lat\":36.0156178},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":5.3242942,\"lat\":46.1773941},{\"lng\":-80.9271271,\"lat\":29.0258132},{\"lng\":-88.8893818,\"lat\":30.4007626},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3627245,\"lat\":51.9994572},{\"lng\":-78.3199496,\"lat\":44.3048009},{\"lng\":-116.602983,\"lat\":31.8658887},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-111.787022,\"lat\":43.8235163},{\"lng\":-84.9880449,\"lat\":32.4610708},{\"lng\":-121.9357918,\"lat\":37.7021521},{\"lng\":-79.2576479,\"lat\":43.7729744},{\"lng\":33.8307062,\"lat\":27.222556},{\"lng\":9.2053999,\"lat\":45.649723},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":2.8953121,\"lat\":42.6985304},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.4452231,\"lat\":48.906387},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-74.9226665,\"lat\":40.1745538},{\"lng\":-1.2620038,\"lat\":52.3726682},{\"lng\":2.1701573,\"lat\":48.681708},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-81.3578047,\"lat\":41.1513108},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.1425781,\"lat\":39.4850848},{\"lng\":-87.8536288,\"lat\":41.630663},{\"lng\":-84.5496148,\"lat\":33.9528472},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-117.903317,\"lat\":33.6633386},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-118.5369316,\"lat\":34.2345615},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.4516055,\"lat\":48.8897751},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.7191081,\"lat\":39.6430455},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.4628135,\"lat\":36.8414197},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-85.9213796,\"lat\":39.2014405},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":-114.0532996,\"lat\":35.1895921},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-118.5538088,\"lat\":34.4127963},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.3177933,\"lat\":41.0461864},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-70.8967226,\"lat\":42.5195292},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-116.7811531,\"lat\":47.6742994},{\"lng\":-2.7005643,\"lat\":56.2227638},{\"lng\":5.6713,\"lat\":45.6207},{\"lng\":-123.2620435,\"lat\":44.5645659},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-117.395582,\"lat\":34.0701151},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-120.1835765,\"lat\":39.3279454},{\"lng\":-108.75902,\"lat\":44.752873},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":9.053596,\"lat\":48.5203263},{\"lng\":-85.6802541,\"lat\":40.1053196},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-4.88562,\"lat\":36.508976},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-76.8646092,\"lat\":39.1938429},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-97.4649038,\"lat\":35.6571367},{\"lng\":-84.7668495,\"lat\":43.597646},{\"lng\":-107.3246941,\"lat\":39.5466381},{\"lng\":-88.1450735,\"lat\":41.9994722},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-84.2946539,\"lat\":37.7478572},{\"lng\":-98.3898883,\"lat\":40.5861322},{\"lng\":2.2453842,\"lat\":48.7144587},{\"lng\":-117.0430865,\"lat\":34.033625},{\"lng\":-48.2767837,\"lat\":-18.9188041},{\"lng\":-158.009166,\"lat\":21.3866667},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-106.5173088,\"lat\":31.7692821},{\"lng\":-3.6106856,\"lat\":55.0691831},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-61.4764728,\"lat\":-31.2492442},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.1400923,\"lat\":29.1871986},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-111.8627989,\"lat\":40.5247777},{\"lng\":-93.12611,\"lat\":44.7391873},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.5011729,\"lat\":48.4205915},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.0967857,\"lat\":33.3140311},{\"lng\":5.5783856,\"lat\":46.1825453},{\"lng\":-58.5264866,\"lat\":-34.4739792},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-121.2117148,\"lat\":37.7986184},{\"lng\":-7.9891608,\"lat\":31.6258257},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-92.9339449,\"lat\":44.919896},{\"lng\":-111.3921528,\"lat\":28.8223775},{\"lng\":-71.2661597,\"lat\":41.6770463},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-71.1494972,\"lat\":42.2792649},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":6.9459377,\"lat\":51.1008952},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-81.8020722,\"lat\":24.5548262},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-84.4041725,\"lat\":39.516644},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-116.0833144,\"lat\":34.8253019},{\"lng\":-2.0588889,\"lat\":46.7936111},{\"lng\":2.134529,\"lat\":48.7018823},{\"lng\":-72.644512,\"lat\":41.767914},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-0.4438854,\"lat\":39.4827253},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":114.2999353,\"lat\":30.5951051},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.6200043,\"lat\":30.4393696},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-105.0612448,\"lat\":39.672564},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-0.1049747,\"lat\":50.9999616},{\"lng\":-70.5587024,\"lat\":41.5786678},{\"lng\":2.2216686,\"lat\":48.5774044},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-122.3520327,\"lat\":48.24216},{\"lng\":-96.8238183,\"lat\":33.1505998},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":-2.8277046,\"lat\":51.3908826},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-117.579304,\"lat\":47.4892246},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":2.3872525,\"lat\":48.8122302},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-71.3739532,\"lat\":42.8650869},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":-105.523216,\"lat\":40.3771926},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":2.4916592,\"lat\":48.8387639},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.4609528,\"lat\":35.3187279},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":21.0714322,\"lat\":52.2337172},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-77.571382,\"lat\":40.5992395},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.780542,\"lat\":49.2621643},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-111.9367107,\"lat\":40.5584882},{\"lng\":-94.4137923,\"lat\":39.0924792},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.1138977,\"lat\":41.5421013},{\"lng\":-122.0215737,\"lat\":37.5872576},{\"lng\":-113.1966394,\"lat\":40.4062872},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-97.8567339,\"lat\":30.5736134},{\"lng\":4.8090252,\"lat\":46.0730429},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-63.5720232,\"lat\":44.6799707},{\"lng\":-75.7515682,\"lat\":39.6828358},{\"lng\":-71.2360624,\"lat\":42.2802645},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.2566332,\"lat\":40.782634},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":-122.0607963,\"lat\":37.9479786},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":4.7449605,\"lat\":52.4681109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":103.733224,\"lat\":36.474436},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-90.7926324,\"lat\":40.4264306},{\"lng\":-114.839607,\"lat\":31.0269529},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-0.4662704,\"lat\":51.503513},{\"lng\":-66.0558844,\"lat\":18.2129421},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":73.8079977,\"lat\":15.4677228},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.470786,\"lat\":44.8546856},{\"lng\":-111.9738429,\"lat\":41.2230048},{\"lng\":-73.0839793,\"lat\":40.867749},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-96.7297206,\"lat\":32.9481789},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-75.6009964,\"lat\":38.366027},{\"lng\":-77.8616386,\"lat\":40.7944504},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":5.2676493,\"lat\":59.4181982},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-93.5268986,\"lat\":44.7980186},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":-58.7950701,\"lat\":-34.3453213},{\"lng\":105.8406959,\"lat\":21.0242596},{\"lng\":5.6758509,\"lat\":52.0015245},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-92.3328743,\"lat\":42.498275},{\"lng\":-0.945556,\"lat\":45.82},{\"lng\":-111.8486019,\"lat\":40.3881114},{\"lng\":-83.6900211,\"lat\":43.0161693},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.1374969,\"lat\":41.4910324},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-87.3811461,\"lat\":38.687009},{\"lng\":-93.7460804,\"lat\":45.3324647},{\"lng\":141.3542924,\"lat\":43.061936},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-119.247053,\"lat\":35.7688425},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-76.6235105,\"lat\":39.4837588},{\"lng\":-76.7301718,\"lat\":38.9424464},{\"lng\":-121.2880059,\"lat\":38.7521235},{\"lng\":7.0707659,\"lat\":52.4359731},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-77.3465081,\"lat\":37.5131191},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-122.039966,\"lat\":38.2493581},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-76.6042521,\"lat\":40.153364},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.5848937,\"lat\":51.0862467},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-120.545122,\"lat\":46.9970635},{\"lng\":-107.8766,\"lat\":37.2769484},{\"lng\":-74.1242816,\"lat\":40.8120247},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-74.3483059,\"lat\":40.651726},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":3.2131307,\"lat\":43.3426562},{\"lng\":-83.9044159,\"lat\":33.0142344},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":113.2384362,\"lat\":28.1450774},{\"lng\":-92.1052679,\"lat\":46.7838287},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-119.749351,\"lat\":38.9415062},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.8795408,\"lat\":40.5827745},{\"lng\":-118.689423,\"lat\":34.035591},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":-74.8909988,\"lat\":39.934002},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-122.4329883,\"lat\":45.4978623},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-86.8689419,\"lat\":35.925206},{\"lng\":6.8727506,\"lat\":45.9246705},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-77.1516844,\"lat\":39.0817985},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-121.5631723,\"lat\":37.0065078},{\"lng\":4.4886562,\"lat\":52.2244226},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":-3.9882568,\"lat\":55.9477764},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-82.3646068,\"lat\":41.4219889},{\"lng\":10.4919639,\"lat\":48.8513976},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-81.3399769,\"lat\":41.6664781},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-84.8145115,\"lat\":9.9221181},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-83.8423061,\"lat\":42.5733416},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-88.4040172,\"lat\":43.0594237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":76.9628425,\"lat\":11.0018115},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":46.7160104,\"lat\":24.638916},{\"lng\":-121.06292,\"lat\":39.2190607},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.1574328,\"lat\":36.0625843},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":11.3426327,\"lat\":44.4938203},{\"lng\":-110.854605,\"lat\":39.6841305},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-90.1830408,\"lat\":32.2998686},{\"lng\":-81.6182086,\"lat\":33.5723191},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-83.4754913,\"lat\":42.48059},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-119.8276389,\"lat\":34.4358295},{\"lng\":-81.83511,\"lat\":41.3144733},{\"lng\":-81.508732,\"lat\":41.464498},{\"lng\":-83.2126517,\"lat\":34.0378903},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-71.3085329,\"lat\":42.6414437},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-72.1847598,\"lat\":40.9633868},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":32.8540497,\"lat\":39.9207759},{\"lng\":-80.0973754,\"lat\":43.9193171},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":-81.9567716,\"lat\":35.3692877},{\"lng\":-74.3483059,\"lat\":40.651726},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-77.4309829,\"lat\":34.7509962},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-76.3442846,\"lat\":37.0264414},{\"lng\":-75.1340604,\"lat\":40.2492741},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-82.5486848,\"lat\":35.8263793},{\"lng\":-0.591276,\"lat\":51.512103},{\"lng\":-97.6200043,\"lat\":30.4393696},{\"lng\":18.016667,\"lat\":59.366667},{\"lng\":2.4452231,\"lat\":48.906387},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.251587,\"lat\":43.643032},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":6.996379,\"lat\":49.234362},{\"lng\":-105.05208,\"lat\":39.9403995},{\"lng\":-74.9035159,\"lat\":39.2401316},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-74.1312504,\"lat\":40.9397796},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-74.533084,\"lat\":40.3840222},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-84.1401926,\"lat\":34.2073196},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":6.0820639,\"lat\":44.5612032},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-121.530234,\"lat\":38.5804609},{\"lng\":-77.2340584,\"lat\":42.1051571},{\"lng\":50.1039991,\"lat\":26.4367824},{\"lng\":2.3019814,\"lat\":48.8211559},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-4.1024782,\"lat\":47.9960325},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-80.0532942,\"lat\":26.715364},{\"lng\":0.5513922,\"lat\":50.8512796},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-74.252537,\"lat\":44.433981},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":2.4159739,\"lat\":48.8432434},{\"lng\":-76.5974223,\"lat\":39.4475075},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.8767935,\"lat\":45.5984113},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-0.1517368,\"lat\":51.4428954},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-2.047687,\"lat\":48.4539775},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":2.045018,\"lat\":45.4065225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-79.5656326,\"lat\":43.6435559},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-74.1637553,\"lat\":40.8584328},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-71.2360624,\"lat\":42.2802645},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-121.7124536,\"lat\":37.9974219},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-82.5154471,\"lat\":40.75839},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-118.4492148,\"lat\":34.3076252},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-71.1143838,\"lat\":42.3116046},{\"lng\":-86.0138729,\"lat\":39.9555928},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-84.3330301,\"lat\":46.5126554},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-88.7774734,\"lat\":46.8591287},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.5246791,\"lat\":47.6515096},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":-92.4746033,\"lat\":42.7258451},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.0836549,\"lat\":41.3203913},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":6.1919276,\"lat\":49.3615058},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-105.089705,\"lat\":39.9935959},{\"lng\":4.5887889,\"lat\":51.914403},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.5703031,\"lat\":43.2924385},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-82.9780962,\"lat\":40.095494},{\"lng\":-106.8222688,\"lat\":44.7947537},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-112.468812,\"lat\":34.539984},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-79.0041726,\"lat\":-2.8974072},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":1.9015752,\"lat\":47.8650984},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.039966,\"lat\":38.2493581},{\"lng\":-76.5033406,\"lat\":40.1098561},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":10.6159077,\"lat\":54.1364642},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-101.8858689,\"lat\":36.2452294},{\"lng\":1.6118672,\"lat\":46.2887078},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":5.0487681,\"lat\":44.0554043},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":126.6168874,\"lat\":37.4766821},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":6.5772501,\"lat\":46.5538658},{\"lng\":-76.7928128,\"lat\":17.9712148},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":2.1583033,\"lat\":44.0496296},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-2.1040102,\"lat\":47.1152695},{\"lng\":-3.4914955,\"lat\":47.7894226},{\"lng\":-75.5138959,\"lat\":40.036202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-1.0815361,\"lat\":53.9590555},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.0992246,\"lat\":43.3290992},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":2.6068064,\"lat\":48.8009132},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.8372796,\"lat\":48.6218033},{\"lng\":24.715431,\"lat\":43.1349971},{\"lng\":-0.4804579,\"lat\":52.6519973},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-72.0934864,\"lat\":41.343637},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":0.1826107,\"lat\":51.5747271},{\"lng\":-111.933834,\"lat\":41.6385432},{\"lng\":-117.1091954,\"lat\":44.8776081},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-76.3490396,\"lat\":39.5355063},{\"lng\":-103.338396,\"lat\":20.6720375},{\"lng\":-76.8646092,\"lat\":39.1938429},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-2.2024324,\"lat\":51.3161569},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-82.3646068,\"lat\":41.4219889},{\"lng\":-82.756907,\"lat\":28.0856815},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":-111.9556001,\"lat\":33.5428006},{\"lng\":-96.6353488,\"lat\":30.4764878},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":114.0545429,\"lat\":22.5445741},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-0.2244449,\"lat\":51.5306063},{\"lng\":-75.0579502,\"lat\":39.9562238},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-77.4019268,\"lat\":37.227928},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.6299518,\"lat\":42.9275277},{\"lng\":-83.2729081,\"lat\":42.1961742},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-72.5037167,\"lat\":41.8251014},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-94.4265011,\"lat\":35.3880338},{\"lng\":-122.039966,\"lat\":38.2493581},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-94.0148021,\"lat\":30.1313283},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.3588703,\"lat\":36.5277607},{\"lng\":-97.4394816,\"lat\":35.2225717},{\"lng\":-73.6967338,\"lat\":40.786702},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.0572272,\"lat\":37.1176314},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.6017022,\"lat\":34.2572499},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-76.8317417,\"lat\":39.2757359},{\"lng\":-97.491204,\"lat\":46.585804},{\"lng\":-1.0518771,\"lat\":43.7084065},{\"lng\":-82.4012643,\"lat\":40.0581205},{\"lng\":23.5719843,\"lat\":47.6565584},{\"lng\":-83.6900211,\"lat\":43.0161693},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":-80.6636984,\"lat\":28.2662775},{\"lng\":-1.6171001,\"lat\":54.9751321},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-82.2880508,\"lat\":27.928464},{\"lng\":9.2114144,\"lat\":48.4919508},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.463028,\"lat\":44.336864},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-88.0717708,\"lat\":41.7003302},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.677556,\"lat\":39.049011},{\"lng\":-0.1551,\"lat\":44.53881},{\"lng\":5.4088845,\"lat\":52.1637702},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":1.1076133,\"lat\":41.1555564},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-77.4486772,\"lat\":38.885219},{\"lng\":-74.0323752,\"lat\":40.7433066},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.0637708,\"lat\":47.3586518},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-78.4563914,\"lat\":35.650711},{\"lng\":-94.44355,\"lat\":36.650627},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-72.0759008,\"lat\":41.5243537},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-64.1834193,\"lat\":-31.4166867},{\"lng\":24.3631837,\"lat\":44.4299971},{\"lng\":-0.6772991,\"lat\":48.7285654},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-72.1435861,\"lat\":43.6446871},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.3129164,\"lat\":54.564094},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-73.9112103,\"lat\":41.5965635},{\"lng\":-94.6851702,\"lat\":38.9742502},{\"lng\":-73.6343052,\"lat\":40.7266477},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-99.1619751,\"lat\":19.3498606},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-87.9414608,\"lat\":42.0087978},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.6856197,\"lat\":44.4643768},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":-72.6930522,\"lat\":41.9810263},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-71.0542002,\"lat\":42.4085897},{\"lng\":-79.8030873,\"lat\":35.8179143},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":27.8879787,\"lat\":39.6473917},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.8239794,\"lat\":52.5623089},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-84.99928,\"lat\":41.634874},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-105.049981,\"lat\":40.0502623},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.2008288,\"lat\":46.3580221},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":-84.9030517,\"lat\":42.8692006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-96.6260468,\"lat\":41.4523961},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-87.9822969,\"lat\":43.2219088},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-118.5291917,\"lat\":34.3798765},{\"lng\":-75.6496424,\"lat\":40.2452976},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.2115053,\"lat\":35.7902384},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-122.391675,\"lat\":40.5863563},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-46.5279039,\"lat\":-23.6533509},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":6.1675872,\"lat\":49.3579272},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":1.4284697,\"lat\":38.9982318},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-89.0078418,\"lat\":34.4942683},{\"lng\":-94.0771483,\"lat\":33.4466745},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-80.0736533,\"lat\":36.1198589},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":-1.4621381,\"lat\":53.3783713},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":10.3733692,\"lat\":53.8096562},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":0.1561947,\"lat\":45.6484505},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":1.909928,\"lat\":48.9931578},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-1.5342042,\"lat\":54.9911912},{\"lng\":-75.9125187,\"lat\":42.098698},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-0.3250175,\"lat\":45.6931647},{\"lng\":5.4781463,\"lat\":52.2148536},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-80.2322706,\"lat\":25.9873137},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":5.6361825,\"lat\":45.2928424},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-85.7371604,\"lat\":38.2770227},{\"lng\":-73.1307708,\"lat\":41.1947276},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.951279,\"lat\":40.1045549},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-81.5116471,\"lat\":28.6732806},{\"lng\":11.6400789,\"lat\":52.1314783},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-80.6424886,\"lat\":36.44173},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-81.7016346,\"lat\":30.1654707},{\"lng\":-82.8071054,\"lat\":37.8145384},{\"lng\":-1.8773787,\"lat\":46.847943},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-91.2563658,\"lat\":43.9632211},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.814017,\"lat\":34.044889},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3861737,\"lat\":50.8361447},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":-70.8781883,\"lat\":42.5489744},{\"lng\":-86.2483921,\"lat\":43.2341813},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-77.4871236,\"lat\":37.664879},{\"lng\":-75.7166345,\"lat\":39.4497639},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-73.8320784,\"lat\":40.9381544},{\"lng\":-90.1767012,\"lat\":30.0018546},{\"lng\":-74.0410865,\"lat\":40.8871438},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-90.5136642,\"lat\":41.5058344},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":1.534421,\"lat\":38.9846117},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.9283672,\"lat\":41.7065539},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.3623924,\"lat\":51.4619551},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.2117148,\"lat\":37.7986184},{\"lng\":24.1228361,\"lat\":42.219533},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.2865796,\"lat\":41.6849111},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-71.3137707,\"lat\":41.4899827},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":106.8838584,\"lat\":47.9081991},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":1.1528095,\"lat\":52.0579324},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-0.3944534,\"lat\":44.8777159},{\"lng\":-77.4127562,\"lat\":39.415779},{\"lng\":-96.9146374,\"lat\":19.5408338},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":112.4477046,\"lat\":34.6196539},{\"lng\":-124.223764,\"lat\":43.4918372},{\"lng\":-118.4492148,\"lat\":34.3076252},{\"lng\":1.4628645,\"lat\":48.4364696},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.4979014,\"lat\":41.2814842},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-0.2779124,\"lat\":51.9486943},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":116.3912972,\"lat\":39.9057136},{\"lng\":-88.0125794,\"lat\":44.5126379},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":4.8055118,\"lat\":45.5597173},{\"lng\":2.2557107,\"lat\":48.5948294},{\"lng\":-117.8722311,\"lat\":33.750631},{\"lng\":4.8039331,\"lat\":45.7153254},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.28739,\"lat\":49.1478922},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-4.033442,\"lat\":55.7759095},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-75.5732423,\"lat\":41.4764699},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-82.9371409,\"lat\":42.4972583},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.2411289,\"lat\":43.6053809},{\"lng\":-71.4677032,\"lat\":42.7656251},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-89.7811745,\"lat\":30.2751945},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-1.7822482,\"lat\":53.6466645},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-97.9883477,\"lat\":30.4601975},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":106.8822289,\"lat\":-6.2628908},{\"lng\":2.3340758,\"lat\":48.7945413},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-3.2510247,\"lat\":47.6975924},{\"lng\":-94.1574328,\"lat\":36.0625843},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-118.1366153,\"lat\":34.6981064},{\"lng\":-117.0314172,\"lat\":32.7425516},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.2107006,\"lat\":40.6639916},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":0.577077,\"lat\":44.1688678},{\"lng\":2.0388736,\"lat\":49.0527528},{\"lng\":106.8822289,\"lat\":-6.2628908},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-97.4649038,\"lat\":35.6571367},{\"lng\":-82.3984882,\"lat\":34.851354},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-111.747841,\"lat\":40.2983097},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":-73.5107732,\"lat\":42.7091389},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-71.1408776,\"lat\":42.65717},{\"lng\":-79.7093339,\"lat\":40.3301738},{\"lng\":-122.6246836,\"lat\":47.5653663},{\"lng\":-72.5891221,\"lat\":42.3423259},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-122.768761,\"lat\":45.4853207},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.7942944,\"lat\":26.1421976},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-93.5268986,\"lat\":44.7980186},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-103.3913671,\"lat\":20.7211203},{\"lng\":11.8969383,\"lat\":48.5162681},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-118.307201,\"lat\":34.1812089},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":14.4276003,\"lat\":51.1809132},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":2.4197113,\"lat\":48.8051624},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-82.5338633,\"lat\":28.483576},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":-76.3422525,\"lat\":42.2325723},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.739099,\"lat\":30.9246276},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-74.171811,\"lat\":40.9167654},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":-87.8406031,\"lat\":42.0112329},{\"lng\":-75.1515534,\"lat\":40.103196},{\"lng\":-84.1051939,\"lat\":33.7123305},{\"lng\":-90.4345418,\"lat\":40.0167925},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-91.0031778,\"lat\":30.3946729},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-76.0898259,\"lat\":39.548827},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-80.2872086,\"lat\":26.0061943},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-104.8769227,\"lat\":39.579155},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":-87.9802164,\"lat\":42.0811563},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":17.6387436,\"lat\":59.8586126},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-84.0193858,\"lat\":39.8208998},{\"lng\":2.6021145,\"lat\":48.5624381},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-90.4420411,\"lat\":41.5152157},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-80.8079545,\"lat\":28.6126236},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-8.2526339,\"lat\":37.088241},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-121.971335,\"lat\":47.8552259},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-76.7928128,\"lat\":17.9712148},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-82.756367,\"lat\":28.1470965},{\"lng\":-71.9329968,\"lat\":-39.273222},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-74.8909988,\"lat\":39.934002},{\"lng\":-1.3133333,\"lat\":46.7141667},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":0.1967849,\"lat\":48.0073849},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-70.7618592,\"lat\":41.9426657},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3458417,\"lat\":48.6794572},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-74.0204177,\"lat\":40.7695457},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":-91.9630039,\"lat\":41.0072342},{\"lng\":11.7975218,\"lat\":55.446817},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.4738223,\"lat\":43.8219222},{\"lng\":-83.6279321,\"lat\":41.5571178},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.0811573,\"lat\":39.8005505},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":-9.2038448,\"lat\":39.3443128},{\"lng\":-120.1835765,\"lat\":39.3279454},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-74.0254577,\"lat\":45.3971509},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":12.703706,\"lat\":56.0442098},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-76.4796552,\"lat\":39.4073054},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-91.2343539,\"lat\":43.8830606},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":-118.6058382,\"lat\":34.1684364},{\"lng\":-74.0437839,\"lat\":41.1130231},{\"lng\":2.6068064,\"lat\":48.8009132},{\"lng\":-0.1843514,\"lat\":52.3305093},{\"lng\":-83.9463359,\"lat\":42.4567013},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-8.6394111,\"lat\":41.0083643},{\"lng\":-86.4541894,\"lat\":42.1167065},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":-3.7020023,\"lat\":48.0268097},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.2840639,\"lat\":48.9703664},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.4611995,\"lat\":30.5043583},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.0125794,\"lat\":44.5126379},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-43.8470691,\"lat\":-19.9854089},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-121.302728,\"lat\":38.5890723},{\"lng\":-92.1176521,\"lat\":35.8684075},{\"lng\":-121.8106925,\"lat\":38.0093296},{\"lng\":8.6185666,\"lat\":47.3969942},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":-87.607268,\"lat\":41.6389236},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-94.0309959,\"lat\":42.0391745},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-99.2599579,\"lat\":18.9331321},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":13.5532976,\"lat\":68.118191},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0023825,\"lat\":41.9287812},{\"lng\":120.9803621,\"lat\":14.5904492},{\"lng\":74.8731879,\"lat\":13.5269784},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-92.7239637,\"lat\":41.7430237},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-118.096735,\"lat\":33.9830688},{\"lng\":-72.1847598,\"lat\":40.9633868},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-92.7098744,\"lat\":35.9018987},{\"lng\":-79.008205,\"lat\":34.6183305},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":-87.848682,\"lat\":41.1253903},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-105.1319296,\"lat\":39.977763},{\"lng\":102.6470481,\"lat\":18.0346879},{\"lng\":-120.375716,\"lat\":35.3540209},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-80.3553302,\"lat\":25.8195424},{\"lng\":-103.338396,\"lat\":20.6720375},{\"lng\":-76.4283781,\"lat\":44.3054151},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-3.5310879,\"lat\":40.3536054},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-1.5695287,\"lat\":47.1905456},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":7.90503,\"lat\":48.8004792},{\"lng\":2.289259,\"lat\":48.8212037},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-0.5473085,\"lat\":51.4312585},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.7029194,\"lat\":36.8252277},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":6.4086189,\"lat\":46.0775797},{\"lng\":-121.8106925,\"lat\":38.0093296},{\"lng\":12.5135924,\"lat\":55.6637755},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-84.7477136,\"lat\":33.7514966},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.7880359,\"lat\":32.7867697},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.752653,\"lat\":51.7177044},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-90.1830408,\"lat\":32.2998686},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-105.05208,\"lat\":39.9403995},{\"lng\":-0.0123189,\"lat\":51.5246287},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-79.7507138,\"lat\":40.0871147},{\"lng\":2.5589558,\"lat\":48.9802035},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-92.6723254,\"lat\":38.1259916},{\"lng\":-70.241993,\"lat\":43.729525},{\"lng\":-90.5643258,\"lat\":38.661953},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":4.0413095,\"lat\":48.3185478},{\"lng\":1.8487179,\"lat\":42.9332121},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-155.996933,\"lat\":19.641941},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.0426301,\"lat\":48.9274192},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.270532,\"lat\":40.224432},{\"lng\":0.33179,\"lat\":48.0168},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":-70.9478343,\"lat\":42.981477},{\"lng\":2.6500745,\"lat\":39.5695818},{\"lng\":34.8839799,\"lat\":32.0906241},{\"lng\":-122.3520327,\"lat\":48.24216},{\"lng\":-94.751376,\"lat\":43.2377381},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-83.1446485,\"lat\":42.4894801},{\"lng\":6.0525071,\"lat\":45.8842342},{\"lng\":12.7865937,\"lat\":57.5518736},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-81.4548392,\"lat\":39.4167742},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":-105.016649,\"lat\":39.613321},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-84.3635338,\"lat\":35.5197984},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.3731878,\"lat\":47.5499217},{\"lng\":6.0243622,\"lat\":47.2380222},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":1.2546057,\"lat\":41.1172364},{\"lng\":-112.450627,\"lat\":42.8620287},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":-122.2312383,\"lat\":47.2061882},{\"lng\":-73.9897782,\"lat\":41.1509835},{\"lng\":0.1967849,\"lat\":48.0073849},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.1727546,\"lat\":45.2926341},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2255727,\"lat\":48.8709053},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-77.4127562,\"lat\":39.415779},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-119.0779359,\"lat\":34.4458248},{\"lng\":-4.5122831,\"lat\":55.836517},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.3878945,\"lat\":34.2204227},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-74.1182492,\"lat\":42.0410578},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":8.071992,\"lat\":50.141688},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-86.4475898,\"lat\":36.3883031},{\"lng\":-75.2326641,\"lat\":43.1009031},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-78.3199496,\"lat\":44.3048009},{\"lng\":-122.0151976,\"lat\":47.1803702},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-72.5983151,\"lat\":41.2794282},{\"lng\":-72.6713448,\"lat\":41.707785},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.4535345,\"lat\":40.8214375},{\"lng\":-1.32955,\"lat\":43.75079},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.6077908,\"lat\":28.0785034},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-78.4298248,\"lat\":42.0775022},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.8436412,\"lat\":41.8789942},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-93.1659179,\"lat\":44.818173},{\"lng\":-122.5681191,\"lat\":38.1061979},{\"lng\":-74.4773916,\"lat\":39.3405045},{\"lng\":-72.2147434,\"lat\":41.7121364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":36.828842,\"lat\":-1.3026148},{\"lng\":-71.7629658,\"lat\":42.1499283},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.403984,\"lat\":44.4794941},{\"lng\":151.5511123,\"lat\":-32.7316683},{\"lng\":-83.257153,\"lat\":42.3021687},{\"lng\":104.6928392,\"lat\":29.2995746},{\"lng\":15.3122511,\"lat\":-4.32171},{\"lng\":-1.3061227,\"lat\":45.9437695},{\"lng\":-1.3824404,\"lat\":54.9061115},{\"lng\":-113.903503,\"lat\":53.545204},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-88.0717708,\"lat\":41.7003302},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-118.644097,\"lat\":34.1446643},{\"lng\":5.7055996,\"lat\":45.2088706},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-92.2266876,\"lat\":37.8141419},{\"lng\":-87.8873916,\"lat\":42.0415823},{\"lng\":-84.425589,\"lat\":42.2416466},{\"lng\":-118.448647,\"lat\":33.9776848},{\"lng\":-83.5960264,\"lat\":32.5438429},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-81.5464928,\"lat\":30.7305142},{\"lng\":-97.0819541,\"lat\":32.8370727},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.7007595,\"lat\":38.5349571},{\"lng\":-97.4394816,\"lat\":35.2225717},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":71.4719683,\"lat\":30.197838},{\"lng\":-78.6145758,\"lat\":-0.9340311},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.6845895,\"lat\":49.1049353},{\"lng\":7.1513834,\"lat\":43.6612012},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":25.5597482,\"lat\":47.5297764},{\"lng\":-75.0579502,\"lat\":39.9562238},{\"lng\":117.1138479,\"lat\":36.6519754},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":2.289259,\"lat\":48.8212037},{\"lng\":2.3373021,\"lat\":48.7790514},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-123.2620435,\"lat\":44.5645659},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.9810407,\"lat\":45.5705379},{\"lng\":-76.9199742,\"lat\":40.2398118},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-90.1767012,\"lat\":30.0018546},{\"lng\":-79.1802994,\"lat\":35.4798757},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-73.2541069,\"lat\":42.4484778},{\"lng\":2.2385432,\"lat\":48.8126688},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":15.2151181,\"lat\":59.2747287},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-0.2068872,\"lat\":51.8031083},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-122.192337,\"lat\":47.6144219},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-1.37328,\"lat\":43.68866},{\"lng\":-122.192337,\"lat\":47.6144219},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":4.4811089,\"lat\":52.1518157},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":106.6811524,\"lat\":10.8237546},{\"lng\":-118.8375937,\"lat\":34.1705609},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":-86.3258835,\"lat\":34.025609},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":2.6953079,\"lat\":48.268026},{\"lng\":-96.3455991,\"lat\":30.6183939},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.0996306,\"lat\":26.318342},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":7.5952375,\"lat\":48.3707281},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":101.6454202,\"lat\":3.0988792},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.7529851,\"lat\":48.1806379},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-117.7197785,\"lat\":34.0966764},{\"lng\":-88.3303618,\"lat\":42.1816908},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-77.8616386,\"lat\":40.7944504},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.985181,\"lat\":39.8695516},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2566367,\"lat\":38.1040864},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-95.2092076,\"lat\":29.6910753},{\"lng\":-74.0072568,\"lat\":40.8860164},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-86.2283864,\"lat\":43.0630734},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-0.5762125,\"lat\":42.8801011},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8320784,\"lat\":40.9381544},{\"lng\":-76.5179991,\"lat\":41.9572965},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-122.4094051,\"lat\":48.0399806},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":-74.5908483,\"lat\":41.611556},{\"lng\":-75.710976,\"lat\":45.4277659},{\"lng\":-84.1051939,\"lat\":33.7123305},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":12.1346523,\"lat\":50.4950632},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-79.8625851,\"lat\":32.7940651},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-73.9629154,\"lat\":40.9253766},{\"lng\":-5.9953403,\"lat\":37.3886303},{\"lng\":-155.1003754,\"lat\":19.6854458},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":11.7529851,\"lat\":48.1806379},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.2784264,\"lat\":42.933597},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-3.3449362,\"lat\":51.6001047},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-93.0572272,\"lat\":37.1176314},{\"lng\":-106.8930799,\"lat\":34.0572858},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":4.9884323,\"lat\":43.5139051},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-88.3334274,\"lat\":42.8666803},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":9.4978479,\"lat\":51.3157833},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-88.2578582,\"lat\":42.1211364},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":4.1131937,\"lat\":43.7223794},{\"lng\":-89.5844457,\"lat\":44.5234467},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":7.2196635,\"lat\":51.4818111},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.1374969,\"lat\":41.4910324},{\"lng\":33.3638783,\"lat\":35.1746503},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-90.1740313,\"lat\":44.6662287},{\"lng\":-98.6884208,\"lat\":29.5635688},{\"lng\":-80.1353006,\"lat\":25.7929198},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-6.8408929,\"lat\":34.0218454},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-73.2276183,\"lat\":44.3783486},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":0.3233131,\"lat\":51.4780898},{\"lng\":-81.684004,\"lat\":36.2187873},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.2174603,\"lat\":41.320856},{\"lng\":-85.5872286,\"lat\":42.291707},{\"lng\":-76.5508618,\"lat\":39.3868522},{\"lng\":152.8424214,\"lat\":-26.756741},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.7001187,\"lat\":42.7742446},{\"lng\":-94.1574328,\"lat\":36.0625843},{\"lng\":-95.1530516,\"lat\":43.3955188},{\"lng\":-97.6775634,\"lat\":30.6370152},{\"lng\":-89.6095285,\"lat\":40.8073044},{\"lng\":-6.9261131,\"lat\":52.8408344},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.08816,\"lat\":36.2030064},{\"lng\":-86.6072054,\"lat\":33.1781718},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-77.4127562,\"lat\":39.415779},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.4360158,\"lat\":45.7796836},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.7753539,\"lat\":41.270178},{\"lng\":-92.1052679,\"lat\":46.7838287},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.11136,\"lat\":44.4906817},{\"lng\":-96.8570183,\"lat\":32.5897831},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-2.0260409,\"lat\":48.649518},{\"lng\":-75.1304588,\"lat\":40.3100446},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":8.9746623,\"lat\":56.1379757},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-106.779807,\"lat\":32.3140354},{\"lng\":-80.7224386,\"lat\":35.1159532},{\"lng\":-80.7009406,\"lat\":41.1540381},{\"lng\":-77.2676335,\"lat\":38.636447},{\"lng\":4.438952,\"lat\":52.1893268},{\"lng\":-79.9695004,\"lat\":40.6300671},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":7.1513834,\"lat\":43.6612012},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-75.0629531,\"lat\":42.453492},{\"lng\":-83.3527097,\"lat\":42.36837},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":2.4289667,\"lat\":48.6241665},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":-88.0895061,\"lat\":41.6475306},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-1.3030524,\"lat\":43.7988816},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":0.1967849,\"lat\":48.0073849},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":9.1605106,\"lat\":47.7664456},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-76.3056707,\"lat\":40.0379958},{\"lng\":8.8557862,\"lat\":48.2737512},{\"lng\":-45.2484314,\"lat\":-18.2051533},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-82.805646,\"lat\":39.8428215},{\"lng\":-72.2505752,\"lat\":41.8119557},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-9.3282374,\"lat\":38.9369782},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-81.0352313,\"lat\":34.000754},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-88.4493796,\"lat\":43.7533414},{\"lng\":-74.1537549,\"lat\":40.9492649},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":-71.5745402,\"lat\":42.6112242},{\"lng\":-0.4881708,\"lat\":38.3436365},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":9.2199647,\"lat\":48.6664},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":14.4901093,\"lat\":35.8956788},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.4933648,\"lat\":38.2974855},{\"lng\":-0.7032713,\"lat\":52.4877341},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-71.1843236,\"lat\":42.3652518},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-68.8446177,\"lat\":-32.8894155},{\"lng\":2.3212492,\"lat\":48.8642313},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-76.217705,\"lat\":43.106456},{\"lng\":1.9988356,\"lat\":48.7760957},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-72.5976987,\"lat\":41.9791024},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-75.1515534,\"lat\":40.103196},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":7.0557352,\"lat\":48.734239},{\"lng\":-84.4919524,\"lat\":39.0889469},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":-73.9529126,\"lat\":42.0775906},{\"lng\":1.5212467,\"lat\":42.5069391},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-74.60988,\"lat\":40.5742696},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-3.3660907,\"lat\":47.7477336},{\"lng\":-81.8431567,\"lat\":27.8963791},{\"lng\":-77.4605399,\"lat\":38.3031837},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-80.4136767,\"lat\":37.2296566},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.75596,\"lat\":51.6317449},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-88.822047,\"lat\":42.3683522},{\"lng\":-117.9951044,\"lat\":33.7941024},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-96.9083366,\"lat\":32.6518004},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-87.7834769,\"lat\":42.7313756},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":6.5398722,\"lat\":46.0828653},{\"lng\":-74.186256,\"lat\":40.935654},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.7755065,\"lat\":40.20824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.1810781,\"lat\":53.0079887},{\"lng\":-86.2616968,\"lat\":39.950724},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-97.6775634,\"lat\":30.6370152},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-76.2899539,\"lat\":36.8493695},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":73.5301042,\"lat\":4.1961894},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":12.5135924,\"lat\":55.6637755},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-88.1850028,\"lat\":41.9908485},{\"lng\":-2.6294313,\"lat\":53.6531915},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.5060144,\"lat\":48.8608712},{\"lng\":-71.6129907,\"lat\":42.2694308},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-119.180381,\"lat\":34.1976308},{\"lng\":8.5980265,\"lat\":50.2363508},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.3473099,\"lat\":37.5780965},{\"lng\":5.7826657,\"lat\":43.8338026},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-3.9904173,\"lat\":55.7893512},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":-71.4677032,\"lat\":42.7656251},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-2.6318629,\"lat\":50.9420451},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":11.3278779,\"lat\":48.2077801},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-79.3314725,\"lat\":42.4400476},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-121.971335,\"lat\":47.8552259},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-6.6574093,\"lat\":53.2214677},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.0579359,\"lat\":47.6442067},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-122.9543022,\"lat\":50.1171903},{\"lng\":-72.1847598,\"lat\":40.9633868},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-111.9106607,\"lat\":40.6149174},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":21.6259782,\"lat\":47.531399},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-117.147366,\"lat\":33.4946353},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":27.8435878,\"lat\":37.8483767},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":36.828842,\"lat\":-1.3026148},{\"lng\":-77.4309829,\"lat\":34.7509962},{\"lng\":-71.5785924,\"lat\":42.6650324},{\"lng\":-71.1187829,\"lat\":42.332918},{\"lng\":-47.2180677,\"lat\":-23.0908356},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":25.6321312,\"lat\":43.0820584},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":4.3558561,\"lat\":52.0703201},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.1968257,\"lat\":39.9526791},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-2.7603283,\"lat\":48.5141134},{\"lng\":-79.1262839,\"lat\":40.6424116},{\"lng\":-48.6646323,\"lat\":-27.6447774},{\"lng\":-0.1880608,\"lat\":51.4143912},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":11.3927685,\"lat\":47.2654296},{\"lng\":-89.1287636,\"lat\":41.3272919},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.5174342,\"lat\":34.2661558},{\"lng\":-122.4737053,\"lat\":47.4208759},{\"lng\":-0.7170764,\"lat\":44.8958887},{\"lng\":-70.7746224,\"lat\":43.4387179},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":-76.5974223,\"lat\":39.4475075},{\"lng\":6.3681233,\"lat\":50.801983},{\"lng\":-71.3606721,\"lat\":42.3632063},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-114.315321,\"lat\":48.202158},{\"lng\":-94.7288558,\"lat\":31.3386242},{\"lng\":-46.3286399,\"lat\":-23.9335988},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.0629531,\"lat\":42.453492},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":2.1836324,\"lat\":49.0634561},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-2.0597449,\"lat\":52.3353816},{\"lng\":2.4631476,\"lat\":48.9385489},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.3145039,\"lat\":48.9525181},{\"lng\":-122.2070775,\"lat\":47.6765382},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-70.8578253,\"lat\":42.500096},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-49.2712724,\"lat\":-25.4295963},{\"lng\":-83.1499304,\"lat\":42.6055893},{\"lng\":-6.4008879,\"lat\":54.0046033},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":-118.11711,\"lat\":34.5793131},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":-79.666672,\"lat\":43.447436},{\"lng\":-81.7786972,\"lat\":26.339806},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-92.3745761,\"lat\":30.2140928},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.2776468,\"lat\":40.6081591},{\"lng\":-89.093966,\"lat\":42.2713945},{\"lng\":-76.8646092,\"lat\":39.1938429},{\"lng\":-77.9112655,\"lat\":37.5531622},{\"lng\":-89.683459,\"lat\":45.180522},{\"lng\":-76.2494453,\"lat\":36.7168315},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-8.6058415,\"lat\":41.1300103},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.5501874,\"lat\":39.2085354},{\"lng\":-7.6200284,\"lat\":33.5945144},{\"lng\":-79.1771539,\"lat\":35.7201229},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-103.228023,\"lat\":44.0806041},{\"lng\":-2.0976346,\"lat\":57.1426487},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-83.2646624,\"lat\":42.8247524},{\"lng\":-118.8375937,\"lat\":34.1705609},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.1173394,\"lat\":39.9239373},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":30.061507,\"lat\":-1.950851},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.0942792,\"lat\":48.8990413},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":-97.2681939,\"lat\":36.4129621},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-86.5245906,\"lat\":35.9670985},{\"lng\":-123.137414,\"lat\":49.163168},{\"lng\":-1.8604874,\"lat\":53.7229229},{\"lng\":-101.296273,\"lat\":48.23251},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-61.5037609,\"lat\":10.6680972},{\"lng\":2.4875193,\"lat\":48.8716626},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-9.1576301,\"lat\":38.6831302},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":1.2238259,\"lat\":45.8055591},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-116.464076,\"lat\":33.7810031},{\"lng\":-87.7887615,\"lat\":41.8878145},{\"lng\":-82.6995444,\"lat\":27.8428025},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-71.3322798,\"lat\":41.9841334},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":12.5135924,\"lat\":55.6637755},{\"lng\":-98.3252932,\"lat\":26.2159066},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":8.6938161,\"lat\":50.5808795},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-85.9213796,\"lat\":39.2014405},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-77.4127562,\"lat\":39.415779},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.4547891,\"lat\":42.9956397},{\"lng\":-107.2112407,\"lat\":39.4005647},{\"lng\":-0.1991229,\"lat\":51.4989948},{\"lng\":-71.2804301,\"lat\":41.9439695},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-117.2305791,\"lat\":33.9375177},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.8919011,\"lat\":40.4191229},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":120.5668992,\"lat\":15.9759995},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":77.6226,\"lat\":12.9881567},{\"lng\":7.0581152,\"lat\":46.6190969},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-0.3032767,\"lat\":51.4613531},{\"lng\":-73.2584121,\"lat\":41.1428951},{\"lng\":-81.345941,\"lat\":41.239223},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-80.6636984,\"lat\":28.2662775},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-105.0372046,\"lat\":39.8366528},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-74.6171489,\"lat\":39.3820672},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-87.9803604,\"lat\":42.2204892},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-88.207301,\"lat\":40.1117174},{\"lng\":-71.2084061,\"lat\":46.8137431},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":4.9639631,\"lat\":52.0914501},{\"lng\":4.8423304,\"lat\":45.7969952},{\"lng\":-83.7049498,\"lat\":42.7978061},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":2.3019814,\"lat\":48.8211559},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":23.8280444,\"lat\":61.1974827},{\"lng\":-113.584131,\"lat\":37.104153},{\"lng\":-101.8371192,\"lat\":35.20729},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-75.2590721,\"lat\":39.9184461},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-75.0729504,\"lat\":39.8909466},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":2.415796,\"lat\":48.8795658},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":-107.2112407,\"lat\":39.4005647},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":-77.9065508,\"lat\":34.3548975},{\"lng\":-1.2309278,\"lat\":44.2019796},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-85.7279185,\"lat\":42.8192943},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-88.0895061,\"lat\":41.6475306},{\"lng\":2.1900052,\"lat\":48.7809496},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-86.7825235,\"lat\":36.0325687},{\"lng\":6.6055827,\"lat\":46.534566},{\"lng\":8.7376029,\"lat\":41.9263991},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":114.1582784,\"lat\":22.2818286},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-80.581497,\"lat\":35.4093143},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-58.5036282,\"lat\":-34.5244484},{\"lng\":-88.770018,\"lat\":17.250199},{\"lng\":6.0992785,\"lat\":45.8880398},{\"lng\":-91.4685617,\"lat\":43.6624222},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-105.436074,\"lat\":37.4281735},{\"lng\":-73.1715669,\"lat\":44.4671635},{\"lng\":-79.4607617,\"lat\":46.3092115},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.1499322,\"lat\":42.6583661},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-96.6925096,\"lat\":33.0136764},{\"lng\":-92.4116886,\"lat\":41.0195659},{\"lng\":-90.6647985,\"lat\":42.5006243},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":6.9239103,\"lat\":43.6589011},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3034183,\"lat\":29.0281051},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":6.083862,\"lat\":50.776351},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-4.0239568,\"lat\":39.8560679},{\"lng\":-121.8903368,\"lat\":36.9941295},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.0715658,\"lat\":37.713606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8534326,\"lat\":46.7831001},{\"lng\":-93.1865659,\"lat\":36.0081324},{\"lng\":-121.5881718,\"lat\":48.1138513},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-114.01062,\"lat\":51.28597},{\"lng\":-74.415984,\"lat\":40.4278841},{\"lng\":-119.0167679,\"lat\":36.06523},{\"lng\":2.7005289,\"lat\":48.4881157},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":6.0641634,\"lat\":53.0059606},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-1.7471629,\"lat\":48.0245814},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-97.2258483,\"lat\":33.0040126},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":-64.5651667,\"lat\":45.0682627},{\"lng\":9.4697982,\"lat\":53.9313413},{\"lng\":-81.9705909,\"lat\":33.4943487},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.7853915,\"lat\":43.0821793},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-1.4992075,\"lat\":47.2035029},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.0044767,\"lat\":45.7764637},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-7.6200284,\"lat\":33.5945144},{\"lng\":-81.7016346,\"lat\":30.1654707},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-85.4807825,\"lat\":32.6098566},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-87.4046571,\"lat\":37.9456824},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.219344,\"lat\":48.8437412},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-77.231012,\"lat\":39.8308973},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-1.7003017,\"lat\":43.3624715},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9593041,\"lat\":40.9414874},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-81.4412259,\"lat\":41.3897764},{\"lng\":12.4483489,\"lat\":55.6898267},{\"lng\":0.9918234,\"lat\":47.3279746},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-96.8439365,\"lat\":32.3944908},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":8.3418609,\"lat\":47.4948072},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-82.3076709,\"lat\":28.7211775},{\"lng\":-103.338396,\"lat\":20.6720375},{\"lng\":5.93256,\"lat\":46.932},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":-83.2732627,\"lat\":42.3369816},{\"lng\":2.2956951,\"lat\":49.8941708},{\"lng\":-76.6033433,\"lat\":39.2340834},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.721834,\"lat\":45.3990409},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":2.0942792,\"lat\":48.8990413},{\"lng\":5.5783856,\"lat\":46.1825453},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":-122.29214,\"lat\":47.1849009},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-89.5473245,\"lat\":40.3725415},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-71.0767724,\"lat\":42.7777829},{\"lng\":-0.7460981,\"lat\":51.3392845},{\"lng\":-120.1835765,\"lat\":39.3279454},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.7540703,\"lat\":45.6739755},{\"lng\":11.4354419,\"lat\":48.2592477},{\"lng\":1.5332389,\"lat\":45.1584982},{\"lng\":-118.0539323,\"lat\":33.8644291},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.4159739,\"lat\":48.8432434},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-4.5583284,\"lat\":48.4244717},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":6.3915748,\"lat\":46.4952916},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-77.8616386,\"lat\":40.7944504},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.1392227,\"lat\":48.9614964},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-84.8407732,\"lat\":33.9237141},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-90.4070632,\"lat\":39.3022693},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-76.5528831,\"lat\":39.155816},{\"lng\":-117.865339,\"lat\":34.1361187},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-118.559849,\"lat\":34.4131941},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-72.644512,\"lat\":41.767914},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-91.3378987,\"lat\":34.2928774},{\"lng\":-0.3623924,\"lat\":51.4619551},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":1.178352,\"lat\":49.17231},{\"lng\":-74.0204177,\"lat\":40.7695457},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-76.4626118,\"lat\":40.375713},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":151.885362,\"lat\":-27.7692045},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-84.6768796,\"lat\":34.0659329},{\"lng\":-76.7276989,\"lat\":39.962493},{\"lng\":-87.8406031,\"lat\":42.0112329},{\"lng\":-78.8900409,\"lat\":33.6956461},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-83.6117646,\"lat\":42.241051},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":13.2439512,\"lat\":-8.8272699},{\"lng\":100.5386136,\"lat\":13.7784702},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-75.710976,\"lat\":45.4277659},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-125.244153,\"lat\":50.023071},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":-84.5597128,\"lat\":38.2099837},{\"lng\":10.0176952,\"lat\":53.3965903},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":-2.97019,\"lat\":56.4605938},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-93.470786,\"lat\":44.8546856},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.7832947,\"lat\":45.0049305},{\"lng\":-84.7997613,\"lat\":34.1652304},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-74.5226681,\"lat\":40.0654375},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-72.6719518,\"lat\":42.3355692},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":10.6797912,\"lat\":43.4714722},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-71.889038,\"lat\":45.403271},{\"lng\":-0.2464264,\"lat\":49.1390059},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":6.1301614,\"lat\":43.1202573},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.7030748,\"lat\":44.7927669},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-72.6071119,\"lat\":42.1487691},{\"lng\":-76.4537302,\"lat\":41.0044958},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-73.872635,\"lat\":41.0145418},{\"lng\":-90.6647985,\"lat\":42.5006243},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":6.2455185,\"lat\":48.6876255},{\"lng\":-68.2043361,\"lat\":44.3876378},{\"lng\":5.4832687,\"lat\":43.3351381},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":2.3483549,\"lat\":48.8153656},{\"lng\":-121.9877444,\"lat\":38.3565773},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-89.5119565,\"lat\":43.0962919},{\"lng\":-8.4726423,\"lat\":51.8985136},{\"lng\":15.4382786,\"lat\":47.0708678},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-118.4489739,\"lat\":35.1321878},{\"lng\":-91.6392294,\"lat\":44.0500054},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-101.2727305,\"lat\":21.0198147},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":2.2453842,\"lat\":48.7144587},{\"lng\":-117.210656,\"lat\":33.560832},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-90.1830408,\"lat\":32.2998686},{\"lng\":-71.1143838,\"lat\":42.3116046},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":22.2670522,\"lat\":60.4517531},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-3.5995337,\"lat\":37.1734995},{\"lng\":-75.7116997,\"lat\":39.8467414},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-71.3488963,\"lat\":42.4605189},{\"lng\":-93.574375,\"lat\":45.0151361},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":108.4034084,\"lat\":30.8101669},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.6039516,\"lat\":46.9756991},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-74.9573908,\"lat\":40.0323338},{\"lng\":1.7537638,\"lat\":52.4766308},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":9.959178,\"lat\":63.5842624},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.4503643,\"lat\":48.1747684},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-82.5187629,\"lat\":37.4792672},{\"lng\":-79.4062658,\"lat\":39.4099097},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-94.81887,\"lat\":38.8838856},{\"lng\":-71.1546367,\"lat\":41.7010642},{\"lng\":-83.8598742,\"lat\":33.5966005},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-84.0373054,\"lat\":41.8975152},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.938456,\"lat\":35.6876096},{\"lng\":-94.419079,\"lat\":39.246479},{\"lng\":-74.7333845,\"lat\":45.0469989},{\"lng\":-84.6154897,\"lat\":34.0234337},{\"lng\":-75.3068878,\"lat\":39.9483282},{\"lng\":-117.7517496,\"lat\":34.0553813},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-81.9081937,\"lat\":41.375049},{\"lng\":-75.1946649,\"lat\":40.9864261},{\"lng\":-87.6835974,\"lat\":30.4065868},{\"lng\":-48.5496098,\"lat\":-27.5973002},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":-97.6200043,\"lat\":30.4393696},{\"lng\":2.2619632,\"lat\":48.7811049},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-73.4698253,\"lat\":40.669501},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.6232526,\"lat\":39.3406674},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.6496424,\"lat\":40.2452976},{\"lng\":-89.6237402,\"lat\":20.9670759},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-71.1859782,\"lat\":44.5736767},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-58.6671441,\"lat\":-34.6583293},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.301411,\"lat\":37.9154056},{\"lng\":6.9703991,\"lat\":43.6203852},{\"lng\":1.9988356,\"lat\":48.7760957},{\"lng\":3.7250121,\"lat\":51.0538286},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":135.0762968,\"lat\":48.4812568},{\"lng\":-79.2576479,\"lat\":43.7729744},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-70.09842,\"lat\":41.2844408},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-95.5507771,\"lat\":30.7235263},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-76.6235105,\"lat\":39.4837588},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":-84.4310645,\"lat\":10.3267699},{\"lng\":-72.5886727,\"lat\":42.1018764},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-114.668741,\"lat\":47.6091041},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0566735,\"lat\":40.7899291},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-75.8062341,\"lat\":39.6010603},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-79.0208814,\"lat\":43.8505287},{\"lng\":-76.9274072,\"lat\":38.6023935},{\"lng\":0.0757204,\"lat\":51.6176444},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":15.2151181,\"lat\":59.2747287},{\"lng\":0.2781546,\"lat\":50.7664372},{\"lng\":15.409716,\"lat\":48.1006741},{\"lng\":-71.2084061,\"lat\":46.8137431},{\"lng\":-76.8317417,\"lat\":39.2757359},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-73.9897782,\"lat\":41.1509835},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-97.3404854,\"lat\":32.9616819},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":17.0607599,\"lat\":61.2998501},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":0.4144984,\"lat\":46.5089333},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":-111.651822,\"lat\":35.1987522},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-122.3473099,\"lat\":37.5780965},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.4541894,\"lat\":42.1167065},{\"lng\":-75.889912,\"lat\":40.1552219},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-122.768761,\"lat\":45.4853207},{\"lng\":-79.8728583,\"lat\":43.2560802},{\"lng\":-71.8358095,\"lat\":42.1945465},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-122.4569315,\"lat\":48.9466041},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-97.9647269,\"lat\":29.5688411},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.5420246,\"lat\":41.0469042},{\"lng\":-82.3877015,\"lat\":35.6005795},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-83.2341028,\"lat\":42.6875323},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-104.969565,\"lat\":39.5497243},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-72.6816365,\"lat\":41.2827593},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":9.1224313,\"lat\":47.4299725},{\"lng\":-71.4586114,\"lat\":41.6992717},{\"lng\":-106.325138,\"lat\":42.8501191},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":-77.93918,\"lat\":43.213671},{\"lng\":-83.8598742,\"lat\":33.5966005},{\"lng\":-82.5723193,\"lat\":27.5214269},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.2835502,\"lat\":47.8411013},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-89.216655,\"lat\":37.7274692},{\"lng\":6.1724618,\"lat\":48.6599676},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-121.2462453,\"lat\":38.642897},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-71.1786655,\"lat\":42.3959296},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-95.3024351,\"lat\":29.9118897},{\"lng\":-122.5371325,\"lat\":47.2258172},{\"lng\":-1.5839895,\"lat\":47.1231355},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5133385,\"lat\":37.0841838},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":-71.9598586,\"lat\":46.0554948},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-81.6853534,\"lat\":28.8527675},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.8046023,\"lat\":42.5854371},{\"lng\":6.765164,\"lat\":43.617944},{\"lng\":-0.75596,\"lat\":51.6317449},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.5716694,\"lat\":39.1836082},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-83.2732627,\"lat\":42.3369816},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-81.9705909,\"lat\":33.4943487},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-73.7048024,\"lat\":40.7246999},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":9.1364229,\"lat\":48.9493243},{\"lng\":-82.5540279,\"lat\":28.183222},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":2.4197113,\"lat\":48.8051624},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-117.019529,\"lat\":32.5317397},{\"lng\":-94.1288142,\"lat\":36.1867442},{\"lng\":-81.3410516,\"lat\":35.2450607},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-120.4964189,\"lat\":35.0358216},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-96.4719289,\"lat\":32.747893},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-80.6009388,\"lat\":40.4654148},{\"lng\":-85.4807825,\"lat\":32.6098566},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-87.7887615,\"lat\":41.8878145},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-7.4919318,\"lat\":39.8266322},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-104.8769227,\"lat\":39.579155},{\"lng\":-96.3455991,\"lat\":30.6183939},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-78.4767034,\"lat\":36.0247769},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":116.3912972,\"lat\":39.9057136},{\"lng\":-78.5103731,\"lat\":35.9803138},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-86.851123,\"lat\":33.350293},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":114.0545429,\"lat\":22.5445741},{\"lng\":-82.5164242,\"lat\":35.4661821},{\"lng\":-79.9559437,\"lat\":39.6296809},{\"lng\":14.4258096,\"lat\":35.910083},{\"lng\":-77.3267652,\"lat\":38.5674096},{\"lng\":-72.6110645,\"lat\":42.5896205},{\"lng\":-120.8471545,\"lat\":37.7665947},{\"lng\":-73.9283672,\"lat\":41.7065539},{\"lng\":-4.3888761,\"lat\":55.8775733},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-93.1566107,\"lat\":45.0060767},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":24.0315921,\"lat\":49.841952},{\"lng\":-122.6246836,\"lat\":47.5653663},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-82.7192671,\"lat\":28.2441768},{\"lng\":-93.470786,\"lat\":44.8546856},{\"lng\":-111.7386884,\"lat\":40.3640349},{\"lng\":5.7715863,\"lat\":45.0758358},{\"lng\":-94.1910044,\"lat\":42.5044017},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-71.4235744,\"lat\":46.8595141},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":-93.1553635,\"lat\":45.144882},{\"lng\":-85.3425348,\"lat\":38.0317303},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-82.3269883,\"lat\":27.871197},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-122.29214,\"lat\":47.1849009},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-74.4115401,\"lat\":40.5792701},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-119.242889,\"lat\":34.4480495},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-75.1198911,\"lat\":39.9448402},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-79.4686558,\"lat\":44.2396166},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-122.5371325,\"lat\":47.2258172},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-104.7008056,\"lat\":38.682219},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":-84.4041725,\"lat\":39.516644},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-81.0161686,\"lat\":35.2976298},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":72.5800568,\"lat\":23.0215374},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-96.6783651,\"lat\":34.7743383},{\"lng\":-73.5731712,\"lat\":45.459099},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-71.1143838,\"lat\":42.3116046},{\"lng\":-2.2458192,\"lat\":51.8653705},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":-88.6867538,\"lat\":41.9889173},{\"lng\":-90.4973286,\"lat\":36.0584021},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-88.9939147,\"lat\":40.4797828},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-96.6081167,\"lat\":47.7739988},{\"lng\":1.4580047,\"lat\":48.4489382},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-79.4491057,\"lat\":43.7543217},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":-111.8804817,\"lat\":40.8894611},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-83.7658369,\"lat\":42.4243473},{\"lng\":24.7453688,\"lat\":59.4372155},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-74.9829443,\"lat\":39.8115033},{\"lng\":29.3205405,\"lat\":-3.3242483},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.4881708,\"lat\":38.3436365},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.5495112,\"lat\":34.9854275},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.400941,\"lat\":37.598958},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.2127083,\"lat\":48.8247407},{\"lng\":-2.8458503,\"lat\":47.5968368},{\"lng\":120.6212881,\"lat\":31.311123},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-81.0557921,\"lat\":29.2854132},{\"lng\":2.3872525,\"lat\":48.8122302},{\"lng\":-5.4108305,\"lat\":35.5590626},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.636465,\"lat\":38.2325829},{\"lng\":-121.784889,\"lat\":47.4957757},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-117.903317,\"lat\":33.6633386},{\"lng\":-80.2872086,\"lat\":26.0061943},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-94.282265,\"lat\":39.017316},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.7191081,\"lat\":39.6430455},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9112103,\"lat\":41.5965635},{\"lng\":105.8406959,\"lat\":21.0242596},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":67.0207055,\"lat\":24.8546842},{\"lng\":-84.3041074,\"lat\":39.5589474},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-81.3035515,\"lat\":31.9382381},{\"lng\":-88.3334274,\"lat\":42.8666803},{\"lng\":-77.5645607,\"lat\":39.1154506},{\"lng\":3.094027,\"lat\":36.7429388},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-121.8374777,\"lat\":39.7284945},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-87.8947848,\"lat\":37.9318018},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-2.491841,\"lat\":52.9045385},{\"lng\":-77.0011096,\"lat\":41.2411556},{\"lng\":-1.5342042,\"lat\":54.9911912},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.0715658,\"lat\":37.713606},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-71.4366813,\"lat\":41.779588},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":4.7540703,\"lat\":45.6739755},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":5.6851425,\"lat\":43.4469081},{\"lng\":-80.3975399,\"lat\":27.6387163},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-87.0522661,\"lat\":41.6107243},{\"lng\":-71.8623548,\"lat\":42.3560836},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":104.063315,\"lat\":30.659867},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":-71.346996,\"lat\":42.2836393},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-97.3404854,\"lat\":32.9616819},{\"lng\":90.3890144,\"lat\":23.7643863},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":120.0851114,\"lat\":30.8942995},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":8.6736295,\"lat\":49.8851869},{\"lng\":-75.5138959,\"lat\":40.036202},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-74.1968257,\"lat\":39.9526791},{\"lng\":4.3181187,\"lat\":50.811795},{\"lng\":-83.3527097,\"lat\":42.36837},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.33931,\"lat\":47.313494},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-116.5016784,\"lat\":33.961124},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-87.9822969,\"lat\":43.2219088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":120.9803621,\"lat\":14.5904492},{\"lng\":-112.583776,\"lat\":33.3703197},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-111.634158,\"lat\":33.2483858},{\"lng\":-79.5655129,\"lat\":43.7213619},{\"lng\":-90.3227803,\"lat\":38.7919683},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-89.2134359,\"lat\":43.1834579},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-82.9069508,\"lat\":42.4435616},{\"lng\":-83.0335384,\"lat\":42.6261446},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-83.2396612,\"lat\":42.7844752},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":7.0557352,\"lat\":48.734239},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.1177723,\"lat\":44.0427744},{\"lng\":-75.2188589,\"lat\":38.324505},{\"lng\":-89.0928155,\"lat\":30.3674198},{\"lng\":-76.8115168,\"lat\":40.398036},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-72.6713448,\"lat\":41.707785},{\"lng\":-83.9490365,\"lat\":43.4200387},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":-111.29189,\"lat\":47.5048851},{\"lng\":-121.176058,\"lat\":38.6779591},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-117.147366,\"lat\":33.4946353},{\"lng\":-80.1098123,\"lat\":32.9857275},{\"lng\":-71.9107903,\"lat\":42.5449024},{\"lng\":-76.9429182,\"lat\":39.2065447},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-117.903317,\"lat\":33.6633386},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":-80.0728201,\"lat\":26.4614625},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-97.0867203,\"lat\":33.0283854},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-88.852119,\"lat\":35.6055887},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-75.0437814,\"lat\":40.1742759},{\"lng\":2.7772211,\"lat\":50.291048},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-82.366121,\"lat\":28.1866014},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-8.831088,\"lat\":41.694867},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.5136642,\"lat\":41.5058344},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-79.1802994,\"lat\":35.4798757},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-0.3018577,\"lat\":51.4129277},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-0.9700664,\"lat\":51.4564242},{\"lng\":-117.9056046,\"lat\":34.1338751},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-83.6000696,\"lat\":42.5917805},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-70.9391625,\"lat\":42.2212188},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":2.289259,\"lat\":48.8212037},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-2.2327511,\"lat\":53.3261292},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-82.5748194,\"lat\":27.4989278},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-73.8320784,\"lat\":40.9381544},{\"lng\":-72.0934864,\"lat\":41.343637},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-76.217705,\"lat\":43.106456},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-6.0414184,\"lat\":52.9802376},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-120.834972,\"lat\":44.2998261},{\"lng\":0.1034297,\"lat\":51.4340208},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":58.2058419,\"lat\":23.65478},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-72.2268141,\"lat\":42.594001},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.2289491,\"lat\":40.7264091},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.3957425,\"lat\":51.6553875},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.1573695,\"lat\":48.8897044},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":14.4745958,\"lat\":50.2471333},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-1.0503893,\"lat\":45.6938702},{\"lng\":-111.7386884,\"lat\":40.3640349},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-122.1702293,\"lat\":47.1870191},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":-76.2835569,\"lat\":40.7914769},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.147899,\"lat\":43.9277552},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.5387318,\"lat\":38.5961694},{\"lng\":-84.5810418,\"lat\":33.5670562},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.2765366,\"lat\":40.8398218},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-86.6497378,\"lat\":35.741808},{\"lng\":-74.0326395,\"lat\":40.9912087},{\"lng\":-88.9939147,\"lat\":40.4797828},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":9.0804584,\"lat\":52.1873798},{\"lng\":7.1612669,\"lat\":46.8055656},{\"lng\":-119.951909,\"lat\":39.2501246},{\"lng\":-75.7032742,\"lat\":40.0064958},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":0.4040065,\"lat\":43.5148029},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-83.1596108,\"lat\":40.033814},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-116.9739167,\"lat\":32.8383828},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":-119.119919,\"lat\":46.2087066},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-96.9756323,\"lat\":33.3142085},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-84.1457505,\"lat\":33.8062166},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-83.6156648,\"lat\":42.511726},{\"lng\":27.6781839,\"lat\":62.8924601},{\"lng\":-83.1446485,\"lat\":42.4894801},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-80.44868,\"lat\":41.2333897},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-69.7193802,\"lat\":44.7650773},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-119.8276389,\"lat\":34.4358295},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-70.8378746,\"lat\":42.9417199},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.0618702,\"lat\":37.9020731},{\"lng\":0.1481142,\"lat\":51.5413271},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":4.3668279,\"lat\":50.8331141},{\"lng\":-121.9877444,\"lat\":38.3565773},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":-71.5120096,\"lat\":42.5375917},{\"lng\":-118.117191,\"lat\":33.8503463},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.7050318,\"lat\":52.6019248},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-80.206436,\"lat\":26.2445263},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-86.1807031,\"lat\":41.6611642},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-0.75596,\"lat\":51.6317449},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-95.2621553,\"lat\":29.9988312},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-117.9389526,\"lat\":34.0686208},{\"lng\":-9.3745601,\"lat\":39.1192213},{\"lng\":4.8855966,\"lat\":45.6977109},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.0176904,\"lat\":33.6676103},{\"lng\":-104.937199,\"lat\":40.0991506},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-97.6788056,\"lat\":30.5085915},{\"lng\":-0.474739,\"lat\":44.812928},{\"lng\":-107.2112407,\"lat\":39.4005647},{\"lng\":0.300103,\"lat\":51.3962097},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-67.8854173,\"lat\":45.3283923},{\"lng\":-87.1250154,\"lat\":39.523652},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.4127848,\"lat\":43.4511819},{\"lng\":0.7056174,\"lat\":51.5838691},{\"lng\":-4.7887547,\"lat\":55.6332429},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.2779715,\"lat\":51.6714842},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-78.9284241,\"lat\":39.6583325},{\"lng\":-70.2529189,\"lat\":43.6382443},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-7.2662964,\"lat\":40.5378408},{\"lng\":-71.4586114,\"lat\":41.6992717},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":-122.3873133,\"lat\":45.5392862},{\"lng\":2.7932391,\"lat\":41.6756178},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-106.6329806,\"lat\":35.2702448},{\"lng\":6.4627333,\"lat\":43.5374662},{\"lng\":-71.0542002,\"lat\":42.4085897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-72.9401357,\"lat\":40.879243},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.7038708,\"lat\":44.5014007},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-98.2300605,\"lat\":26.204114},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-74.6893282,\"lat\":41.6556465},{\"lng\":-112.3681428,\"lat\":33.629247},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-101.8470215,\"lat\":33.5855677},{\"lng\":-103.799951,\"lat\":40.2502582},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":16.4399659,\"lat\":43.5116383},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.0812467,\"lat\":46.1444789},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":130.4699924,\"lat\":33.5326401},{\"lng\":-84.5496148,\"lat\":33.9528472},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":1.5332389,\"lat\":45.1584982},{\"lng\":-96.900362,\"lat\":46.874967},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-89.953157,\"lat\":38.8114364},{\"lng\":-81.8020722,\"lat\":24.5548262},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.1282572,\"lat\":44.0537103},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-117.9056046,\"lat\":34.1338751},{\"lng\":2.3019814,\"lat\":48.8211559},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-1.7271466,\"lat\":47.2115054},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-87.7332823,\"lat\":34.5042652},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-75.6621294,\"lat\":41.4086874},{\"lng\":-116.0833144,\"lat\":34.8253019},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.2433113,\"lat\":49.0699667},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.7767859,\"lat\":46.4990505},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-1.7937675,\"lat\":48.1006715},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9414313,\"lat\":37.270973},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-118.2478471,\"lat\":34.1469416},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-120.310349,\"lat\":47.4234599},{\"lng\":-118.4492148,\"lat\":34.3076252},{\"lng\":-40.4984617,\"lat\":-20.6718755},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-121.838579,\"lat\":37.2978434},{\"lng\":45.4254332,\"lat\":35.5630567},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-95.1846301,\"lat\":30.0497077},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-86.2283864,\"lat\":43.0630734},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-85.9744569,\"lat\":42.1080979},{\"lng\":-82.5748194,\"lat\":27.4989278},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":-87.8114044,\"lat\":42.0700662},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3510264,\"lat\":28.5977707},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-1.0677602,\"lat\":50.8221133},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":10.2724617,\"lat\":36.767891},{\"lng\":-96.8238183,\"lat\":33.1505998},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":-86.9300023,\"lat\":35.751179},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3197111,\"lat\":48.9891693},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-87.0717718,\"lat\":20.6269889},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":-83.6117646,\"lat\":42.241051},{\"lng\":-96.9034244,\"lat\":32.9515472},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.4258354,\"lat\":48.9351403},{\"lng\":-88.4493796,\"lat\":43.7533414},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-71.1425197,\"lat\":42.8910542},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-111.133224,\"lat\":39.0935829},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":-75.8940505,\"lat\":45.3128048},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.765164,\"lat\":43.617944},{\"lng\":-80.1762704,\"lat\":33.0186699},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-93.9332302,\"lat\":29.8716577},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.1956331,\"lat\":39.0180508},{\"lng\":-80.4677741,\"lat\":25.091338},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-96.3455991,\"lat\":30.6183939},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.83511,\"lat\":41.3144733},{\"lng\":-122.1389548,\"lat\":48.1810957},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-118.1167679,\"lat\":33.8825705},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-81.2839038,\"lat\":28.2498534},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.8996261,\"lat\":29.690292},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.0921,\"lat\":46.2306739},{\"lng\":-74.2289491,\"lat\":40.7264091},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":-156.5089398,\"lat\":20.8894684},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-94.7685084,\"lat\":36.5898616},{\"lng\":-84.1401926,\"lat\":34.2073196},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-124.054331,\"lat\":46.35232},{\"lng\":10.5038864,\"lat\":60.8721617},{\"lng\":-87.8871505,\"lat\":42.9818858},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-77.5645607,\"lat\":39.1154506},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":114.6280794,\"lat\":38.6458703},{\"lng\":9.053596,\"lat\":48.5203263},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":2.5096751,\"lat\":49.0449139},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-118.226624,\"lat\":33.894927},{\"lng\":44.507897,\"lat\":40.1553328},{\"lng\":-93.6170448,\"lat\":42.0267567},{\"lng\":118.7788631,\"lat\":32.0438284},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-117.0814849,\"lat\":33.1216751},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-86.1283681,\"lat\":39.9784186},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-2.9163053,\"lat\":47.7422676},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.1730571,\"lat\":48.7995951},{\"lng\":3.2131307,\"lat\":43.3426562},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":2.1868998,\"lat\":48.9229416},{\"lng\":-122.5246791,\"lat\":47.6515096},{\"lng\":-71.0767724,\"lat\":42.7777829},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-73.0568716,\"lat\":43.176909},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":-79.9559437,\"lat\":39.6296809},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-79.7093339,\"lat\":40.3301738},{\"lng\":-74.9290536,\"lat\":39.7912262},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-82.8121191,\"lat\":39.9547861},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-68.2043361,\"lat\":44.3876378},{\"lng\":7.1186671,\"lat\":50.5444551},{\"lng\":-106.6329806,\"lat\":35.2702448},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-3.3660907,\"lat\":47.7477336},{\"lng\":2.5076601,\"lat\":48.8406252},{\"lng\":-96.789821,\"lat\":46.877229},{\"lng\":-71.4547891,\"lat\":42.9956397},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-85.2559398,\"lat\":34.0124425},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":100.4230508,\"lat\":13.7803993},{\"lng\":-92.3892966,\"lat\":43.6870098},{\"lng\":-85.5872286,\"lat\":42.291707},{\"lng\":-122.6246836,\"lat\":47.5653663},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.4875797,\"lat\":50.9025623},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":106.6246178,\"lat\":26.6499922},{\"lng\":-95.2864299,\"lat\":29.5639758},{\"lng\":-101.5437395,\"lat\":40.850206},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":-1.5749324,\"lat\":49.3015127},{\"lng\":36.828842,\"lat\":-1.3026148},{\"lng\":-97.4033191,\"lat\":27.7635302},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-74.2295891,\"lat\":40.41483},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-93.6170448,\"lat\":42.0267567},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-80.6520161,\"lat\":41.1035786},{\"lng\":5.5518002,\"lat\":52.0232041},{\"lng\":-96.9146374,\"lat\":19.5408338},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":0.0212014,\"lat\":51.6085806},{\"lng\":4.3627245,\"lat\":51.9994572},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":0.7184407,\"lat\":45.1909365},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":-75.8936803,\"lat\":41.1423516},{\"lng\":43.0997156,\"lat\":36.343694},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":108.3627211,\"lat\":22.8193063},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-73.7458456,\"lat\":42.7436134},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":0.0887195,\"lat\":51.3736037},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.4818087,\"lat\":48.6137734},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.2519175,\"lat\":27.197983},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-97.6960599,\"lat\":26.1907543},{\"lng\":-73.6917878,\"lat\":42.7284117},{\"lng\":7.1513834,\"lat\":43.6612012},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-117.8617337,\"lat\":33.8714814},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":4.4270852,\"lat\":50.8171712},{\"lng\":6.8727506,\"lat\":45.9246705},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":126.9697994,\"lat\":37.5534363},{\"lng\":-80.1353006,\"lat\":25.7929198},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-89.6953656,\"lat\":41.788253},{\"lng\":110.1956502,\"lat\":20.0462328},{\"lng\":-117.9463717,\"lat\":33.7746292},{\"lng\":-77.775644,\"lat\":38.585005},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.5770621,\"lat\":44.3747245},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-79.6847703,\"lat\":40.6739543},{\"lng\":-0.7761489,\"lat\":44.8405364},{\"lng\":-71.1143838,\"lat\":42.3116046},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":14.4383082,\"lat\":35.9141259},{\"lng\":-123.191303,\"lat\":44.8560029},{\"lng\":-87.6305899,\"lat\":46.4481521},{\"lng\":-72.554088,\"lat\":41.8430824},{\"lng\":-71.4378411,\"lat\":42.5792583},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-9.3136189,\"lat\":38.8700189},{\"lng\":-156.3103925,\"lat\":20.8539162},{\"lng\":4.750318,\"lat\":44.5579391},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.0241621,\"lat\":42.6289247},{\"lng\":2.0100492,\"lat\":41.5629623},{\"lng\":-94.6851702,\"lat\":38.9742502},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":108.9423363,\"lat\":34.261004},{\"lng\":-76.4283781,\"lat\":44.3054151},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.2255727,\"lat\":48.8709053},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":2.0388736,\"lat\":49.0527528},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-89.0226793,\"lat\":42.6829765},{\"lng\":-82.902901,\"lat\":42.6741189},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":12.0595795,\"lat\":47.8556623},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6414898,\"lat\":48.1817122},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-70.2177099,\"lat\":44.0990717},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":103.733224,\"lat\":36.474436},{\"lng\":-74.6310081,\"lat\":41.0401567},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-68.0116807,\"lat\":46.8606301},{\"lng\":6.5143539,\"lat\":51.1902651},{\"lng\":-121.420139,\"lat\":37.7385507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.611116,\"lat\":51.7052231},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.147899,\"lat\":43.9277552},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-80.0387292,\"lat\":32.9961038},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-122.0832101,\"lat\":37.3893889},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.1020957,\"lat\":47.8101008},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-3.1583936,\"lat\":47.8340055},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.5368567,\"lat\":51.8566651},{\"lng\":-122.8913181,\"lat\":45.5315957},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.2050856,\"lat\":31.5059105},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-75.1438863,\"lat\":39.770683},{\"lng\":-122.808078,\"lat\":50.3203804},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":4.6395008,\"lat\":45.6815791},{\"lng\":-91.2228203,\"lat\":44.5772777},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-85.8591285,\"lat\":37.693952},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":119.0029034,\"lat\":25.4557366},{\"lng\":4.635647,\"lat\":51.8438893},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-82.9824019,\"lat\":39.3331197},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7977048,\"lat\":33.2371585},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-94.1885387,\"lat\":35.9242477},{\"lng\":-97.2271249,\"lat\":32.9299655},{\"lng\":104.063315,\"lat\":30.659867},{\"lng\":-99.3311525,\"lat\":38.8709984},{\"lng\":-0.453256,\"lat\":51.532563},{\"lng\":7.3260346,\"lat\":48.1437763},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":15.2151181,\"lat\":59.2747287},{\"lng\":-77.3859479,\"lat\":38.9695316},{\"lng\":7.05859,\"lat\":43.5761001},{\"lng\":-111.9866954,\"lat\":40.6967891},{\"lng\":-82.3269883,\"lat\":27.871197},{\"lng\":-85.9529685,\"lat\":42.9903205},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.3724593,\"lat\":35.613224},{\"lng\":-75.3786521,\"lat\":40.6178915},{\"lng\":-123.7080446,\"lat\":48.7786872},{\"lng\":-8.4726423,\"lat\":51.8985136},{\"lng\":-76.6480219,\"lat\":39.0595542},{\"lng\":-88.3053525,\"lat\":41.8875281},{\"lng\":120.6212881,\"lat\":31.311123},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":13.1929449,\"lat\":55.7029296},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":1.3336126,\"lat\":49.1605604},{\"lng\":-76.3056707,\"lat\":40.0379958},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":123.4279105,\"lat\":41.8026095},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-1.7003017,\"lat\":43.3624715},{\"lng\":-2.6474422,\"lat\":47.6350664},{\"lng\":10.3952118,\"lat\":63.4304475},{\"lng\":-80.2331038,\"lat\":26.0628665},{\"lng\":7.4892974,\"lat\":9.0643305},{\"lng\":6.6448413,\"lat\":45.8949213},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":115.348216,\"lat\":25.703866},{\"lng\":-81.7832912,\"lat\":32.4490141},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":11.005345,\"lat\":43.3412507},{\"lng\":4.4304463,\"lat\":46.8078372},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.0785177,\"lat\":47.2596224},{\"lng\":-119.180381,\"lat\":34.1976308},{\"lng\":-77.50741,\"lat\":18.0431254},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-79.6901302,\"lat\":44.3893208},{\"lng\":-71.1908924,\"lat\":42.7262016},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-0.8138335,\"lat\":49.0982623},{\"lng\":-94.282265,\"lat\":39.017316},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-1.0990407,\"lat\":53.785097},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-92.4056858,\"lat\":34.856613},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-106.0465486,\"lat\":39.4829124},{\"lng\":112.5666191,\"lat\":26.8971308},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-81.0161686,\"lat\":35.2976298},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-94.6332768,\"lat\":38.9914109},{\"lng\":-82.8364111,\"lat\":34.6850749},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":114.051111,\"lat\":35.308611},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.1319296,\"lat\":39.977763},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8201338,\"lat\":41.0550969},{\"lng\":35.3252861,\"lat\":36.9863599},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.187578,\"lat\":43.8009132},{\"lng\":-82.9651045,\"lat\":40.2317686},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":121.4511111,\"lat\":31.2515439},{\"lng\":-0.5435655,\"lat\":43.8668219},{\"lng\":-96.0422378,\"lat\":41.1544433},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":2.6389115,\"lat\":50.5309351},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-117.3703235,\"lat\":34.1064001},{\"lng\":-79.5656326,\"lat\":43.6435559},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":113.8951222,\"lat\":29.72817},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-118.5174342,\"lat\":34.2661558},{\"lng\":-88.3525714,\"lat\":41.6834778},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":113.619321,\"lat\":34.7472531},{\"lng\":7.8169251,\"lat\":52.2217481},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":3.620686,\"lat\":49.564665},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":7.6875628,\"lat\":49.6035639},{\"lng\":-118.3963062,\"lat\":34.0696501},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":9.8913283,\"lat\":56.8383525},{\"lng\":-84.2032767,\"lat\":40.0394982},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-80.7440174,\"lat\":34.9248125},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":9.5495141,\"lat\":56.169453},{\"lng\":-72.6713448,\"lat\":41.707785},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":-88.083406,\"lat\":42.0333608},{\"lng\":135.5014539,\"lat\":34.6937569},{\"lng\":-117.953097,\"lat\":34.0280619},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":-122.403277,\"lat\":45.5863014},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":117.1913008,\"lat\":39.1175488},{\"lng\":-1.9483083,\"lat\":52.0940158},{\"lng\":2.3275141,\"lat\":48.9756423},{\"lng\":-71.3495035,\"lat\":42.5292605},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":-83.1446485,\"lat\":42.4894801},{\"lng\":0.6176112,\"lat\":44.2015827},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":-0.3394758,\"lat\":53.7435722},{\"lng\":-79.2576479,\"lat\":43.7729744},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-1.37342,\"lat\":43.65801},{\"lng\":2.2144942,\"lat\":43.3105303},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.1320819,\"lat\":43.63233},{\"lng\":-86.8689419,\"lat\":35.925206},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-74.2905713,\"lat\":41.0053413},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":166.442419,\"lat\":-22.2745264},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":123.4279105,\"lat\":41.8026095},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-72.859545,\"lat\":41.3909305},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":113.2592945,\"lat\":23.1301964},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-93.21772,\"lat\":44.7319094},{\"lng\":6.9478263,\"lat\":46.252844},{\"lng\":-87.8873916,\"lat\":42.0415823},{\"lng\":-82.6995444,\"lat\":27.8428025},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-79.3079337,\"lat\":34.4987347},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-0.6300671,\"lat\":45.7460663},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-79.8625851,\"lat\":32.7940651},{\"lng\":-75.0688604,\"lat\":39.841417},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-84.1556809,\"lat\":31.5782062},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-83.3763219,\"lat\":42.4644795},{\"lng\":-122.636465,\"lat\":38.2325829},{\"lng\":-118.1374663,\"lat\":34.1928193},{\"lng\":7.0191865,\"lat\":43.5761076},{\"lng\":12.3652209,\"lat\":55.7303911},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-9.0701572,\"lat\":39.6029108},{\"lng\":-5.3893743,\"lat\":37.7807467},{\"lng\":-71.3137707,\"lat\":41.4899827},{\"lng\":113.2592945,\"lat\":23.1301964},{\"lng\":-85.9491298,\"lat\":37.8403456},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.665452,\"lat\":40.904011},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-74.6809503,\"lat\":40.6741476},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.2766735,\"lat\":48.730158},{\"lng\":-8.6058415,\"lat\":41.1300103},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-88.0670118,\"lat\":41.8775293},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-82.2327525,\"lat\":27.9378338},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-72.6786035,\"lat\":42.0671708},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-81.0228331,\"lat\":29.2108147},{\"lng\":15.0947756,\"lat\":47.3805128},{\"lng\":-117.8659441,\"lat\":34.0203253},{\"lng\":-71.9785356,\"lat\":-13.5170887},{\"lng\":1.4196476,\"lat\":51.3334726},{\"lng\":-87.668889,\"lat\":20.596667},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":-94.6332768,\"lat\":38.9914109},{\"lng\":6.1301614,\"lat\":43.1202573},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":-87.9517842,\"lat\":43.3195224},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-80.5495112,\"lat\":34.9854275},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":2.1386946,\"lat\":47.9272265},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-80.0721599,\"lat\":-0.3828099},{\"lng\":-82.6715845,\"lat\":42.7525317},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.3053525,\"lat\":41.8875281},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-90.5643258,\"lat\":38.661953},{\"lng\":-1.1626569,\"lat\":52.2578681},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":0.0930414,\"lat\":50.9705836},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-82.3534728,\"lat\":36.3134398},{\"lng\":-2.7856762,\"lat\":51.3142922},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-91.1869659,\"lat\":30.4494155},{\"lng\":-73.1062025,\"lat\":43.9733602},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":5.6969882,\"lat\":50.8579855},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.3633048,\"lat\":48.7921098},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-69.790649,\"lat\":44.713074},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":4.8096049,\"lat\":45.7292173},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.4083096,\"lat\":39.003685},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1641314,\"lat\":48.7119046},{\"lng\":0.1481142,\"lat\":51.5413271},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-79.7919754,\"lat\":36.0726355},{\"lng\":-3.3793614,\"lat\":52.2405222},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":6.4779448,\"lat\":46.3731303},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":2.1347291,\"lat\":48.894254},{\"lng\":-0.941684,\"lat\":48.9963184},{\"lng\":-71.5785924,\"lat\":42.6650324},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-61.4096021,\"lat\":10.51591},{\"lng\":-35.2080905,\"lat\":-5.805398},{\"lng\":-73.993889,\"lat\":40.7652778},{\"lng\":-0.34118,\"lat\":45.10735},{\"lng\":-74.3673748,\"lat\":41.1312069},{\"lng\":-97.1474628,\"lat\":31.5491899},{\"lng\":0.0949036,\"lat\":51.7685568},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":14.5929127,\"lat\":53.4296809},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-88.7033859,\"lat\":34.2576067},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-90.0750949,\"lat\":36.4933927},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-104.9092844,\"lat\":40.3350303},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-71.0931485,\"lat\":41.9019257},{\"lng\":-92.9339449,\"lat\":44.919896},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-85.8902547,\"lat\":38.9592201},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-92.9339449,\"lat\":44.919896},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":2.7015872,\"lat\":48.4049375},{\"lng\":-122.1238767,\"lat\":47.6694141},{\"lng\":-92.2896267,\"lat\":34.7465071},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.9724787,\"lat\":34.72425},{\"lng\":-123.2077861,\"lat\":39.1501662},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.1929215,\"lat\":39.1399187},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.2084941,\"lat\":28.6702526},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-118.0014517,\"lat\":34.1483499},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-0.500972,\"lat\":43.8911318},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":8.1044149,\"lat\":50.0220051},{\"lng\":-0.6300671,\"lat\":45.7460663},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-77.4083096,\"lat\":39.003685},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-121.8746789,\"lat\":37.6624312},{\"lng\":-79.8728583,\"lat\":43.2560802},{\"lng\":-88.8893818,\"lat\":30.4007626},{\"lng\":-105.938456,\"lat\":35.6876096},{\"lng\":-86.4691677,\"lat\":40.0483744},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-78.762383,\"lat\":39.6526498},{\"lng\":7.6251879,\"lat\":51.9625101},{\"lng\":-71.71351,\"lat\":42.2960187},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":0.2450626,\"lat\":46.6852065},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.289259,\"lat\":48.8212037},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-117.9463717,\"lat\":33.7746292},{\"lng\":0.493541,\"lat\":46.5545812},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":55.4776174,\"lat\":-21.341298},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":4.10473,\"lat\":45.5125},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-71.4378411,\"lat\":42.5792583},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.1464895,\"lat\":45.5366795},{\"lng\":2.9580234,\"lat\":48.8239829},{\"lng\":-104.8769227,\"lat\":39.579155},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-83.2320991,\"lat\":33.0801429},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":-84.5930113,\"lat\":35.4428864},{\"lng\":-77.1516844,\"lat\":39.0817985},{\"lng\":-78.7812081,\"lat\":35.7882893},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-90.1997949,\"lat\":38.4428078},{\"lng\":-74.5746001,\"lat\":39.2776156},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-74.9619779,\"lat\":39.8512162},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":1.8320589,\"lat\":46.7422328},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.0584474,\"lat\":39.1803067},{\"lng\":-96.8238183,\"lat\":33.1505998},{\"lng\":-81.345941,\"lat\":41.239223},{\"lng\":2.4455201,\"lat\":48.9229803},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8590006,\"lat\":35.481705},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":-3.000425,\"lat\":51.5887675},{\"lng\":-87.8892189,\"lat\":41.5261437},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":-112.120834,\"lat\":46.236595},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.3480592,\"lat\":36.1459327},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":-111.9395211,\"lat\":40.6061337},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":5.7711166,\"lat\":50.9503183},{\"lng\":-84.8491126,\"lat\":36.8297937},{\"lng\":-84.0193858,\"lat\":39.8208998},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-77.1549078,\"lat\":39.3765918},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-86.190272,\"lat\":40.5789277},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-71.3352393,\"lat\":41.7424526},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-86.1095429,\"lat\":39.6136987},{\"lng\":-77.0952516,\"lat\":43.0467301},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.4429592,\"lat\":43.6797334},{\"lng\":-116.559631,\"lat\":43.5737361},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.072557,\"lat\":38.1495947},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":-71.9698085,\"lat\":42.1340806},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-75.7263008,\"lat\":40.2578714},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-81.3510264,\"lat\":28.5977707},{\"lng\":-85.9529685,\"lat\":42.9903205},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-105.220306,\"lat\":20.6407176},{\"lng\":-115.3481135,\"lat\":51.0866897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-121.768053,\"lat\":37.6820583},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-121.8746789,\"lat\":37.6624312},{\"lng\":-81.0726108,\"lat\":32.2802665},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-75.0254256,\"lat\":39.4862777},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3275141,\"lat\":48.9756423},{\"lng\":-86.2910945,\"lat\":36.2079779},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-111.9866954,\"lat\":40.6967891},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-147.716675,\"lat\":64.837845},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.3821295,\"lat\":38.9107156},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-1.7888095,\"lat\":43.3383176},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":3.2501874,\"lat\":45.5432962},{\"lng\":-88.3303618,\"lat\":42.1816908},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0011096,\"lat\":41.2411556},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":1.2611389,\"lat\":44.6806047},{\"lng\":-89.7811745,\"lat\":30.2751945},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-77.2676335,\"lat\":38.636447},{\"lng\":-87.8839693,\"lat\":41.1639309},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":-108.56448,\"lat\":39.0672568},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.618842,\"lat\":30.4057552},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-83.606568,\"lat\":32.6200973},{\"lng\":-121.420139,\"lat\":37.7385507},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-93.8512052,\"lat\":41.6322562},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":54.3774014,\"lat\":24.4538352},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-73.5898872,\"lat\":40.7157545},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-95.4366206,\"lat\":42.7125676},{\"lng\":-84.6266111,\"lat\":38.9989499},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-71.5159565,\"lat\":-32.9220036},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":2.3570028,\"lat\":48.8125893},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-88.5408574,\"lat\":44.0206919},{\"lng\":-121.4016604,\"lat\":38.3780978},{\"lng\":-87.9138911,\"lat\":33.9675458},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":-104.7091322,\"lat\":40.4233142},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-83.7319658,\"lat\":32.4586695},{\"lng\":0.0581,\"lat\":43.1973846},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-94.992736,\"lat\":29.3872254},{\"lng\":39.1742363,\"lat\":21.5504432},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-83.1933893,\"lat\":37.2489635},{\"lng\":2.1802832,\"lat\":48.87778},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":120.9803621,\"lat\":14.5904492},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":57.4800061,\"lat\":-20.2643015},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-79.6443879,\"lat\":43.5896231},{\"lng\":-73.6788272,\"lat\":41.4266361},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":17.6486876,\"lat\":47.7529429},{\"lng\":-57.6190998,\"lat\":-25.3172629},{\"lng\":-116.4139839,\"lat\":34.1236205},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-74.9869191,\"lat\":39.688691},{\"lng\":-84.7668495,\"lat\":43.597646},{\"lng\":-122.1703055,\"lat\":37.4265407},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-83.2732627,\"lat\":42.3369816},{\"lng\":-117.8984565,\"lat\":34.0142641},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-104.297186,\"lat\":39.0355459},{\"lng\":-73.2987663,\"lat\":40.7064515},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.7618592,\"lat\":41.9426657},{\"lng\":-89.5844457,\"lat\":44.5234467},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":101.6454202,\"lat\":3.0988792},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-71.3085329,\"lat\":42.6414437},{\"lng\":-83.5363637,\"lat\":42.5246873},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-119.8276389,\"lat\":34.4358295},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-93.8399077,\"lat\":30.0294356},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-96.9458791,\"lat\":43.6225937},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-1.7503658,\"lat\":54.9220987},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-0.3311238,\"lat\":51.5714876},{\"lng\":-71.3517602,\"lat\":42.5968617},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-74.2737573,\"lat\":40.2601096},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.1894241,\"lat\":48.8279362},{\"lng\":-122.670649,\"lat\":45.4206749},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-101.0425231,\"lat\":42.0429412},{\"lng\":-123.1059324,\"lat\":44.6365071},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.9700664,\"lat\":51.4564242},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-87.8715185,\"lat\":41.9348693},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":2.510611,\"lat\":48.8137847},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-69.6178847,\"lat\":44.0800341},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-118.0338664,\"lat\":33.9749136},{\"lng\":-75.7515682,\"lat\":39.6828358},{\"lng\":2.0817809,\"lat\":41.4728432},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-118.0107092,\"lat\":33.9060971},{\"lng\":-120.7678602,\"lat\":37.1641544},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":106.8838584,\"lat\":47.9081991},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-86.6702816,\"lat\":39.6878242},{\"lng\":-79.7881025,\"lat\":40.4211798},{\"lng\":-73.2858994,\"lat\":40.8393515},{\"lng\":-81.440667,\"lat\":41.240056},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-69.790649,\"lat\":44.713074},{\"lng\":6.2364886,\"lat\":52.2694896},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-79.7567616,\"lat\":43.2167526},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.9939147,\"lat\":40.4797828},{\"lng\":-82.5164242,\"lat\":35.4661821},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-59.6184184,\"lat\":13.0977832},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-76.3056707,\"lat\":40.0379958},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-84.7477136,\"lat\":33.7514966},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.3442915,\"lat\":35.7333312},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":50.1039991,\"lat\":26.4367824},{\"lng\":-108.56448,\"lat\":39.0672568},{\"lng\":-83.241357,\"lat\":42.5226219},{\"lng\":0.1967849,\"lat\":48.0073849},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":7.0134418,\"lat\":43.5515198},{\"lng\":-118.307201,\"lat\":34.1812089},{\"lng\":-76.2899539,\"lat\":36.8493695},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":27.4962548,\"lat\":38.4549686},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.3269883,\"lat\":27.871197},{\"lng\":12.2999286,\"lat\":55.5833746},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-97.9907362,\"lat\":26.1594305},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":-122.2301808,\"lat\":47.3075369},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-82.2773629,\"lat\":37.6742682},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-123.2620435,\"lat\":44.5645659},{\"lng\":-94.3821295,\"lat\":38.9107156},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-87.9414608,\"lat\":42.0087978},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-68.7621574,\"lat\":44.7967947},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-96.900362,\"lat\":46.874967},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":-81.3442915,\"lat\":35.7333312},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.0532942,\"lat\":26.715364},{\"lng\":-117.1827445,\"lat\":34.0550328},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-74.9999754,\"lat\":40.0166151},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.1450735,\"lat\":41.9994722},{\"lng\":-79.3314725,\"lat\":42.4400476},{\"lng\":19.9971534,\"lat\":50.0469432},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-78.8505516,\"lat\":35.7325352},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-97.0585717,\"lat\":36.1156306},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.4832339,\"lat\":42.4310816},{\"lng\":-84.6433146,\"lat\":42.7269261},{\"lng\":-77.1890783,\"lat\":40.201499},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":-70.0758508,\"lat\":41.6862224},{\"lng\":-80.6070391,\"lat\":34.2464886},{\"lng\":-0.3379675,\"lat\":51.753051},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-72.9771002,\"lat\":43.4717502},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-117.3008784,\"lat\":34.4263886},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-122.768761,\"lat\":45.4853207},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":2.2176533,\"lat\":43.0538068},{\"lng\":-96.6388833,\"lat\":32.912624},{\"lng\":-76.6148148,\"lat\":39.3964591},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-89.004141,\"lat\":42.2467221},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":-84.5501874,\"lat\":39.2085354},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-72.9401357,\"lat\":40.879243},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-70.545273,\"lat\":43.384092},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-78.696697,\"lat\":43.0183913},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-94.6557914,\"lat\":39.0277832},{\"lng\":-122.2070775,\"lat\":47.6765382},{\"lng\":-117.8617337,\"lat\":33.8714814},{\"lng\":-70.7055941,\"lat\":42.091769},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-97.5861393,\"lat\":33.2342834},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-90.3227803,\"lat\":38.7919683},{\"lng\":9.9884451,\"lat\":54.0703296},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-84.6332986,\"lat\":40.1023909},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.3465081,\"lat\":37.5131191},{\"lng\":-118.2478471,\"lat\":34.1469416},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.0388736,\"lat\":49.0527528},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-83.7788283,\"lat\":41.888936},{\"lng\":-82.0394286,\"lat\":28.865286},{\"lng\":-74.4439254,\"lat\":40.4951365},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-88.1170784,\"lat\":43.1790768},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":-159.3191601,\"lat\":22.0747334},{\"lng\":-104.7612638,\"lat\":39.5184514},{\"lng\":-122.5449763,\"lat\":37.9060368},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-71.0767724,\"lat\":42.7777829},{\"lng\":-90.2417806,\"lat\":29.9942265},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-83.8979573,\"lat\":33.9887165},{\"lng\":-49.0658025,\"lat\":-26.9195567},{\"lng\":3.97492,\"lat\":44.3041},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-72.7553916,\"lat\":40.809848},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5420246,\"lat\":41.0469042},{\"lng\":-97.4033191,\"lat\":27.7635302},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-66.05344,\"lat\":18.384239},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-115.121584,\"lat\":36.2005843},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.3965975,\"lat\":52.2048978},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-70.4429592,\"lat\":43.6797334},{\"lng\":-116.9814167,\"lat\":33.3033679},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":46.7160104,\"lat\":24.638916},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":-149.3863924,\"lat\":61.2700284},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-87.9414608,\"lat\":42.0087978},{\"lng\":-117.3272615,\"lat\":33.6680772},{\"lng\":-92.447758,\"lat\":42.5361805},{\"lng\":-85.4191482,\"lat\":41.799217},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-3.9459248,\"lat\":51.6195955},{\"lng\":-0.8868896,\"lat\":52.7645663},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-3.5269209,\"lat\":50.7256138},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":50.1039991,\"lat\":26.4367824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-103.338396,\"lat\":20.6720375},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-94.1288142,\"lat\":36.1867442},{\"lng\":-66.9146008,\"lat\":10.5060934},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":100.4869513,\"lat\":5.6435195},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-105.1319296,\"lat\":39.977763},{\"lng\":17.7959288,\"lat\":59.1653304},{\"lng\":-104.6158764,\"lat\":50.4479733},{\"lng\":-77.7928574,\"lat\":43.2881104},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":-92.116219,\"lat\":32.5025471},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-83.9293952,\"lat\":42.6072552},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-95.6349463,\"lat\":29.6196787},{\"lng\":-74.1979277,\"lat\":40.7934789},{\"lng\":-85.7057035,\"lat\":42.9132581},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.2006687,\"lat\":40.8559314},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-121.2880059,\"lat\":38.7521235},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.9580234,\"lat\":48.8239829},{\"lng\":-1.0714014,\"lat\":44.6360982},{\"lng\":-122.1598465,\"lat\":37.4443293},{\"lng\":5.862294,\"lat\":43.4522053},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-88.0934108,\"lat\":42.1969689},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-4.4239646,\"lat\":55.8455828},{\"lng\":-95.6349463,\"lat\":29.6196787},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":2.5034999,\"lat\":48.9082988},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-70.2529189,\"lat\":43.6382443},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-111.834914,\"lat\":41.7313063},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-81.4023356,\"lat\":40.875891},{\"lng\":2.2453842,\"lat\":48.7144587},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-77.0928401,\"lat\":42.6137794},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-71.407013,\"lat\":43.54805},{\"lng\":-90.3971021,\"lat\":45.6900818},{\"lng\":-97.0585717,\"lat\":36.1156306},{\"lng\":-86.5427551,\"lat\":33.5439212},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-82.2272119,\"lat\":34.9381361},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.3734547,\"lat\":40.6867667},{\"lng\":-57.6190998,\"lat\":-25.3172629},{\"lng\":-81.6851271,\"lat\":41.3139426},{\"lng\":5.8816763,\"lat\":51.626921},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-82.5817053,\"lat\":34.8269276},{\"lng\":9.0150026,\"lat\":48.8012983},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-3.2568304,\"lat\":54.0977012},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-111.111309,\"lat\":43.6025939},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-118.5978087,\"lat\":34.2011078},{\"lng\":-93.3356204,\"lat\":44.7779041},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-75.4712794,\"lat\":40.6022059},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":37.3792617,\"lat\":37.0628317},{\"lng\":-89.5150764,\"lat\":35.228976},{\"lng\":7.570077,\"lat\":47.53656},{\"lng\":12.3425797,\"lat\":45.5035386},{\"lng\":-76.7074042,\"lat\":37.2708788},{\"lng\":-120.375716,\"lat\":35.3540209},{\"lng\":-71.2661597,\"lat\":41.6770463},{\"lng\":-1.0815361,\"lat\":53.9590555},{\"lng\":-83.0302033,\"lat\":42.5803122},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-71.1143838,\"lat\":42.3116046},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.1956111,\"lat\":42.5048167},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-97.4033191,\"lat\":27.7635302},{\"lng\":-0.4440957,\"lat\":44.9954151},{\"lng\":-81.3578047,\"lat\":41.1513108},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-85.9529685,\"lat\":42.9903205},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-93.2349489,\"lat\":45.1607987},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":104.063315,\"lat\":30.659867},{\"lng\":-81.5231597,\"lat\":40.7965119},{\"lng\":5.303116,\"lat\":51.6889387},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.6010143,\"lat\":33.1384886},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":1.1528095,\"lat\":52.0579324},{\"lng\":-76.9274072,\"lat\":38.6023935},{\"lng\":-86.621443,\"lat\":36.3049177},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-81.6853534,\"lat\":28.8527675},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-79.6443879,\"lat\":43.5896231},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":1.09163,\"lat\":49.3831},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8423304,\"lat\":45.7969952},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.2680223,\"lat\":28.8117345},{\"lng\":46.7160104,\"lat\":24.638916},{\"lng\":-84.263826,\"lat\":39.2689476},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.6115586,\"lat\":43.1922408},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-70.4533844,\"lat\":43.4925843},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":-81.3035515,\"lat\":31.9382381},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":5.278244,\"lat\":45.111331},{\"lng\":0.487531,\"lat\":44.8534568},{\"lng\":-78.7997616,\"lat\":42.9783924},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-71.1755732,\"lat\":42.2489143},{\"lng\":-71.2360624,\"lat\":42.2802645},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":-70.2529189,\"lat\":43.6382443},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":12.5135924,\"lat\":55.6637755},{\"lng\":6.3676062,\"lat\":49.5442267},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-94.8907869,\"lat\":47.4785418},{\"lng\":-93.5663455,\"lat\":44.9032963},{\"lng\":-83.0302033,\"lat\":42.5803122},{\"lng\":-94.208787,\"lat\":36.3728608},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":9.3257408,\"lat\":54.7674684},{\"lng\":-77.5358049,\"lat\":35.8968236},{\"lng\":10.8523018,\"lat\":48.5455295},{\"lng\":-79.895197,\"lat\":40.86108},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":-73.5876273,\"lat\":40.7556561},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-105.089705,\"lat\":39.9935959},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":6.1096409,\"lat\":46.2567057},{\"lng\":10.7604024,\"lat\":34.7394361},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-92.5659635,\"lat\":38.628683},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.6132377,\"lat\":-33.5808615},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":41.1277565,\"lat\":37.8835738},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-78.7812081,\"lat\":35.7882893},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-75.6114584,\"lat\":38.6413452},{\"lng\":6.9459377,\"lat\":51.1008952},{\"lng\":-83.3601542,\"lat\":35.4350977},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-92.4364298,\"lat\":39.4201137},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":2.4093697,\"lat\":48.9379976},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-73.2435218,\"lat\":40.7276525},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-98.7075744,\"lat\":35.5261633},{\"lng\":-97.2085844,\"lat\":26.0734119},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":2.4283244,\"lat\":44.5206925},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.1244966,\"lat\":42.2912093},{\"lng\":-100.783739,\"lat\":46.808327},{\"lng\":-97.0585717,\"lat\":36.1156306},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-96.6925096,\"lat\":33.0136764},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-98.581341,\"lat\":33.1020053},{\"lng\":-54.6162947,\"lat\":-20.4640173},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-79.9047583,\"lat\":36.2087468},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-116.4139839,\"lat\":34.1236205},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-83.8240663,\"lat\":34.2978794},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":-88.9939147,\"lat\":40.4797828},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-75.1946649,\"lat\":40.9864261},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-0.1049747,\"lat\":50.9999616},{\"lng\":-114.0532996,\"lat\":35.1895921},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-122.3520327,\"lat\":48.24216},{\"lng\":-68.8446177,\"lat\":-32.8894155},{\"lng\":-95.5377215,\"lat\":29.6185669},{\"lng\":-80.0736533,\"lat\":36.1198589},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":-71.1408776,\"lat\":42.65717},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-64.8004265,\"lat\":46.0985679},{\"lng\":3.0041906,\"lat\":43.1837757},{\"lng\":-122.6065092,\"lat\":37.9526801},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":0.5824703,\"lat\":50.8553888},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-88.1834277,\"lat\":43.4252776},{\"lng\":-121.816926,\"lat\":36.62593},{\"lng\":-1.1305431,\"lat\":37.9923795},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":-74.6930393,\"lat\":41.133372},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-0.942439,\"lat\":48.6474693},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":0.5545405,\"lat\":51.5507054},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":43.0997156,\"lat\":36.343694},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-90.435999,\"lat\":38.7150511},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":7.2909824,\"lat\":52.6947452},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.2713568,\"lat\":48.7247641},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-80.0481488,\"lat\":32.7024009},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-77.2688875,\"lat\":38.7812445},{\"lng\":-88.0599986,\"lat\":44.4493584},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.5164242,\"lat\":35.4661821},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-77.4019268,\"lat\":37.227928},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.8408929,\"lat\":34.0218454},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-86.8647316,\"lat\":39.6444898},{\"lng\":-83.2646624,\"lat\":42.8247524},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-81.5116471,\"lat\":28.6732806},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-76.7870991,\"lat\":41.20484},{\"lng\":-81.9748429,\"lat\":33.4709714},{\"lng\":-90.1767012,\"lat\":30.0018546},{\"lng\":3.3941795,\"lat\":6.4550575},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.865235,\"lat\":42.870889},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-84.2747329,\"lat\":34.0709576},{\"lng\":-9.4204495,\"lat\":38.6968919},{\"lng\":-1.4852861,\"lat\":51.7838848},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.7753539,\"lat\":41.270178},{\"lng\":-2.8062224,\"lat\":47.6980235},{\"lng\":-88.3147539,\"lat\":41.7571701},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-95.0949303,\"lat\":29.5074538},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-120.339415,\"lat\":50.6758269},{\"lng\":0.340196,\"lat\":46.5802596},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.334267,\"lat\":48.911729},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-75.7515682,\"lat\":39.6828358},{\"lng\":8.626979,\"lat\":48.1678244},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-82.9651045,\"lat\":40.2317686},{\"lng\":-88.1784085,\"lat\":42.0255827},{\"lng\":-85.2099992,\"lat\":44.9754211},{\"lng\":-4.0000308,\"lat\":43.4306997},{\"lng\":0.262039,\"lat\":52.3990199},{\"lng\":-0.3379675,\"lat\":51.753051},{\"lng\":-95.677556,\"lat\":39.049011},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-84.6433146,\"lat\":42.7269261},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-96.9553675,\"lat\":32.5888072},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":6.5510623,\"lat\":43.6191015},{\"lng\":44.3872213,\"lat\":33.3061701},{\"lng\":-73.7812103,\"lat\":42.8631868},{\"lng\":-81.4190808,\"lat\":33.2641009},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-70.7719426,\"lat\":43.0120186},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.8628942,\"lat\":47.6379599},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-96.5388038,\"lat\":33.0151561},{\"lng\":-79.3916713,\"lat\":36.5879877},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":21.2636504,\"lat\":40.5216577},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.1763145,\"lat\":42.3222599},{\"lng\":-3.8287012,\"lat\":53.2811822},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.7204155,\"lat\":12.5375979},{\"lng\":-85.3865271,\"lat\":40.1936892},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-73.1715669,\"lat\":44.4671635},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-122.4614566,\"lat\":37.8770247},{\"lng\":6.6946573,\"lat\":45.5685467},{\"lng\":-70.927048,\"lat\":43.134564},{\"lng\":-122.2648674,\"lat\":48.0713855},{\"lng\":135.5014539,\"lat\":34.6937569},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-122.4788813,\"lat\":48.15336},{\"lng\":-91.5511429,\"lat\":35.9469741},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-122.6384056,\"lat\":47.5315625},{\"lng\":138.5710441,\"lat\":35.6652481},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":98.3891503,\"lat\":7.8847901},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.8544568,\"lat\":42.5269718},{\"lng\":-84.7477136,\"lat\":33.7514966},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-97.9883477,\"lat\":30.4601975},{\"lng\":-122.9146292,\"lat\":49.2041754},{\"lng\":0.3954774,\"lat\":52.7538673},{\"lng\":-82.9376919,\"lat\":41.5119954},{\"lng\":2.1868998,\"lat\":48.9229416},{\"lng\":-99.2382245,\"lat\":19.3607174},{\"lng\":10.3952118,\"lat\":63.4304475},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":-119.700583,\"lat\":45.839855},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-82.0350598,\"lat\":41.4516512},{\"lng\":-82.756907,\"lat\":28.0856815},{\"lng\":-100.3917424,\"lat\":20.5922997},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-91.1869659,\"lat\":30.4494155},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-99.0233759,\"lat\":19.1916095},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":-74.9869191,\"lat\":39.688691},{\"lng\":4.2974524,\"lat\":45.793226},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":-79.1226768,\"lat\":44.1088502},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":2.0426301,\"lat\":48.9274192},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-81.3885899,\"lat\":28.6619154},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-82.3984882,\"lat\":34.851354},{\"lng\":-86.2483921,\"lat\":43.2341813},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":120.9817861,\"lat\":14.4809012},{\"lng\":-0.3302184,\"lat\":50.8902203},{\"lng\":114.8782861,\"lat\":40.8171433},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.5798953,\"lat\":48.5958681},{\"lng\":-120.9968892,\"lat\":37.6393419},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.7928827,\"lat\":45.6950021},{\"lng\":-71.4547891,\"lat\":42.9956397},{\"lng\":-118.2005236,\"lat\":34.1998302},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":79.8542005,\"lat\":6.9388614},{\"lng\":-2.5429139,\"lat\":47.614847},{\"lng\":-75.3405529,\"lat\":40.5794426},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-121.3716178,\"lat\":38.4087993},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-84.0199108,\"lat\":33.857328},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":-76.0732254,\"lat\":39.5594191},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":4.9036535,\"lat\":36.6439022},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":4.44653,\"lat\":47.15274},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":73.0651511,\"lat\":33.6938118},{\"lng\":12.4573112,\"lat\":55.7583936},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-71.1631137,\"lat\":42.7070354},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-120.308938,\"lat\":46.3775015},{\"lng\":-71.0683741,\"lat\":42.4268484},{\"lng\":44.0332586,\"lat\":32.595759},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":3.4203712,\"lat\":46.1239268},{\"lng\":69.2877212,\"lat\":41.2932886},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-91.1869659,\"lat\":30.4494155},{\"lng\":-96.6353488,\"lat\":30.4764878},{\"lng\":7.8970717,\"lat\":50.4941653},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.0823355,\"lat\":49.4300997},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-117.5153511,\"lat\":33.9820864},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-99.1324941,\"lat\":19.2953782},{\"lng\":-84.5192192,\"lat\":34.1014112},{\"lng\":-81.4828123,\"lat\":41.1362729},{\"lng\":0.6176112,\"lat\":44.2015827},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-122.1768209,\"lat\":48.0517429},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":-122.0402399,\"lat\":37.5296593},{\"lng\":-1.1226397,\"lat\":46.8263148},{\"lng\":-83.711604,\"lat\":41.621718},{\"lng\":10.5593214,\"lat\":47.1405865},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":6.8592928,\"lat\":47.4616568},{\"lng\":-0.078521,\"lat\":51.7957409},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-60.7336808,\"lat\":-34.1977548},{\"lng\":13.8201171,\"lat\":55.4295203},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-41.8875267,\"lat\":-22.7597805},{\"lng\":-88.1050853,\"lat\":42.5775187},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":120.9724002,\"lat\":14.651348},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-80.3975399,\"lat\":27.6387163},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-65.7528911,\"lat\":44.6762173},{\"lng\":-76.492786,\"lat\":38.9786401},{\"lng\":-88.3303618,\"lat\":42.1816908},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":8.5253985,\"lat\":47.1951976},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":-117.084195,\"lat\":32.6400541},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":-100.315258,\"lat\":25.6802019},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.4549262,\"lat\":33.4487257},{\"lng\":2.1900052,\"lat\":48.7809496},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-112.8331033,\"lat\":49.6945782},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-87.8715185,\"lat\":41.9348693},{\"lng\":-109.546214,\"lat\":38.5738096},{\"lng\":5.1623805,\"lat\":48.7712673},{\"lng\":-122.7459664,\"lat\":45.9018496},{\"lng\":-6.9261131,\"lat\":52.8408344},{\"lng\":-82.4333742,\"lat\":42.9760854},{\"lng\":6.5680077,\"lat\":53.2190652},{\"lng\":-60.6617024,\"lat\":-32.9593609},{\"lng\":-95.3024351,\"lat\":29.9118897},{\"lng\":-7.9807002,\"lat\":40.2202451},{\"lng\":3.862452,\"lat\":43.6978777},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-95.4105347,\"lat\":39.8166687},{\"lng\":-0.1110147,\"lat\":47.222937},{\"lng\":-73.1118997,\"lat\":42.6990349},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.655037,\"lat\":36.6744117},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":2.8722456,\"lat\":48.7100369},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":153.4145987,\"lat\":-28.0023731},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-88.0717708,\"lat\":41.7003302},{\"lng\":-1.6044065,\"lat\":54.9617219},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-1.0150646,\"lat\":46.871379},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-74.3457623,\"lat\":43.0505021},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-70.7803543,\"lat\":42.6326501},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.3660907,\"lat\":47.7477336},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-90.1670585,\"lat\":38.657181},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-4.1024782,\"lat\":47.9960325},{\"lng\":-103.85937,\"lat\":44.490817},{\"lng\":-1.57027,\"lat\":55.1832364},{\"lng\":-9.2365233,\"lat\":38.758959},{\"lng\":-94.9774274,\"lat\":29.7355047},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":0.7538866,\"lat\":49.6179384},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-74.2107006,\"lat\":40.6639916},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-87.2011806,\"lat\":20.9317633},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-122.3473099,\"lat\":37.5780965},{\"lng\":-0.865783,\"lat\":44.5626798},{\"lng\":8.7376029,\"lat\":41.9263991},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":3.0105105,\"lat\":42.704359},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-91.733423,\"lat\":45.5027926},{\"lng\":-84.1357453,\"lat\":35.7603575},{\"lng\":-2.2087993,\"lat\":56.9640234},{\"lng\":5.7679082,\"lat\":49.5145564},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-63.5720232,\"lat\":44.6799707},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":4.8534326,\"lat\":46.7831001},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-73.4698253,\"lat\":40.669501},{\"lng\":-72.8227503,\"lat\":41.461612},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.3350888,\"lat\":37.7644952},{\"lng\":-95.6349463,\"lat\":29.6196787},{\"lng\":-122.0215737,\"lat\":37.5872576},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-114.1130367,\"lat\":51.7923735},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":5.5703031,\"lat\":43.2924385},{\"lng\":-80.6770111,\"lat\":35.7331953},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":8.7291498,\"lat\":47.4991723},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.4093664,\"lat\":48.7630238},{\"lng\":-111.9738429,\"lat\":41.2230048},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":-96.9553675,\"lat\":32.5888072},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-86.4436018,\"lat\":36.9903199},{\"lng\":-73.2006687,\"lat\":40.8559314},{\"lng\":1.9371554,\"lat\":47.8835088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-58.68455,\"lat\":-34.409311},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":0.9918234,\"lat\":47.3279746},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":1.9017347,\"lat\":50.055774},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":136.5836516,\"lat\":34.8817102},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":-5.0293161,\"lat\":51.7117492},{\"lng\":-80.151449,\"lat\":41.641445},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-0.1511977,\"lat\":47.9965376},{\"lng\":-79.5656326,\"lat\":43.6435559},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":1.3337639,\"lat\":47.5876861},{\"lng\":9.2794469,\"lat\":41.5911382},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-8.1022591,\"lat\":37.0712719},{\"lng\":-93.3501222,\"lat\":44.8897027},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-75.7774177,\"lat\":40.5173165},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.4455201,\"lat\":48.9229803},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.3053932,\"lat\":47.8278656},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-76.3442846,\"lat\":37.0264414},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":9.9215263,\"lat\":57.0462626},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":-1.3131692,\"lat\":51.0612766},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":4.3668279,\"lat\":50.8331141},{\"lng\":5.2298559,\"lat\":49.7705329},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-5.9336562,\"lat\":54.5842881},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":-5.9953403,\"lat\":37.3886303},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":7.8653814,\"lat\":48.1224978},{\"lng\":-1.2620038,\"lat\":52.3726682},{\"lng\":-2.7535644,\"lat\":48.1762534},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-97.4033191,\"lat\":27.7635302},{\"lng\":-84.2946539,\"lat\":37.7478572},{\"lng\":2.2276489,\"lat\":48.7000046},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":9.5960536,\"lat\":54.5035476},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":6.1675872,\"lat\":49.3579272},{\"lng\":5.6969882,\"lat\":50.8579855},{\"lng\":7.1906969,\"lat\":43.6690101},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.836241,\"lat\":38.3856488},{\"lng\":10.2835977,\"lat\":53.6635561},{\"lng\":6.1675872,\"lat\":49.3579272},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-84.1335644,\"lat\":34.235309},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-117.7517496,\"lat\":34.0553813},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-122.4168664,\"lat\":37.6535403},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.6976609,\"lat\":44.3778474},{\"lng\":-88.207301,\"lat\":40.1117174},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":7.3389937,\"lat\":47.7467233},{\"lng\":-1.2077985,\"lat\":52.7723859},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.4172117,\"lat\":48.6998552},{\"lng\":-71.1187829,\"lat\":42.332918},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":-12.8260215,\"lat\":10.0368},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":19.2361111,\"lat\":-34.4175},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-73.55793,\"lat\":44.62884},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":-73.343167,\"lat\":40.9009595},{\"lng\":-97.1341783,\"lat\":32.9412363},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":6.0910097,\"lat\":43.3040144},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.1767012,\"lat\":30.0018546},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-0.3032767,\"lat\":51.4613531},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-122.1702293,\"lat\":47.1870191},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":5.0715646,\"lat\":49.6063089},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-1.9154621,\"lat\":52.6791667},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.7435,\"lat\":49.5929},{\"lng\":-85.5356726,\"lat\":41.9031963},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-1.0209685,\"lat\":44.0630824},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-77.4752667,\"lat\":38.7509488},{\"lng\":-2.4514219,\"lat\":52.6780532},{\"lng\":-2.2024324,\"lat\":51.3161569},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.4979963,\"lat\":40.6460921},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-80.4136767,\"lat\":37.2296566},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":5.1925264,\"lat\":45.90363},{\"lng\":5.4127848,\"lat\":43.4511819},{\"lng\":-122.5316686,\"lat\":37.9747795},{\"lng\":2.5732616,\"lat\":48.8091528},{\"lng\":21.2692121,\"lat\":48.7220196},{\"lng\":28.8322923,\"lat\":47.0245117},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-119.9843482,\"lat\":38.9332411},{\"lng\":-121.3716178,\"lat\":38.4087993},{\"lng\":79.8542005,\"lat\":6.9388614},{\"lng\":-92.0178202,\"lat\":30.2262187},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-1.2885317,\"lat\":51.823462},{\"lng\":-10.0994464,\"lat\":51.7696536},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-1.4269698,\"lat\":46.6705431},{\"lng\":-86.8254383,\"lat\":21.1855431},{\"lng\":-77.3859479,\"lat\":38.9695316},{\"lng\":-74.333495,\"lat\":40.2852895},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-121.542726,\"lat\":37.7832614},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":8.52491,\"lat\":47.3117624},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-2.2024324,\"lat\":51.3161569},{\"lng\":-121.95255,\"lat\":49.1709788},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":2.4890211,\"lat\":42.1822177},{\"lng\":-109.546214,\"lat\":38.5738096},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-121.95255,\"lat\":49.1709788},{\"lng\":6.5623343,\"lat\":51.3331205},{\"lng\":-71.4539683,\"lat\":42.4321064},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.0335624,\"lat\":37.9768525},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-121.9877444,\"lat\":38.3565773},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-16.5627509,\"lat\":13.4410165},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-88.8177418,\"lat\":35.6144446},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-81.3578047,\"lat\":41.1513108},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":17.9681359,\"lat\":59.3628802},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-79.666672,\"lat\":43.447436},{\"lng\":5.0735802,\"lat\":52.653272},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":91.8344348,\"lat\":22.333778},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":5.2298559,\"lat\":49.7705329},{\"lng\":-100.315258,\"lat\":25.6802019},{\"lng\":-3.784376,\"lat\":55.9991959},{\"lng\":-79.6765713,\"lat\":44.6502303},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":16.5463679,\"lat\":59.6110992},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":4.2662071,\"lat\":39.8894922},{\"lng\":1.9485841,\"lat\":44.5811875},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":2.4000602,\"lat\":50.6395937},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.1778792,\"lat\":46.8033114},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-72.2762084,\"lat\":41.491269},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-76.515226,\"lat\":40.3295901},{\"lng\":8.694724,\"lat\":49.4093582},{\"lng\":-72.5751341,\"lat\":42.2591392},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-73.9442812,\"lat\":41.117785},{\"lng\":-8.4150492,\"lat\":39.6036596},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":1.4353783,\"lat\":38.9072784},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-112.5285237,\"lat\":37.0481715},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-74.0731738,\"lat\":45.6452452},{\"lng\":-88.6352595,\"lat\":36.7413624},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-1.4194401,\"lat\":53.6991226},{\"lng\":7.0341973,\"lat\":5.489736},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":2.2368863,\"lat\":48.8841522},{\"lng\":-0.1908861,\"lat\":51.3596769},{\"lng\":-44.246944,\"lat\":-19.466111},{\"lng\":1.6053807,\"lat\":42.9638998},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-0.6620551,\"lat\":51.9165794},{\"lng\":5.0715646,\"lat\":49.6063089},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.2765575,\"lat\":49.1512109},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-122.6874469,\"lat\":48.0559402},{\"lng\":-94.0984277,\"lat\":30.0829344},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.3330573,\"lat\":37.496904},{\"lng\":-1.3757282,\"lat\":47.7194057},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":3.4113639,\"lat\":44.5037957},{\"lng\":-97.6114237,\"lat\":38.8402805},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":85.3205817,\"lat\":27.708317},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-97.8772103,\"lat\":29.9892928},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-122.561503,\"lat\":37.9744323},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":-74.1454214,\"lat\":40.7684342},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":11.0566523,\"lat\":49.1952934},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-79.6847703,\"lat\":40.6739543},{\"lng\":-121.955174,\"lat\":37.3541132},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":73.5301042,\"lat\":4.1961894},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-121.8989248,\"lat\":37.4332273},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-72.9632651,\"lat\":41.2709645},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.561503,\"lat\":37.9744323},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":-0.1049747,\"lat\":50.9999616},{\"lng\":-81.5032364,\"lat\":30.0295303},{\"lng\":127.0473,\"lat\":37.5177},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-121.176058,\"lat\":38.6779591},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-95.4187924,\"lat\":30.0795707},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-80.9856069,\"lat\":35.1478727},{\"lng\":-122.9543022,\"lat\":50.1171903},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.1981486,\"lat\":19.0437196},{\"lng\":34.8760954,\"lat\":32.0604256},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":-91.6392294,\"lat\":44.0500054},{\"lng\":-72.4613331,\"lat\":41.4528584},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.206436,\"lat\":26.2445263},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":-86.2541768,\"lat\":41.8297694},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-120.435857,\"lat\":34.9531295},{\"lng\":8.5828944,\"lat\":52.2004727},{\"lng\":-74.2176435,\"lat\":40.0978929},{\"lng\":-0.6438974,\"lat\":52.913192},{\"lng\":-93.0219376,\"lat\":37.6832712},{\"lng\":10.9461479,\"lat\":50.8349097},{\"lng\":10.407855,\"lat\":53.248706},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":12.5329678,\"lat\":57.9299658},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":11.8609561,\"lat\":45.4115847},{\"lng\":-117.1827445,\"lat\":34.0550328},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-74.215011,\"lat\":40.7642404},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-88.0840212,\"lat\":41.5263603},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":120.9545903,\"lat\":14.4070149},{\"lng\":6.3121658,\"lat\":46.0672189},{\"lng\":-159.3191601,\"lat\":22.0747334},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-80.0656106,\"lat\":40.4656244},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-79.6059188,\"lat\":40.6271073},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-123.2290777,\"lat\":44.8486414},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":2.4916592,\"lat\":48.8387639},{\"lng\":-3.8758396,\"lat\":40.4933095},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":-74.1637553,\"lat\":40.8584328},{\"lng\":-1.1448708,\"lat\":43.8066637},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-70.8781883,\"lat\":42.5489744},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":-85.3782795,\"lat\":32.6454116},{\"lng\":10.8337852,\"lat\":48.2687941},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":6.5680077,\"lat\":53.2190652},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-0.0659685,\"lat\":51.5174861},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-0.1991229,\"lat\":51.4989948},{\"lng\":-112.036277,\"lat\":46.5927425},{\"lng\":-87.8735662,\"lat\":41.81483},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-58.5622869,\"lat\":-34.6481661},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":13.1624096,\"lat\":46.2313099},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":8.3640342,\"lat\":47.4182444},{\"lng\":-1.8604874,\"lat\":53.7229229},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":121.4589414,\"lat\":25.061706},{\"lng\":-70.2823287,\"lat\":41.6535345},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":16.6131116,\"lat\":49.1911221},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.5623343,\"lat\":51.3331205},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":-0.2749555,\"lat\":51.6136623},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":3.5665965,\"lat\":51.1844827},{\"lng\":-8.3959425,\"lat\":43.3709703},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-75.4583956,\"lat\":43.2102196},{\"lng\":4.2176541,\"lat\":43.8266904},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":11.98632,\"lat\":48.3136408},{\"lng\":-87.6305899,\"lat\":46.4481521},{\"lng\":13.7772781,\"lat\":45.6496485},{\"lng\":7.5674652,\"lat\":51.445525},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.1810781,\"lat\":53.0079887},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-74.6487018,\"lat\":42.1487726},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":0.983698,\"lat\":47.4110351},{\"lng\":-117.2919818,\"lat\":33.0369867},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.2146275,\"lat\":43.4162729},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":4.2360263,\"lat\":45.2424978},{\"lng\":-97.3865494,\"lat\":32.3474463},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":6.759562,\"lat\":51.434999},{\"lng\":3.9452194,\"lat\":50.4431879},{\"lng\":106.6811524,\"lat\":10.8237546},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-77.1956331,\"lat\":39.0180508},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-0.7630148,\"lat\":51.2494169},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-75.0354347,\"lat\":43.0150703},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-94.969956,\"lat\":35.91537},{\"lng\":-79.8387175,\"lat\":-6.7716146},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-1.5695287,\"lat\":47.1905456},{\"lng\":-96.7077751,\"lat\":40.8088861},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":6.4946806,\"lat\":47.6863376},{\"lng\":32.8554966,\"lat\":39.8853321},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":150.5134227,\"lat\":-23.3782137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":17.6387436,\"lat\":59.8586126},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-111.8627989,\"lat\":40.5247777},{\"lng\":-118.5978087,\"lat\":34.2011078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.1981764,\"lat\":33.4504157},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-52.7066964,\"lat\":47.5646794},{\"lng\":2.1868998,\"lat\":48.9229416},{\"lng\":6.9881194,\"lat\":51.0324743},{\"lng\":-87.2011806,\"lat\":20.9317633},{\"lng\":6.62843,\"lat\":51.451283},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.787022,\"lat\":43.8235163},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.8152074,\"lat\":33.4638745},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":2.4916592,\"lat\":48.8387639},{\"lng\":-0.2796034,\"lat\":51.5560695},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.6775634,\"lat\":30.6370152},{\"lng\":-74.5857218,\"lat\":40.844265},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-1.6676238,\"lat\":43.3844003},{\"lng\":-84.778628,\"lat\":42.9892847},{\"lng\":72.5800568,\"lat\":23.0215374},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-73.872635,\"lat\":41.0145418},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-86.7825235,\"lat\":36.0325687},{\"lng\":-121.29318,\"lat\":38.8915741},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.1783134,\"lat\":50.8526637},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-92.447758,\"lat\":42.5361805},{\"lng\":-76.6042521,\"lat\":40.153364},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":8.4034195,\"lat\":49.0068705},{\"lng\":-81.9320157,\"lat\":34.9498007},{\"lng\":-0.9943593,\"lat\":41.7140829},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-0.4095586,\"lat\":52.99965},{\"lng\":-71.3821203,\"lat\":41.8789531},{\"lng\":-2.8452562,\"lat\":47.7584409},{\"lng\":17.0326689,\"lat\":51.1089776},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":0.6383746,\"lat\":51.8019608},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-81.7016346,\"lat\":30.1654707},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":7.290923,\"lat\":51.9773625},{\"lng\":-111.9866584,\"lat\":46.4649011},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":8.4034195,\"lat\":49.0068705},{\"lng\":12.0819247,\"lat\":55.6433478},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-0.5639812,\"lat\":45.9085506},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-83.1499304,\"lat\":42.6055893},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-117.2740777,\"lat\":32.8401623},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":10.2758153,\"lat\":50.1847547},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.5278045,\"lat\":31.6143213},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.7909452,\"lat\":37.831272},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.5804218,\"lat\":46.0603171},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":2.2824663,\"lat\":48.9064207},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-79.0639039,\"lat\":43.1065603},{\"lng\":-2.2198605,\"lat\":51.745424},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-3.000425,\"lat\":51.5887675},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-110.1618548,\"lat\":38.9961201},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-122.3053932,\"lat\":47.8278656},{\"lng\":-90.1570232,\"lat\":30.4043607},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-0.3699697,\"lat\":50.8115402},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":6.4867321,\"lat\":43.5039337},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-97.8417144,\"lat\":30.082475},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":1.6995213,\"lat\":41.3463825},{\"lng\":-125.904708,\"lat\":49.1529643},{\"lng\":11.4250395,\"lat\":48.7630165},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.6294321,\"lat\":43.3708943},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":2.0388736,\"lat\":49.0527528},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.8526969,\"lat\":42.9300668},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-97.6788056,\"lat\":30.5085915},{\"lng\":-90.1843091,\"lat\":38.8908583},{\"lng\":-2.779317,\"lat\":55.9556144},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":0.6267842,\"lat\":41.6147605},{\"lng\":-71.5525188,\"lat\":42.3468589},{\"lng\":7.6824892,\"lat\":45.0677551},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":3.2131307,\"lat\":43.3426562},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":145.582931,\"lat\":-36.773286},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":25.4701983,\"lat\":65.0117869},{\"lng\":-76.0372354,\"lat\":45.6402189},{\"lng\":2.3491069,\"lat\":43.2130358},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":-90.0657477,\"lat\":30.3582305},{\"lng\":-122.793281,\"lat\":49.2842958},{\"lng\":-80.1762704,\"lat\":33.0186699},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":0.164274,\"lat\":44.5007939},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-159.3463523,\"lat\":22.0833399},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":89.8401059,\"lat\":23.03408},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.5937073,\"lat\":48.6272298},{\"lng\":-5.273032,\"lat\":50.1016731},{\"lng\":0.2673446,\"lat\":51.1371483},{\"lng\":0.1438299,\"lat\":38.7324708},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-111.5908473,\"lat\":33.1941699},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.4394816,\"lat\":35.2225717},{\"lng\":4.8855966,\"lat\":45.6977109},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.4455201,\"lat\":48.9229803},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.0324321,\"lat\":44.6092335},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-77.1233587,\"lat\":38.9812725},{\"lng\":-81.2839038,\"lat\":28.2498534},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-107.9779962,\"lat\":36.7520109},{\"lng\":3.8969928,\"lat\":7.3786064},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-85.1386015,\"lat\":41.0799898},{\"lng\":4.8934402,\"lat\":44.8363656},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-2.1208614,\"lat\":53.5435569},{\"lng\":-117.379483,\"lat\":33.1958696},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":6.6617476,\"lat\":46.5098019},{\"lng\":-112.8331033,\"lat\":49.6945782},{\"lng\":12.0974869,\"lat\":49.0195333},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":9.6556042,\"lat\":47.3859513},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.0715646,\"lat\":49.6063089},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-116.9763092,\"lat\":33.9299925},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":6.0910097,\"lat\":43.3040144},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":3.7250121,\"lat\":51.0538286},{\"lng\":6.46667,\"lat\":50.8833},{\"lng\":2.2674892,\"lat\":48.9148269},{\"lng\":-86.2874232,\"lat\":32.4149235},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-2.6183238,\"lat\":51.7938786},{\"lng\":-83.1848781,\"lat\":34.4870458},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":101.5234848,\"lat\":3.6900079},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":7.444639,\"lat\":51.7717757},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-75.7515682,\"lat\":39.6828358},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":4.8078783,\"lat\":44.1371311},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-71.71351,\"lat\":42.2960187},{\"lng\":-1.0677602,\"lat\":50.8221133},{\"lng\":-122.3330573,\"lat\":37.496904},{\"lng\":-106.6308524,\"lat\":39.624457},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.0475937,\"lat\":59.9738693},{\"lng\":2.334267,\"lat\":48.911729},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":10.1056465,\"lat\":56.1565872},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-1.6363856,\"lat\":53.716564},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-86.8919011,\"lat\":40.4191229},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.5495112,\"lat\":34.9854275},{\"lng\":-89.9841627,\"lat\":38.5135805},{\"lng\":-0.1835802,\"lat\":50.8452678},{\"lng\":0.3018662,\"lat\":51.6201654},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":10.3952118,\"lat\":63.4304475},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.272863,\"lat\":37.8708393},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-122.657047,\"lat\":49.1039289},{\"lng\":-111.926018,\"lat\":33.4942189},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":0.6383746,\"lat\":51.8019608},{\"lng\":-74.5348749,\"lat\":39.8176178},{\"lng\":83.2921297,\"lat\":17.6935526},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-74.249663,\"lat\":45.9024084},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-1.8991667,\"lat\":46.7202778},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":11.1430287,\"lat\":47.8452213},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-117.379483,\"lat\":33.1958696},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":4.4811089,\"lat\":52.1518157},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-54.9582718,\"lat\":-34.9087162},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-1.0677602,\"lat\":50.8221133},{\"lng\":-2.2458192,\"lat\":51.8653705},{\"lng\":6.9684353,\"lat\":53.0786257},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.6141867,\"lat\":38.263995},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-83.1779537,\"lat\":41.114485},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":-1.5756205,\"lat\":54.7770139},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":18.016667,\"lat\":59.366667},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.8606367,\"lat\":42.9105722},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.5441944,\"lat\":28.5694468},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.7603283,\"lat\":48.5141134},{\"lng\":-1.1964165,\"lat\":53.1443785},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":7.8431299,\"lat\":47.560991},{\"lng\":7.1294088,\"lat\":49.3704071},{\"lng\":-0.8809428,\"lat\":41.6521342},{\"lng\":-86.4436018,\"lat\":36.9903199},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":6.8940537,\"lat\":52.2209855},{\"lng\":7.1943544,\"lat\":51.1798706},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-76.9199742,\"lat\":40.2398118},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":33.3638783,\"lat\":35.1746503},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-76.2494453,\"lat\":36.7168315},{\"lng\":7.2994054,\"lat\":47.9569146},{\"lng\":-86.2307992,\"lat\":30.3466423},{\"lng\":7.0134418,\"lat\":43.5515198},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":-1.4761491,\"lat\":52.9212617},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-79.8728583,\"lat\":43.2560802},{\"lng\":-70.8739761,\"lat\":43.1981117},{\"lng\":-76.053813,\"lat\":42.0850703},{\"lng\":-124.2174647,\"lat\":43.3678937},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-83.376398,\"lat\":33.9597677},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-49.3695627,\"lat\":-28.6789941},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-105.0372046,\"lat\":39.8366528},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":6.1041352,\"lat\":49.3043497},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":-122.3455263,\"lat\":37.9621457},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-1.1305431,\"lat\":37.9923795},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-156.3237119,\"lat\":20.792026},{\"lng\":-8.0232598,\"lat\":37.1395485},{\"lng\":4.7760237,\"lat\":51.5887845},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-118.2350733,\"lat\":34.230429},{\"lng\":-79.9559437,\"lat\":39.6296809},{\"lng\":-47.8828,\"lat\":-15.7939869},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":44.3872213,\"lat\":33.3061701},{\"lng\":2.2552381,\"lat\":46.9921896},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-1.7594444,\"lat\":46.6986111},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5595029,\"lat\":44.7737872},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":2.0678397,\"lat\":43.4539616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.5252267,\"lat\":43.929489},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-121.944881,\"lat\":37.2870626},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":151.3120675,\"lat\":-33.3117096},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-58.7662564,\"lat\":-27.5246619},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-75.3741691,\"lat\":6.1536166},{\"lng\":-0.2796034,\"lat\":51.5560695},{\"lng\":9.1750718,\"lat\":47.659216},{\"lng\":12.0495271,\"lat\":57.7970147},{\"lng\":-114.9822486,\"lat\":36.0319843},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-72.7395401,\"lat\":41.7162112},{\"lng\":5.8100016,\"lat\":47.1811265},{\"lng\":-71.065573,\"lat\":42.2501425},{\"lng\":-9.2365233,\"lat\":38.758959},{\"lng\":-2.3926783,\"lat\":53.8717465},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-72.4423102,\"lat\":42.9620253},{\"lng\":-111.6587085,\"lat\":40.2337289},{\"lng\":7.0960124,\"lat\":51.5110321},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-118.0539323,\"lat\":33.8644291},{\"lng\":-6.0414184,\"lat\":52.9802376},{\"lng\":18.798327,\"lat\":54.4288032},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":-157.9129733,\"lat\":21.34045},{\"lng\":100.9872185,\"lat\":13.3662087},{\"lng\":74.7870308,\"lat\":13.3519723},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.7056955,\"lat\":40.6631362},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":100.5386136,\"lat\":13.7784702},{\"lng\":-99.2327986,\"lat\":19.4788356},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-117.0814849,\"lat\":33.1216751},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":-1.4968,\"lat\":53.6830458},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-95.4187924,\"lat\":30.0795707},{\"lng\":-72.5198761,\"lat\":42.3731948},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":3.17459,\"lat\":45.7067},{\"lng\":-70.927048,\"lat\":43.134564},{\"lng\":-3.7659722,\"lat\":40.6587726},{\"lng\":-88.0717708,\"lat\":41.7003302},{\"lng\":-9.2365233,\"lat\":38.758959},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-74.154352,\"lat\":41.8448455},{\"lng\":2.8953121,\"lat\":42.6985304},{\"lng\":-121.96947,\"lat\":48.0817561},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-74.4809868,\"lat\":40.7970382},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":9.7703927,\"lat\":53.7889203},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":-81.684004,\"lat\":36.2187873},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-54.9582718,\"lat\":-34.9087162},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-75.1256812,\"lat\":40.0959385},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-74.0984769,\"lat\":41.0585352},{\"lng\":-77.443014,\"lat\":43.0993},{\"lng\":-93.6170448,\"lat\":42.0267567},{\"lng\":2.30551,\"lat\":48.9026},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":0.7652218,\"lat\":45.8520668},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":4.338636,\"lat\":50.8545959},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-75.2882893,\"lat\":40.004128},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":8.6736295,\"lat\":49.8851869},{\"lng\":-76.0493684,\"lat\":42.098408},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-86.2094342,\"lat\":35.3620235},{\"lng\":-78.219615,\"lat\":0.3316022},{\"lng\":9.0078266,\"lat\":50.0818411},{\"lng\":-7.6991779,\"lat\":52.3611009},{\"lng\":-78.3990378,\"lat\":35.5882559},{\"lng\":-119.2790529,\"lat\":50.7005059},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.8121191,\"lat\":39.9547861},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-73.2006687,\"lat\":40.8559314},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-91.6704053,\"lat\":41.9758872},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-3.0509812,\"lat\":53.8179442},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-117.290039,\"lat\":49.494891},{\"lng\":-84.6102213,\"lat\":38.8756194},{\"lng\":153.1490383,\"lat\":-27.4392673},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":4.09203,\"lat\":46.0205},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.6292018,\"lat\":38.7927405},{\"lng\":-80.9818016,\"lat\":43.3700899},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.6124179,\"lat\":33.4270275},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-103.228023,\"lat\":44.0806041},{\"lng\":-73.0454164,\"lat\":40.871241},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-70.6154965,\"lat\":41.7452589},{\"lng\":1.3549991,\"lat\":44.0175835},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":77.3272147,\"lat\":28.5706333},{\"lng\":-71.5517636,\"lat\":-33.0244535},{\"lng\":5.2828123,\"lat\":45.5872259},{\"lng\":6.929204,\"lat\":51.521581},{\"lng\":-74.3148279,\"lat\":40.6233995},{\"lng\":4.0565359,\"lat\":48.2931517},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-71.2661597,\"lat\":41.6770463},{\"lng\":7.8191185,\"lat\":51.681281},{\"lng\":-86.8689419,\"lat\":35.925206},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-72.0337376,\"lat\":42.0750465},{\"lng\":-121.173921,\"lat\":44.2726203},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-77.443014,\"lat\":43.0993},{\"lng\":-122.2433113,\"lat\":49.0699667},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.3775015,\"lat\":51.5060205},{\"lng\":-81.9498042,\"lat\":28.0394654},{\"lng\":6.8514435,\"lat\":51.4696137},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":6.996379,\"lat\":49.234362},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-4.2660965,\"lat\":55.4540605},{\"lng\":-0.5038294,\"lat\":51.392296},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-77.5626132,\"lat\":39.913338},{\"lng\":-122.5316686,\"lat\":37.9747795},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-73.9897782,\"lat\":41.1509835},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":8.5980265,\"lat\":50.2363508},{\"lng\":-156.4549898,\"lat\":20.7476261},{\"lng\":-2.0822333,\"lat\":52.5700229},{\"lng\":-117.2233069,\"lat\":33.3663105},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-76.6148148,\"lat\":39.3964591},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-123.1110551,\"lat\":45.5190404},{\"lng\":30.7208911,\"lat\":36.8888637},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-87.0604487,\"lat\":41.4672552},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.951183,\"lat\":39.0022605},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":-92.081509,\"lat\":30.5335302},{\"lng\":-3.1029086,\"lat\":51.0147895},{\"lng\":-70.5587024,\"lat\":41.5786678},{\"lng\":-73.7853915,\"lat\":43.0821793},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-119.119919,\"lat\":46.2087066},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-90.2417806,\"lat\":29.9942265},{\"lng\":-78.4297365,\"lat\":40.3575744},{\"lng\":-97.827833,\"lat\":30.5217116},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":57.36914,\"lat\":-20.2789702},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":-95.8833235,\"lat\":35.9420431},{\"lng\":-89.0442238,\"lat\":43.3873717},{\"lng\":5.4768915,\"lat\":52.5150949},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-72.5976987,\"lat\":41.9791024},{\"lng\":-85.2559398,\"lat\":34.0124425},{\"lng\":-1.0935837,\"lat\":45.9883689},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-89.953157,\"lat\":38.8114364},{\"lng\":-5.1468484,\"lat\":36.4268068},{\"lng\":3.3941795,\"lat\":6.4550575},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-121.3716178,\"lat\":38.4087993},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":2.3872525,\"lat\":48.8122302},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":24.7453688,\"lat\":59.4372155},{\"lng\":-110.2997756,\"lat\":31.5545973},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.8940505,\"lat\":45.3128048},{\"lng\":-84.7996573,\"lat\":33.3806716},{\"lng\":-1.4652044,\"lat\":47.2155058},{\"lng\":-0.4804579,\"lat\":52.6519973},{\"lng\":-121.2357828,\"lat\":38.7907339},{\"lng\":5.1925264,\"lat\":45.90363},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.4929452,\"lat\":47.2419677},{\"lng\":12.9990874,\"lat\":55.882914},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":-120.339415,\"lat\":50.6758269},{\"lng\":8.9520281,\"lat\":46.0050102},{\"lng\":104.9224426,\"lat\":11.568271},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":50.0490975,\"lat\":40.4728104},{\"lng\":110.4229104,\"lat\":-6.9903988},{\"lng\":-72.8992932,\"lat\":41.3943921},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-5.8408396,\"lat\":37.3397709},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-105.0811573,\"lat\":39.8005505},{\"lng\":-82.5594293,\"lat\":36.550238},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-87.7521069,\"lat\":42.0262972},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-1.5592776,\"lat\":43.4832523},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":7.0960124,\"lat\":51.5110321},{\"lng\":2.334267,\"lat\":48.911729},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-83.9478911,\"lat\":42.0554875},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-0.1991229,\"lat\":51.4989948},{\"lng\":-106.4244938,\"lat\":36.1780125},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":6.6055827,\"lat\":46.534566},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-1.1472098,\"lat\":44.7951052},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-80.399513,\"lat\":26.1003392},{\"lng\":6.3676062,\"lat\":49.5442267},{\"lng\":-86.8024491,\"lat\":33.6054626},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-3.5211361,\"lat\":50.4652392},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-93.9993505,\"lat\":44.1634663},{\"lng\":6.8081935,\"lat\":50.9096219},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.4196718,\"lat\":44.0121279},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-8.6058415,\"lat\":41.1300103},{\"lng\":19.428333,\"lat\":-34.23},{\"lng\":-122.2566367,\"lat\":38.1040864},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-97.9405828,\"lat\":29.8826436},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.2057067,\"lat\":51.2376557},{\"lng\":-72.1578243,\"lat\":41.6993535},{\"lng\":8.7376029,\"lat\":41.9263991},{\"lng\":-2.4476231,\"lat\":51.2919489},{\"lng\":-73.7826363,\"lat\":40.9115386},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-89.0936778,\"lat\":38.960601},{\"lng\":-83.5657167,\"lat\":35.8672932},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-2.0160287,\"lat\":53.9618497},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":25.2829111,\"lat\":54.6870458},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-1.0287636,\"lat\":45.6245332},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":0.0249248,\"lat\":51.5495236},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-117.826166,\"lat\":33.7458511},{\"lng\":-78.1652404,\"lat\":39.1852184},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":8.7397624,\"lat\":48.7142691},{\"lng\":-80.0666026,\"lat\":26.5256179},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-82.7192671,\"lat\":28.2441768},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-1.4722242,\"lat\":47.1685211},{\"lng\":3.3995767,\"lat\":47.9812486},{\"lng\":-73.9701382,\"lat\":40.8509333},{\"lng\":-87.5715641,\"lat\":37.970495},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-80.1762704,\"lat\":33.0186699},{\"lng\":-8.08053,\"lat\":40.51642},{\"lng\":-70.7939307,\"lat\":42.1617681},{\"lng\":-58.6351056,\"lat\":-34.4537215},{\"lng\":-74.3177933,\"lat\":41.0461864},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-2.9184744,\"lat\":47.6199988},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":2.2674892,\"lat\":48.9148269},{\"lng\":9.2794469,\"lat\":41.5911382},{\"lng\":4.8855966,\"lat\":45.6977109},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.9367107,\"lat\":40.5584882},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-85.1386015,\"lat\":41.0799898},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-73.8162354,\"lat\":42.4684148},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-103.799951,\"lat\":40.2502582},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-72.6077753,\"lat\":41.7148499},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-76.8485094,\"lat\":39.0984317},{\"lng\":8.9520281,\"lat\":46.0050102},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":12.7626208,\"lat\":48.4031909},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":0.0949036,\"lat\":51.7685568},{\"lng\":-2.7603283,\"lat\":48.5141134},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-0.3281887,\"lat\":51.4467444},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-75.2995777,\"lat\":40.2796371},{\"lng\":-85.3094883,\"lat\":35.0457219},{\"lng\":2.9667,\"lat\":42.7838039},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-84.0712997,\"lat\":34.0514898},{\"lng\":-95.4560512,\"lat\":30.3118769},{\"lng\":-87.848085,\"lat\":41.8228378},{\"lng\":-81.0557921,\"lat\":29.2854132},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":6.0812467,\"lat\":46.1444789},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-92.116219,\"lat\":32.5025471},{\"lng\":-1.2620038,\"lat\":52.3726682},{\"lng\":-80.2331038,\"lat\":26.0628665},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-101.6829766,\"lat\":21.121965},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":8.446357,\"lat\":49.9819502},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":-78.8505516,\"lat\":35.7325352},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":3.0000288,\"lat\":49.5805561},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.7659,\"lat\":40.2203074},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-4.2793767,\"lat\":36.7162109},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-155.1003754,\"lat\":19.6854458},{\"lng\":9.5294671,\"lat\":48.8849825},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-0.3004067,\"lat\":51.5149803},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":-86.075836,\"lat\":41.6650487},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-94.1574328,\"lat\":36.0625843},{\"lng\":-72.6719518,\"lat\":42.3355692},{\"lng\":2.4433101,\"lat\":44.9285441},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":7.1503312,\"lat\":43.7228225},{\"lng\":28.9758715,\"lat\":41.006381},{\"lng\":-112.8331033,\"lat\":49.6945782},{\"lng\":9.4294425,\"lat\":52.4257979},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-89.5230357,\"lat\":37.3034933},{\"lng\":9.9571081,\"lat\":49.8565075},{\"lng\":0.5537161,\"lat\":51.8780637},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-80.1137701,\"lat\":43.477503},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":0.2781546,\"lat\":50.7664372},{\"lng\":-84.9373276,\"lat\":41.0788904},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-158.016672,\"lat\":21.5006241},{\"lng\":2.4809129,\"lat\":48.7489857},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.2341028,\"lat\":42.6875323},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-122.0335624,\"lat\":37.9768525},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-6.0410762,\"lat\":53.1068619},{\"lng\":-71.6422408,\"lat\":42.3196015},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":-111.8627989,\"lat\":40.5247777},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":10.1601492,\"lat\":48.3044877},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-79.4607617,\"lat\":46.3092115},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":0.3772655,\"lat\":52.6025943},{\"lng\":-1.4621381,\"lat\":53.3783713},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.36109,\"lat\":61.3187823},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":10.0471189,\"lat\":48.3251884},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.5244419,\"lat\":51.6113905},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":5.681781,\"lat\":45.2325079},{\"lng\":-2.5221184,\"lat\":53.0671376},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-77.0047276,\"lat\":40.2101972},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":27.9166653,\"lat\":43.2073873},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":4.8920811,\"lat\":44.9332277},{\"lng\":-97.6788056,\"lat\":30.5085915},{\"lng\":13.0591397,\"lat\":52.4009309},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":7.0534664,\"lat\":47.7551188},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-82.005019,\"lat\":39.9401426},{\"lng\":-84.5898256,\"lat\":33.3975472},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-122.470042,\"lat\":38.5052288},{\"lng\":-106.0433023,\"lat\":39.6302657},{\"lng\":-70.082796,\"lat\":41.7601093},{\"lng\":25.2829111,\"lat\":54.6870458},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":11.5129742,\"lat\":51.0227878},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":8.4381568,\"lat\":49.4704113},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-121.7529071,\"lat\":36.9092773},{\"lng\":2.3226987,\"lat\":48.8658525},{\"lng\":1.3009485,\"lat\":38.9830568},{\"lng\":4.8380426,\"lat\":47.0239064},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-80.5222961,\"lat\":43.4652699},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-82.5603625,\"lat\":35.6967238},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":120.9817861,\"lat\":14.4809012},{\"lng\":5.5703031,\"lat\":43.2924385},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-105.016649,\"lat\":39.613321},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":-0.3394758,\"lat\":53.7435722},{\"lng\":2.4343549,\"lat\":48.9409151},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.3699697,\"lat\":50.8115402},{\"lng\":3.4302412,\"lat\":43.6263176},{\"lng\":-81.5345547,\"lat\":28.4944695},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-79.5923855,\"lat\":43.7848982},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":110.3646857,\"lat\":-7.8012646},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2127011,\"lat\":47.9793437},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-81.1881557,\"lat\":37.7781702},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":10.327678,\"lat\":36.8790882},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-83.1596108,\"lat\":40.033814},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":1.1239654,\"lat\":49.4222278},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":10.7861682,\"lat\":52.4205588},{\"lng\":-81.7942944,\"lat\":26.1421976},{\"lng\":-122.0322895,\"lat\":37.3228934},{\"lng\":-73.8987469,\"lat\":40.9312099},{\"lng\":-77.1956331,\"lat\":39.0180508},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":33.3638783,\"lat\":35.1746503},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-1.4315213,\"lat\":43.6403659},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-118.3935254,\"lat\":33.8897798},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":6.0820639,\"lat\":44.5612032},{\"lng\":-78.6891675,\"lat\":43.9122995},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.138218,\"lat\":55.5101491},{\"lng\":36.828842,\"lat\":-1.3026148},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":7.6120793,\"lat\":47.6056484},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.1332853,\"lat\":50.9575365},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-105.089705,\"lat\":39.9935959},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-0.8324037,\"lat\":51.4120318},{\"lng\":4.8855966,\"lat\":45.6977109},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":7.6483815,\"lat\":48.0439812},{\"lng\":32.5826451,\"lat\":-25.906355},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":8.7704695,\"lat\":50.8090106},{\"lng\":-83.2910468,\"lat\":42.6389216},{\"lng\":-74.7659,\"lat\":40.2203074},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-89.1618188,\"lat\":54.0245941},{\"lng\":4.6111981,\"lat\":52.4574236},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-96.6227714,\"lat\":32.7287413},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-0.3394758,\"lat\":53.7435722},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":-113.584131,\"lat\":37.104153},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-71.1522766,\"lat\":42.4792618},{\"lng\":-92.0095079,\"lat\":41.6612394},{\"lng\":28.37,\"lat\":-26.235278},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-86.5705084,\"lat\":30.7621326},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-86.9080655,\"lat\":40.4258686},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-112.3842224,\"lat\":33.4674695},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":12.4483489,\"lat\":55.6898267},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":73.5301042,\"lat\":4.1961894},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":-59.1555837,\"lat\":-37.297371},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-96.4066987,\"lat\":32.8923464},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":6.5928442,\"lat\":46.5349093},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":6.840984,\"lat\":46.8978306},{\"lng\":-0.5023006,\"lat\":45.0496567},{\"lng\":25.2829111,\"lat\":54.6870458},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-75.4712794,\"lat\":40.6022059},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":0.739923,\"lat\":47.3577},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":11.3426327,\"lat\":44.4938203},{\"lng\":9.0035455,\"lat\":48.7084162},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-118.3878945,\"lat\":34.2204227},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-89.0226793,\"lat\":42.6829765},{\"lng\":-105.016649,\"lat\":39.613321},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":17.766667,\"lat\":59.416667},{\"lng\":7.335124,\"lat\":51.4370171},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-74.8023882,\"lat\":41.322316},{\"lng\":18.798327,\"lat\":54.4288032},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.985181,\"lat\":39.8695516},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":11.2655684,\"lat\":47.4429543},{\"lng\":-82.2880508,\"lat\":27.928464},{\"lng\":-93.2169807,\"lat\":30.2305095},{\"lng\":-87.8735662,\"lat\":41.81483},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-117.566444,\"lat\":33.8752945},{\"lng\":-74.5143232,\"lat\":40.9012101},{\"lng\":-76.42977,\"lat\":36.9775016},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.4439254,\"lat\":40.4951365},{\"lng\":-75.1515534,\"lat\":40.103196},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-51.0261927,\"lat\":-30.0819338},{\"lng\":-71.4165905,\"lat\":42.2773177},{\"lng\":4.490519,\"lat\":52.2629093},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-71.6422408,\"lat\":42.3196015},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.6267842,\"lat\":41.6147605},{\"lng\":20.4568974,\"lat\":44.8178131},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":7.089351,\"lat\":49.4305056},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-59.1152598,\"lat\":-34.5661734},{\"lng\":-74.171811,\"lat\":40.9167654},{\"lng\":10.0228291,\"lat\":57.1095604},{\"lng\":-98.8082745,\"lat\":19.32929},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":4.8138874,\"lat\":44.4225104},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":36.828842,\"lat\":-1.3026148},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.1561192,\"lat\":29.1335781},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-71.1843236,\"lat\":42.3652518},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-117.6483876,\"lat\":34.09751},{\"lng\":-1.9417444,\"lat\":52.3057655},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":8.6124721,\"lat\":47.2905574},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":32.8540497,\"lat\":39.9207759},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-114.6179954,\"lat\":32.723268},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":91.8344348,\"lat\":22.333778},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":6.996379,\"lat\":49.234362},{\"lng\":13.2807255,\"lat\":52.6732755},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.3085329,\"lat\":42.6414437},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":55.4135962,\"lat\":-21.2840124},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.4164807,\"lat\":41.45011},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":-74.417097,\"lat\":40.7598227},{\"lng\":5.36109,\"lat\":61.3187823},{\"lng\":-87.8212263,\"lat\":42.5846773},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-3.2570517,\"lat\":54.0979084},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-3.5995337,\"lat\":37.1734995},{\"lng\":-68.7713289,\"lat\":44.8016255},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":127.8573107,\"lat\":26.3791496},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-118.852583,\"lat\":36.2516475},{\"lng\":-117.3136547,\"lat\":34.0739016},{\"lng\":-75.5463673,\"lat\":44.8433048},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":8.5828944,\"lat\":52.2004727},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-119.0779359,\"lat\":34.4458248},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-97.8417144,\"lat\":30.082475},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-73.2584121,\"lat\":41.1428951},{\"lng\":10.8768728,\"lat\":48.0497474},{\"lng\":-123.137414,\"lat\":49.163168},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-79.6142224,\"lat\":37.188635},{\"lng\":-5.273032,\"lat\":50.1016731},{\"lng\":7.9492262,\"lat\":47.9770172},{\"lng\":7.444639,\"lat\":51.7717757},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-79.666672,\"lat\":43.447436},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-86.8254383,\"lat\":21.1855431},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.644567,\"lat\":45.0154164},{\"lng\":-1.6171001,\"lat\":54.9751321},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-96.6536701,\"lat\":49.6711222},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.3845942,\"lat\":33.8398289},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-82.7896471,\"lat\":40.733795},{\"lng\":101.0244136,\"lat\":13.1416329},{\"lng\":-90.1830408,\"lat\":32.2998686},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-68.6161357,\"lat\":44.3036899},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":4.031926,\"lat\":49.2577886},{\"lng\":2.2956951,\"lat\":49.8941708},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-117.3703235,\"lat\":34.1064001},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":77.401989,\"lat\":23.2584857},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":11.8627403,\"lat\":45.3951113},{\"lng\":4.6111981,\"lat\":52.4574236},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.844117,\"lat\":42.6870896},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.5587024,\"lat\":41.5786678},{\"lng\":-75.7652424,\"lat\":39.9829308},{\"lng\":6.4053868,\"lat\":46.2087237},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-76.9429182,\"lat\":39.2065447},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-71.0683741,\"lat\":42.4268484},{\"lng\":-74.7659,\"lat\":40.2203074},{\"lng\":-119.2790529,\"lat\":50.7005059},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":5.4804956,\"lat\":43.6003084},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-111.4979963,\"lat\":40.6460921},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":-74.1337508,\"lat\":42.1956438},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":8.9668368,\"lat\":52.3756616},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-1.4264097,\"lat\":53.2352134},{\"lng\":-93.3204872,\"lat\":44.8322405},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":-77.795367,\"lat\":38.7135498},{\"lng\":-2.9184744,\"lat\":47.6199988},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":-80.2533838,\"lat\":35.8240265},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":16.5720327,\"lat\":48.5694535},{\"lng\":1.9988356,\"lat\":48.7760957},{\"lng\":-117.8722311,\"lat\":33.750631},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-72.1934184,\"lat\":41.3212481},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-77.443014,\"lat\":43.0993},{\"lng\":-83.396897,\"lat\":43.491132},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":-77.4309829,\"lat\":34.7509962},{\"lng\":4.3731644,\"lat\":50.6872135},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-16.9086783,\"lat\":32.6496497},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5135474,\"lat\":52.400739},{\"lng\":-82.9295287,\"lat\":40.126139},{\"lng\":-71.1551119,\"lat\":42.3473519},{\"lng\":-3.2299102,\"lat\":51.6489468},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":2.2958034,\"lat\":48.753613},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-119.7487235,\"lat\":39.5404679},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-8.4726423,\"lat\":51.8985136},{\"lng\":3.3331703,\"lat\":46.5660526},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-112.3842224,\"lat\":33.4674695},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-67.4752615,\"lat\":-45.8632024},{\"lng\":-122.5681191,\"lat\":38.1061979},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-58.5559691,\"lat\":-34.5509077},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-86.0085955,\"lat\":40.0455918},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":-118.396466,\"lat\":34.0211224},{\"lng\":-84.5084835,\"lat\":41.3203058},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-88.4474302,\"lat\":42.3147529},{\"lng\":11.5049302,\"lat\":48.5003308},{\"lng\":17.9500556,\"lat\":59.4293164},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-88.3147539,\"lat\":41.7571701},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":4.5999778,\"lat\":51.8714812},{\"lng\":16.3572556,\"lat\":48.3096359},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":7.749254,\"lat\":46.0212076},{\"lng\":-73.0438362,\"lat\":41.5538091},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-16.2507843,\"lat\":28.467178},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-81.7355692,\"lat\":41.3822398},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-73.9283672,\"lat\":41.7065539},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":0.487531,\"lat\":44.8534568},{\"lng\":-120.832348,\"lat\":35.3107214},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-89.1528176,\"lat\":30.3504751},{\"lng\":-117.3008784,\"lat\":34.4263886},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-117.9294401,\"lat\":33.6170092},{\"lng\":-75.1256812,\"lat\":40.0959385},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-87.2169149,\"lat\":30.421309},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-118.2918113,\"lat\":33.8815702},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":30.7030242,\"lat\":36.8865728},{\"lng\":73.0923253,\"lat\":31.4220558},{\"lng\":-4.728605,\"lat\":41.6521807},{\"lng\":-79.2380322,\"lat\":42.0965167},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":107.0867363,\"lat\":10.3535221},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-77.7105332,\"lat\":34.3676686},{\"lng\":10.8815262,\"lat\":49.5710376},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":144.3598241,\"lat\":-38.1493248},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-83.6117646,\"lat\":42.241051},{\"lng\":-120.339415,\"lat\":50.6758269},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-123.3272489,\"lat\":42.4393707},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":104.9224426,\"lat\":11.568271},{\"lng\":0.714368,\"lat\":47.3390872},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":151.3120675,\"lat\":-33.3117096},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":10.1596948,\"lat\":56.1220185},{\"lng\":11.3927685,\"lat\":47.2654296},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-121.9856782,\"lat\":47.7423219},{\"lng\":-85.784453,\"lat\":42.2094839},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.5512469,\"lat\":40.6523325},{\"lng\":3.7250121,\"lat\":51.0538286},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-0.4011868,\"lat\":54.2820009},{\"lng\":-49.2532691,\"lat\":-16.680882},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-75.9206345,\"lat\":45.2584759},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":6.9239103,\"lat\":43.6589011},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-78.3199496,\"lat\":44.3048009},{\"lng\":5.0297213,\"lat\":43.695131},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-73.8645734,\"lat\":42.2173102},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.43736,\"lat\":44.85028},{\"lng\":44.3953896,\"lat\":35.4719308},{\"lng\":-71.1244966,\"lat\":42.2912093},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-118.1085554,\"lat\":34.0990995},{\"lng\":-1.5518632,\"lat\":47.2996846},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.8409057,\"lat\":41.2736163},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-122.2070775,\"lat\":47.6765382},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-1.4315213,\"lat\":43.6403659},{\"lng\":-97.4394816,\"lat\":35.2225717},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-78.1677784,\"lat\":43.9595998},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":-99.3698995,\"lat\":40.4379956},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":-74.1143091,\"lat\":40.6687141},{\"lng\":-97.9647269,\"lat\":29.5688411},{\"lng\":-0.7734022,\"lat\":48.0706687},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":87.6380633,\"lat\":26.6637932},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":12.5051413,\"lat\":55.7718649},{\"lng\":-89.2897646,\"lat\":43.0123487},{\"lng\":-122.9146292,\"lat\":49.2041754},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-5.2276468,\"lat\":50.233989},{\"lng\":-81.275054,\"lat\":33.8986841},{\"lng\":-120.7678602,\"lat\":37.1641544},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.028878,\"lat\":52.2029156},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.748344,\"lat\":48.8741286},{\"lng\":-77.7191081,\"lat\":39.6430455},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-69.942111,\"lat\":18.4801972},{\"lng\":-90.3215983,\"lat\":32.3410552},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-82.3269883,\"lat\":27.871197},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":9.4616921,\"lat\":52.5045772},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":33.8307062,\"lat\":27.222556},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":-84.4310645,\"lat\":10.3267699},{\"lng\":10.7807299,\"lat\":48.7180364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.677556,\"lat\":39.049011},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-0.4675041,\"lat\":52.1363806},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":21.0714322,\"lat\":52.2337172},{\"lng\":4.0328094,\"lat\":45.204168},{\"lng\":12.4985492,\"lat\":55.704111},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":146.9135265,\"lat\":-36.0737734},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-117.147366,\"lat\":33.4946353},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-0.3004067,\"lat\":51.5149803},{\"lng\":-76.7074042,\"lat\":37.2708788},{\"lng\":-111.8953815,\"lat\":40.5710454},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-122.3455263,\"lat\":37.9621457},{\"lng\":12.9569266,\"lat\":52.2288191},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":4.3628851,\"lat\":48.9566218},{\"lng\":123.0250585,\"lat\":10.6163458},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.4381568,\"lat\":49.4704113},{\"lng\":-0.0472059,\"lat\":38.6028245},{\"lng\":101.6454202,\"lat\":3.0988792},{\"lng\":17.965219,\"lat\":40.335126},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":-4.0816846,\"lat\":52.4143113},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-84.2747329,\"lat\":34.0709576},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-113.584131,\"lat\":37.104153},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":-2.7990345,\"lat\":54.0484068},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":23.6470593,\"lat\":37.9431594},{\"lng\":-156.3103925,\"lat\":20.8539162},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-90.3567669,\"lat\":37.4914691},{\"lng\":6.7871219,\"lat\":50.6612623},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":11.3927685,\"lat\":47.2654296},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":50.1039991,\"lat\":26.4367824},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":7.6580337,\"lat\":47.8736185},{\"lng\":10.3678235,\"lat\":53.4374683},{\"lng\":-86.1090828,\"lat\":42.7876022},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.4675021,\"lat\":42.3712},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-80.6923169,\"lat\":32.3850708},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-0.3623924,\"lat\":51.4619551},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-119.593249,\"lat\":49.5003268},{\"lng\":150.89385,\"lat\":-34.4243941},{\"lng\":0.0930414,\"lat\":50.9705836},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-109.92006,\"lat\":22.8938884},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.607077,\"lat\":48.2630217},{\"lng\":-76.4537302,\"lat\":41.0044958},{\"lng\":-120.339415,\"lat\":50.6758269},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.0415528,\"lat\":39.9980022},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":8.531245,\"lat\":50.570561},{\"lng\":-83.9890066,\"lat\":33.9566391},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":8.4259004,\"lat\":47.384708},{\"lng\":-86.1283681,\"lat\":39.9784186},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-79.756817,\"lat\":34.1280501},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-122.0335624,\"lat\":37.9768525},{\"lng\":9.7037748,\"lat\":48.6967865},{\"lng\":-117.9294401,\"lat\":33.6170092},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":-70.8967226,\"lat\":42.5195292},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-77.6473195,\"lat\":37.486806},{\"lng\":-155.66391,\"lat\":20.020452},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-89.0226793,\"lat\":42.6829765},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":0.2207441,\"lat\":51.5617734},{\"lng\":-99.7414869,\"lat\":40.7788486},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-97.8772103,\"lat\":29.9892928},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-87.0717718,\"lat\":20.6269889},{\"lng\":-123.1059324,\"lat\":44.6365071},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-0.4440957,\"lat\":44.9954151},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-93.2349489,\"lat\":45.1607987},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":8.849423,\"lat\":53.0684356},{\"lng\":121.0589931,\"lat\":14.5637482},{\"lng\":-86.621443,\"lat\":36.3049177},{\"lng\":-102.5722706,\"lat\":22.7753891},{\"lng\":0.2255168,\"lat\":49.1460831},{\"lng\":-0.7449925,\"lat\":51.4143513},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-78.8900409,\"lat\":33.6956461},{\"lng\":-0.23054,\"lat\":51.408966},{\"lng\":8.554163,\"lat\":50.8417001},{\"lng\":-70.2177099,\"lat\":44.0990717},{\"lng\":11.6038619,\"lat\":52.1885647},{\"lng\":-74.1979277,\"lat\":40.7934789},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":8.079534,\"lat\":47.373166},{\"lng\":-0.3557651,\"lat\":44.6508185},{\"lng\":-94.8907869,\"lat\":47.4785418},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":9.6541116,\"lat\":48.7031377},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-83.2965971,\"lat\":42.3833698},{\"lng\":-8.3959425,\"lat\":43.3709703},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":9.4236655,\"lat\":50.6656227},{\"lng\":12.1818964,\"lat\":55.4565009},{\"lng\":115.7393915,\"lat\":-32.3006647},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.2250324,\"lat\":46.2051192},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-2.8908955,\"lat\":53.1908873},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-3.5505644,\"lat\":47.8692882},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-117.64843,\"lat\":34.065846},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.7785644,\"lat\":45.7754498},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-118.3935254,\"lat\":33.8897798},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":6.1226129,\"lat\":46.1758901},{\"lng\":-9.0490601,\"lat\":53.2744122},{\"lng\":-94.1574328,\"lat\":36.0625843},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-75.4179623,\"lat\":41.1770316},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.1296075,\"lat\":48.8063265},{\"lng\":2.510611,\"lat\":48.8137847},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.6279321,\"lat\":41.5571178},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":-73.9695409,\"lat\":41.5048402},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.32931,\"lat\":51.2955044},{\"lng\":-117.690075,\"lat\":34.0133561},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-92.0490096,\"lat\":30.317144},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-79.9414313,\"lat\":37.270973},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-83.810138,\"lat\":39.9234046},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":3.2899107,\"lat\":46.3074423},{\"lng\":0.9386329,\"lat\":52.6802052},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":7.9429235,\"lat\":48.4695984},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-75.1438863,\"lat\":39.770683},{\"lng\":-70.654259,\"lat\":-33.4626422},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-116.9739167,\"lat\":32.8383828},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-88.0599986,\"lat\":44.4493584},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-71.2084061,\"lat\":46.8137431},{\"lng\":9.6431145,\"lat\":47.8075299},{\"lng\":-111.6944313,\"lat\":40.2981599},{\"lng\":6.5928442,\"lat\":46.5349093},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-93.530214,\"lat\":47.237166},{\"lng\":4.8423304,\"lat\":45.7969952},{\"lng\":-98.9736172,\"lat\":18.8150158},{\"lng\":-82.8121191,\"lat\":39.9547861},{\"lng\":-0.4646064,\"lat\":46.3239233},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-13.8599051,\"lat\":28.4993424},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":-1.1246168,\"lat\":53.3042362},{\"lng\":4.3660765,\"lat\":45.4037177},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-96.8863922,\"lat\":33.0890094},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-81.6499356,\"lat\":31.1407032},{\"lng\":0.1113306,\"lat\":43.1607605},{\"lng\":-2.8277046,\"lat\":51.3908826},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5424424,\"lat\":50.8095801},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":-123.2077861,\"lat\":39.1501662},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.5872286,\"lat\":42.291707},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-78.9361468,\"lat\":42.7111701},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-117.760056,\"lat\":33.9926803},{\"lng\":-90.1830408,\"lat\":32.2998686},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-58.7965583,\"lat\":-34.4534551},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-74.0323752,\"lat\":40.7433066},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.4775114,\"lat\":51.546655},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.6433146,\"lat\":42.7269261},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":6.4779448,\"lat\":46.3731303},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-2.4251259,\"lat\":53.5735158},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":6.0207779,\"lat\":46.243244},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-81.9468057,\"lat\":41.3131066},{\"lng\":-95.7908195,\"lat\":36.0525993},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":7.5943951,\"lat\":50.3533278},{\"lng\":-123.3417381,\"lat\":43.216505},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":103.8500437,\"lat\":1.296168},{\"lng\":-78.1677784,\"lat\":43.9595998},{\"lng\":-95.555513,\"lat\":33.6617962},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.5707519,\"lat\":43.4046491},{\"lng\":-1.1420694,\"lat\":45.7687967},{\"lng\":-116.0833144,\"lat\":34.8253019},{\"lng\":-122.5681191,\"lat\":38.1061979},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-82.3984882,\"lat\":34.851354},{\"lng\":9.1895147,\"lat\":48.8953937},{\"lng\":28.2009844,\"lat\":47.8392391},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":5.6221058,\"lat\":6.3330586},{\"lng\":-0.7465033,\"lat\":52.0348915},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-120.375716,\"lat\":35.3540209},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-77.1951755,\"lat\":38.838703},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":-80.5607951,\"lat\":28.0684067},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":43.9837257,\"lat\":36.1672128},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":0.8722566,\"lat\":51.148555},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":6.1042772,\"lat\":52.2356369},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-123.763124,\"lat\":49.4721147},{\"lng\":5.7455106,\"lat\":52.0716825},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":0.5321089,\"lat\":51.0965459},{\"lng\":5.3503555,\"lat\":60.5110194},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":5.6662814,\"lat\":51.9663016},{\"lng\":-71.1631137,\"lat\":42.7070354},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":2.1138977,\"lat\":41.5421013},{\"lng\":-117.9463717,\"lat\":33.7746292},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":3.3848084,\"lat\":39.6046865},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-2.8908955,\"lat\":53.1908873},{\"lng\":2.9469339,\"lat\":50.4191721},{\"lng\":100.4974327,\"lat\":13.9120701},{\"lng\":-91.5299106,\"lat\":41.6612561},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-71.4558911,\"lat\":41.6603788},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-3.2568304,\"lat\":54.0977012},{\"lng\":-77.0849245,\"lat\":38.9813699},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":-79.7966835,\"lat\":43.3248924},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-81.6182086,\"lat\":33.5723191},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-1.1857007,\"lat\":43.6569623},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-0.0144629,\"lat\":51.5110713},{\"lng\":4.2334587,\"lat\":48.5161872},{\"lng\":-2.3742854,\"lat\":57.2839493},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":8.5461079,\"lat\":50.2062948},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-94.70496,\"lat\":37.4108841},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-21.8852649,\"lat\":64.0975595},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":-121.9746797,\"lat\":37.226611},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-122.0215737,\"lat\":37.5872576},{\"lng\":-3.5269209,\"lat\":50.7256138},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.9688855,\"lat\":54.2485576},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":-82.9780695,\"lat\":42.2858536},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-111.9395211,\"lat\":40.6061337},{\"lng\":-71.5412101,\"lat\":41.8310404},{\"lng\":-122.657047,\"lat\":49.1039289},{\"lng\":-0.9786725,\"lat\":51.9983175},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-97.1420308,\"lat\":32.563487},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5313816,\"lat\":38.8898478},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":132.4758818,\"lat\":34.3971315},{\"lng\":6.3024961,\"lat\":46.3059806},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":13.08824,\"lat\":52.5606426},{\"lng\":-85.5800022,\"lat\":42.2011538},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":10.0929593,\"lat\":48.8375607},{\"lng\":-8.2955712,\"lat\":41.4417677},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":6.9239103,\"lat\":43.6589011},{\"lng\":11.4738309,\"lat\":47.29282},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.7087667,\"lat\":45.9751893},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0093129,\"lat\":40.7856117},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.684294,\"lat\":40.9808209},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":3.5021158,\"lat\":43.6499836},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":-73.3734547,\"lat\":40.6867667},{\"lng\":-76.8861122,\"lat\":40.2663107},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":6.8031625,\"lat\":50.8027168},{\"lng\":5.36109,\"lat\":61.3187823},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-122.1598465,\"lat\":37.4443293},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":8.8371266,\"lat\":50.1438711},{\"lng\":-2.4791931,\"lat\":47.2771383},{\"lng\":1.6272972,\"lat\":43.0424295},{\"lng\":-122.8284874,\"lat\":47.6395373},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":10.135555,\"lat\":54.3227085},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.3373021,\"lat\":48.7790514},{\"lng\":-87.6651467,\"lat\":41.5574046},{\"lng\":-117.3703235,\"lat\":34.1064001},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.9194212,\"lat\":43.839826},{\"lng\":-77.7485516,\"lat\":39.9259345},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-79.6443879,\"lat\":43.5896231},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":-81.2084941,\"lat\":28.6702526},{\"lng\":-1.7822482,\"lat\":53.6466645},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-73.0918715,\"lat\":41.8580338},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-117.019529,\"lat\":32.5317397},{\"lng\":-99.1332716,\"lat\":19.4933046},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-86.0085955,\"lat\":40.0455918},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-84.7477136,\"lat\":33.7514966},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-80.0351117,\"lat\":43.6340679},{\"lng\":2.2465748,\"lat\":48.9069349},{\"lng\":-122.1702445,\"lat\":37.427467},{\"lng\":-81.330414,\"lat\":48.477473},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":6.8444162,\"lat\":46.753921},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-157.7960716,\"lat\":21.4055},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":10.1808016,\"lat\":47.9863099},{\"lng\":-104.858682,\"lat\":39.3722552},{\"lng\":13.8456344,\"lat\":58.3896329},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.4659275,\"lat\":43.6307863},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-121.3153096,\"lat\":44.0581728},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-3.8492688,\"lat\":40.1248436},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":5.0924352,\"lat\":51.8937356},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-73.7629097,\"lat\":41.0339862},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-16.9086783,\"lat\":32.6496497},{\"lng\":2.1266886,\"lat\":48.8035403},{\"lng\":-99.1955083,\"lat\":19.5370001},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":6.3702817,\"lat\":46.264918},{\"lng\":-2.3655434,\"lat\":53.7541156},{\"lng\":-122.33931,\"lat\":47.313494},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":106.8838584,\"lat\":47.9081991},{\"lng\":-71.1040018,\"lat\":42.3656347},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-116.9629378,\"lat\":44.0265525},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-76.8485094,\"lat\":39.0984317},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.92926,\"lat\":45.639968},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-1.4761491,\"lat\":52.9212617},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":7.1612669,\"lat\":46.8055656},{\"lng\":-122.039966,\"lat\":38.2493581},{\"lng\":2.3872525,\"lat\":48.8122302},{\"lng\":-52.7066964,\"lat\":47.5646794},{\"lng\":-75.3851334,\"lat\":40.0947624},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-71.889038,\"lat\":45.403271},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":13.5027631,\"lat\":59.3809146},{\"lng\":-58.3016167,\"lat\":-34.7476798},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.1765814,\"lat\":35.3137739},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-0.549372,\"lat\":42.5692515},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.71573,\"lat\":25.9372513},{\"lng\":-113.2857941,\"lat\":54.7214539},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-93.0552437,\"lat\":34.5038393},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-72.3102794,\"lat\":43.6482811},{\"lng\":-80.2497707,\"lat\":26.2128609},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-75.7774177,\"lat\":40.5173165},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-71.1994976,\"lat\":42.194543},{\"lng\":-83.3527097,\"lat\":42.36837},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-93.2432791,\"lat\":44.650051},{\"lng\":-74.2107006,\"lat\":40.6639916},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":2.3194375,\"lat\":48.8188544},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-71.3495035,\"lat\":42.5292605},{\"lng\":-69.942111,\"lat\":18.4801972},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":-1.3939844,\"lat\":43.6637121},{\"lng\":-90.3715909,\"lat\":38.7761446},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.2630238,\"lat\":48.8003835},{\"lng\":-113.366399,\"lat\":43.735735},{\"lng\":-80.9968286,\"lat\":29.1386874},{\"lng\":-72.0584234,\"lat\":44.0792316},{\"lng\":-3.9459248,\"lat\":51.6195955},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-0.0123189,\"lat\":51.5246287},{\"lng\":-82.1811947,\"lat\":28.2336196},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-87.9403418,\"lat\":41.8994745},{\"lng\":-122.780542,\"lat\":49.2621643},{\"lng\":-0.5732063,\"lat\":51.2356068},{\"lng\":13.0085489,\"lat\":50.7405217},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-94.992736,\"lat\":29.3872254},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.1342796,\"lat\":49.7588883},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-70.7693304,\"lat\":41.8894422},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":-108.56448,\"lat\":39.0672568},{\"lng\":-83.1668713,\"lat\":42.4805913},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-123.8057607,\"lat\":39.4436579},{\"lng\":1.4353783,\"lat\":38.9072784},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-84.5697965,\"lat\":42.8424784},{\"lng\":-71.889038,\"lat\":45.403271},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":2.2453842,\"lat\":48.7144587},{\"lng\":6.8569063,\"lat\":46.4537524},{\"lng\":-78.9421751,\"lat\":43.87982},{\"lng\":-84.7668495,\"lat\":43.597646},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":0.2433695,\"lat\":52.2416427},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.3033105,\"lat\":51.3937557},{\"lng\":-86.37416,\"lat\":39.6128243},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.8908955,\"lat\":53.1908873},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.3019814,\"lat\":48.8211559},{\"lng\":-88.1170784,\"lat\":43.1790768},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-76.8317417,\"lat\":39.2757359},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-85.3094883,\"lat\":35.0457219},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":6.122827,\"lat\":49.3278069},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":24.0168024,\"lat\":35.5158141},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-74.333495,\"lat\":40.2852895},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-64.3723708,\"lat\":45.9079431},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":5.0660616,\"lat\":51.5856184},{\"lng\":-89.9559348,\"lat\":38.7236594},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.2779124,\"lat\":51.9486943},{\"lng\":-71.0931485,\"lat\":41.9019257},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-117.2424787,\"lat\":33.2021284},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-118.39524,\"lat\":37.363679},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-72.6071119,\"lat\":42.1487691},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-77.4486772,\"lat\":38.885219},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.7689951,\"lat\":49.4432174},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":5.1740496,\"lat\":45.7500102},{\"lng\":120.695345,\"lat\":27.9963899},{\"lng\":12.0595795,\"lat\":47.8556623},{\"lng\":7.6251879,\"lat\":51.9625101},{\"lng\":9.4978479,\"lat\":51.3157833},{\"lng\":2.6500745,\"lat\":39.5695818},{\"lng\":-85.9213796,\"lat\":39.2014405},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":-81.9284776,\"lat\":37.8024603},{\"lng\":-84.1468616,\"lat\":33.4473361},{\"lng\":-2.5313108,\"lat\":53.1920711},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.2385432,\"lat\":48.8126688},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-122.824222,\"lat\":38.4021038},{\"lng\":-82.9069508,\"lat\":42.4435616},{\"lng\":-98.2363318,\"lat\":29.8867349},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-123.1342796,\"lat\":49.7588883},{\"lng\":-119.275205,\"lat\":46.2804298},{\"lng\":8.7123912,\"lat\":50.011974},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-75.3068878,\"lat\":39.9483282},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-83.4430002,\"lat\":42.8522506},{\"lng\":-124.0159522,\"lat\":44.9617922},{\"lng\":-71.2472913,\"lat\":43.6542439},{\"lng\":5.6221058,\"lat\":6.3330586},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":-116.559631,\"lat\":43.5737361},{\"lng\":-106.0465486,\"lat\":39.4829124},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-86.8254383,\"lat\":21.1855431},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":9.242431,\"lat\":50.4411156},{\"lng\":-3.4270534,\"lat\":47.7354591},{\"lng\":8.1061259,\"lat\":51.5725501},{\"lng\":-75.2718507,\"lat\":39.9381682},{\"lng\":-90.485784,\"lat\":30.0771675},{\"lng\":-83.8881711,\"lat\":43.5962107},{\"lng\":2.48291,\"lat\":48.9031},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-73.8381351,\"lat\":42.6251239},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.2897124,\"lat\":48.7997756},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":4.7169554,\"lat\":49.7804687},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":-74.4118169,\"lat\":40.3178867},{\"lng\":-98.1257348,\"lat\":29.7028266},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-74.9829443,\"lat\":39.8115033},{\"lng\":4.8078783,\"lat\":44.1371311},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-80.0942087,\"lat\":26.9342246},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-116.392326,\"lat\":43.6086295},{\"lng\":9.3509475,\"lat\":45.5761735},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.44074,\"lat\":43.2877},{\"lng\":27.4962548,\"lat\":38.4549686},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":-82.652893,\"lat\":46.373464},{\"lng\":-0.1726236,\"lat\":51.6482779},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":6.553745,\"lat\":46.5512503},{\"lng\":-59.0978393,\"lat\":-35.1856322},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":4.4811089,\"lat\":52.1518157},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-0.9700664,\"lat\":51.4564242},{\"lng\":-103.338396,\"lat\":20.6720375},{\"lng\":-84.180897,\"lat\":39.4203978},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.7630148,\"lat\":51.2494169},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":2.4159739,\"lat\":48.8432434},{\"lng\":-100.384479,\"lat\":21.0012598},{\"lng\":-91.3932118,\"lat\":44.9371325},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":11.0960722,\"lat\":53.0989099},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.4985492,\"lat\":55.704111},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-123.8319802,\"lat\":46.1882007},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-80.9239671,\"lat\":36.6612387},{\"lng\":-0.4865787,\"lat\":51.1407587},{\"lng\":-158.0211735,\"lat\":21.5010609},{\"lng\":-0.0117661,\"lat\":51.1322179},{\"lng\":-106.0465486,\"lat\":39.4829124},{\"lng\":-1.6414898,\"lat\":48.1817122},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":11.9593734,\"lat\":49.0250012},{\"lng\":-72.5976987,\"lat\":41.9791024},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-74.2301459,\"lat\":40.701213},{\"lng\":-76.0372354,\"lat\":45.6402189},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":10.5236066,\"lat\":52.2646577},{\"lng\":-72.0759008,\"lat\":41.5243537},{\"lng\":7.219985,\"lat\":51.5380394},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.1024635,\"lat\":50.7352621},{\"lng\":-79.9546341,\"lat\":43.2661904},{\"lng\":-80.9818016,\"lat\":43.3700899},{\"lng\":-88.9843937,\"lat\":40.5092961},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.701098,\"lat\":38.3396367},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":3.3941795,\"lat\":6.4550575},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.2368863,\"lat\":48.8841522},{\"lng\":-121.2810611,\"lat\":38.7071247},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-74.8623849,\"lat\":39.7765048},{\"lng\":-43.9450948,\"lat\":-19.9227318},{\"lng\":4.3212622,\"lat\":45.4348987},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":3.1212505,\"lat\":39.8532473},{\"lng\":-0.6149074,\"lat\":51.1857892},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":1.2161321,\"lat\":44.8879431},{\"lng\":-75.9042674,\"lat\":41.2432536},{\"lng\":-82.8001026,\"lat\":27.9658533},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.9373912,\"lat\":41.7841956},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-122.0832101,\"lat\":37.3893889},{\"lng\":-13.8693225,\"lat\":28.7400646},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.3195789,\"lat\":48.8647637},{\"lng\":-83.4754913,\"lat\":42.48059},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-84.2193334,\"lat\":39.0274538},{\"lng\":11.9382855,\"lat\":58.3490555},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-1.5813204,\"lat\":48.8488845},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":1.7537638,\"lat\":52.4766308},{\"lng\":1.8967943,\"lat\":43.9016766},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-1.4315213,\"lat\":43.6403659},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":3.2492577,\"lat\":45.7971315},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":6.2351431,\"lat\":44.0918144},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-83.810138,\"lat\":39.9234046},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.4718299,\"lat\":48.8046989},{\"lng\":3.0041906,\"lat\":43.1837757},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-70.151825,\"lat\":44.671094},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-73.6292667,\"lat\":45.4325141},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":-1.7854322,\"lat\":51.5615327},{\"lng\":6.1915748,\"lat\":45.951157},{\"lng\":2.1779083,\"lat\":48.9134112},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-82.8890965,\"lat\":42.4969652},{\"lng\":4.9441635,\"lat\":45.6965347},{\"lng\":-1.4149834,\"lat\":43.4694806},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-3.3660907,\"lat\":47.7477336},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-85.0030617,\"lat\":41.941091},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":0.6425012,\"lat\":51.9453005},{\"lng\":-71.065573,\"lat\":42.2501425},{\"lng\":-121.78167,\"lat\":42.224867},{\"lng\":0.2255168,\"lat\":49.1460831},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-74.0243916,\"lat\":41.503557},{\"lng\":-113.491241,\"lat\":53.5462055},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.334267,\"lat\":48.911729},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.5243682,\"lat\":39.158168},{\"lng\":-47.8828,\"lat\":-15.7939869},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":14.4901093,\"lat\":35.8956788},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":-57.5482079,\"lat\":-37.9976168},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":8.0599414,\"lat\":47.5671976},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":8.5976831,\"lat\":47.260692},{\"lng\":-73.7926335,\"lat\":41.1328736},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-75.5274568,\"lat\":45.4068372},{\"lng\":-78.8635324,\"lat\":43.8975558},{\"lng\":-114.1493997,\"lat\":46.4148155},{\"lng\":-95.6971686,\"lat\":29.9691116},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":9.0205888,\"lat\":46.1920538},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.3503555,\"lat\":60.5110194},{\"lng\":-118.0577568,\"lat\":34.1082994},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-80.8100724,\"lat\":35.5848596},{\"lng\":-0.6294321,\"lat\":43.3708943},{\"lng\":-76.7455478,\"lat\":39.2609921},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-59.1488389,\"lat\":-37.2919426},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":9.2794469,\"lat\":41.5911382},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-99.6569007,\"lat\":19.292545},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":7.0581152,\"lat\":46.6190969},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":5.4389442,\"lat\":43.7729328},{\"lng\":9.218655,\"lat\":49.142291},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-73.9726508,\"lat\":40.8929329},{\"lng\":38.7524127,\"lat\":9.0358287},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":6.0243622,\"lat\":47.2380222},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-76.5136495,\"lat\":37.2356655},{\"lng\":17.0326689,\"lat\":51.1089776},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-147.716675,\"lat\":64.837845},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-118.7619719,\"lat\":34.1792025},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-74.4439254,\"lat\":40.4951365},{\"lng\":0.3135215,\"lat\":48.2522145},{\"lng\":-48.6643444,\"lat\":-28.241827},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-73.5293246,\"lat\":40.7695303},{\"lng\":-88.7713953,\"lat\":41.8903447},{\"lng\":9.9614889,\"lat\":53.8371714},{\"lng\":-80.0983887,\"lat\":-2.2895167},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-85.6165976,\"lat\":44.7606481},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-73.5107732,\"lat\":42.7091389},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-97.3404854,\"lat\":32.9616819},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":9.1282868,\"lat\":55.9445468},{\"lng\":-96.5722411,\"lat\":33.2862455},{\"lng\":-122.6246836,\"lat\":47.5653663},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-80.5222961,\"lat\":43.4652699},{\"lng\":-6.8408929,\"lat\":34.0218454},{\"lng\":-80.4706078,\"lat\":27.816415},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-73.7517983,\"lat\":40.9278769},{\"lng\":7.7689368,\"lat\":48.1918267},{\"lng\":8.7473608,\"lat\":50.3681107},{\"lng\":-72.7364844,\"lat\":41.7117668},{\"lng\":-95.1846301,\"lat\":30.0497077},{\"lng\":-3.1474212,\"lat\":52.6600742},{\"lng\":-73.4856789,\"lat\":41.4664832},{\"lng\":-122.2988587,\"lat\":38.0043667},{\"lng\":5.0548176,\"lat\":43.4057279},{\"lng\":2.2105491,\"lat\":48.9250016},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.4136767,\"lat\":37.2296566},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-81.5267403,\"lat\":29.4044186},{\"lng\":2.0997927,\"lat\":41.3598601},{\"lng\":-122.5449763,\"lat\":37.9060368},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-65.2038133,\"lat\":-26.8303703},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":17.9500556,\"lat\":59.4293164},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-5.9226718,\"lat\":37.283689},{\"lng\":-87.1761455,\"lat\":41.5758708},{\"lng\":4.2074197,\"lat\":51.9930016},{\"lng\":6.1763552,\"lat\":49.1196964},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":1.4442469,\"lat\":43.6044622},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-83.1763145,\"lat\":42.3222599},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":13.08824,\"lat\":52.5606426},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.8064922,\"lat\":45.8640034},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-71.8272911,\"lat\":41.3775996},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":17.752136,\"lat\":59.4777776},{\"lng\":-3.2869398,\"lat\":58.8520573},{\"lng\":-83.0062746,\"lat\":42.4932575},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":0.1826107,\"lat\":51.5747271},{\"lng\":-7.4155628,\"lat\":37.1946052},{\"lng\":-76.8861122,\"lat\":40.2663107},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-7.9138664,\"lat\":40.6574713},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-117.9294401,\"lat\":33.6170092},{\"lng\":8.0257947,\"lat\":47.8518286},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-84.2958988,\"lat\":39.174625},{\"lng\":-81.275054,\"lat\":33.8986841},{\"lng\":-75.602387,\"lat\":41.4688301},{\"lng\":-111.651822,\"lat\":35.1987522},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.1374969,\"lat\":41.4910324},{\"lng\":2.3226786,\"lat\":48.8661905},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-77.2651762,\"lat\":38.9013729},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-81.3800824,\"lat\":30.2274645},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-87.5088712,\"lat\":38.6911371},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-70.6624608,\"lat\":42.6153595},{\"lng\":-116.5016784,\"lat\":33.961124},{\"lng\":8.2902,\"lat\":50.2147},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-84.5822632,\"lat\":33.8188333},{\"lng\":8.6736295,\"lat\":49.8851869},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-86.1649421,\"lat\":34.1983281},{\"lng\":-90.481677,\"lat\":38.783855},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":0.4757363,\"lat\":51.5754602},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":2.7310072,\"lat\":47.9978628},{\"lng\":-104.985181,\"lat\":39.8695516},{\"lng\":-89.0226793,\"lat\":42.6829765},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-4.0855906,\"lat\":52.5861123},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":5.0286859,\"lat\":52.0262053},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":7.6251879,\"lat\":51.9625101},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-3.000425,\"lat\":51.5887675},{\"lng\":-80.0728201,\"lat\":26.4614625},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-91.1869659,\"lat\":30.4494155},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":13.7381437,\"lat\":51.0493286},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-0.9392027,\"lat\":51.0024945},{\"lng\":7.7861959,\"lat\":47.5605924},{\"lng\":-73.87619,\"lat\":45.67932},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":7.6251879,\"lat\":51.9625101},{\"lng\":75.8681996,\"lat\":22.7203616},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8534326,\"lat\":46.7831001},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-40.2460053,\"lat\":-15.2454478},{\"lng\":-90.6106819,\"lat\":39.6272694},{\"lng\":2.2545943,\"lat\":41.9302021},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":5.36109,\"lat\":61.3187823},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-105.0372046,\"lat\":39.8366528},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-122.7141049,\"lat\":38.4404925},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":7.815973,\"lat\":47.3069637},{\"lng\":-81.684004,\"lat\":36.2187873},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":-74.0323752,\"lat\":40.7433066},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":-70.9753978,\"lat\":43.3050758},{\"lng\":-77.0011096,\"lat\":41.2411556},{\"lng\":-71.889038,\"lat\":45.403271},{\"lng\":-2.0163917,\"lat\":52.5039074},{\"lng\":-99.2599579,\"lat\":18.9331321},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-89.5230357,\"lat\":37.3034933},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":-75.662956,\"lat\":39.6159851},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-84.853838,\"lat\":38.9495047},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":9.6979598,\"lat\":53.7278939},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-87.7834769,\"lat\":42.7313756},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-70.4533844,\"lat\":43.4925843},{\"lng\":18.6540233,\"lat\":54.3482907},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":2.6500745,\"lat\":39.5695818},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":6.5506458,\"lat\":52.997225},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-79.684768,\"lat\":34.6173516},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.6251879,\"lat\":51.9625101},{\"lng\":6.7537317,\"lat\":46.5730628},{\"lng\":-84.0479643,\"lat\":35.8217479},{\"lng\":-4.6867447,\"lat\":36.6421248},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":8.6938161,\"lat\":50.5808795},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-1.6683537,\"lat\":47.2632611},{\"lng\":1.0802533,\"lat\":51.2800275},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-68.183899,\"lat\":48.583875},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-123.3272489,\"lat\":42.4393707},{\"lng\":-2.2206585,\"lat\":52.1911849},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.59393,\"lat\":43.65506},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-3.8243251,\"lat\":53.322475},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-6.2036691,\"lat\":36.6141547},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.9852679,\"lat\":52.5841365},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":-71.0542002,\"lat\":42.4085897},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-78.3199496,\"lat\":44.3048009},{\"lng\":-74.5143232,\"lat\":40.9012101},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.3010624,\"lat\":32.3512601},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":-8.5122705,\"lat\":38.3729735},{\"lng\":-3.032721,\"lat\":48.800878},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-122.12883,\"lat\":37.834897},{\"lng\":-116.0775155,\"lat\":44.7325107},{\"lng\":8.7291498,\"lat\":47.4991723},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-73.0454164,\"lat\":40.871241},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-118.129807,\"lat\":34.051522},{\"lng\":2.7015872,\"lat\":48.4049375},{\"lng\":-76.307162,\"lat\":40.1571324},{\"lng\":-81.2353683,\"lat\":28.7225829},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":1.0181293,\"lat\":49.0452346},{\"lng\":6.9963543,\"lat\":43.6008898},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-84.105006,\"lat\":40.7399785},{\"lng\":-80.1353006,\"lat\":25.7929198},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-5.9336562,\"lat\":54.5842881},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":5.2176582,\"lat\":52.3722582},{\"lng\":-6.1513647,\"lat\":53.4862405},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-83.2646624,\"lat\":42.8247524},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":5.2002043,\"lat\":43.9110641},{\"lng\":-88.0437509,\"lat\":30.6913462},{\"lng\":-116.2958789,\"lat\":33.677474},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.2424787,\"lat\":33.2021284},{\"lng\":2.6500745,\"lat\":39.5695818},{\"lng\":24.7499297,\"lat\":42.1418541},{\"lng\":-73.9701382,\"lat\":40.8509333},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":145.4863217,\"lat\":-38.0806283},{\"lng\":-107.7447813,\"lat\":38.1833236},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-71.346996,\"lat\":42.2836393},{\"lng\":0.8994651,\"lat\":51.8896903},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-123.1059324,\"lat\":44.6365071},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.2092214,\"lat\":42.3370414},{\"lng\":-76.8317417,\"lat\":39.2757359},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-86.8425761,\"lat\":21.1527467},{\"lng\":-93.1010141,\"lat\":41.3144108},{\"lng\":148.9372222,\"lat\":-33.2933333},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":121.0616503,\"lat\":14.5578167},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-83.4675021,\"lat\":42.3712},{\"lng\":-77.515298,\"lat\":43.090959},{\"lng\":-1.4471035,\"lat\":55.0087655},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-117.2424787,\"lat\":33.2021284},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":9.573777,\"lat\":49.9947528},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-90.7195348,\"lat\":29.5957696},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":30.061507,\"lat\":-1.950851},{\"lng\":-74.665452,\"lat\":40.904011},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":11.3763014,\"lat\":47.7518502},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":7.9020696,\"lat\":53.5736426},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":7.6824892,\"lat\":45.0677551},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-74.8291638,\"lat\":40.8538944},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-98.2300605,\"lat\":26.204114},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-85.969951,\"lat\":31.8087678},{\"lng\":-68.330514,\"lat\":-34.6126025},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-2.4251259,\"lat\":53.5735158},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":1.3337639,\"lat\":47.5876861},{\"lng\":-79.1262839,\"lat\":40.6424116},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-106.831735,\"lat\":40.4848003},{\"lng\":-122.2127011,\"lat\":47.9793437},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-83.7596557,\"lat\":40.3611643},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-74.4659275,\"lat\":43.6307863},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-81.4410425,\"lat\":27.4957453},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":9.9966023,\"lat\":48.3904657},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-73.1968205,\"lat\":42.8788667},{\"lng\":-122.33931,\"lat\":47.313494},{\"lng\":-122.6246836,\"lat\":47.5653663},{\"lng\":4.3181187,\"lat\":50.811795},{\"lng\":9.9215263,\"lat\":57.0462626},{\"lng\":-85.4807825,\"lat\":32.6098566},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-97.6788056,\"lat\":30.5085915},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-99.2327986,\"lat\":19.4788356},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":121.4589414,\"lat\":25.061706},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":6.0525071,\"lat\":45.8842342},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":7.0134418,\"lat\":43.5515198},{\"lng\":8.2146017,\"lat\":53.1389753},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":12.0974869,\"lat\":49.0195333},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-82.9780695,\"lat\":42.2858536},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":150.86499,\"lat\":-33.7822832},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":2.3212492,\"lat\":48.8642313},{\"lng\":-60.6617024,\"lat\":-32.9593609},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-97.4981698,\"lat\":25.9024289},{\"lng\":-122.0607963,\"lat\":37.9479786},{\"lng\":-122.301411,\"lat\":37.9154056},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":4.4285918,\"lat\":52.1809225},{\"lng\":-74.1496048,\"lat\":40.5834557},{\"lng\":-74.3483059,\"lat\":40.651726},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.8944,\"lat\":49.9675456},{\"lng\":-3.5995337,\"lat\":37.1734995},{\"lng\":-84.1170163,\"lat\":9.9981515},{\"lng\":-84.5822632,\"lat\":33.8188333},{\"lng\":-0.4652452,\"lat\":47.4460674},{\"lng\":7.5878261,\"lat\":47.5581077},{\"lng\":-16.9086783,\"lat\":32.6496497},{\"lng\":-78.7391813,\"lat\":35.5071045},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":30.2368381,\"lat\":1.5642298},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":4.7449605,\"lat\":52.4681109},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":7.4472685,\"lat\":48.6373266},{\"lng\":-99.1906167,\"lat\":19.4071156},{\"lng\":9.1895147,\"lat\":48.8953937},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-78.8893999,\"lat\":38.0686668},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-2.4194132,\"lat\":52.5345626},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":8.9520281,\"lat\":46.0050102},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-100.1850769,\"lat\":25.7871006},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-1.2885317,\"lat\":51.823462},{\"lng\":-0.5435655,\"lat\":43.8668219},{\"lng\":-3.1582296,\"lat\":56.1110218},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":-38.4812772,\"lat\":-12.9822499},{\"lng\":7.0557352,\"lat\":48.734239},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":11.3927685,\"lat\":47.2654296},{\"lng\":-80.0942087,\"lat\":26.9342246},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-106.779807,\"lat\":32.3140354},{\"lng\":-82.4168055,\"lat\":36.1451082},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-88.3525714,\"lat\":41.6834778},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-86.37416,\"lat\":39.6128243},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-92.9438218,\"lat\":44.8277446},{\"lng\":127.0853183,\"lat\":36.9908233},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":13.39272,\"lat\":51.5158115},{\"lng\":-85.1824269,\"lat\":42.3192548},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-73.5669583,\"lat\":45.4981853},{\"lng\":-81.3410516,\"lat\":35.2450607},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-99.0925404,\"lat\":19.3588629},{\"lng\":-79.6901302,\"lat\":44.3893208},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-74.2210643,\"lat\":40.8164458},{\"lng\":-73.3734547,\"lat\":40.6867667},{\"lng\":-75.1198911,\"lat\":39.9448402},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-4.7882104,\"lat\":50.338466},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":-95.8937398,\"lat\":41.1365122},{\"lng\":5.4372681,\"lat\":51.8874333},{\"lng\":-73.059912,\"lat\":41.2223781},{\"lng\":-122.8072257,\"lat\":47.0263876},{\"lng\":-79.6443879,\"lat\":43.5896231},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.7538071,\"lat\":34.2677404},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-104.500541,\"lat\":37.169397},{\"lng\":-1.3402795,\"lat\":52.0601807},{\"lng\":-116.602983,\"lat\":31.8658887},{\"lng\":-75.071284,\"lat\":39.9181686},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":121.4589414,\"lat\":25.061706},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-88.3053525,\"lat\":41.8875281},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-75.8817316,\"lat\":41.2464824},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":2.1138977,\"lat\":41.5421013},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":-97.827833,\"lat\":30.5217116},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-104.858682,\"lat\":39.3722552},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":8.1350021,\"lat\":49.3539802},{\"lng\":4.6408412,\"lat\":52.1131403},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":6.2980123,\"lat\":43.3855592},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-1.1518287,\"lat\":51.8988832},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":-1.4761491,\"lat\":52.9212617},{\"lng\":-0.472528,\"lat\":51.7511784},{\"lng\":-124.1707558,\"lat\":40.8018746},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-8.4726423,\"lat\":51.8985136},{\"lng\":-118.3845942,\"lat\":33.8398289},{\"lng\":7.0086255,\"lat\":43.641141},{\"lng\":-80.9271271,\"lat\":29.0258132},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-0.2012376,\"lat\":5.5571096},{\"lng\":-90.2214858,\"lat\":38.5955375},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-55.1347737,\"lat\":-27.8738956},{\"lng\":-117.6124179,\"lat\":33.4270275},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":13.1796853,\"lat\":48.7556753},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-72.9020069,\"lat\":41.3836233},{\"lng\":-111.834914,\"lat\":41.7313063},{\"lng\":-118.3845942,\"lat\":33.8398289},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-82.3519192,\"lat\":27.7123035},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.882817,\"lat\":43.513671},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-72.6908547,\"lat\":41.764582},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.7774177,\"lat\":40.5173165},{\"lng\":-48.6339782,\"lat\":-26.9924395},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-74.1454214,\"lat\":40.7684342},{\"lng\":-0.3004067,\"lat\":51.5149803},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":-71.1187829,\"lat\":42.332918},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":104.063315,\"lat\":30.659867},{\"lng\":-73.2541069,\"lat\":42.4484778},{\"lng\":100.0639917,\"lat\":13.8190071},{\"lng\":-118.3845942,\"lat\":33.8398289},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":-112.0244841,\"lat\":41.1135837},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-73.5017966,\"lat\":40.814858},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-82.9069508,\"lat\":42.4435616},{\"lng\":-80.2493276,\"lat\":43.5460516},{\"lng\":-117.58938,\"lat\":33.6626232},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-86.6694413,\"lat\":35.9522852},{\"lng\":-74.1182492,\"lat\":42.0410578},{\"lng\":8.7376029,\"lat\":41.9263991},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":-76.42977,\"lat\":36.9775016},{\"lng\":-77.3507698,\"lat\":39.4817659},{\"lng\":10.596884,\"lat\":49.6389632},{\"lng\":-97.2271249,\"lat\":32.9299655},{\"lng\":-74.8231794,\"lat\":11.0101922},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-123.508918,\"lat\":49.4006197},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":5.7727504,\"lat\":46.9032246},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":4.3315503,\"lat\":50.8606042},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":7.7885978,\"lat\":48.8172236},{\"lng\":-85.5163391,\"lat\":42.7891193},{\"lng\":-70.1895554,\"lat\":44.4724293},{\"lng\":11.3426327,\"lat\":44.4938203},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-95.1169366,\"lat\":43.8663464},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-113.214894,\"lat\":53.7128571},{\"lng\":7.1024635,\"lat\":50.7352621},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":2.4019804,\"lat\":48.8965023},{\"lng\":0.5595871,\"lat\":47.7440445},{\"lng\":21.2692121,\"lat\":48.7220196},{\"lng\":-89.5108818,\"lat\":44.4604931},{\"lng\":-70.9753978,\"lat\":43.3050758},{\"lng\":-81.3055188,\"lat\":28.6987317},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":-3.5175773,\"lat\":55.8829582},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":18.0894593,\"lat\":48.31295},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-1.954579,\"lat\":48.363601},{\"lng\":1.3549991,\"lat\":44.0175835},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":0.7046455,\"lat\":44.4056615},{\"lng\":-1.5815742,\"lat\":52.2814519},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":102.6133707,\"lat\":17.9640988},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":6.9239103,\"lat\":43.6589011},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-75.1812913,\"lat\":40.9995386},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":9.9748557,\"lat\":52.3749334},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-116.602983,\"lat\":31.8658887},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-78.8688833,\"lat\":38.4493315},{\"lng\":-95.0949303,\"lat\":29.5074538},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":0.6153054,\"lat\":44.8373323},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":-122.0215737,\"lat\":37.5872576},{\"lng\":8.6394715,\"lat\":52.1530879},{\"lng\":-118.1956709,\"lat\":50.998045},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-0.7465033,\"lat\":52.0348915},{\"lng\":-1.6117595,\"lat\":54.9751136},{\"lng\":6.1675872,\"lat\":49.3579272},{\"lng\":4.8059012,\"lat\":43.9492493},{\"lng\":-121.8106925,\"lat\":38.0093296},{\"lng\":8.3054682,\"lat\":47.0505452},{\"lng\":-119.292058,\"lat\":36.3302284},{\"lng\":8.5752736,\"lat\":48.9430357},{\"lng\":-83.6513229,\"lat\":41.3747744},{\"lng\":-105.22058,\"lat\":39.7546349},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":73.1942567,\"lat\":22.2973142},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-80.6672631,\"lat\":32.9021377},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":73.0923253,\"lat\":31.4220558},{\"lng\":-73.5835826,\"lat\":40.6576071},{\"lng\":-72.2108428,\"lat\":41.3659278},{\"lng\":-73.1212214,\"lat\":41.8006523},{\"lng\":6.0161687,\"lat\":46.5270731},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":2.3194375,\"lat\":48.8188544},{\"lng\":-85.0215983,\"lat\":32.341536},{\"lng\":-80.0983887,\"lat\":-2.2895167},{\"lng\":-70.2823287,\"lat\":41.6535345},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-76.7918234,\"lat\":39.4148436},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":17.8127308,\"lat\":59.2439038},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":3.570579,\"lat\":47.7961287},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-84.7668495,\"lat\":43.597646},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":6.553745,\"lat\":46.5512503},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-82.2327525,\"lat\":27.9378338},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-118.307201,\"lat\":34.1812089},{\"lng\":1.8505364,\"lat\":48.9079595},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-82.2272119,\"lat\":34.9381361},{\"lng\":75.8681996,\"lat\":22.7203616},{\"lng\":-75.26046,\"lat\":40.0084456},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.2276378,\"lat\":47.5766324},{\"lng\":1.7140683,\"lat\":48.9891971},{\"lng\":3.3331703,\"lat\":46.5660526},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":2.4151151,\"lat\":48.6538754},{\"lng\":-79.4491057,\"lat\":43.7543217},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-104.820246,\"lat\":41.139981},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-104.6158764,\"lat\":50.4479733},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-105.938456,\"lat\":35.6876096},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-87.9531303,\"lat\":42.2830786},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":-0.3004067,\"lat\":51.5149803},{\"lng\":-59.1488389,\"lat\":-37.2919426},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-82.9371409,\"lat\":42.4972583},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-8.1989013,\"lat\":41.3648572},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-2.3198467,\"lat\":51.2294852},{\"lng\":18.0399308,\"lat\":59.2759647},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":-71.3264492,\"lat\":42.8808677},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":-71.0037374,\"lat\":42.2509914},{\"lng\":-88.0039653,\"lat\":42.263079},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":4.8526493,\"lat\":52.2862177},{\"lng\":-1.7822482,\"lat\":53.6466645},{\"lng\":-89.3614407,\"lat\":40.7907409},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":-94.208787,\"lat\":36.3728608},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":2.4197113,\"lat\":48.8051624},{\"lng\":121.4511111,\"lat\":31.2515439},{\"lng\":2.1374969,\"lat\":41.4910324},{\"lng\":-77.1516844,\"lat\":39.0817985},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-123.3272489,\"lat\":42.4393707},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":-117.173895,\"lat\":46.7304268},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":7.2333295,\"lat\":49.2833031},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-82.5338633,\"lat\":28.483576},{\"lng\":18.1820897,\"lat\":59.3669445},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-80.1494901,\"lat\":26.0112014},{\"lng\":5.7357595,\"lat\":49.2932974},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":-87.7686078,\"lat\":41.741406},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-1.3776342,\"lat\":53.9259798},{\"lng\":-80.1353006,\"lat\":25.7929198},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-125.244153,\"lat\":50.023071},{\"lng\":13.0591397,\"lat\":52.4009309},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":103.7649059,\"lat\":1.4581986},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-120.4579009,\"lat\":34.6391501},{\"lng\":-112.3842224,\"lat\":33.4674695},{\"lng\":6.7556852,\"lat\":53.1638192},{\"lng\":-73.6113502,\"lat\":40.6534835},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-97.8772103,\"lat\":29.9892928},{\"lng\":-73.7126064,\"lat\":41.132973},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":9.5581577,\"lat\":52.2099318},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-104.8658084,\"lat\":39.9205405},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-73.4078968,\"lat\":41.1175966},{\"lng\":-82.902901,\"lat\":42.6741189},{\"lng\":-79.2576479,\"lat\":43.7729744},{\"lng\":-122.657047,\"lat\":49.1039289},{\"lng\":120.1852496,\"lat\":22.9921256},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":-81.9081937,\"lat\":41.375049},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.3338445,\"lat\":50.8035441},{\"lng\":-73.5748483,\"lat\":41.2087066},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-84.1170163,\"lat\":9.9981515},{\"lng\":-2.0580178,\"lat\":48.6320379},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-97.937622,\"lat\":49.187089},{\"lng\":-112.281933,\"lat\":33.6290111},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":9.7473511,\"lat\":56.5034534},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.6154897,\"lat\":34.0234337},{\"lng\":0.7126205,\"lat\":51.5349879},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-0.7170764,\"lat\":44.8958887},{\"lng\":19.2691151,\"lat\":42.4321076},{\"lng\":78.1358153,\"lat\":27.8761073},{\"lng\":-74.4262011,\"lat\":40.4997407},{\"lng\":-82.7192671,\"lat\":28.2441768},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-87.0338464,\"lat\":35.6148165},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-68.4662317,\"lat\":-33.1959388},{\"lng\":91.753943,\"lat\":26.1805978},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":13.0820846,\"lat\":54.3096314},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-77.1154448,\"lat\":37.5327893},{\"lng\":-2.9350039,\"lat\":43.2630018},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":5.5271394,\"lat\":45.126906},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":2.3507289,\"lat\":48.861352},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":101.7055684,\"lat\":3.0340649},{\"lng\":-97.3404854,\"lat\":32.9616819},{\"lng\":30.061507,\"lat\":-1.950851},{\"lng\":-75.0946183,\"lat\":39.8676134},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":5.4127848,\"lat\":43.4511819},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.760056,\"lat\":33.9926803},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":26.1772794,\"lat\":44.4902779},{\"lng\":-75.1526774,\"lat\":39.8381691},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.2465748,\"lat\":48.9069349},{\"lng\":5.5910751,\"lat\":45.3631386},{\"lng\":-73.9283672,\"lat\":41.7065539},{\"lng\":2.334267,\"lat\":48.911729},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-78.8688833,\"lat\":38.4493315},{\"lng\":0.7299495,\"lat\":52.0401524},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":17.9681359,\"lat\":59.3628802},{\"lng\":115.1609766,\"lat\":-8.6434167},{\"lng\":-95.4187924,\"lat\":30.0795707},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-93.7211623,\"lat\":36.9724863},{\"lng\":-75.1162306,\"lat\":40.1507046},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-75.292676,\"lat\":40.372048},{\"lng\":80.270186,\"lat\":13.0836939},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-68.836982,\"lat\":44.7445159},{\"lng\":1.089746,\"lat\":49.4151549},{\"lng\":-123.2620435,\"lat\":44.5645659},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-90.9806954,\"lat\":38.9794923},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":9.0150026,\"lat\":48.8012983},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":121.0573969,\"lat\":14.3134763},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":5.7455106,\"lat\":52.0716825},{\"lng\":-74.9077919,\"lat\":39.7836223},{\"lng\":12.0974869,\"lat\":49.0195333},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":4.3188215,\"lat\":52.0446265},{\"lng\":4.7493384,\"lat\":52.2669442},{\"lng\":-75.1438863,\"lat\":39.770683},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7253575,\"lat\":17.0604663},{\"lng\":-2.9350039,\"lat\":43.2630018},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":-74.3045277,\"lat\":40.6652251},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":79.8542005,\"lat\":6.9388614},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-111.9866954,\"lat\":40.6967891},{\"lng\":-0.3691409,\"lat\":51.4150272},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-1.8604874,\"lat\":53.7229229},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":12.6757914,\"lat\":48.2268085},{\"lng\":-51.2303767,\"lat\":-30.0324999},{\"lng\":9.1364229,\"lat\":48.9493243},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-121.8903368,\"lat\":36.9941295},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-96.4980424,\"lat\":33.1801161},{\"lng\":-92.5601884,\"lat\":39.7969772},{\"lng\":-89.216655,\"lat\":37.7274692},{\"lng\":5.5783856,\"lat\":46.1825453},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-76.1789242,\"lat\":40.1799111},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":6.8514435,\"lat\":51.4696137},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":12.3747329,\"lat\":51.3406321},{\"lng\":-2.9770012,\"lat\":53.4105292},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-86.1283681,\"lat\":39.9784186},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-0.2427217,\"lat\":44.9133742},{\"lng\":10.6159077,\"lat\":54.1364642},{\"lng\":-1.37328,\"lat\":43.68866},{\"lng\":9.4978479,\"lat\":51.3157833},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-75.1340604,\"lat\":40.2492741},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-86.1597137,\"lat\":33.3967079},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-77.0398762,\"lat\":35.1068428},{\"lng\":-1.4269698,\"lat\":46.6705431},{\"lng\":-2.2206585,\"lat\":52.1911849},{\"lng\":10.9718974,\"lat\":49.0305748},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":9.4800858,\"lat\":47.6500279},{\"lng\":-3.8758396,\"lat\":40.4933095},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-77.0398762,\"lat\":35.1068428},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-96.3050064,\"lat\":35.4325854},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":-79.8728583,\"lat\":43.2560802},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":5.5302024,\"lat\":46.6769747},{\"lng\":0.8994651,\"lat\":51.8896903},{\"lng\":-100.9763993,\"lat\":22.1516472},{\"lng\":3.3396173,\"lat\":47.9917465},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":9.9434769,\"lat\":49.7780356},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":135.5014539,\"lat\":34.6937569},{\"lng\":-114.363662,\"lat\":43.680741},{\"lng\":-0.5216683,\"lat\":44.8791708},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":-0.8324037,\"lat\":51.4120318},{\"lng\":8.6711118,\"lat\":52.1152245},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-82.2359254,\"lat\":27.044224},{\"lng\":-68.7713289,\"lat\":44.8016255},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":4.9570975,\"lat\":45.6638963},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":8.0256131,\"lat\":50.8751175},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":3.5107999,\"lat\":47.9035931},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":0.4757177,\"lat\":50.9265004},{\"lng\":2.2411289,\"lat\":43.6053809},{\"lng\":-122.2070775,\"lat\":47.6765382},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-0.5404819,\"lat\":53.2293545},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-100.315258,\"lat\":25.6802019},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":6.1069469,\"lat\":46.0338359},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.3277854,\"lat\":48.8482145},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-86.0085955,\"lat\":40.0455918},{\"lng\":-79.461708,\"lat\":44.056258},{\"lng\":-0.283934,\"lat\":49.1823826},{\"lng\":27.4721276,\"lat\":42.4936616},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-76.9271851,\"lat\":39.0397735},{\"lng\":174.9057626,\"lat\":-41.2125751},{\"lng\":-1.4562207,\"lat\":43.39876},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-95.4187924,\"lat\":30.0795707},{\"lng\":-113.770256,\"lat\":50.3481989},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-122.2127011,\"lat\":47.9793437},{\"lng\":-90.3770869,\"lat\":38.3652768},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.3749508,\"lat\":40.7985464},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":125.4515852,\"lat\":6.878324},{\"lng\":-2.0976346,\"lat\":57.1426487},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-78.3968299,\"lat\":40.5193586},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-85.1824269,\"lat\":42.3192548},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-88.4069744,\"lat\":44.2613967},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":8.0605908,\"lat\":51.4002384},{\"lng\":-84.5496148,\"lat\":33.9528472},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":11.3297921,\"lat\":50.9793301},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":6.0791195,\"lat\":49.1237163},{\"lng\":18.0894593,\"lat\":48.31295},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.4381568,\"lat\":49.4704113},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-73.6917878,\"lat\":42.7284117},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-64.0681408,\"lat\":-30.70466},{\"lng\":4.4147041,\"lat\":52.0475517},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-109.2194544,\"lat\":41.5860557},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.4036319,\"lat\":40.8472369},{\"lng\":6.9881194,\"lat\":51.0324743},{\"lng\":-73.7629097,\"lat\":41.0339862},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-121.176058,\"lat\":38.6779591},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.9338911,\"lat\":39.9005585},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":36.8172449,\"lat\":-1.2832533},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-16.7787271,\"lat\":28.2101368},{\"lng\":17.7959288,\"lat\":59.1653304},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":0.2781546,\"lat\":50.7664372},{\"lng\":-95.5230691,\"lat\":35.4700917},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":3.0335243,\"lat\":42.7946794},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":5.0660616,\"lat\":51.5856184},{\"lng\":11.6400789,\"lat\":52.1314783},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":7.6824892,\"lat\":45.0677551},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":6.759562,\"lat\":51.434999},{\"lng\":-118.4453745,\"lat\":34.2242902},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3633048,\"lat\":48.7921098},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-88.9125723,\"lat\":43.0798032},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-114.9822486,\"lat\":36.0319843},{\"lng\":-71.4128343,\"lat\":41.8239891},{\"lng\":0.6889268,\"lat\":47.3900474},{\"lng\":-77.4118027,\"lat\":35.5942045},{\"lng\":-78.7998691,\"lat\":35.5843849},{\"lng\":-68.672791,\"lat\":44.883607},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-117.9611761,\"lat\":34.0854739},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.3490769,\"lat\":40.0373323},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-76.8485094,\"lat\":39.0984317},{\"lng\":9.7454815,\"lat\":52.3212183},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":18.2073591,\"lat\":59.3120997},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":7.9625883,\"lat\":52.2414052},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-90.0517638,\"lat\":35.1460249},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":5.0286859,\"lat\":52.0262053},{\"lng\":9.4333264,\"lat\":54.7833021},{\"lng\":-8.378194,\"lat\":41.290118},{\"lng\":-96.6388833,\"lat\":32.912624},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":-89.0078418,\"lat\":34.4942683},{\"lng\":-2.8650938,\"lat\":54.0721085},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-84.5501874,\"lat\":39.2085354},{\"lng\":2.3896123,\"lat\":48.9267236},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":9.9351811,\"lat\":51.5328328},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-4.7760138,\"lat\":37.8845813},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-73.7240106,\"lat\":40.636793},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-120.4579009,\"lat\":34.6391501},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-2.4543424,\"lat\":50.6096257},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.7106094,\"lat\":52.0114922},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":0.5961846,\"lat\":47.4036631},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":1.3009485,\"lat\":38.9830568},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-85.7833563,\"lat\":40.8065352},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":-73.6837987,\"lat\":45.435114},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.2301808,\"lat\":47.3075369},{\"lng\":-3.5269209,\"lat\":50.7256138},{\"lng\":-122.4094051,\"lat\":48.0399806},{\"lng\":8.32494,\"lat\":49.7053458},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-121.988571,\"lat\":37.5482697},{\"lng\":10.684738,\"lat\":53.866444},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-3.1716324,\"lat\":56.1961905},{\"lng\":-83.4754913,\"lat\":42.48059},{\"lng\":5.9146362,\"lat\":45.6886292},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-118.559849,\"lat\":34.4131941},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-86.9838165,\"lat\":34.6060203},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":-121.2810611,\"lat\":38.7071247},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":2.3872525,\"lat\":48.8122302},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":11.9712985,\"lat\":51.4824354},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-81.3498212,\"lat\":34.1659795},{\"lng\":-123.0220289,\"lat\":44.0462362},{\"lng\":11.3526351,\"lat\":48.1704908},{\"lng\":-89.4350519,\"lat\":30.4090829},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":4.6931244,\"lat\":45.9561547},{\"lng\":2.5524906,\"lat\":48.8492238},{\"lng\":0.526559,\"lat\":51.3819167},{\"lng\":-76.2494453,\"lat\":36.7168315},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.3945384,\"lat\":40.9784354},{\"lng\":-0.2012376,\"lat\":5.5571096},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":-116.464076,\"lat\":33.7810031},{\"lng\":-75.0940625,\"lat\":40.0609445},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-93.605092,\"lat\":41.7320796},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-0.2589013,\"lat\":52.0882012},{\"lng\":-75.0946183,\"lat\":39.8676134},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-78.878292,\"lat\":35.0525759},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":3.8855537,\"lat\":45.0459739},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":0.1631961,\"lat\":51.8676279},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":7.1978546,\"lat\":51.6143815},{\"lng\":-122.192337,\"lat\":47.6144219},{\"lng\":-99.097453,\"lat\":19.3957447},{\"lng\":-82.3269883,\"lat\":27.871197},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":-117.3703235,\"lat\":34.1064001},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-74.4015405,\"lat\":40.6984348},{\"lng\":-94.1166283,\"lat\":36.3330154},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-99.1952423,\"lat\":19.3906515},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":12.0595795,\"lat\":47.8556623},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-81.8020722,\"lat\":24.5548262},{\"lng\":-93.7594059,\"lat\":41.5644476},{\"lng\":-94.81887,\"lat\":38.8838856},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-92.6255048,\"lat\":44.8596498},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":10.386436,\"lat\":52.3254911},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":10.9700482,\"lat\":49.8439391},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-92.1801925,\"lat\":30.2378751},{\"lng\":0.5231646,\"lat\":51.2748258},{\"lng\":78.0098161,\"lat\":27.1752554},{\"lng\":-1.7854322,\"lat\":51.5615327},{\"lng\":-94.6851702,\"lat\":38.9742502},{\"lng\":6.2495954,\"lat\":46.2025309},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":2.2630238,\"lat\":48.8003835},{\"lng\":2.9437526,\"lat\":46.5524374},{\"lng\":6.8514435,\"lat\":51.4696137},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-81.3461738,\"lat\":28.7012172},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-97.5468898,\"lat\":30.5427638},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":144.3598241,\"lat\":-38.1493248},{\"lng\":-99.3311525,\"lat\":38.8709984},{\"lng\":-54.558258,\"lat\":-29.2004769},{\"lng\":-0.3018577,\"lat\":51.4129277},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-111.4979963,\"lat\":40.6460921},{\"lng\":-63.7892386,\"lat\":46.394259},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":-76.8861122,\"lat\":40.2663107},{\"lng\":-82.6379387,\"lat\":38.4784144},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-118.129807,\"lat\":34.051522},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-94.1288142,\"lat\":36.1867442},{\"lng\":-72.8246139,\"lat\":40.9446394},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":2.136145,\"lat\":48.8478753},{\"lng\":7.1024635,\"lat\":50.7352621},{\"lng\":-90.5228976,\"lat\":37.8517986},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":18.4126147,\"lat\":43.8570713},{\"lng\":-98.1981486,\"lat\":19.0437196},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-75.1119434,\"lat\":39.7027677},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-3.0756369,\"lat\":47.7483013},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-106.5594391,\"lat\":35.0879638},{\"lng\":-82.692005,\"lat\":28.3581405},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-114.0532996,\"lat\":35.1895921},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-2.2198605,\"lat\":51.745424},{\"lng\":7.5000007,\"lat\":6.4499833},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":-85.4807825,\"lat\":32.6098566},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-74.9693329,\"lat\":39.7173375},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-79.0935648,\"lat\":37.4463105},{\"lng\":-71.2360624,\"lat\":42.2802645},{\"lng\":9.3762397,\"lat\":47.425618},{\"lng\":-116.5016784,\"lat\":33.961124},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":0.8477322,\"lat\":52.829919},{\"lng\":-2.9778916,\"lat\":51.3471927},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-71.2355644,\"lat\":42.3762385},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":126.9518,\"lat\":37.4782},{\"lng\":9.6599406,\"lat\":47.4276538},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-1.7767859,\"lat\":46.4990505},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-76.2461259,\"lat\":41.0602024},{\"lng\":-88.2364775,\"lat\":42.4436308},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":7.8993599,\"lat\":47.3206417},{\"lng\":-77.4605399,\"lat\":38.3031837},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":-57.9537638,\"lat\":-34.9206797},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":10.9587203,\"lat\":49.4885711},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.0338765,\"lat\":34.6731323},{\"lng\":5.3072813,\"lat\":45.3481942},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":7.1262071,\"lat\":43.5812868},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":-71.537476,\"lat\":43.207178},{\"lng\":10.1808016,\"lat\":47.9863099},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-80.0387292,\"lat\":32.9961038},{\"lng\":-97.3887764,\"lat\":30.0541116},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":4.80986,\"lat\":45.6467},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-70.551453,\"lat\":43.735879},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-73.1062025,\"lat\":43.9733602},{\"lng\":1.1306951,\"lat\":51.3719507},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.3825154,\"lat\":48.9565669},{\"lng\":-91.9479586,\"lat\":38.8467082},{\"lng\":10.135555,\"lat\":54.3227085},{\"lng\":-93.5521411,\"lat\":37.0675544},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":121.0764343,\"lat\":14.5605166},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.4204495,\"lat\":38.6968919},{\"lng\":-2.2439196,\"lat\":53.7907262},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-87.6305899,\"lat\":46.4481521},{\"lng\":14.4258096,\"lat\":35.910083},{\"lng\":-0.1740904,\"lat\":45.6791182},{\"lng\":2.3764363,\"lat\":43.4902317},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":2.510611,\"lat\":48.8137847},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":8.634513,\"lat\":47.6960491},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-2.2663682,\"lat\":53.7816338},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":5.6062495,\"lat\":43.1758591},{\"lng\":-118.1634075,\"lat\":34.8641446},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-74.8142502,\"lat\":38.9841969},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":31.045686,\"lat\":-17.831773},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":-94.1166283,\"lat\":36.3330154},{\"lng\":2.30551,\"lat\":48.9026},{\"lng\":-4.1281427,\"lat\":40.5836411},{\"lng\":153.4145987,\"lat\":-28.0023731},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-74.8231794,\"lat\":11.0101922},{\"lng\":-87.1916834,\"lat\":34.639258},{\"lng\":12.4985492,\"lat\":55.704111},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":-96.3455991,\"lat\":30.6183939},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":-74.9794987,\"lat\":40.7584793},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-3.4146801,\"lat\":50.6190962},{\"lng\":-85.4879523,\"lat\":42.9547136},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":17.9681359,\"lat\":59.3628802},{\"lng\":7.1825445,\"lat\":50.8963758},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-75.9696186,\"lat\":40.7974296},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.4078968,\"lat\":41.1175966},{\"lng\":-88.2578582,\"lat\":42.1211364},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-88.1361888,\"lat\":42.1539141},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":8.6930633,\"lat\":47.3895597},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-116.559631,\"lat\":43.5737361},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-0.1726236,\"lat\":51.6482779},{\"lng\":-95.4187924,\"lat\":30.0795707},{\"lng\":13.0630004,\"lat\":53.3617163},{\"lng\":-75.710976,\"lat\":45.4277659},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-96.9083366,\"lat\":32.6518004},{\"lng\":-87.7834769,\"lat\":42.7313756},{\"lng\":6.5621137,\"lat\":46.5258},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-81.2680223,\"lat\":28.8117345},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-122.2070775,\"lat\":47.6765382},{\"lng\":-95.2214564,\"lat\":33.1890841},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.6118771,\"lat\":50.7259985},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-111.926018,\"lat\":33.4942189},{\"lng\":-81.6332812,\"lat\":38.3505995},{\"lng\":-3.2208487,\"lat\":51.5745432},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-71.5785924,\"lat\":42.6650324},{\"lng\":-111.4748846,\"lat\":40.5125438},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-77.0722227,\"lat\":39.1469872},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":6.5213004,\"lat\":52.3080276},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.2674029,\"lat\":48.6155573},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":37.6742652,\"lat\":-6.8254864},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-78.762383,\"lat\":39.6526498},{\"lng\":-117.7197785,\"lat\":34.0966764},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-71.3084633,\"lat\":41.7407661},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-5.3868293,\"lat\":36.2100586},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-73.7629097,\"lat\":41.0339862},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-95.9927516,\"lat\":36.1563122},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":10.7545933,\"lat\":49.1147095},{\"lng\":0.0429787,\"lat\":45.5547638},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-94.3621376,\"lat\":39.3731886},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":33.0332657,\"lat\":34.6852901},{\"lng\":-122.2941914,\"lat\":37.5164926},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-69.8140298,\"lat\":43.9133661},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-105.05208,\"lat\":39.9403995},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-155.1003754,\"lat\":19.6854458},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-121.9856782,\"lat\":47.7423219},{\"lng\":4.87477,\"lat\":45.52524},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":11.0993619,\"lat\":55.6833793},{\"lng\":5.3737893,\"lat\":43.7346782},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-74.228185,\"lat\":40.8813513},{\"lng\":25.1332843,\"lat\":35.33908},{\"lng\":-89.031784,\"lat\":42.5083272},{\"lng\":13.8201171,\"lat\":55.4295203},{\"lng\":6.759562,\"lat\":51.434999},{\"lng\":8.63306,\"lat\":49.4025},{\"lng\":2.166162,\"lat\":48.9898588},{\"lng\":11.3426327,\"lat\":44.4938203},{\"lng\":8.0072645,\"lat\":51.329832},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-0.5762125,\"lat\":42.8801011},{\"lng\":4.19978,\"lat\":44.2600172},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-59.1488389,\"lat\":-37.2919426},{\"lng\":-118.3692894,\"lat\":34.0923014},{\"lng\":4.7876566,\"lat\":52.4952218},{\"lng\":10.0832982,\"lat\":48.2833039},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":153.0933668,\"lat\":-26.6544338},{\"lng\":-89.6272791,\"lat\":44.9597858},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":80.270186,\"lat\":13.0836939},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-80.0852695,\"lat\":42.1294712},{\"lng\":-82.5338633,\"lat\":28.483576},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-84.7027575,\"lat\":39.065813},{\"lng\":-72.9467908,\"lat\":42.7718433},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-90.0973694,\"lat\":30.4408827},{\"lng\":-111.9367107,\"lat\":40.5584882},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":0.0285581,\"lat\":45.4722149},{\"lng\":-70.2177099,\"lat\":44.0990717},{\"lng\":-74.2765366,\"lat\":40.8398218},{\"lng\":-83.1596108,\"lat\":40.033814},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-71.3517602,\"lat\":42.5968617},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.399125,\"lat\":47.0811658},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-0.7097768,\"lat\":51.0876062},{\"lng\":-76.6826661,\"lat\":39.3486919},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-80.0532942,\"lat\":26.715364},{\"lng\":4.8216902,\"lat\":45.6733141},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-87.2169149,\"lat\":30.421309},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":4.8423304,\"lat\":45.7969952},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":31.009909,\"lat\":-29.861825},{\"lng\":-86.1090828,\"lat\":42.7876022},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-87.0717718,\"lat\":20.6269889},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":-112.03628,\"lat\":43.4887907},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-5.5352463,\"lat\":50.1194794},{\"lng\":-73.4526144,\"lat\":45.6050197},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.0729178,\"lat\":46.0345572},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":2.4530731,\"lat\":48.7771486},{\"lng\":7.7769882,\"lat\":48.2198805},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":36.8172449,\"lat\":-1.2832533},{\"lng\":76.1391283,\"lat\":28.7931703},{\"lng\":-71.2925571,\"lat\":42.2964859},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":-80.1386547,\"lat\":26.8233946},{\"lng\":-1.2344047,\"lat\":54.5760419},{\"lng\":-74.8909988,\"lat\":39.934002},{\"lng\":-122.397126,\"lat\":37.7586927},{\"lng\":-86.5859011,\"lat\":34.729847},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-91.6704053,\"lat\":41.9758872},{\"lng\":10.7578121,\"lat\":48.1805562},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-86.1336351,\"lat\":40.4864444},{\"lng\":-0.3944534,\"lat\":44.8777159},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":-0.9050287,\"lat\":51.5375786},{\"lng\":-62.6483547,\"lat\":45.5869474},{\"lng\":4.7785644,\"lat\":45.7754498},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-96.9771177,\"lat\":37.6809165},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-1.1515951,\"lat\":46.159732},{\"lng\":-74.1194403,\"lat\":40.9796683},{\"lng\":-2.0976346,\"lat\":57.1426487},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":14.7631229,\"lat\":50.8700733},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-111.9944938,\"lat\":40.5252569},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-93.4638936,\"lat\":44.9405086},{\"lng\":-1.1305431,\"lat\":37.9923795},{\"lng\":-74.7226665,\"lat\":39.9325409},{\"lng\":-84.5546295,\"lat\":42.7338254},{\"lng\":13.2457591,\"lat\":52.7529379},{\"lng\":-46.5096698,\"lat\":-18.6041453},{\"lng\":-72.5982955,\"lat\":44.5615499},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-87.5715641,\"lat\":37.970495},{\"lng\":15.4382786,\"lat\":47.0708678},{\"lng\":-85.805386,\"lat\":30.1765914},{\"lng\":145.1177321,\"lat\":-37.5121301},{\"lng\":-76.9959168,\"lat\":39.5751717},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-99.2599579,\"lat\":18.9331321},{\"lng\":22.1459535,\"lat\":65.5831187},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.87477,\"lat\":45.52524},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-91.5812739,\"lat\":41.4797157},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-85.865235,\"lat\":42.870889},{\"lng\":-95.2359403,\"lat\":38.9719137},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":7.4652789,\"lat\":51.5142273},{\"lng\":-0.4775114,\"lat\":51.546655},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.9768632,\"lat\":43.0020107},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":6.5340061,\"lat\":45.4849883},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-92.9339449,\"lat\":44.919896},{\"lng\":-122.989827,\"lat\":45.5228939},{\"lng\":-76.9369189,\"lat\":38.980666},{\"lng\":-0.5515588,\"lat\":47.4739884},{\"lng\":-118.307201,\"lat\":34.1812089},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":-95.6349463,\"lat\":29.6196787},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.5378173,\"lat\":41.6529143},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.6621294,\"lat\":41.4086874},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.4414627,\"lat\":53.0996153},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":2.2255727,\"lat\":48.8709053},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-82.7893788,\"lat\":28.0116627},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-121.1841587,\"lat\":45.6015056},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-81.4959267,\"lat\":35.8484645},{\"lng\":-76.2899539,\"lat\":36.8493695},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-83.376398,\"lat\":33.9597677},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":150.89385,\"lat\":-34.4243941},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":6.3121658,\"lat\":46.0672189},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-86.8425761,\"lat\":21.1527467},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":16.5463679,\"lat\":59.6110992},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-122.4995234,\"lat\":37.5980374},{\"lng\":-107.9779962,\"lat\":36.7520109},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-75.3085201,\"lat\":39.9809452},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":7.4892974,\"lat\":9.0643305},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":8.7548,\"lat\":49.8152},{\"lng\":-83.1035688,\"lat\":42.4620142},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.5222961,\"lat\":43.4652699},{\"lng\":-122.1238767,\"lat\":47.6694141},{\"lng\":-75.0437814,\"lat\":40.1742759},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-80.148379,\"lat\":25.9812025},{\"lng\":1.144961,\"lat\":41.1109268},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":127.0365,\"lat\":37.5635},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-116.7811531,\"lat\":47.6742994},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":2.3570028,\"lat\":48.8125893},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":127.0466,\"lat\":37.6686},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-87.8003438,\"lat\":42.1816919},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-74.0120817,\"lat\":40.2203907},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":1.94063,\"lat\":44.0664},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":6.6916476,\"lat\":51.1981778},{\"lng\":-120.5785796,\"lat\":35.1235374},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.2301808,\"lat\":47.3075369},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-119.0167679,\"lat\":36.06523},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":20.1178282,\"lat\":-33.7869944},{\"lng\":2.3194375,\"lat\":48.8188544},{\"lng\":-71.5164618,\"lat\":42.1428913},{\"lng\":11.5879359,\"lat\":50.9281717},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-82.6829406,\"lat\":38.5367471},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.7808584,\"lat\":45.8570477},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-122.261823,\"lat\":37.504936},{\"lng\":-117.1827445,\"lat\":34.0550328},{\"lng\":-83.9040944,\"lat\":38.8645138},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":6.2402791,\"lat\":46.3820585},{\"lng\":-122.9072329,\"lat\":44.5363364},{\"lng\":2.48291,\"lat\":48.9031},{\"lng\":-94.2008288,\"lat\":46.3580221},{\"lng\":-114.377385,\"lat\":62.4540807},{\"lng\":-76.8317417,\"lat\":39.2757359},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":4.8395051,\"lat\":45.8765557},{\"lng\":-87.7844944,\"lat\":41.5733669},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-73.6113502,\"lat\":40.6534835},{\"lng\":8.4444861,\"lat\":47.3965147},{\"lng\":-1.2268602,\"lat\":46.4604008},{\"lng\":-1.5167069,\"lat\":51.4126079},{\"lng\":-73.0521981,\"lat\":41.4928044},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-117.888855,\"lat\":33.9170444},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-121.739005,\"lat\":38.5435526},{\"lng\":7.1161892,\"lat\":46.791321},{\"lng\":-80.0728201,\"lat\":26.4614625},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-84.5084835,\"lat\":41.3203058},{\"lng\":-124.7911479,\"lat\":49.2632931},{\"lng\":5.2092152,\"lat\":51.9493315},{\"lng\":-86.8926239,\"lat\":41.3120186},{\"lng\":-74.228185,\"lat\":40.8813513},{\"lng\":-81.0352313,\"lat\":34.000754},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":7.1024635,\"lat\":50.7352621},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":12.3691588,\"lat\":50.4773298},{\"lng\":11.5879359,\"lat\":50.9281717},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":7.9429235,\"lat\":48.4695984},{\"lng\":39.6111216,\"lat\":24.471153},{\"lng\":6.2364886,\"lat\":52.2694896},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":11.5213344,\"lat\":3.8689867},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-120.9968892,\"lat\":37.6393419},{\"lng\":-0.4264364,\"lat\":51.8850696},{\"lng\":-96.7297206,\"lat\":32.9481789},{\"lng\":-69.0571014,\"lat\":44.0823473},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.7078294,\"lat\":40.7053335},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-7.9891608,\"lat\":31.6258257},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-87.3653136,\"lat\":41.4169806},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-121.3721745,\"lat\":38.6857362},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-63.908282,\"lat\":44.6401885},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":10.3952118,\"lat\":63.4304475},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":15.4382786,\"lat\":47.0708678},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":11.7135474,\"lat\":55.7186117},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-72.5805642,\"lat\":42.4636924},{\"lng\":-91.9901206,\"lat\":30.0996471},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-118.5356869,\"lat\":34.200768},{\"lng\":13.48839,\"lat\":48.2085868},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.9962165,\"lat\":33.870413},{\"lng\":8.90677,\"lat\":53.1414124},{\"lng\":11.8734455,\"lat\":45.4077172},{\"lng\":-1.0198263,\"lat\":44.6883648},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-3.000425,\"lat\":51.5887675},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":12.7573679,\"lat\":47.2713898},{\"lng\":3.2917502,\"lat\":49.5425466},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":67.0207055,\"lat\":24.8546842},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-80.1100556,\"lat\":40.3561805},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-0.1991229,\"lat\":51.4989948},{\"lng\":12.5135924,\"lat\":55.6637755},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-76.7455478,\"lat\":39.2609921},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-95.480941,\"lat\":40.7192038},{\"lng\":10.6613448,\"lat\":52.5780612},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.0335624,\"lat\":37.9768525},{\"lng\":17.1467019,\"lat\":60.6750132},{\"lng\":-73.8987469,\"lat\":40.9312099},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":6.5804218,\"lat\":46.0603171},{\"lng\":-85.5356726,\"lat\":41.9031963},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.3896123,\"lat\":48.9267236},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-76.7083033,\"lat\":40.2653681},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":-122.701098,\"lat\":38.3396367},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":2.8199439,\"lat\":41.9793006},{\"lng\":13.5960911,\"lat\":52.3643159},{\"lng\":-117.000165,\"lat\":46.7323875},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-77.4463445,\"lat\":38.9646244},{\"lng\":-79.7879575,\"lat\":34.2069786},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.518485,\"lat\":41.083064},{\"lng\":-81.684004,\"lat\":36.2187873},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-1.7954134,\"lat\":51.0690613},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-75.3646997,\"lat\":41.1220987},{\"lng\":-74.3148279,\"lat\":40.6233995},{\"lng\":-1.0618718,\"lat\":53.057309},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-3.1885456,\"lat\":55.6517553},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-110.974847,\"lat\":32.2228765},{\"lng\":-117.9962165,\"lat\":33.870413},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-123.057938,\"lat\":49.0846258},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.9587873,\"lat\":42.1157038},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-74.0076276,\"lat\":41.0556645},{\"lng\":-118.2252073,\"lat\":33.9805731},{\"lng\":-0.5564726,\"lat\":51.3201891},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":12.8760923,\"lat\":47.7222676},{\"lng\":-80.9450759,\"lat\":35.0073697},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-76.1279841,\"lat\":43.4112973},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.3859839,\"lat\":38.0094235},{\"lng\":14.2840858,\"lat\":53.0586366},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.9640834,\"lat\":54.6236326},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-114.9822486,\"lat\":36.0319843},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-82.9780695,\"lat\":42.2858536},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":23.7615346,\"lat\":37.8454602},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-0.5239863,\"lat\":44.8552882},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":0.2673446,\"lat\":51.1371483},{\"lng\":2.2071267,\"lat\":48.8924273},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-81.8778582,\"lat\":28.810823},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-86.2483921,\"lat\":43.2341813},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-9.4170802,\"lat\":38.9632411},{\"lng\":0.877989,\"lat\":43.730545},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":100.2249797,\"lat\":26.8595868},{\"lng\":4.2578662,\"lat\":45.6456225},{\"lng\":-70.934205,\"lat\":41.6362152},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":-119.702667,\"lat\":34.4221319},{\"lng\":24.0168024,\"lat\":35.5158141},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-118.5016166,\"lat\":34.1591324},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":1.9350788,\"lat\":48.572604},{\"lng\":-5.1034063,\"lat\":50.1685457},{\"lng\":-116.200886,\"lat\":43.6166163},{\"lng\":-71.1533859,\"lat\":42.3491615},{\"lng\":2.1868998,\"lat\":48.9229416},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-1.7888672,\"lat\":52.4146286},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.1361888,\"lat\":42.1539141},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":6.8827786,\"lat\":49.287307},{\"lng\":-111.841185,\"lat\":33.3062031},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-84.020224,\"lat\":42.3180163},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.6825332,\"lat\":18.941407},{\"lng\":-122.5449763,\"lat\":37.9060368},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":106.6811524,\"lat\":10.8237546},{\"lng\":100.5386136,\"lat\":13.7784702},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":-70.2586618,\"lat\":43.6573605},{\"lng\":37.074632,\"lat\":0.01403},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-71.29303,\"lat\":43.334168},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.3227967,\"lat\":48.7546687},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":4.3527807,\"lat\":50.8469765},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.2215869,\"lat\":33.9701009},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":2.316085,\"lat\":48.7795178},{\"lng\":-149.5659964,\"lat\":-17.5373835},{\"lng\":-82.2797719,\"lat\":33.8795325},{\"lng\":-121.971335,\"lat\":47.8552259},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.4439254,\"lat\":40.4951365},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3855058,\"lat\":41.436589},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":-117.8617337,\"lat\":33.8714814},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-76.4626118,\"lat\":40.375713},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-1.6676238,\"lat\":43.3844003},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.1533859,\"lat\":42.3491615},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-81.6182086,\"lat\":33.5723191},{\"lng\":13.39272,\"lat\":51.5158115},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-122.1598465,\"lat\":37.4443293},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-96.9253004,\"lat\":35.3272928},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-9.228879,\"lat\":38.705235},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-117.2919818,\"lat\":33.0369867},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-84.1457505,\"lat\":33.8062166},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":0.526559,\"lat\":51.3819167},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-98.7319703,\"lat\":29.7946641},{\"lng\":-1.4663202,\"lat\":52.4792826},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-121.0739897,\"lat\":38.8945939},{\"lng\":-111.834914,\"lat\":41.7313063},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-91.8482064,\"lat\":37.2731038},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":-92.4453558,\"lat\":31.3119463},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-71.9107903,\"lat\":42.5449024},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-75.9424217,\"lat\":39.5992989},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":5.986163,\"lat\":49.4947826},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-103.228023,\"lat\":44.0806041},{\"lng\":-87.9751964,\"lat\":41.7950525},{\"lng\":8.8278266,\"lat\":49.4810598},{\"lng\":4.7707325,\"lat\":44.3475554},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":4.2754772,\"lat\":43.6924382},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-118.3965758,\"lat\":34.1637147},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-82.5594293,\"lat\":36.550238},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-111.873193,\"lat\":33.1364413},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-86.9300023,\"lat\":35.751179},{\"lng\":-2.8062224,\"lat\":47.6980235},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.0148931,\"lat\":40.0115009},{\"lng\":-76.9832568,\"lat\":39.8005316},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-120.7678602,\"lat\":37.1641544},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-88.6116855,\"lat\":30.385755},{\"lng\":-74.0243916,\"lat\":41.503557},{\"lng\":6.1834097,\"lat\":48.6937223},{\"lng\":-118.8061794,\"lat\":34.1460234},{\"lng\":-2.9350039,\"lat\":43.2630018},{\"lng\":7.7701468,\"lat\":47.239082},{\"lng\":10.1857757,\"lat\":36.8002068},{\"lng\":-42.8815888,\"lat\":-20.7538586},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":11.3297921,\"lat\":50.9793301},{\"lng\":-73.7001187,\"lat\":42.7742446},{\"lng\":-117.7258122,\"lat\":33.5761376},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-76.4626118,\"lat\":40.375713},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.80378,\"lat\":45.4871723},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-96.6154471,\"lat\":33.1976496},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-1.4621381,\"lat\":53.3783713},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-74.0844894,\"lat\":41.7464972},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":1.1527865,\"lat\":51.7883997},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-91.6704053,\"lat\":41.9758872},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-75.4904323,\"lat\":39.919698},{\"lng\":-77.4605399,\"lat\":38.3031837},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":-0.3775015,\"lat\":51.5060205},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.6158764,\"lat\":50.4479733},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-106.0433023,\"lat\":39.6302657},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-119.3003779,\"lat\":46.287645},{\"lng\":6.9963543,\"lat\":43.6008898},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.756367,\"lat\":28.1470965},{\"lng\":14.1566859,\"lat\":56.0293778},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":13.0464806,\"lat\":47.7981346},{\"lng\":-49.0658025,\"lat\":-26.9195567},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":5.5512698,\"lat\":45.0706211},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-122.1238767,\"lat\":47.6694141},{\"lng\":-75.7166345,\"lat\":39.4497639},{\"lng\":-1.361178,\"lat\":43.6334222},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":12.0974869,\"lat\":49.0195333},{\"lng\":-118.4489739,\"lat\":35.1321878},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-0.1908861,\"lat\":51.3596769},{\"lng\":-1.7616499,\"lat\":43.3641518},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":6.0128532,\"lat\":43.1249185},{\"lng\":4.6309653,\"lat\":43.6776223},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-123.2620435,\"lat\":44.5645659},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-106.831735,\"lat\":40.4848003},{\"lng\":-0.520823,\"lat\":44.8327},{\"lng\":9.8132829,\"lat\":52.3077423},{\"lng\":7.903787,\"lat\":47.3496571},{\"lng\":-104.7612638,\"lat\":39.5184514},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-115.5720773,\"lat\":51.175076},{\"lng\":-83.2259222,\"lat\":35.3737293},{\"lng\":-71.3322798,\"lat\":41.9841334},{\"lng\":-111.8953815,\"lat\":40.5710454},{\"lng\":5.3078261,\"lat\":43.8236124},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-1.0861976,\"lat\":51.262826},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-73.6165288,\"lat\":41.3972985},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-93.7477839,\"lat\":32.5135356},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":3.6959771,\"lat\":43.4014434},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-0.3970796,\"lat\":48.5279194},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.7484616,\"lat\":42.2813722},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-102.938238,\"lat\":48.397244},{\"lng\":-84.2472117,\"lat\":43.6155825},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-1.3532834,\"lat\":53.4179463},{\"lng\":-77.2676335,\"lat\":38.636447},{\"lng\":-155.996933,\"lat\":19.641941},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-88.5987119,\"lat\":43.0694499},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-74.0237512,\"lat\":40.7795455},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-118.036849,\"lat\":34.0751571},{\"lng\":-121.173921,\"lat\":44.2726203},{\"lng\":-122.0335624,\"lat\":37.9768525},{\"lng\":-117.173895,\"lat\":46.7304268},{\"lng\":-71.4677032,\"lat\":42.7656251},{\"lng\":-77.246933,\"lat\":44.031827},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":16.5804218,\"lat\":51.8436068},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-71.0183787,\"lat\":42.0834335},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.0660616,\"lat\":51.5856184},{\"lng\":-82.4605068,\"lat\":28.5710156},{\"lng\":-4.1433925,\"lat\":50.3780967},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-86.3097278,\"lat\":41.3436555},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":174.9057626,\"lat\":-41.2125751},{\"lng\":-88.0016263,\"lat\":41.6737149},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-82.0906448,\"lat\":26.9761707},{\"lng\":-74.0643065,\"lat\":40.3470543},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":-96.9442177,\"lat\":32.8295183},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":-98.0866781,\"lat\":30.1902067},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-117.084195,\"lat\":32.6400541},{\"lng\":-0.6502981,\"lat\":35.7044415},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-0.2796034,\"lat\":51.5560695},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-98.2330927,\"lat\":29.5707831},{\"lng\":-111.9395211,\"lat\":40.6061337},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-106.6329806,\"lat\":35.2702448},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-121.696026,\"lat\":37.9317766},{\"lng\":-114.163761,\"lat\":47.6905295},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-86.9838165,\"lat\":34.6060203},{\"lng\":-86.4436018,\"lat\":36.9903199},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-122.2301808,\"lat\":47.3075369},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.5149128,\"lat\":40.1303822},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-75.9760751,\"lat\":36.8496579},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":11.1174874,\"lat\":51.1618258},{\"lng\":-90.1281824,\"lat\":43.5822002},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-85.6678639,\"lat\":42.9632425},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":1.6770956,\"lat\":46.8203785},{\"lng\":-16.9086783,\"lat\":32.6496497},{\"lng\":-75.5235149,\"lat\":42.5311809},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":9.612468,\"lat\":47.7811014},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-1.7970987,\"lat\":47.9659271},{\"lng\":-90.5136642,\"lat\":41.5058344},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":119.4124282,\"lat\":-5.1342962},{\"lng\":-77.3464516,\"lat\":38.953282},{\"lng\":-119.0167679,\"lat\":36.06523},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":11.6804033,\"lat\":60.2538602},{\"lng\":-123.763124,\"lat\":49.4721147},{\"lng\":2.2453842,\"lat\":48.7144587},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.3311238,\"lat\":51.5714876},{\"lng\":-93.7380243,\"lat\":41.6274511},{\"lng\":-71.6422408,\"lat\":42.3196015},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-109.92006,\"lat\":22.8938884},{\"lng\":-84.9702475,\"lat\":34.7691867},{\"lng\":-100.1417946,\"lat\":25.6653356},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-124.311739,\"lat\":49.3179514},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-88.4069744,\"lat\":44.2613967},{\"lng\":-116.2188054,\"lat\":33.7192808},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-100.783739,\"lat\":46.808327},{\"lng\":-85.9213796,\"lat\":39.2014405},{\"lng\":-118.12706,\"lat\":34.093042},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":-76.3056707,\"lat\":40.0379958},{\"lng\":-83.2696509,\"lat\":42.240872},{\"lng\":-120.2659105,\"lat\":34.7379311},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.8591333,\"lat\":40.5130953},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-71.0369301,\"lat\":42.3912241},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":-118.39524,\"lat\":37.363679},{\"lng\":7.1930989,\"lat\":50.6739719},{\"lng\":-77.185843,\"lat\":38.9366852},{\"lng\":-0.3345171,\"lat\":51.5907595},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.5316686,\"lat\":37.9747795},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-122.0066891,\"lat\":37.8551351},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":5.1580574,\"lat\":45.614003},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-16.3407638,\"lat\":28.5232609},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":7.1024635,\"lat\":50.7352621},{\"lng\":-7.9891608,\"lat\":31.6258257},{\"lng\":-121.29318,\"lat\":38.8915741},{\"lng\":-87.9802164,\"lat\":42.0811563},{\"lng\":-118.0879763,\"lat\":34.0676169},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":3.570579,\"lat\":47.7961287},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.0062746,\"lat\":42.4932575},{\"lng\":-99.2327986,\"lat\":19.4788356},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":-155.1003754,\"lat\":19.6854458},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.2032767,\"lat\":40.0394982},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":5.4185663,\"lat\":43.3000002},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":150.5714724,\"lat\":-34.2039562},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-74.0243916,\"lat\":41.503557},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-107.3246941,\"lat\":39.5466381},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":17.6440484,\"lat\":48.2052983},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-77.9076627,\"lat\":38.0098412},{\"lng\":28.1879101,\"lat\":-25.7459277},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":2.2881683,\"lat\":48.892956},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":106.6811524,\"lat\":10.8237546},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":6.2341093,\"lat\":46.1934005},{\"lng\":-88.0125794,\"lat\":44.5126379},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":15.4382786,\"lat\":47.0708678},{\"lng\":-121.7304882,\"lat\":48.0074736},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.1161892,\"lat\":46.791321},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":19.9971534,\"lat\":50.0469432},{\"lng\":9.7241329,\"lat\":47.5806323},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-79.7966835,\"lat\":43.3248924},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.4442629,\"lat\":27.1192213},{\"lng\":-1.3242212,\"lat\":51.4020243},{\"lng\":-111.9738429,\"lat\":41.2230048},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-79.1422464,\"lat\":37.4137536},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":11.3297921,\"lat\":50.9793301},{\"lng\":-25.6689503,\"lat\":37.7393398},{\"lng\":-121.7529071,\"lat\":36.9092773},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-87.8212263,\"lat\":42.5846773},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":2.4396714,\"lat\":48.8474508},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-97.0618324,\"lat\":27.8332175},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":6.3546345,\"lat\":46.9040348},{\"lng\":-2.1208614,\"lat\":53.5435569},{\"lng\":-0.3735636,\"lat\":44.5973806},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-71.3085329,\"lat\":42.6414437},{\"lng\":-117.374238,\"lat\":33.9824949},{\"lng\":2.2695658,\"lat\":48.884683},{\"lng\":1.0080556,\"lat\":43.5138889},{\"lng\":-63.5859487,\"lat\":44.648618},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-119.9843482,\"lat\":38.9332411},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":6.9839073,\"lat\":51.8957136},{\"lng\":-155.787398,\"lat\":19.9469278},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-92.9174074,\"lat\":41.4073138},{\"lng\":14.8094385,\"lat\":56.8787183},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-7.6200284,\"lat\":33.5945144},{\"lng\":-156.4549898,\"lat\":20.7476261},{\"lng\":-71.8864609,\"lat\":41.8459316},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":11.0287364,\"lat\":50.9777974},{\"lng\":7.3106175,\"lat\":51.5646195},{\"lng\":-92.3337366,\"lat\":38.951883},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-74.2390353,\"lat\":40.7987113},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-72.8948036,\"lat\":41.5031239},{\"lng\":-77.43428,\"lat\":37.5385087},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-72.8611283,\"lat\":41.6156735},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.3635615,\"lat\":49.1813403},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-3.3738533,\"lat\":51.5171616},{\"lng\":6.9557118,\"lat\":43.5810901},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-87.9296885,\"lat\":42.3839618},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":-111.044047,\"lat\":45.6794293},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":2.1585037,\"lat\":48.9409016},{\"lng\":20.4777531,\"lat\":53.776644},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.4464337,\"lat\":47.5505154},{\"lng\":-119.242889,\"lat\":34.4480495},{\"lng\":-87.5085821,\"lat\":38.6907902},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-9.3901368,\"lat\":38.7095707},{\"lng\":2.0839562,\"lat\":48.724051},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-118.191604,\"lat\":33.7690164},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":17.9500556,\"lat\":59.4293164},{\"lng\":1.3009485,\"lat\":38.9830568},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.4585418,\"lat\":29.048099},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-82.4112377,\"lat\":33.0015407},{\"lng\":77.1201239,\"lat\":43.0860537},{\"lng\":-71.4802694,\"lat\":41.7198453},{\"lng\":-87.9020186,\"lat\":42.3702996},{\"lng\":-73.6376527,\"lat\":40.6335905},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":-79.7038708,\"lat\":44.5014007},{\"lng\":-92.2896267,\"lat\":34.7465071},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-81.7669488,\"lat\":28.5551912},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":10.0660066,\"lat\":52.2576212},{\"lng\":-2.2458192,\"lat\":51.8653705},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":6.5317943,\"lat\":46.724144},{\"lng\":-95.2441009,\"lat\":29.4238472},{\"lng\":-87.7090543,\"lat\":41.4845996},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-116.9719684,\"lat\":33.7475203},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-96.6388833,\"lat\":32.912624},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":-70.7055941,\"lat\":42.091769},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-76.7958641,\"lat\":39.36907},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-74.951279,\"lat\":40.1045549},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-84.5822632,\"lat\":33.8188333},{\"lng\":-121.971335,\"lat\":47.8552259},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-4.129694,\"lat\":52.9256029},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-71.2804301,\"lat\":41.9439695},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-1.1491319,\"lat\":44.6316943},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-95.5507771,\"lat\":30.7235263},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-107.9822884,\"lat\":38.6049854},{\"lng\":-70.4132249,\"lat\":41.653384},{\"lng\":-116.392326,\"lat\":43.6086295},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-70.6038026,\"lat\":41.4542914},{\"lng\":-111.8486019,\"lat\":40.3881114},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":16.9197326,\"lat\":52.4006632},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":6.1096409,\"lat\":46.2567057},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":2.1008067,\"lat\":49.0508845},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":-44.7610795,\"lat\":-23.1415413},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-76.8815207,\"lat\":38.8622077},{\"lng\":0.2781546,\"lat\":50.7664372},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-104.901361,\"lat\":40.4774818},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":9.6770448,\"lat\":50.5542328},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-80.3123023,\"lat\":43.3600536},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-89.5187664,\"lat\":34.3663773},{\"lng\":2.3633048,\"lat\":48.7921098},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3503555,\"lat\":60.5110194},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-72.8684337,\"lat\":41.2762081},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-71.4366813,\"lat\":41.779588},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":8.2736253,\"lat\":49.9995205},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-80.5222961,\"lat\":43.4652699},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-75.0254256,\"lat\":39.4862777},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-84.4721678,\"lat\":42.7320307},{\"lng\":2.2674892,\"lat\":48.9148269},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.0946169,\"lat\":40.5687128},{\"lng\":7.2439029,\"lat\":47.1402077},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-51.2303767,\"lat\":-30.0324999},{\"lng\":6.394641,\"lat\":58.983132},{\"lng\":-123.529828,\"lat\":38.7674439},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-81.3656419,\"lat\":28.6275253},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":-73.0151084,\"lat\":40.7656539},{\"lng\":136.8998438,\"lat\":35.1851045},{\"lng\":-70.6554648,\"lat\":-33.422295},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-46.3286399,\"lat\":-23.9335988},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":0.5604805,\"lat\":44.1749808},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-71.7614891,\"lat\":42.5267443},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.7017858,\"lat\":42.5909135},{\"lng\":-122.6744557,\"lat\":45.6306954},{\"lng\":-90.7045297,\"lat\":35.8348088},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.232523,\"lat\":37.4863239},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-80.0691435,\"lat\":26.615891},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.4046994,\"lat\":48.856303},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-2.2327511,\"lat\":53.3261292},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.427027,\"lat\":34.2625025},{\"lng\":-84.1555267,\"lat\":40.284241},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":5.5783856,\"lat\":46.1825453},{\"lng\":8.8071646,\"lat\":53.0758196},{\"lng\":71.4306682,\"lat\":51.1282205},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":-70.4429592,\"lat\":43.6797334},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":-47.059564,\"lat\":-22.9056391},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":-3.2751174,\"lat\":47.8058026},{\"lng\":-80.1433786,\"lat\":26.1223084},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.4034182,\"lat\":50.8720096},{\"lng\":-88.4605713,\"lat\":42.3294391},{\"lng\":-104.901361,\"lat\":40.4774818},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-74.3415394,\"lat\":41.0037087},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-79.1822594,\"lat\":40.8270091},{\"lng\":-122.116578,\"lat\":37.3790629},{\"lng\":-84.8407732,\"lat\":33.9237141},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":4.7449605,\"lat\":52.4681109},{\"lng\":-86.5859011,\"lat\":34.729847},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-78.7812081,\"lat\":35.7882893},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-98.1981486,\"lat\":19.0437196},{\"lng\":-81.0921335,\"lat\":32.0790074},{\"lng\":139.556512,\"lat\":35.636327},{\"lng\":74.2405329,\"lat\":16.7028412},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-106.4870404,\"lat\":31.7601164},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":1.2644847,\"lat\":45.8354243},{\"lng\":11.4250395,\"lat\":48.7630165},{\"lng\":1.3819699,\"lat\":51.3878174},{\"lng\":-5.5627852,\"lat\":54.6489642},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":10.2358999,\"lat\":53.6736529},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":-84.6696549,\"lat\":33.5178907},{\"lng\":-77.3115564,\"lat\":37.5107225},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-88.0079271,\"lat\":43.0494122},{\"lng\":-99.7475905,\"lat\":32.44645},{\"lng\":-120.9968892,\"lat\":37.6393419},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":-71.0993581,\"lat\":42.4802635},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-2.7599079,\"lat\":47.6586772},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-76.5483724,\"lat\":42.4374175},{\"lng\":-86.1336351,\"lat\":40.4864444},{\"lng\":-82.3984882,\"lat\":34.851354},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-52.7066964,\"lat\":47.5646794},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-38.4812772,\"lat\":-12.9822499},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-116.2188054,\"lat\":33.7192808},{\"lng\":-122.587967,\"lat\":37.9872935},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-93.9993505,\"lat\":44.1634663},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-76.610759,\"lat\":39.2908816},{\"lng\":-71.8046023,\"lat\":42.5854371},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-0.4675041,\"lat\":52.1363806},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-2.8042467,\"lat\":53.4275807},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-90.0539604,\"lat\":29.9146493},{\"lng\":-97.1413417,\"lat\":33.1838787},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":9.1895147,\"lat\":48.8953937},{\"lng\":-77.0893094,\"lat\":38.8769326},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-76.8646092,\"lat\":39.1938429},{\"lng\":-75.3173407,\"lat\":40.0238245},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":72.5800568,\"lat\":23.0215374},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-42.507633,\"lat\":-22.9257974},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-74.0218037,\"lat\":40.1784471},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-105.101928,\"lat\":40.1672117},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-83.1338214,\"lat\":42.680588},{\"lng\":-81.4548392,\"lat\":39.4167742},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-80.2440518,\"lat\":36.0998131},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":-1.3824404,\"lat\":54.9061115},{\"lng\":-85.4997057,\"lat\":36.1623886},{\"lng\":73.7902364,\"lat\":20.0112475},{\"lng\":-0.8324037,\"lat\":51.4120318},{\"lng\":121.0338973,\"lat\":14.5774392},{\"lng\":-99.1952423,\"lat\":19.3906515},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-117.7999026,\"lat\":49.0784756},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":-85.7602087,\"lat\":38.2967791},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-72.6077753,\"lat\":41.7148499},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.3865271,\"lat\":40.1936892},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-122.5352539,\"lat\":37.9340915},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-99.1955083,\"lat\":19.5370001},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":12.3425797,\"lat\":45.5035386},{\"lng\":-1.7854322,\"lat\":51.5615327},{\"lng\":1.1528095,\"lat\":52.0579324},{\"lng\":-73.1846098,\"lat\":44.534084},{\"lng\":-1.5149935,\"lat\":43.4813927},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":6.282178,\"lat\":46.7745324},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-72.7296262,\"lat\":42.2294201},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-77.710254,\"lat\":39.5893502},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":125.4515852,\"lat\":6.878324},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-121.99059,\"lat\":37.050096},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-96.9034244,\"lat\":32.9515472},{\"lng\":-75.2590721,\"lat\":39.9184461},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":13.08824,\"lat\":52.5606426},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-97.1384584,\"lat\":49.8955367},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":2.3197111,\"lat\":48.9891693},{\"lng\":127.4554285,\"lat\":36.3120051},{\"lng\":-74.0323752,\"lat\":40.7433066},{\"lng\":18.4368451,\"lat\":49.7801136},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-83.6554159,\"lat\":36.5798289},{\"lng\":-74.0410865,\"lat\":40.8871438},{\"lng\":6.7360182,\"lat\":43.4330308},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-87.8536288,\"lat\":41.630663},{\"lng\":-71.1564428,\"lat\":42.4153739},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-74.0254577,\"lat\":45.3971509},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":0.2781546,\"lat\":50.7664372},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.1867391,\"lat\":41.1779095},{\"lng\":-123.0737925,\"lat\":49.3206294},{\"lng\":-66.9146008,\"lat\":10.5060934},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-84.2332718,\"lat\":39.5522815},{\"lng\":-87.2550353,\"lat\":41.5322592},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.2471089,\"lat\":42.3479005},{\"lng\":-82.4333742,\"lat\":42.9760854},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":22.0291149,\"lat\":60.4688687},{\"lng\":0.1481142,\"lat\":51.5413271},{\"lng\":-103.3913671,\"lat\":20.7211203},{\"lng\":6.9478263,\"lat\":46.252844},{\"lng\":2.2766735,\"lat\":48.730158},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-118.307201,\"lat\":34.1812089},{\"lng\":14.286198,\"lat\":48.3059078},{\"lng\":-43.9450948,\"lat\":-19.9227318},{\"lng\":-74.6607144,\"lat\":40.4667713},{\"lng\":-1.5391039,\"lat\":53.9921491},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":18.1820897,\"lat\":59.3669445},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.4754913,\"lat\":42.48059},{\"lng\":-80.0131374,\"lat\":33.1960027},{\"lng\":-75.2215651,\"lat\":40.1545535},{\"lng\":139.7280058,\"lat\":35.744206},{\"lng\":-121.971335,\"lat\":47.8552259},{\"lng\":-76.5528831,\"lat\":39.155816},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-121.899142,\"lat\":37.6090291},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-122.0618702,\"lat\":37.9020731},{\"lng\":-122.9543022,\"lat\":50.1171903},{\"lng\":-1.4761491,\"lat\":52.9212617},{\"lng\":-73.9081901,\"lat\":42.0128695},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-3.7824148,\"lat\":51.5952353},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":5.4474738,\"lat\":43.5298424},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-65.2038133,\"lat\":-26.8303703},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-120.310349,\"lat\":47.4234599},{\"lng\":-97.7870525,\"lat\":32.4426759},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":-83.1446485,\"lat\":42.4894801},{\"lng\":-46.7916801,\"lat\":-23.5324859},{\"lng\":-9.2365233,\"lat\":38.758959},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":-122.2127011,\"lat\":47.9793437},{\"lng\":-116.559631,\"lat\":43.5737361},{\"lng\":-79.5692407,\"lat\":44.9955309},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":4.7201986,\"lat\":46.3472473},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-87.7115555,\"lat\":42.076066},{\"lng\":-82.255371,\"lat\":34.7373045},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-3.5269209,\"lat\":50.7256138},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":4.93296,\"lat\":44.8534},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.1562551,\"lat\":40.7464901},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-90.5132836,\"lat\":14.6416142},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-122.6925983,\"lat\":45.2629088},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.3433705,\"lat\":40.1148787},{\"lng\":-92.9645794,\"lat\":44.985624},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-16.2507843,\"lat\":28.467178},{\"lng\":5.2146275,\"lat\":43.4162729},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-97.6114237,\"lat\":38.8402805},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-73.425676,\"lat\":40.868154},{\"lng\":5.2176582,\"lat\":52.3722582},{\"lng\":-123.6229791,\"lat\":48.6538128},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-86.5245906,\"lat\":35.9670985},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":1.204956,\"lat\":49.2551454},{\"lng\":-17.447938,\"lat\":14.693425},{\"lng\":-94.4137923,\"lat\":39.0924792},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-71.5147839,\"lat\":42.0028761},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":-77.1516844,\"lat\":39.0817985},{\"lng\":-73.2504911,\"lat\":42.3073477},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":-75.0629531,\"lat\":42.453492},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":2.4455201,\"lat\":48.9229803},{\"lng\":-0.0472059,\"lat\":38.6028245},{\"lng\":-76.5600957,\"lat\":38.3380008},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":30.7030242,\"lat\":36.8865728},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.4993421,\"lat\":42.6411975},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":14.0381357,\"lat\":50.6603327},{\"lng\":-82.6359078,\"lat\":27.7700475},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-82.9741393,\"lat\":42.5438148},{\"lng\":-87.9299841,\"lat\":41.8024604},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-109.2194544,\"lat\":41.5860557},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-94.9774274,\"lat\":29.7355047},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.2775316,\"lat\":48.7670404},{\"lng\":-117.3272615,\"lat\":33.6680772},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-9.1072662,\"lat\":38.6422246},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-115.474899,\"lat\":32.6405247},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-3.0087671,\"lat\":43.3479409},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-77.185843,\"lat\":38.9366852},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-80.7325345,\"lat\":28.3556635},{\"lng\":2.2766735,\"lat\":48.730158},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-1.5959177,\"lat\":48.8376296},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":10.3694118,\"lat\":52.2608949},{\"lng\":7.3579641,\"lat\":48.0777517},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-2.5943178,\"lat\":53.3899497},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":2.6045838,\"lat\":49.3012483},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-71.1786655,\"lat\":42.3959296},{\"lng\":-80.0666026,\"lat\":26.5256179},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":-86.5342881,\"lat\":39.1670396},{\"lng\":-77.3191454,\"lat\":42.850682},{\"lng\":-123.315869,\"lat\":44.9189206},{\"lng\":-77.57539,\"lat\":44.1019126},{\"lng\":-0.7242791,\"lat\":45.0924569},{\"lng\":-80.5495112,\"lat\":34.9854275},{\"lng\":-118.8375937,\"lat\":34.1705609},{\"lng\":10.4510906,\"lat\":54.0341582},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":8.5345821,\"lat\":52.0267233},{\"lng\":3.8969928,\"lat\":7.3786064},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-84.2138789,\"lat\":10.0165183},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-121.802173,\"lat\":36.6844029},{\"lng\":-95.6971686,\"lat\":29.9691116},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-99.243949,\"lat\":19.5733975},{\"lng\":2.3210103,\"lat\":48.8667225},{\"lng\":11.3426327,\"lat\":44.4938203},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-71.010051,\"lat\":42.4648183},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.0832101,\"lat\":37.3893889},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-119.019463,\"lat\":35.3738712},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-121.503636,\"lat\":43.6703995},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.1400561,\"lat\":50.8214626},{\"lng\":-75.4179623,\"lat\":41.1770316},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.2630238,\"lat\":48.8003835},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-77.1549078,\"lat\":39.3765918},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-88.3161965,\"lat\":42.2411344},{\"lng\":-97.1503865,\"lat\":27.909666},{\"lng\":-122.3218414,\"lat\":38.4898675},{\"lng\":24.7453688,\"lat\":59.4372155},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-93.847129,\"lat\":33.9456692},{\"lng\":7.5004774,\"lat\":47.0168481},{\"lng\":-83.2910468,\"lat\":42.6389216},{\"lng\":-83.1052028,\"lat\":42.4858692},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-0.1332853,\"lat\":50.9575365},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-80.154904,\"lat\":-3.4145538},{\"lng\":2.590549,\"lat\":48.8783804},{\"lng\":-117.379483,\"lat\":33.1958696},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":6.4353792,\"lat\":51.1947131},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":8.9520281,\"lat\":46.0050102},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-87.8122348,\"lat\":42.0289319},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-85.8480354,\"lat\":39.9322625},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-71.4165905,\"lat\":42.2773177},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-95.2864299,\"lat\":29.5639758},{\"lng\":5.112215,\"lat\":43.8441157},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":6.6816355,\"lat\":46.6012433},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-96.9977846,\"lat\":32.7459645},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-117.000165,\"lat\":46.7323875},{\"lng\":0.2446652,\"lat\":50.8276836},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":10.8815262,\"lat\":49.5710376},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":-73.1307708,\"lat\":41.1947276},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":77.1709729,\"lat\":31.1041526},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-8.6192306,\"lat\":41.5314496},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":17.916667,\"lat\":59.516667},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-72.1934184,\"lat\":41.3212481},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":4.8868454,\"lat\":45.7733573},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":15.25,\"lat\":59.05},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":15.094215,\"lat\":37.5774071},{\"lng\":12.087733,\"lat\":49.05151},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-90.6956872,\"lat\":37.154497},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.0237512,\"lat\":40.7795455},{\"lng\":-96.789821,\"lat\":46.877229},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.438329,\"lat\":47.2455013},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.6171001,\"lat\":54.9751321},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-86.0887296,\"lat\":35.4832001},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-74.171811,\"lat\":40.9167654},{\"lng\":-77.1710914,\"lat\":38.882334},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-73.5835826,\"lat\":40.6576071},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-0.74043,\"lat\":50.9841854},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-91.2514355,\"lat\":43.8122836},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":8.2416556,\"lat\":50.0820384},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-97.1071186,\"lat\":32.7355816},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-85.8590603,\"lat\":41.6012796},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-114.568298,\"lat\":35.1477774},{\"lng\":16.6957954,\"lat\":47.913427},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":12.5700724,\"lat\":55.6867243},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":10.5385882,\"lat\":52.9840679},{\"lng\":7.2196635,\"lat\":51.4818111},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":8.7610698,\"lat\":50.1055002},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-76.7455478,\"lat\":39.2609921},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":7.8400336,\"lat\":52.0362198},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-88.0437509,\"lat\":30.6913462},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-114.9822486,\"lat\":36.0319843},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":-80.1792299,\"lat\":39.8964641},{\"lng\":-71.3725464,\"lat\":-33.0441903},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-80.8429304,\"lat\":35.4108278},{\"lng\":7.0845893,\"lat\":51.1721629},{\"lng\":-114.568298,\"lat\":35.1477774},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.4726215,\"lat\":38.3235441},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":7.802508,\"lat\":48.7182493},{\"lng\":-75.1268413,\"lat\":40.0770553},{\"lng\":-74.9999754,\"lat\":40.0166151},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-74.3592296,\"lat\":40.7182356},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.9695409,\"lat\":41.5048402},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.2396612,\"lat\":42.7844752},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-2.4396676,\"lat\":42.4661196},{\"lng\":-89.6501621,\"lat\":40.5687911},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-98.2695702,\"lat\":29.5641617},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-70.7548621,\"lat\":43.0702223},{\"lng\":-74.2289491,\"lat\":40.7264091},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-93.3501222,\"lat\":44.8897027},{\"lng\":-93.6249494,\"lat\":41.5868654},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-94.8907869,\"lat\":47.4785418},{\"lng\":-95.8243956,\"lat\":29.7857853},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-71.1818781,\"lat\":44.1105541},{\"lng\":75.8189817,\"lat\":26.9154576},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":7.7391678,\"lat\":52.1363237},{\"lng\":110.4229104,\"lat\":-6.9903988},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-80.4934035,\"lat\":41.2331116},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-121.8106925,\"lat\":38.0093296},{\"lng\":141.3542924,\"lat\":43.061936},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-60.9677445,\"lat\":-34.5796344},{\"lng\":-76.9832568,\"lat\":39.8005316},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.080796,\"lat\":37.6688205},{\"lng\":-117.1743395,\"lat\":33.1352995},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-121.290779,\"lat\":37.9577016},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-75.1198911,\"lat\":39.9448402},{\"lng\":-118.6058382,\"lat\":34.1684364},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-122.7453699,\"lat\":53.9128645},{\"lng\":3.9452194,\"lat\":50.4431879},{\"lng\":-58.7157491,\"lat\":-34.540349},{\"lng\":-96.789821,\"lat\":46.877229},{\"lng\":-117.7197785,\"lat\":34.0966764},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-73.7145746,\"lat\":41.0409305},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-88.5061721,\"lat\":40.211422},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-118.7885967,\"lat\":45.672075},{\"lng\":47.9734174,\"lat\":29.3796532},{\"lng\":-70.9494939,\"lat\":42.466763},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":-117.9962165,\"lat\":33.870413},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-74.4113926,\"lat\":40.518157},{\"lng\":-73.8381351,\"lat\":42.6251239},{\"lng\":8.8791526,\"lat\":51.936284},{\"lng\":-74.9426677,\"lat\":39.9670569},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":80.9346001,\"lat\":26.8381},{\"lng\":-77.4083096,\"lat\":39.003685},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-70.7618592,\"lat\":41.9426657},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-79.05578,\"lat\":35.9131542},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":71.4306682,\"lat\":51.1282205},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-97.0819541,\"lat\":32.8370727},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":44.8005558,\"lat\":41.6953103},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.4173658,\"lat\":48.8688199},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":-48.5496098,\"lat\":-27.5973002},{\"lng\":-79.0287742,\"lat\":-8.1116778},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":13.4153952,\"lat\":52.3384429},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-81.4222408,\"lat\":26.42016},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":55.7452211,\"lat\":24.2248697},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":-3.2299102,\"lat\":51.6489468},{\"lng\":-0.3394758,\"lat\":53.7435722},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-83.1499322,\"lat\":42.6583661},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-112.081648,\"lat\":40.7031629},{\"lng\":-82.5817053,\"lat\":34.8269276},{\"lng\":8.3266114,\"lat\":47.465839},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":98.3891503,\"lat\":7.8847901},{\"lng\":-76.4229094,\"lat\":40.8724037},{\"lng\":76.7797143,\"lat\":30.7334421},{\"lng\":-79.5341802,\"lat\":8.9714493},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":7.0581152,\"lat\":46.6190969},{\"lng\":149.1012676,\"lat\":-35.2975906},{\"lng\":-116.9739167,\"lat\":32.8383828},{\"lng\":121.451,\"lat\":25.0615},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":27.4962548,\"lat\":38.4549686},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-92.9438218,\"lat\":44.8277446},{\"lng\":-1.4761491,\"lat\":52.9212617},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":23.683814,\"lat\":38.0425567},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.9813349,\"lat\":44.6697996},{\"lng\":3.2131307,\"lat\":43.3426562},{\"lng\":-73.6788272,\"lat\":41.4266361},{\"lng\":0.0769545,\"lat\":51.4115718},{\"lng\":-92.2896267,\"lat\":34.7465071},{\"lng\":11.3297921,\"lat\":50.9793301},{\"lng\":-1.1210853,\"lat\":50.7952074},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-149.894852,\"lat\":61.2163129},{\"lng\":2.4412184,\"lat\":48.8623357},{\"lng\":-96.7297206,\"lat\":32.9481789},{\"lng\":-1.9417444,\"lat\":52.3057655},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":77.7679671,\"lat\":29.0018557},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":9.4048406,\"lat\":51.0117227},{\"lng\":-1.6302142,\"lat\":53.6909103},{\"lng\":-68.672791,\"lat\":44.883607},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":8.9420101,\"lat\":45.9838461},{\"lng\":-8.7247205,\"lat\":42.2376602},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-75.2890745,\"lat\":39.9001126},{\"lng\":-71.0744952,\"lat\":42.2973205},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-111.9866954,\"lat\":40.6967891},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-117.953097,\"lat\":34.0280619},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-95.858694,\"lat\":40.676526},{\"lng\":-0.591276,\"lat\":51.512103},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":-87.607616,\"lat\":45.415251},{\"lng\":50.1039991,\"lat\":26.4367824},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-87.7115555,\"lat\":42.076066},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":-88.0434304,\"lat\":42.1105502},{\"lng\":-88.083406,\"lat\":42.0333608},{\"lng\":7.1262071,\"lat\":43.5812868},{\"lng\":7.3389937,\"lat\":47.7467233},{\"lng\":-122.5316686,\"lat\":37.9747795},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-72.789313,\"lat\":41.9538298},{\"lng\":-73.642509,\"lat\":41.2041304},{\"lng\":-0.6450841,\"lat\":53.5922488},{\"lng\":-0.3250175,\"lat\":45.6931647},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-87.8122348,\"lat\":42.0289319},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-76.307162,\"lat\":40.1571324},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":4.8920811,\"lat\":44.9332277},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-122.271356,\"lat\":37.8044557},{\"lng\":139.5400411,\"lat\":35.7287951},{\"lng\":-74.4222416,\"lat\":40.6201412},{\"lng\":-84.0795782,\"lat\":9.9325427},{\"lng\":-75.3490769,\"lat\":40.0373323},{\"lng\":124.7243618,\"lat\":8.4993515},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-122.8950075,\"lat\":47.0451022},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-1.0582645,\"lat\":52.566854},{\"lng\":5.6969882,\"lat\":50.8579855},{\"lng\":-71.2503157,\"lat\":41.6024068},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-75.2216048,\"lat\":38.4606407},{\"lng\":-0.3957425,\"lat\":51.6553875},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":-49.2712724,\"lat\":-25.4295963},{\"lng\":-123.137414,\"lat\":49.163168},{\"lng\":5.1580574,\"lat\":45.614003},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-71.2213228,\"lat\":43.4563663},{\"lng\":-80.794252,\"lat\":34.1709826},{\"lng\":8.7291498,\"lat\":47.4991723},{\"lng\":5.862294,\"lat\":43.4522053},{\"lng\":-81.6695739,\"lat\":39.3753521},{\"lng\":91.8825282,\"lat\":25.5760446},{\"lng\":5.9815066,\"lat\":50.8775239},{\"lng\":-85.4807825,\"lat\":32.6098566},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":2.4159739,\"lat\":48.8432434},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":26.1190178,\"lat\":44.3819025},{\"lng\":76.7176885,\"lat\":30.7041168},{\"lng\":26.1772794,\"lat\":44.4902779},{\"lng\":33.0332657,\"lat\":34.6852901},{\"lng\":2.4806112,\"lat\":48.8412317},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-87.850367,\"lat\":43.4997212},{\"lng\":-82.2880508,\"lat\":27.928464},{\"lng\":-71.0119948,\"lat\":42.4084302},{\"lng\":12.4985492,\"lat\":55.704111},{\"lng\":-105.0811573,\"lat\":39.8005505},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-61.4764728,\"lat\":-31.2492442},{\"lng\":6.9129921,\"lat\":46.4310831},{\"lng\":-72.8684337,\"lat\":41.2762081},{\"lng\":-105.089705,\"lat\":39.9935959},{\"lng\":0.2175739,\"lat\":44.460778},{\"lng\":19.4784857,\"lat\":51.7728245},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":7.0845893,\"lat\":51.1721629},{\"lng\":-122.870138,\"lat\":38.6106812},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-83.3771553,\"lat\":42.4853125},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-1.4722242,\"lat\":47.1685211},{\"lng\":2.2257833,\"lat\":48.7423961},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":26.1650992,\"lat\":44.4182836},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":24.6559808,\"lat\":60.2049651},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":23.7089143,\"lat\":38.0620067},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.3111645,\"lat\":39.2025604},{\"lng\":-5.9953403,\"lat\":37.3886303},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":12.2455414,\"lat\":45.6658505},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-155.9564366,\"lat\":19.663401},{\"lng\":5.1215634,\"lat\":52.0907006},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-75.5149128,\"lat\":40.1303822},{\"lng\":-34.8848193,\"lat\":-8.0584933},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-79.7567616,\"lat\":43.2167526},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":7.7430022,\"lat\":46.3153507},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":26.2513165,\"lat\":50.6196175},{\"lng\":-122.2054035,\"lat\":47.7623204},{\"lng\":7.0086255,\"lat\":43.641141},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":5.4768915,\"lat\":52.5150949},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":78.4740613,\"lat\":17.360589},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":9.0804584,\"lat\":52.1873798},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-92.1052679,\"lat\":46.7838287},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":85.3205817,\"lat\":27.708317},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":6.6760958,\"lat\":51.2652237},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-94.282265,\"lat\":39.017316},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-117.000165,\"lat\":46.7323875},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-77.3063733,\"lat\":38.8462236},{\"lng\":91.8825282,\"lat\":25.5760446},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-83.6277255,\"lat\":42.7919727},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-105.270545,\"lat\":40.0149856},{\"lng\":-3.7824148,\"lat\":51.5952353},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":0.3233131,\"lat\":51.4780898},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-80.0830984,\"lat\":26.3586885},{\"lng\":-118.4486675,\"lat\":34.1866193},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-2.3596963,\"lat\":51.3813864},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-0.902805,\"lat\":52.2343297},{\"lng\":-5.5627852,\"lat\":54.6489642},{\"lng\":2.0153689,\"lat\":48.5288442},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-79.1462866,\"lat\":42.060185},{\"lng\":7.089351,\"lat\":49.4305056},{\"lng\":-105.0770113,\"lat\":40.5871782},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-114.334624,\"lat\":48.4108018},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":-72.0362956,\"lat\":43.3213132},{\"lng\":-8.6103497,\"lat\":41.1502195},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-123.033121,\"lat\":44.9391565},{\"lng\":-83.3527097,\"lat\":42.36837},{\"lng\":-1.1399149,\"lat\":53.5219538},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.173895,\"lat\":46.7304268},{\"lng\":-3.9804785,\"lat\":55.8661181},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":7.3389937,\"lat\":47.7467233},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":0.0295469,\"lat\":51.5217707},{\"lng\":-9.3354702,\"lat\":38.6921092},{\"lng\":-1.5815742,\"lat\":52.2814519},{\"lng\":-2.2458192,\"lat\":51.8653705},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":4.8994366,\"lat\":45.823514},{\"lng\":-157.855676,\"lat\":21.304547},{\"lng\":-80.0532942,\"lat\":26.715364},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":19.9971534,\"lat\":50.0469432},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-82.9651045,\"lat\":40.2317686},{\"lng\":7.063054,\"lat\":50.3181149},{\"lng\":-74.4809868,\"lat\":40.7970382},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":2.4530731,\"lat\":48.7771486},{\"lng\":-74.0970865,\"lat\":40.833989},{\"lng\":-74.4660408,\"lat\":40.5462553},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-81.8802713,\"lat\":42.9480988},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-79.5443274,\"lat\":40.3024514},{\"lng\":-71.3739532,\"lat\":42.8650869},{\"lng\":-76.492786,\"lat\":38.9786401},{\"lng\":0.1079732,\"lat\":49.4938975},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-76.1474244,\"lat\":43.0481221},{\"lng\":-5.71649,\"lat\":54.3279335},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":9.8444774,\"lat\":55.8611696},{\"lng\":-123.364953,\"lat\":48.4283182},{\"lng\":13.2591116,\"lat\":54.4566445},{\"lng\":0.0689113,\"lat\":51.5589375},{\"lng\":75.8189817,\"lat\":26.9154576},{\"lng\":4.6696185,\"lat\":52.5496739},{\"lng\":-71.3876472,\"lat\":41.8873726},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-73.3762307,\"lat\":41.5139837},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-1.4149834,\"lat\":43.4694806},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-82.7873244,\"lat\":27.9094665},{\"lng\":-87.9090751,\"lat\":43.0386475},{\"lng\":-71.2360624,\"lat\":42.2802645},{\"lng\":-70.6694015,\"lat\":41.5238752},{\"lng\":-77.8616386,\"lat\":40.7944504},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-99.5069922,\"lat\":27.5075005},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-1.1305431,\"lat\":37.9923795},{\"lng\":-84.1916069,\"lat\":39.7589478},{\"lng\":-70.8781883,\"lat\":42.5489744},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-75.710976,\"lat\":45.4277659},{\"lng\":115.3351,\"lat\":-33.65214},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-74.6597376,\"lat\":40.3496953},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":7.6944741,\"lat\":47.5192013},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":9.2794469,\"lat\":41.5911382},{\"lng\":13.08824,\"lat\":52.5606426},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":9.1896346,\"lat\":45.4641943},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-71.9952737,\"lat\":42.5763523},{\"lng\":-8.3959425,\"lat\":43.3709703},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":2.1748233,\"lat\":48.8051045},{\"lng\":-79.7966835,\"lat\":43.3248924},{\"lng\":3.8855537,\"lat\":45.0459739},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-88.1479278,\"lat\":41.7728699},{\"lng\":100.5386136,\"lat\":13.7784702},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-85.3094883,\"lat\":35.0457219},{\"lng\":-97.856109,\"lat\":27.5158689},{\"lng\":-77.4347283,\"lat\":38.837613},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-82.2946444,\"lat\":28.058051},{\"lng\":-84.2809332,\"lat\":30.4380832},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-76.8738048,\"lat\":17.9717917},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-97.3404854,\"lat\":32.9616819},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-89.5426165,\"lat\":43.1715386},{\"lng\":-87.3297254,\"lat\":20.8227773},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-94.4265011,\"lat\":35.3880338},{\"lng\":6.996379,\"lat\":49.234362},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-96.0422378,\"lat\":41.1544433},{\"lng\":-0.4181471,\"lat\":51.5077154},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-81.3055188,\"lat\":28.6987317},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.9081901,\"lat\":42.0128695},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-112.450627,\"lat\":42.8620287},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":101.6454202,\"lat\":3.0988792},{\"lng\":-71.3495035,\"lat\":42.5292605},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":5.0414701,\"lat\":47.3215806},{\"lng\":-111.551448,\"lat\":45.892606},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-96.3198013,\"lat\":15.8313373},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-86.1283681,\"lat\":39.9784186},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-79.5655129,\"lat\":43.7213619},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.546589,\"lat\":39.7459468},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-75.0376707,\"lat\":39.8915022},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-0.6680194,\"lat\":51.4101286},{\"lng\":-2.9779978,\"lat\":53.4102276},{\"lng\":-92.2896267,\"lat\":34.7465071},{\"lng\":-120.832348,\"lat\":35.3107214},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.5538088,\"lat\":34.4127963},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.5293246,\"lat\":40.7695303},{\"lng\":-159.3191601,\"lat\":22.0747334},{\"lng\":-74.9338911,\"lat\":39.9005585},{\"lng\":7.0158171,\"lat\":51.4582235},{\"lng\":-95.2296553,\"lat\":30.1024397},{\"lng\":-80.0983887,\"lat\":-2.2895167},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-93.2827625,\"lat\":45.2710195},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-159.465733,\"lat\":21.9042279},{\"lng\":7.2439029,\"lat\":47.1402077},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-90.0034862,\"lat\":34.9873822},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":123.8559809,\"lat\":9.6402611},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.0542002,\"lat\":42.4085897},{\"lng\":-70.2506847,\"lat\":43.7977006},{\"lng\":2.136145,\"lat\":48.8478753},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-73.6343052,\"lat\":40.7266477},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-79.4428157,\"lat\":37.7840208},{\"lng\":6.8236481,\"lat\":52.035862},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-1.0582645,\"lat\":52.566854},{\"lng\":-73.9876388,\"lat\":40.8214894},{\"lng\":5.3259192,\"lat\":60.3943055},{\"lng\":8.8459949,\"lat\":41.8353888},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-83.2696509,\"lat\":42.240872},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-122.824222,\"lat\":38.4021038},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-0.5668831,\"lat\":53.7296397},{\"lng\":-92.447758,\"lat\":42.5361805},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-74.2724241,\"lat\":40.5133218},{\"lng\":5.5836164,\"lat\":43.6465639},{\"lng\":4.6552471,\"lat\":52.0441134},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":-105.22058,\"lat\":39.7546349},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.171811,\"lat\":40.9167654},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-2.632996,\"lat\":53.5433996},{\"lng\":-1.3908774,\"lat\":50.9058615},{\"lng\":-73.4105803,\"lat\":41.5770993},{\"lng\":-87.7962812,\"lat\":41.6681632},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-88.1761521,\"lat\":39.4961458},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-8.0952772,\"lat\":53.9441461},{\"lng\":121.0486254,\"lat\":14.6510546},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-0.7024738,\"lat\":49.2764624},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":10.7518463,\"lat\":59.7756124},{\"lng\":1.3819699,\"lat\":51.3878174},{\"lng\":-81.8020722,\"lat\":24.5548262},{\"lng\":-76.9408647,\"lat\":38.9529442},{\"lng\":115.0975839,\"lat\":-8.5959846},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-74.6241189,\"lat\":40.3159898},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.3426122,\"lat\":33.9128272},{\"lng\":-86.2500066,\"lat\":41.6833813},{\"lng\":-77.3724593,\"lat\":35.613224},{\"lng\":-79.2576479,\"lat\":43.7729744},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.5076181,\"lat\":48.881886},{\"lng\":5.0980225,\"lat\":43.6405237},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-122.1180201,\"lat\":37.8857582},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-122.1244088,\"lat\":37.6810422},{\"lng\":-87.9296885,\"lat\":42.3839618},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":77.3272147,\"lat\":28.5706333},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":100.5386136,\"lat\":13.7784702},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":72.5800568,\"lat\":23.0215374},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":9.0988968,\"lat\":50.1591912},{\"lng\":-77.3465081,\"lat\":37.5131191},{\"lng\":-1.7003017,\"lat\":43.3624715},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":12.6484621,\"lat\":47.8695272},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":57.4927352,\"lat\":-20.2988986},{\"lng\":-79.9047583,\"lat\":36.2087468},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":12.4483489,\"lat\":55.6898267},{\"lng\":-80.9968286,\"lat\":29.1386874},{\"lng\":9.1800132,\"lat\":48.7784485},{\"lng\":74.8580917,\"lat\":32.7185614},{\"lng\":-64.1834193,\"lat\":-31.4166867},{\"lng\":74.8430082,\"lat\":12.8698101},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-73.1715669,\"lat\":44.4671635},{\"lng\":6.1376008,\"lat\":51.7895571},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":7.71667,\"lat\":50.15},{\"lng\":-66.0585188,\"lat\":45.2787992},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.5463018,\"lat\":34.8999056},{\"lng\":-1.1019893,\"lat\":46.2051404},{\"lng\":-2.2478582,\"lat\":52.3880787},{\"lng\":139.6742379,\"lat\":35.6959247},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":-74.1723667,\"lat\":40.735657},{\"lng\":8.6895121,\"lat\":47.4330901},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-122.972545,\"lat\":49.2433804},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.824222,\"lat\":38.4021038},{\"lng\":-73.1774881,\"lat\":42.1894315},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":8.4673098,\"lat\":49.4892913},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":12.0495271,\"lat\":57.7970147},{\"lng\":12.0495271,\"lat\":57.7970147},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":6.083862,\"lat\":50.776351},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":7.0960124,\"lat\":51.5110321},{\"lng\":-58.3953235,\"lat\":-34.7033363},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":8.041135,\"lat\":51.7555148},{\"lng\":11.9178807,\"lat\":50.3219015},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":3.2106461,\"lat\":39.5696458},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":8.7025509,\"lat\":48.890934},{\"lng\":27.5107799,\"lat\":40.9781214},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":17.1314203,\"lat\":48.1557669},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":5.1630646,\"lat\":52.2773656},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":4.3600687,\"lat\":43.8374249},{\"lng\":-87.682932,\"lat\":42.0693991},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-88.3147539,\"lat\":41.7571701},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":11.1647964,\"lat\":61.0014937},{\"lng\":-78.828717,\"lat\":42.716293},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":2.3516139,\"lat\":48.8475163},{\"lng\":2.9610284,\"lat\":48.3868056},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-71.8018877,\"lat\":42.2625621},{\"lng\":-1.2779715,\"lat\":51.6714842},{\"lng\":-85.1646726,\"lat\":34.257038},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-81.3399769,\"lat\":41.6664781},{\"lng\":0.0880189,\"lat\":52.5505996},{\"lng\":-2.7151735,\"lat\":52.0553813},{\"lng\":-0.0139562,\"lat\":51.4656437},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-7.9351771,\"lat\":37.0162727},{\"lng\":-88.9524151,\"lat\":39.8454163},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-79.9900861,\"lat\":40.4416941},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-17.447938,\"lat\":14.693425},{\"lng\":-84.9702475,\"lat\":34.7691867},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":4.4344787,\"lat\":52.2484451},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":-72.7489158,\"lat\":42.1205411},{\"lng\":1.5485088,\"lat\":49.0613978},{\"lng\":-82.005019,\"lat\":39.9401426},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-71.0183787,\"lat\":42.0834335},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":29.7828009,\"lat\":70.2267198},{\"lng\":20.4568974,\"lat\":44.8178131},{\"lng\":-0.4503027,\"lat\":51.7135573},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-85.1288435,\"lat\":36.5745104},{\"lng\":-74.7659,\"lat\":40.2203074},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-89.953157,\"lat\":38.8114364},{\"lng\":-82.3490533,\"lat\":31.7773202},{\"lng\":-73.6788272,\"lat\":41.4266361},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.5129682,\"lat\":41.3894198},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-88.0102281,\"lat\":41.7936822},{\"lng\":-82.403533,\"lat\":42.9743821},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":35.5025585,\"lat\":33.8892265},{\"lng\":-84.2747329,\"lat\":34.0709576},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-77.0240371,\"lat\":38.9997621},{\"lng\":-98.7075744,\"lat\":35.5261633},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-77.061362,\"lat\":43.237843},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":-97.827833,\"lat\":30.5217116},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-88.0437509,\"lat\":30.6913462},{\"lng\":-97.3327459,\"lat\":32.753177},{\"lng\":-75.4712794,\"lat\":40.6022059},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-99.1517322,\"lat\":19.4414715},{\"lng\":-117.825981,\"lat\":33.6856969},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-71.1061639,\"lat\":42.4184296},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":104.9224426,\"lat\":11.568271},{\"lng\":-117.659405,\"lat\":33.5965685},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":1.3011264,\"lat\":51.1291363},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-122.47267,\"lat\":37.6904826},{\"lng\":-6.5922806,\"lat\":53.3830239},{\"lng\":10.8171691,\"lat\":52.2499307},{\"lng\":0.0793235,\"lat\":51.5402677},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":2.2543631,\"lat\":48.9227298},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-86.3091683,\"lat\":32.37742},{\"lng\":-96.8238183,\"lat\":33.1505998},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.9459248,\"lat\":51.6195955},{\"lng\":-83.8979573,\"lat\":33.9887165},{\"lng\":6.7763137,\"lat\":51.2254018},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-111.29189,\"lat\":47.5048851},{\"lng\":-87.5519629,\"lat\":35.5478514},{\"lng\":-111.651822,\"lat\":35.1987522},{\"lng\":-2.1757665,\"lat\":48.3491768},{\"lng\":2.4879753,\"lat\":48.716811},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-117.0244313,\"lat\":34.8986215},{\"lng\":-123.1059324,\"lat\":44.6365071},{\"lng\":-83.2501548,\"lat\":31.2074197},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":3.3941795,\"lat\":6.4550575},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.374752,\"lat\":34.1649502},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-87.9589621,\"lat\":42.1544205},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-80.4927815,\"lat\":43.451291},{\"lng\":-9.2719186,\"lat\":38.788679},{\"lng\":-38.4812772,\"lat\":-12.9822499},{\"lng\":50.1014927,\"lat\":53.1956255},{\"lng\":-81.3749508,\"lat\":40.7985464},{\"lng\":-117.2860371,\"lat\":34.2475493},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":4.5310837,\"lat\":52.0109579},{\"lng\":76.7797143,\"lat\":30.7334421},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-38.4812772,\"lat\":-12.9822499},{\"lng\":-0.0154152,\"lat\":51.4781086},{\"lng\":-83.9704593,\"lat\":35.7564719},{\"lng\":-95.8519484,\"lat\":41.258841},{\"lng\":-2.3783676,\"lat\":52.7688594},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":6.8812387,\"lat\":51.0909476},{\"lng\":-122.478836,\"lat\":48.7544012},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":5.3905714,\"lat\":45.6134459},{\"lng\":33.8307062,\"lat\":27.222556},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-124.311739,\"lat\":49.3179514},{\"lng\":-122.1702293,\"lat\":47.1870191},{\"lng\":7.4373615,\"lat\":52.2797707},{\"lng\":-82.5508407,\"lat\":35.595363},{\"lng\":7.0976053,\"lat\":43.6857041},{\"lng\":9.4978479,\"lat\":51.3157833},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-156.3103925,\"lat\":20.8539162},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-0.3763353,\"lat\":39.4697065},{\"lng\":12.1400211,\"lat\":54.0886707},{\"lng\":-1.3900241,\"lat\":53.0972537},{\"lng\":-73.9923596,\"lat\":40.3042778},{\"lng\":-119.7029194,\"lat\":36.8252277},{\"lng\":4.3296526,\"lat\":50.8390983},{\"lng\":-111.789037,\"lat\":33.3527632},{\"lng\":7.7507127,\"lat\":48.584614},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-119.0779359,\"lat\":34.4458248},{\"lng\":-0.1880608,\"lat\":51.4143912},{\"lng\":-0.2796034,\"lat\":51.5560695},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.510611,\"lat\":48.8137847},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":8.2786906,\"lat\":47.3504945},{\"lng\":-85.559604,\"lat\":43.119721},{\"lng\":-97.555905,\"lat\":30.3420882},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-123.7080446,\"lat\":48.7786872},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":14.2487679,\"lat\":40.8358846},{\"lng\":-68.529968,\"lat\":48.450155},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":10.2134046,\"lat\":56.1496278},{\"lng\":7.1780374,\"lat\":51.264018},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":4.3627245,\"lat\":51.9994572},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-1.4471035,\"lat\":55.0087655},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-2.2138905,\"lat\":47.2733517},{\"lng\":-73.9312445,\"lat\":43.7714532},{\"lng\":-76.5719676,\"lat\":39.0826193},{\"lng\":-79.7599366,\"lat\":43.685832},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-80.5800049,\"lat\":35.4094178},{\"lng\":-71.0183787,\"lat\":42.0834335},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-81.243372,\"lat\":42.9832406},{\"lng\":-77.2676335,\"lat\":38.636447},{\"lng\":-79.9399309,\"lat\":32.7884363},{\"lng\":-0.6469022,\"lat\":44.842168},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-3.2666925,\"lat\":51.4065052},{\"lng\":-122.8072257,\"lat\":47.0263876},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-78.5123274,\"lat\":-0.2201641},{\"lng\":-121.78167,\"lat\":42.224867},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-0.6308396,\"lat\":44.805615},{\"lng\":-1.6171001,\"lat\":54.9751321},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":-111.8486019,\"lat\":40.3881114},{\"lng\":6.4086189,\"lat\":46.0775797},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-75.1340604,\"lat\":40.2492741},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-118.4720281,\"lat\":34.4233293},{\"lng\":-84.5160916,\"lat\":35.8713147},{\"lng\":-111.854317,\"lat\":34.5636358},{\"lng\":0.025585,\"lat\":51.5898978},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-4.7050443,\"lat\":51.6726128},{\"lng\":-2.7151735,\"lat\":52.0553813},{\"lng\":-0.1801094,\"lat\":51.1103444},{\"lng\":80.9346001,\"lat\":26.8381},{\"lng\":-80.4706078,\"lat\":27.816415},{\"lng\":-111.831455,\"lat\":33.4151005},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-93.0012525,\"lat\":34.665341},{\"lng\":77.4831922,\"lat\":19.0940088},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":27.4721276,\"lat\":42.4936616},{\"lng\":-93.326521,\"lat\":45.5693224},{\"lng\":-108.56448,\"lat\":39.0672568},{\"lng\":-122.3330573,\"lat\":37.496904},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":101.6455587,\"lat\":2.9338908},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-77.8603829,\"lat\":39.2952821},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-73.7629097,\"lat\":41.0339862},{\"lng\":-1.6285858,\"lat\":49.634413},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-4.0600467,\"lat\":51.0804057},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.0215737,\"lat\":37.5872576},{\"lng\":-97.3375448,\"lat\":37.6922361},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-83.2965971,\"lat\":42.3833698},{\"lng\":25.1332843,\"lat\":35.33908},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-78.6177611,\"lat\":42.7689141},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-81.9438802,\"lat\":26.5625742},{\"lng\":-103.228023,\"lat\":44.0806041},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-92.3877837,\"lat\":35.2339274},{\"lng\":8.7348747,\"lat\":47.2413349},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":-92.4630182,\"lat\":44.0234387},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":1.9086066,\"lat\":47.9027336},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-0.6487899,\"lat\":47.2982437},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.7097768,\"lat\":51.0876062},{\"lng\":75.8681996,\"lat\":22.7203616},{\"lng\":-74.1637553,\"lat\":40.8584328},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-71.0183787,\"lat\":42.0834335},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-71.5676895,\"lat\":42.3913503},{\"lng\":-88.2810994,\"lat\":42.03726},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.3137707,\"lat\":41.4899827},{\"lng\":-58.268868,\"lat\":-34.7303025},{\"lng\":-80.2781057,\"lat\":25.8575963},{\"lng\":-73.75815,\"lat\":42.8208245},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":6.996379,\"lat\":49.234362},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":5.6221058,\"lat\":6.3330586},{\"lng\":-112.0273739,\"lat\":41.1715361},{\"lng\":-82.0609557,\"lat\":39.3575616},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-121.917794,\"lat\":36.6211149},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-91.2190416,\"lat\":38.6083822},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-77.615214,\"lat\":43.157285},{\"lng\":120.9694534,\"lat\":14.6916903},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":-122.3053932,\"lat\":47.8278656},{\"lng\":-73.2541069,\"lat\":42.4484778},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-97.4394816,\"lat\":35.2225717},{\"lng\":-1.4621381,\"lat\":53.3783713},{\"lng\":-58.6351056,\"lat\":-34.4537215},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":14.4212535,\"lat\":50.0874654},{\"lng\":-93.161159,\"lat\":44.4582041},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-91.2256224,\"lat\":43.5750997},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":135.3413128,\"lat\":34.7377745},{\"lng\":-81.1764865,\"lat\":35.3160401},{\"lng\":153.0933668,\"lat\":-26.6544338},{\"lng\":-97.4033191,\"lat\":27.7635302},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-73.7078294,\"lat\":40.7053335},{\"lng\":-1.4968,\"lat\":53.6830458},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":5.6969882,\"lat\":50.8579855},{\"lng\":-92.7554671,\"lat\":44.9750953},{\"lng\":-96.9034244,\"lat\":32.9515472},{\"lng\":-79.1262839,\"lat\":40.6424116},{\"lng\":-77.8837984,\"lat\":37.7204342},{\"lng\":98.3891503,\"lat\":7.8847901},{\"lng\":5.0044767,\"lat\":45.7764637},{\"lng\":-2.6294313,\"lat\":53.6531915},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-96.7297206,\"lat\":32.9481789},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":9.2045813,\"lat\":48.9596036},{\"lng\":-94.70496,\"lat\":37.4108841},{\"lng\":-4.4860088,\"lat\":48.3905283},{\"lng\":-100.0170787,\"lat\":37.7527982},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":5.2253042,\"lat\":51.9573504},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-0.1947552,\"lat\":51.4027615},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":6.8514435,\"lat\":51.4696137},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-2.2458192,\"lat\":51.8653705},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-96.9977846,\"lat\":32.7459645},{\"lng\":-89.2903392,\"lat\":31.3271189},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-94.2008288,\"lat\":46.3580221},{\"lng\":6.6916476,\"lat\":51.1981778},{\"lng\":-4.2412484,\"lat\":50.8309593},{\"lng\":-0.0135253,\"lat\":51.5911967},{\"lng\":-1.6117595,\"lat\":54.9751136},{\"lng\":-91.403171,\"lat\":31.5604076},{\"lng\":-0.333653,\"lat\":51.4277844},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":25.0407809,\"lat\":60.2933337},{\"lng\":-93.46651,\"lat\":45.0065149},{\"lng\":-73.9395687,\"lat\":42.8142432},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-85.759407,\"lat\":38.2542376},{\"lng\":-96.6736063,\"lat\":29.4938849},{\"lng\":11.9670171,\"lat\":57.7072326},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-0.5473085,\"lat\":51.4312585},{\"lng\":-88.0934145,\"lat\":42.353355},{\"lng\":-101.1992336,\"lat\":26.8792399},{\"lng\":-122.0322895,\"lat\":37.3228934},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-100.783739,\"lat\":46.808327},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-73.7753539,\"lat\":41.270178},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-1.6800198,\"lat\":48.1113387},{\"lng\":-73.9373912,\"lat\":41.7841956},{\"lng\":-96.6154471,\"lat\":33.1976496},{\"lng\":-81.5856742,\"lat\":28.5656649},{\"lng\":-123.815722,\"lat\":46.975371},{\"lng\":7.4521749,\"lat\":46.9484742},{\"lng\":-73.9523976,\"lat\":45.4038563},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":8.6736295,\"lat\":49.8851869},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":-1.623206,\"lat\":47.2711217},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":-1.3129164,\"lat\":54.564094},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":-79.9559437,\"lat\":39.6296809},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":106.8822289,\"lat\":-6.2628908},{\"lng\":-157.9336111,\"lat\":21.3822222},{\"lng\":2.2890454,\"lat\":48.9105948},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-1.4736657,\"lat\":43.4945144},{\"lng\":-71.0994968,\"lat\":42.3875968},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":2.4749347,\"lat\":48.8490721},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":-3.1974329,\"lat\":51.6663189},{\"lng\":-121.8106925,\"lat\":38.0093296},{\"lng\":-80.3503283,\"lat\":27.2939333},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":8.7291498,\"lat\":47.4991723},{\"lng\":2.3027323,\"lat\":48.795056},{\"lng\":-1.4921233,\"lat\":47.2971979},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-2.9990745,\"lat\":53.7485046},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":1.2923954,\"lat\":52.6285576},{\"lng\":17.6387436,\"lat\":59.8586126},{\"lng\":-117.873221,\"lat\":33.7494951},{\"lng\":-0.1200826,\"lat\":51.4955481},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-112.185994,\"lat\":33.5386858},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.5524906,\"lat\":48.8492238},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-93.2922715,\"lat\":37.2081729},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":-1.1700018,\"lat\":44.6616428},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-21.9409445,\"lat\":64.129393},{\"lng\":-0.3699697,\"lat\":50.8115402},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-122.2566367,\"lat\":38.1040864},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.1779083,\"lat\":48.9134112},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-114.057541,\"lat\":51.0456064},{\"lng\":-97.4169964,\"lat\":42.0283379},{\"lng\":-93.6376741,\"lat\":43.2626747},{\"lng\":-86.5675095,\"lat\":34.7736807},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":84.1528515,\"lat\":21.5570606},{\"lng\":-1.257412,\"lat\":51.4024177},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-81.4406258,\"lat\":41.1596261},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-99.0000012,\"lat\":28.4656903},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-117.865339,\"lat\":34.1361187},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-71.2841163,\"lat\":-29.9452193},{\"lng\":-83.9210261,\"lat\":35.9603948},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":10.4486418,\"lat\":54.0354576},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":174.7631803,\"lat\":-36.852095},{\"lng\":-45.083415,\"lat\":-23.433162},{\"lng\":-58.947319,\"lat\":-34.9268133},{\"lng\":-117.3505966,\"lat\":33.1580933},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":-116.0833144,\"lat\":34.8253019},{\"lng\":-79.3321008,\"lat\":42.4423544},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":19.0402383,\"lat\":47.4978789},{\"lng\":-95.9383758,\"lat\":41.2587459},{\"lng\":-91.2514355,\"lat\":43.8122836},{\"lng\":-82.458444,\"lat\":27.9477595},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":9.7385532,\"lat\":52.3744779},{\"lng\":6.759562,\"lat\":51.434999},{\"lng\":-2.6318629,\"lat\":50.9420451},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":-75.5149128,\"lat\":40.1303822},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-73.2820608,\"lat\":41.4200956},{\"lng\":-83.9478911,\"lat\":42.0554875},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.5949279,\"lat\":36.2082431},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-79.9321566,\"lat\":46.3653409},{\"lng\":-61.4635055,\"lat\":10.2805193},{\"lng\":-0.325966,\"lat\":51.4685202},{\"lng\":-92.2670941,\"lat\":34.769536},{\"lng\":-73.754968,\"lat\":42.6511674},{\"lng\":-94.2670404,\"lat\":36.3456186},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-123.137414,\"lat\":49.163168},{\"lng\":-90.1505426,\"lat\":29.9899926},{\"lng\":-111.787022,\"lat\":43.8235163},{\"lng\":5.303116,\"lat\":51.6889387},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":2.4733771,\"lat\":49.2607914},{\"lng\":-61.4635055,\"lat\":10.2805193},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":-96.5764834,\"lat\":33.4220266},{\"lng\":-77.1968941,\"lat\":39.2694715},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":83.0076292,\"lat\":25.3356491},{\"lng\":-81.71573,\"lat\":25.9372513},{\"lng\":-104.825348,\"lat\":38.8339578},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":-75.6059638,\"lat\":39.9597213},{\"lng\":-88.7306517,\"lat\":42.8339562},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-91.4984941,\"lat\":44.811349},{\"lng\":73.1942567,\"lat\":22.2973142},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":103.7649059,\"lat\":1.4581986},{\"lng\":-72.2737216,\"lat\":-50.3387375},{\"lng\":-118.3878945,\"lat\":34.2204227},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":-81.655651,\"lat\":30.3321838},{\"lng\":8.05,\"lat\":52.2},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":0.0781021,\"lat\":43.232858},{\"lng\":4.2074197,\"lat\":51.9930016},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":18.869167,\"lat\":-33.934444},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":75.5678878,\"lat\":31.2922311},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":2.3211651,\"lat\":48.8564006},{\"lng\":-58.6217416,\"lat\":-34.6510527},{\"lng\":7.9429235,\"lat\":48.4695984},{\"lng\":-83.1821445,\"lat\":42.4595317},{\"lng\":-72.6311006,\"lat\":42.3178989},{\"lng\":6.759562,\"lat\":51.434999},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-75.3085201,\"lat\":39.9809452},{\"lng\":88.4309916,\"lat\":26.7164127},{\"lng\":-59.6437728,\"lat\":-29.1443478},{\"lng\":-88.2578582,\"lat\":42.1211364},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-118.3878945,\"lat\":34.2204227},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-84.9790087,\"lat\":32.9955364},{\"lng\":-81.4625919,\"lat\":30.6696818},{\"lng\":-122.2034496,\"lat\":47.4799078},{\"lng\":16.9197326,\"lat\":52.4006632},{\"lng\":-121.3222422,\"lat\":38.6270984},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":11.4676387,\"lat\":48.2266316},{\"lng\":-84.5501874,\"lat\":39.2085354},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-76.8485094,\"lat\":39.0984317},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-86.3921096,\"lat\":35.8460396},{\"lng\":2.273457,\"lat\":48.8250508},{\"lng\":-75.9279495,\"lat\":40.335345},{\"lng\":-77.3538176,\"lat\":37.627722},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-117.42351,\"lat\":47.6571934},{\"lng\":-74.2210643,\"lat\":40.8164458},{\"lng\":8.446357,\"lat\":49.9819502},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-59.1488389,\"lat\":-37.2919426},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-74.012084,\"lat\":40.8042674},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.4105803,\"lat\":41.5770993},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":7.3000295,\"lat\":50.3240804},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":7.4815213,\"lat\":46.9790726},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-111.9367107,\"lat\":40.5584882},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-112.0244841,\"lat\":41.1135837},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-85.8465279,\"lat\":39.9389855},{\"lng\":-81.4075838,\"lat\":28.2918995},{\"lng\":-88.0409574,\"lat\":45.3834983},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":8.6986809,\"lat\":51.5169114},{\"lng\":-105.0846694,\"lat\":39.7085736},{\"lng\":-88.3123889,\"lat\":43.0622536},{\"lng\":-2.9184744,\"lat\":47.6199988},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":-41.8875267,\"lat\":-22.7597805},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":2.3821895,\"lat\":48.9146078},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.8331972,\"lat\":48.5824932},{\"lng\":6.5726698,\"lat\":46.5285212},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-49.2712724,\"lat\":-25.4295963},{\"lng\":-2.9937869,\"lat\":53.0465084},{\"lng\":1.4175744,\"lat\":50.0491699},{\"lng\":5.7235287,\"lat\":51.1932084},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-77.9487284,\"lat\":34.2352853},{\"lng\":-97.0647322,\"lat\":33.1540091},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-79.9356589,\"lat\":35.9941053},{\"lng\":-4.2501687,\"lat\":55.861155},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":-117.162772,\"lat\":32.7174202},{\"lng\":-75.4278733,\"lat\":38.9130453},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":2.248254,\"lat\":41.4493539},{\"lng\":-84.1468616,\"lat\":33.4473361},{\"lng\":-98.4951405,\"lat\":29.4246002},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-78.5103731,\"lat\":35.9803138},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-70.650549,\"lat\":-33.4625225},{\"lng\":-81.4145468,\"lat\":29.9032284},{\"lng\":-95.7343117,\"lat\":33.1189413},{\"lng\":-96.9756323,\"lat\":33.3142085},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":23.7348324,\"lat\":37.9755648},{\"lng\":-78.9018053,\"lat\":35.996653},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-95.7909473,\"lat\":43.3112893},{\"lng\":-74.7695394,\"lat\":46.0412856},{\"lng\":-74.047455,\"lat\":40.7215682},{\"lng\":6.8304613,\"lat\":46.5550197},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":22.5546776,\"lat\":51.2181945},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":-84.2396434,\"lat\":33.8095487},{\"lng\":-111.940016,\"lat\":33.4255117},{\"lng\":14.5105343,\"lat\":46.0582538},{\"lng\":-123.0950506,\"lat\":44.0505054},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":10.0176952,\"lat\":53.3965903},{\"lng\":-80.1386547,\"lat\":26.8233946},{\"lng\":-74.171811,\"lat\":40.9167654},{\"lng\":-74.3618499,\"lat\":40.4635362},{\"lng\":-1.486516,\"lat\":48.899151},{\"lng\":-82.366121,\"lat\":28.1866014},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-9.3036149,\"lat\":38.7293967},{\"lng\":-65.5927221,\"lat\":-27.3459249},{\"lng\":-85.3436973,\"lat\":35.1223478},{\"lng\":0.1186637,\"lat\":52.2055314},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":1.7969781,\"lat\":48.8658569},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-88.0670118,\"lat\":41.8775293},{\"lng\":2.39164,\"lat\":48.7876},{\"lng\":35.5025585,\"lat\":33.8892265},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":8.4286614,\"lat\":51.8074106},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":23.7603118,\"lat\":61.4980214},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":147.3281233,\"lat\":-42.8825088},{\"lng\":18.0710935,\"lat\":59.3251172},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":-92.4412674,\"lat\":34.6295373},{\"lng\":8.6820917,\"lat\":50.1106444},{\"lng\":-87.6305899,\"lat\":46.4481521},{\"lng\":7.8193394,\"lat\":49.1419455},{\"lng\":-118.7538071,\"lat\":34.2677404},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":0.2673446,\"lat\":51.1371483},{\"lng\":-49.4858389,\"lat\":-28.9348832},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":0.2517025,\"lat\":50.9717443},{\"lng\":10.1596948,\"lat\":56.1220185},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-84.5124602,\"lat\":39.1014537},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-88.207301,\"lat\":40.1117174},{\"lng\":55.1885387,\"lat\":25.0742823},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-83.6324022,\"lat\":32.8406946},{\"lng\":-0.5404819,\"lat\":53.2293545},{\"lng\":-84.6165164,\"lat\":44.3326932},{\"lng\":79.0820556,\"lat\":21.1498134},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-91.4171209,\"lat\":41.9222443},{\"lng\":3.2881194,\"lat\":45.7703602},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-87.6244212,\"lat\":41.8755616},{\"lng\":-83.0007065,\"lat\":39.9622601},{\"lng\":11.3927685,\"lat\":47.2654296},{\"lng\":-71.2503157,\"lat\":41.6024068},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-94.5280474,\"lat\":45.1271847},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-82.2359254,\"lat\":27.044224},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.636681,\"lat\":47.4763},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":2.5524906,\"lat\":48.8492238},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-121.9357918,\"lat\":37.7021521},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":174.7772114,\"lat\":-41.2887953},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":2.7005289,\"lat\":48.4881157},{\"lng\":-71.1187829,\"lat\":42.332918},{\"lng\":-4.0816846,\"lat\":52.4143113},{\"lng\":1.215829,\"lat\":6.130419},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":3.9452194,\"lat\":50.4431879},{\"lng\":5.9304919,\"lat\":43.1257311},{\"lng\":-71.060511,\"lat\":42.3554334},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-104.6158764,\"lat\":50.4479733},{\"lng\":-0.5702444,\"lat\":45.3723689},{\"lng\":5.0363571,\"lat\":52.0811781},{\"lng\":2.2385432,\"lat\":48.8126688},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":-88.0934108,\"lat\":42.1969689},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":4.6309653,\"lat\":43.6776223},{\"lng\":-84.4970393,\"lat\":38.0464066},{\"lng\":11.1441047,\"lat\":49.3559425},{\"lng\":-99.1332716,\"lat\":19.4933046},{\"lng\":-77.9112655,\"lat\":37.5531622},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-0.3685668,\"lat\":43.2957547},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":-75.071284,\"lat\":39.9181686},{\"lng\":1.9737186,\"lat\":47.9200018},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-90.0782127,\"lat\":29.9759983},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":101.6454202,\"lat\":3.0988792},{\"lng\":4.6435597,\"lat\":52.3837058},{\"lng\":-1.9298486,\"lat\":52.4672508},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-74.5517146,\"lat\":40.5598127},{\"lng\":-118.000016,\"lat\":33.6783336},{\"lng\":25.3923149,\"lat\":37.4513936},{\"lng\":-87.9084039,\"lat\":42.1900249},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-73.212906,\"lat\":44.4761601},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":80.3217588,\"lat\":26.4609135},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-72.1847598,\"lat\":40.9633868},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-80.1353006,\"lat\":25.7929198},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-84.5740953,\"lat\":30.8736613},{\"lng\":88.3638953,\"lat\":22.5726459},{\"lng\":-83.5378173,\"lat\":41.6529143},{\"lng\":-106.660767,\"lat\":52.131802},{\"lng\":-3.1791934,\"lat\":51.4816546},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":25.2829111,\"lat\":54.6870458},{\"lng\":2.4077003,\"lat\":48.7350308},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":0.4252037,\"lat\":51.5138172},{\"lng\":5.4270482,\"lat\":43.8287799},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-86.8997385,\"lat\":40.0408627},{\"lng\":-86.7742984,\"lat\":36.1622767},{\"lng\":2.3580232,\"lat\":48.935773},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":80.3217588,\"lat\":26.4609135},{\"lng\":7.5905713,\"lat\":48.3971559},{\"lng\":6.1288847,\"lat\":45.8992348},{\"lng\":-122.2301808,\"lat\":47.3075369},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":-122.1560768,\"lat\":37.7249296},{\"lng\":-104.830994,\"lat\":39.7405111},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-86.4477416,\"lat\":43.9555406},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":7.8494005,\"lat\":47.9960901},{\"lng\":-97.6788056,\"lat\":30.5085915},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":8.050948,\"lat\":49.5945916},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":7.5878261,\"lat\":47.5581077},{\"lng\":0.1561947,\"lat\":45.6484505},{\"lng\":1.0939658,\"lat\":49.4404591},{\"lng\":-0.0843244,\"lat\":51.4418786},{\"lng\":2.0426301,\"lat\":48.9274192},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-122.2270272,\"lat\":47.3826903},{\"lng\":6.6436313,\"lat\":44.8984037},{\"lng\":-118.4720281,\"lat\":34.4233293},{\"lng\":-75.6025597,\"lat\":6.2697324},{\"lng\":-117.929416,\"lat\":33.8708215},{\"lng\":-74.0254577,\"lat\":45.3971509},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-1.67584,\"lat\":52.6088967},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-110.3158532,\"lat\":24.1619948},{\"lng\":-34.8848193,\"lat\":-8.0584933},{\"lng\":-121.2810611,\"lat\":38.7071247},{\"lng\":-122.4614566,\"lat\":37.8770247},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":73.7902364,\"lat\":20.0112475},{\"lng\":-1.7342725,\"lat\":53.0173327},{\"lng\":-84.1557496,\"lat\":33.0545709},{\"lng\":-93.0931028,\"lat\":44.9497487},{\"lng\":-43.2093727,\"lat\":-22.9110137},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":0.1481142,\"lat\":51.5413271},{\"lng\":30.2368381,\"lat\":1.5642298},{\"lng\":77.0299194,\"lat\":28.4646148},{\"lng\":-78.6390989,\"lat\":35.7803977},{\"lng\":-74.2107006,\"lat\":40.6639916},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":120.2570297,\"lat\":23.0263249},{\"lng\":7.2791655,\"lat\":49.8123205},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":-106.82356,\"lat\":39.1911128},{\"lng\":-119.5856465,\"lat\":49.4901506},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-58.415498,\"lat\":-35.0405873},{\"lng\":-8.5187849,\"lat\":41.4064621},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":2.4230925,\"lat\":42.6181232},{\"lng\":-1.9020456,\"lat\":53.8684021},{\"lng\":10.8979522,\"lat\":48.3690341},{\"lng\":1.3337639,\"lat\":47.5876861},{\"lng\":5.240333,\"lat\":51.8236456},{\"lng\":12.4483489,\"lat\":55.6898267},{\"lng\":77.3105561,\"lat\":28.4031478},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-99.157701,\"lat\":19.3718796},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":3.3331703,\"lat\":46.5660526},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":-88.0792782,\"lat\":42.0427256},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":4.3113461,\"lat\":52.0799838},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":-4.0600467,\"lat\":51.0804057},{\"lng\":-97.5170536,\"lat\":35.4729886},{\"lng\":-0.1618183,\"lat\":51.5223681},{\"lng\":-3.175096,\"lat\":51.4357312},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-57.6190998,\"lat\":-25.3172629},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":27.9186111,\"lat\":-27.8813889},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":12.5326186,\"lat\":55.678016},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-118.7538071,\"lat\":34.2677404},{\"lng\":0.5231646,\"lat\":51.2748258},{\"lng\":-79.666672,\"lat\":43.447436},{\"lng\":2.4046994,\"lat\":48.856303},{\"lng\":77.0299194,\"lat\":28.4646148},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":1.3549991,\"lat\":44.0175835},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":135.5451809,\"lat\":34.6856252},{\"lng\":-118.401813,\"lat\":33.7872386},{\"lng\":-0.5879629,\"lat\":44.8088438},{\"lng\":-70.7261966,\"lat\":42.1924492},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-99.1332716,\"lat\":19.4933046},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-72.6071119,\"lat\":42.1487691},{\"lng\":-0.0996181,\"lat\":51.582382},{\"lng\":35.4873214,\"lat\":38.7219011},{\"lng\":12.466667,\"lat\":58.716667},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":-95.3676974,\"lat\":29.7589382},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-99.1331785,\"lat\":19.4326296},{\"lng\":4.3873058,\"lat\":45.4401467},{\"lng\":-111.9738429,\"lat\":41.2230048},{\"lng\":-79.5443274,\"lat\":40.3024514},{\"lng\":-82.8868636,\"lat\":39.8522449},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-105.938456,\"lat\":35.6876096},{\"lng\":-105.573284,\"lat\":36.4072377},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":85.1235252,\"lat\":25.6093239},{\"lng\":-83.0466403,\"lat\":42.3315509},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-78.4766781,\"lat\":38.029306},{\"lng\":-48.5496098,\"lat\":-27.5973002},{\"lng\":-66.9146008,\"lat\":10.5060934},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-0.3957425,\"lat\":51.6553875},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-85.0766113,\"lat\":33.5801103},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":6.6327025,\"lat\":46.5218269},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":2.240206,\"lat\":48.8356649},{\"lng\":-4.7565615,\"lat\":36.6600506},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-77.2688875,\"lat\":38.7812445},{\"lng\":3.5225691,\"lat\":47.9647312},{\"lng\":-122.674194,\"lat\":45.5202471},{\"lng\":-0.3770142,\"lat\":51.5968712},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-0.3770142,\"lat\":51.5968712},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-72.6816365,\"lat\":41.2827593},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":75.8189817,\"lat\":26.9154576},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-111.886797,\"lat\":40.7596198},{\"lng\":150.89385,\"lat\":-34.4243941},{\"lng\":-99.7475905,\"lat\":32.44645},{\"lng\":77.7679671,\"lat\":29.0018557},{\"lng\":2.219344,\"lat\":48.8437412},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-8.4294632,\"lat\":40.2111931},{\"lng\":2.3013348,\"lat\":48.839743},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-106.650985,\"lat\":35.0841034},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":28.049722,\"lat\":-26.205},{\"lng\":-77.0365256,\"lat\":-12.0621065},{\"lng\":-74.2401466,\"lat\":40.829822},{\"lng\":2.3763968,\"lat\":48.9379294},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":17.0326689,\"lat\":51.1089776},{\"lng\":-0.1440551,\"lat\":51.4893335},{\"lng\":-76.533788,\"lat\":38.6941057},{\"lng\":-83.5378173,\"lat\":41.6529143},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":74.8787496,\"lat\":31.6356659},{\"lng\":-120.3835349,\"lat\":37.985304},{\"lng\":-90.1505426,\"lat\":29.9899926},{\"lng\":79.0820556,\"lat\":21.1498134},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-73.5582912,\"lat\":40.721775},{\"lng\":-112.074141,\"lat\":33.4484367},{\"lng\":-121.7529071,\"lat\":36.9092773},{\"lng\":5.240582,\"lat\":52.2964844},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.3426122,\"lat\":33.9128272},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":77.2192671,\"lat\":28.6430858},{\"lng\":-89.8973084,\"lat\":35.3414745},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-70.0327996,\"lat\":41.9376051},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":73.0351433,\"lat\":26.2967719},{\"lng\":-2.4396676,\"lat\":42.4661196},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.8298607,\"lat\":52.4424926},{\"lng\":-122.636465,\"lat\":38.2325829},{\"lng\":-73.8785937,\"lat\":40.8466508},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":172.6078498,\"lat\":-43.5399227},{\"lng\":-95.3097807,\"lat\":34.9187023},{\"lng\":28.1220546,\"lat\":-26.2669894},{\"lng\":-93.2654692,\"lat\":44.9772995},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-80.9174262,\"lat\":35.1518062},{\"lng\":-79.666672,\"lat\":43.447436},{\"lng\":-86.1583502,\"lat\":39.7683331},{\"lng\":-73.5698065,\"lat\":45.5031824},{\"lng\":-73.8987469,\"lat\":40.9312099},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":-90.1505426,\"lat\":29.9899926},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-74.0836547,\"lat\":4.6534109},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":31.2118063,\"lat\":29.9870753},{\"lng\":135.5014539,\"lat\":34.6937569},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-118.5356869,\"lat\":34.200768},{\"lng\":0.2031905,\"lat\":49.7074621},{\"lng\":76.7797143,\"lat\":30.7334421},{\"lng\":-99.1619751,\"lat\":19.3498606},{\"lng\":85.3250387,\"lat\":23.3700501},{\"lng\":-16.7787271,\"lat\":28.2101368},{\"lng\":-79.5443274,\"lat\":40.3024514},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":76.3196717,\"lat\":32.2143039},{\"lng\":0.6383746,\"lat\":51.8019608},{\"lng\":-122.347748,\"lat\":37.9357576},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":29.2696961,\"lat\":37.752386},{\"lng\":-117.43433,\"lat\":34.0922947},{\"lng\":75.851601,\"lat\":30.9090157},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":1.7766633,\"lat\":48.9717033},{\"lng\":-119.8126581,\"lat\":39.5261206},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":85.1235252,\"lat\":25.6093239},{\"lng\":5.7496879,\"lat\":43.1378654},{\"lng\":-0.0927317,\"lat\":51.3758448},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-75.2326641,\"lat\":43.1009031},{\"lng\":-1.1236065,\"lat\":52.6321088},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-117.826166,\"lat\":33.7458511},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":-84.6433146,\"lat\":42.7269261},{\"lng\":-118.491227,\"lat\":34.0194704},{\"lng\":-111.457294,\"lat\":36.9148305},{\"lng\":1.09163,\"lat\":49.3831},{\"lng\":139.766706,\"lat\":35.6812546},{\"lng\":-1.3900241,\"lat\":53.0972537},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":-72.251587,\"lat\":43.643032},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":2.3366502,\"lat\":48.8064996},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":-66.9146008,\"lat\":10.5060934},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-49.2712724,\"lat\":-25.4295963},{\"lng\":2.3748001,\"lat\":48.8443818},{\"lng\":7.2683912,\"lat\":43.7009358},{\"lng\":36.8172449,\"lat\":-1.2832533},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":-93.326521,\"lat\":45.5693224},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-121.890591,\"lat\":37.3361663},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-73.8929714,\"lat\":45.5646052},{\"lng\":7.459464,\"lat\":53.2050927},{\"lng\":22.9352716,\"lat\":40.6403167},{\"lng\":-86.8024326,\"lat\":33.5206824},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.3860488,\"lat\":48.655886},{\"lng\":2.2481797,\"lat\":48.9479069},{\"lng\":2.2956951,\"lat\":49.8941708},{\"lng\":7.459464,\"lat\":53.2050927},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":11.7713656,\"lat\":51.6706514},{\"lng\":-2.600511,\"lat\":51.450363},{\"lng\":5.7357819,\"lat\":45.1875602},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":-71.3085329,\"lat\":42.6414437},{\"lng\":13.7381437,\"lat\":51.0493286},{\"lng\":-97.7436995,\"lat\":30.2711286},{\"lng\":-2.7540658,\"lat\":52.707755},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":-77.0365427,\"lat\":38.8950368},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-77.0470229,\"lat\":38.8051095},{\"lng\":30.061507,\"lat\":-1.950851},{\"lng\":115.251951,\"lat\":-8.685213},{\"lng\":-75.4757444,\"lat\":39.0715528},{\"lng\":2.6183971,\"lat\":48.9839674},{\"lng\":7.6808525,\"lat\":48.8873911},{\"lng\":-84.3898151,\"lat\":33.7544657},{\"lng\":-81.4145468,\"lat\":29.9032284},{\"lng\":25.1332843,\"lat\":35.33908},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":16.3691936,\"lat\":48.2032863},{\"lng\":101.6942371,\"lat\":3.1516964},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":-0.1011379,\"lat\":51.5061349},{\"lng\":-119.78483,\"lat\":36.7394421},{\"lng\":-157.9129733,\"lat\":21.34045},{\"lng\":10.135555,\"lat\":54.3227085},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":-88.0437509,\"lat\":30.6913462},{\"lng\":90.3890144,\"lat\":23.7643863},{\"lng\":-1.7767859,\"lat\":46.4990505},{\"lng\":126.99,\"lat\":37.5323},{\"lng\":5.986163,\"lat\":49.4947826},{\"lng\":-5.9336562,\"lat\":54.5842881},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":91.753943,\"lat\":26.1805978},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":5.2828123,\"lat\":45.5872259},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":-1.5527266,\"lat\":43.4711437},{\"lng\":5.8882101,\"lat\":45.2384678},{\"lng\":-117.911732,\"lat\":33.8347516},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":3.8767337,\"lat\":43.6112422},{\"lng\":121.451,\"lat\":25.0615},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":5.9146362,\"lat\":45.6886292},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-0.7734022,\"lat\":48.0706687},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-1.6084351,\"lat\":46.7391797},{\"lng\":-122.972751,\"lat\":45.300347},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":6.6916476,\"lat\":51.1981778},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":5.9203636,\"lat\":45.5662672},{\"lng\":24.9427473,\"lat\":60.1674881},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":2.4631476,\"lat\":48.9385489},{\"lng\":15.7844221,\"lat\":67.2367153},{\"lng\":6.5912615,\"lat\":48.0158951},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":1.3044842,\"lat\":51.1296508},{\"lng\":-73.8283132,\"lat\":40.7135078},{\"lng\":7.7661798,\"lat\":51.3854116},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-74.0237512,\"lat\":40.7795455},{\"lng\":-0.1932607,\"lat\":51.4570271},{\"lng\":-90.1910154,\"lat\":38.6280278},{\"lng\":-3.1904199,\"lat\":55.9519018},{\"lng\":-76.6932818,\"lat\":42.8397906},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-73.9283672,\"lat\":41.7065539},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-99.097453,\"lat\":19.3957447},{\"lng\":32.8540497,\"lat\":39.9207759},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-8.4280045,\"lat\":41.5510583},{\"lng\":21.0067249,\"lat\":52.2319581},{\"lng\":5.2276307,\"lat\":52.0892832},{\"lng\":-1.548621,\"lat\":53.794414},{\"lng\":-78.8783922,\"lat\":42.8867166},{\"lng\":73.8545071,\"lat\":18.5213738},{\"lng\":-84.544109,\"lat\":38.9431183},{\"lng\":5.9108573,\"lat\":51.984257},{\"lng\":5.5873582,\"lat\":50.6429913},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":12.4829321,\"lat\":41.8933203},{\"lng\":7.5894588,\"lat\":48.5281292},{\"lng\":27.4338897,\"lat\":-11.6357362},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-117.3703235,\"lat\":34.1064001},{\"lng\":10.2134046,\"lat\":56.1496278},{\"lng\":77.3272147,\"lat\":28.5706333},{\"lng\":34.7818064,\"lat\":32.0852997},{\"lng\":6.1342493,\"lat\":49.5999681},{\"lng\":2.4197113,\"lat\":48.8051624},{\"lng\":74.1822147,\"lat\":17.2852127},{\"lng\":33.0332657,\"lat\":34.6852901},{\"lng\":-80.0666026,\"lat\":26.5256179},{\"lng\":0.1826107,\"lat\":51.5747271},{\"lng\":80.9346001,\"lat\":26.8381},{\"lng\":-49.5511221,\"lat\":-14.9522349},{\"lng\":-79.090576,\"lat\":43.835765},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":-99.1135482,\"lat\":19.4191658},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-94.5781416,\"lat\":39.100105},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":75.5678878,\"lat\":31.2922311},{\"lng\":5.7318101,\"lat\":58.9699675},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":2.2561602,\"lat\":48.8953328},{\"lng\":13.7381437,\"lat\":51.0493286},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":13.0001566,\"lat\":55.6052931},{\"lng\":-1.1246168,\"lat\":53.3042362},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-3.9904173,\"lat\":55.7893512},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-4.4216366,\"lat\":36.7213028},{\"lng\":-79.4491057,\"lat\":43.7543217},{\"lng\":100.7485803,\"lat\":13.6818766},{\"lng\":-79.4377991,\"lat\":36.0956918},{\"lng\":98.3891503,\"lat\":7.8847901},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-73.5107732,\"lat\":42.7091389},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":13.7757809,\"lat\":54.0536473},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-81.3790304,\"lat\":28.5421109},{\"lng\":-47.6493269,\"lat\":-22.725165},{\"lng\":77.7679671,\"lat\":29.0018557},{\"lng\":-119.0779359,\"lat\":34.4458248},{\"lng\":-0.0567767,\"lat\":51.5471373},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":6.1466014,\"lat\":46.2017559},{\"lng\":115.2191175,\"lat\":-8.6524973},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-8.5187849,\"lat\":41.4064621},{\"lng\":-119.495902,\"lat\":49.8879177},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":4.8924534,\"lat\":52.3730796},{\"lng\":151.2082848,\"lat\":-33.8698439},{\"lng\":-117.084195,\"lat\":32.6400541},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":72.8692035,\"lat\":19.054999},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-2.1001142,\"lat\":53.712125},{\"lng\":4.2133313,\"lat\":51.1253635},{\"lng\":-121.493895,\"lat\":38.5810606},{\"lng\":-74.924321,\"lat\":42.7006303},{\"lng\":-80.8430827,\"lat\":35.2272086},{\"lng\":6.9292641,\"lat\":46.9895828},{\"lng\":77.590082,\"lat\":12.9767936},{\"lng\":-90.9562125,\"lat\":30.4868564},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":2.3483915,\"lat\":48.8534951},{\"lng\":31.2357257,\"lat\":30.0443879},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":-118.3426122,\"lat\":33.9128272},{\"lng\":-123.113952,\"lat\":49.2608724},{\"lng\":2.4077003,\"lat\":48.7350308},{\"lng\":-4.2660965,\"lat\":55.4540605},{\"lng\":-77.4759588,\"lat\":43.1301133},{\"lng\":12.3652209,\"lat\":55.7303911},{\"lng\":-86.6722192,\"lat\":36.0600602},{\"lng\":138.5999312,\"lat\":-34.9281805},{\"lng\":74.8580917,\"lat\":32.7185614},{\"lng\":-77.4744148,\"lat\":39.029784},{\"lng\":9.9753758,\"lat\":53.5909051},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":-120.375716,\"lat\":35.3540209},{\"lng\":5.9146362,\"lat\":45.6886292},{\"lng\":-2.2451148,\"lat\":53.4794892},{\"lng\":71.5787458,\"lat\":34.0123846},{\"lng\":-1.2578499,\"lat\":51.7520131},{\"lng\":-0.0786839,\"lat\":51.6517156},{\"lng\":-0.1426957,\"lat\":51.5394397},{\"lng\":-94.626497,\"lat\":39.1134562},{\"lng\":-75.3321363,\"lat\":42.6239023},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":77.1709729,\"lat\":31.1041526},{\"lng\":-79.8728583,\"lat\":43.2560802},{\"lng\":-59.1488389,\"lat\":-37.2919426},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-79.882817,\"lat\":43.513671},{\"lng\":-103.3913671,\"lat\":20.7211203},{\"lng\":15.9622315,\"lat\":45.8426414},{\"lng\":71.7337464,\"lat\":34.1461506},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":-122.036349,\"lat\":37.3688301},{\"lng\":77.2219388,\"lat\":28.6517178},{\"lng\":76.7797143,\"lat\":30.7334421},{\"lng\":-93.7594059,\"lat\":41.5644476},{\"lng\":2.320041,\"lat\":48.8588897},{\"lng\":6.4271457,\"lat\":45.9418675},{\"lng\":-8.5458608,\"lat\":42.8804219},{\"lng\":-86.7491214,\"lat\":34.8558725},{\"lng\":2.4252507,\"lat\":6.3676953},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":-60.3404356,\"lat\":-33.2246717},{\"lng\":14.4464593,\"lat\":50.0596288},{\"lng\":-88.2430932,\"lat\":40.1164841},{\"lng\":74.8204443,\"lat\":34.0747444},{\"lng\":4.8320114,\"lat\":45.7578137},{\"lng\":-1.1449555,\"lat\":52.9473037},{\"lng\":9.9215263,\"lat\":57.0462626},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-47.059564,\"lat\":-22.9056391},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-0.5800364,\"lat\":44.841225},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":-81.0352313,\"lat\":34.000754},{\"lng\":6.959974,\"lat\":50.938361},{\"lng\":-43.9450948,\"lat\":-19.9227318},{\"lng\":-1.0714014,\"lat\":44.6360982},{\"lng\":-81.6936772,\"lat\":41.4996574},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-97.4719662,\"lat\":33.0534563},{\"lng\":-124.053442,\"lat\":44.636755},{\"lng\":5.3699525,\"lat\":43.2961743},{\"lng\":-2.99168,\"lat\":53.4071991},{\"lng\":-122.5449763,\"lat\":37.9060368},{\"lng\":7.8191185,\"lat\":51.681281},{\"lng\":35.2257856,\"lat\":31.7788472},{\"lng\":-45.8854538,\"lat\":-23.1867782},{\"lng\":11.5753822,\"lat\":48.1371079},{\"lng\":153.0235009,\"lat\":-27.4689623},{\"lng\":-115.146357,\"lat\":36.1716997},{\"lng\":6.77037,\"lat\":46.5419511},{\"lng\":-122.599707,\"lat\":49.2197345},{\"lng\":3.0819427,\"lat\":45.7774551},{\"lng\":115.8605784,\"lat\":-31.9558967},{\"lng\":-89.3837613,\"lat\":43.074761},{\"lng\":18.4172197,\"lat\":-33.9288301},{\"lng\":-3.7035825,\"lat\":40.4167047},{\"lng\":-77.8616386,\"lat\":40.7944504},{\"lng\":26.1009263,\"lat\":44.4356444},{\"lng\":-74.0060152,\"lat\":40.7127281},{\"lng\":-80.19362,\"lat\":25.7741728},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-123.3272489,\"lat\":42.4393707},{\"lng\":15.6946065,\"lat\":48.2843295},{\"lng\":5.478633,\"lat\":51.4392648},{\"lng\":-117.2298477,\"lat\":33.7818729},{\"lng\":-83.2107671,\"lat\":42.2595071},{\"lng\":-118.242766,\"lat\":34.0536909},{\"lng\":2.177073,\"lat\":41.3825802},{\"lng\":-96.7968559,\"lat\":32.7762719},{\"lng\":-82.3249846,\"lat\":29.6519684},{\"lng\":-122.4193286,\"lat\":37.7792588},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":144.9631732,\"lat\":-37.8142454},{\"lng\":-88.3525714,\"lat\":41.6834778},{\"lng\":-9.1365919,\"lat\":38.7077507},{\"lng\":-122.849143,\"lat\":49.1913033},{\"lng\":-0.206809,\"lat\":51.474408},{\"lng\":-117.826166,\"lat\":33.7458511},{\"lng\":13.7757809,\"lat\":54.0536473},{\"lng\":-122.330062,\"lat\":47.6038321},{\"lng\":-46.6333824,\"lat\":-23.5506507},{\"lng\":-1.9739174,\"lat\":52.4968157},{\"lng\":-75.710976,\"lat\":45.4277659},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":4.351697,\"lat\":50.8465573},{\"lng\":75.8533326,\"lat\":30.135717},{\"lng\":-104.984862,\"lat\":39.7392364},{\"lng\":11.077298,\"lat\":49.453872},{\"lng\":8.531007,\"lat\":52.0191005},{\"lng\":-83.0335384,\"lat\":42.6261446},{\"lng\":-72.0997804,\"lat\":41.3556187},{\"lng\":-72.9250518,\"lat\":41.3082138},{\"lng\":-75.6901106,\"lat\":45.4208777},{\"lng\":-6.2605593,\"lat\":53.3493795},{\"lng\":-1.5541362,\"lat\":47.2186371},{\"lng\":-79.3839347,\"lat\":43.6534817},{\"lng\":-86.9300023,\"lat\":35.751179},{\"lng\":-4.0278869,\"lat\":57.8796955},{\"lng\":-71.8046023,\"lat\":42.5854371},{\"lng\":-72.9020069,\"lat\":41.3836233},{\"lng\":-75.1635262,\"lat\":39.9527237},{\"lng\":-79.0993958,\"lat\":36.075382},{\"lng\":-90.4611995,\"lat\":30.5043583},{\"lng\":10.3549776,\"lat\":53.4022952},{\"lng\":8.5410422,\"lat\":47.3744489},{\"lng\":67.0207055,\"lat\":24.8546842},{\"lng\":-83.0302033,\"lat\":42.5803122},{\"lng\":-73.9497211,\"lat\":40.6526006},{\"lng\":4.47775,\"lat\":51.9244424},{\"lng\":-117.903317,\"lat\":33.6633386},{\"lng\":-73.9497211,\"lat\":40.6526006}]");


(0, (/*@__PURE__*/$parcel$interopDefault($af44cc7d4ea0e537$exports))).accessToken = "pk.eyJ1IjoieGR1cmFuZCIsImEiOiJjbWN5azNxZG8wbm53MmtzM2cxeTM0MTQyIn0.BTwzrXnWc21Gs6ASPWVMIA";
const $cd93687958c8007e$var$App = ()=>{
    const mapContainer = (0, $acw62.useRef)(null);
    const mapRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (mapContainer.current && !mapRef.current) {
            mapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($af44cc7d4ea0e537$exports))).Map({
                container: mapContainer.current,
                style: "mapbox://styles/mapbox/dark-v11",
                center: [
                    -100,
                    20
                ],
                zoom: 1.5,
                maxZoom: 7
            });
            // Load coordinates and add heatmap layer
            const features = (0, (/*@__PURE__*/$parcel$interopDefault($92af916dd9113551$exports))).map((c)=>({
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [
                            c.lng,
                            c.lat
                        ]
                    },
                    properties: {}
                }));
            const geojson = {
                type: "FeatureCollection",
                features: features
            };
            if (!mapRef.current) return;
            mapRef.current.on("load", ()=>{
                if (!mapRef.current) return;
                if (!mapRef.current.getSource("users")) {
                    mapRef.current.addSource("users", {
                        type: "geojson",
                        data: geojson
                    });
                    mapRef.current.addLayer({
                        id: "users-heatmap",
                        type: "heatmap",
                        source: "users",
                        paint: {
                            "heatmap-weight": 0.75,
                            "heatmap-intensity": 1,
                            "heatmap-radius": 20,
                            "heatmap-opacity": 0.8,
                            "heatmap-color": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "heatmap-density"
                                ],
                                0,
                                "rgba(0,0,0,0)",
                                0.2,
                                "#ffedfd",
                                0.33,
                                "#fdb022",
                                0.66,
                                "#f45555",
                                1,
                                "#ff4beb"
                            ]
                        }
                    });
                }
            });
            // '50': '#fff6fe',
            // '100': '#ffedfd',
            // '200': '#ffe3fc',
            // '300': '#ffc9f9',
            // '400': '#ffb0f6',
            // '500': '#ff96f4',
            // '600': '#ff92f4',
            // '700': '#ff6ef1',
            // '800': '#ff4beb',
            // '900': '#e544d6',
            // '1000': '#cc3dbe',
            // '1100': '#b235a6',
            // '1200': '#992d8e',
            // '1300': '#802577',
            // '1400': '#661e5f',
            // At low zooms, complete a revolution every two minutes.
            const secondsPerRevolution = 120;
            // Above zoom level 5, do not rotate.
            const maxSpinZoom = 5;
            // Rotate at intermediate speeds between zoom levels 3 and 5.
            const slowSpinZoom = 3;
            let userInteracting = false;
            let spinEnabled = true;
            function spinGlobe() {
                const zoom = mapRef.current?.getZoom();
                if (spinEnabled && !userInteracting && zoom && zoom < maxSpinZoom) {
                    let distancePerSecond = 360 / secondsPerRevolution;
                    if (zoom > slowSpinZoom) {
                        // Slow spinning at higher zooms
                        const zoomDif = (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
                        distancePerSecond *= zoomDif;
                    }
                    const center = mapRef.current?.getCenter();
                    if (center) {
                        center.lng += distancePerSecond;
                        // Smoothly animate the map over one second.
                        // When this animation is complete, it calls a 'moveend' event.
                        mapRef.current?.easeTo({
                            center: center,
                            duration: 1000,
                            easing: (n)=>n
                        });
                    }
                }
            }
            // Pause spinning on interaction
            mapRef.current?.on("mousedown", ()=>userInteracting = true);
            mapRef.current?.on("touchstart", ()=>userInteracting = true);
            mapRef.current?.on("touchmove", ()=>userInteracting = true);
            // Restart spinning the globe when interaction is complete
            mapRef.current?.on("mouseup", ()=>{
                userInteracting = false;
                spinGlobe();
            });
            // These events account for cases where the mouse has moved
            // off the map, so 'mouseup' will not be fired.
            mapRef.current?.on("dragend", ()=>{
                userInteracting = false;
                spinGlobe();
            });
            mapRef.current?.on("touchend", ()=>{
                userInteracting = false;
                spinGlobe();
            });
            mapRef.current?.on("pitchend", ()=>{
                userInteracting = false;
                spinGlobe();
            });
            mapRef.current?.on("rotateend", ()=>{
                userInteracting = false;
                spinGlobe();
            });
            // When animation is complete, start spinning if there is no ongoing interaction
            mapRef.current?.on("moveend", ()=>{
                spinGlobe();
            });
            spinGlobe();
        }
        return ()=>{
            mapRef.current?.remove();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: mapContainer,
        style: {
            width: "100vw",
            height: "100vh"
        }
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;


const $70fc9a727fa662ae$var$container = document.getElementById("root");
if ($70fc9a727fa662ae$var$container) {
    const root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
    root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));
}


//# sourceMappingURL=path0.21d868c3.js.map
